
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire137e"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire137e"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1b2ls", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $0db8a335f84591c1$export$ffb0004e005737fa, (v) => $0db8a335f84591c1$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $0db8a335f84591c1$export$34b9dba7ce09269b, (v) => $0db8a335f84591c1$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $0db8a335f84591c1$export$25062201e9e25d76, (v) => $0db8a335f84591c1$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $0db8a335f84591c1$export$ffb0004e005737fa;
var $0db8a335f84591c1$export$34b9dba7ce09269b;
var $0db8a335f84591c1$export$25062201e9e25d76;
"use strict";

var $acw62 = parcelRequire("acw62");
var $0db8a335f84591c1$var$k = Symbol.for("react.element"), $0db8a335f84591c1$var$l = Symbol.for("react.fragment"), $0db8a335f84591c1$var$m = Object.prototype.hasOwnProperty, $0db8a335f84591c1$var$n = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $0db8a335f84591c1$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $0db8a335f84591c1$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$0db8a335f84591c1$var$m.call(a, b) && !$0db8a335f84591c1$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $0db8a335f84591c1$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $0db8a335f84591c1$var$n.current
    };
}
$0db8a335f84591c1$export$ffb0004e005737fa = $0db8a335f84591c1$var$l;
$0db8a335f84591c1$export$34b9dba7ce09269b = $0db8a335f84591c1$var$q;
$0db8a335f84591c1$export$25062201e9e25d76 = $0db8a335f84591c1$var$q;

});
parcelRegister("acw62", function(module, exports) {
"use strict";

module.exports = (parcelRequire("2pUnB"));

});
parcelRegister("2pUnB", function(module, exports) {

$parcel$export(module.exports, "Children", () => $1c29a66706a62afd$export$dca3b0875bd9a954, (v) => $1c29a66706a62afd$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $1c29a66706a62afd$export$16fa2f45be04daa8, (v) => $1c29a66706a62afd$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $1c29a66706a62afd$export$ffb0004e005737fa, (v) => $1c29a66706a62afd$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $1c29a66706a62afd$export$e2c29f18771995cb, (v) => $1c29a66706a62afd$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $1c29a66706a62afd$export$221d75b3f55bb0bd, (v) => $1c29a66706a62afd$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $1c29a66706a62afd$export$5f8d39834fd61797, (v) => $1c29a66706a62afd$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $1c29a66706a62afd$export$74bf444e3cd11ea5, (v) => $1c29a66706a62afd$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $1c29a66706a62afd$export$ae55be85d98224ed, (v) => $1c29a66706a62afd$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "cloneElement", () => $1c29a66706a62afd$export$e530037191fcd5d7, (v) => $1c29a66706a62afd$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $1c29a66706a62afd$export$fd42f52fd3ae1109, (v) => $1c29a66706a62afd$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $1c29a66706a62afd$export$c8a8987d4410bf2d, (v) => $1c29a66706a62afd$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createFactory", () => $1c29a66706a62afd$export$d38cd72104c1f0e9, (v) => $1c29a66706a62afd$export$d38cd72104c1f0e9 = v);
$parcel$export(module.exports, "createRef", () => $1c29a66706a62afd$export$7d1e3a5e95ceca43, (v) => $1c29a66706a62afd$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $1c29a66706a62afd$export$257a8862b851cb5b, (v) => $1c29a66706a62afd$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $1c29a66706a62afd$export$a8257692ac88316c, (v) => $1c29a66706a62afd$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $1c29a66706a62afd$export$488013bae63b21da, (v) => $1c29a66706a62afd$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $1c29a66706a62afd$export$7c73462e0d25e514, (v) => $1c29a66706a62afd$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $1c29a66706a62afd$export$7568632d0d33d16d, (v) => $1c29a66706a62afd$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_act", () => $1c29a66706a62afd$export$88948ce120ea2619, (v) => $1c29a66706a62afd$export$88948ce120ea2619 = v);
$parcel$export(module.exports, "useCallback", () => $1c29a66706a62afd$export$35808ee640e87ca7, (v) => $1c29a66706a62afd$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $1c29a66706a62afd$export$fae74005e78b1a27, (v) => $1c29a66706a62afd$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $1c29a66706a62afd$export$dc8fbce3eb94dc1e, (v) => $1c29a66706a62afd$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $1c29a66706a62afd$export$6a7bc4e911dc01cf, (v) => $1c29a66706a62afd$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $1c29a66706a62afd$export$6d9c69b0de29b591, (v) => $1c29a66706a62afd$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useId", () => $1c29a66706a62afd$export$f680877a34711e37, (v) => $1c29a66706a62afd$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $1c29a66706a62afd$export$d5a552a76deda3c2, (v) => $1c29a66706a62afd$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $1c29a66706a62afd$export$aaabe4eda9ed9969, (v) => $1c29a66706a62afd$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $1c29a66706a62afd$export$e5c5a5f917a5871c, (v) => $1c29a66706a62afd$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $1c29a66706a62afd$export$1538c33de8887b59, (v) => $1c29a66706a62afd$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useReducer", () => $1c29a66706a62afd$export$13e3392192263954, (v) => $1c29a66706a62afd$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $1c29a66706a62afd$export$b8f5890fc79d6aca, (v) => $1c29a66706a62afd$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $1c29a66706a62afd$export$60241385465d0a34, (v) => $1c29a66706a62afd$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $1c29a66706a62afd$export$306c0aa65ff9ec16, (v) => $1c29a66706a62afd$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $1c29a66706a62afd$export$7b286972b8d8ccbf, (v) => $1c29a66706a62afd$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $1c29a66706a62afd$export$83d89fbfd8236492, (v) => $1c29a66706a62afd$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $1c29a66706a62afd$export$dca3b0875bd9a954;
var $1c29a66706a62afd$export$16fa2f45be04daa8;
var $1c29a66706a62afd$export$ffb0004e005737fa;
var $1c29a66706a62afd$export$e2c29f18771995cb;
var $1c29a66706a62afd$export$221d75b3f55bb0bd;
var $1c29a66706a62afd$export$5f8d39834fd61797;
var $1c29a66706a62afd$export$74bf444e3cd11ea5;
var $1c29a66706a62afd$export$ae55be85d98224ed;
var $1c29a66706a62afd$export$e530037191fcd5d7;
var $1c29a66706a62afd$export$fd42f52fd3ae1109;
var $1c29a66706a62afd$export$c8a8987d4410bf2d;
var $1c29a66706a62afd$export$d38cd72104c1f0e9;
var $1c29a66706a62afd$export$7d1e3a5e95ceca43;
var $1c29a66706a62afd$export$257a8862b851cb5b;
var $1c29a66706a62afd$export$a8257692ac88316c;
var $1c29a66706a62afd$export$488013bae63b21da;
var $1c29a66706a62afd$export$7c73462e0d25e514;
var $1c29a66706a62afd$export$7568632d0d33d16d;
var $1c29a66706a62afd$export$88948ce120ea2619;
var $1c29a66706a62afd$export$35808ee640e87ca7;
var $1c29a66706a62afd$export$fae74005e78b1a27;
var $1c29a66706a62afd$export$dc8fbce3eb94dc1e;
var $1c29a66706a62afd$export$6a7bc4e911dc01cf;
var $1c29a66706a62afd$export$6d9c69b0de29b591;
var $1c29a66706a62afd$export$f680877a34711e37;
var $1c29a66706a62afd$export$d5a552a76deda3c2;
var $1c29a66706a62afd$export$aaabe4eda9ed9969;
var $1c29a66706a62afd$export$e5c5a5f917a5871c;
var $1c29a66706a62afd$export$1538c33de8887b59;
var $1c29a66706a62afd$export$13e3392192263954;
var $1c29a66706a62afd$export$b8f5890fc79d6aca;
var $1c29a66706a62afd$export$60241385465d0a34;
var $1c29a66706a62afd$export$306c0aa65ff9ec16;
var $1c29a66706a62afd$export$7b286972b8d8ccbf;
var $1c29a66706a62afd$export$83d89fbfd8236492;
"use strict";
var $1c29a66706a62afd$var$l = Symbol.for("react.element"), $1c29a66706a62afd$var$n = Symbol.for("react.portal"), $1c29a66706a62afd$var$p = Symbol.for("react.fragment"), $1c29a66706a62afd$var$q = Symbol.for("react.strict_mode"), $1c29a66706a62afd$var$r = Symbol.for("react.profiler"), $1c29a66706a62afd$var$t = Symbol.for("react.provider"), $1c29a66706a62afd$var$u = Symbol.for("react.context"), $1c29a66706a62afd$var$v = Symbol.for("react.forward_ref"), $1c29a66706a62afd$var$w = Symbol.for("react.suspense"), $1c29a66706a62afd$var$x = Symbol.for("react.memo"), $1c29a66706a62afd$var$y = Symbol.for("react.lazy"), $1c29a66706a62afd$var$z = Symbol.iterator;
function $1c29a66706a62afd$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $1c29a66706a62afd$var$z && a[$1c29a66706a62afd$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $1c29a66706a62afd$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $1c29a66706a62afd$var$C = Object.assign, $1c29a66706a62afd$var$D = {};
function $1c29a66706a62afd$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
$1c29a66706a62afd$var$E.prototype.isReactComponent = {};
$1c29a66706a62afd$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$1c29a66706a62afd$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $1c29a66706a62afd$var$F() {}
$1c29a66706a62afd$var$F.prototype = $1c29a66706a62afd$var$E.prototype;
function $1c29a66706a62afd$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $1c29a66706a62afd$var$D;
    this.updater = e || $1c29a66706a62afd$var$B;
}
var $1c29a66706a62afd$var$H = $1c29a66706a62afd$var$G.prototype = new $1c29a66706a62afd$var$F;
$1c29a66706a62afd$var$H.constructor = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$var$C($1c29a66706a62afd$var$H, $1c29a66706a62afd$var$E.prototype);
$1c29a66706a62afd$var$H.isPureReactComponent = !0;
var $1c29a66706a62afd$var$I = Array.isArray, $1c29a66706a62afd$var$J = Object.prototype.hasOwnProperty, $1c29a66706a62afd$var$K = {
    current: null
}, $1c29a66706a62afd$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $1c29a66706a62afd$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$1c29a66706a62afd$var$J.call(b, d) && !$1c29a66706a62afd$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $1c29a66706a62afd$var$K.current
    };
}
function $1c29a66706a62afd$var$N(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $1c29a66706a62afd$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $1c29a66706a62afd$var$l;
}
function $1c29a66706a62afd$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $1c29a66706a62afd$var$P = /\/+/g;
function $1c29a66706a62afd$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $1c29a66706a62afd$var$escape("" + a.key) : b.toString(36);
}
function $1c29a66706a62afd$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $1c29a66706a62afd$var$l:
                case $1c29a66706a62afd$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $1c29a66706a62afd$var$Q(h, 0) : d, $1c29a66706a62afd$var$I(c) ? (e = "", null != a && (e = a.replace($1c29a66706a62afd$var$P, "$&/") + "/"), $1c29a66706a62afd$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($1c29a66706a62afd$var$O(c) && (c = $1c29a66706a62afd$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($1c29a66706a62afd$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($1c29a66706a62afd$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $1c29a66706a62afd$var$Q(k, g);
        h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    }
    else if (f = $1c29a66706a62afd$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $1c29a66706a62afd$var$Q(k, g++), h += $1c29a66706a62afd$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $1c29a66706a62afd$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $1c29a66706a62afd$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $1c29a66706a62afd$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $1c29a66706a62afd$var$U = {
    current: null
}, $1c29a66706a62afd$var$V = {
    transition: null
}, $1c29a66706a62afd$var$W = {
    ReactCurrentDispatcher: $1c29a66706a62afd$var$U,
    ReactCurrentBatchConfig: $1c29a66706a62afd$var$V,
    ReactCurrentOwner: $1c29a66706a62afd$var$K
};
$1c29a66706a62afd$export$dca3b0875bd9a954 = {
    map: $1c29a66706a62afd$var$S,
    forEach: function(a, b, e) {
        $1c29a66706a62afd$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $1c29a66706a62afd$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $1c29a66706a62afd$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$1c29a66706a62afd$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$1c29a66706a62afd$export$16fa2f45be04daa8 = $1c29a66706a62afd$var$E;
$1c29a66706a62afd$export$ffb0004e005737fa = $1c29a66706a62afd$var$p;
$1c29a66706a62afd$export$e2c29f18771995cb = $1c29a66706a62afd$var$r;
$1c29a66706a62afd$export$221d75b3f55bb0bd = $1c29a66706a62afd$var$G;
$1c29a66706a62afd$export$5f8d39834fd61797 = $1c29a66706a62afd$var$q;
$1c29a66706a62afd$export$74bf444e3cd11ea5 = $1c29a66706a62afd$var$w;
$1c29a66706a62afd$export$ae55be85d98224ed = $1c29a66706a62afd$var$W;
$1c29a66706a62afd$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $1c29a66706a62afd$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $1c29a66706a62afd$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$1c29a66706a62afd$var$J.call(b, f) && !$1c29a66706a62afd$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $1c29a66706a62afd$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$1c29a66706a62afd$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $1c29a66706a62afd$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $1c29a66706a62afd$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$1c29a66706a62afd$export$c8a8987d4410bf2d = $1c29a66706a62afd$var$M;
$1c29a66706a62afd$export$d38cd72104c1f0e9 = function(a) {
    var b = $1c29a66706a62afd$var$M.bind(null, a);
    b.type = a;
    return b;
};
$1c29a66706a62afd$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$1c29a66706a62afd$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$v,
        render: a
    };
};
$1c29a66706a62afd$export$a8257692ac88316c = $1c29a66706a62afd$var$O;
$1c29a66706a62afd$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $1c29a66706a62afd$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $1c29a66706a62afd$var$T
    };
};
$1c29a66706a62afd$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $1c29a66706a62afd$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$1c29a66706a62afd$export$7568632d0d33d16d = function(a) {
    var b = $1c29a66706a62afd$var$V.transition;
    $1c29a66706a62afd$var$V.transition = {};
    try {
        a();
    } finally{
        $1c29a66706a62afd$var$V.transition = b;
    }
};
$1c29a66706a62afd$export$88948ce120ea2619 = function() {
    throw Error("act(...) is not supported in production builds of React.");
};
$1c29a66706a62afd$export$35808ee640e87ca7 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useCallback(a, b);
};
$1c29a66706a62afd$export$fae74005e78b1a27 = function(a) {
    return $1c29a66706a62afd$var$U.current.useContext(a);
};
$1c29a66706a62afd$export$dc8fbce3eb94dc1e = function() {};
$1c29a66706a62afd$export$6a7bc4e911dc01cf = function(a) {
    return $1c29a66706a62afd$var$U.current.useDeferredValue(a);
};
$1c29a66706a62afd$export$6d9c69b0de29b591 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useEffect(a, b);
};
$1c29a66706a62afd$export$f680877a34711e37 = function() {
    return $1c29a66706a62afd$var$U.current.useId();
};
$1c29a66706a62afd$export$d5a552a76deda3c2 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useImperativeHandle(a, b, e);
};
$1c29a66706a62afd$export$aaabe4eda9ed9969 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useInsertionEffect(a, b);
};
$1c29a66706a62afd$export$e5c5a5f917a5871c = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useLayoutEffect(a, b);
};
$1c29a66706a62afd$export$1538c33de8887b59 = function(a, b) {
    return $1c29a66706a62afd$var$U.current.useMemo(a, b);
};
$1c29a66706a62afd$export$13e3392192263954 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useReducer(a, b, e);
};
$1c29a66706a62afd$export$b8f5890fc79d6aca = function(a) {
    return $1c29a66706a62afd$var$U.current.useRef(a);
};
$1c29a66706a62afd$export$60241385465d0a34 = function(a) {
    return $1c29a66706a62afd$var$U.current.useState(a);
};
$1c29a66706a62afd$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $1c29a66706a62afd$var$U.current.useSyncExternalStore(a, b, e);
};
$1c29a66706a62afd$export$7b286972b8d8ccbf = function() {
    return $1c29a66706a62afd$var$U.current.useTransition();
};
$1c29a66706a62afd$export$83d89fbfd8236492 = "18.2.0";

});



parcelRegister("1u0KT", function(module, exports) {
"use strict";
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("Xw6Mv"));

});
parcelRegister("Xw6Mv", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", () => $0b2e6adb871a3b94$export$ae55be85d98224ed, (v) => $0b2e6adb871a3b94$export$ae55be85d98224ed = v);
$parcel$export(module.exports, "createPortal", () => $0b2e6adb871a3b94$export$d39a5bbd09211389, (v) => $0b2e6adb871a3b94$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "createRoot", () => $0b2e6adb871a3b94$export$882461b6382ed46c, (v) => $0b2e6adb871a3b94$export$882461b6382ed46c = v);
$parcel$export(module.exports, "findDOMNode", () => $0b2e6adb871a3b94$export$466bfc07425424d5, (v) => $0b2e6adb871a3b94$export$466bfc07425424d5 = v);
$parcel$export(module.exports, "flushSync", () => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4, (v) => $0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "hydrate", () => $0b2e6adb871a3b94$export$fa8d919ba61d84db, (v) => $0b2e6adb871a3b94$export$fa8d919ba61d84db = v);
$parcel$export(module.exports, "hydrateRoot", () => $0b2e6adb871a3b94$export$757ceba2d55c277e, (v) => $0b2e6adb871a3b94$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "render", () => $0b2e6adb871a3b94$export$b3890eb0ae9dca99, (v) => $0b2e6adb871a3b94$export$b3890eb0ae9dca99 = v);
$parcel$export(module.exports, "unmountComponentAtNode", () => $0b2e6adb871a3b94$export$502457920280e6be, (v) => $0b2e6adb871a3b94$export$502457920280e6be = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $0b2e6adb871a3b94$export$c78a37762a8d58e1, (v) => $0b2e6adb871a3b94$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", () => $0b2e6adb871a3b94$export$dc54d992c10e8a18, (v) => $0b2e6adb871a3b94$export$dc54d992c10e8a18 = v);
$parcel$export(module.exports, "version", () => $0b2e6adb871a3b94$export$83d89fbfd8236492, (v) => $0b2e6adb871a3b94$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $0b2e6adb871a3b94$export$ae55be85d98224ed;
var $0b2e6adb871a3b94$export$d39a5bbd09211389;
var $0b2e6adb871a3b94$export$882461b6382ed46c;
var $0b2e6adb871a3b94$export$466bfc07425424d5;
var $0b2e6adb871a3b94$export$cd75ccfd720a3cd4;
var $0b2e6adb871a3b94$export$fa8d919ba61d84db;
var $0b2e6adb871a3b94$export$757ceba2d55c277e;
var $0b2e6adb871a3b94$export$b3890eb0ae9dca99;
var $0b2e6adb871a3b94$export$502457920280e6be;
var $0b2e6adb871a3b94$export$c78a37762a8d58e1;
var $0b2e6adb871a3b94$export$dc54d992c10e8a18;
var $0b2e6adb871a3b94$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");

var $fO90s = parcelRequire("fO90s");
function $0b2e6adb871a3b94$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $0b2e6adb871a3b94$var$da = new Set, $0b2e6adb871a3b94$var$ea = {};
function $0b2e6adb871a3b94$var$fa(a, b) {
    $0b2e6adb871a3b94$var$ha(a, b);
    $0b2e6adb871a3b94$var$ha(a + "Capture", b);
}
function $0b2e6adb871a3b94$var$ha(a, b) {
    $0b2e6adb871a3b94$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$da.add(b[a]);
}
var $0b2e6adb871a3b94$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $0b2e6adb871a3b94$var$ja = Object.prototype.hasOwnProperty, $0b2e6adb871a3b94$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $0b2e6adb871a3b94$var$la = {}, $0b2e6adb871a3b94$var$ma = {};
function $0b2e6adb871a3b94$var$oa(a) {
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$ma, a)) return !0;
    if ($0b2e6adb871a3b94$var$ja.call($0b2e6adb871a3b94$var$la, a)) return !1;
    if ($0b2e6adb871a3b94$var$ka.test(a)) return $0b2e6adb871a3b94$var$ma[a] = !0;
    $0b2e6adb871a3b94$var$la[a] = !0;
    return !1;
}
function $0b2e6adb871a3b94$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $0b2e6adb871a3b94$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $0b2e6adb871a3b94$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $0b2e6adb871a3b94$var$ra = /[\-:]([a-z])/g;
function $0b2e6adb871a3b94$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($0b2e6adb871a3b94$var$ra, $0b2e6adb871a3b94$var$sa);
    $0b2e6adb871a3b94$var$z[b] = new $0b2e6adb871a3b94$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$0b2e6adb871a3b94$var$z.xlinkHref = new $0b2e6adb871a3b94$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $0b2e6adb871a3b94$var$z[a] = new $0b2e6adb871a3b94$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $0b2e6adb871a3b94$var$ta(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$z.hasOwnProperty(b) ? $0b2e6adb871a3b94$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $0b2e6adb871a3b94$var$qa(b, c, e, d) && (c = null), d || null === e ? $0b2e6adb871a3b94$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $0b2e6adb871a3b94$var$ua = $acw62.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $0b2e6adb871a3b94$var$va = Symbol.for("react.element"), $0b2e6adb871a3b94$var$wa = Symbol.for("react.portal"), $0b2e6adb871a3b94$var$ya = Symbol.for("react.fragment"), $0b2e6adb871a3b94$var$za = Symbol.for("react.strict_mode"), $0b2e6adb871a3b94$var$Aa = Symbol.for("react.profiler"), $0b2e6adb871a3b94$var$Ba = Symbol.for("react.provider"), $0b2e6adb871a3b94$var$Ca = Symbol.for("react.context"), $0b2e6adb871a3b94$var$Da = Symbol.for("react.forward_ref"), $0b2e6adb871a3b94$var$Ea = Symbol.for("react.suspense"), $0b2e6adb871a3b94$var$Fa = Symbol.for("react.suspense_list"), $0b2e6adb871a3b94$var$Ga = Symbol.for("react.memo"), $0b2e6adb871a3b94$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $0b2e6adb871a3b94$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $0b2e6adb871a3b94$var$Ja = Symbol.iterator;
function $0b2e6adb871a3b94$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $0b2e6adb871a3b94$var$Ja && a[$0b2e6adb871a3b94$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $0b2e6adb871a3b94$var$A = Object.assign, $0b2e6adb871a3b94$var$La;
function $0b2e6adb871a3b94$var$Ma(a) {
    if (void 0 === $0b2e6adb871a3b94$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $0b2e6adb871a3b94$var$La = b && b[1] || "";
    }
    return "\n" + $0b2e6adb871a3b94$var$La + a;
}
var $0b2e6adb871a3b94$var$Na = !1;
function $0b2e6adb871a3b94$var$Oa(a, b) {
    if (!a || $0b2e6adb871a3b94$var$Na) return "";
    $0b2e6adb871a3b94$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $0b2e6adb871a3b94$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $0b2e6adb871a3b94$var$Ma(a) : "";
}
function $0b2e6adb871a3b94$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $0b2e6adb871a3b94$var$Ma(a.type);
        case 16:
            return $0b2e6adb871a3b94$var$Ma("Lazy");
        case 13:
            return $0b2e6adb871a3b94$var$Ma("Suspense");
        case 19:
            return $0b2e6adb871a3b94$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !1), a;
        case 11:
            return a = $0b2e6adb871a3b94$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $0b2e6adb871a3b94$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return "Fragment";
        case $0b2e6adb871a3b94$var$wa:
            return "Portal";
        case $0b2e6adb871a3b94$var$Aa:
            return "Profiler";
        case $0b2e6adb871a3b94$var$za:
            return "StrictMode";
        case $0b2e6adb871a3b94$var$Ea:
            return "Suspense";
        case $0b2e6adb871a3b94$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $0b2e6adb871a3b94$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $0b2e6adb871a3b94$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $0b2e6adb871a3b94$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $0b2e6adb871a3b94$var$Ga:
            return b = a.displayName || null, null !== b ? b : $0b2e6adb871a3b94$var$Qa(a.type) || "Memo";
        case $0b2e6adb871a3b94$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $0b2e6adb871a3b94$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $0b2e6adb871a3b94$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $0b2e6adb871a3b94$var$Qa(b);
        case 8:
            return b === $0b2e6adb871a3b94$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $0b2e6adb871a3b94$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $0b2e6adb871a3b94$var$Ua(a) {
    var b = $0b2e6adb871a3b94$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $0b2e6adb871a3b94$var$Va(a) {
    a._valueTracker || (a._valueTracker = $0b2e6adb871a3b94$var$Ua(a));
}
function $0b2e6adb871a3b94$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $0b2e6adb871a3b94$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $0b2e6adb871a3b94$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $0b2e6adb871a3b94$var$Ya(a, b) {
    var c = b.checked;
    return $0b2e6adb871a3b94$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $0b2e6adb871a3b94$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $0b2e6adb871a3b94$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $0b2e6adb871a3b94$var$ab(a, b) {
    b = b.checked;
    null != b && $0b2e6adb871a3b94$var$ta(a, "checked", b, !1);
}
function $0b2e6adb871a3b94$var$bb(a, b) {
    $0b2e6adb871a3b94$var$ab(a, b);
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $0b2e6adb871a3b94$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $0b2e6adb871a3b94$var$cb(a, b.type, $0b2e6adb871a3b94$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $0b2e6adb871a3b94$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $0b2e6adb871a3b94$var$cb(a, b, c) {
    if ("number" !== b || $0b2e6adb871a3b94$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $0b2e6adb871a3b94$var$eb = Array.isArray;
function $0b2e6adb871a3b94$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $0b2e6adb871a3b94$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $0b2e6adb871a3b94$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($0b2e6adb871a3b94$var$p(91));
    return $0b2e6adb871a3b94$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $0b2e6adb871a3b94$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($0b2e6adb871a3b94$var$p(92));
            if ($0b2e6adb871a3b94$var$eb(c)) {
                if (1 < c.length) throw Error($0b2e6adb871a3b94$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $0b2e6adb871a3b94$var$Sa(c)
    };
}
function $0b2e6adb871a3b94$var$ib(a, b) {
    var c = $0b2e6adb871a3b94$var$Sa(b.value), d = $0b2e6adb871a3b94$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $0b2e6adb871a3b94$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $0b2e6adb871a3b94$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $0b2e6adb871a3b94$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $0b2e6adb871a3b94$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $0b2e6adb871a3b94$var$mb, $0b2e6adb871a3b94$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $0b2e6adb871a3b94$var$mb = $0b2e6adb871a3b94$var$mb || document.createElement("div");
        $0b2e6adb871a3b94$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $0b2e6adb871a3b94$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $0b2e6adb871a3b94$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $0b2e6adb871a3b94$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $0b2e6adb871a3b94$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($0b2e6adb871a3b94$var$pb).forEach(function(a) {
    $0b2e6adb871a3b94$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $0b2e6adb871a3b94$var$pb[b] = $0b2e6adb871a3b94$var$pb[a];
    });
});
function $0b2e6adb871a3b94$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $0b2e6adb871a3b94$var$pb.hasOwnProperty(a) && $0b2e6adb871a3b94$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $0b2e6adb871a3b94$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $0b2e6adb871a3b94$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $0b2e6adb871a3b94$var$tb = $0b2e6adb871a3b94$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $0b2e6adb871a3b94$var$ub(a, b) {
    if (b) {
        if ($0b2e6adb871a3b94$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($0b2e6adb871a3b94$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($0b2e6adb871a3b94$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($0b2e6adb871a3b94$var$p(62));
    }
}
function $0b2e6adb871a3b94$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $0b2e6adb871a3b94$var$wb = null;
function $0b2e6adb871a3b94$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $0b2e6adb871a3b94$var$yb = null, $0b2e6adb871a3b94$var$zb = null, $0b2e6adb871a3b94$var$Ab = null;
function $0b2e6adb871a3b94$var$Bb(a) {
    if (a = $0b2e6adb871a3b94$var$Cb(a)) {
        if ("function" !== typeof $0b2e6adb871a3b94$var$yb) throw Error($0b2e6adb871a3b94$var$p(280));
        var b = a.stateNode;
        b && (b = $0b2e6adb871a3b94$var$Db(b), $0b2e6adb871a3b94$var$yb(a.stateNode, a.type, b));
    }
}
function $0b2e6adb871a3b94$var$Eb(a) {
    $0b2e6adb871a3b94$var$zb ? $0b2e6adb871a3b94$var$Ab ? $0b2e6adb871a3b94$var$Ab.push(a) : $0b2e6adb871a3b94$var$Ab = [
        a
    ] : $0b2e6adb871a3b94$var$zb = a;
}
function $0b2e6adb871a3b94$var$Fb() {
    if ($0b2e6adb871a3b94$var$zb) {
        var a = $0b2e6adb871a3b94$var$zb, b = $0b2e6adb871a3b94$var$Ab;
        $0b2e6adb871a3b94$var$Ab = $0b2e6adb871a3b94$var$zb = null;
        $0b2e6adb871a3b94$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$0b2e6adb871a3b94$var$Bb(b[a]);
    }
}
function $0b2e6adb871a3b94$var$Gb(a, b) {
    return a(b);
}
function $0b2e6adb871a3b94$var$Hb() {}
var $0b2e6adb871a3b94$var$Ib = !1;
function $0b2e6adb871a3b94$var$Jb(a, b, c) {
    if ($0b2e6adb871a3b94$var$Ib) return a(b, c);
    $0b2e6adb871a3b94$var$Ib = !0;
    try {
        return $0b2e6adb871a3b94$var$Gb(a, b, c);
    } finally{
        if ($0b2e6adb871a3b94$var$Ib = !1, null !== $0b2e6adb871a3b94$var$zb || null !== $0b2e6adb871a3b94$var$Ab) $0b2e6adb871a3b94$var$Hb(), $0b2e6adb871a3b94$var$Fb();
    }
}
function $0b2e6adb871a3b94$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $0b2e6adb871a3b94$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($0b2e6adb871a3b94$var$p(231, b, typeof c));
    return c;
}
var $0b2e6adb871a3b94$var$Lb = !1;
if ($0b2e6adb871a3b94$var$ia) try {
    var $0b2e6adb871a3b94$var$Mb = {};
    Object.defineProperty($0b2e6adb871a3b94$var$Mb, "passive", {
        get: function() {
            $0b2e6adb871a3b94$var$Lb = !0;
        }
    });
    window.addEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
    window.removeEventListener("test", $0b2e6adb871a3b94$var$Mb, $0b2e6adb871a3b94$var$Mb);
} catch (a) {
    $0b2e6adb871a3b94$var$Lb = !1;
}
function $0b2e6adb871a3b94$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $0b2e6adb871a3b94$var$Ob = !1, $0b2e6adb871a3b94$var$Pb = null, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, $0b2e6adb871a3b94$var$Sb = {
    onError: function(a) {
        $0b2e6adb871a3b94$var$Ob = !0;
        $0b2e6adb871a3b94$var$Pb = a;
    }
};
function $0b2e6adb871a3b94$var$Tb(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Ob = !1;
    $0b2e6adb871a3b94$var$Pb = null;
    $0b2e6adb871a3b94$var$Nb.apply($0b2e6adb871a3b94$var$Sb, arguments);
}
function $0b2e6adb871a3b94$var$Ub(a, b, c, d, e, f, g, h, k) {
    $0b2e6adb871a3b94$var$Tb.apply(this, arguments);
    if ($0b2e6adb871a3b94$var$Ob) {
        if ($0b2e6adb871a3b94$var$Ob) {
            var l = $0b2e6adb871a3b94$var$Pb;
            $0b2e6adb871a3b94$var$Ob = !1;
            $0b2e6adb871a3b94$var$Pb = null;
        } else throw Error($0b2e6adb871a3b94$var$p(198));
        $0b2e6adb871a3b94$var$Qb || ($0b2e6adb871a3b94$var$Qb = !0, $0b2e6adb871a3b94$var$Rb = l);
    }
}
function $0b2e6adb871a3b94$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $0b2e6adb871a3b94$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xb(a) {
    if ($0b2e6adb871a3b94$var$Vb(a) !== a) throw Error($0b2e6adb871a3b94$var$p(188));
}
function $0b2e6adb871a3b94$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $0b2e6adb871a3b94$var$Vb(a);
        if (null === b) throw Error($0b2e6adb871a3b94$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $0b2e6adb871a3b94$var$Xb(e), a;
                if (f === d) return $0b2e6adb871a3b94$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($0b2e6adb871a3b94$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($0b2e6adb871a3b94$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($0b2e6adb871a3b94$var$p(190));
    }
    if (3 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $0b2e6adb871a3b94$var$Zb(a) {
    a = $0b2e6adb871a3b94$var$Yb(a);
    return null !== a ? $0b2e6adb871a3b94$var$$b(a) : null;
}
function $0b2e6adb871a3b94$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $0b2e6adb871a3b94$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$ac = $fO90s.unstable_scheduleCallback, $0b2e6adb871a3b94$var$bc = $fO90s.unstable_cancelCallback, $0b2e6adb871a3b94$var$cc = $fO90s.unstable_shouldYield, $0b2e6adb871a3b94$var$dc = $fO90s.unstable_requestPaint, $0b2e6adb871a3b94$var$B = $fO90s.unstable_now, $0b2e6adb871a3b94$var$ec = $fO90s.unstable_getCurrentPriorityLevel, $0b2e6adb871a3b94$var$fc = $fO90s.unstable_ImmediatePriority, $0b2e6adb871a3b94$var$gc = $fO90s.unstable_UserBlockingPriority, $0b2e6adb871a3b94$var$hc = $fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$ic = $fO90s.unstable_LowPriority, $0b2e6adb871a3b94$var$jc = $fO90s.unstable_IdlePriority, $0b2e6adb871a3b94$var$kc = null, $0b2e6adb871a3b94$var$lc = null;
function $0b2e6adb871a3b94$var$mc(a) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberRoot) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberRoot($0b2e6adb871a3b94$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $0b2e6adb871a3b94$var$oc = Math.clz32 ? Math.clz32 : $0b2e6adb871a3b94$var$nc, $0b2e6adb871a3b94$var$pc = Math.log, $0b2e6adb871a3b94$var$qc = Math.LN2;
function $0b2e6adb871a3b94$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($0b2e6adb871a3b94$var$pc(a) / $0b2e6adb871a3b94$var$qc | 0) | 0;
}
var $0b2e6adb871a3b94$var$rc = 64, $0b2e6adb871a3b94$var$sc = 4194304;
function $0b2e6adb871a3b94$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $0b2e6adb871a3b94$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $0b2e6adb871a3b94$var$tc(h) : (f &= g, 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $0b2e6adb871a3b94$var$tc(g) : 0 !== f && (d = $0b2e6adb871a3b94$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $0b2e6adb871a3b94$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $0b2e6adb871a3b94$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $0b2e6adb871a3b94$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $0b2e6adb871a3b94$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $0b2e6adb871a3b94$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $0b2e6adb871a3b94$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $0b2e6adb871a3b94$var$yc() {
    var a = $0b2e6adb871a3b94$var$rc;
    $0b2e6adb871a3b94$var$rc <<= 1;
    0 === ($0b2e6adb871a3b94$var$rc & 4194240) && ($0b2e6adb871a3b94$var$rc = 64);
    return a;
}
function $0b2e6adb871a3b94$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $0b2e6adb871a3b94$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $0b2e6adb871a3b94$var$oc(b);
    a[b] = c;
}
function $0b2e6adb871a3b94$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $0b2e6adb871a3b94$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $0b2e6adb871a3b94$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $0b2e6adb871a3b94$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $0b2e6adb871a3b94$var$C = 0;
function $0b2e6adb871a3b94$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $0b2e6adb871a3b94$var$Ec, $0b2e6adb871a3b94$var$Fc, $0b2e6adb871a3b94$var$Gc, $0b2e6adb871a3b94$var$Hc, $0b2e6adb871a3b94$var$Ic, $0b2e6adb871a3b94$var$Jc = !1, $0b2e6adb871a3b94$var$Kc = [], $0b2e6adb871a3b94$var$Lc = null, $0b2e6adb871a3b94$var$Mc = null, $0b2e6adb871a3b94$var$Nc = null, $0b2e6adb871a3b94$var$Oc = new Map, $0b2e6adb871a3b94$var$Pc = new Map, $0b2e6adb871a3b94$var$Qc = [], $0b2e6adb871a3b94$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $0b2e6adb871a3b94$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $0b2e6adb871a3b94$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $0b2e6adb871a3b94$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $0b2e6adb871a3b94$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $0b2e6adb871a3b94$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $0b2e6adb871a3b94$var$Pc.delete(b.pointerId);
    }
}
function $0b2e6adb871a3b94$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $0b2e6adb871a3b94$var$Cb(b), null !== b && $0b2e6adb871a3b94$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $0b2e6adb871a3b94$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $0b2e6adb871a3b94$var$Lc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $0b2e6adb871a3b94$var$Mc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $0b2e6adb871a3b94$var$Nc = $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $0b2e6adb871a3b94$var$Oc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $0b2e6adb871a3b94$var$Pc.set(f, $0b2e6adb871a3b94$var$Tc($0b2e6adb871a3b94$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Vc(a) {
    var b = $0b2e6adb871a3b94$var$Wc(a.target);
    if (null !== b) {
        var c = $0b2e6adb871a3b94$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $0b2e6adb871a3b94$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $0b2e6adb871a3b94$var$Ic(a.priority, function() {
                        $0b2e6adb871a3b94$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $0b2e6adb871a3b94$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $0b2e6adb871a3b94$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $0b2e6adb871a3b94$var$wb = d;
            c.target.dispatchEvent(d);
            $0b2e6adb871a3b94$var$wb = null;
        } else return b = $0b2e6adb871a3b94$var$Cb(c), null !== b && $0b2e6adb871a3b94$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Zc(a, b, c) {
    $0b2e6adb871a3b94$var$Xc(a) && c.delete(b);
}
function $0b2e6adb871a3b94$var$$c() {
    $0b2e6adb871a3b94$var$Jc = !1;
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Lc) && ($0b2e6adb871a3b94$var$Lc = null);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Mc) && ($0b2e6adb871a3b94$var$Mc = null);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$Xc($0b2e6adb871a3b94$var$Nc) && ($0b2e6adb871a3b94$var$Nc = null);
    $0b2e6adb871a3b94$var$Oc.forEach($0b2e6adb871a3b94$var$Zc);
    $0b2e6adb871a3b94$var$Pc.forEach($0b2e6adb871a3b94$var$Zc);
}
function $0b2e6adb871a3b94$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $0b2e6adb871a3b94$var$Jc || ($0b2e6adb871a3b94$var$Jc = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $0b2e6adb871a3b94$var$$c)));
}
function $0b2e6adb871a3b94$var$bd(a) {
    function b(b) {
        return $0b2e6adb871a3b94$var$ad(b, a);
    }
    if (0 < $0b2e6adb871a3b94$var$Kc.length) {
        $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Kc[0], a);
        for(var c = 1; c < $0b2e6adb871a3b94$var$Kc.length; c++){
            var d = $0b2e6adb871a3b94$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $0b2e6adb871a3b94$var$Lc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Lc, a);
    null !== $0b2e6adb871a3b94$var$Mc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Mc, a);
    null !== $0b2e6adb871a3b94$var$Nc && $0b2e6adb871a3b94$var$ad($0b2e6adb871a3b94$var$Nc, a);
    $0b2e6adb871a3b94$var$Oc.forEach(b);
    $0b2e6adb871a3b94$var$Pc.forEach(b);
    for(c = 0; c < $0b2e6adb871a3b94$var$Qc.length; c++)d = $0b2e6adb871a3b94$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $0b2e6adb871a3b94$var$Qc.length && (c = $0b2e6adb871a3b94$var$Qc[0], null === c.blockedOn);)$0b2e6adb871a3b94$var$Vc(c), null === c.blockedOn && $0b2e6adb871a3b94$var$Qc.shift();
}
var $0b2e6adb871a3b94$var$cd = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$dd = !0;
function $0b2e6adb871a3b94$var$ed(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$gd(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$C, f = $0b2e6adb871a3b94$var$cd.transition;
    $0b2e6adb871a3b94$var$cd.transition = null;
    try {
        $0b2e6adb871a3b94$var$C = 4, $0b2e6adb871a3b94$var$fd(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$C = e, $0b2e6adb871a3b94$var$cd.transition = f;
    }
}
function $0b2e6adb871a3b94$var$fd(a, b, c, d) {
    if ($0b2e6adb871a3b94$var$dd) {
        var e = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
        if (null === e) $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c), $0b2e6adb871a3b94$var$Sc(a, d);
        else if ($0b2e6adb871a3b94$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($0b2e6adb871a3b94$var$Sc(a, d), b & 4 && -1 < $0b2e6adb871a3b94$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $0b2e6adb871a3b94$var$Cb(e);
                null !== f && $0b2e6adb871a3b94$var$Ec(f);
                f = $0b2e6adb871a3b94$var$Yc(a, b, c, d);
                null === f && $0b2e6adb871a3b94$var$hd(a, b, d, $0b2e6adb871a3b94$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $0b2e6adb871a3b94$var$hd(a, b, d, null, c);
    }
}
var $0b2e6adb871a3b94$var$id = null;
function $0b2e6adb871a3b94$var$Yc(a, b, c, d) {
    $0b2e6adb871a3b94$var$id = null;
    a = $0b2e6adb871a3b94$var$xb(d);
    a = $0b2e6adb871a3b94$var$Wc(a);
    if (null !== a) {
        if (b = $0b2e6adb871a3b94$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $0b2e6adb871a3b94$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $0b2e6adb871a3b94$var$id = a;
    return null;
}
function $0b2e6adb871a3b94$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($0b2e6adb871a3b94$var$ec()){
                case $0b2e6adb871a3b94$var$fc:
                    return 1;
                case $0b2e6adb871a3b94$var$gc:
                    return 4;
                case $0b2e6adb871a3b94$var$hc:
                case $0b2e6adb871a3b94$var$ic:
                    return 16;
                case $0b2e6adb871a3b94$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ld = null, $0b2e6adb871a3b94$var$md = null;
function $0b2e6adb871a3b94$var$nd() {
    if ($0b2e6adb871a3b94$var$md) return $0b2e6adb871a3b94$var$md;
    var a, b = $0b2e6adb871a3b94$var$ld, c = b.length, d, e = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $0b2e6adb871a3b94$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $0b2e6adb871a3b94$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $0b2e6adb871a3b94$var$pd() {
    return !0;
}
function $0b2e6adb871a3b94$var$qd() {
    return !1;
}
function $0b2e6adb871a3b94$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $0b2e6adb871a3b94$var$pd : $0b2e6adb871a3b94$var$qd;
        this.isPropagationStopped = $0b2e6adb871a3b94$var$qd;
        return this;
    }
    $0b2e6adb871a3b94$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $0b2e6adb871a3b94$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $0b2e6adb871a3b94$var$pd);
        },
        persist: function() {},
        isPersistent: $0b2e6adb871a3b94$var$pd
    });
    return b;
}
var $0b2e6adb871a3b94$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $0b2e6adb871a3b94$var$td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$sd), $0b2e6adb871a3b94$var$ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    view: 0,
    detail: 0
}), $0b2e6adb871a3b94$var$vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$ud), $0b2e6adb871a3b94$var$wd, $0b2e6adb871a3b94$var$xd, $0b2e6adb871a3b94$var$yd, $0b2e6adb871a3b94$var$Ad = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $0b2e6adb871a3b94$var$yd && ($0b2e6adb871a3b94$var$yd && "mousemove" === a.type ? ($0b2e6adb871a3b94$var$wd = a.screenX - $0b2e6adb871a3b94$var$yd.screenX, $0b2e6adb871a3b94$var$xd = a.screenY - $0b2e6adb871a3b94$var$yd.screenY) : $0b2e6adb871a3b94$var$xd = $0b2e6adb871a3b94$var$wd = 0, $0b2e6adb871a3b94$var$yd = a);
        return $0b2e6adb871a3b94$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $0b2e6adb871a3b94$var$xd;
    }
}), $0b2e6adb871a3b94$var$Bd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ad), $0b2e6adb871a3b94$var$Cd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    dataTransfer: 0
}), $0b2e6adb871a3b94$var$Dd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Cd), $0b2e6adb871a3b94$var$Ed = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    relatedTarget: 0
}), $0b2e6adb871a3b94$var$Fd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ed), $0b2e6adb871a3b94$var$Gd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Hd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Gd), $0b2e6adb871a3b94$var$Id = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $0b2e6adb871a3b94$var$Jd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Id), $0b2e6adb871a3b94$var$Kd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    data: 0
}), $0b2e6adb871a3b94$var$Ld = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Kd), $0b2e6adb871a3b94$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $0b2e6adb871a3b94$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $0b2e6adb871a3b94$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $0b2e6adb871a3b94$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $0b2e6adb871a3b94$var$Od[a]) ? !!b[a] : !1;
}
function $0b2e6adb871a3b94$var$zd() {
    return $0b2e6adb871a3b94$var$Pd;
}
var $0b2e6adb871a3b94$var$Qd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $0b2e6adb871a3b94$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $0b2e6adb871a3b94$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $0b2e6adb871a3b94$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $0b2e6adb871a3b94$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $0b2e6adb871a3b94$var$Rd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Qd), $0b2e6adb871a3b94$var$Sd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $0b2e6adb871a3b94$var$Td = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Sd), $0b2e6adb871a3b94$var$Ud = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $0b2e6adb871a3b94$var$zd
}), $0b2e6adb871a3b94$var$Vd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Ud), $0b2e6adb871a3b94$var$Wd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $0b2e6adb871a3b94$var$Xd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Wd), $0b2e6adb871a3b94$var$Yd = $0b2e6adb871a3b94$var$A({}, $0b2e6adb871a3b94$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $0b2e6adb871a3b94$var$Zd = $0b2e6adb871a3b94$var$rd($0b2e6adb871a3b94$var$Yd), $0b2e6adb871a3b94$var$$d = [
    9,
    13,
    27,
    32
], $0b2e6adb871a3b94$var$ae = $0b2e6adb871a3b94$var$ia && "CompositionEvent" in window, $0b2e6adb871a3b94$var$be = null;
$0b2e6adb871a3b94$var$ia && "documentMode" in document && ($0b2e6adb871a3b94$var$be = document.documentMode);
var $0b2e6adb871a3b94$var$ce = $0b2e6adb871a3b94$var$ia && "TextEvent" in window && !$0b2e6adb871a3b94$var$be, $0b2e6adb871a3b94$var$de = $0b2e6adb871a3b94$var$ia && (!$0b2e6adb871a3b94$var$ae || $0b2e6adb871a3b94$var$be && 8 < $0b2e6adb871a3b94$var$be && 11 >= $0b2e6adb871a3b94$var$be), $0b2e6adb871a3b94$var$ee = String.fromCharCode(32), $0b2e6adb871a3b94$var$fe = !1;
function $0b2e6adb871a3b94$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $0b2e6adb871a3b94$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $0b2e6adb871a3b94$var$ie = !1;
function $0b2e6adb871a3b94$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $0b2e6adb871a3b94$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $0b2e6adb871a3b94$var$fe = !0;
            return $0b2e6adb871a3b94$var$ee;
        case "textInput":
            return a = b.data, a === $0b2e6adb871a3b94$var$ee && $0b2e6adb871a3b94$var$fe ? null : a;
        default:
            return null;
    }
}
function $0b2e6adb871a3b94$var$ke(a, b) {
    if ($0b2e6adb871a3b94$var$ie) return "compositionend" === a || !$0b2e6adb871a3b94$var$ae && $0b2e6adb871a3b94$var$ge(a, b) ? (a = $0b2e6adb871a3b94$var$nd(), $0b2e6adb871a3b94$var$md = $0b2e6adb871a3b94$var$ld = $0b2e6adb871a3b94$var$kd = null, $0b2e6adb871a3b94$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $0b2e6adb871a3b94$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $0b2e6adb871a3b94$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$0b2e6adb871a3b94$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $0b2e6adb871a3b94$var$ne(a, b, c, d) {
    $0b2e6adb871a3b94$var$Eb(d);
    b = $0b2e6adb871a3b94$var$oe(b, "onChange");
    0 < b.length && (c = new $0b2e6adb871a3b94$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $0b2e6adb871a3b94$var$pe = null, $0b2e6adb871a3b94$var$qe = null;
function $0b2e6adb871a3b94$var$re(a) {
    $0b2e6adb871a3b94$var$se(a, 0);
}
function $0b2e6adb871a3b94$var$te(a) {
    var b = $0b2e6adb871a3b94$var$ue(a);
    if ($0b2e6adb871a3b94$var$Wa(b)) return a;
}
function $0b2e6adb871a3b94$var$ve(a, b) {
    if ("change" === a) return b;
}
var $0b2e6adb871a3b94$var$we = !1;
if ($0b2e6adb871a3b94$var$ia) {
    var $0b2e6adb871a3b94$var$xe;
    if ($0b2e6adb871a3b94$var$ia) {
        var $0b2e6adb871a3b94$var$ye = "oninput" in document;
        if (!$0b2e6adb871a3b94$var$ye) {
            var $0b2e6adb871a3b94$var$ze = document.createElement("div");
            $0b2e6adb871a3b94$var$ze.setAttribute("oninput", "return;");
            $0b2e6adb871a3b94$var$ye = "function" === typeof $0b2e6adb871a3b94$var$ze.oninput;
        }
        $0b2e6adb871a3b94$var$xe = $0b2e6adb871a3b94$var$ye;
    } else $0b2e6adb871a3b94$var$xe = !1;
    $0b2e6adb871a3b94$var$we = $0b2e6adb871a3b94$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $0b2e6adb871a3b94$var$Ae() {
    $0b2e6adb871a3b94$var$pe && ($0b2e6adb871a3b94$var$pe.detachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be), $0b2e6adb871a3b94$var$qe = $0b2e6adb871a3b94$var$pe = null);
}
function $0b2e6adb871a3b94$var$Be(a) {
    if ("value" === a.propertyName && $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe)) {
        var b = [];
        $0b2e6adb871a3b94$var$ne(b, $0b2e6adb871a3b94$var$qe, a, $0b2e6adb871a3b94$var$xb(a));
        $0b2e6adb871a3b94$var$Jb($0b2e6adb871a3b94$var$re, b);
    }
}
function $0b2e6adb871a3b94$var$Ce(a, b, c) {
    "focusin" === a ? ($0b2e6adb871a3b94$var$Ae(), $0b2e6adb871a3b94$var$pe = b, $0b2e6adb871a3b94$var$qe = c, $0b2e6adb871a3b94$var$pe.attachEvent("onpropertychange", $0b2e6adb871a3b94$var$Be)) : "focusout" === a && $0b2e6adb871a3b94$var$Ae();
}
function $0b2e6adb871a3b94$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $0b2e6adb871a3b94$var$te($0b2e6adb871a3b94$var$qe);
}
function $0b2e6adb871a3b94$var$Ee(a, b) {
    if ("click" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $0b2e6adb871a3b94$var$te(b);
}
function $0b2e6adb871a3b94$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $0b2e6adb871a3b94$var$He = "function" === typeof Object.is ? Object.is : $0b2e6adb871a3b94$var$Ge;
function $0b2e6adb871a3b94$var$Ie(a, b) {
    if ($0b2e6adb871a3b94$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$0b2e6adb871a3b94$var$ja.call(b, e) || !$0b2e6adb871a3b94$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $0b2e6adb871a3b94$var$Ke(a, b) {
    var c = $0b2e6adb871a3b94$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $0b2e6adb871a3b94$var$Je(c);
    }
}
function $0b2e6adb871a3b94$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $0b2e6adb871a3b94$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $0b2e6adb871a3b94$var$Me() {
    for(var a = window, b = $0b2e6adb871a3b94$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $0b2e6adb871a3b94$var$Xa(a.document);
    }
    return b;
}
function $0b2e6adb871a3b94$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $0b2e6adb871a3b94$var$Oe(a) {
    var b = $0b2e6adb871a3b94$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $0b2e6adb871a3b94$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $0b2e6adb871a3b94$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $0b2e6adb871a3b94$var$Ke(c, f);
                var g = $0b2e6adb871a3b94$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $0b2e6adb871a3b94$var$Pe = $0b2e6adb871a3b94$var$ia && "documentMode" in document && 11 >= document.documentMode, $0b2e6adb871a3b94$var$Qe = null, $0b2e6adb871a3b94$var$Re = null, $0b2e6adb871a3b94$var$Se = null, $0b2e6adb871a3b94$var$Te = !1;
function $0b2e6adb871a3b94$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $0b2e6adb871a3b94$var$Te || null == $0b2e6adb871a3b94$var$Qe || $0b2e6adb871a3b94$var$Qe !== $0b2e6adb871a3b94$var$Xa(d) || (d = $0b2e6adb871a3b94$var$Qe, "selectionStart" in d && $0b2e6adb871a3b94$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $0b2e6adb871a3b94$var$Se && $0b2e6adb871a3b94$var$Ie($0b2e6adb871a3b94$var$Se, d) || ($0b2e6adb871a3b94$var$Se = d, d = $0b2e6adb871a3b94$var$oe($0b2e6adb871a3b94$var$Re, "onSelect"), 0 < d.length && (b = new $0b2e6adb871a3b94$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $0b2e6adb871a3b94$var$Qe)));
}
function $0b2e6adb871a3b94$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $0b2e6adb871a3b94$var$We = {
    animationend: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationIteration"),
    animationstart: $0b2e6adb871a3b94$var$Ve("Animation", "AnimationStart"),
    transitionend: $0b2e6adb871a3b94$var$Ve("Transition", "TransitionEnd")
}, $0b2e6adb871a3b94$var$Xe = {}, $0b2e6adb871a3b94$var$Ye = {};
$0b2e6adb871a3b94$var$ia && ($0b2e6adb871a3b94$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $0b2e6adb871a3b94$var$We.animationend.animation, delete $0b2e6adb871a3b94$var$We.animationiteration.animation, delete $0b2e6adb871a3b94$var$We.animationstart.animation), "TransitionEvent" in window || delete $0b2e6adb871a3b94$var$We.transitionend.transition);
function $0b2e6adb871a3b94$var$Ze(a) {
    if ($0b2e6adb871a3b94$var$Xe[a]) return $0b2e6adb871a3b94$var$Xe[a];
    if (!$0b2e6adb871a3b94$var$We[a]) return a;
    var b = $0b2e6adb871a3b94$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $0b2e6adb871a3b94$var$Ye) return $0b2e6adb871a3b94$var$Xe[a] = b[c];
    return a;
}
var $0b2e6adb871a3b94$var$$e = $0b2e6adb871a3b94$var$Ze("animationend"), $0b2e6adb871a3b94$var$af = $0b2e6adb871a3b94$var$Ze("animationiteration"), $0b2e6adb871a3b94$var$bf = $0b2e6adb871a3b94$var$Ze("animationstart"), $0b2e6adb871a3b94$var$cf = $0b2e6adb871a3b94$var$Ze("transitionend"), $0b2e6adb871a3b94$var$df = new Map, $0b2e6adb871a3b94$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $0b2e6adb871a3b94$var$ff(a, b) {
    $0b2e6adb871a3b94$var$df.set(a, b);
    $0b2e6adb871a3b94$var$fa(b, [
        a
    ]);
}
for(var $0b2e6adb871a3b94$var$gf = 0; $0b2e6adb871a3b94$var$gf < $0b2e6adb871a3b94$var$ef.length; $0b2e6adb871a3b94$var$gf++){
    var $0b2e6adb871a3b94$var$hf = $0b2e6adb871a3b94$var$ef[$0b2e6adb871a3b94$var$gf], $0b2e6adb871a3b94$var$jf = $0b2e6adb871a3b94$var$hf.toLowerCase(), $0b2e6adb871a3b94$var$kf = $0b2e6adb871a3b94$var$hf[0].toUpperCase() + $0b2e6adb871a3b94$var$hf.slice(1);
    $0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$jf, "on" + $0b2e6adb871a3b94$var$kf);
}
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$$e, "onAnimationEnd");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$af, "onAnimationIteration");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$bf, "onAnimationStart");
$0b2e6adb871a3b94$var$ff("dblclick", "onDoubleClick");
$0b2e6adb871a3b94$var$ff("focusin", "onFocus");
$0b2e6adb871a3b94$var$ff("focusout", "onBlur");
$0b2e6adb871a3b94$var$ff($0b2e6adb871a3b94$var$cf, "onTransitionEnd");
$0b2e6adb871a3b94$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$0b2e6adb871a3b94$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$0b2e6adb871a3b94$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$0b2e6adb871a3b94$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$0b2e6adb871a3b94$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$0b2e6adb871a3b94$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $0b2e6adb871a3b94$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $0b2e6adb871a3b94$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($0b2e6adb871a3b94$var$lf));
function $0b2e6adb871a3b94$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $0b2e6adb871a3b94$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $0b2e6adb871a3b94$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $0b2e6adb871a3b94$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($0b2e6adb871a3b94$var$Qb) throw a = $0b2e6adb871a3b94$var$Rb, $0b2e6adb871a3b94$var$Qb = !1, $0b2e6adb871a3b94$var$Rb = null, a;
}
function $0b2e6adb871a3b94$var$D(a, b) {
    var c = b[$0b2e6adb871a3b94$var$of];
    void 0 === c && (c = b[$0b2e6adb871a3b94$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($0b2e6adb871a3b94$var$pf(b, a, 2, !1), c.add(d));
}
function $0b2e6adb871a3b94$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $0b2e6adb871a3b94$var$pf(c, a, d, b);
}
var $0b2e6adb871a3b94$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $0b2e6adb871a3b94$var$sf(a) {
    if (!a[$0b2e6adb871a3b94$var$rf]) {
        a[$0b2e6adb871a3b94$var$rf] = !0;
        $0b2e6adb871a3b94$var$da.forEach(function(b) {
            "selectionchange" !== b && ($0b2e6adb871a3b94$var$mf.has(b) || $0b2e6adb871a3b94$var$qf(b, !1, a), $0b2e6adb871a3b94$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$0b2e6adb871a3b94$var$rf] || (b[$0b2e6adb871a3b94$var$rf] = !0, $0b2e6adb871a3b94$var$qf("selectionchange", !1, b));
    }
}
function $0b2e6adb871a3b94$var$pf(a, b, c, d) {
    switch($0b2e6adb871a3b94$var$jd(b)){
        case 1:
            var e = $0b2e6adb871a3b94$var$ed;
            break;
        case 4:
            e = $0b2e6adb871a3b94$var$gd;
            break;
        default:
            e = $0b2e6adb871a3b94$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$0b2e6adb871a3b94$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $0b2e6adb871a3b94$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $0b2e6adb871a3b94$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $0b2e6adb871a3b94$var$Jb(function() {
        var d = f, e = $0b2e6adb871a3b94$var$xb(c), g = [];
        a: {
            var h = $0b2e6adb871a3b94$var$df.get(a);
            if (void 0 !== h) {
                var k = $0b2e6adb871a3b94$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $0b2e6adb871a3b94$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $0b2e6adb871a3b94$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $0b2e6adb871a3b94$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $0b2e6adb871a3b94$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $0b2e6adb871a3b94$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $0b2e6adb871a3b94$var$Vd;
                        break;
                    case $0b2e6adb871a3b94$var$$e:
                    case $0b2e6adb871a3b94$var$af:
                    case $0b2e6adb871a3b94$var$bf:
                        k = $0b2e6adb871a3b94$var$Hd;
                        break;
                    case $0b2e6adb871a3b94$var$cf:
                        k = $0b2e6adb871a3b94$var$Xd;
                        break;
                    case "scroll":
                        k = $0b2e6adb871a3b94$var$vd;
                        break;
                    case "wheel":
                        k = $0b2e6adb871a3b94$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $0b2e6adb871a3b94$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $0b2e6adb871a3b94$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $0b2e6adb871a3b94$var$Kb(w, x), null != F && t.push($0b2e6adb871a3b94$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $0b2e6adb871a3b94$var$wb && (n = c.relatedTarget || c.fromElement) && ($0b2e6adb871a3b94$var$Wc(n) || n[$0b2e6adb871a3b94$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $0b2e6adb871a3b94$var$Wc(n) : null, null !== n && (J = $0b2e6adb871a3b94$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $0b2e6adb871a3b94$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $0b2e6adb871a3b94$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $0b2e6adb871a3b94$var$ue(k);
                        u = null == n ? h : $0b2e6adb871a3b94$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $0b2e6adb871a3b94$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $0b2e6adb871a3b94$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $0b2e6adb871a3b94$var$vf(F))u++;
                            for(; 0 < w - u;)t = $0b2e6adb871a3b94$var$vf(t), w--;
                            for(; 0 < u - w;)x = $0b2e6adb871a3b94$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $0b2e6adb871a3b94$var$vf(t);
                                x = $0b2e6adb871a3b94$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $0b2e6adb871a3b94$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $0b2e6adb871a3b94$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $0b2e6adb871a3b94$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $0b2e6adb871a3b94$var$ve;
                else if ($0b2e6adb871a3b94$var$me(h)) {
                    if ($0b2e6adb871a3b94$var$we) na = $0b2e6adb871a3b94$var$Fe;
                    else {
                        na = $0b2e6adb871a3b94$var$De;
                        var xa = $0b2e6adb871a3b94$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $0b2e6adb871a3b94$var$Ee);
                if (na && (na = na(a, d))) {
                    $0b2e6adb871a3b94$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $0b2e6adb871a3b94$var$cb(h, "number", h.value);
            }
            xa = d ? $0b2e6adb871a3b94$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($0b2e6adb871a3b94$var$me(xa) || "true" === xa.contentEditable) $0b2e6adb871a3b94$var$Qe = xa, $0b2e6adb871a3b94$var$Re = d, $0b2e6adb871a3b94$var$Se = null;
                    break;
                case "focusout":
                    $0b2e6adb871a3b94$var$Se = $0b2e6adb871a3b94$var$Re = $0b2e6adb871a3b94$var$Qe = null;
                    break;
                case "mousedown":
                    $0b2e6adb871a3b94$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $0b2e6adb871a3b94$var$Te = !1;
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($0b2e6adb871a3b94$var$Pe) break;
                case "keydown":
                case "keyup":
                    $0b2e6adb871a3b94$var$Ue(g, c, e);
            }
            var $a;
            if ($0b2e6adb871a3b94$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $0b2e6adb871a3b94$var$ie ? $0b2e6adb871a3b94$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($0b2e6adb871a3b94$var$de && "ko" !== c.locale && ($0b2e6adb871a3b94$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $0b2e6adb871a3b94$var$ie && ($a = $0b2e6adb871a3b94$var$nd()) : ($0b2e6adb871a3b94$var$kd = e, $0b2e6adb871a3b94$var$ld = "value" in $0b2e6adb871a3b94$var$kd ? $0b2e6adb871a3b94$var$kd.value : $0b2e6adb871a3b94$var$kd.textContent, $0b2e6adb871a3b94$var$ie = !0)), xa = $0b2e6adb871a3b94$var$oe(d, ba), 0 < xa.length && (ba = new $0b2e6adb871a3b94$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $0b2e6adb871a3b94$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $0b2e6adb871a3b94$var$ce ? $0b2e6adb871a3b94$var$je(a, c) : $0b2e6adb871a3b94$var$ke(a, c)) d = $0b2e6adb871a3b94$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $0b2e6adb871a3b94$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $0b2e6adb871a3b94$var$se(g, b);
    });
}
function $0b2e6adb871a3b94$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $0b2e6adb871a3b94$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $0b2e6adb871a3b94$var$Kb(a, c), null != f && d.unshift($0b2e6adb871a3b94$var$tf(a, f, e)), f = $0b2e6adb871a3b94$var$Kb(a, b), null != f && d.push($0b2e6adb871a3b94$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $0b2e6adb871a3b94$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $0b2e6adb871a3b94$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.unshift($0b2e6adb871a3b94$var$tf(c, k, h))) : e || (k = $0b2e6adb871a3b94$var$Kb(c, f), null != k && g.push($0b2e6adb871a3b94$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $0b2e6adb871a3b94$var$xf = /\r\n?/g, $0b2e6adb871a3b94$var$yf = /\u0000|\uFFFD/g;
function $0b2e6adb871a3b94$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($0b2e6adb871a3b94$var$xf, "\n").replace($0b2e6adb871a3b94$var$yf, "");
}
function $0b2e6adb871a3b94$var$Af(a, b, c) {
    b = $0b2e6adb871a3b94$var$zf(b);
    if ($0b2e6adb871a3b94$var$zf(a) !== b && c) throw Error($0b2e6adb871a3b94$var$p(425));
}
function $0b2e6adb871a3b94$var$Bf() {}
var $0b2e6adb871a3b94$var$Cf = null, $0b2e6adb871a3b94$var$Df = null;
function $0b2e6adb871a3b94$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $0b2e6adb871a3b94$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $0b2e6adb871a3b94$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $0b2e6adb871a3b94$var$Hf = "function" === typeof Promise ? Promise : void 0, $0b2e6adb871a3b94$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $0b2e6adb871a3b94$var$Hf ? function(a) {
    return $0b2e6adb871a3b94$var$Hf.resolve(null).then(a).catch($0b2e6adb871a3b94$var$If);
} : $0b2e6adb871a3b94$var$Ff;
function $0b2e6adb871a3b94$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $0b2e6adb871a3b94$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $0b2e6adb871a3b94$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $0b2e6adb871a3b94$var$bd(b);
}
function $0b2e6adb871a3b94$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $0b2e6adb871a3b94$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nf = Math.random().toString(36).slice(2), $0b2e6adb871a3b94$var$Of = "__reactFiber$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Pf = "__reactProps$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$uf = "__reactContainer$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$of = "__reactEvents$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Qf = "__reactListeners$" + $0b2e6adb871a3b94$var$Nf, $0b2e6adb871a3b94$var$Rf = "__reactHandles$" + $0b2e6adb871a3b94$var$Nf;
function $0b2e6adb871a3b94$var$Wc(a) {
    var b = a[$0b2e6adb871a3b94$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$0b2e6adb871a3b94$var$uf] || c[$0b2e6adb871a3b94$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $0b2e6adb871a3b94$var$Mf(a); null !== a;){
                if (c = a[$0b2e6adb871a3b94$var$Of]) return c;
                a = $0b2e6adb871a3b94$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Cb(a) {
    a = a[$0b2e6adb871a3b94$var$Of] || a[$0b2e6adb871a3b94$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $0b2e6adb871a3b94$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($0b2e6adb871a3b94$var$p(33));
}
function $0b2e6adb871a3b94$var$Db(a) {
    return a[$0b2e6adb871a3b94$var$Pf] || null;
}
var $0b2e6adb871a3b94$var$Sf = [], $0b2e6adb871a3b94$var$Tf = -1;
function $0b2e6adb871a3b94$var$Uf(a) {
    return {
        current: a
    };
}
function $0b2e6adb871a3b94$var$E(a) {
    0 > $0b2e6adb871a3b94$var$Tf || (a.current = $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf], $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = null, $0b2e6adb871a3b94$var$Tf--);
}
function $0b2e6adb871a3b94$var$G(a, b) {
    $0b2e6adb871a3b94$var$Tf++;
    $0b2e6adb871a3b94$var$Sf[$0b2e6adb871a3b94$var$Tf] = a.current;
    a.current = b;
}
var $0b2e6adb871a3b94$var$Vf = {}, $0b2e6adb871a3b94$var$H = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Vf), $0b2e6adb871a3b94$var$Wf = $0b2e6adb871a3b94$var$Uf(!1), $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$Vf;
function $0b2e6adb871a3b94$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $0b2e6adb871a3b94$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $0b2e6adb871a3b94$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $0b2e6adb871a3b94$var$$f() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
}
function $0b2e6adb871a3b94$var$ag(a, b, c) {
    if ($0b2e6adb871a3b94$var$H.current !== $0b2e6adb871a3b94$var$Vf) throw Error($0b2e6adb871a3b94$var$p(168));
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
function $0b2e6adb871a3b94$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($0b2e6adb871a3b94$var$p(108, $0b2e6adb871a3b94$var$Ra(a) || "Unknown", e));
    return $0b2e6adb871a3b94$var$A({}, c, d);
}
function $0b2e6adb871a3b94$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $0b2e6adb871a3b94$var$Vf;
    $0b2e6adb871a3b94$var$Xf = $0b2e6adb871a3b94$var$H.current;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, $0b2e6adb871a3b94$var$Wf.current);
    return !0;
}
function $0b2e6adb871a3b94$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($0b2e6adb871a3b94$var$p(169));
    c ? (a = $0b2e6adb871a3b94$var$bg(a, b, $0b2e6adb871a3b94$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$H, a)) : $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Wf, c);
}
var $0b2e6adb871a3b94$var$eg = null, $0b2e6adb871a3b94$var$fg = !1, $0b2e6adb871a3b94$var$gg = !1;
function $0b2e6adb871a3b94$var$hg(a) {
    null === $0b2e6adb871a3b94$var$eg ? $0b2e6adb871a3b94$var$eg = [
        a
    ] : $0b2e6adb871a3b94$var$eg.push(a);
}
function $0b2e6adb871a3b94$var$ig(a) {
    $0b2e6adb871a3b94$var$fg = !0;
    $0b2e6adb871a3b94$var$hg(a);
}
function $0b2e6adb871a3b94$var$jg() {
    if (!$0b2e6adb871a3b94$var$gg && null !== $0b2e6adb871a3b94$var$eg) {
        $0b2e6adb871a3b94$var$gg = !0;
        var a = 0, b = $0b2e6adb871a3b94$var$C;
        try {
            var c = $0b2e6adb871a3b94$var$eg;
            for($0b2e6adb871a3b94$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $0b2e6adb871a3b94$var$eg = null;
            $0b2e6adb871a3b94$var$fg = !1;
        } catch (e) {
            throw null !== $0b2e6adb871a3b94$var$eg && ($0b2e6adb871a3b94$var$eg = $0b2e6adb871a3b94$var$eg.slice(a + 1)), $0b2e6adb871a3b94$var$ac($0b2e6adb871a3b94$var$fc, $0b2e6adb871a3b94$var$jg), e;
        } finally{
            $0b2e6adb871a3b94$var$C = b, $0b2e6adb871a3b94$var$gg = !1;
        }
    }
    return null;
}
var $0b2e6adb871a3b94$var$kg = [], $0b2e6adb871a3b94$var$lg = 0, $0b2e6adb871a3b94$var$mg = null, $0b2e6adb871a3b94$var$ng = 0, $0b2e6adb871a3b94$var$og = [], $0b2e6adb871a3b94$var$pg = 0, $0b2e6adb871a3b94$var$qg = null, $0b2e6adb871a3b94$var$rg = 1, $0b2e6adb871a3b94$var$sg = "";
function $0b2e6adb871a3b94$var$tg(a, b) {
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$ng;
    $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg++] = $0b2e6adb871a3b94$var$mg;
    $0b2e6adb871a3b94$var$mg = a;
    $0b2e6adb871a3b94$var$ng = b;
}
function $0b2e6adb871a3b94$var$ug(a, b, c) {
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg;
    $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg;
    $0b2e6adb871a3b94$var$qg = a;
    var d = $0b2e6adb871a3b94$var$rg;
    a = $0b2e6adb871a3b94$var$sg;
    var e = 32 - $0b2e6adb871a3b94$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $0b2e6adb871a3b94$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $0b2e6adb871a3b94$var$rg = 1 << 32 - $0b2e6adb871a3b94$var$oc(b) + e | c << e | d;
        $0b2e6adb871a3b94$var$sg = f + a;
    } else $0b2e6adb871a3b94$var$rg = 1 << f | c << e | d, $0b2e6adb871a3b94$var$sg = a;
}
function $0b2e6adb871a3b94$var$vg(a) {
    null !== a.return && ($0b2e6adb871a3b94$var$tg(a, 1), $0b2e6adb871a3b94$var$ug(a, 1, 0));
}
function $0b2e6adb871a3b94$var$wg(a) {
    for(; a === $0b2e6adb871a3b94$var$mg;)$0b2e6adb871a3b94$var$mg = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null, $0b2e6adb871a3b94$var$ng = $0b2e6adb871a3b94$var$kg[--$0b2e6adb871a3b94$var$lg], $0b2e6adb871a3b94$var$kg[$0b2e6adb871a3b94$var$lg] = null;
    for(; a === $0b2e6adb871a3b94$var$qg;)$0b2e6adb871a3b94$var$qg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$sg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null, $0b2e6adb871a3b94$var$rg = $0b2e6adb871a3b94$var$og[--$0b2e6adb871a3b94$var$pg], $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg] = null;
}
var $0b2e6adb871a3b94$var$xg = null, $0b2e6adb871a3b94$var$yg = null, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$zg = null;
function $0b2e6adb871a3b94$var$Ag(a, b) {
    var c = $0b2e6adb871a3b94$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $0b2e6adb871a3b94$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $0b2e6adb871a3b94$var$qg ? {
                id: $0b2e6adb871a3b94$var$rg,
                overflow: $0b2e6adb871a3b94$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $0b2e6adb871a3b94$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $0b2e6adb871a3b94$var$xg = a, $0b2e6adb871a3b94$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $0b2e6adb871a3b94$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $0b2e6adb871a3b94$var$Eg(a) {
    if ($0b2e6adb871a3b94$var$I) {
        var b = $0b2e6adb871a3b94$var$yg;
        if (b) {
            var c = b;
            if (!$0b2e6adb871a3b94$var$Cg(a, b)) {
                if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
                b = $0b2e6adb871a3b94$var$Lf(c.nextSibling);
                var d = $0b2e6adb871a3b94$var$xg;
                b && $0b2e6adb871a3b94$var$Cg(a, b) ? $0b2e6adb871a3b94$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $0b2e6adb871a3b94$var$I = !1, $0b2e6adb871a3b94$var$xg = a);
            }
        } else {
            if ($0b2e6adb871a3b94$var$Dg(a)) throw Error($0b2e6adb871a3b94$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $0b2e6adb871a3b94$var$I = !1;
            $0b2e6adb871a3b94$var$xg = a;
        }
    }
}
function $0b2e6adb871a3b94$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $0b2e6adb871a3b94$var$xg = a;
}
function $0b2e6adb871a3b94$var$Gg(a) {
    if (a !== $0b2e6adb871a3b94$var$xg) return !1;
    if (!$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$Fg(a), $0b2e6adb871a3b94$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$0b2e6adb871a3b94$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $0b2e6adb871a3b94$var$yg)) {
        if ($0b2e6adb871a3b94$var$Dg(a)) throw $0b2e6adb871a3b94$var$Hg(), Error($0b2e6adb871a3b94$var$p(418));
        for(; b;)$0b2e6adb871a3b94$var$Ag(a, b), b = $0b2e6adb871a3b94$var$Lf(b.nextSibling);
    }
    $0b2e6adb871a3b94$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($0b2e6adb871a3b94$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $0b2e6adb871a3b94$var$yg = null;
        }
    } else $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg ? $0b2e6adb871a3b94$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $0b2e6adb871a3b94$var$Hg() {
    for(var a = $0b2e6adb871a3b94$var$yg; a;)a = $0b2e6adb871a3b94$var$Lf(a.nextSibling);
}
function $0b2e6adb871a3b94$var$Ig() {
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$xg = null;
    $0b2e6adb871a3b94$var$I = !1;
}
function $0b2e6adb871a3b94$var$Jg(a) {
    null === $0b2e6adb871a3b94$var$zg ? $0b2e6adb871a3b94$var$zg = [
        a
    ] : $0b2e6adb871a3b94$var$zg.push(a);
}
var $0b2e6adb871a3b94$var$Kg = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig;
function $0b2e6adb871a3b94$var$Lg(a, b) {
    if (a && a.defaultProps) {
        b = $0b2e6adb871a3b94$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Mg = $0b2e6adb871a3b94$var$Uf(null), $0b2e6adb871a3b94$var$Ng = null, $0b2e6adb871a3b94$var$Og = null, $0b2e6adb871a3b94$var$Pg = null;
function $0b2e6adb871a3b94$var$Qg() {
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Ng = null;
}
function $0b2e6adb871a3b94$var$Rg(a) {
    var b = $0b2e6adb871a3b94$var$Mg.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Mg);
    a._currentValue = b;
}
function $0b2e6adb871a3b94$var$Sg(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $0b2e6adb871a3b94$var$Tg(a, b) {
    $0b2e6adb871a3b94$var$Ng = a;
    $0b2e6adb871a3b94$var$Pg = $0b2e6adb871a3b94$var$Og = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($0b2e6adb871a3b94$var$Ug = !0), a.firstContext = null);
}
function $0b2e6adb871a3b94$var$Vg(a) {
    var b = a._currentValue;
    if ($0b2e6adb871a3b94$var$Pg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $0b2e6adb871a3b94$var$Og) {
            if (null === $0b2e6adb871a3b94$var$Ng) throw Error($0b2e6adb871a3b94$var$p(308));
            $0b2e6adb871a3b94$var$Og = a;
            $0b2e6adb871a3b94$var$Ng.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $0b2e6adb871a3b94$var$Og = $0b2e6adb871a3b94$var$Og.next = a;
    }
    return b;
}
var $0b2e6adb871a3b94$var$Wg = null;
function $0b2e6adb871a3b94$var$Xg(a) {
    null === $0b2e6adb871a3b94$var$Wg ? $0b2e6adb871a3b94$var$Wg = [
        a
    ] : $0b2e6adb871a3b94$var$Wg.push(a);
}
function $0b2e6adb871a3b94$var$Yg(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $0b2e6adb871a3b94$var$Xg(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $0b2e6adb871a3b94$var$Zg(a, d);
}
function $0b2e6adb871a3b94$var$Zg(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $0b2e6adb871a3b94$var$$g = !1;
function $0b2e6adb871a3b94$var$ah(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $0b2e6adb871a3b94$var$bh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $0b2e6adb871a3b94$var$ch(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $0b2e6adb871a3b94$var$dh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $0b2e6adb871a3b94$var$Zg(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $0b2e6adb871a3b94$var$Xg(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $0b2e6adb871a3b94$var$Zg(a, c);
}
function $0b2e6adb871a3b94$var$eh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
function $0b2e6adb871a3b94$var$fh(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $0b2e6adb871a3b94$var$gh(a, b, c, d) {
    var e = a.updateQueue;
    $0b2e6adb871a3b94$var$$g = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $0b2e6adb871a3b94$var$A({}, q, r);
                            break a;
                        case 2:
                            $0b2e6adb871a3b94$var$$g = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $0b2e6adb871a3b94$var$hh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $0b2e6adb871a3b94$var$ih(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($0b2e6adb871a3b94$var$p(191, e));
            e.call(d);
        }
    }
}
var $0b2e6adb871a3b94$var$jh = (new $acw62.Component).refs;
function $0b2e6adb871a3b94$var$kh(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $0b2e6adb871a3b94$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $0b2e6adb871a3b94$var$nh = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $0b2e6adb871a3b94$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $0b2e6adb871a3b94$var$L(), e = $0b2e6adb871a3b94$var$lh(a), f = $0b2e6adb871a3b94$var$ch(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $0b2e6adb871a3b94$var$dh(a, f, e);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, e, d), $0b2e6adb871a3b94$var$eh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $0b2e6adb871a3b94$var$L(), d = $0b2e6adb871a3b94$var$lh(a), e = $0b2e6adb871a3b94$var$ch(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $0b2e6adb871a3b94$var$dh(a, e, d);
        null !== b && ($0b2e6adb871a3b94$var$mh(b, a, d, c), $0b2e6adb871a3b94$var$eh(b, a, d));
    }
};
function $0b2e6adb871a3b94$var$oh(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$0b2e6adb871a3b94$var$Ie(c, d) || !$0b2e6adb871a3b94$var$Ie(e, f) : !0;
}
function $0b2e6adb871a3b94$var$ph(a, b, c) {
    var d = !1, e = $0b2e6adb871a3b94$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $0b2e6adb871a3b94$var$Vg(f) : (e = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $0b2e6adb871a3b94$var$Yf(a, e) : $0b2e6adb871a3b94$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $0b2e6adb871a3b94$var$nh;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $0b2e6adb871a3b94$var$qh(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(b, b.state, null);
}
function $0b2e6adb871a3b94$var$rh(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = $0b2e6adb871a3b94$var$jh;
    $0b2e6adb871a3b94$var$ah(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $0b2e6adb871a3b94$var$Vg(f) : (f = $0b2e6adb871a3b94$var$Zf(b) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, e.context = $0b2e6adb871a3b94$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($0b2e6adb871a3b94$var$kh(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $0b2e6adb871a3b94$var$nh.enqueueReplaceState(e, e.state, null), $0b2e6adb871a3b94$var$gh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $0b2e6adb871a3b94$var$sh(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($0b2e6adb871a3b94$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($0b2e6adb871a3b94$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                b === $0b2e6adb871a3b94$var$jh && (b = e.refs = {});
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($0b2e6adb871a3b94$var$p(284));
        if (!c._owner) throw Error($0b2e6adb871a3b94$var$p(290, a));
    }
    return a;
}
function $0b2e6adb871a3b94$var$th(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($0b2e6adb871a3b94$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $0b2e6adb871a3b94$var$uh(a) {
    var b = a._init;
    return b(a._payload);
}
function $0b2e6adb871a3b94$var$vh(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $0b2e6adb871a3b94$var$wh(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $0b2e6adb871a3b94$var$xh(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $0b2e6adb871a3b94$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(f) === b.type)) return d = e(b, c.props), d.ref = $0b2e6adb871a3b94$var$sh(a, b, c), d.return = a, d;
        d = $0b2e6adb871a3b94$var$yh(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $0b2e6adb871a3b94$var$sh(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $0b2e6adb871a3b94$var$zh(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $0b2e6adb871a3b94$var$Ah(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $0b2e6adb871a3b94$var$xh("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c = $0b2e6adb871a3b94$var$yh(b.type, b.key, b.props, null, a.mode, c), c.ref = $0b2e6adb871a3b94$var$sh(a, null, b), c.return = a, c;
                case $0b2e6adb871a3b94$var$wa:
                    return b = $0b2e6adb871a3b94$var$zh(b, a.mode, c), b.return = a, b;
                case $0b2e6adb871a3b94$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($0b2e6adb871a3b94$var$eb(b) || $0b2e6adb871a3b94$var$Ka(b)) return b = $0b2e6adb871a3b94$var$Ah(b, a.mode, c, null), b.return = a, b;
            $0b2e6adb871a3b94$var$th(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $0b2e6adb871a3b94$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($0b2e6adb871a3b94$var$eb(c) || $0b2e6adb871a3b94$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $0b2e6adb871a3b94$var$th(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $0b2e6adb871a3b94$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $0b2e6adb871a3b94$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($0b2e6adb871a3b94$var$eb(d) || $0b2e6adb871a3b94$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $0b2e6adb871a3b94$var$th(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $0b2e6adb871a3b94$var$Ka(h);
        if ("function" !== typeof l) throw Error($0b2e6adb871a3b94$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($0b2e6adb871a3b94$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $0b2e6adb871a3b94$var$I && $0b2e6adb871a3b94$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $0b2e6adb871a3b94$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $0b2e6adb871a3b94$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $0b2e6adb871a3b94$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $0b2e6adb871a3b94$var$Ha && $0b2e6adb871a3b94$var$uh(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $0b2e6adb871a3b94$var$sh(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $0b2e6adb871a3b94$var$ya ? (d = $0b2e6adb871a3b94$var$Ah(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $0b2e6adb871a3b94$var$yh(f.type, f.key, f.props, null, a.mode, h), h.ref = $0b2e6adb871a3b94$var$sh(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $0b2e6adb871a3b94$var$zh(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $0b2e6adb871a3b94$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($0b2e6adb871a3b94$var$eb(f)) return n(a, d, f, h);
            if ($0b2e6adb871a3b94$var$Ka(f)) return t(a, d, f, h);
            $0b2e6adb871a3b94$var$th(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $0b2e6adb871a3b94$var$xh(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $0b2e6adb871a3b94$var$Bh = $0b2e6adb871a3b94$var$vh(!0), $0b2e6adb871a3b94$var$Ch = $0b2e6adb871a3b94$var$vh(!1), $0b2e6adb871a3b94$var$Dh = {}, $0b2e6adb871a3b94$var$Eh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Fh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh), $0b2e6adb871a3b94$var$Gh = $0b2e6adb871a3b94$var$Uf($0b2e6adb871a3b94$var$Dh);
function $0b2e6adb871a3b94$var$Hh(a) {
    if (a === $0b2e6adb871a3b94$var$Dh) throw Error($0b2e6adb871a3b94$var$p(174));
    return a;
}
function $0b2e6adb871a3b94$var$Ih(a, b) {
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Gh, b);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, $0b2e6adb871a3b94$var$Dh);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $0b2e6adb871a3b94$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $0b2e6adb871a3b94$var$lb(b, a);
    }
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, b);
}
function $0b2e6adb871a3b94$var$Jh() {
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh);
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Gh);
}
function $0b2e6adb871a3b94$var$Kh(a) {
    $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
    var b = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
    var c = $0b2e6adb871a3b94$var$lb(b, a.type);
    b !== c && ($0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Fh, a), $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Eh, c));
}
function $0b2e6adb871a3b94$var$Lh(a) {
    $0b2e6adb871a3b94$var$Fh.current === a && ($0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Eh), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Fh));
}
var $0b2e6adb871a3b94$var$M = $0b2e6adb871a3b94$var$Uf(0);
function $0b2e6adb871a3b94$var$Mh(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $0b2e6adb871a3b94$var$Nh = [];
function $0b2e6adb871a3b94$var$Oh() {
    for(var a = 0; a < $0b2e6adb871a3b94$var$Nh.length; a++)$0b2e6adb871a3b94$var$Nh[a]._workInProgressVersionPrimary = null;
    $0b2e6adb871a3b94$var$Nh.length = 0;
}
var $0b2e6adb871a3b94$var$Ph = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$Qh = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$Rh = 0, $0b2e6adb871a3b94$var$N = null, $0b2e6adb871a3b94$var$O = null, $0b2e6adb871a3b94$var$P = null, $0b2e6adb871a3b94$var$Sh = !1, $0b2e6adb871a3b94$var$Th = !1, $0b2e6adb871a3b94$var$Uh = 0, $0b2e6adb871a3b94$var$Vh = 0;
function $0b2e6adb871a3b94$var$Q() {
    throw Error($0b2e6adb871a3b94$var$p(321));
}
function $0b2e6adb871a3b94$var$Wh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$0b2e6adb871a3b94$var$He(a[c], b[c])) return !1;
    return !0;
}
function $0b2e6adb871a3b94$var$Xh(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$Rh = f;
    $0b2e6adb871a3b94$var$N = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $0b2e6adb871a3b94$var$Ph.current = null === a || null === a.memoizedState ? $0b2e6adb871a3b94$var$Yh : $0b2e6adb871a3b94$var$Zh;
    a = c(d, e);
    if ($0b2e6adb871a3b94$var$Th) {
        f = 0;
        do {
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            if (25 <= f) throw Error($0b2e6adb871a3b94$var$p(301));
            f += 1;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = null;
            b.updateQueue = null;
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$$h;
            a = c(d, e);
        }while ($0b2e6adb871a3b94$var$Th);
    }
    $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
    b = null !== $0b2e6adb871a3b94$var$O && null !== $0b2e6adb871a3b94$var$O.next;
    $0b2e6adb871a3b94$var$Rh = 0;
    $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
    $0b2e6adb871a3b94$var$Sh = !1;
    if (b) throw Error($0b2e6adb871a3b94$var$p(300));
    return a;
}
function $0b2e6adb871a3b94$var$bi() {
    var a = 0 !== $0b2e6adb871a3b94$var$Uh;
    $0b2e6adb871a3b94$var$Uh = 0;
    return a;
}
function $0b2e6adb871a3b94$var$ci() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$di() {
    if (null === $0b2e6adb871a3b94$var$O) {
        var a = $0b2e6adb871a3b94$var$N.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $0b2e6adb871a3b94$var$O.next;
    var b = null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState : $0b2e6adb871a3b94$var$P.next;
    if (null !== b) $0b2e6adb871a3b94$var$P = b, $0b2e6adb871a3b94$var$O = a;
    else {
        if (null === a) throw Error($0b2e6adb871a3b94$var$p(310));
        $0b2e6adb871a3b94$var$O = a;
        a = {
            memoizedState: $0b2e6adb871a3b94$var$O.memoizedState,
            baseState: $0b2e6adb871a3b94$var$O.baseState,
            baseQueue: $0b2e6adb871a3b94$var$O.baseQueue,
            queue: $0b2e6adb871a3b94$var$O.queue,
            next: null
        };
        null === $0b2e6adb871a3b94$var$P ? $0b2e6adb871a3b94$var$N.memoizedState = $0b2e6adb871a3b94$var$P = a : $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$P.next = a;
    }
    return $0b2e6adb871a3b94$var$P;
}
function $0b2e6adb871a3b94$var$ei(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $0b2e6adb871a3b94$var$fi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = $0b2e6adb871a3b94$var$O, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($0b2e6adb871a3b94$var$Rh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $0b2e6adb871a3b94$var$N.lanes |= m;
                $0b2e6adb871a3b94$var$hh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $0b2e6adb871a3b94$var$He(d, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $0b2e6adb871a3b94$var$N.lanes |= f, $0b2e6adb871a3b94$var$hh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $0b2e6adb871a3b94$var$gi(a) {
    var b = $0b2e6adb871a3b94$var$di(), c = b.queue;
    if (null === c) throw Error($0b2e6adb871a3b94$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $0b2e6adb871a3b94$var$He(f, b.memoizedState) || ($0b2e6adb871a3b94$var$Ug = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $0b2e6adb871a3b94$var$hi() {}
function $0b2e6adb871a3b94$var$ii(a, b) {
    var c = $0b2e6adb871a3b94$var$N, d = $0b2e6adb871a3b94$var$di(), e = b(), f = !$0b2e6adb871a3b94$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $0b2e6adb871a3b94$var$Ug = !0);
    d = d.queue;
    $0b2e6adb871a3b94$var$ji($0b2e6adb871a3b94$var$ki.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $0b2e6adb871a3b94$var$P && $0b2e6adb871a3b94$var$P.memoizedState.tag & 1) {
        c.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, c, d, e, b), void 0, null);
        if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
        0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(c, b, e);
    }
    return e;
}
function $0b2e6adb871a3b94$var$ni(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $0b2e6adb871a3b94$var$mi(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
}
function $0b2e6adb871a3b94$var$ki(a, b, c) {
    return c(function() {
        $0b2e6adb871a3b94$var$oi(b) && $0b2e6adb871a3b94$var$pi(a);
    });
}
function $0b2e6adb871a3b94$var$oi(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$0b2e6adb871a3b94$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $0b2e6adb871a3b94$var$pi(a) {
    var b = $0b2e6adb871a3b94$var$Zg(a, 1);
    null !== b && $0b2e6adb871a3b94$var$mh(b, a, 1, -1);
}
function $0b2e6adb871a3b94$var$qi(a) {
    var b = $0b2e6adb871a3b94$var$ci();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $0b2e6adb871a3b94$var$ei,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $0b2e6adb871a3b94$var$ri.bind(null, $0b2e6adb871a3b94$var$N, a);
    return [
        b.memoizedState,
        a
    ];
}
function $0b2e6adb871a3b94$var$li(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $0b2e6adb871a3b94$var$N.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $0b2e6adb871a3b94$var$N.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $0b2e6adb871a3b94$var$si() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$ti(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$ci();
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, void 0, void 0 === d ? null : d);
}
function $0b2e6adb871a3b94$var$ui(a, b, c, d) {
    var e = $0b2e6adb871a3b94$var$di();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $0b2e6adb871a3b94$var$O) {
        var g = $0b2e6adb871a3b94$var$O.memoizedState;
        f = g.destroy;
        if (null !== d && $0b2e6adb871a3b94$var$Wh(d, g.deps)) {
            e.memoizedState = $0b2e6adb871a3b94$var$li(b, c, f, d);
            return;
        }
    }
    $0b2e6adb871a3b94$var$N.flags |= a;
    e.memoizedState = $0b2e6adb871a3b94$var$li(1 | b, c, f, d);
}
function $0b2e6adb871a3b94$var$vi(a, b) {
    return $0b2e6adb871a3b94$var$ti(8390656, 8, a, b);
}
function $0b2e6adb871a3b94$var$ji(a, b) {
    return $0b2e6adb871a3b94$var$ui(2048, 8, a, b);
}
function $0b2e6adb871a3b94$var$wi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 2, a, b);
}
function $0b2e6adb871a3b94$var$xi(a, b) {
    return $0b2e6adb871a3b94$var$ui(4, 4, a, b);
}
function $0b2e6adb871a3b94$var$yi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $0b2e6adb871a3b94$var$zi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $0b2e6adb871a3b94$var$ui(4, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
}
function $0b2e6adb871a3b94$var$Ai() {}
function $0b2e6adb871a3b94$var$Bi(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Ci(a, b) {
    var c = $0b2e6adb871a3b94$var$di();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $0b2e6adb871a3b94$var$Wh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $0b2e6adb871a3b94$var$Di(a, b, c) {
    if (0 === ($0b2e6adb871a3b94$var$Rh & 21)) return a.baseState && (a.baseState = !1, $0b2e6adb871a3b94$var$Ug = !0), a.memoizedState = c;
    $0b2e6adb871a3b94$var$He(c, b) || (c = $0b2e6adb871a3b94$var$yc(), $0b2e6adb871a3b94$var$N.lanes |= c, $0b2e6adb871a3b94$var$hh |= c, a.baseState = !0);
    return b;
}
function $0b2e6adb871a3b94$var$Ei(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    $0b2e6adb871a3b94$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $0b2e6adb871a3b94$var$Qh.transition;
    $0b2e6adb871a3b94$var$Qh.transition = {};
    try {
        a(!1), b();
    } finally{
        $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$Qh.transition = d;
    }
}
function $0b2e6adb871a3b94$var$Fi() {
    return $0b2e6adb871a3b94$var$di().memoizedState;
}
function $0b2e6adb871a3b94$var$Gi(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, c);
    else if (c = $0b2e6adb871a3b94$var$Yg(a, b, c, d), null !== c) {
        var e = $0b2e6adb871a3b94$var$L();
        $0b2e6adb871a3b94$var$mh(c, a, d, e);
        $0b2e6adb871a3b94$var$Ji(c, b, d);
    }
}
function $0b2e6adb871a3b94$var$ri(a, b, c) {
    var d = $0b2e6adb871a3b94$var$lh(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($0b2e6adb871a3b94$var$Hi(a)) $0b2e6adb871a3b94$var$Ii(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($0b2e6adb871a3b94$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $0b2e6adb871a3b94$var$Xg(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $0b2e6adb871a3b94$var$Yg(a, b, e, d);
        null !== c && (e = $0b2e6adb871a3b94$var$L(), $0b2e6adb871a3b94$var$mh(c, a, d, e), $0b2e6adb871a3b94$var$Ji(c, b, d));
    }
}
function $0b2e6adb871a3b94$var$Hi(a) {
    var b = a.alternate;
    return a === $0b2e6adb871a3b94$var$N || null !== b && b === $0b2e6adb871a3b94$var$N;
}
function $0b2e6adb871a3b94$var$Ii(a, b) {
    $0b2e6adb871a3b94$var$Th = $0b2e6adb871a3b94$var$Sh = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $0b2e6adb871a3b94$var$Ji(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $0b2e6adb871a3b94$var$Cc(a, c);
    }
}
var $0b2e6adb871a3b94$var$ai = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Q,
    useContext: $0b2e6adb871a3b94$var$Q,
    useEffect: $0b2e6adb871a3b94$var$Q,
    useImperativeHandle: $0b2e6adb871a3b94$var$Q,
    useInsertionEffect: $0b2e6adb871a3b94$var$Q,
    useLayoutEffect: $0b2e6adb871a3b94$var$Q,
    useMemo: $0b2e6adb871a3b94$var$Q,
    useReducer: $0b2e6adb871a3b94$var$Q,
    useRef: $0b2e6adb871a3b94$var$Q,
    useState: $0b2e6adb871a3b94$var$Q,
    useDebugValue: $0b2e6adb871a3b94$var$Q,
    useDeferredValue: $0b2e6adb871a3b94$var$Q,
    useTransition: $0b2e6adb871a3b94$var$Q,
    useMutableSource: $0b2e6adb871a3b94$var$Q,
    useSyncExternalStore: $0b2e6adb871a3b94$var$Q,
    useId: $0b2e6adb871a3b94$var$Q,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Yh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: function(a, b) {
        $0b2e6adb871a3b94$var$ci().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$vi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $0b2e6adb871a3b94$var$ti(4194308, 4, $0b2e6adb871a3b94$var$yi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $0b2e6adb871a3b94$var$ti(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $0b2e6adb871a3b94$var$ci();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$ci();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $0b2e6adb871a3b94$var$Gi.bind(null, $0b2e6adb871a3b94$var$N, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $0b2e6adb871a3b94$var$ci();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $0b2e6adb871a3b94$var$qi,
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        return $0b2e6adb871a3b94$var$ci().memoizedState = a;
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$qi(!1), b = a[0];
        a = $0b2e6adb871a3b94$var$Ei.bind(null, a[1]);
        $0b2e6adb871a3b94$var$ci().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $0b2e6adb871a3b94$var$N, e = $0b2e6adb871a3b94$var$ci();
        if ($0b2e6adb871a3b94$var$I) {
            if (void 0 === c) throw Error($0b2e6adb871a3b94$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $0b2e6adb871a3b94$var$R) throw Error($0b2e6adb871a3b94$var$p(349));
            0 !== ($0b2e6adb871a3b94$var$Rh & 30) || $0b2e6adb871a3b94$var$ni(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $0b2e6adb871a3b94$var$vi($0b2e6adb871a3b94$var$ki.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $0b2e6adb871a3b94$var$li(9, $0b2e6adb871a3b94$var$mi.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $0b2e6adb871a3b94$var$ci(), b = $0b2e6adb871a3b94$var$R.identifierPrefix;
        if ($0b2e6adb871a3b94$var$I) {
            var c = $0b2e6adb871a3b94$var$sg;
            var d = $0b2e6adb871a3b94$var$rg;
            c = (d & ~(1 << 32 - $0b2e6adb871a3b94$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $0b2e6adb871a3b94$var$Uh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $0b2e6adb871a3b94$var$Vh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$Zh = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$fi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$fi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
}, $0b2e6adb871a3b94$var$$h = {
    readContext: $0b2e6adb871a3b94$var$Vg,
    useCallback: $0b2e6adb871a3b94$var$Bi,
    useContext: $0b2e6adb871a3b94$var$Vg,
    useEffect: $0b2e6adb871a3b94$var$ji,
    useImperativeHandle: $0b2e6adb871a3b94$var$zi,
    useInsertionEffect: $0b2e6adb871a3b94$var$wi,
    useLayoutEffect: $0b2e6adb871a3b94$var$xi,
    useMemo: $0b2e6adb871a3b94$var$Ci,
    useReducer: $0b2e6adb871a3b94$var$gi,
    useRef: $0b2e6adb871a3b94$var$si,
    useState: function() {
        return $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei);
    },
    useDebugValue: $0b2e6adb871a3b94$var$Ai,
    useDeferredValue: function(a) {
        var b = $0b2e6adb871a3b94$var$di();
        return null === $0b2e6adb871a3b94$var$O ? b.memoizedState = a : $0b2e6adb871a3b94$var$Di(b, $0b2e6adb871a3b94$var$O.memoizedState, a);
    },
    useTransition: function() {
        var a = $0b2e6adb871a3b94$var$gi($0b2e6adb871a3b94$var$ei)[0], b = $0b2e6adb871a3b94$var$di().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $0b2e6adb871a3b94$var$hi,
    useSyncExternalStore: $0b2e6adb871a3b94$var$ii,
    useId: $0b2e6adb871a3b94$var$Fi,
    unstable_isNewReconciler: !1
};
function $0b2e6adb871a3b94$var$Ki(a, b) {
    try {
        var c = "", d = b;
        do c += $0b2e6adb871a3b94$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $0b2e6adb871a3b94$var$Li(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $0b2e6adb871a3b94$var$Mi(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $0b2e6adb871a3b94$var$Ni = "function" === typeof WeakMap ? WeakMap : Map;
function $0b2e6adb871a3b94$var$Oi(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $0b2e6adb871a3b94$var$Pi || ($0b2e6adb871a3b94$var$Pi = !0, $0b2e6adb871a3b94$var$Qi = d);
        $0b2e6adb871a3b94$var$Mi(a, b);
    };
    return c;
}
function $0b2e6adb871a3b94$var$Ri(a, b, c) {
    c = $0b2e6adb871a3b94$var$ch(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $0b2e6adb871a3b94$var$Mi(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $0b2e6adb871a3b94$var$Mi(a, b);
        "function" !== typeof d && (null === $0b2e6adb871a3b94$var$Si ? $0b2e6adb871a3b94$var$Si = new Set([
            this
        ]) : $0b2e6adb871a3b94$var$Si.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $0b2e6adb871a3b94$var$Ti(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $0b2e6adb871a3b94$var$Ni;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $0b2e6adb871a3b94$var$Ui.bind(null, a, b, c), b.then(a, a));
}
function $0b2e6adb871a3b94$var$Vi(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $0b2e6adb871a3b94$var$Wi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $0b2e6adb871a3b94$var$ch(-1, 1), b.tag = 2, $0b2e6adb871a3b94$var$dh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $0b2e6adb871a3b94$var$Xi = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$Ug = !1;
function $0b2e6adb871a3b94$var$Yi(a, b, c, d) {
    b.child = null === a ? $0b2e6adb871a3b94$var$Ch(b, null, c, d) : $0b2e6adb871a3b94$var$Bh(b, a.child, c, d);
}
function $0b2e6adb871a3b94$var$Zi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $0b2e6adb871a3b94$var$Tg(b, e);
    d = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    c = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && c && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, d, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$aj(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$0b2e6adb871a3b94$var$bj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $0b2e6adb871a3b94$var$cj(a, b, f, d, e);
        a = $0b2e6adb871a3b94$var$yh(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $0b2e6adb871a3b94$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $0b2e6adb871a3b94$var$$i(a, b, e);
    }
    b.flags |= 1;
    a = $0b2e6adb871a3b94$var$wh(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $0b2e6adb871a3b94$var$cj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($0b2e6adb871a3b94$var$Ie(f, d) && a.ref === b.ref) {
            if ($0b2e6adb871a3b94$var$Ug = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($0b2e6adb871a3b94$var$Ug = !0);
            else return b.lanes = a.lanes, $0b2e6adb871a3b94$var$$i(a, b, e);
        }
    }
    return $0b2e6adb871a3b94$var$dj(a, b, c, d, e);
}
function $0b2e6adb871a3b94$var$ej(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj);
            $0b2e6adb871a3b94$var$gj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$fj, $0b2e6adb871a3b94$var$gj), $0b2e6adb871a3b94$var$gj |= d;
    $0b2e6adb871a3b94$var$Yi(a, b, e, c);
    return b.child;
}
function $0b2e6adb871a3b94$var$hj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $0b2e6adb871a3b94$var$dj(a, b, c, d, e) {
    var f = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current;
    f = $0b2e6adb871a3b94$var$Yf(b, f);
    $0b2e6adb871a3b94$var$Tg(b, e);
    c = $0b2e6adb871a3b94$var$Xh(a, b, c, d, f, e);
    d = $0b2e6adb871a3b94$var$bi();
    if (null !== a && !$0b2e6adb871a3b94$var$Ug) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $0b2e6adb871a3b94$var$$i(a, b, e);
    $0b2e6adb871a3b94$var$I && d && $0b2e6adb871a3b94$var$vg(b);
    b.flags |= 1;
    $0b2e6adb871a3b94$var$Yi(a, b, c, e);
    return b.child;
}
function $0b2e6adb871a3b94$var$ij(a, b, c, d, e) {
    if ($0b2e6adb871a3b94$var$Zf(c)) {
        var f = !0;
        $0b2e6adb871a3b94$var$cg(b);
    } else f = !1;
    $0b2e6adb871a3b94$var$Tg(b, e);
    if (null === b.stateNode) $0b2e6adb871a3b94$var$jj(a, b), $0b2e6adb871a3b94$var$ph(b, c, d), $0b2e6adb871a3b94$var$rh(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $0b2e6adb871a3b94$var$Vg(l) : (l = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, l = $0b2e6adb871a3b94$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $0b2e6adb871a3b94$var$qh(b, g, d, l);
        $0b2e6adb871a3b94$var$$g = !1;
        var r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof m && ($0b2e6adb871a3b94$var$kh(b, c, m, d), k = b.memoizedState), (h = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $0b2e6adb871a3b94$var$bh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $0b2e6adb871a3b94$var$Lg(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $0b2e6adb871a3b94$var$Vg(k) : (k = $0b2e6adb871a3b94$var$Zf(c) ? $0b2e6adb871a3b94$var$Xf : $0b2e6adb871a3b94$var$H.current, k = $0b2e6adb871a3b94$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $0b2e6adb871a3b94$var$qh(b, g, d, k);
        $0b2e6adb871a3b94$var$$g = !1;
        r = b.memoizedState;
        g.state = r;
        $0b2e6adb871a3b94$var$gh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $0b2e6adb871a3b94$var$Wf.current || $0b2e6adb871a3b94$var$$g ? ("function" === typeof y && ($0b2e6adb871a3b94$var$kh(b, c, y, d), n = b.memoizedState), (l = $0b2e6adb871a3b94$var$$g || $0b2e6adb871a3b94$var$oh(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $0b2e6adb871a3b94$var$kj(a, b, c, d, f, e);
}
function $0b2e6adb871a3b94$var$kj(a, b, c, d, e, f) {
    $0b2e6adb871a3b94$var$hj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $0b2e6adb871a3b94$var$dg(b, c, !1), $0b2e6adb871a3b94$var$$i(a, b, f);
    d = b.stateNode;
    $0b2e6adb871a3b94$var$Xi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $0b2e6adb871a3b94$var$Bh(b, a.child, null, f), b.child = $0b2e6adb871a3b94$var$Bh(b, null, h, f)) : $0b2e6adb871a3b94$var$Yi(a, b, h, f);
    b.memoizedState = d.state;
    e && $0b2e6adb871a3b94$var$dg(b, c, !0);
    return b.child;
}
function $0b2e6adb871a3b94$var$lj(a) {
    var b = a.stateNode;
    b.pendingContext ? $0b2e6adb871a3b94$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $0b2e6adb871a3b94$var$ag(a, b.context, !1);
    $0b2e6adb871a3b94$var$Ih(a, b.containerInfo);
}
function $0b2e6adb871a3b94$var$mj(a, b, c, d, e) {
    $0b2e6adb871a3b94$var$Ig();
    $0b2e6adb871a3b94$var$Jg(e);
    b.flags |= 256;
    $0b2e6adb871a3b94$var$Yi(a, b, c, d);
    return b.child;
}
var $0b2e6adb871a3b94$var$nj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $0b2e6adb871a3b94$var$oj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $0b2e6adb871a3b94$var$pj(a, b, c) {
    var d = b.pendingProps, e = $0b2e6adb871a3b94$var$M.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, e & 1);
    if (null === a) {
        $0b2e6adb871a3b94$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $0b2e6adb871a3b94$var$qj(g, d, 0, null), a = $0b2e6adb871a3b94$var$Ah(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $0b2e6adb871a3b94$var$oj(c), b.memoizedState = $0b2e6adb871a3b94$var$nj, a) : $0b2e6adb871a3b94$var$rj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $0b2e6adb871a3b94$var$sj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $0b2e6adb871a3b94$var$wh(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $0b2e6adb871a3b94$var$wh(h, f) : (f = $0b2e6adb871a3b94$var$Ah(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $0b2e6adb871a3b94$var$oj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $0b2e6adb871a3b94$var$wh(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $0b2e6adb871a3b94$var$rj(a, b) {
    b = $0b2e6adb871a3b94$var$qj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $0b2e6adb871a3b94$var$tj(a, b, c, d) {
    null !== d && $0b2e6adb871a3b94$var$Jg(d);
    $0b2e6adb871a3b94$var$Bh(b, a.child, null, c);
    a = $0b2e6adb871a3b94$var$rj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $0b2e6adb871a3b94$var$sj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(422))), $0b2e6adb871a3b94$var$tj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $0b2e6adb871a3b94$var$qj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $0b2e6adb871a3b94$var$Ah(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $0b2e6adb871a3b94$var$Bh(b, a.child, null, g);
        b.child.memoizedState = $0b2e6adb871a3b94$var$oj(g);
        b.memoizedState = $0b2e6adb871a3b94$var$nj;
        return f;
    }
    if (0 === (b.mode & 1)) return $0b2e6adb871a3b94$var$tj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($0b2e6adb871a3b94$var$p(419));
        d = $0b2e6adb871a3b94$var$Li(f, d, void 0);
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($0b2e6adb871a3b94$var$Ug || h) {
        d = $0b2e6adb871a3b94$var$R;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $0b2e6adb871a3b94$var$Zg(a, e), $0b2e6adb871a3b94$var$mh(d, a, e, -1));
        }
        $0b2e6adb871a3b94$var$uj();
        d = $0b2e6adb871a3b94$var$Li(Error($0b2e6adb871a3b94$var$p(421)));
        return $0b2e6adb871a3b94$var$tj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $0b2e6adb871a3b94$var$vj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(e.nextSibling);
    $0b2e6adb871a3b94$var$xg = b;
    $0b2e6adb871a3b94$var$I = !0;
    $0b2e6adb871a3b94$var$zg = null;
    null !== a && ($0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$rg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$sg, $0b2e6adb871a3b94$var$og[$0b2e6adb871a3b94$var$pg++] = $0b2e6adb871a3b94$var$qg, $0b2e6adb871a3b94$var$rg = a.id, $0b2e6adb871a3b94$var$sg = a.overflow, $0b2e6adb871a3b94$var$qg = b);
    b = $0b2e6adb871a3b94$var$rj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $0b2e6adb871a3b94$var$wj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $0b2e6adb871a3b94$var$Sg(a.return, b, c);
}
function $0b2e6adb871a3b94$var$xj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $0b2e6adb871a3b94$var$yj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $0b2e6adb871a3b94$var$Yi(a, b, d.children, c);
    d = $0b2e6adb871a3b94$var$M.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (19 === a.tag) $0b2e6adb871a3b94$var$wj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $0b2e6adb871a3b94$var$Mh(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $0b2e6adb871a3b94$var$xj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $0b2e6adb871a3b94$var$Mh(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $0b2e6adb871a3b94$var$xj(b, !0, c, null, f);
            break;
        case "together":
            $0b2e6adb871a3b94$var$xj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$jj(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $0b2e6adb871a3b94$var$$i(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $0b2e6adb871a3b94$var$hh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($0b2e6adb871a3b94$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $0b2e6adb871a3b94$var$wh(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $0b2e6adb871a3b94$var$wh(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $0b2e6adb871a3b94$var$zj(a, b, c) {
    switch(b.tag){
        case 3:
            $0b2e6adb871a3b94$var$lj(b);
            $0b2e6adb871a3b94$var$Ig();
            break;
        case 5:
            $0b2e6adb871a3b94$var$Kh(b);
            break;
        case 1:
            $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$cg(b);
            break;
        case 4:
            $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $0b2e6adb871a3b94$var$pj(a, b, c);
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
                a = $0b2e6adb871a3b94$var$$i(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $0b2e6adb871a3b94$var$yj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    return $0b2e6adb871a3b94$var$$i(a, b, c);
}
var $0b2e6adb871a3b94$var$Aj, $0b2e6adb871a3b94$var$Bj, $0b2e6adb871a3b94$var$Cj, $0b2e6adb871a3b94$var$Dj;
$0b2e6adb871a3b94$var$Aj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$0b2e6adb871a3b94$var$Bj = function() {};
$0b2e6adb871a3b94$var$Cj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
        var f = null;
        switch(c){
            case "input":
                e = $0b2e6adb871a3b94$var$Ya(a, e);
                d = $0b2e6adb871a3b94$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $0b2e6adb871a3b94$var$A({}, e, {
                    value: void 0
                });
                d = $0b2e6adb871a3b94$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $0b2e6adb871a3b94$var$gb(a, e);
                d = $0b2e6adb871a3b94$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
        }
        $0b2e6adb871a3b94$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $0b2e6adb871a3b94$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$0b2e6adb871a3b94$var$Dj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $0b2e6adb871a3b94$var$Ej(a, b) {
    if (!$0b2e6adb871a3b94$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $0b2e6adb871a3b94$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $0b2e6adb871a3b94$var$Fj(a, b, c) {
    var d = b.pendingProps;
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $0b2e6adb871a3b94$var$S(b), null;
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 3:
            d = b.stateNode;
            $0b2e6adb871a3b94$var$Jh();
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
            $0b2e6adb871a3b94$var$Oh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $0b2e6adb871a3b94$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null));
            $0b2e6adb871a3b94$var$Bj(a, b);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 5:
            $0b2e6adb871a3b94$var$Lh(b);
            var e = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $0b2e6adb871a3b94$var$Cj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                    $0b2e6adb871a3b94$var$S(b);
                    return null;
                }
                a = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    d[$0b2e6adb871a3b94$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $0b2e6adb871a3b94$var$D("cancel", d);
                            $0b2e6adb871a3b94$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], d);
                            break;
                        case "source":
                            $0b2e6adb871a3b94$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $0b2e6adb871a3b94$var$D("error", d);
                            $0b2e6adb871a3b94$var$D("load", d);
                            break;
                        case "details":
                            $0b2e6adb871a3b94$var$D("toggle", d);
                            break;
                        case "input":
                            $0b2e6adb871a3b94$var$Za(d, f);
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $0b2e6adb871a3b94$var$D("invalid", d);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$hb(d, f), $0b2e6adb871a3b94$var$D("invalid", d);
                    }
                    $0b2e6adb871a3b94$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $0b2e6adb871a3b94$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $0b2e6adb871a3b94$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$Va(d);
                            $0b2e6adb871a3b94$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $0b2e6adb871a3b94$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $0b2e6adb871a3b94$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script></script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$0b2e6adb871a3b94$var$Of] = b;
                    a[$0b2e6adb871a3b94$var$Pf] = d;
                    $0b2e6adb871a3b94$var$Aj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $0b2e6adb871a3b94$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $0b2e6adb871a3b94$var$D("cancel", a);
                                $0b2e6adb871a3b94$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $0b2e6adb871a3b94$var$lf.length; e++)$0b2e6adb871a3b94$var$D($0b2e6adb871a3b94$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $0b2e6adb871a3b94$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $0b2e6adb871a3b94$var$D("error", a);
                                $0b2e6adb871a3b94$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $0b2e6adb871a3b94$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $0b2e6adb871a3b94$var$Za(a, d);
                                e = $0b2e6adb871a3b94$var$Ya(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $0b2e6adb871a3b94$var$A({}, d, {
                                    value: void 0
                                });
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$hb(a, d);
                                e = $0b2e6adb871a3b94$var$gb(a, d);
                                $0b2e6adb871a3b94$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $0b2e6adb871a3b94$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $0b2e6adb871a3b94$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $0b2e6adb871a3b94$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $0b2e6adb871a3b94$var$ob(a, k) : "number" === typeof k && $0b2e6adb871a3b94$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($0b2e6adb871a3b94$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $0b2e6adb871a3b94$var$D("scroll", a) : null != k && $0b2e6adb871a3b94$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $0b2e6adb871a3b94$var$Va(a);
                                $0b2e6adb871a3b94$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $0b2e6adb871a3b94$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $0b2e6adb871a3b94$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $0b2e6adb871a3b94$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $0b2e6adb871a3b94$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $0b2e6adb871a3b94$var$Dj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($0b2e6adb871a3b94$var$p(166));
                c = $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Gh.current);
                $0b2e6adb871a3b94$var$Hh($0b2e6adb871a3b94$var$Eh.current);
                if ($0b2e6adb871a3b94$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$0b2e6adb871a3b94$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $0b2e6adb871a3b94$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $0b2e6adb871a3b94$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$0b2e6adb871a3b94$var$Of] = b, b.stateNode = d;
            }
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($0b2e6adb871a3b94$var$I && null !== $0b2e6adb871a3b94$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $0b2e6adb871a3b94$var$Hg(), $0b2e6adb871a3b94$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $0b2e6adb871a3b94$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($0b2e6adb871a3b94$var$p(317));
                        f[$0b2e6adb871a3b94$var$Of] = b;
                    } else $0b2e6adb871a3b94$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $0b2e6adb871a3b94$var$S(b);
                    f = !1;
                } else null !== $0b2e6adb871a3b94$var$zg && ($0b2e6adb871a3b94$var$Gj($0b2e6adb871a3b94$var$zg), $0b2e6adb871a3b94$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($0b2e6adb871a3b94$var$M.current & 1) ? 0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 3) : $0b2e6adb871a3b94$var$uj()));
            null !== b.updateQueue && (b.flags |= 4);
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$Bj(a, b), null === a && $0b2e6adb871a3b94$var$sf(b.stateNode.containerInfo), $0b2e6adb871a3b94$var$S(b), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), $0b2e6adb871a3b94$var$S(b), null;
        case 17:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), $0b2e6adb871a3b94$var$S(b), null;
        case 19:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            f = b.memoizedState;
            if (null === f) return $0b2e6adb871a3b94$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $0b2e6adb871a3b94$var$Ej(f, !1);
                else {
                    if (0 !== $0b2e6adb871a3b94$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $0b2e6adb871a3b94$var$Mh(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $0b2e6adb871a3b94$var$Ej(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, $0b2e6adb871a3b94$var$M.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $0b2e6adb871a3b94$var$B() > $0b2e6adb871a3b94$var$Hj && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $0b2e6adb871a3b94$var$Mh(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $0b2e6adb871a3b94$var$Ej(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$0b2e6adb871a3b94$var$I) return $0b2e6adb871a3b94$var$S(b), null;
                    } else 2 * $0b2e6adb871a3b94$var$B() - f.renderingStartTime > $0b2e6adb871a3b94$var$Hj && 1073741824 !== c && (b.flags |= 128, d = !0, $0b2e6adb871a3b94$var$Ej(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $0b2e6adb871a3b94$var$B(), b.sibling = null, c = $0b2e6adb871a3b94$var$M.current, $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$M, d ? c & 1 | 2 : c & 1), b;
            $0b2e6adb871a3b94$var$S(b);
            return null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($0b2e6adb871a3b94$var$gj & 1073741824) && ($0b2e6adb871a3b94$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $0b2e6adb871a3b94$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
}
function $0b2e6adb871a3b94$var$Jj(a, b) {
    $0b2e6adb871a3b94$var$wg(b);
    switch(b.tag){
        case 1:
            return $0b2e6adb871a3b94$var$Zf(b.type) && $0b2e6adb871a3b94$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $0b2e6adb871a3b94$var$Jh(), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf), $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H), $0b2e6adb871a3b94$var$Oh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $0b2e6adb871a3b94$var$Lh(b), null;
        case 13:
            $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($0b2e6adb871a3b94$var$p(340));
                $0b2e6adb871a3b94$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M), null;
        case 4:
            return $0b2e6adb871a3b94$var$Jh(), null;
        case 10:
            return $0b2e6adb871a3b94$var$Rg(b.type._context), null;
        case 22:
        case 23:
            return $0b2e6adb871a3b94$var$Ij(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $0b2e6adb871a3b94$var$Kj = !1, $0b2e6adb871a3b94$var$U = !1, $0b2e6adb871a3b94$var$Lj = "function" === typeof WeakSet ? WeakSet : Set, $0b2e6adb871a3b94$var$V = null;
function $0b2e6adb871a3b94$var$Mj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $0b2e6adb871a3b94$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $0b2e6adb871a3b94$var$Nj(a, b, c) {
    try {
        c();
    } catch (d) {
        $0b2e6adb871a3b94$var$W(a, b, d);
    }
}
var $0b2e6adb871a3b94$var$Oj = !1;
function $0b2e6adb871a3b94$var$Pj(a, b) {
    $0b2e6adb871a3b94$var$Cf = $0b2e6adb871a3b94$var$dd;
    a = $0b2e6adb871a3b94$var$Me();
    if ($0b2e6adb871a3b94$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $0b2e6adb871a3b94$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $0b2e6adb871a3b94$var$dd = !1;
    for($0b2e6adb871a3b94$var$V = b; null !== $0b2e6adb871a3b94$var$V;)if (b = $0b2e6adb871a3b94$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $0b2e6adb871a3b94$var$V = a;
    else for(; null !== $0b2e6adb871a3b94$var$V;){
        b = $0b2e6adb871a3b94$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $0b2e6adb871a3b94$var$Lg(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(163));
            }
        } catch (F) {
            $0b2e6adb871a3b94$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $0b2e6adb871a3b94$var$V = a;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
    n = $0b2e6adb871a3b94$var$Oj;
    $0b2e6adb871a3b94$var$Oj = !1;
    return n;
}
function $0b2e6adb871a3b94$var$Qj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $0b2e6adb871a3b94$var$Nj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $0b2e6adb871a3b94$var$Rj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $0b2e6adb871a3b94$var$Sj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $0b2e6adb871a3b94$var$Tj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $0b2e6adb871a3b94$var$Tj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$0b2e6adb871a3b94$var$Of], delete b[$0b2e6adb871a3b94$var$Pf], delete b[$0b2e6adb871a3b94$var$of], delete b[$0b2e6adb871a3b94$var$Qf], delete b[$0b2e6adb871a3b94$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $0b2e6adb871a3b94$var$Uj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $0b2e6adb871a3b94$var$Vj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $0b2e6adb871a3b94$var$Uj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $0b2e6adb871a3b94$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $0b2e6adb871a3b94$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Wj(a, b, c), a = a.sibling;
}
function $0b2e6adb871a3b94$var$Xj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling; null !== a;)$0b2e6adb871a3b94$var$Xj(a, b, c), a = a.sibling;
}
var $0b2e6adb871a3b94$var$X = null, $0b2e6adb871a3b94$var$Yj = !1;
function $0b2e6adb871a3b94$var$Zj(a, b, c) {
    for(c = c.child; null !== c;)$0b2e6adb871a3b94$var$ak(a, b, c), c = c.sibling;
}
function $0b2e6adb871a3b94$var$ak(a, b, c) {
    if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount) try {
        $0b2e6adb871a3b94$var$lc.onCommitFiberUnmount($0b2e6adb871a3b94$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Mj(c, b);
        case 6:
            var d = $0b2e6adb871a3b94$var$X, e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $0b2e6adb871a3b94$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $0b2e6adb871a3b94$var$X && ($0b2e6adb871a3b94$var$Yj ? (a = $0b2e6adb871a3b94$var$X, c = c.stateNode, 8 === a.nodeType ? $0b2e6adb871a3b94$var$Kf(a.parentNode, c) : 1 === a.nodeType && $0b2e6adb871a3b94$var$Kf(a, c), $0b2e6adb871a3b94$var$bd(a)) : $0b2e6adb871a3b94$var$Kf($0b2e6adb871a3b94$var$X, c.stateNode));
            break;
        case 4:
            d = $0b2e6adb871a3b94$var$X;
            e = $0b2e6adb871a3b94$var$Yj;
            $0b2e6adb871a3b94$var$X = c.stateNode.containerInfo;
            $0b2e6adb871a3b94$var$Yj = !0;
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            $0b2e6adb871a3b94$var$X = d;
            $0b2e6adb871a3b94$var$Yj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$0b2e6adb871a3b94$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $0b2e6adb871a3b94$var$Nj(c, b, g) : 0 !== (f & 4) && $0b2e6adb871a3b94$var$Nj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 1:
            if (!$0b2e6adb871a3b94$var$U && ($0b2e6adb871a3b94$var$Mj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $0b2e6adb871a3b94$var$W(c, b, h);
            }
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 21:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($0b2e6adb871a3b94$var$U = (d = $0b2e6adb871a3b94$var$U) || null !== c.memoizedState, $0b2e6adb871a3b94$var$Zj(a, b, c), $0b2e6adb871a3b94$var$U = d) : $0b2e6adb871a3b94$var$Zj(a, b, c);
            break;
        default:
            $0b2e6adb871a3b94$var$Zj(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$bk(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $0b2e6adb871a3b94$var$Lj);
        b.forEach(function(b) {
            var d = $0b2e6adb871a3b94$var$ck.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $0b2e6adb871a3b94$var$dk(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $0b2e6adb871a3b94$var$X = h.stateNode;
                        $0b2e6adb871a3b94$var$Yj = !1;
                        break a;
                    case 3:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                    case 4:
                        $0b2e6adb871a3b94$var$X = h.stateNode.containerInfo;
                        $0b2e6adb871a3b94$var$Yj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $0b2e6adb871a3b94$var$X) throw Error($0b2e6adb871a3b94$var$p(160));
            $0b2e6adb871a3b94$var$ak(f, g, e);
            $0b2e6adb871a3b94$var$X = null;
            $0b2e6adb871a3b94$var$Yj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $0b2e6adb871a3b94$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$0b2e6adb871a3b94$var$ek(b, a), b = b.sibling;
}
function $0b2e6adb871a3b94$var$ek(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                try {
                    $0b2e6adb871a3b94$var$Qj(3, a, a.return), $0b2e6adb871a3b94$var$Rj(3, a);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
                try {
                    $0b2e6adb871a3b94$var$Qj(5, a, a.return);
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            break;
        case 5:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 512 && null !== c && $0b2e6adb871a3b94$var$Mj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $0b2e6adb871a3b94$var$ob(e, "");
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $0b2e6adb871a3b94$var$ab(e, f);
                    $0b2e6adb871a3b94$var$vb(h, g);
                    var l = $0b2e6adb871a3b94$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $0b2e6adb871a3b94$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $0b2e6adb871a3b94$var$nb(e, q) : "children" === m ? $0b2e6adb871a3b94$var$ob(e, q) : $0b2e6adb871a3b94$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $0b2e6adb871a3b94$var$bb(e, f);
                            break;
                        case "textarea":
                            $0b2e6adb871a3b94$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.defaultValue, !0) : $0b2e6adb871a3b94$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$0b2e6adb871a3b94$var$Pf] = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($0b2e6adb871a3b94$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $0b2e6adb871a3b94$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $0b2e6adb871a3b94$var$bd(b.containerInfo);
            } catch (t) {
                $0b2e6adb871a3b94$var$W(a, a.return, t);
            }
            break;
        case 4:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            break;
        case 13:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($0b2e6adb871a3b94$var$gk = $0b2e6adb871a3b94$var$B()));
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($0b2e6adb871a3b94$var$U = (l = $0b2e6adb871a3b94$var$U) || m, $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$U = l) : $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($0b2e6adb871a3b94$var$V = a, m = a.child; null !== m;){
                    for(q = $0b2e6adb871a3b94$var$V = m; null !== $0b2e6adb871a3b94$var$V;){
                        r = $0b2e6adb871a3b94$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(4, r, r.return);
                                break;
                            case 1:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $0b2e6adb871a3b94$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $0b2e6adb871a3b94$var$Mj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $0b2e6adb871a3b94$var$hk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $0b2e6adb871a3b94$var$V = y) : $0b2e6adb871a3b94$var$hk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $0b2e6adb871a3b94$var$rb("display", g));
                            } catch (t) {
                                $0b2e6adb871a3b94$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $0b2e6adb871a3b94$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $0b2e6adb871a3b94$var$dk(b, a);
            $0b2e6adb871a3b94$var$fk(a);
            d & 4 && $0b2e6adb871a3b94$var$bk(a);
            break;
        case 21:
            break;
        default:
            $0b2e6adb871a3b94$var$dk(b, a), $0b2e6adb871a3b94$var$fk(a);
    }
}
function $0b2e6adb871a3b94$var$fk(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($0b2e6adb871a3b94$var$Uj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($0b2e6adb871a3b94$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($0b2e6adb871a3b94$var$ob(e, ""), d.flags &= -33);
                    var f = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Xj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $0b2e6adb871a3b94$var$Vj(a);
                    $0b2e6adb871a3b94$var$Wj(a, h, g);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(161));
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $0b2e6adb871a3b94$var$ik(a, b, c) {
    $0b2e6adb871a3b94$var$V = a;
    $0b2e6adb871a3b94$var$jk(a, b, c);
}
function $0b2e6adb871a3b94$var$jk(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $0b2e6adb871a3b94$var$V;){
        var e = $0b2e6adb871a3b94$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $0b2e6adb871a3b94$var$Kj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $0b2e6adb871a3b94$var$U;
                h = $0b2e6adb871a3b94$var$Kj;
                var l = $0b2e6adb871a3b94$var$U;
                $0b2e6adb871a3b94$var$Kj = g;
                if (($0b2e6adb871a3b94$var$U = k) && !l) for($0b2e6adb871a3b94$var$V = e; null !== $0b2e6adb871a3b94$var$V;)g = $0b2e6adb871a3b94$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $0b2e6adb871a3b94$var$kk(e) : null !== k ? (k.return = g, $0b2e6adb871a3b94$var$V = k) : $0b2e6adb871a3b94$var$kk(e);
                for(; null !== f;)$0b2e6adb871a3b94$var$V = f, $0b2e6adb871a3b94$var$jk(f, b, c), f = f.sibling;
                $0b2e6adb871a3b94$var$V = e;
                $0b2e6adb871a3b94$var$Kj = h;
                $0b2e6adb871a3b94$var$U = l;
            }
            $0b2e6adb871a3b94$var$lk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $0b2e6adb871a3b94$var$V = f) : $0b2e6adb871a3b94$var$lk(a, b, c);
    }
}
function $0b2e6adb871a3b94$var$lk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $0b2e6adb871a3b94$var$U || $0b2e6adb871a3b94$var$Rj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$0b2e6adb871a3b94$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $0b2e6adb871a3b94$var$Lg(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $0b2e6adb871a3b94$var$ih(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $0b2e6adb871a3b94$var$ih(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $0b2e6adb871a3b94$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($0b2e6adb871a3b94$var$p(163));
                }
                $0b2e6adb871a3b94$var$U || b.flags & 512 && $0b2e6adb871a3b94$var$Sj(b);
            } catch (r) {
                $0b2e6adb871a3b94$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$hk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $0b2e6adb871a3b94$var$V = c;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
function $0b2e6adb871a3b94$var$kk(a) {
    for(; null !== $0b2e6adb871a3b94$var$V;){
        var b = $0b2e6adb871a3b94$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Rj(4, b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $0b2e6adb871a3b94$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $0b2e6adb871a3b94$var$Sj(b);
                    } catch (k) {
                        $0b2e6adb871a3b94$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $0b2e6adb871a3b94$var$W(b, b.return, k);
        }
        if (b === a) {
            $0b2e6adb871a3b94$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $0b2e6adb871a3b94$var$V = h;
            break;
        }
        $0b2e6adb871a3b94$var$V = b.return;
    }
}
var $0b2e6adb871a3b94$var$mk = Math.ceil, $0b2e6adb871a3b94$var$nk = $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher, $0b2e6adb871a3b94$var$ok = $0b2e6adb871a3b94$var$ua.ReactCurrentOwner, $0b2e6adb871a3b94$var$pk = $0b2e6adb871a3b94$var$ua.ReactCurrentBatchConfig, $0b2e6adb871a3b94$var$K = 0, $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Y = null, $0b2e6adb871a3b94$var$Z = 0, $0b2e6adb871a3b94$var$gj = 0, $0b2e6adb871a3b94$var$fj = $0b2e6adb871a3b94$var$Uf(0), $0b2e6adb871a3b94$var$T = 0, $0b2e6adb871a3b94$var$qk = null, $0b2e6adb871a3b94$var$hh = 0, $0b2e6adb871a3b94$var$rk = 0, $0b2e6adb871a3b94$var$sk = 0, $0b2e6adb871a3b94$var$tk = null, $0b2e6adb871a3b94$var$uk = null, $0b2e6adb871a3b94$var$gk = 0, $0b2e6adb871a3b94$var$Hj = Infinity, $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Pi = !1, $0b2e6adb871a3b94$var$Qi = null, $0b2e6adb871a3b94$var$Si = null, $0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = null, $0b2e6adb871a3b94$var$yk = 0, $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, $0b2e6adb871a3b94$var$Bk = -1, $0b2e6adb871a3b94$var$Ck = 0;
function $0b2e6adb871a3b94$var$L() {
    return 0 !== ($0b2e6adb871a3b94$var$K & 6) ? $0b2e6adb871a3b94$var$B() : -1 !== $0b2e6adb871a3b94$var$Bk ? $0b2e6adb871a3b94$var$Bk : $0b2e6adb871a3b94$var$Bk = $0b2e6adb871a3b94$var$B();
}
function $0b2e6adb871a3b94$var$lh(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($0b2e6adb871a3b94$var$K & 2) && 0 !== $0b2e6adb871a3b94$var$Z) return $0b2e6adb871a3b94$var$Z & -$0b2e6adb871a3b94$var$Z;
    if (null !== $0b2e6adb871a3b94$var$Kg.transition) return 0 === $0b2e6adb871a3b94$var$Ck && ($0b2e6adb871a3b94$var$Ck = $0b2e6adb871a3b94$var$yc()), $0b2e6adb871a3b94$var$Ck;
    a = $0b2e6adb871a3b94$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $0b2e6adb871a3b94$var$jd(a.type);
    return a;
}
function $0b2e6adb871a3b94$var$mh(a, b, c, d) {
    if (50 < $0b2e6adb871a3b94$var$zk) throw $0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = null, Error($0b2e6adb871a3b94$var$p(185));
    $0b2e6adb871a3b94$var$Ac(a, c, d);
    if (0 === ($0b2e6adb871a3b94$var$K & 2) || a !== $0b2e6adb871a3b94$var$R) a === $0b2e6adb871a3b94$var$R && (0 === ($0b2e6adb871a3b94$var$K & 2) && ($0b2e6adb871a3b94$var$rk |= c), 4 === $0b2e6adb871a3b94$var$T && $0b2e6adb871a3b94$var$Dk(a, $0b2e6adb871a3b94$var$Z)), $0b2e6adb871a3b94$var$Ek(a, d), 1 === c && 0 === $0b2e6adb871a3b94$var$K && 0 === (b.mode & 1) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
}
function $0b2e6adb871a3b94$var$Ek(a, b) {
    var c = a.callbackNode;
    $0b2e6adb871a3b94$var$wc(a, b);
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) null !== c && $0b2e6adb871a3b94$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $0b2e6adb871a3b94$var$bc(c);
        if (1 === b) 0 === a.tag ? $0b2e6adb871a3b94$var$ig($0b2e6adb871a3b94$var$Fk.bind(null, a)) : $0b2e6adb871a3b94$var$hg($0b2e6adb871a3b94$var$Fk.bind(null, a)), $0b2e6adb871a3b94$var$Jf(function() {
            0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
        }), c = null;
        else {
            switch($0b2e6adb871a3b94$var$Dc(d)){
                case 1:
                    c = $0b2e6adb871a3b94$var$fc;
                    break;
                case 4:
                    c = $0b2e6adb871a3b94$var$gc;
                    break;
                case 16:
                    c = $0b2e6adb871a3b94$var$hc;
                    break;
                case 536870912:
                    c = $0b2e6adb871a3b94$var$jc;
                    break;
                default:
                    c = $0b2e6adb871a3b94$var$hc;
            }
            c = $0b2e6adb871a3b94$var$Gk(c, $0b2e6adb871a3b94$var$Hk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $0b2e6adb871a3b94$var$Hk(a, b) {
    $0b2e6adb871a3b94$var$Bk = -1;
    $0b2e6adb871a3b94$var$Ck = 0;
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    var c = a.callbackNode;
    if ($0b2e6adb871a3b94$var$Ik() && a.callbackNode !== c) return null;
    var d = $0b2e6adb871a3b94$var$uc(a, a === $0b2e6adb871a3b94$var$R ? $0b2e6adb871a3b94$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $0b2e6adb871a3b94$var$Jk(a, d);
    else {
        b = d;
        var e = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 2;
        var f = $0b2e6adb871a3b94$var$Kk();
        if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$Lk(a, b);
        for(;;)try {
            $0b2e6adb871a3b94$var$Mk();
            break;
        } catch (h) {
            $0b2e6adb871a3b94$var$Nk(a, h);
        }
        $0b2e6adb871a3b94$var$Qg();
        $0b2e6adb871a3b94$var$nk.current = f;
        $0b2e6adb871a3b94$var$K = e;
        null !== $0b2e6adb871a3b94$var$Y ? b = 0 : ($0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0, b = $0b2e6adb871a3b94$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $0b2e6adb871a3b94$var$xc(a), 0 !== e && (d = e, b = $0b2e6adb871a3b94$var$Ok(a, e)));
        if (1 === b) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
        if (6 === b) $0b2e6adb871a3b94$var$Dk(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$0b2e6adb871a3b94$var$Pk(e) && (b = $0b2e6adb871a3b94$var$Jk(a, d), 2 === b && (f = $0b2e6adb871a3b94$var$xc(a), 0 !== f && (d = f, b = $0b2e6adb871a3b94$var$Ok(a, f))), 1 === b)) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, d), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($0b2e6adb871a3b94$var$p(345));
                case 2:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 3:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 130023424) === d && (b = $0b2e6adb871a3b94$var$gk + 500 - $0b2e6adb871a3b94$var$B(), 10 < b)) {
                        if (0 !== $0b2e6adb871a3b94$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $0b2e6adb871a3b94$var$L();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), b);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 4:
                    $0b2e6adb871a3b94$var$Dk(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $0b2e6adb871a3b94$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $0b2e6adb871a3b94$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $0b2e6adb871a3b94$var$mk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $0b2e6adb871a3b94$var$Ff($0b2e6adb871a3b94$var$Qk.bind(null, a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk), d);
                        break;
                    }
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                case 5:
                    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
                    break;
                default:
                    throw Error($0b2e6adb871a3b94$var$p(329));
            }
        }
    }
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return a.callbackNode === c ? $0b2e6adb871a3b94$var$Hk.bind(null, a) : null;
}
function $0b2e6adb871a3b94$var$Ok(a, b) {
    var c = $0b2e6adb871a3b94$var$tk;
    a.current.memoizedState.isDehydrated && ($0b2e6adb871a3b94$var$Lk(a, b).flags |= 256);
    a = $0b2e6adb871a3b94$var$Jk(a, b);
    2 !== a && (b = $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$uk = c, null !== b && $0b2e6adb871a3b94$var$Gj(b));
    return a;
}
function $0b2e6adb871a3b94$var$Gj(a) {
    null === $0b2e6adb871a3b94$var$uk ? $0b2e6adb871a3b94$var$uk = a : $0b2e6adb871a3b94$var$uk.push.apply($0b2e6adb871a3b94$var$uk, a);
}
function $0b2e6adb871a3b94$var$Pk(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$0b2e6adb871a3b94$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $0b2e6adb871a3b94$var$Dk(a, b) {
    b &= ~$0b2e6adb871a3b94$var$sk;
    b &= ~$0b2e6adb871a3b94$var$rk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $0b2e6adb871a3b94$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $0b2e6adb871a3b94$var$Fk(a) {
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$uc(a, 0);
    if (0 === (b & 1)) return $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), null;
    var c = $0b2e6adb871a3b94$var$Jk(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $0b2e6adb871a3b94$var$xc(a);
        0 !== d && (b = d, c = $0b2e6adb871a3b94$var$Ok(a, d));
    }
    if (1 === c) throw c = $0b2e6adb871a3b94$var$qk, $0b2e6adb871a3b94$var$Lk(a, 0), $0b2e6adb871a3b94$var$Dk(a, b), $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B()), c;
    if (6 === c) throw Error($0b2e6adb871a3b94$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $0b2e6adb871a3b94$var$Qk(a, $0b2e6adb871a3b94$var$uk, $0b2e6adb871a3b94$var$vk);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    return null;
}
function $0b2e6adb871a3b94$var$Rk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    try {
        return a(b);
    } finally{
        $0b2e6adb871a3b94$var$K = c, 0 === $0b2e6adb871a3b94$var$K && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$fg && $0b2e6adb871a3b94$var$jg());
    }
}
function $0b2e6adb871a3b94$var$Sk(a) {
    null !== $0b2e6adb871a3b94$var$xk && 0 === $0b2e6adb871a3b94$var$xk.tag && 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$Ik();
    var b = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 1;
    var c = $0b2e6adb871a3b94$var$pk.transition, d = $0b2e6adb871a3b94$var$C;
    try {
        if ($0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, a) return a();
    } finally{
        $0b2e6adb871a3b94$var$C = d, $0b2e6adb871a3b94$var$pk.transition = c, $0b2e6adb871a3b94$var$K = b, 0 === ($0b2e6adb871a3b94$var$K & 6) && $0b2e6adb871a3b94$var$jg();
    }
}
function $0b2e6adb871a3b94$var$Ij() {
    $0b2e6adb871a3b94$var$gj = $0b2e6adb871a3b94$var$fj.current;
    $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$fj);
}
function $0b2e6adb871a3b94$var$Lk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $0b2e6adb871a3b94$var$Gf(c));
    if (null !== $0b2e6adb871a3b94$var$Y) for(c = $0b2e6adb871a3b94$var$Y.return; null !== c;){
        var d = c;
        $0b2e6adb871a3b94$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $0b2e6adb871a3b94$var$$f();
                break;
            case 3:
                $0b2e6adb871a3b94$var$Jh();
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$Wf);
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$H);
                $0b2e6adb871a3b94$var$Oh();
                break;
            case 5:
                $0b2e6adb871a3b94$var$Lh(d);
                break;
            case 4:
                $0b2e6adb871a3b94$var$Jh();
                break;
            case 13:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 19:
                $0b2e6adb871a3b94$var$E($0b2e6adb871a3b94$var$M);
                break;
            case 10:
                $0b2e6adb871a3b94$var$Rg(d.type._context);
                break;
            case 22:
            case 23:
                $0b2e6adb871a3b94$var$Ij();
        }
        c = c.return;
    }
    $0b2e6adb871a3b94$var$R = a;
    $0b2e6adb871a3b94$var$Y = a = $0b2e6adb871a3b94$var$wh(a.current, null);
    $0b2e6adb871a3b94$var$Z = $0b2e6adb871a3b94$var$gj = b;
    $0b2e6adb871a3b94$var$T = 0;
    $0b2e6adb871a3b94$var$qk = null;
    $0b2e6adb871a3b94$var$sk = $0b2e6adb871a3b94$var$rk = $0b2e6adb871a3b94$var$hh = 0;
    $0b2e6adb871a3b94$var$uk = $0b2e6adb871a3b94$var$tk = null;
    if (null !== $0b2e6adb871a3b94$var$Wg) {
        for(b = 0; b < $0b2e6adb871a3b94$var$Wg.length; b++)if (c = $0b2e6adb871a3b94$var$Wg[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $0b2e6adb871a3b94$var$Wg = null;
    }
    return a;
}
function $0b2e6adb871a3b94$var$Nk(a, b) {
    do {
        var c = $0b2e6adb871a3b94$var$Y;
        try {
            $0b2e6adb871a3b94$var$Qg();
            $0b2e6adb871a3b94$var$Ph.current = $0b2e6adb871a3b94$var$ai;
            if ($0b2e6adb871a3b94$var$Sh) {
                for(var d = $0b2e6adb871a3b94$var$N.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $0b2e6adb871a3b94$var$Sh = !1;
            }
            $0b2e6adb871a3b94$var$Rh = 0;
            $0b2e6adb871a3b94$var$P = $0b2e6adb871a3b94$var$O = $0b2e6adb871a3b94$var$N = null;
            $0b2e6adb871a3b94$var$Th = !1;
            $0b2e6adb871a3b94$var$Uh = 0;
            $0b2e6adb871a3b94$var$ok.current = null;
            if (null === c || null === c.return) {
                $0b2e6adb871a3b94$var$T = 1;
                $0b2e6adb871a3b94$var$qk = b;
                $0b2e6adb871a3b94$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $0b2e6adb871a3b94$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $0b2e6adb871a3b94$var$Wi(y, g, h, f, b);
                        y.mode & 1 && $0b2e6adb871a3b94$var$Ti(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $0b2e6adb871a3b94$var$Ti(f, l, b);
                            $0b2e6adb871a3b94$var$uj();
                            break a;
                        }
                        k = Error($0b2e6adb871a3b94$var$p(426));
                    }
                } else if ($0b2e6adb871a3b94$var$I && h.mode & 1) {
                    var J = $0b2e6adb871a3b94$var$Vi(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $0b2e6adb871a3b94$var$Wi(J, g, h, f, b);
                        $0b2e6adb871a3b94$var$Jg($0b2e6adb871a3b94$var$Ki(k, h));
                        break a;
                    }
                }
                f = k = $0b2e6adb871a3b94$var$Ki(k, h);
                4 !== $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 2);
                null === $0b2e6adb871a3b94$var$tk ? $0b2e6adb871a3b94$var$tk = [
                    f
                ] : $0b2e6adb871a3b94$var$tk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $0b2e6adb871a3b94$var$Oi(f, k, b);
                            $0b2e6adb871a3b94$var$fh(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $0b2e6adb871a3b94$var$Ri(f, h, b);
                                $0b2e6adb871a3b94$var$fh(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $0b2e6adb871a3b94$var$Tk(c);
        } catch (na) {
            b = na;
            $0b2e6adb871a3b94$var$Y === c && null !== c && ($0b2e6adb871a3b94$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $0b2e6adb871a3b94$var$Kk() {
    var a = $0b2e6adb871a3b94$var$nk.current;
    $0b2e6adb871a3b94$var$nk.current = $0b2e6adb871a3b94$var$ai;
    return null === a ? $0b2e6adb871a3b94$var$ai : a;
}
function $0b2e6adb871a3b94$var$uj() {
    if (0 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T || 2 === $0b2e6adb871a3b94$var$T) $0b2e6adb871a3b94$var$T = 4;
    null === $0b2e6adb871a3b94$var$R || 0 === ($0b2e6adb871a3b94$var$hh & 268435455) && 0 === ($0b2e6adb871a3b94$var$rk & 268435455) || $0b2e6adb871a3b94$var$Dk($0b2e6adb871a3b94$var$R, $0b2e6adb871a3b94$var$Z);
}
function $0b2e6adb871a3b94$var$Jk(a, b) {
    var c = $0b2e6adb871a3b94$var$K;
    $0b2e6adb871a3b94$var$K |= 2;
    var d = $0b2e6adb871a3b94$var$Kk();
    if ($0b2e6adb871a3b94$var$R !== a || $0b2e6adb871a3b94$var$Z !== b) $0b2e6adb871a3b94$var$vk = null, $0b2e6adb871a3b94$var$Lk(a, b);
    for(;;)try {
        $0b2e6adb871a3b94$var$Uk();
        break;
    } catch (e) {
        $0b2e6adb871a3b94$var$Nk(a, e);
    }
    $0b2e6adb871a3b94$var$Qg();
    $0b2e6adb871a3b94$var$K = c;
    $0b2e6adb871a3b94$var$nk.current = d;
    if (null !== $0b2e6adb871a3b94$var$Y) throw Error($0b2e6adb871a3b94$var$p(261));
    $0b2e6adb871a3b94$var$R = null;
    $0b2e6adb871a3b94$var$Z = 0;
    return $0b2e6adb871a3b94$var$T;
}
function $0b2e6adb871a3b94$var$Uk() {
    for(; null !== $0b2e6adb871a3b94$var$Y;)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Mk() {
    for(; null !== $0b2e6adb871a3b94$var$Y && !$0b2e6adb871a3b94$var$cc();)$0b2e6adb871a3b94$var$Vk($0b2e6adb871a3b94$var$Y);
}
function $0b2e6adb871a3b94$var$Vk(a) {
    var b = $0b2e6adb871a3b94$var$Wk(a.alternate, a, $0b2e6adb871a3b94$var$gj);
    a.memoizedProps = a.pendingProps;
    null === b ? $0b2e6adb871a3b94$var$Tk(a) : $0b2e6adb871a3b94$var$Y = b;
    $0b2e6adb871a3b94$var$ok.current = null;
}
function $0b2e6adb871a3b94$var$Tk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $0b2e6adb871a3b94$var$Fj(c, b, $0b2e6adb871a3b94$var$gj), null !== c) {
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
        } else {
            c = $0b2e6adb871a3b94$var$Jj(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $0b2e6adb871a3b94$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $0b2e6adb871a3b94$var$T = 6;
                $0b2e6adb871a3b94$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $0b2e6adb871a3b94$var$Y = b;
            return;
        }
        $0b2e6adb871a3b94$var$Y = b = a;
    }while (null !== b);
    0 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$T = 5);
}
function $0b2e6adb871a3b94$var$Qk(a, b, c) {
    var d = $0b2e6adb871a3b94$var$C, e = $0b2e6adb871a3b94$var$pk.transition;
    try {
        $0b2e6adb871a3b94$var$pk.transition = null, $0b2e6adb871a3b94$var$C = 1, $0b2e6adb871a3b94$var$Xk(a, b, c, d);
    } finally{
        $0b2e6adb871a3b94$var$pk.transition = e, $0b2e6adb871a3b94$var$C = d;
    }
    return null;
}
function $0b2e6adb871a3b94$var$Xk(a, b, c, d) {
    do $0b2e6adb871a3b94$var$Ik();
    while (null !== $0b2e6adb871a3b94$var$xk);
    if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($0b2e6adb871a3b94$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $0b2e6adb871a3b94$var$Bc(a, f);
    a === $0b2e6adb871a3b94$var$R && ($0b2e6adb871a3b94$var$Y = $0b2e6adb871a3b94$var$R = null, $0b2e6adb871a3b94$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $0b2e6adb871a3b94$var$wk || ($0b2e6adb871a3b94$var$wk = !0, $0b2e6adb871a3b94$var$Gk($0b2e6adb871a3b94$var$hc, function() {
        $0b2e6adb871a3b94$var$Ik();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $0b2e6adb871a3b94$var$pk.transition;
        $0b2e6adb871a3b94$var$pk.transition = null;
        var g = $0b2e6adb871a3b94$var$C;
        $0b2e6adb871a3b94$var$C = 1;
        var h = $0b2e6adb871a3b94$var$K;
        $0b2e6adb871a3b94$var$K |= 4;
        $0b2e6adb871a3b94$var$ok.current = null;
        $0b2e6adb871a3b94$var$Pj(a, c);
        $0b2e6adb871a3b94$var$ek(c, a);
        $0b2e6adb871a3b94$var$Oe($0b2e6adb871a3b94$var$Df);
        $0b2e6adb871a3b94$var$dd = !!$0b2e6adb871a3b94$var$Cf;
        $0b2e6adb871a3b94$var$Df = $0b2e6adb871a3b94$var$Cf = null;
        a.current = c;
        $0b2e6adb871a3b94$var$ik(c, a, e);
        $0b2e6adb871a3b94$var$dc();
        $0b2e6adb871a3b94$var$K = h;
        $0b2e6adb871a3b94$var$C = g;
        $0b2e6adb871a3b94$var$pk.transition = f;
    } else a.current = c;
    $0b2e6adb871a3b94$var$wk && ($0b2e6adb871a3b94$var$wk = !1, $0b2e6adb871a3b94$var$xk = a, $0b2e6adb871a3b94$var$yk = e);
    f = a.pendingLanes;
    0 === f && ($0b2e6adb871a3b94$var$Si = null);
    $0b2e6adb871a3b94$var$mc(c.stateNode, d);
    $0b2e6adb871a3b94$var$Ek(a, $0b2e6adb871a3b94$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($0b2e6adb871a3b94$var$Pi) throw $0b2e6adb871a3b94$var$Pi = !1, a = $0b2e6adb871a3b94$var$Qi, $0b2e6adb871a3b94$var$Qi = null, a;
    0 !== ($0b2e6adb871a3b94$var$yk & 1) && 0 !== a.tag && $0b2e6adb871a3b94$var$Ik();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $0b2e6adb871a3b94$var$Ak ? $0b2e6adb871a3b94$var$zk++ : ($0b2e6adb871a3b94$var$zk = 0, $0b2e6adb871a3b94$var$Ak = a) : $0b2e6adb871a3b94$var$zk = 0;
    $0b2e6adb871a3b94$var$jg();
    return null;
}
function $0b2e6adb871a3b94$var$Ik() {
    if (null !== $0b2e6adb871a3b94$var$xk) {
        var a = $0b2e6adb871a3b94$var$Dc($0b2e6adb871a3b94$var$yk), b = $0b2e6adb871a3b94$var$pk.transition, c = $0b2e6adb871a3b94$var$C;
        try {
            $0b2e6adb871a3b94$var$pk.transition = null;
            $0b2e6adb871a3b94$var$C = 16 > a ? 16 : a;
            if (null === $0b2e6adb871a3b94$var$xk) var d = !1;
            else {
                a = $0b2e6adb871a3b94$var$xk;
                $0b2e6adb871a3b94$var$xk = null;
                $0b2e6adb871a3b94$var$yk = 0;
                if (0 !== ($0b2e6adb871a3b94$var$K & 6)) throw Error($0b2e6adb871a3b94$var$p(331));
                var e = $0b2e6adb871a3b94$var$K;
                $0b2e6adb871a3b94$var$K |= 4;
                for($0b2e6adb871a3b94$var$V = a.current; null !== $0b2e6adb871a3b94$var$V;){
                    var f = $0b2e6adb871a3b94$var$V, g = f.child;
                    if (0 !== ($0b2e6adb871a3b94$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($0b2e6adb871a3b94$var$V = l; null !== $0b2e6adb871a3b94$var$V;){
                                    var m = $0b2e6adb871a3b94$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $0b2e6adb871a3b94$var$Qj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $0b2e6adb871a3b94$var$V = q;
                                    else for(; null !== $0b2e6adb871a3b94$var$V;){
                                        m = $0b2e6adb871a3b94$var$V;
                                        var r = m.sibling, y = m.return;
                                        $0b2e6adb871a3b94$var$Tj(m);
                                        if (m === l) {
                                            $0b2e6adb871a3b94$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $0b2e6adb871a3b94$var$V = r;
                                            break;
                                        }
                                        $0b2e6adb871a3b94$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $0b2e6adb871a3b94$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $0b2e6adb871a3b94$var$V = g;
                    else b: for(; null !== $0b2e6adb871a3b94$var$V;){
                        f = $0b2e6adb871a3b94$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $0b2e6adb871a3b94$var$Qj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $0b2e6adb871a3b94$var$V = x;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = f.return;
                    }
                }
                var w = a.current;
                for($0b2e6adb871a3b94$var$V = w; null !== $0b2e6adb871a3b94$var$V;){
                    g = $0b2e6adb871a3b94$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $0b2e6adb871a3b94$var$V = u;
                    else b: for(g = w; null !== $0b2e6adb871a3b94$var$V;){
                        h = $0b2e6adb871a3b94$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $0b2e6adb871a3b94$var$Rj(9, h);
                            }
                        } catch (na) {
                            $0b2e6adb871a3b94$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $0b2e6adb871a3b94$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $0b2e6adb871a3b94$var$V = F;
                            break b;
                        }
                        $0b2e6adb871a3b94$var$V = h.return;
                    }
                }
                $0b2e6adb871a3b94$var$K = e;
                $0b2e6adb871a3b94$var$jg();
                if ($0b2e6adb871a3b94$var$lc && "function" === typeof $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot) try {
                    $0b2e6adb871a3b94$var$lc.onPostCommitFiberRoot($0b2e6adb871a3b94$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $0b2e6adb871a3b94$var$C = c, $0b2e6adb871a3b94$var$pk.transition = b;
        }
    }
    return !1;
}
function $0b2e6adb871a3b94$var$Yk(a, b, c) {
    b = $0b2e6adb871a3b94$var$Ki(c, b);
    b = $0b2e6adb871a3b94$var$Oi(a, b, 1);
    a = $0b2e6adb871a3b94$var$dh(a, b, 1);
    b = $0b2e6adb871a3b94$var$L();
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, 1, b), $0b2e6adb871a3b94$var$Ek(a, b));
}
function $0b2e6adb871a3b94$var$W(a, b, c) {
    if (3 === a.tag) $0b2e6adb871a3b94$var$Yk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $0b2e6adb871a3b94$var$Yk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $0b2e6adb871a3b94$var$Si || !$0b2e6adb871a3b94$var$Si.has(d))) {
                a = $0b2e6adb871a3b94$var$Ki(c, a);
                a = $0b2e6adb871a3b94$var$Ri(b, a, 1);
                b = $0b2e6adb871a3b94$var$dh(b, a, 1);
                a = $0b2e6adb871a3b94$var$L();
                null !== b && ($0b2e6adb871a3b94$var$Ac(b, 1, a), $0b2e6adb871a3b94$var$Ek(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $0b2e6adb871a3b94$var$Ui(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $0b2e6adb871a3b94$var$L();
    a.pingedLanes |= a.suspendedLanes & c;
    $0b2e6adb871a3b94$var$R === a && ($0b2e6adb871a3b94$var$Z & c) === c && (4 === $0b2e6adb871a3b94$var$T || 3 === $0b2e6adb871a3b94$var$T && ($0b2e6adb871a3b94$var$Z & 130023424) === $0b2e6adb871a3b94$var$Z && 500 > $0b2e6adb871a3b94$var$B() - $0b2e6adb871a3b94$var$gk ? $0b2e6adb871a3b94$var$Lk(a, 0) : $0b2e6adb871a3b94$var$sk |= c);
    $0b2e6adb871a3b94$var$Ek(a, b);
}
function $0b2e6adb871a3b94$var$Zk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $0b2e6adb871a3b94$var$sc, $0b2e6adb871a3b94$var$sc <<= 1, 0 === ($0b2e6adb871a3b94$var$sc & 130023424) && ($0b2e6adb871a3b94$var$sc = 4194304)));
    var c = $0b2e6adb871a3b94$var$L();
    a = $0b2e6adb871a3b94$var$Zg(a, b);
    null !== a && ($0b2e6adb871a3b94$var$Ac(a, b, c), $0b2e6adb871a3b94$var$Ek(a, c));
}
function $0b2e6adb871a3b94$var$vj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
function $0b2e6adb871a3b94$var$ck(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($0b2e6adb871a3b94$var$p(314));
    }
    null !== d && d.delete(b);
    $0b2e6adb871a3b94$var$Zk(a, c);
}
var $0b2e6adb871a3b94$var$Wk;
$0b2e6adb871a3b94$var$Wk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $0b2e6adb871a3b94$var$Wf.current) $0b2e6adb871a3b94$var$Ug = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$zj(a, b, c);
            $0b2e6adb871a3b94$var$Ug = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $0b2e6adb871a3b94$var$Ug = !1, $0b2e6adb871a3b94$var$I && 0 !== (b.flags & 1048576) && $0b2e6adb871a3b94$var$ug(b, $0b2e6adb871a3b94$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $0b2e6adb871a3b94$var$jj(a, b);
            a = b.pendingProps;
            var e = $0b2e6adb871a3b94$var$Yf(b, $0b2e6adb871a3b94$var$H.current);
            $0b2e6adb871a3b94$var$Tg(b, c);
            e = $0b2e6adb871a3b94$var$Xh(null, b, d, a, e, c);
            var f = $0b2e6adb871a3b94$var$bi();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $0b2e6adb871a3b94$var$Zf(d) ? (f = !0, $0b2e6adb871a3b94$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $0b2e6adb871a3b94$var$ah(b), e.updater = $0b2e6adb871a3b94$var$nh, b.stateNode = e, e._reactInternals = b, $0b2e6adb871a3b94$var$rh(b, d, a, c), b = $0b2e6adb871a3b94$var$kj(null, b, d, !0, f, c)) : (b.tag = 0, $0b2e6adb871a3b94$var$I && f && $0b2e6adb871a3b94$var$vg(b), $0b2e6adb871a3b94$var$Yi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $0b2e6adb871a3b94$var$jj(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $0b2e6adb871a3b94$var$$k(d);
                a = $0b2e6adb871a3b94$var$Lg(d, a);
                switch(e){
                    case 0:
                        b = $0b2e6adb871a3b94$var$dj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $0b2e6adb871a3b94$var$ij(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $0b2e6adb871a3b94$var$Zi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $0b2e6adb871a3b94$var$aj(null, b, d, $0b2e6adb871a3b94$var$Lg(d.type, a), c);
                        break a;
                }
                throw Error($0b2e6adb871a3b94$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$dj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$ij(a, b, d, e, c);
        case 3:
            a: {
                $0b2e6adb871a3b94$var$lj(b);
                if (null === a) throw Error($0b2e6adb871a3b94$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $0b2e6adb871a3b94$var$bh(a, b);
                $0b2e6adb871a3b94$var$gh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(423)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $0b2e6adb871a3b94$var$Ki(Error($0b2e6adb871a3b94$var$p(424)), b);
                        b = $0b2e6adb871a3b94$var$mj(a, b, d, c, e);
                        break a;
                    } else for($0b2e6adb871a3b94$var$yg = $0b2e6adb871a3b94$var$Lf(b.stateNode.containerInfo.firstChild), $0b2e6adb871a3b94$var$xg = b, $0b2e6adb871a3b94$var$I = !0, $0b2e6adb871a3b94$var$zg = null, c = $0b2e6adb871a3b94$var$Ch(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $0b2e6adb871a3b94$var$Ig();
                    if (d === e) {
                        b = $0b2e6adb871a3b94$var$$i(a, b, c);
                        break a;
                    }
                    $0b2e6adb871a3b94$var$Yi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $0b2e6adb871a3b94$var$Kh(b), null === a && $0b2e6adb871a3b94$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $0b2e6adb871a3b94$var$Ef(d, e) ? g = null : null !== f && $0b2e6adb871a3b94$var$Ef(d, f) && (b.flags |= 32), $0b2e6adb871a3b94$var$hj(a, b), $0b2e6adb871a3b94$var$Yi(a, b, g, c), b.child;
        case 6:
            return null === a && $0b2e6adb871a3b94$var$Eg(b), null;
        case 13:
            return $0b2e6adb871a3b94$var$pj(a, b, c);
        case 4:
            return $0b2e6adb871a3b94$var$Ih(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $0b2e6adb871a3b94$var$Bh(b, null, d, c) : $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$Zi(a, b, d, e, c);
        case 7:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $0b2e6adb871a3b94$var$Yi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $0b2e6adb871a3b94$var$G($0b2e6adb871a3b94$var$Mg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($0b2e6adb871a3b94$var$He(f.value, g)) {
                        if (f.children === e.children && !$0b2e6adb871a3b94$var$Wf.current) {
                            b = $0b2e6adb871a3b94$var$$i(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $0b2e6adb871a3b94$var$ch(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $0b2e6adb871a3b94$var$Sg(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($0b2e6adb871a3b94$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $0b2e6adb871a3b94$var$Sg(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $0b2e6adb871a3b94$var$Yi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $0b2e6adb871a3b94$var$Tg(b, c), e = $0b2e6adb871a3b94$var$Vg(e), d = d(e), b.flags |= 1, $0b2e6adb871a3b94$var$Yi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $0b2e6adb871a3b94$var$Lg(d, b.pendingProps), e = $0b2e6adb871a3b94$var$Lg(d.type, e), $0b2e6adb871a3b94$var$aj(a, b, d, e, c);
        case 15:
            return $0b2e6adb871a3b94$var$cj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $0b2e6adb871a3b94$var$Lg(d, e), $0b2e6adb871a3b94$var$jj(a, b), b.tag = 1, $0b2e6adb871a3b94$var$Zf(d) ? (a = !0, $0b2e6adb871a3b94$var$cg(b)) : a = !1, $0b2e6adb871a3b94$var$Tg(b, c), $0b2e6adb871a3b94$var$ph(b, d, e), $0b2e6adb871a3b94$var$rh(b, d, e, c), $0b2e6adb871a3b94$var$kj(null, b, d, !0, a, c);
        case 19:
            return $0b2e6adb871a3b94$var$yj(a, b, c);
        case 22:
            return $0b2e6adb871a3b94$var$ej(a, b, c);
    }
    throw Error($0b2e6adb871a3b94$var$p(156, b.tag));
};
function $0b2e6adb871a3b94$var$Gk(a, b) {
    return $0b2e6adb871a3b94$var$ac(a, b);
}
function $0b2e6adb871a3b94$var$al(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $0b2e6adb871a3b94$var$Bg(a, b, c, d) {
    return new $0b2e6adb871a3b94$var$al(a, b, c, d);
}
function $0b2e6adb871a3b94$var$bj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $0b2e6adb871a3b94$var$$k(a) {
    if ("function" === typeof a) return $0b2e6adb871a3b94$var$bj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $0b2e6adb871a3b94$var$Da) return 11;
        if (a === $0b2e6adb871a3b94$var$Ga) return 14;
    }
    return 2;
}
function $0b2e6adb871a3b94$var$wh(a, b) {
    var c = a.alternate;
    null === c ? (c = $0b2e6adb871a3b94$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $0b2e6adb871a3b94$var$yh(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $0b2e6adb871a3b94$var$bj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $0b2e6adb871a3b94$var$ya:
            return $0b2e6adb871a3b94$var$Ah(c.children, e, f, b);
        case $0b2e6adb871a3b94$var$za:
            g = 8;
            e |= 8;
            break;
        case $0b2e6adb871a3b94$var$Aa:
            return a = $0b2e6adb871a3b94$var$Bg(12, c, b, e | 2), a.elementType = $0b2e6adb871a3b94$var$Aa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ea:
            return a = $0b2e6adb871a3b94$var$Bg(13, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Ea, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Fa:
            return a = $0b2e6adb871a3b94$var$Bg(19, c, b, e), a.elementType = $0b2e6adb871a3b94$var$Fa, a.lanes = f, a;
        case $0b2e6adb871a3b94$var$Ia:
            return $0b2e6adb871a3b94$var$qj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $0b2e6adb871a3b94$var$Ba:
                    g = 10;
                    break a;
                case $0b2e6adb871a3b94$var$Ca:
                    g = 9;
                    break a;
                case $0b2e6adb871a3b94$var$Da:
                    g = 11;
                    break a;
                case $0b2e6adb871a3b94$var$Ga:
                    g = 14;
                    break a;
                case $0b2e6adb871a3b94$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($0b2e6adb871a3b94$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $0b2e6adb871a3b94$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $0b2e6adb871a3b94$var$Ah(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$qj(a, b, c, d) {
    a = $0b2e6adb871a3b94$var$Bg(22, a, d, b);
    a.elementType = $0b2e6adb871a3b94$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $0b2e6adb871a3b94$var$xh(a, b, c) {
    a = $0b2e6adb871a3b94$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $0b2e6adb871a3b94$var$zh(a, b, c) {
    b = $0b2e6adb871a3b94$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $0b2e6adb871a3b94$var$bl(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $0b2e6adb871a3b94$var$zc(0);
    this.expirationTimes = $0b2e6adb871a3b94$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $0b2e6adb871a3b94$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $0b2e6adb871a3b94$var$cl(a, b, c, d, e, f, g, h, k) {
    a = new $0b2e6adb871a3b94$var$bl(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $0b2e6adb871a3b94$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $0b2e6adb871a3b94$var$ah(f);
    return a;
}
function $0b2e6adb871a3b94$var$dl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $0b2e6adb871a3b94$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $0b2e6adb871a3b94$var$el(a) {
    if (!a) return $0b2e6adb871a3b94$var$Vf;
    a = a._reactInternals;
    a: {
        if ($0b2e6adb871a3b94$var$Vb(a) !== a || 1 !== a.tag) throw Error($0b2e6adb871a3b94$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($0b2e6adb871a3b94$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($0b2e6adb871a3b94$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($0b2e6adb871a3b94$var$Zf(c)) return $0b2e6adb871a3b94$var$bg(a, c, b);
    }
    return b;
}
function $0b2e6adb871a3b94$var$fl(a, b, c, d, e, f, g, h, k) {
    a = $0b2e6adb871a3b94$var$cl(c, d, !0, a, e, f, g, h, k);
    a.context = $0b2e6adb871a3b94$var$el(null);
    c = a.current;
    d = $0b2e6adb871a3b94$var$L();
    e = $0b2e6adb871a3b94$var$lh(c);
    f = $0b2e6adb871a3b94$var$ch(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $0b2e6adb871a3b94$var$dh(c, f, e);
    a.current.lanes = e;
    $0b2e6adb871a3b94$var$Ac(a, e, d);
    $0b2e6adb871a3b94$var$Ek(a, d);
    return a;
}
function $0b2e6adb871a3b94$var$gl(a, b, c, d) {
    var e = b.current, f = $0b2e6adb871a3b94$var$L(), g = $0b2e6adb871a3b94$var$lh(e);
    c = $0b2e6adb871a3b94$var$el(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $0b2e6adb871a3b94$var$ch(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $0b2e6adb871a3b94$var$dh(e, b, g);
    null !== a && ($0b2e6adb871a3b94$var$mh(a, e, g, f), $0b2e6adb871a3b94$var$eh(a, e, g));
    return g;
}
function $0b2e6adb871a3b94$var$hl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $0b2e6adb871a3b94$var$il(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $0b2e6adb871a3b94$var$jl(a, b) {
    $0b2e6adb871a3b94$var$il(a, b);
    (a = a.alternate) && $0b2e6adb871a3b94$var$il(a, b);
}
function $0b2e6adb871a3b94$var$kl() {
    return null;
}
var $0b2e6adb871a3b94$var$ll = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $0b2e6adb871a3b94$var$ml(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.render = $0b2e6adb871a3b94$var$ml.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($0b2e6adb871a3b94$var$p(409));
    $0b2e6adb871a3b94$var$gl(a, b, null, null);
};
$0b2e6adb871a3b94$var$nl.prototype.unmount = $0b2e6adb871a3b94$var$ml.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $0b2e6adb871a3b94$var$Sk(function() {
            $0b2e6adb871a3b94$var$gl(null, a, null, null);
        });
        b[$0b2e6adb871a3b94$var$uf] = null;
    }
};
function $0b2e6adb871a3b94$var$nl(a) {
    this._internalRoot = a;
}
$0b2e6adb871a3b94$var$nl.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $0b2e6adb871a3b94$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $0b2e6adb871a3b94$var$Qc.length && 0 !== b && b < $0b2e6adb871a3b94$var$Qc[c].priority; c++);
        $0b2e6adb871a3b94$var$Qc.splice(c, 0, a);
        0 === c && $0b2e6adb871a3b94$var$Vc(a);
    }
};
function $0b2e6adb871a3b94$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $0b2e6adb871a3b94$var$pl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $0b2e6adb871a3b94$var$ql() {}
function $0b2e6adb871a3b94$var$rl(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                f.call(a);
            };
        }
        var g = $0b2e6adb871a3b94$var$fl(b, d, a, 0, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
        a._reactRootContainer = g;
        a[$0b2e6adb871a3b94$var$uf] = g.current;
        $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
        $0b2e6adb871a3b94$var$Sk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $0b2e6adb871a3b94$var$hl(k);
            h.call(a);
        };
    }
    var k = $0b2e6adb871a3b94$var$cl(a, 0, !1, null, null, !1, !1, "", $0b2e6adb871a3b94$var$ql);
    a._reactRootContainer = k;
    a[$0b2e6adb871a3b94$var$uf] = k.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    $0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$gl(b, k, c, d);
    });
    return k;
}
function $0b2e6adb871a3b94$var$sl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $0b2e6adb871a3b94$var$hl(g);
                h.call(a);
            };
        }
        $0b2e6adb871a3b94$var$gl(b, g, a, e);
    } else g = $0b2e6adb871a3b94$var$rl(c, b, a, e, d);
    return $0b2e6adb871a3b94$var$hl(g);
}
$0b2e6adb871a3b94$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $0b2e6adb871a3b94$var$tc(b.pendingLanes);
                0 !== c && ($0b2e6adb871a3b94$var$Cc(b, c | 1), $0b2e6adb871a3b94$var$Ek(b, $0b2e6adb871a3b94$var$B()), 0 === ($0b2e6adb871a3b94$var$K & 6) && ($0b2e6adb871a3b94$var$Hj = $0b2e6adb871a3b94$var$B() + 500, $0b2e6adb871a3b94$var$jg()));
            }
            break;
        case 13:
            $0b2e6adb871a3b94$var$Sk(function() {
                var b = $0b2e6adb871a3b94$var$Zg(a, 1);
                if (null !== b) {
                    var c = $0b2e6adb871a3b94$var$L();
                    $0b2e6adb871a3b94$var$mh(b, a, 1, c);
                }
            }), $0b2e6adb871a3b94$var$jl(a, 1);
    }
};
$0b2e6adb871a3b94$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$Zg(a, 134217728);
        if (null !== b) {
            var c = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(b, a, 134217728, c);
        }
        $0b2e6adb871a3b94$var$jl(a, 134217728);
    }
};
$0b2e6adb871a3b94$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $0b2e6adb871a3b94$var$lh(a), c = $0b2e6adb871a3b94$var$Zg(a, b);
        if (null !== c) {
            var d = $0b2e6adb871a3b94$var$L();
            $0b2e6adb871a3b94$var$mh(c, a, b, d);
        }
        $0b2e6adb871a3b94$var$jl(a, b);
    }
};
$0b2e6adb871a3b94$var$Hc = function() {
    return $0b2e6adb871a3b94$var$C;
};
$0b2e6adb871a3b94$var$Ic = function(a, b) {
    var c = $0b2e6adb871a3b94$var$C;
    try {
        return $0b2e6adb871a3b94$var$C = a, b();
    } finally{
        $0b2e6adb871a3b94$var$C = c;
    }
};
$0b2e6adb871a3b94$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $0b2e6adb871a3b94$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $0b2e6adb871a3b94$var$Db(d);
                        if (!e) throw Error($0b2e6adb871a3b94$var$p(90));
                        $0b2e6adb871a3b94$var$Wa(d);
                        $0b2e6adb871a3b94$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $0b2e6adb871a3b94$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $0b2e6adb871a3b94$var$fb(a, !!c.multiple, b, !1);
    }
};
$0b2e6adb871a3b94$var$Gb = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$var$Hb = $0b2e6adb871a3b94$var$Sk;
var $0b2e6adb871a3b94$var$tl = {
    usingClientEntryPoint: !1,
    Events: [
        $0b2e6adb871a3b94$var$Cb,
        $0b2e6adb871a3b94$var$ue,
        $0b2e6adb871a3b94$var$Db,
        $0b2e6adb871a3b94$var$Eb,
        $0b2e6adb871a3b94$var$Fb,
        $0b2e6adb871a3b94$var$Rk
    ]
}, $0b2e6adb871a3b94$var$ul = {
    findFiberByHostInstance: $0b2e6adb871a3b94$var$Wc,
    bundleType: 0,
    version: "18.2.0",
    rendererPackageName: "react-dom"
};
var $0b2e6adb871a3b94$var$vl = {
    bundleType: $0b2e6adb871a3b94$var$ul.bundleType,
    version: $0b2e6adb871a3b94$var$ul.version,
    rendererPackageName: $0b2e6adb871a3b94$var$ul.rendererPackageName,
    rendererConfig: $0b2e6adb871a3b94$var$ul.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $0b2e6adb871a3b94$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $0b2e6adb871a3b94$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $0b2e6adb871a3b94$var$ul.findFiberByHostInstance || $0b2e6adb871a3b94$var$kl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.2.0-next-9e3b772b8-20220608"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $0b2e6adb871a3b94$var$wl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$0b2e6adb871a3b94$var$wl.isDisabled && $0b2e6adb871a3b94$var$wl.supportsFiber) try {
        $0b2e6adb871a3b94$var$kc = $0b2e6adb871a3b94$var$wl.inject($0b2e6adb871a3b94$var$vl), $0b2e6adb871a3b94$var$lc = $0b2e6adb871a3b94$var$wl;
    } catch (a) {}
}
$0b2e6adb871a3b94$export$ae55be85d98224ed = $0b2e6adb871a3b94$var$tl;
$0b2e6adb871a3b94$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$0b2e6adb871a3b94$var$ol(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$dl(a, b, null, c);
};
$0b2e6adb871a3b94$export$882461b6382ed46c = function(a, b) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(299));
    var c = !1, d = "", e = $0b2e6adb871a3b94$var$ll;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $0b2e6adb871a3b94$var$cl(a, 1, !1, null, null, c, !1, d, e);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $0b2e6adb871a3b94$var$ml(b);
};
$0b2e6adb871a3b94$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($0b2e6adb871a3b94$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($0b2e6adb871a3b94$var$p(268, a));
    }
    a = $0b2e6adb871a3b94$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$0b2e6adb871a3b94$export$cd75ccfd720a3cd4 = function(a) {
    return $0b2e6adb871a3b94$var$Sk(a);
};
$0b2e6adb871a3b94$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !0, c);
};
$0b2e6adb871a3b94$export$757ceba2d55c277e = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$ol(a)) throw Error($0b2e6adb871a3b94$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $0b2e6adb871a3b94$var$ll;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $0b2e6adb871a3b94$var$fl(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$0b2e6adb871a3b94$var$uf] = b.current;
    $0b2e6adb871a3b94$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $0b2e6adb871a3b94$var$nl(b);
};
$0b2e6adb871a3b94$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$0b2e6adb871a3b94$var$pl(b)) throw Error($0b2e6adb871a3b94$var$p(200));
    return $0b2e6adb871a3b94$var$sl(null, a, b, !1, c);
};
$0b2e6adb871a3b94$export$502457920280e6be = function(a) {
    if (!$0b2e6adb871a3b94$var$pl(a)) throw Error($0b2e6adb871a3b94$var$p(40));
    return a._reactRootContainer ? ($0b2e6adb871a3b94$var$Sk(function() {
        $0b2e6adb871a3b94$var$sl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$0b2e6adb871a3b94$var$uf] = null;
        });
    }), !0) : !1;
};
$0b2e6adb871a3b94$export$c78a37762a8d58e1 = $0b2e6adb871a3b94$var$Rk;
$0b2e6adb871a3b94$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$0b2e6adb871a3b94$var$pl(c)) throw Error($0b2e6adb871a3b94$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($0b2e6adb871a3b94$var$p(38));
    return $0b2e6adb871a3b94$var$sl(a, b, c, !1, d);
};
$0b2e6adb871a3b94$export$83d89fbfd8236492 = "18.2.0-next-9e3b772b8-20220608";

});
parcelRegister("fO90s", function(module, exports) {
"use strict";

module.exports = (parcelRequire("gcnCG"));

});
parcelRegister("gcnCG", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $bcb017604639e9d7$export$c4744153514ff05d, (v) => $bcb017604639e9d7$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $bcb017604639e9d7$export$3e506c1ccc9cc1a7, (v) => $bcb017604639e9d7$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $bcb017604639e9d7$export$e26fe2ed2fa76875, (v) => $bcb017604639e9d7$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $bcb017604639e9d7$export$502329bbf4b505b1, (v) => $bcb017604639e9d7$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $bcb017604639e9d7$export$6e3807111c4874c4, (v) => $bcb017604639e9d7$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $bcb017604639e9d7$export$c27134553091fb3a, (v) => $bcb017604639e9d7$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $bcb017604639e9d7$export$33ee1acdc04fd2a2, (v) => $bcb017604639e9d7$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $bcb017604639e9d7$export$b00a404bbd5edef2, (v) => $bcb017604639e9d7$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_continueExecution", () => $bcb017604639e9d7$export$8352ce38b91d0c62, (v) => $bcb017604639e9d7$export$8352ce38b91d0c62 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $bcb017604639e9d7$export$d66a1c1c77bd778b, (v) => $bcb017604639e9d7$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $bcb017604639e9d7$export$d3dfb8e4810cb555, (v) => $bcb017604639e9d7$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_getFirstCallbackNode", () => $bcb017604639e9d7$export$839f9183b0465a69, (v) => $bcb017604639e9d7$export$839f9183b0465a69 = v);
$parcel$export(module.exports, "unstable_next", () => $bcb017604639e9d7$export$72fdf0e06517287b, (v) => $bcb017604639e9d7$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_pauseExecution", () => $bcb017604639e9d7$export$4b844e58a3e414b4, (v) => $bcb017604639e9d7$export$4b844e58a3e414b4 = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $bcb017604639e9d7$export$816d2913ae6b83b1, (v) => $bcb017604639e9d7$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $bcb017604639e9d7$export$61bcfe829111a1d0, (v) => $bcb017604639e9d7$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $bcb017604639e9d7$export$7ee8c9beb337bc3f, (v) => $bcb017604639e9d7$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $bcb017604639e9d7$export$b5836b71941fa3ed, (v) => $bcb017604639e9d7$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $bcb017604639e9d7$export$cf845f2c119da08a, (v) => $bcb017604639e9d7$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $bcb017604639e9d7$export$c4744153514ff05d;
var $bcb017604639e9d7$export$3e506c1ccc9cc1a7;
var $bcb017604639e9d7$export$e26fe2ed2fa76875;
var $bcb017604639e9d7$export$502329bbf4b505b1;
var $bcb017604639e9d7$export$6e3807111c4874c4;
var $bcb017604639e9d7$export$c27134553091fb3a;
var $bcb017604639e9d7$export$33ee1acdc04fd2a2;
var $bcb017604639e9d7$export$b00a404bbd5edef2;
var $bcb017604639e9d7$export$8352ce38b91d0c62;
var $bcb017604639e9d7$export$d66a1c1c77bd778b;
var $bcb017604639e9d7$export$d3dfb8e4810cb555;
var $bcb017604639e9d7$export$839f9183b0465a69;
var $bcb017604639e9d7$export$72fdf0e06517287b;
var $bcb017604639e9d7$export$4b844e58a3e414b4;
var $bcb017604639e9d7$export$816d2913ae6b83b1;
var $bcb017604639e9d7$export$61bcfe829111a1d0;
var $bcb017604639e9d7$export$7ee8c9beb337bc3f;
var $bcb017604639e9d7$export$b5836b71941fa3ed;
var $bcb017604639e9d7$export$cf845f2c119da08a;
"use strict";
function $bcb017604639e9d7$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $bcb017604639e9d7$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $bcb017604639e9d7$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $bcb017604639e9d7$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $bcb017604639e9d7$var$g(C, c)) n < e && 0 > $bcb017604639e9d7$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $bcb017604639e9d7$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $bcb017604639e9d7$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $bcb017604639e9d7$var$l = performance;
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$l.now();
    };
} else {
    var $bcb017604639e9d7$var$p = Date, $bcb017604639e9d7$var$q = $bcb017604639e9d7$var$p.now();
    $bcb017604639e9d7$export$c4744153514ff05d = function() {
        return $bcb017604639e9d7$var$p.now() - $bcb017604639e9d7$var$q;
    };
}
var $bcb017604639e9d7$var$r = [], $bcb017604639e9d7$var$t = [], $bcb017604639e9d7$var$u = 1, $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = 3, $bcb017604639e9d7$var$z = !1, $bcb017604639e9d7$var$A = !1, $bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$D = "function" === typeof setTimeout ? setTimeout : null, $bcb017604639e9d7$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $bcb017604639e9d7$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $bcb017604639e9d7$var$G(a) {
    for(var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t); null !== b;){
        if (null === b.callback) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t);
        else if (b.startTime <= a) $bcb017604639e9d7$var$k($bcb017604639e9d7$var$t), b.sortIndex = b.expirationTime, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, b);
        else break;
        b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
    }
}
function $bcb017604639e9d7$var$H(a) {
    $bcb017604639e9d7$var$B = !1;
    $bcb017604639e9d7$var$G(a);
    if (!$bcb017604639e9d7$var$A) {
        if (null !== $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r)) $bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J);
        else {
            var b = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== b && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, b.startTime - a);
        }
    }
}
function $bcb017604639e9d7$var$J(a, b) {
    $bcb017604639e9d7$var$A = !1;
    $bcb017604639e9d7$var$B && ($bcb017604639e9d7$var$B = !1, $bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1);
    $bcb017604639e9d7$var$z = !0;
    var c = $bcb017604639e9d7$var$y;
    try {
        $bcb017604639e9d7$var$G(b);
        for($bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r); null !== $bcb017604639e9d7$var$v && (!($bcb017604639e9d7$var$v.expirationTime > b) || a && !$bcb017604639e9d7$var$M());){
            var d = $bcb017604639e9d7$var$v.callback;
            if ("function" === typeof d) {
                $bcb017604639e9d7$var$v.callback = null;
                $bcb017604639e9d7$var$y = $bcb017604639e9d7$var$v.priorityLevel;
                var e = d($bcb017604639e9d7$var$v.expirationTime <= b);
                b = $bcb017604639e9d7$export$c4744153514ff05d();
                "function" === typeof e ? $bcb017604639e9d7$var$v.callback = e : $bcb017604639e9d7$var$v === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
                $bcb017604639e9d7$var$G(b);
            } else $bcb017604639e9d7$var$k($bcb017604639e9d7$var$r);
            $bcb017604639e9d7$var$v = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
        }
        if (null !== $bcb017604639e9d7$var$v) var w = !0;
        else {
            var m = $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t);
            null !== m && $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $bcb017604639e9d7$var$v = null, $bcb017604639e9d7$var$y = c, $bcb017604639e9d7$var$z = !1;
    }
}
var $bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null, $bcb017604639e9d7$var$L = -1, $bcb017604639e9d7$var$P = 5, $bcb017604639e9d7$var$Q = -1;
function $bcb017604639e9d7$var$M() {
    return $bcb017604639e9d7$export$c4744153514ff05d() - $bcb017604639e9d7$var$Q < $bcb017604639e9d7$var$P ? !1 : !0;
}
function $bcb017604639e9d7$var$R() {
    if (null !== $bcb017604639e9d7$var$O) {
        var a = $bcb017604639e9d7$export$c4744153514ff05d();
        $bcb017604639e9d7$var$Q = a;
        var b = !0;
        try {
            b = $bcb017604639e9d7$var$O(!0, a);
        } finally{
            b ? $bcb017604639e9d7$var$S() : ($bcb017604639e9d7$var$N = !1, $bcb017604639e9d7$var$O = null);
        }
    } else $bcb017604639e9d7$var$N = !1;
}
var $bcb017604639e9d7$var$S;
if ("function" === typeof $bcb017604639e9d7$var$F) $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$F($bcb017604639e9d7$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $bcb017604639e9d7$var$T = new MessageChannel, $bcb017604639e9d7$var$U = $bcb017604639e9d7$var$T.port2;
    $bcb017604639e9d7$var$T.port1.onmessage = $bcb017604639e9d7$var$R;
    $bcb017604639e9d7$var$S = function() {
        $bcb017604639e9d7$var$U.postMessage(null);
    };
} else $bcb017604639e9d7$var$S = function() {
    $bcb017604639e9d7$var$D($bcb017604639e9d7$var$R, 0);
};
function $bcb017604639e9d7$var$I(a) {
    $bcb017604639e9d7$var$O = a;
    $bcb017604639e9d7$var$N || ($bcb017604639e9d7$var$N = !0, $bcb017604639e9d7$var$S());
}
function $bcb017604639e9d7$var$K(a, b) {
    $bcb017604639e9d7$var$L = $bcb017604639e9d7$var$D(function() {
        a($bcb017604639e9d7$export$c4744153514ff05d());
    }, b);
}
$bcb017604639e9d7$export$3e506c1ccc9cc1a7 = 5;
$bcb017604639e9d7$export$e26fe2ed2fa76875 = 1;
$bcb017604639e9d7$export$502329bbf4b505b1 = 4;
$bcb017604639e9d7$export$6e3807111c4874c4 = 3;
$bcb017604639e9d7$export$c27134553091fb3a = null;
$bcb017604639e9d7$export$33ee1acdc04fd2a2 = 2;
$bcb017604639e9d7$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$bcb017604639e9d7$export$8352ce38b91d0c62 = function() {
    $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J));
};
$bcb017604639e9d7$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $bcb017604639e9d7$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$bcb017604639e9d7$export$d3dfb8e4810cb555 = function() {
    return $bcb017604639e9d7$var$y;
};
$bcb017604639e9d7$export$839f9183b0465a69 = function() {
    return $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r);
};
$bcb017604639e9d7$export$72fdf0e06517287b = function(a) {
    switch($bcb017604639e9d7$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $bcb017604639e9d7$var$y;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = b;
    try {
        return a();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$4b844e58a3e414b4 = function() {};
$bcb017604639e9d7$export$816d2913ae6b83b1 = function() {};
$bcb017604639e9d7$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $bcb017604639e9d7$var$y;
    $bcb017604639e9d7$var$y = a;
    try {
        return b();
    } finally{
        $bcb017604639e9d7$var$y = c;
    }
};
$bcb017604639e9d7$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $bcb017604639e9d7$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $bcb017604639e9d7$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$t, a), null === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$r) && a === $bcb017604639e9d7$var$h($bcb017604639e9d7$var$t) && ($bcb017604639e9d7$var$B ? ($bcb017604639e9d7$var$E($bcb017604639e9d7$var$L), $bcb017604639e9d7$var$L = -1) : $bcb017604639e9d7$var$B = !0, $bcb017604639e9d7$var$K($bcb017604639e9d7$var$H, c - d))) : (a.sortIndex = e, $bcb017604639e9d7$var$f($bcb017604639e9d7$var$r, a), $bcb017604639e9d7$var$A || $bcb017604639e9d7$var$z || ($bcb017604639e9d7$var$A = !0, $bcb017604639e9d7$var$I($bcb017604639e9d7$var$J)));
    return a;
};
$bcb017604639e9d7$export$b5836b71941fa3ed = $bcb017604639e9d7$var$M;
$bcb017604639e9d7$export$cf845f2c119da08a = function(a) {
    var b = $bcb017604639e9d7$var$y;
    return function() {
        var c = $bcb017604639e9d7$var$y;
        $bcb017604639e9d7$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $bcb017604639e9d7$var$y = c;
        }
    };
};

});




parcelRegister("8dUxG", function(module, exports) {
/*!
 * surveyjs - Survey JavaScript library v1.9.137
 * Copyright (c) 2015-2024 Devsoft Baltic OÜ  - http://surveyjs.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = factory();
})(module.exports, function() {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/entries/core.ts");
    /******/ }({
        /***/ "./node_modules/signature_pad/dist/signature_pad.js": /*!**********************************************************!*\
  !*** ./node_modules/signature_pad/dist/signature_pad.js ***!
  \**********************************************************/ /*! exports provided: default */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() {
                return SignaturePad;
            });
            /*!
 * Signature Pad v4.2.0 | https://github.com/szimek/signature_pad
 * (c) 2024 Szymon Nowak | Released under the MIT license
 */ class Point {
                constructor(x, y, pressure, time){
                    if (isNaN(x) || isNaN(y)) throw new Error(`Point is invalid: (${x}, ${y})`);
                    this.x = +x;
                    this.y = +y;
                    this.pressure = pressure || 0;
                    this.time = time || Date.now();
                }
                distanceTo(start) {
                    return Math.sqrt(Math.pow(this.x - start.x, 2) + Math.pow(this.y - start.y, 2));
                }
                equals(other) {
                    return this.x === other.x && this.y === other.y && this.pressure === other.pressure && this.time === other.time;
                }
                velocityFrom(start) {
                    return this.time !== start.time ? this.distanceTo(start) / (this.time - start.time) : 0;
                }
            }
            class Bezier {
                static fromPoints(points, widths) {
                    const c2 = this.calculateControlPoints(points[0], points[1], points[2]).c2;
                    const c3 = this.calculateControlPoints(points[1], points[2], points[3]).c1;
                    return new Bezier(points[1], c2, c3, points[2], widths.start, widths.end);
                }
                static calculateControlPoints(s1, s2, s3) {
                    const dx1 = s1.x - s2.x;
                    const dy1 = s1.y - s2.y;
                    const dx2 = s2.x - s3.x;
                    const dy2 = s2.y - s3.y;
                    const m1 = {
                        x: (s1.x + s2.x) / 2.0,
                        y: (s1.y + s2.y) / 2.0
                    };
                    const m2 = {
                        x: (s2.x + s3.x) / 2.0,
                        y: (s2.y + s3.y) / 2.0
                    };
                    const l1 = Math.sqrt(dx1 * dx1 + dy1 * dy1);
                    const l2 = Math.sqrt(dx2 * dx2 + dy2 * dy2);
                    const dxm = m1.x - m2.x;
                    const dym = m1.y - m2.y;
                    const k = l2 / (l1 + l2);
                    const cm = {
                        x: m2.x + dxm * k,
                        y: m2.y + dym * k
                    };
                    const tx = s2.x - cm.x;
                    const ty = s2.y - cm.y;
                    return {
                        c1: new Point(m1.x + tx, m1.y + ty),
                        c2: new Point(m2.x + tx, m2.y + ty)
                    };
                }
                constructor(startPoint, control2, control1, endPoint, startWidth, endWidth){
                    this.startPoint = startPoint;
                    this.control2 = control2;
                    this.control1 = control1;
                    this.endPoint = endPoint;
                    this.startWidth = startWidth;
                    this.endWidth = endWidth;
                }
                length() {
                    const steps = 10;
                    let length = 0;
                    let px;
                    let py;
                    for(let i = 0; i <= steps; i += 1){
                        const t = i / steps;
                        const cx = this.point(t, this.startPoint.x, this.control1.x, this.control2.x, this.endPoint.x);
                        const cy = this.point(t, this.startPoint.y, this.control1.y, this.control2.y, this.endPoint.y);
                        if (i > 0) {
                            const xdiff = cx - px;
                            const ydiff = cy - py;
                            length += Math.sqrt(xdiff * xdiff + ydiff * ydiff);
                        }
                        px = cx;
                        py = cy;
                    }
                    return length;
                }
                point(t, start, c1, c2, end) {
                    return start * (1.0 - t) * (1.0 - t) * (1.0 - t) + 3.0 * c1 * (1.0 - t) * (1.0 - t) * t + 3.0 * c2 * (1.0 - t) * t * t + end * t * t * t;
                }
            }
            class SignatureEventTarget {
                constructor(){
                    try {
                        this._et = new EventTarget();
                    } catch (error) {
                        this._et = document;
                    }
                }
                addEventListener(type, listener, options) {
                    this._et.addEventListener(type, listener, options);
                }
                dispatchEvent(event1) {
                    return this._et.dispatchEvent(event1);
                }
                removeEventListener(type, callback, options) {
                    this._et.removeEventListener(type, callback, options);
                }
            }
            function throttle(fn, wait = 250) {
                let previous = 0;
                let timeout = null;
                let result;
                let storedContext;
                let storedArgs;
                const later = ()=>{
                    previous = Date.now();
                    timeout = null;
                    result = fn.apply(storedContext, storedArgs);
                    if (!timeout) {
                        storedContext = null;
                        storedArgs = [];
                    }
                };
                return function wrapper(...args) {
                    const now = Date.now();
                    const remaining = wait - (now - previous);
                    storedContext = this;
                    storedArgs = args;
                    if (remaining <= 0 || remaining > wait) {
                        if (timeout) {
                            clearTimeout(timeout);
                            timeout = null;
                        }
                        previous = now;
                        result = fn.apply(storedContext, storedArgs);
                        if (!timeout) {
                            storedContext = null;
                            storedArgs = [];
                        }
                    } else if (!timeout) timeout = window.setTimeout(later, remaining);
                    return result;
                };
            }
            class SignaturePad extends SignatureEventTarget {
                constructor(canvas, options = {}){
                    super();
                    this.canvas = canvas;
                    this._drawingStroke = false;
                    this._isEmpty = true;
                    this._lastPoints = [];
                    this._data = [];
                    this._lastVelocity = 0;
                    this._lastWidth = 0;
                    this._handleMouseDown = (event1)=>{
                        if (event1.buttons === 1) this._strokeBegin(event1);
                    };
                    this._handleMouseMove = (event1)=>{
                        this._strokeMoveUpdate(event1);
                    };
                    this._handleMouseUp = (event1)=>{
                        if (event1.buttons === 1) this._strokeEnd(event1);
                    };
                    this._handleTouchStart = (event1)=>{
                        if (event1.cancelable) event1.preventDefault();
                        if (event1.targetTouches.length === 1) {
                            const touch = event1.changedTouches[0];
                            this._strokeBegin(touch);
                        }
                    };
                    this._handleTouchMove = (event1)=>{
                        if (event1.cancelable) event1.preventDefault();
                        const touch = event1.targetTouches[0];
                        this._strokeMoveUpdate(touch);
                    };
                    this._handleTouchEnd = (event1)=>{
                        const wasCanvasTouched = event1.target === this.canvas;
                        if (wasCanvasTouched) {
                            if (event1.cancelable) event1.preventDefault();
                            const touch = event1.changedTouches[0];
                            this._strokeEnd(touch);
                        }
                    };
                    this._handlePointerStart = (event1)=>{
                        event1.preventDefault();
                        this._strokeBegin(event1);
                    };
                    this._handlePointerMove = (event1)=>{
                        this._strokeMoveUpdate(event1);
                    };
                    this._handlePointerEnd = (event1)=>{
                        if (this._drawingStroke) {
                            event1.preventDefault();
                            this._strokeEnd(event1);
                        }
                    };
                    this.velocityFilterWeight = options.velocityFilterWeight || 0.7;
                    this.minWidth = options.minWidth || 0.5;
                    this.maxWidth = options.maxWidth || 2.5;
                    this.throttle = "throttle" in options ? options.throttle : 16;
                    this.minDistance = "minDistance" in options ? options.minDistance : 5;
                    this.dotSize = options.dotSize || 0;
                    this.penColor = options.penColor || "black";
                    this.backgroundColor = options.backgroundColor || "rgba(0,0,0,0)";
                    this.compositeOperation = options.compositeOperation || "source-over";
                    this.canvasContextOptions = "canvasContextOptions" in options ? options.canvasContextOptions : {};
                    this._strokeMoveUpdate = this.throttle ? throttle(SignaturePad.prototype._strokeUpdate, this.throttle) : SignaturePad.prototype._strokeUpdate;
                    this._ctx = canvas.getContext("2d", this.canvasContextOptions);
                    this.clear();
                    this.on();
                }
                clear() {
                    const { _ctx: ctx, canvas: canvas } = this;
                    ctx.fillStyle = this.backgroundColor;
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    this._data = [];
                    this._reset(this._getPointGroupOptions());
                    this._isEmpty = true;
                }
                fromDataURL(dataUrl, options = {}) {
                    return new Promise((resolve, reject)=>{
                        const image = new Image();
                        const ratio = options.ratio || window.devicePixelRatio || 1;
                        const width = options.width || this.canvas.width / ratio;
                        const height = options.height || this.canvas.height / ratio;
                        const xOffset = options.xOffset || 0;
                        const yOffset = options.yOffset || 0;
                        this._reset(this._getPointGroupOptions());
                        image.onload = ()=>{
                            this._ctx.drawImage(image, xOffset, yOffset, width, height);
                            resolve();
                        };
                        image.onerror = (error)=>{
                            reject(error);
                        };
                        image.crossOrigin = "anonymous";
                        image.src = dataUrl;
                        this._isEmpty = false;
                    });
                }
                toDataURL(type = "image/png", encoderOptions) {
                    switch(type){
                        case "image/svg+xml":
                            if (typeof encoderOptions !== "object") encoderOptions = undefined;
                            return `data:image/svg+xml;base64,${btoa(this.toSVG(encoderOptions))}`;
                        default:
                            if (typeof encoderOptions !== "number") encoderOptions = undefined;
                            return this.canvas.toDataURL(type, encoderOptions);
                    }
                }
                on() {
                    this.canvas.style.touchAction = "none";
                    this.canvas.style.msTouchAction = "none";
                    this.canvas.style.userSelect = "none";
                    const isIOS = /Macintosh/.test(navigator.userAgent) && "ontouchstart" in document;
                    if (window.PointerEvent && !isIOS) this._handlePointerEvents();
                    else {
                        this._handleMouseEvents();
                        if ("ontouchstart" in window) this._handleTouchEvents();
                    }
                }
                off() {
                    this.canvas.style.touchAction = "auto";
                    this.canvas.style.msTouchAction = "auto";
                    this.canvas.style.userSelect = "auto";
                    this.canvas.removeEventListener("pointerdown", this._handlePointerStart);
                    this.canvas.removeEventListener("pointermove", this._handlePointerMove);
                    this.canvas.ownerDocument.removeEventListener("pointerup", this._handlePointerEnd);
                    this.canvas.removeEventListener("mousedown", this._handleMouseDown);
                    this.canvas.removeEventListener("mousemove", this._handleMouseMove);
                    this.canvas.ownerDocument.removeEventListener("mouseup", this._handleMouseUp);
                    this.canvas.removeEventListener("touchstart", this._handleTouchStart);
                    this.canvas.removeEventListener("touchmove", this._handleTouchMove);
                    this.canvas.removeEventListener("touchend", this._handleTouchEnd);
                }
                isEmpty() {
                    return this._isEmpty;
                }
                fromData(pointGroups, { clear: clear = true } = {}) {
                    if (clear) this.clear();
                    this._fromData(pointGroups, this._drawCurve.bind(this), this._drawDot.bind(this));
                    this._data = this._data.concat(pointGroups);
                }
                toData() {
                    return this._data;
                }
                _getPointGroupOptions(group) {
                    return {
                        penColor: group && "penColor" in group ? group.penColor : this.penColor,
                        dotSize: group && "dotSize" in group ? group.dotSize : this.dotSize,
                        minWidth: group && "minWidth" in group ? group.minWidth : this.minWidth,
                        maxWidth: group && "maxWidth" in group ? group.maxWidth : this.maxWidth,
                        velocityFilterWeight: group && "velocityFilterWeight" in group ? group.velocityFilterWeight : this.velocityFilterWeight,
                        compositeOperation: group && "compositeOperation" in group ? group.compositeOperation : this.compositeOperation
                    };
                }
                _strokeBegin(event1) {
                    const cancelled = !this.dispatchEvent(new CustomEvent("beginStroke", {
                        detail: event1,
                        cancelable: true
                    }));
                    if (cancelled) return;
                    this._drawingStroke = true;
                    const pointGroupOptions = this._getPointGroupOptions();
                    const newPointGroup = Object.assign(Object.assign({}, pointGroupOptions), {
                        points: []
                    });
                    this._data.push(newPointGroup);
                    this._reset(pointGroupOptions);
                    this._strokeUpdate(event1);
                }
                _strokeUpdate(event1) {
                    if (!this._drawingStroke) return;
                    if (this._data.length === 0) {
                        this._strokeBegin(event1);
                        return;
                    }
                    this.dispatchEvent(new CustomEvent("beforeUpdateStroke", {
                        detail: event1
                    }));
                    const x = event1.clientX;
                    const y = event1.clientY;
                    const pressure = event1.pressure !== undefined ? event1.pressure : event1.force !== undefined ? event1.force : 0;
                    const point = this._createPoint(x, y, pressure);
                    const lastPointGroup = this._data[this._data.length - 1];
                    const lastPoints = lastPointGroup.points;
                    const lastPoint = lastPoints.length > 0 && lastPoints[lastPoints.length - 1];
                    const isLastPointTooClose = lastPoint ? point.distanceTo(lastPoint) <= this.minDistance : false;
                    const pointGroupOptions = this._getPointGroupOptions(lastPointGroup);
                    if (!lastPoint || !(lastPoint && isLastPointTooClose)) {
                        const curve = this._addPoint(point, pointGroupOptions);
                        if (!lastPoint) this._drawDot(point, pointGroupOptions);
                        else if (curve) this._drawCurve(curve, pointGroupOptions);
                        lastPoints.push({
                            time: point.time,
                            x: point.x,
                            y: point.y,
                            pressure: point.pressure
                        });
                    }
                    this.dispatchEvent(new CustomEvent("afterUpdateStroke", {
                        detail: event1
                    }));
                }
                _strokeEnd(event1) {
                    if (!this._drawingStroke) return;
                    this._strokeUpdate(event1);
                    this._drawingStroke = false;
                    this.dispatchEvent(new CustomEvent("endStroke", {
                        detail: event1
                    }));
                }
                _handlePointerEvents() {
                    this._drawingStroke = false;
                    this.canvas.addEventListener("pointerdown", this._handlePointerStart);
                    this.canvas.addEventListener("pointermove", this._handlePointerMove);
                    this.canvas.ownerDocument.addEventListener("pointerup", this._handlePointerEnd);
                }
                _handleMouseEvents() {
                    this._drawingStroke = false;
                    this.canvas.addEventListener("mousedown", this._handleMouseDown);
                    this.canvas.addEventListener("mousemove", this._handleMouseMove);
                    this.canvas.ownerDocument.addEventListener("mouseup", this._handleMouseUp);
                }
                _handleTouchEvents() {
                    this.canvas.addEventListener("touchstart", this._handleTouchStart);
                    this.canvas.addEventListener("touchmove", this._handleTouchMove);
                    this.canvas.addEventListener("touchend", this._handleTouchEnd);
                }
                _reset(options) {
                    this._lastPoints = [];
                    this._lastVelocity = 0;
                    this._lastWidth = (options.minWidth + options.maxWidth) / 2;
                    this._ctx.fillStyle = options.penColor;
                    this._ctx.globalCompositeOperation = options.compositeOperation;
                }
                _createPoint(x, y, pressure) {
                    const rect = this.canvas.getBoundingClientRect();
                    return new Point(x - rect.left, y - rect.top, pressure, new Date().getTime());
                }
                _addPoint(point, options) {
                    const { _lastPoints: _lastPoints } = this;
                    _lastPoints.push(point);
                    if (_lastPoints.length > 2) {
                        if (_lastPoints.length === 3) _lastPoints.unshift(_lastPoints[0]);
                        const widths = this._calculateCurveWidths(_lastPoints[1], _lastPoints[2], options);
                        const curve = Bezier.fromPoints(_lastPoints, widths);
                        _lastPoints.shift();
                        return curve;
                    }
                    return null;
                }
                _calculateCurveWidths(startPoint, endPoint, options) {
                    const velocity = options.velocityFilterWeight * endPoint.velocityFrom(startPoint) + (1 - options.velocityFilterWeight) * this._lastVelocity;
                    const newWidth = this._strokeWidth(velocity, options);
                    const widths = {
                        end: newWidth,
                        start: this._lastWidth
                    };
                    this._lastVelocity = velocity;
                    this._lastWidth = newWidth;
                    return widths;
                }
                _strokeWidth(velocity, options) {
                    return Math.max(options.maxWidth / (velocity + 1), options.minWidth);
                }
                _drawCurveSegment(x, y, width) {
                    const ctx = this._ctx;
                    ctx.moveTo(x, y);
                    ctx.arc(x, y, width, 0, 2 * Math.PI, false);
                    this._isEmpty = false;
                }
                _drawCurve(curve, options) {
                    const ctx = this._ctx;
                    const widthDelta = curve.endWidth - curve.startWidth;
                    const drawSteps = Math.ceil(curve.length()) * 2;
                    ctx.beginPath();
                    ctx.fillStyle = options.penColor;
                    for(let i = 0; i < drawSteps; i += 1){
                        const t = i / drawSteps;
                        const tt = t * t;
                        const ttt = tt * t;
                        const u = 1 - t;
                        const uu = u * u;
                        const uuu = uu * u;
                        let x = uuu * curve.startPoint.x;
                        x += 3 * uu * t * curve.control1.x;
                        x += 3 * u * tt * curve.control2.x;
                        x += ttt * curve.endPoint.x;
                        let y = uuu * curve.startPoint.y;
                        y += 3 * uu * t * curve.control1.y;
                        y += 3 * u * tt * curve.control2.y;
                        y += ttt * curve.endPoint.y;
                        const width = Math.min(curve.startWidth + ttt * widthDelta, options.maxWidth);
                        this._drawCurveSegment(x, y, width);
                    }
                    ctx.closePath();
                    ctx.fill();
                }
                _drawDot(point, options) {
                    const ctx = this._ctx;
                    const width = options.dotSize > 0 ? options.dotSize : (options.minWidth + options.maxWidth) / 2;
                    ctx.beginPath();
                    this._drawCurveSegment(point.x, point.y, width);
                    ctx.closePath();
                    ctx.fillStyle = options.penColor;
                    ctx.fill();
                }
                _fromData(pointGroups, drawCurve, drawDot) {
                    for (const group of pointGroups){
                        const { points: points } = group;
                        const pointGroupOptions = this._getPointGroupOptions(group);
                        if (points.length > 1) for(let j = 0; j < points.length; j += 1){
                            const basicPoint = points[j];
                            const point = new Point(basicPoint.x, basicPoint.y, basicPoint.pressure, basicPoint.time);
                            if (j === 0) this._reset(pointGroupOptions);
                            const curve = this._addPoint(point, pointGroupOptions);
                            if (curve) drawCurve(curve, pointGroupOptions);
                        }
                        else {
                            this._reset(pointGroupOptions);
                            drawDot(points[0], pointGroupOptions);
                        }
                    }
                }
                toSVG({ includeBackgroundColor: includeBackgroundColor = false } = {}) {
                    const pointGroups = this._data;
                    const ratio = Math.max(window.devicePixelRatio || 1, 1);
                    const minX = 0;
                    const minY = 0;
                    const maxX = this.canvas.width / ratio;
                    const maxY = this.canvas.height / ratio;
                    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
                    svg.setAttribute("xmlns:xlink", "http://www.w3.org/1999/xlink");
                    svg.setAttribute("viewBox", `${minX} ${minY} ${maxX} ${maxY}`);
                    svg.setAttribute("width", maxX.toString());
                    svg.setAttribute("height", maxY.toString());
                    if (includeBackgroundColor && this.backgroundColor) {
                        const rect = document.createElement("rect");
                        rect.setAttribute("width", "100%");
                        rect.setAttribute("height", "100%");
                        rect.setAttribute("fill", this.backgroundColor);
                        svg.appendChild(rect);
                    }
                    this._fromData(pointGroups, (curve, { penColor: penColor })=>{
                        const path = document.createElement("path");
                        if (!isNaN(curve.control1.x) && !isNaN(curve.control1.y) && !isNaN(curve.control2.x) && !isNaN(curve.control2.y)) {
                            const attr = `M ${curve.startPoint.x.toFixed(3)},${curve.startPoint.y.toFixed(3)} ` + `C ${curve.control1.x.toFixed(3)},${curve.control1.y.toFixed(3)} ` + `${curve.control2.x.toFixed(3)},${curve.control2.y.toFixed(3)} ` + `${curve.endPoint.x.toFixed(3)},${curve.endPoint.y.toFixed(3)}`;
                            path.setAttribute("d", attr);
                            path.setAttribute("stroke-width", (curve.endWidth * 2.25).toFixed(3));
                            path.setAttribute("stroke", penColor);
                            path.setAttribute("fill", "none");
                            path.setAttribute("stroke-linecap", "round");
                            svg.appendChild(path);
                        }
                    }, (point, { penColor: penColor, dotSize: dotSize, minWidth: minWidth, maxWidth: maxWidth })=>{
                        const circle = document.createElement("circle");
                        const size = dotSize > 0 ? dotSize : (minWidth + maxWidth) / 2;
                        circle.setAttribute("r", size.toString());
                        circle.setAttribute("cx", point.x.toString());
                        circle.setAttribute("cy", point.y.toString());
                        circle.setAttribute("fill", penColor);
                        svg.appendChild(circle);
                    });
                    return svg.outerHTML;
                }
            }
        //# sourceMappingURL=signature_pad.js.map
        /***/ },
        /***/ "./src/actions/action.ts": /*!*******************************!*\
  !*** ./src/actions/action.ts ***!
  \*******************************/ /*! exports provided: createDropdownActionModel, createDropdownActionModelAdvanced, getActionDropdownButtonTarget, BaseAction, Action, ActionDropdownViewModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDropdownActionModel", function() {
                return createDropdownActionModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDropdownActionModelAdvanced", function() {
                return createDropdownActionModelAdvanced;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActionDropdownButtonTarget", function() {
                return getActionDropdownButtonTarget;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAction", function() {
                return BaseAction;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Action", function() {
                return Action;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionDropdownViewModel", function() {
                return ActionDropdownViewModel;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../base */ "./src/base.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../list */ "./src/list.ts");
            /* harmony import */ var _popup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../popup */ "./src/popup.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./container */ "./src/actions/container.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            function createDropdownActionModel(actionOptions, dropdownOptions, locOwner) {
                return createDropdownActionModelAdvanced(actionOptions, dropdownOptions, dropdownOptions, locOwner);
            }
            function createDropdownActionModelAdvanced(actionOptions, listOptions, popupOptions, locOwner) {
                var listModel = new _list__WEBPACK_IMPORTED_MODULE_3__["ListModel"](listOptions.items, function(item) {
                    if (newAction.hasTitle) newAction.title = item.title;
                    listOptions.onSelectionChanged(item);
                    innerPopupModel.toggleVisibility();
                }, listOptions.allowSelection, listOptions.selectedItem, listOptions.onFilterStringChangedCallback);
                listModel.locOwner = locOwner;
                var innerPopupModel = new _popup__WEBPACK_IMPORTED_MODULE_4__["PopupModel"]("sv-list", {
                    model: listModel
                }, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.verticalPosition, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.horizontalPosition, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.showPointer, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.isModal, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.onCancel, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.onApply, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.onHide, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.onShow, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.cssClass, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.title, function() {
                    listModel.dispose();
                });
                innerPopupModel.displayMode = popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.displayMode;
                var newActionOptions = Object.assign({}, actionOptions, {
                    component: "sv-action-bar-item-dropdown",
                    popupModel: innerPopupModel,
                    action: function(action, isUserAction) {
                        !!actionOptions.action && actionOptions.action();
                        innerPopupModel.isFocusedContent = !isUserAction || listModel.showFilter;
                        innerPopupModel.toggleVisibility();
                        listModel.scrollToSelectedItem();
                    }
                });
                var newAction = new Action(newActionOptions);
                newAction.data = listModel;
                return newAction;
            }
            function getActionDropdownButtonTarget(container) {
                return container === null || container === void 0 ? void 0 : container.previousElementSibling;
            }
            var BaseAction = /** @class */ function(_super) {
                __extends(BaseAction, _super);
                function BaseAction() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.iconSize = 24;
                    return _this;
                }
                Object.defineProperty(BaseAction.prototype, "visible", {
                    get: function() {
                        return this.getVisible();
                    },
                    set: function(val1) {
                        this.setVisible(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "enabled", {
                    get: function() {
                        return this.getEnabled();
                    },
                    set: function(val1) {
                        this.setEnabled(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "component", {
                    get: function() {
                        return this.getComponent();
                    },
                    set: function(val1) {
                        this.setComponent(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "locTitle", {
                    get: function() {
                        return this.getLocTitle();
                    },
                    set: function(val1) {
                        this.setLocTitle(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "title", {
                    get: function() {
                        return this.getTitle();
                    },
                    set: function(val1) {
                        this.setTitle(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "cssClasses", {
                    get: function() {
                        return this.cssClassesValue || _container__WEBPACK_IMPORTED_MODULE_6__["defaultActionBarCss"];
                    },
                    set: function(val1) {
                        this.cssClassesValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "isVisible", {
                    get: function() {
                        return this.visible && this.mode !== "popup" && this.mode !== "removed";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "disabled", {
                    get: function() {
                        return this.enabled !== undefined && !this.enabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "canShrink", {
                    get: function() {
                        return !!this.iconName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "hasTitle", {
                    get: function() {
                        return (this.mode != "small" && (this.showTitle || this.showTitle === undefined) || !this.iconName) && !!this.title;
                    },
                    enumerable: false,
                    configurable: true
                });
                BaseAction.prototype.getActionBarItemTitleCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.itemTitle).append(this.cssClasses.itemTitleWithIcon, !!this.iconName).toString();
                };
                BaseAction.prototype.getActionBarItemCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.item).append(this.cssClasses.itemWithTitle, this.hasTitle).append(this.cssClasses.itemAsIcon, !this.hasTitle).append(this.cssClasses.itemActive, !!this.active).append(this.cssClasses.itemPressed, !!this.pressed).append(this.innerCss).toString();
                };
                BaseAction.prototype.getActionRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append("sv-action").append(this.css).append("sv-action--space", this.needSpace).append("sv-action--hidden", !this.isVisible).toString();
                };
                BaseAction.prototype.getTooltip = function() {
                    return this.tooltip || this.title;
                };
                BaseAction.prototype.getIsTrusted = function(args) {
                    if (!!args.originalEvent) return args.originalEvent.isTrusted;
                    return args.isTrusted;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "tooltip", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "showTitle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "innerCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "active", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "pressed", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "data", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "popupModel", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "needSeparator", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "template", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: "large"
                    })
                ], BaseAction.prototype, "mode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "visibleIndex", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "disableTabStop", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "disableShrink", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "disableHide", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: false
                    })
                ], BaseAction.prototype, "needSpace", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "ariaChecked", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "ariaExpanded", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: "button"
                    })
                ], BaseAction.prototype, "ariaRole", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "iconName", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "iconSize", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "css", void 0);
                return BaseAction;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            var Action = /** @class */ function(_super) {
                __extends(Action, _super);
                function Action(innerItem) {
                    var _this = _super.call(this) || this;
                    _this.innerItem = innerItem;
                    _this.locTitleChanged = function() {
                        var val1 = _this.locTitle.renderedHtml;
                        _this.setPropertyValue("_title", !!val1 ? val1 : undefined);
                    };
                    _this.locTitle = !!innerItem ? innerItem["locTitle"] : null;
                    //Object.assign(this, item) to support IE11
                    if (!!innerItem) {
                        for(var key in innerItem)if (key !== "locTitle") _this[key] = innerItem[key];
                    }
                    if (!!_this.locTitleName) _this.locTitleChanged();
                    _this.registerFunctionOnPropertyValueChanged("_title", function() {
                        _this.raiseUpdate(true);
                    });
                    _this.locStrChangedInPopupModel();
                    return _this;
                }
                Action.prototype.raiseUpdate = function(isResetInitialized) {
                    if (isResetInitialized === void 0) isResetInitialized = false;
                    this.updateCallback && this.updateCallback(isResetInitialized);
                };
                Action.prototype.createLocTitle = function() {
                    return this.createLocalizableString("title", this, true);
                };
                Action.prototype.getLocTitle = function() {
                    return this.locTitleValue;
                };
                Action.prototype.setLocTitle = function(val1) {
                    if (!val1 && !this.locTitleValue) val1 = this.createLocTitle();
                    if (!!this.locTitleValue) this.locTitleValue.onStringChanged.remove(this.locTitleChanged);
                    this.locTitleValue = val1;
                    this.locTitleValue.onStringChanged.add(this.locTitleChanged);
                    this.locTitleChanged();
                };
                Action.prototype.getTitle = function() {
                    return this._title;
                };
                Action.prototype.setTitle = function(val1) {
                    this._title = val1;
                };
                Object.defineProperty(Action.prototype, "locTitleName", {
                    get: function() {
                        return this.locTitle.localizationName;
                    },
                    set: function(val1) {
                        this.locTitle.localizationName = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Action.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.locTooltipChanged();
                    this.locStrChangedInPopupModel();
                };
                Action.prototype.locStrChangedInPopupModel = function() {
                    if (!this.popupModel || !this.popupModel.contentComponentData || !this.popupModel.contentComponentData.model) return;
                    var model = this.popupModel.contentComponentData.model;
                    if (Array.isArray(model.actions)) {
                        var actions = model.actions;
                        actions.forEach(function(item) {
                            if (!!item.locStrsChanged) item.locStrsChanged();
                        });
                    }
                };
                Action.prototype.locTooltipChanged = function() {
                    if (!this.locTooltipName) return;
                    this.tooltip = _surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].getString(this.locTooltipName, this.locTitle.locale);
                };
                //ILocalizableOwner
                Action.prototype.getLocale = function() {
                    return this.owner ? this.owner.getLocale() : "";
                };
                Action.prototype.getMarkdownHtml = function(text, name) {
                    return this.owner ? this.owner.getMarkdownHtml(text, name) : undefined;
                };
                Action.prototype.getProcessedText = function(text) {
                    return this.owner ? this.owner.getProcessedText(text) : text;
                };
                Action.prototype.getRenderer = function(name) {
                    return this.owner ? this.owner.getRenderer(name) : null;
                };
                Action.prototype.getRendererContext = function(locStr) {
                    return this.owner ? this.owner.getRendererContext(locStr) : locStr;
                };
                Action.prototype.setVisible = function(val1) {
                    this._visible = val1;
                };
                Action.prototype.getVisible = function() {
                    return this._visible;
                };
                Action.prototype.setEnabled = function(val1) {
                    this._enabled = val1;
                };
                Action.prototype.getEnabled = function() {
                    if (this.enabledIf) return this.enabledIf();
                    return this._enabled;
                };
                Action.prototype.setComponent = function(val1) {
                    this._component = val1;
                };
                Action.prototype.getComponent = function() {
                    return this._component;
                };
                Action.prototype.dispose = function() {
                    this.updateCallback = undefined;
                    this.action = undefined;
                    _super.prototype.dispose.call(this);
                    if (this.popupModel) this.popupModel.dispose();
                    if (!!this.locTitleValue) {
                        this.locTitleValue.onStringChanged.remove(this.locTitleChanged);
                        this.locTitleChanged = undefined;
                    }
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "id", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: true,
                        onSet: function(_, target) {
                            target.raiseUpdate();
                        }
                    })
                ], Action.prototype, "_visible", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        onSet: function(_, target) {
                            target.locTooltipChanged();
                        }
                    })
                ], Action.prototype, "locTooltipName", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "_enabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "action", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "_component", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "items", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        onSet: function(val1, target) {
                            if (target.locTitleValue.text === val1) return;
                            target.locTitleValue.text = val1;
                        }
                    })
                ], Action.prototype, "_title", void 0);
                return Action;
            }(BaseAction);
            var ActionDropdownViewModel = /** @class */ function() {
                function ActionDropdownViewModel(item) {
                    this.item = item;
                    this.funcKey = "sv-dropdown-action";
                    this.setupPopupCallbacks();
                }
                ActionDropdownViewModel.prototype.setupPopupCallbacks = function() {
                    var _this = this;
                    var popupModel = this.popupModel = this.item.popupModel;
                    if (!popupModel) return;
                    popupModel.registerPropertyChangedHandlers([
                        "isVisible"
                    ], function() {
                        if (!popupModel.isVisible) _this.item.pressed = false;
                        else _this.item.pressed = true;
                    }, this.funcKey);
                };
                ActionDropdownViewModel.prototype.removePopupCallbacks = function() {
                    if (!!this.popupModel) this.popupModel.unregisterPropertyChangedHandlers([
                        "isVisible"
                    ], this.funcKey);
                };
                ActionDropdownViewModel.prototype.dispose = function() {
                    this.removePopupCallbacks();
                };
                return ActionDropdownViewModel;
            }();
        /***/ },
        /***/ "./src/actions/adaptive-container.ts": /*!*******************************************!*\
  !*** ./src/actions/adaptive-container.ts ***!
  \*******************************************/ /*! exports provided: AdaptiveActionContainer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdaptiveActionContainer", function() {
                return AdaptiveActionContainer;
            });
            /* harmony import */ var _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/responsivity-manager */ "./src/utils/responsivity-manager.ts");
            /* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./action */ "./src/actions/action.ts");
            /* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./container */ "./src/actions/container.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../surveyStrings */ "./src/surveyStrings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var AdaptiveActionContainer = /** @class */ function(_super) {
                __extends(AdaptiveActionContainer, _super);
                function AdaptiveActionContainer() {
                    var _this = _super.call(this) || this;
                    _this.minVisibleItemsCount = 0;
                    _this.isResponsivenessDisabled = false;
                    _this.dotsItem = Object(_action__WEBPACK_IMPORTED_MODULE_1__["createDropdownActionModelAdvanced"])({
                        id: "dotsItem-id" + AdaptiveActionContainer.ContainerID++,
                        css: "sv-dots",
                        innerCss: "sv-dots__item",
                        iconName: "icon-more",
                        visible: false,
                        tooltip: _surveyStrings__WEBPACK_IMPORTED_MODULE_3__["surveyLocalization"].getString("more")
                    }, {
                        items: [],
                        onSelectionChanged: function(item) {
                            _this.hiddenItemSelected(item);
                        },
                        allowSelection: false
                    });
                    return _this;
                }
                AdaptiveActionContainer.prototype.hideItemsGreaterN = function(visibleItemsCount) {
                    var actionsToHide = this.getActionsToHide();
                    visibleItemsCount = Math.max(visibleItemsCount, this.minVisibleItemsCount - (this.visibleActions.length - actionsToHide.length));
                    var hiddenItems = [];
                    actionsToHide.forEach(function(item) {
                        if (visibleItemsCount <= 0) {
                            if (item.removePriority) item.mode = "removed";
                            else {
                                item.mode = "popup";
                                hiddenItems.push(item.innerItem);
                            }
                        }
                        visibleItemsCount--;
                    });
                    this.hiddenItemsListModel.setItems(hiddenItems);
                };
                AdaptiveActionContainer.prototype.getActionsToHide = function() {
                    return this.visibleActions.filter(function(action) {
                        return !action.disableHide;
                    }).sort(function(a, b) {
                        return a.removePriority || 0 - b.removePriority || 0;
                    });
                };
                AdaptiveActionContainer.prototype.getVisibleItemsCount = function(availableSize) {
                    this.visibleActions.filter(function(action) {
                        return action.disableHide;
                    }).forEach(function(action) {
                        return availableSize -= action.minDimension;
                    });
                    var itemsSizes = this.getActionsToHide().map(function(item) {
                        return item.minDimension;
                    });
                    var currSize = 0;
                    for(var i = 0; i < itemsSizes.length; i++){
                        currSize += itemsSizes[i];
                        if (currSize > availableSize) return i;
                    }
                    return i;
                };
                AdaptiveActionContainer.prototype.updateItemMode = function(availableSize, itemsSize) {
                    var items = this.visibleActions;
                    for(var index = items.length - 1; index >= 0; index--)if (itemsSize > availableSize && !items[index].disableShrink) {
                        itemsSize -= items[index].maxDimension - items[index].minDimension;
                        items[index].mode = "small";
                    } else items[index].mode = "large";
                    if (itemsSize > availableSize) {
                        var hidableItems = this.visibleActions.filter(function(a) {
                            return a.removePriority;
                        });
                        hidableItems.sort(function(a, b) {
                            return a.removePriority - b.removePriority;
                        });
                        for(var index = 0; index < hidableItems.length; index++)if (itemsSize > availableSize) {
                            itemsSize -= items[index].disableShrink ? hidableItems[index].maxDimension : hidableItems[index].minDimension;
                            hidableItems[index].mode = "removed";
                        }
                    }
                };
                Object.defineProperty(AdaptiveActionContainer.prototype, "hiddenItemsListModel", {
                    get: function() {
                        return this.dotsItem.data;
                    },
                    enumerable: false,
                    configurable: true
                });
                AdaptiveActionContainer.prototype.hiddenItemSelected = function(item) {
                    if (!!item && typeof item.action === "function") item.action();
                };
                AdaptiveActionContainer.prototype.onSet = function() {
                    var _this = this;
                    this.actions.forEach(function(action) {
                        return action.updateCallback = function(isResetInitialized) {
                            return _this.raiseUpdate(isResetInitialized);
                        };
                    });
                    _super.prototype.onSet.call(this);
                };
                AdaptiveActionContainer.prototype.onPush = function(item) {
                    var _this = this;
                    item.updateCallback = function(isResetInitialized) {
                        return _this.raiseUpdate(isResetInitialized);
                    };
                    _super.prototype.onPush.call(this, item);
                };
                AdaptiveActionContainer.prototype.getRenderedActions = function() {
                    if (this.actions.length === 1 && !!this.actions[0].iconName) return this.actions;
                    return this.actions.concat([
                        this.dotsItem
                    ]);
                };
                AdaptiveActionContainer.prototype.raiseUpdate = function(isResetInitialized) {
                    if (!this.isResponsivenessDisabled) _super.prototype.raiseUpdate.call(this, isResetInitialized);
                };
                AdaptiveActionContainer.prototype.fit = function(dimension, dotsItemSize) {
                    if (dimension <= 0) return;
                    this.dotsItem.visible = false;
                    var minSize = 0;
                    var maxSize = 0;
                    var items = this.visibleActions;
                    items.forEach(function(item) {
                        minSize += item.minDimension;
                        maxSize += item.maxDimension;
                    });
                    if (dimension >= maxSize) this.setActionsMode("large");
                    else if (dimension < minSize) {
                        this.setActionsMode("small");
                        this.hideItemsGreaterN(this.getVisibleItemsCount(dimension - dotsItemSize));
                        this.dotsItem.visible = !!this.hiddenItemsListModel.actions.length;
                    } else this.updateItemMode(dimension, maxSize);
                };
                AdaptiveActionContainer.prototype.initResponsivityManager = function(container, delayedUpdateFunction) {
                    this.responsivityManager = new _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_0__["ResponsivityManager"](container, this, ":scope > .sv-action:not(.sv-dots) > .sv-action__content", null, delayedUpdateFunction);
                };
                AdaptiveActionContainer.prototype.resetResponsivityManager = function() {
                    if (!!this.responsivityManager) {
                        this.responsivityManager.dispose();
                        this.responsivityManager = undefined;
                    }
                };
                AdaptiveActionContainer.prototype.setActionsMode = function(mode) {
                    this.actions.forEach(function(action) {
                        if (mode == "small" && action.disableShrink) return;
                        action.mode = mode;
                    });
                };
                AdaptiveActionContainer.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.dotsItem.data.dispose();
                    this.dotsItem.dispose();
                    this.resetResponsivityManager();
                };
                AdaptiveActionContainer.ContainerID = 1;
                return AdaptiveActionContainer;
            }(_container__WEBPACK_IMPORTED_MODULE_2__["ActionContainer"]);
        /***/ },
        /***/ "./src/actions/container.ts": /*!**********************************!*\
  !*** ./src/actions/container.ts ***!
  \**********************************/ /*! exports provided: defaultActionBarCss, ActionContainer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultActionBarCss", function() {
                return defaultActionBarCss;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionContainer", function() {
                return ActionContainer;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../base */ "./src/base.ts");
            /* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./action */ "./src/actions/action.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var defaultActionBarCss = {
                root: "sv-action-bar",
                defaultSizeMode: "sv-action-bar--default-size-mode",
                smallSizeMode: "sv-action-bar--small-size-mode",
                item: "sv-action-bar-item",
                itemWithTitle: "",
                itemAsIcon: "sv-action-bar-item--icon",
                itemActive: "sv-action-bar-item--active",
                itemPressed: "sv-action-bar-item--pressed",
                itemIcon: "sv-action-bar-item__icon",
                itemTitle: "sv-action-bar-item__title",
                itemTitleWithIcon: "sv-action-bar-item__title--with-icon"
            };
            var ActionContainer = /** @class */ function(_super) {
                __extends(ActionContainer, _super);
                function ActionContainer() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.sizeMode = "default";
                    return _this;
                }
                ActionContainer.prototype.getMarkdownHtml = function(text, name) {
                    return !!this.locOwner ? this.locOwner.getMarkdownHtml(text, name) : undefined;
                };
                ActionContainer.prototype.getRenderer = function(name) {
                    return !!this.locOwner ? this.locOwner.getRenderer(name) : null;
                };
                ActionContainer.prototype.getRendererContext = function(locStr) {
                    return !!this.locOwner ? this.locOwner.getRendererContext(locStr) : locStr;
                };
                ActionContainer.prototype.getProcessedText = function(text) {
                    return this.locOwner ? this.locOwner.getProcessedText(text) : text;
                };
                ActionContainer.prototype.getLocale = function() {
                    return !!this.locOwner ? this.locOwner.getLocale() : "";
                };
                ActionContainer.prototype.getRenderedActions = function() {
                    return this.actions;
                };
                ActionContainer.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.actions.forEach(function(item) {
                        if (item.locTitle) item.locTitle.strChanged();
                        item.locStrsChanged();
                    });
                };
                ActionContainer.prototype.raiseUpdate = function(isResetInitialized) {
                    this.isEmpty = !this.actions.some(function(action) {
                        return action.visible;
                    });
                    this.updateCallback && this.updateCallback(isResetInitialized);
                };
                ActionContainer.prototype.onSet = function() {
                    var _this = this;
                    this.actions.forEach(function(item) {
                        _this.setActionCssClasses(item);
                    });
                    this.raiseUpdate(true);
                };
                ActionContainer.prototype.onPush = function(item) {
                    this.setActionCssClasses(item);
                    item.owner = this;
                    this.raiseUpdate(true);
                };
                ActionContainer.prototype.onRemove = function(item) {
                    item.owner = null;
                    this.raiseUpdate(true);
                };
                ActionContainer.prototype.setActionCssClasses = function(item) {
                    item.cssClasses = this.cssClasses;
                };
                Object.defineProperty(ActionContainer.prototype, "hasActions", {
                    get: function() {
                        return (this.actions || []).length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ActionContainer.prototype, "renderedActions", {
                    get: function() {
                        return this.getRenderedActions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ActionContainer.prototype, "visibleActions", {
                    get: function() {
                        return this.actions.filter(function(action) {
                            return action.visible !== false;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                ActionContainer.prototype.getRootCss = function() {
                    var sizeModeClass = this.sizeMode === "small" ? this.cssClasses.smallSizeMode : this.cssClasses.defaultSizeMode;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.cssClasses.root + (!!sizeModeClass ? " " + sizeModeClass : "") + (!!this.containerCss ? " " + this.containerCss : "")).append(this.cssClasses.root + "--empty", this.isEmpty).toString();
                };
                ActionContainer.prototype.getDefaultCssClasses = function() {
                    return defaultActionBarCss;
                };
                Object.defineProperty(ActionContainer.prototype, "cssClasses", {
                    get: function() {
                        if (!this.cssClassesValue) this.cssClassesValue = this.getDefaultCssClasses();
                        return this.cssClassesValue;
                    },
                    set: function(val1) {
                        var _this = this;
                        this.cssClassesValue = {};
                        this.copyCssClasses(this.cssClassesValue, this.getDefaultCssClasses());
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_4__["mergeValues"])(val1, this.cssClasses);
                        this.actions.forEach(function(action) {
                            _this.setActionCssClasses(action);
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                ActionContainer.prototype.createAction = function(item) {
                    return item instanceof _action__WEBPACK_IMPORTED_MODULE_2__["BaseAction"] ? item : new _action__WEBPACK_IMPORTED_MODULE_2__["Action"](item);
                };
                ActionContainer.prototype.addAction = function(val1, sortByVisibleIndex) {
                    if (sortByVisibleIndex === void 0) sortByVisibleIndex = true;
                    var res = this.createAction(val1);
                    this.actions.push(res);
                    this.sortItems();
                    return res;
                };
                ActionContainer.prototype.sortItems = function() {
                    this.actions = [].concat(this.actions.filter(function(item) {
                        return item.visibleIndex === undefined || item.visibleIndex >= 0;
                    })).sort(function(firstItem, secondItem) {
                        return firstItem.visibleIndex - secondItem.visibleIndex;
                    });
                };
                ActionContainer.prototype.setItems = function(items, sortByVisibleIndex) {
                    var _this = this;
                    if (sortByVisibleIndex === void 0) sortByVisibleIndex = true;
                    this.actions = items.map(function(item) {
                        return _this.createAction(item);
                    });
                    if (sortByVisibleIndex) this.sortItems();
                };
                ActionContainer.prototype.initResponsivityManager = function(container, delayedUpdateFunction) {
                    return;
                };
                ActionContainer.prototype.resetResponsivityManager = function() {};
                ActionContainer.prototype.getActionById = function(id) {
                    for(var i = 0; i < this.actions.length; i++){
                        if (this.actions[i].id === id) return this.actions[i];
                    }
                    return null;
                };
                ActionContainer.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.actions.forEach(function(action) {
                        return action.dispose();
                    });
                    this.actions.length = 0;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["propertyArray"])({
                        onSet: function(_, target) {
                            target.onSet();
                        },
                        onPush: function(item, i, target) {
                            target.onPush(item);
                        },
                        onRemove: function(item, i, target) {
                            target.onRemove(item);
                        }
                    })
                ], ActionContainer.prototype, "actions", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], ActionContainer.prototype, "containerCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ActionContainer.prototype, "isEmpty", void 0);
                return ActionContainer;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
        /***/ },
        /***/ "./src/base.ts": /*!*********************!*\
  !*** ./src/base.ts ***!
  \*********************/ /*! exports provided: Bindings, Dependencies, ComputedUpdater, Base, ArrayChanges, Event, EventBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bindings", function() {
                return Bindings;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dependencies", function() {
                return Dependencies;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComputedUpdater", function() {
                return ComputedUpdater;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Base", function() {
                return Base;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayChanges", function() {
                return ArrayChanges;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Event", function() {
                return Event;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBase", function() {
                return EventBase;
            });
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __spreadArray = function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            var Bindings = /** @class */ function() {
                function Bindings(obj) {
                    this.obj = obj;
                    this.properties = null;
                    this.values = null;
                }
                Bindings.prototype.getType = function() {
                    return "bindings";
                };
                Bindings.prototype.getNames = function() {
                    var res = [];
                    this.fillProperties();
                    for(var i = 0; i < this.properties.length; i++)if (this.properties[i].isVisible("", this.obj)) res.push(this.properties[i].name);
                    return res;
                };
                Bindings.prototype.getProperties = function() {
                    var res = [];
                    this.fillProperties();
                    for(var i = 0; i < this.properties.length; i++)res.push(this.properties[i]);
                    return res;
                };
                Bindings.prototype.setBinding = function(propertyName, valueName) {
                    if (!this.values) this.values = {};
                    var oldValue = this.getJson();
                    if (oldValue === valueName) return;
                    if (!!valueName) this.values[propertyName] = valueName;
                    else {
                        delete this.values[propertyName];
                        if (Object.keys(this.values).length == 0) this.values = null;
                    }
                    this.onChangedJSON(oldValue);
                };
                Bindings.prototype.clearBinding = function(propertyName) {
                    this.setBinding(propertyName, "");
                };
                Bindings.prototype.isEmpty = function() {
                    if (!this.values) return true;
                    for(var key in this.values)return false;
                    return true;
                };
                Bindings.prototype.getValueNameByPropertyName = function(propertyName) {
                    if (!this.values) return undefined;
                    return this.values[propertyName];
                };
                Bindings.prototype.getPropertiesByValueName = function(valueName) {
                    if (!this.values) return [];
                    var res = [];
                    for(var key in this.values)if (this.values[key] == valueName) res.push(key);
                    return res;
                };
                Bindings.prototype.getJson = function() {
                    if (this.isEmpty()) return undefined;
                    var res = {};
                    for(var key in this.values)res[key] = this.values[key];
                    return res;
                };
                Bindings.prototype.setJson = function(value) {
                    var oldValue = this.getJson();
                    this.values = null;
                    if (!!value) {
                        this.values = {};
                        for(var key in value)this.values[key] = value[key];
                    }
                    this.onChangedJSON(oldValue);
                };
                Bindings.prototype.fillProperties = function() {
                    if (this.properties !== null) return;
                    this.properties = [];
                    var objProperties = _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].getPropertiesByObj(this.obj);
                    for(var i = 0; i < objProperties.length; i++)if (objProperties[i].isBindable) this.properties.push(objProperties[i]);
                };
                Bindings.prototype.onChangedJSON = function(oldValue) {
                    if (this.obj) this.obj.onBindingChanged(oldValue, this.getJson());
                };
                return Bindings;
            }();
            var Dependencies = /** @class */ function() {
                function Dependencies(currentDependency, target, property) {
                    this.currentDependency = currentDependency;
                    this.target = target;
                    this.property = property;
                    this.dependencies = [];
                    this.id = "" + ++Dependencies.DependenciesCount;
                }
                Dependencies.prototype.addDependency = function(target, property) {
                    if (this.target === target && this.property === property) return;
                    if (this.dependencies.some(function(dependency) {
                        return dependency.obj === target && dependency.prop === property;
                    })) return;
                    this.dependencies.push({
                        obj: target,
                        prop: property,
                        id: this.id
                    });
                    target.registerPropertyChangedHandlers([
                        property
                    ], this.currentDependency, this.id);
                };
                Dependencies.prototype.dispose = function() {
                    this.dependencies.forEach(function(dependency) {
                        dependency.obj.unregisterPropertyChangedHandlers([
                            dependency.prop
                        ], dependency.id);
                    });
                // this.currentDependency = undefined;
                };
                Dependencies.DependenciesCount = 0;
                return Dependencies;
            }();
            var ComputedUpdater = /** @class */ function() {
                function ComputedUpdater(_updater) {
                    this._updater = _updater;
                    this.dependencies = undefined;
                    this.type = ComputedUpdater.ComputedUpdaterType;
                }
                Object.defineProperty(ComputedUpdater.prototype, "updater", {
                    get: function() {
                        return this._updater;
                    },
                    enumerable: false,
                    configurable: true
                });
                ComputedUpdater.prototype.setDependencies = function(dependencies) {
                    this.clearDependencies();
                    this.dependencies = dependencies;
                };
                ComputedUpdater.prototype.getDependencies = function() {
                    return this.dependencies;
                };
                ComputedUpdater.prototype.clearDependencies = function() {
                    if (this.dependencies) {
                        this.dependencies.dispose();
                        this.dependencies = undefined;
                    }
                };
                ComputedUpdater.prototype.dispose = function() {
                    this.clearDependencies();
                };
                ComputedUpdater.ComputedUpdaterType = "__dependency_computed";
                return ComputedUpdater;
            }();
            /**
 * A base class for all SurveyJS objects.
 */ var Base = /** @class */ function() {
                function Base() {
                    this.dependencies = {};
                    this.propertyHash = Base.createPropertiesHash();
                    this.eventList = [];
                    this.isLoadingFromJsonValue = false;
                    this.loadingOwner = null;
                    /**
         * An event that is raised when a property of this SurveyJS object has changed.
         *
         * Parameters:
         *
         * - `sender`: `this`\
         * A SurveyJS object whose property has changed.
         * - `options.name`: `string`\
         * The name of the changed property.
         * - `options.newValue`: `any`\
         * A new value for the property.
         * - `options.oldValue`: `any`\
         * An old value of the property. If the property is an array, `oldValue` contains the same array as `newValue` does.
         */ this.onPropertyChanged = this.addEvent();
                    /**
         * An event that is raised when an [`ItemValue`](https://surveyjs.io/form-library/documentation/itemvalue) property is changed.
         *
         * Parameters:
         *
         * - `sender`: `this`\
         * A SurveyJS object whose property contains an array of `ItemValue` objects.
         * - `options.obj`: [`ItemValue`](https://surveyjs.io/form-library/documentation/itemvalue)\
         * An `ItemValue` object.
         * - `options.propertyName`: `string`\
         * The name of the property to which an array of `ItemValue` objects is assigned (for example, `"choices"` or `"rows"`).
         * - `options.name`: `"text"` | `"value"`\
         * The name of the changed property.
         * - `options.newValue`: `any`\
         * A new value for the property.
         */ this.onItemValuePropertyChanged = this.addEvent();
                    this.isCreating = true;
                    this.bindingsValue = new Bindings(this);
                    _jsonobject__WEBPACK_IMPORTED_MODULE_2__["CustomPropertiesCollection"].createProperties(this);
                    this.onBaseCreating();
                    this.isCreating = false;
                }
                Base.finishCollectDependencies = function() {
                    var deps = Base.currentDependencis;
                    Base.currentDependencis = undefined;
                    return deps;
                };
                Base.startCollectDependencies = function(updater, target, property) {
                    if (Base.currentDependencis !== undefined) throw new Error("Attempt to collect nested dependencies. Nested dependencies are not supported.");
                    Base.currentDependencis = new Dependencies(updater, target, property);
                };
                Base.collectDependency = function(target, property) {
                    if (Base.currentDependencis === undefined) return;
                    Base.currentDependencis.addDependency(target, property);
                };
                Object.defineProperty(Base, "commentSuffix", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].commentSuffix;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].commentSuffix = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Base, "commentPrefix", {
                    get: function() {
                        return Base.commentSuffix;
                    },
                    set: function(val1) {
                        Base.commentSuffix = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns `true` if a passed `value` is an empty string, array, or object or if it equals to `undefined` or `null`.
     *
     * @param value A value to be checked.
     * @param trimString *(Optional)* When this parameter is `true`, the method ignores whitespace characters at the beginning and end of a string value. Pass `false` to disable this functionality.
     */ Base.prototype.isValueEmpty = function(value, trimString) {
                    if (trimString === void 0) trimString = true;
                    if (trimString) value = this.trimValue(value);
                    return _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isValueEmpty(value);
                };
                Base.prototype.equals = function(obj) {
                    if (!obj) return false;
                    if (this.isDisposed || obj.isDisposed) return false;
                    if (this.getType() != obj.getType()) return false;
                    return this.equalsCore(obj);
                };
                Base.prototype.equalsCore = function(obj) {
                    if (this.name !== obj.name) return false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(this.toJSON(), obj.toJSON(), false, true, false);
                };
                Base.prototype.trimValue = function(value) {
                    if (!!value && (typeof value === "string" || value instanceof String)) return value.trim();
                    return value;
                };
                Base.prototype.isPropertyEmpty = function(value) {
                    return value !== "" && this.isValueEmpty(value);
                };
                Base.createPropertiesHash = function() {
                    return {};
                };
                Base.prototype.dispose = function() {
                    var _this = this;
                    for(var i = 0; i < this.eventList.length; i++)this.eventList[i].clear();
                    this.onPropertyValueChangedCallback = undefined;
                    this.isDisposedValue = true;
                    Object.keys(this.dependencies).forEach(function(key) {
                        return _this.dependencies[key].dispose();
                    });
                };
                Object.defineProperty(Base.prototype, "isDisposed", {
                    get: function() {
                        return this.isDisposedValue === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.addEvent = function() {
                    var res = new EventBase();
                    this.eventList.push(res);
                    return res;
                };
                Base.prototype.onBaseCreating = function() {};
                /**
     * Returns the object type as it is used in the JSON schema.
     */ Base.prototype.getType = function() {
                    return "base";
                };
                /**
     * Use this method to find out if the current object is of a given `typeName` or inherited from it.
     *
     * @param typeName One of the values listed in the [getType()](https://surveyjs.io/form-library/documentation/question#getType) description.
     * @returns `true` if the current object is of a given `typeName` or inherited from it.
     * @see getType
     */ Base.prototype.isDescendantOf = function(typeName) {
                    return _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].isDescendantOf(this.getType(), typeName);
                };
                Base.prototype.getSurvey = function(isLive) {
                    if (isLive === void 0) isLive = false;
                    return null;
                };
                Object.defineProperty(Base.prototype, "isDesignMode", {
                    /**
         * Returns `true` if the survey is being designed in Survey Creator.
         */ get: function() {
                        var survey = this.getSurvey();
                        return !!survey && survey.isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Base.prototype, "isDesignModeV2", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].supportCreatorV2 && this.isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Base.prototype, "inSurvey", {
                    /**
         * Returns `true` if the object is included in a survey.
         *
         * This property may return `false`, for example, when you [create a survey model dynamically](https://surveyjs.io/form-library/documentation/design-survey-create-a-simple-survey#create-or-change-a-survey-model-dynamically).
         */ get: function() {
                        return !!this.getSurvey(true);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Base.prototype, "bindings", {
                    get: function() {
                        return this.bindingsValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.checkBindings = function(valueName, value) {};
                Base.prototype.updateBindings = function(propertyName, value) {
                    var valueName = this.bindings.getValueNameByPropertyName(propertyName);
                    if (!!valueName) this.updateBindingValue(valueName, value);
                };
                Base.prototype.updateBindingValue = function(valueName, value) {};
                Base.prototype.getTemplate = function() {
                    return this.getType();
                };
                Object.defineProperty(Base.prototype, "isLoadingFromJson", {
                    /**
         * Returns `true` if the object configuration is being loaded from JSON.
         */ get: function() {
                        return this.isLoadingFromJsonValue || this.getIsLoadingFromJson();
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.getIsLoadingFromJson = function() {
                    if (!!this.loadingOwner && this.loadingOwner.isLoadingFromJson) return true;
                    return this.isLoadingFromJsonValue;
                };
                Base.prototype.startLoadingFromJson = function(json) {
                    this.isLoadingFromJsonValue = true;
                    this.jsonObj = json;
                };
                Base.prototype.endLoadingFromJson = function() {
                    this.isLoadingFromJsonValue = false;
                };
                /**
     * Returns a JSON object that corresponds to the current SurveyJS object.
     * @see fromJSON
     */ Base.prototype.toJSON = function(options) {
                    return new _jsonobject__WEBPACK_IMPORTED_MODULE_2__["JsonObject"]().toJsonObject(this, options);
                };
                /**
     * Assigns a new configuration to the current SurveyJS object. This configuration is taken from a passed JSON object.
     *
     * The JSON object should contain only serializable properties of this SurveyJS object. Event handlers and properties that do not belong to the SurveyJS object are ignored.
     *
     * @param json A JSON object with properties that you want to apply to the current SurveyJS object.
     * @param options An object with configuration options.
     * @param {boolean} options.validatePropertyValues Pass `true` if you want to validate property values. Use the [`jsonErrors`](#jsonErrors) array to access validation errors.
     * @see toJSON
     */ Base.prototype.fromJSON = function(json, options) {
                    new _jsonobject__WEBPACK_IMPORTED_MODULE_2__["JsonObject"]().toObject(json, this, options);
                    this.onSurveyLoad();
                };
                Base.prototype.onSurveyLoad = function() {};
                /**
     * Creates a new object that has the same type and properties as the current SurveyJS object.
     */ Base.prototype.clone = function() {
                    var clonedObj = _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].createClass(this.getType());
                    clonedObj.fromJSON(this.toJSON());
                    return clonedObj;
                };
                /**
     * Returns a `JsonObjectProperty` object with metadata about a serializable property that belongs to the current SurveyJS object.
     *
     * If the property is not found, this method returns `null`.
     * @param propName A property name.
     */ Base.prototype.getPropertyByName = function(propName) {
                    var type = this.getType();
                    if (!this.classMetaData || this.classMetaData.name !== type) this.classMetaData = _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].findClass(type);
                    return !!this.classMetaData ? this.classMetaData.findProperty(propName) : null;
                };
                Base.prototype.isPropertyVisible = function(propName) {
                    var prop = this.getPropertyByName(propName);
                    return !!prop ? prop.isVisible("", this) : false;
                };
                Base.createProgressInfo = function() {
                    return {
                        questionCount: 0,
                        answeredQuestionCount: 0,
                        requiredQuestionCount: 0,
                        requiredAnsweredQuestionCount: 0
                    };
                };
                Base.prototype.getProgressInfo = function() {
                    return Base.createProgressInfo();
                };
                Base.prototype.localeChanged = function() {};
                Base.prototype.locStrsChanged = function() {
                    if (!!this.arraysInfo) for(var key in this.arraysInfo){
                        var item = this.arraysInfo[key];
                        if (item && item.isItemValues) {
                            var arr = this.getPropertyValue(key);
                            if (arr && !!Base.itemValueLocStrChanged) Base.itemValueLocStrChanged(arr);
                        }
                    }
                    if (!!this.localizableStrings) for(var key in this.localizableStrings){
                        var item = this.getLocalizableString(key);
                        if (item) item.strChanged();
                    }
                };
                /**
     * Returns the value of a property with a specified name.
     *
     * If the property is not found or does not have a value, this method returns either `undefined`, `defaultValue` specified in the property configuration, or a value passed as the `defaultValue` parameter.
     *
     * @param name A property name.
     * @param defaultValue *(Optional)* A value to return if the property is not found or does not have a value.
     */ Base.prototype.getPropertyValue = function(name, defaultValue) {
                    if (defaultValue === void 0) defaultValue = null;
                    var res = this.getPropertyValueWithoutDefault(name);
                    if (this.isPropertyEmpty(res)) {
                        var locStr = this.localizableStrings ? this.localizableStrings[name] : undefined;
                        if (locStr) return locStr.text;
                        if (defaultValue !== null && defaultValue !== undefined) return defaultValue;
                        var propDefaultValue = this.getDefaultPropertyValue(name);
                        if (propDefaultValue !== undefined) return propDefaultValue;
                    }
                    return res;
                };
                Base.prototype.getDefaultPropertyValue = function(name) {
                    var prop = this.getPropertyByName(name);
                    if (!prop || prop.isCustom && this.isCreating) return undefined;
                    var dValue = prop.defaultValue;
                    if (!this.isPropertyEmpty(dValue) && !Array.isArray(dValue)) return dValue;
                    var locStr = this.localizableStrings ? this.localizableStrings[name] : undefined;
                    if (locStr && locStr.localizationName) return this.getLocalizationString(locStr.localizationName);
                    if (prop.type == "boolean" || prop.type == "switch") return false;
                    if (prop.isCustom && !!prop.onGetValue) return prop.onGetValue(this);
                    return undefined;
                };
                Base.prototype.hasDefaultPropertyValue = function(name) {
                    return this.getDefaultPropertyValue(name) !== undefined;
                };
                Base.prototype.resetPropertyValue = function(name) {
                    var locStr = this.localizableStrings ? this.localizableStrings[name] : undefined;
                    if (locStr) {
                        this.setLocalizableStringText(name, undefined);
                        locStr.clear();
                    } else this.setPropertyValue(name, undefined);
                };
                Base.prototype.getPropertyValueWithoutDefault = function(name) {
                    return this.getPropertyValueCore(this.propertyHash, name);
                };
                Base.prototype.getPropertyValueCore = function(propertiesHash, name) {
                    if (!this.isLoadingFromJson) Base.collectDependency(this, name);
                    if (this.getPropertyValueCoreHandler) return this.getPropertyValueCoreHandler(propertiesHash, name);
                    else return propertiesHash[name];
                };
                Base.prototype.geValueFromHash = function() {
                    return this.propertyHash["value"];
                };
                Base.prototype.setPropertyValueCore = function(propertiesHash, name, val1) {
                    if (this.setPropertyValueCoreHandler) {
                        if (!this.isDisposedValue) this.setPropertyValueCoreHandler(propertiesHash, name, val1);
                        else _console_warnings__WEBPACK_IMPORTED_MODULE_6__["ConsoleWarnings"].disposedObjectChangedProperty(name, this.getType());
                    } else propertiesHash[name] = val1;
                };
                Object.defineProperty(Base.prototype, "isEditingSurveyElement", {
                    get: function() {
                        var survey = this.getSurvey();
                        return !!survey && survey.isEditingSurveyElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.iteratePropertiesHash = function(func) {
                    var _this = this;
                    var keys = [];
                    for(var key in this.propertyHash){
                        if (key === "value" && this.isEditingSurveyElement && Array.isArray(this.value)) continue;
                        keys.push(key);
                    }
                    keys.forEach(function(key) {
                        return func(_this.propertyHash, key);
                    });
                };
                /**
     * Assigns a new value to a specified property.
     * @param name A property name.
     * @param val A new value for the property.
     */ Base.prototype.setPropertyValue = function(name, val1) {
                    name;
                    if (!this.isLoadingFromJson) {
                        var prop = this.getPropertyByName(name);
                        if (!!prop) val1 = prop.settingValue(this, val1);
                    }
                    var oldValue = this.getPropertyValue(name);
                    if (oldValue && Array.isArray(oldValue) && !!this.arraysInfo && (!val1 || Array.isArray(val1))) {
                        if (!this.isTwoValueEquals(oldValue, val1)) this.setArrayPropertyDirectly(name, val1);
                    } else {
                        this.setPropertyValueDirectly(name, val1);
                        if (!this.isDisposedValue && !this.isTwoValueEquals(oldValue, val1)) this.propertyValueChanged(name, oldValue, val1);
                    }
                };
                Base.prototype.setArrayPropertyDirectly = function(name, val1, sendNotification) {
                    if (sendNotification === void 0) sendNotification = true;
                    var arrayInfo = this.arraysInfo[name];
                    this.setArray(name, this.getPropertyValue(name), val1, arrayInfo ? arrayInfo.isItemValues : false, arrayInfo ? sendNotification && arrayInfo.onPush : null);
                };
                Base.prototype.setPropertyValueDirectly = function(name, val1) {
                    this.setPropertyValueCore(this.propertyHash, name, val1);
                };
                Base.prototype.clearPropertyValue = function(name) {
                    this.setPropertyValueCore(this.propertyHash, name, null);
                    delete this.propertyHash[name];
                };
                Base.prototype.onPropertyValueChangedCallback = function(name, oldValue, newValue, sender, arrayChanges) {};
                Base.prototype.itemValuePropertyChanged = function(item, name, oldValue, newValue) {
                    this.onItemValuePropertyChanged.fire(this, {
                        obj: item,
                        name: name,
                        oldValue: oldValue,
                        newValue: newValue,
                        propertyName: item.ownerPropertyName
                    });
                };
                Base.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {};
                Base.prototype.propertyValueChanged = function(name, oldValue, newValue, arrayChanges, target) {
                    if (this.isLoadingFromJson) return;
                    this.updateBindings(name, newValue);
                    this.onPropertyValueChanged(name, oldValue, newValue);
                    this.onPropertyChanged.fire(this, {
                        name: name,
                        oldValue: oldValue,
                        newValue: newValue
                    });
                    this.doPropertyValueChangedCallback(name, oldValue, newValue, arrayChanges, this);
                    this.checkConditionPropertyChanged(name);
                    if (!this.onPropChangeFunctions) return;
                    for(var i = 0; i < this.onPropChangeFunctions.length; i++)if (this.onPropChangeFunctions[i].name == name) this.onPropChangeFunctions[i].func(newValue, arrayChanges);
                };
                Base.prototype.onBindingChanged = function(oldValue, newValue) {
                    if (this.isLoadingFromJson) return;
                    this.doPropertyValueChangedCallback("bindings", oldValue, newValue);
                };
                Object.defineProperty(Base.prototype, "isInternal", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.doPropertyValueChangedCallback = function(name, oldValue, newValue, arrayChanges, target) {
                    var fireCallback = function(obj) {
                        if (!!obj && !!obj.onPropertyValueChangedCallback) obj.onPropertyValueChangedCallback(name, oldValue, newValue, target, arrayChanges);
                    };
                    if (this.isInternal) {
                        fireCallback(this);
                        return;
                    }
                    if (!target) target = this;
                    var notifier = this.getSurvey();
                    if (!notifier) notifier = this;
                    fireCallback(notifier);
                    if (notifier !== this) fireCallback(this);
                };
                Base.prototype.addExpressionProperty = function(name, onExecute, canRun) {
                    if (!this.expressionInfo) this.expressionInfo = {};
                    this.expressionInfo[name] = {
                        onExecute: onExecute,
                        canRun: canRun
                    };
                };
                Base.prototype.getDataFilteredValues = function() {
                    return {};
                };
                Base.prototype.getDataFilteredProperties = function() {
                    return {};
                };
                Base.prototype.runConditionCore = function(values, properties) {
                    if (!this.expressionInfo) return;
                    for(var key in this.expressionInfo)this.runConditionItemCore(key, values, properties);
                };
                Base.prototype.canRunConditions = function() {
                    return !this.isDesignMode;
                };
                Base.prototype.checkConditionPropertyChanged = function(propName) {
                    if (!this.expressionInfo || !this.expressionInfo[propName]) return;
                    if (!this.canRunConditions()) return;
                    this.runConditionItemCore(propName, this.getDataFilteredValues(), this.getDataFilteredProperties());
                };
                Base.prototype.runConditionItemCore = function(propName, values, properties) {
                    var _this = this;
                    var info = this.expressionInfo[propName];
                    var expression = this.getPropertyValue(propName);
                    if (!expression) return;
                    if (!!info.canRun && !info.canRun(this)) return;
                    if (!info.runner) {
                        info.runner = this.createExpressionRunner(expression);
                        info.runner.onRunComplete = function(res) {
                            info.onExecute(_this, res);
                        };
                    }
                    info.runner.expression = expression;
                    info.runner.run(values, properties);
                };
                Base.prototype.doBeforeAsynRun = function(id) {
                    if (!this.asynExpressionHash) this.asynExpressionHash = [];
                    var isChanged = !this.isAsyncExpressionRunning;
                    this.asynExpressionHash[id] = true;
                    if (isChanged) this.onAsyncRunningChanged();
                };
                Base.prototype.doAfterAsynRun = function(id) {
                    if (!!this.asynExpressionHash) {
                        delete this.asynExpressionHash[id];
                        if (!this.isAsyncExpressionRunning) this.onAsyncRunningChanged();
                    }
                };
                Base.prototype.onAsyncRunningChanged = function() {};
                Object.defineProperty(Base.prototype, "isAsyncExpressionRunning", {
                    get: function() {
                        return !!this.asynExpressionHash && Object.keys(this.asynExpressionHash).length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.createExpressionRunner = function(expression) {
                    var _this = this;
                    var res = new _conditions__WEBPACK_IMPORTED_MODULE_4__["ExpressionRunner"](expression);
                    res.onBeforeAsyncRun = function(id) {
                        _this.doBeforeAsynRun(id);
                    };
                    res.onAfterAsyncRun = function(id) {
                        _this.doAfterAsynRun(id);
                    };
                    return res;
                };
                /**
     * Registers a function to call when a property value changes.
     * @param propertyNames An array of one or multiple property names.
     * @param handler A function to call when one of the listed properties change.
     * @param key *(Optional)* A key that identifies the current registration. If a function for one of the properties is already registered with the same key, the function will be overwritten. You can also use the key to subsequently unregister handlers.
     * @see unregisterPropertyChangedHandlers
     */ Base.prototype.registerPropertyChangedHandlers = function(propertyNames, handler, key) {
                    if (key === void 0) key = null;
                    for(var i = 0; i < propertyNames.length; i++)this.registerFunctionOnPropertyValueChanged(propertyNames[i], handler, key);
                };
                /**
     * Unregisters value change event handlers for the specified properties.
     * @param propertyNames An array of one or multiple property names.
     * @param key *(Optional)* A key of the registration that you want to cancel.
     * @see registerPropertyChangedHandlers
     */ Base.prototype.unregisterPropertyChangedHandlers = function(propertyNames, key) {
                    if (key === void 0) key = null;
                    for(var i = 0; i < propertyNames.length; i++)this.unRegisterFunctionOnPropertyValueChanged(propertyNames[i], key);
                };
                Base.prototype.registerFunctionOnPropertyValueChanged = function(name, func, key) {
                    if (key === void 0) key = null;
                    if (!this.onPropChangeFunctions) this.onPropChangeFunctions = [];
                    if (key) for(var i = 0; i < this.onPropChangeFunctions.length; i++){
                        var item = this.onPropChangeFunctions[i];
                        if (item.name == name && item.key == key) {
                            item.func = func;
                            return;
                        }
                    }
                    this.onPropChangeFunctions.push({
                        name: name,
                        func: func,
                        key: key
                    });
                };
                Base.prototype.registerFunctionOnPropertiesValueChanged = function(names, func, key) {
                    if (key === void 0) key = null;
                    this.registerPropertyChangedHandlers(names, func, key);
                };
                Base.prototype.unRegisterFunctionOnPropertyValueChanged = function(name, key) {
                    if (key === void 0) key = null;
                    if (!this.onPropChangeFunctions) return;
                    for(var i = 0; i < this.onPropChangeFunctions.length; i++){
                        var item = this.onPropChangeFunctions[i];
                        if (item.name == name && item.key == key) {
                            this.onPropChangeFunctions.splice(i, 1);
                            return;
                        }
                    }
                };
                Base.prototype.unRegisterFunctionOnPropertiesValueChanged = function(names, key) {
                    if (key === void 0) key = null;
                    this.unregisterPropertyChangedHandlers(names, key);
                };
                Base.prototype.createCustomLocalizableObj = function(name) {
                    var locStr = this.getLocalizableString(name);
                    if (locStr) return locStr;
                    return this.createLocalizableString(name, this, false, true);
                };
                Base.prototype.getLocale = function() {
                    var locOwner = this.getSurvey();
                    return !!locOwner ? locOwner.getLocale() : "";
                };
                Base.prototype.getLocalizationString = function(strName) {
                    return _surveyStrings__WEBPACK_IMPORTED_MODULE_5__["surveyLocalization"].getString(strName, this.getLocale());
                };
                Base.prototype.getLocalizationFormatString = function(strName) {
                    var args = [];
                    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                    var str = this.getLocalizationString(strName);
                    if (!str || !str.format) return "";
                    return str.format.apply(str, args);
                };
                Base.prototype.createLocalizableString = function(name, owner, useMarkDown, defaultStr) {
                    var _this = this;
                    if (useMarkDown === void 0) useMarkDown = false;
                    if (defaultStr === void 0) defaultStr = false;
                    var locStr = new _localizablestring__WEBPACK_IMPORTED_MODULE_0__["LocalizableString"](owner, useMarkDown, name);
                    if (defaultStr) locStr.localizationName = defaultStr === true ? name : defaultStr;
                    locStr.onStrChanged = function(oldValue, newValue) {
                        _this.propertyValueChanged(name, oldValue, newValue);
                    };
                    if (!this.localizableStrings) this.localizableStrings = {};
                    this.localizableStrings[name] = locStr;
                    var prop = this.getPropertyByName(name);
                    locStr.disableLocalization = prop && prop.isLocalizable === false;
                    return locStr;
                };
                Base.prototype.getLocalizableString = function(name) {
                    return !!this.localizableStrings ? this.localizableStrings[name] : null;
                };
                Base.prototype.getLocalizableStringText = function(name, defaultStr) {
                    if (defaultStr === void 0) defaultStr = "";
                    Base.collectDependency(this, name);
                    var locStr = this.getLocalizableString(name);
                    if (!locStr) return "";
                    var res = locStr.text;
                    return res ? res : defaultStr;
                };
                Base.prototype.setLocalizableStringText = function(name, value) {
                    var locStr = this.getLocalizableString(name);
                    if (!locStr) return;
                    var oldValue = locStr.text;
                    if (oldValue != value) locStr.text = value;
                };
                Base.prototype.addUsedLocales = function(locales) {
                    if (!!this.localizableStrings) for(var key in this.localizableStrings){
                        var item = this.getLocalizableString(key);
                        if (item) this.AddLocStringToUsedLocales(item, locales);
                    }
                    if (!!this.arraysInfo) for(var key in this.arraysInfo){
                        var items = this.getPropertyValue(key);
                        if (!items || !items.length) continue;
                        for(var i = 0; i < items.length; i++){
                            var item = items[i];
                            if (item && item.addUsedLocales) item.addUsedLocales(locales);
                        }
                    }
                };
                Base.prototype.searchText = function(text, founded) {
                    var strs = [];
                    this.getSearchableLocalizedStrings(strs);
                    for(var i = 0; i < strs.length; i++)if (strs[i].setFindText(text)) founded.push({
                        element: this,
                        str: strs[i]
                    });
                };
                Base.prototype.getSearchableLocalizedStrings = function(arr) {
                    if (!!this.localizableStrings) {
                        var keys_1 = [];
                        this.getSearchableLocKeys(keys_1);
                        for(var i = 0; i < keys_1.length; i++){
                            var item = this.getLocalizableString(keys_1[i]);
                            if (item) arr.push(item);
                        }
                    }
                    if (!this.arraysInfo) return;
                    var keys = [];
                    this.getSearchableItemValueKeys(keys);
                    for(var i = 0; i < keys.length; i++){
                        var items = this.getPropertyValue(keys[i]);
                        if (!items) continue;
                        for(var j = 0; j < items.length; j++)arr.push(items[j].locText);
                    }
                };
                Base.prototype.getSearchableLocKeys = function(keys) {};
                Base.prototype.getSearchableItemValueKeys = function(keys) {};
                Base.prototype.AddLocStringToUsedLocales = function(locStr, locales) {
                    var locs = locStr.getLocales();
                    for(var i = 0; i < locs.length; i++)if (locales.indexOf(locs[i]) < 0) locales.push(locs[i]);
                };
                Base.prototype.createItemValues = function(name) {
                    var self = this;
                    var result = this.createNewArray(name, function(item) {
                        item.locOwner = self;
                        item.ownerPropertyName = name;
                        if (typeof item.getSurvey == "function") {
                            var survey = item.getSurvey();
                            if (!!survey && typeof survey.makeReactive == "function") survey.makeReactive(item);
                        }
                    });
                    this.arraysInfo[name].isItemValues = true;
                    return result;
                };
                Base.prototype.notifyArrayChanged = function(ar, arrayChanges) {
                    !!ar.onArrayChanged && ar.onArrayChanged(arrayChanges);
                };
                Base.prototype.createNewArrayCore = function(name) {
                    var res = null;
                    if (!!this.createArrayCoreHandler) res = this.createArrayCoreHandler(this.propertyHash, name);
                    if (!res) {
                        res = new Array();
                        this.setPropertyValueCore(this.propertyHash, name, res);
                    }
                    return res;
                };
                Base.prototype.ensureArray = function(name, onPush, onRemove) {
                    if (onPush === void 0) onPush = null;
                    if (onRemove === void 0) onRemove = null;
                    if (this.arraysInfo && this.arraysInfo[name]) return;
                    return this.createNewArray(name, onPush, onRemove);
                };
                Base.prototype.createNewArray = function(name, onPush, onRemove) {
                    if (onPush === void 0) onPush = null;
                    if (onRemove === void 0) onRemove = null;
                    var newArray = this.createNewArrayCore(name);
                    if (!this.arraysInfo) this.arraysInfo = {};
                    this.arraysInfo[name] = {
                        onPush: onPush,
                        isItemValues: false
                    };
                    var self = this;
                    newArray.push = function(value) {
                        var result = Object.getPrototypeOf(newArray).push.call(newArray, value);
                        if (!self.isDisposedValue) {
                            if (onPush) onPush(value, newArray.length - 1);
                            var arrayChanges = new ArrayChanges(newArray.length - 1, 0, [
                                value
                            ], []);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    newArray.shift = function() {
                        var result = Object.getPrototypeOf(newArray).shift.call(newArray);
                        if (!self.isDisposedValue && result) {
                            if (onRemove) onRemove(result);
                            var arrayChanges = new ArrayChanges(newArray.length - 1, 1, [], []);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    newArray.unshift = function(value) {
                        var result = Object.getPrototypeOf(newArray).unshift.call(newArray, value);
                        if (!self.isDisposedValue) {
                            if (onPush) onPush(value, newArray.length - 1);
                            var arrayChanges = new ArrayChanges(0, 0, [
                                value
                            ], []);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    newArray.pop = function() {
                        var result = Object.getPrototypeOf(newArray).pop.call(newArray);
                        if (!self.isDisposedValue) {
                            if (onRemove) onRemove(result);
                            var arrayChanges = new ArrayChanges(newArray.length - 1, 1, [], []);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    newArray.splice = function(start, deleteCount) {
                        var _a;
                        var items = [];
                        for(var _i = 2; _i < arguments.length; _i++)items[_i - 2] = arguments[_i];
                        if (!start) start = 0;
                        if (!deleteCount) deleteCount = 0;
                        var result = (_a = Object.getPrototypeOf(newArray).splice).call.apply(_a, __spreadArray([
                            newArray,
                            start,
                            deleteCount
                        ], items));
                        if (!items) items = [];
                        if (!self.isDisposedValue) {
                            if (onRemove && result) for(var i = 0; i < result.length; i++)onRemove(result[i]);
                            if (onPush) for(var i = 0; i < items.length; i++)onPush(items[i], start + i);
                            var arrayChanges = new ArrayChanges(start, deleteCount, items, result);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    return newArray;
                };
                Base.prototype.getItemValueType = function() {
                    return undefined;
                };
                Base.prototype.setArray = function(name, src, dest, isItemValues, onPush) {
                    var deletedItems = [].concat(src);
                    Object.getPrototypeOf(src).splice.call(src, 0, src.length);
                    if (!!dest) for(var i = 0; i < dest.length; i++){
                        var item = dest[i];
                        if (isItemValues) {
                            if (!!Base.createItemValue) item = Base.createItemValue(item, this.getItemValueType());
                        }
                        Object.getPrototypeOf(src).push.call(src, item);
                        if (onPush) onPush(src[i]);
                    }
                    var arrayChanges = new ArrayChanges(0, deletedItems.length, src, deletedItems);
                    this.propertyValueChanged(name, deletedItems, src, arrayChanges);
                    this.notifyArrayChanged(src, arrayChanges);
                };
                Base.prototype.isTwoValueEquals = function(x, y, caseInSensitive, trimString) {
                    if (caseInSensitive === void 0) caseInSensitive = false;
                    if (trimString === void 0) trimString = false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(x, y, false, !caseInSensitive, trimString);
                };
                Base.copyObject = function(dst, src) {
                    for(var key in src){
                        var source = src[key];
                        if (typeof source === "object") {
                            source = {};
                            this.copyObject(source, src[key]);
                        }
                        dst[key] = source;
                    }
                };
                Base.prototype.copyCssClasses = function(dest, source) {
                    if (!source) return;
                    if (typeof source === "string" || source instanceof String) dest["root"] = source;
                    else Base.copyObject(dest, source);
                };
                Base.prototype.getValueInLowCase = function(val1) {
                    if (!!val1 && typeof val1 == "string") return val1.toLowerCase();
                    return val1;
                };
                Base.prototype.getElementsInDesign = function(includeHidden) {
                    if (includeHidden === void 0) includeHidden = false;
                    return [];
                };
                Base.currentDependencis = undefined;
                return Base;
            }();
            var ArrayChanges = /** @class */ function() {
                function ArrayChanges(index, deleteCount, itemsToAdd, deletedItems) {
                    this.index = index;
                    this.deleteCount = deleteCount;
                    this.itemsToAdd = itemsToAdd;
                    this.deletedItems = deletedItems;
                }
                return ArrayChanges;
            }();
            var Event = /** @class */ function() {
                function Event() {}
                Object.defineProperty(Event.prototype, "isEmpty", {
                    get: function() {
                        return this.length === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Event.prototype, "length", {
                    get: function() {
                        return !!this.callbacks ? this.callbacks.length : 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Event.prototype.fireByCreatingOptions = function(sender, createOptions) {
                    if (!this.callbacks) return;
                    for(var i = 0; i < this.callbacks.length; i++){
                        this.callbacks[i](sender, createOptions());
                        if (!this.callbacks) return;
                    }
                };
                Event.prototype.fire = function(sender, options) {
                    if (!this.callbacks) return;
                    for(var i = 0; i < this.callbacks.length; i++){
                        this.callbacks[i](sender, options);
                        if (!this.callbacks) return;
                    }
                };
                Event.prototype.clear = function() {
                    this.callbacks = undefined;
                };
                Event.prototype.add = function(func) {
                    if (this.hasFunc(func)) return;
                    if (!this.callbacks) this.callbacks = new Array();
                    this.callbacks.push(func);
                    this.fireCallbackChanged();
                };
                Event.prototype.remove = function(func) {
                    if (this.hasFunc(func)) {
                        var index = this.callbacks.indexOf(func, 0);
                        this.callbacks.splice(index, 1);
                        this.fireCallbackChanged();
                    }
                };
                Event.prototype.hasFunc = function(func) {
                    if (this.callbacks == null) return false;
                    return this.callbacks.indexOf(func, 0) > -1;
                };
                Event.prototype.fireCallbackChanged = function() {
                    if (!!this.onCallbacksChanged) this.onCallbacksChanged();
                };
                return Event;
            }();
            var EventBase = /** @class */ function(_super) {
                __extends(EventBase, _super);
                function EventBase() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return EventBase;
            }(Event);
        /***/ },
        /***/ "./src/calculatedValue.ts": /*!********************************!*\
  !*** ./src/calculatedValue.ts ***!
  \********************************/ /*! exports provided: CalculatedValue */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CalculatedValue", function() {
                return CalculatedValue;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * The calculated value is a way to define the variable in Survey Creator.
 * It has two main properties: name and expression. Based on expression the value read-only property is automatically calculated.
 * The name property should be unique though all calculated values.
 * It uses survey.getVariable/seruvey.setVariable functions to get/set its value. The class do not store its value internally.
 * You may set includeIntoResult property to true to store this calculated value into survey result.
 */ var CalculatedValue = /** @class */ function(_super) {
                __extends(CalculatedValue, _super);
                function CalculatedValue(name, expression) {
                    if (name === void 0) name = null;
                    if (expression === void 0) expression = null;
                    var _this = _super.call(this) || this;
                    _this.expressionIsRunning = false;
                    _this.isCalculated = false;
                    if (!!name) _this.name = name;
                    if (!!expression) _this.expression = expression;
                    return _this;
                }
                CalculatedValue.prototype.setOwner = function(data) {
                    this.data = data;
                    this.rerunExpression();
                };
                CalculatedValue.prototype.getType = function() {
                    return "calculatedvalue";
                };
                CalculatedValue.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    return !!this.data && !!this.data["getSurvey"] ? this.data.getSurvey() : null;
                };
                Object.defineProperty(CalculatedValue.prototype, "owner", {
                    get: function() {
                        return this.data;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CalculatedValue.prototype, "name", {
                    /**
         * The calculated value name. It should be non empty and unique.
         */ get: function() {
                        return this.getPropertyValue("name") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("name", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CalculatedValue.prototype, "includeIntoResult", {
                    /**
         * Set this property to true to include the non-empty calculated value into survey result, survey.data property.
         */ get: function() {
                        return this.getPropertyValue("includeIntoResult");
                    },
                    set: function(val1) {
                        this.setPropertyValue("includeIntoResult", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CalculatedValue.prototype, "expression", {
                    /**
         * The Expression that used to calculate the value. You may use standard operators like +, -, * and /, squares (). Here is the example of accessing the question value {questionname}.
         * Example: "({quantity} * {price}) * (100 - {discount}) / 100"
         */ get: function() {
                        return this.getPropertyValue("expression") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("expression", val1);
                        this.rerunExpression();
                    },
                    enumerable: false,
                    configurable: true
                });
                CalculatedValue.prototype.locCalculation = function() {
                    this.expressionIsRunning = true;
                };
                CalculatedValue.prototype.unlocCalculation = function() {
                    this.expressionIsRunning = false;
                };
                CalculatedValue.prototype.resetCalculation = function() {
                    this.isCalculated = false;
                };
                CalculatedValue.prototype.doCalculation = function(calculatedValues, values, properties) {
                    if (this.isCalculated) return;
                    this.runExpressionCore(calculatedValues, values, properties);
                    this.isCalculated = true;
                };
                CalculatedValue.prototype.runExpression = function(values, properties) {
                    this.runExpressionCore(null, values, properties);
                };
                Object.defineProperty(CalculatedValue.prototype, "value", {
                    get: function() {
                        if (!this.data) return undefined;
                        return this.data.getVariable(this.name);
                    },
                    enumerable: false,
                    configurable: true
                });
                CalculatedValue.prototype.setValue = function(val1) {
                    if (!this.data) return;
                    this.data.setVariable(this.name, val1);
                };
                Object.defineProperty(CalculatedValue.prototype, "canRunExpression", {
                    get: function() {
                        return !!this.data && !this.isLoadingFromJson && !!this.expression && !this.expressionIsRunning && !!this.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                CalculatedValue.prototype.rerunExpression = function() {
                    if (!this.canRunExpression) return;
                    this.runExpression(this.data.getFilteredValues(), this.data.getFilteredProperties());
                };
                CalculatedValue.prototype.runExpressionCore = function(calculatedValues, values, properties) {
                    if (!this.canRunExpression) return;
                    this.ensureExpression(values);
                    this.locCalculation();
                    if (!!calculatedValues) this.runDependentExpressions(calculatedValues, values, properties);
                    this.expressionRunner.run(values, properties);
                };
                CalculatedValue.prototype.runDependentExpressions = function(calculatedValues, values, properties) {
                    var variables = this.expressionRunner.getVariables();
                    if (!variables) return;
                    for(var i = 0; i < calculatedValues.length; i++){
                        var calcItem = calculatedValues[i];
                        if (calcItem === this || variables.indexOf(calcItem.name) < 0) continue;
                        calcItem.doCalculation(calculatedValues, values, properties);
                        values[calcItem.name] = calcItem.value;
                    }
                };
                CalculatedValue.prototype.ensureExpression = function(values) {
                    var _this = this;
                    if (!!this.expressionRunner) return;
                    this.expressionRunner = new _conditions__WEBPACK_IMPORTED_MODULE_2__["ExpressionRunner"](this.expression);
                    this.expressionRunner.onRunComplete = function(newValue) {
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(newValue, _this.value, false, true, false)) _this.setValue(newValue);
                        _this.unlocCalculation();
                    };
                };
                return CalculatedValue;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_3__["Serializer"].addClass("calculatedvalue", [
                {
                    name: "!name",
                    isUnique: true
                },
                "expression:expression",
                "includeIntoResult:boolean"
            ], function() {
                return new CalculatedValue();
            }, "base");
        /***/ },
        /***/ "./src/choicesRestful.ts": /*!*******************************!*\
  !*** ./src/choicesRestful.ts ***!
  \*******************************/ /*! exports provided: ChoicesRestful, ChoicesRestfull */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChoicesRestful", function() {
                return ChoicesRestful;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ChoicesRestfull", function() {
                return ChoicesRestfull;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var XmlParser = /** @class */ function() {
                function XmlParser() {
                    this.parser = new DOMParser();
                }
                XmlParser.prototype.assignValue = function(target, name, value) {
                    if (Array.isArray(target[name])) target[name].push(value);
                    else if (target[name] !== undefined) target[name] = [
                        target[name]
                    ].concat(value);
                    else if (typeof value === "object" && Object.keys(value).length === 1 && Object.keys(value)[0] === name) target[name] = value[name];
                    else target[name] = value;
                };
                XmlParser.prototype.xml2Json = function(xmlNode, result) {
                    if (xmlNode.children && xmlNode.children.length > 0) for(var i = 0; i < xmlNode.children.length; i++){
                        var childNode = xmlNode.children[i];
                        var childObject = {};
                        this.xml2Json(childNode, childObject);
                        this.assignValue(result, childNode.nodeName, childObject);
                    }
                    else this.assignValue(result, xmlNode.nodeName, xmlNode.textContent);
                };
                XmlParser.prototype.parseXmlString = function(xmlString) {
                    var xmlRoot = this.parser.parseFromString(xmlString, "text/xml");
                    var json = {};
                    this.xml2Json(xmlRoot, json);
                    return json;
                };
                return XmlParser;
            }();
            /**
 * Configures access to a RESTful service that returns choices for [Checkbox](https://surveyjs.io/Examples/Library?id=questiontype-checkbox), [Dropdown](https://surveyjs.io/Examples/Library?id=questiontype-dropdown), [Radiogroup](https://surveyjs.io/Examples/Library?id=questiontype-radiogroup), and other multiple-choice question types.
 *
 * Use the following properties to configure this object:
 *
 * ```js
 * {
 *   url: "http://...", // A RESTful service's URL.
 *   valueName: "value", // Specifies which field contains choice values.
 *   titleName: "title", // Specifies which field contains display texts for choice values.
 *   imageLinkName: "imageUrl", // Specifies which field contains image URLs. Used in Image Picker questions.
 *   // Path to the array of choices. Specify `path` only if the array of choices is nested within the object returned by the service.
 *   // The following path separators are allowed: semicolon `;`, comma `,`.
 *   path: "myNestedArray"
 * }
 * ```
 *
 * Typically, you should assign this object to a question's [`choicesByUrl`](https://surveyjs.io/Documentation/Library?id=QuestionSelectBase#choicesByUrl) property. You can also specify additional application-wide settings using the [`settings.web`](https://surveyjs.io/form-library/documentation/api-reference/settings#web) object.
 */ var ChoicesRestful = /** @class */ function(_super) {
                __extends(ChoicesRestful, _super);
                function ChoicesRestful() {
                    var _this = _super.call(this) || this;
                    _this.lastObjHash = "";
                    _this.isRunningValue = false;
                    _this.processedUrl = "";
                    _this.processedPath = "";
                    _this.isUsingCacheFromUrl = undefined;
                    _this.error = null;
                    _this.createItemValue = function(value) {
                        return new _itemvalue__WEBPACK_IMPORTED_MODULE_1__["ItemValue"](value);
                    };
                    _this.registerPropertyChangedHandlers([
                        "url"
                    ], function() {
                        if (_this.owner) _this.owner.setPropertyValue("isUsingRestful", !!_this.url);
                    });
                    return _this;
                }
                Object.defineProperty(ChoicesRestful, "EncodeParameters", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.encodeUrlParams;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.encodeUrlParams = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                ChoicesRestful.clearCache = function() {
                    ChoicesRestful.itemsResult = {};
                    ChoicesRestful.sendingSameRequests = {};
                };
                ChoicesRestful.addSameRequest = function(obj) {
                    if (!obj.isUsingCache) return false;
                    var hash = obj.objHash;
                    var res = ChoicesRestful.sendingSameRequests[hash];
                    if (!res) {
                        ChoicesRestful.sendingSameRequests[obj.objHash] = [];
                        return false;
                    }
                    res.push(obj);
                    obj.isRunningValue = true;
                    return true;
                };
                ChoicesRestful.unregisterSameRequests = function(obj, items) {
                    if (!obj.isUsingCache) return;
                    var res = ChoicesRestful.sendingSameRequests[obj.objHash];
                    delete ChoicesRestful.sendingSameRequests[obj.objHash];
                    if (!res) return;
                    for(var i = 0; i < res.length; i++){
                        res[i].isRunningValue = false;
                        if (!!res[i].getResultCallback) res[i].getResultCallback(items);
                    }
                };
                Object.defineProperty(ChoicesRestful, "onBeforeSendRequest", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.onBeforeRequestChoices;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.onBeforeRequestChoices = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                ChoicesRestful.getCachedItemsResult = function(obj) {
                    var hash = obj.objHash;
                    var res = ChoicesRestful.itemsResult[hash];
                    if (!res) return false;
                    if (obj.getResultCallback) obj.getResultCallback(res);
                    return true;
                };
                ChoicesRestful.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    return !!this.owner ? this.owner.survey : null;
                };
                ChoicesRestful.prototype.run = function(textProcessor) {
                    if (textProcessor === void 0) textProcessor = null;
                    if (!this.url || !this.getResultCallback) return;
                    this.processedText(textProcessor);
                    if (!this.processedUrl) {
                        this.doEmptyResultCallback({});
                        this.lastObjHash = this.objHash;
                        return;
                    }
                    if (this.lastObjHash === this.objHash) return;
                    this.lastObjHash = this.objHash;
                    this.error = null;
                    if (this.useChangedItemsResults()) return;
                    if (ChoicesRestful.addSameRequest(this)) return;
                    this.sendRequest();
                };
                Object.defineProperty(ChoicesRestful.prototype, "isUsingCache", {
                    get: function() {
                        if (this.isUsingCacheFromUrl === true) return true;
                        if (this.isUsingCacheFromUrl === false) return false;
                        return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.cacheLoadedChoices;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChoicesRestful.prototype, "isRunning", {
                    get: function() {
                        return this.getIsRunning();
                    },
                    enumerable: false,
                    configurable: true
                });
                ChoicesRestful.prototype.getIsRunning = function() {
                    return this.isRunningValue;
                };
                Object.defineProperty(ChoicesRestful.prototype, "isWaitingForParameters", {
                    get: function() {
                        return this.url && !this.processedUrl;
                    },
                    enumerable: false,
                    configurable: true
                });
                ChoicesRestful.prototype.useChangedItemsResults = function() {
                    return ChoicesRestful.getCachedItemsResult(this);
                };
                ChoicesRestful.prototype.doEmptyResultCallback = function(serverResult) {
                    var items = [];
                    if (this.updateResultCallback) items = this.updateResultCallback(items, serverResult);
                    this.getResultCallback(items);
                };
                ChoicesRestful.prototype.processedText = function(textProcessor) {
                    var urlText = this.url;
                    if (!!urlText) urlText = urlText.replace(ChoicesRestful.cacheText, "").replace(ChoicesRestful.noCacheText, "");
                    if (textProcessor) {
                        var pUrl = textProcessor.processTextEx(urlText, false, _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.encodeUrlParams);
                        var pPath = textProcessor.processTextEx(this.path, false, _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.encodeUrlParams);
                        if (!pUrl.hasAllValuesOnLastRun || !pPath.hasAllValuesOnLastRun) {
                            this.processedUrl = "";
                            this.processedPath = "";
                        } else {
                            this.processedUrl = pUrl.text;
                            this.processedPath = pPath.text;
                        }
                    } else {
                        this.processedUrl = urlText;
                        this.processedPath = this.path;
                    }
                    if (this.onProcessedUrlCallback) this.onProcessedUrlCallback(this.processedUrl, this.processedPath);
                };
                ChoicesRestful.prototype.parseResponse = function(response) {
                    var parsedResponse;
                    if (!!response && typeof response.indexOf === "function" && response.indexOf("<") === 0) {
                        var parser = new XmlParser();
                        parsedResponse = parser.parseXmlString(response);
                    } else try {
                        parsedResponse = JSON.parse(response);
                    } catch (_a) {
                        parsedResponse = (response || "").split("\n").map(function(s) {
                            return s.trim(" ");
                        }).filter(function(s) {
                            return !!s;
                        });
                    }
                    return parsedResponse;
                };
                ChoicesRestful.prototype.sendRequest = function() {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", this.processedUrl);
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                    var self = this;
                    var loadingObjHash = this.objHash;
                    xhr.onload = function() {
                        self.beforeLoadRequest();
                        if (xhr.status === 200) self.onLoad(self.parseResponse(xhr.response), loadingObjHash);
                        else self.onError(xhr.statusText, xhr.responseText);
                    };
                    var options = {
                        request: xhr
                    };
                    if (!!_settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.onBeforeRequestChoices) _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.onBeforeRequestChoices(this, options);
                    this.beforeSendRequest();
                    options.request.send();
                };
                ChoicesRestful.prototype.getType = function() {
                    return "choicesByUrl";
                };
                Object.defineProperty(ChoicesRestful.prototype, "isEmpty", {
                    get: function() {
                        return !this.url && !this.path;
                    },
                    enumerable: false,
                    configurable: true
                });
                ChoicesRestful.prototype.getCustomPropertiesNames = function() {
                    var properties = this.getCustomProperties();
                    var res = new Array();
                    for(var i = 0; i < properties.length; i++)res.push(this.getCustomPropertyName(properties[i].name));
                    return res;
                };
                ChoicesRestful.prototype.getCustomPropertyName = function(propertyName) {
                    return propertyName + "Name";
                };
                ChoicesRestful.prototype.getCustomProperties = function() {
                    var properties = _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].getProperties(this.itemValueType);
                    var res = [];
                    for(var i = 0; i < properties.length; i++){
                        if (properties[i].name === "value" || properties[i].name === "text" || properties[i].name === "visibleIf" || properties[i].name === "enableIf") continue;
                        res.push(properties[i]);
                    }
                    return res;
                };
                ChoicesRestful.prototype.setData = function(json) {
                    this.clear();
                    if (json.url) this.url = json.url;
                    if (json.path) this.path = json.path;
                    if (json.valueName) this.valueName = json.valueName;
                    if (json.titleName) this.titleName = json.titleName;
                    if (json.imageLinkName) this.imageLinkName = json.imageLinkName;
                    if (json.allowEmptyResponse !== undefined) this.allowEmptyResponse = json.allowEmptyResponse;
                    if (json.attachOriginalItems !== undefined) this.attachOriginalItems = json.attachOriginalItems;
                    var properties = this.getCustomPropertiesNames();
                    for(var i = 0; i < properties.length; i++)if (json[properties[i]]) this[properties[i]] = json[properties[i]];
                };
                ChoicesRestful.prototype.getData = function() {
                    if (this.isEmpty) return null;
                    var res = {};
                    if (this.url) res["url"] = this.url;
                    if (this.path) res["path"] = this.path;
                    if (this.valueName) res["valueName"] = this.valueName;
                    if (this.titleName) res["titleName"] = this.titleName;
                    if (this.imageLinkName) res["imageLinkName"] = this.imageLinkName;
                    if (this.allowEmptyResponse) res["allowEmptyResponse"] = this.allowEmptyResponse;
                    if (this.attachOriginalItems) res["attachOriginalItems"] = this.attachOriginalItems;
                    var properties = this.getCustomPropertiesNames();
                    for(var i = 0; i < properties.length; i++)if (this[properties[i]]) res[properties[i]] = this[properties[i]];
                    return res;
                };
                Object.defineProperty(ChoicesRestful.prototype, "url", {
                    /**
         * A RESTful service's URL.
         *
         * This property supports [dynamic URLs](https://surveyjs.io/Documentation/Library?id=design-survey-conditional-logic#dynamic-texts). For example, the URL below depends on the `region` question's value. When the value changes, the survey automatically loads a new dataset that corresponds to the selected region.
         *
         * ```js
         * url: "https://surveyjs.io/api/CountriesExample?region={region}"
         * ```
         *
         * [View Demo](https://surveyjs.io/Examples/Library/?id=questiontype-dropdownrestfull (linkStyle))
         * @see path
         * @see valueName
         * @see titleName
         */ get: function() {
                        return this.getPropertyValue("url") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("url", val1);
                        this.isUsingCacheFromUrl = undefined;
                        if (!val1) return;
                        if (val1.indexOf(ChoicesRestful.cacheText) > -1) this.isUsingCacheFromUrl = true;
                        else if (val1.indexOf(ChoicesRestful.noCacheText) > -1) this.isUsingCacheFromUrl = false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChoicesRestful.prototype, "path", {
                    /**
         * Path to the array of choices. The following path separators are allowed: semicolon `;`, comma `,`.
         *
         * Specify this property only if the array of choices is nested within the object returned by the service. For example, the service returns the following object:
         *
         * ```js
         * {
         *   countries: [ ... ],
         *   capitals: [ ... ]
         * }
         * ```
         *
         * To populate choices with values from the `countries` array, set the `path` property to `"countries"`. To use the `capitals` array, set this property to `"capitals"`.
         * @see url
         * @see valueName
         * @see titleName
         */ get: function() {
                        return this.getPropertyValue("path") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("path", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChoicesRestful.prototype, "valueName", {
                    /**
         * Specifies which property in the obtained data object contains choice values.
         *
         * [View Demo](https://surveyjs.io/Examples/Library/?id=questiontype-dropdownrestfull (linkStyle))
         *
         * @see url
         * @see path
         * @see titleName
         */ get: function() {
                        return this.getPropertyValue("valueName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("valueName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChoicesRestful.prototype, "titleName", {
                    /**
         * Specifies which property in the obtained data object contains display texts for choices.
         *
         * @see url
         * @see path
         * @see valueName
         */ get: function() {
                        return this.getPropertyValue("titleName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("titleName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChoicesRestful.prototype, "imageLinkName", {
                    /**
         * Specifies which property in the obtained data object contains image URLs. Used only in [Image Picker](https://surveyjs.io/Examples/Library?id=questiontype-imagepicker) questions.
         *
         * @see url
         * @see path
         * @see valueName
         */ get: function() {
                        return this.getPropertyValue("imageLinkName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageLinkName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChoicesRestful.prototype, "allowEmptyResponse", {
                    /**
         * Specifies whether the service is allowed to return an empty response or an empty array in a response.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("allowEmptyResponse");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowEmptyResponse", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChoicesRestful.prototype, "attachOriginalItems", {
                    get: function() {
                        return this.getPropertyValue("attachOriginalItems");
                    },
                    set: function(val1) {
                        this.setPropertyValue("attachOriginalItems", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ChoicesRestful.prototype, "itemValueType", {
                    get: function() {
                        if (!this.owner) return "itemvalue";
                        var prop = _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].findProperty(this.owner.getType(), "choices");
                        if (!prop) return "itemvalue";
                        if (prop.type == "itemvalue[]") return "itemvalue";
                        return prop.type;
                    },
                    enumerable: false,
                    configurable: true
                });
                ChoicesRestful.prototype.clear = function() {
                    this.url = undefined;
                    this.path = undefined;
                    this.valueName = undefined;
                    this.titleName = undefined;
                    this.imageLinkName = undefined;
                    var properties = this.getCustomPropertiesNames();
                    for(var i = 0; i < properties.length; i++)if (this[properties[i]]) this[properties[i]] = "";
                };
                ChoicesRestful.prototype.beforeSendRequest = function() {
                    this.isRunningValue = true;
                    if (!!this.beforeSendRequestCallback) this.beforeSendRequestCallback();
                };
                ChoicesRestful.prototype.beforeLoadRequest = function() {
                    this.isRunningValue = false;
                };
                ChoicesRestful.prototype.onLoad = function(result, loadingObjHash) {
                    if (loadingObjHash === void 0) loadingObjHash = null;
                    if (!loadingObjHash) loadingObjHash = this.objHash;
                    var items = new Array();
                    var updatedResult = this.getResultAfterPath(result);
                    if (updatedResult && updatedResult["length"]) for(var i = 0; i < updatedResult.length; i++){
                        var itemValue = updatedResult[i];
                        if (!itemValue) continue;
                        var value = !!this.getItemValueCallback ? this.getItemValueCallback(itemValue) : this.getValue(itemValue);
                        var item = this.createItemValue(value);
                        this.setTitle(item, itemValue);
                        this.setCustomProperties(item, itemValue);
                        if (this.attachOriginalItems) item.originalItem = itemValue;
                        var imageLink = this.getImageLink(itemValue);
                        if (!!imageLink) item.imageLink = imageLink;
                        items.push(item);
                    }
                    else if (!this.allowEmptyResponse) this.error = new _error__WEBPACK_IMPORTED_MODULE_3__["WebRequestEmptyError"](null, this.owner);
                    if (this.updateResultCallback) items = this.updateResultCallback(items, result);
                    if (this.isUsingCache) ChoicesRestful.itemsResult[loadingObjHash] = items;
                    this.callResultCallback(items, loadingObjHash);
                    ChoicesRestful.unregisterSameRequests(this, items);
                };
                ChoicesRestful.prototype.callResultCallback = function(items, loadingObjHash) {
                    if (loadingObjHash != this.objHash) return;
                    this.getResultCallback(items);
                };
                ChoicesRestful.prototype.setCustomProperties = function(item, itemValue) {
                    var properties = this.getCustomProperties();
                    for(var i = 0; i < properties.length; i++){
                        var prop = properties[i];
                        var val1 = this.getValueCore(itemValue, this.getPropertyBinding(prop.name));
                        if (!this.isValueEmpty(val1)) item[prop.name] = val1;
                    }
                };
                ChoicesRestful.prototype.getPropertyBinding = function(propertyName) {
                    if (this[this.getCustomPropertyName(propertyName)]) return this[this.getCustomPropertyName(propertyName)];
                    if (this[propertyName]) return this[propertyName];
                    return propertyName;
                };
                ChoicesRestful.prototype.onError = function(status, response) {
                    this.error = new _error__WEBPACK_IMPORTED_MODULE_3__["WebRequestError"](status, response, this.owner);
                    this.doEmptyResultCallback(response);
                    ChoicesRestful.unregisterSameRequests(this, []);
                };
                ChoicesRestful.prototype.getResultAfterPath = function(result) {
                    if (!result) return result;
                    if (!this.processedPath) return result;
                    var pathes = this.getPathes();
                    for(var i = 0; i < pathes.length; i++){
                        result = result[pathes[i]];
                        if (!result) return null;
                    }
                    return result;
                };
                ChoicesRestful.prototype.getPathes = function() {
                    var pathes = [];
                    if (this.processedPath.indexOf(";") > -1) pathes = this.path.split(";");
                    else pathes = this.processedPath.split(",");
                    if (pathes.length == 0) pathes.push(this.processedPath);
                    return pathes;
                };
                ChoicesRestful.prototype.getValue = function(item) {
                    if (!item) return null;
                    if (this.valueName) return this.getValueCore(item, this.valueName);
                    if (!(item instanceof Object)) return item;
                    var len = Object.keys(item).length;
                    if (len < 1) return null;
                    return item[Object.keys(item)[0]];
                };
                ChoicesRestful.prototype.setTitle = function(item, itemValue) {
                    var title = this.titleName ? this.titleName : "title";
                    var val1 = this.getValueCore(itemValue, title);
                    if (!val1) return;
                    if (typeof val1 === "string") item.text = val1;
                    else item.locText.setJson(val1);
                };
                ChoicesRestful.prototype.getImageLink = function(item) {
                    var imageLink = this.imageLinkName ? this.imageLinkName : "imageLink";
                    return this.getValueCore(item, imageLink);
                };
                ChoicesRestful.prototype.getValueCore = function(item, property) {
                    if (!item) return null;
                    if (property.indexOf(".") < 0) return item[property];
                    var properties = property.split(".");
                    for(var i = 0; i < properties.length; i++){
                        item = item[properties[i]];
                        if (!item) return null;
                    }
                    return item;
                };
                Object.defineProperty(ChoicesRestful.prototype, "objHash", {
                    get: function() {
                        return this.processedUrl + ";" + this.processedPath + ";" + this.valueName + ";" + this.titleName + ";" + this.imageLinkName;
                    },
                    enumerable: false,
                    configurable: true
                });
                ChoicesRestful.cacheText = "{CACHE}";
                ChoicesRestful.noCacheText = "{NOCACHE}";
                ChoicesRestful.itemsResult = {};
                ChoicesRestful.sendingSameRequests = {};
                return ChoicesRestful;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            /**
 * Obsolete, please use ChoicesRestful
 */ var ChoicesRestfull = /** @class */ function(_super) {
                __extends(ChoicesRestfull, _super);
                function ChoicesRestfull() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(ChoicesRestfull, "EncodeParameters", {
                    get: function() {
                        return ChoicesRestful.EncodeParameters;
                    },
                    set: function(val1) {
                        ChoicesRestful.EncodeParameters = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                ChoicesRestfull.clearCache = function() {
                    ChoicesRestful.clearCache();
                };
                Object.defineProperty(ChoicesRestfull, "onBeforeSendRequest", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.onBeforeRequestChoices;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].web.onBeforeRequestChoices = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                return ChoicesRestfull;
            }(ChoicesRestful);
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("choicesByUrl", [
                "url",
                "path",
                "valueName",
                "titleName",
                {
                    name: "imageLinkName",
                    visibleIf: function(obj) {
                        return !!obj && !!obj.owner && obj.owner.getType() == "imagepicker";
                    }
                },
                {
                    name: "allowEmptyResponse:boolean"
                },
                {
                    name: "attachOriginalItems:boolean",
                    visible: false
                }
            ], function() {
                return new ChoicesRestful();
            });
        /***/ },
        /***/ "./src/conditionProcessValue.ts": /*!**************************************!*\
  !*** ./src/conditionProcessValue.ts ***!
  \**************************************/ /*! exports provided: ProcessValue */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProcessValue", function() {
                return ProcessValue;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            var surveyBuiltInVarible = "@survey";
            var ProcessValue = /** @class */ function() {
                function ProcessValue() {
                    this.values = null;
                    this.properties = null;
                }
                ProcessValue.prototype.getFirstName = function(text, obj) {
                    if (obj === void 0) obj = null;
                    if (!text) return text;
                    var res = "";
                    if (!!obj) {
                        res = this.getFirstPropertyName(text, obj);
                        if (!!res) return res;
                    }
                    for(var i = 0; i < text.length; i++){
                        var ch = text[i];
                        if (ch == "." || ch == "[") break;
                        res += ch;
                    }
                    return res;
                };
                ProcessValue.prototype.hasValue = function(text, values) {
                    if (values === void 0) values = null;
                    if (!values) values = this.values;
                    var res = this.getValueCore(text, values);
                    return res.hasValue;
                };
                ProcessValue.prototype.getValue = function(text, values) {
                    if (values === void 0) values = null;
                    if (!values) values = this.values;
                    var res = this.getValueCore(text, values);
                    return res.value;
                };
                ProcessValue.prototype.setValue = function(obj, text, value) {
                    if (!text) return;
                    var nonNestedObj = this.getNonNestedObject(obj, text, true);
                    if (!nonNestedObj) return;
                    obj = nonNestedObj.value;
                    text = nonNestedObj.text;
                    if (!!obj && !!text) obj[text] = value;
                };
                ProcessValue.prototype.getValueInfo = function(valueInfo) {
                    if (!!valueInfo.path) {
                        valueInfo.value = this.getValueFromPath(valueInfo.path, this.values);
                        valueInfo.hasValue = valueInfo.value !== null && !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(valueInfo.value);
                        if (!valueInfo.hasValue && valueInfo.path.length > 1 && valueInfo.path[valueInfo.path.length - 1] == "length") {
                            valueInfo.hasValue = true;
                            valueInfo.value = 0;
                        }
                        return;
                    }
                    var res = this.getValueCore(valueInfo.name, this.values);
                    valueInfo.value = res.value;
                    valueInfo.hasValue = res.hasValue;
                    valueInfo.path = res.hasValue ? res.path : null;
                    valueInfo.sctrictCompare = res.sctrictCompare;
                };
                ProcessValue.prototype.isAnyKeyChanged = function(keys, usedNames) {
                    for(var i = 0; i < usedNames.length; i++){
                        var name = usedNames[i];
                        if (keys.hasOwnProperty(name)) return true;
                        var firstName = this.getFirstName(name);
                        if (!keys.hasOwnProperty(firstName)) continue;
                        if (name === firstName) return true;
                        var keyValue = keys[firstName];
                        if (keyValue == undefined) continue;
                        if (!keyValue.hasOwnProperty("oldValue") || !keyValue.hasOwnProperty("newValue")) return true;
                        var v = {};
                        v[firstName] = keyValue["oldValue"];
                        var oldValue = this.getValue(name, v);
                        v[firstName] = keyValue["newValue"];
                        var newValue = this.getValue(name, v);
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(oldValue, newValue, false, false, false)) return true;
                    }
                    return false;
                };
                ProcessValue.prototype.getValueFromPath = function(path, values) {
                    if (path.length === 2 && path[0] === surveyBuiltInVarible) return this.getValueFromSurvey(path[1]);
                    var index = 0;
                    while(!!values && index < path.length){
                        var ind_name = path[index];
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(ind_name) && Array.isArray(values) && ind_name >= values.length) return null;
                        values = values[ind_name];
                        index++;
                    }
                    return values;
                };
                ProcessValue.prototype.getValueCore = function(text, values) {
                    var question = this.getQuestionDirectly(text);
                    if (question) return {
                        hasValue: true,
                        value: question.value,
                        path: [
                            text
                        ],
                        sctrictCompare: question.requireStrictCompare
                    };
                    var res = this.getValueFromValues(text, values);
                    if (!!text && !res.hasValue) {
                        var val1 = this.getValueFromSurvey(text);
                        if (val1 !== undefined) {
                            res.hasValue = true;
                            res.value = val1;
                            res.path = [
                                surveyBuiltInVarible,
                                text
                            ];
                        }
                    }
                    return res;
                };
                ProcessValue.prototype.getQuestionDirectly = function(name) {
                    if (!!this.properties && !!this.properties.survey) return this.properties.survey.getQuestionByValueName(name);
                    return undefined;
                };
                ProcessValue.prototype.getValueFromSurvey = function(name) {
                    if (!!this.properties && !!this.properties.survey) return this.properties.survey.getBuiltInVariableValue(name.toLocaleLowerCase());
                    return undefined;
                };
                ProcessValue.prototype.getValueFromValues = function(text, values) {
                    var res = {
                        hasValue: false,
                        value: null,
                        path: null
                    };
                    var curValue = values;
                    if (!curValue && curValue !== 0 && curValue !== false) return res;
                    if (text && text.lastIndexOf(".length") > -1 && text.lastIndexOf(".length") === text.length - 7) {
                        res.value = 0;
                        res.hasValue = true;
                    }
                    var nonNestedObj = this.getNonNestedObject(curValue, text, false);
                    if (!nonNestedObj) return res;
                    res.path = nonNestedObj.path;
                    res.value = !!nonNestedObj.text ? this.getObjectValue(nonNestedObj.value, nonNestedObj.text) : nonNestedObj.value;
                    res.hasValue = !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(res.value);
                    return res;
                };
                ProcessValue.prototype.getNonNestedObject = function(obj, text, createPath) {
                    var checkedKeys = new Array();
                    var len = 0;
                    var res = this.getNonNestedObjectCore(obj, text, createPath, checkedKeys);
                    while(!res && len < checkedKeys.length){
                        len = checkedKeys.length;
                        res = this.getNonNestedObjectCore(obj, text, createPath, checkedKeys);
                    }
                    return res;
                };
                ProcessValue.prototype.getNonNestedObjectCore = function(obj, text, createPath, checkedKeys) {
                    var curName = this.getFirstPropertyName(text, obj, createPath, checkedKeys);
                    if (!!curName) checkedKeys.push(curName);
                    var path = !!curName ? [
                        curName
                    ] : null;
                    while(text != curName && !!obj){
                        var isArray = text[0] == "[";
                        if (!isArray) {
                            if (!curName && text == this.getFirstName(text)) return {
                                value: obj,
                                text: text,
                                path: path
                            };
                            obj = this.getObjectValue(obj, curName);
                            if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(obj) && !createPath) return null;
                            text = text.substring(curName.length);
                        } else {
                            var objInArray = this.getObjInArray(obj, text);
                            if (!objInArray) return null;
                            obj = objInArray.value;
                            text = objInArray.text;
                            path.push(objInArray.index);
                        }
                        if (!!text && text[0] == ".") text = text.substring(1);
                        curName = this.getFirstPropertyName(text, obj, createPath, checkedKeys);
                        if (!!curName) path.push(curName);
                    }
                    return {
                        value: obj,
                        text: text,
                        path: path
                    };
                };
                ProcessValue.prototype.getObjInArray = function(curValue, text) {
                    if (!Array.isArray(curValue)) return null;
                    var index = 1;
                    var str = "";
                    while(index < text.length && text[index] != "]"){
                        str += text[index];
                        index++;
                    }
                    text = index < text.length ? text.substring(index + 1) : "";
                    index = this.getIntValue(str);
                    if (index < 0 || index >= curValue.length) return null;
                    return {
                        value: curValue[index],
                        text: text,
                        index: index
                    };
                };
                ProcessValue.prototype.getFirstPropertyName = function(name, obj, createProp, checkedKeys) {
                    if (createProp === void 0) createProp = false;
                    if (checkedKeys === void 0) checkedKeys = undefined;
                    if (!name) return name;
                    if (!obj) obj = {};
                    if (obj.hasOwnProperty(name)) return name;
                    var nameInLow = name.toLowerCase();
                    var A = nameInLow[0];
                    var a = A.toUpperCase();
                    for(var key in obj){
                        if (Array.isArray(checkedKeys) && checkedKeys.indexOf(key) > -1) continue;
                        var first = key[0];
                        if (first === a || first === A) {
                            var keyName = key.toLowerCase();
                            if (keyName == nameInLow) return key;
                            if (nameInLow.length <= keyName.length) continue;
                            var ch = nameInLow[keyName.length];
                            if (ch != "." && ch != "[") continue;
                            if (keyName == nameInLow.substring(0, keyName.length)) return key;
                        }
                    }
                    if (createProp && name[0] !== "[") {
                        var ind = name.indexOf(".");
                        if (ind > -1) {
                            name = name.substring(0, ind);
                            obj[name] = {};
                        }
                        return name;
                    }
                    return "";
                };
                ProcessValue.prototype.getObjectValue = function(obj, name) {
                    if (!name) return null;
                    return obj[name];
                };
                ProcessValue.prototype.getIntValue = function(str) {
                    if (str == "0" || (str | 0) > 0 && str % 1 == 0) return Number(str);
                    return -1;
                };
                return ProcessValue;
            }();
        /***/ },
        /***/ "./src/conditions.ts": /*!***************************!*\
  !*** ./src/conditions.ts ***!
  \***************************/ /*! exports provided: ExpressionExecutor, ExpressionRunnerBase, ConditionRunner, ExpressionRunner */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionExecutor", function() {
                return ExpressionExecutor;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionRunnerBase", function() {
                return ExpressionRunnerBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConditionRunner", function() {
                return ConditionRunner;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionRunner", function() {
                return ExpressionRunner;
            });
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./conditionProcessValue */ "./src/conditionProcessValue.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            /* harmony import */ var _conditionsParser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./conditionsParser */ "./src/conditionsParser.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ExpressionExecutor = /** @class */ function() {
                function ExpressionExecutor(expression) {
                    this.processValue = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_0__["ProcessValue"]();
                    this.parser = new _conditionsParser__WEBPACK_IMPORTED_MODULE_2__["ConditionsParser"]();
                    this.isAsyncValue = false;
                    this.hasFunctionValue = false;
                    this.setExpression(expression);
                }
                Object.defineProperty(ExpressionExecutor.prototype, "expression", {
                    get: function() {
                        return this.expressionValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionExecutor.prototype.setExpression = function(value) {
                    if (this.expression === value) return;
                    this.expressionValue = value;
                    this.operand = this.parser.parseExpression(value);
                    this.hasFunctionValue = this.canRun() ? this.operand.hasFunction() : false;
                    this.isAsyncValue = this.hasFunction() ? this.operand.hasAsyncFunction() : false;
                };
                ExpressionExecutor.prototype.getVariables = function() {
                    if (!this.operand) return [];
                    var variables = [];
                    this.operand.setVariables(variables);
                    return variables;
                };
                ExpressionExecutor.prototype.hasFunction = function() {
                    return this.hasFunctionValue;
                };
                Object.defineProperty(ExpressionExecutor.prototype, "isAsync", {
                    get: function() {
                        return this.isAsyncValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionExecutor.prototype.canRun = function() {
                    return !!this.operand;
                };
                ExpressionExecutor.prototype.run = function(values, properties) {
                    var _this = this;
                    if (properties === void 0) properties = null;
                    if (!this.operand) {
                        if (!!this.expression) _console_warnings__WEBPACK_IMPORTED_MODULE_1__["ConsoleWarnings"].warn("Invalid expression: " + this.expression);
                        return null;
                    }
                    this.processValue.values = values;
                    this.processValue.properties = properties;
                    if (!this.isAsync) return this.runValues();
                    this.asyncFuncList = [];
                    this.operand.addToAsyncList(this.asyncFuncList);
                    for(var i = 0; i < this.asyncFuncList.length; i++)this.asyncFuncList[i].onAsyncReady = function() {
                        _this.doAsyncFunctionReady();
                    };
                    for(var i = 0; i < this.asyncFuncList.length; i++)this.asyncFuncList[i].evaluateAsync(this.processValue);
                    return false;
                };
                ExpressionExecutor.prototype.doAsyncFunctionReady = function() {
                    for(var i = 0; i < this.asyncFuncList.length; i++){
                        if (!this.asyncFuncList[i].isReady) return;
                    }
                    this.runValues();
                };
                ExpressionExecutor.prototype.runValues = function() {
                    var res = this.operand.evaluate(this.processValue);
                    if (!!this.onComplete) this.onComplete(res);
                    return res;
                };
                ExpressionExecutor.createExpressionExecutor = function(expression) {
                    return new ExpressionExecutor(expression);
                };
                return ExpressionExecutor;
            }();
            var ExpressionRunnerBase = /** @class */ function() {
                function ExpressionRunnerBase(expression) {
                    this._id = ExpressionRunnerBase.IdCounter++;
                    this.expression = expression;
                }
                Object.defineProperty(ExpressionRunnerBase.prototype, "id", {
                    get: function() {
                        return this._id;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExpressionRunnerBase.prototype, "expression", {
                    get: function() {
                        return !!this.expressionExecutor ? this.expressionExecutor.expression : "";
                    },
                    set: function(value) {
                        var _this = this;
                        if (!!this.expressionExecutor && value === this.expression) return;
                        this.expressionExecutor = ExpressionExecutor.createExpressionExecutor(value);
                        this.expressionExecutor.onComplete = function(res) {
                            _this.doOnComplete(res);
                        };
                        this.variables = undefined;
                        this.containsFunc = undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionRunnerBase.prototype.getVariables = function() {
                    if (this.variables === undefined) this.variables = this.expressionExecutor.getVariables();
                    return this.variables;
                };
                ExpressionRunnerBase.prototype.hasFunction = function() {
                    if (this.containsFunc === undefined) this.containsFunc = this.expressionExecutor.hasFunction();
                    return this.containsFunc;
                };
                Object.defineProperty(ExpressionRunnerBase.prototype, "isAsync", {
                    get: function() {
                        return this.expressionExecutor.isAsync;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionRunnerBase.prototype.canRun = function() {
                    return this.expressionExecutor.canRun();
                };
                ExpressionRunnerBase.prototype.runCore = function(values, properties) {
                    if (properties === void 0) properties = null;
                    if (this.onBeforeAsyncRun && this.isAsync) this.onBeforeAsyncRun(this.id);
                    return this.expressionExecutor.run(values, properties);
                };
                ExpressionRunnerBase.prototype.doOnComplete = function(res) {
                    if (this.onAfterAsyncRun && this.isAsync) this.onAfterAsyncRun(this.id);
                };
                ExpressionRunnerBase.IdCounter = 1;
                return ExpressionRunnerBase;
            }();
            var ConditionRunner = /** @class */ function(_super) {
                __extends(ConditionRunner, _super);
                function ConditionRunner() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ConditionRunner.prototype.run = function(values, properties) {
                    if (properties === void 0) properties = null;
                    return this.runCore(values, properties) == true;
                };
                ConditionRunner.prototype.doOnComplete = function(res) {
                    if (!!this.onRunComplete) this.onRunComplete(res == true);
                    _super.prototype.doOnComplete.call(this, res);
                };
                return ConditionRunner;
            }(ExpressionRunnerBase);
            var ExpressionRunner = /** @class */ function(_super) {
                __extends(ExpressionRunner, _super);
                function ExpressionRunner() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ExpressionRunner.prototype.run = function(values, properties) {
                    if (properties === void 0) properties = null;
                    return this.runCore(values, properties);
                };
                ExpressionRunner.prototype.doOnComplete = function(res) {
                    if (!!this.onRunComplete) this.onRunComplete(res);
                    _super.prototype.doOnComplete.call(this, res);
                };
                return ExpressionRunner;
            }(ExpressionRunnerBase);
        /***/ },
        /***/ "./src/conditionsParser.ts": /*!*********************************!*\
  !*** ./src/conditionsParser.ts ***!
  \*********************************/ /*! exports provided: ConditionsParserError, ConditionsParser */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConditionsParserError", function() {
                return ConditionsParserError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConditionsParser", function() {
                return ConditionsParser;
            });
            /* harmony import */ var _expressions_expressionParser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./expressions/expressionParser */ "./src/expressions/expressionParser.ts");
            var ConditionsParserError = /** @class */ function() {
                function ConditionsParserError(at, code) {
                    this.at = at;
                    this.code = code;
                }
                return ConditionsParserError;
            }();
            var ConditionsParser = /** @class */ function() {
                function ConditionsParser() {}
                ConditionsParser.prototype.patchExpression = function(text) {
                    return text.replace(/=>/g, ">=").replace(/=</g, "<=").replace(/<>/g, "!=").replace(/equals/g, "equal ").replace(/notequals/g, "notequal ");
                };
                ConditionsParser.prototype.createCondition = function(text) {
                    return this.parseExpression(text);
                };
                ConditionsParser.prototype.parseExpression = function(text) {
                    try {
                        var result = ConditionsParser.parserCache[text];
                        if (result === undefined) {
                            result = Object(_expressions_expressionParser__WEBPACK_IMPORTED_MODULE_0__["parse"])(this.patchExpression(text));
                            if (!result.hasAsyncFunction()) ConditionsParser.parserCache[text] = result;
                        }
                        return result;
                    } catch (e) {
                        if (e instanceof _expressions_expressionParser__WEBPACK_IMPORTED_MODULE_0__["SyntaxError"]) this.conditionError = new ConditionsParserError(e.location.start.offset, e.message);
                    }
                };
                Object.defineProperty(ConditionsParser.prototype, "error", {
                    get: function() {
                        return this.conditionError;
                    },
                    enumerable: false,
                    configurable: true
                });
                ConditionsParser.parserCache = {};
                return ConditionsParser;
            }();
        /***/ },
        /***/ "./src/console-warnings.ts": /*!*********************************!*\
  !*** ./src/console-warnings.ts ***!
  \*********************************/ /*! exports provided: ConsoleWarnings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConsoleWarnings", function() {
                return ConsoleWarnings;
            });
            var ConsoleWarnings = /** @class */ function() {
                function ConsoleWarnings() {}
                ConsoleWarnings.disposedObjectChangedProperty = function(propName, objType) {
                    ConsoleWarnings.warn('An attempt to set a property "' + propName + '" of a disposed object "' + objType + '"');
                };
                ConsoleWarnings.inCorrectQuestionValue = function(questionName, val1) {
                    var valStr = JSON.stringify(val1, null, 3);
                    ConsoleWarnings.warn("An attempt to assign an incorrect value" + valStr + ' to the following question: "' + questionName + '"');
                };
                ConsoleWarnings.warn = function(text) {
                    // eslint-disable-next-line no-console
                    console.warn(text);
                };
                ConsoleWarnings.error = function(text) {
                    // eslint-disable-next-line no-console
                    console.error(text);
                };
                return ConsoleWarnings;
            }();
        /***/ },
        /***/ "./src/defaultCss/cssmodern.ts": /*!*************************************!*\
  !*** ./src/defaultCss/cssmodern.ts ***!
  \*************************************/ /*! exports provided: modernCss */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modernCss", function() {
                return modernCss;
            });
            /* harmony import */ var _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./defaultV2Css */ "./src/defaultCss/defaultV2Css.ts");
            var modernCss = {
                root: "sv-root-modern",
                timerRoot: "sv-body__timer",
                container: "sv-container-modern",
                header: "sv-title sv-container-modern__title",
                headerClose: "sv-container-modern__close",
                bodyContainer: "sv-components-row",
                body: "sv-body",
                bodyEmpty: "sv-body sv-body--empty",
                footer: "sv-footer sv-body__footer sv-clearfix",
                title: "",
                description: "",
                logo: "sv-logo",
                logoImage: "sv-logo__image",
                headerText: "sv-header__text",
                navigationButton: "sv-btn sv-btn--navigation",
                completedPage: "sv-completedpage",
                navigation: {
                    complete: "sv-footer__complete-btn",
                    prev: "sv-footer__prev-btn",
                    next: "sv-footer__next-btn",
                    start: "sv-footer__start-btn",
                    preview: "sv-footer__preview-btn",
                    edit: "sv-footer__edit-btn"
                },
                panel: {
                    title: "sv-title sv-panel__title",
                    titleExpandable: "sv-panel__title--expandable",
                    titleExpanded: "sv-panel__title--expanded",
                    titleCollapsed: "sv-panel__title--collapsed",
                    titleOnError: "sv-panel__title--error",
                    description: "sv-description sv-panel__description",
                    container: "sv-panel sv-row__panel",
                    content: "sv-panel__content",
                    icon: "sv-panel__icon",
                    iconExpanded: "sv-panel__icon--expanded",
                    footer: "sv-panel__footer",
                    requiredText: "sv-panel__required-text",
                    number: "sv-question__num"
                },
                paneldynamic: {
                    root: "sv-paneldynamic",
                    navigation: "sv-paneldynamic__navigation",
                    title: "sv-title sv-question__title",
                    button: "sv-btn",
                    buttonRemove: "sv-paneldynamic__remove-btn",
                    buttonRemoveRight: "sv-paneldynamic__remove-btn--right",
                    buttonAdd: "sv-paneldynamic__add-btn",
                    progressTop: "sv-paneldynamic__progress sv-paneldynamic__progress--top",
                    progressBottom: "sv-paneldynamic__progress sv-paneldynamic__progress--bottom",
                    buttonPrev: "sv-paneldynamic__prev-btn",
                    buttonNext: "sv-paneldynamic__next-btn",
                    buttonPrevDisabled: "sv-paneldynamic__prev-btn--disabled",
                    buttonNextDisabled: "sv-paneldynamic__next-btn--disabled",
                    progressContainer: "sv-paneldynamic__progress-container",
                    progress: "sv-progress",
                    progressBar: "sv-progress__bar",
                    progressText: "sv-paneldynamic__progress-text",
                    separator: "sv-paneldynamic__separator",
                    panelWrapper: "sv-paneldynamic__panel-wrapper",
                    panelWrapperInRow: "sv-paneldynamic__panel-wrapper--in-row",
                    progressBtnIcon: "icon-progressbutton",
                    footer: ""
                },
                progress: "sv-progress sv-body__progress",
                progressBar: "sv-progress__bar",
                progressText: "sv-progress__text",
                progressTextInBar: "sv-hidden",
                progressButtonsContainerCenter: "sv_progress-buttons__container-center",
                progressButtonsContainer: "sv_progress-buttons__container",
                progressButtonsImageButtonLeft: "sv_progress-buttons__image-button-left",
                progressButtonsImageButtonRight: "sv_progress-buttons__image-button-right",
                progressButtonsImageButtonHidden: "sv_progress-buttons__image-button--hidden",
                progressButtonsListContainer: "sv_progress-buttons__list-container",
                progressButtonsList: "sv_progress-buttons__list",
                progressButtonsListElementPassed: "sv_progress-buttons__list-element--passed",
                progressButtonsListElementCurrent: "sv_progress-buttons__list-element--current",
                progressButtonsListElementNonClickable: "sv_progress-buttons__list-element--nonclickable",
                progressButtonsPageTitle: "sv_progress-buttons__page-title",
                progressButtonsPageDescription: "sv_progress-buttons__page-description",
                page: {
                    root: "sv-page sv-body__page",
                    title: "sv-title sv-page__title",
                    description: "sv-description sv-page__description"
                },
                pageTitle: "sv-title sv-page__title",
                pageDescription: "sv-description sv-page__description",
                row: "sv-row sv-clearfix",
                question: {
                    mainRoot: "sv-question sv-row__question",
                    flowRoot: "sv-question sv-row__question sv-row__question--flow",
                    asCell: "sv-table__cell",
                    header: "sv-question__header",
                    headerLeft: "sv-question__header--location--left",
                    headerTop: "sv-question__header--location--top",
                    headerBottom: "sv-question__header--location--bottom",
                    content: "sv-question__content",
                    contentLeft: "sv-question__content--left",
                    titleLeftRoot: "",
                    answered: "sv-question--answered",
                    titleOnAnswer: "sv-question__title--answer",
                    titleOnError: "sv-question__title--error",
                    title: "sv-title sv-question__title",
                    titleExpandable: "sv-question__title--expandable",
                    titleExpanded: "sv-question__title--expanded",
                    titleCollapsed: "sv-question__title--collapsed",
                    icon: "sv-question__icon",
                    iconExpanded: "sv-question__icon--expanded",
                    requiredText: "sv-question__required-text",
                    number: "sv-question__num",
                    description: "sv-description sv-question__description",
                    descriptionUnderInput: "sv-description sv-question__description",
                    comment: "sv-comment",
                    required: "sv-question--required",
                    titleRequired: "sv-question__title--required",
                    indent: 20,
                    footer: "sv-question__footer",
                    formGroup: "sv-question__form-group",
                    hasError: "",
                    disabled: "sv-question--disabled"
                },
                image: {
                    root: "sv-image",
                    image: "sv_image_image"
                },
                error: {
                    root: "sv-question__erbox",
                    icon: "",
                    item: "",
                    locationTop: "sv-question__erbox--location--top",
                    locationBottom: "sv-question__erbox--location--bottom"
                },
                checkbox: {
                    root: "sv-selectbase",
                    item: "sv-item sv-checkbox sv-selectbase__item",
                    itemSelectAll: "sv-checkbox--selectall",
                    itemNone: "sv-checkbox--none",
                    itemDisabled: "sv-item--disabled sv-checkbox--disabled",
                    itemChecked: "sv-checkbox--checked",
                    itemHover: "sv-checkbox--allowhover",
                    itemInline: "sv-selectbase__item--inline",
                    label: "sv-selectbase__label",
                    labelChecked: "",
                    itemControl: "sv-visuallyhidden sv-item__control",
                    itemDecorator: "sv-item__svg sv-checkbox__svg",
                    itemSvgIconId: "#icon-moderncheck",
                    controlLabel: "sv-item__control-label",
                    materialDecorator: "sv-item__decorator sv-selectbase__decorator sv-checkbox__decorator",
                    other: "sv-comment sv-question__other",
                    column: "sv-selectbase__column"
                },
                ranking: {
                    root: "sv-ranking",
                    rootMobileMod: "sv-ranking--mobile",
                    rootDragMod: "sv-ranking--drag",
                    rootDisabled: "sv-ranking--disabled",
                    rootDragHandleAreaIcon: "sv-ranking--drag-handle-area-icon",
                    rootSelectToRankMod: "sv-ranking--select-to-rank",
                    rootSelectToRankAlignVertical: "sv-ranking--select-to-rank-vertical",
                    rootSelectToRankAlignHorizontal: "sv-ranking--select-to-rank-horizontal",
                    item: "sv-ranking-item",
                    itemContent: "sv-ranking-item__content",
                    itemIndex: "sv-ranking-item__index",
                    itemIndexEmptyMode: "sv-ranking-item__index--empty",
                    // itemText: "sv-ranking-item__text",
                    controlLabel: "sv-ranking-item__text",
                    itemGhostNode: "sv-ranking-item__ghost",
                    itemIconContainer: "sv-ranking-item__icon-container",
                    itemIcon: "sv-ranking-item__icon",
                    itemIconHoverMod: "sv-ranking-item__icon--hover",
                    itemIconFocusMod: "sv-ranking-item__icon--focus",
                    itemGhostMod: "sv-ranking-item--ghost",
                    itemDragMod: "sv-ranking-item--drag",
                    container: "sv-ranking__container",
                    containerEmptyMode: "sv-ranking__container--empty",
                    containerFromMode: "sv-ranking__container--from",
                    containerToMode: "sv-ranking__container--to",
                    containerPlaceholder: "sv-ranking__container-placeholder",
                    containersDivider: "sv-ranking__containers-divider"
                },
                radiogroup: {
                    root: "sv-selectbase",
                    item: "sv-item sv-radio sv-selectbase__item",
                    itemInline: "sv-selectbase__item--inline",
                    label: "sv-selectbase__label",
                    labelChecked: "",
                    itemDisabled: "sv-item--disabled sv-radio--disabled",
                    itemChecked: "sv-radio--checked",
                    itemHover: "sv-radio--allowhover",
                    itemControl: "sv-visuallyhidden sv-item__control",
                    itemDecorator: "sv-item__svg sv-radio__svg",
                    itemSvgIconId: "#icon-modernradio",
                    controlLabel: "sv-item__control-label",
                    materialDecorator: "sv-item__decorator sv-selectbase__decorator sv-radio__decorator",
                    other: "sv-comment sv-question__other",
                    clearButton: "sv-btn sv-selectbase__clear-btn",
                    column: "sv-selectbase__column"
                },
                buttongroup: {
                    root: "sv-button-group",
                    item: "sv-button-group__item",
                    itemIcon: "sv-button-group__item-icon",
                    itemDecorator: "sv-button-group__item-decorator",
                    itemCaption: "sv-button-group__item-caption",
                    itemSelected: "sv-button-group__item--selected",
                    itemHover: "sv-button-group__item--hover",
                    itemDisabled: "sv-button-group__item--disabled",
                    itemControl: "sv-visuallyhidden"
                },
                boolean: {
                    root: "sv_qbln",
                    rootRadio: "sv_qbln",
                    small: "sv-row__question--small",
                    item: "sv-boolean sv-item",
                    control: "sv-visuallyhidden",
                    itemChecked: "sv-boolean--checked",
                    itemIndeterminate: "sv-boolean--indeterminate",
                    itemDisabled: "sv-item--disabled sv-boolean--disabled",
                    switch: "sv-boolean__switch",
                    slider: "sv-boolean__slider",
                    label: "sv-boolean__label",
                    disabledLabel: "sv-boolean__label--disabled",
                    sliderGhost: "sv-boolean__thumb-ghost",
                    //checkbox
                    rootCheckbox: "sv_qbln",
                    checkboxItem: "sv-boolean sv-item",
                    checkboxItemChecked: "sv-boolean--checked",
                    controlCheckbox: "sv-visuallyhidden",
                    checkboxControlLabel: "sv-boolean__label",
                    checkboxItemIndeterminate: "sv-boolean--indeterminate",
                    checkboxItemDisabled: "sv-item--disabled sv-boolean--disabled",
                    checkboxMaterialDecorator: "sv-item__decorator sv-boolean__decorator ",
                    checkboxItemDecorator: "sv-item__svg  sv-boolean__svg",
                    indeterminatePath: "sv-boolean__indeterminate-path",
                    svgIconCheckedId: "#icon-modernbooleancheckchecked",
                    svgIconUncheckedId: "#icon-modernbooleancheckunchecked",
                    svgIconIndId: "#icon-modernbooleancheckind"
                },
                text: {
                    root: "sv-text",
                    small: "sv-row__question--small",
                    remainingCharacterCounter: "sv-remaining-character-counter",
                    onError: "sv-text--error"
                },
                multipletext: {
                    root: "sv-multipletext",
                    item: "sv-multipletext__item",
                    itemLabel: "sv-multipletext__item-label",
                    itemTitle: "sv-multipletext__item-title",
                    row: "sv-multipletext__row",
                    cell: "sv-multipletext__cell"
                },
                dropdown: {
                    root: "",
                    popup: "sv-dropdown-popup",
                    small: "sv-row__question--small",
                    control: "sv-dropdown",
                    selectWrapper: "",
                    other: "sv-comment sv-question__other",
                    onError: "sv-dropdown--error",
                    cleanButton: "sv-dropdown_clean-button",
                    cleanButtonSvg: "sv-dropdown_clean-button-svg",
                    cleanButtonIconId: "icon-clear_16x16",
                    filterStringInput: "sv-dropdown__filter-string-input",
                    controlValue: "sv-dropdown__value",
                    controlInputFieldComponent: "sv_dropdown_control__input-field-component",
                    hintPrefix: "sv-dropdown__hint-prefix",
                    hintSuffix: "sv-dropdown__hint-suffix"
                },
                tagbox: {
                    root: "",
                    popup: "sv-dropdown-popup",
                    small: "sv-row__question--small",
                    selectWrapper: "sv_select_wrapper sv-tagbox_wrapper",
                    other: "sv-input sv-comment sv-selectbase__other",
                    cleanButton: "sv-tagbox_clean-button sv-dropdown_clean-button",
                    cleanButtonSvg: "sv-tagbox_clean-button-svg sv-dropdown_clean-button-svg",
                    cleanButtonIconId: "icon-clear_16x16",
                    cleanItemButton: "sv-tagbox__item_clean-button",
                    cleanItemButtonSvg: "sv-tagbox__item_clean-button-svg",
                    cleanItemButtonIconId: "icon-clear_16x16",
                    control: "sv-input sv-tagbox sv-dropdown",
                    controlValue: "sv-tagbox__value sv-dropdown__value",
                    controlEmpty: "sv-dropdown--empty sv-tagbox--empty",
                    placeholderInput: "sv-tagbox__placeholder",
                    filterStringInput: "sv-tagbox__filter-string-input sv-dropdown__filter-string-input"
                },
                imagepicker: {
                    root: "sv-selectbase sv-imagepicker",
                    column: "sv-selectbase__column",
                    item: "sv-imagepicker__item",
                    itemInline: "sv-imagepicker__item--inline",
                    itemChecked: "sv-imagepicker__item--checked",
                    itemDisabled: "sv-imagepicker__item--disabled",
                    itemHover: "sv-imagepicker__item--allowhover",
                    label: "sv-imagepicker__label",
                    itemControl: "sv-imagepicker__control sv-visuallyhidden",
                    image: "sv-imagepicker__image",
                    itemText: "sv-imagepicker__text",
                    clearButton: "sv-btn",
                    other: "sv-comment sv-question__other"
                },
                matrix: {
                    tableWrapper: "sv-matrix",
                    root: "sv-table sv-matrix-root",
                    rowError: "sv-matrix__row--error",
                    cell: "sv-table__cell sv-matrix__cell",
                    headerCell: "sv-table__cell sv-table__cell--header",
                    label: "sv-item sv-radio sv-matrix__label",
                    itemValue: "sv-visuallyhidden sv-item__control sv-radio__control",
                    itemChecked: "sv-radio--checked",
                    itemDisabled: "sv-item--disabled sv-radio--disabled",
                    itemHover: "sv-radio--allowhover",
                    materialDecorator: "sv-item__decorator sv-radio__decorator",
                    itemDecorator: "sv-item__svg sv-radio__svg",
                    cellText: "sv-matrix__text",
                    cellTextSelected: "sv-matrix__text--checked",
                    cellTextDisabled: "sv-matrix__text--disabled",
                    cellResponsiveTitle: "sv-matrix__cell-responsive-title",
                    itemSvgIconId: "#icon-modernradio"
                },
                matrixdropdown: {
                    root: "sv-table sv-matrixdropdown",
                    cell: "sv-table__cell",
                    headerCell: "sv-table__cell sv-table__cell--header",
                    row: "sv-table__row",
                    rowTextCell: "sv-table__cell--row-text",
                    rowAdditional: "sv-table__row--additional",
                    detailRow: "sv-table__row--detail",
                    detailRowText: "sv-table__cell--detail-rowtext",
                    detailCell: "sv-table__cell--detail",
                    choiceCell: "sv-table__cell--choice",
                    detailButton: "sv-table__cell--detail-button",
                    detailButtonExpanded: "sv-table__cell--detail-button--expanded",
                    detailIcon: "sv-detail-panel__icon",
                    detailIconExpanded: "sv-detail-panel__icon--expanded",
                    detailPanelCell: "sv-table__cell--detail-panel",
                    actionsCell: "sv-table__cell sv-table__cell--actions"
                },
                matrixdynamic: {
                    root: "sv-table sv-matrixdynamic",
                    cell: "sv-table__cell",
                    headerCell: "sv-table__cell sv-table__cell--header",
                    button: "sv-btn",
                    buttonAdd: "sv-matrixdynamic__add-btn",
                    buttonRemove: "sv-matrixdynamic__remove-btn",
                    iconAdd: "",
                    iconRemove: "",
                    iconDrag: "sv-matrixdynamic__drag-icon",
                    row: "sv-table__row",
                    detailRow: "sv-table__row--detail",
                    detailCell: "sv-table__cell--detail",
                    choiceCell: "sv-table__cell--choice",
                    detailButton: "sv-table__cell--detail-button",
                    detailButtonExpanded: "sv-table__cell--detail-button--expanded",
                    detailIcon: "sv-detail-panel__icon",
                    detailIconExpanded: "sv-detail-panel__icon--expanded",
                    detailPanelCell: "sv-table__cell--detail-panel",
                    actionsCell: "sv-table__cell sv-table__cell--actions",
                    emptyRowsSection: "sv-table__empty--rows--section",
                    emptyRowsText: "sv-table__empty--rows--text",
                    emptyRowsButton: "",
                    ghostRow: "sv-matrix-row--drag-drop-ghost-mod"
                },
                rating: {
                    root: "sv-rating",
                    item: "sv-rating__item",
                    selected: "sv-rating__item--selected",
                    minText: "sv-rating__min-text",
                    itemText: "sv-rating__item-text",
                    maxText: "sv-rating__max-text",
                    itemDisabled: "sv-rating--disabled",
                    filterStringInput: "sv-dropdown__filter-string-input",
                    control: "sv-dropdown",
                    cleanButton: "sv-dropdown_clean-button",
                    cleanButtonSvg: "sv-dropdown_clean-button-svg",
                    cleanButtonIconId: "icon-clear_16x16",
                    controlValue: "sv-dropdown__value",
                    controlInputFieldComponent: "sv_dropdown_control__input-field-component",
                    itemSmiley: "sv-rating__item-smiley",
                    itemStar: "sv-rating__item-star",
                    itemSmileySelected: "sv-rating__item-smiley--selected",
                    itemStarSelected: "sv-rating__item-star--selected"
                },
                comment: {
                    root: "sv-comment",
                    small: "sv-row__question--small",
                    remainingCharacterCounter: "sv-remaining-character-counter"
                },
                expression: "",
                file: {
                    root: "sv-file",
                    other: "sv-comment sv-question__other",
                    placeholderInput: "sv-visuallyhidden",
                    preview: "sv-file__preview",
                    fileSignBottom: "sv-file__sign",
                    fileDecorator: "sv-file__decorator",
                    fileInput: "sv-visuallyhidden",
                    noFileChosen: "sv-description sv-file__no-file-chosen",
                    chooseFile: "sv-btn sv-file__choose-btn",
                    controlDisabled: "sv-file__choose-btn--disabled",
                    removeButton: "sv-hidden",
                    removeButtonBottom: "sv-btn sv-file__clean-btn",
                    removeFile: "sv-hidden",
                    removeFileSvg: "sv-file__remove-svg",
                    removeFileSvgIconId: "icon-removefile",
                    wrapper: "sv-file__wrapper",
                    dragAreaPlaceholder: "sv-hidden",
                    fileList: ""
                },
                signaturepad: {
                    root: "sv-signaturepad sjs_sp_container",
                    small: "sv-row__question--small",
                    controls: "sjs_sp_controls",
                    placeholder: "sjs_sp_placeholder",
                    canvas: "sjs_sp_canvas",
                    backgroundImage: "sjs_sp__background-image",
                    clearButton: "sjs_sp_clear"
                },
                saveData: {
                    root: "sv-save-data_root",
                    rootWithButtons: "sv-save-data_root--with-buttons",
                    info: "sv-save-data_info",
                    error: "sv-save-data_error",
                    success: "sv-save-data_success",
                    button: "sv-save-data_button",
                    shown: "sv-save-data_root--shown"
                },
                window: {
                    root: "sv_window",
                    rootCollapsedMod: "sv_window--collapsed",
                    rootFullScreenMode: "sv_window--full-screen",
                    rootContent: "sv_window_root-content",
                    body: "sv_window_content",
                    header: {
                        root: "sv_window_header",
                        titleCollapsed: "sv_window_header_title_collapsed",
                        buttonsContainer: "sv_window_buttons_container",
                        button: "sv_window_button",
                        buttonExpanded: "",
                        buttonCollapsed: "",
                        collapseButton: "sv_window_button sv_window_button_collapse",
                        closeButton: "sv_window_button sv_window_button_close",
                        fullScreenButton: "sv_window_button sv_window_button_full_screen"
                    }
                },
                variables: {
                    mobileWidth: "--sv-mobile-width",
                    themeMark: "--sv-modern-mark"
                }
            };
            _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"]["modern"] = modernCss;
        /***/ },
        /***/ "./src/defaultCss/cssstandard.ts": /*!***************************************!*\
  !*** ./src/defaultCss/cssstandard.ts ***!
  \***************************************/ /*! exports provided: defaultStandardCss */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultStandardCss", function() {
                return defaultStandardCss;
            });
            /* harmony import */ var _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./defaultV2Css */ "./src/defaultCss/defaultV2Css.ts");
            var defaultStandardCss = {
                root: "sv_main sv_default_css",
                container: "sv_container",
                header: "sv_header",
                bodyContainer: "sv-components-row",
                body: "sv_body",
                bodyEmpty: "sv_body sv_body_empty",
                footer: "sv_nav",
                title: "",
                description: "",
                logo: "sv_logo",
                logoImage: "sv_logo__image",
                headerText: "sv_header__text",
                navigationButton: "sv_nav_btn",
                completedPage: "sv_completed_page",
                navigation: {
                    complete: "sv_complete_btn",
                    prev: "sv_prev_btn",
                    next: "sv_next_btn",
                    start: "sv_start_btn",
                    preview: "sv_preview_btn",
                    edit: "sv_edit_btn"
                },
                progress: "sv_progress",
                progressBar: "sv_progress_bar",
                progressTextInBar: "sv-hidden",
                progressButtonsContainerCenter: "sv_progress-buttons__container-center",
                progressButtonsContainer: "sv_progress-buttons__container",
                progressButtonsImageButtonLeft: "sv_progress-buttons__image-button-left",
                progressButtonsImageButtonRight: "sv_progress-buttons__image-button-right",
                progressButtonsImageButtonHidden: "sv_progress-buttons__image-button--hidden",
                progressButtonsListContainer: "sv_progress-buttons__list-container",
                progressButtonsList: "sv_progress-buttons__list",
                progressButtonsListElementPassed: "sv_progress-buttons__list-element--passed",
                progressButtonsListElementCurrent: "sv_progress-buttons__list-element--current",
                progressButtonsListElementNonClickable: "sv_progress-buttons__list-element--nonclickable",
                progressButtonsPageTitle: "sv_progress-buttons__page-title",
                progressButtonsPageDescription: "sv_progress-buttons__page-description",
                page: {
                    root: "sv_p_root",
                    title: "sv_page_title",
                    description: ""
                },
                // TODO: move to the page object
                pageTitle: "sv_page_title",
                pageDescription: "",
                row: "sv_row",
                question: {
                    mainRoot: "sv_q sv_qstn",
                    flowRoot: "sv_q_flow sv_qstn",
                    header: "",
                    headerLeft: "title-left",
                    content: "",
                    contentLeft: "content-left",
                    titleLeftRoot: "sv_qstn_left",
                    requiredText: "sv_q_required_text",
                    title: "sv_q_title",
                    titleExpandable: "sv_q_title_expandable",
                    titleExpanded: "sv_q_title_expanded",
                    titleCollapsed: "sv_q_title_collapsed",
                    number: "sv_q_num",
                    description: "sv_q_description",
                    comment: "",
                    required: "",
                    titleRequired: "",
                    hasError: "",
                    indent: 20,
                    footer: "sv_q_footer",
                    formGroup: "form-group",
                    asCell: "sv_matrix_cell",
                    icon: "sv_question_icon",
                    iconExpanded: "sv_expanded",
                    disabled: "sv_q--disabled"
                },
                panel: {
                    title: "sv_p_title",
                    titleExpandable: "sv_p_title_expandable",
                    titleExpanded: "sv_p_title_expanded",
                    titleCollapsed: "sv_p_title_collapsed",
                    titleOnError: "",
                    icon: "sv_panel_icon",
                    iconExpanded: "sv_expanded",
                    description: "sv_p_description",
                    container: "sv_p_container",
                    footer: "sv_p_footer",
                    number: "sv_q_num",
                    requiredText: "sv_q_required_text"
                },
                error: {
                    root: "sv_q_erbox",
                    icon: "",
                    item: "",
                    locationTop: "sv_qstn_error_top",
                    locationBottom: "sv_qstn_error_bottom"
                },
                boolean: {
                    root: "sv_qcbc sv_qbln",
                    rootRadio: "sv_qcbc sv_qbln",
                    item: "sv-boolean",
                    control: "sv-visuallyhidden",
                    itemChecked: "sv-boolean--checked checked",
                    itemIndeterminate: "sv-boolean--indeterminate",
                    itemDisabled: "sv-boolean--disabled",
                    switch: "sv-boolean__switch",
                    slider: "sv-boolean__slider",
                    label: "sv-boolean__label ",
                    disabledLabel: "sv-boolean__label--disabled",
                    sliderGhost: "sv-boolean__thumb-ghost",
                    //checkbox
                    rootCheckbox: "sv_qcbc sv_qbln",
                    checkboxItem: "sv-boolean",
                    checkboxItemChecked: "sv-boolean--checked",
                    controlCheckbox: "sv-visuallyvisible",
                    checkboxControlLabel: "sv-boolean__label",
                    checkboxItemIndeterminate: "sv-boolean--indeterminate",
                    checkboxItemDisabled: "sv-item--disabled sv-boolean--disabled",
                    checkboxMaterialDecorator: "sv-item__decorator sv-boolean__decorator",
                    checkboxItemDecorator: "sv-item__svg sv-boolean__svg"
                },
                checkbox: {
                    root: "sv_qcbc sv_qcbx",
                    item: "sv_q_checkbox",
                    itemSelectAll: "sv_q_checkbox_selectall",
                    itemNone: "sv_q_checkbox_none",
                    itemChecked: "checked",
                    itemInline: "sv_q_checkbox_inline",
                    label: "sv_q_checkbox_label",
                    labelChecked: "",
                    itemControl: "sv_q_checkbox_control_item",
                    itemDecorator: "sv-hidden",
                    controlLabel: "sv_q_checkbox_control_label",
                    other: "sv_q_other sv_q_checkbox_other",
                    column: "sv_q_select_column"
                },
                ranking: {
                    root: "sv-ranking",
                    rootMobileMod: "sv-ranking--mobile",
                    rootDragMod: "sv-ranking--drag",
                    rootDisabled: "sv-ranking--disabled",
                    rootDragHandleAreaIcon: "sv-ranking--drag-handle-area-icon",
                    rootSelectToRankMod: "sv-ranking--select-to-rank",
                    rootSelectToRankAlignVertical: "sv-ranking--select-to-rank-vertical",
                    rootSelectToRankAlignHorizontal: "sv-ranking--select-to-rank-horizontal",
                    item: "sv-ranking-item",
                    itemContent: "sv-ranking-item__content",
                    itemIndex: "sv-ranking-item__index",
                    itemIndexEmptyMode: "sv-ranking-item__index--empty",
                    // itemText: "sv-ranking-item__text",
                    controlLabel: "sv-ranking-item__text",
                    itemGhostNode: "sv-ranking-item__ghost",
                    itemIconContainer: "sv-ranking-item__icon-container",
                    itemIcon: "sv-ranking-item__icon",
                    itemIconHoverMod: "sv-ranking-item__icon--hover",
                    itemIconFocusMod: "sv-ranking-item__icon--focus",
                    itemGhostMod: "sv-ranking-item--ghost",
                    itemDragMod: "sv-ranking-item--drag",
                    container: "sv-ranking__container",
                    containerEmptyMode: "sv-ranking__container--empty",
                    containerFromMode: "sv-ranking__container--from",
                    containerToMode: "sv-ranking__container--to",
                    containerPlaceholder: "sv-ranking__container-placeholder",
                    containersDivider: "sv-ranking__containers-divider"
                },
                comment: {
                    remainingCharacterCounter: "sv-remaining-character-counter"
                },
                dropdown: {
                    root: "",
                    popup: "sv-dropdown-popup",
                    control: "sv_q_dropdown_control",
                    controlInputFieldComponent: "sv_q_dropdown_control__input-field-component",
                    selectWrapper: "sv_select_wrapper",
                    other: "sv_q_dd_other",
                    cleanButton: "sv_q_dropdown_clean-button",
                    cleanButtonSvg: "sv_q_dropdown_clean-button-svg",
                    cleanButtonIconId: "icon-clear_16x16",
                    controlValue: "sv_q_dropdown__value",
                    filterStringInput: "sv_q_dropdown__filter-string-input",
                    hintPrefix: "sv_q_dropdown__hint-prefix",
                    hintSuffix: "sv_q_dropdown__hint-suffix"
                },
                html: {
                    root: ""
                },
                image: {
                    root: "sv_q_image",
                    image: "sv_image_image",
                    noImage: "sv-image__no-image",
                    noImageSvgIconId: "icon-no-image"
                },
                matrix: {
                    root: "sv_q_matrix",
                    label: "sv_q_m_label",
                    itemChecked: "checked",
                    itemDecorator: "sv-hidden",
                    cell: "sv_q_m_cell",
                    cellText: "sv_q_m_cell_text",
                    cellTextSelected: "sv_q_m_cell_selected",
                    cellLabel: "sv_q_m_cell_label",
                    cellResponsiveTitle: "sv_q_m_cell_responsive_title"
                },
                matrixdropdown: {
                    root: "sv_q_matrix_dropdown",
                    cell: "sv_matrix_cell",
                    headerCell: "sv_matrix_cell_header",
                    row: "sv_matrix_row",
                    rowAdditional: "sv-matrix__row--additional",
                    rowTextCell: "sv-table__cell--row-text",
                    detailRow: "sv_matrix_detail_row",
                    detailRowText: "sv_matrix_cell_detail_rowtext",
                    detailCell: "sv_matrix_cell_detail",
                    choiceCell: "sv-table__cell--choice",
                    detailButton: "sv_matrix_cell_detail_button",
                    detailButtonExpanded: "sv_matrix_cell_detail_button_expanded",
                    detailIcon: "sv_detail_panel_icon",
                    detailIconExpanded: "sv_detail_expanded",
                    detailPanelCell: "sv_matrix_cell_detail_panel",
                    actionsCell: "sv_matrix_cell sv_matrix_cell_actions"
                },
                matrixdynamic: {
                    root: "sv_q_matrix_dynamic",
                    button: "sv_matrix_dynamic_button",
                    buttonAdd: "",
                    buttonRemove: "",
                    iconAdd: "",
                    iconRemove: "",
                    iconDrag: "sv-matrixdynamic__drag-icon",
                    cell: "sv_matrix_cell",
                    headerCell: "sv_matrix_cell_header",
                    row: "sv_matrix_row",
                    detailRow: "sv_matrix_detail_row",
                    detailCell: "sv_matrix_cell_detail",
                    choiceCell: "sv-table__cell--choice",
                    detailButton: "sv_matrix_cell_detail_button",
                    detailButtonExpanded: "sv_matrix_cell_detail_button_expanded",
                    detailIcon: "sv_detail_panel_icon",
                    detailIconExpanded: "sv_detail_expanded",
                    detailPanelCell: "sv_matrix_cell_detail_panel",
                    actionsCell: "sv_matrix_cell sv_matrix_cell_actions",
                    emptyRowsSection: "sv_matrix_empty_rows_section",
                    emptyRowsText: "sv_matrix_empty_rows_text",
                    emptyRowsButton: "",
                    ghostRow: "sv-matrix-row--drag-drop-ghost-mod"
                },
                paneldynamic: {
                    root: "sv_panel_dynamic",
                    title: "sv_p_title",
                    header: "sv-paneldynamic__header sv_header",
                    headerTab: "sv-paneldynamic__header-tab",
                    button: "",
                    buttonAdd: "sv-paneldynamic__add-btn",
                    buttonRemove: "sv_p_remove_btn",
                    buttonRemoveRight: "sv_p_remove_btn_right",
                    buttonPrev: "sv-paneldynamic__prev-btn",
                    buttonPrevDisabled: "sv-paneldynamic__prev-btn--disabled",
                    buttonNextDisabled: "sv-paneldynamic__next-btn--disabled",
                    buttonNext: "sv-paneldynamic__next-btn",
                    progressContainer: "sv-paneldynamic__progress-container",
                    progress: "sv-progress",
                    progressBar: "sv-progress__bar",
                    progressText: "sv-paneldynamic__progress-text",
                    panelWrapper: "sv_p_wrapper",
                    panelWrapperInRow: "sv_p_wrapper_in_row",
                    footer: "",
                    progressBtnIcon: "icon-progressbutton"
                },
                multipletext: {
                    root: "sv_q_mt",
                    itemTitle: "sv_q_mt_title",
                    item: "sv_q_mt_item",
                    row: "sv_q_mt_row",
                    itemLabel: "sv_q_mt_label",
                    itemValue: "sv_q_mt_item_value sv_q_text_root"
                },
                radiogroup: {
                    root: "sv_qcbc",
                    item: "sv_q_radiogroup",
                    itemChecked: "checked",
                    itemInline: "sv_q_radiogroup_inline",
                    itemDecorator: "sv-hidden",
                    label: "sv_q_radiogroup_label",
                    labelChecked: "",
                    itemControl: "sv_q_radiogroup_control_item",
                    controlLabel: "",
                    other: "sv_q_other sv_q_radiogroup_other",
                    clearButton: "sv_q_radiogroup_clear",
                    column: "sv_q_select_column"
                },
                buttongroup: {
                    root: "sv-button-group",
                    item: "sv-button-group__item",
                    itemIcon: "sv-button-group__item-icon",
                    itemDecorator: "sv-button-group__item-decorator",
                    itemCaption: "sv-button-group__item-caption",
                    itemHover: "sv-button-group__item--hover",
                    itemSelected: "sv-button-group__item--selected",
                    itemDisabled: "sv-button-group__item--disabled",
                    itemControl: "sv-visuallyhidden"
                },
                imagepicker: {
                    root: "sv_imgsel",
                    item: "sv_q_imgsel",
                    itemChecked: "checked",
                    label: "sv_q_imgsel_label",
                    itemControl: "sv_q_imgsel_control_item",
                    image: "sv_q_imgsel_image",
                    itemInline: "sv_q_imagepicker_inline",
                    itemText: "sv_q_imgsel_text",
                    clearButton: "sv_q_radiogroup_clear",
                    column: "sv_q_select_column",
                    itemNoImage: "sv_q_imgsel__no-image",
                    itemNoImageSvgIcon: "sv_q_imgsel__no-image-svg",
                    itemNoImageSvgIconId: "icon-no-image"
                },
                rating: {
                    root: "sv_q_rating",
                    item: "sv_q_rating_item",
                    itemFixedSize: "sv_q_rating_item_fixed",
                    selected: "active",
                    minText: "sv_q_rating_min_text",
                    itemText: "sv_q_rating_item_text",
                    maxText: "sv_q_rating_max_text",
                    itemStar: "sv_q_rating__item-star",
                    itemStarSelected: "sv_q_rating__item-star--selected",
                    itemSmiley: "sv_q_rating__item-smiley",
                    itemSmileySelected: "sv_q_rating__item-smiley--selected"
                },
                text: {
                    root: "sv_q_text_root",
                    remainingCharacterCounter: "sv-remaining-character-counter"
                },
                expression: "",
                file: {
                    root: "sv_q_file",
                    placeholderInput: "sv-visuallyhidden",
                    preview: "sv_q_file_preview",
                    removeButton: "sv_q_file_remove_button",
                    fileInput: "sv-visuallyhidden",
                    removeFile: "sv_q_file_remove",
                    fileDecorator: "sv-file__decorator",
                    fileSign: "sv_q_file_sign",
                    chooseFile: "sv_q_file_choose_button",
                    noFileChosen: "sv_q_file_placeholder",
                    dragAreaPlaceholder: "sv-hidden",
                    fileList: ""
                },
                signaturepad: {
                    root: "sv_q_signaturepad sjs_sp_container",
                    controls: "sjs_sp_controls",
                    placeholder: "sjs_sp_placeholder",
                    canvas: "sjs_sp_canvas",
                    backgroundImage: "sjs_sp__background-image",
                    clearButton: "sjs_sp_clear"
                },
                saveData: {
                    root: "sv-save-data_root",
                    rootWithButtons: "sv-save-data_root--with-buttons",
                    info: "sv-save-data_info",
                    error: "sv-save-data_error",
                    success: "sv-save-data_success",
                    button: "sv-save-data_button",
                    shown: "sv-save-data_root--shown"
                },
                window: {
                    root: "sv_window",
                    rootCollapsedMod: "sv_window--collapsed",
                    rootFullScreenMode: "sv_window--full-screen",
                    rootContent: "sv_window_root-content",
                    body: "sv_window_content",
                    header: {
                        root: "sv_window_header",
                        titleCollapsed: "sv_window_header_title_collapsed",
                        buttonsContainer: "sv_window_buttons_container",
                        button: "sv_window_button",
                        buttonExpanded: "",
                        buttonCollapsed: "",
                        collapseButton: "sv_window_button sv_window_button_collapse",
                        closeButton: "sv_window_button sv_window_button_close",
                        fullScreenButton: "sv_window_button sv_window_button_full_screen"
                    }
                },
                variables: {
                    mobileWidth: "--sv-mobile-width",
                    themeMark: "--sv-default-mark"
                },
                tagbox: {
                    root: "",
                    popup: "sv-dropdown-popup",
                    small: "sv_q_row__question--small",
                    selectWrapper: "sv_select_wrapper sv_q_tagbox_wrapper",
                    other: "sv_q_input sv_q_comment sv_q_selectbase__other",
                    cleanButton: "sv_q_tagbox_clean-button sv_q_dropdown_clean-button",
                    cleanButtonSvg: "sv_q_tagbox_clean-button-svg sv_q_dropdown_clean-button-svg",
                    cleanButtonIconId: "icon-clear_16x16",
                    cleanItemButton: "sv_q_tagbox-item_clean-button",
                    cleanItemButtonSvg: "sv_q_tagbox-item_clean-button-svg",
                    cleanItemButtonIconId: "icon-clear_16x16",
                    control: "sv_q_input sv_q_tagbox sv_q_dropdown_control",
                    controlValue: "sv_q_tagbox__value sv_q_dropdown__value",
                    controlEmpty: "sv_q_dropdown--empty sv_q_tagbox--empty",
                    placeholderInput: "sv_q_tagbox__placeholder",
                    filterStringInput: "sv_q_tagbox__filter-string-input sv_q_dropdown__filter-string-input",
                    hint: "sv_q_tagbox__hint",
                    hintPrefix: "sv_q_dropdown__hint-prefix sv_q_tagbox__hint-prefix",
                    hintSuffix: "sv_q_dropdown__hint-suffix sv_q_tagbox__hint-suffix",
                    hintSuffixWrapper: "sv_q_tagbox__hint-suffix-wrapper"
                }
            };
            _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"]["default"] = defaultStandardCss;
            _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"]["orange"] = defaultStandardCss;
            _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"]["darkblue"] = defaultStandardCss;
            _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"]["darkrose"] = defaultStandardCss;
            _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"]["stone"] = defaultStandardCss;
            _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"]["winter"] = defaultStandardCss;
            _defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"]["winterstone"] = defaultStandardCss;
        /***/ },
        /***/ "./src/defaultCss/defaultV2Css.ts": /*!****************************************!*\
  !*** ./src/defaultCss/defaultV2Css.ts ***!
  \****************************************/ /*! exports provided: surveyCss, defaultV2Css, defaultV2ThemeName */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "surveyCss", function() {
                return surveyCss;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultV2Css", function() {
                return defaultV2Css;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultV2ThemeName", function() {
                return defaultV2ThemeName;
            });
            var surveyCss = {
                currentType: "",
                getCss: function() {
                    var loc = this.currentType ? this[this.currentType] : defaultV2Css;
                    if (!loc) loc = defaultV2Css;
                    return loc;
                },
                getAvailableThemes: function() {
                    return Object.keys(this).filter(function(propertyName) {
                        return [
                            "currentType",
                            "getCss",
                            "getAvailableThemes"
                        ].indexOf(propertyName) === -1;
                    });
                }
            };
            var defaultV2Css = {
                root: "sd-root-modern",
                rootMobile: "sd-root-modern--mobile",
                rootAnimationDisabled: "sd-root-modern--animation-disabled",
                rootReadOnly: "sd-root--readonly",
                rootCompact: "sd-root--compact",
                rootFitToContainer: "sd-root-modern--full-container",
                rootWrapper: "sd-root-modern__wrapper",
                rootWrapperFixed: "sd-root-modern__wrapper--fixed",
                rootBackgroundImage: "sd-root_background-image",
                container: "sd-container-modern",
                header: "sd-title sd-container-modern__title",
                bodyContainer: "sv-components-row",
                body: "sd-body",
                bodyWithTimer: "sd-body--with-timer",
                clockTimerRoot: "sd-timer",
                clockTimerRootTop: "sd-timer--top",
                clockTimerRootBottom: "sd-timer--bottom",
                clockTimerProgress: "sd-timer__progress",
                clockTimerProgressAnimation: "sd-timer__progress--animation",
                clockTimerTextContainer: "sd-timer__text-container",
                clockTimerMinorText: "sd-timer__text--minor",
                clockTimerMajorText: "sd-timer__text--major",
                bodyEmpty: "sd-body sd-body--empty",
                bodyLoading: "sd-body--loading",
                footer: "sd-footer sd-body__navigation sd-clearfix",
                title: "sd-title",
                description: "sd-description",
                logo: "sd-logo",
                logoImage: "sd-logo__image",
                headerText: "sd-header__text",
                headerClose: "sd-hidden",
                navigationButton: "",
                bodyNavigationButton: "sd-btn",
                completedPage: "sd-completedpage",
                completedBeforePage: "sd-completed-before-page",
                timerRoot: "sd-body__timer",
                navigation: {
                    complete: "sd-btn--action sd-navigation__complete-btn",
                    prev: "sd-navigation__prev-btn",
                    next: "sd-navigation__next-btn",
                    start: "sd-navigation__start-btn",
                    preview: "sd-navigation__preview-btn",
                    edit: "sd-btn sd-btn--small"
                },
                panel: {
                    contentFadeIn: "sd-element__content--fade-in",
                    contentFadeOut: "sd-element__content--fade-out",
                    fadeIn: "sd-element-wrapper--fade-in",
                    fadeOut: "sd-element-wrapper--fade-out",
                    asPage: "sd-panel--as-page",
                    number: "sd-element__num",
                    title: "sd-title sd-element__title sd-panel__title",
                    titleExpandable: "sd-element__title--expandable",
                    titleNumInline: "sd-element__title--num-inline",
                    titleExpanded: "sd-element__title--expanded",
                    titleCollapsed: "sd-element__title--collapsed",
                    titleDisabled: "sd-element__title--disabled",
                    titleOnExpand: "sd-panel__title--expanded",
                    titleOnError: "sd-panel__title--error",
                    titleBar: "sd-action-title-bar",
                    description: "sd-description sd-panel__description",
                    container: "sd-element sd-element--complex sd-panel sd-row__panel",
                    withFrame: "sd-element--with-frame",
                    content: "sd-element__content sd-panel__content",
                    icon: "sd-panel__icon",
                    iconExpanded: "sd-panel__icon--expanded",
                    footer: "sd-panel__footer",
                    requiredText: "sd-panel__required-text",
                    header: "sd-panel__header sd-element__header sd-element__header--location-top",
                    collapsed: "sd-element--collapsed",
                    expanded: "sd-element--expanded",
                    expandable: "sd-element--expandable",
                    expandableAnimating: "sd-elemenet--expandable--animating",
                    nested: "sd-element--nested sd-element--nested-with-borders",
                    invisible: "sd-element--invisible",
                    navigationButton: "",
                    compact: "sd-element--with-frame sd-element--compact",
                    errorsContainer: "sd-panel__errbox sd-element__erbox sd-element__erbox--above-element"
                },
                paneldynamic: {
                    mainRoot: "sd-element  sd-question sd-question--paneldynamic sd-element--complex sd-question--complex sd-row__question",
                    empty: "sd-question--empty",
                    root: "sd-paneldynamic",
                    iconRemove: "sd-hidden",
                    navigation: "sd-paneldynamic__navigation",
                    title: "sd-title sd-element__title sd-question__title",
                    header: "sd-paneldynamic__header sd-element__header",
                    headerTab: "sd-paneldynamic__header-tab",
                    button: "sd-action sd-paneldynamic__btn",
                    buttonRemove: "sd-action--negative sd-paneldynamic__remove-btn",
                    buttonAdd: "sd-paneldynamic__add-btn",
                    buttonPrev: "sd-paneldynamic__prev-btn sd-action--icon sd-action",
                    buttonPrevDisabled: "sd-action--disabled",
                    buttonNextDisabled: "sd-action--disabled",
                    buttonNext: "sd-paneldynamic__next-btn sd-action--icon sd-action",
                    progressContainer: "sd-paneldynamic__progress-container",
                    progress: "sd-progress",
                    progressBar: "sd-progress__bar",
                    nested: "sd-element--nested sd-element--nested-with-borders",
                    progressText: "sd-paneldynamic__progress-text",
                    separator: "sd-paneldynamic__separator",
                    panelWrapper: "sd-paneldynamic__panel-wrapper",
                    footer: "sd-paneldynamic__footer",
                    panelFooter: "sd-paneldynamic__panel-footer",
                    footerButtonsContainer: "sd-paneldynamic__buttons-container",
                    panelWrapperInRow: "sd-paneldynamic__panel-wrapper--in-row",
                    progressBtnIcon: "icon-progressbuttonv2",
                    noEntriesPlaceholder: "sd-paneldynamic__placeholder sd-question__placeholder",
                    compact: "sd-element--with-frame sd-element--compact",
                    tabsRoot: "sd-tabs-toolbar",
                    tabsLeft: "sd-tabs-toolbar--left",
                    tabsRight: "sd-tabs-toolbar--right",
                    tabsCenter: "sd-tabs-toolbar--center",
                    tabs: {
                        item: "sd-tab-item",
                        itemPressed: "sd-tab-item--pressed",
                        itemAsIcon: "sd-tab-item--icon",
                        itemIcon: "sd-tab-item__icon",
                        itemTitle: "sd-tab-item__title"
                    }
                },
                progress: "sd-progress sd-body__progress",
                progressTop: "sd-body__progress--top",
                progressBottom: "sd-body__progress--bottom",
                progressBar: "sd-progress__bar",
                progressText: "sd-progress__text",
                progressButtonsRoot: "sd-progress-buttons",
                progressButtonsNumbered: "sd-progress-buttons--numbered",
                progressButtonsFitSurveyWidth: "sd-progress-buttons--fit-survey-width",
                progressButtonsContainerCenter: "sd-progress-buttons__container-center",
                progressButtonsContainer: "sd-progress-buttons__container",
                progressButtonsConnector: "sd-progress-buttons__connector",
                progressButtonsButton: "sd-progress-buttons__button",
                progressButtonsButtonBackground: "sd-progress-buttons__button-background",
                progressButtonsButtonContent: "sd-progress-buttons__button-content",
                progressButtonsHeader: "sd-progress-buttons__header",
                progressButtonsFooter: "sd-progress-buttons__footer",
                progressButtonsImageButtonLeft: "sd-progress-buttons__image-button-left",
                progressButtonsImageButtonRight: "sd-progress-buttons__image-button-right",
                progressButtonsImageButtonHidden: "sd-progress-buttons__image-button--hidden",
                progressButtonsListContainer: "sd-progress-buttons__list-container",
                progressButtonsList: "sd-progress-buttons__list",
                progressButtonsListElementPassed: "sd-progress-buttons__list-element--passed",
                progressButtonsListElementCurrent: "sd-progress-buttons__list-element--current",
                progressButtonsListElementNonClickable: "sd-progress-buttons__list-element--nonclickable",
                progressButtonsPageTitle: "sd-progress-buttons__page-title",
                progressButtonsPageDescription: "sd-progress-buttons__page-description",
                progressTextInBar: "sd-hidden",
                page: {
                    root: "sd-page sd-body__page",
                    emptyHeaderRoot: "sd-page__empty-header",
                    title: "sd-title sd-page__title",
                    description: "sd-description sd-page__description",
                    errorsContainer: "sd-page__errbox"
                },
                pageTitle: "sd-title sd-page__title",
                pageDescription: "sd-description sd-page__description",
                row: "sd-row sd-clearfix",
                rowMultiple: "sd-row--multiple",
                rowCompact: "sd-row--compact",
                rowFadeIn: "sd-row--fade-in",
                rowFadeOut: "sd-row--fade-out",
                pageRow: "sd-page__row",
                question: {
                    contentFadeIn: "sd-element__content--fade-in",
                    contentFadeOut: "sd-element__content--fade-out",
                    fadeIn: "sd-element-wrapper--fade-in",
                    fadeOut: "sd-element-wrapper--fade-out",
                    mainRoot: "sd-element sd-question sd-row__question",
                    flowRoot: "sd-element sd-question sd-row__question sd-row__question--flow",
                    withFrame: "sd-element--with-frame",
                    asCell: "sd-table__cell",
                    answered: "sd-question--answered",
                    header: "sd-question__header sd-element__header",
                    headerLeft: "sd-question__header--location--left",
                    headerTop: "sd-question__header--location-top sd-element__header--location-top",
                    headerBottom: "sd-question__header--location--bottom",
                    content: "sd-element__content sd-question__content",
                    contentSupportContainerQueries: "sd-question__content--support-container-queries",
                    contentLeft: "sd-question__content--left",
                    titleNumInline: "sd-element__title--num-inline",
                    titleLeftRoot: "sd-question--left",
                    titleTopRoot: "sd-question--title-top",
                    descriptionUnderInputRoot: "sd-question--description-under-input",
                    titleBottomRoot: "sd-question--title-bottom",
                    titleOnAnswer: "sd-question__title--answer",
                    titleEmpty: "sd-question__title--empty",
                    titleOnError: "sd-question__title--error",
                    title: "sd-title sd-element__title sd-question__title",
                    titleExpandable: "sd-element__title--expandable",
                    titleExpanded: "sd-element__title--expanded",
                    titleCollapsed: "sd-element__title--collapsed",
                    titleDisabled: "sd-element__title--disabled",
                    titleBar: "sd-action-title-bar",
                    requiredText: "sd-question__required-text",
                    number: "sd-element__num",
                    description: "sd-description sd-question__description",
                    descriptionUnderInput: "sd-description sd-question__description sd-question__description--under-input",
                    comment: "sd-input sd-comment",
                    other: "sd-input sd-comment",
                    required: "sd-question--required",
                    titleRequired: "sd-question__title--required",
                    indent: 20,
                    footer: "sd-question__footer",
                    commentArea: "sd-question__comment-area",
                    formGroup: "sd-question__form-group",
                    hasError: "sd-question--error",
                    hasErrorTop: "sd-question--error-top",
                    hasErrorBottom: "sd-question--error-bottom",
                    collapsed: "sd-element--collapsed",
                    expandable: "sd-element--expandable",
                    expandableAnimating: "sd-elemenet--expandable--animating",
                    expanded: "sd-element--expanded",
                    nested: "sd-element--nested",
                    invisible: "sd-element--invisible",
                    composite: "sd-element--complex sd-composite",
                    disabled: "sd-question--disabled",
                    errorsContainer: "sd-element__erbox sd-question__erbox",
                    errorsContainerTop: "sd-element__erbox--above-element sd-question__erbox--above-question",
                    errorsContainerBottom: "sd-question__erbox--below-question"
                },
                image: {
                    mainRoot: "sd-question sd-question--image",
                    root: "sd-image",
                    image: "sd-image__image",
                    adaptive: "sd-image__image--adaptive",
                    noImage: "sd-image__no-image",
                    noImageSvgIconId: "icon-no-image",
                    withFrame: ""
                },
                html: {
                    mainRoot: "sd-question sd-row__question sd-question--html",
                    root: "sd-html",
                    withFrame: "",
                    nested: "sd-element--nested sd-html--nested"
                },
                error: {
                    root: "sd-error",
                    icon: "",
                    item: "",
                    locationTop: "",
                    locationBottom: ""
                },
                checkbox: {
                    root: "sd-selectbase",
                    rootMobile: "sd-selectbase--mobile",
                    rootRow: "sd-selectbase--row",
                    rootMultiColumn: "sd-selectbase--multi-column",
                    item: "sd-item sd-checkbox sd-selectbase__item",
                    itemOnError: "sd-item--error",
                    itemSelectAll: "sd-checkbox--selectall",
                    itemNone: "sd-checkbox--none",
                    itemDisabled: "sd-item--disabled sd-checkbox--disabled",
                    itemChecked: "sd-item--checked sd-checkbox--checked",
                    itemHover: "sd-item--allowhover sd-checkbox--allowhover",
                    itemInline: "sd-selectbase__item--inline",
                    label: "sd-selectbase__label",
                    labelChecked: "",
                    itemControl: "sd-visuallyhidden sd-item__control sd-checkbox__control",
                    itemDecorator: "sd-item__svg sd-checkbox__svg",
                    itemSvgIconId: "#icon-v2check",
                    controlLabel: "sd-item__control-label",
                    materialDecorator: "sd-item__decorator sd-checkbox__decorator",
                    other: "sd-input sd-comment sd-selectbase__other",
                    column: "sd-selectbase__column"
                },
                radiogroup: {
                    root: "sd-selectbase",
                    rootMobile: "sd-selectbase--mobile",
                    rootRow: "sd-selectbase--row",
                    rootMultiColumn: "sd-selectbase--multi-column",
                    item: "sd-item sd-radio sd-selectbase__item",
                    itemOnError: "sd-item--error",
                    itemInline: "sd-selectbase__item--inline",
                    label: "sd-selectbase__label",
                    labelChecked: "",
                    itemDisabled: "sd-item--disabled sd-radio--disabled",
                    itemChecked: "sd-item--checked sd-radio--checked",
                    itemHover: "sd-item--allowhover sd-radio--allowhover",
                    itemControl: "sd-visuallyhidden sd-item__control sd-radio__control",
                    itemDecorator: "sd-item__svg sd-radio__svg",
                    controlLabel: "sd-item__control-label",
                    materialDecorator: "sd-item__decorator sd-radio__decorator",
                    other: "sd-input sd-comment sd-selectbase__other",
                    clearButton: "",
                    column: "sd-selectbase__column"
                },
                boolean: {
                    mainRoot: "sd-element sd-question sd-row__question sd-question--boolean",
                    root: "sv_qcbc sv_qbln sd-scrollable-container sd-boolean-root",
                    rootRadio: "sv_qcbc sv_qbln sd-scrollable-container sd-scrollable-container--compact",
                    item: "sd-boolean",
                    itemOnError: "sd-boolean--error",
                    control: "sd-boolean__control sd-visuallyhidden",
                    itemChecked: "sd-boolean--checked",
                    itemExchanged: "sd-boolean--exchanged",
                    itemIndeterminate: "sd-boolean--indeterminate",
                    itemDisabled: "sd-boolean--disabled",
                    itemHover: "sd-boolean--allowhover",
                    label: "sd-boolean__label",
                    labelTrue: "sd-boolean__label--true",
                    labelFalse: "sd-boolean__label--false",
                    switch: "sd-boolean__switch",
                    disabledLabel: "sd-checkbox__label--disabled",
                    sliderText: "sd-boolean__thumb-text",
                    slider: "sd-boolean__thumb",
                    sliderGhost: "sd-boolean__thumb-ghost",
                    //radio
                    radioItem: "sd-item",
                    radioItemChecked: "sd-item--checked sd-radio--checked",
                    radioLabel: "sd-selectbase__label",
                    radioControlLabel: "sd-item__control-label",
                    radioFieldset: "sd-selectbase",
                    itemRadioDecorator: "sd-item__svg sd-radio__svg",
                    materialRadioDecorator: "sd-item__decorator sd-radio__decorator",
                    itemRadioControl: "sd-visuallyhidden sd-item__control sd-radio__control",
                    //end radio
                    //checkbox
                    rootCheckbox: "sd-selectbase",
                    checkboxItem: "sd-item sd-selectbase__item sd-checkbox",
                    checkboxLabel: "sd-selectbase__label",
                    checkboxItemOnError: "sd-item--error",
                    checkboxItemIndeterminate: "sd-checkbox--intermediate",
                    checkboxItemChecked: "sd-item--checked sd-checkbox--checked",
                    checkboxItemDecorator: "sd-item__svg sd-checkbox__svg",
                    checkboxItemDisabled: "sd-item--disabled sd-checkbox--disabled",
                    controlCheckbox: "sd-visuallyhidden sd-item__control sd-checkbox__control",
                    checkboxMaterialDecorator: "sd-item__decorator sd-checkbox__decorator",
                    checkboxControlLabel: "sd-item__control-label",
                    svgIconCheckedId: "#icon-v2check"
                },
                text: {
                    root: "sd-input sd-text",
                    small: "sd-row__question--small",
                    controlDisabled: "sd-input--disabled",
                    constrolWithCharacterCounter: "sd-text__character-counter",
                    characterCounterBig: "sd-text__character-counter--big",
                    content: "sd-text__content sd-question__content",
                    remainingCharacterCounter: "sd-remaining-character-counter",
                    onError: "sd-input--error"
                },
                multipletext: {
                    root: "sd-multipletext",
                    rootMobile: "sd-multipletext--mobile",
                    itemLabel: "sd-multipletext__item-container sd-input",
                    itemLabelOnError: "sd-multipletext__item-container--error",
                    itemLabelAllowFocus: "sd-multipletext__item-container--allow-focus",
                    itemLabelAnswered: "sd-multipletext__item-container--answered",
                    itemWithCharacterCounter: "sd-multipletext-item__character-counter",
                    item: "sd-multipletext__item",
                    itemTitle: "sd-multipletext__item-title",
                    content: "sd-multipletext__content sd-question__content",
                    row: "sd-multipletext__row",
                    cell: "sd-multipletext__cell",
                    cellError: "sd-multipletext__cell--error",
                    cellErrorTop: "sd-multipletext__cell--error-top",
                    cellErrorBottom: "sd-multipletext__cell--error-bottom"
                },
                dropdown: {
                    root: "sd-selectbase",
                    popup: "sv-dropdown-popup",
                    small: "sd-row__question--small",
                    selectWrapper: "sv-dropdown_select-wrapper",
                    other: "sd-input sd-comment sd-selectbase__other",
                    onError: "sd-input--error",
                    label: "sd-selectbase__label",
                    item: "sd-item sd-radio sd-selectbase__item",
                    itemDisabled: "sd-item--disabled sd-radio--disabled",
                    itemChecked: "sd-item--checked sd-radio--checked",
                    itemHover: "sd-item--allowhover sd-radio--allowhover",
                    itemControl: "sd-visuallyhidden sd-item__control sd-radio__control",
                    itemDecorator: "sd-item__svg sd-radio__svg",
                    cleanButton: "sd-dropdown_clean-button",
                    cleanButtonSvg: "sd-dropdown_clean-button-svg",
                    cleanButtonIconId: "icon-clear",
                    chevronButton: "sd-dropdown_chevron-button",
                    chevronButtonSvg: "sd-dropdown_chevron-button-svg",
                    chevronButtonIconId: "icon-chevron",
                    control: "sd-input sd-dropdown",
                    controlInputFieldComponent: "sd-dropdown__input-field-component",
                    controlValue: "sd-dropdown__value",
                    controlDisabled: "sd-input--disabled",
                    controlEmpty: "sd-dropdown--empty",
                    controlLabel: "sd-item__control-label",
                    filterStringInput: "sd-dropdown__filter-string-input",
                    materialDecorator: "sd-item__decorator sd-radio__decorator",
                    hintPrefix: "sd-dropdown__hint-prefix",
                    hintSuffix: "sd-dropdown__hint-suffix"
                },
                imagepicker: {
                    mainRoot: "sd-element sd-question sd-row__question",
                    root: "sd-selectbase sd-imagepicker",
                    rootColumn: "sd-imagepicker--column",
                    item: "sd-imagepicker__item",
                    itemOnError: "sd-imagepicker__item--error",
                    itemInline: "sd-imagepicker__item--inline",
                    itemChecked: "sd-imagepicker__item--checked",
                    itemDisabled: "sd-imagepicker__item--disabled",
                    itemHover: "sd-imagepicker__item--allowhover",
                    label: "sd-imagepicker__label",
                    itemDecorator: "sd-imagepicker__item-decorator",
                    imageContainer: "sd-imagepicker__image-container",
                    itemControl: "sd-imagepicker__control sd-visuallyhidden",
                    image: "sd-imagepicker__image",
                    itemText: "sd-imagepicker__text",
                    other: "sd-input sd-comment",
                    itemNoImage: "sd-imagepicker__no-image",
                    itemNoImageSvgIcon: "sd-imagepicker__no-image-svg",
                    itemNoImageSvgIconId: "icon-no-image",
                    column: "sd-selectbase__column sd-imagepicker__column",
                    checkedItemDecorator: "sd-imagepicker__check-decorator",
                    checkedItemSvgIcon: "sd-imagepicker__check-icon",
                    checkedItemSvgIconId: "icon-v2check_24x24"
                },
                matrix: {
                    mainRoot: "sd-element sd-question sd-row__question sd-element--complex sd-question--complex sd-question--table",
                    tableWrapper: "sd-matrix sd-table-wrapper",
                    root: "sd-table sd-matrix__table",
                    columnsAutoWidth: "sd-table--columnsautowidth",
                    noHeader: "sd-table--no-header",
                    rootVerticalAlignTop: "sd-table--align-top",
                    rootVerticalAlignMiddle: "sd-table--align-middle",
                    rootAlternateRows: "sd-table--alternate-rows",
                    rowError: "sd-matrix__row--error",
                    cell: "sd-table__cell sd-matrix__cell",
                    row: "sd-table__row",
                    rowDisabled: "sd-table__row-disabled",
                    headerCell: "sd-table__cell sd-table__cell--header",
                    rowTextCell: "sd-table__cell sd-matrix__cell sd-table__cell--row-text",
                    label: "sd-item sd-radio sd-matrix__label",
                    itemOnError: "sd-item--error",
                    itemValue: "sd-visuallyhidden sd-item__control sd-radio__control",
                    itemChecked: "sd-item--checked sd-radio--checked",
                    itemDisabled: "sd-item--disabled sd-radio--disabled",
                    itemHover: "sd-radio--allowhover",
                    materialDecorator: "sd-item__decorator sd-radio__decorator",
                    itemDecorator: "sd-item__svg sd-radio__svg",
                    cellText: "sd-matrix__text",
                    cellTextSelected: "sd-matrix__text--checked",
                    cellTextDisabled: "sd-matrix__text--disabled",
                    cellResponsiveTitle: "sd-matrix__responsive-title",
                    compact: "sd-element--with-frame sd-element--compact"
                },
                matrixdropdown: {
                    mainRoot: "sd-element sd-question sd-row__question sd-element--complex sd-question--complex sd-question--table",
                    rootScroll: "sd-question--scroll",
                    root: "sd-table sd-matrixdropdown",
                    columnsAutoWidth: "sd-table--columnsautowidth",
                    noHeader: "sd-table--no-header",
                    hasFooter: "sd-table--has-footer",
                    rootVerticalAlignTop: "sd-table--align-top",
                    rootVerticalAlignMiddle: "sd-table--align-middle",
                    tableWrapper: "sd-table-wrapper",
                    rootAlternateRows: "sd-table--alternate-rows",
                    cell: "sd-table__cell",
                    errorsCell: "sd-table__cell--error",
                    errorsCellTop: "sd-table__cell--error-top",
                    errorsCellBottom: "sd-table__cell--error-bottom",
                    itemCell: "sd-table__cell--item",
                    row: "sd-table__row",
                    expandedRow: "sd-table__row--expanded",
                    rowHasPanel: "sd-table__row--has-panel",
                    rowHasEndActions: "sd-table__row--has-end-actions",
                    headerCell: "sd-table__cell sd-table__cell--header",
                    rowTextCell: "sd-table__cell sd-table__cell--row-text",
                    footerCell: "sd-table__cell sd-table__cell--footer",
                    footerTotalCell: "sd-table__cell sd-table__cell--footer-total",
                    columnTitleCell: "sd-table__cell--column-title",
                    cellRequiredText: "sd-question__required-text",
                    detailButton: "sd-table__cell--detail-button",
                    detailButtonExpanded: "sd-table__cell--detail-button--expanded",
                    detailIcon: "sd-detail-panel__icon",
                    detailIconExpanded: "sd-detail-panel__icon--expanded",
                    detailIconId: "icon-expanddetail",
                    detailIconExpandedId: "icon-collapsedetail",
                    detailPanelCell: "sd-table__cell--detail-panel",
                    detailRowCell: "sd-table__cell--detail",
                    actionsCellPrefix: "sd-table__cell-action",
                    actionsCell: "sd-table__cell sd-table__cell--actions",
                    actionsCellDrag: "sd-table__cell--drag",
                    emptyCell: "sd-table__cell--empty",
                    verticalCell: "sd-table__cell--vertical",
                    cellQuestionWrapper: "sd-table__question-wrapper",
                    compact: "sd-element--with-frame sd-element--compact"
                },
                matrixdynamic: {
                    mainRoot: "sd-element sd-question sd-row__question sd-element--complex sd-question--complex sd-question--table",
                    rootScroll: "sd-question--scroll",
                    empty: "sd-question--empty",
                    root: "sd-table sd-matrixdynamic",
                    columnsAutoWidth: "sd-table--columnsautowidth",
                    noHeader: "sd-table--no-header",
                    hasFooter: "sd-table--has-footer",
                    tableWrapper: "sd-table-wrapper",
                    rootAlternateRows: "sd-table--alternate-rows",
                    content: "sd-matrixdynamic__content sd-question__content",
                    cell: "sd-table__cell",
                    row: "sd-table__row",
                    rowHasPanel: "sd-table__row--has-panel",
                    rowHasEndActions: "sd-table__row--has-end-actions",
                    expandedRow: "sd-table__row--expanded",
                    itemCell: "sd-table__cell--item",
                    headerCell: "sd-table__cell sd-table__cell--header",
                    rowTextCell: "sd-table__cell sd-table__cell--row-text",
                    footerCell: "sd-table__cell sd-table__cell--footer",
                    columnTitleCell: "sd-table__cell--column-title",
                    cellRequiredText: "sd-question__required-text",
                    button: "sd-action sd-matrixdynamic__btn",
                    detailRow: "sd-table__row sd-table__row--detail",
                    detailButton: "sd-table__cell--detail-button",
                    detailButtonExpanded: "sd-table__cell--detail-button--expanded",
                    detailIcon: "sd-detail-panel__icon",
                    detailIconExpanded: "sd-detail-panel__icon--expanded",
                    detailIconId: "icon-expanddetail",
                    detailIconExpandedId: "icon-collapsedetail",
                    detailPanelCell: "sd-table__cell--detail-panel",
                    detailRowCell: "sd-table__cell--detail",
                    actionsCellPrefix: "sd-table__cell-action",
                    actionsCell: "sd-table__cell sd-table__cell--actions",
                    actionsCellDrag: "sd-table__cell--drag",
                    buttonAdd: "sd-matrixdynamic__add-btn",
                    buttonRemove: "sd-action--negative sd-matrixdynamic__remove-btn",
                    iconAdd: "sd-hidden",
                    iconRemove: "",
                    dragElementDecorator: "sd-drag-element__svg",
                    iconDragElement: "#icon-v2dragelement_16x16",
                    footer: "sd-matrixdynamic__footer",
                    emptyRowsSection: "sd-matrixdynamic__placeholder sd-question__placeholder",
                    iconDrag: "sv-matrixdynamic__drag-icon",
                    ghostRow: "sv-matrix-row--drag-drop-ghost-mod",
                    emptyCell: "sd-table__cell--empty",
                    verticalCell: "sd-table__cell--vertical",
                    cellQuestionWrapper: "sd-table__question-wrapper",
                    errorsCell: "sd-table__cell--error",
                    errorsCellTop: "sd-table__cell--error-top",
                    errorsCellBottom: "sd-table__cell--error-bottom",
                    compact: "sd-element--with-frame sd-element--compact"
                },
                rating: {
                    rootDropdown: "sd-scrollable-container sd-scrollable-container--compact sd-selectbase",
                    root: "sd-scrollable-container sd-rating",
                    rootWrappable: "sd-rating--wrappable",
                    rootLabelsTop: "sd-rating--labels-top",
                    rootLabelsBottom: "sd-rating--labels-bottom",
                    rootLabelsDiagonal: "sd-rating--labels-diagonal",
                    item: "sd-rating__item",
                    itemOnError: "sd-rating__item--error",
                    itemHover: "sd-rating__item--allowhover",
                    selected: "sd-rating__item--selected",
                    itemStar: "sd-rating__item-star",
                    itemStarOnError: "sd-rating__item-star--error",
                    itemStarHover: "sd-rating__item-star--allowhover",
                    itemStarSelected: "sd-rating__item-star--selected",
                    itemStarDisabled: "sd-rating__item-star--disabled",
                    itemStarHighlighted: "sd-rating__item-star--highlighted",
                    itemStarUnhighlighted: "sd-rating__item-star--unhighlighted",
                    itemStarSmall: "sd-rating__item-star--small",
                    itemSmiley: "sd-rating__item-smiley",
                    itemSmileyOnError: "sd-rating__item-smiley--error",
                    itemSmileyHover: "sd-rating__item-smiley--allowhover",
                    itemSmileySelected: "sd-rating__item-smiley--selected",
                    itemSmileyDisabled: "sd-rating__item-smiley--disabled",
                    itemSmileyHighlighted: "sd-rating__item-star--highlighted",
                    itemSmileyScaleColored: "sd-rating__item-smiley--scale-colored",
                    itemSmileyRateColored: "sd-rating__item-smiley--rate-colored",
                    itemSmileySmall: "sd-rating__item-smiley--small",
                    minText: "sd-rating__item-text sd-rating__min-text",
                    itemText: "sd-rating__item-text",
                    maxText: "sd-rating__item-text sd-rating__max-text",
                    itemDisabled: "sd-rating__item--disabled",
                    itemFixedSize: "sd-rating__item--fixed-size",
                    control: "sd-input sd-dropdown",
                    itemSmall: "sd-rating--small",
                    selectWrapper: "sv-dropdown_select-wrapper",
                    controlValue: "sd-dropdown__value",
                    controlDisabled: "sd-input--disabled",
                    controlEmpty: "sd-dropdown--empty",
                    filterStringInput: "sd-dropdown__filter-string-input",
                    chevronButton: "sd-dropdown_chevron-button",
                    chevronButtonSvg: "sd-dropdown_chevron-button-svg",
                    chevronButtonIconId: "icon-chevron",
                    popup: "sv-dropdown-popup",
                    onError: "sd-input--error"
                },
                comment: {
                    root: "sd-input sd-comment",
                    small: "sd-row__question--small",
                    controlDisabled: "sd-input--disabled",
                    content: "sd-comment__content sd-question__content",
                    remainingCharacterCounter: "sd-remaining-character-counter",
                    onError: "sd-input--error"
                },
                expression: "sd-expression",
                file: {
                    root: "sd-file",
                    rootDragging: "sd-file--dragging",
                    rootAnswered: "sd-file--answered",
                    other: "sd-input sd-comment",
                    placeholderInput: "sd-visuallyhidden",
                    preview: "sd-file__preview",
                    fileSign: "",
                    fileList: "sd-file__list",
                    fileSignBottom: "sd-file__sign",
                    dragArea: "sd-file__drag-area",
                    dragAreaActive: "sd-file__drag-area--active",
                    fileDecorator: "sd-file__decorator",
                    onError: "sd-file__decorator--error",
                    fileDecoratorDrag: "sd-file__decorator--drag",
                    fileInput: "sd-visuallyhidden",
                    noFileChosen: "sd-description sd-file__no-file-chosen",
                    chooseFile: "sd-file__choose-btn",
                    chooseFileAsText: "sd-action sd-file__choose-btn--text",
                    chooseFileAsTextDisabled: "sd-action--disabled",
                    chooseFileAsIcon: "sd-file__choose-btn--icon",
                    chooseFileIconId: "icon-choosefile",
                    disabled: "sd-file__choose-btn--disabled",
                    controlDisabled: "sd-file__choose-file-btn--disabled",
                    //todo: remove it in v2
                    removeButton: "sd-context-btn--negative",
                    removeButtonBottom: "",
                    //
                    removeButtonIconId: "icon-clear",
                    removeFile: "sd-hidden",
                    removeFileSvg: "",
                    removeFileSvgIconId: "icon-delete",
                    wrapper: "sd-file__wrapper",
                    defaultImage: "sd-file__default-image",
                    defaultImageIconId: "icon-defaultfile",
                    leftIconId: "icon-arrowleft",
                    rightIconId: "icon-arrowright",
                    removeFileButton: "sd-context-btn--negative sd-file__remove-file-button",
                    dragAreaPlaceholder: "sd-file__drag-area-placeholder",
                    imageWrapper: "sd-file__image-wrapper",
                    imageWrapperDefaultImage: "sd-file__image-wrapper--default-image",
                    single: "sd-file--single",
                    singleImage: "sd-file--single-image",
                    mobile: "sd-file--mobile",
                    videoContainer: "sd-file__video-container",
                    contextButton: "sd-context-btn",
                    video: "sd-file__video",
                    actionsContainer: "sd-file__actions-container",
                    closeCameraButton: "sd-file__close-camera-button",
                    changeCameraButton: "sd-file__change-camera-button",
                    takePictureButton: "sd-file__take-picture-button",
                    loadingIndicator: "sd-file__loading-indicator"
                },
                signaturepad: {
                    mainRoot: "sd-element sd-question sd-question--signature sd-row__question",
                    root: "sd-signaturepad sjs_sp_container",
                    small: "sd-row__question--small",
                    controls: "sjs_sp_controls sd-signaturepad__controls",
                    placeholder: "sjs_sp_placeholder",
                    canvas: "sjs_sp_canvas sd-signaturepad__canvas",
                    backgroundImage: "sjs_sp__background-image sd-signaturepad__background-image",
                    clearButton: "sjs_sp_clear sd-context-btn sd-context-btn--negative sd-signaturepad__clear",
                    clearButtonIconId: "icon-clear",
                    loadingIndicator: "sd-signaturepad__loading-indicator"
                },
                saveData: {
                    root: "sv-save-data_root",
                    rootWithButtons: "sv-save-data_root--with-buttons",
                    info: "sv-save-data_info",
                    error: "sv-save-data_error",
                    success: "sv-save-data_success",
                    button: "sv-save-data_button",
                    shown: "sv-save-data_root--shown"
                },
                window: {
                    root: "sv_window",
                    rootCollapsedMod: "sv_window--collapsed",
                    rootFullScreenMode: "sv_window--full-screen",
                    rootContent: "sv_window_root-content",
                    body: "sv_window_content",
                    header: {
                        root: "sv_window_header",
                        titleCollapsed: "sv_window_header_title_collapsed",
                        buttonsContainer: "sv_window_buttons_container",
                        button: "sv_window_button",
                        buttonExpanded: "",
                        buttonCollapsed: "",
                        collapseButton: "sv_window_button sv_window_button_collapse",
                        closeButton: "sv_window_button sv_window_button_close",
                        fullScreenButton: "sv_window_button sv_window_button_full_screen"
                    }
                },
                ranking: {
                    root: "sv-ranking",
                    rootMobileMod: "sv-ranking--mobile",
                    rootDragMod: "sv-ranking--drag",
                    rootDisabled: "sd-ranking--disabled",
                    rootDesignMode: "sv-ranking--design-mode",
                    rootDragHandleAreaIcon: "sv-ranking--drag-handle-area-icon",
                    rootSelectToRankMod: "sv-ranking--select-to-rank",
                    rootSelectToRankAlignVertical: "sv-ranking--select-to-rank-vertical",
                    rootSelectToRankAlignHorizontal: "sv-ranking--select-to-rank-horizontal",
                    item: "sv-ranking-item",
                    itemContent: "sv-ranking-item__content sd-ranking-item__content",
                    itemIndex: "sv-ranking-item__index sd-ranking-item__index",
                    itemIndexEmptyMode: "sv-ranking-item__index--empty sd-ranking-item__index--empty",
                    // itemText: "sv-ranking-item__text",
                    itemDisabled: "sv-ranking-item--disabled",
                    controlLabel: "sv-ranking-item__text",
                    itemGhostNode: "sv-ranking-item__ghost",
                    itemIconContainer: "sv-ranking-item__icon-container",
                    itemIcon: "sv-ranking-item__icon",
                    itemIconHoverMod: "sv-ranking-item__icon--hover",
                    itemIconFocusMod: "sv-ranking-item__icon--focus",
                    itemGhostMod: "sv-ranking-item--ghost",
                    itemDragMod: "sv-ranking--drag",
                    itemOnError: "sv-ranking-item--error",
                    container: "sv-ranking__container",
                    containerEmptyMode: "sv-ranking__container--empty",
                    containerFromMode: "sv-ranking__container--from",
                    containerToMode: "sv-ranking__container--to",
                    containerPlaceholder: "sv-ranking__container-placeholder",
                    containersDivider: "sv-ranking__containers-divider"
                },
                buttongroup: {
                    root: "sv-button-group",
                    item: "sv-button-group__item",
                    itemIcon: "sv-button-group__item-icon",
                    itemDecorator: "sv-button-group__item-decorator",
                    itemCaption: "sv-button-group__item-caption",
                    itemHover: "sv-button-group__item--hover",
                    itemSelected: "sv-button-group__item--selected",
                    itemDisabled: "sv-button-group__item--disabled",
                    itemControl: "sv-visuallyhidden"
                },
                list: {
                    root: "sv-list__container sd-list",
                    item: "sv-list__item sd-list__item",
                    itemBody: "sv-list__item-body sd-list__item-body",
                    itemSelected: "sv-list__item--selected sd-list__item--selected",
                    itemFocused: "sv-list__item--focused sd-list__item--focused"
                },
                actionBar: {
                    root: "sd-action-bar",
                    item: "sd-action",
                    defaultSizeMode: "",
                    smallSizeMode: "",
                    itemPressed: "sd-action--pressed",
                    itemAsIcon: "sd-action--icon",
                    itemIcon: "sd-action__icon",
                    itemTitle: "sd-action__title"
                },
                variables: {
                    mobileWidth: "--sd-mobile-width",
                    themeMark: "--sv-defaultV2-mark"
                },
                tagbox: {
                    root: "sd-selectbase",
                    popup: "sv-dropdown-popup",
                    small: "sd-row__question--small",
                    selectWrapper: "sv-dropdown_select-wrapper",
                    other: "sd-input sd-comment sd-selectbase__other",
                    onError: "sd-input--error",
                    label: "sd-selectbase__label",
                    itemSvgIconId: "#icon-v2check",
                    item: "sd-item sd-checkbox sd-selectbase__item",
                    itemDisabled: "sd-item--disabled sd-checkbox--disabled",
                    itemChecked: "sd-item--checked sd-checkbox--checked",
                    itemHover: "sd-item--allowhover sd-checkbox--allowhover",
                    itemControl: "sd-visuallyhidden sd-item__control sd-checkbox__control",
                    itemDecorator: "sd-item__svg sd-checkbox__svg",
                    cleanButton: "sd-tagbox_clean-button sd-dropdown_clean-button",
                    cleanButtonSvg: "sd-tagbox_clean-button-svg sd-dropdown_clean-button-svg",
                    cleanButtonIconId: "icon-clear",
                    cleanItemButton: "sd-tagbox-item_clean-button",
                    cleanItemButtonSvg: "sd-tagbox-item_clean-button-svg",
                    cleanItemButtonIconId: "icon-clear_16x16",
                    chevronButton: "sd-dropdown_chevron-button",
                    chevronButtonSvg: "sd-dropdown_chevron-button-svg",
                    chevronButtonIconId: "icon-chevron",
                    control: "sd-input sd-tagbox sd-dropdown",
                    controlValue: "sd-tagbox__value sd-dropdown__value",
                    controlValueItems: "sd-tagbox__value-items",
                    placeholderInput: "sd-tagbox__placeholder",
                    controlDisabled: "sd-input--disabled",
                    controlEmpty: "sd-dropdown--empty sd-tagbox--empty",
                    controlLabel: "sd-item__control-label",
                    filterStringInput: "sd-tagbox__filter-string-input sd-dropdown__filter-string-input",
                    materialDecorator: "sd-item__decorator sd-checkbox__decorator",
                    hint: "sd-tagbox__hint",
                    hintPrefix: "sd-dropdown__hint-prefix sd-tagbox__hint-prefix",
                    hintSuffix: "sd-dropdown__hint-suffix sd-tagbox__hint-suffix",
                    hintSuffixWrapper: "sd-tagbox__hint-suffix-wrapper"
                }
            };
            var defaultV2ThemeName = "defaultV2";
            surveyCss[defaultV2ThemeName] = defaultV2Css;
        /***/ },
        /***/ "./src/defaultTitle.ts": /*!*****************************!*\
  !*** ./src/defaultTitle.ts ***!
  \*****************************/ /*! exports provided: DefaultTitleModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DefaultTitleModel", function() {
                return DefaultTitleModel;
            });
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            var DefaultTitleModel = /** @class */ function() {
                function DefaultTitleModel() {}
                DefaultTitleModel.getIconCss = function(cssClasses, isCollapsed) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_0__["CssClassBuilder"]().append(cssClasses.icon).append(cssClasses.iconExpanded, !isCollapsed).toString();
                };
                return DefaultTitleModel;
            }();
        /***/ },
        /***/ "./src/drag-drop-helper-v1.ts": /*!************************************!*\
  !*** ./src/drag-drop-helper-v1.ts ***!
  \************************************/ /*! exports provided: DragDropInfo */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropInfo", function() {
                return DragDropInfo;
            });
            var DragDropInfo = /** @class */ function() {
                function DragDropInfo(source, target, nestedPanelDepth) {
                    if (nestedPanelDepth === void 0) nestedPanelDepth = -1;
                    this.source = source;
                    this.target = target;
                    this.nestedPanelDepth = nestedPanelDepth;
                }
                return DragDropInfo;
            }();
        /***/ },
        /***/ "./src/drag-drop-page-helper-v1.ts": /*!*****************************************!*\
  !*** ./src/drag-drop-page-helper-v1.ts ***!
  \*****************************************/ /*! exports provided: DragDropPageHelperV1 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropPageHelperV1", function() {
                return DragDropPageHelperV1;
            });
            /* harmony import */ var _drag_drop_helper_v1__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./drag-drop-helper-v1 */ "./src/drag-drop-helper-v1.ts");
            var DragDropPageHelperV1 = /** @class */ function() {
                function DragDropPageHelperV1(page) {
                    this.page = page;
                }
                DragDropPageHelperV1.prototype.getDragDropInfo = function() {
                    return this.dragDropInfo;
                };
                DragDropPageHelperV1.prototype.dragDropStart = function(src, target, nestedPanelDepth) {
                    if (nestedPanelDepth === void 0) nestedPanelDepth = -1;
                    this.dragDropInfo = new _drag_drop_helper_v1__WEBPACK_IMPORTED_MODULE_0__["DragDropInfo"](src, target, nestedPanelDepth);
                };
                DragDropPageHelperV1.prototype.dragDropMoveTo = function(destination, isBottom, isEdge) {
                    if (isBottom === void 0) isBottom = false;
                    if (isEdge === void 0) isEdge = false;
                    if (!this.dragDropInfo) return false;
                    this.dragDropInfo.destination = destination;
                    this.dragDropInfo.isBottom = isBottom;
                    this.dragDropInfo.isEdge = isEdge;
                    this.correctDragDropInfo(this.dragDropInfo);
                    if (!this.dragDropCanDropTagert()) return false;
                    if (!this.dragDropCanDropSource() || !this.dragDropAllowFromSurvey()) {
                        if (!!this.dragDropInfo.source) {
                            var row = this.page.dragDropFindRow(this.dragDropInfo.target);
                            this.page.updateRowsRemoveElementFromRow(this.dragDropInfo.target, row);
                        }
                        return false;
                    }
                    this.page.dragDropAddTarget(this.dragDropInfo);
                    return true;
                };
                DragDropPageHelperV1.prototype.correctDragDropInfo = function(dragDropInfo) {
                    if (!dragDropInfo.destination) return;
                    var panel = dragDropInfo.destination.isPanel ? dragDropInfo.destination : null;
                    if (!panel) return;
                    if (!dragDropInfo.target.isLayoutTypeSupported(panel.getChildrenLayoutType())) dragDropInfo.isEdge = true;
                };
                DragDropPageHelperV1.prototype.dragDropAllowFromSurvey = function() {
                    var dest = this.dragDropInfo.destination;
                    if (!dest || !this.page.survey) return true;
                    var insertBefore = null;
                    var insertAfter = null;
                    var parent = dest.isPage || !this.dragDropInfo.isEdge && dest.isPanel ? dest : dest.parent;
                    if (!dest.isPage) {
                        var container = dest.parent;
                        if (!!container) {
                            var elements = container.elements;
                            var index = elements.indexOf(dest);
                            if (index > -1) {
                                insertBefore = dest;
                                insertAfter = dest;
                                if (this.dragDropInfo.isBottom) insertBefore = index < elements.length - 1 ? elements[index + 1] : null;
                                else insertAfter = index > 0 ? elements[index - 1] : null;
                            }
                        }
                    }
                    var options = {
                        allow: true,
                        target: this.dragDropInfo.target,
                        source: this.dragDropInfo.source,
                        toElement: this.dragDropInfo.target,
                        draggedElement: this.dragDropInfo.source,
                        parent: parent,
                        fromElement: this.dragDropInfo.source ? this.dragDropInfo.source.parent : null,
                        insertAfter: insertAfter,
                        insertBefore: insertBefore
                    };
                    return this.page.survey.dragAndDropAllow(options);
                };
                DragDropPageHelperV1.prototype.dragDropFinish = function(isCancel) {
                    if (isCancel === void 0) isCancel = false;
                    if (!this.dragDropInfo) return;
                    var target = this.dragDropInfo.target;
                    var src = this.dragDropInfo.source;
                    var dest = this.dragDropInfo.destination;
                    var row = this.page.dragDropFindRow(target);
                    var targetIndex = this.dragDropGetElementIndex(target, row);
                    this.page.updateRowsRemoveElementFromRow(target, row);
                    var elementsToSetSWNL = [];
                    var elementsToResetSWNL = [];
                    if (!isCancel && !!row) {
                        var isSamePanel = false;
                        if (this.page.isDesignModeV2) {
                            var srcRow = src && src.parent && src.parent.dragDropFindRow(src);
                            if (row.panel.elements[targetIndex] && row.panel.elements[targetIndex].startWithNewLine && row.elements.length > 1 && row.panel.elements[targetIndex] === dest) {
                                elementsToSetSWNL.push(target);
                                elementsToResetSWNL.push(row.panel.elements[targetIndex]);
                            }
                            if (target.startWithNewLine && row.elements.length > 1 && (!row.panel.elements[targetIndex] || !row.panel.elements[targetIndex].startWithNewLine)) elementsToResetSWNL.push(target);
                            if (srcRow && srcRow.elements[0] === src && srcRow.elements[1]) elementsToSetSWNL.push(srcRow.elements[1]);
                            if (row.elements.length <= 1) elementsToSetSWNL.push(target);
                            if (target.startWithNewLine && row.elements.length > 1 && row.elements[0] !== dest) elementsToResetSWNL.push(target);
                        }
                        this.page.survey.startMovingQuestion();
                        if (!!src && !!src.parent) {
                            isSamePanel = row.panel == src.parent;
                            if (isSamePanel) {
                                row.panel.dragDropMoveElement(src, target, targetIndex);
                                targetIndex = -1;
                            } else src.parent.removeElement(src);
                        }
                        if (targetIndex > -1) row.panel.addElement(target, targetIndex);
                        this.page.survey.stopMovingQuestion();
                    }
                    elementsToSetSWNL.map(function(e) {
                        e.startWithNewLine = true;
                    });
                    elementsToResetSWNL.map(function(e) {
                        e.startWithNewLine = false;
                    });
                    this.dragDropInfo = null;
                    return !isCancel ? target : null;
                };
                DragDropPageHelperV1.prototype.dragDropGetElementIndex = function(target, row) {
                    if (!row) return -1;
                    var index = row.elements.indexOf(target);
                    if (row.index == 0) return index;
                    var prevRow = row.panel.rows[row.index - 1];
                    var prevElement = prevRow.elements[prevRow.elements.length - 1];
                    return index + row.panel.elements.indexOf(prevElement) + 1;
                };
                DragDropPageHelperV1.prototype.dragDropCanDropTagert = function() {
                    var destination = this.dragDropInfo.destination;
                    if (!destination || destination.isPage) return true;
                    return this.dragDropCanDropCore(this.dragDropInfo.target, destination);
                };
                DragDropPageHelperV1.prototype.dragDropCanDropSource = function() {
                    var source = this.dragDropInfo.source;
                    if (!source) return true;
                    var destination = this.dragDropInfo.destination;
                    if (!this.dragDropCanDropCore(source, destination)) return false;
                    if (this.page.isDesignModeV2) {
                        var rowSource = this.page.dragDropFindRow(source);
                        var rowDestination = this.page.dragDropFindRow(destination);
                        if (rowSource !== rowDestination) {
                            if (!source.startWithNewLine && destination.startWithNewLine) return true;
                            if (source.startWithNewLine && !destination.startWithNewLine) return true;
                        }
                        var row = this.page.dragDropFindRow(destination);
                        if (row && row.elements.length == 1) return true;
                    }
                    return this.dragDropCanDropNotNext(source, destination, this.dragDropInfo.isEdge, this.dragDropInfo.isBottom);
                };
                DragDropPageHelperV1.prototype.dragDropCanDropCore = function(target, destination) {
                    if (!destination) return true;
                    if (this.dragDropIsSameElement(destination, target)) return false;
                    if (target.isPanel) {
                        var pnl = target;
                        if (pnl.containsElement(destination) || !!pnl.getElementByName(destination.name)) return false;
                    }
                    return true;
                };
                DragDropPageHelperV1.prototype.dragDropCanDropNotNext = function(source, destination, isEdge, isBottom) {
                    if (!destination || destination.isPanel && !isEdge) return true;
                    if (typeof source.parent === "undefined" || source.parent !== destination.parent) return true;
                    var pnl = source.parent;
                    var srcIndex = pnl.elements.indexOf(source);
                    var destIndex = pnl.elements.indexOf(destination);
                    if (destIndex < srcIndex && !isBottom) destIndex--;
                    if (isBottom) destIndex++;
                    return srcIndex < destIndex ? destIndex - srcIndex > 1 : srcIndex - destIndex > 0;
                };
                DragDropPageHelperV1.prototype.dragDropIsSameElement = function(el1, el2) {
                    return el1 == el2 || el1.name == el2.name;
                };
                return DragDropPageHelperV1;
            }();
        /***/ },
        /***/ "./src/drag-drop-panel-helper-v1.ts": /*!******************************************!*\
  !*** ./src/drag-drop-panel-helper-v1.ts ***!
  \******************************************/ /*! exports provided: DragDropPanelHelperV1 */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropPanelHelperV1", function() {
                return DragDropPanelHelperV1;
            });
            /* harmony import */ var _drag_drop_helper_v1__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./drag-drop-helper-v1 */ "./src/drag-drop-helper-v1.ts");
            var DragDropPanelHelperV1 = /** @class */ function() {
                function DragDropPanelHelperV1(panel) {
                    this.panel = panel;
                }
                DragDropPanelHelperV1.prototype.dragDropAddTarget = function(dragDropInfo) {
                    var prevRow = this.dragDropFindRow(dragDropInfo.target);
                    if (this.dragDropAddTargetToRow(dragDropInfo, prevRow)) this.panel.updateRowsRemoveElementFromRow(dragDropInfo.target, prevRow);
                };
                DragDropPanelHelperV1.prototype.dragDropFindRow = function(findElement) {
                    if (!findElement || findElement.isPage) return null;
                    var element = findElement;
                    var rows = this.panel.rows;
                    for(var i = 0; i < rows.length; i++){
                        if (rows[i].elements.indexOf(element) > -1) return rows[i];
                    }
                    for(var i = 0; i < this.panel.elements.length; i++){
                        var pnl = this.panel.elements[i].getPanel();
                        if (!pnl) continue;
                        var row = pnl.dragDropFindRow(element);
                        if (!!row) return row;
                    }
                    return null;
                };
                DragDropPanelHelperV1.prototype.dragDropMoveElement = function(src, target, targetIndex) {
                    var srcIndex = src.parent.elements.indexOf(src);
                    if (targetIndex > srcIndex) targetIndex--;
                    this.panel.removeElement(src);
                    this.panel.addElement(target, targetIndex);
                };
                DragDropPanelHelperV1.prototype.updateRowsOnElementAdded = function(element, index, dragDropInfo, thisElement) {
                    if (!dragDropInfo) {
                        dragDropInfo = new _drag_drop_helper_v1__WEBPACK_IMPORTED_MODULE_0__["DragDropInfo"](null, element);
                        dragDropInfo.target = element;
                        dragDropInfo.isEdge = this.panel.elements.length > 1;
                        if (this.panel.elements.length < 2) dragDropInfo.destination = thisElement;
                        else {
                            dragDropInfo.isBottom = index > 0;
                            if (index == 0) dragDropInfo.destination = this.panel.elements[1];
                            else dragDropInfo.destination = this.panel.elements[index - 1];
                        }
                    }
                    this.dragDropAddTargetToRow(dragDropInfo, null);
                };
                DragDropPanelHelperV1.prototype.dragDropAddTargetToRow = function(dragDropInfo, prevRow) {
                    if (!dragDropInfo.destination) return true;
                    if (this.dragDropAddTargetToEmptyPanel(dragDropInfo)) return true;
                    var dest = dragDropInfo.destination;
                    var destRow = this.dragDropFindRow(dest);
                    if (!destRow) return true;
                    // if (settings.supportCreatorV2 && this.panel.isDesignMode) {
                    //   if (destRow.elements.length > 1)
                    //     return this.dragDropAddTargetToExistingRow(
                    //       dragDropInfo,
                    //       destRow,
                    //       prevRow
                    //     );
                    //   else
                    //     return this.dragDropAddTargetToNewRow(dragDropInfo, destRow, prevRow);
                    // }
                    if (!dragDropInfo.target.startWithNewLine) return this.dragDropAddTargetToExistingRow(dragDropInfo, destRow, prevRow);
                    return this.dragDropAddTargetToNewRow(dragDropInfo, destRow, prevRow);
                };
                DragDropPanelHelperV1.prototype.dragDropAddTargetToEmptyPanel = function(dragDropInfo) {
                    if (dragDropInfo.destination.isPage) {
                        this.dragDropAddTargetToEmptyPanelCore(this.panel.root, dragDropInfo.target, dragDropInfo.isBottom);
                        return true;
                    }
                    var dest = dragDropInfo.destination;
                    if (dest.isPanel && !dragDropInfo.isEdge) {
                        var panel = dest;
                        if (dragDropInfo.target["template"] === dest) return false;
                        if (dragDropInfo.nestedPanelDepth < 0 || dragDropInfo.nestedPanelDepth >= panel.depth) {
                            this.dragDropAddTargetToEmptyPanelCore(dest, dragDropInfo.target, dragDropInfo.isBottom);
                            return true;
                        }
                    }
                    return false;
                };
                DragDropPanelHelperV1.prototype.dragDropAddTargetToExistingRow = function(dragDropInfo, destRow, prevRow) {
                    var index = destRow.elements.indexOf(dragDropInfo.destination);
                    if (index == 0 && !dragDropInfo.isBottom) {
                        if (this.panel.isDesignModeV2) ;
                        else if (destRow.elements[0].startWithNewLine) {
                            if (destRow.index > 0) {
                                dragDropInfo.isBottom = true;
                                destRow = destRow.panel.rows[destRow.index - 1];
                                dragDropInfo.destination = destRow.elements[destRow.elements.length - 1];
                                return this.dragDropAddTargetToExistingRow(dragDropInfo, destRow, prevRow);
                            } else return this.dragDropAddTargetToNewRow(dragDropInfo, destRow, prevRow);
                        }
                    }
                    var prevRowIndex = -1;
                    if (prevRow == destRow) prevRowIndex = destRow.elements.indexOf(dragDropInfo.target);
                    if (dragDropInfo.isBottom) index++;
                    var srcRow = this.panel.findRowByElement(dragDropInfo.source);
                    if (srcRow == destRow && srcRow.elements.indexOf(dragDropInfo.source) == index) return false;
                    if (index == prevRowIndex) return false;
                    if (prevRowIndex > -1) {
                        destRow.elements.splice(prevRowIndex, 1);
                        if (prevRowIndex < index) index--;
                    }
                    destRow.elements.splice(index, 0, dragDropInfo.target);
                    destRow.updateVisible();
                    return prevRowIndex < 0;
                };
                DragDropPanelHelperV1.prototype.dragDropAddTargetToNewRow = function(dragDropInfo, destRow, prevRow) {
                    var targetRow = destRow.panel.createRowAndSetLazy(destRow.panel.rows.length);
                    if (this.panel.isDesignModeV2) targetRow.setIsLazyRendering(false);
                    targetRow.addElement(dragDropInfo.target);
                    var index = destRow.index;
                    if (dragDropInfo.isBottom) index++;
                    //same row
                    if (!!prevRow && prevRow.panel == targetRow.panel && prevRow.index == index) return false;
                    var srcRow = this.panel.findRowByElement(dragDropInfo.source);
                    if (!!srcRow && srcRow.panel == targetRow.panel && srcRow.elements.length == 1 && srcRow.index == index) return false;
                    destRow.panel.rows.splice(index, 0, targetRow);
                    return true;
                };
                DragDropPanelHelperV1.prototype.dragDropAddTargetToEmptyPanelCore = function(panel, target, isBottom) {
                    var targetRow = panel.createRow();
                    targetRow.addElement(target);
                    if (panel.elements.length == 0 || isBottom) panel.rows.push(targetRow);
                    else panel.rows.splice(0, 0, targetRow);
                };
                return DragDropPanelHelperV1;
            }();
        /***/ },
        /***/ "./src/dragdrop/choices.ts": /*!*********************************!*\
  !*** ./src/dragdrop/choices.ts ***!
  \*********************************/ /*! exports provided: DragDropChoices */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropChoices", function() {
                return DragDropChoices;
            });
            /* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core */ "./src/dragdrop/core.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var DragDropChoices = /** @class */ function(_super) {
                __extends(DragDropChoices, _super);
                function DragDropChoices() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.doDragOver = function() {
                        if (_this.parentElement.getType() === "imagepicker") return;
                        var node = _this.domAdapter.draggedElementShortcut.querySelector(".svc-item-value-controls__button");
                        node.style.cursor = "grabbing";
                    };
                    _this.doBanDropHere = function() {
                        if (_this.parentElement.getType() === "imagepicker") return;
                        var node = _this.domAdapter.draggedElementShortcut.querySelector(".svc-item-value-controls__button");
                        node.style.cursor = "not-allowed";
                    };
                    return _this;
                }
                Object.defineProperty(DragDropChoices.prototype, "draggedElementType", {
                    get: function() {
                        return "item-value";
                    },
                    enumerable: false,
                    configurable: true
                });
                DragDropChoices.prototype.createDraggedElementShortcut = function(text, draggedElementNode, event1) {
                    if (this.parentElement.getType() === "imagepicker") return this.createImagePickerShortcut(this.draggedElement, text, draggedElementNode, event1);
                    var draggedElementShortcut = _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__["DomDocumentHelper"].createElement("div");
                    if (!draggedElementShortcut) return;
                    // draggedElementShortcut.innerText = text;
                    draggedElementShortcut.style.cssText = " \n          cursor: grabbing;\n          position: absolute;\n          z-index: 10000;\n          font-family: var(--sjs-font-family, var(--font-family, var(--sjs-default-font-family)));\n        ";
                    var isDeepClone = true;
                    var clone = draggedElementNode.closest("[data-sv-drop-target-item-value]").cloneNode(isDeepClone);
                    clone.style.cssText = "\n      min-width: 100px;\n      box-shadow: var(--sjs-shadow-large, 0px 8px 16px 0px rgba(0, 0, 0, 0.1)), var(--sjs-shadow-medium, 0px 2px 6px 0px rgba(0, 0, 0, 0.1));\n      background-color: var(--sjs-general-backcolor, var(--background, #fff));\n      border-radius: calc(4.5 * var(--sjs-base-unit, var(--base-unit, 8px)));\n      padding-right: calc(2* var(--sjs-base-unit, var(--base-unit, 8px)));\n      margin-left: 0;\n    ";
                    var dragIcon = clone.querySelector(".svc-item-value-controls__drag-icon");
                    dragIcon.style.visibility = "visible";
                    var removeIcon = clone.querySelector(".svc-item-value-controls__remove");
                    removeIcon.style.backgroundColor = "transparent";
                    clone.classList.remove("svc-item-value--moveup");
                    clone.classList.remove("svc-item-value--movedown");
                    this.draggedElement.isDragDropMoveDown = false;
                    this.draggedElement.isDragDropMoveUp = false;
                    draggedElementShortcut.appendChild(clone);
                    var rect = draggedElementNode.getBoundingClientRect();
                    draggedElementShortcut.shortcutXOffset = event1.clientX - rect.x;
                    draggedElementShortcut.shortcutYOffset = event1.clientY - rect.y;
                    this.isBottom = null;
                    return draggedElementShortcut;
                };
                DragDropChoices.prototype.createImagePickerShortcut = function(item, text, draggedElementNode, event1) {
                    var draggedElementShortcut = _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__["DomDocumentHelper"].createElement("div");
                    if (!draggedElementShortcut) return;
                    draggedElementShortcut.style.cssText = " \n      cursor: grabbing;\n      position: absolute;\n      z-index: 10000;\n      box-shadow: var(--sjs-shadow-large, 0px 8px 16px 0px rgba(0, 0, 0, 0.1)), var(--sjs-shadow-medium, 0px 2px 6px 0px rgba(0, 0, 0, 0.1));\n      background-color: var(--sjs-general-backcolor, var(--background, #fff));\n      padding: calc(0.5 * var(--sjs-base-unit, var(--base-unit, 8px)));\n      border-radius: calc(0.5 * var(--sjs-base-unit, var(--base-unit, 8px)));\n    ";
                    var itemValueNode = draggedElementNode.closest("[data-sv-drop-target-item-value]");
                    this.imagepickerControlsNode = itemValueNode.querySelector(".svc-image-item-value-controls");
                    var imageContainerNode = itemValueNode.querySelector(".sd-imagepicker__image-container");
                    var imageNode = itemValueNode.querySelector(item.imageLink ? "img" : ".sd-imagepicker__no-image").cloneNode(true);
                    if (!!this.imagepickerControlsNode) this.imagepickerControlsNode.style.display = "none";
                    imageContainerNode.style.width = imageNode.width + "px";
                    imageContainerNode.style.height = imageNode.height + "px";
                    imageNode.style.objectFit = "cover";
                    imageNode.style.borderRadius = "4px";
                    draggedElementShortcut.appendChild(imageNode);
                    return draggedElementShortcut;
                };
                DragDropChoices.prototype.getDropTargetByDataAttributeValue = function(dataAttributeValue) {
                    var dragOverChoice;
                    dragOverChoice = this.parentElement.choices.filter(function(choice) {
                        return "" + choice.value == dataAttributeValue;
                    })[0];
                    return dragOverChoice;
                };
                DragDropChoices.prototype.getVisibleChoices = function() {
                    var parent = this.parentElement;
                    if (parent.getType() === "ranking") {
                        if (parent.selectToRankEnabled) return parent.visibleChoices;
                        else return parent.rankingChoices;
                    }
                    return parent.visibleChoices;
                };
                DragDropChoices.prototype.isDropTargetValid = function(dropTarget, dropTargetNode) {
                    var choices = this.getVisibleChoices();
                    if (this.parentElement.getType() !== "imagepicker") {
                        var dropTargetIndex = choices.indexOf(this.dropTarget);
                        var draggedElementIndex = choices.indexOf(this.draggedElement);
                        if (draggedElementIndex > dropTargetIndex && this.dropTarget.isDragDropMoveUp) {
                            this.dropTarget.isDragDropMoveUp = false;
                            return false;
                        }
                        if (draggedElementIndex < dropTargetIndex && this.dropTarget.isDragDropMoveDown) {
                            this.dropTarget.isDragDropMoveDown = false;
                            return false;
                        }
                    }
                    // shouldn't allow to drop on "adorners" (selectall, none, other)
                    if (choices.indexOf(dropTarget) === -1) return false;
                    return true;
                };
                DragDropChoices.prototype.calculateIsBottom = function(clientY) {
                    var choices = this.getVisibleChoices();
                    return choices.indexOf(this.dropTarget) - choices.indexOf(this.draggedElement) > 0;
                };
                DragDropChoices.prototype.afterDragOver = function(dropTargetNode) {
                    if (this.isDropTargetDoesntChanged(this.isBottom)) return;
                    var choices = this.getVisibleChoices();
                    var dropTargetIndex = choices.indexOf(this.dropTarget);
                    var draggedElementIndex = choices.indexOf(this.draggedElement);
                    choices.splice(draggedElementIndex, 1);
                    choices.splice(dropTargetIndex, 0, this.draggedElement);
                    if (this.parentElement.getType() === "imagepicker") return;
                    if (draggedElementIndex !== dropTargetIndex) {
                        dropTargetNode.classList.remove("svc-item-value--moveup");
                        dropTargetNode.classList.remove("svc-item-value--movedown");
                        this.dropTarget.isDragDropMoveDown = false;
                        this.dropTarget.isDragDropMoveUp = false;
                    }
                    if (draggedElementIndex > dropTargetIndex) this.dropTarget.isDragDropMoveDown = true;
                    if (draggedElementIndex < dropTargetIndex) this.dropTarget.isDragDropMoveUp = true;
                    _super.prototype.ghostPositionChanged.call(this);
                };
                DragDropChoices.prototype.doDrop = function() {
                    var choices = this.parentElement.choices;
                    var filteredChoices = this.getVisibleChoices().filter(function(item) {
                        return choices.indexOf(item) !== -1;
                    });
                    var oldIndex = choices.indexOf(this.draggedElement);
                    var newIndex = filteredChoices.indexOf(this.draggedElement);
                    choices.splice(oldIndex, 1);
                    choices.splice(newIndex, 0, this.draggedElement);
                    return this.parentElement;
                };
                DragDropChoices.prototype.clear = function() {
                    if (!!this.parentElement) this.updateVisibleChoices(this.parentElement);
                    if (!!this.imagepickerControlsNode) {
                        this.imagepickerControlsNode.style.display = "flex";
                        this.imagepickerControlsNode = null;
                    }
                    _super.prototype.clear.call(this);
                };
                DragDropChoices.prototype.updateVisibleChoices = function(parent) {
                    parent.getType() === "ranking" ? parent.updateRankingChoices() : parent["updateVisibleChoices"]();
                };
                return DragDropChoices;
            }(_core__WEBPACK_IMPORTED_MODULE_0__["DragDropCore"]);
        /***/ },
        /***/ "./src/dragdrop/core.ts": /*!******************************!*\
  !*** ./src/dragdrop/core.ts ***!
  \******************************/ /*! exports provided: DragDropCore */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropCore", function() {
                return DragDropCore;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../base */ "./src/base.ts");
            /* harmony import */ var _dom_adapter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./dom-adapter */ "./src/dragdrop/dom-adapter.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            var DragDropCore = /** @class */ function() {
                function DragDropCore(surveyValue, creator, longTap, domAdapter) {
                    var _this = this;
                    var _a;
                    this.surveyValue = surveyValue;
                    this.creator = creator;
                    this._isBottom = null;
                    this.onGhostPositionChanged = new _base__WEBPACK_IMPORTED_MODULE_0__["EventBase"]();
                    this.onDragStart = new _base__WEBPACK_IMPORTED_MODULE_0__["EventBase"]();
                    this.onDragEnd = new _base__WEBPACK_IMPORTED_MODULE_0__["EventBase"]();
                    this.onBeforeDrop = this.onDragStart;
                    this.onAfterDrop = this.onDragEnd;
                    this.draggedElement = null;
                    this.dropTarget = null;
                    this.prevDropTarget = null;
                    this.allowDropHere = false;
                    this.banDropHere = function() {
                        _this.allowDropHere = false;
                        _this.doBanDropHere();
                        _this.dropTarget = null;
                        _this.domAdapter.draggedElementShortcut.style.cursor = "not-allowed";
                        _this.isBottom = null;
                    };
                    this.doBanDropHere = function() {};
                    this.domAdapter = domAdapter || new _dom_adapter__WEBPACK_IMPORTED_MODULE_1__["DragDropDOMAdapter"](this, longTap, (_a = this.survey) === null || _a === void 0 ? void 0 : _a.fitToContainer);
                }
                Object.defineProperty(DragDropCore.prototype, "isBottom", {
                    get: function() {
                        return !!this._isBottom;
                    },
                    set: function(val1) {
                        this._isBottom = val1;
                        this.ghostPositionChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                DragDropCore.prototype.ghostPositionChanged = function() {
                    this.onGhostPositionChanged.fire({}, {});
                };
                Object.defineProperty(DragDropCore.prototype, "dropTargetDataAttributeName", {
                    get: function() {
                        return "[data-sv-drop-target-" + this.draggedElementType + "]";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DragDropCore.prototype, "survey", {
                    get: function() {
                        var _a;
                        return this.surveyValue || ((_a = this.creator) === null || _a === void 0 ? void 0 : _a.survey);
                    },
                    enumerable: false,
                    configurable: true
                });
                DragDropCore.prototype.startDrag = function(event1, draggedElement, parentElement, draggedElementNode, preventSaveTargetNode) {
                    if (preventSaveTargetNode === void 0) preventSaveTargetNode = false;
                    this.domAdapter.rootContainer = this.getRootElement(this.survey, this.creator);
                    this.domAdapter.startDrag(event1, draggedElement, parentElement, draggedElementNode, preventSaveTargetNode);
                };
                DragDropCore.prototype.getRootElement = function(survey, creator) {
                    return creator ? creator.rootElement : survey.rootElement;
                };
                DragDropCore.prototype.dragInit = function(event1, draggedElement, parentElement, draggedElementNode) {
                    this.draggedElement = draggedElement;
                    this.parentElement = parentElement;
                    var shortcutText = this.getShortcutText(this.draggedElement);
                    this.domAdapter.draggedElementShortcut = this.createDraggedElementShortcut(shortcutText, draggedElementNode, event1);
                    this.onStartDrag(event1);
                };
                DragDropCore.prototype.onStartDrag = function(event1) {};
                DragDropCore.prototype.isDropTargetDoesntChanged = function(newIsBottom) {
                    return this.dropTarget === this.prevDropTarget && newIsBottom === this.isBottom;
                };
                DragDropCore.prototype.getShortcutText = function(draggedElement) {
                    return draggedElement.shortcutText;
                };
                DragDropCore.prototype.createDraggedElementShortcut = function(text, draggedElementNode, event1) {
                    var draggedElementShortcut = _global_variables_utils__WEBPACK_IMPORTED_MODULE_2__["DomDocumentHelper"].createElement("div");
                    if (!!draggedElementShortcut) {
                        draggedElementShortcut.innerText = text;
                        draggedElementShortcut.className = this.getDraggedElementClass();
                    }
                    return draggedElementShortcut;
                };
                DragDropCore.prototype.getDraggedElementClass = function() {
                    return "sv-dragged-element-shortcut";
                };
                DragDropCore.prototype.doDragOver = function() {};
                DragDropCore.prototype.afterDragOver = function(dropTargetNode) {};
                DragDropCore.prototype.findDropTargetNodeFromPoint = function(clientX, clientY) {
                    var displayProp = this.domAdapter.draggedElementShortcut.style.display;
                    //this.domAdapter.draggedElementShortcut.hidden = true;
                    this.domAdapter.draggedElementShortcut.style.display = "none";
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_2__["DomDocumentHelper"].isAvailable()) return null;
                    var dragOverNode = this.domAdapter.documentOrShadowRoot.elementFromPoint(clientX, clientY);
                    // this.domAdapter.draggedElementShortcut.hidden = false;
                    this.domAdapter.draggedElementShortcut.style.display = displayProp || "block";
                    if (!dragOverNode) return null;
                    return this.findDropTargetNodeByDragOverNode(dragOverNode);
                };
                DragDropCore.prototype.getDataAttributeValueByNode = function(node) {
                    var _this = this;
                    var datasetName = "svDropTarget";
                    var words = this.draggedElementType.split("-");
                    words.forEach(function(word) {
                        datasetName += _this.capitalizeFirstLetter(word);
                    });
                    return node.dataset[datasetName];
                };
                DragDropCore.prototype.getDropTargetByNode = function(dropTargetNode, event1) {
                    var dataAttributeValue = this.getDataAttributeValueByNode(dropTargetNode);
                    return this.getDropTargetByDataAttributeValue(dataAttributeValue, dropTargetNode, event1);
                };
                DragDropCore.prototype.capitalizeFirstLetter = function(string) {
                    return string.charAt(0).toUpperCase() + string.slice(1);
                };
                DragDropCore.prototype.calculateVerticalMiddleOfHTMLElement = function(HTMLElement) {
                    var rect = HTMLElement.getBoundingClientRect();
                    return rect.y + rect.height / 2;
                };
                DragDropCore.prototype.calculateHorizontalMiddleOfHTMLElement = function(HTMLElement) {
                    var rect = HTMLElement.getBoundingClientRect();
                    return rect.x + rect.width / 2;
                };
                DragDropCore.prototype.calculateIsBottom = function(clientY, dropTargetNode) {
                    return false;
                };
                DragDropCore.prototype.findDropTargetNodeByDragOverNode = function(dragOverNode) {
                    var dropTargetNode = dragOverNode.closest(this.dropTargetDataAttributeName);
                    return dropTargetNode;
                };
                DragDropCore.prototype.dragOver = function(event1) {
                    var dropTargetNode = this.findDropTargetNodeFromPoint(event1.clientX, event1.clientY);
                    if (!dropTargetNode) {
                        this.banDropHere();
                        return;
                    }
                    this.dropTarget = this.getDropTargetByNode(dropTargetNode, event1);
                    var isDropTargetValid = this.isDropTargetValid(this.dropTarget, dropTargetNode);
                    this.doDragOver();
                    if (!isDropTargetValid) {
                        this.banDropHere();
                        return;
                    }
                    var isBottom = this.calculateIsBottom(event1.clientY, dropTargetNode);
                    this.allowDropHere = true;
                    if (this.isDropTargetDoesntChanged(isBottom)) return;
                    this.isBottom = null; //TODO need for property change trigger with guarantee but it would be better not to watch on isBottom property but have some event like onValidTargetDragOver
                    this.isBottom = isBottom;
                    if (this.draggedElement != this.dropTarget) this.afterDragOver(dropTargetNode);
                    this.prevDropTarget = this.dropTarget;
                };
                DragDropCore.prototype.drop = function() {
                    if (this.allowDropHere) {
                        var fromElement = this.draggedElement.parent;
                        this.onDragStart.fire(this, {
                            fromElement: fromElement,
                            draggedElement: this.draggedElement
                        });
                        var newElement = this.doDrop();
                        this.onDragEnd.fire(this, {
                            fromElement: fromElement,
                            draggedElement: newElement,
                            toElement: this.dropTarget
                        });
                    }
                };
                DragDropCore.prototype.clear = function() {
                    this.dropTarget = null;
                    this.prevDropTarget = null;
                    this.draggedElement = null;
                    this.isBottom = null;
                    this.parentElement = null;
                };
                return DragDropCore;
            }();
        /***/ },
        /***/ "./src/dragdrop/dom-adapter.ts": /*!*************************************!*\
  !*** ./src/dragdrop/dom-adapter.ts ***!
  \*************************************/ /*! exports provided: DragDropDOMAdapter */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropDOMAdapter", function() {
                return DragDropDOMAdapter;
            });
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _utils_devices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/devices */ "./src/utils/devices.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../settings */ "./src/settings.ts");
            var __spreadArray = function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            /* eslint-disable no-restricted-globals */ // WebKit requires cancelable `touchmove` events to be added as early as possible
            // see https://bugs.webkit.org/show_bug.cgi?id=184250
            if (typeof window !== "undefined") window.addEventListener("touchmove", function(event1) {
                if (!DragDropDOMAdapter.PreventScrolling) return;
                // Prevent scrolling
                event1.preventDefault();
            }, {
                passive: false
            });
            var DragDropDOMAdapter = /** @class */ function() {
                function DragDropDOMAdapter(dd, longTap, fitToContainer) {
                    var _this = this;
                    if (longTap === void 0) longTap = true;
                    if (fitToContainer === void 0) fitToContainer = false;
                    this.dd = dd;
                    this.longTap = longTap;
                    this.fitToContainer = fitToContainer;
                    this.scrollIntervalId = null;
                    this.stopLongTapIfMoveEnough = function(pointerMoveEvent) {
                        pointerMoveEvent.preventDefault();
                        _this.currentX = pointerMoveEvent.pageX;
                        _this.currentY = pointerMoveEvent.pageY;
                        if (_this.isMicroMovement) return;
                        _this.returnUserSelectBack();
                        _this.stopLongTap();
                    };
                    this.stopLongTap = function(e) {
                        clearTimeout(_this.timeoutID);
                        _this.timeoutID = null;
                        document.removeEventListener("pointerup", _this.stopLongTap);
                        document.removeEventListener("pointermove", _this.stopLongTapIfMoveEnough);
                    };
                    this.handlePointerCancel = function(event1) {
                        _this.clear();
                    };
                    this.handleEscapeButton = function(event1) {
                        if (event1.keyCode == 27) _this.clear();
                    };
                    this.onContextMenu = function(event1) {
                        event1.preventDefault();
                        event1.stopPropagation();
                    };
                    this.dragOver = function(event1) {
                        _this.moveShortcutElement(event1);
                        _this.draggedElementShortcut.style.cursor = "grabbing";
                        _this.dd.dragOver(event1);
                    };
                    this.clear = function() {
                        cancelAnimationFrame(_this.scrollIntervalId);
                        document.removeEventListener("pointermove", _this.dragOver);
                        document.removeEventListener("pointercancel", _this.handlePointerCancel);
                        document.removeEventListener("keydown", _this.handleEscapeButton);
                        document.removeEventListener("pointerup", _this.drop);
                        _this.draggedElementShortcut.removeEventListener("pointerup", _this.drop);
                        if (_utils_devices__WEBPACK_IMPORTED_MODULE_1__["IsTouch"]) _this.draggedElementShortcut.removeEventListener("contextmenu", _this.onContextMenu);
                        _this.draggedElementShortcut.parentElement.removeChild(_this.draggedElementShortcut);
                        _this.dd.clear();
                        _this.draggedElementShortcut = null;
                        _this.scrollIntervalId = null;
                        if (_utils_devices__WEBPACK_IMPORTED_MODULE_1__["IsTouch"]) {
                            _this.savedTargetNode.style.cssText = null;
                            _this.savedTargetNode && _this.savedTargetNode.parentElement.removeChild(_this.savedTargetNode);
                            _this.insertNodeToParentAtIndex(_this.savedTargetNodeParent, _this.savedTargetNode, _this.savedTargetNodeIndex);
                            DragDropDOMAdapter.PreventScrolling = false;
                        }
                        _this.savedTargetNode = null;
                        _this.savedTargetNodeParent = null;
                        _this.savedTargetNodeIndex = null;
                        _this.returnUserSelectBack();
                    };
                    this.drop = function() {
                        _this.dd.drop();
                        _this.clear();
                    };
                    this.draggedElementShortcut = null;
                }
                Object.defineProperty(DragDropDOMAdapter.prototype, "documentOrShadowRoot", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment.root;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DragDropDOMAdapter.prototype, "rootElement", {
                    get: function() {
                        if (Object(_utils_utils__WEBPACK_IMPORTED_MODULE_0__["isShadowDOM"])(_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment.root)) return this.rootContainer || _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment.root.host;
                        else return this.rootContainer || _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment.root.documentElement || document.body;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DragDropDOMAdapter.prototype, "isMicroMovement", {
                    // see https://stackoverflow.com/questions/6042202/how-to-distinguish-mouse-click-and-drag
                    get: function() {
                        var delta = 5;
                        var diffX = Math.abs(this.currentX - this.startX);
                        var diffY = Math.abs(this.currentY - this.startY);
                        return diffX < delta && diffY < delta;
                    },
                    enumerable: false,
                    configurable: true
                });
                DragDropDOMAdapter.prototype.startLongTapProcessing = function(event1, draggedElement, parentElement, draggedElementNode, preventSaveTargetNode) {
                    var _this = this;
                    if (preventSaveTargetNode === void 0) preventSaveTargetNode = false;
                    this.startX = event1.pageX;
                    this.startY = event1.pageY;
                    document.body.style.setProperty("touch-action", "none", "important");
                    //document.body.style.setProperty("-webkit-touch-callout", "none", "important");
                    this.timeoutID = setTimeout(function() {
                        _this.doStartDrag(event1, draggedElement, parentElement, draggedElementNode);
                        if (!preventSaveTargetNode) {
                            _this.savedTargetNode = event1.target;
                            _this.savedTargetNode.style.cssText = "\n          position: absolute;\n          height: 1px!important;\n          width: 1px!important;\n          overflow: hidden;\n          clip: rect(1px 1px 1px 1px);\n          clip: rect(1px, 1px, 1px, 1px);\n        ";
                            _this.savedTargetNodeParent = _this.savedTargetNode.parentElement;
                            _this.savedTargetNodeIndex = _this.getNodeIndexInParent(_this.savedTargetNode);
                            _this.rootElement.appendChild(_this.savedTargetNode);
                        }
                        _this.stopLongTap();
                    }, this.longTap ? 500 : 0);
                    document.addEventListener("pointerup", this.stopLongTap);
                    document.addEventListener("pointermove", this.stopLongTapIfMoveEnough);
                };
                DragDropDOMAdapter.prototype.moveShortcutElement = function(event1) {
                    var rootElementX = this.rootElement.getBoundingClientRect().x;
                    var rootElementY = this.rootElement.getBoundingClientRect().y;
                    var rootElementScrollLeft = this.rootElement.scrollLeft;
                    var rootElementScrollTop = this.rootElement.scrollTop;
                    this.doScroll(event1.clientY, event1.clientX);
                    var shortcutHeight = this.draggedElementShortcut.offsetHeight;
                    var shortcutWidth = this.draggedElementShortcut.offsetWidth;
                    var shortcutXOffset = this.draggedElementShortcut.shortcutXOffset || shortcutWidth / 2;
                    var shortcutYOffset = this.draggedElementShortcut.shortcutYOffset || shortcutHeight / 2;
                    // TODO this is hot fix for RTL support. Probably we need better global strategy for it. https://github.com/surveyjs/survey-library/issues/4554
                    if (document.querySelectorAll("[dir='rtl']").length !== 0) {
                        shortcutXOffset = shortcutWidth / 2;
                        shortcutYOffset = shortcutHeight / 2;
                    }
                    var documentBottom = document.documentElement.clientHeight;
                    var documentRight = document.documentElement.clientWidth;
                    var pageX = event1.pageX;
                    var pageY = event1.pageY;
                    var clientX = event1.clientX;
                    var clientY = event1.clientY;
                    if (!!this.fitToContainer) {
                        rootElementX -= rootElementScrollLeft;
                        rootElementY -= rootElementScrollTop;
                    }
                    var shortcutBottomCoordinate = this.getShortcutBottomCoordinate(clientY, shortcutHeight, shortcutYOffset);
                    var shortcutRightCoordinate = this.getShortcutRightCoordinate(clientX, shortcutWidth, shortcutXOffset);
                    if (shortcutRightCoordinate >= documentRight) {
                        this.draggedElementShortcut.style.left = // pageX -
                        // clientX +
                        documentRight - shortcutWidth - rootElementX + "px";
                        this.draggedElementShortcut.style.top = /*pageY*/ clientY - shortcutYOffset - rootElementY + "px";
                        return;
                    }
                    if (clientX - shortcutXOffset <= 0) {
                        this.draggedElementShortcut.style.left = pageX - clientX - rootElementX + "px";
                        this.draggedElementShortcut.style.top = /*pageY*/ clientY - rootElementY - shortcutYOffset + "px";
                        return;
                    }
                    if (shortcutBottomCoordinate >= documentBottom) {
                        this.draggedElementShortcut.style.left = /*pageX*/ clientX - shortcutXOffset - rootElementX + "px";
                        this.draggedElementShortcut.style.top = // pageY -
                        // clientY +
                        documentBottom - shortcutHeight - rootElementY + "px";
                        return;
                    }
                    if (clientY - shortcutYOffset <= 0) {
                        this.draggedElementShortcut.style.left = clientX - shortcutXOffset - rootElementX + "px";
                        this.draggedElementShortcut.style.top = pageY - clientY - rootElementY + "px";
                        return;
                    }
                    this.draggedElementShortcut.style.left = clientX - rootElementX - shortcutXOffset + "px";
                    this.draggedElementShortcut.style.top = clientY - rootElementY - shortcutYOffset + "px";
                };
                DragDropDOMAdapter.prototype.getShortcutBottomCoordinate = function(currentY, shortcutHeight, shortcutYOffset) {
                    return currentY + shortcutHeight - shortcutYOffset;
                };
                DragDropDOMAdapter.prototype.getShortcutRightCoordinate = function(currentX, shortcutWidth, shortcutXOffset) {
                    return currentX + shortcutWidth - shortcutXOffset;
                };
                DragDropDOMAdapter.prototype.doScroll = function(clientY, clientX) {
                    var _this = this;
                    cancelAnimationFrame(this.scrollIntervalId);
                    var startScrollBoundary = 100;
                    var displayProp = this.draggedElementShortcut.style.display;
                    //this.draggedElementShortcut.hidden = true;
                    this.draggedElementShortcut.style.display = "none";
                    var dragOverNode = this.documentOrShadowRoot.elementFromPoint(clientX, clientY);
                    //this.draggedElementShortcut.hidden = false;
                    this.draggedElementShortcut.style.display = displayProp || "block";
                    var scrollableParentNode = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_0__["findScrollableParent"])(dragOverNode);
                    var top;
                    var bottom;
                    var left;
                    var right;
                    if (scrollableParentNode.tagName === "HTML") {
                        top = 0;
                        bottom = document.documentElement.clientHeight;
                        left = 0;
                        right = document.documentElement.clientWidth;
                    } else {
                        top = scrollableParentNode.getBoundingClientRect().top;
                        bottom = scrollableParentNode.getBoundingClientRect().bottom;
                        left = scrollableParentNode.getBoundingClientRect().left;
                        right = scrollableParentNode.getBoundingClientRect().right;
                    }
                    var repeat = function() {
                        if (clientY - top <= startScrollBoundary) scrollableParentNode.scrollTop -= 15;
                        else if (bottom - clientY <= startScrollBoundary) scrollableParentNode.scrollTop += 15;
                        else if (right - clientX <= startScrollBoundary) scrollableParentNode.scrollLeft += 15;
                        else if (clientX - left <= startScrollBoundary) scrollableParentNode.scrollLeft -= 15;
                        _this.scrollIntervalId = requestAnimationFrame(repeat);
                    };
                    this.scrollIntervalId = requestAnimationFrame(repeat);
                };
                DragDropDOMAdapter.prototype.doStartDrag = function(event1, draggedElement, parentElement, draggedElementNode) {
                    if (_utils_devices__WEBPACK_IMPORTED_MODULE_1__["IsTouch"]) DragDropDOMAdapter.PreventScrolling = true;
                    if (event1.which === 3) return; //right mouse btn
                    this.dd.dragInit(event1, draggedElement, parentElement, draggedElementNode);
                    this.rootElement.append(this.draggedElementShortcut);
                    this.moveShortcutElement(event1);
                    document.addEventListener("pointermove", this.dragOver);
                    document.addEventListener("pointercancel", this.handlePointerCancel);
                    document.addEventListener("keydown", this.handleEscapeButton);
                    document.addEventListener("pointerup", this.drop);
                    if (!_utils_devices__WEBPACK_IMPORTED_MODULE_1__["IsTouch"]) this.draggedElementShortcut.addEventListener("pointerup", this.drop);
                    else this.draggedElementShortcut.addEventListener("contextmenu", this.onContextMenu);
                };
                DragDropDOMAdapter.prototype.returnUserSelectBack = function() {
                    document.body.style.setProperty("touch-action", "auto");
                    document.body.style.setProperty("user-select", "auto");
                    document.body.style.setProperty("-webkit-user-select", "auto");
                //document.body.style.setProperty("-webkit-touch-callout", "default");
                };
                DragDropDOMAdapter.prototype.startDrag = function(event1, draggedElement, parentElement, draggedElementNode, preventSaveTargetNode) {
                    if (preventSaveTargetNode === void 0) preventSaveTargetNode = false;
                    document.body.style.setProperty("user-select", "none", "important");
                    document.body.style.setProperty("-webkit-user-select", "none", "important");
                    if (_utils_devices__WEBPACK_IMPORTED_MODULE_1__["IsTouch"]) {
                        this.startLongTapProcessing(event1, draggedElement, parentElement, draggedElementNode, preventSaveTargetNode);
                        return;
                    }
                    this.doStartDrag(event1, draggedElement, parentElement, draggedElementNode);
                };
                DragDropDOMAdapter.prototype.getNodeIndexInParent = function(node) {
                    return __spreadArray([], node.parentElement.childNodes).indexOf(node);
                };
                DragDropDOMAdapter.prototype.insertNodeToParentAtIndex = function(parent, node, index) {
                    parent.insertBefore(node, parent.childNodes[index]);
                };
                DragDropDOMAdapter.PreventScrolling = false;
                return DragDropDOMAdapter;
            }();
        /***/ },
        /***/ "./src/dragdrop/matrix-rows.ts": /*!*************************************!*\
  !*** ./src/dragdrop/matrix-rows.ts ***!
  \*************************************/ /*! exports provided: DragDropMatrixRows */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropMatrixRows", function() {
                return DragDropMatrixRows;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core */ "./src/dragdrop/core.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var DragDropMatrixRows = /** @class */ function(_super) {
                __extends(DragDropMatrixRows, _super);
                function DragDropMatrixRows() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.fromIndex = null;
                    _this.toIndex = null;
                    _this.doDrop = function() {
                        _this.parentElement.moveRowByIndex(_this.fromIndex, _this.toIndex);
                        return _this.parentElement;
                    };
                    return _this;
                }
                Object.defineProperty(DragDropMatrixRows.prototype, "draggedElementType", {
                    get: function() {
                        return "matrix-row";
                    },
                    enumerable: false,
                    configurable: true
                });
                DragDropMatrixRows.prototype.onStartDrag = function() {
                    var _body = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody();
                    if (!!_body) {
                        this.restoreUserSelectValue = _body.style.userSelect;
                        _body.style.userSelect = "none";
                    }
                };
                DragDropMatrixRows.prototype.createDraggedElementShortcut = function(text, draggedElementNode, event1) {
                    var _this = this;
                    var draggedElementShortcut = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].createElement("div");
                    if (!draggedElementShortcut) return;
                    // draggedElementShortcut.innerText = text;
                    draggedElementShortcut.style.cssText = " \n          cursor: grabbing;\n          position: absolute;\n          z-index: 10000;\n          font-family: var(--sjs-font-family, var(--font-family, var(--sjs-default-font-family)));\n        ";
                    var isDeepClone = true;
                    if (!!draggedElementNode) {
                        var row = draggedElementNode.closest("[data-sv-drop-target-matrix-row]");
                        var clone = row.cloneNode(isDeepClone);
                        clone.style.cssText = "\n        box-shadow: var(--sjs-shadow-large, 0px 8px 16px 0px rgba(0, 0, 0, 0.1)), var(--sjs-shadow-medium, 0px 2px 6px 0px rgba(0, 0, 0, 0.1));\n        background-color: var(--sjs-general-backcolor, var(--background, #fff));\n        display: flex;\n        flex-grow: 0;\n        flex-shrink: 0;\n        align-items: center;\n        line-height: 0;\n        width: " + row.offsetWidth + "px;\n      ";
                        clone.classList.remove("sv-matrix__drag-drop--moveup");
                        clone.classList.remove("sv-matrix__drag-drop--movedown");
                        this.draggedElement.isDragDropMoveDown = false;
                        this.draggedElement.isDragDropMoveUp = false;
                        draggedElementShortcut.appendChild(clone);
                        var rect = draggedElementNode.getBoundingClientRect();
                        draggedElementShortcut.shortcutXOffset = event1.clientX - rect.x;
                        draggedElementShortcut.shortcutYOffset = event1.clientY - rect.y;
                    }
                    //this.isBottom = null;
                    var renderedRows = this.parentElement.renderedTable.rows;
                    renderedRows.forEach(function(renderedRow, index) {
                        if (renderedRow.row === _this.draggedElement) renderedRow.isGhostRow = true;
                    });
                    this.fromIndex = this.parentElement.visibleRows.indexOf(this.draggedElement);
                    return draggedElementShortcut;
                };
                // protected ghostPositionChanged(): void {
                //   let ghostPosition;
                //   this.parentElement.renderedTable.rows.forEach(
                //     (renderedRow: QuestionMatrixDropdownRenderedRow) => {
                //       ghostPosition = this.getGhostPosition(
                //         renderedRow.row
                //       );
                //       renderedRow.isGhostRow = !ghostPosition;
                //     }
                //   );
                //   super.ghostPositionChanged();
                // }
                DragDropMatrixRows.prototype.getDropTargetByDataAttributeValue = function(dataAttributeValue) {
                    var matrix = this.parentElement;
                    var dropTargetRenderedRow;
                    dropTargetRenderedRow = matrix.renderedTable.rows.filter(function(renderedRow) {
                        return renderedRow.row && renderedRow.row.id === dataAttributeValue;
                    })[0];
                    return dropTargetRenderedRow.row;
                };
                DragDropMatrixRows.prototype.isDropTargetValid = function(dropTarget, dropTargetNode) {
                    return true;
                };
                DragDropMatrixRows.prototype.calculateIsBottom = function(clientY) {
                    var rendreredRows = this.parentElement.renderedTable.rows;
                    var rows = rendreredRows.map(function(rendredRow) {
                        return rendredRow.row;
                    });
                    return rows.indexOf(this.dropTarget) - rows.indexOf(this.draggedElement) > 0;
                };
                DragDropMatrixRows.prototype.afterDragOver = function(dropTargetNode) {
                    var _this = this;
                    if (this.isDropTargetDoesntChanged(this.isBottom)) return;
                    var dropTargetIndex;
                    var draggedElementIndex;
                    var draggedRenderedRow;
                    var renderedRows = this.parentElement.renderedTable.rows;
                    renderedRows.forEach(function(renderedRow, index) {
                        if (renderedRow.row === _this.dropTarget) // renderedRow.isGhostRow = true;
                        dropTargetIndex = index;
                        if (renderedRow.row === _this.draggedElement) {
                            draggedRenderedRow = renderedRow;
                            draggedElementIndex = index;
                            draggedRenderedRow.isGhostRow = true;
                        }
                    });
                    renderedRows.splice(draggedElementIndex, 1);
                    renderedRows.splice(dropTargetIndex, 0, draggedRenderedRow);
                    this.toIndex = this.parentElement.visibleRows.indexOf(this.dropTarget);
                    // const matrix = this.parentElement;
                    // const fromIndex = matrix.visibleRows.indexOf(this.draggedElement);
                    // const toIndex = matrix.visibleRows.indexOf(this.dropTarget);
                    // matrix.moveRowByIndex(fromIndex, toIndex);
                    // if (draggedElementIndex !== dropTargetIndex) {
                    //   dropTargetNode.classList.remove("sv-matrix__drag-drop--moveup");
                    //   dropTargetNode.classList.remove("sv-matrix__drag-drop--movedown");
                    //   this.dropTarget.isDragDropMoveDown = false;
                    //   this.dropTarget.isDragDropMoveUp = false;
                    // }
                    // if (draggedElementIndex > dropTargetIndex) {
                    //   this.dropTarget.isDragDropMoveDown = true;
                    // }
                    // if (draggedElementIndex < dropTargetIndex) {
                    //   this.dropTarget.isDragDropMoveUp = true;
                    // }
                    _super.prototype.ghostPositionChanged.call(this);
                };
                DragDropMatrixRows.prototype.clear = function() {
                    var renderedRows = this.parentElement.renderedTable.rows;
                    renderedRows.forEach(function(renderedRow) {
                        renderedRow.isGhostRow = false;
                    });
                    this.parentElement.clearOnDrop();
                    this.fromIndex = null;
                    this.toIndex = null;
                    var _body = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody();
                    if (!!_body) _body.style.userSelect = this.restoreUserSelectValue || "initial";
                    _super.prototype.clear.call(this);
                };
                return DragDropMatrixRows;
            }(_core__WEBPACK_IMPORTED_MODULE_1__["DragDropCore"]);
        /***/ },
        /***/ "./src/dragdrop/ranking-choices.ts": /*!*****************************************!*\
  !*** ./src/dragdrop/ranking-choices.ts ***!
  \*****************************************/ /*! exports provided: DragDropRankingChoices */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropRankingChoices", function() {
                return DragDropRankingChoices;
            });
            /* harmony import */ var _choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./choices */ "./src/dragdrop/choices.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_devices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/devices */ "./src/utils/devices.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var DragDropRankingChoices = /** @class */ function(_super) {
                __extends(DragDropRankingChoices, _super);
                function DragDropRankingChoices() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.isDragOverRootNode = false;
                    _this.doDragOver = function() {
                        var node = _this.domAdapter.draggedElementShortcut.querySelector(".sv-ranking-item");
                        node.style.cursor = "grabbing";
                    };
                    _this.doBanDropHere = function() {
                        if (_this.isDragOverRootNode) {
                            _this.allowDropHere = true;
                            return;
                        }
                        var node = _this.domAdapter.draggedElementShortcut.querySelector(".sv-ranking-item");
                        node.style.cursor = "not-allowed";
                    };
                    return _this;
                }
                Object.defineProperty(DragDropRankingChoices.prototype, "draggedElementType", {
                    get: function() {
                        return "ranking-item";
                    },
                    enumerable: false,
                    configurable: true
                });
                DragDropRankingChoices.prototype.createDraggedElementShortcut = function(text, draggedElementNode, event1) {
                    var draggedElementShortcut = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].createElement("div");
                    if (!draggedElementShortcut) return;
                    draggedElementShortcut.className = this.shortcutClass + " sv-ranking-shortcut";
                    draggedElementShortcut.style.cssText = " \n          cursor: grabbing;\n          position: absolute;\n          z-index: 10000;\n          border-radius: calc(12.5 * var(--sjs-base-unit, var(--base-unit, 8px)));\n          min-width: 100px;\n          max-width: 400px;\n          box-shadow: var(--sjs-shadow-medium, 0px 2px 6px 0px rgba(0, 0, 0, 0.1)), var(--sjs-shadow-large, 0px 8px 16px 0px rgba(0, 0, 0, 0.1));\n          background-color: var(--sjs-general-backcolor, var(--background, #fff));\n          font-family: var(--sjs-font-family, var(--font-family, var(--sjs-default-font-family)));\n        ";
                    var isDeepClone = true;
                    var clone = draggedElementNode.cloneNode(isDeepClone);
                    draggedElementShortcut.appendChild(clone);
                    var rect = draggedElementNode.getBoundingClientRect();
                    draggedElementShortcut.shortcutXOffset = event1.clientX - rect.x;
                    draggedElementShortcut.shortcutYOffset = event1.clientY - rect.y;
                    if (this.parentElement && this.parentElement.useFullItemSizeForShortcut) {
                        draggedElementShortcut.style.width = draggedElementNode.offsetWidth + "px";
                        draggedElementShortcut.style.height = draggedElementNode.offsetHeight + "px";
                    }
                    return draggedElementShortcut;
                };
                Object.defineProperty(DragDropRankingChoices.prototype, "shortcutClass", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_1__["CssClassBuilder"]().append(this.parentElement.cssClasses.root).append(this.parentElement.cssClasses.rootMobileMod, _utils_devices__WEBPACK_IMPORTED_MODULE_2__["IsMobile"]).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                DragDropRankingChoices.prototype.getDropTargetByDataAttributeValue = function(dataAttributeValue) {
                    return this.parentElement.rankingChoices[dataAttributeValue];
                };
                DragDropRankingChoices.prototype.findDropTargetNodeByDragOverNode = function(dragOverNode) {
                    this.isDragOverRootNode = this.getIsDragOverRootNode(dragOverNode);
                    return _super.prototype.findDropTargetNodeByDragOverNode.call(this, dragOverNode);
                };
                DragDropRankingChoices.prototype.getIsDragOverRootNode = function(dragOverNode) {
                    // dragOverNode might be <path></path> for example and the className prop is obj
                    return typeof dragOverNode.className === "string" && dragOverNode.className.indexOf("sv-ranking") !== -1;
                };
                DragDropRankingChoices.prototype.isDropTargetValid = function(dropTarget, dropTargetNode) {
                    var choices = this.parentElement.rankingChoices;
                    var dropTargetIndex = choices.indexOf(this.dropTarget);
                    var draggedElementIndex = choices.indexOf(this.draggedElement);
                    if (draggedElementIndex > dropTargetIndex && dropTargetNode.classList.contains("sv-dragdrop-moveup")) {
                        this.parentElement.dropTargetNodeMove = null;
                        return false;
                    }
                    if (draggedElementIndex < dropTargetIndex && dropTargetNode.classList.contains("sv-dragdrop-movedown")) {
                        this.parentElement.dropTargetNodeMove = null;
                        return false;
                    }
                    if (choices.indexOf(dropTarget) === -1) // shouldn't allow to drop on "adorners" (selectall, none, other)
                    return false;
                    return true;
                };
                DragDropRankingChoices.prototype.calculateIsBottom = function(clientY) {
                    var choices = this.parentElement.rankingChoices;
                    return choices.indexOf(this.dropTarget) - choices.indexOf(this.draggedElement) > 0;
                };
                DragDropRankingChoices.prototype.afterDragOver = function(dropTargetNode) {
                    var choices = this.parentElement.rankingChoices;
                    var dropTargetIndex = choices.indexOf(this.dropTarget);
                    var draggedElementIndex = choices.indexOf(this.draggedElement);
                    choices.splice(draggedElementIndex, 1);
                    choices.splice(dropTargetIndex, 0, this.draggedElement);
                    this.parentElement.setPropertyValue("rankingChoices", choices);
                    //return;
                    this.updateDraggedElementShortcut(dropTargetIndex + 1);
                    if (draggedElementIndex !== dropTargetIndex) {
                        dropTargetNode.classList.remove("sv-dragdrop-moveup");
                        dropTargetNode.classList.remove("sv-dragdrop-movedown");
                        this.parentElement.dropTargetNodeMove = null;
                    }
                    if (draggedElementIndex > dropTargetIndex) this.parentElement.dropTargetNodeMove = "down";
                    if (draggedElementIndex < dropTargetIndex) this.parentElement.dropTargetNodeMove = "up";
                };
                DragDropRankingChoices.prototype.updateDraggedElementShortcut = function(newIndex) {
                    var newIndexText = newIndex !== null ? newIndex + "" : "";
                    // TODO should avoid direct DOM manipulation, do through the frameworks instead
                    var indexNode = this.domAdapter.draggedElementShortcut.querySelector(".sv-ranking-item__index");
                    indexNode.innerText = newIndexText;
                };
                DragDropRankingChoices.prototype.ghostPositionChanged = function() {
                    this.parentElement.currentDropTarget = this.draggedElement;
                    _super.prototype.ghostPositionChanged.call(this);
                };
                DragDropRankingChoices.prototype.doDrop = function() {
                    this.parentElement.setValue();
                    return this.parentElement;
                };
                DragDropRankingChoices.prototype.clear = function() {
                    if (!!this.parentElement) {
                        this.parentElement.dropTargetNodeMove = null;
                        this.parentElement.updateRankingChoices(true);
                    }
                    _super.prototype.clear.call(this);
                };
                return DragDropRankingChoices;
            }(_choices__WEBPACK_IMPORTED_MODULE_0__["DragDropChoices"]);
        /***/ },
        /***/ "./src/dragdrop/ranking-select-to-rank.ts": /*!************************************************!*\
  !*** ./src/dragdrop/ranking-select-to-rank.ts ***!
  \************************************************/ /*! exports provided: DragDropRankingSelectToRank */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragDropRankingSelectToRank", function() {
                return DragDropRankingSelectToRank;
            });
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _ranking_choices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./ranking-choices */ "./src/dragdrop/ranking-choices.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var DragDropRankingSelectToRank = /** @class */ function(_super) {
                __extends(DragDropRankingSelectToRank, _super);
                function DragDropRankingSelectToRank() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.selectToRank = function(questionModel, fromIndex, toIndex) {
                        var rankingChoices = [].concat(questionModel.rankingChoices);
                        var unRankingChoices = questionModel.unRankingChoices;
                        var item = unRankingChoices[fromIndex];
                        rankingChoices.splice(toIndex, 0, item);
                        _this.updateChoices(questionModel, rankingChoices);
                    };
                    _this.unselectFromRank = function(questionModel, fromIndex, toIndex) {
                        var rankingChoices = [].concat(questionModel.rankingChoices);
                        rankingChoices.splice(fromIndex, 1);
                        _this.updateChoices(questionModel, rankingChoices);
                    };
                    _this.reorderRankedItem = function(questionModel, fromIndex, toIndex, dropTargetNode) {
                        var rankingChoices = questionModel.rankingChoices;
                        var item = rankingChoices[fromIndex];
                        if (fromIndex == toIndex) return;
                        questionModel.isValueSetByUser = true;
                        rankingChoices.splice(fromIndex, 1);
                        rankingChoices.splice(toIndex, 0, item);
                        questionModel.setPropertyValue("rankingChoices", rankingChoices);
                        if (dropTargetNode) _this.doUIEffects(dropTargetNode, fromIndex, toIndex);
                    };
                    return _this;
                }
                DragDropRankingSelectToRank.prototype.findDropTargetNodeByDragOverNode = function(dragOverNode) {
                    if (dragOverNode.dataset.ranking === "from-container" || dragOverNode.dataset.ranking === "to-container") return dragOverNode;
                    var toContainer = dragOverNode.closest("[data-ranking='to-container']");
                    var fromContainer = dragOverNode.closest("[data-ranking='from-container']");
                    if (this.parentElement.unRankingChoices.length === 0 && fromContainer) return fromContainer;
                    if (this.parentElement.rankingChoices.length === 0 && toContainer) return toContainer;
                    return _super.prototype.findDropTargetNodeByDragOverNode.call(this, dragOverNode);
                };
                DragDropRankingSelectToRank.prototype.getDropTargetByDataAttributeValue = function(dataAttributeValue) {
                    return this.parentElement.rankingChoices[dataAttributeValue] || this.parentElement.unRankingChoices[dataAttributeValue];
                };
                DragDropRankingSelectToRank.prototype.getDropTargetByNode = function(dropTargetNode, event1) {
                    if (dropTargetNode.dataset.ranking === "to-container") return "to-container";
                    if (dropTargetNode.dataset.ranking === "from-container" || dropTargetNode.closest("[data-ranking='from-container']")) return "from-container";
                    return _super.prototype.getDropTargetByNode.call(this, dropTargetNode, event1);
                };
                DragDropRankingSelectToRank.prototype.isDropTargetValid = function(dropTarget, dropTargetNode) {
                    if (dropTarget === "to-container" || dropTarget === "from-container") return true;
                    else return _super.prototype.isDropTargetValid.call(this, dropTarget, dropTargetNode);
                };
                DragDropRankingSelectToRank.prototype.afterDragOver = function(dropTargetNode) {
                    var questionModel = this.parentElement;
                    var rankingChoices = questionModel.rankingChoices;
                    var unRankingChoices = questionModel.unRankingChoices;
                    if (this.isDraggedElementUnranked && this.isDropTargetRanked) {
                        this.doRankBetween(dropTargetNode, unRankingChoices, rankingChoices, this.selectToRank);
                        return;
                    }
                    if (this.isDraggedElementRanked && this.isDropTargetRanked) {
                        this.doRankBetween(dropTargetNode, rankingChoices, rankingChoices, this.reorderRankedItem);
                        return;
                    }
                    if (this.isDraggedElementRanked && !this.isDropTargetRanked) {
                        this.doRankBetween(dropTargetNode, rankingChoices, unRankingChoices, this.unselectFromRank);
                        return;
                    }
                };
                DragDropRankingSelectToRank.prototype.doRankBetween = function(dropTargetNode, fromChoicesArray, toChoicesArray, rankFunction) {
                    var questionModel = this.parentElement;
                    var _a = this.getIndixies(questionModel, fromChoicesArray, toChoicesArray), fromIndex = _a.fromIndex, toIndex = _a.toIndex;
                    rankFunction(questionModel, fromIndex, toIndex, dropTargetNode);
                };
                DragDropRankingSelectToRank.prototype.getIndixies = function(model, fromChoicesArray, toChoicesArray) {
                    var fromIndex = fromChoicesArray.indexOf(this.draggedElement);
                    var toIndex = toChoicesArray.indexOf(this.dropTarget);
                    if (toIndex === -1) {
                        var length_1 = model.value.length;
                        toIndex = length_1;
                    } else if (fromChoicesArray == toChoicesArray) {
                        if (!this.isBottom && fromIndex < toIndex) toIndex--;
                        if (this.isBottom && fromIndex > toIndex) toIndex++;
                    } else if (fromChoicesArray != toChoicesArray) {
                        if (this.isBottom) toIndex++;
                    }
                    return {
                        fromIndex: fromIndex,
                        toIndex: toIndex
                    };
                };
                DragDropRankingSelectToRank.prototype.calculateIsBottom = function(clientY, dropTargetNode) {
                    if (this.dropTarget instanceof _itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"] && this.draggedElement !== this.dropTarget) {
                        var rect = dropTargetNode.getBoundingClientRect();
                        return clientY >= rect.y + rect.height / 2;
                    }
                    return _super.prototype.calculateIsBottom.call(this, clientY);
                };
                DragDropRankingSelectToRank.prototype.doUIEffects = function(dropTargetNode, fromIndex, toIndex) {
                    var questionModel = this.parentElement;
                    var isDropToEmptyRankedContainer = this.dropTarget === "to-container" && questionModel.isEmpty();
                    var isNeedToShowIndexAtShortcut = !this.isDropTargetUnranked || isDropToEmptyRankedContainer;
                    var shortcutIndex = isNeedToShowIndexAtShortcut ? toIndex + 1 : null;
                    this.updateDraggedElementShortcut(shortcutIndex);
                    if (fromIndex !== toIndex) {
                        dropTargetNode.classList.remove("sv-dragdrop-moveup");
                        dropTargetNode.classList.remove("sv-dragdrop-movedown");
                        questionModel.dropTargetNodeMove = null;
                    }
                    if (fromIndex > toIndex) questionModel.dropTargetNodeMove = "down";
                    if (fromIndex < toIndex) questionModel.dropTargetNodeMove = "up";
                };
                Object.defineProperty(DragDropRankingSelectToRank.prototype, "isDraggedElementRanked", {
                    get: function() {
                        return this.parentElement.rankingChoices.indexOf(this.draggedElement) !== -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DragDropRankingSelectToRank.prototype, "isDropTargetRanked", {
                    get: function() {
                        if (this.dropTarget === "to-container") return true;
                        return this.parentElement.rankingChoices.indexOf(this.dropTarget) !== -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DragDropRankingSelectToRank.prototype, "isDraggedElementUnranked", {
                    get: function() {
                        return !this.isDraggedElementRanked;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DragDropRankingSelectToRank.prototype, "isDropTargetUnranked", {
                    get: function() {
                        return !this.isDropTargetRanked;
                    },
                    enumerable: false,
                    configurable: true
                });
                DragDropRankingSelectToRank.prototype.updateChoices = function(questionModel, rankingChoices) {
                    questionModel.isValueSetByUser = true;
                    questionModel.rankingChoices = rankingChoices;
                    questionModel.updateUnRankingChoices(rankingChoices);
                };
                DragDropRankingSelectToRank.prototype.clear = function() {
                    var questionModel = this.parentElement;
                    if (!!questionModel) {
                        questionModel.rankingChoicesAnimation.cancel();
                        questionModel.unRankingChoicesAnimation.cancel();
                    }
                    _super.prototype.clear.call(this);
                };
                return DragDropRankingSelectToRank;
            }(_ranking_choices__WEBPACK_IMPORTED_MODULE_1__["DragDropRankingChoices"]);
        /***/ },
        /***/ "./src/dropdownListModel.ts": /*!**********************************!*\
  !*** ./src/dropdownListModel.ts ***!
  \**********************************/ /*! exports provided: DropdownListModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownListModel", function() {
                return DropdownListModel;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./list */ "./src/list.ts");
            /* harmony import */ var _popup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./popup */ "./src/popup.ts");
            /* harmony import */ var _question_dropdown__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./question_dropdown */ "./src/question_dropdown.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_devices__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utils/devices */ "./src/utils/devices.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var DropdownListModel = /** @class */ function(_super) {
                __extends(DropdownListModel, _super);
                function DropdownListModel(question, onSelectionChanged) {
                    var _this = _super.call(this) || this;
                    _this.question = question;
                    _this.onSelectionChanged = onSelectionChanged;
                    _this.minPageSize = 25;
                    _this.loadingItemHeight = 40;
                    _this._markdownMode = false;
                    _this.filteredItems = undefined;
                    _this.selectedItemSelector = ".sv-list__item--selected";
                    _this.itemSelector = ".sv-list__item";
                    _this.itemsSettings = {
                        skip: 0,
                        take: 0,
                        totalCount: 0,
                        items: []
                    };
                    _this.isRunningLoadQuestionChoices = false;
                    _this.popupCssClasses = "sv-single-select-list";
                    _this.listModelFilterStringChanged = function(newValue) {
                        if (_this.filterString !== newValue) _this.filterString = newValue;
                    };
                    _this.qustionPropertyChangedHandler = function(sender, options) {
                        _this.onPropertyChangedHandler(sender, options);
                    };
                    _this.htmlCleanerElement = _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__["DomDocumentHelper"].createElement("div");
                    question.onPropertyChanged.add(_this.qustionPropertyChangedHandler);
                    _this.showInputFieldComponent = _this.question.showInputFieldComponent;
                    _this.listModel = _this.createListModel();
                    _this.updateAfterListModelCreated(_this.listModel);
                    _this.setSearchEnabled(_this.question.searchEnabled);
                    _this.setTextWrapEnabled(_this.question.textWrapEnabled);
                    _this.createPopup();
                    _this.resetItemsSettings();
                    return _this;
                }
                Object.defineProperty(DropdownListModel.prototype, "focusFirstInputSelector", {
                    get: function() {
                        return this.getFocusFirstInputSelector();
                    },
                    enumerable: false,
                    configurable: true
                });
                DropdownListModel.prototype.getFocusFirstInputSelector = function() {
                    if (_utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"]) return this.isValueEmpty(this.question.value) ? this.itemSelector : this.selectedItemSelector;
                    else return !this.listModel.showFilter && !!this.question.value ? this.selectedItemSelector : "";
                };
                DropdownListModel.prototype.resetItemsSettings = function() {
                    this.itemsSettings.skip = 0;
                    this.itemsSettings.take = Math.max(this.minPageSize, this.question.choicesLazyLoadPageSize);
                    this.itemsSettings.totalCount = 0;
                    this.itemsSettings.items = [];
                };
                DropdownListModel.prototype.setItems = function(items, totalCount) {
                    this.itemsSettings.items = [].concat(this.itemsSettings.items, items);
                    this.itemsSettings.totalCount = totalCount;
                    this.listModel.isAllDataLoaded = this.question.choicesLazyLoadEnabled && this.itemsSettings.items.length == this.itemsSettings.totalCount;
                    this.question.choices = this.itemsSettings.items;
                };
                DropdownListModel.prototype.updateQuestionChoices = function(callbackAfterItemsLoaded) {
                    var _this = this;
                    if (this.isRunningLoadQuestionChoices) return;
                    var isUpdate = this.itemsSettings.skip + 1 < this.itemsSettings.totalCount;
                    if (!this.itemsSettings.skip || isUpdate) {
                        this.isRunningLoadQuestionChoices = true;
                        this.question.survey.loadQuestionChoices({
                            question: this.question,
                            filter: this.filterString,
                            skip: this.itemsSettings.skip,
                            take: this.itemsSettings.take,
                            setItems: function(items, totalCount) {
                                _this.isRunningLoadQuestionChoices = false;
                                _this.setItems(items || [], totalCount || 0);
                                _this.popupRecalculatePosition(_this.itemsSettings.skip === _this.itemsSettings.take);
                                if (!!callbackAfterItemsLoaded) callbackAfterItemsLoaded();
                            }
                        });
                        this.itemsSettings.skip += this.itemsSettings.take;
                    }
                };
                DropdownListModel.prototype.updatePopupFocusFirstInputSelector = function() {
                    this._popupModel.focusFirstInputSelector = this.focusFirstInputSelector;
                };
                DropdownListModel.prototype.createPopup = function() {
                    var _this = this;
                    this._popupModel = new _popup__WEBPACK_IMPORTED_MODULE_5__["PopupModel"]("sv-list", {
                        model: this.listModel
                    }, "bottom", "center", false);
                    this._popupModel.displayMode = _utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"] ? "overlay" : "popup";
                    this._popupModel.positionMode = "fixed";
                    this._popupModel.isFocusedContainer = false;
                    this._popupModel.isFocusedContent = _utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"];
                    this._popupModel.setWidthByTarget = !_utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"];
                    this.updatePopupFocusFirstInputSelector();
                    this.listModel.registerPropertyChangedHandlers([
                        "showFilter"
                    ], function() {
                        _this.updatePopupFocusFirstInputSelector();
                    });
                    this._popupModel.cssClass = this.popupCssClasses;
                    this._popupModel.onVisibilityChanged.add(function(_, option) {
                        if (option.isVisible) _this.listModel.renderElements = true;
                        if (option.isVisible && _this.question.choicesLazyLoadEnabled) {
                            _this.listModel.actions = [];
                            _this.updateQuestionChoices();
                        }
                        if (option.isVisible && !!_this.question.onOpenedCallBack) {
                            _this.updatePopupFocusFirstInputSelector();
                            _this.question.onOpenedCallBack();
                        }
                        if (!option.isVisible) {
                            _this.onHidePopup();
                            if (_this.question.choicesLazyLoadEnabled) _this.resetItemsSettings();
                        }
                        _this.question.processPopupVisiblilityChanged(_this.popupModel, option.isVisible);
                    });
                };
                DropdownListModel.prototype.setFilterStringToListModel = function(newValue) {
                    var _this = this;
                    this.listModel.filterString = newValue;
                    this.listModel.resetFocusedItem();
                    if (this.question.selectedItem && this.question.selectedItem.text.indexOf(newValue) >= 0) {
                        this.listModel.focusedItem = this.getAvailableItems().filter(function(item) {
                            return item.id == _this.question.selectedItem.value;
                        })[0];
                        if (this.listModel.filterString) this.listModel.actions.map(function(a) {
                            return a.selectedValue = false;
                        });
                        return;
                    }
                    if (!this.listModel.focusedItem || !this.listModel.isItemVisible(this.listModel.focusedItem)) this.listModel.focusFirstVisibleItem();
                };
                DropdownListModel.prototype.setTextWrapEnabled = function(newValue) {
                    this.listModel.textWrapEnabled = newValue;
                };
                DropdownListModel.prototype.popupRecalculatePosition = function(isResetHeight) {
                    var _this = this;
                    setTimeout(function() {
                        _this.popupModel.recalculatePosition(isResetHeight);
                    }, 1);
                };
                DropdownListModel.prototype.onHidePopup = function() {
                    this.resetFilterString();
                    this.question.suggestedItem = null;
                    this.listModel.refresh();
                };
                DropdownListModel.prototype.getAvailableItems = function() {
                    return this.question.visibleChoices;
                };
                DropdownListModel.prototype.setOnTextSearchCallbackForListModel = function(listModel) {
                    var _this = this;
                    listModel.setOnTextSearchCallback(function(item, textToSearch) {
                        if (_this.filteredItems) return _this.filteredItems.indexOf(item) >= 0;
                        var textInLow = item.text.toLocaleLowerCase();
                        textInLow = _settings__WEBPACK_IMPORTED_MODULE_7__["settings"].comparator.normalizeTextCallback(textInLow, "filter");
                        var index = textInLow.indexOf(textToSearch.toLocaleLowerCase());
                        return _this.question.searchMode == "startsWith" ? index == 0 : index > -1;
                    });
                };
                DropdownListModel.prototype.createListModel = function() {
                    var _this = this;
                    var visibleItems = this.getAvailableItems();
                    var _onSelectionChanged = this.onSelectionChanged;
                    if (!_onSelectionChanged) _onSelectionChanged = function(item) {
                        _this.question.value = item.id;
                        if (_this.question.searchEnabled) _this.applyInputString(item);
                        _this.popupModel.isVisible = false;
                    };
                    var res = new _list__WEBPACK_IMPORTED_MODULE_4__["ListModel"](visibleItems, _onSelectionChanged, false, undefined, this.question.choicesLazyLoadEnabled ? this.listModelFilterStringChanged : undefined, this.listElementId);
                    this.setOnTextSearchCallbackForListModel(res);
                    res.renderElements = false;
                    res.forceShowFilter = true;
                    res.areSameItemsCallback = function(item1, item2) {
                        return item1 === item2;
                    };
                    return res;
                };
                DropdownListModel.prototype.updateAfterListModelCreated = function(model) {
                    var _this = this;
                    model.isItemSelected = function(action) {
                        return !!action.selected;
                    };
                    model.locOwner = this.question;
                    model.onPropertyChanged.add(function(sender, options) {
                        if (options.name == "hasVerticalScroller") _this.hasScroll = options.newValue;
                    });
                    model.isAllDataLoaded = !this.question.choicesLazyLoadEnabled;
                };
                DropdownListModel.prototype.updateCssClasses = function(popupCssClass, listCssClasses) {
                    this.popupModel.cssClass = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_8__["CssClassBuilder"]().append(popupCssClass).append(this.popupCssClasses).toString();
                    this.listModel.cssClasses = listCssClasses;
                };
                DropdownListModel.prototype.resetFilterString = function() {
                    if (!!this.filterString) this.filterString = undefined;
                };
                DropdownListModel.prototype.clear = function() {
                    this.inputString = null;
                    this.hintString = "";
                    this.resetFilterString();
                };
                DropdownListModel.prototype.onSetFilterString = function() {
                    var _this = this;
                    this.filteredItems = undefined;
                    if (!this.filterString && !this.popupModel.isVisible) return;
                    var options = {
                        question: this.question,
                        choices: this.getAvailableItems(),
                        filter: this.filterString,
                        filteredChoices: undefined
                    };
                    this.question.survey.onChoicesSearch.fire(this.question.survey, options);
                    this.filteredItems = options.filteredChoices;
                    if (!!this.filterString && !this.popupModel.isVisible) this.popupModel.isVisible = true;
                    var updateAfterFilterStringChanged = function() {
                        _this.setFilterStringToListModel(_this.filterString);
                        _this.popupRecalculatePosition(true);
                    };
                    if (this.question.choicesLazyLoadEnabled) {
                        this.resetItemsSettings();
                        this.updateQuestionChoices(updateAfterFilterStringChanged);
                    } else updateAfterFilterStringChanged();
                };
                Object.defineProperty(DropdownListModel.prototype, "isAllDataLoaded", {
                    get: function() {
                        return !!this.itemsSettings.totalCount && this.itemsSettings.items.length == this.itemsSettings.totalCount;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "canShowSelectedItem", {
                    get: function() {
                        return !this.focused || this._markdownMode || !this.searchEnabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                DropdownListModel.prototype.applyInputString = function(item) {
                    var hasHtml = item === null || item === void 0 ? void 0 : item.locText.hasHtml;
                    if (hasHtml || this.question.inputFieldComponentName) {
                        this._markdownMode = true;
                        this.inputString = this.cleanHtml(item === null || item === void 0 ? void 0 : item.locText.getHtmlValue());
                        this.hintString = "";
                    } else {
                        this.inputString = item === null || item === void 0 ? void 0 : item.title;
                        this.hintString = item === null || item === void 0 ? void 0 : item.title;
                    }
                };
                DropdownListModel.prototype.cleanHtml = function(html) {
                    if (!this.htmlCleanerElement) return "";
                    this.htmlCleanerElement.innerHTML = html;
                    return this.htmlCleanerElement.textContent;
                };
                DropdownListModel.prototype.fixInputCase = function() {
                    var hintStringMiddle = this.hintStringMiddle;
                    if (hintStringMiddle && this.inputString != hintStringMiddle) this.inputString = hintStringMiddle;
                };
                DropdownListModel.prototype.applyHintString = function(item) {
                    var hasHtml = item === null || item === void 0 ? void 0 : item.locText.hasHtml;
                    if (hasHtml || this.question.inputFieldComponentName) {
                        this._markdownMode = true;
                        this.hintString = "";
                    } else this.hintString = item === null || item === void 0 ? void 0 : item.title;
                };
                Object.defineProperty(DropdownListModel.prototype, "inputStringRendered", {
                    get: function() {
                        return this.inputString || "";
                    },
                    set: function(val1) {
                        this.inputString = val1;
                        this.filterString = val1;
                        if (!val1) this.hintString = "";
                        else this.applyHintString(this.listModel.focusedItem || this.question.selectedItem);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "placeholderRendered", {
                    get: function() {
                        return this.hintString ? "" : this.question.readOnlyText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "listElementId", {
                    get: function() {
                        return this.question.inputId + "_list";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "hintStringLC", {
                    get: function() {
                        var _a;
                        return ((_a = this.hintString) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "inputStringLC", {
                    get: function() {
                        var _a;
                        return ((_a = this.inputString) === null || _a === void 0 ? void 0 : _a.toLowerCase()) || "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "showHintPrefix", {
                    get: function() {
                        return !!this.inputString && this.hintStringLC.indexOf(this.inputStringLC) > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "hintStringPrefix", {
                    get: function() {
                        if (!this.inputString) return null;
                        return this.hintString.substring(0, this.hintStringLC.indexOf(this.inputStringLC));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "showHintString", {
                    get: function() {
                        return !!this.question.searchEnabled && this.hintStringLC && this.hintStringLC.indexOf(this.inputStringLC) >= 0 || !this.question.searchEnabled && this.hintStringLC && this.question.isEmpty();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "hintStringSuffix", {
                    get: function() {
                        return this.hintString.substring(this.hintStringLC.indexOf(this.inputStringLC) + this.inputStringLC.length);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "hintStringMiddle", {
                    get: function() {
                        var start = this.hintStringLC.indexOf(this.inputStringLC);
                        if (start == -1) return null;
                        return this.hintString.substring(start, start + this.inputStringLC.length);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "popupModel", {
                    get: function() {
                        return this._popupModel;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "noTabIndex", {
                    get: function() {
                        return this.question.isInputReadOnly || this.searchEnabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "filterReadOnly", {
                    get: function() {
                        return this.question.isInputReadOnly || !this.searchEnabled || !this.focused;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "filterStringEnabled", {
                    get: function() {
                        return !this.question.isInputReadOnly && this.searchEnabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(DropdownListModel.prototype, "inputMode", {
                    get: function() {
                        return _utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"] ? "none" : "text";
                    },
                    enumerable: false,
                    configurable: true
                });
                DropdownListModel.prototype.setSearchEnabled = function(newValue) {
                    this.listModel.searchEnabled = _utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"];
                    this.listModel.showSearchClearButton = _utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"];
                    this.searchEnabled = newValue;
                };
                DropdownListModel.prototype.updateItems = function() {
                    this.listModel.setItems(this.getAvailableItems());
                };
                DropdownListModel.prototype.onClick = function(event1) {
                    if (this.question.readOnly || this.question.isDesignMode) return;
                    this._popupModel.toggleVisibility();
                    this.focusItemOnClickAndPopup();
                    this.question.focus();
                };
                DropdownListModel.prototype.chevronPointerDown = function(event1) {
                    if (this._popupModel.isVisible) event1.preventDefault();
                };
                DropdownListModel.prototype.onPropertyChangedHandler = function(sender, options) {
                    if (options.name == "value") this.showInputFieldComponent = this.question.showInputFieldComponent;
                    if (options.name == "choicesLazyLoadEnabled" && options.newValue) this.listModel.setOnFilterStringChangedCallback(this.listModelFilterStringChanged);
                    if (options.name == "textWrapEnabled") this.setTextWrapEnabled(options.newValue);
                };
                DropdownListModel.prototype.focusItemOnClickAndPopup = function() {
                    if (this._popupModel.isVisible && this.question.value) this.changeSelectionWithKeyboard(false);
                };
                DropdownListModel.prototype.onClear = function(event1) {
                    this.question.clearValue();
                    this._popupModel.isVisible = false;
                    if (event1) {
                        event1.preventDefault();
                        event1.stopPropagation();
                    }
                };
                DropdownListModel.prototype.getSelectedAction = function() {
                    return this.question.selectedItem || null;
                };
                DropdownListModel.prototype.changeSelectionWithKeyboard = function(reverse) {
                    var _a;
                    var focusedItem = this.listModel.focusedItem;
                    if (!focusedItem && this.question.selectedItem) {
                        if (_itemvalue__WEBPACK_IMPORTED_MODULE_2__["ItemValue"].getItemByValue(this.question.visibleChoices, this.question.value)) this.listModel.focusedItem = this.question.selectedItem;
                    } else if (reverse) this.listModel.focusPrevVisibleItem();
                    else this.listModel.focusNextVisibleItem();
                    this.beforeScrollToFocusedItem(focusedItem);
                    this.scrollToFocusedItem();
                    this.afterScrollToFocusedItem();
                    this.ariaActivedescendant = (_a = this.listModel.focusedItem) === null || _a === void 0 ? void 0 : _a.elementId;
                };
                DropdownListModel.prototype.beforeScrollToFocusedItem = function(focusedItem) {
                    if (this.question.value && focusedItem) {
                        focusedItem.selectedValue = false;
                        this.listModel.focusedItem.selectedValue = !this.listModel.filterString;
                        this.question.suggestedItem = this.listModel.focusedItem;
                    }
                };
                DropdownListModel.prototype.afterScrollToFocusedItem = function() {
                    var _a;
                    if (this.question.value && !this.listModel.filterString && this.question.searchEnabled) this.applyInputString(this.listModel.focusedItem || this.question.selectedItem);
                    else this.applyHintString(this.listModel.focusedItem || this.question.selectedItem);
                    this.fixInputCase();
                    this.ariaActivedescendant = (_a = this.listModel.focusedItem) === null || _a === void 0 ? void 0 : _a.elementId;
                };
                DropdownListModel.prototype.keyHandler = function(event1) {
                    var char = event1.which || event1.keyCode;
                    if (this.popupModel.isVisible && event1.keyCode === 38) {
                        this.changeSelectionWithKeyboard(true);
                        event1.preventDefault();
                        event1.stopPropagation();
                    } else if (event1.keyCode === 40) {
                        if (!this.popupModel.isVisible) this.popupModel.toggleVisibility();
                        this.changeSelectionWithKeyboard(false);
                        event1.preventDefault();
                        event1.stopPropagation();
                    }
                    if (event1.keyCode === 9) this.popupModel.isVisible = false;
                    else if (!this.popupModel.isVisible && (event1.keyCode === 13 || event1.keyCode === 32)) {
                        if (event1.keyCode === 32) {
                            this.popupModel.toggleVisibility();
                            this.changeSelectionWithKeyboard(false);
                        }
                        if (event1.keyCode === 13) this.question.survey.questionEditFinishCallback(this.question, event1);
                        event1.preventDefault();
                        event1.stopPropagation();
                    } else if (this.popupModel.isVisible && (event1.keyCode === 13 || event1.keyCode === 32 && (!this.question.searchEnabled || !this.inputString))) {
                        if (event1.keyCode === 13 && this.question.searchEnabled && !this.inputString && this.question instanceof _question_dropdown__WEBPACK_IMPORTED_MODULE_6__["QuestionDropdownModel"] && !this._markdownMode && this.question.value) {
                            this._popupModel.isVisible = false;
                            this.onClear(event1);
                        } else {
                            this.listModel.selectFocusedItem();
                            this.onFocus(event1);
                        }
                        event1.preventDefault();
                        event1.stopPropagation();
                    } else if (char === 46 || char === 8) {
                        if (!this.searchEnabled) this.onClear(event1);
                    } else if (event1.keyCode === 27) {
                        this._popupModel.isVisible = false;
                        this.hintString = "";
                        this.onEscape();
                    } else {
                        if (event1.keyCode === 38 || event1.keyCode === 40 || event1.keyCode === 32 && !this.question.searchEnabled) {
                            event1.preventDefault();
                            event1.stopPropagation();
                        }
                        if (event1.keyCode === 32 && this.question.searchEnabled) return;
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_10__["doKey2ClickUp"])(event1, {
                            processEsc: false,
                            disableTabStop: this.question.isInputReadOnly
                        });
                    }
                };
                DropdownListModel.prototype.onEscape = function() {
                    if (this.question.searchEnabled) this.applyInputString(this.question.selectedItem);
                };
                DropdownListModel.prototype.onScroll = function(event1) {
                    var target = event1.target;
                    if (target.scrollHeight - (target.scrollTop + target.offsetHeight) <= this.loadingItemHeight) this.updateQuestionChoices();
                };
                DropdownListModel.prototype.onBlur = function(event1) {
                    this.focused = false;
                    if (this.popupModel.isVisible && _utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"]) {
                        this._popupModel.isVisible = true;
                        return;
                    }
                    Object(_utils_utils__WEBPACK_IMPORTED_MODULE_10__["doKey2ClickBlur"])(event1);
                    this._popupModel.isVisible = false;
                    this.resetFilterString();
                    this.inputString = null;
                    this.hintString = "";
                    event1.stopPropagation();
                };
                DropdownListModel.prototype.onFocus = function(event1) {
                    this.focused = true;
                    this.setInputStringFromSelectedItem(this.question.selectedItem);
                };
                DropdownListModel.prototype.setInputStringFromSelectedItem = function(newValue) {
                    if (!this.focused) return;
                    if (this.question.searchEnabled && !!newValue) this.applyInputString(newValue);
                    else this.inputString = null;
                };
                DropdownListModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.question && this.question.onPropertyChanged.remove(this.qustionPropertyChangedHandler);
                    this.qustionPropertyChangedHandler = undefined;
                    if (!!this.listModel) this.listModel.dispose();
                    if (!!this.popupModel) this.popupModel.dispose();
                };
                DropdownListModel.prototype.scrollToFocusedItem = function() {
                    this.listModel.scrollToFocusedItem();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: false
                    })
                ], DropdownListModel.prototype, "focused", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: true
                    })
                ], DropdownListModel.prototype, "searchEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: "",
                        onSet: function(_, target) {
                            target.onSetFilterString();
                        }
                    })
                ], DropdownListModel.prototype, "filterString", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: "",
                        onSet: function(newValue, target) {
                            target.question.inputHasValue = !!newValue;
                        }
                    })
                ], DropdownListModel.prototype, "inputString", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({})
                ], DropdownListModel.prototype, "showInputFieldComponent", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])()
                ], DropdownListModel.prototype, "ariaActivedescendant", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: false,
                        onSet: function(newVal, target) {
                            if (newVal) target.listModel.addScrollEventListener(function(e) {
                                target.onScroll(e);
                            });
                            else target.listModel.removeScrollEventListener();
                        }
                    })
                ], DropdownListModel.prototype, "hasScroll", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: ""
                    })
                ], DropdownListModel.prototype, "hintString", void 0);
                return DropdownListModel;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
        /***/ },
        /***/ "./src/dropdownMultiSelectListModel.ts": /*!*********************************************!*\
  !*** ./src/dropdownMultiSelectListModel.ts ***!
  \*********************************************/ /*! exports provided: DropdownMultiSelectListModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DropdownMultiSelectListModel", function() {
                return DropdownMultiSelectListModel;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _dropdownListModel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./dropdownListModel */ "./src/dropdownListModel.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _multiSelectListModel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./multiSelectListModel */ "./src/multiSelectListModel.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_devices__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/devices */ "./src/utils/devices.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var DropdownMultiSelectListModel = /** @class */ function(_super) {
                __extends(DropdownMultiSelectListModel, _super);
                function DropdownMultiSelectListModel(question, onSelectionChanged) {
                    var _this = _super.call(this, question, onSelectionChanged) || this;
                    _this.popupCssClasses = "sv-multi-select-list";
                    _this.setHideSelectedItems(question.hideSelectedItems);
                    _this.syncFilterStringPlaceholder();
                    _this.closeOnSelect = question.closeOnSelect;
                    return _this;
                }
                DropdownMultiSelectListModel.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.syncFilterStringPlaceholder();
                };
                DropdownMultiSelectListModel.prototype.updateListState = function() {
                    this.listModel.updateState();
                    this.syncFilterStringPlaceholder();
                };
                DropdownMultiSelectListModel.prototype.syncFilterStringPlaceholder = function() {
                    var selectedActions = this.getSelectedActions();
                    if (selectedActions.length || this.question.selectedItems.length || this.listModel.focusedItem) this.filterStringPlaceholder = undefined;
                    else this.filterStringPlaceholder = this.question.placeholder;
                };
                DropdownMultiSelectListModel.prototype.getSelectedActions = function() {
                    return this.listModel.actions.filter(function(item) {
                        return item.selected;
                    });
                };
                DropdownMultiSelectListModel.prototype.getFocusFirstInputSelector = function() {
                    if (this.listModel.hideSelectedItems && _utils_devices__WEBPACK_IMPORTED_MODULE_5__["IsTouch"] && !this.isValueEmpty(this.question.value)) return this.itemSelector;
                    else return _super.prototype.getFocusFirstInputSelector.call(this);
                };
                DropdownMultiSelectListModel.prototype.createListModel = function() {
                    var _this = this;
                    var visibleItems = this.getAvailableItems();
                    var _onSelectionChanged = this.onSelectionChanged;
                    if (!_onSelectionChanged) _onSelectionChanged = function(item, status) {
                        _this.resetFilterString();
                        if (item.id === "selectall") _this.selectAllItems();
                        else if (status === "added" && item.value === _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].noneItemValue) _this.selectNoneItem();
                        else if (status === "added") _this.selectItem(item.value);
                        else if (status === "removed") _this.deselectItem(item.value);
                        _this.popupRecalculatePosition(false);
                        if (_this.closeOnSelect) _this.popupModel.isVisible = false;
                    };
                    var res = new _multiSelectListModel__WEBPACK_IMPORTED_MODULE_3__["MultiSelectListModel"](visibleItems, _onSelectionChanged, false, undefined, this.question.choicesLazyLoadEnabled ? this.listModelFilterStringChanged : undefined, this.listElementId);
                    this.setOnTextSearchCallbackForListModel(res);
                    res.forceShowFilter = true;
                    return res;
                };
                DropdownMultiSelectListModel.prototype.resetFilterString = function() {
                    _super.prototype.resetFilterString.call(this);
                    this.inputString = null;
                    this.hintString = "";
                };
                Object.defineProperty(DropdownMultiSelectListModel.prototype, "shouldResetAfterCancel", {
                    get: function() {
                        return _utils_devices__WEBPACK_IMPORTED_MODULE_5__["IsTouch"] && !this.closeOnSelect;
                    },
                    enumerable: false,
                    configurable: true
                });
                DropdownMultiSelectListModel.prototype.createPopup = function() {
                    var _this = this;
                    _super.prototype.createPopup.call(this);
                    this.popupModel.onFooterActionsCreated.add(function(_, opt) {
                        if (_this.shouldResetAfterCancel) opt.actions.push({
                            id: "sv-dropdown-done-button",
                            title: _this.doneButtonCaption,
                            innerCss: "sv-popup__button--done",
                            needSpace: true,
                            action: function() {
                                _this.popupModel.isVisible = false;
                            },
                            enabled: new _base__WEBPACK_IMPORTED_MODULE_0__["ComputedUpdater"](function() {
                                return !_this.isTwoValueEquals(_this.question.renderedValue, _this.previousValue);
                            })
                        });
                    });
                    this.popupModel.onVisibilityChanged.add(function(_, opt) {
                        if (_this.shouldResetAfterCancel && opt.isVisible) _this.previousValue = [].concat(_this.question.renderedValue || []);
                    });
                    this.popupModel.onCancel = function() {
                        if (_this.shouldResetAfterCancel) {
                            _this.question.renderedValue = _this.previousValue;
                            _this.updateListState();
                        }
                    };
                };
                DropdownMultiSelectListModel.prototype.selectAllItems = function() {
                    this.question.toggleSelectAll();
                    this.updateListState();
                };
                DropdownMultiSelectListModel.prototype.selectNoneItem = function() {
                    this.question.renderedValue = [
                        _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].noneItemValue
                    ];
                    this.updateListState();
                };
                DropdownMultiSelectListModel.prototype.selectItem = function(id) {
                    var newValue = [].concat(this.question.renderedValue || []);
                    newValue.push(id);
                    this.question.renderedValue = newValue;
                    this.updateListState();
                };
                DropdownMultiSelectListModel.prototype.deselectItem = function(id) {
                    var newValue = [].concat(this.question.renderedValue || []);
                    newValue.splice(newValue.indexOf(id), 1);
                    this.question.renderedValue = newValue;
                    this.applyHintString(this.listModel.focusedItem);
                    this.updateListState();
                };
                DropdownMultiSelectListModel.prototype.clear = function() {
                    _super.prototype.clear.call(this);
                    this.syncFilterStringPlaceholder();
                };
                DropdownMultiSelectListModel.prototype.onClear = function(event1) {
                    _super.prototype.onClear.call(this, event1);
                    this.updateListState();
                };
                DropdownMultiSelectListModel.prototype.setHideSelectedItems = function(newValue) {
                    this.listModel.hideSelectedItems = newValue;
                    this.updateListState();
                };
                DropdownMultiSelectListModel.prototype.removeLastSelectedItem = function() {
                    this.deselectItem(this.question.renderedValue[this.question.renderedValue.length - 1]);
                    this.popupRecalculatePosition(false);
                };
                DropdownMultiSelectListModel.prototype.inputKeyHandler = function(event1) {
                    if (event1.keyCode === 8 && !this.filterString) {
                        this.removeLastSelectedItem();
                        event1.preventDefault();
                        event1.stopPropagation();
                    }
                };
                DropdownMultiSelectListModel.prototype.setInputStringFromSelectedItem = function(newValue) {
                    if (this.question.searchEnabled) this.inputString = null;
                };
                DropdownMultiSelectListModel.prototype.focusItemOnClickAndPopup = function() {
                    return;
                };
                DropdownMultiSelectListModel.prototype.onEscape = function() {
                    return;
                };
                DropdownMultiSelectListModel.prototype.beforeScrollToFocusedItem = function(focusedItem) {
                    return;
                };
                DropdownMultiSelectListModel.prototype.afterScrollToFocusedItem = function() {
                    var _a;
                    if (!((_a = this.listModel.focusedItem) === null || _a === void 0 ? void 0 : _a.selected)) this.applyHintString(this.listModel.focusedItem || this.question.selectedItem);
                    else this.hintString = "";
                    this.syncFilterStringPlaceholder();
                };
                DropdownMultiSelectListModel.prototype.onPropertyChangedHandler = function(sender, options) {
                    _super.prototype.onPropertyChangedHandler.call(this, sender, options);
                    if (options.name === "value" || options.name === "renderedValue") this.syncFilterStringPlaceholder();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: ""
                    })
                ], DropdownMultiSelectListModel.prototype, "filterStringPlaceholder", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: true
                    })
                ], DropdownMultiSelectListModel.prototype, "closeOnSelect", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], DropdownMultiSelectListModel.prototype, "previousValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        localizable: {
                            defaultStr: "tagboxDoneButtonCaption"
                        }
                    })
                ], DropdownMultiSelectListModel.prototype, "doneButtonCaption", void 0);
                return DropdownMultiSelectListModel;
            }(_dropdownListModel__WEBPACK_IMPORTED_MODULE_1__["DropdownListModel"]);
        /***/ },
        /***/ "./src/dxSurveyService.ts": /*!********************************!*\
  !*** ./src/dxSurveyService.ts ***!
  \********************************/ /*! exports provided: dxSurveyService */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dxSurveyService", function() {
                return dxSurveyService;
            });
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /**
 * The class contains methods to work with api.surveyjs.io service.
 */ var dxSurveyService = /** @class */ function() {
                function dxSurveyService() {}
                Object.defineProperty(dxSurveyService, "serviceUrl", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].web.surveyServiceUrl;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].web.surveyServiceUrl = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                dxSurveyService.prototype.loadSurvey = function(surveyId, onLoad) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", dxSurveyService.serviceUrl + "/getSurvey?surveyId=" + surveyId);
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                    xhr.onload = function() {
                        var result = JSON.parse(xhr.response);
                        onLoad(xhr.status == 200, result, xhr.response);
                    };
                    xhr.send();
                };
                dxSurveyService.prototype.getSurveyJsonAndIsCompleted = function(surveyId, clientId, onLoad) {
                    var xhr = new XMLHttpRequest();
                    xhr.open("GET", dxSurveyService.serviceUrl + "/getSurveyAndIsCompleted?surveyId=" + surveyId + "&clientId=" + clientId);
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                    xhr.onload = function() {
                        var result = JSON.parse(xhr.response);
                        var surveyJson = result ? result.survey : null;
                        var isCompleted = result ? result.isCompleted : null;
                        onLoad(xhr.status == 200, surveyJson, isCompleted, xhr.response);
                    };
                    xhr.send();
                };
                dxSurveyService.prototype.sendResult = function(postId, result, onSendResult, clientId, isPartialCompleted) {
                    if (clientId === void 0) clientId = null;
                    if (isPartialCompleted === void 0) isPartialCompleted = false;
                    var xhr = new XMLHttpRequest();
                    xhr.open("POST", dxSurveyService.serviceUrl + "/post/");
                    xhr.setRequestHeader("Content-Type", "application/json; charset=utf-8");
                    var data = {
                        postId: postId,
                        surveyResult: JSON.stringify(result)
                    };
                    if (clientId) data["clientId"] = clientId;
                    if (isPartialCompleted) data["isPartialCompleted"] = true;
                    var dataStringify = JSON.stringify(data);
                    var self = this;
                    xhr.onload = xhr.onerror = function() {
                        if (!onSendResult) return;
                        onSendResult(xhr.status === 200, xhr.response, xhr);
                    };
                    xhr.send(dataStringify);
                };
                dxSurveyService.prototype.sendFile = function(postId, file, onSendFile) {
                    var xhr = new XMLHttpRequest();
                    xhr.onload = xhr.onerror = function() {
                        if (!onSendFile) return;
                        onSendFile(xhr.status == 200, JSON.parse(xhr.response));
                    };
                    xhr.open("POST", dxSurveyService.serviceUrl + "/upload/", true);
                    var formData = new FormData();
                    formData.append("file", file);
                    formData.append("postId", postId);
                    xhr.send(formData);
                };
                dxSurveyService.prototype.getResult = function(resultId, name, onGetResult) {
                    var xhr = new XMLHttpRequest();
                    var data = "resultId=" + resultId + "&name=" + name;
                    xhr.open("GET", dxSurveyService.serviceUrl + "/getResult?" + data);
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                    var self = this;
                    xhr.onload = function() {
                        var result = null;
                        var list = null;
                        if (xhr.status == 200) {
                            result = JSON.parse(xhr.response);
                            list = [];
                            for(var key in result.QuestionResult){
                                var el = {
                                    name: key,
                                    value: result.QuestionResult[key]
                                };
                                list.push(el);
                            }
                        }
                        onGetResult(xhr.status == 200, result, list, xhr.response);
                    };
                    xhr.send();
                };
                dxSurveyService.prototype.isCompleted = function(resultId, clientId, onIsCompleted) {
                    var xhr = new XMLHttpRequest();
                    var data = "resultId=" + resultId + "&clientId=" + clientId;
                    xhr.open("GET", dxSurveyService.serviceUrl + "/isCompleted?" + data);
                    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
                    var self = this;
                    xhr.onload = function() {
                        var result = null;
                        if (xhr.status == 200) result = JSON.parse(xhr.response);
                        onIsCompleted(xhr.status == 200, result, xhr.response);
                    };
                    xhr.send();
                };
                return dxSurveyService;
            }();
        /***/ },
        /***/ "./src/element-helper.ts": /*!*******************************!*\
  !*** ./src/element-helper.ts ***!
  \*******************************/ /*! exports provided: ElementHelper */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementHelper", function() {
                return ElementHelper;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var ElementHelper = /** @class */ function() {
                function ElementHelper() {}
                ElementHelper.focusElement = function(element) {
                    element && element.focus();
                };
                ElementHelper.visibility = function(node) {
                    var style = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getComputedStyle(node);
                    if (style.display === "none" || style.visibility === "hidden") return false;
                    return node.parentElement ? this.visibility(node.parentElement) : true;
                };
                ElementHelper.getNextElementPreorder = function(element) {
                    var result = !!element.nextElementSibling ? element.nextElementSibling : element.parentElement.firstElementChild;
                    if (this.visibility(result)) return result;
                    else return this.getNextElementPreorder(result);
                };
                ElementHelper.getNextElementPostorder = function(element) {
                    var result = !!element.previousElementSibling ? element.previousElementSibling : element.parentElement.lastElementChild;
                    if (this.visibility(result)) return result;
                    else return this.getNextElementPostorder(result);
                };
                ElementHelper.hasHorizontalScroller = function(element) {
                    if (!!element) return element.scrollWidth > element.offsetWidth;
                    return false;
                };
                ElementHelper.hasVerticalScroller = function(element) {
                    if (!!element) return element.scrollHeight > element.offsetHeight;
                    return false;
                };
                return ElementHelper;
            }();
        /***/ },
        /***/ "./src/entries/chunks/model.ts": /*!*************************************!*\
  !*** ./src/entries/chunks/model.ts ***!
  \*************************************/ /*! exports provided: Version, ReleaseDate, checkLibraryVersion, setLicenseKey, slk, hasLicense, settings, Helpers, AnswerCountValidator, EmailValidator, NumericValidator, RegexValidator, SurveyValidator, TextValidator, ValidatorResult, ExpressionValidator, ValidatorRunner, ItemValue, Base, Event, EventBase, ArrayChanges, ComputedUpdater, SurveyError, SurveyElementCore, SurveyElement, DragTypeOverMeEnum, CalculatedValue, CustomError, AnswerRequiredError, OneAnswerRequiredError, RequreNumericError, ExceedSizeError, LocalizableString, LocalizableStrings, HtmlConditionItem, UrlConditionItem, ChoicesRestful, ChoicesRestfull, FunctionFactory, registerFunction, ConditionRunner, ExpressionRunner, ExpressionExecutor, Operand, Const, BinaryOperand, Variable, FunctionOperand, ArrayOperand, UnaryOperand, ConditionsParser, ProcessValue, JsonError, JsonIncorrectTypeError, JsonMetadata, JsonMetadataClass, JsonMissingTypeError, JsonMissingTypeErrorBase, JsonObject, JsonObjectProperty, JsonRequiredPropertyError, JsonUnknownPropertyError, Serializer, property, propertyArray, MatrixDropdownCell, MatrixDropdownRowModelBase, QuestionMatrixDropdownModelBase, MatrixDropdownColumn, matrixDropdownColumnTypes, QuestionMatrixDropdownRenderedCell, QuestionMatrixDropdownRenderedRow, QuestionMatrixDropdownRenderedErrorRow, QuestionMatrixDropdownRenderedTable, MatrixDropdownRowModel, QuestionMatrixDropdownModel, MatrixDynamicRowModel, QuestionMatrixDynamicModel, MatrixRowModel, MatrixCells, QuestionMatrixModel, QuestionMatrixBaseModel, MultipleTextItemModel, MultipleTextCell, MultipleTextErrorCell, MutlipleTextErrorRow, MutlipleTextRow, QuestionMultipleTextModel, MultipleTextEditorModel, PanelModel, PanelModelBase, QuestionRowModel, FlowPanelModel, PageModel, DefaultTitleModel, Question, QuestionNonValue, QuestionEmptyModel, QuestionCheckboxBase, QuestionSelectBase, QuestionCheckboxModel, QuestionTagboxModel, QuestionRankingModel, QuestionCommentModel, QuestionDropdownModel, QuestionFactory, ElementFactory, QuestionFileModel, QuestionHtmlModel, QuestionRadiogroupModel, QuestionRatingModel, RenderedRatingItem, QuestionExpressionModel, QuestionTextBase, CharacterCounter, QuestionTextModel, QuestionBooleanModel, QuestionImagePickerModel, ImageItemValue, QuestionImageModel, QuestionSignaturePadModel, QuestionPanelDynamicModel, QuestionPanelDynamicItem, SurveyTimer, SurveyTimerModel, tryFocusPage, createTOCListModel, getTocRootCss, TOCModel, SurveyProgressModel, ProgressButtons, ProgressButtonsResponsivityManager, SurveyModel, SurveyTrigger, SurveyTriggerComplete, SurveyTriggerSetValue, SurveyTriggerVisible, SurveyTriggerCopyValue, SurveyTriggerRunExpression, SurveyTriggerSkip, Trigger, PopupSurveyModel, SurveyWindowModel, TextPreProcessor, Notifier, Cover, CoverCell, dxSurveyService, englishStrings, surveyLocalization, surveyStrings, QuestionCustomWidget, CustomWidgetCollection, QuestionCustomModel, QuestionCompositeModel, ComponentQuestionJSON, ComponentCollection, StylesManager, ListModel, MultiSelectListModel, PopupModel, createDialogOptions, PopupBaseViewModel, PopupDropdownViewModel, PopupModalViewModel, createPopupViewModel, createPopupModalViewModel, DropdownListModel, DropdownMultiSelectListModel, QuestionButtonGroupModel, ButtonGroupItemModel, ButtonGroupItemValue, IsMobile, IsTouch, _setIsTouch, confirmAction, confirmActionAsync, detectIEOrEdge, doKey2ClickUp, doKey2ClickDown, doKey2ClickBlur, loadFileFromBase64, increaseHeightByContent, createSvg, chooseFiles, sanitizeEditableContent, InputMaskBase, InputMaskPattern, InputMaskNumeric, InputMaskDateTime, InputMaskCurrency, CssClassBuilder, surveyCss, defaultV2Css, defaultV2ThemeName, DragDropCore, DragDropChoices, DragDropRankingSelectToRank */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Version", function() {
                return Version;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReleaseDate", function() {
                return ReleaseDate;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "checkLibraryVersion", function() {
                return checkLibraryVersion;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "setLicenseKey", function() {
                return setLicenseKey;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "slk", function() {
                return slk;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "hasLicense", function() {
                return hasLicense;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../settings */ "./src/settings.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "settings", function() {
                return _settings__WEBPACK_IMPORTED_MODULE_1__["settings"];
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../helpers */ "./src/helpers.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Helpers", function() {
                return _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"];
            });
            /* harmony import */ var _validator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../validator */ "./src/validator.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnswerCountValidator", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["AnswerCountValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["EmailValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumericValidator", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["NumericValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RegexValidator", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["RegexValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyValidator", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["SurveyValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextValidator", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["TextValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValidatorResult", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["ValidatorResult"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionValidator", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["ExpressionValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValidatorRunner", function() {
                return _validator__WEBPACK_IMPORTED_MODULE_3__["ValidatorRunner"];
            });
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../itemvalue */ "./src/itemvalue.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ItemValue", function() {
                return _itemvalue__WEBPACK_IMPORTED_MODULE_4__["ItemValue"];
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../base */ "./src/base.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() {
                return _base__WEBPACK_IMPORTED_MODULE_5__["Base"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Event", function() {
                return _base__WEBPACK_IMPORTED_MODULE_5__["Event"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventBase", function() {
                return _base__WEBPACK_IMPORTED_MODULE_5__["EventBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayChanges", function() {
                return _base__WEBPACK_IMPORTED_MODULE_5__["ArrayChanges"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComputedUpdater", function() {
                return _base__WEBPACK_IMPORTED_MODULE_5__["ComputedUpdater"];
            });
            /* harmony import */ var _survey_error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../survey-error */ "./src/survey-error.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyError", function() {
                return _survey_error__WEBPACK_IMPORTED_MODULE_6__["SurveyError"];
            });
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../survey-element */ "./src/survey-element.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElementCore", function() {
                return _survey_element__WEBPACK_IMPORTED_MODULE_7__["SurveyElementCore"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElement", function() {
                return _survey_element__WEBPACK_IMPORTED_MODULE_7__["SurveyElement"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTypeOverMeEnum", function() {
                return _survey_element__WEBPACK_IMPORTED_MODULE_7__["DragTypeOverMeEnum"];
            });
            /* harmony import */ var _calculatedValue__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../calculatedValue */ "./src/calculatedValue.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculatedValue", function() {
                return _calculatedValue__WEBPACK_IMPORTED_MODULE_8__["CalculatedValue"];
            });
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../error */ "./src/error.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CustomError", function() {
                return _error__WEBPACK_IMPORTED_MODULE_9__["CustomError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnswerRequiredError", function() {
                return _error__WEBPACK_IMPORTED_MODULE_9__["AnswerRequiredError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OneAnswerRequiredError", function() {
                return _error__WEBPACK_IMPORTED_MODULE_9__["OneAnswerRequiredError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RequreNumericError", function() {
                return _error__WEBPACK_IMPORTED_MODULE_9__["RequreNumericError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExceedSizeError", function() {
                return _error__WEBPACK_IMPORTED_MODULE_9__["ExceedSizeError"];
            });
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../localizablestring */ "./src/localizablestring.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableString", function() {
                return _localizablestring__WEBPACK_IMPORTED_MODULE_10__["LocalizableString"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableStrings", function() {
                return _localizablestring__WEBPACK_IMPORTED_MODULE_10__["LocalizableStrings"];
            });
            /* harmony import */ var _expressionItems__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../expressionItems */ "./src/expressionItems.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HtmlConditionItem", function() {
                return _expressionItems__WEBPACK_IMPORTED_MODULE_11__["HtmlConditionItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UrlConditionItem", function() {
                return _expressionItems__WEBPACK_IMPORTED_MODULE_11__["UrlConditionItem"];
            });
            /* harmony import */ var _choicesRestful__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../../choicesRestful */ "./src/choicesRestful.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChoicesRestful", function() {
                return _choicesRestful__WEBPACK_IMPORTED_MODULE_12__["ChoicesRestful"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChoicesRestfull", function() {
                return _choicesRestful__WEBPACK_IMPORTED_MODULE_12__["ChoicesRestfull"];
            });
            /* harmony import */ var _functionsfactory__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../functionsfactory */ "./src/functionsfactory.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionFactory", function() {
                return _functionsfactory__WEBPACK_IMPORTED_MODULE_13__["FunctionFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "registerFunction", function() {
                return _functionsfactory__WEBPACK_IMPORTED_MODULE_13__["registerFunction"];
            });
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../conditions */ "./src/conditions.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConditionRunner", function() {
                return _conditions__WEBPACK_IMPORTED_MODULE_14__["ConditionRunner"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionRunner", function() {
                return _conditions__WEBPACK_IMPORTED_MODULE_14__["ExpressionRunner"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionExecutor", function() {
                return _conditions__WEBPACK_IMPORTED_MODULE_14__["ExpressionExecutor"];
            });
            /* harmony import */ var _expressions_expressions__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../../expressions/expressions */ "./src/expressions/expressions.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Operand", function() {
                return _expressions_expressions__WEBPACK_IMPORTED_MODULE_15__["Operand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Const", function() {
                return _expressions_expressions__WEBPACK_IMPORTED_MODULE_15__["Const"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BinaryOperand", function() {
                return _expressions_expressions__WEBPACK_IMPORTED_MODULE_15__["BinaryOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Variable", function() {
                return _expressions_expressions__WEBPACK_IMPORTED_MODULE_15__["Variable"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionOperand", function() {
                return _expressions_expressions__WEBPACK_IMPORTED_MODULE_15__["FunctionOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayOperand", function() {
                return _expressions_expressions__WEBPACK_IMPORTED_MODULE_15__["ArrayOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnaryOperand", function() {
                return _expressions_expressions__WEBPACK_IMPORTED_MODULE_15__["UnaryOperand"];
            });
            /* harmony import */ var _conditionsParser__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../../conditionsParser */ "./src/conditionsParser.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConditionsParser", function() {
                return _conditionsParser__WEBPACK_IMPORTED_MODULE_16__["ConditionsParser"];
            });
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../../conditionProcessValue */ "./src/conditionProcessValue.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProcessValue", function() {
                return _conditionProcessValue__WEBPACK_IMPORTED_MODULE_17__["ProcessValue"];
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../../jsonobject */ "./src/jsonobject.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonError", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonIncorrectTypeError", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonIncorrectTypeError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMetadata", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonMetadata"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMetadataClass", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonMetadataClass"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeError", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonMissingTypeError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeErrorBase", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonMissingTypeErrorBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonObject", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonObject"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonObjectProperty", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonObjectProperty"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonRequiredPropertyError", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonRequiredPropertyError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonUnknownPropertyError", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["JsonUnknownPropertyError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Serializer", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["Serializer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "property", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["property"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "propertyArray", function() {
                return _jsonobject__WEBPACK_IMPORTED_MODULE_18__["propertyArray"];
            });
            /* harmony import */ var _question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../../question_matrixdropdownbase */ "./src/question_matrixdropdownbase.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownCell", function() {
                return _question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_19__["MatrixDropdownCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownRowModelBase", function() {
                return _question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_19__["MatrixDropdownRowModelBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownModelBase", function() {
                return _question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_19__["QuestionMatrixDropdownModelBase"];
            });
            /* harmony import */ var _question_matrixdropdowncolumn__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../../question_matrixdropdowncolumn */ "./src/question_matrixdropdowncolumn.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownColumn", function() {
                return _question_matrixdropdowncolumn__WEBPACK_IMPORTED_MODULE_20__["MatrixDropdownColumn"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matrixDropdownColumnTypes", function() {
                return _question_matrixdropdowncolumn__WEBPACK_IMPORTED_MODULE_20__["matrixDropdownColumnTypes"];
            });
            /* harmony import */ var _question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../../question_matrixdropdownrendered */ "./src/question_matrixdropdownrendered.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedCell", function() {
                return _question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_21__["QuestionMatrixDropdownRenderedCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedRow", function() {
                return _question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_21__["QuestionMatrixDropdownRenderedRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedErrorRow", function() {
                return _question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_21__["QuestionMatrixDropdownRenderedErrorRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedTable", function() {
                return _question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_21__["QuestionMatrixDropdownRenderedTable"];
            });
            /* harmony import */ var _question_matrixdropdown__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../../question_matrixdropdown */ "./src/question_matrixdropdown.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownRowModel", function() {
                return _question_matrixdropdown__WEBPACK_IMPORTED_MODULE_22__["MatrixDropdownRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownModel", function() {
                return _question_matrixdropdown__WEBPACK_IMPORTED_MODULE_22__["QuestionMatrixDropdownModel"];
            });
            /* harmony import */ var _question_matrixdynamic__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../../question_matrixdynamic */ "./src/question_matrixdynamic.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDynamicRowModel", function() {
                return _question_matrixdynamic__WEBPACK_IMPORTED_MODULE_23__["MatrixDynamicRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDynamicModel", function() {
                return _question_matrixdynamic__WEBPACK_IMPORTED_MODULE_23__["QuestionMatrixDynamicModel"];
            });
            /* harmony import */ var _question_matrix__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../../question_matrix */ "./src/question_matrix.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixRowModel", function() {
                return _question_matrix__WEBPACK_IMPORTED_MODULE_24__["MatrixRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixCells", function() {
                return _question_matrix__WEBPACK_IMPORTED_MODULE_24__["MatrixCells"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixModel", function() {
                return _question_matrix__WEBPACK_IMPORTED_MODULE_24__["QuestionMatrixModel"];
            });
            /* harmony import */ var _martixBase__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../../martixBase */ "./src/martixBase.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixBaseModel", function() {
                return _martixBase__WEBPACK_IMPORTED_MODULE_25__["QuestionMatrixBaseModel"];
            });
            /* harmony import */ var _question_multipletext__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../../question_multipletext */ "./src/question_multipletext.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextItemModel", function() {
                return _question_multipletext__WEBPACK_IMPORTED_MODULE_26__["MultipleTextItemModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextCell", function() {
                return _question_multipletext__WEBPACK_IMPORTED_MODULE_26__["MultipleTextCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextErrorCell", function() {
                return _question_multipletext__WEBPACK_IMPORTED_MODULE_26__["MultipleTextErrorCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MutlipleTextErrorRow", function() {
                return _question_multipletext__WEBPACK_IMPORTED_MODULE_26__["MutlipleTextErrorRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MutlipleTextRow", function() {
                return _question_multipletext__WEBPACK_IMPORTED_MODULE_26__["MutlipleTextRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMultipleTextModel", function() {
                return _question_multipletext__WEBPACK_IMPORTED_MODULE_26__["QuestionMultipleTextModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextEditorModel", function() {
                return _question_multipletext__WEBPACK_IMPORTED_MODULE_26__["MultipleTextEditorModel"];
            });
            /* harmony import */ var _panel__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../../panel */ "./src/panel.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelModel", function() {
                return _panel__WEBPACK_IMPORTED_MODULE_27__["PanelModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelModelBase", function() {
                return _panel__WEBPACK_IMPORTED_MODULE_27__["PanelModelBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRowModel", function() {
                return _panel__WEBPACK_IMPORTED_MODULE_27__["QuestionRowModel"];
            });
            /* harmony import */ var _flowpanel__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../../flowpanel */ "./src/flowpanel.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlowPanelModel", function() {
                return _flowpanel__WEBPACK_IMPORTED_MODULE_28__["FlowPanelModel"];
            });
            /* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../../page */ "./src/page.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PageModel", function() {
                return _page__WEBPACK_IMPORTED_MODULE_29__["PageModel"];
            });
            /* harmony import */ var _template_renderer__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../../template-renderer */ "./src/template-renderer.ts");
            /* empty/unused harmony star reexport */ /* harmony import */ var _defaultTitle__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../../defaultTitle */ "./src/defaultTitle.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultTitleModel", function() {
                return _defaultTitle__WEBPACK_IMPORTED_MODULE_31__["DefaultTitleModel"];
            });
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../../question */ "./src/question.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Question", function() {
                return _question__WEBPACK_IMPORTED_MODULE_32__["Question"];
            });
            /* harmony import */ var _questionnonvalue__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../../questionnonvalue */ "./src/questionnonvalue.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionNonValue", function() {
                return _questionnonvalue__WEBPACK_IMPORTED_MODULE_33__["QuestionNonValue"];
            });
            /* harmony import */ var _question_empty__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../../question_empty */ "./src/question_empty.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionEmptyModel", function() {
                return _question_empty__WEBPACK_IMPORTED_MODULE_34__["QuestionEmptyModel"];
            });
            /* harmony import */ var _question_baseselect__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../../question_baseselect */ "./src/question_baseselect.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCheckboxBase", function() {
                return _question_baseselect__WEBPACK_IMPORTED_MODULE_35__["QuestionCheckboxBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionSelectBase", function() {
                return _question_baseselect__WEBPACK_IMPORTED_MODULE_35__["QuestionSelectBase"];
            });
            /* harmony import */ var _question_checkbox__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../../question_checkbox */ "./src/question_checkbox.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCheckboxModel", function() {
                return _question_checkbox__WEBPACK_IMPORTED_MODULE_36__["QuestionCheckboxModel"];
            });
            /* harmony import */ var _question_tagbox__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../../question_tagbox */ "./src/question_tagbox.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTagboxModel", function() {
                return _question_tagbox__WEBPACK_IMPORTED_MODULE_37__["QuestionTagboxModel"];
            });
            /* harmony import */ var _question_ranking__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../../question_ranking */ "./src/question_ranking.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRankingModel", function() {
                return _question_ranking__WEBPACK_IMPORTED_MODULE_38__["QuestionRankingModel"];
            });
            /* harmony import */ var _question_comment__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../../question_comment */ "./src/question_comment.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCommentModel", function() {
                return _question_comment__WEBPACK_IMPORTED_MODULE_39__["QuestionCommentModel"];
            });
            /* harmony import */ var _question_dropdown__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../../question_dropdown */ "./src/question_dropdown.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionDropdownModel", function() {
                return _question_dropdown__WEBPACK_IMPORTED_MODULE_40__["QuestionDropdownModel"];
            });
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../../questionfactory */ "./src/questionfactory.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionFactory", function() {
                return _questionfactory__WEBPACK_IMPORTED_MODULE_41__["QuestionFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ElementFactory", function() {
                return _questionfactory__WEBPACK_IMPORTED_MODULE_41__["ElementFactory"];
            });
            /* harmony import */ var _question_file__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../../question_file */ "./src/question_file.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionFileModel", function() {
                return _question_file__WEBPACK_IMPORTED_MODULE_42__["QuestionFileModel"];
            });
            /* harmony import */ var _question_html__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../../question_html */ "./src/question_html.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionHtmlModel", function() {
                return _question_html__WEBPACK_IMPORTED_MODULE_43__["QuestionHtmlModel"];
            });
            /* harmony import */ var _question_radiogroup__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../../question_radiogroup */ "./src/question_radiogroup.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRadiogroupModel", function() {
                return _question_radiogroup__WEBPACK_IMPORTED_MODULE_44__["QuestionRadiogroupModel"];
            });
            /* harmony import */ var _question_rating__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../../question_rating */ "./src/question_rating.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRatingModel", function() {
                return _question_rating__WEBPACK_IMPORTED_MODULE_45__["QuestionRatingModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RenderedRatingItem", function() {
                return _question_rating__WEBPACK_IMPORTED_MODULE_45__["RenderedRatingItem"];
            });
            /* harmony import */ var _question_expression__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../../question_expression */ "./src/question_expression.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionExpressionModel", function() {
                return _question_expression__WEBPACK_IMPORTED_MODULE_46__["QuestionExpressionModel"];
            });
            /* harmony import */ var _question_textbase__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../../question_textbase */ "./src/question_textbase.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTextBase", function() {
                return _question_textbase__WEBPACK_IMPORTED_MODULE_47__["QuestionTextBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CharacterCounter", function() {
                return _question_textbase__WEBPACK_IMPORTED_MODULE_47__["CharacterCounter"];
            });
            /* harmony import */ var _question_text__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../../question_text */ "./src/question_text.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTextModel", function() {
                return _question_text__WEBPACK_IMPORTED_MODULE_48__["QuestionTextModel"];
            });
            /* harmony import */ var _question_boolean__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../../question_boolean */ "./src/question_boolean.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionBooleanModel", function() {
                return _question_boolean__WEBPACK_IMPORTED_MODULE_49__["QuestionBooleanModel"];
            });
            /* harmony import */ var _question_imagepicker__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../../question_imagepicker */ "./src/question_imagepicker.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionImagePickerModel", function() {
                return _question_imagepicker__WEBPACK_IMPORTED_MODULE_50__["QuestionImagePickerModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageItemValue", function() {
                return _question_imagepicker__WEBPACK_IMPORTED_MODULE_50__["ImageItemValue"];
            });
            /* harmony import */ var _question_image__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../../question_image */ "./src/question_image.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionImageModel", function() {
                return _question_image__WEBPACK_IMPORTED_MODULE_51__["QuestionImageModel"];
            });
            /* harmony import */ var _question_signaturepad__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../../question_signaturepad */ "./src/question_signaturepad.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionSignaturePadModel", function() {
                return _question_signaturepad__WEBPACK_IMPORTED_MODULE_52__["QuestionSignaturePadModel"];
            });
            /* harmony import */ var _question_paneldynamic__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../../question_paneldynamic */ "./src/question_paneldynamic.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicModel", function() {
                return _question_paneldynamic__WEBPACK_IMPORTED_MODULE_53__["QuestionPanelDynamicModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicItem", function() {
                return _question_paneldynamic__WEBPACK_IMPORTED_MODULE_53__["QuestionPanelDynamicItem"];
            });
            /* harmony import */ var _surveytimer__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../../surveytimer */ "./src/surveytimer.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTimer", function() {
                return _surveytimer__WEBPACK_IMPORTED_MODULE_54__["SurveyTimer"];
            });
            /* harmony import */ var _surveyTimerModel__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../../surveyTimerModel */ "./src/surveyTimerModel.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTimerModel", function() {
                return _surveyTimerModel__WEBPACK_IMPORTED_MODULE_55__["SurveyTimerModel"];
            });
            /* harmony import */ var _surveyToc__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../../surveyToc */ "./src/surveyToc.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "tryFocusPage", function() {
                return _surveyToc__WEBPACK_IMPORTED_MODULE_56__["tryFocusPage"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createTOCListModel", function() {
                return _surveyToc__WEBPACK_IMPORTED_MODULE_56__["createTOCListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getTocRootCss", function() {
                return _surveyToc__WEBPACK_IMPORTED_MODULE_56__["getTocRootCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TOCModel", function() {
                return _surveyToc__WEBPACK_IMPORTED_MODULE_56__["TOCModel"];
            });
            /* harmony import */ var _surveyProgress__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../../surveyProgress */ "./src/surveyProgress.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressModel", function() {
                return _surveyProgress__WEBPACK_IMPORTED_MODULE_57__["SurveyProgressModel"];
            });
            /* harmony import */ var _progress_buttons__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../../progress-buttons */ "./src/progress-buttons.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressButtons", function() {
                return _progress_buttons__WEBPACK_IMPORTED_MODULE_58__["ProgressButtons"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressButtonsResponsivityManager", function() {
                return _progress_buttons__WEBPACK_IMPORTED_MODULE_58__["ProgressButtonsResponsivityManager"];
            });
            /* harmony import */ var _themes__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../../themes */ "./src/themes.ts");
            /* empty/unused harmony star reexport */ /* harmony import */ var _survey__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../../survey */ "./src/survey.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyModel", function() {
                return _survey__WEBPACK_IMPORTED_MODULE_60__["SurveyModel"];
            });
            /* harmony import */ var _survey_events_api__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../../survey-events-api */ "./src/survey-events-api.ts");
            /* empty/unused harmony star reexport */ /* harmony import */ var _trigger__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../../trigger */ "./src/trigger.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTrigger", function() {
                return _trigger__WEBPACK_IMPORTED_MODULE_62__["SurveyTrigger"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerComplete", function() {
                return _trigger__WEBPACK_IMPORTED_MODULE_62__["SurveyTriggerComplete"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerSetValue", function() {
                return _trigger__WEBPACK_IMPORTED_MODULE_62__["SurveyTriggerSetValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerVisible", function() {
                return _trigger__WEBPACK_IMPORTED_MODULE_62__["SurveyTriggerVisible"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerCopyValue", function() {
                return _trigger__WEBPACK_IMPORTED_MODULE_62__["SurveyTriggerCopyValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerRunExpression", function() {
                return _trigger__WEBPACK_IMPORTED_MODULE_62__["SurveyTriggerRunExpression"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerSkip", function() {
                return _trigger__WEBPACK_IMPORTED_MODULE_62__["SurveyTriggerSkip"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Trigger", function() {
                return _trigger__WEBPACK_IMPORTED_MODULE_62__["Trigger"];
            });
            /* harmony import */ var _popup_survey__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../../popup-survey */ "./src/popup-survey.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupSurveyModel", function() {
                return _popup_survey__WEBPACK_IMPORTED_MODULE_63__["PopupSurveyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyWindowModel", function() {
                return _popup_survey__WEBPACK_IMPORTED_MODULE_63__["SurveyWindowModel"];
            });
            /* harmony import */ var _textPreProcessor__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../../textPreProcessor */ "./src/textPreProcessor.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextPreProcessor", function() {
                return _textPreProcessor__WEBPACK_IMPORTED_MODULE_64__["TextPreProcessor"];
            });
            /* harmony import */ var _notifier__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../../notifier */ "./src/notifier.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Notifier", function() {
                return _notifier__WEBPACK_IMPORTED_MODULE_65__["Notifier"];
            });
            /* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../../header */ "./src/header.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Cover", function() {
                return _header__WEBPACK_IMPORTED_MODULE_66__["Cover"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoverCell", function() {
                return _header__WEBPACK_IMPORTED_MODULE_66__["CoverCell"];
            });
            /* harmony import */ var _dxSurveyService__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../../dxSurveyService */ "./src/dxSurveyService.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dxSurveyService", function() {
                return _dxSurveyService__WEBPACK_IMPORTED_MODULE_67__["dxSurveyService"];
            });
            /* harmony import */ var _localization_english__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../../localization/english */ "./src/localization/english.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "englishStrings", function() {
                return _localization_english__WEBPACK_IMPORTED_MODULE_68__["englishStrings"];
            });
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../../surveyStrings */ "./src/surveyStrings.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyLocalization", function() {
                return _surveyStrings__WEBPACK_IMPORTED_MODULE_69__["surveyLocalization"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyStrings", function() {
                return _surveyStrings__WEBPACK_IMPORTED_MODULE_69__["surveyStrings"];
            });
            /* harmony import */ var _questionCustomWidgets__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../../questionCustomWidgets */ "./src/questionCustomWidgets.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomWidget", function() {
                return _questionCustomWidgets__WEBPACK_IMPORTED_MODULE_70__["QuestionCustomWidget"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CustomWidgetCollection", function() {
                return _questionCustomWidgets__WEBPACK_IMPORTED_MODULE_70__["CustomWidgetCollection"];
            });
            /* harmony import */ var _question_custom__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../../question_custom */ "./src/question_custom.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomModel", function() {
                return _question_custom__WEBPACK_IMPORTED_MODULE_71__["QuestionCustomModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCompositeModel", function() {
                return _question_custom__WEBPACK_IMPORTED_MODULE_71__["QuestionCompositeModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentQuestionJSON", function() {
                return _question_custom__WEBPACK_IMPORTED_MODULE_71__["ComponentQuestionJSON"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentCollection", function() {
                return _question_custom__WEBPACK_IMPORTED_MODULE_71__["ComponentCollection"];
            });
            /* harmony import */ var _stylesmanager__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../../stylesmanager */ "./src/stylesmanager.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StylesManager", function() {
                return _stylesmanager__WEBPACK_IMPORTED_MODULE_72__["StylesManager"];
            });
            /* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../../list */ "./src/list.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListModel", function() {
                return _list__WEBPACK_IMPORTED_MODULE_73__["ListModel"];
            });
            /* harmony import */ var _multiSelectListModel__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../../multiSelectListModel */ "./src/multiSelectListModel.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiSelectListModel", function() {
                return _multiSelectListModel__WEBPACK_IMPORTED_MODULE_74__["MultiSelectListModel"];
            });
            /* harmony import */ var _popup__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../../popup */ "./src/popup.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupModel", function() {
                return _popup__WEBPACK_IMPORTED_MODULE_75__["PopupModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createDialogOptions", function() {
                return _popup__WEBPACK_IMPORTED_MODULE_75__["createDialogOptions"];
            });
            /* harmony import */ var _popup_view_model__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../../popup-view-model */ "./src/popup-view-model.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupBaseViewModel", function() {
                return _popup_view_model__WEBPACK_IMPORTED_MODULE_76__["PopupBaseViewModel"];
            });
            /* harmony import */ var _popup_dropdown_view_model__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../../popup-dropdown-view-model */ "./src/popup-dropdown-view-model.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupDropdownViewModel", function() {
                return _popup_dropdown_view_model__WEBPACK_IMPORTED_MODULE_77__["PopupDropdownViewModel"];
            });
            /* harmony import */ var _popup_modal_view_model__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../../popup-modal-view-model */ "./src/popup-modal-view-model.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupModalViewModel", function() {
                return _popup_modal_view_model__WEBPACK_IMPORTED_MODULE_78__["PopupModalViewModel"];
            });
            /* harmony import */ var _popup_utils__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../../popup-utils */ "./src/popup-utils.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createPopupViewModel", function() {
                return _popup_utils__WEBPACK_IMPORTED_MODULE_79__["createPopupViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createPopupModalViewModel", function() {
                return _popup_utils__WEBPACK_IMPORTED_MODULE_79__["createPopupModalViewModel"];
            });
            /* harmony import */ var _dropdownListModel__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../../dropdownListModel */ "./src/dropdownListModel.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownListModel", function() {
                return _dropdownListModel__WEBPACK_IMPORTED_MODULE_80__["DropdownListModel"];
            });
            /* harmony import */ var _dropdownMultiSelectListModel__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../../dropdownMultiSelectListModel */ "./src/dropdownMultiSelectListModel.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownMultiSelectListModel", function() {
                return _dropdownMultiSelectListModel__WEBPACK_IMPORTED_MODULE_81__["DropdownMultiSelectListModel"];
            });
            /* harmony import */ var _question_buttongroup__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../../question_buttongroup */ "./src/question_buttongroup.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionButtonGroupModel", function() {
                return _question_buttongroup__WEBPACK_IMPORTED_MODULE_82__["QuestionButtonGroupModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupItemModel", function() {
                return _question_buttongroup__WEBPACK_IMPORTED_MODULE_82__["ButtonGroupItemModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupItemValue", function() {
                return _question_buttongroup__WEBPACK_IMPORTED_MODULE_82__["ButtonGroupItemValue"];
            });
            /* harmony import */ var _utils_devices__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../../utils/devices */ "./src/utils/devices.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IsMobile", function() {
                return _utils_devices__WEBPACK_IMPORTED_MODULE_83__["IsMobile"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IsTouch", function() {
                return _utils_devices__WEBPACK_IMPORTED_MODULE_83__["IsTouch"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_setIsTouch", function() {
                return _utils_devices__WEBPACK_IMPORTED_MODULE_83__["_setIsTouch"];
            });
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "confirmAction", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["confirmAction"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "confirmActionAsync", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["confirmActionAsync"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "detectIEOrEdge", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["detectIEOrEdge"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickUp", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["doKey2ClickUp"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickDown", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["doKey2ClickDown"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickBlur", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["doKey2ClickBlur"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "loadFileFromBase64", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["loadFileFromBase64"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "increaseHeightByContent", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["increaseHeightByContent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createSvg", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["createSvg"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "chooseFiles", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["chooseFiles"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sanitizeEditableContent", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_84__["sanitizeEditableContent"];
            });
            /* harmony import */ var _mask_mask_base__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../../mask/mask_base */ "./src/mask/mask_base.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskBase", function() {
                return _mask_mask_base__WEBPACK_IMPORTED_MODULE_85__["InputMaskBase"];
            });
            /* harmony import */ var _mask_mask_pattern__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../../mask/mask_pattern */ "./src/mask/mask_pattern.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskPattern", function() {
                return _mask_mask_pattern__WEBPACK_IMPORTED_MODULE_86__["InputMaskPattern"];
            });
            /* harmony import */ var _mask_mask_numeric__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../../mask/mask_numeric */ "./src/mask/mask_numeric.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskNumeric", function() {
                return _mask_mask_numeric__WEBPACK_IMPORTED_MODULE_87__["InputMaskNumeric"];
            });
            /* harmony import */ var _mask_mask_datetime__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../../mask/mask_datetime */ "./src/mask/mask_datetime.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskDateTime", function() {
                return _mask_mask_datetime__WEBPACK_IMPORTED_MODULE_88__["InputMaskDateTime"];
            });
            /* harmony import */ var _mask_mask_currency__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../../mask/mask_currency */ "./src/mask/mask_currency.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskCurrency", function() {
                return _mask_mask_currency__WEBPACK_IMPORTED_MODULE_89__["InputMaskCurrency"];
            });
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../../utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CssClassBuilder", function() {
                return _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_90__["CssClassBuilder"];
            });
            /* harmony import */ var _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../../defaultCss/defaultV2Css */ "./src/defaultCss/defaultV2Css.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyCss", function() {
                return _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_91__["surveyCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultV2Css", function() {
                return _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_91__["defaultV2Css"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultV2ThemeName", function() {
                return _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_91__["defaultV2ThemeName"];
            });
            /* harmony import */ var _dragdrop_core__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../../dragdrop/core */ "./src/dragdrop/core.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropCore", function() {
                return _dragdrop_core__WEBPACK_IMPORTED_MODULE_92__["DragDropCore"];
            });
            /* harmony import */ var _dragdrop_choices__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../../dragdrop/choices */ "./src/dragdrop/choices.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropChoices", function() {
                return _dragdrop_choices__WEBPACK_IMPORTED_MODULE_93__["DragDropChoices"];
            });
            /* harmony import */ var _dragdrop_ranking_select_to_rank__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! ../../dragdrop/ranking-select-to-rank */ "./src/dragdrop/ranking-select-to-rank.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropRankingSelectToRank", function() {
                return _dragdrop_ranking_select_to_rank__WEBPACK_IMPORTED_MODULE_94__["DragDropRankingSelectToRank"];
            });
            // styles
            // import "../../main.scss";
            //import "../../modern.scss";
            var Version;
            var ReleaseDate;
            Version = "1.9.137";
            ReleaseDate = "2024-04-02";
            function checkLibraryVersion(ver, libraryName) {
                if (Version != ver) {
                    var str = "survey-core has version '" + Version + "' and " + libraryName + " has version '" + ver + "'. SurveyJS libraries should have the same versions to work correctly.";
                    /* eslint no-console: ["error", { allow: ["error"] }] */ console.error(str);
                }
            }
            function setLicenseKey(key) {
                slk(key);
            }
            function slk(key) {
                _slk(key, lic, ReleaseDate);
            }
            function hasLicense(index) {
                return lic[index.toString()] === true;
            }
            var lic = {};
            function _slk(k, lh, rd) {
                if (!k) return;
                var en = function(s) {
                    var e = {}, i, b = 0, c, x, l = 0, a, r = "", w = String.fromCharCode, L = s.length;
                    var A = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
                    for(i = 0; i < 64; i++)e[A.charAt(i)] = i;
                    for(x = 0; x < L; x++){
                        var c_1 = e[s.charAt(x)];
                        b = (b << 6) + c_1;
                        l += 6;
                        while(l >= 8)((a = b >>> (l -= 8) & 0xff) || x < L - 2) && (r += w(a));
                    }
                    return r;
                };
                var v = en(k);
                if (!v) return;
                var index = v.indexOf(";");
                if (index < 0) return;
                if (!checkPrefix(v.substring(0, index))) return;
                v = v.substring(index + 1);
                v.split(",").forEach(function(s) {
                    var i = s.indexOf("=");
                    if (i > 0) lh[s.substring(0, i)] = new Date(rd) <= new Date(s.substring(i + 1));
                });
            }
            function checkPrefix(prefix) {
                if (!prefix) return true;
                var s = "domains:";
                var index = prefix.indexOf(s);
                if (index < 0) return true;
                var ds = prefix.substring(index + s.length).toLowerCase().split(",");
                if (!Array.isArray(ds) || ds.length === 0) return true;
                var location = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomWindowHelper"].getLocation();
                if (!!location && !!location.hostname) {
                    var hn = location.hostname.toLowerCase();
                    ds.push("localhost");
                    for(var i = 0; i < ds.length; i++){
                        if (hn.indexOf(ds[i]) > -1) return true;
                    }
                    return false;
                }
                return true;
            }
        // export { cultureInfo } from "../../cultureInfo";
        //Uncomment to include the "date" question type.
        //export {default as QuestionDateModel} from "../../plugins/question_date";
        /***/ },
        /***/ "./src/entries/core-wo-model.ts": /*!**************************************!*\
  !*** ./src/entries/core-wo-model.ts ***!
  \**************************************/ /*! exports provided: Version, ReleaseDate, checkLibraryVersion, setLicenseKey, slk, hasLicense, settings, Helpers, AnswerCountValidator, EmailValidator, NumericValidator, RegexValidator, SurveyValidator, TextValidator, ValidatorResult, ExpressionValidator, ValidatorRunner, ItemValue, Base, Event, EventBase, ArrayChanges, ComputedUpdater, SurveyError, SurveyElementCore, SurveyElement, DragTypeOverMeEnum, CalculatedValue, CustomError, AnswerRequiredError, OneAnswerRequiredError, RequreNumericError, ExceedSizeError, LocalizableString, LocalizableStrings, HtmlConditionItem, UrlConditionItem, ChoicesRestful, ChoicesRestfull, FunctionFactory, registerFunction, ConditionRunner, ExpressionRunner, ExpressionExecutor, Operand, Const, BinaryOperand, Variable, FunctionOperand, ArrayOperand, UnaryOperand, ConditionsParser, ProcessValue, JsonError, JsonIncorrectTypeError, JsonMetadata, JsonMetadataClass, JsonMissingTypeError, JsonMissingTypeErrorBase, JsonObject, JsonObjectProperty, JsonRequiredPropertyError, JsonUnknownPropertyError, Serializer, property, propertyArray, MatrixDropdownCell, MatrixDropdownRowModelBase, QuestionMatrixDropdownModelBase, MatrixDropdownColumn, matrixDropdownColumnTypes, QuestionMatrixDropdownRenderedCell, QuestionMatrixDropdownRenderedRow, QuestionMatrixDropdownRenderedErrorRow, QuestionMatrixDropdownRenderedTable, MatrixDropdownRowModel, QuestionMatrixDropdownModel, MatrixDynamicRowModel, QuestionMatrixDynamicModel, MatrixRowModel, MatrixCells, QuestionMatrixModel, QuestionMatrixBaseModel, MultipleTextItemModel, MultipleTextCell, MultipleTextErrorCell, MutlipleTextErrorRow, MutlipleTextRow, QuestionMultipleTextModel, MultipleTextEditorModel, PanelModel, PanelModelBase, QuestionRowModel, FlowPanelModel, PageModel, DefaultTitleModel, Question, QuestionNonValue, QuestionEmptyModel, QuestionCheckboxBase, QuestionSelectBase, QuestionCheckboxModel, QuestionTagboxModel, QuestionRankingModel, QuestionCommentModel, QuestionDropdownModel, QuestionFactory, ElementFactory, QuestionFileModel, QuestionHtmlModel, QuestionRadiogroupModel, QuestionRatingModel, RenderedRatingItem, QuestionExpressionModel, QuestionTextBase, CharacterCounter, QuestionTextModel, QuestionBooleanModel, QuestionImagePickerModel, ImageItemValue, QuestionImageModel, QuestionSignaturePadModel, QuestionPanelDynamicModel, QuestionPanelDynamicItem, SurveyTimer, SurveyTimerModel, tryFocusPage, createTOCListModel, getTocRootCss, TOCModel, SurveyProgressModel, ProgressButtons, ProgressButtonsResponsivityManager, SurveyModel, SurveyTrigger, SurveyTriggerComplete, SurveyTriggerSetValue, SurveyTriggerVisible, SurveyTriggerCopyValue, SurveyTriggerRunExpression, SurveyTriggerSkip, Trigger, PopupSurveyModel, SurveyWindowModel, TextPreProcessor, Notifier, Cover, CoverCell, dxSurveyService, englishStrings, surveyLocalization, surveyStrings, QuestionCustomWidget, CustomWidgetCollection, QuestionCustomModel, QuestionCompositeModel, ComponentQuestionJSON, ComponentCollection, StylesManager, ListModel, MultiSelectListModel, PopupModel, createDialogOptions, PopupBaseViewModel, PopupDropdownViewModel, PopupModalViewModel, createPopupViewModel, createPopupModalViewModel, DropdownListModel, DropdownMultiSelectListModel, QuestionButtonGroupModel, ButtonGroupItemModel, ButtonGroupItemValue, IsMobile, IsTouch, _setIsTouch, confirmAction, confirmActionAsync, detectIEOrEdge, doKey2ClickUp, doKey2ClickDown, doKey2ClickBlur, loadFileFromBase64, increaseHeightByContent, createSvg, chooseFiles, sanitizeEditableContent, InputMaskBase, InputMaskPattern, InputMaskNumeric, InputMaskDateTime, InputMaskCurrency, CssClassBuilder, surveyCss, defaultV2Css, defaultV2ThemeName, DragDropCore, DragDropChoices, DragDropRankingSelectToRank, defaultStandardCss, modernCss, SvgIconRegistry, SvgRegistry, SvgBundleViewModel, RendererFactory, ResponsivityManager, VerticalResponsivityManager, unwrap, getOriginalEvent, getElement, createDropdownActionModel, createDropdownActionModelAdvanced, getActionDropdownButtonTarget, BaseAction, Action, ActionDropdownViewModel, AnimationUtils, AnimationPropertyUtils, AnimationGroupUtils, AnimationBoolean, AnimationGroup, AdaptiveActionContainer, defaultActionBarCss, ActionContainer, DragOrClickHelper */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _chunks_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./chunks/model */ "./src/entries/chunks/model.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Version", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Version"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReleaseDate", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ReleaseDate"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "checkLibraryVersion", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["checkLibraryVersion"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setLicenseKey", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["setLicenseKey"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "slk", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["slk"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hasLicense", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["hasLicense"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "settings", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["settings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Helpers", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Helpers"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnswerCountValidator", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["AnswerCountValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["EmailValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumericValidator", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["NumericValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RegexValidator", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["RegexValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyValidator", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextValidator", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["TextValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValidatorResult", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ValidatorResult"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionValidator", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ExpressionValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValidatorRunner", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ValidatorRunner"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ItemValue", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ItemValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Base"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Event", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Event"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["EventBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayChanges", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ArrayChanges"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComputedUpdater", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ComputedUpdater"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElementCore", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyElementCore"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElement", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyElement"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTypeOverMeEnum", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["DragTypeOverMeEnum"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculatedValue", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["CalculatedValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CustomError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["CustomError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnswerRequiredError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["AnswerRequiredError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OneAnswerRequiredError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["OneAnswerRequiredError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RequreNumericError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["RequreNumericError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExceedSizeError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ExceedSizeError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableString", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["LocalizableString"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableStrings", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["LocalizableStrings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HtmlConditionItem", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["HtmlConditionItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UrlConditionItem", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["UrlConditionItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChoicesRestful", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ChoicesRestful"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChoicesRestfull", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ChoicesRestfull"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionFactory", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["FunctionFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "registerFunction", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["registerFunction"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConditionRunner", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ConditionRunner"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionRunner", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ExpressionRunner"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionExecutor", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ExpressionExecutor"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Operand", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Operand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Const", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Const"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BinaryOperand", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["BinaryOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Variable", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Variable"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionOperand", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["FunctionOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayOperand", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ArrayOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnaryOperand", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["UnaryOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConditionsParser", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ConditionsParser"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProcessValue", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ProcessValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonIncorrectTypeError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonIncorrectTypeError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMetadata", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonMetadata"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMetadataClass", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonMetadataClass"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonMissingTypeError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeErrorBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonMissingTypeErrorBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonObject", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonObject"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonObjectProperty", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonObjectProperty"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonRequiredPropertyError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonRequiredPropertyError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonUnknownPropertyError", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["JsonUnknownPropertyError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Serializer", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Serializer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "property", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["property"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "propertyArray", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["propertyArray"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownCell", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownRowModelBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownRowModelBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownModelBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownModelBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownColumn", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownColumn"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matrixDropdownColumnTypes", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["matrixDropdownColumnTypes"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedCell", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownRenderedCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedRow", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownRenderedRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedErrorRow", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownRenderedErrorRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedTable", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownRenderedTable"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownRowModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDynamicRowModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDynamicRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDynamicModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDynamicModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixRowModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MatrixRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixCells", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MatrixCells"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixBaseModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixBaseModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextItemModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MultipleTextItemModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextCell", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MultipleTextCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextErrorCell", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MultipleTextErrorCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MutlipleTextErrorRow", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MutlipleTextErrorRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MutlipleTextRow", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MutlipleTextRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMultipleTextModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMultipleTextModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextEditorModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MultipleTextEditorModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["PanelModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelModelBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["PanelModelBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRowModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlowPanelModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["FlowPanelModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PageModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["PageModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultTitleModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["DefaultTitleModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Question", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Question"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionNonValue", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionNonValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionEmptyModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionEmptyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCheckboxBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCheckboxBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionSelectBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionSelectBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCheckboxModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCheckboxModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTagboxModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionTagboxModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRankingModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionRankingModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCommentModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCommentModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionDropdownModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionDropdownModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionFactory", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ElementFactory", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ElementFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionFileModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionFileModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionHtmlModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionHtmlModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRadiogroupModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionRadiogroupModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRatingModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionRatingModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RenderedRatingItem", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["RenderedRatingItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionExpressionModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionExpressionModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTextBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionTextBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CharacterCounter", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["CharacterCounter"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTextModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionTextModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionBooleanModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionBooleanModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionImagePickerModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionImagePickerModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageItemValue", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ImageItemValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionImageModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionImageModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionSignaturePadModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionSignaturePadModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionPanelDynamicModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicItem", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionPanelDynamicItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTimer", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTimer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTimerModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTimerModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "tryFocusPage", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["tryFocusPage"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createTOCListModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["createTOCListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getTocRootCss", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["getTocRootCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TOCModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["TOCModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyProgressModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressButtons", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ProgressButtons"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressButtonsResponsivityManager", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ProgressButtonsResponsivityManager"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTrigger", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTrigger"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerComplete", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerComplete"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerSetValue", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerSetValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerVisible", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerVisible"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerCopyValue", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerCopyValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerRunExpression", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerRunExpression"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerSkip", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerSkip"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Trigger", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Trigger"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupSurveyModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["PopupSurveyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyWindowModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["SurveyWindowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextPreProcessor", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["TextPreProcessor"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Notifier", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Notifier"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Cover", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["Cover"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoverCell", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["CoverCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dxSurveyService", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["dxSurveyService"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "englishStrings", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["englishStrings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyLocalization", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyStrings", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["surveyStrings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomWidget", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCustomWidget"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CustomWidgetCollection", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["CustomWidgetCollection"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCustomModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCompositeModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCompositeModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentQuestionJSON", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ComponentQuestionJSON"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentCollection", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ComponentCollection"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StylesManager", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["StylesManager"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiSelectListModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["MultiSelectListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["PopupModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createDialogOptions", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["createDialogOptions"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupBaseViewModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["PopupBaseViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupDropdownViewModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["PopupDropdownViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupModalViewModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["PopupModalViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createPopupViewModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["createPopupViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createPopupModalViewModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["createPopupModalViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownListModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["DropdownListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownMultiSelectListModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["DropdownMultiSelectListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionButtonGroupModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["QuestionButtonGroupModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupItemModel", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ButtonGroupItemModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupItemValue", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["ButtonGroupItemValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IsMobile", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["IsMobile"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IsTouch", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["IsTouch"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_setIsTouch", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["_setIsTouch"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "confirmAction", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["confirmAction"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "confirmActionAsync", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["confirmActionAsync"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "detectIEOrEdge", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["detectIEOrEdge"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickUp", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["doKey2ClickUp"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickDown", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["doKey2ClickDown"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickBlur", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["doKey2ClickBlur"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "loadFileFromBase64", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["loadFileFromBase64"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "increaseHeightByContent", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["increaseHeightByContent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createSvg", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["createSvg"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "chooseFiles", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["chooseFiles"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sanitizeEditableContent", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["sanitizeEditableContent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskBase", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskPattern", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskPattern"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskNumeric", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskNumeric"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskDateTime", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskDateTime"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskCurrency", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskCurrency"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CssClassBuilder", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["CssClassBuilder"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyCss", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["surveyCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultV2Css", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["defaultV2Css"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultV2ThemeName", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["defaultV2ThemeName"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropCore", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["DragDropCore"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropChoices", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["DragDropChoices"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropRankingSelectToRank", function() {
                return _chunks_model__WEBPACK_IMPORTED_MODULE_0__["DragDropRankingSelectToRank"];
            });
            /* harmony import */ var _defaultCss_cssstandard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../defaultCss/cssstandard */ "./src/defaultCss/cssstandard.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultStandardCss", function() {
                return _defaultCss_cssstandard__WEBPACK_IMPORTED_MODULE_1__["defaultStandardCss"];
            });
            /* harmony import */ var _defaultCss_cssmodern__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../defaultCss/cssmodern */ "./src/defaultCss/cssmodern.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "modernCss", function() {
                return _defaultCss_cssmodern__WEBPACK_IMPORTED_MODULE_2__["modernCss"];
            });
            /* harmony import */ var _svgbundle__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../svgbundle */ "./src/svgbundle.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgIconRegistry", function() {
                return _svgbundle__WEBPACK_IMPORTED_MODULE_3__["SvgIconRegistry"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgRegistry", function() {
                return _svgbundle__WEBPACK_IMPORTED_MODULE_3__["SvgRegistry"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgBundleViewModel", function() {
                return _svgbundle__WEBPACK_IMPORTED_MODULE_3__["SvgBundleViewModel"];
            });
            /* harmony import */ var _rendererFactory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../rendererFactory */ "./src/rendererFactory.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RendererFactory", function() {
                return _rendererFactory__WEBPACK_IMPORTED_MODULE_4__["RendererFactory"];
            });
            /* harmony import */ var _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/responsivity-manager */ "./src/utils/responsivity-manager.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResponsivityManager", function() {
                return _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_5__["ResponsivityManager"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VerticalResponsivityManager", function() {
                return _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_5__["VerticalResponsivityManager"];
            });
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "unwrap", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_6__["unwrap"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getOriginalEvent", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_6__["getOriginalEvent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getElement", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_6__["getElement"];
            });
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../actions/action */ "./src/actions/action.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createDropdownActionModel", function() {
                return _actions_action__WEBPACK_IMPORTED_MODULE_7__["createDropdownActionModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createDropdownActionModelAdvanced", function() {
                return _actions_action__WEBPACK_IMPORTED_MODULE_7__["createDropdownActionModelAdvanced"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getActionDropdownButtonTarget", function() {
                return _actions_action__WEBPACK_IMPORTED_MODULE_7__["getActionDropdownButtonTarget"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseAction", function() {
                return _actions_action__WEBPACK_IMPORTED_MODULE_7__["BaseAction"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Action", function() {
                return _actions_action__WEBPACK_IMPORTED_MODULE_7__["Action"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionDropdownViewModel", function() {
                return _actions_action__WEBPACK_IMPORTED_MODULE_7__["ActionDropdownViewModel"];
            });
            /* harmony import */ var _utils_animation__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../utils/animation */ "./src/utils/animation.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationUtils", function() {
                return _utils_animation__WEBPACK_IMPORTED_MODULE_8__["AnimationUtils"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationPropertyUtils", function() {
                return _utils_animation__WEBPACK_IMPORTED_MODULE_8__["AnimationPropertyUtils"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationGroupUtils", function() {
                return _utils_animation__WEBPACK_IMPORTED_MODULE_8__["AnimationGroupUtils"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationBoolean", function() {
                return _utils_animation__WEBPACK_IMPORTED_MODULE_8__["AnimationBoolean"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationGroup", function() {
                return _utils_animation__WEBPACK_IMPORTED_MODULE_8__["AnimationGroup"];
            });
            /* harmony import */ var _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../actions/adaptive-container */ "./src/actions/adaptive-container.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdaptiveActionContainer", function() {
                return _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_9__["AdaptiveActionContainer"];
            });
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../actions/container */ "./src/actions/container.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultActionBarCss", function() {
                return _actions_container__WEBPACK_IMPORTED_MODULE_10__["defaultActionBarCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionContainer", function() {
                return _actions_container__WEBPACK_IMPORTED_MODULE_10__["ActionContainer"];
            });
            /* harmony import */ var _utils_dragOrClickHelper__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../utils/dragOrClickHelper */ "./src/utils/dragOrClickHelper.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragOrClickHelper", function() {
                return _utils_dragOrClickHelper__WEBPACK_IMPORTED_MODULE_11__["DragOrClickHelper"];
            });
        // model
        // css standard classes
        // css modern classes
        // utils
        /***/ },
        /***/ "./src/entries/core.ts": /*!*****************************!*\
  !*** ./src/entries/core.ts ***!
  \*****************************/ /*! exports provided: Version, ReleaseDate, checkLibraryVersion, setLicenseKey, slk, hasLicense, settings, Helpers, AnswerCountValidator, EmailValidator, NumericValidator, RegexValidator, SurveyValidator, TextValidator, ValidatorResult, ExpressionValidator, ValidatorRunner, ItemValue, Base, Event, EventBase, ArrayChanges, ComputedUpdater, SurveyError, SurveyElementCore, SurveyElement, DragTypeOverMeEnum, CalculatedValue, CustomError, AnswerRequiredError, OneAnswerRequiredError, RequreNumericError, ExceedSizeError, LocalizableString, LocalizableStrings, HtmlConditionItem, UrlConditionItem, ChoicesRestful, ChoicesRestfull, FunctionFactory, registerFunction, ConditionRunner, ExpressionRunner, ExpressionExecutor, Operand, Const, BinaryOperand, Variable, FunctionOperand, ArrayOperand, UnaryOperand, ConditionsParser, ProcessValue, JsonError, JsonIncorrectTypeError, JsonMetadata, JsonMetadataClass, JsonMissingTypeError, JsonMissingTypeErrorBase, JsonObject, JsonObjectProperty, JsonRequiredPropertyError, JsonUnknownPropertyError, Serializer, property, propertyArray, MatrixDropdownCell, MatrixDropdownRowModelBase, QuestionMatrixDropdownModelBase, MatrixDropdownColumn, matrixDropdownColumnTypes, QuestionMatrixDropdownRenderedCell, QuestionMatrixDropdownRenderedRow, QuestionMatrixDropdownRenderedErrorRow, QuestionMatrixDropdownRenderedTable, MatrixDropdownRowModel, QuestionMatrixDropdownModel, MatrixDynamicRowModel, QuestionMatrixDynamicModel, MatrixRowModel, MatrixCells, QuestionMatrixModel, QuestionMatrixBaseModel, MultipleTextItemModel, MultipleTextCell, MultipleTextErrorCell, MutlipleTextErrorRow, MutlipleTextRow, QuestionMultipleTextModel, MultipleTextEditorModel, PanelModel, PanelModelBase, QuestionRowModel, FlowPanelModel, PageModel, DefaultTitleModel, Question, QuestionNonValue, QuestionEmptyModel, QuestionCheckboxBase, QuestionSelectBase, QuestionCheckboxModel, QuestionTagboxModel, QuestionRankingModel, QuestionCommentModel, QuestionDropdownModel, QuestionFactory, ElementFactory, QuestionFileModel, QuestionHtmlModel, QuestionRadiogroupModel, QuestionRatingModel, RenderedRatingItem, QuestionExpressionModel, QuestionTextBase, CharacterCounter, QuestionTextModel, QuestionBooleanModel, QuestionImagePickerModel, ImageItemValue, QuestionImageModel, QuestionSignaturePadModel, QuestionPanelDynamicModel, QuestionPanelDynamicItem, SurveyTimer, SurveyTimerModel, tryFocusPage, createTOCListModel, getTocRootCss, TOCModel, SurveyProgressModel, ProgressButtons, ProgressButtonsResponsivityManager, SurveyModel, SurveyTrigger, SurveyTriggerComplete, SurveyTriggerSetValue, SurveyTriggerVisible, SurveyTriggerCopyValue, SurveyTriggerRunExpression, SurveyTriggerSkip, Trigger, PopupSurveyModel, SurveyWindowModel, TextPreProcessor, Notifier, Cover, CoverCell, dxSurveyService, englishStrings, surveyLocalization, surveyStrings, QuestionCustomWidget, CustomWidgetCollection, QuestionCustomModel, QuestionCompositeModel, ComponentQuestionJSON, ComponentCollection, StylesManager, ListModel, MultiSelectListModel, PopupModel, createDialogOptions, PopupBaseViewModel, PopupDropdownViewModel, PopupModalViewModel, createPopupViewModel, createPopupModalViewModel, DropdownListModel, DropdownMultiSelectListModel, QuestionButtonGroupModel, ButtonGroupItemModel, ButtonGroupItemValue, IsMobile, IsTouch, _setIsTouch, confirmAction, confirmActionAsync, detectIEOrEdge, doKey2ClickUp, doKey2ClickDown, doKey2ClickBlur, loadFileFromBase64, increaseHeightByContent, createSvg, chooseFiles, sanitizeEditableContent, InputMaskBase, InputMaskPattern, InputMaskNumeric, InputMaskDateTime, InputMaskCurrency, CssClassBuilder, surveyCss, defaultV2Css, defaultV2ThemeName, DragDropCore, DragDropChoices, DragDropRankingSelectToRank, defaultStandardCss, modernCss, SvgIconRegistry, SvgRegistry, SvgBundleViewModel, RendererFactory, ResponsivityManager, VerticalResponsivityManager, unwrap, getOriginalEvent, getElement, createDropdownActionModel, createDropdownActionModelAdvanced, getActionDropdownButtonTarget, BaseAction, Action, ActionDropdownViewModel, AnimationUtils, AnimationPropertyUtils, AnimationGroupUtils, AnimationBoolean, AnimationGroup, AdaptiveActionContainer, defaultActionBarCss, ActionContainer, DragOrClickHelper, Model */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _core_wo_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./core-wo-model */ "./src/entries/core-wo-model.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Version", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Version"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReleaseDate", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ReleaseDate"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "checkLibraryVersion", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["checkLibraryVersion"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "setLicenseKey", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["setLicenseKey"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "slk", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["slk"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "hasLicense", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["hasLicense"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "settings", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["settings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Helpers", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Helpers"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnswerCountValidator", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["AnswerCountValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["EmailValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NumericValidator", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["NumericValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RegexValidator", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["RegexValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyValidator", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextValidator", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["TextValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValidatorResult", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ValidatorResult"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionValidator", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ExpressionValidator"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ValidatorRunner", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ValidatorRunner"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ItemValue", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ItemValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Base", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Base"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Event", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Event"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "EventBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["EventBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayChanges", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ArrayChanges"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComputedUpdater", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ComputedUpdater"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElementCore", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyElementCore"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElement", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyElement"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragTypeOverMeEnum", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["DragTypeOverMeEnum"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CalculatedValue", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["CalculatedValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CustomError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["CustomError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnswerRequiredError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["AnswerRequiredError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "OneAnswerRequiredError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["OneAnswerRequiredError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RequreNumericError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["RequreNumericError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExceedSizeError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ExceedSizeError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableString", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["LocalizableString"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LocalizableStrings", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["LocalizableStrings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HtmlConditionItem", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["HtmlConditionItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UrlConditionItem", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["UrlConditionItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChoicesRestful", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ChoicesRestful"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ChoicesRestfull", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ChoicesRestfull"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionFactory", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["FunctionFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "registerFunction", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["registerFunction"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConditionRunner", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ConditionRunner"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionRunner", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ExpressionRunner"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ExpressionExecutor", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ExpressionExecutor"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Operand", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Operand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Const", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Const"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BinaryOperand", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["BinaryOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Variable", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Variable"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FunctionOperand", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["FunctionOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ArrayOperand", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ArrayOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "UnaryOperand", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["UnaryOperand"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ConditionsParser", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ConditionsParser"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProcessValue", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ProcessValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonIncorrectTypeError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonIncorrectTypeError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMetadata", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonMetadata"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMetadataClass", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonMetadataClass"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonMissingTypeError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeErrorBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonMissingTypeErrorBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonObject", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonObject"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonObjectProperty", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonObjectProperty"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonRequiredPropertyError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonRequiredPropertyError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "JsonUnknownPropertyError", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["JsonUnknownPropertyError"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Serializer", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Serializer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "property", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["property"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "propertyArray", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["propertyArray"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownCell", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownRowModelBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownRowModelBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownModelBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownModelBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownColumn", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownColumn"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "matrixDropdownColumnTypes", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["matrixDropdownColumnTypes"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedCell", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownRenderedCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedRow", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownRenderedRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedErrorRow", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownRenderedErrorRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedTable", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownRenderedTable"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownRowModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixDynamicRowModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MatrixDynamicRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDynamicModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDynamicModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixRowModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MatrixRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixCells", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MatrixCells"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixBaseModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixBaseModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextItemModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MultipleTextItemModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextCell", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MultipleTextCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextErrorCell", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MultipleTextErrorCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MutlipleTextErrorRow", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MutlipleTextErrorRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MutlipleTextRow", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MutlipleTextRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionMultipleTextModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionMultipleTextModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultipleTextEditorModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MultipleTextEditorModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["PanelModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PanelModelBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["PanelModelBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRowModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionRowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "FlowPanelModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["FlowPanelModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PageModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["PageModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DefaultTitleModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["DefaultTitleModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Question", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Question"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionNonValue", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionNonValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionEmptyModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionEmptyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCheckboxBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCheckboxBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionSelectBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionSelectBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCheckboxModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCheckboxModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTagboxModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionTagboxModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRankingModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionRankingModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCommentModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCommentModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionDropdownModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionDropdownModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionFactory", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ElementFactory", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ElementFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionFileModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionFileModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionHtmlModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionHtmlModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRadiogroupModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionRadiogroupModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionRatingModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionRatingModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RenderedRatingItem", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["RenderedRatingItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionExpressionModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionExpressionModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTextBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionTextBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CharacterCounter", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["CharacterCounter"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionTextModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionTextModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionBooleanModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionBooleanModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionImagePickerModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionImagePickerModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ImageItemValue", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ImageItemValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionImageModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionImageModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionSignaturePadModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionSignaturePadModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionPanelDynamicModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicItem", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionPanelDynamicItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTimer", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTimer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTimerModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTimerModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "tryFocusPage", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["tryFocusPage"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createTOCListModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["createTOCListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getTocRootCss", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["getTocRootCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TOCModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["TOCModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyProgressModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressButtons", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ProgressButtons"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ProgressButtonsResponsivityManager", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ProgressButtonsResponsivityManager"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTrigger", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTrigger"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerComplete", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerComplete"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerSetValue", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerSetValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerVisible", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerVisible"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerCopyValue", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerCopyValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerRunExpression", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerRunExpression"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerSkip", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTriggerSkip"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Trigger", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Trigger"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupSurveyModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["PopupSurveyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyWindowModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SurveyWindowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TextPreProcessor", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["TextPreProcessor"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Notifier", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Notifier"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Cover", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Cover"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CoverCell", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["CoverCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "dxSurveyService", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["dxSurveyService"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "englishStrings", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["englishStrings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyLocalization", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyStrings", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["surveyStrings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomWidget", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCustomWidget"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CustomWidgetCollection", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["CustomWidgetCollection"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCustomModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionCompositeModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionCompositeModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentQuestionJSON", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ComponentQuestionJSON"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentCollection", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ComponentCollection"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "StylesManager", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["StylesManager"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ListModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MultiSelectListModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["MultiSelectListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["PopupModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createDialogOptions", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["createDialogOptions"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupBaseViewModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["PopupBaseViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupDropdownViewModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["PopupDropdownViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupModalViewModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["PopupModalViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createPopupViewModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["createPopupViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createPopupModalViewModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["createPopupModalViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownListModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["DropdownListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DropdownMultiSelectListModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["DropdownMultiSelectListModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "QuestionButtonGroupModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["QuestionButtonGroupModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupItemModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ButtonGroupItemModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupItemValue", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ButtonGroupItemValue"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IsMobile", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["IsMobile"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "IsTouch", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["IsTouch"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "_setIsTouch", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["_setIsTouch"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "confirmAction", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["confirmAction"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "confirmActionAsync", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["confirmActionAsync"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "detectIEOrEdge", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["detectIEOrEdge"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickUp", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["doKey2ClickUp"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickDown", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["doKey2ClickDown"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickBlur", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["doKey2ClickBlur"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "loadFileFromBase64", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["loadFileFromBase64"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "increaseHeightByContent", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["increaseHeightByContent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createSvg", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["createSvg"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "chooseFiles", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["chooseFiles"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "sanitizeEditableContent", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["sanitizeEditableContent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskBase", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskPattern", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskPattern"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskNumeric", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskNumeric"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskDateTime", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskDateTime"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "InputMaskCurrency", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["InputMaskCurrency"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CssClassBuilder", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["CssClassBuilder"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyCss", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["surveyCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultV2Css", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["defaultV2Css"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultV2ThemeName", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["defaultV2ThemeName"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropCore", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["DragDropCore"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropChoices", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["DragDropChoices"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragDropRankingSelectToRank", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["DragDropRankingSelectToRank"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultStandardCss", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["defaultStandardCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "modernCss", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["modernCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgIconRegistry", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SvgIconRegistry"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgRegistry", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SvgRegistry"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgBundleViewModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["SvgBundleViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RendererFactory", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["RendererFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResponsivityManager", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ResponsivityManager"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VerticalResponsivityManager", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["VerticalResponsivityManager"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "unwrap", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["unwrap"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getOriginalEvent", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["getOriginalEvent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getElement", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["getElement"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createDropdownActionModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["createDropdownActionModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "createDropdownActionModelAdvanced", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["createDropdownActionModelAdvanced"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "getActionDropdownButtonTarget", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["getActionDropdownButtonTarget"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "BaseAction", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["BaseAction"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Action", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["Action"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionDropdownViewModel", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ActionDropdownViewModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationUtils", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["AnimationUtils"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationPropertyUtils", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["AnimationPropertyUtils"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationGroupUtils", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["AnimationGroupUtils"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationBoolean", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["AnimationBoolean"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AnimationGroup", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["AnimationGroup"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "AdaptiveActionContainer", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["AdaptiveActionContainer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "defaultActionBarCss", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["defaultActionBarCss"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ActionContainer", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["ActionContainer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "DragOrClickHelper", function() {
                return _core_wo_model__WEBPACK_IMPORTED_MODULE_0__["DragOrClickHelper"];
            });
            /* harmony import */ var _survey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../survey */ "./src/survey.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() {
                return _survey__WEBPACK_IMPORTED_MODULE_1__["SurveyModel"];
            });
        // model
        /***/ },
        /***/ "./src/error.ts": /*!**********************!*\
  !*** ./src/error.ts ***!
  \**********************/ /*! exports provided: AnswerRequiredError, OneAnswerRequiredError, RequreNumericError, ExceedSizeError, WebRequestError, WebRequestEmptyError, OtherEmptyError, UploadingFileError, RequiredInAllRowsError, EachRowUniqueError, MinRowCountError, KeyDuplicationError, CustomError */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnswerRequiredError", function() {
                return AnswerRequiredError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OneAnswerRequiredError", function() {
                return OneAnswerRequiredError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequreNumericError", function() {
                return RequreNumericError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExceedSizeError", function() {
                return ExceedSizeError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebRequestError", function() {
                return WebRequestError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "WebRequestEmptyError", function() {
                return WebRequestEmptyError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OtherEmptyError", function() {
                return OtherEmptyError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UploadingFileError", function() {
                return UploadingFileError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RequiredInAllRowsError", function() {
                return RequiredInAllRowsError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EachRowUniqueError", function() {
                return EachRowUniqueError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MinRowCountError", function() {
                return MinRowCountError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "KeyDuplicationError", function() {
                return KeyDuplicationError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomError", function() {
                return CustomError;
            });
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _survey_error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./survey-error */ "./src/survey-error.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var AnswerRequiredError = /** @class */ function(_super) {
                __extends(AnswerRequiredError, _super);
                function AnswerRequiredError(text, errorOwner) {
                    if (text === void 0) text = null;
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                AnswerRequiredError.prototype.getErrorType = function() {
                    return "required";
                };
                AnswerRequiredError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("requiredError");
                };
                return AnswerRequiredError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var OneAnswerRequiredError = /** @class */ function(_super) {
                __extends(OneAnswerRequiredError, _super);
                function OneAnswerRequiredError(text, errorOwner) {
                    if (text === void 0) text = null;
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                OneAnswerRequiredError.prototype.getErrorType = function() {
                    return "requireoneanswer";
                };
                OneAnswerRequiredError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("requiredErrorInPanel");
                };
                return OneAnswerRequiredError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var RequreNumericError = /** @class */ function(_super) {
                __extends(RequreNumericError, _super);
                function RequreNumericError(text, errorOwner) {
                    if (text === void 0) text = null;
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                RequreNumericError.prototype.getErrorType = function() {
                    return "requirenumeric";
                };
                RequreNumericError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("numericError");
                };
                return RequreNumericError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var ExceedSizeError = /** @class */ function(_super) {
                __extends(ExceedSizeError, _super);
                function ExceedSizeError(maxSize, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, null, errorOwner) || this;
                    _this.maxSize = maxSize;
                    _this.locText.text = _this.getText();
                    return _this;
                }
                ExceedSizeError.prototype.getErrorType = function() {
                    return "exceedsize";
                };
                ExceedSizeError.prototype.getDefaultText = function() {
                    return _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString("exceedMaxSize")["format"](this.getTextSize());
                };
                ExceedSizeError.prototype.getTextSize = function() {
                    var sizes = [
                        "Bytes",
                        "KB",
                        "MB",
                        "GB",
                        "TB"
                    ];
                    var fixed = [
                        0,
                        0,
                        2,
                        3,
                        3
                    ];
                    if (this.maxSize === 0) return "0 Byte";
                    var i = Math.floor(Math.log(this.maxSize) / Math.log(1024));
                    var value = this.maxSize / Math.pow(1024, i);
                    return value.toFixed(fixed[i]) + " " + sizes[i];
                };
                return ExceedSizeError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var WebRequestError = /** @class */ function(_super) {
                __extends(WebRequestError, _super);
                function WebRequestError(status, response, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, null, errorOwner) || this;
                    _this.status = status;
                    _this.response = response;
                    return _this;
                }
                WebRequestError.prototype.getErrorType = function() {
                    return "webrequest";
                };
                WebRequestError.prototype.getDefaultText = function() {
                    var str = this.getLocalizationString("urlRequestError");
                    return !!str ? str["format"](this.status, this.response) : "";
                };
                return WebRequestError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var WebRequestEmptyError = /** @class */ function(_super) {
                __extends(WebRequestEmptyError, _super);
                function WebRequestEmptyError(text, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                WebRequestEmptyError.prototype.getErrorType = function() {
                    return "webrequestempty";
                };
                WebRequestEmptyError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("urlGetChoicesError");
                };
                return WebRequestEmptyError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var OtherEmptyError = /** @class */ function(_super) {
                __extends(OtherEmptyError, _super);
                function OtherEmptyError(text, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                OtherEmptyError.prototype.getErrorType = function() {
                    return "otherempty";
                };
                OtherEmptyError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("otherRequiredError");
                };
                return OtherEmptyError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var UploadingFileError = /** @class */ function(_super) {
                __extends(UploadingFileError, _super);
                function UploadingFileError(text, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                UploadingFileError.prototype.getErrorType = function() {
                    return "uploadingfile";
                };
                UploadingFileError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("uploadingFile");
                };
                return UploadingFileError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var RequiredInAllRowsError = /** @class */ function(_super) {
                __extends(RequiredInAllRowsError, _super);
                function RequiredInAllRowsError(text, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                RequiredInAllRowsError.prototype.getErrorType = function() {
                    return "requiredinallrowserror";
                };
                RequiredInAllRowsError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("requiredInAllRowsError");
                };
                return RequiredInAllRowsError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var EachRowUniqueError = /** @class */ function(_super) {
                __extends(EachRowUniqueError, _super);
                function EachRowUniqueError(text, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                EachRowUniqueError.prototype.getErrorType = function() {
                    return "eachrowuniqueeerror";
                };
                EachRowUniqueError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("eachRowUniqueError");
                };
                return EachRowUniqueError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var MinRowCountError = /** @class */ function(_super) {
                __extends(MinRowCountError, _super);
                function MinRowCountError(minRowCount, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, null, errorOwner) || this;
                    _this.minRowCount = minRowCount;
                    return _this;
                }
                MinRowCountError.prototype.getErrorType = function() {
                    return "minrowcounterror";
                };
                MinRowCountError.prototype.getDefaultText = function() {
                    return _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString("minRowCountError")["format"](this.minRowCount);
                };
                return MinRowCountError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var KeyDuplicationError = /** @class */ function(_super) {
                __extends(KeyDuplicationError, _super);
                function KeyDuplicationError(text, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                KeyDuplicationError.prototype.getErrorType = function() {
                    return "keyduplicationerror";
                };
                KeyDuplicationError.prototype.getDefaultText = function() {
                    return this.getLocalizationString("keyDuplicationError");
                };
                return KeyDuplicationError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
            var CustomError = /** @class */ function(_super) {
                __extends(CustomError, _super);
                function CustomError(text, errorOwner) {
                    if (errorOwner === void 0) errorOwner = null;
                    var _this = _super.call(this, text, errorOwner) || this;
                    _this.text = text;
                    return _this;
                }
                CustomError.prototype.getErrorType = function() {
                    return "custom";
                };
                return CustomError;
            }(_survey_error__WEBPACK_IMPORTED_MODULE_1__["SurveyError"]);
        /***/ },
        /***/ "./src/expressionItems.ts": /*!********************************!*\
  !*** ./src/expressionItems.ts ***!
  \********************************/ /*! exports provided: ExpressionItem, HtmlConditionItem, UrlConditionItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionItem", function() {
                return ExpressionItem;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HtmlConditionItem", function() {
                return HtmlConditionItem;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UrlConditionItem", function() {
                return UrlConditionItem;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * Base class for HtmlConditionItem and UrlConditionItem classes.
 */ var ExpressionItem = /** @class */ function(_super) {
                __extends(ExpressionItem, _super);
                function ExpressionItem(expression) {
                    if (expression === void 0) expression = null;
                    var _this = _super.call(this) || this;
                    _this.expression = expression;
                    return _this;
                }
                ExpressionItem.prototype.getType = function() {
                    return "expressionitem";
                };
                ExpressionItem.prototype.runCondition = function(values, properties) {
                    if (!this.expression) return false;
                    return new _conditions__WEBPACK_IMPORTED_MODULE_2__["ConditionRunner"](this.expression).run(values, properties);
                };
                Object.defineProperty(ExpressionItem.prototype, "expression", {
                    /**
         * The expression property. If this expression returns true, then survey will use html property to show on complete page.
         */ get: function() {
                        return this.getPropertyValue("expression", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("expression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExpressionItem.prototype, "locHtml", {
                    get: function() {
                        return this.getLocalizableString("html");
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionItem.prototype.getLocale = function() {
                    return !!this.locOwner ? this.locOwner.getLocale() : "";
                };
                ExpressionItem.prototype.getMarkdownHtml = function(text, name) {
                    return !!this.locOwner ? this.locOwner.getMarkdownHtml(text, name) : undefined;
                };
                ExpressionItem.prototype.getRenderer = function(name) {
                    return !!this.locOwner ? this.locOwner.getRenderer(name) : null;
                };
                ExpressionItem.prototype.getRendererContext = function(locStr) {
                    return !!this.locOwner ? this.locOwner.getRendererContext(locStr) : locStr;
                };
                ExpressionItem.prototype.getProcessedText = function(text) {
                    return this.locOwner ? this.locOwner.getProcessedText(text) : text;
                };
                ExpressionItem.prototype.getSurvey = function(isLive) {
                    if (isLive === void 0) isLive = false;
                    return this.locOwner;
                };
                return ExpressionItem;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
            /**
 * A class that contains expression and html propeties. It uses in survey.completedHtmlOnCondition array.
 * If the expression returns true then html of this item uses instead of survey.completedHtml property
 * @see SurveyModel.completedHtmlOnCondition
 * @see SurveyModel.completedHtml
 */ var HtmlConditionItem = /** @class */ function(_super) {
                __extends(HtmlConditionItem, _super);
                function HtmlConditionItem(expression, html) {
                    if (expression === void 0) expression = null;
                    if (html === void 0) html = null;
                    var _this = _super.call(this, expression) || this;
                    _this.createLocalizableString("html", _this);
                    _this.html = html;
                    return _this;
                }
                HtmlConditionItem.prototype.getType = function() {
                    return "htmlconditionitem";
                };
                Object.defineProperty(HtmlConditionItem.prototype, "html", {
                    /**
         * The html that shows on completed ('Thank you') page. The expression should return true
         * @see expression
         */ get: function() {
                        return this.getLocalizableStringText("html");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("html", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(HtmlConditionItem.prototype, "locHtml", {
                    get: function() {
                        return this.getLocalizableString("html");
                    },
                    enumerable: false,
                    configurable: true
                });
                return HtmlConditionItem;
            }(ExpressionItem);
            /**
 * A class that contains expression and url propeties. It uses in survey.navigateToUrlOnCondition array.
 * If the expression returns true then url of this item uses instead of survey.navigateToUrl property
 * @see SurveyModel.navigateToUrl
 */ var UrlConditionItem = /** @class */ function(_super) {
                __extends(UrlConditionItem, _super);
                function UrlConditionItem(expression, url) {
                    if (expression === void 0) expression = null;
                    if (url === void 0) url = null;
                    var _this = _super.call(this, expression) || this;
                    _this.createLocalizableString("url", _this);
                    _this.url = url;
                    return _this;
                }
                UrlConditionItem.prototype.getType = function() {
                    return "urlconditionitem";
                };
                Object.defineProperty(UrlConditionItem.prototype, "url", {
                    /**
         * The url that survey navigates to on completing the survey. The expression should return true
         * @see expression
         */ get: function() {
                        return this.getLocalizableStringText("url");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("url", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(UrlConditionItem.prototype, "locUrl", {
                    get: function() {
                        return this.getLocalizableString("url");
                    },
                    enumerable: false,
                    configurable: true
                });
                return UrlConditionItem;
            }(ExpressionItem);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("expressionitem", [
                "expression:condition"
            ], function() {
                return new ExpressionItem();
            }, "base");
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("htmlconditionitem", [
                {
                    name: "html:html",
                    serializationProperty: "locHtml"
                }
            ], function() {
                return new HtmlConditionItem();
            }, "expressionitem");
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("urlconditionitem", [
                {
                    name: "url:string",
                    serializationProperty: "locUrl"
                }
            ], function() {
                return new UrlConditionItem();
            }, "expressionitem");
        /***/ },
        /***/ "./src/expressions/expressionParser.ts": /*!*********************************************!*\
  !*** ./src/expressions/expressionParser.ts ***!
  \*********************************************/ /*! exports provided: SyntaxError, parse */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SyntaxError", function() {
                return SyntaxError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() {
                return parse;
            });
            /* harmony import */ var _expressions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./expressions */ "./src/expressions/expressions.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /* eslint-disable */ // Generated by PEG.js v. 0.10.0 (ts-pegjs plugin v. 0.3.1 )
            //
            // https://pegjs.org/   https://github.com/metadevpro/ts-pegjs
            "use strict";
            var SyntaxError = /** @class */ function(_super) {
                __extends(SyntaxError, _super);
                function SyntaxError(message, expected, found, location) {
                    var _this = _super.call(this) || this;
                    _this.message = message;
                    _this.expected = expected;
                    _this.found = found;
                    _this.location = location;
                    _this.name = "SyntaxError";
                    if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(_this, SyntaxError);
                    return _this;
                }
                SyntaxError.buildMessage = function(expected, found) {
                    function hex(ch) {
                        return ch.charCodeAt(0).toString(16).toUpperCase();
                    }
                    function literalEscape(s) {
                        return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                            return "\\x0" + hex(ch);
                        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                            return "\\x" + hex(ch);
                        });
                    }
                    function classEscape(s) {
                        return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                            return "\\x0" + hex(ch);
                        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                            return "\\x" + hex(ch);
                        });
                    }
                    function describeExpectation(expectation) {
                        switch(expectation.type){
                            case "literal":
                                return '"' + literalEscape(expectation.text) + '"';
                            case "class":
                                var escapedParts = expectation.parts.map(function(part) {
                                    return Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part);
                                });
                                return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
                            case "any":
                                return "any character";
                            case "end":
                                return "end of input";
                            case "other":
                                return expectation.description;
                        }
                    }
                    function describeExpected(expected1) {
                        var descriptions = expected1.map(describeExpectation);
                        var i;
                        var j;
                        descriptions.sort();
                        if (descriptions.length > 0) {
                            for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                                descriptions[j] = descriptions[i];
                                j++;
                            }
                            descriptions.length = j;
                        }
                        switch(descriptions.length){
                            case 1:
                                return descriptions[0];
                            case 2:
                                return descriptions[0] + " or " + descriptions[1];
                            default:
                                return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
                        }
                    }
                    function describeFound(found1) {
                        return found1 ? '"' + literalEscape(found1) + '"' : "end of input";
                    }
                    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
                };
                return SyntaxError;
            }(Error);
            function peg$parse(input, options) {
                options = options !== undefined ? options : {};
                var peg$FAILED = {};
                var peg$startRuleFunctions = {
                    Expression: peg$parseExpression
                };
                var peg$startRuleFunction = peg$parseExpression;
                var peg$c0 = function(head, tail) {
                    return buildBinaryOperand(head, tail, true);
                };
                var peg$c1 = "||";
                var peg$c2 = peg$literalExpectation("||", false);
                var peg$c3 = "or";
                var peg$c4 = peg$literalExpectation("or", true);
                var peg$c5 = function() {
                    return "or";
                };
                var peg$c6 = "&&";
                var peg$c7 = peg$literalExpectation("&&", false);
                var peg$c8 = "and";
                var peg$c9 = peg$literalExpectation("and", true);
                var peg$c10 = function() {
                    return "and";
                };
                var peg$c11 = function(head, tail) {
                    return buildBinaryOperand(head, tail);
                };
                var peg$c12 = "<=";
                var peg$c13 = peg$literalExpectation("<=", false);
                var peg$c14 = "lessorequal";
                var peg$c15 = peg$literalExpectation("lessorequal", true);
                var peg$c16 = function() {
                    return "lessorequal";
                };
                var peg$c17 = ">=";
                var peg$c18 = peg$literalExpectation(">=", false);
                var peg$c19 = "greaterorequal";
                var peg$c20 = peg$literalExpectation("greaterorequal", true);
                var peg$c21 = function() {
                    return "greaterorequal";
                };
                var peg$c22 = "==";
                var peg$c23 = peg$literalExpectation("==", false);
                var peg$c24 = "equal";
                var peg$c25 = peg$literalExpectation("equal", true);
                var peg$c26 = function() {
                    return "equal";
                };
                var peg$c27 = "=";
                var peg$c28 = peg$literalExpectation("=", false);
                var peg$c29 = "!=";
                var peg$c30 = peg$literalExpectation("!=", false);
                var peg$c31 = "notequal";
                var peg$c32 = peg$literalExpectation("notequal", true);
                var peg$c33 = function() {
                    return "notequal";
                };
                var peg$c34 = "<";
                var peg$c35 = peg$literalExpectation("<", false);
                var peg$c36 = "less";
                var peg$c37 = peg$literalExpectation("less", true);
                var peg$c38 = function() {
                    return "less";
                };
                var peg$c39 = ">";
                var peg$c40 = peg$literalExpectation(">", false);
                var peg$c41 = "greater";
                var peg$c42 = peg$literalExpectation("greater", true);
                var peg$c43 = function() {
                    return "greater";
                };
                var peg$c44 = "+";
                var peg$c45 = peg$literalExpectation("+", false);
                var peg$c46 = function() {
                    return "plus";
                };
                var peg$c47 = "-";
                var peg$c48 = peg$literalExpectation("-", false);
                var peg$c49 = function() {
                    return "minus";
                };
                var peg$c50 = "*";
                var peg$c51 = peg$literalExpectation("*", false);
                var peg$c52 = function() {
                    return "mul";
                };
                var peg$c53 = "/";
                var peg$c54 = peg$literalExpectation("/", false);
                var peg$c55 = function() {
                    return "div";
                };
                var peg$c56 = "%";
                var peg$c57 = peg$literalExpectation("%", false);
                var peg$c58 = function() {
                    return "mod";
                };
                var peg$c59 = "^";
                var peg$c60 = peg$literalExpectation("^", false);
                var peg$c61 = "power";
                var peg$c62 = peg$literalExpectation("power", true);
                var peg$c63 = function() {
                    return "power";
                };
                var peg$c64 = "*=";
                var peg$c65 = peg$literalExpectation("*=", false);
                var peg$c66 = "contains";
                var peg$c67 = peg$literalExpectation("contains", true);
                var peg$c68 = "contain";
                var peg$c69 = peg$literalExpectation("contain", true);
                var peg$c70 = function() {
                    return "contains";
                };
                var peg$c71 = "notcontains";
                var peg$c72 = peg$literalExpectation("notcontains", true);
                var peg$c73 = "notcontain";
                var peg$c74 = peg$literalExpectation("notcontain", true);
                var peg$c75 = function() {
                    return "notcontains";
                };
                var peg$c76 = "anyof";
                var peg$c77 = peg$literalExpectation("anyof", true);
                var peg$c78 = function() {
                    return "anyof";
                };
                var peg$c79 = "allof";
                var peg$c80 = peg$literalExpectation("allof", true);
                var peg$c81 = function() {
                    return "allof";
                };
                var peg$c82 = "(";
                var peg$c83 = peg$literalExpectation("(", false);
                var peg$c84 = ")";
                var peg$c85 = peg$literalExpectation(")", false);
                var peg$c86 = function(expr) {
                    return expr;
                };
                var peg$c87 = function(name, params) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["FunctionOperand"](name, params);
                };
                var peg$c88 = "!";
                var peg$c89 = peg$literalExpectation("!", false);
                var peg$c90 = "negate";
                var peg$c91 = peg$literalExpectation("negate", true);
                var peg$c92 = function(expr) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["UnaryOperand"](expr, "negate");
                };
                var peg$c93 = function(expr, op) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["UnaryOperand"](expr, op);
                };
                var peg$c94 = "empty";
                var peg$c95 = peg$literalExpectation("empty", true);
                var peg$c96 = function() {
                    return "empty";
                };
                var peg$c97 = "notempty";
                var peg$c98 = peg$literalExpectation("notempty", true);
                var peg$c99 = function() {
                    return "notempty";
                };
                var peg$c100 = "undefined";
                var peg$c101 = peg$literalExpectation("undefined", false);
                var peg$c102 = "null";
                var peg$c103 = peg$literalExpectation("null", false);
                var peg$c104 = function() {
                    return null;
                };
                var peg$c105 = function(value) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["Const"](value);
                };
                var peg$c106 = "{";
                var peg$c107 = peg$literalExpectation("{", false);
                var peg$c108 = "}";
                var peg$c109 = peg$literalExpectation("}", false);
                var peg$c110 = function(value) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["Variable"](value);
                };
                var peg$c111 = function(value) {
                    return value;
                };
                var peg$c112 = "''";
                var peg$c113 = peg$literalExpectation("''", false);
                var peg$c114 = function() {
                    return "";
                };
                var peg$c115 = '""';
                var peg$c116 = peg$literalExpectation('""', false);
                var peg$c117 = "'";
                var peg$c118 = peg$literalExpectation("'", false);
                var peg$c119 = function(value) {
                    return "'" + value + "'";
                };
                var peg$c120 = '"';
                var peg$c121 = peg$literalExpectation('"', false);
                var peg$c122 = "[";
                var peg$c123 = peg$literalExpectation("[", false);
                var peg$c124 = "]";
                var peg$c125 = peg$literalExpectation("]", false);
                var peg$c126 = function(sequence) {
                    return sequence;
                };
                var peg$c127 = ",";
                var peg$c128 = peg$literalExpectation(",", false);
                var peg$c129 = function(expr, tail) {
                    if (expr == null) return new _expressions__WEBPACK_IMPORTED_MODULE_0__["ArrayOperand"]([]);
                    var array = [
                        expr
                    ];
                    if (Array.isArray(tail)) {
                        var flatten = flattenArray(tail);
                        for(var i = 3; i < flatten.length; i += 4)array.push(flatten[i]);
                    }
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["ArrayOperand"](array);
                };
                var peg$c130 = "true";
                var peg$c131 = peg$literalExpectation("true", true);
                var peg$c132 = function() {
                    return true;
                };
                var peg$c133 = "false";
                var peg$c134 = peg$literalExpectation("false", true);
                var peg$c135 = function() {
                    return false;
                };
                var peg$c136 = "0x";
                var peg$c137 = peg$literalExpectation("0x", false);
                var peg$c138 = function() {
                    return parseInt(text(), 16);
                };
                var peg$c139 = /^[\-]/;
                var peg$c140 = peg$classExpectation([
                    "-"
                ], false, false);
                var peg$c141 = function(sign, num) {
                    return sign == null ? num : -num;
                };
                var peg$c142 = ".";
                var peg$c143 = peg$literalExpectation(".", false);
                var peg$c144 = function() {
                    return parseFloat(text());
                };
                var peg$c145 = function() {
                    return parseInt(text(), 10);
                };
                var peg$c146 = "0";
                var peg$c147 = peg$literalExpectation("0", false);
                var peg$c148 = function() {
                    return 0;
                };
                var peg$c149 = function(chars) {
                    return chars.join("");
                };
                var peg$c150 = "\\'";
                var peg$c151 = peg$literalExpectation("\\'", false);
                var peg$c152 = function() {
                    return "'";
                };
                var peg$c153 = '\\"';
                var peg$c154 = peg$literalExpectation('\\"', false);
                var peg$c155 = function() {
                    return '"';
                };
                var peg$c156 = /^[^"']/;
                var peg$c157 = peg$classExpectation([
                    '"',
                    "'"
                ], true, false);
                var peg$c158 = function() {
                    return text();
                };
                var peg$c159 = /^[^{}]/;
                var peg$c160 = peg$classExpectation([
                    "{",
                    "}"
                ], true, false);
                var peg$c161 = /^[0-9]/;
                var peg$c162 = peg$classExpectation([
                    [
                        "0",
                        "9"
                    ]
                ], false, false);
                var peg$c163 = /^[1-9]/;
                var peg$c164 = peg$classExpectation([
                    [
                        "1",
                        "9"
                    ]
                ], false, false);
                var peg$c165 = /^[a-zA-Z_]/;
                var peg$c166 = peg$classExpectation([
                    [
                        "a",
                        "z"
                    ],
                    [
                        "A",
                        "Z"
                    ],
                    "_"
                ], false, false);
                var peg$c167 = peg$otherExpectation("whitespace");
                var peg$c168 = /^[ \t\n\r]/;
                var peg$c169 = peg$classExpectation([
                    " ",
                    "	",
                    "\n",
                    "\r"
                ], false, false);
                var peg$currPos = 0;
                var peg$savedPos = 0;
                var peg$posDetailsCache = [
                    {
                        line: 1,
                        column: 1
                    }
                ];
                var peg$maxFailPos = 0;
                var peg$maxFailExpected = [];
                var peg$silentFails = 0;
                var peg$resultsCache = {};
                var peg$result;
                if (options.startRule !== undefined) {
                    if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
                    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
                }
                function text() {
                    return input.substring(peg$savedPos, peg$currPos);
                }
                function location() {
                    return peg$computeLocation(peg$savedPos, peg$currPos);
                }
                function expected(description, location1) {
                    location1 = location1 !== undefined ? location1 : peg$computeLocation(peg$savedPos, peg$currPos);
                    throw peg$buildStructuredError([
                        peg$otherExpectation(description)
                    ], input.substring(peg$savedPos, peg$currPos), location1);
                }
                function error(message, location1) {
                    location1 = location1 !== undefined ? location1 : peg$computeLocation(peg$savedPos, peg$currPos);
                    throw peg$buildSimpleError(message, location1);
                }
                function peg$literalExpectation(text1, ignoreCase) {
                    return {
                        type: "literal",
                        text: text1,
                        ignoreCase: ignoreCase
                    };
                }
                function peg$classExpectation(parts, inverted, ignoreCase) {
                    return {
                        type: "class",
                        parts: parts,
                        inverted: inverted,
                        ignoreCase: ignoreCase
                    };
                }
                function peg$anyExpectation() {
                    return {
                        type: "any"
                    };
                }
                function peg$endExpectation() {
                    return {
                        type: "end"
                    };
                }
                function peg$otherExpectation(description) {
                    return {
                        type: "other",
                        description: description
                    };
                }
                function peg$computePosDetails(pos) {
                    var details = peg$posDetailsCache[pos];
                    var p;
                    if (details) return details;
                    else {
                        p = pos - 1;
                        while(!peg$posDetailsCache[p])p--;
                        details = peg$posDetailsCache[p];
                        details = {
                            line: details.line,
                            column: details.column
                        };
                        while(p < pos){
                            if (input.charCodeAt(p) === 10) {
                                details.line++;
                                details.column = 1;
                            } else details.column++;
                            p++;
                        }
                        peg$posDetailsCache[pos] = details;
                        return details;
                    }
                }
                function peg$computeLocation(startPos, endPos) {
                    var startPosDetails = peg$computePosDetails(startPos);
                    var endPosDetails = peg$computePosDetails(endPos);
                    return {
                        start: {
                            offset: startPos,
                            line: startPosDetails.line,
                            column: startPosDetails.column
                        },
                        end: {
                            offset: endPos,
                            line: endPosDetails.line,
                            column: endPosDetails.column
                        }
                    };
                }
                function peg$fail(expected1) {
                    if (peg$currPos < peg$maxFailPos) return;
                    if (peg$currPos > peg$maxFailPos) {
                        peg$maxFailPos = peg$currPos;
                        peg$maxFailExpected = [];
                    }
                    peg$maxFailExpected.push(expected1);
                }
                function peg$buildSimpleError(message, location1) {
                    return new SyntaxError(message, [], "", location1);
                }
                function peg$buildStructuredError(expected1, found, location1) {
                    return new SyntaxError(SyntaxError.buildMessage(expected1, found), expected1, found, location1);
                }
                function peg$parseExpression() {
                    var s0, s1, s2, s3, s4, s5, s6, s7, s8;
                    var key = peg$currPos * 34 + 0;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parse_();
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseLogicOr();
                        if (s2 !== peg$FAILED) {
                            s3 = [];
                            s4 = peg$currPos;
                            s5 = peg$parse_();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parseOrSign();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parse_();
                                    if (s7 !== peg$FAILED) {
                                        s8 = peg$parseLogicOr();
                                        if (s8 !== peg$FAILED) {
                                            s5 = [
                                                s5,
                                                s6,
                                                s7,
                                                s8
                                            ];
                                            s4 = s5;
                                        } else {
                                            peg$currPos = s4;
                                            s4 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s4;
                                        s4 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                            while(s4 !== peg$FAILED){
                                s3.push(s4);
                                s4 = peg$currPos;
                                s5 = peg$parse_();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parseOrSign();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parse_();
                                        if (s7 !== peg$FAILED) {
                                            s8 = peg$parseLogicOr();
                                            if (s8 !== peg$FAILED) {
                                                s5 = [
                                                    s5,
                                                    s6,
                                                    s7,
                                                    s8
                                                ];
                                                s4 = s5;
                                            } else {
                                                peg$currPos = s4;
                                                s4 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s4;
                                            s4 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s4;
                                        s4 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            }
                            if (s3 !== peg$FAILED) {
                                s4 = peg$parse_();
                                if (s4 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c0(s2, s3);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseOrSign() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 1;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c1) {
                        s1 = peg$c1;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 2).toLowerCase() === peg$c3) {
                            s1 = input.substr(peg$currPos, 2);
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c4);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c5();
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLogicOr() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 2;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseLogicAnd();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseAndSign();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseLogicAnd();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseAndSign();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseLogicAnd();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseAndSign() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 3;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c6) {
                        s1 = peg$c6;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c7);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 3).toLowerCase() === peg$c8) {
                            s1 = input.substr(peg$currPos, 3);
                            peg$currPos += 3;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c9);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c10();
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLogicAnd() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 4;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseCompOps();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseComparableOperators();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseCompOps();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseComparableOperators();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseCompOps();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c11(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseComparableOperators() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 5;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c12) {
                        s1 = peg$c12;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c13);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 11).toLowerCase() === peg$c14) {
                            s1 = input.substr(peg$currPos, 11);
                            peg$currPos += 11;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c15);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c16();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c17) {
                            s1 = peg$c17;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c18);
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 14).toLowerCase() === peg$c19) {
                                s1 = input.substr(peg$currPos, 14);
                                peg$currPos += 14;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c20);
                            }
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c21();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 2) === peg$c22) {
                                s1 = peg$c22;
                                peg$currPos += 2;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c23);
                            }
                            if (s1 === peg$FAILED) {
                                if (input.substr(peg$currPos, 5).toLowerCase() === peg$c24) {
                                    s1 = input.substr(peg$currPos, 5);
                                    peg$currPos += 5;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c25);
                                }
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c26();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.charCodeAt(peg$currPos) === 61) {
                                    s1 = peg$c27;
                                    peg$currPos++;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c28);
                                }
                                if (s1 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 5).toLowerCase() === peg$c24) {
                                        s1 = input.substr(peg$currPos, 5);
                                        peg$currPos += 5;
                                    } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c25);
                                    }
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c26();
                                }
                                s0 = s1;
                                if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    if (input.substr(peg$currPos, 2) === peg$c29) {
                                        s1 = peg$c29;
                                        peg$currPos += 2;
                                    } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c30);
                                    }
                                    if (s1 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 8).toLowerCase() === peg$c31) {
                                            s1 = input.substr(peg$currPos, 8);
                                            peg$currPos += 8;
                                        } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c32);
                                        }
                                    }
                                    if (s1 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c33();
                                    }
                                    s0 = s1;
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 60) {
                                            s1 = peg$c34;
                                            peg$currPos++;
                                        } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c35);
                                        }
                                        if (s1 === peg$FAILED) {
                                            if (input.substr(peg$currPos, 4).toLowerCase() === peg$c36) {
                                                s1 = input.substr(peg$currPos, 4);
                                                peg$currPos += 4;
                                            } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) peg$fail(peg$c37);
                                            }
                                        }
                                        if (s1 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c38();
                                        }
                                        s0 = s1;
                                        if (s0 === peg$FAILED) {
                                            s0 = peg$currPos;
                                            if (input.charCodeAt(peg$currPos) === 62) {
                                                s1 = peg$c39;
                                                peg$currPos++;
                                            } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) peg$fail(peg$c40);
                                            }
                                            if (s1 === peg$FAILED) {
                                                if (input.substr(peg$currPos, 7).toLowerCase() === peg$c41) {
                                                    s1 = input.substr(peg$currPos, 7);
                                                    peg$currPos += 7;
                                                } else {
                                                    s1 = peg$FAILED;
                                                    if (peg$silentFails === 0) peg$fail(peg$c42);
                                                }
                                            }
                                            if (s1 !== peg$FAILED) {
                                                peg$savedPos = s0;
                                                s1 = peg$c43();
                                            }
                                            s0 = s1;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseCompOps() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 6;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parsePlusMinusOps();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsePlusMinusSigns();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parsePlusMinusOps();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parsePlusMinusSigns();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parsePlusMinusOps();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parsePlusMinusSigns() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 7;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 43) {
                        s1 = peg$c44;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c45);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c46();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 45) {
                            s1 = peg$c47;
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c48);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c49();
                        }
                        s0 = s1;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parsePlusMinusOps() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 8;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseMulDivOps();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseMulDivSigns();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseMulDivOps();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseMulDivSigns();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseMulDivOps();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseMulDivSigns() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 9;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 42) {
                        s1 = peg$c50;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c51);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c52();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 47) {
                            s1 = peg$c53;
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c54);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c55();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 37) {
                                s1 = peg$c56;
                                peg$currPos++;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c57);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c58();
                            }
                            s0 = s1;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseMulDivOps() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 10;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseBinaryFuncOp();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsePowerSigns();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseBinaryFuncOp();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parsePowerSigns();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseBinaryFuncOp();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parsePowerSigns() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 11;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 94) {
                        s1 = peg$c59;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c60);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5).toLowerCase() === peg$c61) {
                            s1 = input.substr(peg$currPos, 5);
                            peg$currPos += 5;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c62);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c63();
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseBinaryFuncOp() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 12;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseFactor();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseBinFunctions();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseFactor();
                                    if (s7 === peg$FAILED) s7 = null;
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseBinFunctions();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseFactor();
                                        if (s7 === peg$FAILED) s7 = null;
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c11(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseBinFunctions() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 13;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c64) {
                        s1 = peg$c64;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c65);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 8).toLowerCase() === peg$c66) {
                            s1 = input.substr(peg$currPos, 8);
                            peg$currPos += 8;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c67);
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 7).toLowerCase() === peg$c68) {
                                s1 = input.substr(peg$currPos, 7);
                                peg$currPos += 7;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c69);
                            }
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c70();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 11).toLowerCase() === peg$c71) {
                            s1 = input.substr(peg$currPos, 11);
                            peg$currPos += 11;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c72);
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 10).toLowerCase() === peg$c73) {
                                s1 = input.substr(peg$currPos, 10);
                                peg$currPos += 10;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c74);
                            }
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c75();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 5).toLowerCase() === peg$c76) {
                                s1 = input.substr(peg$currPos, 5);
                                peg$currPos += 5;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c77);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c78();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 5).toLowerCase() === peg$c79) {
                                    s1 = input.substr(peg$currPos, 5);
                                    peg$currPos += 5;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c80);
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c81();
                                }
                                s0 = s1;
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseFactor() {
                    var s0, s1, s2, s3, s4, s5;
                    var key = peg$currPos * 34 + 14;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 40) {
                        s1 = peg$c82;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c83);
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parse_();
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseExpression();
                            if (s3 !== peg$FAILED) {
                                s4 = peg$parse_();
                                if (s4 !== peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 41) {
                                        s5 = peg$c84;
                                        peg$currPos++;
                                    } else {
                                        s5 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c85);
                                    }
                                    if (s5 === peg$FAILED) s5 = null;
                                    if (s5 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c86(s3);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseFunctionOp();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parseUnaryFunctionOp();
                            if (s0 === peg$FAILED) {
                                s0 = peg$parseAtom();
                                if (s0 === peg$FAILED) s0 = peg$parseArrayOp();
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseFunctionOp() {
                    var s0, s1, s2, s3, s4;
                    var key = peg$currPos * 34 + 15;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseLettersAndDigits();
                    if (s1 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 40) {
                            s2 = peg$c82;
                            peg$currPos++;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c83);
                        }
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseSequence();
                            if (s3 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s4 = peg$c84;
                                    peg$currPos++;
                                } else {
                                    s4 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c85);
                                }
                                if (s4 === peg$FAILED) s4 = null;
                                if (s4 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c87(s1, s3);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseUnaryFunctionOp() {
                    var s0, s1, s2, s3;
                    var key = peg$currPos * 34 + 16;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 33) {
                        s1 = peg$c88;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c89);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 6).toLowerCase() === peg$c90) {
                            s1 = input.substr(peg$currPos, 6);
                            peg$currPos += 6;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c91);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parse_();
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseExpression();
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c92(s3);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseAtom();
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parse_();
                            if (s2 !== peg$FAILED) {
                                s3 = peg$parseUnFunctions();
                                if (s3 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c93(s1, s3);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseUnFunctions() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 17;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 5).toLowerCase() === peg$c94) {
                        s1 = input.substr(peg$currPos, 5);
                        peg$currPos += 5;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c95);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c96();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 8).toLowerCase() === peg$c97) {
                            s1 = input.substr(peg$currPos, 8);
                            peg$currPos += 8;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c98);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c99();
                        }
                        s0 = s1;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseAtom() {
                    var s0, s1, s2, s3, s4;
                    var key = peg$currPos * 34 + 18;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parse_();
                    if (s1 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 9) === peg$c100) {
                            s2 = peg$c100;
                            peg$currPos += 9;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c101);
                        }
                        if (s2 === peg$FAILED) {
                            if (input.substr(peg$currPos, 4) === peg$c102) {
                                s2 = peg$c102;
                                peg$currPos += 4;
                            } else {
                                s2 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c103);
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c104();
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parse_();
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parseConstValue();
                            if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c105(s2);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parse_();
                            if (s1 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 123) {
                                    s2 = peg$c106;
                                    peg$currPos++;
                                } else {
                                    s2 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c107);
                                }
                                if (s2 !== peg$FAILED) {
                                    s3 = peg$parseValueInput();
                                    if (s3 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 125) {
                                            s4 = peg$c108;
                                            peg$currPos++;
                                        } else {
                                            s4 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c109);
                                        }
                                        if (s4 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c110(s3);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseConstValue() {
                    var s0, s1, s2, s3;
                    var key = peg$currPos * 34 + 19;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseLogicValue();
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c111(s1);
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseArithmeticValue();
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c111(s1);
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parseLettersAndDigits();
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c111(s1);
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 2) === peg$c112) {
                                    s1 = peg$c112;
                                    peg$currPos += 2;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c113);
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c114();
                                }
                                s0 = s1;
                                if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    if (input.substr(peg$currPos, 2) === peg$c115) {
                                        s1 = peg$c115;
                                        peg$currPos += 2;
                                    } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c116);
                                    }
                                    if (s1 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c114();
                                    }
                                    s0 = s1;
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 39) {
                                            s1 = peg$c117;
                                            peg$currPos++;
                                        } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c118);
                                        }
                                        if (s1 !== peg$FAILED) {
                                            s2 = peg$parseAnyInput();
                                            if (s2 !== peg$FAILED) {
                                                if (input.charCodeAt(peg$currPos) === 39) {
                                                    s3 = peg$c117;
                                                    peg$currPos++;
                                                } else {
                                                    s3 = peg$FAILED;
                                                    if (peg$silentFails === 0) peg$fail(peg$c118);
                                                }
                                                if (s3 !== peg$FAILED) {
                                                    peg$savedPos = s0;
                                                    s1 = peg$c119(s2);
                                                    s0 = s1;
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                        if (s0 === peg$FAILED) {
                                            s0 = peg$currPos;
                                            if (input.charCodeAt(peg$currPos) === 34) {
                                                s1 = peg$c120;
                                                peg$currPos++;
                                            } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) peg$fail(peg$c121);
                                            }
                                            if (s1 !== peg$FAILED) {
                                                s2 = peg$parseAnyInput();
                                                if (s2 !== peg$FAILED) {
                                                    if (input.charCodeAt(peg$currPos) === 34) {
                                                        s3 = peg$c120;
                                                        peg$currPos++;
                                                    } else {
                                                        s3 = peg$FAILED;
                                                        if (peg$silentFails === 0) peg$fail(peg$c121);
                                                    }
                                                    if (s3 !== peg$FAILED) {
                                                        peg$savedPos = s0;
                                                        s1 = peg$c119(s2);
                                                        s0 = s1;
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseArrayOp() {
                    var s0, s1, s2, s3;
                    var key = peg$currPos * 34 + 20;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 91) {
                        s1 = peg$c122;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c123);
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseSequence();
                        if (s2 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 93) {
                                s3 = peg$c124;
                                peg$currPos++;
                            } else {
                                s3 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c125);
                            }
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c126(s2);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseSequence() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 21;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseExpression();
                    if (s1 === peg$FAILED) s1 = null;
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s5 = peg$c127;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c128);
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseExpression();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 44) {
                                    s5 = peg$c127;
                                    peg$currPos++;
                                } else {
                                    s5 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c128);
                                }
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseExpression();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c129(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLogicValue() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 22;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 4).toLowerCase() === peg$c130) {
                        s1 = input.substr(peg$currPos, 4);
                        peg$currPos += 4;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c131);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c132();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 5).toLowerCase() === peg$c133) {
                            s1 = input.substr(peg$currPos, 5);
                            peg$currPos += 5;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c134);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c135();
                        }
                        s0 = s1;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseArithmeticValue() {
                    var s0, s1, s2;
                    var key = peg$currPos * 34 + 23;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c136) {
                        s1 = peg$c136;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c137);
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseDigits();
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c138();
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (peg$c139.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c140);
                        }
                        if (s1 === peg$FAILED) s1 = null;
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parseNumber();
                            if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c141(s1, s2);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseNumber() {
                    var s0, s1, s2, s3;
                    var key = peg$currPos * 34 + 24;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseDigits();
                    if (s1 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s2 = peg$c142;
                            peg$currPos++;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c143);
                        }
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseDigits();
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c144();
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseNonZeroDigits();
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parseDigits();
                            if (s2 === peg$FAILED) s2 = null;
                            if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c145();
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 48) {
                                s1 = peg$c146;
                                peg$currPos++;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c147);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c148();
                            }
                            s0 = s1;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseValueInput() {
                    var s0, s1, s2;
                    var key = peg$currPos * 34 + 25;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = [];
                    s2 = peg$parseValueCharacters();
                    if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                        s1.push(s2);
                        s2 = peg$parseValueCharacters();
                    }
                    else s1 = peg$FAILED;
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c149(s1);
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseAnyInput() {
                    var s0, s1, s2;
                    var key = peg$currPos * 34 + 26;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = [];
                    s2 = peg$parseAnyCharacters();
                    if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                        s1.push(s2);
                        s2 = peg$parseAnyCharacters();
                    }
                    else s1 = peg$FAILED;
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c149(s1);
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseAnyCharacters() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 27;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c150) {
                        s1 = peg$c150;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c151);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c152();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c153) {
                            s1 = peg$c153;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c154);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c155();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (peg$c156.test(input.charAt(peg$currPos))) {
                                s1 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c157);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c158();
                            }
                            s0 = s1;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseValueCharacters() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 28;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (peg$c159.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c160);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c158();
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLettersAndDigits() {
                    var s0, s1, s2, s3, s4, s5, s6;
                    var key = peg$currPos * 34 + 29;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseLetters();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parseDigits();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseLetters();
                            while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseLetters();
                            }
                            if (s5 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parseDigits();
                            if (s4 !== peg$FAILED) {
                                s5 = [];
                                s6 = peg$parseLetters();
                                while(s6 !== peg$FAILED){
                                    s5.push(s6);
                                    s6 = peg$parseLetters();
                                }
                                if (s5 !== peg$FAILED) {
                                    s4 = [
                                        s4,
                                        s5
                                    ];
                                    s3 = s4;
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c158();
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseDigits() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 30;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = [];
                    if (peg$c161.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c162);
                    }
                    if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                        s0.push(s1);
                        if (peg$c161.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c162);
                        }
                    }
                    else s0 = peg$FAILED;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseNonZeroDigits() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 31;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = [];
                    if (peg$c163.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c164);
                    }
                    if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                        s0.push(s1);
                        if (peg$c163.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c164);
                        }
                    }
                    else s0 = peg$FAILED;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLetters() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 32;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = [];
                    if (peg$c165.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c166);
                    }
                    if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                        s0.push(s1);
                        if (peg$c165.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c166);
                        }
                    }
                    else s0 = peg$FAILED;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parse_() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 33;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    peg$silentFails++;
                    s0 = [];
                    if (peg$c168.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c169);
                    }
                    while(s1 !== peg$FAILED){
                        s0.push(s1);
                        if (peg$c168.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c169);
                        }
                    }
                    peg$silentFails--;
                    if (s0 === peg$FAILED) {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c167);
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function buildBinaryOperand(head, tail, isArithmeticOp) {
                    if (isArithmeticOp === void 0) isArithmeticOp = false;
                    return tail.reduce(function(result, elements) {
                        return new _expressions__WEBPACK_IMPORTED_MODULE_0__["BinaryOperand"](elements[1], result, elements[3], isArithmeticOp);
                    }, head);
                }
                function flattenArray(array) {
                    return [].concat.apply([], array);
                }
                peg$result = peg$startRuleFunction();
                if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
                else {
                    if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
                    throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
                }
            }
            var parse = peg$parse;
        /***/ },
        /***/ "./src/expressions/expressions.ts": /*!****************************************!*\
  !*** ./src/expressions/expressions.ts ***!
  \****************************************/ /*! exports provided: Operand, BinaryOperand, UnaryOperand, ArrayOperand, Const, Variable, FunctionOperand, OperandMaker */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Operand", function() {
                return Operand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BinaryOperand", function() {
                return BinaryOperand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnaryOperand", function() {
                return UnaryOperand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayOperand", function() {
                return ArrayOperand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Const", function() {
                return Const;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Variable", function() {
                return Variable;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionOperand", function() {
                return FunctionOperand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperandMaker", function() {
                return OperandMaker;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers */ "./src/helpers.ts");
            /* harmony import */ var _functionsfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../functionsfactory */ "./src/functionsfactory.ts");
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../conditionProcessValue */ "./src/conditionProcessValue.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var Operand = /** @class */ function() {
                function Operand() {}
                Operand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    return "";
                };
                Operand.prototype.hasFunction = function() {
                    return false;
                };
                Operand.prototype.hasAsyncFunction = function() {
                    return false;
                };
                Operand.prototype.addToAsyncList = function(list) {};
                Operand.prototype.isEqual = function(op) {
                    return !!op && op.getType() === this.getType() && this.isContentEqual(op);
                };
                Operand.prototype.areOperatorsEquals = function(op1, op2) {
                    return !op1 && !op2 || !!op1 && op1.isEqual(op2);
                };
                return Operand;
            }();
            var BinaryOperand = /** @class */ function(_super) {
                __extends(BinaryOperand, _super);
                function BinaryOperand(operatorName, left, right, isArithmeticOp) {
                    if (left === void 0) left = null;
                    if (right === void 0) right = null;
                    if (isArithmeticOp === void 0) isArithmeticOp = false;
                    var _this = _super.call(this) || this;
                    _this.operatorName = operatorName;
                    _this.left = left;
                    _this.right = right;
                    _this.isArithmeticValue = isArithmeticOp;
                    if (isArithmeticOp) _this.consumer = OperandMaker.binaryFunctions["arithmeticOp"](operatorName);
                    else _this.consumer = OperandMaker.binaryFunctions[operatorName];
                    if (_this.consumer == null) OperandMaker.throwInvalidOperatorError(operatorName);
                    return _this;
                }
                Object.defineProperty(BinaryOperand.prototype, "requireStrictCompare", {
                    get: function() {
                        return this.getIsOperandRequireStrict(this.left) || this.getIsOperandRequireStrict(this.right);
                    },
                    enumerable: false,
                    configurable: true
                });
                BinaryOperand.prototype.getIsOperandRequireStrict = function(op) {
                    return !!op && op.requireStrictCompare;
                };
                BinaryOperand.prototype.getType = function() {
                    return "binary";
                };
                Object.defineProperty(BinaryOperand.prototype, "isArithmetic", {
                    get: function() {
                        return this.isArithmeticValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "isConjunction", {
                    get: function() {
                        return this.operatorName == "or" || this.operatorName == "and";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "conjunction", {
                    get: function() {
                        return this.isConjunction ? this.operatorName : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "operator", {
                    get: function() {
                        return this.operatorName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "leftOperand", {
                    get: function() {
                        return this.left;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "rightOperand", {
                    get: function() {
                        return this.right;
                    },
                    enumerable: false,
                    configurable: true
                });
                BinaryOperand.prototype.isContentEqual = function(op) {
                    var bOp = op;
                    return bOp.operator === this.operator && this.areOperatorsEquals(this.left, bOp.left) && this.areOperatorsEquals(this.right, bOp.right);
                };
                BinaryOperand.prototype.evaluateParam = function(x, processValue) {
                    return x == null ? null : x.evaluate(processValue);
                };
                BinaryOperand.prototype.evaluate = function(processValue) {
                    return this.consumer.call(this, this.evaluateParam(this.left, processValue), this.evaluateParam(this.right, processValue), this.requireStrictCompare);
                };
                BinaryOperand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return "(" + OperandMaker.safeToString(this.left, func) + " " + OperandMaker.operatorToString(this.operatorName) + " " + OperandMaker.safeToString(this.right, func) + ")";
                };
                BinaryOperand.prototype.setVariables = function(variables) {
                    if (this.left != null) this.left.setVariables(variables);
                    if (this.right != null) this.right.setVariables(variables);
                };
                BinaryOperand.prototype.hasFunction = function() {
                    return !!this.left && this.left.hasFunction() || !!this.right && this.right.hasFunction();
                };
                BinaryOperand.prototype.hasAsyncFunction = function() {
                    return !!this.left && this.left.hasAsyncFunction() || !!this.right && this.right.hasAsyncFunction();
                };
                BinaryOperand.prototype.addToAsyncList = function(list) {
                    if (!!this.left) this.left.addToAsyncList(list);
                    if (!!this.right) this.right.addToAsyncList(list);
                };
                return BinaryOperand;
            }(Operand);
            var UnaryOperand = /** @class */ function(_super) {
                __extends(UnaryOperand, _super);
                function UnaryOperand(expressionValue, operatorName) {
                    var _this = _super.call(this) || this;
                    _this.expressionValue = expressionValue;
                    _this.operatorName = operatorName;
                    _this.consumer = OperandMaker.unaryFunctions[operatorName];
                    if (_this.consumer == null) OperandMaker.throwInvalidOperatorError(operatorName);
                    return _this;
                }
                Object.defineProperty(UnaryOperand.prototype, "operator", {
                    get: function() {
                        return this.operatorName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(UnaryOperand.prototype, "expression", {
                    get: function() {
                        return this.expressionValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                UnaryOperand.prototype.getType = function() {
                    return "unary";
                };
                UnaryOperand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return OperandMaker.operatorToString(this.operatorName) + " " + this.expression.toString(func);
                };
                UnaryOperand.prototype.isContentEqual = function(op) {
                    var uOp = op;
                    return uOp.operator == this.operator && this.areOperatorsEquals(this.expression, uOp.expression);
                };
                UnaryOperand.prototype.hasFunction = function() {
                    return this.expression.hasFunction();
                };
                UnaryOperand.prototype.hasAsyncFunction = function() {
                    return this.expression.hasAsyncFunction();
                };
                UnaryOperand.prototype.addToAsyncList = function(list) {
                    this.expression.addToAsyncList(list);
                };
                UnaryOperand.prototype.evaluate = function(processValue) {
                    var value = this.expression.evaluate(processValue);
                    return this.consumer.call(this, value);
                };
                UnaryOperand.prototype.setVariables = function(variables) {
                    this.expression.setVariables(variables);
                };
                return UnaryOperand;
            }(Operand);
            var ArrayOperand = /** @class */ function(_super) {
                __extends(ArrayOperand, _super);
                function ArrayOperand(values) {
                    var _this = _super.call(this) || this;
                    _this.values = values;
                    return _this;
                }
                ArrayOperand.prototype.getType = function() {
                    return "array";
                };
                ArrayOperand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return "[" + this.values.map(function(el) {
                        return el.toString(func);
                    }).join(", ") + "]";
                };
                ArrayOperand.prototype.evaluate = function(processValue) {
                    return this.values.map(function(el) {
                        return el.evaluate(processValue);
                    });
                };
                ArrayOperand.prototype.setVariables = function(variables) {
                    this.values.forEach(function(el) {
                        el.setVariables(variables);
                    });
                };
                ArrayOperand.prototype.hasFunction = function() {
                    return this.values.some(function(operand) {
                        return operand.hasFunction();
                    });
                };
                ArrayOperand.prototype.hasAsyncFunction = function() {
                    return this.values.some(function(operand) {
                        return operand.hasAsyncFunction();
                    });
                };
                ArrayOperand.prototype.addToAsyncList = function(list) {
                    this.values.forEach(function(operand) {
                        return operand.addToAsyncList(list);
                    });
                };
                ArrayOperand.prototype.isContentEqual = function(op) {
                    var aOp = op;
                    if (aOp.values.length !== this.values.length) return false;
                    for(var i = 0; i < this.values.length; i++){
                        if (!aOp.values[i].isEqual(this.values[i])) return false;
                    }
                    return true;
                };
                return ArrayOperand;
            }(Operand);
            var Const = /** @class */ function(_super) {
                __extends(Const, _super);
                function Const(value) {
                    var _this = _super.call(this) || this;
                    _this.value = value;
                    return _this;
                }
                Const.prototype.getType = function() {
                    return "const";
                };
                Const.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return this.value.toString();
                };
                Object.defineProperty(Const.prototype, "correctValue", {
                    get: function() {
                        return this.getCorrectValue(this.value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Const.prototype, "requireStrictCompare", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Const.prototype.evaluate = function() {
                    return this.getCorrectValue(this.value);
                };
                Const.prototype.setVariables = function(variables) {};
                Const.prototype.getCorrectValue = function(value) {
                    if (!value || typeof value != "string") return value;
                    if (this.isBooleanValue(value)) return value.toLowerCase() === "true";
                    if (value.length > 1 && this.isQuote(value[0]) && this.isQuote(value[value.length - 1])) return value.substring(1, value.length - 1);
                    if (OperandMaker.isNumeric(value)) {
                        if (value.indexOf("0x") == 0) return parseInt(value);
                        if (value.length > 1 && value[0] == "0" && (value.length < 2 || value[1] !== "." && value[1] !== ",")) return value;
                        return parseFloat(value);
                    }
                    return value;
                };
                Const.prototype.isContentEqual = function(op) {
                    var cOp = op;
                    return cOp.value == this.value;
                };
                Const.prototype.isQuote = function(ch) {
                    return ch == "'" || ch == '"';
                };
                Const.prototype.isBooleanValue = function(value) {
                    return value && (value.toLowerCase() === "true" || value.toLowerCase() === "false");
                };
                return Const;
            }(Operand);
            var Variable = /** @class */ function(_super) {
                __extends(Variable, _super);
                function Variable(variableName) {
                    var _this = _super.call(this, variableName) || this;
                    _this.variableName = variableName;
                    _this.valueInfo = {};
                    _this.useValueAsItIs = false;
                    if (!!_this.variableName && _this.variableName.length > 1 && _this.variableName[0] === Variable.DisableConversionChar) {
                        _this.variableName = _this.variableName.substring(1);
                        _this.useValueAsItIs = true;
                    }
                    return _this;
                }
                Object.defineProperty(Variable, "DisableConversionChar", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].expressionDisableConversionChar;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].expressionDisableConversionChar = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Variable.prototype, "requireStrictCompare", {
                    get: function() {
                        return this.valueInfo.sctrictCompare === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Variable.prototype.getType = function() {
                    return "variable";
                };
                Variable.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    var prefix = this.useValueAsItIs ? Variable.DisableConversionChar : "";
                    return "{" + prefix + this.variableName + "}";
                };
                Object.defineProperty(Variable.prototype, "variable", {
                    get: function() {
                        return this.variableName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Variable.prototype.evaluate = function(processValue) {
                    this.valueInfo.name = this.variableName;
                    processValue.getValueInfo(this.valueInfo);
                    return this.valueInfo.hasValue ? this.getCorrectValue(this.valueInfo.value) : null;
                };
                Variable.prototype.setVariables = function(variables) {
                    variables.push(this.variableName);
                };
                Variable.prototype.getCorrectValue = function(value) {
                    if (this.useValueAsItIs) return value;
                    return _super.prototype.getCorrectValue.call(this, value);
                };
                Variable.prototype.isContentEqual = function(op) {
                    var vOp = op;
                    return vOp.variable == this.variable;
                };
                return Variable;
            }(Const);
            var FunctionOperand = /** @class */ function(_super) {
                __extends(FunctionOperand, _super);
                function FunctionOperand(originalValue, parameters) {
                    var _this = _super.call(this) || this;
                    _this.originalValue = originalValue;
                    _this.parameters = parameters;
                    _this.isReadyValue = false;
                    if (Array.isArray(parameters) && parameters.length === 0) _this.parameters = new ArrayOperand([]);
                    return _this;
                }
                FunctionOperand.prototype.getType = function() {
                    return "function";
                };
                FunctionOperand.prototype.evaluateAsync = function(processValue) {
                    var _this = this;
                    this.isReadyValue = false;
                    var asyncProcessValue = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_2__["ProcessValue"]();
                    asyncProcessValue.values = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(processValue.values);
                    asyncProcessValue.properties = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(processValue.properties);
                    asyncProcessValue.properties.returnResult = function(result) {
                        _this.asynResult = result;
                        _this.isReadyValue = true;
                        _this.onAsyncReady();
                    };
                    this.evaluateCore(asyncProcessValue);
                };
                FunctionOperand.prototype.evaluate = function(processValue) {
                    if (this.isReady) return this.asynResult;
                    return this.evaluateCore(processValue);
                };
                FunctionOperand.prototype.evaluateCore = function(processValue) {
                    return _functionsfactory__WEBPACK_IMPORTED_MODULE_1__["FunctionFactory"].Instance.run(this.originalValue, this.parameters.evaluate(processValue), processValue.properties);
                };
                FunctionOperand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return this.originalValue + "(" + this.parameters.toString(func) + ")";
                };
                FunctionOperand.prototype.setVariables = function(variables) {
                    this.parameters.setVariables(variables);
                };
                Object.defineProperty(FunctionOperand.prototype, "isReady", {
                    get: function() {
                        return this.isReadyValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                FunctionOperand.prototype.hasFunction = function() {
                    return true;
                };
                FunctionOperand.prototype.hasAsyncFunction = function() {
                    return _functionsfactory__WEBPACK_IMPORTED_MODULE_1__["FunctionFactory"].Instance.isAsyncFunction(this.originalValue);
                };
                FunctionOperand.prototype.addToAsyncList = function(list) {
                    if (this.hasAsyncFunction()) list.push(this);
                };
                FunctionOperand.prototype.isContentEqual = function(op) {
                    var fOp = op;
                    return fOp.originalValue == this.originalValue && this.areOperatorsEquals(fOp.parameters, this.parameters);
                };
                return FunctionOperand;
            }(Operand);
            var OperandMaker = /** @class */ function() {
                function OperandMaker() {}
                OperandMaker.throwInvalidOperatorError = function(op) {
                    throw new Error("Invalid operator: '" + op + "'");
                };
                OperandMaker.safeToString = function(operand, func) {
                    return operand == null ? "" : operand.toString(func);
                };
                OperandMaker.toOperandString = function(value) {
                    if (!!value && !OperandMaker.isNumeric(value) && !OperandMaker.isBooleanValue(value)) value = "'" + value + "'";
                    return value;
                };
                OperandMaker.isSpaceString = function(str) {
                    return !!str && !str.replace(" ", "");
                };
                OperandMaker.isNumeric = function(value) {
                    if (!!value && (value.indexOf("-") > -1 || value.indexOf("+") > 1 || value.indexOf("*") > -1 || value.indexOf("^") > -1 || value.indexOf("/") > -1 || value.indexOf("%") > -1)) return false;
                    if (OperandMaker.isSpaceString(value)) return false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(value);
                };
                OperandMaker.isBooleanValue = function(value) {
                    return !!value && (value.toLowerCase() === "true" || value.toLowerCase() === "false");
                };
                OperandMaker.countDecimals = function(value) {
                    if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(value) && Math.floor(value) !== value) {
                        var strs = value.toString().split(".");
                        return strs.length > 1 && strs[1].length || 0;
                    }
                    return 0;
                };
                OperandMaker.plusMinus = function(a, b, res) {
                    var digitsA = OperandMaker.countDecimals(a);
                    var digitsB = OperandMaker.countDecimals(b);
                    if (digitsA > 0 || digitsB > 0) {
                        var digits = Math.max(digitsA, digitsB);
                        res = parseFloat(res.toFixed(digits));
                    }
                    return res;
                };
                OperandMaker.isTwoValueEquals = function(x, y, ignoreOrder) {
                    if (ignoreOrder === void 0) ignoreOrder = true;
                    if (x === "undefined") x = undefined;
                    if (y === "undefined") y = undefined;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(x, y, ignoreOrder);
                };
                OperandMaker.operatorToString = function(operatorName) {
                    var opStr = OperandMaker.signs[operatorName];
                    return opStr == null ? operatorName : opStr;
                };
                OperandMaker.convertValForDateCompare = function(val1, second) {
                    if (second instanceof Date && typeof val1 === "string") {
                        var res = new Date(val1);
                        res.setHours(0, 0, 0);
                        return res;
                    }
                    return val1;
                };
                OperandMaker.unaryFunctions = {
                    empty: function(value) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(value);
                    },
                    notempty: function(value) {
                        return !OperandMaker.unaryFunctions.empty(value);
                    },
                    negate: function(value) {
                        return !value;
                    }
                };
                OperandMaker.binaryFunctions = {
                    arithmeticOp: function(operatorName) {
                        var convertForArithmeticOp = function(val1, second) {
                            if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(val1)) return val1;
                            if (typeof second === "number") return 0;
                            if (typeof val1 === "string") return val1;
                            if (typeof second === "string") return "";
                            if (Array.isArray(second)) return [];
                            return 0;
                        };
                        return function(a, b) {
                            a = convertForArithmeticOp(a, b);
                            b = convertForArithmeticOp(b, a);
                            var consumer = OperandMaker.binaryFunctions[operatorName];
                            return consumer == null ? null : consumer.call(this, a, b);
                        };
                    },
                    and: function(a, b) {
                        return a && b;
                    },
                    or: function(a, b) {
                        return a || b;
                    },
                    plus: function(a, b) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].sumAnyValues(a, b);
                    },
                    minus: function(a, b) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].correctAfterPlusMinis(a, b, a - b);
                    },
                    mul: function(a, b) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].correctAfterMultiple(a, b, a * b);
                    },
                    div: function(a, b) {
                        if (!b) return null;
                        return a / b;
                    },
                    mod: function(a, b) {
                        if (!b) return null;
                        return a % b;
                    },
                    power: function(a, b) {
                        return Math.pow(a, b);
                    },
                    greater: function(left, right) {
                        if (left == null || right == null) return false;
                        left = OperandMaker.convertValForDateCompare(left, right);
                        right = OperandMaker.convertValForDateCompare(right, left);
                        return left > right;
                    },
                    less: function(left, right) {
                        if (left == null || right == null) return false;
                        left = OperandMaker.convertValForDateCompare(left, right);
                        right = OperandMaker.convertValForDateCompare(right, left);
                        return left < right;
                    },
                    greaterorequal: function(left, right) {
                        if (OperandMaker.binaryFunctions.equal(left, right)) return true;
                        return OperandMaker.binaryFunctions.greater(left, right);
                    },
                    lessorequal: function(left, right) {
                        if (OperandMaker.binaryFunctions.equal(left, right)) return true;
                        return OperandMaker.binaryFunctions.less(left, right);
                    },
                    equal: function(left, right, strictCompare) {
                        left = OperandMaker.convertValForDateCompare(left, right);
                        right = OperandMaker.convertValForDateCompare(right, left);
                        return OperandMaker.isTwoValueEquals(left, right, strictCompare !== true);
                    },
                    notequal: function(left, right, strictCompare) {
                        return !OperandMaker.binaryFunctions.equal(left, right, strictCompare);
                    },
                    contains: function(left, right) {
                        return OperandMaker.binaryFunctions.containsCore(left, right, true);
                    },
                    notcontains: function(left, right) {
                        if (!left && !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(right)) return true;
                        return OperandMaker.binaryFunctions.containsCore(left, right, false);
                    },
                    anyof: function(left, right) {
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(left) && _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(right)) return true;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(left) || !Array.isArray(left) && left.length === 0) return false;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(right)) return true;
                        if (!Array.isArray(left)) return OperandMaker.binaryFunctions.contains(right, left);
                        if (!Array.isArray(right)) return OperandMaker.binaryFunctions.contains(left, right);
                        for(var i = 0; i < right.length; i++){
                            if (OperandMaker.binaryFunctions.contains(left, right[i])) return true;
                        }
                        return false;
                    },
                    allof: function(left, right) {
                        if (!left && !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(right)) return false;
                        if (!Array.isArray(right)) return OperandMaker.binaryFunctions.contains(left, right);
                        for(var i = 0; i < right.length; i++){
                            if (!OperandMaker.binaryFunctions.contains(left, right[i])) return false;
                        }
                        return true;
                    },
                    containsCore: function(left, right, isContains) {
                        if (!left && left !== 0 && left !== false) return false;
                        if (!left.length) {
                            left = left.toString();
                            if (typeof right === "string" || right instanceof String) {
                                left = left.toUpperCase();
                                right = right.toUpperCase();
                            }
                        }
                        if (typeof left === "string" || left instanceof String) {
                            if (!right) return false;
                            right = right.toString();
                            var found = left.indexOf(right) > -1;
                            return isContains ? found : !found;
                        }
                        var rightArray = Array.isArray(right) ? right : [
                            right
                        ];
                        for(var rIndex = 0; rIndex < rightArray.length; rIndex++){
                            var i = 0;
                            right = rightArray[rIndex];
                            for(; i < left.length; i++){
                                if (OperandMaker.isTwoValueEquals(left[i], right)) break;
                            }
                            if (i == left.length) return !isContains;
                        }
                        return isContains;
                    }
                };
                OperandMaker.signs = {
                    less: "<",
                    lessorequal: "<=",
                    greater: ">",
                    greaterorequal: ">=",
                    equal: "==",
                    notequal: "!=",
                    plus: "+",
                    minus: "-",
                    mul: "*",
                    div: "/",
                    and: "and",
                    or: "or",
                    power: "^",
                    mod: "%",
                    negate: "!"
                };
                return OperandMaker;
            }();
        /***/ },
        /***/ "./src/flowpanel.ts": /*!**************************!*\
  !*** ./src/flowpanel.ts ***!
  \**************************/ /*! exports provided: FlowPanelModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FlowPanelModel", function() {
                return FlowPanelModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _panel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./panel */ "./src/panel.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * The flow panel object. It is a container with flow layout where you can mix questions with markdown text.
 *
 */ var FlowPanelModel = /** @class */ function(_super) {
                __extends(FlowPanelModel, _super);
                function FlowPanelModel(name) {
                    if (name === void 0) name = "";
                    var _this = _super.call(this, name) || this;
                    _this.createLocalizableString("content", _this, true);
                    _this.registerPropertyChangedHandlers([
                        "content"
                    ], function() {
                        _this.onContentChanged();
                    });
                    return _this;
                }
                FlowPanelModel.prototype.getType = function() {
                    return "flowpanel";
                };
                FlowPanelModel.prototype.getChildrenLayoutType = function() {
                    return "flow";
                };
                FlowPanelModel.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    this.onContentChanged();
                };
                Object.defineProperty(FlowPanelModel.prototype, "content", {
                    get: function() {
                        return this.getLocalizableStringText("content");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("content", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(FlowPanelModel.prototype, "locContent", {
                    get: function() {
                        return this.getLocalizableString("content");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(FlowPanelModel.prototype, "html", {
                    get: function() {
                        return this.getPropertyValue("html", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("html", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                FlowPanelModel.prototype.onContentChanged = function() {
                    var html = "";
                    if (!!this.onCustomHtmlProducing) html = this.onCustomHtmlProducing();
                    else html = this.produceHtml();
                    this.html = html;
                    if (!!this.contentChangedCallback) this.contentChangedCallback();
                };
                FlowPanelModel.prototype.produceHtml = function() {
                    var html = [];
                    //contentElementNamePrefix
                    var regEx = /{(.*?(element:)[^$].*?)}/g;
                    var str = this.content;
                    var startIndex = 0;
                    var res = null;
                    while((res = regEx.exec(str)) !== null){
                        if (res.index > startIndex) {
                            html.push(str.substring(startIndex, res.index));
                            startIndex = res.index;
                        }
                        var question = this.getQuestionFromText(res[0]);
                        if (!!question) html.push(this.getHtmlForQuestion(question));
                        else html.push(str.substring(startIndex, res.index + res[0].length));
                        startIndex = res.index + res[0].length;
                    }
                    if (startIndex < str.length) html.push(str.substring(startIndex, str.length));
                    return html.join("").replace(new RegExp("<br>", "g"), "<br/>");
                };
                FlowPanelModel.prototype.getQuestionFromText = function(str) {
                    str = str.substring(1, str.length - 1);
                    str = str.replace(FlowPanelModel.contentElementNamePrefix, "").trim();
                    return this.getQuestionByName(str);
                };
                FlowPanelModel.prototype.getHtmlForQuestion = function(question) {
                    if (!!this.onGetHtmlForQuestion) return this.onGetHtmlForQuestion(question);
                    return "";
                };
                FlowPanelModel.prototype.getQuestionHtmlId = function(question) {
                    return this.name + "_" + question.id;
                };
                FlowPanelModel.prototype.onAddElement = function(element, index) {
                    _super.prototype.onAddElement.call(this, element, index);
                    this.addElementToContent(element);
                    element.renderWidth = "";
                };
                FlowPanelModel.prototype.onRemoveElement = function(element) {
                    var searchStr = this.getElementContentText(element);
                    this.content = this.content.replace(searchStr, "");
                    _super.prototype.onRemoveElement.call(this, element);
                };
                FlowPanelModel.prototype.dragDropMoveElement = function(src, target, targetIndex) {};
                FlowPanelModel.prototype.addElementToContent = function(element) {
                    if (this.isLoadingFromJson) return;
                    var text = this.getElementContentText(element);
                    if (!this.insertTextAtCursor(text)) this.content = this.content + text;
                };
                FlowPanelModel.prototype.insertTextAtCursor = function(text, prevName) {
                    if (prevName === void 0) prevName = null;
                    if (!this.isDesignMode || !_global_variables_utils__WEBPACK_IMPORTED_MODULE_2__["DomWindowHelper"].isAvailable()) return false;
                    var sel = _global_variables_utils__WEBPACK_IMPORTED_MODULE_2__["DomWindowHelper"].getSelection();
                    if (sel.getRangeAt && sel.rangeCount) {
                        var range = sel.getRangeAt(0);
                        range.deleteContents();
                        var textElement = new Text(text);
                        range.insertNode(textElement);
                        var self = this;
                        if (self.getContent) {
                            var str = self.getContent(prevName);
                            this.content = str;
                        }
                        return true;
                    }
                    return false;
                };
                FlowPanelModel.prototype.getElementContentText = function(element) {
                    return "{" + FlowPanelModel.contentElementNamePrefix + element.name + "}";
                };
                FlowPanelModel.contentElementNamePrefix = "element:";
                return FlowPanelModel;
            }(_panel__WEBPACK_IMPORTED_MODULE_1__["PanelModel"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("flowpanel", [
                {
                    name: "content:html",
                    serializationProperty: "locContent"
                }
            ], function() {
                return new FlowPanelModel();
            }, "panel");
        /***/ },
        /***/ "./src/functionsfactory.ts": /*!*********************************!*\
  !*** ./src/functionsfactory.ts ***!
  \*********************************/ /*! exports provided: FunctionFactory, registerFunction */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionFactory", function() {
                return FunctionFactory;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerFunction", function() {
                return registerFunction;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            var FunctionFactory = /** @class */ function() {
                function FunctionFactory() {
                    this.functionHash = {};
                    this.isAsyncHash = {};
                }
                FunctionFactory.prototype.register = function(name, func, isAsync) {
                    if (isAsync === void 0) isAsync = false;
                    this.functionHash[name] = func;
                    if (isAsync) this.isAsyncHash[name] = true;
                };
                FunctionFactory.prototype.unregister = function(name) {
                    delete this.functionHash[name];
                    delete this.isAsyncHash[name];
                };
                FunctionFactory.prototype.hasFunction = function(name) {
                    return !!this.functionHash[name];
                };
                FunctionFactory.prototype.isAsyncFunction = function(name) {
                    return !!this.isAsyncHash[name];
                };
                FunctionFactory.prototype.clear = function() {
                    this.functionHash = {};
                };
                FunctionFactory.prototype.getAll = function() {
                    var result = [];
                    for(var key in this.functionHash)result.push(key);
                    return result.sort();
                };
                FunctionFactory.prototype.run = function(name, params, properties) {
                    if (properties === void 0) properties = null;
                    var func = this.functionHash[name];
                    if (!func) {
                        _console_warnings__WEBPACK_IMPORTED_MODULE_2__["ConsoleWarnings"].warn("Unknown function name: " + name);
                        return null;
                    }
                    var classRunner = {
                        func: func
                    };
                    if (properties) for(var key in properties)classRunner[key] = properties[key];
                    return classRunner.func(params);
                };
                FunctionFactory.Instance = new FunctionFactory();
                return FunctionFactory;
            }();
            var registerFunction = FunctionFactory.Instance.register;
            function getParamsAsArray(value, arr) {
                if (value === undefined || value === null) return;
                if (Array.isArray(value)) for(var i = 0; i < value.length; i++)getParamsAsArray(value[i], arr);
                else {
                    if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(value)) value = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].getNumber(value);
                    arr.push(value);
                }
            }
            function sum(params) {
                var arr = [];
                getParamsAsArray(params, arr);
                var res = 0;
                for(var i = 0; i < arr.length; i++)res = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].correctAfterPlusMinis(res, arr[i], res + arr[i]);
                return res;
            }
            FunctionFactory.Instance.register("sum", sum);
            function min_max(params, isMin) {
                var arr = [];
                getParamsAsArray(params, arr);
                var res = undefined;
                for(var i = 0; i < arr.length; i++){
                    if (res === undefined) res = arr[i];
                    if (isMin) {
                        if (res > arr[i]) res = arr[i];
                    } else if (res < arr[i]) res = arr[i];
                }
                return res;
            }
            function min(params) {
                return min_max(params, true);
            }
            FunctionFactory.Instance.register("min", min);
            function max(params) {
                return min_max(params, false);
            }
            FunctionFactory.Instance.register("max", max);
            function count(params) {
                var arr = [];
                getParamsAsArray(params, arr);
                return arr.length;
            }
            FunctionFactory.Instance.register("count", count);
            function avg(params) {
                var arr = [];
                getParamsAsArray(params, arr);
                var res = sum(params);
                return arr.length > 0 ? res / arr.length : 0;
            }
            FunctionFactory.Instance.register("avg", avg);
            function getInArrayParams(params) {
                if (params.length != 2) return null;
                var arr = params[0];
                if (!arr) return null;
                if (!Array.isArray(arr) && !Array.isArray(Object.keys(arr))) return null;
                var name = params[1];
                if (typeof name !== "string" && !(name instanceof String)) return null;
                return {
                    data: arr,
                    name: name
                };
            }
            function convertToNumber(val1) {
                if (typeof val1 === "string") return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(val1) ? _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].getNumber(val1) : undefined;
                return val1;
            }
            function processItemInArray(item, name, res, func, needToConvert) {
                if (!item || _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(item[name])) return res;
                var val1 = needToConvert ? convertToNumber(item[name]) : 1;
                return func(res, val1);
            }
            function calcInArray(params, func, needToConvert) {
                if (needToConvert === void 0) needToConvert = true;
                var v = getInArrayParams(params);
                if (!v) return undefined;
                var res = undefined;
                if (Array.isArray(v.data)) for(var i = 0; i < v.data.length; i++)res = processItemInArray(v.data[i], v.name, res, func, needToConvert);
                else for(var key in v.data)res = processItemInArray(v.data[key], v.name, res, func, needToConvert);
                return res;
            }
            function sumInArray(params) {
                var res = calcInArray(params, function(res, val1) {
                    if (res == undefined) res = 0;
                    if (val1 == undefined || val1 == null) return res;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].correctAfterPlusMinis(res, val1, res + val1);
                });
                return res !== undefined ? res : 0;
            }
            FunctionFactory.Instance.register("sumInArray", sumInArray);
            function minInArray(params) {
                return calcInArray(params, function(res, val1) {
                    if (res == undefined) return val1;
                    if (val1 == undefined || val1 == null) return res;
                    return res < val1 ? res : val1;
                });
            }
            FunctionFactory.Instance.register("minInArray", minInArray);
            function maxInArray(params) {
                return calcInArray(params, function(res, val1) {
                    if (res == undefined) return val1;
                    if (val1 == undefined || val1 == null) return res;
                    return res > val1 ? res : val1;
                });
            }
            FunctionFactory.Instance.register("maxInArray", maxInArray);
            function countInArray(params) {
                var res = calcInArray(params, function(res, val1) {
                    if (res == undefined) res = 0;
                    if (val1 == undefined || val1 == null) return res;
                    return res + 1;
                }, false);
                return res !== undefined ? res : 0;
            }
            FunctionFactory.Instance.register("countInArray", countInArray);
            function avgInArray(params) {
                var count = countInArray(params);
                if (count == 0) return 0;
                return sumInArray(params) / count;
            }
            FunctionFactory.Instance.register("avgInArray", avgInArray);
            function iif(params) {
                if (!params && params.length !== 3) return "";
                return params[0] ? params[1] : params[2];
            }
            FunctionFactory.Instance.register("iif", iif);
            function getDate(params) {
                if (!params && params.length < 1) return null;
                if (!params[0]) return null;
                return new Date(params[0]);
            }
            FunctionFactory.Instance.register("getDate", getDate);
            function age(params) {
                if (!params && params.length < 1) return null;
                if (!params[0]) return null;
                var birthDate = new Date(params[0]);
                var today = new Date();
                var age = today.getFullYear() - birthDate.getFullYear();
                if (age > 0) {
                    var m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) age -= 1;
                }
                return age;
            }
            FunctionFactory.Instance.register("age", age);
            function isContainerReadyCore(container) {
                if (!container) return false;
                var questions = container.questions;
                for(var i = 0; i < questions.length; i++){
                    if (!questions[i].validate(false)) return false;
                }
                return true;
            }
            function isContainerReady(params) {
                if (!params && params.length < 1) return false;
                if (!params[0] || !this.survey) return false;
                var name = params[0];
                var container = this.survey.getPageByName(name);
                if (!container) container = this.survey.getPanelByName(name);
                if (!container) {
                    var question = this.survey.getQuestionByName(name);
                    if (!question || !Array.isArray(question.panels)) return false;
                    if (params.length > 1) {
                        if (params[1] < question.panels.length) container = question.panels[params[1]];
                    } else {
                        for(var i = 0; i < question.panels.length; i++){
                            if (!isContainerReadyCore(question.panels[i])) return false;
                        }
                        return true;
                    }
                }
                return isContainerReadyCore(container);
            }
            FunctionFactory.Instance.register("isContainerReady", isContainerReady);
            function isDisplayMode() {
                return this.survey && this.survey.isDisplayMode;
            }
            FunctionFactory.Instance.register("isDisplayMode", isDisplayMode);
            function currentDate() {
                return new Date();
            }
            FunctionFactory.Instance.register("currentDate", currentDate);
            function today(params) {
                var res = new Date();
                if (_settings__WEBPACK_IMPORTED_MODULE_1__["settings"].localization.useLocalTimeZone) res.setHours(0, 0, 0, 0);
                else res.setUTCHours(0, 0, 0, 0);
                if (Array.isArray(params) && params.length == 1) res.setDate(res.getDate() + params[0]);
                return res;
            }
            FunctionFactory.Instance.register("today", today);
            function getYear(params) {
                if (params.length !== 1 || !params[0]) return undefined;
                return new Date(params[0]).getFullYear();
            }
            FunctionFactory.Instance.register("getYear", getYear);
            function currentYear() {
                return new Date().getFullYear();
            }
            FunctionFactory.Instance.register("currentYear", currentYear);
            function diffDays(params) {
                if (!Array.isArray(params) || params.length !== 2) return 0;
                if (!params[0] || !params[1]) return 0;
                var date1 = new Date(params[0]);
                var date2 = new Date(params[1]);
                var diffTime = Math.abs(date2 - date1);
                return Math.ceil(diffTime / 86400000);
            }
            FunctionFactory.Instance.register("diffDays", diffDays);
            function dateFromFirstParameterOrToday(params) {
                var date = today(undefined);
                if (params && params[0]) date = new Date(params[0]);
                return date;
            }
            function year(params) {
                var date = dateFromFirstParameterOrToday(params);
                return date.getFullYear();
            }
            FunctionFactory.Instance.register("year", year);
            function month(params) {
                var date = dateFromFirstParameterOrToday(params);
                return date.getMonth() + 1;
            }
            FunctionFactory.Instance.register("month", month);
            function day(params) {
                var date = dateFromFirstParameterOrToday(params);
                return date.getDate();
            }
            FunctionFactory.Instance.register("day", day);
            function weekday(params) {
                var date = dateFromFirstParameterOrToday(params);
                return date.getDay();
            }
            FunctionFactory.Instance.register("weekday", weekday);
            function getQuestionValueByContext(context, name) {
                if (!context || !name) return undefined;
                var keys = [
                    "row",
                    "panel",
                    "survey"
                ];
                for(var i = 0; i < keys.length; i++){
                    var ctx = context[keys[i]];
                    if (ctx && ctx.getQuestionByName) {
                        var res = ctx.getQuestionByName(name);
                        if (res) return res;
                    }
                }
                return null;
            }
            function displayValue(params) {
                var q = getQuestionValueByContext(this, params[0]);
                return q ? q.displayValue : "";
            }
            FunctionFactory.Instance.register("displayValue", displayValue);
            function propertyValue(params) {
                if (params.length !== 2 || !params[0] || !params[1]) return undefined;
                var q = getQuestionValueByContext(this, params[0]);
                return q ? q[params[1]] : undefined;
            }
            FunctionFactory.Instance.register("propertyValue", propertyValue);
            function substring_(params) {
                if (params.length < 2) return "";
                var s = params[0];
                if (!s || typeof s !== "string") return "";
                var start = params[1];
                if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(start)) return "";
                var end = params.length > 2 ? params[2] : undefined;
                if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(end)) return s.substring(start);
                return s.substring(start, end);
            }
            FunctionFactory.Instance.register("substring", substring_);
        /***/ },
        /***/ "./src/global_variables_utils.ts": /*!***************************************!*\
  !*** ./src/global_variables_utils.ts ***!
  \***************************************/ /*! exports provided: DomWindowHelper, DomDocumentHelper */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomWindowHelper", function() {
                return DomWindowHelper;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomDocumentHelper", function() {
                return DomDocumentHelper;
            });
            /* eslint-disable no-restricted-globals */ var DomWindowHelper = /** @class */ function() {
                function DomWindowHelper() {}
                DomWindowHelper.isAvailable = function() {
                    return "undefined" !== typeof window;
                };
                DomWindowHelper.isFileReaderAvailable = function() {
                    if (!DomWindowHelper.isAvailable()) return false;
                    return !!window["FileReader"];
                };
                DomWindowHelper.getLocation = function() {
                    if (!DomWindowHelper.isAvailable()) return;
                    return window.location;
                };
                DomWindowHelper.getVisualViewport = function() {
                    if (!DomWindowHelper.isAvailable()) return null;
                    return window.visualViewport;
                };
                DomWindowHelper.getInnerWidth = function() {
                    if (!DomWindowHelper.isAvailable()) return;
                    return window.innerWidth;
                };
                DomWindowHelper.getInnerHeight = function() {
                    if (!DomWindowHelper.isAvailable()) return null;
                    return window.innerHeight;
                };
                DomWindowHelper.getWindow = function() {
                    if (!DomWindowHelper.isAvailable()) return;
                    return window;
                };
                DomWindowHelper.hasOwn = function(propertyName) {
                    if (!DomWindowHelper.isAvailable()) return;
                    return propertyName in window;
                };
                DomWindowHelper.getSelection = function() {
                    if (DomWindowHelper.isAvailable() && window.getSelection) return window.getSelection();
                };
                DomWindowHelper.requestAnimationFrame = function(callback) {
                    if (DomWindowHelper.isAvailable()) return window.requestAnimationFrame(callback);
                };
                DomWindowHelper.addEventListener = function(type, listener) {
                    if (!DomWindowHelper.isAvailable()) return;
                    window.addEventListener(type, listener);
                };
                DomWindowHelper.removeEventListener = function(type, listener) {
                    if (!DomWindowHelper.isAvailable()) return;
                    window.removeEventListener(type, listener);
                };
                return DomWindowHelper;
            }();
            var DomDocumentHelper = /** @class */ function() {
                function DomDocumentHelper() {}
                DomDocumentHelper.isAvailable = function() {
                    return "undefined" !== typeof document;
                };
                DomDocumentHelper.getBody = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document.body;
                };
                DomDocumentHelper.getDocumentElement = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document.documentElement;
                };
                DomDocumentHelper.getDocument = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document;
                };
                DomDocumentHelper.getCookie = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document.cookie;
                };
                DomDocumentHelper.setCookie = function(newCookie) {
                    if (!DomDocumentHelper.isAvailable()) return;
                    document.cookie = newCookie;
                };
                DomDocumentHelper.activeElementBlur = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    var activeElement = document.activeElement;
                    if (!!activeElement && !!activeElement.blur) activeElement.blur();
                };
                DomDocumentHelper.createElement = function(tagName) {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document.createElement(tagName);
                };
                DomDocumentHelper.getComputedStyle = function(elt) {
                    if (!DomDocumentHelper.isAvailable()) return new CSSStyleDeclaration();
                    return document.defaultView.getComputedStyle(elt);
                };
                DomDocumentHelper.addEventListener = function(type, listener) {
                    if (!DomDocumentHelper.isAvailable()) return;
                    document.addEventListener(type, listener);
                };
                DomDocumentHelper.removeEventListener = function(type, listener) {
                    if (!DomDocumentHelper.isAvailable()) return;
                    document.removeEventListener(type, listener);
                };
                return DomDocumentHelper;
            }();
        /***/ },
        /***/ "./src/header.ts": /*!***********************!*\
  !*** ./src/header.ts ***!
  \***********************/ /*! exports provided: CoverCell, Cover */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CoverCell", function() {
                return CoverCell;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Cover", function() {
                return Cover;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var CoverCell = /** @class */ function() {
                function CoverCell(cover, positionX, positionY) {
                    this.cover = cover;
                    this.positionX = positionX;
                    this.positionY = positionY;
                }
                CoverCell.prototype.calcRow = function(positionY) {
                    return positionY === "top" ? 1 : positionY === "middle" ? 2 : 3;
                };
                CoverCell.prototype.calcColumn = function(positionX) {
                    return positionX === "left" ? 1 : positionX === "center" ? 2 : 3;
                };
                CoverCell.prototype.calcAlignItems = function(positionX) {
                    return positionX === "left" ? "flex-start" : positionX === "center" ? "center" : "flex-end";
                };
                CoverCell.prototype.calcAlignText = function(positionX) {
                    return positionX === "left" ? "start" : positionX === "center" ? "center" : "end";
                };
                CoverCell.prototype.calcJustifyContent = function(positionY) {
                    return positionY === "top" ? "flex-start" : positionY === "middle" ? "center" : "flex-end";
                };
                Object.defineProperty(CoverCell.prototype, "survey", {
                    get: function() {
                        return this.cover.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CoverCell.prototype, "css", {
                    get: function() {
                        var result = CoverCell.CLASSNAME + " " + CoverCell.CLASSNAME + "--" + this.positionX + " " + CoverCell.CLASSNAME + "--" + this.positionY;
                        return result;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CoverCell.prototype, "style", {
                    get: function() {
                        var result = {};
                        result["gridColumn"] = this.calcColumn(this.positionX);
                        result["gridRow"] = this.calcRow(this.positionY);
                        return result;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CoverCell.prototype, "contentStyle", {
                    get: function() {
                        var result = {};
                        result["textAlign"] = this.calcAlignText(this.positionX);
                        result["alignItems"] = this.calcAlignItems(this.positionX);
                        result["justifyContent"] = this.calcJustifyContent(this.positionY);
                        return result;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CoverCell.prototype, "showLogo", {
                    get: function() {
                        return this.survey.hasLogo && this.positionX === this.cover.logoPositionX && this.positionY === this.cover.logoPositionY;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CoverCell.prototype, "showTitle", {
                    get: function() {
                        return this.survey.hasTitle && this.positionX === this.cover.titlePositionX && this.positionY === this.cover.titlePositionY;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CoverCell.prototype, "showDescription", {
                    get: function() {
                        return this.survey.renderedHasDescription && this.positionX === this.cover.descriptionPositionX && this.positionY === this.cover.descriptionPositionY;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(CoverCell.prototype, "textAreaWidth", {
                    get: function() {
                        if (!this.cover.textAreaWidth) return "";
                        return "" + this.cover.textAreaWidth + "px";
                    },
                    enumerable: false,
                    configurable: true
                });
                CoverCell.CLASSNAME = "sv-header__cell";
                return CoverCell;
            }();
            var Cover = /** @class */ function(_super) {
                __extends(Cover, _super);
                function Cover() {
                    var _this = _super.call(this) || this;
                    _this.cells = [];
                    [
                        "top",
                        "middle",
                        "bottom"
                    ].forEach(function(positionY) {
                        return [
                            "left",
                            "center",
                            "right"
                        ].forEach(function(positionX) {
                            return _this.cells.push(new CoverCell(_this, positionX, positionY));
                        });
                    });
                    _this.init();
                    return _this;
                }
                Cover.prototype.calcBackgroundSize = function(backgroundImageFit) {
                    if (backgroundImageFit === "fill") return "100% 100%";
                    if (backgroundImageFit === "tile") return "auto";
                    return backgroundImageFit;
                };
                Cover.prototype.updateHeaderClasses = function() {
                    this.headerClasses = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append("sv-header").append("sv-header__without-background", this.backgroundColor === "transparent" && !this.backgroundImage).append("sv-header__background-color--none", this.backgroundColor === "transparent" && !this.titleColor && !this.descriptionColor).append("sv-header__background-color--accent", !this.backgroundColor && !this.titleColor && !this.descriptionColor).append("sv-header__background-color--custom", !!this.backgroundColor && this.backgroundColor !== "transparent" && !this.titleColor && !this.descriptionColor).append("sv-header__overlap", this.overlapEnabled).toString();
                };
                Cover.prototype.updateContentClasses = function() {
                    var surveyWidthMode = !!this.survey && this.survey.calculateWidthMode();
                    this.maxWidth = this.inheritWidthFrom === "survey" && !!surveyWidthMode && surveyWidthMode === "static" && this.survey.renderedWidth;
                    this.contentClasses = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append("sv-header__content").append("sv-header__content--static", this.inheritWidthFrom === "survey" && !!surveyWidthMode && surveyWidthMode === "static").append("sv-header__content--responsive", this.inheritWidthFrom === "container" || !!surveyWidthMode && surveyWidthMode === "responsive").toString();
                };
                Cover.prototype.updateBackgroundImageClasses = function() {
                    this.backgroundImageClasses = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append("sv-header__background-image").append("sv-header__background-image--contain", this.backgroundImageFit === "contain").append("sv-header__background-image--tile", this.backgroundImageFit === "tile").toString();
                };
                Cover.prototype.fromTheme = function(theme) {
                    _super.prototype.fromJSON.call(this, theme.header);
                    if (!!theme.cssVariables) {
                        this.backgroundColor = theme.cssVariables["--sjs-header-backcolor"];
                        this.titleColor = theme.cssVariables["--sjs-font-headertitle-color"];
                        this.descriptionColor = theme.cssVariables["--sjs-font-headerdescription-color"];
                    }
                    this.init();
                };
                Cover.prototype.init = function() {
                    this.renderBackgroundImage = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_3__["wrapUrlForBackgroundImage"])(this.backgroundImage);
                    this.updateHeaderClasses();
                    this.updateContentClasses();
                    this.updateBackgroundImageClasses();
                };
                Cover.prototype.getType = function() {
                    return "cover";
                };
                Object.defineProperty(Cover.prototype, "renderedHeight", {
                    get: function() {
                        return this.height && (this.survey && !this.survey.isMobile || !this.survey) ? Math.max(this.height, this.actualHeight + 40) + "px" : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Cover.prototype, "renderedtextAreaWidth", {
                    get: function() {
                        return this.textAreaWidth ? this.textAreaWidth + "px" : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Cover.prototype, "survey", {
                    get: function() {
                        return this._survey;
                    },
                    set: function(newValue) {
                        var _this = this;
                        if (this._survey === newValue) return;
                        this._survey = newValue;
                        if (!!newValue) {
                            this.updateContentClasses();
                            this._survey.onPropertyChanged.add(function(sender, options) {
                                if (options.name == "widthMode" || options.name == "width") _this.updateContentClasses();
                            });
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Cover.prototype, "backgroundImageStyle", {
                    get: function() {
                        if (!this.backgroundImage) return null;
                        return {
                            opacity: this.backgroundImageOpacity,
                            backgroundImage: this.renderBackgroundImage,
                            backgroundSize: this.calcBackgroundSize(this.backgroundImageFit)
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                Cover.prototype.propertyValueChanged = function(name, oldValue, newValue) {
                    _super.prototype.propertyValueChanged.call(this, name, oldValue, newValue);
                    if (name === "backgroundColor" || name === "backgroundImage" || name === "overlapEnabled") this.updateHeaderClasses();
                    if (name === "inheritWidthFrom") this.updateContentClasses();
                    if (name === "backgroundImageFit") this.updateBackgroundImageClasses();
                };
                Cover.prototype.calculateActualHeight = function(logoHeight, titleHeight, descriptionHeight) {
                    var positionsY = [
                        "top",
                        "middle",
                        "bottom"
                    ];
                    var logoIndex = positionsY.indexOf(this.logoPositionY);
                    var titleIndex = positionsY.indexOf(this.titlePositionY);
                    var descriptionIndex = positionsY.indexOf(this.descriptionPositionY);
                    var positionsX = [
                        "left",
                        "center",
                        "right"
                    ];
                    var logoIndexX = positionsX.indexOf(this.logoPositionX);
                    var titleIndexX = positionsX.indexOf(this.titlePositionX);
                    var descriptionIndexX = positionsX.indexOf(this.descriptionPositionX);
                    var heights = [
                        [
                            0,
                            0,
                            0
                        ],
                        [
                            0,
                            0,
                            0
                        ],
                        [
                            0,
                            0,
                            0
                        ]
                    ];
                    heights[logoIndex][logoIndexX] = logoHeight;
                    heights[titleIndex][titleIndexX] += titleHeight;
                    heights[descriptionIndex][descriptionIndexX] += descriptionHeight;
                    return heights.reduce(function(total, rowArr) {
                        return total + Math.max.apply(Math, rowArr);
                    }, 0);
                };
                Cover.prototype.processResponsiveness = function(width) {
                    if (this.survey && this.survey.rootElement) {
                        var logoEl = this.survey.rootElement.querySelectorAll(".sv-header__logo")[0];
                        var titleEl = this.survey.rootElement.querySelectorAll(".sv-header__title")[0];
                        var descriptionEl = this.survey.rootElement.querySelectorAll(".sv-header__description")[0];
                        var logoHeight = logoEl ? logoEl.getBoundingClientRect().height : 0;
                        var titleHeight = titleEl ? titleEl.getBoundingClientRect().height : 0;
                        var descriptionHeight = descriptionEl ? descriptionEl.getBoundingClientRect().height : 0;
                        this.actualHeight = this.calculateActualHeight(logoHeight, titleHeight, descriptionHeight);
                    }
                };
                Object.defineProperty(Cover.prototype, "hasBackground", {
                    get: function() {
                        return !!this.backgroundImage || this.backgroundColor !== "transparent";
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: 0
                    })
                ], Cover.prototype, "actualHeight", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "height", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "inheritWidthFrom", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "textAreaWidth", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "textGlowEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "overlapEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "backgroundColor", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "titleColor", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "descriptionColor", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        onSet: function(newVal, target) {
                            target.renderBackgroundImage = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_3__["wrapUrlForBackgroundImage"])(newVal);
                        }
                    })
                ], Cover.prototype, "backgroundImage", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "renderBackgroundImage", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "backgroundImageFit", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "backgroundImageOpacity", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "logoPositionX", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "logoPositionY", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "titlePositionX", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "titlePositionY", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "descriptionPositionX", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "descriptionPositionY", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "logoStyle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "titleStyle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "descriptionStyle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "headerClasses", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "contentClasses", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "maxWidth", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Cover.prototype, "backgroundImageClasses", void 0);
                return Cover;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("cover", [
                {
                    name: "height:number",
                    minValue: 0,
                    default: 256
                },
                {
                    name: "inheritWidthFrom",
                    default: "container"
                },
                {
                    name: "textAreaWidth:number",
                    minValue: 0,
                    default: 512
                },
                {
                    name: "textGlowEnabled:boolean"
                },
                {
                    name: "overlapEnabled:boolean"
                },
                {
                    name: "backgroundImage:file"
                },
                {
                    name: "backgroundImageOpacity:number",
                    minValue: 0,
                    maxValue: 1,
                    default: 1
                },
                {
                    name: "backgroundImageFit",
                    default: "cover",
                    choices: [
                        "cover",
                        "fill",
                        "contain"
                    ]
                },
                {
                    name: "logoPositionX",
                    default: "right"
                },
                {
                    name: "logoPositionY",
                    default: "top"
                },
                {
                    name: "titlePositionX",
                    default: "left"
                },
                {
                    name: "titlePositionY",
                    default: "bottom"
                },
                {
                    name: "descriptionPositionX",
                    default: "left"
                },
                {
                    name: "descriptionPositionY",
                    default: "bottom"
                }
            ], function() {
                return new Cover();
            });
        /***/ },
        /***/ "./src/helpers.ts": /*!************************!*\
  !*** ./src/helpers.ts ***!
  \************************/ /*! exports provided: Helpers */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Helpers", function() {
                return Helpers;
            });
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var Helpers = /** @class */ function() {
                function Helpers() {}
                /**
     * A static methods that returns true if a value undefined, null, empty string or empty array.
     * @param value
     */ Helpers.isValueEmpty = function(value) {
                    if (Array.isArray(value) && value.length === 0) return true;
                    if (!!value && Helpers.isValueObject(value) && value.constructor === Object) {
                        for(var key in value){
                            if (!Helpers.isValueEmpty(value[key])) return false;
                        }
                        return true;
                    }
                    return !value && value !== 0 && value !== false;
                };
                Helpers.isArrayContainsEqual = function(x, y) {
                    if (!Array.isArray(x) || !Array.isArray(y)) return false;
                    if (x.length !== y.length) return false;
                    for(var i = 0; i < x.length; i++){
                        var j = 0;
                        for(; j < y.length; j++){
                            if (Helpers.isTwoValueEquals(x[i], y[j])) break;
                        }
                        if (j === y.length) return false;
                    }
                    return true;
                };
                Helpers.isArraysEqual = function(x, y, ignoreOrder, caseSensitive, trimStrings) {
                    if (ignoreOrder === void 0) ignoreOrder = false;
                    if (!Array.isArray(x) || !Array.isArray(y)) return false;
                    if (x.length !== y.length) return false;
                    if (ignoreOrder) {
                        var xSorted = [];
                        var ySorted = [];
                        for(var i = 0; i < x.length; i++){
                            xSorted.push(x[i]);
                            ySorted.push(y[i]);
                        }
                        xSorted.sort();
                        ySorted.sort();
                        x = xSorted;
                        y = ySorted;
                    }
                    for(var i = 0; i < x.length; i++){
                        if (!Helpers.isTwoValueEquals(x[i], y[i], ignoreOrder, caseSensitive, trimStrings)) return false;
                    }
                    return true;
                };
                Helpers.compareStrings = function(x, y) {
                    var normalize = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].comparator.normalizeTextCallback;
                    if (!!x) x = normalize(x, "compare").trim();
                    if (!!y) y = normalize(y, "compare").trim();
                    if (!x && !y) return 0;
                    if (!x) return -1;
                    if (!y) return 1;
                    if (x === y) return 0;
                    var digitIndex = -1;
                    for(var i = 0; i < x.length && i < y.length; i++){
                        if (this.isCharDigit(x[i]) && this.isCharDigit(y[i])) {
                            digitIndex = i;
                            break;
                        }
                        if (x[i] !== y[i]) break;
                    }
                    if (digitIndex > -1) {
                        var nX = this.getNumberFromStr(x, digitIndex);
                        var nY = this.getNumberFromStr(y, digitIndex);
                        if (!Number.isNaN(nX) && !Number.isNaN(nY) && nX !== nY) return nX > nY ? 1 : -1;
                    }
                    return x > y ? 1 : -1;
                };
                Helpers.isTwoValueEquals = function(x, y, ignoreOrder, caseSensitive, trimStrings) {
                    if (ignoreOrder === void 0) ignoreOrder = false;
                    if (x === y) return true;
                    if (Array.isArray(x) && x.length === 0 && typeof y === "undefined") return true;
                    if (Array.isArray(y) && y.length === 0 && typeof x === "undefined") return true;
                    if ((x === undefined || x === null) && y === "") return true;
                    if ((y === undefined || y === null) && x === "") return true;
                    if (trimStrings === undefined) trimStrings = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].comparator.trimStrings;
                    if (caseSensitive === undefined) caseSensitive = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].comparator.caseSensitive;
                    if (typeof x === "string" && typeof y === "string") {
                        var normalize = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].comparator.normalizeTextCallback;
                        x = normalize(x, "compare");
                        y = normalize(y, "compare");
                        if (trimStrings) {
                            x = x.trim();
                            y = y.trim();
                        }
                        if (!caseSensitive) {
                            x = x.toLowerCase();
                            y = y.toLowerCase();
                        }
                        return x === y;
                    }
                    if (x instanceof Date && y instanceof Date) return x.getTime() == y.getTime();
                    if (Helpers.isConvertibleToNumber(x) && Helpers.isConvertibleToNumber(y)) {
                        if (parseInt(x) === parseInt(y) && parseFloat(x) === parseFloat(y)) return true;
                    }
                    if (!Helpers.isValueEmpty(x) && Helpers.isValueEmpty(y) || Helpers.isValueEmpty(x) && !Helpers.isValueEmpty(y)) return false;
                    if ((x === true || x === false) && typeof y == "string") return x.toString() === y.toLocaleLowerCase();
                    if ((y === true || y === false) && typeof x == "string") return y.toString() === x.toLocaleLowerCase();
                    if (!Helpers.isValueObject(x) && !Helpers.isValueObject(y)) return x == y;
                    if (!Helpers.isValueObject(x) || !Helpers.isValueObject(y)) return false;
                    if (x["equals"] && y["equals"]) return x.equals(y);
                    if (Array.isArray(x) && Array.isArray(y)) return Helpers.isArraysEqual(x, y, ignoreOrder, caseSensitive, trimStrings);
                    for(var p in x){
                        if (!x.hasOwnProperty(p)) continue;
                        if (!y.hasOwnProperty(p)) return false;
                        if (!this.isTwoValueEquals(x[p], y[p], ignoreOrder, caseSensitive, trimStrings)) return false;
                    }
                    for(p in y){
                        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
                    }
                    return true;
                };
                Helpers.randomizeArray = function(array) {
                    for(var i = array.length - 1; i > 0; i--){
                        var j = Math.floor(Math.random() * (i + 1));
                        var temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    return array;
                };
                Helpers.getUnbindValue = function(value) {
                    if (Array.isArray(value)) {
                        var res = [];
                        for(var i = 0; i < value.length; i++)res.push(Helpers.getUnbindValue(value[i]));
                        return res;
                    }
                    if (!!value && Helpers.isValueObject(value) && !(value instanceof Date)) return JSON.parse(JSON.stringify(value));
                    return value;
                };
                Helpers.createCopy = function(obj) {
                    var res = {};
                    if (!obj) return res;
                    for(var key in obj)res[key] = obj[key];
                    return res;
                };
                Helpers.isConvertibleToNumber = function(value) {
                    return value !== undefined && value !== null && !Array.isArray(value) && !isNaN(value);
                };
                Helpers.isValueObject = function(val1, excludeArray) {
                    return val1 instanceof Object && (!excludeArray || !Array.isArray(val1));
                };
                Helpers.isNumber = function(value) {
                    return !isNaN(this.getNumber(value));
                };
                Helpers.getNumber = function(value) {
                    if (typeof value == "string" && !!value && value.indexOf("0x") == 0 && value.length > 32) return NaN;
                    value = this.prepareStringToNumber(value);
                    var res = parseFloat(value);
                    if (isNaN(res) || !isFinite(value)) return NaN;
                    return res;
                };
                Helpers.prepareStringToNumber = function(val1) {
                    if (typeof val1 !== "string" || !val1) return val1;
                    var i = val1.indexOf(",");
                    if (i > -1 && val1.indexOf(",", i + 1) < 0) return val1.replace(",", ".");
                    return val1;
                };
                Helpers.getMaxLength = function(maxLength, surveyLength) {
                    if (maxLength < 0) maxLength = surveyLength;
                    return maxLength > 0 ? maxLength : null;
                };
                Helpers.getRemainingCharacterCounterText = function(newValue, maxLength) {
                    if (!maxLength || maxLength <= 0 || !_settings__WEBPACK_IMPORTED_MODULE_0__["settings"].showMaxLengthIndicator) return "";
                    var value = newValue ? newValue.length : "0";
                    return [
                        value,
                        maxLength
                    ].join("/");
                };
                Helpers.getNumberByIndex = function(index, startIndexStr) {
                    if (index < 0) return "";
                    var startIndex = 1;
                    var prefix = "";
                    var postfix = ".";
                    var isNumeric = true;
                    var strIndex = "A";
                    var str = "";
                    if (!!startIndexStr) {
                        str = startIndexStr;
                        var ind = str.length - 1;
                        var hasDigit = false;
                        for(var i = 0; i < str.length; i++)if (Helpers.isCharDigit(str[i])) {
                            hasDigit = true;
                            break;
                        }
                        var checkLetter = function() {
                            return hasDigit && !Helpers.isCharDigit(str[ind]) || Helpers.isCharNotLetterAndDigit(str[ind]);
                        };
                        while(ind >= 0 && checkLetter())ind--;
                        var newPostfix = "";
                        if (ind < str.length - 1) {
                            newPostfix = str.substring(ind + 1);
                            str = str.substring(0, ind + 1);
                        }
                        ind = str.length - 1;
                        while(ind >= 0){
                            if (checkLetter()) break;
                            ind--;
                            if (!hasDigit) break;
                        }
                        strIndex = str.substring(ind + 1);
                        prefix = str.substring(0, ind + 1);
                        if (parseInt(strIndex)) startIndex = parseInt(strIndex);
                        else if (strIndex.length == 1) isNumeric = false;
                        if (!!newPostfix || !!prefix) postfix = newPostfix;
                    }
                    if (isNumeric) {
                        var val1 = (index + startIndex).toString();
                        while(val1.length < strIndex.length)val1 = "0" + val1;
                        return prefix + val1 + postfix;
                    }
                    return prefix + String.fromCharCode(strIndex.charCodeAt(0) + index) + postfix;
                };
                Helpers.isCharNotLetterAndDigit = function(ch) {
                    return ch.toUpperCase() == ch.toLowerCase() && !Helpers.isCharDigit(ch);
                };
                Helpers.isCharDigit = function(ch) {
                    return ch >= "0" && ch <= "9";
                };
                Helpers.getNumberFromStr = function(str, index) {
                    if (!this.isCharDigit(str[index])) return NaN;
                    var nStr = "";
                    while(index < str.length && this.isCharDigit(str[index])){
                        nStr += str[index];
                        index++;
                    }
                    if (!nStr) return NaN;
                    return this.getNumber(nStr);
                };
                Helpers.countDecimals = function(value) {
                    if (Helpers.isNumber(value) && Math.floor(value) !== value) {
                        var strs = value.toString().split(".");
                        return strs.length > 1 && strs[1].length || 0;
                    }
                    return 0;
                };
                Helpers.correctAfterPlusMinis = function(a, b, res) {
                    var digitsA = Helpers.countDecimals(a);
                    var digitsB = Helpers.countDecimals(b);
                    if (digitsA > 0 || digitsB > 0) {
                        var digits = Math.max(digitsA, digitsB);
                        res = parseFloat(res.toFixed(digits));
                    }
                    return res;
                };
                Helpers.sumAnyValues = function(a, b) {
                    if (!Helpers.isNumber(a) || !Helpers.isNumber(b)) {
                        if (Array.isArray(a) && Array.isArray(b)) return [].concat(a).concat(b);
                        if (Array.isArray(a) || Array.isArray(b)) {
                            var arr = Array.isArray(a) ? a : b;
                            var val1 = arr === a ? b : a;
                            if (typeof val1 === "string") {
                                var str = arr.join(", ");
                                return arr === a ? str + val1 : val1 + str;
                            }
                            if (typeof val1 === "number") {
                                var res = 0;
                                for(var i = 0; i < arr.length; i++)if (typeof arr[i] === "number") res = Helpers.correctAfterPlusMinis(res, arr[i], res + arr[i]);
                                return Helpers.correctAfterPlusMinis(res, val1, res + val1);
                            }
                        }
                        return a + b;
                    }
                    if (typeof a === "string" || typeof b === "string") return a + b;
                    return Helpers.correctAfterPlusMinis(a, b, a + b);
                };
                Helpers.correctAfterMultiple = function(a, b, res) {
                    var digits = Helpers.countDecimals(a) + Helpers.countDecimals(b);
                    if (digits > 0) res = parseFloat(res.toFixed(digits));
                    return res;
                };
                Helpers.convertArrayValueToObject = function(src, propName, dest) {
                    if (dest === void 0) dest = undefined;
                    var res = new Array();
                    if (!src || !Array.isArray(src)) return res;
                    for(var i = 0; i < src.length; i++){
                        var item = void 0;
                        if (Array.isArray(dest)) item = Helpers.findObjByPropValue(dest, propName, src[i]);
                        if (!item) {
                            item = {};
                            item[propName] = src[i];
                        }
                        res.push(item);
                    }
                    return res;
                };
                Helpers.findObjByPropValue = function(arr, propName, val1) {
                    for(var i = 0; i < arr.length; i++){
                        if (Helpers.isTwoValueEquals(arr[i][propName], val1)) return arr[i];
                    }
                    return undefined;
                };
                Helpers.convertArrayObjectToValue = function(src, propName) {
                    var res = new Array();
                    if (!src || !Array.isArray(src)) return res;
                    for(var i = 0; i < src.length; i++){
                        var itemVal = !!src[i] ? src[i][propName] : undefined;
                        if (!Helpers.isValueEmpty(itemVal)) res.push(itemVal);
                    }
                    return res;
                };
                Helpers.convertDateToString = function(date) {
                    var toStr = function(val1) {
                        if (val1 < 10) return "0" + val1.toString();
                        return val1.toString();
                    };
                    return date.getFullYear() + "-" + toStr(date.getMonth() + 1) + "-" + toStr(date.getDate());
                };
                Helpers.convertDateTimeToString = function(date) {
                    var toStr = function(val1) {
                        if (val1 < 10) return "0" + val1.toString();
                        return val1.toString();
                    };
                    return this.convertDateToString(date) + " " + toStr(date.getHours()) + ":" + toStr(date.getMinutes());
                };
                Helpers.convertValToQuestionVal = function(val1, inputType) {
                    if (val1 instanceof Date) {
                        if (inputType === "datetime-local") return Helpers.convertDateTimeToString(val1);
                        return Helpers.convertDateToString(val1);
                    }
                    return val1;
                };
                Helpers.compareVerions = function(ver1, ver2) {
                    if (!ver1 && !ver2) return 0;
                    var ver1Ar = ver1.split(".");
                    var ver2Ar = ver2.split(".");
                    var len1 = ver1Ar.length;
                    var len2 = ver2Ar.length;
                    for(var i = 0; i < len1 && i < len2; i++){
                        var str1 = ver1Ar[i];
                        var str2 = ver2Ar[i];
                        if (str1.length === str2.length) {
                            if (str1 !== str2) return str1 < str2 ? -1 : 1;
                        } else return str1.length < str2.length ? -1 : 1;
                    }
                    return len1 === len2 ? 0 : len1 < len2 ? -1 : 1;
                };
                return Helpers;
            }();
            if (!String.prototype["format"]) String.prototype["format"] = function() {
                var args = arguments;
                return this.replace(/{(\d+)}/g, function(match, number) {
                    return typeof args[number] != "undefined" ? args[number] : match;
                });
            };
        /***/ },
        /***/ "./src/images sync \\.svg$": /*!*********************************************!*\
  !*** ./src/images sync nonrecursive \.svg$ ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var map = {
                "./ArrowDown_34x34.svg": "./src/images/ArrowDown_34x34.svg",
                "./ArrowLeft.svg": "./src/images/ArrowLeft.svg",
                "./ArrowRight.svg": "./src/images/ArrowRight.svg",
                "./Arrow_downGREY_10x10.svg": "./src/images/Arrow_downGREY_10x10.svg",
                "./ChangeCamera.svg": "./src/images/ChangeCamera.svg",
                "./ChooseFile.svg": "./src/images/ChooseFile.svg",
                "./Clear.svg": "./src/images/Clear.svg",
                "./CloseCamera.svg": "./src/images/CloseCamera.svg",
                "./DefaultFile.svg": "./src/images/DefaultFile.svg",
                "./Delete.svg": "./src/images/Delete.svg",
                "./Down_34x34.svg": "./src/images/Down_34x34.svg",
                "./Left.svg": "./src/images/Left.svg",
                "./ModernBooleanCheckChecked.svg": "./src/images/ModernBooleanCheckChecked.svg",
                "./ModernBooleanCheckInd.svg": "./src/images/ModernBooleanCheckInd.svg",
                "./ModernBooleanCheckUnchecked.svg": "./src/images/ModernBooleanCheckUnchecked.svg",
                "./ModernCheck.svg": "./src/images/ModernCheck.svg",
                "./ModernRadio.svg": "./src/images/ModernRadio.svg",
                "./More.svg": "./src/images/More.svg",
                "./NavMenu_24x24.svg": "./src/images/NavMenu_24x24.svg",
                "./ProgressButton.svg": "./src/images/ProgressButton.svg",
                "./ProgressButtonV2.svg": "./src/images/ProgressButtonV2.svg",
                "./RemoveFile.svg": "./src/images/RemoveFile.svg",
                "./Right.svg": "./src/images/Right.svg",
                "./SearchClear.svg": "./src/images/SearchClear.svg",
                "./ShowCamera.svg": "./src/images/ShowCamera.svg",
                "./TakePicture.svg": "./src/images/TakePicture.svg",
                "./TakePicture_24x24.svg": "./src/images/TakePicture_24x24.svg",
                "./TimerCircle.svg": "./src/images/TimerCircle.svg",
                "./V2Check.svg": "./src/images/V2Check.svg",
                "./V2Check_24x24.svg": "./src/images/V2Check_24x24.svg",
                "./V2DragElement_16x16.svg": "./src/images/V2DragElement_16x16.svg",
                "./back-to-panel_16x16.svg": "./src/images/back-to-panel_16x16.svg",
                "./chevron.svg": "./src/images/chevron.svg",
                "./clear_16x16.svg": "./src/images/clear_16x16.svg",
                "./close_16x16.svg": "./src/images/close_16x16.svg",
                "./collapseDetail.svg": "./src/images/collapseDetail.svg",
                "./drag-n-drop.svg": "./src/images/drag-n-drop.svg",
                "./expandDetail.svg": "./src/images/expandDetail.svg",
                "./full-screen_16x16.svg": "./src/images/full-screen_16x16.svg",
                "./loading.svg": "./src/images/loading.svg",
                "./minimize_16x16.svg": "./src/images/minimize_16x16.svg",
                "./no-image.svg": "./src/images/no-image.svg",
                "./ranking-arrows.svg": "./src/images/ranking-arrows.svg",
                "./ranking-dash.svg": "./src/images/ranking-dash.svg",
                "./rating-star-2.svg": "./src/images/rating-star-2.svg",
                "./rating-star-small-2.svg": "./src/images/rating-star-small-2.svg",
                "./rating-star-small.svg": "./src/images/rating-star-small.svg",
                "./rating-star.svg": "./src/images/rating-star.svg",
                "./restore_16x16.svg": "./src/images/restore_16x16.svg",
                "./search.svg": "./src/images/search.svg"
            };
            function webpackContext(req) {
                var id = webpackContextResolve(req);
                return __webpack_require__(id);
            }
            function webpackContextResolve(req) {
                if (!__webpack_require__.o(map, req)) {
                    var e = new Error("Cannot find module '" + req + "'");
                    e.code = "MODULE_NOT_FOUND";
                    throw e;
                }
                return map[req];
            }
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module1.exports = webpackContext;
            webpackContext.id = "./src/images sync \\.svg$";
        /***/ },
        /***/ "./src/images/ArrowDown_34x34.svg": /*!****************************************!*\
  !*** ./src/images/ArrowDown_34x34.svg ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 34 34" xml:space="preserve"><polygon class="st0" points="12,16 14,14 17,17 20,14 22,16 17,21 "></polygon></svg>';
        /***/ },
        /***/ "./src/images/ArrowLeft.svg": /*!**********************************!*\
  !*** ./src/images/ArrowLeft.svg ***!
  \**********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15 8.99999H4.39998L8.69998 13.3L7.29998 14.7L0.599976 7.99999L7.29998 1.29999L8.69998 2.69999L4.39998 6.99999H15V8.99999Z"></path></svg>';
        /***/ },
        /***/ "./src/images/ArrowRight.svg": /*!***********************************!*\
  !*** ./src/images/ArrowRight.svg ***!
  \***********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M1 6.99999H11.6L7.3 2.69999L8.7 1.29999L15.4 7.99999L8.7 14.7L7.3 13.3L11.6 8.99999H1V6.99999Z"></path></svg>';
        /***/ },
        /***/ "./src/images/Arrow_downGREY_10x10.svg": /*!*********************************************!*\
  !*** ./src/images/Arrow_downGREY_10x10.svg ***!
  \*********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 10 10" xml:space="preserve"><polygon class="st0" points="2,2 0,4 5,9 10,4 8,2 5,5 "></polygon></svg>';
        /***/ },
        /***/ "./src/images/ChangeCamera.svg": /*!*************************************!*\
  !*** ./src/images/ChangeCamera.svg ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M23 12.0037C23 14.2445 21.7794 16.3052 19.5684 17.8257C19.3984 17.9458 19.1983 18.0058 19.0082 18.0058C18.688 18.0058 18.3779 17.8557 18.1778 17.5756C17.8677 17.1155 17.9777 16.4953 18.4379 16.1852C20.0887 15.0448 21.0091 13.5643 21.0091 12.0138C21.0091 8.70262 16.9673 6.01171 12.005 6.01171C11.4948 6.01171 10.9945 6.04172 10.5043 6.09173L11.7149 7.30215C12.105 7.69228 12.105 8.32249 11.7149 8.71263C11.5148 8.9127 11.2647 9.00273 11.0045 9.00273C10.7444 9.00273 10.4943 8.90269 10.2942 8.71263L6.58254 5.00136L10.2842 1.2901C10.6744 0.899964 11.3047 0.899964 11.6949 1.2901C12.085 1.68023 12.085 2.31045 11.6949 2.70058L10.3042 4.09105C10.8545 4.03103 11.4147 4.00102 11.985 4.00102C18.0578 4.00102 22.99 7.59225 22.99 12.0037H23ZM12.2851 15.2949C11.895 15.685 11.895 16.3152 12.2851 16.7054L13.4957 17.9158C13.0055 17.9758 12.4952 17.9958 11.995 17.9958C7.03274 17.9958 2.99091 15.3049 2.99091 11.9937C2.99091 10.4332 3.90132 8.95271 5.56207 7.82232C6.02228 7.51222 6.13233 6.89201 5.82219 6.43185C5.51205 5.97169 4.89177 5.86166 4.43156 6.17176C2.22055 7.69228 1 9.76299 1 11.9937C1 16.4052 5.93224 19.9965 12.005 19.9965C12.5753 19.9965 13.1355 19.9665 13.6858 19.9064L12.2951 21.2969C11.905 21.6871 11.905 22.3173 12.2951 22.7074C12.4952 22.9075 12.7453 22.9975 13.0055 22.9975C13.2656 22.9975 13.5157 22.8975 13.7158 22.7074L17.4275 18.9961L13.7158 15.2849C13.3256 14.8947 12.6953 14.8947 12.3051 15.2849L12.2851 15.2949Z"></path></svg>';
        /***/ },
        /***/ "./src/images/ChooseFile.svg": /*!***********************************!*\
  !*** ./src/images/ChooseFile.svg ***!
  \***********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 9V7C22 5.9 21.1 5 20 5H12L10 3H4C2.9 3 2 3.9 2 5V9V10V21H22L24 9H22ZM4 5H9.2L10.6 6.4L11.2 7H12H20V9H4V5ZM20.3 19H4V11H21.6L20.3 19Z"></path></svg>';
        /***/ },
        /***/ "./src/images/Clear.svg": /*!******************************!*\
  !*** ./src/images/Clear.svg ***!
  \******************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22.6 8.6L16.4 2.4C16 2 15.5 1.8 15 1.8C14.5 1.8 14 2 13.6 2.4L1.4 14.6C0.600003 15.4 0.600003 16.6 1.4 17.4L6 22H12L22.6 11.4C23.3 10.6 23.3 9.3 22.6 8.6ZM11.1 20H6.8L2.8 16L6.2 12.6L12.4 18.8L11.1 20ZM13.8 17.4L7.6 11.2L15 3.8L21.2 10L13.8 17.4ZM16 20H23V22H14L16 20Z"></path></svg>';
        /***/ },
        /***/ "./src/images/CloseCamera.svg": /*!************************************!*\
  !*** ./src/images/CloseCamera.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M13.41 12L20.7 4.71C21.09 4.32 21.09 3.69 20.7 3.3C20.31 2.91 19.68 2.91 19.29 3.3L12 10.59L4.71 3.29C4.32 2.9 3.68 2.9 3.29 3.29C2.9 3.68 2.9 4.32 3.29 4.71L10.58 12L3.29 19.29C2.9 19.68 2.9 20.31 3.29 20.7C3.49 20.9 3.74 20.99 4 20.99C4.26 20.99 4.51 20.89 4.71 20.7L12 13.41L19.29 20.7C19.49 20.9 19.74 20.99 20 20.99C20.26 20.99 20.51 20.89 20.71 20.7C21.1 20.31 21.1 19.68 20.71 19.29L13.42 12H13.41Z"></path></svg>';
        /***/ },
        /***/ "./src/images/DefaultFile.svg": /*!************************************!*\
  !*** ./src/images/DefaultFile.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 56 68" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_9011_41219)"><path d="M54.83 10.83L45.17 1.17C44.7982 0.798664 44.357 0.504208 43.8714 0.303455C43.3858 0.102703 42.8654 -0.000411943 42.34 1.2368e-06H6C4.4087 1.2368e-06 2.88257 0.632142 1.75735 1.75736C0.632136 2.88258 0 4.4087 0 6V62C0 63.5913 0.632136 65.1174 1.75735 66.2426C2.88257 67.3679 4.4087 68 6 68H50C51.5913 68 53.1174 67.3679 54.2426 66.2426C55.3679 65.1174 56 63.5913 56 62V13.66C56.0004 13.1346 55.8973 12.6142 55.6965 12.1286C55.4958 11.643 55.2013 11.2018 54.83 10.83ZM44 2.83L53.17 12H48C46.9391 12 45.9217 11.5786 45.1716 10.8284C44.4214 10.0783 44 9.06087 44 8V2.83ZM54 62C54 63.0609 53.5786 64.0783 52.8284 64.8284C52.0783 65.5786 51.0609 66 50 66H6C4.93913 66 3.92172 65.5786 3.17157 64.8284C2.42142 64.0783 2 63.0609 2 62V6C2 4.93914 2.42142 3.92172 3.17157 3.17157C3.92172 2.42143 4.93913 2 6 2H42V8C42 9.5913 42.6321 11.1174 43.7574 12.2426C44.8826 13.3679 46.4087 14 48 14H54V62ZM14 24H42V26H14V24ZM14 30H42V32H14V30ZM14 36H42V38H14V36ZM14 42H42V44H14V42Z" fill="#909090"></path></g><defs><clipPath id="clip0_9011_41219"><rect width="56" height="68" fill="white"></rect></clipPath></defs></svg>';
        /***/ },
        /***/ "./src/images/Delete.svg": /*!*******************************!*\
  !*** ./src/images/Delete.svg ***!
  \*******************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M22 4H20H16V2C16 0.9 15.1 0 14 0H10C8.9 0 8 0.9 8 2V4H4H2V6H4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V6H22V4ZM10 2H14V4H10V2ZM18 20H6V6H8H16H18V20ZM14 8H16V18H14V8ZM11 8H13V18H11V8ZM8 8H10V18H8V8Z"></path></svg>';
        /***/ },
        /***/ "./src/images/Down_34x34.svg": /*!***********************************!*\
  !*** ./src/images/Down_34x34.svg ***!
  \***********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 34 34" xml:space="preserve"><g><path class="st0" d="M33,34H0V0h33c0.6,0,1,0.4,1,1v32C34,33.6,33.6,34,33,34z"></path><polygon class="st1" points="12,16 14,14 17,17 20,14 22,16 17,21 "></polygon></g></svg>';
        /***/ },
        /***/ "./src/images/Left.svg": /*!*****************************!*\
  !*** ./src/images/Left.svg ***!
  \*****************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve"><polygon points="11,12 9,14 3,8 9,2 11,4 7,8 "></polygon></svg>';
        /***/ },
        /***/ "./src/images/ModernBooleanCheckChecked.svg": /*!**************************************************!*\
  !*** ./src/images/ModernBooleanCheckChecked.svg ***!
  \**************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><polygon points="19,10 14,10 14,5 10,5 10,10 5,10 5,14 10,14 10,19 14,19 14,14 19,14 "></polygon></svg>';
        /***/ },
        /***/ "./src/images/ModernBooleanCheckInd.svg": /*!**********************************************!*\
  !*** ./src/images/ModernBooleanCheckInd.svg ***!
  \**********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><path d="M22,0H2C0.9,0,0,0.9,0,2v20c0,1.1,0.9,2,2,2h20c1.1,0,2-0.9,2-2V2C24,0.9,23.1,0,22,0z M21,18L6,3h15V18z M3,6l15,15H3V6z"></path></svg>';
        /***/ },
        /***/ "./src/images/ModernBooleanCheckUnchecked.svg": /*!****************************************************!*\
  !*** ./src/images/ModernBooleanCheckUnchecked.svg ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 24 24"><rect x="5" y="10" width="14" height="4"></rect></svg>';
        /***/ },
        /***/ "./src/images/ModernCheck.svg": /*!************************************!*\
  !*** ./src/images/ModernCheck.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24"><path d="M5,13l2-2l3,3l7-7l2,2l-9,9L5,13z"></path></svg>';
        /***/ },
        /***/ "./src/images/ModernRadio.svg": /*!************************************!*\
  !*** ./src/images/ModernRadio.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="-12 -12 24 24"><circle r="6" cx="0" cy="0"></circle></svg>';
        /***/ },
        /***/ "./src/images/More.svg": /*!*****************************!*\
  !*** ./src/images/More.svg ***!
  \*****************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6 12C6 13.1 5.1 14 4 14C2.9 14 2 13.1 2 12C2 10.9 2.9 10 4 10C5.1 10 6 10.9 6 12ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM20 10C18.9 10 18 10.9 18 12C18 13.1 18.9 14 20 14C21.1 14 22 13.1 22 12C22 10.9 21.1 10 20 10Z"></path></svg>';
        /***/ },
        /***/ "./src/images/NavMenu_24x24.svg": /*!**************************************!*\
  !*** ./src/images/NavMenu_24x24.svg ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M16 7H2V5H16V7ZM2 11V13H22V11H2ZM2 19H10V17H2V19Z" fill="black" fill-opacity="0.45"></path></svg>';
        /***/ },
        /***/ "./src/images/ProgressButton.svg": /*!***************************************!*\
  !*** ./src/images/ProgressButton.svg ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 10 10"><polygon points="2,2 0,4 5,9 10,4 8,2 5,5 "></polygon></svg>';
        /***/ },
        /***/ "./src/images/ProgressButtonV2.svg": /*!*****************************************!*\
  !*** ./src/images/ProgressButtonV2.svg ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16"><path d="M15 8.99999H4.39998L8.69998 13.3L7.29998 14.7L0.599976 7.99999L7.29998 1.29999L8.69998 2.69999L4.39998 6.99999H15V8.99999Z"></path></svg>';
        /***/ },
        /***/ "./src/images/RemoveFile.svg": /*!***********************************!*\
  !*** ./src/images/RemoveFile.svg ***!
  \***********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16"><path d="M8,2C4.7,2,2,4.7,2,8s2.7,6,6,6s6-2.7,6-6S11.3,2,8,2z M11,10l-1,1L8,9l-2,2l-1-1l2-2L5,6l1-1l2,2l2-2l1,1L9,8 L11,10z"></path></svg>';
        /***/ },
        /***/ "./src/images/Right.svg": /*!******************************!*\
  !*** ./src/images/Right.svg ***!
  \******************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 16 16" xml:space="preserve"><polygon points="5,4 7,2 13,8 7,14 5,12 9,8 "></polygon></svg>';
        /***/ },
        /***/ "./src/images/SearchClear.svg": /*!************************************!*\
  !*** ./src/images/SearchClear.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.35 3.34999L12.65 2.64999L8.05002 7.24999L3.35002 2.64999L2.65002 3.34999L7.25002 8.04999L2.65002 12.65L3.35002 13.35L8.05002 8.74999L12.65 13.35L13.35 12.65L8.75002 8.04999L13.35 3.34999Z"></path></svg>';
        /***/ },
        /***/ "./src/images/ShowCamera.svg": /*!***********************************!*\
  !*** ./src/images/ShowCamera.svg ***!
  \***********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.01 4H18.4C18.2 4 18.01 3.9 17.9 3.73L16.97 2.34C16.41 1.5 15.48 1 14.47 1H9.54C8.53 1 7.6 1.5 7.04 2.34L6.11 3.73C6 3.9 5.81 4 5.61 4H4C2.35 4 1 5.35 1 7V19C1 20.65 2.35 22 4 22H20C21.65 22 23 20.65 23 19V7C23 5.35 21.65 4 20 4H20.01ZM21.01 19C21.01 19.55 20.56 20 20.01 20H4.01C3.46 20 3.01 19.55 3.01 19V7C3.01 6.45 3.46 6 4.01 6H5.62C6.49 6 7.3 5.56 7.79 4.84L8.72 3.45C8.91 3.17 9.22 3 9.55 3H14.48C14.81 3 15.13 3.17 15.31 3.45L16.24 4.84C16.72 5.56 17.54 6 18.41 6H20.02C20.57 6 21.02 6.45 21.02 7V19H21.01ZM12.01 6C8.7 6 6.01 8.69 6.01 12C6.01 15.31 8.7 18 12.01 18C15.32 18 18.01 15.31 18.01 12C18.01 8.69 15.32 6 12.01 6ZM12.01 16C9.8 16 8.01 14.21 8.01 12C8.01 9.79 9.8 8 12.01 8C14.22 8 16.01 9.79 16.01 12C16.01 14.21 14.22 16 12.01 16ZM13.01 10C13.01 10.55 12.56 11 12.01 11C11.46 11 11.01 11.45 11.01 12C11.01 12.55 10.56 13 10.01 13C9.46 13 9.01 12.55 9.01 12C9.01 10.35 10.36 9 12.01 9C12.56 9 13.01 9.45 13.01 10Z" fill="black" fill-opacity="0.45"></path></svg>';
        /***/ },
        /***/ "./src/images/TakePicture.svg": /*!************************************!*\
  !*** ./src/images/TakePicture.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg"><path d="M27 6H23.8C23.34 6 22.92 5.77 22.66 5.39L22.25 4.78C21.51 3.66 20.26 3 18.92 3H13.06C11.72 3 10.48 3.67 9.73 4.78L9.32 5.39C9.07 5.77 8.64 6 8.18 6H4.98C2.79 6 1 7.79 1 10V24C1 26.21 2.79 28 5 28H27C29.21 28 31 26.21 31 24V10C31 7.79 29.21 6 27 6ZM29 24C29 25.1 28.1 26 27 26H5C3.9 26 3 25.1 3 24V10C3 8.9 3.9 8 5 8H8.2C9.33 8 10.38 7.44 11 6.5L11.41 5.89C11.78 5.33 12.41 5 13.07 5H18.93C19.6 5 20.22 5.33 20.59 5.89L21 6.5C21.62 7.44 22.68 8 23.8 8H27C28.1 8 29 8.9 29 10V24ZM16 9C12.13 9 9 12.13 9 16C9 19.87 12.13 23 16 23C19.87 23 23 19.87 23 16C23 12.13 19.87 9 16 9ZM16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21ZM17 13C17 13.55 16.55 14 16 14C14.9 14 14 14.9 14 16C14 16.55 13.55 17 13 17C12.45 17 12 16.55 12 16C12 13.79 13.79 12 16 12C16.55 12 17 12.45 17 13Z"></path></svg>';
        /***/ },
        /***/ "./src/images/TakePicture_24x24.svg": /*!******************************************!*\
  !*** ./src/images/TakePicture_24x24.svg ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M20.01 4H18.4C18.2 4 18.01 3.9 17.9 3.73L16.97 2.34C16.41 1.5 15.48 1 14.47 1H9.54C8.53 1 7.6 1.5 7.04 2.34L6.11 3.73C6 3.9 5.81 4 5.61 4H4C2.35 4 1 5.35 1 7V19C1 20.65 2.35 22 4 22H20C21.65 22 23 20.65 23 19V7C23 5.35 21.65 4 20 4H20.01ZM21.01 19C21.01 19.55 20.56 20 20.01 20H4.01C3.46 20 3.01 19.55 3.01 19V7C3.01 6.45 3.46 6 4.01 6H5.62C6.49 6 7.3 5.56 7.79 4.84L8.72 3.45C8.91 3.17 9.22 3 9.55 3H14.48C14.81 3 15.13 3.17 15.31 3.45L16.24 4.84C16.72 5.56 17.54 6 18.41 6H20.02C20.57 6 21.02 6.45 21.02 7V19H21.01ZM12.01 6C8.7 6 6.01 8.69 6.01 12C6.01 15.31 8.7 18 12.01 18C15.32 18 18.01 15.31 18.01 12C18.01 8.69 15.32 6 12.01 6ZM12.01 16C9.8 16 8.01 14.21 8.01 12C8.01 9.79 9.8 8 12.01 8C14.22 8 16.01 9.79 16.01 12C16.01 14.21 14.22 16 12.01 16ZM13.01 10C13.01 10.55 12.56 11 12.01 11C11.46 11 11.01 11.45 11.01 12C11.01 12.55 10.56 13 10.01 13C9.46 13 9.01 12.55 9.01 12C9.01 10.35 10.36 9 12.01 9C12.56 9 13.01 9.45 13.01 10Z"></path></svg>';
        /***/ },
        /***/ "./src/images/TimerCircle.svg": /*!************************************!*\
  !*** ./src/images/TimerCircle.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 160 160"><circle cx="80" cy="80" r="70" style="stroke: var(--sd-timer-stroke-background-color); stroke-width: var(--sd-timer-stroke-background-width)" stroke-dasharray="none" stroke-dashoffset="none"></circle><circle cx="80" cy="80" r="70"></circle></svg>';
        /***/ },
        /***/ "./src/images/V2Check.svg": /*!********************************!*\
  !*** ./src/images/V2Check.svg ***!
  \********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M8.00001 15.8L2.60001 10.4L4.00001 9L8.00001 13L16 5L17.4 6.4L8.00001 15.8Z"></path></svg>';
        /***/ },
        /***/ "./src/images/V2Check_24x24.svg": /*!**************************************!*\
  !*** ./src/images/V2Check_24x24.svg ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M9 20.1L1 12L3.1 9.9L9 15.9L20.9 4L23 6.1L9 20.1Z"></path></svg>';
        /***/ },
        /***/ "./src/images/V2DragElement_16x16.svg": /*!********************************************!*\
  !*** ./src/images/V2DragElement_16x16.svg ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M2 4C2 3.73478 2.10536 3.48043 2.29289 3.29289C2.48043 3.10536 2.73478 3 3 3H13C13.2652 3 13.5196 3.10536 13.7071 3.29289C13.8946 3.48043 14 3.73478 14 4C14 4.26522 13.8946 4.51957 13.7071 4.70711C13.5196 4.89464 13.2652 5 13 5H3C2.73478 5 2.48043 4.89464 2.29289 4.70711C2.10536 4.51957 2 4.26522 2 4ZM13 7H3C2.73478 7 2.48043 7.10536 2.29289 7.29289C2.10536 7.48043 2 7.73478 2 8C2 8.26522 2.10536 8.51957 2.29289 8.70711C2.48043 8.89464 2.73478 9 3 9H13C13.2652 9 13.5196 8.89464 13.7071 8.70711C13.8946 8.51957 14 8.26522 14 8C14 7.73478 13.8946 7.48043 13.7071 7.29289C13.5196 7.10536 13.2652 7 13 7ZM13 11H3C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H13C13.2652 13 13.5196 12.8946 13.7071 12.7071C13.8946 12.5196 14 12.2652 14 12C14 11.7348 13.8946 11.4804 13.7071 11.2929C13.5196 11.1054 13.2652 11 13 11Z"></path></svg>';
        /***/ },
        /***/ "./src/images/back-to-panel_16x16.svg": /*!********************************************!*\
  !*** ./src/images/back-to-panel_16x16.svg ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M15.0001 6C15.0001 6.55 14.5501 7 14.0001 7H10.0001C9.45006 7 9.00006 6.55 9.00006 6V2C9.00006 1.45 9.45006 1 10.0001 1C10.5501 1 11.0001 1.45 11.0001 2V3.59L13.2901 1.29C13.4901 1.09 13.7401 1 14.0001 1C14.2601 1 14.5101 1.1 14.7101 1.29C15.1001 1.68 15.1001 2.31 14.7101 2.7L12.4201 4.99H14.0101C14.5601 4.99 15.0101 5.44 15.0101 5.99L15.0001 6ZM6.00006 9H2.00006C1.45006 9 1.00006 9.45 1.00006 10C1.00006 10.55 1.45006 11 2.00006 11H3.59006L1.29006 13.29C0.900059 13.68 0.900059 14.31 1.29006 14.7C1.68006 15.09 2.31006 15.09 2.70006 14.7L4.99006 12.41V14C4.99006 14.55 5.44006 15 5.99006 15C6.54006 15 6.99006 14.55 6.99006 14V10C6.99006 9.45 6.54006 9 5.99006 9H6.00006Z"></path></svg>';
        /***/ },
        /***/ "./src/images/chevron.svg": /*!********************************!*\
  !*** ./src/images/chevron.svg ***!
  \********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 15L17 10H7L12 15Z"></path></svg>';
        /***/ },
        /***/ "./src/images/clear_16x16.svg": /*!************************************!*\
  !*** ./src/images/clear_16x16.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13.35 3.34999L12.65 2.64999L8.05002 7.24999L3.35002 2.64999L2.65002 3.34999L7.25002 8.04999L2.65002 12.65L3.35002 13.35L8.05002 8.74999L12.65 13.35L13.35 12.65L8.75002 8.04999L13.35 3.34999Z"></path></svg>';
        /***/ },
        /***/ "./src/images/close_16x16.svg": /*!************************************!*\
  !*** ./src/images/close_16x16.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M9.43 8.0025L13.7 3.7225C14.09 3.3325 14.09 2.6925 13.7 2.2925C13.31 1.9025 12.67 1.9025 12.27 2.2925L7.99 6.5725L3.72 2.3025C3.33 1.9025 2.69 1.9025 2.3 2.3025C1.9 2.6925 1.9 3.3325 2.3 3.7225L6.58 8.0025L2.3 12.2825C1.91 12.6725 1.91 13.3125 2.3 13.7125C2.69 14.1025 3.33 14.1025 3.73 13.7125L8.01 9.4325L12.29 13.7125C12.68 14.1025 13.32 14.1025 13.72 13.7125C14.11 13.3225 14.11 12.6825 13.72 12.2825L9.44 8.0025H9.43Z"></path></svg>';
        /***/ },
        /***/ "./src/images/collapseDetail.svg": /*!***************************************!*\
  !*** ./src/images/collapseDetail.svg ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 7H3V9H13V7Z"></path></svg>';
        /***/ },
        /***/ "./src/images/drag-n-drop.svg": /*!************************************!*\
  !*** ./src/images/drag-n-drop.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 10 16" xmlns="http://www.w3.org/2000/svg"><path d="M6 2C6 0.9 6.9 0 8 0C9.1 0 10 0.9 10 2C10 3.1 9.1 4 8 4C6.9 4 6 3.1 6 2ZM2 0C0.9 0 0 0.9 0 2C0 3.1 0.9 4 2 4C3.1 4 4 3.1 4 2C4 0.9 3.1 0 2 0ZM8 6C6.9 6 6 6.9 6 8C6 9.1 6.9 10 8 10C9.1 10 10 9.1 10 8C10 6.9 9.1 6 8 6ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6ZM8 12C6.9 12 6 12.9 6 14C6 15.1 6.9 16 8 16C9.1 16 10 15.1 10 14C10 12.9 9.1 12 8 12ZM2 12C0.9 12 0 12.9 0 14C0 15.1 0.9 16 2 16C3.1 16 4 15.1 4 14C4 12.9 3.1 12 2 12Z"></path></svg>';
        /***/ },
        /***/ "./src/images/expandDetail.svg": /*!*************************************!*\
  !*** ./src/images/expandDetail.svg ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 7H9V3H7V7H3V9H7V13H9V9H13V7Z"></path></svg>';
        /***/ },
        /***/ "./src/images/full-screen_16x16.svg": /*!******************************************!*\
  !*** ./src/images/full-screen_16x16.svg ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M6.71 10.71L4.42 13H6.01C6.56 13 7.01 13.45 7.01 14C7.01 14.55 6.56 15 6.01 15H2C1.45 15 1 14.55 1 14V10C1 9.45 1.45 9 2 9C2.55 9 3 9.45 3 10V11.59L5.29 9.3C5.68 8.91 6.31 8.91 6.7 9.3C7.09 9.69 7.09 10.32 6.7 10.71H6.71ZM14 1H10C9.45 1 9 1.45 9 2C9 2.55 9.45 3 10 3H11.59L9.3 5.29C8.91 5.68 8.91 6.31 9.3 6.7C9.5 6.9 9.75 6.99 10.01 6.99C10.27 6.99 10.52 6.89 10.72 6.7L13.01 4.41V6C13.01 6.55 13.46 7 14.01 7C14.56 7 15.01 6.55 15.01 6V2C15.01 1.45 14.56 1 14.01 1H14Z"></path></svg>';
        /***/ },
        /***/ "./src/images/loading.svg": /*!********************************!*\
  !*** ./src/images/loading.svg ***!
  \********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_885_24957)"><path opacity="0.1" d="M24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40ZM24 12C17.38 12 12 17.38 12 24C12 30.62 17.38 36 24 36C30.62 36 36 30.62 36 24C36 17.38 30.62 12 24 12Z" fill="black" fill-opacity="0.91"></path><path d="M10 26C8.9 26 8 25.1 8 24C8 15.18 15.18 8 24 8C25.1 8 26 8.9 26 10C26 11.1 25.1 12 24 12C17.38 12 12 17.38 12 24C12 25.1 11.1 26 10 26Z" fill="#19B394"></path></g><defs><clipPath id="clip0_885_24957"><rect width="32" height="32" fill="white" transform="translate(8 8)"></rect></clipPath></defs></svg>';
        /***/ },
        /***/ "./src/images/minimize_16x16.svg": /*!***************************************!*\
  !*** ./src/images/minimize_16x16.svg ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M13 9H3C2.45 9 2 8.55 2 8C2 7.45 2.45 7 3 7H13C13.55 7 14 7.45 14 8C14 8.55 13.55 9 13 9Z"></path></svg>';
        /***/ },
        /***/ "./src/images/no-image.svg": /*!*********************************!*\
  !*** ./src/images/no-image.svg ***!
  \*********************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 48 48"><g opacity="0.5"><path d="M14 17.01C14 16.4167 14.1759 15.8366 14.5056 15.3433C14.8352 14.8499 15.3038 14.4654 15.8519 14.2384C16.4001 14.0113 17.0033 13.9519 17.5853 14.0676C18.1672 14.1834 18.7018 14.4691 19.1213 14.8887C19.5409 15.3082 19.8266 15.8428 19.9424 16.4247C20.0581 17.0067 19.9987 17.6099 19.7716 18.1581C19.5446 18.7062 19.1601 19.1748 18.6667 19.5044C18.1734 19.8341 17.5933 20.01 17 20.01C16.2044 20.01 15.4413 19.6939 14.8787 19.1313C14.3161 18.5687 14 17.8056 14 17.01ZM27.09 24.14L20 36.01H36L27.09 24.14ZM36.72 8.14L35.57 10.01H36C36.5304 10.01 37.0391 10.2207 37.4142 10.5958C37.7893 10.9709 38 11.4796 38 12.01V36.01C38 36.5404 37.7893 37.0491 37.4142 37.4242C37.0391 37.7993 36.5304 38.01 36 38.01H18.77L17.57 40.01H36C37.0609 40.01 38.0783 39.5886 38.8284 38.8384C39.5786 38.0883 40 37.0709 40 36.01V12.01C39.9966 11.0765 39.6668 10.1737 39.0678 9.45778C38.4688 8.74188 37.6382 8.25802 36.72 8.09V8.14ZM36.86 4.5L12.86 44.5L11.14 43.5L13.23 40.01H12C10.9391 40.01 9.92172 39.5886 9.17157 38.8384C8.42143 38.0883 8 37.0709 8 36.01V12.01C8 10.9491 8.42143 9.93172 9.17157 9.18157C9.92172 8.43143 10.9391 8.01 12 8.01H32.43L35.14 3.5L36.86 4.5ZM14.43 38.01L15.63 36.01H12L19 27.01L20.56 27.8L31.23 10.01H12C11.4696 10.01 10.9609 10.2207 10.5858 10.5958C10.2107 10.9709 10 11.4796 10 12.01V36.01C10 36.5404 10.2107 37.0491 10.5858 37.4242C10.9609 37.7993 11.4696 38.01 12 38.01H14.43Z"></path></g></svg>';
        /***/ },
        /***/ "./src/images/ranking-arrows.svg": /*!***************************************!*\
  !*** ./src/images/ranking-arrows.svg ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 10 24" xmlns="http://www.w3.org/2000/svg"><path d="M10 5L5 0L0 5H4V9H6V5H10Z"></path><path d="M6 19V15H4V19H0L5 24L10 19H6Z"></path></svg>';
        /***/ },
        /***/ "./src/images/ranking-dash.svg": /*!*************************************!*\
  !*** ./src/images/ranking-dash.svg ***!
  \*************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><path d="M13 7H3V9H13V7Z"></path></svg>';
        /***/ },
        /***/ "./src/images/rating-star-2.svg": /*!**************************************!*\
  !*** ./src/images/rating-star-2.svg ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g><path d="M24 39.5057L11.7226 45.9839C10.4095 46.6739 8.87606 45.5622 9.12525 44.096L11.4734 30.373L1.54411 20.6556C0.480254 19.6207 1.06489 17.8095 2.53128 17.5986L16.2559 15.5957L22.3994 3.10891C23.0512 1.77685 24.9488 1.77685 25.6102 3.10891L31.7441 15.5957L45.4687 17.5986C46.9351 17.8095 47.5197 19.6207 46.4559 20.6556L36.5266 30.373L38.8748 44.096C39.1239 45.5622 37.5905 46.6835 36.2774 45.9839L24 39.5057Z" fill="none" stroke-width="2"></path><path d="M24.4663 34.6154L24 34.3695L23.5336 34.6154L14.4788 39.389L16.2156 29.2691L16.3044 28.7517L15.9289 28.3848L8.57358 21.1966L18.7249 19.7094L19.245 19.6332L19.4772 19.1616L24 9.97413L28.5228 19.1616L28.755 19.6332L29.275 19.7094L39.4264 21.1966L32.0711 28.3848L31.6956 28.7517L31.7844 29.2691L33.5211 39.389L24.4663 34.6154Z" stroke-width="2"></path></g></svg>';
        /***/ },
        /***/ "./src/images/rating-star-small-2.svg": /*!********************************************!*\
  !*** ./src/images/rating-star-small-2.svg ***!
  \********************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12 19.3373L6.13001 22.4373C5.50001 22.7673 4.77001 22.2373 4.89001 21.5373L6.01001 14.9773L1.26001 10.3273C0.750007 9.83728 1.03001 8.96728 1.73001 8.86728L8.29001 7.90728L11.23 1.93728C11.54 1.29728 12.45 1.29728 12.77 1.93728L15.7 7.90728L22.26 8.86728C22.96 8.96728 23.24 9.83728 22.73 10.3273L17.98 14.9773L19.1 21.5373C19.22 22.2373 18.49 22.7773 17.86 22.4373L11.99 19.3373H12Z" fill="none" stroke-width="2"></path><path d="M12 15.9472L8.58001 17.7572L9.23001 13.9272L6.45001 11.2072L10.29 10.6472L12 7.17725L13.71 10.6472L17.55 11.2072L14.77 13.9272L15.42 17.7572L12 15.9472Z"></path></svg>';
        /***/ },
        /***/ "./src/images/rating-star-small.svg": /*!******************************************!*\
  !*** ./src/images/rating-star-small.svg ***!
  \******************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g><path d="M12 19.3373L6.13001 22.4373C5.50001 22.7673 4.77001 22.2373 4.89001 21.5373L6.01001 14.9773L1.26001 10.3273C0.750007 9.83728 1.03001 8.96728 1.73001 8.86728L8.29001 7.90728L11.23 1.93728C11.54 1.29728 12.45 1.29728 12.77 1.93728L15.7 7.90728L22.26 8.86728C22.96 8.96728 23.24 9.83728 22.73 10.3273L17.98 14.9773L19.1 21.5373C19.22 22.2373 18.49 22.7773 17.86 22.4373L11.99 19.3373H12Z" stroke-width="2"></path></g></svg>';
        /***/ },
        /***/ "./src/images/rating-star.svg": /*!************************************!*\
  !*** ./src/images/rating-star.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg"><g><path d="M24 39.5057L11.7226 45.9839C10.4095 46.6739 8.87606 45.5622 9.12525 44.096L11.4734 30.373L1.54411 20.6556C0.480254 19.6207 1.06489 17.8095 2.53128 17.5986L16.2559 15.5957L22.3994 3.10891C23.0512 1.77685 24.9488 1.77685 25.6102 3.10891L31.7441 15.5957L45.4687 17.5986C46.9351 17.8095 47.5197 19.6207 46.4559 20.6556L36.5266 30.373L38.8748 44.096C39.1239 45.5622 37.5905 46.6835 36.2774 45.9839L24 39.5057Z" stroke-width="2"></path></g></svg>';
        /***/ },
        /***/ "./src/images/restore_16x16.svg": /*!**************************************!*\
  !*** ./src/images/restore_16x16.svg ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg"><path d="M12 13H4C2.9 13 2 12.1 2 11V5C2 3.9 2.9 3 4 3H12C13.1 3 14 3.9 14 5V11C14 12.1 13.1 13 12 13ZM4 5V11H12V5H4Z"></path></svg>';
        /***/ },
        /***/ "./src/images/search.svg": /*!*******************************!*\
  !*** ./src/images/search.svg ***!
  \*******************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M14 2C9.6 2 6 5.6 6 10C6 11.8 6.6 13.5 7.7 14.9L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.5 21.9 2.7 22 3 22C3.3 22 3.5 21.9 3.7 21.7L9.1 16.3C10.5 17.4 12.2 18 14 18C18.4 18 22 14.4 22 10C22 5.6 18.4 2 14 2ZM14 16C10.7 16 8 13.3 8 10C8 6.7 10.7 4 14 4C17.3 4 20 6.7 20 10C20 13.3 17.3 16 14 16Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley sync \\.svg$": /*!****************************************************!*\
  !*** ./src/images/smiley sync nonrecursive \.svg$ ***!
  \****************************************************/ /*! no static exports found */ /***/ function(module1, exports, __webpack_require__) {
            var map = {
                "./average.svg": "./src/images/smiley/average.svg",
                "./excellent.svg": "./src/images/smiley/excellent.svg",
                "./good.svg": "./src/images/smiley/good.svg",
                "./normal.svg": "./src/images/smiley/normal.svg",
                "./not-good.svg": "./src/images/smiley/not-good.svg",
                "./perfect.svg": "./src/images/smiley/perfect.svg",
                "./poor.svg": "./src/images/smiley/poor.svg",
                "./terrible.svg": "./src/images/smiley/terrible.svg",
                "./very-good.svg": "./src/images/smiley/very-good.svg",
                "./very-poor.svg": "./src/images/smiley/very-poor.svg"
            };
            function webpackContext(req) {
                var id = webpackContextResolve(req);
                return __webpack_require__(id);
            }
            function webpackContextResolve(req) {
                if (!__webpack_require__.o(map, req)) {
                    var e = new Error("Cannot find module '" + req + "'");
                    e.code = "MODULE_NOT_FOUND";
                    throw e;
                }
                return map[req];
            }
            webpackContext.keys = function webpackContextKeys() {
                return Object.keys(map);
            };
            webpackContext.resolve = webpackContextResolve;
            module1.exports = webpackContext;
            webpackContext.id = "./src/images/smiley sync \\.svg$";
        /***/ },
        /***/ "./src/images/smiley/average.svg": /*!***************************************!*\
  !*** ./src/images/smiley/average.svg ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.00572 7C6.45572 7 6.00572 6.55 6.00572 6V2C6.00572 1.45 6.45572 1 7.00572 1C7.55572 1 8.00572 1.45 8.00572 2V6C8.00572 6.55 7.55572 7 7.00572 7ZM18.0057 6V2C18.0057 1.45 17.5557 1 17.0057 1C16.4557 1 16.0057 1.45 16.0057 2V6C16.0057 6.55 16.4557 7 17.0057 7C17.5557 7 18.0057 6.55 18.0057 6ZM19.9457 21.33C20.1257 20.81 19.8557 20.24 19.3357 20.05C14.5457 18.35 9.45572 18.35 4.66572 20.05C4.14572 20.23 3.87572 20.81 4.05572 21.33C4.23572 21.85 4.80572 22.12 5.33572 21.94C9.69572 20.4 14.3057 20.4 18.6657 21.94C18.7757 21.98 18.8857 22 18.9957 22C19.4057 22 19.7957 21.74 19.9357 21.33H19.9457Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/excellent.svg": /*!*****************************************!*\
  !*** ./src/images/smiley/excellent.svg ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 24C6.85767 24 1.15509 20.96 0.0145752 14.16C-0.0354475 13.87 0.0445888 13.57 0.234675 13.35C0.424761 13.13 0.704888 13 0.995019 13H23.005C23.2951 13 23.5752 13.13 23.7653 13.35C23.9554 13.57 24.0354 13.87 23.9854 14.16C22.8549 20.95 17.1423 24 11.99 24H12.01ZM2.25559 15C3.61621 19.82 8.0182 22 12.01 22C16.0018 22 20.4038 19.82 21.7644 15H2.25559ZM8.00819 6V2C8.00819 1.45 7.55799 1 7.00774 1C6.45749 1 6.00729 1.45 6.00729 2V6C6.00729 6.55 6.45749 7 7.00774 7C7.55799 7 8.00819 6.55 8.00819 6ZM18.0127 6V2C18.0127 1.45 17.5625 1 17.0123 1C16.462 1 16.0118 1.45 16.0118 2V6C16.0118 6.55 16.462 7 17.0123 7C17.5625 7 18.0127 6.55 18.0127 6Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/good.svg": /*!************************************!*\
  !*** ./src/images/smiley/good.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.0022 23.99C11.452 23.99 11.0018 23.5402 11.0018 22.9904C11.0018 22.4407 11.452 21.9909 12.0022 21.9909C16.3137 21.9909 21.0755 19.472 22.0158 13.8344C22.1058 13.2947 22.616 12.9248 23.1662 13.0148C23.7064 13.1047 24.0765 13.6245 23.9865 14.1643C22.8561 20.9513 17.144 24 11.9922 24L12.0022 23.99ZM8.00072 5.99783V1.99957C8.00072 1.4498 7.55056 1 7.00036 1C6.45016 1 6 1.4498 6 1.99957V5.99783C6 6.54759 6.45016 6.99739 7.00036 6.99739C7.55056 6.99739 8.00072 6.54759 8.00072 5.99783ZM18.0043 5.99783V1.99957C18.0043 1.4498 17.5542 1 17.004 1C16.4538 1 16.0036 1.4498 16.0036 1.99957V5.99783C16.0036 6.54759 16.4538 6.99739 17.004 6.99739C17.5542 6.99739 18.0043 6.54759 18.0043 5.99783Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/normal.svg": /*!**************************************!*\
  !*** ./src/images/smiley/normal.svg ***!
  \**************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7 7C6.45 7 6 6.55 6 6V2C6 1.45 6.45 1 7 1C7.55 1 8 1.45 8 2V6C8 6.55 7.55 7 7 7ZM18 6V2C18 1.45 17.55 1 17 1C16.45 1 16 1.45 16 2V6C16 6.55 16.45 7 17 7C17.55 7 18 6.55 18 6ZM21 21C21 20.45 20.55 20 20 20H4C3.45 20 3 20.45 3 21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/not-good.svg": /*!****************************************!*\
  !*** ./src/images/smiley/not-good.svg ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.06927 7C6.51927 7 6.06927 6.55 6.06927 6V2C6.06927 1.45 6.51927 1 7.06927 1C7.61927 1 8.06927 1.45 8.06927 2V6C8.06927 6.55 7.61927 7 7.06927 7ZM18.0693 6V2C18.0693 1.45 17.6193 1 17.0693 1C16.5193 1 16.0693 1.45 16.0693 2V6C16.0693 6.55 16.5193 7 17.0693 7C17.6193 7 18.0693 6.55 18.0693 6ZM22.5693 21.9C23.0693 21.66 23.2793 21.07 23.0393 20.57C21.1093 16.52 16.9093 14 12.0693 14C7.22927 14 3.02927 16.52 1.09927 20.57C0.859273 21.07 1.06927 21.67 1.56927 21.9C2.06927 22.14 2.65927 21.93 2.89927 21.43C4.49927 18.08 8.00927 16 12.0593 16C16.1093 16 19.6293 18.08 21.2193 21.43C21.3893 21.79 21.7493 22 22.1193 22C22.2593 22 22.4093 21.97 22.5493 21.9H22.5693Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/perfect.svg": /*!***************************************!*\
  !*** ./src/images/smiley/perfect.svg ***!
  \***************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 23C6.85721 23 1.15412 19.9621 0.0134987 13.1669C-0.0765501 12.6272 0.293651 12.1076 0.833944 12.0177C1.38424 11.9277 1.89452 12.2975 1.98457 12.8371C2.92508 18.4732 7.69767 20.9914 12 20.9914C16.3023 20.9914 21.0749 18.4732 22.0154 12.8371C22.1055 12.2975 22.6158 11.9277 23.1661 12.0177C23.7063 12.1076 24.0765 12.6272 23.9865 13.1669C22.8559 19.9521 17.1428 23 11.99 23H12.01ZM21.165 6.15177C22.3056 5.01257 22.3056 3.16386 21.165 2.02465L21.0049 1.85477C19.9143 0.765533 18.1633 0.725561 17.0227 1.71487C15.8821 0.715568 14.1312 0.765533 13.0406 1.85477L12.8705 2.01466C11.7299 3.15386 11.7299 5.00257 12.8705 6.14178L17.0227 10.2889L21.175 6.14178L21.165 6.15177ZM15.742 3.27378L17.0127 4.54289L18.2834 3.27378C18.6436 2.91403 19.2239 2.91403 19.5841 3.27378L19.7442 3.43367C20.1044 3.79342 20.1044 4.37301 19.7442 4.73276L17.0127 7.46086L14.2812 4.73276C13.921 4.37301 13.921 3.79342 14.2812 3.43367L14.4413 3.27378C14.6214 3.09391 14.8515 3.00397 15.0917 3.00397C15.3318 3.00397 15.5619 3.09391 15.742 3.27378ZM11.1595 6.15177C12.3002 5.01257 12.3002 3.16386 11.1595 2.02465L10.9995 1.85477C9.90886 0.765533 8.15792 0.725561 7.0173 1.71487C5.87668 0.715568 4.12573 0.765533 3.03514 1.85477L2.86505 2.01466C1.72443 3.15386 1.72443 5.00257 2.86505 6.14178L7.0173 10.2889L11.1695 6.14178L11.1595 6.15177ZM5.7366 3.27378L7.00729 4.54289L8.27798 3.27378C8.63818 2.91403 9.21849 2.91403 9.57869 3.27378L9.73877 3.43367C10.099 3.79342 10.099 4.37301 9.73877 4.73276L7.00729 7.46086L4.27581 4.73276C3.91562 4.37301 3.91562 3.79342 4.27581 3.43367L4.4359 3.27378C4.61599 3.09391 4.84612 3.00397 5.08625 3.00397C5.32638 3.00397 5.5565 3.09391 5.7366 3.27378Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/poor.svg": /*!************************************!*\
  !*** ./src/images/smiley/poor.svg ***!
  \************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M7.01915 7C6.46961 7 6.01998 6.55 6.01998 6V2C6.01998 1.45 6.46961 1 7.01915 1C7.56869 1 8.01832 1.45 8.01832 2V6C8.01832 6.55 7.56869 7 7.01915 7ZM18.01 6V2C18.01 1.45 17.5604 1 17.0108 1C16.4613 1 16.0117 1.45 16.0117 2V6C16.0117 6.55 16.4613 7 17.0108 7C17.5604 7 18.01 6.55 18.01 6ZM16.4213 21.58L18.01 19.99L19.2989 21.28C19.6886 21.67 20.3181 21.67 20.7077 21.28C21.0974 20.89 21.0974 20.26 20.7077 19.87L19.4188 18.58C18.6395 17.8 17.3705 17.8 16.5912 18.58L15.0025 20.17L13.4138 18.58C12.6345 17.8 11.3655 17.8 10.5862 18.58L8.9975 20.17L7.40883 18.58C6.62948 17.8 5.36053 17.8 4.58118 18.58L3.29226 19.87C2.90258 20.26 2.90258 20.89 3.29226 21.28C3.68193 21.67 4.31141 21.67 4.70108 21.28L5.99001 19.99L7.57868 21.58C8.35803 22.36 9.62698 22.36 10.4063 21.58L11.995 19.99L13.5837 21.58C13.9734 21.97 14.4829 22.16 14.9925 22.16C15.5021 22.16 16.0117 21.97 16.4013 21.58H16.4213Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/terrible.svg": /*!****************************************!*\
  !*** ./src/images/smiley/terrible.svg ***!
  \****************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M4 4.9938C4 4.44362 4.45 3.99348 5 3.99348H6.59L5.3 2.70306C4.91 2.31293 4.91 1.68272 5.3 1.2926C5.69 0.902468 6.32 0.902468 6.71 1.2926L9.71 4.29357C9.8 4.3836 9.88 4.49364 9.93 4.62368C10.03 4.86376 10.03 5.14385 9.93 5.38393C9.88 5.50397 9.81 5.614 9.71 5.71404L6.71 8.71501C6.51 8.91508 6.26 9.00511 6 9.00511C5.74 9.00511 5.49 8.90508 5.29 8.71501C4.9 8.32489 4.9 7.69468 5.29 7.30456L6.58 6.01413H4.99C4.44 6.01413 3.99 5.56399 3.99 5.01381L4 4.9938ZM14.08 5.37393C14.13 5.49397 14.2 5.604 14.3 5.70403L17.3 8.70501C17.5 8.90508 17.75 8.99511 18.01 8.99511C18.27 8.99511 18.52 8.89507 18.72 8.70501C19.11 8.31488 19.11 7.68468 18.72 7.29455L17.43 6.00413H19.02C19.57 6.00413 20.02 5.55399 20.02 5.00381C20.02 4.45363 19.57 4.00348 19.02 4.00348H17.43L18.72 2.71306C19.11 2.32293 19.11 1.69273 18.72 1.3026C18.33 0.912471 17.7 0.912471 17.31 1.3026L14.31 4.30358C14.22 4.39361 14.14 4.50364 14.09 4.63368C13.99 4.87376 13.99 5.15385 14.09 5.39393L14.08 5.37393ZM22 14.9971V20.999C22 22.6496 20.65 24 19 24H5C3.35 24 2 22.6496 2 20.999V14.9971C2 13.3465 3.35 11.9961 5 11.9961H19C20.65 11.9961 22 13.3465 22 14.9971ZM19 13.9967H16V16.9977H20V14.9971C20 14.4469 19.55 13.9967 19 13.9967ZM14 16.9977V13.9967H10V16.9977H14ZM10 18.9984V21.9993H14V18.9984H10ZM4 14.9971V16.9977H8V13.9967H5C4.45 13.9967 4 14.4469 4 14.9971ZM5 21.9993H8V18.9984H4V20.999C4 21.5492 4.45 21.9993 5 21.9993ZM20 20.999V18.9984H16V21.9993H19C19.55 21.9993 20 21.5492 20 20.999Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/very-good.svg": /*!*****************************************!*\
  !*** ./src/images/smiley/very-good.svg ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.01 24C6.85721 24 1.15412 20.96 0.0134987 14.16C-0.0765501 13.62 0.293651 13.1 0.833944 13.01C1.38424 12.92 1.89452 13.29 1.98457 13.83C2.92508 19.47 7.69767 21.99 12 21.99C16.3023 21.99 21.0749 19.47 22.0154 13.83C22.1055 13.29 22.6158 12.92 23.1661 13.01C23.7063 13.1 24.0765 13.62 23.9865 14.16C22.8559 20.95 17.1428 24 11.99 24H12.01ZM8.00783 6V2C8.00783 1.45 7.55759 1 7.00729 1C6.45699 1 6.00675 1.45 6.00675 2V6C6.00675 6.55 6.45699 7 7.00729 7C7.55759 7 8.00783 6.55 8.00783 6ZM18.0133 6V2C18.0133 1.45 17.563 1 17.0127 1C16.4624 1 16.0122 1.45 16.0122 2V6C16.0122 6.55 16.4624 7 17.0127 7C17.563 7 18.0133 6.55 18.0133 6Z"></path></svg>';
        /***/ },
        /***/ "./src/images/smiley/very-poor.svg": /*!*****************************************!*\
  !*** ./src/images/smiley/very-poor.svg ***!
  \*****************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = '<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><g clip-path="url(#clip0_15894_140103)"><path d="M4.88291 4.50999C4.47291 4.50999 4.08291 4.24999 3.94291 3.83999C3.76291 3.31999 4.03291 2.74999 4.55291 2.56999L8.32291 1.24999C8.84291 1.05999 9.41291 1.33999 9.59291 1.85999C9.77291 2.37999 9.50291 2.94999 8.98291 3.12999L5.20291 4.44999C5.09291 4.48999 4.98291 4.50999 4.87291 4.50999H4.88291ZM19.8129 3.88999C20.0229 3.37999 19.7729 2.78999 19.2629 2.58999L15.5529 1.06999C15.0429 0.859992 14.4529 1.10999 14.2529 1.61999C14.0429 2.12999 14.2929 2.71999 14.8029 2.91999L18.5029 4.42999C18.6229 4.47999 18.7529 4.49999 18.8829 4.49999C19.2729 4.49999 19.6529 4.26999 19.8129 3.87999V3.88999ZM3.50291 5.99999C2.64291 6.36999 1.79291 6.87999 1.00291 7.47999C0.79291 7.63999 0.64291 7.86999 0.59291 8.13999C0.48291 8.72999 0.87291 9.28999 1.45291 9.39999C2.04291 9.50999 2.60291 9.11999 2.71291 8.53999C2.87291 7.68999 3.12291 6.82999 3.50291 5.98999V5.99999ZM21.0429 8.54999C21.6029 10.48 24.2429 8.83999 22.7529 7.47999C21.9629 6.87999 21.1129 6.36999 20.2529 5.99999C20.6329 6.83999 20.8829 7.69999 21.0429 8.54999ZM21.5729 13.2C21.2529 14.2 22.5429 15.09 23.3629 14.39C23.8529 14 23.9229 13.29 23.5429 12.81C21.7429 10.67 22.1329 10.55 21.5829 13.2H21.5729ZM1.75291 11C1.22291 11.79 -0.14709 12.64 0.0129102 13.75C0.15291 14.36 0.75291 14.74 1.35291 14.6C2.98291 14.1 1.80291 12.22 1.75291 11ZM19.8829 17C19.8829 13.14 16.2929 9.99999 11.8829 9.99999C7.47291 9.99999 3.88291 13.14 3.88291 17C3.88291 20.86 7.47291 24 11.8829 24C16.2929 24 19.8829 20.86 19.8829 17ZM17.8829 17C17.8829 19.76 15.1929 22 11.8829 22C8.57291 22 5.88291 19.76 5.88291 17C5.88291 14.24 8.57291 12 11.8829 12C15.1929 12 17.8829 14.24 17.8829 17Z"></path></g><defs><clipPath id="clip0_15894_140103"><rect width="24" height="24" fill="white"></rect></clipPath></defs></svg>';
        /***/ },
        /***/ "./src/itemvalue.ts": /*!**************************!*\
  !*** ./src/itemvalue.ts ***!
  \**************************/ /*! exports provided: ItemValue */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ItemValue", function() {
                return ItemValue;
            });
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * Array of ItemValue is used in checkbox, dropdown and radiogroup choices, matrix columns and rows.
 * It has two main properties: value and text. If text is empty, value is used for displaying.
 * The text property is localizable and support markdown.
 */ var ItemValue = /** @class */ function(_super) {
                __extends(ItemValue, _super);
                function ItemValue(value, text, typeName) {
                    if (text === void 0) text = null;
                    if (typeName === void 0) typeName = "itemvalue";
                    var _this = _super.call(this) || this;
                    _this.typeName = typeName;
                    _this.ownerPropertyName = "";
                    _this.locTextValue = new _localizablestring__WEBPACK_IMPORTED_MODULE_0__["LocalizableString"](_this, true, "text");
                    _this.locTextValue.onStrChanged = function(oldValue, newValue) {
                        if (newValue == _this.value) newValue = undefined;
                        _this.propertyValueChanged("text", oldValue, newValue);
                    };
                    _this.locTextValue.onGetTextCallback = function(txt) {
                        return txt ? txt : !_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(_this.value) ? _this.value.toString() : null;
                    };
                    if (text) _this.locText.text = text;
                    if (!!value && typeof value === "object") _this.setData(value);
                    else _this.value = value;
                    if (_this.getType() != "itemvalue") _jsonobject__WEBPACK_IMPORTED_MODULE_1__["CustomPropertiesCollection"].createProperties(_this);
                    _this.data = _this;
                    _this.onCreating();
                    return _this;
                }
                ItemValue.prototype.getMarkdownHtml = function(text, name) {
                    return !!this.locOwner ? this.locOwner.getMarkdownHtml(text, name) : undefined;
                };
                ItemValue.prototype.getRenderer = function(name) {
                    return !!this.locOwner ? this.locOwner.getRenderer(name) : null;
                };
                ItemValue.prototype.getRendererContext = function(locStr) {
                    return !!this.locOwner ? this.locOwner.getRendererContext(locStr) : locStr;
                };
                ItemValue.prototype.getProcessedText = function(text) {
                    return this.locOwner ? this.locOwner.getProcessedText(text) : text;
                };
                Object.defineProperty(ItemValue, "Separator", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_5__["settings"].itemValueSeparator;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_5__["settings"].itemValueSeparator = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Resets the input array and fills it with values from the values array
     */ ItemValue.setData = function(items, values, type) {
                    items.length = 0;
                    for(var i = 0; i < values.length; i++){
                        var value = values[i];
                        var itemType = !!value && typeof value.getType === "function" ? value.getType() : type !== null && type !== void 0 ? type : "itemvalue";
                        var item = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass(itemType);
                        item.setData(value);
                        if (!!value.originalItem) item.originalItem = value.originalItem;
                        items.push(item);
                    }
                };
                ItemValue.getData = function(items) {
                    var result = [];
                    for(var i = 0; i < items.length; i++)result.push(items[i].getData());
                    return result;
                };
                ItemValue.getItemByValue = function(items, val1) {
                    if (!Array.isArray(items)) return null;
                    var valIsEmpty = _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(val1);
                    for(var i = 0; i < items.length; i++){
                        if (valIsEmpty && _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(items[i].value)) return items[i];
                        if (_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(items[i].value, val1, false, true, false)) return items[i];
                    }
                    return null;
                };
                ItemValue.getTextOrHtmlByValue = function(items, val1) {
                    var item = ItemValue.getItemByValue(items, val1);
                    return item !== null ? item.locText.textOrHtml : "";
                };
                ItemValue.locStrsChanged = function(items) {
                    for(var i = 0; i < items.length; i++)items[i].locStrsChanged();
                };
                ItemValue.runConditionsForItems = function(items, filteredItems, runner, values, properties, useItemExpression, onItemCallBack) {
                    if (useItemExpression === void 0) useItemExpression = true;
                    return ItemValue.runConditionsForItemsCore(items, filteredItems, runner, values, properties, true, useItemExpression, onItemCallBack);
                };
                ItemValue.runEnabledConditionsForItems = function(items, runner, values, properties, onItemCallBack) {
                    return ItemValue.runConditionsForItemsCore(items, null, runner, values, properties, false, true, onItemCallBack);
                };
                ItemValue.runConditionsForItemsCore = function(items, filteredItems, runner, values, properties, isVisible, useItemExpression, onItemCallBack) {
                    if (useItemExpression === void 0) useItemExpression = true;
                    if (!values) values = {};
                    var itemValue = values["item"];
                    var choiceValue = values["choice"];
                    var hasChanded = false;
                    for(var i = 0; i < items.length; i++){
                        var item = items[i];
                        values["item"] = item.value;
                        values["choice"] = item.value;
                        var itemRunner = useItemExpression && !!item.getConditionRunner ? item.getConditionRunner(isVisible) : false;
                        if (!itemRunner) itemRunner = runner;
                        var newValue = true;
                        if (itemRunner) newValue = itemRunner.run(values, properties);
                        if (!!onItemCallBack) newValue = onItemCallBack(item, newValue);
                        if (!!filteredItems && newValue) filteredItems.push(item);
                        var oldValue = isVisible ? item.isVisible : item.isEnabled;
                        if (newValue != oldValue) {
                            hasChanded = true;
                            if (isVisible) {
                                if (!!item.setIsVisible) item.setIsVisible(newValue);
                            } else if (!!item.setIsEnabled) item.setIsEnabled(newValue);
                        }
                    }
                    if (itemValue) values["item"] = itemValue;
                    else delete values["item"];
                    if (choiceValue) values["choice"] = choiceValue;
                    else delete values["choice"];
                    return hasChanded;
                };
                ItemValue.prototype.onCreating = function() {};
                ItemValue.prototype.getType = function() {
                    return !!this.typeName ? this.typeName : "itemvalue";
                };
                ItemValue.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    return !!this.locOwner && !!this.locOwner["getSurvey"] ? this.locOwner.getSurvey() : null;
                };
                ItemValue.prototype.getLocale = function() {
                    return !!this.locOwner && this.locOwner.getLocale ? this.locOwner.getLocale() : "";
                };
                Object.defineProperty(ItemValue.prototype, "isInternal", {
                    get: function() {
                        return this.isGhost === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "locText", {
                    get: function() {
                        return this.locTextValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ItemValue.prototype.setLocText = function(locText) {
                    this.locTextValue = locText;
                };
                Object.defineProperty(ItemValue.prototype, "locOwner", {
                    get: function() {
                        return this._locOwner;
                    },
                    set: function(value) {
                        this._locOwner = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "value", {
                    get: function() {
                        return this.getPropertyValue("value");
                    },
                    set: function(newValue) {
                        var text = undefined;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(newValue)) {
                            var str = newValue.toString();
                            var index = str.indexOf(_settings__WEBPACK_IMPORTED_MODULE_5__["settings"].itemValueSeparator);
                            if (index > -1) {
                                newValue = str.slice(0, index);
                                text = str.slice(index + 1);
                            }
                        }
                        this.setPropertyValue("value", newValue);
                        if (!!text) this.text = text;
                        this.id = this.value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "hasText", {
                    get: function() {
                        return this.locText.pureText ? true : false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "pureText", {
                    get: function() {
                        return this.locText.pureText;
                    },
                    set: function(val1) {
                        this.text = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "text", {
                    get: function() {
                        return this.locText.calculatedText; //TODO: it will be correct to use this.locText.text, however it would require a lot of rewriting in Creator
                    },
                    set: function(newText) {
                        this.locText.text = newText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "calculatedText", {
                    get: function() {
                        return this.locText.calculatedText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "shortcutText", {
                    get: function() {
                        return this.text;
                    },
                    enumerable: false,
                    configurable: true
                });
                ItemValue.prototype.canSerializeValue = function() {
                    var val1 = this.value;
                    if (val1 === undefined || val1 === null) return false;
                    return !Array.isArray(val1) && typeof val1 !== "object";
                };
                ItemValue.prototype.getData = function() {
                    var json = this.toJSON();
                    if (!!json["value"] && !!json["value"]["pos"]) delete json["value"]["pos"];
                    if (_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(json.value)) return json;
                    var canSerializeVal = this.canSerializeValue();
                    var canSerializeAsContant = !canSerializeVal || !_settings__WEBPACK_IMPORTED_MODULE_5__["settings"].serialization.itemValueSerializeAsObject && !_settings__WEBPACK_IMPORTED_MODULE_5__["settings"].serialization.itemValueSerializeDisplayText;
                    if (canSerializeAsContant && Object.keys(json).length == 1) return this.value;
                    if (_settings__WEBPACK_IMPORTED_MODULE_5__["settings"].serialization.itemValueSerializeDisplayText && json.text === undefined && canSerializeVal) json.text = this.value.toString();
                    return json;
                };
                ItemValue.prototype.toJSON = function() {
                    var res = {};
                    var properties = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].getProperties(this.getType());
                    if (!properties || properties.length == 0) properties = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].getProperties("itemvalue");
                    var jsoObj = new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]();
                    for(var i = 0; i < properties.length; i++){
                        var prop = properties[i];
                        if (prop.name === "text" && !this.locText.hasNonDefaultText() && _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(this.value, this.text, false, true, false)) continue;
                        jsoObj.valueToJson(this, res, prop);
                    }
                    return res;
                };
                ItemValue.prototype.setData = function(value) {
                    if (_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(value)) return;
                    if (typeof value.value === "undefined" && typeof value.text !== "undefined" && Object.keys(value).length === 1) value.value = value.text;
                    if (typeof value.value !== "undefined") {
                        var json = void 0;
                        if (typeof value.toJSON === "function") json = value.toJSON();
                        else json = value;
                        new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]().toObject(json, this);
                    } else this.value = value;
                    this.locText.strChanged();
                };
                Object.defineProperty(ItemValue.prototype, "visibleIf", {
                    get: function() {
                        return this.getPropertyValueWithoutDefault("visibleIf") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("visibleIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "enableIf", {
                    get: function() {
                        return this.getPropertyValueWithoutDefault("enableIf") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("enableIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ItemValue.prototype, "isVisible", {
                    get: function() {
                        var res = this.getPropertyValueWithoutDefault("isVisible");
                        return res !== undefined ? res : true;
                    },
                    enumerable: false,
                    configurable: true
                });
                ItemValue.prototype.setIsVisible = function(val1) {
                    this.setPropertyValue("isVisible", val1);
                };
                Object.defineProperty(ItemValue.prototype, "isEnabled", {
                    get: function() {
                        var res = this.getPropertyValueWithoutDefault("isEnabled");
                        return res !== undefined ? res : true;
                    },
                    enumerable: false,
                    configurable: true
                });
                ItemValue.prototype.setIsEnabled = function(val1) {
                    this.setPropertyValue("isEnabled", val1);
                };
                ItemValue.prototype.addUsedLocales = function(locales) {
                    this.AddLocStringToUsedLocales(this.locTextValue, locales);
                };
                ItemValue.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.locText.strChanged();
                };
                ItemValue.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {
                    if (name === "value" && !this.hasText) this.locText.strChanged();
                    var funcName = "itemValuePropertyChanged";
                    if (!this.locOwner || !this.locOwner[funcName]) return;
                    this.locOwner[funcName](this, name, oldValue, newValue);
                };
                ItemValue.prototype.getConditionRunner = function(isVisible) {
                    if (isVisible) return this.getVisibleConditionRunner();
                    return this.getEnableConditionRunner();
                };
                ItemValue.prototype.getVisibleConditionRunner = function() {
                    if (!this.visibleIf) return null;
                    if (!this.visibleConditionRunner) this.visibleConditionRunner = new _conditions__WEBPACK_IMPORTED_MODULE_3__["ConditionRunner"](this.visibleIf);
                    this.visibleConditionRunner.expression = this.visibleIf;
                    return this.visibleConditionRunner;
                };
                ItemValue.prototype.getEnableConditionRunner = function() {
                    if (!this.enableIf) return null;
                    if (!this.enableConditionRunner) this.enableConditionRunner = new _conditions__WEBPACK_IMPORTED_MODULE_3__["ConditionRunner"](this.enableIf);
                    this.enableConditionRunner.expression = this.enableIf;
                    return this.enableConditionRunner;
                };
                Object.defineProperty(ItemValue.prototype, "selected", {
                    get: function() {
                        var _this = this;
                        var locOwner = this._locOwner;
                        if (locOwner instanceof _question__WEBPACK_IMPORTED_MODULE_7__["Question"] && locOwner.isItemSelected && this.selectedValue === undefined) this.selectedValue = new _base__WEBPACK_IMPORTED_MODULE_4__["ComputedUpdater"](function() {
                            return locOwner.isItemSelected(_this);
                        });
                        return this.selectedValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ItemValue.prototype.getComponent = function() {
                    if (this._locOwner instanceof _question__WEBPACK_IMPORTED_MODULE_7__["Question"]) return this.componentValue || this._locOwner.itemComponent;
                    return this.componentValue;
                };
                ItemValue.prototype.setComponent = function(val1) {
                    this.componentValue = val1;
                };
                ItemValue.prototype.getEnabled = function() {
                    return this.isEnabled;
                };
                ItemValue.prototype.setEnabled = function(val1) {
                    this.setIsEnabled(val1);
                };
                ItemValue.prototype.getVisible = function() {
                    var isVisible = this.isVisible === undefined ? true : this.isVisible;
                    var visible = this._visible === undefined ? true : this._visible;
                    return isVisible && visible;
                };
                ItemValue.prototype.setVisible = function(val1) {
                    this._visible = val1;
                };
                ItemValue.prototype.getLocTitle = function() {
                    return this.locText;
                };
                ItemValue.prototype.getTitle = function() {
                    return this.text;
                };
                ItemValue.prototype.setLocTitle = function(val1) {};
                ItemValue.prototype.setTitle = function(val1) {};
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: true
                    })
                ], ItemValue.prototype, "_visible", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], ItemValue.prototype, "selectedValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], ItemValue.prototype, "icon", void 0);
                return ItemValue;
            }(_actions_action__WEBPACK_IMPORTED_MODULE_6__["BaseAction"]);
            _base__WEBPACK_IMPORTED_MODULE_4__["Base"].createItemValue = function(source, type) {
                var item = null;
                if (!!type) item = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"].metaData.createClass(type, {});
                else if (typeof source.getType === "function") item = new ItemValue(null, undefined, source.getType());
                else item = new ItemValue(null);
                item.setData(source);
                return item;
            };
            _base__WEBPACK_IMPORTED_MODULE_4__["Base"].itemValueLocStrChanged = function(arr) {
                ItemValue.locStrsChanged(arr);
            };
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObjectProperty"].getItemValuesDefaultValue = function(val1, type) {
                var res = new Array();
                ItemValue.setData(res, Array.isArray(val1) ? val1 : [], type);
                return res;
            };
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("itemvalue", [
                {
                    name: "!value",
                    isUnique: true
                },
                {
                    name: "text",
                    serializationProperty: "locText"
                },
                {
                    name: "visibleIf:condition",
                    showMode: "form"
                },
                {
                    name: "enableIf:condition",
                    showMode: "form",
                    visibleIf: function(obj) {
                        return !obj || obj.ownerPropertyName !== "rateValues";
                    }
                }
            ], function(value) {
                return new ItemValue(value);
            });
        /***/ },
        /***/ "./src/jsonobject.ts": /*!***************************!*\
  !*** ./src/jsonobject.ts ***!
  \***************************/ /*! exports provided: property, propertyArray, JsonObjectProperty, CustomPropertiesCollection, JsonMetadataClass, JsonMetadata, JsonError, JsonUnknownPropertyError, JsonMissingTypeErrorBase, JsonMissingTypeError, JsonIncorrectTypeError, JsonRequiredPropertyError, JsonRequiredArrayPropertyError, JsonIncorrectPropertyValueError, JsonObject, Serializer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "property", function() {
                return property;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propertyArray", function() {
                return propertyArray;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonObjectProperty", function() {
                return JsonObjectProperty;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomPropertiesCollection", function() {
                return CustomPropertiesCollection;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonMetadataClass", function() {
                return JsonMetadataClass;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonMetadata", function() {
                return JsonMetadata;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonError", function() {
                return JsonError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonUnknownPropertyError", function() {
                return JsonUnknownPropertyError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeErrorBase", function() {
                return JsonMissingTypeErrorBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeError", function() {
                return JsonMissingTypeError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonIncorrectTypeError", function() {
                return JsonIncorrectTypeError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonRequiredPropertyError", function() {
                return JsonRequiredPropertyError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonRequiredArrayPropertyError", function() {
                return JsonRequiredArrayPropertyError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonIncorrectPropertyValueError", function() {
                return JsonIncorrectPropertyValueError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonObject", function() {
                return JsonObject;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Serializer", function() {
                return Serializer;
            });
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __spreadArray = function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            function ensureLocString(target, options, key) {
                var locString = target.getLocalizableString(key);
                if (!locString) {
                    var defaultStr = void 0;
                    if (typeof options.localizable === "object" && options.localizable.defaultStr) defaultStr = options.localizable.defaultStr;
                    locString = target.createLocalizableString(key, target, true, defaultStr);
                    if (typeof options.localizable === "object" && typeof options.localizable.onGetTextCallback === "function") locString.onGetTextCallback = options.localizable.onGetTextCallback;
                }
            }
            function getLocStringValue(target, options, key) {
                ensureLocString(target, options, key);
                var res = target.getLocalizableStringText(key);
                if (!!res) return res;
                if (typeof options.localizable === "object" && options.localizable.defaultStr) {
                    var loc = !!target.getLocale ? target.getLocale() : "";
                    return _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString(options.localizable.defaultStr, loc);
                }
                return "";
            }
            function property(options) {
                if (options === void 0) options = {};
                // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                return function(target, key) {
                    var processComputedUpdater = function(obj, val1) {
                        if (!!val1 && typeof val1 === "object" && val1.type === _base__WEBPACK_IMPORTED_MODULE_1__["ComputedUpdater"].ComputedUpdaterType) {
                            _base__WEBPACK_IMPORTED_MODULE_1__["Base"].startCollectDependencies(function() {
                                return obj[key] = val1.updater();
                            }, obj, key);
                            var result = val1.updater();
                            var dependencies = _base__WEBPACK_IMPORTED_MODULE_1__["Base"].finishCollectDependencies();
                            val1.setDependencies(dependencies);
                            if (obj.dependencies[key]) obj.dependencies[key].dispose();
                            obj.dependencies[key] = val1;
                            return result;
                        }
                        return val1;
                    };
                    if (!options || !options.localizable) Object.defineProperty(target, key, {
                        get: function() {
                            // const serializationProperty = Serializer.getProperty(target.getType(), key);
                            // if(!!serializationProperty && options.defaultValue !== undefined) {
                            //   ConsoleWarnings.error("remove defaultValue from @property for class " + target.getType() + " property name is " + key);
                            // }
                            var defaultVal = null;
                            if (!!options) {
                                if (typeof options.getDefaultValue === "function") defaultVal = options.getDefaultValue(this);
                                if (options.defaultValue !== undefined) defaultVal = options.defaultValue;
                            }
                            return this.getPropertyValue(key, defaultVal);
                        },
                        set: function(val1) {
                            var newValue = processComputedUpdater(this, val1);
                            this.setPropertyValue(key, newValue);
                            if (!!options && options.onSet) options.onSet(newValue, this);
                        }
                    });
                    else {
                        Object.defineProperty(target, key, {
                            get: function() {
                                return getLocStringValue(this, options, key);
                            },
                            set: function(val1) {
                                ensureLocString(this, options, key);
                                var newValue = processComputedUpdater(this, val1);
                                this.setLocalizableStringText(key, newValue);
                                if (!!options && options.onSet) options.onSet(newValue, this);
                            }
                        });
                        Object.defineProperty(target, typeof options.localizable === "object" && !!options.localizable.name ? options.localizable.name : "loc" + key.charAt(0).toUpperCase() + key.slice(1), {
                            get: function() {
                                ensureLocString(this, options, key);
                                return this.getLocalizableString(key);
                            }
                        });
                    }
                };
            }
            function ensureArray(target, options, key) {
                target.ensureArray(key, function(item, index) {
                    var handler = !!options ? options.onPush : null;
                    handler && handler(item, index, target);
                }, function(item, index) {
                    var handler = !!options ? options.onRemove : null;
                    handler && handler(item, index, target);
                });
            }
            function propertyArray(options) {
                return function(target, key) {
                    Object.defineProperty(target, key, {
                        get: function() {
                            ensureArray(this, options, key);
                            return this.getPropertyValue(key);
                        },
                        set: function(val1) {
                            ensureArray(this, options, key);
                            var arr = this.getPropertyValue(key);
                            if (val1 === arr) return;
                            if (arr) arr.splice.apply(arr, __spreadArray([
                                0,
                                arr.length
                            ], val1 || []));
                            else this.setPropertyValue(key, val1);
                            if (!!options && options.onSet) options.onSet(val1, this);
                        }
                    });
                };
            }
            /**
 * Contains information about a property of a survey element (page, panel, questions, and etc).
 * @see addProperty
 * @see removeProperty
 * @see [Add Properties](https://surveyjs.io/Documentation/Survey-Creator#addproperties)
 * @see [Remove Properties](https://surveyjs.io/Documentation/Survey-Creator#removeproperties)
 */ var JsonObjectProperty = /** @class */ function() {
                function JsonObjectProperty(classInfo, name, isRequired) {
                    if (isRequired === void 0) isRequired = false;
                    this.name = name;
                    this.isRequiredValue = false;
                    this.isUniqueValue = false;
                    this.isSerializable = true;
                    this.isLightSerializable = true;
                    this.isCustom = false;
                    this.isDynamicChoices = false; //TODO obsolete, use dependsOn attribute
                    this.isBindable = false;
                    this.category = "";
                    this.categoryIndex = -1;
                    this.visibleIndex = -1;
                    this.maxLength = -1;
                    this.isArray = false;
                    this.classInfoValue = classInfo;
                    this.isRequiredValue = isRequired;
                    this.idValue = JsonObjectProperty.Index++;
                }
                Object.defineProperty(JsonObjectProperty.prototype, "id", {
                    get: function() {
                        return this.idValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "classInfo", {
                    get: function() {
                        return this.classInfoValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "type", {
                    get: function() {
                        return this.typeValue ? this.typeValue : "string";
                    },
                    set: function(value) {
                        if (value === "itemvalues") value = "itemvalue[]";
                        if (value === "textitems") value = "textitem[]";
                        this.typeValue = value;
                        if (this.typeValue.indexOf("[]") === this.typeValue.length - 2) {
                            this.isArray = true;
                            this.className = this.typeValue.substring(0, this.typeValue.length - 2);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "isRequired", {
                    get: function() {
                        return this.isRequiredValue;
                    },
                    set: function(val1) {
                        if (val1 !== this.isRequired) {
                            this.isRequiredValue = val1;
                            if (!!this.classInfo) this.classInfo.resetAllProperties();
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "isUnique", {
                    get: function() {
                        return this.isUniqueValue;
                    },
                    set: function(val1) {
                        this.isUniqueValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "uniquePropertyName", {
                    get: function() {
                        return this.uniquePropertyValue;
                    },
                    set: function(val1) {
                        this.uniquePropertyValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "hasToUseGetValue", {
                    get: function() {
                        return this.onGetValue || this.serializationProperty;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.getDefaultValue = function(obj) {
                    var result = !!this.defaultValueFunc ? this.defaultValueFunc(obj) : this.defaultValueValue;
                    if (!!JsonObjectProperty.getItemValuesDefaultValue && Serializer.isDescendantOf(this.className, "itemvalue")) result = JsonObjectProperty.getItemValuesDefaultValue(this.defaultValueValue || [], this.className);
                    return result;
                };
                Object.defineProperty(JsonObjectProperty.prototype, "defaultValue", {
                    get: function() {
                        return this.getDefaultValue(undefined);
                    },
                    set: function(newValue) {
                        this.defaultValueValue = newValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.isDefaultValue = function(value) {
                    return this.isDefaultValueByObj(undefined, value);
                };
                JsonObjectProperty.prototype.isDefaultValueByObj = function(obj, value) {
                    var dValue = this.getDefaultValue(obj);
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(dValue)) return _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(value, dValue, false, true, false);
                    if (this.isLocalizable) return value === null || value === undefined;
                    return value === false && (this.type == "boolean" || this.type == "switch") || value === "" || _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(value);
                };
                JsonObjectProperty.prototype.getSerializableValue = function(obj) {
                    if (!!this.onSerializeValue) return this.onSerializeValue(obj);
                    return this.getValue(obj);
                };
                JsonObjectProperty.prototype.getValue = function(obj) {
                    if (this.onGetValue) return this.onGetValue(obj);
                    if (this.serializationProperty && !!obj[this.serializationProperty]) return obj[this.serializationProperty].getJson();
                    return obj[this.name];
                };
                JsonObjectProperty.prototype.getPropertyValue = function(obj) {
                    if (this.isLocalizable) return !!obj[this.serializationProperty] ? obj[this.serializationProperty].text : null;
                    return this.getValue(obj);
                };
                Object.defineProperty(JsonObjectProperty.prototype, "hasToUseSetValue", {
                    get: function() {
                        return this.onSetValue || this.serializationProperty;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.settingValue = function(obj, value) {
                    if (!this.onSettingValue || obj.isLoadingFromJson) return value;
                    return this.onSettingValue(obj, value);
                };
                JsonObjectProperty.prototype.setValue = function(obj, value, jsonConv) {
                    if (this.onSetValue) this.onSetValue(obj, value, jsonConv);
                    else if (this.serializationProperty && !!obj[this.serializationProperty]) obj[this.serializationProperty].setJson(value);
                    else {
                        if (value && typeof value === "string") {
                            if (this.type == "number") value = parseInt(value);
                            if (this.type == "boolean" || this.type == "switch") value = value.toLowerCase() === "true";
                        }
                        obj[this.name] = value;
                    }
                };
                JsonObjectProperty.prototype.validateValue = function(value) {
                    var choices = this.choices;
                    if (!Array.isArray(choices) || choices.length === 0) return true;
                    return choices.indexOf(value) > -1;
                };
                JsonObjectProperty.prototype.getObjType = function(objType) {
                    if (!this.classNamePart) return objType;
                    return objType.replace(this.classNamePart, "");
                };
                Object.defineProperty(JsonObjectProperty.prototype, "choices", {
                    /**
         * Depricated, please use getChoices
         */ get: function() {
                        return this.getChoices(null);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "hasChoices", {
                    get: function() {
                        return !!this.choicesValue || !!this.choicesfunc;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.getChoices = function(obj, choicesCallback) {
                    if (choicesCallback === void 0) choicesCallback = null;
                    if (this.choicesValue != null) return this.choicesValue;
                    if (this.choicesfunc != null) return this.choicesfunc(obj, choicesCallback);
                    return null;
                };
                JsonObjectProperty.prototype.setChoices = function(value, valueFunc) {
                    if (valueFunc === void 0) valueFunc = null;
                    this.choicesValue = value;
                    this.choicesfunc = valueFunc;
                };
                JsonObjectProperty.prototype.getBaseValue = function() {
                    if (!this.baseValue) return "";
                    if (typeof this.baseValue == "function") return this.baseValue();
                    return this.baseValue;
                };
                JsonObjectProperty.prototype.setBaseValue = function(val1) {
                    this.baseValue = val1;
                };
                Object.defineProperty(JsonObjectProperty.prototype, "readOnly", {
                    get: function() {
                        return this.readOnlyValue != null ? this.readOnlyValue : false;
                    },
                    set: function(val1) {
                        this.readOnlyValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.isEnable = function(obj) {
                    if (this.readOnly) return false;
                    if (!obj || !this.enableIf) return true;
                    return this.enableIf(this.getOriginalObj(obj));
                };
                JsonObjectProperty.prototype.isVisible = function(layout, obj) {
                    if (obj === void 0) obj = null;
                    var isLayout = !this.layout || this.layout == layout;
                    if (!this.visible || !isLayout) return false;
                    if (!!this.visibleIf && !!obj) return this.visibleIf(this.getOriginalObj(obj));
                    return true;
                };
                JsonObjectProperty.prototype.getOriginalObj = function(obj) {
                    if (obj && obj.getOriginalObj) {
                        var orjObj = obj.getOriginalObj();
                        if (orjObj && Serializer.findProperty(orjObj.getType(), this.name)) return orjObj;
                    }
                    return obj;
                };
                Object.defineProperty(JsonObjectProperty.prototype, "visible", {
                    get: function() {
                        return this.visibleValue != null ? this.visibleValue : true;
                    },
                    set: function(val1) {
                        this.visibleValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.isAvailableInVersion = function(ver) {
                    if (!!this.alternativeName || this.oldName) return true;
                    return this.isAvailableInVersionCore(ver);
                };
                JsonObjectProperty.prototype.getSerializedName = function(ver) {
                    if (!this.alternativeName) return this.name;
                    return this.isAvailableInVersionCore(ver) ? this.name : this.alternativeName || this.oldName;
                };
                JsonObjectProperty.prototype.getSerializedProperty = function(obj, ver) {
                    if (!this.oldName || this.isAvailableInVersionCore(ver)) return this;
                    if (!obj || !obj.getType) return null;
                    return Serializer.findProperty(obj.getType(), this.oldName);
                };
                JsonObjectProperty.prototype.isAvailableInVersionCore = function(ver) {
                    if (!ver || !this.version) return true;
                    return _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].compareVerions(this.version, ver) <= 0;
                };
                Object.defineProperty(JsonObjectProperty.prototype, "isLocalizable", {
                    get: function() {
                        return this.isLocalizableValue != null ? this.isLocalizableValue : false;
                    },
                    set: function(val1) {
                        this.isLocalizableValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "dataList", {
                    get: function() {
                        return Array.isArray(this.dataListValue) ? this.dataListValue : [];
                    },
                    set: function(val1) {
                        this.dataListValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.mergeWith = function(prop) {
                    var valuesNames = JsonObjectProperty.mergableValues;
                    for(var i = 0; i < valuesNames.length; i++)this.mergeValue(prop, valuesNames[i]);
                };
                JsonObjectProperty.prototype.addDependedProperty = function(name) {
                    if (!this.dependedProperties) this.dependedProperties = [];
                    if (this.dependedProperties.indexOf(name) < 0) this.dependedProperties.push(name);
                };
                JsonObjectProperty.prototype.getDependedProperties = function() {
                    return !!this.dependedProperties ? this.dependedProperties : [];
                };
                JsonObjectProperty.prototype.schemaType = function() {
                    if (this.className === "choicesByUrl") return undefined;
                    if (this.className === "string") return this.className;
                    if (!!this.className) return "array";
                    if (!!this.baseClassName) return "array";
                    if (this.type == "switch") return "boolean";
                    if (this.type == "boolean" || this.type == "number") return this.type;
                    return "string";
                };
                JsonObjectProperty.prototype.schemaRef = function() {
                    if (!!this.className) return this.className;
                    return undefined;
                };
                JsonObjectProperty.prototype.mergeValue = function(prop, valueName) {
                    if (this[valueName] == null && prop[valueName] != null) this[valueName] = prop[valueName];
                };
                JsonObjectProperty.Index = 1;
                JsonObjectProperty.mergableValues = [
                    "typeValue",
                    "choicesValue",
                    "baseValue",
                    "readOnlyValue",
                    "visibleValue",
                    "isSerializable",
                    "isLightSerializable",
                    "isCustom",
                    "isBindable",
                    "isUnique",
                    "uniquePropertyName",
                    "isDynamicChoices",
                    "isLocalizableValue",
                    "className",
                    "alternativeName",
                    "oldName",
                    "layout",
                    "version",
                    "classNamePart",
                    "baseClassName",
                    "defaultValue",
                    "defaultValueFunc",
                    "serializationProperty",
                    "onGetValue",
                    "onSetValue",
                    "onSettingValue",
                    "displayName",
                    "category",
                    "categoryIndex",
                    "visibleIndex",
                    "nextToProperty",
                    "overridingProperty",
                    "showMode",
                    "dependedProperties",
                    "visibleIf",
                    "enableIf",
                    "onExecuteExpression",
                    "onPropertyEditorUpdate",
                    "maxLength",
                    "maxValue",
                    "minValue",
                    "dataListValue"
                ];
                return JsonObjectProperty;
            }();
            var CustomPropertiesCollection = /** @class */ function() {
                function CustomPropertiesCollection() {}
                CustomPropertiesCollection.addProperty = function(className, property) {
                    className = className.toLowerCase();
                    var props = CustomPropertiesCollection.properties;
                    if (!props[className]) props[className] = [];
                    props[className].push(property);
                };
                CustomPropertiesCollection.removeProperty = function(className, propertyName) {
                    className = className.toLowerCase();
                    var props = CustomPropertiesCollection.properties;
                    if (!props[className]) return;
                    var properties = props[className];
                    for(var i = 0; i < properties.length; i++)if (properties[i].name == propertyName) {
                        props[className].splice(i, 1);
                        break;
                    }
                };
                CustomPropertiesCollection.removeAllProperties = function(className) {
                    className = className.toLowerCase();
                    delete CustomPropertiesCollection.properties[className];
                };
                CustomPropertiesCollection.addClass = function(className, parentClassName) {
                    className = className.toLowerCase();
                    if (parentClassName) parentClassName = parentClassName.toLowerCase();
                    CustomPropertiesCollection.parentClasses[className] = parentClassName;
                };
                CustomPropertiesCollection.getProperties = function(className) {
                    className = className.toLowerCase();
                    var res = [];
                    var props = CustomPropertiesCollection.properties;
                    while(className){
                        var properties = props[className];
                        if (properties) for(var i = 0; i < properties.length; i++)res.push(properties[i]);
                        className = CustomPropertiesCollection.parentClasses[className];
                    }
                    return res;
                };
                CustomPropertiesCollection.createProperties = function(obj) {
                    if (!obj || !obj.getType) return;
                    CustomPropertiesCollection.createPropertiesCore(obj, obj.getType());
                };
                CustomPropertiesCollection.createPropertiesCore = function(obj, className) {
                    var props = CustomPropertiesCollection.properties;
                    if (props[className]) CustomPropertiesCollection.createPropertiesInObj(obj, props[className]);
                    var parentClass = CustomPropertiesCollection.parentClasses[className];
                    if (parentClass) CustomPropertiesCollection.createPropertiesCore(obj, parentClass);
                };
                CustomPropertiesCollection.createPropertiesInObj = function(obj, properties) {
                    for(var i = 0; i < properties.length; i++)CustomPropertiesCollection.createPropertyInObj(obj, properties[i]);
                };
                CustomPropertiesCollection.createPropertyInObj = function(obj, prop) {
                    if (CustomPropertiesCollection.checkIsPropertyExists(obj, prop.name)) return;
                    if (!!prop.serializationProperty && CustomPropertiesCollection.checkIsPropertyExists(obj, prop.serializationProperty)) return;
                    if (prop.isLocalizable && prop.serializationProperty && obj.createCustomLocalizableObj) {
                        var locStr = obj.createCustomLocalizableObj(prop.name);
                        locStr.defaultValue = prop.defaultValue;
                        var locDesc = {
                            get: function() {
                                return obj.getLocalizableString(prop.name);
                            }
                        };
                        Object.defineProperty(obj, prop.serializationProperty, locDesc);
                        var desc = {
                            get: function() {
                                return obj.getLocalizableStringText(prop.name);
                            },
                            set: function(v) {
                                obj.setLocalizableStringText(prop.name, v);
                            }
                        };
                        Object.defineProperty(obj, prop.name, desc);
                    } else {
                        var defaultValue = prop.defaultValue;
                        var isArrayProp = prop.isArray || prop.type === "multiplevalues";
                        if (typeof obj.createNewArray === "function") {
                            if (Serializer.isDescendantOf(prop.className, "itemvalue")) {
                                obj.createNewArray(prop.name, function(item) {
                                    item.locOwner = obj;
                                    item.ownerPropertyName = prop.name;
                                });
                                isArrayProp = true;
                            } else //It is a simple array property
                            if (isArrayProp) obj.createNewArray(prop.name);
                            if (isArrayProp) {
                                if (Array.isArray(defaultValue)) obj.setPropertyValue(prop.name, defaultValue);
                                defaultValue = null;
                            }
                        }
                        if (!!obj.getPropertyValue && !!obj.setPropertyValue) {
                            var desc = {
                                get: function() {
                                    if (!!prop.onGetValue) return prop.onGetValue(obj);
                                    return obj.getPropertyValue(prop.name, defaultValue);
                                },
                                set: function(v) {
                                    if (!!prop.onSetValue) prop.onSetValue(obj, v, null);
                                    else obj.setPropertyValue(prop.name, v);
                                }
                            };
                            Object.defineProperty(obj, prop.name, desc);
                        }
                    }
                    if (prop.type === "condition" || prop.type === "expression") {
                        if (!!prop.onExecuteExpression) obj.addExpressionProperty(prop.name, prop.onExecuteExpression);
                    }
                };
                CustomPropertiesCollection.checkIsPropertyExists = function(obj, name) {
                    return obj.hasOwnProperty(name) || obj[name];
                };
                CustomPropertiesCollection.properties = {};
                CustomPropertiesCollection.parentClasses = {};
                return CustomPropertiesCollection;
            }();
            var JsonMetadataClass = /** @class */ function() {
                function JsonMetadataClass(name, properties, creator, parentName) {
                    if (creator === void 0) creator = null;
                    if (parentName === void 0) parentName = null;
                    this.name = name;
                    this.creator = creator;
                    this.parentName = parentName;
                    name = name.toLowerCase();
                    this.isCustomValue = !creator && name !== "survey";
                    if (this.parentName) {
                        this.parentName = this.parentName.toLowerCase();
                        CustomPropertiesCollection.addClass(name, this.parentName);
                        if (!!creator) this.makeParentRegularClass();
                    }
                    this.properties = new Array();
                    for(var i = 0; i < properties.length; i++)this.createProperty(properties[i], this.isCustom);
                }
                //Obsolete
                JsonMetadataClass.prototype.find = function(name) {
                    for(var i = 0; i < this.properties.length; i++){
                        if (this.properties[i].name == name) return this.properties[i];
                    }
                    return null;
                };
                JsonMetadataClass.prototype.findProperty = function(name) {
                    this.fillAllProperties();
                    return this.hashProperties[name];
                };
                JsonMetadataClass.prototype.getAllProperties = function() {
                    this.fillAllProperties();
                    return this.allProperties;
                };
                JsonMetadataClass.prototype.getRequiredProperties = function() {
                    if (!!this.requiredProperties) return this.requiredProperties;
                    this.requiredProperties = [];
                    var props = this.getAllProperties();
                    for(var i = 0; i < props.length; i++)if (props[i].isRequired) this.requiredProperties.push(props[i]);
                    return this.requiredProperties;
                };
                JsonMetadataClass.prototype.resetAllProperties = function() {
                    this.allProperties = undefined;
                    this.requiredProperties = undefined;
                    this.hashProperties = undefined;
                    var childClasses = Serializer.getChildrenClasses(this.name);
                    for(var i = 0; i < childClasses.length; i++)childClasses[i].resetAllProperties();
                };
                Object.defineProperty(JsonMetadataClass.prototype, "isCustom", {
                    get: function() {
                        return this.isCustomValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonMetadataClass.prototype.fillAllProperties = function() {
                    var _this = this;
                    if (!!this.allProperties) return;
                    this.allProperties = [];
                    this.hashProperties = {};
                    var localProperties = {};
                    this.properties.forEach(function(prop) {
                        return localProperties[prop.name] = prop;
                    });
                    var parentClass = !!this.parentName ? Serializer.findClass(this.parentName) : null;
                    if (!!parentClass) {
                        var parentProperties = parentClass.getAllProperties();
                        parentProperties.forEach(function(prop) {
                            var overridedProp = localProperties[prop.name];
                            if (!!overridedProp) {
                                overridedProp.mergeWith(prop);
                                _this.addPropCore(overridedProp);
                            } else _this.addPropCore(prop);
                        });
                    }
                    this.properties.forEach(function(prop) {
                        if (!_this.hashProperties[prop.name]) _this.addPropCore(prop);
                    });
                };
                JsonMetadataClass.prototype.addPropCore = function(prop) {
                    this.allProperties.push(prop);
                    this.hashProperties[prop.name] = prop;
                    if (!!prop.alternativeName) this.hashProperties[prop.alternativeName] = prop;
                };
                JsonMetadataClass.prototype.isOverridedProp = function(propName) {
                    return !!this.parentName && !!Serializer.findProperty(this.parentName, propName);
                };
                JsonMetadataClass.prototype.hasRegularChildClass = function() {
                    if (!this.isCustom) return;
                    this.isCustomValue = false;
                    for(var i = 0; i < this.properties.length; i++)this.properties[i].isCustom = false;
                    CustomPropertiesCollection.removeAllProperties(this.name);
                    this.makeParentRegularClass();
                };
                JsonMetadataClass.prototype.makeParentRegularClass = function() {
                    if (!this.parentName) return;
                    var parent = Serializer.findClass(this.parentName);
                    if (!!parent) parent.hasRegularChildClass();
                };
                JsonMetadataClass.prototype.createProperty = function(propInfo, isCustom) {
                    if (isCustom === void 0) isCustom = false;
                    var propertyName = typeof propInfo === "string" ? propInfo : propInfo.name;
                    if (!propertyName) return;
                    var propertyType = null;
                    var typeIndex = propertyName.indexOf(JsonMetadataClass.typeSymbol);
                    if (typeIndex > -1) {
                        propertyType = propertyName.substring(typeIndex + 1);
                        propertyName = propertyName.substring(0, typeIndex);
                    }
                    var isRequired = this.getIsPropertyNameRequired(propertyName) || !!propInfo.isRequired;
                    propertyName = this.getPropertyName(propertyName);
                    var prop = new JsonObjectProperty(this, propertyName, isRequired);
                    if (propertyType) prop.type = propertyType;
                    if (typeof propInfo === "object") {
                        if (propInfo.type) prop.type = propInfo.type;
                        if (propInfo.default !== undefined) prop.defaultValue = propInfo.default;
                        if (propInfo.defaultFunc !== undefined) prop.defaultValueFunc = propInfo.defaultFunc;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isSerializable)) prop.isSerializable = propInfo.isSerializable;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isLightSerializable)) prop.isLightSerializable = propInfo.isLightSerializable;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.maxLength)) prop.maxLength = propInfo.maxLength;
                        if (propInfo.displayName !== undefined) prop.displayName = propInfo.displayName;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.category)) prop.category = propInfo.category;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.categoryIndex)) prop.categoryIndex = propInfo.categoryIndex;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.nextToProperty)) prop.nextToProperty = propInfo.nextToProperty;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.overridingProperty)) prop.overridingProperty = propInfo.overridingProperty;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.visibleIndex)) prop.visibleIndex = propInfo.visibleIndex;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.showMode)) prop.showMode = propInfo.showMode;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.maxValue)) prop.maxValue = propInfo.maxValue;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.minValue)) prop.minValue = propInfo.minValue;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.dataList)) prop.dataList = propInfo.dataList;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isDynamicChoices)) prop.isDynamicChoices = propInfo.isDynamicChoices;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isBindable)) prop.isBindable = propInfo.isBindable;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isUnique)) prop.isUnique = propInfo.isUnique;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.uniqueProperty)) prop.uniquePropertyName = propInfo.uniqueProperty;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isArray)) prop.isArray = propInfo.isArray;
                        if (propInfo.visible === true || propInfo.visible === false) prop.visible = propInfo.visible;
                        if (!!propInfo.visibleIf) prop.visibleIf = propInfo.visibleIf;
                        if (!!propInfo.enableIf) prop.enableIf = propInfo.enableIf;
                        if (!!propInfo.onExecuteExpression) prop.onExecuteExpression = propInfo.onExecuteExpression;
                        if (!!propInfo.onPropertyEditorUpdate) prop.onPropertyEditorUpdate = propInfo.onPropertyEditorUpdate;
                        if (propInfo.readOnly === true) prop.readOnly = true;
                        if (propInfo.choices) {
                            var choicesFunc = typeof propInfo.choices === "function" ? propInfo.choices : null;
                            var choicesValue = typeof propInfo.choices !== "function" ? propInfo.choices : null;
                            prop.setChoices(choicesValue, choicesFunc);
                        }
                        if (!!propInfo.baseValue) prop.setBaseValue(propInfo.baseValue);
                        if (propInfo.onSerializeValue) prop.onSerializeValue = propInfo.onSerializeValue;
                        if (propInfo.onGetValue) prop.onGetValue = propInfo.onGetValue;
                        if (propInfo.onSetValue) prop.onSetValue = propInfo.onSetValue;
                        if (propInfo.onSettingValue) prop.onSettingValue = propInfo.onSettingValue;
                        if (propInfo.isLocalizable) propInfo.serializationProperty = "loc" + prop.name;
                        if (propInfo.serializationProperty) {
                            prop.serializationProperty = propInfo.serializationProperty;
                            var s;
                            if (prop.serializationProperty && prop.serializationProperty.indexOf("loc") == 0) prop.isLocalizable = true;
                        }
                        if (propInfo.isLocalizable) prop.isLocalizable = propInfo.isLocalizable;
                        if (propInfo.className) prop.className = propInfo.className;
                        if (propInfo.baseClassName) {
                            prop.baseClassName = propInfo.baseClassName;
                            prop.isArray = true;
                        }
                        if (prop.isArray === true) prop.isArray = true;
                        if (propInfo.classNamePart) prop.classNamePart = propInfo.classNamePart;
                        if (propInfo.alternativeName) prop.alternativeName = propInfo.alternativeName;
                        if (propInfo.oldName) prop.oldName = propInfo.oldName;
                        if (propInfo.layout) prop.layout = propInfo.layout;
                        if (propInfo.version) prop.version = propInfo.version;
                        if (propInfo.dependsOn) this.addDependsOnProperties(prop, propInfo.dependsOn);
                    }
                    this.properties.push(prop);
                    if (isCustom && !this.isOverridedProp(prop.name)) {
                        prop.isCustom = true;
                        CustomPropertiesCollection.addProperty(this.name, prop);
                    }
                    return prop;
                };
                JsonMetadataClass.prototype.addDependsOnProperties = function(prop, dependsOn) {
                    if (Array.isArray(dependsOn)) for(var i = 0; i < dependsOn.length; i++)this.addDependsOnProperty(prop, dependsOn[i]);
                    else this.addDependsOnProperty(prop, dependsOn);
                };
                JsonMetadataClass.prototype.addDependsOnProperty = function(prop, dependsOn) {
                    var property = this.find(dependsOn);
                    if (!property) property = Serializer.findProperty(this.parentName, dependsOn);
                    if (!property) return;
                    property.addDependedProperty(prop.name);
                };
                JsonMetadataClass.prototype.getIsPropertyNameRequired = function(propertyName) {
                    return propertyName.length > 0 && propertyName[0] == JsonMetadataClass.requiredSymbol;
                };
                JsonMetadataClass.prototype.getPropertyName = function(propertyName) {
                    if (!this.getIsPropertyNameRequired(propertyName)) return propertyName;
                    propertyName = propertyName.slice(1);
                    return propertyName;
                };
                JsonMetadataClass.requiredSymbol = "!";
                JsonMetadataClass.typeSymbol = ":";
                return JsonMetadataClass;
            }();
            /**
 * The metadata object. It contains object properties' runtime information and allows you to modify it.
 */ var JsonMetadata = /** @class */ function() {
                function JsonMetadata() {
                    this.classes = {};
                    this.alternativeNames = {};
                    this.childrenClasses = {};
                    this.dynamicPropsCache = {};
                }
                JsonMetadata.prototype.getObjPropertyValue = function(obj, name) {
                    if (this.isObjWrapper(obj) && this.isNeedUseObjWrapper(obj, name)) {
                        var orignalObj = obj.getOriginalObj();
                        var prop_1 = Serializer.findProperty(orignalObj.getType(), name);
                        if (!!prop_1) return this.getObjPropertyValueCore(orignalObj, prop_1);
                    }
                    var prop = Serializer.findProperty(obj.getType(), name);
                    if (!prop) return obj[name];
                    return this.getObjPropertyValueCore(obj, prop);
                };
                JsonMetadata.prototype.setObjPropertyValue = function(obj, name, val1) {
                    if (obj[name] === val1) return;
                    if (!!obj[name] && !!obj[name].setJson) obj[name].setJson(val1);
                    else {
                        if (Array.isArray(val1)) {
                            var newVal = [];
                            for(var i = 0; i < val1.length; i++)newVal.push(val1[i]);
                            val1 = newVal;
                        }
                        obj[name] = val1;
                    }
                };
                JsonMetadata.prototype.getObjPropertyValueCore = function(obj, prop) {
                    if (!prop.isSerializable) return obj[prop.name];
                    if (prop.isLocalizable) {
                        if (prop.isArray) return obj[prop.name];
                        if (!!prop.serializationProperty) return obj[prop.serializationProperty].text;
                    }
                    return obj.getPropertyValue(prop.name);
                };
                JsonMetadata.prototype.isObjWrapper = function(obj) {
                    return !!obj.getOriginalObj && !!obj.getOriginalObj();
                };
                JsonMetadata.prototype.isNeedUseObjWrapper = function(obj, name) {
                    if (!obj.getDynamicProperties) return true;
                    var props = obj.getDynamicProperties();
                    if (!Array.isArray(props)) return false;
                    for(var i = 0; i < props.length; i++){
                        if (props[i].name === name) return true;
                    }
                    return false;
                };
                JsonMetadata.prototype.addClass = function(name, properties, creator, parentName) {
                    if (creator === void 0) creator = null;
                    if (parentName === void 0) parentName = null;
                    name = name.toLowerCase();
                    var metaDataClass = new JsonMetadataClass(name, properties, creator, parentName);
                    this.classes[name] = metaDataClass;
                    if (parentName) {
                        parentName = parentName.toLowerCase();
                        var children = this.childrenClasses[parentName];
                        if (!children) this.childrenClasses[parentName] = [];
                        this.childrenClasses[parentName].push(metaDataClass);
                    }
                    return metaDataClass;
                };
                JsonMetadata.prototype.removeClass = function(name) {
                    var metaClass = this.findClass(name);
                    if (!metaClass) return;
                    delete this.classes[metaClass.name];
                    if (!!metaClass.parentName) {
                        var index = this.childrenClasses[metaClass.parentName].indexOf(metaClass);
                        if (index > -1) this.childrenClasses[metaClass.parentName].splice(index, 1);
                    }
                };
                JsonMetadata.prototype.overrideClassCreatore = function(name, creator) {
                    this.overrideClassCreator(name, creator);
                };
                JsonMetadata.prototype.overrideClassCreator = function(name, creator) {
                    name = name.toLowerCase();
                    var metaDataClass = this.findClass(name);
                    if (metaDataClass) metaDataClass.creator = creator;
                };
                JsonMetadata.prototype.getProperties = function(className) {
                    var metaClass = this.findClass(className);
                    if (!metaClass) return [];
                    return metaClass.getAllProperties();
                };
                JsonMetadata.prototype.getPropertiesByObj = function(obj) {
                    if (!obj || !obj.getType) return [];
                    var props = this.getProperties(obj.getType());
                    var dynamicProps = this.getDynamicPropertiesByObj(obj);
                    return [].concat(props).concat(dynamicProps);
                };
                JsonMetadata.prototype.addDynamicPropertiesIntoObj = function(dest, src, props) {
                    var _this = this;
                    props.forEach(function(prop) {
                        _this.addDynamicPropertyIntoObj(dest, src, prop.name, false);
                        if (prop.serializationProperty) _this.addDynamicPropertyIntoObj(dest, src, prop.serializationProperty, true);
                        if (prop.alternativeName) _this.addDynamicPropertyIntoObj(dest, src, prop.alternativeName, false);
                    });
                };
                JsonMetadata.prototype.addDynamicPropertyIntoObj = function(dest, src, propName, isReadOnly) {
                    var desc = {
                        configurable: true,
                        get: function() {
                            return src[propName];
                        }
                    };
                    if (!isReadOnly) desc["set"] = function(v) {
                        src[propName] = v;
                    };
                    Object.defineProperty(dest, propName, desc);
                };
                JsonMetadata.prototype.getDynamicPropertiesByObj = function(obj, dynamicType) {
                    if (dynamicType === void 0) dynamicType = null;
                    if (!obj || !obj.getType) return [];
                    if (!!obj.getDynamicProperties) return obj.getDynamicProperties();
                    if (!obj.getDynamicType && !dynamicType) return [];
                    var dType = !!dynamicType ? dynamicType : obj.getDynamicType();
                    return this.getDynamicPropertiesByTypes(obj.getType(), dType);
                };
                JsonMetadata.prototype.getDynamicPropertiesByTypes = function(objType, dynamicType, invalidNames) {
                    if (!dynamicType) return [];
                    var cacheType = dynamicType + "-" + objType;
                    if (this.dynamicPropsCache[cacheType]) return this.dynamicPropsCache[cacheType];
                    var dynamicProps = this.getProperties(dynamicType);
                    if (!dynamicProps || dynamicProps.length == 0) return [];
                    var hash = {};
                    var props = this.getProperties(objType);
                    for(var i = 0; i < props.length; i++)hash[props[i].name] = props[i];
                    var res = [];
                    if (!invalidNames) invalidNames = [];
                    for(var i_1 = 0; i_1 < dynamicProps.length; i_1++){
                        var dProp = dynamicProps[i_1];
                        if (!hash[dProp.name] && invalidNames.indexOf(dProp.name) < 0) res.push(dProp);
                    }
                    this.dynamicPropsCache[cacheType] = res;
                    return res;
                };
                JsonMetadata.prototype.hasOriginalProperty = function(obj, propName) {
                    return !!this.getOriginalProperty(obj, propName);
                };
                JsonMetadata.prototype.getOriginalProperty = function(obj, propName) {
                    var res = this.findProperty(obj.getType(), propName);
                    if (!!res) return res;
                    if (this.isObjWrapper(obj)) return this.findProperty(obj.getOriginalObj().getType(), propName);
                    return null;
                };
                JsonMetadata.prototype.getProperty = function(className, propertyName) {
                    var prop = this.findProperty(className, propertyName);
                    if (!prop) return prop;
                    var classInfo = this.findClass(className);
                    if (prop.classInfo === classInfo) return prop;
                    var newProp = new JsonObjectProperty(classInfo, prop.name, prop.isRequired);
                    newProp.mergeWith(prop);
                    newProp.isArray = prop.isArray;
                    classInfo.properties.push(newProp);
                    classInfo.resetAllProperties();
                    return newProp;
                };
                JsonMetadata.prototype.findProperty = function(className, propertyName) {
                    var cl = this.findClass(className);
                    return !!cl ? cl.findProperty(propertyName) : null;
                };
                JsonMetadata.prototype.findProperties = function(className, propertyNames) {
                    var result = new Array();
                    var cl = this.findClass(className);
                    if (!cl) return result;
                    for(var i = 0; i < propertyNames.length; i++){
                        var prop = cl.findProperty(propertyNames[i]);
                        if (prop) result.push(prop);
                    }
                    return result;
                };
                JsonMetadata.prototype.getAllPropertiesByName = function(propertyName) {
                    var res = new Array();
                    var classes = this.getAllClasses();
                    for(var i = 0; i < classes.length; i++){
                        var classInfo = this.findClass(classes[i]);
                        for(var j = 0; j < classInfo.properties.length; j++)if (classInfo.properties[j].name == propertyName) {
                            res.push(classInfo.properties[j]);
                            break;
                        }
                    }
                    return res;
                };
                JsonMetadata.prototype.getAllClasses = function() {
                    var res = new Array();
                    for(var name in this.classes)res.push(name);
                    return res;
                };
                JsonMetadata.prototype.createClass = function(name, json) {
                    if (json === void 0) json = undefined;
                    name = name.toLowerCase();
                    var metaDataClass = this.findClass(name);
                    if (!metaDataClass) return null;
                    if (metaDataClass.creator) return metaDataClass.creator(json);
                    var parentName = metaDataClass.parentName;
                    while(parentName){
                        metaDataClass = this.findClass(parentName);
                        if (!metaDataClass) return null;
                        parentName = metaDataClass.parentName;
                        if (metaDataClass.creator) return this.createCustomType(name, metaDataClass.creator, json);
                    }
                    return null;
                };
                JsonMetadata.prototype.createCustomType = function(name, creator, json) {
                    if (json === void 0) json = undefined;
                    name = name.toLowerCase();
                    var res = creator(json);
                    var customTypeName = name;
                    var customTemplateName = res.getTemplate ? res.getTemplate() : res.getType();
                    res.getType = function() {
                        return customTypeName;
                    };
                    res.getTemplate = function() {
                        return customTemplateName;
                    };
                    CustomPropertiesCollection.createProperties(res);
                    return res;
                };
                JsonMetadata.prototype.getChildrenClasses = function(name, canBeCreated) {
                    if (canBeCreated === void 0) canBeCreated = false;
                    name = name.toLowerCase();
                    var result = [];
                    this.fillChildrenClasses(name, canBeCreated, result);
                    return result;
                };
                JsonMetadata.prototype.getRequiredProperties = function(name) {
                    var metaClass = this.findClass(name);
                    if (!metaClass) return [];
                    var props = metaClass.getRequiredProperties();
                    var res = [];
                    for(var i = 0; i < props.length; i++)res.push(props[i].name);
                    return res;
                };
                JsonMetadata.prototype.addProperties = function(className, propertiesInfos) {
                    className = className.toLowerCase();
                    var metaDataClass = this.findClass(className);
                    for(var i = 0; i < propertiesInfos.length; i++)this.addCustomPropertyCore(metaDataClass, propertiesInfos[i]);
                };
                JsonMetadata.prototype.addProperty = function(className, propertyInfo) {
                    return this.addCustomPropertyCore(this.findClass(className), propertyInfo);
                };
                JsonMetadata.prototype.addCustomPropertyCore = function(metaDataClass, propertyInfo) {
                    if (!metaDataClass) return null;
                    var property = metaDataClass.createProperty(propertyInfo, true);
                    if (property) {
                        this.clearDynamicPropsCache(metaDataClass);
                        metaDataClass.resetAllProperties();
                    }
                    return property;
                };
                JsonMetadata.prototype.removeProperty = function(className, propertyName) {
                    var metaDataClass = this.findClass(className);
                    if (!metaDataClass) return false;
                    var property = metaDataClass.find(propertyName);
                    if (property) {
                        this.clearDynamicPropsCache(metaDataClass);
                        this.removePropertyFromClass(metaDataClass, property);
                        metaDataClass.resetAllProperties();
                        CustomPropertiesCollection.removeProperty(metaDataClass.name, propertyName);
                    }
                };
                JsonMetadata.prototype.clearDynamicPropsCache = function(metaDataClass) {
                    this.dynamicPropsCache = {};
                };
                JsonMetadata.prototype.removePropertyFromClass = function(metaDataClass, property) {
                    var index = metaDataClass.properties.indexOf(property);
                    if (index < 0) return;
                    metaDataClass.properties.splice(index, 1);
                };
                JsonMetadata.prototype.fillChildrenClasses = function(name, canBeCreated, result) {
                    var children = this.childrenClasses[name];
                    if (!children) return;
                    for(var i = 0; i < children.length; i++){
                        if (!canBeCreated || children[i].creator) result.push(children[i]);
                        this.fillChildrenClasses(children[i].name, canBeCreated, result);
                    }
                };
                JsonMetadata.prototype.findClass = function(name) {
                    name = name.toLowerCase();
                    var res = this.classes[name];
                    if (!res) {
                        var newName = this.alternativeNames[name];
                        if (!!newName && newName != name) return this.findClass(newName);
                    }
                    return res;
                };
                JsonMetadata.prototype.isDescendantOf = function(className, ancestorClassName) {
                    if (!className || !ancestorClassName) return false;
                    className = className.toLowerCase();
                    ancestorClassName = ancestorClassName.toLowerCase();
                    var class_ = this.findClass(className);
                    if (!class_) return false;
                    var parentClass = class_;
                    do {
                        if (parentClass.name === ancestorClassName) return true;
                        parentClass = this.classes[parentClass.parentName];
                    }while (!!parentClass);
                    return false;
                };
                JsonMetadata.prototype.addAlterNativeClassName = function(name, alternativeName) {
                    this.alternativeNames[alternativeName.toLowerCase()] = name.toLowerCase();
                };
                JsonMetadata.prototype.generateSchema = function(className) {
                    if (className === void 0) className = undefined;
                    if (!className) className = "survey";
                    var classInfo = this.findClass(className);
                    if (!classInfo) return null;
                    var res = {
                        $schema: "http://json-schema.org/draft-07/schema#",
                        title: "SurveyJS Library json schema",
                        type: "object",
                        properties: {},
                        definitions: {
                            locstring: this.generateLocStrClass()
                        }
                    };
                    this.generateSchemaProperties(classInfo, res, res.definitions, true);
                    return res;
                };
                JsonMetadata.prototype.generateLocStrClass = function() {
                    var props = {};
                    var locProp = Serializer.findProperty("survey", "locale");
                    if (!!locProp) {
                        var choices = locProp.getChoices(null);
                        if (Array.isArray(choices)) {
                            if (choices.indexOf("en") < 0) choices.splice(0, 0, "en");
                            choices.splice(0, 0, "default");
                            choices.forEach(function(l) {
                                if (!!l) props[l] = {
                                    type: "string"
                                };
                            });
                        }
                    }
                    return {
                        $id: "locstring",
                        type: "object",
                        properties: props
                    };
                };
                JsonMetadata.prototype.generateSchemaProperties = function(classInfo, classSchema, schemaDef, isRoot) {
                    if (!classInfo) return;
                    var schemaProperties = classSchema.properties;
                    var requiredProps = [];
                    if (classInfo.name === "question" || classInfo.name === "panel") {
                        schemaProperties.type = {
                            type: "string"
                        };
                        requiredProps.push("type");
                    }
                    for(var i = 0; i < classInfo.properties.length; i++){
                        var prop = classInfo.properties[i];
                        if (!!classInfo.parentName && !!Serializer.findProperty(classInfo.parentName, prop.name)) continue;
                        schemaProperties[prop.name] = this.generateSchemaProperty(prop, schemaDef, isRoot);
                        if (prop.isRequired) requiredProps.push(prop.name);
                    }
                    if (requiredProps.length > 0) classSchema.required = requiredProps;
                };
                JsonMetadata.prototype.generateSchemaProperty = function(prop, schemaDef, isRoot) {
                    if (prop.isLocalizable) return {
                        oneOf: [
                            {
                                "type": "string"
                            },
                            {
                                "$ref": this.getChemeRefName("locstring", isRoot)
                            }
                        ]
                    };
                    var propType = prop.schemaType();
                    var refType = prop.schemaRef();
                    var res = {};
                    if (!!propType) res.type = propType;
                    if (prop.hasChoices) {
                        var enumRes = prop.getChoices(null);
                        if (Array.isArray(enumRes) && enumRes.length > 0) res.enum = this.getChoicesValues(enumRes);
                    }
                    if (!!refType) {
                        if (propType === "array") {
                            if (prop.className === "string") res.items = {
                                type: prop.className
                            };
                            else res.items = {
                                $ref: this.getChemeRefName(prop.className, isRoot)
                            };
                        } else res["$ref"] = this.getChemeRefName(refType, isRoot);
                        this.generateChemaClass(prop.className, schemaDef, false);
                    }
                    if (!!prop.baseClassName) {
                        var usedClasses = this.getChildrenClasses(prop.baseClassName, true);
                        if (prop.baseClassName == "question") usedClasses.push(this.findClass("panel"));
                        res.items = {
                            anyOf: []
                        };
                        for(var i = 0; i < usedClasses.length; i++){
                            var className = usedClasses[i].name;
                            res.items.anyOf.push({
                                $ref: this.getChemeRefName(className, isRoot)
                            });
                            this.generateChemaClass(className, schemaDef, false);
                        }
                    }
                    return res;
                };
                JsonMetadata.prototype.getChemeRefName = function(className, isRoot) {
                    //Fix for #6486, according to https://niem.github.io/json/reference/json-schema/references/#:~:text=In%20a%20JSON%20schema%2C%20a,%2C%20an%20in%2Dschema%20reference
                    //Checked by https://www.jsonschemavalidator.net/
                    return isRoot ? "#/definitions/" + className : className;
                };
                JsonMetadata.prototype.generateChemaClass = function(className, schemaDef, isRoot) {
                    if (!!schemaDef[className]) return;
                    var classInfo = this.findClass(className);
                    if (!classInfo) return;
                    var hasParent = !!classInfo.parentName && classInfo.parentName != "base";
                    if (hasParent) this.generateChemaClass(classInfo.parentName, schemaDef, isRoot);
                    var res = {
                        type: "object",
                        $id: className
                    };
                    schemaDef[className] = res;
                    var chemaProps = {
                        properties: {}
                    };
                    this.generateSchemaProperties(classInfo, chemaProps, schemaDef, isRoot);
                    if (hasParent) res.allOf = [
                        {
                            $ref: this.getChemeRefName(classInfo.parentName, isRoot)
                        },
                        {
                            properties: chemaProps.properties
                        }
                    ];
                    else res.properties = chemaProps.properties;
                    if (Array.isArray(chemaProps.required)) res.required = chemaProps.required;
                };
                JsonMetadata.prototype.getChoicesValues = function(enumRes) {
                    var res = new Array();
                    enumRes.forEach(function(item) {
                        if (typeof item === "object" && item.value !== undefined) res.push(item.value);
                        else res.push(item);
                    });
                    return res;
                };
                return JsonMetadata;
            }();
            var JsonError = /** @class */ function() {
                function JsonError(type, message) {
                    this.type = type;
                    this.message = message;
                    this.description = "";
                    this.at = -1;
                    this.end = -1;
                }
                JsonError.prototype.getFullDescription = function() {
                    return this.message + (this.description ? "\n" + this.description : "");
                };
                return JsonError;
            }();
            var JsonUnknownPropertyError = /** @class */ function(_super) {
                __extends(JsonUnknownPropertyError, _super);
                function JsonUnknownPropertyError(propertyName, className) {
                    var _this = _super.call(this, "unknownproperty", "Unknown property in class '" + className + "': '" + propertyName + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.className = className;
                    return _this;
                }
                return JsonUnknownPropertyError;
            }(JsonError);
            var JsonMissingTypeErrorBase = /** @class */ function(_super) {
                __extends(JsonMissingTypeErrorBase, _super);
                function JsonMissingTypeErrorBase(baseClassName, type, message) {
                    var _this = _super.call(this, type, message) || this;
                    _this.baseClassName = baseClassName;
                    _this.type = type;
                    _this.message = message;
                    return _this;
                }
                return JsonMissingTypeErrorBase;
            }(JsonError);
            var JsonMissingTypeError = /** @class */ function(_super) {
                __extends(JsonMissingTypeError, _super);
                function JsonMissingTypeError(propertyName, baseClassName) {
                    var _this = _super.call(this, baseClassName, "missingtypeproperty", "The property type is missing in the object. Please take a look at property: '" + propertyName + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.baseClassName = baseClassName;
                    return _this;
                }
                return JsonMissingTypeError;
            }(JsonMissingTypeErrorBase);
            var JsonIncorrectTypeError = /** @class */ function(_super) {
                __extends(JsonIncorrectTypeError, _super);
                function JsonIncorrectTypeError(propertyName, baseClassName) {
                    var _this = _super.call(this, baseClassName, "incorrecttypeproperty", "The property type is incorrect in the object. Please take a look at property: '" + propertyName + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.baseClassName = baseClassName;
                    return _this;
                }
                return JsonIncorrectTypeError;
            }(JsonMissingTypeErrorBase);
            var JsonRequiredPropertyError = /** @class */ function(_super) {
                __extends(JsonRequiredPropertyError, _super);
                function JsonRequiredPropertyError(propertyName, className) {
                    var _this = _super.call(this, "requiredproperty", "The property '" + propertyName + "' is required in class '" + className + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.className = className;
                    return _this;
                }
                return JsonRequiredPropertyError;
            }(JsonError);
            var JsonRequiredArrayPropertyError = /** @class */ function(_super) {
                __extends(JsonRequiredArrayPropertyError, _super);
                function JsonRequiredArrayPropertyError(propertyName, className) {
                    var _this = _super.call(this, "arrayproperty", "The property '" + propertyName + "' should be an array in '" + className + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.className = className;
                    return _this;
                }
                return JsonRequiredArrayPropertyError;
            }(JsonError);
            var JsonIncorrectPropertyValueError = /** @class */ function(_super) {
                __extends(JsonIncorrectPropertyValueError, _super);
                function JsonIncorrectPropertyValueError(property, value) {
                    var _this = _super.call(this, "incorrectvalue", "The property value: '" + value + "' is incorrect for property '" + property.name + "'.") || this;
                    _this.property = property;
                    _this.value = value;
                    return _this;
                }
                return JsonIncorrectPropertyValueError;
            }(JsonError);
            var JsonObject = /** @class */ function() {
                function JsonObject() {
                    this.errors = new Array();
                    this.lightSerializing = false;
                }
                Object.defineProperty(JsonObject, "metaData", {
                    get: function() {
                        return JsonObject.metaDataValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObject.prototype.toJsonObject = function(obj, options) {
                    return this.toJsonObjectCore(obj, null, options);
                };
                JsonObject.prototype.toObject = function(jsonObj, obj, options) {
                    this.toObjectCore(jsonObj, obj, options);
                    var error = this.getRequiredError(obj, jsonObj);
                    if (!!error) this.addNewError(error, jsonObj, obj);
                };
                JsonObject.prototype.toObjectCore = function(jsonObj, obj, options) {
                    if (!jsonObj) return;
                    var properties = null;
                    var objType = undefined;
                    var needAddErrors = true;
                    if (obj.getType) {
                        objType = obj.getType();
                        properties = Serializer.getProperties(objType);
                        needAddErrors = !!objType && !Serializer.isDescendantOf(objType, "itemvalue");
                    }
                    if (!properties) return;
                    if (obj.startLoadingFromJson) obj.startLoadingFromJson(jsonObj);
                    properties = this.addDynamicProperties(obj, jsonObj, properties);
                    this.options = options;
                    for(var key in jsonObj){
                        if (key === JsonObject.typePropertyName) continue;
                        if (key === JsonObject.positionPropertyName) {
                            obj[key] = jsonObj[key];
                            continue;
                        }
                        var property = this.findProperty(properties, key);
                        if (!property) {
                            if (needAddErrors) this.addNewError(new JsonUnknownPropertyError(key.toString(), objType), jsonObj, obj);
                            continue;
                        }
                        this.valueToObj(jsonObj[key], obj, property, jsonObj, options);
                    }
                    this.options = undefined;
                    if (obj.endLoadingFromJson) obj.endLoadingFromJson();
                };
                JsonObject.prototype.toJsonObjectCore = function(obj, property, options) {
                    if (!obj || !obj.getType) return obj;
                    if (typeof obj.getData === "function") return obj.getData();
                    var result = {};
                    if (property != null && !property.className) result[JsonObject.typePropertyName] = property.getObjType(obj.getType());
                    var storeDefaults = options === true;
                    if (!options || options === true) options = {};
                    if (storeDefaults) options.storeDefaults = storeDefaults;
                    this.propertiesToJson(obj, Serializer.getProperties(obj.getType()), result, options);
                    this.propertiesToJson(obj, this.getDynamicProperties(obj), result, options);
                    return result;
                };
                JsonObject.prototype.getDynamicProperties = function(obj) {
                    return Serializer.getDynamicPropertiesByObj(obj);
                };
                JsonObject.prototype.addDynamicProperties = function(obj, jsonObj, props) {
                    if (!obj.getDynamicPropertyName && !obj.getDynamicProperties) return props;
                    if (obj.getDynamicPropertyName) {
                        var dynamicPropName = obj.getDynamicPropertyName();
                        if (!dynamicPropName) return props;
                        if (dynamicPropName && jsonObj[dynamicPropName]) obj[dynamicPropName] = jsonObj[dynamicPropName];
                    }
                    var dynamicProps = this.getDynamicProperties(obj);
                    return dynamicProps.length === 0 ? props : [].concat(props).concat(dynamicProps);
                };
                JsonObject.prototype.propertiesToJson = function(obj, properties, json, options) {
                    for(var i = 0; i < properties.length; i++)this.valueToJson(obj, json, properties[i], options);
                };
                JsonObject.prototype.valueToJson = function(obj, result, prop, options) {
                    if (!options) options = {};
                    if (prop.isSerializable === false || prop.isLightSerializable === false && this.lightSerializing) return;
                    if (options.version && !prop.isAvailableInVersion(options.version)) return;
                    this.valueToJsonCore(obj, result, prop, options);
                };
                JsonObject.prototype.valueToJsonCore = function(obj, result, prop, options) {
                    var serProp = prop.getSerializedProperty(obj, options.version);
                    if (serProp && serProp !== prop) {
                        this.valueToJsonCore(obj, result, serProp, options);
                        return;
                    }
                    var value = prop.getSerializableValue(obj);
                    if (!options.storeDefaults && prop.isDefaultValueByObj(obj, value)) return;
                    if (this.isValueArray(value)) {
                        var arrValue = [];
                        for(var i = 0; i < value.length; i++)arrValue.push(this.toJsonObjectCore(value[i], prop, options));
                        value = arrValue.length > 0 ? arrValue : null;
                    } else value = this.toJsonObjectCore(value, prop, options);
                    if (value === undefined || value === null) return;
                    var name = prop.getSerializedName(options.version);
                    var hasValue = typeof obj["getPropertyValue"] === "function" && obj["getPropertyValue"](name, null) !== null;
                    if (options.storeDefaults && hasValue || !prop.isDefaultValueByObj(obj, value)) {
                        if (!Serializer.onSerializingProperty || !Serializer.onSerializingProperty(obj, prop, value, result)) result[name] = this.removePosOnValueToJson(prop, value);
                    }
                };
                JsonObject.prototype.valueToObj = function(value, obj, property, jsonObj, options) {
                    if (value === null || value === undefined) return;
                    this.removePos(property, value);
                    if (property != null && property.hasToUseSetValue) {
                        property.setValue(obj, value, this);
                        return;
                    }
                    if (property.isArray && !Array.isArray(value) && !!value) {
                        value = [
                            value
                        ];
                        var propName = !!jsonObj && property.alternativeName && !!jsonObj[property.alternativeName] ? property.alternativeName : property.name;
                        this.addNewError(new JsonRequiredArrayPropertyError(propName, obj.getType()), !!jsonObj ? jsonObj : value, obj);
                    }
                    if (this.isValueArray(value)) {
                        this.valueToArray(value, obj, property.name, property, options);
                        return;
                    }
                    var newObj = this.createNewObj(value, property);
                    if (newObj.newObj) {
                        this.toObjectCore(value, newObj.newObj, options);
                        value = newObj.newObj;
                    }
                    if (!newObj.error) {
                        if (property != null) {
                            property.setValue(obj, value, this);
                            if (!!options && options.validatePropertyValues) {
                                if (!property.validateValue(value)) this.addNewError(new JsonIncorrectPropertyValueError(property, value), jsonObj, obj);
                            }
                        } else obj[property.name] = value;
                    }
                };
                JsonObject.prototype.removePosOnValueToJson = function(property, value) {
                    if (!property.isCustom || !value) return value;
                    this.removePosFromObj(value);
                    return value;
                };
                JsonObject.prototype.removePos = function(property, value) {
                    if (!property || !property.type || property.type.indexOf("value") < 0) return;
                    this.removePosFromObj(value);
                };
                JsonObject.prototype.removePosFromObj = function(obj) {
                    if (!obj) return;
                    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)this.removePosFromObj(obj[i]);
                    if (typeof obj !== "object") return;
                    if (!!obj[JsonObject.positionPropertyName]) delete obj[JsonObject.positionPropertyName];
                    for(var key in obj)this.removePosFromObj(obj[key]);
                };
                JsonObject.prototype.isValueArray = function(value) {
                    return value && Array.isArray(value);
                };
                JsonObject.prototype.createNewObj = function(value, property) {
                    var result = {
                        newObj: null,
                        error: null
                    };
                    var className = this.getClassNameForNewObj(value, property);
                    result.newObj = className ? Serializer.createClass(className, value) : null;
                    result.error = this.checkNewObjectOnErrors(result.newObj, value, property, className);
                    return result;
                };
                JsonObject.prototype.getClassNameForNewObj = function(value, property) {
                    var res = property != null && property.className ? property.className : undefined;
                    if (!res) res = value[JsonObject.typePropertyName];
                    if (!res) return res;
                    res = res.toLowerCase();
                    var classNamePart = property.classNamePart;
                    if (classNamePart && res.indexOf(classNamePart) < 0) res += classNamePart;
                    return res;
                };
                JsonObject.prototype.checkNewObjectOnErrors = function(newObj, value, property, className) {
                    var error = null;
                    if (newObj) error = this.getRequiredError(newObj, value);
                    else if (property.baseClassName) {
                        if (!className) error = new JsonMissingTypeError(property.name, property.baseClassName);
                        else error = new JsonIncorrectTypeError(property.name, property.baseClassName);
                    }
                    if (error) this.addNewError(error, value, newObj);
                    return error;
                };
                JsonObject.prototype.getRequiredError = function(obj, jsonValue) {
                    if (!obj.getType || typeof obj.getData === "function") return null;
                    var metaClass = Serializer.findClass(obj.getType());
                    if (!metaClass) return null;
                    var props = metaClass.getRequiredProperties();
                    if (!Array.isArray(props)) return null;
                    for(var i = 0; i < props.length; i++){
                        var prop = props[i];
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(prop.defaultValue)) continue;
                        if (!jsonValue[prop.name]) return new JsonRequiredPropertyError(prop.name, obj.getType());
                    }
                    return null;
                };
                JsonObject.prototype.addNewError = function(error, jsonObj, element) {
                    error.jsonObj = jsonObj;
                    error.element = element;
                    this.errors.push(error);
                    if (!jsonObj) return;
                    var posObj = jsonObj[JsonObject.positionPropertyName];
                    if (!posObj) return;
                    error.at = posObj.start;
                    error.end = posObj.end;
                };
                JsonObject.prototype.valueToArray = function(value, obj, key, property, options) {
                    if (obj[key] && !this.isValueArray(obj[key])) return;
                    if (obj[key] && value.length > 0) obj[key].splice(0, obj[key].length);
                    var valueRes = obj[key] ? obj[key] : [];
                    this.addValuesIntoArray(value, valueRes, property, options);
                    if (!obj[key]) obj[key] = valueRes;
                };
                JsonObject.prototype.addValuesIntoArray = function(value, result, property, options) {
                    for(var i = 0; i < value.length; i++){
                        var newValue = this.createNewObj(value[i], property);
                        if (newValue.newObj) {
                            if (!!value[i].name) newValue.newObj.name = value[i].name;
                            if (!!value[i].valueName) newValue.newObj.valueName = value[i].valueName.toString();
                            result.push(newValue.newObj);
                            this.toObjectCore(value[i], newValue.newObj, options);
                        } else if (!newValue.error) result.push(value[i]);
                    }
                };
                JsonObject.prototype.findProperty = function(properties, key) {
                    if (!properties) return null;
                    for(var i = 0; i < properties.length; i++){
                        var prop = properties[i];
                        if (prop.name == key || prop.alternativeName == key) return prop;
                    }
                    return null;
                };
                JsonObject.typePropertyName = "type";
                JsonObject.positionPropertyName = "pos";
                JsonObject.metaDataValue = new JsonMetadata();
                return JsonObject;
            }();
            /**
 * An alias for the metadata object. It contains object properties' runtime information and allows you to modify it.
 * @see JsonMetadata
 */ var Serializer = JsonObject.metaData;
        /***/ },
        /***/ "./src/list.ts": /*!*********************!*\
  !*** ./src/list.ts ***!
  \*********************/ /*! exports provided: defaultListCss, ListModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultListCss", function() {
                return defaultListCss;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListModel", function() {
                return ListModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _element_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./element-helper */ "./src/element-helper.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var defaultListCss = {
                root: "sv-list__container",
                item: "sv-list__item",
                searchClearButtonIcon: "sv-list__filter-clear-button",
                loadingIndicator: "sv-list__loading-indicator",
                itemSelected: "sv-list__item--selected",
                itemWithIcon: "sv-list__item--with-icon",
                itemDisabled: "sv-list__item--disabled",
                itemFocused: "sv-list__item--focused",
                itemTextWrap: "sv-list__item-text--wrap",
                itemIcon: "sv-list__item-icon",
                itemSeparator: "sv-list__item-separator",
                itemBody: "sv-list__item-body",
                itemsContainer: "sv-list",
                itemsContainerFiltering: "sv-list--filtering",
                filter: "sv-list__filter",
                filterIcon: "sv-list__filter-icon",
                filterInput: "sv-list__input",
                emptyContainer: "sv-list__empty-container",
                emptyText: "sv-list__empty-text"
            };
            var ListModel = /** @class */ function(_super) {
                __extends(ListModel, _super);
                function ListModel(items, onSelectionChanged, allowSelection, selectedItem, onFilterStringChangedCallback, elementId) {
                    var _this = _super.call(this) || this;
                    _this.onSelectionChanged = onSelectionChanged;
                    _this.allowSelection = allowSelection;
                    _this.onFilterStringChangedCallback = onFilterStringChangedCallback;
                    _this.elementId = elementId;
                    _this.onItemClick = function(itemValue) {
                        if (_this.isItemDisabled(itemValue)) return;
                        _this.isExpanded = false;
                        if (_this.allowSelection) _this.selectedItem = itemValue;
                        if (!!_this.onSelectionChanged) _this.onSelectionChanged(itemValue);
                    };
                    _this.isItemDisabled = function(itemValue) {
                        return itemValue.enabled !== undefined && !itemValue.enabled;
                    };
                    _this.isItemSelected = function(itemValue) {
                        return _this.areSameItems(_this.selectedItem, itemValue);
                    };
                    _this.isItemFocused = function(itemValue) {
                        return _this.areSameItems(_this.focusedItem, itemValue);
                    };
                    _this.getListClass = function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(_this.cssClasses.itemsContainer).append(_this.cssClasses.itemsContainerFiltering, !!_this.filterString && _this.visibleActions.length !== _this.visibleItems.length).toString();
                    };
                    _this.getItemClass = function(itemValue) {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(_this.cssClasses.item).append(_this.cssClasses.itemWithIcon, !!itemValue.iconName).append(_this.cssClasses.itemDisabled, _this.isItemDisabled(itemValue)).append(_this.cssClasses.itemFocused, _this.isItemFocused(itemValue)).append(_this.cssClasses.itemSelected, _this.isItemSelected(itemValue)).append(_this.cssClasses.itemTextWrap, _this.textWrapEnabled).append(itemValue.css).toString();
                    };
                    _this.getItemIndent = function(itemValue) {
                        var level = itemValue.level || 0;
                        return (level + 1) * ListModel.INDENT + "px";
                    };
                    _this.setItems(items);
                    _this.selectedItem = selectedItem;
                    return _this;
                }
                ListModel.prototype.hasText = function(item, filterStringInLow) {
                    if (!filterStringInLow) return true;
                    var text = item.title || "";
                    if (this.onTextSearchCallback) return this.onTextSearchCallback(item, filterStringInLow);
                    var textInLow = text.toLocaleLowerCase();
                    textInLow = _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].comparator.normalizeTextCallback(textInLow, "filter");
                    return textInLow.indexOf(filterStringInLow.toLocaleLowerCase()) > -1;
                };
                ListModel.prototype.isItemVisible = function(item) {
                    return item.visible && (!this.shouldProcessFilter || this.hasText(item, this.filterString));
                };
                Object.defineProperty(ListModel.prototype, "visibleItems", {
                    get: function() {
                        var _this = this;
                        return this.visibleActions.filter(function(item) {
                            return _this.isItemVisible(item);
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "shouldProcessFilter", {
                    get: function() {
                        return !this.onFilterStringChangedCallback;
                    },
                    enumerable: false,
                    configurable: true
                });
                ListModel.prototype.onFilterStringChanged = function(text) {
                    var _this = this;
                    if (!!this.onFilterStringChangedCallback) this.onFilterStringChangedCallback(text);
                    this.isEmpty = this.renderedActions.filter(function(action) {
                        return _this.isItemVisible(action);
                    }).length === 0;
                };
                ListModel.prototype.scrollToItem = function(selector, ms) {
                    var _this = this;
                    if (ms === void 0) ms = 0;
                    setTimeout(function() {
                        if (!_this.listContainerHtmlElement) return;
                        var item = _this.listContainerHtmlElement.querySelector("." + selector);
                        if (item) setTimeout(function() {
                            item.scrollIntoView({
                                behavior: "smooth",
                                block: "nearest",
                                inline: "start"
                            });
                        }, ms);
                    }, ms);
                };
                ListModel.prototype.setOnFilterStringChangedCallback = function(callback) {
                    this.onFilterStringChangedCallback = callback;
                };
                ListModel.prototype.setOnTextSearchCallback = function(callback) {
                    this.onTextSearchCallback = callback;
                };
                ListModel.prototype.setItems = function(items, sortByVisibleIndex) {
                    var _this = this;
                    if (sortByVisibleIndex === void 0) sortByVisibleIndex = true;
                    _super.prototype.setItems.call(this, items, sortByVisibleIndex);
                    if (this.elementId) this.renderedActions.forEach(function(action) {
                        action.elementId = _this.elementId + action.id;
                    });
                    if (!this.isAllDataLoaded && !!this.actions.length) this.actions.push(this.loadingIndicator);
                };
                ListModel.prototype.onSet = function() {
                    this.showFilter = this.searchEnabled && (this.forceShowFilter || (this.actions || []).length > ListModel.MINELEMENTCOUNT);
                    _super.prototype.onSet.call(this);
                };
                ListModel.prototype.getDefaultCssClasses = function() {
                    return defaultListCss;
                };
                ListModel.prototype.areSameItems = function(item1, item2) {
                    if (!!this.areSameItemsCallback) return this.areSameItemsCallback(item1, item2);
                    return !!item1 && !!item2 && item1.id == item2.id;
                };
                Object.defineProperty(ListModel.prototype, "filterStringPlaceholder", {
                    get: function() {
                        return this.getLocalizationString("filterStringPlaceholder");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "emptyMessage", {
                    get: function() {
                        return this.isAllDataLoaded ? this.getLocalizationString("emptyMessage") : this.loadingText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "scrollableContainer", {
                    get: function() {
                        return this.listContainerHtmlElement.querySelector("." + this.getDefaultCssClasses().itemsContainer);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "loadingText", {
                    get: function() {
                        return this.getLocalizationString("loadingFile");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "loadingIndicator", {
                    get: function() {
                        if (!this.loadingIndicatorValue) this.loadingIndicatorValue = new _actions_action__WEBPACK_IMPORTED_MODULE_2__["Action"]({
                            id: "loadingIndicator",
                            title: this.loadingText,
                            action: function() {},
                            css: this.cssClasses.loadingIndicator
                        });
                        return this.loadingIndicatorValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ListModel.prototype.goToItems = function(event1) {
                    if (event1.key === "ArrowDown" || event1.keyCode === 40) {
                        var currentElement = event1.target.parentElement;
                        var listElement = currentElement.parentElement.querySelector("ul");
                        var firstChild = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_5__["getFirstVisibleChild"])(listElement);
                        if (!!listElement && !!firstChild) {
                            _element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].focusElement(firstChild);
                            event1.preventDefault();
                        }
                    }
                };
                ListModel.prototype.onMouseMove = function(event1) {
                    this.resetFocusedItem();
                };
                ListModel.prototype.onKeyDown = function(event1) {
                    var currentElement = event1.target;
                    if (event1.key === "ArrowDown" || event1.keyCode === 40) {
                        _element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].focusElement(_element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].getNextElementPreorder(currentElement));
                        event1.preventDefault();
                    } else if (event1.key === "ArrowUp" || event1.keyCode === 38) {
                        _element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].focusElement(_element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].getNextElementPostorder(currentElement));
                        event1.preventDefault();
                    }
                };
                ListModel.prototype.onPointerDown = function(event1, item) {};
                ListModel.prototype.refresh = function() {
                    this.filterString = "";
                    this.resetFocusedItem();
                };
                ListModel.prototype.onClickSearchClearButton = function(event1) {
                    event1.currentTarget.parentElement.querySelector("input").focus();
                    this.refresh();
                };
                ListModel.prototype.resetFocusedItem = function() {
                    this.focusedItem = undefined;
                };
                ListModel.prototype.focusFirstVisibleItem = function() {
                    this.focusedItem = this.visibleItems[0];
                };
                ListModel.prototype.focusLastVisibleItem = function() {
                    this.focusedItem = this.visibleItems[this.visibleItems.length - 1];
                };
                ListModel.prototype.initFocusedItem = function() {
                    var _this = this;
                    this.focusedItem = this.visibleItems.filter(function(item) {
                        return item.visible && _this.isItemSelected(item);
                    })[0];
                    if (!this.focusedItem) this.focusFirstVisibleItem();
                };
                ListModel.prototype.focusNextVisibleItem = function() {
                    if (!this.focusedItem) this.initFocusedItem();
                    else {
                        var items = this.visibleItems;
                        var currentFocusedItemIndex = items.indexOf(this.focusedItem);
                        var nextItem = items[currentFocusedItemIndex + 1];
                        if (nextItem) this.focusedItem = nextItem;
                        else this.focusFirstVisibleItem();
                    }
                };
                ListModel.prototype.focusPrevVisibleItem = function() {
                    if (!this.focusedItem) this.initFocusedItem();
                    else {
                        var items = this.visibleItems;
                        var currentFocusedItemIndex = items.indexOf(this.focusedItem);
                        var prevItem = items[currentFocusedItemIndex - 1];
                        if (prevItem) this.focusedItem = prevItem;
                        else this.focusLastVisibleItem();
                    }
                };
                ListModel.prototype.selectFocusedItem = function() {
                    !!this.focusedItem && this.onItemClick(this.focusedItem);
                };
                ListModel.prototype.initListContainerHtmlElement = function(htmlElement) {
                    this.listContainerHtmlElement = htmlElement;
                };
                ListModel.prototype.onLastItemRended = function(item) {
                    if (this.isAllDataLoaded) return;
                    if (item === this.actions[this.actions.length - 1] && !!this.listContainerHtmlElement) this.hasVerticalScroller = _element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].hasVerticalScroller(this.scrollableContainer);
                };
                ListModel.prototype.scrollToFocusedItem = function() {
                    this.scrollToItem(this.getDefaultCssClasses().itemFocused);
                };
                ListModel.prototype.scrollToSelectedItem = function() {
                    this.scrollToItem(this.getDefaultCssClasses().itemSelected, 110);
                };
                ListModel.prototype.addScrollEventListener = function(handler) {
                    if (!!handler) this.scrollHandler = handler;
                    if (!!this.scrollHandler) this.scrollableContainer.addEventListener("scroll", this.scrollHandler);
                };
                ListModel.prototype.removeScrollEventListener = function() {
                    if (!!this.scrollHandler) this.scrollableContainer.removeEventListener("scroll", this.scrollHandler);
                };
                ListModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (!!this.loadingIndicatorValue) this.loadingIndicatorValue.dispose();
                    this.listContainerHtmlElement = undefined;
                };
                ListModel.INDENT = 16;
                ListModel.MINELEMENTCOUNT = 10;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true,
                        onSet: function(newValue, target) {
                            target.onSet();
                        }
                    })
                ], ListModel.prototype, "searchEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "showFilter", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "forceShowFilter", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "isExpanded", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], ListModel.prototype, "selectedItem", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], ListModel.prototype, "focusedItem", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        onSet: function(_, target) {
                            target.onFilterStringChanged(target.filterString);
                        }
                    })
                ], ListModel.prototype, "filterString", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "hasVerticalScroller", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], ListModel.prototype, "isAllDataLoaded", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "showSearchClearButton", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], ListModel.prototype, "renderElements", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "textWrapEnabled", void 0);
                return ListModel;
            }(_actions_container__WEBPACK_IMPORTED_MODULE_1__["ActionContainer"]);
        /***/ },
        /***/ "./src/localizablestring.ts": /*!**********************************!*\
  !*** ./src/localizablestring.ts ***!
  \**********************************/ /*! exports provided: LocalizableString, LocalizableStrings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalizableString", function() {
                return LocalizableString;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalizableStrings", function() {
                return LocalizableStrings;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /**
 * The class represents the string that supports multi-languages and markdown.
 * It uses in all objects where support for multi-languages and markdown is required.
 */ var LocalizableString = /** @class */ function() {
                function LocalizableString(owner, useMarkdown, name) {
                    if (useMarkdown === void 0) useMarkdown = false;
                    var _a;
                    this.owner = owner;
                    this.useMarkdown = useMarkdown;
                    this.name = name;
                    this.values = {};
                    this.htmlValues = {};
                    this._allowLineBreaks = false;
                    this.onStringChanged = new _base__WEBPACK_IMPORTED_MODULE_3__["EventBase"]();
                    if (owner instanceof _survey_element__WEBPACK_IMPORTED_MODULE_5__["SurveyElementCore"]) this._allowLineBreaks = ((_a = _jsonobject__WEBPACK_IMPORTED_MODULE_4__["Serializer"].findProperty(owner.getType(), name)) === null || _a === void 0 ? void 0 : _a.type) == "text";
                    this.onCreating();
                }
                Object.defineProperty(LocalizableString, "defaultLocale", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "localizationName", {
                    get: function() {
                        return this._localizationName;
                    },
                    set: function(val1) {
                        if (this._localizationName != val1) {
                            this._localizationName = val1;
                            this.strChanged();
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "allowLineBreaks", {
                    get: function() {
                        return this._allowLineBreaks;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.getIsMultiple = function() {
                    return false;
                };
                Object.defineProperty(LocalizableString.prototype, "locale", {
                    get: function() {
                        if (this.owner && this.owner.getLocale) {
                            var res = this.owner.getLocale();
                            if (!!res || !this.sharedData) return res;
                        }
                        if (!!this.sharedData) return this.sharedData.locale;
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.strChanged = function() {
                    this.searchableText = undefined;
                    if (this.renderedText === undefined) return;
                    this.calculatedTextValue = this.calcText();
                    if (this.renderedText !== this.calculatedTextValue) {
                        this.renderedText = undefined;
                        this.calculatedTextValue = undefined;
                    }
                    this.htmlValues = {};
                    this.onChanged();
                    this.onStringChanged.fire(this, {});
                };
                Object.defineProperty(LocalizableString.prototype, "text", {
                    get: function() {
                        return this.pureText;
                    },
                    set: function(value) {
                        this.setLocaleText(this.locale, value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "calculatedText", {
                    get: function() {
                        this.renderedText = this.calculatedTextValue !== undefined ? this.calculatedTextValue : this.calcText();
                        this.calculatedTextValue = undefined;
                        return this.renderedText;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.calcText = function() {
                    var res = this.pureText;
                    if (res && this.owner && this.owner.getProcessedText && res.indexOf("{") > -1) res = this.owner.getProcessedText(res);
                    if (this.onGetTextCallback) res = this.onGetTextCallback(res);
                    return res;
                };
                Object.defineProperty(LocalizableString.prototype, "pureText", {
                    get: function() {
                        var loc = this.locale;
                        if (!loc) loc = this.defaultLoc;
                        var res = this.getValue(loc);
                        if (this.isValueEmpty(res) && loc === this.defaultLoc) res = this.getValue(_surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].defaultLocale);
                        if (this.isValueEmpty(res)) {
                            var dialect = this.getRootDialect(loc);
                            if (!!dialect) res = this.getValue(dialect);
                        }
                        if (this.isValueEmpty(res) && loc !== this.defaultLoc) res = this.getValue(this.defaultLoc);
                        if (this.isValueEmpty(res) && !!this.getLocalizationName()) {
                            res = this.getLocalizationStr();
                            if (!!this.onGetLocalizationTextCallback) res = this.onGetLocalizationTextCallback(res);
                        }
                        if (!res) res = this.defaultValue || "";
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.getRootDialect = function(loc) {
                    if (!loc) return loc;
                    var index = loc.indexOf("-");
                    return index > -1 ? loc.substring(0, index) : "";
                };
                LocalizableString.prototype.getLocalizationName = function() {
                    return !!this.sharedData ? this.sharedData.localizationName : this.localizationName;
                };
                LocalizableString.prototype.getLocalizationStr = function() {
                    var name = this.getLocalizationName();
                    return !!name ? _surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].getString(name, this.locale) : "";
                };
                Object.defineProperty(LocalizableString.prototype, "hasHtml", {
                    get: function() {
                        return this.hasHtmlValue();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "html", {
                    get: function() {
                        if (!this.hasHtml) return "";
                        return this.getHtmlValue();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "isEmpty", {
                    get: function() {
                        return this.getValuesKeys().length == 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "textOrHtml", {
                    get: function() {
                        return this.hasHtml ? this.getHtmlValue() : this.calculatedText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "renderedHtml", {
                    get: function() {
                        return this.textOrHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.getLocaleText = function(loc) {
                    var res = this.getLocaleTextCore(loc);
                    return res ? res : "";
                };
                LocalizableString.prototype.getLocaleTextCore = function(loc) {
                    if (!loc) loc = this.defaultLoc;
                    return this.getValue(loc);
                };
                LocalizableString.prototype.isLocaleTextEqualsWithDefault = function(loc, val1) {
                    var res = this.getLocaleTextCore(loc);
                    if (res === val1) return true;
                    return this.isValueEmpty(res) && this.isValueEmpty(val1);
                };
                LocalizableString.prototype.clear = function() {
                    this.setJson(undefined);
                };
                LocalizableString.prototype.clearLocale = function(loc) {
                    this.setLocaleText(loc, undefined);
                };
                LocalizableString.prototype.setLocaleText = function(loc, value) {
                    loc = this.getValueLoc(loc);
                    if (!this.storeDefaultText && this.isLocaleTextEqualsWithDefault(loc, value)) {
                        if (!this.isValueEmpty(value) || !!loc && loc !== this.defaultLoc) return;
                        var dl = _surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].defaultLocale;
                        var oldValue_1 = this.getValue(dl);
                        if (!!dl && !this.isValueEmpty(oldValue_1)) {
                            this.setValue(dl, value);
                            this.fireStrChanged(dl, oldValue_1);
                        }
                        return;
                    }
                    if (!_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.storeDuplicatedTranslations && !this.isValueEmpty(value) && loc && loc != this.defaultLoc && !this.getValue(loc) && value == this.getLocaleText(this.defaultLoc)) return;
                    var curLoc = this.curLocale;
                    if (!loc) loc = this.defaultLoc;
                    var oldValue = this.onStrChanged && loc === curLoc ? this.pureText : undefined;
                    delete this.htmlValues[loc];
                    if (this.isValueEmpty(value)) this.deleteValue(loc);
                    else if (typeof value === "string") {
                        if (this.canRemoveLocValue(loc, value)) this.setLocaleText(loc, null);
                        else {
                            this.setValue(loc, value);
                            if (loc == this.defaultLoc) this.deleteValuesEqualsToDefault(value);
                        }
                    }
                    this.fireStrChanged(loc, oldValue);
                };
                LocalizableString.prototype.isValueEmpty = function(val1) {
                    if (val1 === undefined || val1 === null) return true;
                    if (this.localizationName) return false;
                    return val1 === "";
                };
                Object.defineProperty(LocalizableString.prototype, "curLocale", {
                    get: function() {
                        return !!this.locale ? this.locale : this.defaultLoc;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.canRemoveLocValue = function(loc, val1) {
                    if (_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.storeDuplicatedTranslations) return false;
                    if (loc === this.defaultLoc) return false;
                    var dialect = this.getRootDialect(loc);
                    if (!!dialect) {
                        var dialectVal = this.getLocaleText(dialect);
                        if (!!dialectVal) return dialectVal == val1;
                        return this.canRemoveLocValue(dialect, val1);
                    } else return val1 == this.getLocaleText(this.defaultLoc);
                };
                LocalizableString.prototype.fireStrChanged = function(loc, oldValue) {
                    this.strChanged();
                    if (!this.onStrChanged) return;
                    var value = this.pureText;
                    if (loc !== this.curLocale || oldValue !== value) this.onStrChanged(oldValue, value);
                };
                LocalizableString.prototype.hasNonDefaultText = function() {
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return false;
                    return keys.length > 1 || keys[0] != this.defaultLoc;
                };
                LocalizableString.prototype.getLocales = function() {
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return [];
                    return keys;
                };
                LocalizableString.prototype.getJson = function() {
                    if (!!this.sharedData) return this.sharedData.getJson();
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return null;
                    if (keys.length == 1 && keys[0] == _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName && !_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].serialization.localizableStringSerializeAsObject) return this.values[keys[0]];
                    var res = {};
                    for(var key in this.values)res[key] = this.values[key];
                    return res;
                };
                LocalizableString.prototype.setJson = function(value) {
                    if (!!this.sharedData) {
                        this.sharedData.setJson(value);
                        return;
                    }
                    this.values = {};
                    this.htmlValues = {};
                    if (value === null || value === undefined) return;
                    if (typeof value === "string") this.setLocaleText(null, value);
                    else for(var key in value)this.setLocaleText(key, value[key]);
                    this.strChanged();
                };
                Object.defineProperty(LocalizableString.prototype, "renderAs", {
                    get: function() {
                        if (!this.owner || typeof this.owner.getRenderer !== "function") return LocalizableString.defaultRenderer;
                        return this.owner.getRenderer(this.name) || LocalizableString.defaultRenderer;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "renderAsData", {
                    get: function() {
                        if (!this.owner || typeof this.owner.getRendererContext !== "function") return this;
                        return this.owner.getRendererContext(this) || this;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.equals = function(obj) {
                    if (!!this.sharedData) return this.sharedData.equals(obj);
                    if (!obj || !obj.values) return false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(this.values, obj.values, false, true, false);
                };
                LocalizableString.prototype.setFindText = function(text) {
                    if (this.searchText == text) return;
                    this.searchText = text;
                    if (!this.searchableText) {
                        var textOrHtml = this.textOrHtml;
                        this.searchableText = !!textOrHtml ? textOrHtml.toLowerCase() : "";
                    }
                    var str = this.searchableText;
                    var index = !!str && !!text ? str.indexOf(text) : undefined;
                    if (index < 0) index = undefined;
                    if (index != undefined || this.searchIndex != index) {
                        this.searchIndex = index;
                        if (!!this.onSearchChanged) this.onSearchChanged();
                    }
                    return this.searchIndex != undefined;
                };
                LocalizableString.prototype.onChanged = function() {};
                LocalizableString.prototype.onCreating = function() {};
                LocalizableString.prototype.hasHtmlValue = function() {
                    if (!this.owner || !this.useMarkdown) return false;
                    var loc = this.locale;
                    if (!loc) loc = this.defaultLoc;
                    if (this.htmlValues[loc] !== undefined) return !!this.htmlValues[loc];
                    var renderedText = this.calculatedText;
                    if (!renderedText) {
                        this.setHtmlValue(loc, "");
                        return false;
                    }
                    if (!!this.getLocalizationName() && renderedText === this.getLocalizationStr()) {
                        this.setHtmlValue(loc, "");
                        return false;
                    }
                    var res = this.owner.getMarkdownHtml(renderedText, this.name);
                    this.setHtmlValue(loc, res);
                    return !!res;
                };
                LocalizableString.prototype.setHtmlValue = function(loc, val1) {
                    this.htmlValues[loc] = val1;
                };
                LocalizableString.prototype.getHtmlValue = function() {
                    var loc = this.locale;
                    if (!loc) loc = this.defaultLoc;
                    return this.htmlValues[loc];
                };
                LocalizableString.prototype.deleteValuesEqualsToDefault = function(defaultValue) {
                    if (_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.storeDuplicatedTranslations) return;
                    var keys = this.getValuesKeys();
                    for(var i = 0; i < keys.length; i++){
                        if (keys[i] == this.defaultLoc) continue;
                        if (this.getValue(keys[i]) == defaultValue) this.deleteValue(keys[i]);
                    }
                };
                LocalizableString.prototype.getValue = function(loc) {
                    if (!!this.sharedData) return this.sharedData.getValue(loc);
                    return this.values[this.getValueLoc(loc)];
                };
                LocalizableString.prototype.setValue = function(loc, value) {
                    if (!!this.sharedData) this.sharedData.setValue(loc, value);
                    else this.values[this.getValueLoc(loc)] = value;
                };
                LocalizableString.prototype.deleteValue = function(loc) {
                    if (!!this.sharedData) this.sharedData.deleteValue(loc);
                    else delete this.values[this.getValueLoc(loc)];
                };
                LocalizableString.prototype.getValueLoc = function(loc) {
                    if (this.disableLocalization) return _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                    return loc;
                };
                LocalizableString.prototype.getValuesKeys = function() {
                    if (!!this.sharedData) return this.sharedData.getValuesKeys();
                    return Object.keys(this.values);
                };
                Object.defineProperty(LocalizableString.prototype, "defaultLoc", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.SerializeAsObject = false;
                LocalizableString.defaultRenderer = "sv-string-viewer";
                LocalizableString.editableRenderer = "sv-string-editor";
                return LocalizableString;
            }();
            /**
 * The class represents the list of strings that supports multi-languages.
 */ var LocalizableStrings = /** @class */ function() {
                function LocalizableStrings(owner) {
                    this.owner = owner;
                    this.values = {};
                }
                LocalizableStrings.prototype.getIsMultiple = function() {
                    return true;
                };
                Object.defineProperty(LocalizableStrings.prototype, "locale", {
                    get: function() {
                        return this.owner && this.owner.getLocale ? this.owner.getLocale() : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableStrings.prototype, "value", {
                    get: function() {
                        return this.getValue("");
                    },
                    set: function(val1) {
                        this.setValue("", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableStrings.prototype, "text", {
                    get: function() {
                        return Array.isArray(this.value) ? this.value.join("\n") : "";
                    },
                    set: function(val1) {
                        this.value = !!val1 ? val1.split("\n") : [];
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableStrings.prototype.getLocaleText = function(loc) {
                    var res = this.getValueCore(loc, !loc || loc === this.locale);
                    if (!res || !Array.isArray(res) || res.length == 0) return "";
                    return res.join("\n");
                };
                LocalizableStrings.prototype.setLocaleText = function(loc, newValue) {
                    var val1 = !!newValue ? newValue.split("\n") : null;
                    this.setValue(loc, val1);
                };
                LocalizableStrings.prototype.getValue = function(loc) {
                    return this.getValueCore(loc);
                };
                LocalizableStrings.prototype.getValueCore = function(loc, useDefault) {
                    if (useDefault === void 0) useDefault = true;
                    loc = this.getLocale(loc);
                    if (this.values[loc]) return this.values[loc];
                    if (useDefault) {
                        var defLoc = _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                        if (loc !== defLoc && this.values[defLoc]) return this.values[defLoc];
                    }
                    return [];
                };
                LocalizableStrings.prototype.setValue = function(loc, val1) {
                    loc = this.getLocale(loc);
                    var oldValue = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(this.values);
                    if (!val1 || val1.length == 0) delete this.values[loc];
                    else this.values[loc] = val1;
                    if (!!this.onValueChanged) this.onValueChanged(oldValue, this.values);
                };
                LocalizableStrings.prototype.hasValue = function(loc) {
                    if (loc === void 0) loc = "";
                    return !this.isEmpty && this.getValue(loc).length > 0;
                };
                Object.defineProperty(LocalizableStrings.prototype, "isEmpty", {
                    get: function() {
                        return this.getValuesKeys().length == 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableStrings.prototype.getLocale = function(loc) {
                    if (!!loc) return loc;
                    loc = this.locale;
                    return !!loc ? loc : _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                };
                LocalizableStrings.prototype.getLocales = function() {
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return [];
                    return keys;
                };
                LocalizableStrings.prototype.getJson = function() {
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return null;
                    if (keys.length == 1 && keys[0] == _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName && !_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].serialization.localizableStringSerializeAsObject) return this.values[keys[0]];
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(this.values);
                };
                LocalizableStrings.prototype.setJson = function(value) {
                    this.values = {};
                    if (!value) return;
                    if (Array.isArray(value)) this.setValue(null, value);
                    else for(var key in value)this.setValue(key, value[key]);
                };
                LocalizableStrings.prototype.getValuesKeys = function() {
                    return Object.keys(this.values);
                };
                return LocalizableStrings;
            }();
        /***/ },
        /***/ "./src/localization/english.ts": /*!*************************************!*\
  !*** ./src/localization/english.ts ***!
  \*************************************/ /*! exports provided: englishStrings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "englishStrings", function() {
                return englishStrings;
            });
            // Uncomment the line below if you create a custom dictionary
            // import { surveyLocalization } from "survey-core";
            var englishStrings = {
                pagePrevText: "Previous",
                pageNextText: "Next",
                completeText: "Complete",
                previewText: "Preview",
                editText: "Edit",
                startSurveyText: "Start",
                otherItemText: "Other (describe)",
                noneItemText: "None",
                refuseItemText: "Refuse to answer",
                dontKnowItemText: "Don't know",
                selectAllItemText: "Select All",
                progressText: "Page {0} of {1}",
                indexText: "{0} of {1}",
                panelDynamicProgressText: "{0} of {1}",
                panelDynamicTabTextFormat: "Panel {panelIndex}",
                questionsProgressText: "Answered {0}/{1} questions",
                emptySurvey: "The survey doesn't contain any visible elements.",
                completingSurvey: "Thank you for completing the survey",
                completingSurveyBefore: "Our records show that you have already completed this survey.",
                loadingSurvey: "Loading Survey...",
                placeholder: "Select...",
                ratingOptionsCaption: "Select...",
                value: "value",
                requiredError: "Response required.",
                requiredErrorInPanel: "Response required: answer at least one question.",
                requiredInAllRowsError: "Response required: answer questions in all rows.",
                eachRowUniqueError: "Each row must have a unique value.",
                numericError: "The value should be numeric.",
                minError: "The value should not be less than {0}",
                maxError: "The value should not be greater than {0}",
                textMinLength: "Please enter at least {0} character(s).",
                textMaxLength: "Please enter no more than {0} character(s).",
                textMinMaxLength: "Please enter at least {0} and no more than {1} characters.",
                minRowCountError: "Please fill in at least {0} row(s).",
                minSelectError: "Please select at least {0} option(s).",
                maxSelectError: "Please select no more than {0} option(s).",
                numericMinMax: "The '{0}' should be at least {1} and at most {2}",
                numericMin: "The '{0}' should be at least {1}",
                numericMax: "The '{0}' should be at most {1}",
                invalidEmail: "Please enter a valid e-mail address.",
                invalidExpression: "The expression: {0} should return 'true'.",
                urlRequestError: "The request returned error '{0}'. {1}",
                urlGetChoicesError: "The request returned empty data or the 'path' property is incorrect",
                exceedMaxSize: "The file size should not exceed {0}.",
                noUploadFilesHandler: "Files cannot be uploaded. Please add a handler for the 'onUploadFiles' event.",
                otherRequiredError: "Response required: enter another value.",
                uploadingFile: "Your file is uploading. Please wait several seconds and try again.",
                loadingFile: "Loading...",
                chooseFile: "Choose file(s)...",
                noFileChosen: "No file chosen",
                filePlaceholder: "Drag and drop a file here or click the button below to select a file to upload.",
                confirmDelete: "Are you sure you want to delete this record?",
                keyDuplicationError: "This value should be unique.",
                addColumn: "Add Column",
                addRow: "Add Row",
                removeRow: "Remove",
                emptyRowsText: "There are no rows.",
                addPanel: "Add new",
                removePanel: "Remove",
                showDetails: "Show Details",
                hideDetails: "Hide Details",
                choices_Item: "item",
                matrix_column: "Column",
                matrix_row: "Row",
                multipletext_itemname: "text",
                savingData: "The results are being saved on the server...",
                savingDataError: "An error occurred and we could not save the results.",
                savingDataSuccess: "The results were saved successfully!",
                saveAgainButton: "Try again",
                timerMin: "min",
                timerSec: "sec",
                timerSpentAll: "You have spent {0} on this page and {1} in total.",
                timerSpentPage: "You have spent {0} on this page.",
                timerSpentSurvey: "You have spent {0} in total.",
                timerLimitAll: "You have spent {0} of {1} on this page and {2} of {3} in total.",
                timerLimitPage: "You have spent {0} of {1} on this page.",
                timerLimitSurvey: "You have spent {0} of {1} in total.",
                clearCaption: "Clear",
                signaturePlaceHolder: "Sign here",
                chooseFileCaption: "Select File",
                takePhotoCaption: "Take Photo",
                photoPlaceholder: "Click the button below to take a photo using the camera.",
                fileOrPhotoPlaceholder: "Drag and drop or select a file to upload or take a photo using the camera.",
                replaceFileCaption: "Replace file",
                removeFileCaption: "Remove this file",
                booleanCheckedLabel: "Yes",
                booleanUncheckedLabel: "No",
                confirmRemoveFile: "Are you sure that you want to remove this file: {0}?",
                confirmRemoveAllFiles: "Are you sure that you want to remove all files?",
                questionTitlePatternText: "Question Title",
                modalCancelButtonText: "Cancel",
                modalApplyButtonText: "Apply",
                filterStringPlaceholder: "Type to search...",
                emptyMessage: "No data to display",
                noEntriesText: "No entries yet.\nClick the button below to add a new entry.",
                noEntriesReadonlyText: "No entries.",
                more: "More",
                tagboxDoneButtonCaption: "OK",
                selectToRankEmptyRankedAreaText: "All choices are selected for ranking",
                selectToRankEmptyUnrankedAreaText: "Drag choices here to rank them",
                ok: "OK",
                cancel: "Cancel"
            };
        // Uncomment the lines below if you create a custom dictionary.
        // Replace "en" with a custom locale code (for example, "fr" or "de"),
        // Replace `englishStrings` with the name of the variable that contains the custom dictionary.
        // surveyLocalization.locales["en"] = englishStrings;
        // surveyLocalization.localeNames["en"] = "English";
        /***/ },
        /***/ "./src/martixBase.ts": /*!***************************!*\
  !*** ./src/martixBase.ts ***!
  \***************************/ /*! exports provided: QuestionMatrixBaseModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixBaseModel", function() {
                return QuestionMatrixBaseModel;
            });
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A base class for all matrix question types.
 */ var QuestionMatrixBaseModel = /** @class */ function(_super) {
                __extends(QuestionMatrixBaseModel, _super);
                function QuestionMatrixBaseModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.generatedVisibleRows = null;
                    _this.generatedTotalRow = null;
                    _this.filteredRows = null;
                    _this.filteredColumns = null;
                    _this.columns = _this.createColumnValues();
                    _this.rows = _this.createItemValues("rows");
                    return _this;
                }
                QuestionMatrixBaseModel.prototype.createColumnValues = function() {
                    return this.createItemValues("columns");
                };
                QuestionMatrixBaseModel.prototype.getType = function() {
                    return "matrixbase";
                };
                QuestionMatrixBaseModel.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    this.updateVisibilityBasedOnRows();
                };
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "isCompositeQuestion", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "showHeader", {
                    /**
         * Specifies whether to display the table header that contains column captions.
         *
         * Default value: `true`
         */ get: function() {
                        return this.getPropertyValue("showHeader");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showHeader", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "columns", {
                    /**
         * An array of matrix columns.
         *
         * For a Single-Select Matrix, the `columns` array can contain configuration objects with the `text` (display value) and `value` (value to be saved in survey results) properties. Alternatively, the array can contain primitive values that will be used as both the display values and values to be saved in survey results.
         *
         * [View "Single-Select Matrix" Demo](https://surveyjs.io/form-library/examples/single-selection-matrix-table-question/ (linkStyle))
         *
         * For a Multi-Select Matrix or Dynamic Matrix, the `columns` array should contain configuration objects with properties described in the [`MatrixDropdownColumn`](https://surveyjs.io/form-library/documentation/api-reference/multi-select-matrix-column-values) API Reference section.
         *
         * [View "Multi-Select Matrix" Demo](https://surveyjs.io/form-library/examples/questiontype-matrixdropdown/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("columns");
                    },
                    set: function(newValue) {
                        this.setPropertyValue("columns", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "visibleColumns", {
                    get: function() {
                        return !!this.filteredColumns ? this.filteredColumns : this.columns;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "rows", {
                    /**
         * An array of matrix rows.
         *
         * This array can contain primitive values or objects with the `text` (display value) and `value` (value to be saved in survey results) properties.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/single-selection-matrix-table-question/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("rows");
                    },
                    set: function(newValue) {
                        var newRows = this.processRowsOnSet(newValue);
                        this.setPropertyValue("rows", newRows);
                        this.filterItems();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixBaseModel.prototype.processRowsOnSet = function(newRows) {
                    return newRows;
                };
                QuestionMatrixBaseModel.prototype.getVisibleRows = function() {
                    return [];
                };
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "visibleRows", {
                    /**
         * Returns an array of visible matrix rows.
         * @see rowsVisibleIf
         */ get: function() {
                        return this.getVisibleRows();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "rowsVisibleIf", {
                    /**
         * A Boolean expression that is evaluated against each matrix row. If the expression evaluates to `false`, the row becomes hidden.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Use the `{item}` placeholder to reference the current row in the expression.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see visibleRows
         * @see columnsVisibleIf
         */ get: function() {
                        return this.getPropertyValue("rowsVisibleIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("rowsVisibleIf", val1);
                        this.filterItems();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "columnsVisibleIf", {
                    /**
         * A Boolean expression that is evaluated against each matrix column. If the expression evaluates to `false`, the column becomes hidden.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Use the `{item}` placeholder to reference the current column in the expression.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see rowsVisibleIf
         */ get: function() {
                        return this.getPropertyValue("columnsVisibleIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("columnsVisibleIf", val1);
                        this.filterItems();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixBaseModel.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    this.runItemsCondition(values, properties);
                };
                QuestionMatrixBaseModel.prototype.filterItems = function() {
                    if (this.areInvisibleElementsShowing) {
                        this.onRowsChanged();
                        return false;
                    }
                    if (this.isLoadingFromJson || !this.data) return false;
                    return this.runItemsCondition(this.getDataFilteredValues(), this.getDataFilteredProperties());
                };
                QuestionMatrixBaseModel.prototype.onColumnsChanged = function() {};
                QuestionMatrixBaseModel.prototype.onRowsChanged = function() {
                    this.updateVisibilityBasedOnRows();
                    this.fireCallback(this.visibleRowsChangedCallback);
                };
                QuestionMatrixBaseModel.prototype.updateVisibilityBasedOnRows = function() {
                    if (this.hideIfRowsEmpty) this.visible = this.rows.length > 0 && (!this.filteredRows || this.filteredRows.length > 0);
                };
                QuestionMatrixBaseModel.prototype.shouldRunColumnExpression = function() {
                    return !this.survey || !this.survey.areInvisibleElementsShowing;
                };
                QuestionMatrixBaseModel.prototype.hasRowsAsItems = function() {
                    return true;
                };
                QuestionMatrixBaseModel.prototype.runItemsCondition = function(values, properties) {
                    var oldVisibleRows = null;
                    if (!!this.filteredRows && !_helpers__WEBPACK_IMPORTED_MODULE_4__["Helpers"].isValueEmpty(this.defaultValue)) {
                        oldVisibleRows = [];
                        for(var i = 0; i < this.filteredRows.length; i++)oldVisibleRows.push(this.filteredRows[i]);
                    }
                    var hasChanges = this.hasRowsAsItems() && this.runConditionsForRows(values, properties);
                    var hasColumnsChanged = this.runConditionsForColumns(values, properties);
                    hasChanges = hasColumnsChanged || hasChanges;
                    if (hasChanges) {
                        if (this.isClearValueOnHidden && (!!this.filteredColumns || !!this.filteredRows)) this.clearIncorrectValues();
                        if (!!oldVisibleRows) this.restoreNewVisibleRowsValues(oldVisibleRows);
                        this.clearGeneratedRows();
                        if (hasColumnsChanged) this.onColumnsChanged();
                        this.onRowsChanged();
                    }
                    return hasChanges;
                };
                QuestionMatrixBaseModel.prototype.clearGeneratedRows = function() {
                    this.generatedVisibleRows = null;
                };
                QuestionMatrixBaseModel.prototype.runConditionsForRows = function(values, properties) {
                    var showInvisibile = !!this.survey && this.survey.areInvisibleElementsShowing;
                    var runner = !showInvisibile && !!this.rowsVisibleIf ? new _conditions__WEBPACK_IMPORTED_MODULE_3__["ConditionRunner"](this.rowsVisibleIf) : null;
                    this.filteredRows = [];
                    var hasChanged = _itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].runConditionsForItems(this.rows, this.filteredRows, runner, values, properties, !showInvisibile);
                    if (this.filteredRows.length === this.rows.length) this.filteredRows = null;
                    return hasChanged;
                };
                QuestionMatrixBaseModel.prototype.runConditionsForColumns = function(values, properties) {
                    var useColumnsExpression = !!this.survey && !this.survey.areInvisibleElementsShowing;
                    var runner = useColumnsExpression && !!this.columnsVisibleIf ? new _conditions__WEBPACK_IMPORTED_MODULE_3__["ConditionRunner"](this.columnsVisibleIf) : null;
                    this.filteredColumns = [];
                    var hasChanged = _itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].runConditionsForItems(this.columns, this.filteredColumns, runner, values, properties, this.shouldRunColumnExpression());
                    if (this.filteredColumns.length === this.columns.length) this.filteredColumns = null;
                    return hasChanged;
                };
                QuestionMatrixBaseModel.prototype.clearIncorrectValues = function() {
                    var val1 = this.value;
                    if (!val1) return;
                    var newVal = null;
                    var isChanged = false;
                    var rows = !!this.filteredRows ? this.filteredRows : this.rows;
                    var columns = !!this.filteredColumns ? this.filteredColumns : this.columns;
                    for(var key in val1)if (_itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].getItemByValue(rows, key) && _itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].getItemByValue(columns, val1[key])) {
                        if (newVal == null) newVal = {};
                        newVal[key] = val1[key];
                    } else isChanged = true;
                    if (isChanged) this.value = newVal;
                    _super.prototype.clearIncorrectValues.call(this);
                };
                QuestionMatrixBaseModel.prototype.clearInvisibleValuesInRows = function() {
                    if (this.isEmpty()) return;
                    var newData = this.getUnbindValue(this.value);
                    var rows = this.rows;
                    for(var i = 0; i < rows.length; i++){
                        var key = rows[i].value;
                        if (!!newData[key] && !rows[i].isVisible) delete newData[key];
                    }
                    if (this.isTwoValueEquals(newData, this.value)) return;
                    this.value = newData;
                };
                QuestionMatrixBaseModel.prototype.restoreNewVisibleRowsValues = function(oldVisibleRows) {
                    var rows = !!this.filteredRows ? this.filteredRows : this.rows;
                    var val1 = this.defaultValue;
                    var newValue = this.getUnbindValue(this.value);
                    var isChanged = false;
                    for(var key in val1)if (_itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].getItemByValue(rows, key) && !_itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].getItemByValue(oldVisibleRows, key)) {
                        if (newValue == null) newValue = {};
                        newValue[key] = val1[key];
                        isChanged = true;
                    }
                    if (isChanged) this.value = newValue;
                };
                QuestionMatrixBaseModel.prototype.needResponsiveWidth = function() {
                    //TODO: make it mor intelligent
                    return true;
                };
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "columnsAutoWidth", {
                    get: function() {
                        return !this.isMobile && !this.columns.some(function(col) {
                            return !!col.width;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixBaseModel.prototype.getTableCss = function() {
                    var _a;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.root).append(this.cssClasses.columnsAutoWidth, this.columnsAutoWidth).append(this.cssClasses.noHeader, !this.showHeader).append(this.cssClasses.hasFooter, !!((_a = this.renderedTable) === null || _a === void 0 ? void 0 : _a.showAddRowOnBottom)).append(this.cssClasses.rootAlternateRows, this.alternateRows).append(this.cssClasses.rootVerticalAlignTop, this.verticalAlign === "top").append(this.cssClasses.rootVerticalAlignMiddle, this.verticalAlign === "middle").toString();
                };
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "columnMinWidth", {
                    /**
         * Minimum column width in CSS values.
         *
         * @see width
         */ get: function() {
                        return this.getPropertyValue("columnMinWidth") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("columnMinWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "rowTitleWidth", {
                    /**
         * A width for the column that displays row titles (first column). Accepts CSS values.
         */ get: function() {
                        return this.getPropertyValue("rowTitleWidth") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("rowTitleWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                //a11y
                QuestionMatrixBaseModel.prototype.getCellAriaLabel = function(rowTitle, columnTitle) {
                    var row = (this.getLocalizationString("matrix_row") || "row").toLocaleLowerCase();
                    var column = (this.getLocalizationString("matrix_column") || "column").toLocaleLowerCase();
                    return row + " " + rowTitle + ", " + column + " " + columnTitle;
                };
                Object.defineProperty(QuestionMatrixBaseModel.prototype, "isNewA11yStructure", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionMatrixBaseModel.prototype, "verticalAlign", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionMatrixBaseModel.prototype, "alternateRows", void 0);
                return QuestionMatrixBaseModel;
            }(_question__WEBPACK_IMPORTED_MODULE_1__["Question"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("matrixbase", [
                {
                    name: "showCommentArea:switch",
                    layout: "row",
                    visible: true,
                    category: "general"
                },
                "columnsVisibleIf:condition",
                "rowsVisibleIf:condition",
                "columnMinWidth",
                {
                    name: "showHeader:boolean",
                    default: true
                },
                {
                    name: "verticalAlign",
                    choices: [
                        "top",
                        "middle"
                    ],
                    default: "middle"
                },
                {
                    name: "alternateRows:boolean",
                    default: false
                }
            ], undefined, "question");
        /***/ },
        /***/ "./src/mask/input_element_adapter.ts": /*!*******************************************!*\
  !*** ./src/mask/input_element_adapter.ts ***!
  \*******************************************/ /*! exports provided: InputElementAdapter */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputElementAdapter", function() {
                return InputElementAdapter;
            });
            var InputElementAdapter = /** @class */ function() {
                function InputElementAdapter(inputMaskInstance, inputElement, value) {
                    var _this = this;
                    this.inputMaskInstance = inputMaskInstance;
                    this.inputElement = inputElement;
                    this.prevUnmaskedValue = undefined;
                    this.inputMaskInstancePropertyChangedHandler = function(sender, options) {
                        if (options.name !== "saveMaskedValue") {
                            var maskedValue = _this.inputMaskInstance.getMaskedValue(_this.prevUnmaskedValue);
                            _this.inputElement.value = maskedValue;
                        }
                    };
                    this.beforeInputHandler = function(event1) {
                        var args = _this.createArgs(event1);
                        var result = _this.inputMaskInstance.processInput(args);
                        _this.inputElement.value = result.value;
                        _this.inputElement.setSelectionRange(result.caretPosition, result.caretPosition);
                        if (!result.cancelPreventDefault) event1.preventDefault();
                    };
                    var _value = value;
                    if (_value === null || _value === undefined) _value = "";
                    else if (typeof _value !== "string") _value = _value.toString();
                    this.inputElement.value = inputMaskInstance.getMaskedValue(_value);
                    this.prevUnmaskedValue = _value;
                    inputMaskInstance.onPropertyChanged.add(this.inputMaskInstancePropertyChangedHandler);
                    this.addInputEventListener();
                }
                InputElementAdapter.prototype.createArgs = function(event1) {
                    var args = {
                        insertedChars: event1.data,
                        selectionStart: event1.target.selectionStart,
                        selectionEnd: event1.target.selectionEnd,
                        prevValue: event1.target.value,
                        inputDirection: "forward"
                    };
                    if (event1.inputType === "deleteContentBackward") {
                        args.inputDirection = "backward";
                        if (args.selectionStart === args.selectionEnd) args.selectionStart = Math.max(args.selectionStart - 1, 0);
                    }
                    if (event1.inputType === "deleteContentForward" && args.selectionStart === args.selectionEnd) args.selectionEnd += 1;
                    return args;
                };
                InputElementAdapter.prototype.addInputEventListener = function() {
                    if (!!this.inputElement) this.inputElement.addEventListener("beforeinput", this.beforeInputHandler);
                };
                InputElementAdapter.prototype.removeInputEventListener = function() {
                    if (!!this.inputElement) this.inputElement.removeEventListener("beforeinput", this.beforeInputHandler);
                };
                InputElementAdapter.prototype.dispose = function() {
                    this.removeInputEventListener();
                    this.inputMaskInstance.onPropertyChanged.remove(this.inputMaskInstancePropertyChangedHandler);
                };
                return InputElementAdapter;
            }();
        /***/ },
        /***/ "./src/mask/mask_base.ts": /*!*******************************!*\
  !*** ./src/mask/mask_base.ts ***!
  \*******************************/ /*! exports provided: InputMaskBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputMaskBase", function() {
                return InputMaskBase;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A base class for classes that implement input masks:
 *
 * - [`InputMaskNumeric`](https://surveyjs.io/form-library/documentation/inputmasknumeric)
 * - [`InputMaskCurrency`](https://surveyjs.io/form-library/documentation/inputmaskcurrency)
 * - [`InputMaskDateTime`](https://surveyjs.io/form-library/documentation/inputmaskdatetime)
 * - [`InputMaskPattern`](https://surveyjs.io/form-library/documentation/inputmaskpattern)
 */ var InputMaskBase = /** @class */ function(_super) {
                __extends(InputMaskBase, _super);
                function InputMaskBase() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InputMaskBase.prototype.getType = function() {
                    return "masksettings";
                };
                InputMaskBase.prototype.setData = function(json) {
                    var _this = this;
                    var properties = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].getProperties(this.getType());
                    properties.forEach(function(property) {
                        var currentValue = json[property.name];
                        _this[property.name] = currentValue !== undefined ? currentValue : property.defaultValue;
                    });
                };
                InputMaskBase.prototype.getData = function() {
                    var _this = this;
                    var res = {};
                    var properties = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].getProperties(this.getType());
                    properties.forEach(function(property) {
                        var currentValue = _this[property.name];
                        if (!property.isDefaultValue(currentValue)) res[property.name] = currentValue;
                    });
                    return res;
                };
                // public get maskedInputValue(): string {
                //   return this.input.value;
                // }
                // public get unmaskedInputValue(): string {
                //   return this.getUnmaskedValue(this.input.value, true);
                // }
                InputMaskBase.prototype.processInput = function(args) {
                    return {
                        value: args.prevValue,
                        caretPosition: args.selectionEnd,
                        cancelPreventDefault: false
                    };
                };
                InputMaskBase.prototype.getUnmaskedValue = function(src) {
                    return src;
                };
                InputMaskBase.prototype.getMaskedValue = function(src) {
                    return src;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], InputMaskBase.prototype, "saveMaskedValue", void 0);
                return InputMaskBase;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("masksettings", [
                {
                    name: "saveMaskedValue:boolean",
                    visibleIf: function(obj) {
                        if (!obj) return false;
                        return obj.getType() !== "masksettings";
                    }
                }
            ], function() {
                return new InputMaskBase();
            });
        /***/ },
        /***/ "./src/mask/mask_currency.ts": /*!***********************************!*\
  !*** ./src/mask/mask_currency.ts ***!
  \***********************************/ /*! exports provided: InputMaskCurrency */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputMaskCurrency", function() {
                return InputMaskCurrency;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _mask_numeric__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mask_numeric */ "./src/mask/mask_numeric.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A class that describes an input mask of the `"currency"` [`maskType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#maskType).
 *
 * The following code shows how to specify the properties of this class within a survey JSON schema:
 *
 * ```js
 * const surveyJson = {
 *   "elements": [{
 *     "name": "textquestion1"
 *     "type": "text",
 *     "maskType": "currency",
 *     "maskSettings": {
 *       // Specify the properties of a currency input mask here
 *     }
 *   }]
 * }
 * ```
 *
 * [View Demo](https://surveyjs.io/form-library/examples/masked-input-fields/ (linkStyle))
 */ var InputMaskCurrency = /** @class */ function(_super) {
                __extends(InputMaskCurrency, _super);
                function InputMaskCurrency() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InputMaskCurrency.prototype.getType = function() {
                    return "currencymask";
                };
                InputMaskCurrency.prototype.wrapText = function(str) {
                    var prefixValue = this.prefix || "";
                    var suffixValue = this.suffix || "";
                    var result = str;
                    if (!result) return result;
                    if (result.indexOf(prefixValue) === -1) result = prefixValue + result;
                    if (result.indexOf(suffixValue) === -1) result += suffixValue;
                    return result;
                };
                InputMaskCurrency.prototype.unwrapInputArgs = function(args) {
                    var result = args.prevValue;
                    if (!result) return;
                    if (this.prefix && result.indexOf(this.prefix) !== -1) {
                        result = result.slice(result.indexOf(this.prefix) + this.prefix.length);
                        var preffixPadding = (this.prefix || "").length;
                        args.selectionStart = Math.max(args.selectionStart - preffixPadding, 0);
                        args.selectionEnd -= preffixPadding;
                    }
                    if (this.suffix && result.indexOf(this.suffix) !== -1) result = result.slice(0, result.indexOf(this.suffix));
                    args.prevValue = result;
                };
                InputMaskCurrency.prototype.processInput = function(args) {
                    this.unwrapInputArgs(args);
                    var result = _super.prototype.processInput.call(this, args);
                    var preffixPadding = (this.prefix || "").length;
                    if (!!result.value) result.caretPosition += preffixPadding;
                    result.value = this.wrapText(result.value);
                    return result;
                };
                InputMaskCurrency.prototype.getMaskedValue = function(src) {
                    var result = _super.prototype.getMaskedValue.call(this, src);
                    return this.wrapText(result);
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskCurrency.prototype, "prefix", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskCurrency.prototype, "suffix", void 0);
                return InputMaskCurrency;
            }(_mask_numeric__WEBPACK_IMPORTED_MODULE_1__["InputMaskNumeric"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("currencymask", [
                {
                    name: "prefix"
                },
                {
                    name: "suffix"
                }
            ], function() {
                return new InputMaskCurrency();
            }, "numericmask");
        /***/ },
        /***/ "./src/mask/mask_datetime.ts": /*!***********************************!*\
  !*** ./src/mask/mask_datetime.ts ***!
  \***********************************/ /*! exports provided: getDateTimeLexems, InputMaskDateTime */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getDateTimeLexems", function() {
                return getDateTimeLexems;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputMaskDateTime", function() {
                return InputMaskDateTime;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _mask_pattern__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mask_pattern */ "./src/mask/mask_pattern.ts");
            /* harmony import */ var _mask_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mask_utils */ "./src/mask/mask_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            function getMaxCountLexem(currentLexemType, count) {
                switch(currentLexemType){
                    case "day":
                    case "month":
                        return 2;
                    case "year":
                        return count;
                    default:
                        return 1;
                }
            }
            function trimDatePart(lexem, data) {
                var result = data;
                if (lexem.count < lexem.maxCount && (lexem.type === "day" && parseInt(data[0]) === 0 || lexem.type === "month" && parseInt(data[0]) === 0)) result = data.slice(1, data.length);
                return result;
            }
            function getDefaultYearForValidation(minYear, maxYear) {
                var defaultVal = 2000;
                if (defaultVal > maxYear) defaultVal = parseInt(maxYear.toString().slice(0, maxYear.toString().length - 2)) * 100;
                if (defaultVal < minYear) {
                    var middle = (maxYear - minYear) / 2 + minYear;
                    defaultVal = parseInt(middle.toString().slice(0, middle.toString().length - 1)) * 10;
                }
                if (defaultVal >= minYear && defaultVal <= maxYear) return defaultVal;
                return minYear;
            }
            function getDateTimeLexems(pattern) {
                var result = [];
                var prevLexemType;
                var createOrUpdateLexem = function(currentLexemType, currentChar) {
                    if (!!prevLexemType && prevLexemType === currentLexemType) {
                        result[result.length - 1].count++;
                        var maxCount = getMaxCountLexem(currentLexemType, result[result.length - 1].count);
                        result[result.length - 1].maxCount = maxCount;
                    } else {
                        var maxCount = getMaxCountLexem(currentLexemType, 1);
                        // result.push({ type: currentLexemType, value: currentChar, count: 1, data: { value: "", isCompleted: false, isCorrect: false }, maxCount: maxCount });
                        result.push({
                            type: currentLexemType,
                            value: currentChar,
                            count: 1,
                            maxCount: maxCount
                        });
                    }
                };
                for(var index = 0; index < pattern.length; index++){
                    var currentChar = pattern[index];
                    switch(currentChar){
                        case "m":
                            createOrUpdateLexem("month", "m");
                            break;
                        case "d":
                            createOrUpdateLexem("day", "d");
                            break;
                        case "y":
                            createOrUpdateLexem("year", "y");
                            break;
                        default:
                            result.push({
                                type: "separator",
                                value: currentChar,
                                count: 1,
                                maxCount: 1
                            });
                            break;
                    }
                    prevLexemType = result[result.length - 1].type;
                }
                return result;
            }
            /**
 * A class that describes an input mask of the `"datetime"` [`maskType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#maskType).
 *
 * The following code shows how to specify the properties of this class within a survey JSON schema:
 *
 * ```js
 * const surveyJson = {
 *   "elements": [{
 *     "name": "textquestion1"
 *     "type": "text",
 *     "maskType": "datetime",
 *     "maskSettings": {
 *       // Specify the properties of a date-time input mask here
 *     }
 *   }]
 * }
 * ```
 *
 * [View Demo](https://surveyjs.io/form-library/examples/masked-input-fields/ (linkStyle))
 */ var InputMaskDateTime = /** @class */ function(_super) {
                __extends(InputMaskDateTime, _super);
                function InputMaskDateTime() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.turnOfTheCentury = 68;
                    _this.lexems = [];
                    _this.inputDateTimeData = [];
                    return _this;
                }
                InputMaskDateTime.prototype.getType = function() {
                    return "datetimemask";
                };
                InputMaskDateTime.prototype.updateLiterals = function() {
                    this.lexems = getDateTimeLexems(this.pattern || "");
                };
                InputMaskDateTime.prototype.leaveOnlyNumbers = function(input) {
                    var result = "";
                    for(var index = 0; index < input.length; index++)if (input[index].match(_mask_utils__WEBPACK_IMPORTED_MODULE_2__["numberDefinition"])) result += input[index];
                    return result;
                };
                InputMaskDateTime.prototype.getMaskedStrFromISO = function(str) {
                    var _this = this;
                    var date = new Date(str);
                    this.initInputDateTimeData();
                    if (!isNaN(date)) this.lexems.forEach(function(lexem, index) {
                        var inputData = _this.inputDateTimeData[index];
                        inputData.isCompleted = true;
                        switch(lexem.type){
                            case "day":
                                inputData.value = date.getDate().toString();
                                break;
                            case "month":
                                inputData.value = (date.getMonth() + 1).toString();
                                break;
                            case "year":
                                var year = date.getFullYear();
                                if (lexem.count == 2) year = year % 100;
                                inputData.value = year.toString();
                                break;
                            default:
                                break;
                        }
                    });
                    return this.getFormatedString(true);
                };
                InputMaskDateTime.prototype.initInputDateTimeData = function() {
                    var _this = this;
                    this.inputDateTimeData = [];
                    this.lexems.forEach(function(lexem) {
                        _this.inputDateTimeData.push({
                            lexem: lexem,
                            isCompleted: false,
                            value: undefined
                        });
                    });
                };
                InputMaskDateTime.prototype.getISO_8601Format = function(dateTime) {
                    if (dateTime.year === undefined || dateTime.month === undefined || dateTime.day === undefined) return "";
                    var year = this.getPlaceholder(4, dateTime.year.toString(), "0") + dateTime.year;
                    var month = this.getPlaceholder(2, dateTime.month.toString(), "0") + dateTime.month;
                    var day = this.getPlaceholder(2, dateTime.day.toString(), "0") + dateTime.day;
                    return [
                        year,
                        month,
                        day
                    ].join("-");
                };
                InputMaskDateTime.prototype.isYearValid = function(dateTime) {
                    if (dateTime.min === undefined && dateTime.max === undefined) return false;
                    var data = dateTime.year.toString();
                    var minYearPart = dateTime.min.toISOString().slice(0, data.length);
                    var maxYearPart = dateTime.max.toISOString().slice(0, data.length);
                    return dateTime.year >= parseInt(minYearPart) && dateTime.year <= parseInt(maxYearPart);
                };
                InputMaskDateTime.prototype.isDateValid = function(dateTime) {
                    var min = dateTime.min;
                    var max = dateTime.max;
                    var year = dateTime.year !== undefined ? dateTime.year : getDefaultYearForValidation(min.getFullYear(), max.getFullYear());
                    var month = dateTime.month !== undefined ? dateTime.month : 1;
                    var day = dateTime.day !== undefined ? dateTime.day : 1;
                    var date = new Date(this.getISO_8601Format({
                        year: year,
                        month: month,
                        day: day
                    }));
                    var monthIndex = month - 1;
                    return !isNaN(date) && date.getDate() === day && date.getMonth() === monthIndex && date.getFullYear() === year && date >= dateTime.min && date <= dateTime.max;
                };
                InputMaskDateTime.prototype.getPlaceholder = function(lexemLength, str, char) {
                    var paddingsLength = lexemLength - (str || "").length;
                    var paddings = paddingsLength > 0 ? char.repeat(paddingsLength) : "";
                    return paddings;
                };
                InputMaskDateTime.prototype.updateInputDateTimeData = function(newItem, dateTime) {
                    var data = newItem.value;
                    if (!data) return;
                    var propertyName = newItem.lexem.type;
                    dateTime[propertyName] = parseInt(data);
                    if (data.length === newItem.lexem.maxCount) {
                        if (this.isDateValid(dateTime)) newItem.isCompleted = true;
                        else data = data.slice(0, data.length - 1);
                    } else if (propertyName === "year" && !this.isYearValid(dateTime)) data = data.slice(0, data.length - 1);
                    else if (propertyName === "day" && parseInt(data[0]) > 3 || propertyName === "month" && parseInt(data[0]) > 1) newItem.isCompleted = true;
                    newItem.value = data;
                    dateTime[propertyName] = parseInt(data) > 0 ? parseInt(data) : undefined;
                };
                InputMaskDateTime.prototype.getCorrectDatePartFormat = function(inputData, matchWholeMask) {
                    var lexem = inputData.lexem;
                    var dataStr = inputData.value || "";
                    if (!!dataStr && inputData.isCompleted) dataStr = parseInt(dataStr).toString();
                    if (!!dataStr && inputData.isCompleted) {
                        var zeroPaddings = this.getPlaceholder(lexem.count, dataStr, "0");
                        dataStr = zeroPaddings + dataStr;
                    } else {
                        // !!!
                        dataStr = trimDatePart(lexem, dataStr);
                        if (matchWholeMask) dataStr += this.getPlaceholder(lexem.count, dataStr, lexem.value);
                    }
                    return dataStr;
                };
                InputMaskDateTime.prototype.createIDateTimeComposition = function() {
                    var tempDateTime = {
                        day: undefined,
                        month: undefined,
                        year: undefined,
                        min: new Date(this.min || "0001-01-01"),
                        max: new Date(this.max || "9999-12-31")
                    };
                    return tempDateTime;
                };
                InputMaskDateTime.prototype.parseTwoDigitYear = function(data) {
                    var inputData = data.value;
                    if (data.lexem.type !== "year" || data.lexem.count > 2) return inputData;
                    if (!!this.max && this.max.length >= 4) this.turnOfTheCentury = parseInt(this.max.slice(2, 4));
                    var year = parseInt(inputData);
                    var result = (year > this.turnOfTheCentury ? "19" : "20") + inputData;
                    return result;
                };
                InputMaskDateTime.prototype.getFormatedString = function(matchWholeMask) {
                    var result = "";
                    var prevSeparator = "";
                    var prevIsCompleted = false;
                    for(var index = 0; index < this.inputDateTimeData.length; index++){
                        var inputData = this.inputDateTimeData[index];
                        switch(inputData.lexem.type){
                            case "day":
                            case "month":
                            case "year":
                                if (inputData.value === undefined && !matchWholeMask) {
                                    result += prevIsCompleted ? prevSeparator : "";
                                    return result;
                                } else {
                                    var data = this.getCorrectDatePartFormat(inputData, matchWholeMask);
                                    result += prevSeparator + data;
                                    prevIsCompleted = inputData.isCompleted;
                                }
                                break;
                            case "separator":
                                prevSeparator = inputData.lexem.value;
                                break;
                        }
                    }
                    return result;
                };
                InputMaskDateTime.prototype.setInputDateTimeData = function(numberParts) {
                    var _this = this;
                    var numberPartsArrayIndex = 0;
                    this.initInputDateTimeData();
                    this.lexems.forEach(function(lexem, index) {
                        if (lexem.type !== "separator" && numberParts.length > 0 && numberPartsArrayIndex < numberParts.length) {
                            var inputData = _this.inputDateTimeData[index];
                            var currentPart = numberParts[numberPartsArrayIndex];
                            var _data = _this.leaveOnlyNumbers(currentPart);
                            inputData.value = _data.slice(0, lexem.maxCount);
                            numberPartsArrayIndex++;
                        }
                    });
                };
                InputMaskDateTime.prototype._getMaskedValue = function(src, matchWholeMask) {
                    var _this = this;
                    if (matchWholeMask === void 0) matchWholeMask = true;
                    var input = src === undefined || src === null ? "" : src.toString();
                    var inputParts = this.getParts(input);
                    this.setInputDateTimeData(inputParts);
                    var tempDateTime = this.createIDateTimeComposition();
                    this.inputDateTimeData.forEach(function(itemData) {
                        return _this.updateInputDateTimeData(itemData, tempDateTime);
                    });
                    var result = this.getFormatedString(matchWholeMask);
                    return result;
                };
                InputMaskDateTime.prototype.getPartsOld = function(input) {
                    var inputParts = [];
                    var separatorLexems = this.lexems.filter(function(l) {
                        return l.type === "separator";
                    });
                    var separatorLexemsIndex = 0;
                    do {
                        if (!separatorLexems[separatorLexemsIndex]) {
                            if (!!input) {
                                inputParts.push(input);
                                input = "";
                            }
                            break;
                        }
                        var separatorCharIndex = input.indexOf(separatorLexems[separatorLexemsIndex].value);
                        if (separatorCharIndex !== -1) {
                            var part = input.slice(0, separatorCharIndex);
                            if (!!part) inputParts.push(part);
                            input = input.slice(separatorCharIndex + 1);
                        }
                        separatorLexemsIndex++;
                    }while (!!input);
                    return inputParts;
                };
                InputMaskDateTime.prototype.getParts = function(input) {
                    var inputParts = [];
                    var lexemsWithValue = this.lexems.filter(function(l) {
                        return l.type !== "separator";
                    });
                    var separators = this.lexems.filter(function(l) {
                        return l.type === "separator";
                    }).map(function(s) {
                        return s.value;
                    });
                    var curPart = "";
                    var foundSeparator = false;
                    var foundPseudoSeparator = false;
                    for(var i = 0; i < input.length; i++){
                        var inputChar = input[i];
                        if (inputChar.match(_mask_utils__WEBPACK_IMPORTED_MODULE_2__["numberDefinition"]) || inputChar === lexemsWithValue[inputParts.length].value) {
                            foundSeparator = false;
                            foundPseudoSeparator = false;
                            curPart += inputChar;
                        } else {
                            if (separators.indexOf(inputChar) !== -1) {
                                if (!foundPseudoSeparator) {
                                    foundSeparator = true;
                                    inputParts.push(curPart);
                                    curPart = "";
                                }
                            } else if (!foundSeparator) {
                                foundPseudoSeparator = true;
                                inputParts.push(curPart);
                                curPart = "";
                            }
                        }
                        if (inputParts.length >= lexemsWithValue.length) {
                            foundSeparator = false;
                            break;
                        }
                    }
                    if (curPart != "" || foundSeparator) inputParts.push(curPart);
                    return inputParts;
                };
                InputMaskDateTime.prototype.getUnmaskedValue = function(src) {
                    var _this = this;
                    var input = src === undefined || src === null ? "" : src.toString();
                    var inputParts = this.getParts(input);
                    this.setInputDateTimeData(inputParts);
                    var tempDateTime = this.createIDateTimeComposition();
                    this.inputDateTimeData.forEach(function(inputData) {
                        var str = inputData.value;
                        if (!str || str.length < inputData.lexem.count) return undefined;
                        tempDateTime[inputData.lexem.type] = parseInt(_this.parseTwoDigitYear(inputData));
                    });
                    return this.getISO_8601Format(tempDateTime);
                };
                InputMaskDateTime.prototype.getMaskedValue = function(src) {
                    return this.getMaskedStrFromISO(src);
                };
                InputMaskDateTime.prototype.processInput = function(args) {
                    var result = {
                        value: args.prevValue,
                        caretPosition: args.selectionEnd,
                        cancelPreventDefault: false
                    };
                    var leftPart = args.prevValue.slice(0, args.selectionStart);
                    var rightPart = args.prevValue.slice(args.selectionEnd);
                    result.value = this._getMaskedValue(leftPart + (args.insertedChars || "") + rightPart);
                    if (!args.insertedChars && args.inputDirection === "backward") result.caretPosition = args.selectionStart;
                    else result.caretPosition = this._getMaskedValue(leftPart + (args.insertedChars || ""), false).length;
                    return result;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskDateTime.prototype, "min", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskDateTime.prototype, "max", void 0);
                return InputMaskDateTime;
            }(_mask_pattern__WEBPACK_IMPORTED_MODULE_1__["InputMaskPattern"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("datetimemask", [
                {
                    name: "min",
                    type: "datetime",
                    enableIf: function(obj) {
                        return !!obj.pattern;
                    }
                },
                {
                    name: "max",
                    type: "datetime",
                    enableIf: function(obj) {
                        return !!obj.pattern;
                    }
                }
            ], function() {
                return new InputMaskDateTime();
            }, "patternmask");
        /***/ },
        /***/ "./src/mask/mask_numeric.ts": /*!**********************************!*\
  !*** ./src/mask/mask_numeric.ts ***!
  \**********************************/ /*! exports provided: splitString, InputMaskNumeric */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "splitString", function() {
                return splitString;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputMaskNumeric", function() {
                return InputMaskNumeric;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _mask_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./mask_base */ "./src/mask/mask_base.ts");
            /* harmony import */ var _mask_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mask_utils */ "./src/mask/mask_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            function splitString(str, reverse, n) {
                if (reverse === void 0) reverse = true;
                if (n === void 0) n = 3;
                var arr = [];
                if (reverse) {
                    for(var i = str.length - n; i > -n; i -= n)arr.push(str.substring(i, i + n));
                    arr = arr.reverse();
                } else for(var i = 0; i < str.length; i += n)arr.push(str.substring(i, i + n));
                return arr;
            }
            /**
 * A class that describes an input mask of the `"numeric"` [`maskType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#maskType).
 *
 * The following code shows how to specify the properties of this class within a survey JSON schema:
 *
 * ```js
 * const surveyJson = {
 *   "elements": [{
 *     "name": "textquestion1"
 *     "type": "text",
 *     "maskType": "numeric",
 *     "maskSettings": {
 *       // Specify the properties of a numeric input mask here
 *     }
 *   }]
 * }
 * ```
 *
 * [View Demo](https://surveyjs.io/form-library/examples/masked-input-fields/ (linkStyle))
 */ var InputMaskNumeric = /** @class */ function(_super) {
                __extends(InputMaskNumeric, _super);
                function InputMaskNumeric() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                InputMaskNumeric.prototype.calccaretPosition = function(leftPart, args, maskedValue) {
                    var leftPartMaskedLength = !!leftPart ? this.displayNumber(this.parseNumber(leftPart), false).length : 0;
                    var validCharIndex = 0;
                    var result = args.selectionStart;
                    // let result = 0;
                    var isDeleteKeyOperation = !args.insertedChars && args.inputDirection === "forward";
                    for(var index = 0; index < maskedValue.length; index++){
                        var currentChar = maskedValue[index];
                        if (currentChar !== this.thousandsSeparator) validCharIndex++;
                        if (validCharIndex === leftPartMaskedLength + (isDeleteKeyOperation ? 1 : 0)) {
                            if (isDeleteKeyOperation) result = index;
                            else result = index + 1;
                            break;
                        }
                    // if (validCharIndex === leftPartMaskedLength) {
                    //   result = index + 1;
                    //   break;
                    // }
                    }
                    return result;
                };
                InputMaskNumeric.prototype.displayNumber = function(parsedNumber, insertThousandsSeparator, matchWholeMask) {
                    if (insertThousandsSeparator === void 0) insertThousandsSeparator = true;
                    if (matchWholeMask === void 0) matchWholeMask = false;
                    var displayIntegralPart = parsedNumber.integralPart;
                    if (insertThousandsSeparator && !!displayIntegralPart) displayIntegralPart = splitString(displayIntegralPart).join(this.thousandsSeparator);
                    var displayFractionalPart = parsedNumber.fractionalPart;
                    var minusSign = parsedNumber.isNegative ? "-" : "";
                    if (displayFractionalPart === "") {
                        if (matchWholeMask) return !displayIntegralPart || displayIntegralPart === "0" ? displayIntegralPart : minusSign + displayIntegralPart;
                        else {
                            var displayDecimalSeparator = parsedNumber.hasDecimalSeparator && !matchWholeMask ? this.decimalSeparator : "";
                            var src = displayIntegralPart + displayDecimalSeparator;
                            return src === "0" ? src : minusSign + src;
                        }
                    } else {
                        displayIntegralPart = displayIntegralPart || "0";
                        displayFractionalPart = displayFractionalPart.substring(0, this.precision);
                        return [
                            minusSign + displayIntegralPart,
                            displayFractionalPart
                        ].join(this.decimalSeparator);
                    }
                };
                InputMaskNumeric.prototype.convertNumber = function(parsedNumber) {
                    var value;
                    var minusSign = parsedNumber.isNegative ? "-" : "";
                    if (!!parsedNumber.fractionalPart) value = parseFloat(minusSign + (parsedNumber.integralPart || "0") + "." + parsedNumber.fractionalPart.substring(0, this.precision));
                    else value = parseInt(minusSign + parsedNumber.integralPart || "0");
                    return value;
                };
                InputMaskNumeric.prototype.validateNumber = function(number) {
                    var min = this.min || Number.MIN_SAFE_INTEGER;
                    var max = this.max || Number.MAX_SAFE_INTEGER;
                    if (this.min !== undefined || this.max !== undefined) {
                        var value = this.convertNumber(number);
                        if (Number.isNaN(value)) return true;
                        return value >= min && value <= max;
                    }
                    return true;
                };
                InputMaskNumeric.prototype.parseNumber = function(src) {
                    var result = {
                        integralPart: "",
                        fractionalPart: "",
                        hasDecimalSeparator: false,
                        isNegative: false
                    };
                    var input = src === undefined || src === null ? "" : src.toString();
                    if (typeof src === "number") input = src.toString().replace(".", this.decimalSeparator);
                    var minusCharCount = 0;
                    for(var inputIndex = 0; inputIndex < input.length; inputIndex++){
                        var currentChar = input[inputIndex];
                        switch(currentChar){
                            case "-":
                                if (this.allowNegativeValues) minusCharCount++;
                                break;
                            case this.decimalSeparator:
                                if (this.precision > 0) result.hasDecimalSeparator = true;
                                break;
                            case this.thousandsSeparator:
                                break;
                            default:
                                if (currentChar.match(_mask_utils__WEBPACK_IMPORTED_MODULE_2__["numberDefinition"])) {
                                    if (result.hasDecimalSeparator) result.fractionalPart += currentChar;
                                    else result.integralPart += currentChar;
                                }
                        }
                    }
                    result.isNegative = minusCharCount % 2 !== 0;
                    if (result.integralPart.length > 1 && result.integralPart[0] === "0") result.integralPart = result.integralPart.slice(1);
                    return result;
                };
                InputMaskNumeric.prototype.getNumberMaskedValue = function(src, matchWholeMask) {
                    if (matchWholeMask === void 0) matchWholeMask = false;
                    var input = src === undefined || src === null ? "" : src;
                    var parsedNumber = this.parseNumber(input);
                    var displayText = this.displayNumber(parsedNumber, true, matchWholeMask);
                    return displayText;
                };
                InputMaskNumeric.prototype.getNumberUnmaskedValue = function(str) {
                    var parsedNumber = this.parseNumber(str);
                    return this.convertNumber(parsedNumber);
                };
                InputMaskNumeric.prototype.getMaskedValue = function(src) {
                    return this.getNumberMaskedValue(src, true);
                };
                InputMaskNumeric.prototype.getUnmaskedValue = function(src) {
                    return this.getNumberUnmaskedValue(src);
                };
                InputMaskNumeric.prototype.processInput = function(args) {
                    var result = {
                        value: args.prevValue,
                        caretPosition: args.selectionEnd,
                        cancelPreventDefault: false
                    };
                    var leftPart = args.prevValue.slice(0, args.selectionStart) + (args.insertedChars || "");
                    var rightPart = args.prevValue.slice(args.selectionEnd);
                    var src = leftPart + rightPart;
                    var parsedNumber = this.parseNumber(src);
                    if (!this.validateNumber(parsedNumber)) return result;
                    var maskedValue = this.getNumberMaskedValue(src);
                    var caretPosition = this.calccaretPosition(leftPart, args, maskedValue);
                    result.value = maskedValue;
                    result.caretPosition = caretPosition;
                    return result;
                };
                InputMaskNumeric.prototype.getType = function() {
                    return "numericmask";
                };
                InputMaskNumeric.prototype.isPropertyEmpty = function(value) {
                    return value === "" || value === undefined || value === null;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskNumeric.prototype, "allowNegativeValues", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskNumeric.prototype, "decimalSeparator", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskNumeric.prototype, "precision", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskNumeric.prototype, "thousandsSeparator", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskNumeric.prototype, "min", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], InputMaskNumeric.prototype, "max", void 0);
                return InputMaskNumeric;
            }(_mask_base__WEBPACK_IMPORTED_MODULE_1__["InputMaskBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("numericmask", [
                {
                    name: "allowNegativeValues:boolean",
                    default: true
                },
                {
                    name: "decimalSeparator",
                    default: ".",
                    maxLength: 1
                },
                {
                    name: "thousandsSeparator",
                    default: ",",
                    maxLength: 1
                },
                {
                    name: "precision:number",
                    default: 2,
                    minValue: 0
                },
                {
                    name: "min:number"
                },
                {
                    name: "max:number"
                }
            ], function() {
                return new InputMaskNumeric();
            }, "masksettings");
        /***/ },
        /***/ "./src/mask/mask_pattern.ts": /*!**********************************!*\
  !*** ./src/mask/mask_pattern.ts ***!
  \**********************************/ /*! exports provided: getLiterals, getMaskedValueByPattern, getUnmaskedValueByPattern, InputMaskPattern */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLiterals", function() {
                return getLiterals;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getMaskedValueByPattern", function() {
                return getMaskedValueByPattern;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getUnmaskedValueByPattern", function() {
                return getUnmaskedValueByPattern;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "InputMaskPattern", function() {
                return InputMaskPattern;
            });
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../settings */ "./src/settings.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _mask_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./mask_base */ "./src/mask/mask_base.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            function getLiterals(pattern) {
                var result = [];
                var prevCharIsEscaped = false;
                var definitionsKeys = Object.keys(_settings__WEBPACK_IMPORTED_MODULE_0__["settings"].maskSettings.patternDefinitions);
                for(var index = 0; index < pattern.length; index++){
                    var currentChar = pattern[index];
                    if (currentChar === _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].maskSettings.patternEscapeChar) prevCharIsEscaped = true;
                    else if (prevCharIsEscaped) {
                        prevCharIsEscaped = false;
                        result.push({
                            type: "fixed",
                            value: currentChar
                        });
                    } else result.push({
                        type: definitionsKeys.indexOf(currentChar) !== -1 ? "regex" : "const",
                        value: currentChar
                    });
                }
                return result;
            }
            function getFirstMatch(str, strIndex, literal) {
                var currentDefinition = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].maskSettings.patternDefinitions[literal.value];
                while(strIndex < str.length){
                    if (str[strIndex].match(currentDefinition)) return strIndex;
                    strIndex++;
                }
                return strIndex;
            }
            function getMaskedValueByPattern(src, pattern, matchWholeMask) {
                var input = src === undefined || src === null ? "" : src;
                var result = "";
                var strIndex = 0;
                var literals = typeof pattern === "string" ? getLiterals(pattern) : pattern;
                for(var maskIndex = 0; maskIndex < literals.length; maskIndex++)switch(literals[maskIndex].type){
                    case "regex":
                        if (strIndex < input.length) strIndex = getFirstMatch(input, strIndex, literals[maskIndex]);
                        if (strIndex < input.length) result += input[strIndex];
                        else if (matchWholeMask) result += _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].maskSettings.patternPlaceholderChar;
                        else return result;
                        strIndex++;
                        break;
                    case "const":
                    case "fixed":
                        result += literals[maskIndex].value;
                        if (literals[maskIndex].value === input[strIndex]) strIndex++;
                        break;
                }
                return result;
            }
            function getUnmaskedValueByPattern(str, pattern, matchWholeMask, skipFixedChar) {
                if (skipFixedChar === void 0) skipFixedChar = false;
                var result = "";
                if (!str) return result;
                var literals = typeof pattern === "string" ? getLiterals(pattern) : pattern;
                for(var index = 0; index < literals.length; index++){
                    if (literals[index].type === "fixed" && !skipFixedChar) result += literals[index].value;
                    if (literals[index].type === "regex") {
                        var currentDefinition = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].maskSettings.patternDefinitions[literals[index].value];
                        if (!!str[index] && str[index].match(currentDefinition)) result += str[index];
                        else if (matchWholeMask) {
                            result = "";
                            break;
                        } else break;
                    }
                }
                return result;
            }
            /**
 * A class that describes an input mask of the `"pattern"` [`maskType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#maskType).
 *
 * The following code shows how to specify the properties of this class within a survey JSON schema:
 *
 * ```js
 * const surveyJson = {
 *   "elements": [{
 *     "name": "textquestion1"
 *     "type": "text",
 *     "maskType": "pattern",
 *     "maskSettings": {
 *       // Specify the properties of a pattern input mask here
 *     }
 *   }]
 * }
 * ```
 *
 * [View Demo](https://surveyjs.io/form-library/examples/masked-input-fields/ (linkStyle))
 */ var InputMaskPattern = /** @class */ function(_super) {
                __extends(InputMaskPattern, _super);
                function InputMaskPattern() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.literals = [];
                    return _this;
                }
                InputMaskPattern.prototype.updateLiterals = function() {
                    this.literals = getLiterals(this.pattern || "");
                };
                InputMaskPattern.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {
                    if (name === "pattern") this.updateLiterals();
                };
                InputMaskPattern.prototype.getType = function() {
                    return "patternmask";
                };
                InputMaskPattern.prototype.fromJSON = function(json, options) {
                    _super.prototype.fromJSON.call(this, json, options);
                    this.updateLiterals();
                };
                InputMaskPattern.prototype._getMaskedValue = function(src, matchWholeMask) {
                    if (matchWholeMask === void 0) matchWholeMask = false;
                    var input = src === undefined || src === null ? "" : src;
                    return getMaskedValueByPattern(input, this.literals, matchWholeMask);
                };
                InputMaskPattern.prototype._getUnmaskedValue = function(src, matchWholeMask) {
                    if (matchWholeMask === void 0) matchWholeMask = false;
                    var input = src === undefined || src === null ? "" : src;
                    return getUnmaskedValueByPattern(input, this.literals, matchWholeMask);
                };
                InputMaskPattern.prototype.processInput = function(args) {
                    var result = {
                        value: args.prevValue,
                        caretPosition: args.selectionEnd,
                        cancelPreventDefault: false
                    };
                    if (!args.insertedChars && args.selectionStart === args.selectionEnd) return result;
                    var leftPart = args.prevValue.slice(0, args.selectionStart) + (args.insertedChars || "");
                    var leftPartUnmasked = getUnmaskedValueByPattern(args.prevValue.slice(0, args.selectionStart), this.literals.slice(0, args.selectionStart), false);
                    var rightPartUnmasked = getUnmaskedValueByPattern(args.prevValue.slice(args.selectionEnd), this.literals.slice(args.selectionEnd), false, true);
                    result.value = this._getMaskedValue(leftPartUnmasked + (args.insertedChars || "") + rightPartUnmasked, true);
                    if (!args.insertedChars && args.inputDirection === "backward") result.caretPosition = args.selectionStart;
                    else result.caretPosition = this._getMaskedValue(leftPart).length;
                    return result;
                };
                InputMaskPattern.prototype.getMaskedValue = function(src) {
                    return this._getMaskedValue(src, true);
                };
                InputMaskPattern.prototype.getUnmaskedValue = function(src) {
                    return this._getUnmaskedValue(src, true);
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], InputMaskPattern.prototype, "pattern", void 0);
                return InputMaskPattern;
            }(_mask_base__WEBPACK_IMPORTED_MODULE_2__["InputMaskBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("patternmask", [
                {
                    name: "pattern"
                }
            ], function() {
                return new InputMaskPattern();
            }, "masksettings");
        /***/ },
        /***/ "./src/mask/mask_utils.ts": /*!********************************!*\
  !*** ./src/mask/mask_utils.ts ***!
  \********************************/ /*! exports provided: numberDefinition */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numberDefinition", function() {
                return numberDefinition;
            });
            var numberDefinition = /[0-9]/;
        /***/ },
        /***/ "./src/multiSelectListModel.ts": /*!*************************************!*\
  !*** ./src/multiSelectListModel.ts ***!
  \*************************************/ /*! exports provided: MultiSelectListModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultiSelectListModel", function() {
                return MultiSelectListModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./list */ "./src/list.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var MultiSelectListModel = /** @class */ function(_super) {
                __extends(MultiSelectListModel, _super);
                function MultiSelectListModel(items, onSelectionChanged, allowSelection, selectedItems, onFilterStringChangedCallback, elementId) {
                    var _this = _super.call(this, items, onSelectionChanged, allowSelection, undefined, onFilterStringChangedCallback, elementId) || this;
                    _this.onItemClick = function(item) {
                        if (_this.isItemDisabled(item)) return;
                        _this.isExpanded = false;
                        if (_this.isItemSelected(item)) {
                            _this.selectedItems.splice(_this.selectedItems.indexOf(item), 1)[0];
                            !!_this.onSelectionChanged && _this.onSelectionChanged(item, "removed");
                        } else {
                            _this.selectedItems.push(item);
                            !!_this.onSelectionChanged && _this.onSelectionChanged(item, "added");
                        }
                    };
                    _this.isItemDisabled = function(itemValue) {
                        return itemValue.enabled !== undefined && !itemValue.enabled;
                    };
                    _this.isItemSelected = function(itemValue) {
                        return !!_this.allowSelection && _this.selectedItems.filter(function(item) {
                            return _this.areSameItems(item, itemValue);
                        }).length > 0;
                    };
                    _this.setSelectedItems(selectedItems || []);
                    return _this;
                }
                MultiSelectListModel.prototype.updateItemState = function() {
                    var _this = this;
                    this.actions.forEach(function(action) {
                        var isSelected = _this.isItemSelected(action);
                        action.visible = _this.hideSelectedItems ? !isSelected : true;
                    });
                };
                MultiSelectListModel.prototype.updateState = function() {
                    var _this = this;
                    this.updateItemState();
                    this.isEmpty = this.renderedActions.filter(function(action) {
                        return _this.isItemVisible(action);
                    }).length === 0;
                };
                MultiSelectListModel.prototype.setSelectedItems = function(newItems) {
                    this.selectedItems = newItems;
                    this.updateState();
                };
                MultiSelectListModel.prototype.selectFocusedItem = function() {
                    _super.prototype.selectFocusedItem.call(this);
                    if (this.hideSelectedItems) this.focusNextVisibleItem();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], MultiSelectListModel.prototype, "hideSelectedItems", void 0);
                return MultiSelectListModel;
            }(_list__WEBPACK_IMPORTED_MODULE_1__["ListModel"]);
        /***/ },
        /***/ "./src/notifier.ts": /*!*************************!*\
  !*** ./src/notifier.ts ***!
  \*************************/ /*! exports provided: Notifier */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Notifier", function() {
                return Notifier;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var Notifier = /** @class */ function(_super) {
                __extends(Notifier, _super);
                function Notifier(cssClasses) {
                    var _this = _super.call(this) || this;
                    _this.cssClasses = cssClasses;
                    _this.timeout = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].notifications.lifetime;
                    _this.timer = undefined;
                    _this.actionsVisibility = {};
                    _this.showActions = true;
                    _this.actionBar = new _actions_container__WEBPACK_IMPORTED_MODULE_4__["ActionContainer"]();
                    _this.actionBar.updateCallback = function(isResetInitialized) {
                        _this.actionBar.actions.forEach(function(action) {
                            return action.cssClasses = {};
                        });
                    };
                    _this.css = _this.cssClasses.root;
                    return _this;
                }
                Notifier.prototype.getCssClass = function(type) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.cssClasses.root).append(this.cssClasses.rootWithButtons, this.actionBar.visibleActions.length > 0).append(this.cssClasses.info, type !== "error" && type !== "success").append(this.cssClasses.error, type === "error").append(this.cssClasses.success, type === "success").append(this.cssClasses.shown, this.active).toString();
                };
                Notifier.prototype.updateActionsVisibility = function(type) {
                    var _this = this;
                    this.actionBar.actions.forEach(function(action) {
                        return action.visible = _this.showActions && _this.actionsVisibility[action.id] === type;
                    });
                };
                Notifier.prototype.notify = function(message, type, waitUserAction) {
                    var _this = this;
                    if (type === void 0) type = "info";
                    if (waitUserAction === void 0) waitUserAction = false;
                    this.isDisplayed = true;
                    setTimeout(function() {
                        _this.updateActionsVisibility(type);
                        _this.message = message;
                        _this.active = true;
                        _this.css = _this.getCssClass(type);
                        if (!!_this.timer) {
                            clearTimeout(_this.timer);
                            _this.timer = undefined;
                        }
                        if (!waitUserAction) _this.timer = setTimeout(function() {
                            _this.timer = undefined;
                            _this.active = false;
                            _this.css = _this.getCssClass(type);
                        }, _this.timeout);
                    }, 1);
                };
                Notifier.prototype.addAction = function(action, notificationType) {
                    action.visible = false;
                    action.innerCss = this.cssClasses.button;
                    var res = this.actionBar.addAction(action);
                    this.actionsVisibility[res.id] = notificationType;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: false
                    })
                ], Notifier.prototype, "active", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: false
                    })
                ], Notifier.prototype, "isDisplayed", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Notifier.prototype, "message", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Notifier.prototype, "css", void 0);
                return Notifier;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
        /***/ },
        /***/ "./src/page.ts": /*!*********************!*\
  !*** ./src/page.ts ***!
  \*********************/ /*! exports provided: PageModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PageModel", function() {
                return PageModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _panel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./panel */ "./src/panel.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _drag_drop_page_helper_v1__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./drag-drop-page-helper-v1 */ "./src/drag-drop-page-helper-v1.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * The `PageModel` object describes a survey page and contains properties and methods that allow you to control the page and access its elements (panels and questions).
 *
 * [View Demo](https://surveyjs.io/form-library/examples/nps-question/ (linkStyle))
 */ var PageModel = /** @class */ function(_super) {
                __extends(PageModel, _super);
                function PageModel(name) {
                    if (name === void 0) name = "";
                    var _this = _super.call(this, name) || this;
                    _this.hasShownValue = false;
                    /**
         * A time period that a respondent has spent on this page so far; measured in seconds. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
         * @see maxTimeToFinish
         */ _this.timeSpent = 0;
                    _this.locTitle.onGetTextCallback = function(text) {
                        if (_this.canShowPageNumber() && text) return _this.num + ". " + text;
                        return text;
                    };
                    _this.createLocalizableString("navigationTitle", _this, true);
                    _this.createLocalizableString("navigationDescription", _this, true);
                    _this.dragDropPageHelper = new _drag_drop_page_helper_v1__WEBPACK_IMPORTED_MODULE_3__["DragDropPageHelperV1"](_this);
                    return _this;
                }
                PageModel.prototype.getType = function() {
                    return "page";
                };
                PageModel.prototype.toString = function() {
                    return this.name;
                };
                Object.defineProperty(PageModel.prototype, "isPage", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                PageModel.prototype.canShowPageNumber = function() {
                    return this.survey && this.survey.showPageNumbers;
                };
                PageModel.prototype.canShowTitle = function() {
                    return this.survey && this.survey.showPageTitles;
                };
                Object.defineProperty(PageModel.prototype, "navigationTitle", {
                    /**
         * A caption displayed on a navigation button in the TOC or progress bar. Applies when [`showTOC`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#showTOC) is `true` or when the [progress bar is visible](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#showProgressBar), [`progressBarType`](https://surveyjs.io/form-library/documentation/surveymodel#progressBarType) is set to `"pages"`, and [`progressBarShowPageTitles`](https://surveyjs.io/form-library/documentation/surveymodel#progressBarShowPageTitles) is `true`.
         *
         * If navigation titles are unspecified, the navigation buttons display page [titles](https://surveyjs.io/form-library/documentation/api-reference/page-model#title) or [names](https://surveyjs.io/form-library/documentation/pagemodel#name).
         */ get: function() {
                        return this.getLocalizableStringText("navigationTitle");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("navigationTitle", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "locNavigationTitle", {
                    get: function() {
                        return this.getLocalizableString("navigationTitle");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "navigationDescription", {
                    /**
         * Explanatory text displayed under a navigation button in the progress bar. Applies when the [progress bar is visible](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#showProgressBar), `SurveyModel`'s [`progressBarType`](https://surveyjs.io/form-library/documentation/surveymodel#progressBarType) is set to `"pages"`, and [`progressBarShowPageTitles`](https://surveyjs.io/form-library/documentation/surveymodel#progressBarShowPageTitles) is `true`.
         */ get: function() {
                        return this.getLocalizableStringText("navigationDescription");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("navigationDescription", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "locNavigationDescription", {
                    get: function() {
                        return this.getLocalizableString("navigationDescription");
                    },
                    enumerable: false,
                    configurable: true
                });
                PageModel.prototype.navigationLocStrChanged = function() {
                    this.locNavigationTitle.strChanged();
                    this.locNavigationDescription.strChanged();
                };
                Object.defineProperty(PageModel.prototype, "renderedNavigationTitle", {
                    get: function() {
                        return this.locNavigationTitle.renderedHtml || this.title || this.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "passed", {
                    get: function() {
                        return this.getPropertyValue("passed", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("passed", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PageModel.prototype.removeFromParent = function() {
                    if (!!this.survey) this.removeSelfFromList(this.survey.pages);
                };
                PageModel.prototype.onFirstRendering = function() {
                    if (this.wasShown) return;
                    _super.prototype.onFirstRendering.call(this);
                };
                Object.defineProperty(PageModel.prototype, "visibleIndex", {
                    /**
         * The visible index of the page. It has values from 0 to visible page count - 1.
         * @see SurveyModel.visiblePages
         * @see SurveyModel.pages
         */ get: function() {
                        return this.getPropertyValue("visibleIndex", -1);
                    },
                    set: function(val1) {
                        this.setPropertyValue("visibleIndex", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PageModel.prototype.canRenderFirstRows = function() {
                    return !this.isDesignMode || this.visibleIndex == 0;
                };
                Object.defineProperty(PageModel.prototype, "isStartPage", {
                    /**
         * Returns `true` if this page is a start page.
         *
         * Refer to the following help topic for more information on how to configure a start page: [Start Page](https://surveyjs.io/form-library/documentation/design-survey-create-a-multi-page-survey#start-page).
         */ get: function() {
                        return this.survey && this.survey.isPageStarted(this);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "isStarted", {
                    get: function() {
                        return this.isStartPage;
                    },
                    enumerable: false,
                    configurable: true
                });
                PageModel.prototype.calcCssClasses = function(css) {
                    var classes = {
                        page: {},
                        error: {},
                        pageTitle: "",
                        pageDescription: "",
                        row: "",
                        rowMultiple: "",
                        pageRow: "",
                        rowCompact: "",
                        rowFadeIn: "",
                        rowFadeOut: "",
                        rowFadeOutActive: ""
                    };
                    this.copyCssClasses(classes.page, css.page);
                    this.copyCssClasses(classes.error, css.error);
                    if (!!css.pageTitle) classes.pageTitle = css.pageTitle;
                    if (!!css.pageDescription) classes.pageDescription = css.pageDescription;
                    if (!!css.row) classes.row = css.row;
                    if (!!css.pageRow) classes.pageRow = css.pageRow;
                    if (!!css.rowMultiple) classes.rowMultiple = css.rowMultiple;
                    if (!!css.rowCompact) classes.rowCompact = css.rowCompact;
                    if (!!css.rowFadeIn) classes.rowFadeIn = css.rowFadeIn;
                    if (!!css.rowFadeOut) classes.rowFadeOut = css.rowFadeOut;
                    if (!!css.rowFadeOutActive) classes.rowFadeOutActive = css.rowFadeOutActive;
                    if (this.survey) this.survey.updatePageCssClasses(this, classes);
                    return classes;
                };
                Object.defineProperty(PageModel.prototype, "cssTitle", {
                    get: function() {
                        if (!this.cssClasses.page) return "";
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append(this.cssClasses.page.title).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "cssRoot", {
                    get: function() {
                        if (!this.cssClasses.page || !this.survey) return "";
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append(this.cssClasses.page.root).append(this.cssClasses.page.emptyHeaderRoot, !this.survey.renderedHasHeader && !(this.survey.isShowProgressBarOnTop && !this.survey.isStaring)).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                PageModel.prototype.getCssError = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append(_super.prototype.getCssError.call(this, cssClasses)).append(cssClasses.page.errorsContainer).toString();
                };
                Object.defineProperty(PageModel.prototype, "navigationButtonsVisibility", {
                    /**
         * Set this property to "hide" to make "Prev", "Next" and "Complete" buttons are invisible for this page. Set this property to "show" to make these buttons visible, even if survey showNavigationButtons property is false.
         * @see SurveyMode.showNavigationButtons
         */ get: function() {
                        return this.getPropertyValue("navigationButtonsVisibility");
                    },
                    set: function(val1) {
                        this.setPropertyValue("navigationButtonsVisibility", val1.toLowerCase());
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "isActive", {
                    /**
         * Returns `true` if this is the current page.
         * @see SurveyModel.currentPage
         */ get: function() {
                        return !!this.survey && this.survey.currentPage === this;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "wasShown", {
                    /**
         * Returns `true` if the respondent has already seen this page during the current session.
         */ get: function() {
                        return this.hasShownValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PageModel.prototype, "hasShown", {
                    get: function() {
                        return this.wasShown;
                    },
                    enumerable: false,
                    configurable: true
                });
                PageModel.prototype.setWasShown = function(val1) {
                    if (val1 == this.hasShownValue) return;
                    this.hasShownValue = val1;
                    if (this.isDesignMode || val1 !== true) return;
                    var els = this.elements;
                    for(var i = 0; i < els.length; i++)if (els[i].isPanel) els[i].randomizeElements(this.areQuestionsRandomized);
                    this.randomizeElements(this.areQuestionsRandomized);
                };
                /**
     * Scrolls this page to the top.
     */ PageModel.prototype.scrollToTop = function() {
                    if (!!this.survey) this.survey.scrollElementToTop(this, null, this, this.id);
                };
                // public get timeSpent(): number {
                //   return this.getPropertyValue("timeSpent", 0);
                // }
                // public set timeSpent(val: number) {
                //   this.setPropertyValue("timeSpent", val);
                // }
                /**
     * Returns a list of all panels on this page.
     * @param visibleOnly A Boolean value that specifies whether to include only visible panels.
     * @param includingDesignTime For internal use.
     */ PageModel.prototype.getAllPanels = function(visibleOnly, includingDesignTime) {
                    if (visibleOnly === void 0) visibleOnly = false;
                    if (includingDesignTime === void 0) includingDesignTime = false;
                    var result = new Array();
                    this.addPanelsIntoList(result, visibleOnly, includingDesignTime);
                    return result;
                };
                PageModel.prototype.getPanels = function(visibleOnly, includingDesignTime) {
                    if (visibleOnly === void 0) visibleOnly = false;
                    if (includingDesignTime === void 0) includingDesignTime = false;
                    return this.getAllPanels(visibleOnly, includingDesignTime);
                };
                Object.defineProperty(PageModel.prototype, "maxTimeToFinish", {
                    /**
         * A time period that a respondent has to complete this page; measured in seconds. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
         *
         * A negative value or 0 sets an unlimited time period.
         *
         * Alternatively, you can use the `SurveyModel`'s [`maxTimeToFinishPage`](https://surveyjs.io/form-library/documentation/surveymodel#maxTimeToFinishPage) property to specify identical time periods for all survey pages.
         * @see timeSpent
         */ get: function() {
                        return this.getPropertyValue("maxTimeToFinish", 0);
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxTimeToFinish", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PageModel.prototype.onNumChanged = function(value) {};
                PageModel.prototype.onVisibleChanged = function() {
                    if (this.isRandomizing) return;
                    _super.prototype.onVisibleChanged.call(this);
                    if (this.survey != null) this.survey.pageVisibilityChanged(this, this.isVisible);
                };
                PageModel.prototype.getDragDropInfo = function() {
                    return this.dragDropPageHelper.getDragDropInfo();
                };
                PageModel.prototype.dragDropStart = function(src, target, nestedPanelDepth) {
                    if (nestedPanelDepth === void 0) nestedPanelDepth = -1;
                    this.dragDropPageHelper.dragDropStart(src, target, nestedPanelDepth);
                };
                PageModel.prototype.dragDropMoveTo = function(destination, isBottom, isEdge) {
                    if (isBottom === void 0) isBottom = false;
                    if (isEdge === void 0) isEdge = false;
                    return this.dragDropPageHelper.dragDropMoveTo(destination, isBottom, isEdge);
                };
                PageModel.prototype.dragDropFinish = function(isCancel) {
                    if (isCancel === void 0) isCancel = false;
                    return this.dragDropPageHelper.dragDropFinish(isCancel);
                };
                PageModel.prototype.ensureRowsVisibility = function() {
                    _super.prototype.ensureRowsVisibility.call(this);
                    this.getPanels().forEach(function(panel) {
                        return panel.ensureRowsVisibility();
                    });
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: -1,
                        onSet: function(val1, target) {
                            return target.onNumChanged(val1);
                        }
                    })
                ], PageModel.prototype, "num", void 0);
                return PageModel;
            }(_panel__WEBPACK_IMPORTED_MODULE_1__["PanelModelBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("page", [
                {
                    name: "navigationButtonsVisibility",
                    default: "inherit",
                    choices: [
                        "inherit",
                        "show",
                        "hide"
                    ]
                },
                {
                    name: "maxTimeToFinish:number",
                    default: 0,
                    minValue: 0
                },
                {
                    name: "navigationTitle",
                    visibleIf: function(obj) {
                        return !!obj.survey && (obj.survey.progressBarType === "buttons" || obj.survey.showTOC);
                    },
                    serializationProperty: "locNavigationTitle"
                },
                {
                    name: "navigationDescription",
                    visibleIf: function(obj) {
                        return !!obj.survey && obj.survey.progressBarType === "buttons";
                    },
                    serializationProperty: "locNavigationDescription"
                },
                {
                    name: "title:text",
                    serializationProperty: "locTitle"
                },
                {
                    name: "description:text",
                    serializationProperty: "locDescription"
                }
            ], function() {
                return new PageModel();
            }, "panelbase");
        /***/ },
        /***/ "./src/panel.ts": /*!**********************!*\
  !*** ./src/panel.ts ***!
  \**********************/ /*! exports provided: QuestionRowModel, PanelModelBase, PanelModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionRowModel", function() {
                return QuestionRowModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PanelModelBase", function() {
                return PanelModelBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PanelModel", function() {
                return PanelModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _drag_drop_panel_helper_v1__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./drag-drop-panel-helper-v1 */ "./src/drag-drop-panel-helper-v1.ts");
            /* harmony import */ var _utils_animation__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils/animation */ "./src/utils/animation.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var __spreadArray = function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            var QuestionRowModel = /** @class */ function(_super) {
                __extends(QuestionRowModel, _super);
                function QuestionRowModel(panel) {
                    var _this = _super.call(this) || this;
                    _this.panel = panel;
                    _this._scrollableParent = undefined;
                    _this._updateVisibility = undefined;
                    _this.visibleElementsAnimation = new _utils_animation__WEBPACK_IMPORTED_MODULE_11__["AnimationGroup"](_this.getVisibleElementsAnimationOptions(), function(value) {
                        _this.setPropertyValue("visibleElements", value);
                        _this.setWidth();
                    }, function() {
                        return _this.visibleElements;
                    });
                    _this.idValue = QuestionRowModel.getRowId();
                    _this.visible = panel.areInvisibleElementsShowing;
                    _this.createNewArray("elements");
                    _this.createNewArray("visibleElements");
                    return _this;
                }
                QuestionRowModel.getRowId = function() {
                    return "pr_" + QuestionRowModel.rowCounter++;
                };
                QuestionRowModel.prototype.startLazyRendering = function(rowContainerDiv, findScrollableContainer) {
                    var _this = this;
                    if (findScrollableContainer === void 0) findScrollableContainer = _utils_utils__WEBPACK_IMPORTED_MODULE_8__["findScrollableParent"];
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_12__["DomDocumentHelper"].isAvailable()) return;
                    this._scrollableParent = findScrollableContainer(rowContainerDiv);
                    // if  this._scrollableParent is html the scroll event isn't fired, so we should use window
                    if (this._scrollableParent === _global_variables_utils__WEBPACK_IMPORTED_MODULE_12__["DomDocumentHelper"].getDocumentElement()) this._scrollableParent = _global_variables_utils__WEBPACK_IMPORTED_MODULE_12__["DomWindowHelper"].getWindow();
                    var hasScroll = this._scrollableParent.scrollHeight > this._scrollableParent.clientHeight;
                    this.isNeedRender = !hasScroll;
                    if (hasScroll) {
                        this._updateVisibility = function() {
                            var isRowContainerDivVisible = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_8__["isElementVisible"])(rowContainerDiv, 50);
                            if (!_this.isNeedRender && isRowContainerDivVisible) {
                                _this.isNeedRender = true;
                                _this.stopLazyRendering();
                            }
                        };
                        setTimeout(function() {
                            if (!!_this._scrollableParent && !!_this._scrollableParent.addEventListener) _this._scrollableParent.addEventListener("scroll", _this._updateVisibility);
                            _this.ensureVisibility();
                        }, 10);
                    }
                };
                QuestionRowModel.prototype.ensureVisibility = function() {
                    if (!!this._updateVisibility) this._updateVisibility();
                };
                QuestionRowModel.prototype.stopLazyRendering = function() {
                    if (!!this._scrollableParent && !!this._updateVisibility && !!this._scrollableParent.removeEventListener) this._scrollableParent.removeEventListener("scroll", this._updateVisibility);
                    this._scrollableParent = undefined;
                    this._updateVisibility = undefined;
                };
                QuestionRowModel.prototype.setIsLazyRendering = function(val1) {
                    this.isLazyRenderingValue = val1;
                    this.isNeedRender = !val1;
                };
                QuestionRowModel.prototype.isLazyRendering = function() {
                    return this.isLazyRenderingValue === true;
                };
                Object.defineProperty(QuestionRowModel.prototype, "id", {
                    get: function() {
                        return this.idValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRowModel.prototype.equalsCore = function(obj) {
                    return this == obj;
                };
                Object.defineProperty(QuestionRowModel.prototype, "elements", {
                    get: function() {
                        return this.getPropertyValue("elements");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRowModel.prototype.getVisibleElementsAnimationOptions = function() {
                    var _this = this;
                    var beforeRunAnimation = function(el) {
                        el.style.setProperty("--animation-height", el.offsetHeight + "px");
                        el.style.setProperty("--animation-width", Object(_utils_utils__WEBPACK_IMPORTED_MODULE_8__["getElementWidth"])(el) + "px");
                    };
                    return {
                        isAnimationEnabled: function() {
                            var _a;
                            return _settings__WEBPACK_IMPORTED_MODULE_7__["settings"].animationEnabled && ((_a = _this.panel) === null || _a === void 0 ? void 0 : _a.animationAllowed) && _this.visible;
                        },
                        getAnimatedElement: function(element) {
                            return element.getWrapperElement();
                        },
                        getLeaveOptions: function(element) {
                            var surveyElement = element;
                            var cssClasses = element.isPanel ? surveyElement.cssClasses.panel : surveyElement.cssClasses;
                            return {
                                cssClass: cssClasses.fadeOut,
                                onBeforeRunAnimation: beforeRunAnimation
                            };
                        },
                        getEnterOptions: function(element) {
                            var surveyElement = element;
                            var cssClasses = element.isPanel ? surveyElement.cssClasses.panel : surveyElement.cssClasses;
                            return {
                                cssClass: cssClasses.fadeIn,
                                onBeforeRunAnimation: beforeRunAnimation
                            };
                        }
                    };
                };
                Object.defineProperty(QuestionRowModel.prototype, "visibleElements", {
                    get: function() {
                        return this.getPropertyValue("visibleElements");
                    },
                    set: function(val1) {
                        if (!val1.length) {
                            this.visible = false;
                            this.visibleElementsAnimation.cancel();
                            return;
                        } else this.visible = true;
                        this.visibleElementsAnimation.sync(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRowModel.prototype, "visible", {
                    get: function() {
                        return this.getPropertyValue("visible", true);
                    },
                    set: function(val1) {
                        this.setPropertyValue("visible", val1);
                        this.onVisibleChangedCallback && this.onVisibleChangedCallback();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRowModel.prototype, "isNeedRender", {
                    get: function() {
                        return this.getPropertyValue("isneedrender", true);
                    },
                    set: function(val1) {
                        this.setPropertyValue("isneedrender", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRowModel.prototype.updateVisible = function() {
                    var visElements = [];
                    for(var i = 0; i < this.elements.length; i++)if (this.elements[i].isVisible) visElements.push(this.elements[i]);
                    this.visibleElements = visElements;
                    return;
                };
                QuestionRowModel.prototype.addElement = function(q) {
                    this.elements.push(q);
                    this.updateVisible();
                };
                Object.defineProperty(QuestionRowModel.prototype, "index", {
                    get: function() {
                        return this.panel.rows.indexOf(this);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRowModel.prototype.setWidth = function() {
                    var _a;
                    var visCount = this.visibleElements.length;
                    if (visCount == 0) return;
                    var isSingleInRow = this.visibleElements.length === 1;
                    var counter = 0;
                    var preSetWidthElements = [];
                    for(var i = 0; i < this.elements.length; i++){
                        var el = this.elements[i];
                        if (el.isVisible) {
                            el.isSingleInRow = isSingleInRow;
                            var width = this.getElementWidth(el);
                            if (!!width) {
                                el.renderWidth = this.getRenderedWidthFromWidth(width);
                                preSetWidthElements.push(el);
                            }
                            if (counter < visCount - 1 && !(this.panel.isDefaultV2Theme || ((_a = this.panel.parentQuestion) === null || _a === void 0 ? void 0 : _a.isDefaultV2Theme))) el.rightIndent = 1;
                            else el.rightIndent = 0;
                            counter++;
                        } else el.renderWidth = "";
                    }
                    for(var i = 0; i < this.elements.length; i++){
                        var el = this.elements[i];
                        if (!el.isVisible || preSetWidthElements.indexOf(el) > -1) continue;
                        if (preSetWidthElements.length == 0) el.renderWidth = Number.parseFloat((100 / visCount).toFixed(6)) + "%";
                        else el.renderWidth = this.getRenderedCalcWidth(el, preSetWidthElements, visCount);
                    }
                };
                QuestionRowModel.prototype.getRenderedCalcWidth = function(el, preSetWidthElements, visCount) {
                    var expression = "100%";
                    for(var i = 0; i < preSetWidthElements.length; i++)expression += " - " + preSetWidthElements[i].renderWidth;
                    var calcWidthEl = visCount - preSetWidthElements.length;
                    if (calcWidthEl > 1) expression = "(" + expression + ")/" + calcWidthEl.toString();
                    return "calc(" + expression + ")";
                };
                QuestionRowModel.prototype.getElementWidth = function(el) {
                    var width = el.width;
                    if (!width || typeof width !== "string") return "";
                    return width.trim();
                };
                QuestionRowModel.prototype.getRenderedWidthFromWidth = function(width) {
                    return _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isNumber(width) ? width + "px" : width;
                };
                QuestionRowModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.stopLazyRendering();
                };
                QuestionRowModel.prototype.getRowCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_9__["CssClassBuilder"]().append(this.panel.cssClasses.row).append(this.panel.cssClasses.rowCompact, this.panel["isCompact"]).append(this.panel.cssClasses.pageRow, this.panel.isPage || !!this.panel.originalPage).append(this.panel.cssClasses.rowMultiple, this.visibleElements.length > 1).toString();
                };
                QuestionRowModel.prototype.setRootElement = function(element) {
                    this.rootElement = element;
                };
                QuestionRowModel.prototype.getRootElement = function() {
                    return this.rootElement;
                };
                QuestionRowModel.rowCounter = 100;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: null
                    })
                ], QuestionRowModel.prototype, "dragTypeOverMe", void 0);
                return QuestionRowModel;
            }(_base__WEBPACK_IMPORTED_MODULE_2__["Base"]);
            /**
 * A base class for the [PanelModel](https://surveyjs.io/form-library/documentation/panelmodel) and [PageModel](https://surveyjs.io/form-library/documentation/pagemodel) classes.
 */ var PanelModelBase = /** @class */ function(_super) {
                __extends(PanelModelBase, _super);
                function PanelModelBase(name) {
                    if (name === void 0) name = "";
                    var _this = _super.call(this, name) || this;
                    _this.isQuestionsReady = false;
                    _this.questionsValue = new Array();
                    _this.rowsAnimation = new _utils_animation__WEBPACK_IMPORTED_MODULE_11__["AnimationGroup"](_this.getRowsAnimationOptions(), function(value) {
                        _this.setPropertyValue("visibleRows", value);
                    }, function() {
                        return _this.visibleRows;
                    });
                    _this.isRandomizing = false;
                    _this.locCountRowUpdates = 0;
                    _this.createNewArray("rows", function(el, index) {
                        _this.onAddRow(el);
                    }, function(el) {
                        _this.onRemoveRow(el);
                    });
                    _this.createNewArray("visibleRows");
                    _this.elementsValue = _this.createNewArray("elements", _this.onAddElement.bind(_this), _this.onRemoveElement.bind(_this));
                    _this.id = PanelModelBase.getPanelId();
                    _this.addExpressionProperty("visibleIf", function(obj, res) {
                        _this.visible = res === true;
                    }, function(obj) {
                        return !_this.areInvisibleElementsShowing;
                    });
                    _this.addExpressionProperty("enableIf", function(obj, res) {
                        _this.readOnly = res === false;
                    });
                    _this.addExpressionProperty("requiredIf", function(obj, res) {
                        _this.isRequired = res === true;
                    });
                    _this.createLocalizableString("requiredErrorText", _this);
                    _this.registerPropertyChangedHandlers([
                        "questionTitleLocation"
                    ], function() {
                        _this.onVisibleChanged.bind(_this);
                        _this.updateElementCss(true);
                    });
                    _this.registerPropertyChangedHandlers([
                        "questionStartIndex",
                        "showQuestionNumbers"
                    ], function() {
                        _this.updateVisibleIndexes();
                    });
                    _this.dragDropPanelHelper = new _drag_drop_panel_helper_v1__WEBPACK_IMPORTED_MODULE_10__["DragDropPanelHelperV1"](_this);
                    return _this;
                }
                PanelModelBase.getPanelId = function() {
                    return "sp_" + PanelModelBase.panelCounter++;
                };
                PanelModelBase.prototype.onAddRow = function(row) {
                    var _this = this;
                    this.onRowVisibleChanged();
                    row.onVisibleChangedCallback = function() {
                        return _this.onRowVisibleChanged();
                    };
                };
                PanelModelBase.prototype.getRowsAnimationOptions = function() {
                    var _this = this;
                    var beforeRunAnimation = function(el) {
                        el.style.setProperty("--animation-height", el.offsetHeight + "px");
                    };
                    return {
                        isAnimationEnabled: function() {
                            return _settings__WEBPACK_IMPORTED_MODULE_7__["settings"].animationEnabled && _this.animationAllowed;
                        },
                        getAnimatedElement: function(row) {
                            return row.getRootElement();
                        },
                        getLeaveOptions: function(_) {
                            return {
                                cssClass: _this.cssClasses.rowFadeOut,
                                onBeforeRunAnimation: beforeRunAnimation
                            };
                        },
                        getEnterOptions: function(_) {
                            return {
                                cssClass: _this.cssClasses.rowFadeIn,
                                onBeforeRunAnimation: beforeRunAnimation
                            };
                        }
                    };
                };
                Object.defineProperty(PanelModelBase.prototype, "visibleRows", {
                    get: function() {
                        return this.getPropertyValue("visibleRows");
                    },
                    set: function(val1) {
                        this.rowsAnimation.sync(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.onRemoveRow = function(row) {
                    row.visibleElementsAnimation.cancel();
                    this.visibleRows = this.rows.filter(function(row) {
                        return row.visible;
                    });
                    row.onVisibleChangedCallback = undefined;
                };
                PanelModelBase.prototype.onRowVisibleChanged = function() {
                    this.visibleRows = this.rows.filter(function(row) {
                        return row.visible;
                    });
                };
                PanelModelBase.prototype.getType = function() {
                    return "panelbase";
                };
                PanelModelBase.prototype.setSurveyImpl = function(value, isLight) {
                    this.animationAllowed = false;
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    if (this.isDesignMode) this.onVisibleChanged();
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].setSurveyImpl(value, isLight);
                    this.animationAllowed = true;
                };
                PanelModelBase.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    this.updateDescriptionVisibility(this.description);
                    this.markQuestionListDirty();
                    this.onRowsChanged();
                };
                Object.defineProperty(PanelModelBase.prototype, "hasTitle", {
                    get: function() {
                        return this.canShowTitle() && this.locTitle.textOrHtml.length > 0 || this.isDesignMode && this.showTitle && _settings__WEBPACK_IMPORTED_MODULE_7__["settings"].designMode.showEmptyTitles;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.delete = function(doDispose) {
                    if (doDispose === void 0) doDispose = true;
                    this.removeFromParent();
                    if (doDispose) this.dispose();
                };
                PanelModelBase.prototype.removeFromParent = function() {};
                PanelModelBase.prototype.canShowTitle = function() {
                    return true;
                };
                Object.defineProperty(PanelModelBase.prototype, "_showDescription", {
                    get: function() {
                        if (!this.hasTitle && this.isDesignMode) return false;
                        return this.survey && this.survey.showPageTitles && this.hasDescription || this.showDescription && this.isDesignMode && _settings__WEBPACK_IMPORTED_MODULE_7__["settings"].designMode.showEmptyDescriptions;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].localeChanged();
                };
                PanelModelBase.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].locStrsChanged();
                };
                Object.defineProperty(PanelModelBase.prototype, "renderedNavigationTitle", {
                    get: function() {
                        return this.title || this.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "requiredText", {
                    /**
         * Returns a character or text string that indicates a required panel/page.
         * @see SurveyModel.requiredText
         * @see isRequired
         */ get: function() {
                        return !!this.survey && this.isRequired ? this.survey.requiredText : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "titlePattern", {
                    get: function() {
                        return !!this.survey ? this.survey.questionTitlePattern : "numTitleRequire";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "isRequireTextOnStart", {
                    get: function() {
                        return this.isRequired && this.titlePattern == "requireNumTitle";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "isRequireTextBeforeTitle", {
                    get: function() {
                        return this.isRequired && this.titlePattern == "numRequireTitle";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "isRequireTextAfterTitle", {
                    get: function() {
                        return this.isRequired && this.titlePattern == "numTitleRequire";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "requiredErrorText", {
                    /**
         * Specifies a custom error message for a required panel/page.
         * @see isRequired
         * @see requiredIf
         */ get: function() {
                        return this.getLocalizableStringText("requiredErrorText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("requiredErrorText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "locRequiredErrorText", {
                    get: function() {
                        return this.getLocalizableString("requiredErrorText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "questionsOrder", {
                    /**
         * Specifies the sort order of questions in the panel/page.
         *
         * Possible values:
         *
         * - `"initial"` - Preserves the original order of questions.
         * - `"random"` - Displays questions in random order.
         * - `"default"` (default) - Inherits the setting from the Survey's `questionsOrder` property.
         * @see SurveyModel.questionsOrder
         * @see areQuestionsRandomized
         */ get: function() {
                        return this.getPropertyValue("questionsOrder");
                    },
                    set: function(val1) {
                        this.setPropertyValue("questionsOrder", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.canRandomize = function(isRandom) {
                    return isRandom && this.questionsOrder !== "initial" || this.questionsOrder === "random";
                };
                PanelModelBase.prototype.randomizeElements = function(isRandom) {
                    if (!this.canRandomize(isRandom) || this.isRandomizing) return;
                    this.isRandomizing = true;
                    var oldElements = [];
                    var elements = this.elements;
                    for(var i = 0; i < elements.length; i++)oldElements.push(elements[i]);
                    var newElements = _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].randomizeArray(oldElements);
                    this.setArrayPropertyDirectly("elements", newElements, false);
                    this.updateRows();
                    this.updateVisibleIndexes();
                    this.isRandomizing = false;
                };
                Object.defineProperty(PanelModelBase.prototype, "areQuestionsRandomized", {
                    /**
         * Returns `true` if elements in this panel/page are arranged in random order.
         * @see questionsOrder
         */ get: function() {
                        var order = this.questionsOrder == "default" && this.survey ? this.survey.questionsOrder : this.questionsOrder;
                        return order == "random";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "parent", {
                    /**
         * Returns a survey element (panel or page) that contains this panel and allows you to move this question to a different survey element.
         *
         * This property is always `null` for the `PageModel` object.
         */ get: function() {
                        return this.getPropertyValue("parent", null);
                    },
                    set: function(val1) {
                        this.setPropertyValue("parent", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "depth", {
                    get: function() {
                        if (this.parent == null) return 0;
                        return this.parent.depth + 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "visibleIf", {
                    /**
         * A Boolean expression. If it evaluates to `false`, this panel/page becomes hidden.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see visible
         * @see isVisible
         */ get: function() {
                        return this.getPropertyValue("visibleIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("visibleIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.calcCssClasses = function(css) {
                    var classes = {
                        panel: {},
                        error: {},
                        row: "",
                        rowFadeIn: "",
                        rowFadeOut: "",
                        rowFadeOutActive: "",
                        rowMultiple: "",
                        pageRow: "",
                        rowCompact: ""
                    };
                    this.copyCssClasses(classes.panel, css.panel);
                    this.copyCssClasses(classes.error, css.error);
                    if (!!css.pageRow) classes.pageRow = css.pageRow;
                    if (!!css.rowCompact) classes.rowCompact = css.rowCompact;
                    if (!!css.row) classes.row = css.row;
                    if (!!css.rowFadeIn) classes.rowFadeIn = css.rowFadeIn;
                    if (!!css.rowFadeOut) classes.rowFadeOut = css.rowFadeOut;
                    if (!!css.rowFadeOutActive) classes.rowFadeOutActive = css.rowFadeOutActive;
                    if (!!css.rowMultiple) classes.rowMultiple = css.rowMultiple;
                    if (this.survey) this.survey.updatePanelCssClasses(this, classes);
                    return classes;
                };
                Object.defineProperty(PanelModelBase.prototype, "id", {
                    /**
         * An auto-generated unique element identifier.
         */ get: function() {
                        return this.getPropertyValue("id");
                    },
                    set: function(val1) {
                        this.setPropertyValue("id", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "isPanel", {
                    /**
         * Returns `true` if the survey element is a panel.
         * @see Base.getType
         */ get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.getPanel = function() {
                    return this;
                };
                PanelModelBase.prototype.getLayoutType = function() {
                    return "row";
                };
                PanelModelBase.prototype.isLayoutTypeSupported = function(layoutType) {
                    return layoutType !== "flow";
                };
                Object.defineProperty(PanelModelBase.prototype, "questions", {
                    /**
         * An array of all questions within this panel/page. Includes questions within nested panels.
         * @see elements
         */ get: function() {
                        if (!this.isQuestionsReady) {
                            this.questionsValue = [];
                            for(var i = 0; i < this.elements.length; i++){
                                var el = this.elements[i];
                                if (el.isPanel) {
                                    var qs = el.questions;
                                    for(var j = 0; j < qs.length; j++)this.questionsValue.push(qs[j]);
                                } else this.questionsValue.push(el);
                            }
                            this.isQuestionsReady = true;
                        }
                        return this.questionsValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.getQuestions = function(includeNested) {
                    var res = this.questions;
                    if (!includeNested) return res;
                    var res2 = [];
                    res.forEach(function(q) {
                        res2.push(q);
                        q.getNestedQuestions().forEach(function(nQ) {
                            return res2.push(nQ);
                        });
                    });
                    return res2;
                };
                PanelModelBase.prototype.getValidName = function(name) {
                    if (!!name) return name.trim();
                    return name;
                };
                /**
     * Returns a question with a specified `name`. This method does not find questions within nested panels.
     * @param name A question name.
     */ PanelModelBase.prototype.getQuestionByName = function(name) {
                    var questions = this.questions;
                    for(var i = 0; i < questions.length; i++){
                        if (questions[i].name == name) return questions[i];
                    }
                    return null;
                };
                /**
     * Returns a survey element with a specified `name`. This method can find survey elements within nested elements.
     * @param name An element name.
     */ PanelModelBase.prototype.getElementByName = function(name) {
                    var elements = this.elements;
                    for(var i = 0; i < elements.length; i++){
                        var el = elements[i];
                        if (el.name == name) return el;
                        var pnl = el.getPanel();
                        if (!!pnl) {
                            var res = pnl.getElementByName(name);
                            if (!!res) return res;
                        }
                    }
                    return null;
                };
                PanelModelBase.prototype.getQuestionByValueName = function(valueName) {
                    var questions = this.questions;
                    for(var i = 0; i < questions.length; i++){
                        if (questions[i].getValueName() == valueName) return questions[i];
                    }
                    return null;
                };
                /**
     * Returns a JSON object with question values nested in the panel/page.
     * @see getDisplayValue
     */ PanelModelBase.prototype.getValue = function() {
                    var data = {};
                    this.collectValues(data, 0);
                    return data;
                };
                PanelModelBase.prototype.collectValues = function(data, level) {
                    var elements = this.elements;
                    if (level === 0) elements = this.questions;
                    var hasValue = false;
                    for(var i = 0; i < elements.length; i++){
                        var el = elements[i];
                        if (el.isPanel || el.isPage) {
                            var panelData = {};
                            if (el.collectValues(panelData, level - 1)) {
                                data[el.name] = panelData;
                                hasValue = true;
                            }
                        } else {
                            var q = el;
                            if (!q.isEmpty()) {
                                var valueName = q.getValueName();
                                data[valueName] = q.value;
                                if (!!this.data) {
                                    var comment = this.data.getComment(valueName);
                                    if (!!comment) data[valueName + _base__WEBPACK_IMPORTED_MODULE_2__["Base"].commentSuffix] = comment;
                                }
                            }
                            hasValue = true;
                        }
                    }
                    return true;
                };
                /**
     * Returns a JSON object with display texts that correspond to question values nested in the panel/page.
     * @param keysAsText Pass `true` if not only values in the object should be display texts, but also keys. Default value: `false`.
     * @see getValue
     */ PanelModelBase.prototype.getDisplayValue = function(keysAsText) {
                    var data = {};
                    var questions = this.questions;
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        if (q.isEmpty()) continue;
                        var valueName = keysAsText ? q.title : q.getValueName();
                        data[valueName] = q.getDisplayValue(keysAsText);
                    }
                    return data;
                };
                /**
     * Returns a JSON object with comments left to questions within this panel/page. Question names are used as keys.
     */ PanelModelBase.prototype.getComments = function() {
                    var comments = {};
                    if (!this.data) return comments;
                    var questions = this.questions;
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        var comment = this.data.getComment(q.getValueName());
                        if (!!comment) comments[q.getValueName()] = comment;
                    }
                    return comments;
                };
                /**
     * Removes values that cannot be assigned to nested questions, for example, choices unlisted in the `choices` array.
     *
     * Call this method after you assign new question values in code to ensure that they are acceptable.
     *
     * > This method does not remove values for invisible questions and values that fail validation. Call the `validate()` method to validate newly assigned values.
     *
     * @see validate
     */ PanelModelBase.prototype.clearIncorrectValues = function() {
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].clearIncorrectValues();
                };
                /**
     * Empties the `errors` array for this panel/page and all its child elements (panels and questions).
     * @see errors
     */ PanelModelBase.prototype.clearErrors = function() {
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].clearErrors();
                    this.errors = [];
                };
                PanelModelBase.prototype.markQuestionListDirty = function() {
                    this.isQuestionsReady = false;
                    if (this.parent) this.parent.markQuestionListDirty();
                };
                Object.defineProperty(PanelModelBase.prototype, "elements", {
                    /**
         * An array of all survey elements (questions or panels) within this panel/page. Does not include questions within nested panels.
         * @see questions
         */ get: function() {
                        return this.elementsValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.getElementsInDesign = function(includeHidden) {
                    if (includeHidden === void 0) includeHidden = false;
                    return this.elements;
                };
                /**
     * Checks whether a given element belongs to this panel/page or nested panels.
     * @param element A survey element to check.
     */ PanelModelBase.prototype.containsElement = function(element) {
                    for(var i = 0; i < this.elements.length; i++){
                        var el = this.elements[i];
                        if (el == element) return true;
                        var pnl = el.getPanel();
                        if (!!pnl) {
                            if (pnl.containsElement(element)) return true;
                        }
                    }
                    return false;
                };
                Object.defineProperty(PanelModelBase.prototype, "isRequired", {
                    /**
         * Makes the panel/page require an answer at least in one nested question. If a respondent leaves the panel/page without any answers, the survey displays a validation error.
         * @see requiredIf
         * @see [Data Validation](https://surveyjs.io/form-library/documentation/data-validation)
         */ get: function() {
                        return this.getPropertyValue("isRequired");
                    },
                    set: function(val1) {
                        this.setPropertyValue("isRequired", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "requiredIf", {
                    /**
         * A Boolean expression. If it evaluates to `true`, this panel/page becomes required (at least one question in the panel/page should have an answer).
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see isRequired
         */ get: function() {
                        return this.getPropertyValue("requiredIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("requiredIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.searchText = function(text, founded) {
                    _super.prototype.searchText.call(this, text, founded);
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].searchText(text, founded);
                };
                PanelModelBase.prototype.hasErrors = function(fireCallback, focusOnFirstError, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (focusOnFirstError === void 0) focusOnFirstError = false;
                    if (rec === void 0) rec = null;
                    return !this.validate(fireCallback, focusOnFirstError, rec);
                };
                /**
     * Validates questions within this panel or page and returns `false` if the validation fails.
     * @param fireCallback *(Optional)* Pass `false` if you do not want to show validation errors in the UI.
     * @param focusOnFirstError *(Optional)* Pass `true` if you want to focus the first question with a validation error.
     * @see [Data Validation](https://surveyjs.io/form-library/documentation/data-validation)
     */ PanelModelBase.prototype.validate = function(fireCallback, focusOnFirstError, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (focusOnFirstError === void 0) focusOnFirstError = false;
                    if (rec === void 0) rec = null;
                    rec = !!rec ? rec : {
                        fireCallback: fireCallback,
                        focuseOnFirstError: focusOnFirstError,
                        firstErrorQuestion: null,
                        result: false
                    };
                    if (rec.result !== true) rec.result = false;
                    this.hasErrorsCore(rec);
                    if (rec.firstErrorQuestion) rec.firstErrorQuestion.focus(true);
                    return !rec.result;
                };
                PanelModelBase.prototype.validateContainerOnly = function() {
                    this.hasErrorsInPanels({
                        fireCallback: true
                    });
                    if (!!this.parent) this.parent.validateContainerOnly();
                };
                PanelModelBase.prototype.hasErrorsInPanels = function(rec) {
                    var errors = [];
                    this.hasRequiredError(rec, errors);
                    if (this.survey) {
                        var customError = this.survey.validatePanel(this);
                        if (customError) {
                            errors.push(customError);
                            rec.result = true;
                        }
                    }
                    if (!!rec.fireCallback) {
                        if (!!this.survey) this.survey.beforeSettingPanelErrors(this, errors);
                        this.errors = errors;
                    }
                };
                //ISurveyErrorOwner
                PanelModelBase.prototype.getErrorCustomText = function(text, error) {
                    if (!!this.survey) return this.survey.getSurveyErrorCustomText(this, text, error);
                    return text;
                };
                PanelModelBase.prototype.hasRequiredError = function(rec, errors) {
                    if (!this.isRequired) return;
                    var visQuestions = [];
                    this.addQuestionsToList(visQuestions, true);
                    if (visQuestions.length == 0) return;
                    for(var i = 0; i < visQuestions.length; i++){
                        if (!visQuestions[i].isEmpty()) return;
                    }
                    rec.result = true;
                    errors.push(new _error__WEBPACK_IMPORTED_MODULE_6__["OneAnswerRequiredError"](this.requiredErrorText, this));
                    if (rec.focuseOnFirstError && !rec.firstErrorQuestion) rec.firstErrorQuestion = visQuestions[0];
                };
                PanelModelBase.prototype.hasErrorsCore = function(rec) {
                    var elements = this.elements;
                    var element = null;
                    for(var i = 0; i < elements.length; i++){
                        element = elements[i];
                        if (!element.isVisible) continue;
                        if (element.isPanel) element.hasErrorsCore(rec);
                        else {
                            var question = element;
                            if (!question.validate(rec.fireCallback, rec)) {
                                if (rec.focuseOnFirstError && rec.firstErrorQuestion == null) rec.firstErrorQuestion = question;
                                rec.result = true;
                            }
                        }
                    }
                    this.hasErrorsInPanels(rec);
                    this.updateContainsErrors();
                };
                PanelModelBase.prototype.getContainsErrors = function() {
                    var res = _super.prototype.getContainsErrors.call(this);
                    if (res) return res;
                    var elements = this.elements;
                    for(var i = 0; i < elements.length; i++){
                        if (elements[i].containsErrors) return true;
                    }
                    return false;
                };
                PanelModelBase.prototype.updateElementVisibility = function() {
                    for(var i = 0; i < this.elements.length; i++){
                        var el = this.elements[i];
                        el.setPropertyValue("isVisible", el.isVisible);
                        if (el.isPanel) el.updateElementVisibility();
                    }
                };
                PanelModelBase.prototype.getFirstQuestionToFocus = function(withError, ignoreCollapseState) {
                    if (withError === void 0) withError = false;
                    if (ignoreCollapseState === void 0) ignoreCollapseState = false;
                    if (!withError && !ignoreCollapseState && this.isCollapsed) return null;
                    var elements = this.elements;
                    for(var i = 0; i < elements.length; i++){
                        var el = elements[i];
                        if (!el.isVisible || !ignoreCollapseState && el.isCollapsed) continue;
                        if (el.isPanel) {
                            var res = el.getFirstQuestionToFocus(withError, ignoreCollapseState);
                            if (!!res) return res;
                        } else {
                            var q = el.getFirstQuestionToFocus(withError);
                            if (!!q) return q;
                        }
                    }
                    return null;
                };
                /**
     * Focuses the first question in this panel/page.
     * @see focusFirstErrorQuestion
     */ PanelModelBase.prototype.focusFirstQuestion = function() {
                    var q = this.getFirstQuestionToFocus();
                    if (!!q) q.focus();
                };
                /**
     * Focuses the first question with a validation error in this panel/page.
     * @see validate
     * @see focusFirstQuestion
     */ PanelModelBase.prototype.focusFirstErrorQuestion = function() {
                    var q = this.getFirstQuestionToFocus(true);
                    if (!!q) q.focus();
                };
                PanelModelBase.prototype.addQuestionsToList = function(list, visibleOnly, includingDesignTime) {
                    if (visibleOnly === void 0) visibleOnly = false;
                    if (includingDesignTime === void 0) includingDesignTime = false;
                    this.addElementsToList(list, visibleOnly, includingDesignTime, false);
                };
                PanelModelBase.prototype.addPanelsIntoList = function(list, visibleOnly, includingDesignTime) {
                    if (visibleOnly === void 0) visibleOnly = false;
                    if (includingDesignTime === void 0) includingDesignTime = false;
                    this.addElementsToList(list, visibleOnly, includingDesignTime, true);
                };
                PanelModelBase.prototype.addElementsToList = function(list, visibleOnly, includingDesignTime, isPanel) {
                    if (visibleOnly && !this.visible) return;
                    this.addElementsToListCore(list, this.elements, visibleOnly, includingDesignTime, isPanel);
                };
                PanelModelBase.prototype.addElementsToListCore = function(list, elements, visibleOnly, includingDesignTime, isPanel) {
                    for(var i = 0; i < elements.length; i++){
                        var el = elements[i];
                        if (visibleOnly && !el.visible) continue;
                        if (isPanel && el.isPanel || !isPanel && !el.isPanel) list.push(el);
                        if (el.isPanel) el.addElementsToListCore(list, el.elements, visibleOnly, includingDesignTime, isPanel);
                        else if (includingDesignTime) this.addElementsToListCore(list, el.getElementsInDesign(false), visibleOnly, includingDesignTime, isPanel);
                    }
                };
                PanelModelBase.prototype.updateCustomWidgets = function() {
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].updateCustomWidgets();
                };
                Object.defineProperty(PanelModelBase.prototype, "questionTitleLocation", {
                    /**
         * Sets a title location relative to the input field for questions that belong to this panel/page.
         *
         * Use this property to override the `questionTitleLocation` property specified for the survey. You can also set the `titleLocation` property for individual questions.
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the `questionTitleLocation` property specified for the survey.
         * - `"top"` - Displays the title above the input field.
         * - `"bottom"` - Displays the title below the input field.
         * - `"left"` - Displays the title to the left of the input field.
         * - `"hidden"` - Hides the question title.
         *
         * > Certain question types (Matrix, Multiple Text) do not support the `"left"` value. For them, the `"top"` value is used.
         * @see SurveyModel.questionTitleLocation
         */ get: function() {
                        return this.getPropertyValue("questionTitleLocation");
                    },
                    set: function(value) {
                        this.setPropertyValue("questionTitleLocation", value.toLowerCase());
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.getQuestionTitleLocation = function() {
                    if (this.onGetQuestionTitleLocation) return this.onGetQuestionTitleLocation();
                    if (this.questionTitleLocation != "default") return this.questionTitleLocation;
                    if (this.parent) return this.parent.getQuestionTitleLocation();
                    return this.survey ? this.survey.questionTitleLocation : "top";
                };
                PanelModelBase.prototype.getStartIndex = function() {
                    if (!!this.parent) return this.parent.getQuestionStartIndex();
                    if (!!this.survey) return this.survey.questionStartIndex;
                    return "";
                };
                PanelModelBase.prototype.getQuestionStartIndex = function() {
                    return this.getStartIndex();
                };
                PanelModelBase.prototype.getChildrenLayoutType = function() {
                    return "row";
                };
                PanelModelBase.prototype.getProgressInfo = function() {
                    return _survey_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElement"].getProgressInfoByElements(this.elements, this.isRequired);
                };
                Object.defineProperty(PanelModelBase.prototype, "root", {
                    get: function() {
                        var res = this;
                        while(res.parent)res = res.parent;
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.childVisibilityChanged = function() {
                    var newIsVisibleValue = this.getIsPageVisible(null);
                    var oldIsVisibleValue = this.getPropertyValue("isVisible", true);
                    if (newIsVisibleValue !== oldIsVisibleValue) this.onVisibleChanged();
                };
                PanelModelBase.prototype.createRowAndSetLazy = function(index) {
                    var row = this.createRow();
                    row.setIsLazyRendering(this.isLazyRenderInRow(index));
                    return row;
                };
                PanelModelBase.prototype.createRow = function() {
                    return new QuestionRowModel(this);
                };
                PanelModelBase.prototype.onSurveyLoad = function() {
                    this.animationAllowed = false;
                    _super.prototype.onSurveyLoad.call(this);
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].onSurveyLoad();
                    this.onElementVisibilityChanged(this);
                    this.animationAllowed = true;
                };
                PanelModelBase.prototype.onFirstRendering = function() {
                    _super.prototype.onFirstRendering.call(this);
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].onFirstRendering();
                    this.onRowsChanged();
                };
                PanelModelBase.prototype.updateRows = function() {
                    if (this.isLoadingFromJson) return;
                    for(var i = 0; i < this.elements.length; i++)if (this.elements[i].isPanel) this.elements[i].updateRows();
                    this.onRowsChanged();
                };
                Object.defineProperty(PanelModelBase.prototype, "rows", {
                    get: function() {
                        return this.getPropertyValue("rows");
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.ensureRowsVisibility = function() {
                    this.rows.forEach(function(row) {
                        row.ensureVisibility();
                    });
                };
                PanelModelBase.prototype.onRowsChanged = function() {
                    if (this.isLoadingFromJson) return;
                    this.animationAllowed = false;
                    this.setArrayPropertyDirectly("rows", this.buildRows());
                    this.animationAllowed = true;
                };
                PanelModelBase.prototype.blockRowsUpdates = function() {
                    this.locCountRowUpdates++;
                };
                PanelModelBase.prototype.releaseRowsUpdates = function() {
                    this.locCountRowUpdates--;
                };
                PanelModelBase.prototype.updateRowsBeforeElementRemoved = function(element) {
                    var _this = this;
                    var elementRow = this.findRowByElement(element);
                    var elementRowIndex = this.rows.indexOf(elementRow);
                    var elementIndexInRow = elementRow.elements.indexOf(element);
                    elementRow.elements.splice(elementIndexInRow, 1);
                    if (elementRow.elements.length == 0) this.rows.splice(elementRowIndex, 1);
                    else if (!elementRow.elements[0].startWithNewLine && this.rows[elementRowIndex - 1]) {
                        elementRow.elements.forEach(function(el) {
                            return _this.rows[elementRowIndex - 1].addElement(el);
                        });
                        this.rows.splice(elementRowIndex, 1);
                    } else elementRow.updateVisible();
                };
                PanelModelBase.prototype.updateRowsOnElementAdded = function(element) {
                    var _this = this;
                    var index = this.elements.indexOf(element);
                    var targetElement = this.elements[index + 1];
                    var createRowAtIndex = function(index) {
                        var row = _this.createRowAndSetLazy(index);
                        if (_this.isDesignModeV2) row.setIsLazyRendering(false);
                        _this.rows.splice(index, 0, row);
                        return row;
                    };
                    var updateRow = function(row, start, deleteCount) {
                        var _a;
                        var elements = [];
                        for(var _i = 3; _i < arguments.length; _i++)elements[_i - 3] = arguments[_i];
                        var removedElements = (_a = row.elements).splice.apply(_a, __spreadArray([
                            start,
                            deleteCount
                        ], elements));
                        row.updateVisible();
                        return removedElements;
                    };
                    if (!targetElement) {
                        if (index == 0 || element.startWithNewLine) updateRow(createRowAtIndex(this.rows.length), 0, 0, element);
                        else this.rows[this.rows.length - 1].addElement(element);
                        return;
                    }
                    var targetRow = this.findRowByElement(targetElement);
                    if (!targetRow) return;
                    var targetRowIndex = this.rows.indexOf(targetRow);
                    var targetElementIndexInRow = targetRow.elements.indexOf(targetElement);
                    if (targetElementIndexInRow == 0) {
                        if (!targetElement.startWithNewLine) updateRow(targetRow, 0, 0, element);
                        else if (element.startWithNewLine || targetRowIndex < 1) createRowAtIndex(targetRowIndex).addElement(element);
                        else this.rows[targetRowIndex - 1].addElement(element);
                    } else if (element.startWithNewLine) updateRow.apply(void 0, __spreadArray([
                        createRowAtIndex(targetRowIndex + 1),
                        0,
                        0
                    ], [
                        element
                    ].concat(updateRow(targetRow, targetElementIndexInRow, targetRow.elements.length))));
                    else updateRow(targetRow, targetElementIndexInRow, 0, element);
                };
                PanelModelBase.prototype.onAddElement = function(element, index) {
                    var _this = this;
                    element.setSurveyImpl(this.surveyImpl);
                    element.parent = this;
                    this.markQuestionListDirty();
                    if (this.canBuildRows()) this.updateRowsOnElementAdded(element);
                    if (element.isPanel) {
                        var p = element;
                        if (this.survey) this.survey.panelAdded(p, index, this, this.root);
                    } else if (this.survey) {
                        var q = element;
                        this.survey.questionAdded(q, index, this, this.root);
                    }
                    if (!!this.addElementCallback) this.addElementCallback(element);
                    var self = this;
                    element.registerPropertyChangedHandlers([
                        "visible",
                        "isVisible"
                    ], function() {
                        _this.onElementVisibilityChanged(element);
                    }, this.id);
                    element.registerPropertyChangedHandlers([
                        "startWithNewLine"
                    ], function() {
                        _this.onElementStartWithNewLineChanged(element);
                    }, this.id);
                    this.onElementVisibilityChanged(this);
                };
                PanelModelBase.prototype.onRemoveElement = function(element) {
                    element.parent = null;
                    this.markQuestionListDirty();
                    element.unregisterPropertyChangedHandlers([
                        "visible",
                        "isVisible",
                        "startWithNewLine"
                    ], this.id);
                    this.updateRowsOnElementRemoved(element);
                    if (this.isRandomizing) return;
                    if (!element.isPanel) {
                        if (this.survey) this.survey.questionRemoved(element);
                    } else if (this.survey) this.survey.panelRemoved(element);
                    if (!!this.removeElementCallback) this.removeElementCallback(element);
                    this.onElementVisibilityChanged(this);
                };
                PanelModelBase.prototype.onElementVisibilityChanged = function(element) {
                    if (this.isLoadingFromJson || this.isRandomizing) return;
                    this.updateRowsVisibility(element);
                    this.childVisibilityChanged();
                    if (!!this.parent) this.parent.onElementVisibilityChanged(this);
                };
                PanelModelBase.prototype.onElementStartWithNewLineChanged = function(element) {
                    if (this.locCountRowUpdates > 0) return;
                    this.updateRowsBeforeElementRemoved(element);
                    this.updateRowsOnElementAdded(element);
                };
                PanelModelBase.prototype.updateRowsVisibility = function(element) {
                    var rows = this.rows;
                    for(var i = 0; i < rows.length; i++){
                        var row = rows[i];
                        if (row.elements.indexOf(element) > -1) {
                            row.updateVisible();
                            if (row.visible && !row.isNeedRender) row.isNeedRender = true;
                            break;
                        }
                    }
                };
                PanelModelBase.prototype.canBuildRows = function() {
                    return !this.isLoadingFromJson && this.getChildrenLayoutType() == "row";
                };
                PanelModelBase.prototype.buildRows = function() {
                    if (!this.canBuildRows()) return [];
                    var result = new Array();
                    for(var i = 0; i < this.elements.length; i++){
                        var el = this.elements[i];
                        var isNewRow = i == 0 || el.startWithNewLine;
                        var row = isNewRow ? this.createRowAndSetLazy(result.length) : result[result.length - 1];
                        if (isNewRow) result.push(row);
                        row.addElement(el);
                    }
                    for(var i = 0; i < result.length; i++)result[i].updateVisible();
                    return result;
                };
                PanelModelBase.prototype.isLazyRenderInRow = function(rowIndex) {
                    if (!this.survey || !this.survey.isLazyRendering) return false;
                    return rowIndex >= this.survey.lazyRenderingFirstBatchSize || !this.canRenderFirstRows();
                };
                PanelModelBase.prototype.canRenderFirstRows = function() {
                    return this.isPage;
                };
                PanelModelBase.prototype.getDragDropInfo = function() {
                    var page = this.getPage(this.parent);
                    return !!page ? page.getDragDropInfo() : undefined;
                };
                PanelModelBase.prototype.updateRowsOnElementRemoved = function(element) {
                    if (!this.canBuildRows()) return;
                    this.updateRowsRemoveElementFromRow(element, this.findRowByElement(element));
                };
                PanelModelBase.prototype.updateRowsRemoveElementFromRow = function(element, row) {
                    if (!row || !row.panel) return;
                    var elIndex = row.elements.indexOf(element);
                    if (elIndex < 0) return;
                    row.elements.splice(elIndex, 1);
                    if (row.elements.length > 0) {
                        this.blockRowsUpdates();
                        row.elements[0].startWithNewLine = true;
                        this.releaseRowsUpdates();
                        row.updateVisible();
                    } else if (row.index >= 0) row.panel.rows.splice(row.index, 1);
                };
                PanelModelBase.prototype.findRowByElement = function(el) {
                    var rows = this.rows;
                    for(var i = 0; i < rows.length; i++){
                        if (rows[i].elements.indexOf(el) > -1) return rows[i];
                    }
                    return null;
                };
                PanelModelBase.prototype.elementWidthChanged = function(el) {
                    if (this.isLoadingFromJson) return;
                    var row = this.findRowByElement(el);
                    if (!!row) row.updateVisible();
                };
                Object.defineProperty(PanelModelBase.prototype, "processedTitle", {
                    get: function() {
                        return this.getRenderedTitle(this.locTitle.textOrHtml);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.getRenderedTitle = function(str) {
                    return this.textProcessor != null ? this.textProcessor.processText(str, true) : str;
                };
                Object.defineProperty(PanelModelBase.prototype, "visible", {
                    /**
         * Gets or sets panel/page visibility.
         *
         * If you want to display or hide a survey element based on a condition, specify the `visibleIf` property. Refer to the following help topic for information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see visibleIf
         * @see isVisible
         */ get: function() {
                        return this.getPropertyValue("visible", true);
                    },
                    set: function(value) {
                        if (value === this.visible) return;
                        this.setPropertyValue("visible", value);
                        this.setPropertyValue("isVisible", this.isVisible);
                        if (!this.isLoadingFromJson) this.onVisibleChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.onHidingContent = function() {
                    this.questions.forEach(function(q) {
                        return q.onHidingContent();
                    });
                };
                PanelModelBase.prototype.onVisibleChanged = function() {
                    if (this.isRandomizing) return;
                    this.setPropertyValue("isVisible", this.isVisible);
                    if (!!this.survey && this.survey.getQuestionClearIfInvisible("default") !== "none" && !this.isLoadingFromJson) {
                        var questions = this.questions;
                        var isVisible = this.isVisible;
                        for(var i = 0; i < questions.length; i++){
                            var q = questions[i];
                            if (!isVisible) {
                                q.clearValueIfInvisible("onHiddenContainer");
                                q.onHidingContent();
                            } else q.updateValueWithDefaults();
                        }
                    }
                };
                PanelModelBase.prototype.notifyStateChanged = function(prevState) {
                    var _this = this;
                    _super.prototype.notifyStateChanged.call(this, prevState);
                    if (this.isCollapsed) this.questions.forEach(function(q) {
                        return q.onHidingContent();
                    });
                    if (this.survey != null && !this.isLoadingFromJson && this.isExpanded && prevState === "collapsed") {
                        var q_1 = this.getFirstQuestionToFocus(false);
                        if (!!q_1) setTimeout(function() {
                            if (!_this.isDisposed && !!_this.survey) _this.survey.scrollElementToTop(q_1, q_1, null, q_1.inputId, false);
                        }, 15);
                    }
                };
                Object.defineProperty(PanelModelBase.prototype, "isVisible", {
                    /**
         * Returns `true` if the panel/page is visible or the survey is currently in design mode.
         *
         * If you want to display or hide a question based on a condition, specify the `visibleIf` property. Refer to the following help topic for information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see visibleIf
         * @see visible
         */ get: function() {
                        return this.areInvisibleElementsShowing || this.getIsPageVisible(null);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.getIsContentVisible = function(exceptionQuestion) {
                    if (this.areInvisibleElementsShowing) return true;
                    for(var i = 0; i < this.elements.length; i++){
                        if (this.elements[i] == exceptionQuestion) continue;
                        if (this.elements[i].isVisible) return true;
                    }
                    return false;
                };
                PanelModelBase.prototype.getIsPageVisible = function(exceptionQuestion) {
                    return this.visible && this.getIsContentVisible(exceptionQuestion);
                };
                PanelModelBase.prototype.setVisibleIndex = function(index) {
                    if (!this.isVisible || index < 0) {
                        this.resetVisibleIndexes();
                        return 0;
                    }
                    this.lastVisibleIndex = index;
                    var startIndex = index;
                    index += this.beforeSetVisibleIndex(index);
                    var panelStartIndex = this.getPanelStartIndex(index);
                    var panelIndex = panelStartIndex;
                    for(var i = 0; i < this.elements.length; i++)panelIndex += this.elements[i].setVisibleIndex(panelIndex);
                    if (this.isContinueNumbering()) index += panelIndex - panelStartIndex;
                    return index - startIndex;
                };
                PanelModelBase.prototype.updateVisibleIndexes = function() {
                    if (this.lastVisibleIndex === undefined) return;
                    this.resetVisibleIndexes();
                    this.setVisibleIndex(this.lastVisibleIndex);
                };
                PanelModelBase.prototype.resetVisibleIndexes = function() {
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].setVisibleIndex(-1);
                };
                PanelModelBase.prototype.beforeSetVisibleIndex = function(index) {
                    return 0;
                };
                PanelModelBase.prototype.getPanelStartIndex = function(index) {
                    return index;
                };
                PanelModelBase.prototype.isContinueNumbering = function() {
                    return true;
                };
                Object.defineProperty(PanelModelBase.prototype, "isReadOnly", {
                    get: function() {
                        var isParentReadOnly = !!this.parent && this.parent.isReadOnly;
                        var isSurveyReadOnly = !!this.survey && this.survey.isDisplayMode;
                        return this.readOnly || isParentReadOnly || isSurveyReadOnly;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.onReadOnlyChanged = function() {
                    for(var i = 0; i < this.elements.length; i++){
                        var el = this.elements[i];
                        el.setPropertyValue("isReadOnly", el.isReadOnly);
                    }
                    _super.prototype.onReadOnlyChanged.call(this);
                };
                PanelModelBase.prototype.updateElementCss = function(reNew) {
                    _super.prototype.updateElementCss.call(this, reNew);
                    for(var i = 0; i < this.elements.length; i++){
                        var el = this.elements[i];
                        el.updateElementCss(reNew);
                    }
                };
                Object.defineProperty(PanelModelBase.prototype, "enableIf", {
                    /**
         * A Boolean expression. If it evaluates to `false`, this panel/page becomes read-only.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see readOnly
         * @see isReadOnly
         */ get: function() {
                        return this.getPropertyValue("enableIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("enableIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Adds a survey element (question or panel) to this panel/page. Returns `true` if the element was added successfully; `false` otherwise.
     * @param element A survey element to add.
     * @param index A desired index of this element in the `elements` array.
     * @see addNewQuestion
     * @see addNewPanel
     */ PanelModelBase.prototype.addElement = function(element, index) {
                    if (index === void 0) index = -1;
                    if (!this.canAddElement(element)) return false;
                    if (index < 0 || index >= this.elements.length) this.elements.push(element);
                    else this.elements.splice(index, 0, element);
                    if (this.wasRendered) element.onFirstRendering();
                    return true;
                };
                PanelModelBase.prototype.insertElement = function(element, dest, location) {
                    if (location === void 0) location = "bottom";
                    if (!dest) {
                        this.addElement(element);
                        return;
                    }
                    this.blockRowsUpdates();
                    var index = this.elements.indexOf(dest);
                    var destRow = this.findRowByElement(dest);
                    if (location == "left" || location == "right") {
                        if (location == "right") {
                            element.startWithNewLine = false;
                            index++;
                        } else if (destRow.elements.indexOf(dest) == 0) {
                            dest.startWithNewLine = false;
                            element.startWithNewLine = true;
                        } else element.startWithNewLine = false;
                    } else {
                        element.startWithNewLine = true;
                        if (location == "top") index = this.elements.indexOf(destRow.elements[0]);
                        else index = this.elements.indexOf(destRow.elements[destRow.elements.length - 1]) + 1;
                    }
                    this.releaseRowsUpdates();
                    this.addElement(element, index);
                };
                PanelModelBase.prototype.insertElementAfter = function(element, after) {
                    var index = this.elements.indexOf(after);
                    if (index >= 0) this.addElement(element, index + 1);
                };
                PanelModelBase.prototype.insertElementBefore = function(element, before) {
                    var index = this.elements.indexOf(before);
                    if (index >= 0) this.addElement(element, index);
                };
                PanelModelBase.prototype.canAddElement = function(element) {
                    return !!element && element.isLayoutTypeSupported(this.getChildrenLayoutType());
                };
                PanelModelBase.prototype.addQuestion = function(question, index) {
                    if (index === void 0) index = -1;
                    return this.addElement(question, index);
                };
                PanelModelBase.prototype.addPanel = function(panel, index) {
                    if (index === void 0) index = -1;
                    return this.addElement(panel, index);
                };
                /**
     * Creates a new question of a given type and adds it to the `elements` array at a specified index.
     *
     * This method returns `null` if the question cannot be created or added to this panel/page; otherwise, the method returns the created question.
     *
     * @param questionType A [question type](https://surveyjs.io/form-library/documentation/question#getType).
     * @param name A question name.
     * @param index A desired index of the new question in the `elements` array.
     * @see elements
     * @see addElement
     */ PanelModelBase.prototype.addNewQuestion = function(questionType, name, index) {
                    if (name === void 0) name = null;
                    if (index === void 0) index = -1;
                    var question = _questionfactory__WEBPACK_IMPORTED_MODULE_5__["QuestionFactory"].Instance.createQuestion(questionType, name);
                    if (!this.addQuestion(question, index)) return null;
                    return question;
                };
                /**
     * Creates a new panel and adds it to the end of the `elements` array.
     *
     * This method returns `null` if the panel cannot be created or added to this panel/page; otherwise, the method returns the created panel.
     * @param name A panel name.
     * @see elementsup
     * @see addElement
     */ PanelModelBase.prototype.addNewPanel = function(name) {
                    if (name === void 0) name = null;
                    var panel = this.createNewPanel(name);
                    if (!this.addPanel(panel)) return null;
                    return panel;
                };
                PanelModelBase.prototype.indexOf = function(element) {
                    return this.elements.indexOf(element);
                };
                PanelModelBase.prototype.createNewPanel = function(name) {
                    var res = _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].createClass("panel");
                    res.name = name;
                    return res;
                };
                /**
     * Deletes a survey element (question or panel) from this panel/page. Returns `true` if the element was deleted successfully; `false` otherwise.
     * @param element A survey element to delete.
     * @see elements
     */ PanelModelBase.prototype.removeElement = function(element) {
                    var index = this.elements.indexOf(element);
                    if (index < 0) {
                        for(var i = 0; i < this.elements.length; i++){
                            if (this.elements[i].removeElement(element)) return true;
                        }
                        return false;
                    }
                    this.elements.splice(index, 1);
                    return true;
                };
                PanelModelBase.prototype.removeQuestion = function(question) {
                    this.removeElement(question);
                };
                PanelModelBase.prototype.runCondition = function(values, properties) {
                    if (this.isDesignMode || this.isLoadingFromJson) return;
                    var elements = this.elements.slice();
                    for(var i = 0; i < elements.length; i++)elements[i].runCondition(values, properties);
                    this.runConditionCore(values, properties);
                };
                PanelModelBase.prototype.onAnyValueChanged = function(name, questionName) {
                    var els = this.elements;
                    for(var i = 0; i < els.length; i++)els[i].onAnyValueChanged(name, questionName);
                };
                PanelModelBase.prototype.checkBindings = function(valueName, value) {
                    var els = this.elements;
                    for(var i = 0; i < els.length; i++)els[i].checkBindings(valueName, value);
                };
                PanelModelBase.prototype.dragDropAddTarget = function(dragDropInfo) {
                    this.dragDropPanelHelper.dragDropAddTarget(dragDropInfo);
                };
                PanelModelBase.prototype.dragDropFindRow = function(findElement) {
                    return this.dragDropPanelHelper.dragDropFindRow(findElement);
                };
                PanelModelBase.prototype.dragDropMoveElement = function(src, target, targetIndex) {
                    this.dragDropPanelHelper.dragDropMoveElement(src, target, targetIndex);
                };
                PanelModelBase.prototype.needResponsiveWidth = function() {
                    var result = false;
                    this.elements.forEach(function(e) {
                        if (e.needResponsiveWidth()) result = true;
                    });
                    this.rows.forEach(function(r) {
                        if (r.elements.length > 1) result = true;
                    });
                    return result;
                };
                Object.defineProperty(PanelModelBase.prototype, "hasDescriptionUnderTitle", {
                    get: function() {
                        return this.hasDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "cssHeader", {
                    get: function() {
                        return this.cssClasses.panel.header;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "cssDescription", {
                    get: function() {
                        return this.cssClasses.panel.description;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "questionErrorLocation", {
                    /**
         * Specifies the error message position for questions that belong to this page/panel.
         *
         * Use this property to override the [`questionErrorLocation`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#questionErrorLocation) property specified for the survey. You can also set the [`errorLocation`](https://surveyjs.io/form-library/documentation/question#errorLocation) property for individual questions.
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the `questionErrorLocation` property specified for the survey.
         * - `"top"` - Displays error messages above questions.
         * - `"bottom"` - Displays error messages below questions.
         */ get: function() {
                        return this.getPropertyValue("questionErrorLocation");
                    },
                    set: function(val1) {
                        this.setPropertyValue("questionErrorLocation", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.getQuestionErrorLocation = function() {
                    if (this.questionErrorLocation !== "default") return this.questionErrorLocation;
                    if (this.parent) return this.parent.getQuestionErrorLocation();
                    return this.survey ? this.survey.questionErrorLocation : "top";
                };
                Object.defineProperty(PanelModelBase.prototype, "no", {
                    //ITitleOwner
                    get: function() {
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModelBase.prototype, "cssError", {
                    get: function() {
                        return this.getCssError(this.cssClasses);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModelBase.prototype.getCssError = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_9__["CssClassBuilder"]().append(cssClasses.error.root).toString();
                };
                PanelModelBase.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (this.rows) {
                        for(var i = 0; i < this.rows.length; i++)this.rows[i].dispose();
                        this.rows.splice(0, this.rows.length);
                    }
                    for(var i = 0; i < this.elements.length; i++)this.elements[i].dispose();
                    this.elements.splice(0, this.elements.length);
                };
                PanelModelBase.panelCounter = 100;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], PanelModelBase.prototype, "showTitle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], PanelModelBase.prototype, "showDescription", void 0);
                return PanelModelBase;
            }(_survey_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElement"]);
            /**
 * A class that describes the Panel container element.
 *
 * A panel can contain questions and other panels. Refer to the following help topic for an illustration: [Survey Structure](https://surveyjs.io/form-library/documentation/design-survey-create-a-simple-survey#survey-structure).
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-panel/ (linkStyle))
 */ var PanelModel = /** @class */ function(_super) {
                __extends(PanelModel, _super);
                function PanelModel(name) {
                    if (name === void 0) name = "";
                    var _this = _super.call(this, name) || this;
                    _this.createNewArray("footerActions");
                    _this.registerPropertyChangedHandlers([
                        "width"
                    ], function() {
                        if (!!_this.parent) _this.parent.elementWidthChanged(_this);
                    });
                    _this.registerPropertyChangedHandlers([
                        "indent",
                        "innerIndent",
                        "rightIndent"
                    ], function() {
                        _this.onIndentChanged();
                    });
                    return _this;
                }
                PanelModel.prototype.getType = function() {
                    return "panel";
                };
                Object.defineProperty(PanelModel.prototype, "contentId", {
                    get: function() {
                        return this.id + "_content";
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    if (live) return !!this.parent ? this.parent.getSurvey(live) : null;
                    return _super.prototype.getSurvey.call(this, live);
                };
                PanelModel.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    this.onIndentChanged();
                };
                PanelModel.prototype.onSetData = function() {
                    _super.prototype.onSetData.call(this);
                    this.onIndentChanged();
                };
                Object.defineProperty(PanelModel.prototype, "isPanel", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModel.prototype, "page", {
                    /**
         * Returns a page to which the panel belongs and allows you to move this panel to a different page.
         * @see PanelModelBase.parent
         */ get: function() {
                        return this.getPage(this.parent);
                    },
                    set: function(val1) {
                        this.setPage(this.parent, val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.removeFromParent = function() {
                    if (!!this.parent) this.removeSelfFromList(this.parent.elements);
                };
                PanelModel.prototype.moveTo = function(container, insertBefore) {
                    if (insertBefore === void 0) insertBefore = null;
                    return this.moveToBase(this.parent, container, insertBefore);
                };
                Object.defineProperty(PanelModel.prototype, "visibleIndex", {
                    /**
         * Returns the visible index of the panel in the survey. Commonly it is -1 and it doesn't show.
         * You have to set showNumber to true to show index/numbering for the Panel
         * @see showNumber
         */ get: function() {
                        return this.getPropertyValue("visibleIndex", -1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.getTitleOwner = function() {
                    return this;
                };
                Object.defineProperty(PanelModel.prototype, "showNumber", {
                    /**
         * Specifies whether to show the panel number in the title.
         *
         * Default value: `false`
         * @see SurveyModel.showQuestionNumbers
         * @see SurveyModel.questionTitlePattern
         */ get: function() {
                        return this.getPropertyValue("showNumber");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showNumber", val1);
                        this.notifySurveyOnVisibilityChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModel.prototype, "showQuestionNumbers", {
                    /**
         * Gets or sets a value that specifies how the elements numbers inside panel are displayed.
         *
         * The following options are available:
         *
         * - `default` - display questions numbers as defined in parent panel or survey
         * - `onpanel` - display questions numbers, start numbering from beginning of this page
         * - `off` - turn off the numbering for questions titles
         * @see showNumber
         */ get: function() {
                        return this.getPropertyValue("showQuestionNumbers");
                    },
                    set: function(value) {
                        this.setPropertyValue("showQuestionNumbers", value);
                        this.notifySurveyOnVisibilityChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModel.prototype, "questionStartIndex", {
                    /**
         * Specifies a number or letter used to start numbering of elements inside the panel.
         *
         * You can include desired prefixes and postfixes alongside the number or letter:
         *
         * ```js
         * "questionStartIndex": "a.", // a., b., c., ...
         * "questionStartIndex": "#3", // #3, #4, #5, ...
         * "questionStartIndex": "(B)." // (B)., (C)., (D)., ...
         * ```
         * Default value: `"1."` (inherited from `SurveyModel`'s `questionStartIndex` property)
         * @see SurveyModel.questionStartIndex
         * @see showQuestionNumbers
         */ get: function() {
                        return this.getPropertyValue("questionStartIndex", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("questionStartIndex", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.getQuestionStartIndex = function() {
                    if (!!this.questionStartIndex) return this.questionStartIndex;
                    return _super.prototype.getQuestionStartIndex.call(this);
                };
                Object.defineProperty(PanelModel.prototype, "no", {
                    /**
         * A question number or letter (depends on the `questionStartIndex` property).
         *
         * When the question number, title, or the entire question is invisible, this property returns an empty string.
         * @see questionStartIndex
         * @see showNumber
         * @see visibleIf
         */ get: function() {
                        return this.getPropertyValue("no", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.setNo = function(visibleIndex) {
                    this.setPropertyValue("no", _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].getNumberByIndex(this.visibleIndex, this.getStartIndex()));
                };
                PanelModel.prototype.notifyStateChanged = function(prevState) {
                    if (!this.isLoadingFromJson) this.locTitle.strChanged();
                    _super.prototype.notifyStateChanged.call(this, prevState);
                };
                PanelModel.prototype.createLocTitleProperty = function() {
                    var _this = this;
                    var locTitleValue = _super.prototype.createLocTitleProperty.call(this);
                    locTitleValue.onGetTextCallback = function(text) {
                        if (!text && _this.state !== "default") text = _this.name;
                        return text;
                    };
                    return locTitleValue;
                };
                PanelModel.prototype.beforeSetVisibleIndex = function(index) {
                    var visibleIndex = -1;
                    if (this.showNumber && (this.isDesignMode || !this.locTitle.isEmpty)) visibleIndex = index;
                    this.setPropertyValue("visibleIndex", visibleIndex);
                    this.setNo(visibleIndex);
                    return visibleIndex < 0 ? 0 : 1;
                };
                PanelModel.prototype.getPanelStartIndex = function(index) {
                    if (this.showQuestionNumbers == "off") return -1;
                    if (this.showQuestionNumbers == "onpanel") return 0;
                    return index;
                };
                PanelModel.prototype.isContinueNumbering = function() {
                    return this.showQuestionNumbers != "off" && this.showQuestionNumbers != "onpanel";
                };
                PanelModel.prototype.notifySurveyOnVisibilityChanged = function() {
                    if (this.survey != null && !this.isLoadingFromJson) this.survey.panelVisibilityChanged(this, this.isVisible);
                };
                PanelModel.prototype.hasErrorsCore = function(rec) {
                    _super.prototype.hasErrorsCore.call(this, rec);
                    if (this.isCollapsed && rec.result && rec.fireCallback) this.expand();
                };
                PanelModel.prototype.getRenderedTitle = function(str) {
                    if (!str) {
                        if (this.isCollapsed || this.isExpanded) return this.name;
                        if (this.isDesignMode) return "[" + this.name + "]";
                    }
                    return _super.prototype.getRenderedTitle.call(this, str);
                };
                Object.defineProperty(PanelModel.prototype, "innerIndent", {
                    /**
         * Increases or decreases an indent of panel content from the left edge. Accepts positive integer values and 0.
         */ get: function() {
                        return this.getPropertyValue("innerIndent");
                    },
                    set: function(val1) {
                        this.setPropertyValue("innerIndent", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModel.prototype, "startWithNewLine", {
                    /**
         * Disable this property if you want to render the current panel on the same line or row with the previous question or panel.
         */ get: function() {
                        return this.getPropertyValue("startWithNewLine");
                    },
                    set: function(value) {
                        this.setPropertyValue("startWithNewLine", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModel.prototype, "allowAdaptiveActions", {
                    get: function() {
                        return this.getPropertyValue("allowAdaptiveActions");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowAdaptiveActions", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModel.prototype, "innerPaddingLeft", {
                    get: function() {
                        return this.getPropertyValue("innerPaddingLeft", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("innerPaddingLeft", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.onIndentChanged = function() {
                    if (!this.getSurvey()) return;
                    this.innerPaddingLeft = this.getIndentSize(this.innerIndent);
                    this.paddingLeft = this.getIndentSize(this.indent);
                    this.paddingRight = this.getIndentSize(this.rightIndent);
                };
                PanelModel.prototype.getIndentSize = function(indent) {
                    if (indent < 1) return "";
                    var css = this.survey["css"];
                    if (!css || !css.question.indent) return "";
                    return indent * css.question.indent + "px";
                };
                PanelModel.prototype.clearOnDeletingContainer = function() {
                    this.elements.forEach(function(element) {
                        if (element instanceof _question__WEBPACK_IMPORTED_MODULE_4__["Question"] || element instanceof PanelModel) element.clearOnDeletingContainer();
                    });
                };
                Object.defineProperty(PanelModel.prototype, "footerActions", {
                    get: function() {
                        return this.getPropertyValue("footerActions");
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.getFooterToolbar = function() {
                    var _this = this;
                    var _a, _b;
                    if (!this.footerToolbarValue) {
                        var actions = this.footerActions;
                        if (this.hasEditButton) actions.push({
                            id: "cancel-preview",
                            locTitle: this.survey.locEditText,
                            innerCss: this.survey.cssNavigationEdit,
                            component: "sv-nav-btn",
                            action: function() {
                                _this.cancelPreview();
                            }
                        });
                        if (!!this.onGetFooterActionsCallback) actions = this.onGetFooterActionsCallback();
                        else actions = (_a = this.survey) === null || _a === void 0 ? void 0 : _a.getUpdatedPanelFooterActions(this, actions);
                        this.footerToolbarValue = this.createActionContainer(this.allowAdaptiveActions);
                        var footerCss = this.onGetFooterToolbarCssCallback ? this.onGetFooterToolbarCssCallback() : "";
                        if (!footerCss) footerCss = (_b = this.cssClasses.panel) === null || _b === void 0 ? void 0 : _b.footer;
                        if (footerCss) this.footerToolbarValue.containerCss = footerCss;
                        this.footerToolbarValue.setItems(actions);
                    }
                    return this.footerToolbarValue;
                };
                Object.defineProperty(PanelModel.prototype, "hasEditButton", {
                    get: function() {
                        if (this.survey && this.survey.state === "preview") return this.depth === 1;
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.cancelPreview = function() {
                    if (!this.hasEditButton) return;
                    this.survey.cancelPreviewByPage(this);
                };
                Object.defineProperty(PanelModel.prototype, "cssTitle", {
                    get: function() {
                        return this.getCssTitle(this.cssClasses.panel);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PanelModel.prototype, "showErrorsAbovePanel", {
                    get: function() {
                        return this.isDefaultV2Theme && !this.showPanelAsPage;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.getCssError = function(cssClasses) {
                    var builder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_9__["CssClassBuilder"]().append(_super.prototype.getCssError.call(this, cssClasses)).append(cssClasses.panel.errorsContainer);
                    return builder.append("panel-error-root", builder.isEmpty()).toString();
                };
                PanelModel.prototype.onVisibleChanged = function() {
                    _super.prototype.onVisibleChanged.call(this);
                    this.notifySurveyOnVisibilityChanged();
                };
                PanelModel.prototype.needResponsiveWidth = function() {
                    if (!this.startWithNewLine) return true;
                    else return _super.prototype.needResponsiveWidth.call(this);
                };
                PanelModel.prototype.focusIn = function() {
                    if (!this.survey) return;
                    this.survey.whenPanelFocusIn(this);
                };
                PanelModel.prototype.getHasFrameV2 = function() {
                    return _super.prototype.getHasFrameV2.call(this) && !this.showPanelAsPage;
                };
                PanelModel.prototype.getIsNested = function() {
                    return _super.prototype.getIsNested.call(this) && this.parent !== undefined;
                };
                Object.defineProperty(PanelModel.prototype, "showPanelAsPage", {
                    get: function() {
                        return !!this.originalPage;
                    },
                    enumerable: false,
                    configurable: true
                });
                PanelModel.prototype.getCssRoot = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_9__["CssClassBuilder"]().append(_super.prototype.getCssRoot.call(this, cssClasses)).append(cssClasses.container).append(cssClasses.asPage, this.showPanelAsPage).append(cssClasses.invisible, !this.isDesignMode && this.areInvisibleElementsShowing && !this.visible).toString();
                };
                PanelModel.prototype.getContainerCss = function() {
                    return this.getCssRoot(this.cssClasses.panel);
                };
                return PanelModel;
            }(PanelModelBase);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("panelbase", [
                "name",
                {
                    name: "elements",
                    alternativeName: "questions",
                    baseClassName: "question",
                    visible: false,
                    isLightSerializable: false
                },
                {
                    name: "visible:switch",
                    default: true,
                    overridingProperty: "visibleIf"
                },
                {
                    name: "readOnly:boolean",
                    overridingProperty: "enableIf"
                },
                "visibleIf:condition",
                "enableIf:condition",
                "requiredIf:condition",
                {
                    name: "questionTitleLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom",
                        "left",
                        "hidden"
                    ]
                },
                {
                    name: "title:text",
                    serializationProperty: "locTitle"
                },
                {
                    name: "description:text",
                    serializationProperty: "locDescription"
                },
                {
                    name: "questionsOrder",
                    default: "default",
                    choices: [
                        "default",
                        "initial",
                        "random"
                    ]
                },
                {
                    name: "questionErrorLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom"
                    ]
                }
            ], function() {
                return new PanelModelBase();
            });
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("panel", [
                {
                    name: "state",
                    default: "default",
                    choices: [
                        "default",
                        "collapsed",
                        "expanded"
                    ]
                },
                {
                    name: "isRequired:switch",
                    overridingProperty: "requiredIf"
                },
                {
                    name: "requiredErrorText:text",
                    serializationProperty: "locRequiredErrorText"
                },
                {
                    name: "startWithNewLine:boolean",
                    default: true
                },
                "width",
                {
                    name: "minWidth",
                    defaultFunc: function() {
                        return "auto";
                    }
                },
                {
                    name: "maxWidth",
                    defaultFunc: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_7__["settings"].maxWidth;
                    }
                },
                {
                    name: "innerIndent:number",
                    default: 0,
                    choices: [
                        0,
                        1,
                        2,
                        3
                    ]
                },
                {
                    name: "indent:number",
                    default: 0,
                    choices: [
                        0,
                        1,
                        2,
                        3
                    ],
                    visible: false
                },
                {
                    name: "page",
                    isSerializable: false,
                    visibleIf: function(obj) {
                        var survey = obj ? obj.survey : null;
                        return !survey || !survey.pages || survey.pages.length > 1;
                    },
                    choices: function(obj) {
                        var survey = obj ? obj.survey : null;
                        return survey ? survey.pages.map(function(p) {
                            return {
                                value: p.name,
                                text: p.title
                            };
                        }) : [];
                    }
                },
                "showNumber:boolean",
                {
                    name: "showQuestionNumbers",
                    default: "default",
                    choices: [
                        "default",
                        "onpanel",
                        "off"
                    ]
                },
                "questionStartIndex",
                {
                    name: "allowAdaptiveActions:boolean",
                    default: true,
                    visible: false
                }
            ], function() {
                return new PanelModel();
            }, "panelbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_5__["ElementFactory"].Instance.registerElement("panel", function(name) {
                return new PanelModel(name);
            });
        /***/ },
        /***/ "./src/popup-dropdown-view-model.ts": /*!******************************************!*\
  !*** ./src/popup-dropdown-view-model.ts ***!
  \******************************************/ /*! exports provided: PopupDropdownViewModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupDropdownViewModel", function() {
                return PopupDropdownViewModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _utils_popup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/popup */ "./src/utils/popup.ts");
            /* harmony import */ var _popup_view_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./popup-view-model */ "./src/popup-view-model.ts");
            /* harmony import */ var _utils_devices__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/devices */ "./src/utils/devices.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _survey__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./survey */ "./src/survey.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var PopupDropdownViewModel = /** @class */ function(_super) {
                __extends(PopupDropdownViewModel, _super);
                function PopupDropdownViewModel(model, targetElement) {
                    var _this = _super.call(this, model) || this;
                    _this.targetElement = targetElement;
                    _this.scrollEventCallBack = function(event1) {
                        if (_this.isOverlay && _utils_devices__WEBPACK_IMPORTED_MODULE_3__["IsTouch"]) {
                            event1.stopPropagation();
                            event1.preventDefault();
                            return;
                        }
                        _this.hidePopup();
                    };
                    _this.resizeEventCallback = function() {
                        if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].isAvailable()) return;
                        var visualViewport = _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getVisualViewport();
                        var documentElement = _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomDocumentHelper"].getDocumentElement();
                        if (!!documentElement && !!visualViewport) documentElement.style.setProperty("--sv-popup-overlay-height", visualViewport.height * visualViewport.scale + "px");
                    };
                    _this.resizeWindowCallback = function() {
                        if (!_this.isOverlay) _this.updatePosition(true, _survey__WEBPACK_IMPORTED_MODULE_5__["SurveyModel"].platform === "vue" || _survey__WEBPACK_IMPORTED_MODULE_5__["SurveyModel"].platform === "vue3" || _survey__WEBPACK_IMPORTED_MODULE_5__["SurveyModel"].platform == "react");
                    };
                    _this.clientY = 0;
                    _this.isTablet = false;
                    _this.touchStartEventCallback = function(event1) {
                        _this.clientY = event1.touches[0].clientY;
                    };
                    _this.touchMoveEventCallback = function(event1) {
                        _this.preventScrollOuside(event1, _this.clientY - event1.changedTouches[0].clientY);
                    };
                    _this.model.onRecalculatePosition.add(_this.recalculatePositionHandler);
                    return _this;
                }
                PopupDropdownViewModel.prototype.calculateIsTablet = function(windowWidth, windowHeight) {
                    var width = Math.min(windowWidth, windowHeight);
                    this.isTablet = width >= PopupDropdownViewModel.tabletSizeBreakpoint;
                };
                PopupDropdownViewModel.prototype._updatePosition = function() {
                    var _a, _b, _c;
                    if (!this.targetElement) return;
                    var targetElementRect = this.targetElement.getBoundingClientRect();
                    var popupContainer = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector(this.containerSelector);
                    if (!popupContainer) return;
                    var fixedPopupContainer = (_b = this.container) === null || _b === void 0 ? void 0 : _b.querySelector(this.fixedPopupContainer);
                    var scrollContent = popupContainer.querySelector(this.scrollingContentSelector);
                    var popupComputedStyle = _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomDocumentHelper"].getComputedStyle(popupContainer);
                    var marginLeft = parseFloat(popupComputedStyle.marginLeft) || 0;
                    var marginRight = parseFloat(popupComputedStyle.marginRight) || 0;
                    var height = popupContainer.offsetHeight - scrollContent.offsetHeight + scrollContent.scrollHeight;
                    var width = popupContainer.getBoundingClientRect().width;
                    this.model.setWidthByTarget && (this.minWidth = targetElementRect.width + "px");
                    var verticalPosition = this.model.verticalPosition;
                    var actualHorizontalPosition = this.getActualHorizontalPosition();
                    if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].isAvailable()) {
                        var heightValues = [
                            height,
                            _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getInnerHeight() * 0.9,
                            (_c = _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getVisualViewport()) === null || _c === void 0 ? void 0 : _c.height
                        ];
                        height = Math.ceil(Math.min.apply(Math, heightValues.filter(function(each) {
                            return typeof each === "number";
                        })));
                        verticalPosition = _utils_popup__WEBPACK_IMPORTED_MODULE_1__["PopupUtils"].updateVerticalPosition(targetElementRect, height, this.model.verticalPosition, this.model.showPointer, _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getInnerHeight());
                    }
                    this.popupDirection = _utils_popup__WEBPACK_IMPORTED_MODULE_1__["PopupUtils"].calculatePopupDirection(verticalPosition, actualHorizontalPosition);
                    var pos = _utils_popup__WEBPACK_IMPORTED_MODULE_1__["PopupUtils"].calculatePosition(targetElementRect, height, width + marginLeft + marginRight, verticalPosition, actualHorizontalPosition, this.showHeader, this.model.positionMode);
                    if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].isAvailable()) {
                        var newVerticalDimensions = _utils_popup__WEBPACK_IMPORTED_MODULE_1__["PopupUtils"].getCorrectedVerticalDimensions(pos.top, height, _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getInnerHeight(), verticalPosition);
                        if (!!newVerticalDimensions) {
                            this.height = newVerticalDimensions.height + "px";
                            pos.top = newVerticalDimensions.top;
                        }
                        if (this.model.setWidthByTarget) {
                            this.width = targetElementRect.width + "px";
                            pos.left = targetElementRect.left;
                        } else {
                            var newHorizontalDimensions = _utils_popup__WEBPACK_IMPORTED_MODULE_1__["PopupUtils"].updateHorizontalDimensions(pos.left, width, _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getInnerWidth(), actualHorizontalPosition, this.model.positionMode, {
                                left: marginLeft,
                                right: marginRight
                            });
                            if (!!newHorizontalDimensions) {
                                this.width = newHorizontalDimensions.width ? newHorizontalDimensions.width + "px" : undefined;
                                pos.left = newHorizontalDimensions.left;
                            }
                        }
                    }
                    if (!!fixedPopupContainer) {
                        var rect = fixedPopupContainer.getBoundingClientRect();
                        pos.top -= rect.top;
                        pos.left -= rect.left;
                    }
                    this.left = pos.left + "px";
                    this.top = pos.top + "px";
                    if (this.showHeader) {
                        this.pointerTarget = _utils_popup__WEBPACK_IMPORTED_MODULE_1__["PopupUtils"].calculatePointerTarget(targetElementRect, pos.top, pos.left, verticalPosition, actualHorizontalPosition, marginLeft, marginRight);
                        this.pointerTarget.top += "px";
                        this.pointerTarget.left += "px";
                    }
                };
                PopupDropdownViewModel.prototype.getActualHorizontalPosition = function() {
                    var actualHorizontalPosition = this.model.horizontalPosition;
                    if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomDocumentHelper"].isAvailable()) {
                        var isRtl = _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomDocumentHelper"].getComputedStyle(_global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomDocumentHelper"].getBody()).direction == "rtl";
                        if (isRtl) {
                            if (this.model.horizontalPosition === "left") actualHorizontalPosition = "right";
                            else if (this.model.horizontalPosition === "right") actualHorizontalPosition = "left";
                        }
                    }
                    return actualHorizontalPosition;
                };
                PopupDropdownViewModel.prototype.getStyleClass = function() {
                    return _super.prototype.getStyleClass.call(this).append("sv-popup--dropdown", !this.isOverlay).append("sv-popup--dropdown-overlay", this.isOverlay && this.model.overlayDisplayMode !== "overlay").append("sv-popup--tablet", this.isTablet && this.isOverlay).append("sv-popup--show-pointer", !this.isOverlay && this.showHeader).append("sv-popup--" + this.popupDirection, !this.isOverlay && (this.showHeader || this.popupDirection == "top" || this.popupDirection == "bottom"));
                };
                PopupDropdownViewModel.prototype.getShowHeader = function() {
                    return this.model.showPointer && !this.isOverlay;
                };
                PopupDropdownViewModel.prototype.getPopupHeaderTemplate = function() {
                    return "popup-pointer";
                };
                PopupDropdownViewModel.prototype.setComponentElement = function(componentRoot, targetElement) {
                    _super.prototype.setComponentElement.call(this, componentRoot);
                    if (!!componentRoot && !!componentRoot.parentElement && !this.isModal) this.targetElement = targetElement || componentRoot.parentElement;
                };
                PopupDropdownViewModel.prototype.resetComponentElement = function() {
                    _super.prototype.resetComponentElement.call(this);
                    this.targetElement = undefined;
                };
                PopupDropdownViewModel.prototype.updateOnShowing = function() {
                    var root = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root;
                    this.prevActiveElement = root.activeElement;
                    if (this.isOverlay) this.resetDimensionsAndPositionStyleProperties();
                    else this.updatePosition(true, false);
                    this.switchFocus();
                    _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].addEventListener("resize", this.resizeWindowCallback);
                    if (this.shouldCreateResizeCallback) {
                        _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getVisualViewport().addEventListener("resize", this.resizeEventCallback);
                        if (this.container) {
                            this.container.addEventListener("touchstart", this.touchStartEventCallback);
                            this.container.addEventListener("touchmove", this.touchMoveEventCallback);
                        }
                        this.calculateIsTablet(_global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getInnerWidth(), _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getInnerHeight());
                        this.resizeEventCallback();
                    }
                    _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].addEventListener("scroll", this.scrollEventCallBack);
                };
                Object.defineProperty(PopupDropdownViewModel.prototype, "shouldCreateResizeCallback", {
                    get: function() {
                        return !!_global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getVisualViewport() && this.isOverlay && _utils_devices__WEBPACK_IMPORTED_MODULE_3__["IsTouch"];
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupDropdownViewModel.prototype.updatePosition = function(isResetHeight, isDelayUpdating) {
                    var _this = this;
                    if (isDelayUpdating === void 0) isDelayUpdating = true;
                    if (isResetHeight) this.height = "auto";
                    if (isDelayUpdating) setTimeout(function() {
                        _this._updatePosition();
                    }, 1);
                    else this._updatePosition();
                };
                PopupDropdownViewModel.prototype.updateOnHiding = function() {
                    _super.prototype.updateOnHiding.call(this);
                    _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].removeEventListener("resize", this.resizeWindowCallback);
                    if (this.shouldCreateResizeCallback) {
                        _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].getVisualViewport().removeEventListener("resize", this.resizeEventCallback);
                        if (this.container) {
                            this.container.removeEventListener("touchstart", this.touchStartEventCallback);
                            this.container.removeEventListener("touchmove", this.touchMoveEventCallback);
                        }
                    }
                    _global_variables_utils__WEBPACK_IMPORTED_MODULE_6__["DomWindowHelper"].removeEventListener("scroll", this.scrollEventCallBack);
                    if (!this.isDisposed) {
                        this.top = undefined;
                        this.left = undefined;
                        this.height = undefined;
                        this.width = undefined;
                        this.minWidth = undefined;
                    }
                };
                PopupDropdownViewModel.prototype.onModelChanging = function(newModel) {
                    var _this = this;
                    if (!!this.model) this.model.onRecalculatePosition.remove(this.recalculatePositionHandler);
                    if (!this.recalculatePositionHandler) this.recalculatePositionHandler = function(_, options) {
                        if (!_this.isOverlay) _this.updatePosition(options.isResetHeight);
                    };
                    _super.prototype.onModelChanging.call(this, newModel);
                    newModel.onRecalculatePosition.add(this.recalculatePositionHandler);
                };
                PopupDropdownViewModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.updateOnHiding();
                    if (!!this.model) {
                        this.model.onRecalculatePosition.remove(this.recalculatePositionHandler);
                        this.recalculatePositionHandler = undefined;
                    }
                    this.resetComponentElement();
                };
                PopupDropdownViewModel.tabletSizeBreakpoint = 600;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], PopupDropdownViewModel.prototype, "isTablet", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: "left"
                    })
                ], PopupDropdownViewModel.prototype, "popupDirection", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: {
                            left: "0px",
                            top: "0px"
                        }
                    })
                ], PopupDropdownViewModel.prototype, "pointerTarget", void 0);
                return PopupDropdownViewModel;
            }(_popup_view_model__WEBPACK_IMPORTED_MODULE_2__["PopupBaseViewModel"]);
        /***/ },
        /***/ "./src/popup-modal-view-model.ts": /*!***************************************!*\
  !*** ./src/popup-modal-view-model.ts ***!
  \***************************************/ /*! exports provided: PopupModalViewModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupModalViewModel", function() {
                return PopupModalViewModel;
            });
            /* harmony import */ var _popup_view_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./popup-view-model */ "./src/popup-view-model.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var PopupModalViewModel = /** @class */ function(_super) {
                __extends(PopupModalViewModel, _super);
                function PopupModalViewModel(model) {
                    var _this = _super.call(this, model) || this;
                    _this.onScrollOutsideCallback = function(event1) {
                        _this.preventScrollOuside(event1, event1.deltaY);
                    };
                    return _this;
                }
                PopupModalViewModel.prototype.getStyleClass = function() {
                    return _super.prototype.getStyleClass.call(this).append("sv-popup--modal", !this.isOverlay);
                };
                PopupModalViewModel.prototype.getShowFooter = function() {
                    return true;
                };
                PopupModalViewModel.prototype.createFooterActionBar = function() {
                    var _this = this;
                    _super.prototype.createFooterActionBar.call(this);
                    this.footerToolbarValue.addAction({
                        id: "apply",
                        visibleIndex: 20,
                        title: this.applyButtonText,
                        innerCss: "sv-popup__body-footer-item sv-popup__button sv-popup__button--apply sd-btn sd-btn--action",
                        action: function() {
                            _this.apply();
                        }
                    });
                };
                Object.defineProperty(PopupModalViewModel.prototype, "applyButtonText", {
                    get: function() {
                        return this.getLocalizationString("modalApplyButtonText");
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupModalViewModel.prototype.apply = function() {
                    if (!!this.model.onApply && !this.model.onApply()) return;
                    this.hidePopup();
                };
                PopupModalViewModel.prototype.clickOutside = function() {
                    return;
                };
                PopupModalViewModel.prototype.onKeyDown = function(event1) {
                    if (event1.key === "Escape" || event1.keyCode === 27) this.model.onCancel();
                    _super.prototype.onKeyDown.call(this, event1);
                };
                PopupModalViewModel.prototype.updateOnShowing = function() {
                    if (this.container) this.container.addEventListener("wheel", this.onScrollOutsideCallback, {
                        passive: false
                    });
                    _super.prototype.updateOnShowing.call(this);
                };
                PopupModalViewModel.prototype.updateOnHiding = function() {
                    if (this.container) this.container.removeEventListener("wheel", this.onScrollOutsideCallback);
                    _super.prototype.updateOnHiding.call(this);
                };
                return PopupModalViewModel;
            }(_popup_view_model__WEBPACK_IMPORTED_MODULE_0__["PopupBaseViewModel"]);
        /***/ },
        /***/ "./src/popup-survey.ts": /*!*****************************!*\
  !*** ./src/popup-survey.ts ***!
  \*****************************/ /*! exports provided: PopupSurveyModel, SurveyWindowModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupSurveyModel", function() {
                return PopupSurveyModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyWindowModel", function() {
                return SurveyWindowModel;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _survey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./survey */ "./src/survey.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A class that renders a survey in a pop-up window.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/popup-survey/ (linkStyle))
 */ var PopupSurveyModel = /** @class */ function(_super) {
                __extends(PopupSurveyModel, _super);
                function PopupSurveyModel(jsonObj, initialModel) {
                    if (initialModel === void 0) initialModel = null;
                    var _this = _super.call(this) || this;
                    /**
         * Specifies how many seconds the pop-up window should remain open after users complete the survey.
         *
         * Default value: 0 (the window is closed immediately)
         *
         * Set this property to a negative value (for instance, -1) to keep the pop-up window open without a time limit.
         */ _this.closeOnCompleteTimeout = 0;
                    if (initialModel) _this.surveyValue = initialModel;
                    else _this.surveyValue = _this.createSurvey(jsonObj);
                    _this.surveyValue.fitToContainer = true;
                    _this.windowElement = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].createElement("div");
                    _this.survey.onComplete.add(function(survey, options) {
                        _this.onSurveyComplete();
                    });
                    _this.registerPropertyChangedHandlers([
                        "isShowing"
                    ], function() {
                        if (!!_this.showingChangedCallback) _this.showingChangedCallback();
                    });
                    _this.registerPropertyChangedHandlers([
                        "isExpanded"
                    ], function() {
                        _this.onExpandedChanged();
                    });
                    _this.width = new _base__WEBPACK_IMPORTED_MODULE_0__["ComputedUpdater"](function() {
                        return _this.survey.width;
                    });
                    _this.width = _this.survey.width;
                    _this.updateCss();
                    _this.onCreating();
                    return _this;
                }
                PopupSurveyModel.prototype.onCreating = function() {};
                PopupSurveyModel.prototype.getType = function() {
                    return "popupsurvey";
                };
                Object.defineProperty(PopupSurveyModel.prototype, "survey", {
                    /**
         * A [`SurveyModel`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model) instance rendered in the pop-up window.
         */ get: function() {
                        return this.surveyValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "isShowing", {
                    /**
         * Indicates whether the pop-up survey appears on the page, regardless of its [expand state](#isExpanded).
         *
         * You can set this property to `true` or `false` to control visibility of the pop-up survey. Alternatively, you can use the [`show()`](#show) and [`hide()`](#hide) methods.
         */ get: function() {
                        return this.getPropertyValue("isShowing", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("isShowing", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "isFullScreen", {
                    get: function() {
                        return this.getPropertyValue("isFullScreen", false);
                    },
                    set: function(val1) {
                        if (!this.isExpanded && !!val1) this.isExpanded = true;
                        this.setPropertyValue("isFullScreen", val1);
                        this.setCssRoot();
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Shows the pop-up survey. The survey may appear [expanded or collapsed](#isExpanded).
     *
     * As an alternative to this method, you can set the [`isShowing`](#isShowing) property to `true`.
     * @see hide
     */ PopupSurveyModel.prototype.show = function() {
                    this.isShowing = true;
                };
                /**
     * Hides the pop-up survey.
     *
     * As an alternative to this method, you can set the [`isShowing`](#isShowing) property to `false`.
     * @see show
     * @see expand
     * @see collapse
     */ PopupSurveyModel.prototype.hide = function() {
                    this.isShowing = false;
                };
                PopupSurveyModel.prototype.toggleFullScreen = function() {
                    this.isFullScreen = !this.isFullScreen;
                };
                Object.defineProperty(PopupSurveyModel.prototype, "isExpanded", {
                    /**
         * Indicates whether the pop-up window is expanded or collapsed.
         *
         * You can set this property to `true` or `false` to control the expand state of the pop-up survey. Alternatively, you can use the [`expand()`](#expand) and [`collapse()`](#collapse) methods.
         */ get: function() {
                        return this.getPropertyValue("isExpanded", false);
                    },
                    set: function(val1) {
                        if (!!this.isFullScreen && !val1) this.isFullScreen = false;
                        this.setPropertyValue("isExpanded", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "isCollapsed", {
                    get: function() {
                        return !this.isExpanded;
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupSurveyModel.prototype.onExpandedChanged = function() {
                    if (!!this.expandedChangedCallback) this.expandedChangedCallback();
                    this.updateCssButton();
                };
                Object.defineProperty(PopupSurveyModel.prototype, "title", {
                    /**
         * A title for the pop-up window. If this property is undefined, the title is taken from [`SurveyModel`](#survey)'s [`title`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#title) property.
         */ get: function() {
                        return this.survey.title;
                    },
                    set: function(value) {
                        this.survey.title = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "locTitle", {
                    get: function() {
                        if (this.survey.locTitle.isEmpty) return null;
                        return this.survey.locTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "locDescription", {
                    get: function() {
                        if (this.survey.locTitle.isEmpty) return null;
                        return this.survey.locDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Expands the pop-up window.
     *
     * As an alternative to this method, you can set the [`isExpanded`](#isExpanded) property to `true`.
     * @see collapse
     */ PopupSurveyModel.prototype.expand = function() {
                    this.isExpanded = true;
                };
                /**
     * Collapses the pop-up window, leaving only the survey title visible.
     *
     * As an alternative to this method, you can set the [`isExpanded`](#isExpanded) property to `false`.
     * @see expand
     */ PopupSurveyModel.prototype.collapse = function() {
                    this.isExpanded = false;
                };
                PopupSurveyModel.prototype.changeExpandCollapse = function() {
                    this.isExpanded = !this.isExpanded;
                };
                Object.defineProperty(PopupSurveyModel.prototype, "allowClose", {
                    /**
         * Specifies whether to display a button that closes the pop-up window.
         *
         * Default value: `false`
         *
         * If you allow users to close the pop-up window, make sure to implement a UI element that opens it. This element should call the [`show()`](#show) method or enable the [`isShowing`](#isShowing) property.
         * @see expand
         * @see collapse
         * @see hide
         */ get: function() {
                        return this.getPropertyValue("allowClose", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowClose", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "allowFullScreen", {
                    /**
         * Specifies whether to display a button that allows respondents to show the pop-up survey in full screen mode.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("allowFullScreen", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowFullScreen", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "css", {
                    get: function() {
                        return this.survey.css;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssButton", {
                    get: function() {
                        return this.getPropertyValue("cssButton", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssRoot", {
                    get: function() {
                        var result = this.getPropertyValue("cssRoot", "");
                        if (this.isCollapsed) result += " " + this.getPropertyValue("cssRootCollapsedMod", "");
                        return result;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssRootCollapsedMod", {
                    get: function() {
                        return this.getPropertyValue("cssRootCollapsedMod");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssRootContent", {
                    get: function() {
                        return this.getPropertyValue("cssRootContent");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssBody", {
                    get: function() {
                        return this.getPropertyValue("cssBody", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssHeaderRoot", {
                    get: function() {
                        return this.getPropertyValue("cssHeaderRoot", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssHeaderTitleCollapsed", {
                    get: function() {
                        return this.getPropertyValue("cssHeaderTitleCollapsed", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssHeaderButtonsContainer", {
                    get: function() {
                        return this.getPropertyValue("cssHeaderButtonsContainer", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssHeaderCollapseButton", {
                    get: function() {
                        return this.getPropertyValue("cssHeaderCollapseButton", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssHeaderCloseButton", {
                    get: function() {
                        return this.getPropertyValue("cssHeaderCloseButton", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "cssHeaderFullScreenButton", {
                    get: function() {
                        return this.getPropertyValue("cssHeaderFullScreenButton", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupSurveyModel.prototype, "renderedWidth", {
                    get: function() {
                        var width = this.getPropertyValue("width", "60%");
                        if (width && !isNaN(width)) width = width + "px";
                        return width;
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupSurveyModel.prototype.updateCss = function() {
                    if (!this.css || !this.css.window) return;
                    var cssWindow = this.css.window;
                    this.setCssRoot();
                    this.setPropertyValue("cssRootCollapsedMod", cssWindow.rootCollapsedMod);
                    this.setPropertyValue("cssRootContent", cssWindow.rootContent);
                    this.setPropertyValue("cssBody", cssWindow.body);
                    var cssHeader = cssWindow.header;
                    if (!cssHeader) return;
                    this.setPropertyValue("cssHeaderRoot", cssHeader.root);
                    this.setPropertyValue("cssHeaderTitleCollapsed", cssHeader.titleCollapsed);
                    this.setPropertyValue("cssHeaderButtonsContainer", cssHeader.buttonsContainer);
                    this.setPropertyValue("cssHeaderCollapseButton", cssHeader.collapseButton);
                    this.setPropertyValue("cssHeaderCloseButton", cssHeader.closeButton);
                    this.setPropertyValue("cssHeaderFullScreenButton", cssHeader.fullScreenButton);
                    this.updateCssButton();
                };
                PopupSurveyModel.prototype.setCssRoot = function() {
                    var cssWindow = this.css.window;
                    if (this.isFullScreen) this.setPropertyValue("cssRoot", cssWindow.root + " " + cssWindow.rootFullScreenMode);
                    else this.setPropertyValue("cssRoot", cssWindow.root);
                };
                PopupSurveyModel.prototype.updateCssButton = function() {
                    var cssHeader = !!this.css.window ? this.css.window.header : null;
                    if (!cssHeader) return;
                    this.setCssButton(this.isExpanded ? cssHeader.buttonExpanded : cssHeader.buttonCollapsed);
                };
                PopupSurveyModel.prototype.setCssButton = function(val1) {
                    if (!val1) return;
                    this.setPropertyValue("cssButton", val1);
                };
                PopupSurveyModel.prototype.createSurvey = function(jsonObj) {
                    return new _survey__WEBPACK_IMPORTED_MODULE_1__["SurveyModel"](jsonObj);
                };
                PopupSurveyModel.prototype.onSurveyComplete = function() {
                    if (this.closeOnCompleteTimeout < 0) return;
                    if (this.closeOnCompleteTimeout == 0) this.hide();
                    else {
                        var self = this;
                        var timerId = null;
                        var func = function() {
                            self.hide();
                            clearInterval(timerId);
                        };
                        timerId = setInterval(func, this.closeOnCompleteTimeout * 1000);
                    }
                };
                PopupSurveyModel.prototype.onScroll = function() {
                    this.survey.onScroll();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], PopupSurveyModel.prototype, "width", void 0);
                return PopupSurveyModel;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            /**
 * Obsolete. Please use PopupSurvey
 */ var SurveyWindowModel = /** @class */ function(_super) {
                __extends(SurveyWindowModel, _super);
                function SurveyWindowModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return SurveyWindowModel;
            }(PopupSurveyModel);
        /***/ },
        /***/ "./src/popup-utils.ts": /*!****************************!*\
  !*** ./src/popup-utils.ts ***!
  \****************************/ /*! exports provided: createPopupModalViewModel, createPopupViewModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPopupModalViewModel", function() {
                return createPopupModalViewModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createPopupViewModel", function() {
                return createPopupViewModel;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _popup__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./popup */ "./src/popup.ts");
            /* harmony import */ var _popup_dropdown_view_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./popup-dropdown-view-model */ "./src/popup-dropdown-view-model.ts");
            /* harmony import */ var _popup_modal_view_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./popup-modal-view-model */ "./src/popup-modal-view-model.ts");
            function createPopupModalViewModel(options, rootElement1) {
                var _a;
                var popupModel = new _popup__WEBPACK_IMPORTED_MODULE_1__["PopupModel"](options.componentName, options.data, "top", "left", false, true, options.onCancel, options.onApply, options.onHide, options.onShow, options.cssClass, options.title);
                popupModel.displayMode = options.displayMode || "popup";
                popupModel.isFocusedContent = (_a = options.isFocusedContent) !== null && _a !== void 0 ? _a : true;
                var popupViewModel = new _popup_modal_view_model__WEBPACK_IMPORTED_MODULE_3__["PopupModalViewModel"](popupModel);
                if (!!rootElement1 && !!rootElement1.appendChild) {
                    var container = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].createElement("div");
                    rootElement1.appendChild(container);
                    popupViewModel.setComponentElement(container);
                }
                if (!popupViewModel.container) popupViewModel.initializePopupContainer();
                var onVisibilityChangedCallback = function(sender, options) {
                    if (!options.isVisible) {
                        if (!!container) popupViewModel.resetComponentElement();
                    }
                    popupViewModel.onVisibilityChanged.remove(onVisibilityChangedCallback);
                };
                popupViewModel.onVisibilityChanged.add(onVisibilityChangedCallback);
                return popupViewModel;
            }
            function createPopupViewModel(model, targetElement) {
                if (model.isModal) return new _popup_modal_view_model__WEBPACK_IMPORTED_MODULE_3__["PopupModalViewModel"](model);
                else return new _popup_dropdown_view_model__WEBPACK_IMPORTED_MODULE_2__["PopupDropdownViewModel"](model, targetElement);
            }
        /***/ },
        /***/ "./src/popup-view-model.ts": /*!*********************************!*\
  !*** ./src/popup-view-model.ts ***!
  \*********************************/ /*! exports provided: FOCUS_INPUT_SELECTOR, PopupBaseViewModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FOCUS_INPUT_SELECTOR", function() {
                return FOCUS_INPUT_SELECTOR;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupBaseViewModel", function() {
                return PopupBaseViewModel;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _utils_animation__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/animation */ "./src/utils/animation.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var FOCUS_INPUT_SELECTOR = 'input:not(:disabled):not([readonly]):not([type=hidden]),select:not(:disabled):not([readonly]),textarea:not(:disabled):not([readonly]), button:not(:disabled):not([readonly]), [tabindex]:not([tabindex^="-"])';
            var PopupBaseViewModel = /** @class */ function(_super) {
                __extends(PopupBaseViewModel, _super);
                function PopupBaseViewModel(model) {
                    var _this = _super.call(this) || this;
                    _this.popupSelector = ".sv-popup";
                    _this.fixedPopupContainer = ".sv-popup";
                    _this.containerSelector = ".sv-popup__container";
                    _this.scrollingContentSelector = ".sv-popup__scrolling-content";
                    _this.visibilityAnimation = new _utils_animation__WEBPACK_IMPORTED_MODULE_6__["AnimationBoolean"](_this, function(val1) {
                        if (_this._isVisible !== val1) {
                            if (!val1) {
                                _this.updateOnHiding();
                                _this.updateIsVisible(val1);
                            } else _this.updateIsVisible(val1);
                        }
                    }, function() {
                        return _this._isVisible;
                    });
                    _this.onVisibilityChanged = new _base__WEBPACK_IMPORTED_MODULE_0__["EventBase"]();
                    _this.onModelIsVisibleChangedCallback = function() {
                        _this.isVisible = _this.model.isVisible;
                    };
                    _this.model = model;
                    return _this;
                }
                PopupBaseViewModel.prototype.updateIsVisible = function(val1) {
                    this._isVisible = val1;
                    this.onVisibilityChanged.fire(this, {
                        isVisible: val1
                    });
                };
                PopupBaseViewModel.prototype.getLeaveOptions = function() {
                    return {
                        cssClass: "sv-popup--animate-leave"
                    };
                };
                PopupBaseViewModel.prototype.getEnterOptions = function() {
                    return {
                        cssClass: "sv-popup--animate-enter"
                    };
                };
                PopupBaseViewModel.prototype.getAnimatedElement = function() {
                    return this.getAnimationContainer();
                };
                PopupBaseViewModel.prototype.isAnimationEnabled = function() {
                    return this.model.displayMode !== "overlay" && _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].animationEnabled;
                };
                PopupBaseViewModel.prototype.getAnimationContainer = function() {
                    var _a;
                    return (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector(this.fixedPopupContainer);
                };
                Object.defineProperty(PopupBaseViewModel.prototype, "isVisible", {
                    get: function() {
                        return this._isVisible;
                    },
                    set: function(val1) {
                        this.visibilityAnimation.sync(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "container", {
                    get: function() {
                        return this.containerElement || this.createdContainer;
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupBaseViewModel.prototype.getLocale = function() {
                    if (!!this.locale) return this.locale;
                    return _super.prototype.getLocale.call(this);
                };
                PopupBaseViewModel.prototype.hidePopup = function() {
                    this.model.isVisible = false;
                };
                PopupBaseViewModel.prototype.getStyleClass = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append(this.model.cssClass).append("sv-popup--" + this.model.displayMode, this.isOverlay);
                };
                PopupBaseViewModel.prototype.getShowFooter = function() {
                    return this.isOverlay;
                };
                PopupBaseViewModel.prototype.getShowHeader = function() {
                    return false;
                };
                PopupBaseViewModel.prototype.getPopupHeaderTemplate = function() {
                    return undefined;
                };
                PopupBaseViewModel.prototype.createFooterActionBar = function() {
                    var _this = this;
                    this.footerToolbarValue = new _actions_container__WEBPACK_IMPORTED_MODULE_3__["ActionContainer"]();
                    this.footerToolbar.updateCallback = function(isResetInitialized) {
                        _this.footerToolbarValue.actions.forEach(function(action) {
                            return action.cssClasses = {
                                item: "sv-popup__body-footer-item sv-popup__button sd-btn"
                            };
                        });
                    };
                    var footerActions = [
                        {
                            id: "cancel",
                            visibleIndex: 10,
                            title: this.cancelButtonText,
                            innerCss: "sv-popup__button--cancel sd-btn",
                            action: function() {
                                _this.cancel();
                            }
                        }
                    ];
                    footerActions = this.model.updateFooterActions(footerActions);
                    this.footerToolbarValue.setItems(footerActions);
                };
                PopupBaseViewModel.prototype.resetDimensionsAndPositionStyleProperties = function() {
                    var nullableValue = "inherit";
                    this.top = nullableValue;
                    this.left = nullableValue;
                    this.height = nullableValue;
                    this.width = nullableValue;
                    this.minWidth = nullableValue;
                };
                PopupBaseViewModel.prototype.onModelChanging = function(newModel) {};
                PopupBaseViewModel.prototype.setupModel = function(model) {
                    if (!!this.model) this.model.onVisibilityChanged.remove(this.onModelIsVisibleChangedCallback);
                    this.onModelChanging(model);
                    this._model = model;
                    model.onVisibilityChanged.add(this.onModelIsVisibleChangedCallback);
                    this.onModelIsVisibleChangedCallback();
                };
                Object.defineProperty(PopupBaseViewModel.prototype, "model", {
                    get: function() {
                        return this._model;
                    },
                    set: function(model) {
                        this.setupModel(model);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "title", {
                    get: function() {
                        return this.model.title;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "contentComponentName", {
                    get: function() {
                        return this.model.contentComponentName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "contentComponentData", {
                    get: function() {
                        return this.model.contentComponentData;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "isModal", {
                    get: function() {
                        return this.model.isModal;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "isFocusedContent", {
                    get: function() {
                        return this.model.isFocusedContent;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "isFocusedContainer", {
                    get: function() {
                        return this.model.isFocusedContainer;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "showFooter", {
                    get: function() {
                        return this.getShowFooter();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "showHeader", {
                    get: function() {
                        return this.getShowHeader();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "popupHeaderTemplate", {
                    get: function() {
                        return this.getPopupHeaderTemplate();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "isOverlay", {
                    get: function() {
                        return this.model.displayMode === "overlay";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "styleClass", {
                    get: function() {
                        return this.getStyleClass().toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "cancelButtonText", {
                    get: function() {
                        return this.getLocalizationString("modalCancelButtonText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(PopupBaseViewModel.prototype, "footerToolbar", {
                    get: function() {
                        if (!this.footerToolbarValue) this.createFooterActionBar();
                        return this.footerToolbarValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupBaseViewModel.prototype.onKeyDown = function(event1) {
                    if (event1.key === "Tab" || event1.keyCode === 9) this.trapFocus(event1);
                    else if (event1.key === "Escape" || event1.keyCode === 27) this.hidePopup();
                };
                PopupBaseViewModel.prototype.trapFocus = function(event1) {
                    var focusableElements = this.container.querySelectorAll(FOCUS_INPUT_SELECTOR);
                    var firstFocusableElement = focusableElements[0];
                    var lastFocusableElement = focusableElements[focusableElements.length - 1];
                    if (event1.shiftKey) {
                        if (_settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root.activeElement === firstFocusableElement) {
                            lastFocusableElement.focus();
                            event1.preventDefault();
                        }
                    } else if (_settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root.activeElement === lastFocusableElement) {
                        firstFocusableElement.focus();
                        event1.preventDefault();
                    }
                };
                PopupBaseViewModel.prototype.switchFocus = function() {
                    if (this.isFocusedContent) this.focusFirstInput();
                    else if (this.isFocusedContainer) this.focusContainer();
                };
                PopupBaseViewModel.prototype.updateOnShowing = function() {
                    this.prevActiveElement = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root.activeElement;
                    if (this.isOverlay) this.resetDimensionsAndPositionStyleProperties();
                    this.switchFocus();
                };
                PopupBaseViewModel.prototype.updateOnHiding = function() {
                    if (this.isFocusedContent && this.prevActiveElement) this.prevActiveElement.focus();
                };
                PopupBaseViewModel.prototype.focusContainer = function() {
                    if (!this.container) return;
                    var popup = this.container.querySelector(this.popupSelector);
                    popup === null || popup === void 0 || popup.focus();
                };
                PopupBaseViewModel.prototype.focusFirstInput = function() {
                    var _this = this;
                    setTimeout(function() {
                        if (!_this.container) return;
                        var el = _this.container.querySelector(_this.model.focusFirstInputSelector || FOCUS_INPUT_SELECTOR);
                        if (!!el) el.focus();
                        else _this.focusContainer();
                    }, 100);
                };
                PopupBaseViewModel.prototype.clickOutside = function(event1) {
                    this.hidePopup();
                    event1 === null || event1 === void 0 || event1.stopPropagation();
                };
                PopupBaseViewModel.prototype.cancel = function() {
                    this.model.onCancel();
                    this.hidePopup();
                };
                PopupBaseViewModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (this.model) this.model.onVisibilityChanged.remove(this.onModelIsVisibleChangedCallback);
                    if (!!this.createdContainer) {
                        this.createdContainer.remove();
                        this.createdContainer = undefined;
                    }
                    if (!!this.footerToolbarValue) this.footerToolbarValue.dispose();
                    this.resetComponentElement();
                };
                PopupBaseViewModel.prototype.initializePopupContainer = function() {
                    if (!this.container) {
                        var container = _global_variables_utils__WEBPACK_IMPORTED_MODULE_7__["DomDocumentHelper"].createElement("div");
                        this.createdContainer = container;
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_5__["getElement"])(_settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.popupMountContainer).appendChild(container);
                    }
                };
                PopupBaseViewModel.prototype.setComponentElement = function(componentRoot, targetElement) {
                    if (!!componentRoot) this.containerElement = componentRoot;
                };
                PopupBaseViewModel.prototype.resetComponentElement = function() {
                    this.containerElement = undefined;
                    this.prevActiveElement = undefined;
                };
                PopupBaseViewModel.prototype.preventScrollOuside = function(event1, deltaY) {
                    var currentElement = event1.target;
                    while(currentElement !== this.container){
                        if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_7__["DomDocumentHelper"].getComputedStyle(currentElement).overflowY === "auto" && currentElement.scrollHeight !== currentElement.offsetHeight) {
                            var scrollHeight = currentElement.scrollHeight, scrollTop = currentElement.scrollTop, clientHeight = currentElement.clientHeight;
                            if (!(deltaY > 0 && Math.abs(scrollHeight - clientHeight - scrollTop) < 1) && !(deltaY < 0 && scrollTop <= 0)) return;
                        }
                        currentElement = currentElement.parentElement;
                    }
                    if (event1.cancelable) event1.preventDefault();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "0px"
                    })
                ], PopupBaseViewModel.prototype, "top", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "0px"
                    })
                ], PopupBaseViewModel.prototype, "left", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "auto"
                    })
                ], PopupBaseViewModel.prototype, "height", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "auto"
                    })
                ], PopupBaseViewModel.prototype, "width", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "auto"
                    })
                ], PopupBaseViewModel.prototype, "minWidth", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], PopupBaseViewModel.prototype, "_isVisible", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], PopupBaseViewModel.prototype, "locale", void 0);
                return PopupBaseViewModel;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
        /***/ },
        /***/ "./src/popup.ts": /*!**********************!*\
  !*** ./src/popup.ts ***!
  \**********************/ /*! exports provided: PopupModel, createDialogOptions */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupModel", function() {
                return PopupModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDialogOptions", function() {
                return createDialogOptions;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var PopupModel = /** @class */ function(_super) {
                __extends(PopupModel, _super);
                function PopupModel(contentComponentName, contentComponentData, verticalPosition, horizontalPosition, showPointer, isModal, onCancel, onApply, onHide, onShow, cssClass, title, onDispose) {
                    if (verticalPosition === void 0) verticalPosition = "bottom";
                    if (horizontalPosition === void 0) horizontalPosition = "left";
                    if (showPointer === void 0) showPointer = true;
                    if (isModal === void 0) isModal = false;
                    if (onCancel === void 0) onCancel = function() {};
                    if (onApply === void 0) onApply = function() {
                        return true;
                    };
                    if (onHide === void 0) onHide = function() {};
                    if (onShow === void 0) onShow = function() {};
                    if (cssClass === void 0) cssClass = "";
                    if (title === void 0) title = "";
                    if (onDispose === void 0) onDispose = function() {};
                    var _this = _super.call(this) || this;
                    _this.onDispose = onDispose;
                    _this.focusFirstInputSelector = "";
                    _this.onVisibilityChanged = _this.addEvent();
                    _this.onFooterActionsCreated = _this.addEvent();
                    _this.onRecalculatePosition = _this.addEvent();
                    _this.contentComponentName = contentComponentName;
                    _this.contentComponentData = contentComponentData;
                    _this.verticalPosition = verticalPosition;
                    _this.horizontalPosition = horizontalPosition;
                    _this.showPointer = showPointer;
                    _this.isModal = isModal;
                    _this.onCancel = onCancel;
                    _this.onApply = onApply;
                    _this.onHide = onHide;
                    _this.onShow = onShow;
                    _this.cssClass = cssClass;
                    _this.title = title;
                    return _this;
                }
                PopupModel.prototype.refreshInnerModel = function() {
                    var innerModel = this.contentComponentData["model"];
                    innerModel && innerModel.refresh && innerModel.refresh();
                };
                Object.defineProperty(PopupModel.prototype, "isVisible", {
                    get: function() {
                        return this.getPropertyValue("isVisible", false);
                    },
                    set: function(value) {
                        if (this.isVisible === value) return;
                        this.setPropertyValue("isVisible", value);
                        this.onVisibilityChanged.fire(this, {
                            model: this,
                            isVisible: value
                        });
                        if (this.isVisible) this.onShow();
                        else {
                            this.refreshInnerModel();
                            this.onHide();
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupModel.prototype.toggleVisibility = function() {
                    this.isVisible = !this.isVisible;
                };
                PopupModel.prototype.recalculatePosition = function(isResetHeight) {
                    this.onRecalculatePosition.fire(this, {
                        isResetHeight: isResetHeight
                    });
                };
                PopupModel.prototype.updateFooterActions = function(footerActions) {
                    var options = {
                        actions: footerActions
                    };
                    this.onFooterActionsCreated.fire(this, options);
                    return options.actions;
                };
                PopupModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.onDispose();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], PopupModel.prototype, "contentComponentName", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], PopupModel.prototype, "contentComponentData", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "bottom"
                    })
                ], PopupModel.prototype, "verticalPosition", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "left"
                    })
                ], PopupModel.prototype, "horizontalPosition", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], PopupModel.prototype, "showPointer", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], PopupModel.prototype, "isModal", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: true
                    })
                ], PopupModel.prototype, "isFocusedContent", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: true
                    })
                ], PopupModel.prototype, "isFocusedContainer", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: function() {}
                    })
                ], PopupModel.prototype, "onCancel", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: function() {
                            return true;
                        }
                    })
                ], PopupModel.prototype, "onApply", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: function() {}
                    })
                ], PopupModel.prototype, "onHide", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: function() {}
                    })
                ], PopupModel.prototype, "onShow", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: ""
                    })
                ], PopupModel.prototype, "cssClass", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: ""
                    })
                ], PopupModel.prototype, "title", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "auto"
                    })
                ], PopupModel.prototype, "overlayDisplayMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "popup"
                    })
                ], PopupModel.prototype, "displayMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "flex"
                    })
                ], PopupModel.prototype, "positionMode", void 0);
                return PopupModel;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            function createDialogOptions(componentName, data, onApply, onCancel, onHide, onShow, cssClass, title, displayMode) {
                if (onHide === void 0) onHide = function() {};
                if (onShow === void 0) onShow = function() {};
                if (displayMode === void 0) displayMode = "popup";
                _console_warnings__WEBPACK_IMPORTED_MODULE_2__["ConsoleWarnings"].warn("The `showModal()` and `createDialogOptions()` methods are obsolete. Use the `showDialog()` method instead.");
                return {
                    componentName: componentName,
                    data: data,
                    onApply: onApply,
                    onCancel: onCancel,
                    onHide: onHide,
                    onShow: onShow,
                    cssClass: cssClass,
                    title: title,
                    displayMode: displayMode
                };
            }
        /***/ },
        /***/ "./src/progress-buttons.ts": /*!*********************************!*\
  !*** ./src/progress-buttons.ts ***!
  \*********************************/ /*! exports provided: ProgressButtons, ProgressButtonsResponsivityManager */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressButtons", function() {
                return ProgressButtons;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProgressButtonsResponsivityManager", function() {
                return ProgressButtonsResponsivityManager;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./defaultCss/defaultV2Css */ "./src/defaultCss/defaultV2Css.ts");
            /* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./page */ "./src/page.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ProgressButtons = /** @class */ function(_super) {
                __extends(ProgressButtons, _super);
                function ProgressButtons(survey) {
                    var _this = _super.call(this) || this;
                    _this.survey = survey;
                    _this.onResize = _this.addEvent();
                    return _this;
                }
                ProgressButtons.prototype.isListElementClickable = function(index) {
                    if (!this.survey.onServerValidateQuestions || this.survey.onServerValidateQuestions.isEmpty || this.survey.checkErrorsMode === "onComplete") return true;
                    return index <= this.survey.currentPageNo + 1;
                };
                ProgressButtons.prototype.getRootCss = function(container) {
                    if (container === void 0) container = "center";
                    var result = this.survey.css.progressButtonsContainerCenter;
                    if (this.survey.css.progressButtonsRoot) {
                        result += " " + this.survey.css.progressButtonsRoot + " " + this.survey.css.progressButtonsRoot + "--" + ([
                            "footer",
                            "contentBottom"
                        ].indexOf(container) !== -1 ? "bottom" : "top");
                        result += " " + this.survey.css.progressButtonsRoot + "--" + (this.showItemTitles ? "with-titles" : "no-titles");
                    }
                    if (this.showItemNumbers && this.survey.css.progressButtonsNumbered) result += " " + this.survey.css.progressButtonsNumbered;
                    if (this.isFitToSurveyWidth) result += " " + this.survey.css.progressButtonsFitSurveyWidth;
                    return result;
                };
                ProgressButtons.prototype.getListElementCss = function(index) {
                    if (index >= this.survey.visiblePages.length) return;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.survey.css.progressButtonsListElementPassed, this.survey.visiblePages[index].passed).append(this.survey.css.progressButtonsListElementCurrent, this.survey.currentPageNo === index).append(this.survey.css.progressButtonsListElementNonClickable, !this.isListElementClickable(index)).toString();
                };
                ProgressButtons.prototype.getScrollButtonCss = function(hasScroller, isLeftScroll) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.survey.css.progressButtonsImageButtonLeft, isLeftScroll).append(this.survey.css.progressButtonsImageButtonRight, !isLeftScroll).append(this.survey.css.progressButtonsImageButtonHidden, !hasScroller).toString();
                };
                ProgressButtons.prototype.clickListElement = function(element) {
                    if (!(element instanceof _page__WEBPACK_IMPORTED_MODULE_2__["PageModel"])) element = this.survey.visiblePages[element];
                    this.survey.tryNavigateToPage(element);
                };
                ProgressButtons.prototype.isListContainerHasScroller = function(element) {
                    var listContainerElement = element.querySelector("." + this.survey.css.progressButtonsListContainer);
                    if (!!listContainerElement) return listContainerElement.scrollWidth > listContainerElement.offsetWidth;
                    return false;
                };
                ProgressButtons.prototype.isCanShowItemTitles = function(element) {
                    var listContainerElement = element.querySelector("ul");
                    if (!listContainerElement || listContainerElement.children.length < 2) return true;
                    if (listContainerElement.clientWidth > listContainerElement.parentElement.clientWidth) return false;
                    var expectedElementWidth = listContainerElement.children[0].clientWidth;
                    for(var i = 0; i < listContainerElement.children.length; i++){
                        if (Math.abs(listContainerElement.children[i].clientWidth - expectedElementWidth) > 5) return false;
                    }
                    return true;
                };
                ProgressButtons.prototype.clearConnectorsWidth = function(element) {
                    var listContainerElements = element.querySelectorAll(".sd-progress-buttons__connector");
                    for(var i = 0; i < listContainerElements.length; i++)listContainerElements[i].style.width = "";
                };
                ProgressButtons.prototype.adjustConnectors = function(element) {
                    var listContainerElement = element.querySelector("ul");
                    if (!listContainerElement) return;
                    var listContainerElements = element.querySelectorAll(".sd-progress-buttons__connector");
                    var circleWidth = this.showItemNumbers ? 17 : 5;
                    var connectorWidth = listContainerElement.clientWidth / (listContainerElement.children.length - 1) - circleWidth;
                    for(var i = 0; i < listContainerElements.length; i++)listContainerElements[i].style.width = connectorWidth + "px";
                };
                Object.defineProperty(ProgressButtons.prototype, "isFitToSurveyWidth", {
                    get: function() {
                        if (_defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_1__["surveyCss"].currentType !== "defaultV2") return false;
                        return this.survey.progressBarInheritWidthFrom === "survey" && this.survey.widthMode == "static";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProgressButtons.prototype, "progressWidth", {
                    get: function() {
                        if (this.isFitToSurveyWidth) return this.survey.width;
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProgressButtons.prototype, "showItemNumbers", {
                    get: function() {
                        if (_defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_1__["surveyCss"].currentType !== "defaultV2") return false;
                        return this.survey.progressBarShowPageNumbers;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProgressButtons.prototype, "showItemTitles", {
                    get: function() {
                        if (_defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_1__["surveyCss"].currentType !== "defaultV2") return true;
                        return this.survey.progressBarShowPageTitles;
                    },
                    enumerable: false,
                    configurable: true
                });
                ProgressButtons.prototype.getItemNumber = function(page) {
                    var result = "";
                    if (this.showItemNumbers) result += this.survey.visiblePages.indexOf(page) + 1;
                    return result;
                };
                Object.defineProperty(ProgressButtons.prototype, "headerText", {
                    get: function() {
                        return this.survey.currentPage ? this.survey.currentPage.renderedNavigationTitle : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ProgressButtons.prototype, "footerText", {
                    get: function() {
                        return this.survey.progressText;
                    },
                    enumerable: false,
                    configurable: true
                });
                ProgressButtons.prototype.processResponsiveness = function(width) {
                    this.onResize.fire(this, {
                        width: width
                    });
                };
                return ProgressButtons;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            var ProgressButtonsResponsivityManager = /** @class */ function() {
                function ProgressButtonsResponsivityManager(model, element, viewModel) {
                    var _this = this;
                    this.model = model;
                    this.element = element;
                    this.viewModel = viewModel;
                    this.criticalProperties = [
                        "progressBarType",
                        "progressBarShowPageTitles"
                    ];
                    this.canShowItemTitles = true;
                    this.processResponsiveness = function(model, options) {
                        _this.viewModel.onUpdateScroller(model.isListContainerHasScroller(_this.element));
                        if (!model.showItemTitles) {
                            _this.model.adjustConnectors(_this.element);
                            return;
                        }
                        if (model.survey.isMobile) {
                            _this.prevWidth = options.width;
                            _this.canShowItemTitles = false;
                            _this.model.adjustConnectors(_this.element);
                            _this.viewModel.onResize(_this.canShowItemTitles);
                            return;
                        }
                        _this.model.clearConnectorsWidth(_this.element);
                        if (_this.timer !== undefined) clearTimeout(_this.timer);
                        _this.timer = setTimeout(function() {
                            if (_this.prevWidth === undefined || _this.prevWidth < options.width && !_this.canShowItemTitles || _this.prevWidth > options.width && _this.canShowItemTitles) {
                                _this.prevWidth = options.width;
                                _this.canShowItemTitles = model.isCanShowItemTitles(_this.element);
                                _this.viewModel.onResize(_this.canShowItemTitles);
                                _this.timer = undefined;
                            }
                        }, 10);
                    };
                    this.model.survey.registerFunctionOnPropertiesValueChanged(this.criticalProperties, function() {
                        return _this.forceUpdate();
                    }, "ProgressButtonsResponsivityManager" + this.viewModel.container);
                    this.model.onResize.add(this.processResponsiveness);
                    this.forceUpdate();
                }
                ProgressButtonsResponsivityManager.prototype.forceUpdate = function() {
                    this.viewModel.onUpdateSettings();
                    this.processResponsiveness(this.model, {});
                };
                ProgressButtonsResponsivityManager.prototype.dispose = function() {
                    clearTimeout(this.timer);
                    this.model.onResize.remove(this.processResponsiveness);
                    this.model.survey.unRegisterFunctionOnPropertiesValueChanged(this.criticalProperties, "ProgressButtonsResponsivityManager" + this.viewModel.container);
                    this.element = undefined;
                    this.model = undefined;
                };
                return ProgressButtonsResponsivityManager;
            }();
        /***/ },
        /***/ "./src/question.ts": /*!*************************!*\
  !*** ./src/question.ts ***!
  \*************************/ /*! exports provided: Question */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Question", function() {
                return Question;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _validator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./validator */ "./src/validator.ts");
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _questionCustomWidgets__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./questionCustomWidgets */ "./src/questionCustomWidgets.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _rendererFactory__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./rendererFactory */ "./src/rendererFactory.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./conditionProcessValue */ "./src/conditionProcessValue.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var TriggerExpressionInfo = /** @class */ function() {
                function TriggerExpressionInfo(name, canRun, doComplete) {
                    this.name = name;
                    this.canRun = canRun;
                    this.doComplete = doComplete;
                    this.runSecondCheck = function(keys) {
                        return false;
                    };
                }
                return TriggerExpressionInfo;
            }();
            /**
 * A base class for all questions.
 */ var Question = /** @class */ function(_super) {
                __extends(Question, _super);
                function Question(name) {
                    var _this = _super.call(this, name) || this;
                    _this.customWidgetData = {
                        isNeedRender: true
                    };
                    _this.hasCssErrorCallback = function() {
                        return false;
                    };
                    _this.isReadyValue = true;
                    _this.dependedQuestions = [];
                    /**
         * An event that is raised when the question's ready state has changed (expressions are evaluated, choices are loaded from a web resource specified by the `choicesByUrl` property, etc.).
         *
         * Parameters:
         *
         * - `sender`: `SurveyModel`\
         * A survey instance that contains the question whose ready state has changed.
         * - `options.isReady`: `boolean`\
         * Indicates whether the question is ready.
         * - `options.oldIsReady`: `boolean`\
         * Indicates the previous ready state.
         */ _this.onReadyChanged = _this.addEvent();
                    _this.triggersInfo = [];
                    _this.isRunningValidatorsValue = false;
                    _this.isValueChangedInSurvey = false;
                    _this.allowNotifyValueChanged = true;
                    _this.id = Question.getQuestionId();
                    _this.onCreating();
                    _this.createNewArray("validators", function(validator) {
                        validator.errorOwner = _this;
                    });
                    _this.addExpressionProperty("visibleIf", function(obj, res) {
                        _this.visible = res === true;
                    }, function(obj) {
                        return !_this.areInvisibleElementsShowing;
                    });
                    _this.addExpressionProperty("enableIf", function(obj, res) {
                        _this.readOnly = res === false;
                    });
                    _this.addExpressionProperty("requiredIf", function(obj, res) {
                        _this.isRequired = res === true;
                    });
                    _this.createLocalizableString("commentText", _this, true, "otherItemText");
                    _this.createLocalizableString("requiredErrorText", _this);
                    _this.addTriggerInfo("resetValueIf", function() {
                        return !_this.isEmpty();
                    }, function() {
                        _this.clearValue();
                        _this.updateValueWithDefaults();
                    });
                    var setValueIfInfo = _this.addTriggerInfo("setValueIf", function() {
                        return true;
                    }, function() {
                        return _this.runSetValueExpression();
                    });
                    setValueIfInfo.runSecondCheck = function(keys) {
                        return _this.checkExpressionIf(keys);
                    };
                    _this.registerPropertyChangedHandlers([
                        "width"
                    ], function() {
                        _this.updateQuestionCss();
                        if (!!_this.parent) _this.parent.elementWidthChanged(_this);
                    });
                    _this.registerPropertyChangedHandlers([
                        "isRequired"
                    ], function() {
                        if (!_this.isRequired && _this.errors.length > 0) _this.validate();
                        _this.locTitle.strChanged();
                        _this.clearCssClasses();
                    });
                    _this.registerPropertyChangedHandlers([
                        "indent",
                        "rightIndent"
                    ], function() {
                        _this.onIndentChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "showCommentArea",
                        "showOtherItem"
                    ], function() {
                        _this.initCommentFromSurvey();
                    });
                    _this.registerFunctionOnPropertiesValueChanged([
                        "no",
                        "readOnly",
                        "hasVisibleErrors",
                        "containsErrors"
                    ], function() {
                        _this.updateQuestionCss();
                    });
                    _this.registerPropertyChangedHandlers([
                        "isMobile"
                    ], function() {
                        _this.onMobileChanged();
                    });
                    return _this;
                }
                Question.getQuestionId = function() {
                    return "sq_" + Question.questionCounter++;
                };
                Question.prototype.isReadOnlyRenderDiv = function() {
                    return this.isReadOnly && _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].readOnly.commentRenderMode === "div";
                };
                Question.prototype.allowMobileInDesignMode = function() {
                    return false;
                };
                Question.prototype.updateIsMobileFromSurvey = function() {
                    this.setIsMobile(this.survey._isMobile);
                };
                Question.prototype.setIsMobile = function(val1) {
                    this.isMobile = val1 && (this.allowMobileInDesignMode() || !this.isDesignMode);
                };
                Question.prototype.themeChanged = function(theme) {};
                Question.prototype.getDefaultTitle = function() {
                    return this.name;
                };
                Question.prototype.createLocTitleProperty = function() {
                    var _this = this;
                    var locTitleValue = _super.prototype.createLocTitleProperty.call(this);
                    locTitleValue.storeDefaultText = true;
                    locTitleValue.onGetTextCallback = function(text) {
                        if (!text) text = _this.getDefaultTitle();
                        if (!_this.survey) return text;
                        return _this.survey.getUpdatedQuestionTitle(_this, text);
                    };
                    this.locProcessedTitle = new _localizablestring__WEBPACK_IMPORTED_MODULE_5__["LocalizableString"](this, true);
                    this.locProcessedTitle.sharedData = locTitleValue;
                    return locTitleValue;
                };
                Question.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    if (live) return !!this.parent ? this.parent.getSurvey(live) : null;
                    if (!!this.onGetSurvey) return this.onGetSurvey();
                    return _super.prototype.getSurvey.call(this);
                };
                Question.prototype.getValueName = function() {
                    if (!!this.valueName) return this.valueName.toString();
                    return this.name;
                };
                Object.defineProperty(Question.prototype, "valueName", {
                    /**
         * Specifies an object property that should store the question value.
         *
         * Refer to the [Merge Question Values](https://surveyjs.io/form-library/documentation/design-survey-merge-question-values) help topic for more information.
         */ get: function() {
                        return this.getPropertyValue("valueName", "");
                    },
                    set: function(val1) {
                        var oldValueName = this.getValueName();
                        this.setPropertyValue("valueName", val1);
                        this.onValueNameChanged(oldValueName);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.onValueNameChanged = function(oldValue) {
                    if (!this.survey) return;
                    this.survey.questionRenamed(this, this.name, !!oldValue ? oldValue : this.name);
                    this.initDataFromSurvey();
                };
                Question.prototype.onNameChanged = function(oldValue) {
                    this.locTitle.strChanged();
                    if (!this.survey) return;
                    this.survey.questionRenamed(this, oldValue, this.valueName ? this.valueName : oldValue);
                };
                Object.defineProperty(Question.prototype, "isReady", {
                    get: function() {
                        return this.isReadyValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.onAsyncRunningChanged = function() {
                    this.updateIsReady();
                };
                Question.prototype.updateIsReady = function() {
                    var res = this.getIsQuestionReady();
                    if (res) {
                        var questions = this.getIsReadyDependsOn();
                        for(var i = 0; i < questions.length; i++)if (!questions[i].getIsQuestionReady()) {
                            res = false;
                            break;
                        }
                    }
                    this.setIsReady(res);
                };
                Question.prototype.getIsQuestionReady = function() {
                    return !this.isAsyncExpressionRunning && this.getAreNestedQuestionsReady();
                };
                Question.prototype.getAreNestedQuestionsReady = function() {
                    var questions = this.getIsReadyNestedQuestions();
                    if (!Array.isArray(questions)) return true;
                    for(var i = 0; i < questions.length; i++){
                        if (!questions[i].isReady) return false;
                    }
                    return true;
                };
                Question.prototype.getIsReadyNestedQuestions = function() {
                    return this.getNestedQuestions();
                };
                Question.prototype.setIsReady = function(val1) {
                    var oldIsReady = this.isReadyValue;
                    this.isReadyValue = val1;
                    if (oldIsReady != val1) {
                        this.getIsReadyDependends().forEach(function(q) {
                            return q.updateIsReady();
                        });
                        this.onReadyChanged.fire(this, {
                            question: this,
                            isReady: val1,
                            oldIsReady: oldIsReady
                        });
                    }
                };
                Question.prototype.getIsReadyDependsOn = function() {
                    return this.getIsReadyDependendCore(true);
                };
                Question.prototype.getIsReadyDependends = function() {
                    return this.getIsReadyDependendCore(false);
                };
                Question.prototype.getIsReadyDependendCore = function(isDependOn) {
                    var _this = this;
                    if (!this.survey) return [];
                    var questions = this.survey.questionsByValueName(this.getValueName());
                    var res = new Array();
                    questions.forEach(function(q) {
                        if (q !== _this) res.push(q);
                    });
                    if (!isDependOn) {
                        if (this.parentQuestion) res.push(this.parentQuestion);
                        if (this.dependedQuestions.length > 0) this.dependedQuestions.forEach(function(q) {
                            return res.push(q);
                        });
                    }
                    return res;
                };
                Question.prototype.choicesLoaded = function() {};
                Object.defineProperty(Question.prototype, "page", {
                    /**
         * Returns a page to which the question belongs and allows you to move this question to a different page.
         */ get: function() {
                        if (!!this.parentQuestion) return this.parentQuestion.page;
                        return this.getPage(this.parent);
                    },
                    set: function(val1) {
                        this.setPage(this.parent, val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getPanel = function() {
                    return null;
                };
                Question.prototype.delete = function(doDispose) {
                    if (doDispose === void 0) doDispose = true;
                    this.removeFromParent();
                    if (doDispose) this.dispose();
                    else this.resetDependedQuestions();
                };
                Question.prototype.removeFromParent = function() {
                    if (!!this.parent) this.removeSelfFromList(this.parent.elements);
                };
                Question.prototype.addDependedQuestion = function(question) {
                    if (!question || this.dependedQuestions.indexOf(question) > -1) return;
                    this.dependedQuestions.push(question);
                };
                Question.prototype.removeDependedQuestion = function(question) {
                    if (!question) return;
                    var index = this.dependedQuestions.indexOf(question);
                    if (index > -1) this.dependedQuestions.splice(index, 1);
                };
                Question.prototype.updateDependedQuestions = function() {
                    for(var i = 0; i < this.dependedQuestions.length; i++)this.dependedQuestions[i].updateDependedQuestion();
                };
                Question.prototype.updateDependedQuestion = function() {};
                Question.prototype.resetDependedQuestion = function() {};
                Object.defineProperty(Question.prototype, "isFlowLayout", {
                    get: function() {
                        return this.getLayoutType() === "flow";
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getLayoutType = function() {
                    if (!!this.parent) return this.parent.getChildrenLayoutType();
                    return "row";
                };
                Question.prototype.isLayoutTypeSupported = function(layoutType) {
                    return layoutType !== "flow";
                };
                Object.defineProperty(Question.prototype, "visible", {
                    /**
         * Gets or sets question visibility.
         *
         * If you want to display or hide a question based on a condition, specify the [`visibleIf`](https://surveyjs.io/form-library/documentation/question#visibleIf) property. Refer to the following help topic for information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see isVisible
         * @see visibleIf
         */ get: function() {
                        return this.getPropertyValue("visible", true);
                    },
                    set: function(val1) {
                        if (val1 == this.visible) return;
                        this.setPropertyValue("visible", val1);
                        this.onVisibleChanged();
                        this.notifySurveyVisibilityChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.onVisibleChanged = function() {
                    this.updateIsVisibleProp();
                    if (!this.isVisible && this.errors && this.errors.length > 0) this.errors = [];
                };
                Question.prototype.notifyStateChanged = function(prevState) {
                    _super.prototype.notifyStateChanged.call(this, prevState);
                    if (this.isCollapsed) this.onHidingContent();
                };
                Question.prototype.updateIsVisibleProp = function() {
                    var prev = this.getPropertyValue("isVisible");
                    var val1 = this.isVisible;
                    if (prev !== val1) {
                        this.setPropertyValue("isVisible", val1);
                        if (!val1) this.onHidingContent();
                    }
                };
                Object.defineProperty(Question.prototype, "useDisplayValuesInDynamicTexts", {
                    /**
         * Specifies whether to use display names for question values in placeholders.
         *
         * Default value: `true`
         *
         * This property applies to questions whose values are defined as objects with the `value` and `text` properties (for example, [choice items](https://surveyjs.io/form-library/documentation/questionradiogroupmodel#choices) in Radiogroup, Checkbox, and Dropdown questions).
         *
         * You can use question values as placeholders in the following places:
         *
         * - Survey element titles and descriptions
         * - The [`html`](https://surveyjs.io/form-library/documentation/questionhtmlmodel#html) property of the [HTML](https://surveyjs.io/form-library/documentation/questionhtmlmodel) question
         *
         * To use a question value as a placeholder, specify the question `name` in curly brackets: `{questionName}`. Refer to the following help topic for more information: [Dynamic Texts - Question Values](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#question-values).
         */ get: function() {
                        return this.getPropertyValue("useDisplayValuesInDynamicTexts");
                    },
                    set: function(val1) {
                        this.setPropertyValue("useDisplayValuesInDynamicTexts", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getUseDisplayValuesInDynamicTexts = function() {
                    return this.useDisplayValuesInDynamicTexts;
                };
                Object.defineProperty(Question.prototype, "visibleIf", {
                    /**
         * A Boolean expression. If it evaluates to `false`, this question becomes hidden.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see visible
         * @see isVisible
         */ get: function() {
                        return this.getPropertyValue("visibleIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("visibleIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isVisible", {
                    /**
         * Returns `true` if the question is visible or the survey is currently in design mode.
         *
         * If you want to display or hide a question based on a condition, specify the [`visibleIf`](https://surveyjs.io/form-library/documentation/question#visibleIf) property. Refer to the following help topic for information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see visibleIf
         * @see visible
         * @see isParentVisible
         */ get: function() {
                        if (this.survey && this.survey.areEmptyElementsHidden && this.isEmpty()) return false;
                        if (this.areInvisibleElementsShowing) return true;
                        return this.isVisibleCore();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isVisibleInSurvey", {
                    get: function() {
                        return this.isVisible && this.isParentVisible;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.isVisibleCore = function() {
                    return this.visible;
                };
                Object.defineProperty(Question.prototype, "visibleIndex", {
                    /**
         * Returns the visible index of the question in the survey. It can be from 0 to all visible questions count - 1
         * The visibleIndex is -1 if the title is 'hidden' or hideNumber is true
         * @see titleLocation
         * @see hideNumber
         */ get: function() {
                        return this.getPropertyValue("visibleIndex", -1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.onHidingContent = function() {};
                Object.defineProperty(Question.prototype, "hideNumber", {
                    /**
         * Hides the question number from the title and excludes the question from numbering.
         *
         * If you want to disable question numbering in the entire survey, set `SurveyModel`'s `showQuestionNumbers` property to `false`.
         * @see SurveyModel.showQuestionNumbers
         */ get: function() {
                        return this.getPropertyValue("hideNumber");
                    },
                    set: function(val1) {
                        this.setPropertyValue("hideNumber", val1);
                        this.notifySurveyVisibilityChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isAllowTitleLeft", {
                    /**
         * Returns `true` if the question can display its title to the left of the input field.
         * @see titleLocation
         * @see getTitleLocation
         * @see hasTitle
         */ get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns the question type.
     * Possible values:
     * - [*"boolean"*](https://surveyjs.io/Documentation/Library?id=questionbooleanmodel)
     * - [*"checkbox"*](https://surveyjs.io/Documentation/Library?id=questioncheckboxmodel)
     * - [*"comment"*](https://surveyjs.io/Documentation/Library?id=questioncommentmodel)
     * - [*"dropdown"*](https://surveyjs.io/Documentation/Library?id=questiondropdownmodel)
     * - [*"tagbox"*](https://surveyjs.io/form-library/documentation/questiontagboxmodel)
     * - [*"expression"*](https://surveyjs.io/Documentation/Library?id=questionexpressionmodel)
     * - [*"file"*](https://surveyjs.io/Documentation/Library?id=questionfilemodel)
     * - [*"html"*](https://surveyjs.io/Documentation/Library?id=questionhtmlmodel)
     * - [*"image"*](https://surveyjs.io/Documentation/Library?id=questionimagemodel)
     * - [*"imagepicker"*](https://surveyjs.io/Documentation/Library?id=questionimagepickermodel)
     * - [*"matrix"*](https://surveyjs.io/Documentation/Library?id=questionmatrixmodel)
     * - [*"matrixdropdown"*](https://surveyjs.io/Documentation/Library?id=questionmatrixdropdownmodel)
     * - [*"matrixdynamic"*](https://surveyjs.io/Documentation/Library?id=questionmatrixdynamicmodel)
     * - [*"multipletext"*](https://surveyjs.io/Documentation/Library?id=questionmultipletextmodel)
     * - [*"panel"*](https://surveyjs.io/Documentation/Library?id=panelmodel)
     * - [*"paneldynamic"*](https://surveyjs.io/Documentation/Library?id=questionpaneldynamicmodel)
     * - [*"radiogroup"*](https://surveyjs.io/Documentation/Library?id=questionradiogroupmodel)
     * - [*"rating"*](https://surveyjs.io/Documentation/Library?id=questionratingmodel)
     * - [*"ranking"*](https://surveyjs.io/Documentation/Library?id=questionrankingmodel)
     * - [*"signaturepad"*](https://surveyjs.io/Documentation/Library?id=questionsignaturepadmodel)
     * - [*"text"*](https://surveyjs.io/Documentation/Library?id=questiontextmodel)
     */ Question.prototype.getType = function() {
                    return "question";
                };
                Object.defineProperty(Question.prototype, "isQuestion", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.moveTo = function(container, insertBefore) {
                    if (insertBefore === void 0) insertBefore = null;
                    return this.moveToBase(this.parent, container, insertBefore);
                };
                Question.prototype.getProgressInfo = function() {
                    if (!this.hasInput) return _super.prototype.getProgressInfo.call(this);
                    return {
                        questionCount: 1,
                        answeredQuestionCount: !this.isEmpty() ? 1 : 0,
                        requiredQuestionCount: this.isRequired ? 1 : 0,
                        requiredAnsweredQuestionCount: !this.isEmpty() && this.isRequired ? 1 : 0
                    };
                };
                Question.prototype.ensureSetValueExpressionRunner = function() {
                    var _this = this;
                    if (!this.setValueExpressionRunner) {
                        this.setValueExpressionRunner = new _conditions__WEBPACK_IMPORTED_MODULE_6__["ExpressionRunner"](this.setValueExpression);
                        this.setValueExpressionRunner.onRunComplete = function(res) {
                            if (!_this.isTwoValueEquals(_this.value, res)) _this.value = res;
                        };
                    } else this.setValueExpressionRunner.expression = this.setValueExpression;
                };
                Question.prototype.runSetValueExpression = function() {
                    if (!this.setValueExpression) this.clearValue();
                    else {
                        this.ensureSetValueExpressionRunner();
                        this.setValueExpressionRunner.run(this.getDataFilteredValues(), this.getDataFilteredProperties());
                    }
                };
                Question.prototype.checkExpressionIf = function(keys) {
                    this.ensureSetValueExpressionRunner();
                    if (!this.setValueExpressionRunner) return false;
                    return new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_13__["ProcessValue"]().isAnyKeyChanged(keys, this.setValueExpressionRunner.getVariables());
                };
                Question.prototype.addTriggerInfo = function(name, canRun, doComplete) {
                    var info = new TriggerExpressionInfo(name, canRun, doComplete);
                    this.triggersInfo.push(info);
                    return info;
                };
                Question.prototype.runTriggerInfo = function(info, name, value) {
                    var expression = this[info.name];
                    var keys = {};
                    keys[name] = value;
                    if (!expression || info.isRunning || !info.canRun()) {
                        if (info.runSecondCheck(keys)) info.doComplete();
                        return;
                    }
                    if (!info.runner) {
                        info.runner = new _conditions__WEBPACK_IMPORTED_MODULE_6__["ExpressionRunner"](expression);
                        info.runner.onRunComplete = function(res) {
                            if (res === true) info.doComplete();
                            info.isRunning = false;
                        };
                    } else info.runner.expression = expression;
                    if (!new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_13__["ProcessValue"]().isAnyKeyChanged(keys, info.runner.getVariables()) && !info.runSecondCheck(keys)) return;
                    info.isRunning = true;
                    info.runner.run(this.getDataFilteredValues(), this.getDataFilteredProperties());
                };
                Question.prototype.runTriggers = function(name, value) {
                    var _this = this;
                    if (this.isReadOnly || this.isSettingQuestionValue || this.parentQuestion && this.parentQuestion.getValueName() === name) return;
                    this.triggersInfo.forEach(function(info) {
                        _this.runTriggerInfo(info, name, value);
                    });
                };
                Question.prototype.runConditions = function() {
                    if (this.data && !this.isLoadingFromJson) {
                        if (!this.isDesignMode) this.runCondition(this.getDataFilteredValues(), this.getDataFilteredProperties());
                        this.locStrsChanged();
                    }
                };
                Question.prototype.setSurveyImpl = function(value, isLight) {
                    _super.prototype.setSurveyImpl.call(this, value);
                    if (!this.survey) return;
                    this.survey.questionCreated(this);
                    if (isLight !== true) this.runConditions();
                    this.calcRenderedCommentPlaceholder();
                    if (!this.visible) this.updateIsVisibleProp();
                    this.updateIsMobileFromSurvey();
                };
                Object.defineProperty(Question.prototype, "parent", {
                    /**
         * Returns a survey element (panel or page) that contains the question and allows you to move this question to a different survey element.
         */ get: function() {
                        return this.getPropertyValue("parent", null);
                    },
                    set: function(val1) {
                        if (this.parent === val1) return;
                        this.removeFromParent();
                        this.setPropertyValue("parent", val1);
                        this.updateQuestionCss();
                        this.onParentChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.onParentChanged = function() {};
                Object.defineProperty(Question.prototype, "hasTitle", {
                    /**
         * Returns `false` if the `titleLocation` property is set to `"hidden"` or if the question cannot have a title (for example, an [HTML](https://surveyjs.io/form-library/documentation/questionhtmlmodel) question).
         *
         * If the `title` property is `undefined` or set to an empty string, the `hasTitle` property returns `true`, because the question uses its `name` as a title in this case.
         * @see title
         * @see titleLocation
         */ get: function() {
                        return this.getTitleLocation() !== "hidden";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "titleLocation", {
                    /**
         * Sets question title location relative to the input field. Overrides the `questionTitleLocation` property specified for the question's container (survey, page, or panel).
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the `questionTitleLocation` property specified for the question's container.
         * - `"top"` - Displays the title above the input field.
         * - `"bottom"` - Displays the title below the input field.
         * - `"left"` - Displays the title to the left of the input field.
         * - `"hidden"` - Hides the question title.
         *
         * > Certain question types (Matrix, Multiple Text) do not support the `"left"` value. For them, the `"top"` value is used.
         * @see SurveyModel.questionTitleLocation
         * @see getTitleLocation
         * @see isAllowTitleLeft
         */ get: function() {
                        return this.getPropertyValue("titleLocation");
                    },
                    set: function(value) {
                        var isVisibilityChanged = this.titleLocation == "hidden" || value == "hidden";
                        this.setPropertyValue("titleLocation", value.toLowerCase());
                        this.updateQuestionCss();
                        if (isVisibilityChanged) this.notifySurveyVisibilityChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getTitleOwner = function() {
                    return this;
                };
                Question.prototype.getIsTitleRenderedAsString = function() {
                    return this.titleLocation === "hidden";
                };
                Question.prototype.notifySurveyVisibilityChanged = function() {
                    if (!this.survey || this.isLoadingFromJson) return;
                    this.survey.questionVisibilityChanged(this, this.isVisible);
                    var isClearOnHidden = this.isClearValueOnHidden;
                    if (!this.visible) this.clearValueOnHidding(isClearOnHidden);
                    if (isClearOnHidden && this.isVisibleInSurvey) this.updateValueWithDefaults();
                };
                Question.prototype.clearValueOnHidding = function(isClearOnHidden) {
                    if (isClearOnHidden) this.clearValueIfInvisible();
                };
                /**
     * Returns title location calculated based on the question's `titleLocation` property and the `questionTitleLocation` property of the question's containers (survey, page, or panel).
     * @see titleLocation
     * @see SurveyModel.questionTitleLocation
     */ Question.prototype.getTitleLocation = function() {
                    if (this.isFlowLayout) return "hidden";
                    var location = this.getTitleLocationCore();
                    if (location === "left" && !this.isAllowTitleLeft) location = "top";
                    return location;
                };
                Question.prototype.getTitleLocationCore = function() {
                    if (this.titleLocation !== "default") return this.titleLocation;
                    if (!!this.parent) return this.parent.getQuestionTitleLocation();
                    if (!!this.survey) return this.survey.questionTitleLocation;
                    return "top";
                };
                Object.defineProperty(Question.prototype, "hasTitleOnLeft", {
                    get: function() {
                        return this.hasTitle && this.getTitleLocation() === "left";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasTitleOnTop", {
                    get: function() {
                        return this.hasTitle && this.getTitleLocation() === "top";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasTitleOnBottom", {
                    get: function() {
                        return this.hasTitle && this.getTitleLocation() === "bottom";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasTitleOnLeftTop", {
                    get: function() {
                        if (!this.hasTitle) return false;
                        var location = this.getTitleLocation();
                        return location === "left" || location === "top";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "errorLocation", {
                    /**
         * Specifies the error message position. Overrides the `questionErrorLocation` property specified for the question's container ([survey](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#questionErrorLocation), [page](https://surveyjs.io/form-library/documentation/api-reference/page-model#questionErrorLocation), or [panel](https://surveyjs.io/form-library/documentation/api-reference/panel-model#questionErrorLocation)).
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the `questionErrorLocation` property specified for the question's container.
         * - `"top"` - Displays error messages above questions.
         * - `"bottom"` - Displays error messages below questions.
         */ get: function() {
                        return this.getPropertyValue("errorLocation");
                    },
                    set: function(val1) {
                        this.setPropertyValue("errorLocation", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getErrorLocation = function() {
                    if (this.errorLocation !== "default") return this.errorLocation;
                    if (this.parentQuestion) return this.parentQuestion.getChildErrorLocation(this);
                    if (this.parent) return this.parent.getQuestionErrorLocation();
                    return this.survey ? this.survey.questionErrorLocation : "top";
                };
                Question.prototype.getChildErrorLocation = function(child) {
                    return this.getErrorLocation();
                };
                Object.defineProperty(Question.prototype, "hasInput", {
                    /**
         * Returns `false` if the question has no input fields ([HTML](https://surveyjs.io/form-library/documentation/questionhtmlmodel), [Image](https://surveyjs.io/form-library/documentation/questionimagemodel), and similar question types).
         * @see hasSingleInput
         */ get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasSingleInput", {
                    /**
         * Returns `false` if the question has no input fields ([HTML](https://surveyjs.io/form-library/documentation/questionhtmlmodel), [Image](https://surveyjs.io/form-library/documentation/questionimagemodel)) or has multiple input fields ([Matrix](https://surveyjs.io/form-library/documentation/questionmatrixmodel), [Multiple Text](https://surveyjs.io/form-library/documentation/questionmultipletextmodel)).
         * @see hasInput
         */ get: function() {
                        return this.hasInput;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "inputId", {
                    get: function() {
                        return this.id + "i";
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getDefaultTitleValue = function() {
                    return this.name;
                };
                Question.prototype.getDefaultTitleTagName = function() {
                    return _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].titleTags.question;
                };
                Object.defineProperty(Question.prototype, "descriptionLocation", {
                    /**
         * Specifies where to display a question description.
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the Survey's [`questionDescriptionLocation`](https://surveyjs.io/form-library/documentation/surveymodel#questionDescriptionLocation) property.
         * - `"underTitle"` - Displays the description under the question title.
         * - `"underInput"` - Displays the description under the interactive area.
         * @see description
         * @see hasDescription
         */ get: function() {
                        return this.getPropertyValue("descriptionLocation");
                    },
                    set: function(val1) {
                        this.setPropertyValue("descriptionLocation", val1);
                        this.updateQuestionCss();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasDescriptionUnderTitle", {
                    get: function() {
                        return this.getDescriptionLocation() == "underTitle" && this.hasDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasDescriptionUnderInput", {
                    get: function() {
                        return this.getDescriptionLocation() == "underInput" && this.hasDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getDescriptionLocation = function() {
                    if (this.descriptionLocation !== "default") return this.descriptionLocation;
                    return !!this.survey ? this.survey.questionDescriptionLocation : "underTitle";
                };
                Question.prototype.needClickTitleFunction = function() {
                    return _super.prototype.needClickTitleFunction.call(this) || this.hasInput;
                };
                Question.prototype.processTitleClick = function() {
                    var _this = this;
                    _super.prototype.processTitleClick.call(this);
                    if (this.isCollapsed) return;
                    setTimeout(function() {
                        _this.focus();
                    }, 1);
                    return true;
                };
                Object.defineProperty(Question.prototype, "requiredErrorText", {
                    /**
         * Specifies a custom error message for a required form field.
         * @see isRequired
         */ get: function() {
                        return this.getLocalizableStringText("requiredErrorText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("requiredErrorText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "locRequiredErrorText", {
                    get: function() {
                        return this.getLocalizableString("requiredErrorText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "commentText", {
                    /**
         * Specifies a caption displayed above the comment area. Applies when the `showCommentArea` property is `true`.
         * @see showCommentArea
         * @see comment
         */ get: function() {
                        return this.getLocalizableStringText("commentText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("commentText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "locCommentText", {
                    get: function() {
                        return this.getLocalizableString("commentText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "commentPlaceHolder", {
                    get: function() {
                        return this.commentPlaceholder;
                    },
                    set: function(newValue) {
                        this.commentPlaceholder = newValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "renderedCommentPlaceholder", {
                    get: function() {
                        return this.getPropertyValue("renderedCommentPlaceholder");
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.calcRenderedCommentPlaceholder = function() {
                    var res = !this.isReadOnly ? this.commentPlaceHolder : undefined;
                    this.setPropertyValue("renderedCommentPlaceholder", res);
                };
                Question.prototype.getAllErrors = function() {
                    return this.errors.slice();
                };
                Question.prototype.getErrorByType = function(errorType) {
                    for(var i = 0; i < this.errors.length; i++){
                        if (this.errors[i].getErrorType() === errorType) return this.errors[i];
                    }
                    return null;
                };
                Object.defineProperty(Question.prototype, "customWidget", {
                    get: function() {
                        if (!this.isCustomWidgetRequested && !this.customWidgetValue) {
                            this.isCustomWidgetRequested = true;
                            this.updateCustomWidget();
                        }
                        return this.customWidgetValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.updateCustomWidget = function() {
                    this.customWidgetValue = _questionCustomWidgets__WEBPACK_IMPORTED_MODULE_7__["CustomWidgetCollection"].Instance.getCustomWidget(this);
                };
                Question.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    this.calcRenderedCommentPlaceholder();
                    if (!!this.localeChangedCallback) this.localeChangedCallback();
                };
                Object.defineProperty(Question.prototype, "isCompositeQuestion", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isContainer", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.updateCommentElements = function() {
                    if (!this.autoGrowComment || !Array.isArray(this.commentElements)) return;
                    for(var i = 0; i < this.commentElements.length; i++){
                        var el = this.commentElements[i];
                        if (el) Object(_utils_utils__WEBPACK_IMPORTED_MODULE_11__["increaseHeightByContent"])(el);
                    }
                };
                Question.prototype.onCommentInput = function(event1) {
                    if (this.isInputTextUpdate) {
                        if (event1.target) this.comment = event1.target.value;
                    } else this.updateCommentElements();
                };
                Question.prototype.onCommentChange = function(event1) {
                    this.comment = event1.target.value;
                    if (this.comment !== event1.target.value) event1.target.value = this.comment;
                };
                Question.prototype.afterRenderQuestionElement = function(el) {
                    if (!this.survey || !this.hasSingleInput) return;
                    this.survey.afterRenderQuestionInput(this, el);
                };
                Question.prototype.afterRender = function(el) {
                    var _this = this;
                    this.afterRenderCore(el);
                    if (!this.survey) return;
                    this.survey.afterRenderQuestion(this, el);
                    if (!!this.afterRenderQuestionCallback) this.afterRenderQuestionCallback(this, el);
                    if (this.supportComment() || this.supportOther()) {
                        this.commentElements = [];
                        this.getCommentElementsId().forEach(function(id) {
                            var root = _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].environment.root;
                            var el = root.getElementById(id);
                            if (el) _this.commentElements.push(el);
                        });
                        this.updateCommentElements();
                    }
                    this.checkForResponsiveness(el);
                };
                Question.prototype.afterRenderCore = function(el) {};
                Question.prototype.getCommentElementsId = function() {
                    return [
                        this.commentId
                    ];
                };
                Question.prototype.beforeDestroyQuestionElement = function(el) {
                    this.commentElements = undefined;
                };
                Object.defineProperty(Question.prototype, "processedTitle", {
                    get: function() {
                        var res = this.locProcessedTitle.textOrHtml;
                        return res ? res : this.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "fullTitle", {
                    get: function() {
                        return this.locTitle.renderedHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "titlePattern", {
                    get: function() {
                        return !!this.survey ? this.survey.questionTitlePattern : "numTitleRequire";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isRequireTextOnStart", {
                    get: function() {
                        return this.isRequired && this.titlePattern == "requireNumTitle";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isRequireTextBeforeTitle", {
                    get: function() {
                        return this.isRequired && this.titlePattern == "numRequireTitle" && this.requiredText !== "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isRequireTextAfterTitle", {
                    get: function() {
                        return this.isRequired && this.titlePattern == "numTitleRequire" && this.requiredText !== "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "startWithNewLine", {
                    /**
         * Disable this property if you want to render the current question on the same line or row with the previous question or panel.
         */ get: function() {
                        return this.getPropertyValue("startWithNewLine");
                    },
                    set: function(val1) {
                        if (this.startWithNewLine == val1) return;
                        this.setPropertyValue("startWithNewLine", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.calcCssClasses = function(css) {
                    var classes = {
                        error: {}
                    };
                    this.copyCssClasses(classes, css.question);
                    this.copyCssClasses(classes.error, css.error);
                    this.updateCssClasses(classes, css);
                    if (this.survey) this.survey.updateQuestionCssClasses(this, classes);
                    if (this.onUpdateCssClassesCallback) this.onUpdateCssClassesCallback(classes);
                    return classes;
                };
                Object.defineProperty(Question.prototype, "cssRoot", {
                    get: function() {
                        this.ensureElementCss();
                        return this.getPropertyValue("cssRoot", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.setCssRoot = function(val1) {
                    this.setPropertyValue("cssRoot", val1);
                };
                Question.prototype.getCssRoot = function(cssClasses) {
                    var hasError = this.hasCssError();
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(_super.prototype.getCssRoot.call(this, cssClasses)).append(this.isFlowLayout && !this.isDesignMode ? cssClasses.flowRoot : cssClasses.mainRoot).append(cssClasses.titleLeftRoot, !this.isFlowLayout && this.hasTitleOnLeft).append(cssClasses.titleTopRoot, !this.isFlowLayout && this.hasTitleOnTop).append(cssClasses.titleBottomRoot, !this.isFlowLayout && this.hasTitleOnBottom).append(cssClasses.descriptionUnderInputRoot, !this.isFlowLayout && this.hasDescriptionUnderInput).append(cssClasses.hasError, hasError).append(cssClasses.hasErrorTop, hasError && this.getErrorLocation() == "top").append(cssClasses.hasErrorBottom, hasError && this.getErrorLocation() == "bottom").append(cssClasses.small, !this.width).append(cssClasses.answered, this.isAnswered).toString();
                };
                Object.defineProperty(Question.prototype, "cssHeader", {
                    get: function() {
                        this.ensureElementCss();
                        return this.getPropertyValue("cssHeader", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.setCssHeader = function(val1) {
                    this.setPropertyValue("cssHeader", val1);
                };
                Question.prototype.getCssHeader = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(cssClasses.header).append(cssClasses.headerTop, this.hasTitleOnTop).append(cssClasses.headerLeft, this.hasTitleOnLeft).append(cssClasses.headerBottom, this.hasTitleOnBottom).toString();
                };
                Question.prototype.supportContainerQueries = function() {
                    return false;
                };
                Object.defineProperty(Question.prototype, "cssContent", {
                    get: function() {
                        this.ensureElementCss();
                        return this.getPropertyValue("cssContent", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.setCssContent = function(val1) {
                    this.setPropertyValue("cssContent", val1);
                };
                Question.prototype.getCssContent = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(cssClasses.content).append(cssClasses.contentSupportContainerQueries, this.supportContainerQueries()).append(cssClasses.contentLeft, this.hasTitleOnLeft).toString();
                };
                Object.defineProperty(Question.prototype, "cssTitle", {
                    get: function() {
                        this.ensureElementCss();
                        return this.getPropertyValue("cssTitle", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.setCssTitle = function(val1) {
                    this.setPropertyValue("cssTitle", val1);
                };
                Question.prototype.getCssTitle = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(_super.prototype.getCssTitle.call(this, cssClasses)).append(cssClasses.titleOnAnswer, !this.containsErrors && this.isAnswered).append(cssClasses.titleEmpty, !this.title.trim()).toString();
                };
                Object.defineProperty(Question.prototype, "cssDescription", {
                    get: function() {
                        this.ensureElementCss();
                        return this.getPropertyValue("cssDescription", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.setCssDescription = function(val1) {
                    this.setPropertyValue("cssDescription", val1);
                };
                Question.prototype.getCssDescription = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(cssClasses.description, this.hasDescriptionUnderTitle).append(cssClasses.descriptionUnderInput, this.hasDescriptionUnderInput).toString();
                };
                Question.prototype.showErrorOnCore = function(location) {
                    return !this.showErrorsAboveQuestion && !this.showErrorsBelowQuestion && this.getErrorLocation() === location;
                };
                Object.defineProperty(Question.prototype, "showErrorOnTop", {
                    get: function() {
                        return this.showErrorOnCore("top");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "showErrorOnBottom", {
                    get: function() {
                        return this.showErrorOnCore("bottom");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "showErrorsOutsideQuestion", {
                    get: function() {
                        return this.isDefaultV2Theme;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "showErrorsAboveQuestion", {
                    get: function() {
                        return this.showErrorsOutsideQuestion && this.getErrorLocation() === "top";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "showErrorsBelowQuestion", {
                    get: function() {
                        return this.showErrorsOutsideQuestion && this.getErrorLocation() === "bottom";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "cssError", {
                    get: function() {
                        this.ensureElementCss();
                        return this.getPropertyValue("cssError", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.setCssError = function(val1) {
                    this.setPropertyValue("cssError", val1);
                };
                Question.prototype.getCssError = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(cssClasses.error.root).append(cssClasses.errorsContainer, this.showErrorsBelowQuestion || this.showErrorsAboveQuestion).append(cssClasses.errorsContainerTop, this.showErrorsAboveQuestion).append(cssClasses.errorsContainerBottom, this.showErrorsBelowQuestion).append(cssClasses.error.locationTop, this.showErrorOnTop).append(cssClasses.error.locationBottom, this.showErrorOnBottom).toString();
                };
                Question.prototype.hasCssError = function() {
                    return this.errors.length > 0 || this.hasCssErrorCallback();
                };
                Question.prototype.getRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssRoot).append(this.cssClasses.disabled, this.isReadOnly).append(this.cssClasses.invisible, !this.isDesignMode && this.areInvisibleElementsShowing && !this.visible).toString();
                };
                Question.prototype.getQuestionRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.root).append(this.cssClasses.rootMobile, this.isMobile).toString();
                };
                Question.prototype.updateElementCss = function(reNew) {
                    _super.prototype.updateElementCss.call(this, reNew);
                    if (reNew) this.updateQuestionCss(true);
                    this.onIndentChanged();
                };
                Question.prototype.updateQuestionCss = function(reNew) {
                    if (this.isLoadingFromJson || !this.survey || reNew !== true && !this.cssClassesValue) return;
                    this.updateElementCssCore(this.cssClasses);
                };
                Question.prototype.ensureElementCss = function() {
                    if (!this.cssClassesValue) this.updateQuestionCss(true);
                };
                Question.prototype.updateElementCssCore = function(cssClasses) {
                    this.setCssRoot(this.getCssRoot(cssClasses));
                    this.setCssHeader(this.getCssHeader(cssClasses));
                    this.setCssContent(this.getCssContent(cssClasses));
                    this.setCssTitle(this.getCssTitle(cssClasses));
                    this.setCssDescription(this.getCssDescription(cssClasses));
                    this.setCssError(this.getCssError(cssClasses));
                };
                Question.prototype.updateCssClasses = function(res, css) {
                    if (!css.question) return;
                    var objCss = css[this.getCssType()];
                    var titleBuilder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(res.title).append(css.question.titleRequired, this.isRequired);
                    res.title = titleBuilder.toString();
                    var rootBuilder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(res.root).append(objCss, this.isRequired && !!css.question.required);
                    if (objCss === undefined || objCss === null) res.root = rootBuilder.toString();
                    else if (typeof objCss === "string" || objCss instanceof String) res.root = rootBuilder.append(objCss.toString()).toString();
                    else {
                        res.root = rootBuilder.toString();
                        for(var key in objCss)res[key] = objCss[key];
                    }
                };
                Question.prototype.getCssType = function() {
                    return this.getType();
                };
                Object.defineProperty(Question.prototype, "renderCssRoot", {
                    get: function() {
                        return this.cssClasses.root || undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.onIndentChanged = function() {
                    this.paddingLeft = this.getIndentSize(this.indent);
                    this.paddingRight = this.getIndentSize(this.rightIndent);
                };
                Question.prototype.getIndentSize = function(indent) {
                    if (indent < 1 || !this.getSurvey() || !this.cssClasses || !this.cssClasses.indent) return "";
                    return indent * this.cssClasses.indent + "px";
                };
                /**
     * Moves focus to the input field of this question.
     * @param onError Pass `true` if you want to focus an input field with the first validation error. Default value: `false` (focuses the first input field). Applies to question types with multiple input fields.
     */ Question.prototype.focus = function(onError, scrollIfVisible) {
                    if (onError === void 0) onError = false;
                    if (this.isDesignMode || !this.isVisible || !this.survey) return;
                    var page = this.page;
                    var shouldChangePage = !!page && this.survey.activePage !== page;
                    if (shouldChangePage) this.survey.focusQuestionByInstance(this, onError);
                    else this.focuscore(onError, scrollIfVisible);
                };
                Question.prototype.focuscore = function(onError, scrollIfVisible) {
                    if (onError === void 0) onError = false;
                    if (!!this.survey) {
                        this.expandAllParents(this);
                        this.survey.scrollElementToTop(this, this, null, this.id, scrollIfVisible);
                    }
                    var id = !onError ? this.getFirstInputElementId() : this.getFirstErrorInputElementId();
                    if (_survey_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElement"].FocusElement(id)) this.fireCallback(this.focusCallback);
                };
                Question.prototype.expandAllParents = function(element) {
                    if (!element) return;
                    if (element.isCollapsed) element.expand();
                    this.expandAllParents(element.parent);
                    this.expandAllParents(element.parentQuestion);
                };
                Question.prototype.focusIn = function() {
                    if (!this.survey || this.isDisposed || this.isContainer) return;
                    this.survey.whenQuestionFocusIn(this);
                };
                Question.prototype.fireCallback = function(callback) {
                    if (callback) callback();
                };
                Question.prototype.getOthersMaxLength = function() {
                    if (!this.survey) return null;
                    return this.survey.maxOthersLength > 0 ? this.survey.maxOthersLength : null;
                };
                Question.prototype.onCreating = function() {};
                Question.prototype.getFirstQuestionToFocus = function(withError) {
                    return this.hasInput && (!withError || this.currentErrorCount > 0) ? this : null;
                };
                Question.prototype.getFirstInputElementId = function() {
                    return this.inputId;
                };
                Question.prototype.getFirstErrorInputElementId = function() {
                    return this.getFirstInputElementId();
                };
                Question.prototype.getProcessedTextValue = function(textValue) {
                    var name = textValue.name.toLocaleLowerCase();
                    textValue.isExists = Object.keys(Question.TextPreprocessorValuesMap).indexOf(name) !== -1 || this[textValue.name] !== undefined;
                    textValue.value = this[Question.TextPreprocessorValuesMap[name] || textValue.name];
                };
                Question.prototype.supportComment = function() {
                    var prop = this.getPropertyByName("showCommentArea");
                    return !prop || prop.visible;
                };
                Question.prototype.supportOther = function() {
                    return false;
                };
                Object.defineProperty(Question.prototype, "isRequired", {
                    /**
         * Makes the question required. If a respondent skips a required question, the survey displays a validation error.
         * @see requiredIf
         * @see [Data Validation](https://surveyjs.io/form-library/documentation/data-validation)
         */ get: function() {
                        return this.getPropertyValue("isRequired");
                    },
                    set: function(val1) {
                        this.setPropertyValue("isRequired", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "requiredIf", {
                    /**
         * A Boolean expression. If it evaluates to `true`, this question becomes required.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see isRequired
         */ get: function() {
                        return this.getPropertyValue("requiredIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("requiredIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "showCommentArea", {
                    /**
         * Specifies whether to display a comment area. Incompatible with the `showOtherItem` property.
         * @see comment
         * @see commentText
         * @see showOtherItem
         */ get: function() {
                        return this.getPropertyValue("showCommentArea", false);
                    },
                    set: function(val1) {
                        if (!this.supportComment()) return;
                        this.setPropertyValue("showCommentArea", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasComment", {
                    get: function() {
                        return this.showCommentArea;
                    },
                    set: function(val1) {
                        this.showCommentArea = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "id", {
                    /**
         * A value to assign to the `id` attribute of the rendered HTML element. A default `id` is generated automatically.
         */ get: function() {
                        return this.getPropertyValue("id");
                    },
                    set: function(val1) {
                        this.setPropertyValue("id", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaTitleId", {
                    get: function() {
                        return this.id + "_ariaTitle";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaDescriptionId", {
                    get: function() {
                        return this.id + "_ariaDescription";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "commentId", {
                    get: function() {
                        return this.id + "_comment";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "showOtherItem", {
                    /**
         * Specifies whether to display the "Other" choice item. Incompatible with the `showCommentArea` property.
         *
         * @see otherText
         * @see otherItem
         * @see otherErrorText
         * @see showCommentArea
         * @see [settings.specialChoicesOrder](https://surveyjs.io/form-library/documentation/api-reference/settings#specialChoicesOrder)
         */ get: function() {
                        return this.getPropertyValue("showOtherItem", false);
                    },
                    set: function(val1) {
                        if (!this.supportOther() || this.showOtherItem == val1) return;
                        this.setPropertyValue("showOtherItem", val1);
                        this.hasOtherChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasOther", {
                    get: function() {
                        return this.showOtherItem;
                    },
                    set: function(val1) {
                        this.showOtherItem = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.hasOtherChanged = function() {};
                Object.defineProperty(Question.prototype, "requireUpdateCommentValue", {
                    get: function() {
                        return this.hasComment || this.hasOther;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isReadOnly", {
                    get: function() {
                        var isParentReadOnly = !!this.parent && this.parent.isReadOnly;
                        var isPareQuestionReadOnly = !!this.parentQuestion && this.parentQuestion.isReadOnly;
                        var isSurveyReadOnly = !!this.survey && this.survey.isDisplayMode;
                        return this.readOnly || isParentReadOnly || isSurveyReadOnly || isPareQuestionReadOnly;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isInputReadOnly", {
                    get: function() {
                        if (this.forceIsInputReadOnly !== undefined) return this.forceIsInputReadOnly;
                        return this.isReadOnly || this.isDesignModeV2;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "renderedInputReadOnly", {
                    get: function() {
                        return this.isInputReadOnly ? "" : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "renderedInputDisabled", {
                    get: function() {
                        return this.isInputReadOnly ? "" : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.onReadOnlyChanged = function() {
                    this.setPropertyValue("isInputReadOnly", this.isInputReadOnly);
                    _super.prototype.onReadOnlyChanged.call(this);
                    if (this.isReadOnly) this.clearErrors();
                    this.updateQuestionCss();
                    this.calcRenderedCommentPlaceholder();
                };
                Object.defineProperty(Question.prototype, "enableIf", {
                    /**
         * A Boolean expression. If it evaluates to `false`, this question becomes read-only.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see readOnly
         * @see isReadOnly
         */ get: function() {
                        return this.getPropertyValue("enableIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("enableIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.surveyChoiceItemVisibilityChange = function() {};
                Question.prototype.runCondition = function(values, properties) {
                    if (this.isDesignMode) return;
                    if (!properties) properties = {};
                    properties["question"] = this;
                    this.runConditionCore(values, properties);
                    if (!this.isValueChangedDirectly && (!this.isClearValueOnHidden || this.isVisibleInSurvey)) {
                        this.defaultValueRunner = this.getDefaultRunner(this.defaultValueRunner, this.defaultValueExpression);
                        this.runDefaultValueExpression(this.defaultValueRunner, values, properties);
                    }
                };
                Object.defineProperty(Question.prototype, "no", {
                    /**
         * A question number or letter (depends on the `questionStartIndex` property of the question container (panel, page, or survey)).
         *
         * When the question number, title, or the entire question is invisible, this property returns an empty string.
         * @see SurveyModel.questionStartIndex
         * @see hideNumber
         * @see titleLocation
         * @see visibleIf
         */ get: function() {
                        return this.getPropertyValue("no");
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.calcNo = function() {
                    if (!this.hasTitle || this.hideNumber) return "";
                    var no = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].getNumberByIndex(this.visibleIndex, this.getStartIndex());
                    if (!!this.survey) no = this.survey.getUpdatedQuestionNo(this, no);
                    return no;
                };
                Question.prototype.getStartIndex = function() {
                    if (!!this.parent) return this.parent.getQuestionStartIndex();
                    if (!!this.survey) return this.survey.questionStartIndex;
                    return "";
                };
                Question.prototype.onSurveyLoad = function() {
                    this.isCustomWidgetRequested = false;
                    this.fireCallback(this.surveyLoadCallback);
                    this.updateValueWithDefaults();
                    if (this.isEmpty()) this.initDataFromSurvey();
                    this.calcRenderedCommentPlaceholder();
                    this.onIndentChanged();
                };
                Question.prototype.onSetData = function() {
                    _super.prototype.onSetData.call(this);
                    if (!this.survey) return;
                    this.initDataFromSurvey();
                    this.onSurveyValueChanged(this.value);
                    this.updateValueWithDefaults();
                    this.onIndentChanged();
                    this.updateQuestionCss();
                    this.updateIsAnswered();
                };
                Question.prototype.initDataFromSurvey = function() {
                    if (!!this.data) {
                        var val1 = this.data.getValue(this.getValueName());
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(val1) || !this.isLoadingFromJson) this.updateValueFromSurvey(val1);
                        this.initCommentFromSurvey();
                    }
                };
                Question.prototype.initCommentFromSurvey = function() {
                    if (!!this.data && this.requireUpdateCommentValue) this.updateCommentFromSurvey(this.data.getComment(this.getValueName()));
                    else this.updateCommentFromSurvey("");
                };
                Question.prototype.runExpression = function(expression) {
                    if (!this.survey || !expression) return undefined;
                    return this.survey.runExpression(expression);
                };
                Object.defineProperty(Question.prototype, "autoGrowComment", {
                    get: function() {
                        return this.survey && this.survey.autoGrowComment;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "allowResizeComment", {
                    get: function() {
                        return this.survey && this.survey.allowResizeComment;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "questionValue", {
                    get: function() {
                        return this.getPropertyValueWithoutDefault("value");
                    },
                    set: function(val1) {
                        this.setPropertyValue("value", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "questionComment", {
                    get: function() {
                        return this.getPropertyValueWithoutDefault("comment");
                    },
                    set: function(val1) {
                        this.setPropertyValue("comment", val1);
                        this.fireCallback(this.commentChangedCallback);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "isValueArray", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "value", {
                    /**
         * Gets or sets the question value.
         *
         * The following table illustrates how the value type depends on the question type:
         *
         * | Question type | Value type(s) |
         * | ------------- | ------------- |
         * | Checkboxes | `Array<string \| number>` |
         * | Dropdown | `string` \| `number` |
         * | Dynamic Matrix | `Array<object>` |
         * | Dynamic Panel | `Array<object>` |
         * | Expression | `string` \| `number` \| `boolean` |
         * | File Upload | `File` \| `Array<File>` |
         * | HTML | (no value) |
         * | Image | (no value) |
         * | Image Picker | `Array<string \| number>` |
         * | Long Text | `string` |
         * | Multi-Select Dropdown | `object` |
         * | Multi-Select Matrix | `object` |
         * | Multiple Textboxes | `Array<string>` |
         * | Panel | (no value) |
         * | Radio Button Group | `string` \| `number` |
         * | Ranking | `Array<string \| number>` |
         * | Rating Scale | `number` \| `string` |
         * | Signature | `string` (base64-encoded image) |
         * | Single-Line Input | `string` \| `number` \| `Date` |
         * | Single-Select Matrix | `object` |
         * | Yes/No (Boolean) | `boolean` \| `string` |
         */ get: function() {
                        return this.getValueCore();
                    },
                    set: function(newValue) {
                        this.setNewValue(newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "hasFilteredValue", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getFilteredValue = function() {
                    return this.value;
                };
                Object.defineProperty(Question.prototype, "valueForSurvey", {
                    get: function() {
                        if (!!this.valueToDataCallback) return this.valueToDataCallback(this.value);
                        return this.value;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets the question's `value` and `comment` properties to `undefined`.
     * @see value
     * @see comment
     */ Question.prototype.clearValue = function() {
                    if (this.value !== undefined) this.value = undefined;
                    if (!!this.comment) this.comment = undefined;
                    this.setValueChangedDirectly(false);
                };
                Question.prototype.unbindValue = function() {
                    this.clearValue();
                };
                Question.prototype.createValueCopy = function() {
                    return this.getUnbindValue(this.value);
                };
                Question.prototype.initDataUI = function() {};
                Question.prototype.getUnbindValue = function(value) {
                    if (this.isValueSurveyElement(value)) return value;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].getUnbindValue(value);
                };
                Question.prototype.isValueSurveyElement = function(val1) {
                    if (!val1) return false;
                    if (Array.isArray(val1)) return val1.length > 0 ? this.isValueSurveyElement(val1[0]) : false;
                    return !!val1.getType && !!val1.onPropertyChanged;
                };
                Question.prototype.canClearValueAsInvisible = function(reason) {
                    if (reason === "onHiddenContainer" && !this.isParentVisible) return true;
                    if (this.isVisibleInSurvey) return false;
                    if (!!this.page && this.page.isStartPage) return false;
                    if (!this.survey) return true;
                    return !this.survey.hasVisibleQuestionByValueName(this.getValueName());
                };
                Object.defineProperty(Question.prototype, "isParentVisible", {
                    /**
         * Returns `true` if a parent element (page or panel) is visible.
         */ get: function() {
                        if (this.parentQuestion && !this.parentQuestion.isVisible) return false;
                        var parent = this.parent;
                        while(parent){
                            if (!parent.isVisible) return false;
                            parent = parent.parent;
                        }
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.clearValueIfInvisible = function(reason) {
                    if (reason === void 0) reason = "onHidden";
                    var clearIf = this.getClearIfInvisible();
                    if (clearIf === "none") return;
                    if (reason === "onHidden" && clearIf === "onComplete") return;
                    if (reason === "onHiddenContainer" && clearIf !== reason) return;
                    this.clearValueIfInvisibleCore(reason);
                };
                Question.prototype.clearValueIfInvisibleCore = function(reason) {
                    if (this.canClearValueAsInvisible(reason)) {
                        this.clearValue();
                        this.setValueChangedDirectly(undefined);
                    }
                };
                Object.defineProperty(Question.prototype, "clearIfInvisible", {
                    /**
         * Specifies when to clear the question value if the question becomes invisible.
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the Survey's [`clearInvisibleValues`](https://surveyjs.io/form-library/documentation/surveymodel#clearInvisibleValues) property.
         * - `"onHidden"` - Clears the value when the question becomes invisible. If a question is invisible on startup and has an initial value, this value will be cleared when the survey is complete.
         * - `"onHiddenContainer"` - Clears the value when the question or its container (page or panel) becomes invisible. If a question is invisible on startup and has an initial value, this value will be cleared when the survey is complete.
         * - `"onComplete"` - Clears the value when the survey is complete.
         * - `"none"` - Never clears the value of an invisible question.
         * @see SurveyModel.clearInvisibleValues
         * @see visible
         * @see SurveyModel.onComplete
         */ get: function() {
                        return this.getPropertyValue("clearIfInvisible");
                    },
                    set: function(val1) {
                        this.setPropertyValue("clearIfInvisible", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getClearIfInvisible = function() {
                    var res = this.clearIfInvisible;
                    if (!!this.survey) return this.survey.getQuestionClearIfInvisible(res);
                    return res !== "default" ? res : "onComplete";
                };
                Object.defineProperty(Question.prototype, "displayValue", {
                    get: function() {
                        if (this.isLoadingFromJson) return "";
                        return this.getDisplayValue(true);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns a display text that corresponds to the question value. For example, if you call this method for a Dropdown question, it returns an item text instead of an item value.
     * @param keysAsText Applies when the question value is an object (in Matrix, Multiple Text, and similar questions). Pass `true` if not only values in the object should be display texts, but also keys. Default value: `false`.
     * @param value Specify this parameter to get a display text for a specific value, not for the current question value. If the question value is an object, this parameter should be a similar object.
     */ Question.prototype.getDisplayValue = function(keysAsText, value) {
                    if (value === void 0) value = undefined;
                    var res = this.calcDisplayValue(keysAsText, value);
                    if (this.survey) res = this.survey.getQuestionDisplayValue(this, res);
                    return !!this.displayValueCallback ? this.displayValueCallback(res) : res;
                };
                Question.prototype.calcDisplayValue = function(keysAsText, value) {
                    if (value === void 0) value = undefined;
                    if (this.customWidget) {
                        var res = this.customWidget.getDisplayValue(this, value);
                        if (res) return res;
                    }
                    value = value == undefined ? this.createValueCopy() : value;
                    if (this.isValueEmpty(value, !this.allowSpaceAsAnswer)) return this.getDisplayValueEmpty();
                    return this.getDisplayValueCore(keysAsText, value);
                };
                Question.prototype.getDisplayValueCore = function(keyAsText, value) {
                    return value;
                };
                Question.prototype.getDisplayValueEmpty = function() {
                    return "";
                };
                Object.defineProperty(Question.prototype, "defaultValue", {
                    /**
         * A default value for the question. Ignored for question types that cannot have a [value](https://surveyjs.io/form-library/documentation/question#value) (for example, HTML).
         *
         * The default value is used as a question value in the following cases:
         *
         * - While the survey is being loaded from JSON.
         * - The question is just added to the survey and does not yet have an answer.
         * - The respondent left the answer empty.
         * @see defaultValueExpression
         */ get: function() {
                        return this.getPropertyValue("defaultValue");
                    },
                    set: function(val1) {
                        if (this.isValueExpression(val1)) {
                            this.defaultValueExpression = val1.substring(1);
                            return;
                        }
                        this.setPropertyValue("defaultValue", this.convertDefaultValue(val1));
                        this.updateValueWithDefaults();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "defaultValueExpression", {
                    /**
         * An expression used to calculate the [defaultValue](https://surveyjs.io/form-library/documentation/question#defaultValue).
         *
         * This expression applies until the question [value](https://surveyjs.io/form-library/documentation/question#value) is specified by an end user or programmatically.
         *
         * An expression can reference other questions as follows:
         *
         * - `{other_question_name}`
         * - `{panel.other_question_name}` (to access questions inside the same dynamic panel)
         * - `{row.other_question_name}` (to access questions inside the same dynamic matrix or multi-column dropdown)
         *
         * An expression can also include built-in and custom functions for advanced calculations. For example, if the `defaultValue` should be today's date, set the `defaultValueExpression` to `"today()"`, and the corresponding built-in function will be executed each time the survey is loaded. Refer to the following help topic for more information: [Built-In Functions](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#built-in-functions).
         *
         * [View Demo](https://surveyjs.io/form-library/examples/specify-default-question-value-dynamically (linkStyle))
         * @see defaultValue
         * @see setValueExpression
         */ get: function() {
                        return this.getPropertyValue("defaultValueExpression");
                    },
                    set: function(val1) {
                        this.setPropertyValue("defaultValueExpression", val1);
                        this.defaultValueRunner = undefined;
                        this.updateValueWithDefaults();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "resetValueIf", {
                    /**
         * A Boolean expression. If it evaluates to `true`, the question value is reset to [default](#defaultValue).
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions (linkStyle))
         * @see setValueIf
         */ get: function() {
                        return this.getPropertyValue("resetValueIf");
                    },
                    set: function(val1) {
                        this.setPropertyValue("resetValueIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "setValueIf", {
                    /**
         * A Boolean expression. If it evaluates to `true`, the question value is set to a value calculated using the [`setValueExpression`](#setValueExpression).
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions (linkStyle))
         * @see resetValueIf
         */ get: function() {
                        return this.getPropertyValue("setValueIf");
                    },
                    set: function(val1) {
                        this.setPropertyValue("setValueIf", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "setValueExpression", {
                    /**
         * An expression used to calculate the question value.
         *
         * You can use `setValueExpression` as a standalone property or in conjunction with the [`setValueIf`](#setValueIf) expression, in which case the calculated question value applies only when `setValueIf` evaluates to `true`.
         *
         * [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions (linkStyle))
         * @see defaultValueExpression
         * @see resetValueIf
         */ get: function() {
                        return this.getPropertyValue("setValueExpression");
                    },
                    set: function(val1) {
                        this.setPropertyValue("setValueExpression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "resizeStyle", {
                    get: function() {
                        return this.allowResizeComment ? "both" : "none";
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns the question value as an object in which the question name, title, value, and other parameters are stored as individual properties.
     *
     * If the question can have more than one value (Matrix, Multiple Text), the object enables the `isNode` flag and stores information about these values in the `data` property. Refer to the following help topic for more information: [Access Full Survey Results](https://surveyjs.io/form-library/documentation/handle-survey-results-access#access-full-survey-results).
     *
     * Pass an object with the `includeEmpty` property set to `false` if you want to skip empty answers.
     */ Question.prototype.getPlainData = function(options) {
                    var _this = this;
                    if (!options) options = {
                        includeEmpty: true,
                        includeQuestionTypes: false
                    };
                    if (options.includeEmpty || !this.isEmpty()) {
                        var questionPlainData = {
                            name: this.name,
                            title: this.locTitle.renderedHtml,
                            value: this.value,
                            displayValue: this.displayValue,
                            isNode: false,
                            getString: function(val1) {
                                return typeof val1 === "object" ? JSON.stringify(val1) : val1;
                            }
                        };
                        if (options.includeQuestionTypes === true) questionPlainData.questionType = this.getType();
                        (options.calculations || []).forEach(function(calculation) {
                            questionPlainData[calculation.propertyName] = _this.getPlainDataCalculatedValue(calculation.propertyName);
                        });
                        if (this.hasComment) {
                            questionPlainData.isNode = true;
                            questionPlainData.data = [
                                {
                                    name: 0,
                                    isComment: true,
                                    title: "Comment",
                                    value: _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].commentSuffix,
                                    displayValue: this.comment,
                                    getString: function(val1) {
                                        return typeof val1 === "object" ? JSON.stringify(val1) : val1;
                                    },
                                    isNode: false
                                }
                            ];
                        }
                        return questionPlainData;
                    }
                    return undefined;
                };
                Question.prototype.getPlainDataCalculatedValue = function(propName) {
                    return this[propName];
                };
                Object.defineProperty(Question.prototype, "correctAnswer", {
                    /**
         * A correct answer to this question. Specify this property if you want to [create a quiz](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
         * @see SurveyModel.getCorrectAnswerCount
         * @see SurveyModel.getInCorrectAnswerCount
         */ get: function() {
                        return this.getPropertyValue("correctAnswer");
                    },
                    set: function(val1) {
                        this.setPropertyValue("correctAnswer", this.convertDefaultValue(val1));
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.convertDefaultValue = function(val1) {
                    return val1;
                };
                Object.defineProperty(Question.prototype, "quizQuestionCount", {
                    /**
         * The number of quiz questions. A question counts if it is visible, has an input field, and specifies `correctAnswer`.
         * @see [Create a Quiz](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz)
         * @see correctAnswer
         * @see SurveyModel.getQuizQuestions
         */ get: function() {
                        if (this.isVisible && this.hasInput && !this.isValueEmpty(this.correctAnswer)) return this.getQuizQuestionCount();
                        return 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "correctAnswerCount", {
                    get: function() {
                        if (!this.isEmpty() && !this.isValueEmpty(this.correctAnswer)) return this.getCorrectAnswerCount();
                        return 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getQuizQuestionCount = function() {
                    return 1;
                };
                Question.prototype.getCorrectAnswerCount = function() {
                    return this.checkIfAnswerCorrect() ? 1 : 0;
                };
                Question.prototype.checkIfAnswerCorrect = function() {
                    var isEqual = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(this.value, this.correctAnswer, this.getAnswerCorrectIgnoreOrder(), _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].comparator.caseSensitive, true);
                    var correct = isEqual ? 1 : 0;
                    var options = {
                        result: isEqual,
                        correctAnswer: correct,
                        correctAnswers: correct,
                        incorrectAnswers: this.quizQuestionCount - correct
                    };
                    if (!!this.survey) this.survey.onCorrectQuestionAnswer(this, options);
                    return options.result;
                };
                Question.prototype.getAnswerCorrectIgnoreOrder = function() {
                    return false;
                };
                /**
    * Returns `true` if a question answer matches the `correctAnswer` property value.
    *
    * [View Demo](https://surveyjs.io/form-library/examples/create-a-scored-quiz (linkStyle))
    * @see correctAnswer
    * @see SurveyModel.getQuizQuestions
    */ Question.prototype.isAnswerCorrect = function() {
                    return this.correctAnswerCount == this.quizQuestionCount;
                };
                Question.prototype.updateValueWithDefaults = function() {
                    if (this.isLoadingFromJson || !this.isDesignMode && this.isDefaultValueEmpty()) return;
                    if (!this.isDesignMode && !this.isEmpty()) return;
                    if (this.isEmpty() && this.isDefaultValueEmpty()) return;
                    if (this.isClearValueOnHidden && !this.isVisible) return;
                    if (this.isDesignMode && this.isContentElement && this.isDefaultValueEmpty()) return;
                    this.setDefaultValue();
                };
                Object.defineProperty(Question.prototype, "isClearValueOnHidden", {
                    get: function() {
                        var clearIf = this.getClearIfInvisible();
                        if (clearIf === "none" || clearIf === "onComplete") return false;
                        return clearIf === "onHidden" || clearIf === "onHiddenContainer";
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getQuestionFromArray = function(name, index) {
                    return null;
                };
                Question.prototype.getDefaultValue = function() {
                    return this.defaultValue;
                };
                Question.prototype.isDefaultValueEmpty = function() {
                    return !this.defaultValueExpression && this.isValueEmpty(this.defaultValue, !this.allowSpaceAsAnswer);
                };
                Question.prototype.getDefaultRunner = function(runner, expression) {
                    if (!runner && !!expression) runner = this.createExpressionRunner(expression);
                    if (!!runner) runner.expression = expression;
                    return runner;
                };
                Question.prototype.setDefaultValue = function() {
                    var _this = this;
                    this.setDefaultValueCore(function(val1) {
                        if (!_this.isTwoValueEquals(_this.value, val1)) _this.value = val1;
                    });
                };
                Question.prototype.setDefaultValueCore = function(func) {
                    this.defaultValueRunner = this.getDefaultRunner(this.defaultValueRunner, this.defaultValueExpression);
                    this.setValueAndRunExpression(this.defaultValueRunner, this.getUnbindValue(this.defaultValue), function(val1) {
                        return func(val1);
                    });
                };
                Question.prototype.isValueExpression = function(val1) {
                    return !!val1 && typeof val1 == "string" && val1.length > 0 && val1[0] == "=";
                };
                Question.prototype.setValueAndRunExpression = function(runner, defaultValue, setFunc, values, properties) {
                    var _this = this;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    var func = function(val1) {
                        _this.runExpressionSetValue(val1, setFunc);
                    };
                    if (!this.runDefaultValueExpression(runner, values, properties, func)) func(defaultValue);
                };
                Question.prototype.convertFuncValuetoQuestionValue = function(val1) {
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].convertValToQuestionVal(val1);
                };
                Question.prototype.runExpressionSetValue = function(val1, setFunc) {
                    setFunc(this.convertFuncValuetoQuestionValue(val1));
                };
                Question.prototype.runDefaultValueExpression = function(runner, values, properties, setFunc) {
                    var _this = this;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    if (!runner || !this.data) return false;
                    if (!setFunc) setFunc = function(val1) {
                        _this.runExpressionSetValue(val1, function(val1) {
                            if (!_this.isTwoValueEquals(_this.value, val1)) _this.value = val1;
                        });
                    };
                    if (!values) values = this.data.getFilteredValues();
                    if (!properties) properties = this.data.getFilteredProperties();
                    if (!!runner && runner.canRun) {
                        runner.onRunComplete = function(res) {
                            if (res == undefined) res = _this.defaultValue;
                            _this.isChangingViaDefaultValue = true;
                            setFunc(res);
                            _this.isChangingViaDefaultValue = false;
                        };
                        runner.run(values, properties);
                    }
                    return true;
                };
                Object.defineProperty(Question.prototype, "comment", {
                    /**
         * A comment to the selected question value. Enable the `showCommentArea` property to allow users to leave comments.
         * @see showCommentArea
         * @see commentText
         */ get: function() {
                        return this.getQuestionComment();
                    },
                    set: function(newValue) {
                        if (!!newValue) {
                            var trimmedValue = newValue.toString().trim();
                            if (trimmedValue !== newValue) {
                                newValue = trimmedValue;
                                if (newValue === this.comment) this.setPropertyValueDirectly("comment", newValue);
                            }
                        }
                        if (this.comment == newValue) return;
                        this.setQuestionComment(newValue);
                        this.updateCommentElements();
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getCommentAreaCss = function(isOther) {
                    if (isOther === void 0) isOther = false;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append("form-group", isOther).append(this.cssClasses.formGroup, !isOther).append(this.cssClasses.commentArea).toString();
                };
                Question.prototype.getQuestionComment = function() {
                    return this.questionComment;
                };
                Question.prototype.setQuestionComment = function(newValue) {
                    this.setNewComment(newValue);
                };
                /**
     * Returns `true` if the question value is an empty string, array, or object or if it equals `undefined` or `null`.
     */ Question.prototype.isEmpty = function() {
                    return this.isValueEmpty(this.value, !this.allowSpaceAsAnswer);
                };
                Object.defineProperty(Question.prototype, "isAnswered", {
                    get: function() {
                        return this.getPropertyValue("isAnswered");
                    },
                    set: function(val1) {
                        this.setPropertyValue("isAnswered", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.updateIsAnswered = function() {
                    var oldVal = this.isAnswered;
                    this.setPropertyValue("isAnswered", this.getIsAnswered());
                    if (oldVal !== this.isAnswered) this.updateQuestionCss();
                };
                Question.prototype.getIsAnswered = function() {
                    return !this.isEmpty();
                };
                Object.defineProperty(Question.prototype, "validators", {
                    /**
         * Question validators.
         * @see [Data Validation](https://surveyjs.io/form-library/documentation/data-validation)
         */ get: function() {
                        return this.getPropertyValue("validators");
                    },
                    set: function(val1) {
                        this.setPropertyValue("validators", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getValidators = function() {
                    return this.validators;
                };
                Question.prototype.getSupportedValidators = function() {
                    var res = [];
                    var className = this.getType();
                    while(!!className){
                        var classValidators = _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].supportedValidators[className];
                        if (!!classValidators) for(var i = classValidators.length - 1; i >= 0; i--)res.splice(0, 0, classValidators[i]);
                        var classInfo = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].findClass(className);
                        className = classInfo.parentName;
                    }
                    return res;
                };
                Question.prototype.addConditionObjectsByContext = function(objects, context) {
                    objects.push({
                        name: this.getValueName(),
                        text: this.processedTitle,
                        question: this
                    });
                };
                /**
     * Returns an array of questions nested within the current question. Use this method to obtain questions within [Multiple Text](https://surveyjs.io/form-library/documentation/api-reference/multiple-text-entry-question-model), [Dynamic Panel](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model), and [Matrix](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-question-model)-like questions.
     * @param visibleOnly A Boolean value that specifies whether to include only visible nested questions.
     * @returns An array of nested questions.
     */ Question.prototype.getNestedQuestions = function(visibleOnly) {
                    if (visibleOnly === void 0) visibleOnly = false;
                    var res = [];
                    this.collectNestedQuestions(res, visibleOnly);
                    if (res.length === 1 && res[0] === this) return [];
                    return res;
                };
                Question.prototype.collectNestedQuestions = function(questions, visibleOnly) {
                    if (visibleOnly === void 0) visibleOnly = false;
                    if (visibleOnly && !this.isVisible) return;
                    this.collectNestedQuestionsCore(questions, visibleOnly);
                };
                Question.prototype.collectNestedQuestionsCore = function(questions, visibleOnly) {
                    questions.push(this);
                };
                Question.prototype.getConditionJson = function(operator, path) {
                    if (operator === void 0) operator = null;
                    if (path === void 0) path = null;
                    var json = new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]().toJsonObject(this);
                    json["type"] = this.getType();
                    return json;
                };
                Question.prototype.hasErrors = function(fireCallback, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (rec === void 0) rec = null;
                    var errors = this.checkForErrors(!!rec && rec.isOnValueChanged === true);
                    if (fireCallback) {
                        if (!!this.survey) this.survey.beforeSettingQuestionErrors(this, errors);
                        this.errors = errors;
                        if (this.errors !== errors) this.errors.forEach(function(er) {
                            return er.locText.strChanged();
                        });
                    }
                    this.updateContainsErrors();
                    if (this.isCollapsed && rec && fireCallback && errors.length > 0) this.expand();
                    return errors.length > 0;
                };
                /**
     * Validates this question and returns `false` if the validation fails.
     * @param fireCallback *(Optional)* Pass `false` if you do not want to show validation errors in the UI.
     * @see [Data Validation](https://surveyjs.io/form-library/documentation/data-validation)
     */ Question.prototype.validate = function(fireCallback, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (rec === void 0) rec = null;
                    if (!!rec && rec.isOnValueChanged) {
                        if (!!this.parent) this.parent.validateContainerOnly();
                    }
                    return !this.hasErrors(fireCallback, rec);
                };
                Object.defineProperty(Question.prototype, "currentErrorCount", {
                    get: function() {
                        return this.errors.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "requiredText", {
                    /**
         * Returns a character or text string that indicates a required question.
         * @see SurveyModel.requiredText
         * @see isRequired
         */ get: function() {
                        return this.survey != null && this.isRequired ? this.survey.requiredText : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.addError = function(error) {
                    if (!error) return;
                    var newError = null;
                    if (typeof error === "string" || error instanceof String) newError = this.addCustomError(error);
                    else newError = error;
                    this.errors.push(newError);
                };
                Question.prototype.addCustomError = function(error) {
                    return new _error__WEBPACK_IMPORTED_MODULE_3__["CustomError"](error, this.survey);
                };
                Question.prototype.removeError = function(error) {
                    var errors = this.errors;
                    var index = errors.indexOf(error);
                    if (index !== -1) errors.splice(index, 1);
                };
                Question.prototype.checkForErrors = function(isOnValueChanged) {
                    var qErrors = new Array();
                    if (this.isVisible && this.canCollectErrors()) this.collectErrors(qErrors, isOnValueChanged);
                    return qErrors;
                };
                Question.prototype.canCollectErrors = function() {
                    return !this.isReadOnly || _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].readOnly.enableValidation;
                };
                Question.prototype.collectErrors = function(qErrors, isOnValueChanged) {
                    this.onCheckForErrors(qErrors, isOnValueChanged);
                    if (qErrors.length > 0 || !this.canRunValidators(isOnValueChanged)) return;
                    var errors = this.runValidators();
                    if (errors.length > 0) {
                        //validators may change the question value.
                        qErrors.length = 0;
                        for(var i = 0; i < errors.length; i++)qErrors.push(errors[i]);
                    }
                    if (this.survey && qErrors.length == 0) {
                        var error = this.fireSurveyValidation();
                        if (error) qErrors.push(error);
                    }
                };
                Question.prototype.canRunValidators = function(isOnValueChanged) {
                    return true;
                };
                Question.prototype.fireSurveyValidation = function() {
                    if (this.validateValueCallback) return this.validateValueCallback();
                    return this.survey ? this.survey.validateQuestion(this) : null;
                };
                Question.prototype.onCheckForErrors = function(errors, isOnValueChanged) {
                    var _this = this;
                    if ((!isOnValueChanged || this.isOldAnswered) && this.hasRequiredError()) {
                        var err = new _error__WEBPACK_IMPORTED_MODULE_3__["AnswerRequiredError"](this.requiredErrorText, this);
                        err.onUpdateErrorTextCallback = function(err) {
                            err.text = _this.requiredErrorText;
                        };
                        errors.push(err);
                    }
                    if (!this.isEmpty() && this.customWidget) {
                        var text = this.customWidget.validate(this);
                        if (!!text) errors.push(this.addCustomError(text));
                    }
                };
                Question.prototype.hasRequiredError = function() {
                    return this.isRequired && this.isEmpty();
                };
                Object.defineProperty(Question.prototype, "isRunningValidators", {
                    get: function() {
                        return this.getIsRunningValidators();
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getIsRunningValidators = function() {
                    return this.isRunningValidatorsValue;
                };
                Question.prototype.runValidators = function() {
                    var _this = this;
                    if (!!this.validatorRunner) this.validatorRunner.onAsyncCompleted = null;
                    this.validatorRunner = new _validator__WEBPACK_IMPORTED_MODULE_4__["ValidatorRunner"]();
                    this.isRunningValidatorsValue = true;
                    this.validatorRunner.onAsyncCompleted = function(errors) {
                        _this.doOnAsyncCompleted(errors);
                    };
                    return this.validatorRunner.run(this);
                };
                Question.prototype.doOnAsyncCompleted = function(errors) {
                    for(var i = 0; i < errors.length; i++)this.errors.push(errors[i]);
                    this.isRunningValidatorsValue = false;
                    this.raiseOnCompletedAsyncValidators();
                };
                Question.prototype.raiseOnCompletedAsyncValidators = function() {
                    if (!!this.onCompletedAsyncValidators && !this.isRunningValidators) {
                        this.onCompletedAsyncValidators(this.getAllErrors().length > 0);
                        this.onCompletedAsyncValidators = null;
                    }
                };
                Question.prototype.setNewValue = function(newValue) {
                    if (this.isNewValueEqualsToValue(newValue)) return;
                    if (!this.checkIsValueCorrect(newValue)) return;
                    this.isOldAnswered = this.isAnswered;
                    this.isSettingQuestionValue = true;
                    this.setNewValueInData(newValue);
                    this.allowNotifyValueChanged && this.onValueChanged();
                    this.isSettingQuestionValue = false;
                    if (this.isAnswered !== this.isOldAnswered) this.updateQuestionCss();
                    this.isOldAnswered = undefined;
                };
                Question.prototype.checkIsValueCorrect = function(val1) {
                    var res = this.isValueEmpty(val1, !this.allowSpaceAsAnswer) || this.isNewValueCorrect(val1);
                    if (!res) _console_warnings__WEBPACK_IMPORTED_MODULE_12__["ConsoleWarnings"].inCorrectQuestionValue(this.name, val1);
                    return res;
                };
                Question.prototype.isNewValueCorrect = function(val1) {
                    return true;
                };
                Question.prototype.isNewValueEqualsToValue = function(newValue) {
                    var val1 = this.value;
                    if (!this.isTwoValueEquals(newValue, val1, false, false)) return false;
                    var isObj = newValue === val1 && !!val1 && (Array.isArray(val1) || typeof val1 === "object");
                    return !isObj;
                };
                Question.prototype.isTextValue = function() {
                    return false;
                };
                Object.defineProperty(Question.prototype, "isSurveyInputTextUpdate", {
                    get: function() {
                        return !!this.survey ? this.survey.isUpdateValueTextOnTyping : false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "requireStrictCompare", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getDataLocNotification = function() {
                    return this.isInputTextUpdate ? "text" : false;
                };
                Object.defineProperty(Question.prototype, "isInputTextUpdate", {
                    get: function() {
                        return this.isSurveyInputTextUpdate && this.isTextValue();
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.setNewValueInData = function(newValue) {
                    newValue = this.valueToData(newValue);
                    if (!this.isValueChangedInSurvey) this.setValueCore(newValue);
                };
                Question.prototype.getValueCore = function() {
                    return this.questionValue;
                };
                Question.prototype.setValueCore = function(newValue) {
                    this.setQuestionValue(newValue);
                    if (this.data != null && this.canSetValueToSurvey()) {
                        newValue = this.valueForSurvey;
                        this.data.setValue(this.getValueName(), newValue, this.getDataLocNotification(), this.allowNotifyValueChanged, this.name);
                    }
                    this.isMouseDown = false;
                };
                Question.prototype.canSetValueToSurvey = function() {
                    return true;
                };
                Question.prototype.valueFromData = function(val1) {
                    return val1;
                };
                Question.prototype.valueToData = function(val1) {
                    return val1;
                };
                Question.prototype.convertToCorrectValue = function(val1) {
                    return val1;
                };
                Question.prototype.onValueChanged = function() {};
                Question.prototype.onMouseDown = function() {
                    this.isMouseDown = true;
                };
                Question.prototype.setNewComment = function(newValue) {
                    if (this.questionComment === newValue) return;
                    this.questionComment = newValue;
                    this.setCommentIntoData(newValue);
                };
                Question.prototype.setCommentIntoData = function(newValue) {
                    if (this.data != null) this.data.setComment(this.getValueName(), newValue, this.isSurveyInputTextUpdate ? "text" : false);
                };
                Question.prototype.getValidName = function(name) {
                    return makeNameValid(name);
                };
                //IQuestion
                Question.prototype.updateValueFromSurvey = function(newValue, clearData) {
                    var _this = this;
                    if (clearData === void 0) clearData = false;
                    newValue = this.getUnbindValue(newValue);
                    if (!!this.valueFromDataCallback) newValue = this.valueFromDataCallback(newValue);
                    if (!this.checkIsValueCorrect(newValue)) return;
                    var isEmpty = this.isValueEmpty(newValue);
                    if (!isEmpty && this.defaultValueExpression) this.setDefaultValueCore(function(val1) {
                        _this.updateValueFromSurveyCore(newValue, _this.isTwoValueEquals(newValue, val1));
                    });
                    else {
                        this.updateValueFromSurveyCore(newValue, this.data !== this.getSurvey());
                        if (clearData && isEmpty) this.isValueChangedDirectly = false;
                    }
                    this.updateDependedQuestions();
                    this.updateIsAnswered();
                };
                Question.prototype.updateValueFromSurveyCore = function(newValue, viaDefaultVal) {
                    this.isChangingViaDefaultValue = viaDefaultVal;
                    this.setQuestionValue(this.valueFromData(newValue));
                    this.isChangingViaDefaultValue = false;
                };
                Question.prototype.updateCommentFromSurvey = function(newValue) {
                    this.questionComment = newValue;
                };
                Question.prototype.onChangeQuestionValue = function(newValue) {};
                Question.prototype.setValueChangedDirectly = function(val1) {
                    this.isValueChangedDirectly = val1;
                    if (!!this.setValueChangedDirectlyCallback) this.setValueChangedDirectlyCallback(val1);
                };
                Question.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    newValue = this.convertToCorrectValue(newValue);
                    var isEqual = this.isTwoValueEquals(this.questionValue, newValue);
                    if (!isEqual && !this.isChangingViaDefaultValue && !this.isParentChangingViaDefaultValue) this.setValueChangedDirectly(true);
                    this.questionValue = newValue;
                    if (!isEqual) this.onChangeQuestionValue(newValue);
                    !isEqual && this.allowNotifyValueChanged && this.fireCallback(this.valueChangedCallback);
                    if (updateIsAnswered) this.updateIsAnswered();
                };
                Object.defineProperty(Question.prototype, "isParentChangingViaDefaultValue", {
                    get: function() {
                        var _a;
                        return ((_a = this.data) === null || _a === void 0 ? void 0 : _a.isChangingViaDefaultValue) === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.onSurveyValueChanged = function(newValue) {};
                Question.prototype.setVisibleIndex = function(val1) {
                    if (!this.isVisible || !this.hasTitle && !_settings__WEBPACK_IMPORTED_MODULE_8__["settings"].numbering.includeQuestionsWithHiddenTitle || this.hideNumber && !_settings__WEBPACK_IMPORTED_MODULE_8__["settings"].numbering.includeQuestionsWithHiddenNumber) val1 = -1;
                    this.setPropertyValue("visibleIndex", val1);
                    this.setPropertyValue("no", this.calcNo());
                    return val1 < 0 ? 0 : 1;
                };
                Question.prototype.removeElement = function(element) {
                    return false;
                };
                Question.prototype.supportGoNextPageAutomatic = function() {
                    return false;
                };
                Question.prototype.supportGoNextPageError = function() {
                    return true;
                };
                /**
     * Removes values that cannot be assigned to this question, for example, choices unlisted in the `choices` array.
     *
     * Call this method after you assign new question values in code to ensure that they are acceptable.
     *
     * > This method does not remove values that fail validation. Call the `validate()` method to validate newly assigned values.
     *
     * @see validate
     */ Question.prototype.clearIncorrectValues = function() {};
                Question.prototype.clearOnDeletingContainer = function() {};
                /**
     * Empties the `errors` array.
     * @see errors
     */ Question.prototype.clearErrors = function() {
                    this.errors = [];
                };
                Question.prototype.clearUnusedValues = function() {};
                Question.prototype.onAnyValueChanged = function(name, questionName) {};
                Question.prototype.checkBindings = function(valueName, value) {
                    if (this.bindings.isEmpty() || !this.data) return;
                    var props = this.bindings.getPropertiesByValueName(valueName);
                    for(var i = 0; i < props.length; i++){
                        var propName = props[i];
                        if (this.isValueEmpty(value) && _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(this[propName])) value = 0;
                        this[propName] = value;
                    }
                };
                Question.prototype.getComponentName = function() {
                    return _rendererFactory__WEBPACK_IMPORTED_MODULE_9__["RendererFactory"].Instance.getRendererByQuestion(this);
                };
                Question.prototype.isDefaultRendering = function() {
                    return !!this.customWidget || this.renderAs === "default" || this.getComponentName() === "default";
                };
                //ISurveyErrorOwner
                Question.prototype.getErrorCustomText = function(text, error) {
                    if (!!this.survey) return this.survey.getSurveyErrorCustomText(this, text, error);
                    return text;
                };
                //IValidatorOwner
                Question.prototype.getValidatorTitle = function() {
                    return null;
                };
                Object.defineProperty(Question.prototype, "validatedValue", {
                    get: function() {
                        return this.value;
                    },
                    set: function(val1) {
                        this.value = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.prototype.getAllValues = function() {
                    return !!this.data ? this.data.getAllValues() : null;
                };
                Question.prototype.processPopupVisiblilityChanged = function(popupModel, visible) {
                    this.survey.processPopupVisiblityChanged(this, popupModel, visible);
                };
                Question.prototype.onTextKeyDownHandler = function(event1) {
                    if (event1.keyCode === 13) this.survey.questionEditFinishCallback(this, event1);
                };
                Question.prototype.transformToMobileView = function() {};
                Question.prototype.transformToDesktopView = function() {};
                Question.prototype.needResponsiveWidth = function() {
                    return false;
                };
                //responsiveness methods
                Question.prototype.supportResponsiveness = function() {
                    return false;
                };
                Question.prototype.needResponsiveness = function() {
                    return this.supportResponsiveness() && this.isDefaultV2Theme && !this.isDesignMode;
                };
                Question.prototype.checkForResponsiveness = function(el) {
                    var _this = this;
                    if (this.needResponsiveness()) {
                        if (this.isCollapsed) {
                            var onStateChanged = function() {
                                if (_this.isExpanded) {
                                    _this.initResponsiveness(el);
                                    _this.unregisterPropertyChangedHandlers([
                                        "state"
                                    ], "for-responsiveness");
                                }
                            };
                            this.registerPropertyChangedHandlers([
                                "state"
                            ], onStateChanged, "for-responsiveness");
                        } else this.initResponsiveness(el);
                    }
                };
                Question.prototype.getObservedElementSelector = function() {
                    return ".sd-scrollable-container";
                };
                Question.prototype.onMobileChanged = function() {
                    this.onMobileChangedCallback && this.onMobileChangedCallback();
                };
                Question.prototype.triggerResponsiveness = function(hard) {
                    if (hard === void 0) hard = true;
                    if (this.triggerResponsivenessCallback) this.triggerResponsivenessCallback(hard);
                };
                Question.prototype.initResponsiveness = function(el) {
                    var _this = this;
                    this.destroyResizeObserver();
                    if (!!el && this.isDefaultRendering()) {
                        var scrollableSelector_1 = this.getObservedElementSelector();
                        if (!scrollableSelector_1) return;
                        var defaultRootEl = el.querySelector(scrollableSelector_1);
                        if (!defaultRootEl) return;
                        var isProcessed_1 = false;
                        var requiredWidth_1 = undefined;
                        this.triggerResponsivenessCallback = function(hard) {
                            if (hard) {
                                requiredWidth_1 = undefined;
                                _this.renderAs = "default";
                                isProcessed_1 = false;
                            }
                            var callback = function() {
                                var rootEl = el.querySelector(scrollableSelector_1);
                                if (!requiredWidth_1 && _this.isDefaultRendering()) requiredWidth_1 = rootEl.scrollWidth;
                                if (isProcessed_1 || !Object(_utils_utils__WEBPACK_IMPORTED_MODULE_11__["isContainerVisible"])(rootEl)) isProcessed_1 = false;
                                else isProcessed_1 = _this.processResponsiveness(requiredWidth_1, Object(_utils_utils__WEBPACK_IMPORTED_MODULE_11__["getElementWidth"])(rootEl));
                            };
                            if (hard) setTimeout(callback, 1);
                            else callback();
                        };
                        this.resizeObserver = new ResizeObserver(function(entries) {
                            _global_variables_utils__WEBPACK_IMPORTED_MODULE_14__["DomWindowHelper"].requestAnimationFrame(function() {
                                _this.triggerResponsiveness(false);
                            });
                        });
                        this.onMobileChangedCallback = function() {
                            setTimeout(function() {
                                var rootEl = el.querySelector(scrollableSelector_1);
                                _this.processResponsiveness(requiredWidth_1, Object(_utils_utils__WEBPACK_IMPORTED_MODULE_11__["getElementWidth"])(rootEl));
                            }, 0);
                        };
                        this.resizeObserver.observe(el);
                    }
                };
                Question.prototype.getCompactRenderAs = function() {
                    return "default";
                };
                Question.prototype.getDesktopRenderAs = function() {
                    return "default";
                };
                Question.prototype.processResponsiveness = function(requiredWidth, availableWidth) {
                    availableWidth = Math.round(availableWidth);
                    if (Math.abs(requiredWidth - availableWidth) > 2) {
                        var oldRenderAs = this.renderAs;
                        if (requiredWidth > availableWidth) this.renderAs = this.getCompactRenderAs();
                        else this.renderAs = this.getDesktopRenderAs();
                        return oldRenderAs !== this.renderAs;
                    }
                    return false;
                };
                Question.prototype.destroyResizeObserver = function() {
                    if (!!this.resizeObserver) {
                        this.resizeObserver.disconnect();
                        this.resizeObserver = undefined;
                        this.onMobileChangedCallback = undefined;
                        this.triggerResponsivenessCallback = undefined;
                        this.renderAs = this.getDesktopRenderAs();
                    }
                };
                Question.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.resetDependedQuestions();
                    this.destroyResizeObserver();
                };
                Question.prototype.resetDependedQuestions = function() {
                    for(var i = 0; i < this.dependedQuestions.length; i++)this.dependedQuestions[i].resetDependedQuestion();
                };
                Object.defineProperty(Question.prototype, "isNewA11yStructure", {
                    //a11y
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaLabel", {
                    get: function() {
                        if (this.isNewA11yStructure) return null;
                        return this.locTitle.renderedHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaRole", {
                    get: function() {
                        if (this.isNewA11yStructure) return null;
                        return "textbox";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaRequired", {
                    get: function() {
                        if (this.isNewA11yStructure) return null;
                        return this.isRequired ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaInvalid", {
                    get: function() {
                        if (this.isNewA11yStructure) return null;
                        return this.hasCssError() ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaLabelledBy", {
                    get: function() {
                        if (this.isNewA11yStructure) return null;
                        if (this.hasTitle) return this.ariaTitleId;
                        else return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaDescribedBy", {
                    get: function() {
                        if (this.isNewA11yStructure) return null;
                        if (this.hasTitle) return this.ariaDescriptionId;
                        else return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaExpanded", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "ariaErrormessage", {
                    get: function() {
                        if (this.isNewA11yStructure) return null;
                        return this.hasCssError() ? this.id + "_errors" : null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "a11y_input_ariaRole", {
                    //EO a11y
                    //new a11y
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "a11y_input_ariaRequired", {
                    get: function() {
                        return this.isRequired ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "a11y_input_ariaInvalid", {
                    get: function() {
                        return this.hasCssError() ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "a11y_input_ariaLabel", {
                    get: function() {
                        if (this.hasTitle && !this.parentQuestion) return null;
                        else return this.locTitle.renderedHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "a11y_input_ariaLabelledBy", {
                    get: function() {
                        if (this.hasTitle && !this.parentQuestion) return this.ariaTitleId;
                        else return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "a11y_input_ariaDescribedBy", {
                    get: function() {
                        if (this.hasTitle && !this.parentQuestion) return this.ariaDescriptionId;
                        else return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Question.prototype, "a11y_input_ariaErrormessage", {
                    get: function() {
                        return this.hasCssError() ? this.id + "_errors" : null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Question.TextPreprocessorValuesMap = {
                    title: "processedTitle",
                    require: "requiredText"
                };
                Question.questionCounter = 100;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], Question.prototype, "isMobile", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Question.prototype, "forceIsInputReadOnly", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: true,
                        onSet: function(val1, target) {
                            return target.calcRenderedCommentPlaceholder();
                        }
                    })
                ], Question.prototype, "commentPlaceholder", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], Question.prototype, "renderAs", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], Question.prototype, "inMatrixMode", void 0);
                return Question;
            }(_survey_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElement"]);
            function makeNameValid(str) {
                if (!str) return str;
                str = str.trim().replace(/[\{\}]+/g, "");
                while(!!str && str[0] === _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].expressionDisableConversionChar)str = str.substring(1);
                return str;
            }
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("question", [
                {
                    name: "!name",
                    onSettingValue: function(obj, val1) {
                        return makeNameValid(val1);
                    }
                },
                {
                    name: "state",
                    default: "default",
                    choices: [
                        "default",
                        "collapsed",
                        "expanded"
                    ]
                },
                {
                    name: "visible:switch",
                    default: true,
                    overridingProperty: "visibleIf"
                },
                {
                    name: "useDisplayValuesInDynamicTexts:boolean",
                    alternativeName: "useDisplayValuesInTitle",
                    default: true,
                    layout: "row"
                },
                "visibleIf:condition",
                {
                    name: "width"
                },
                {
                    name: "minWidth",
                    defaultFunc: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].minWidth;
                    }
                },
                {
                    name: "maxWidth",
                    defaultFunc: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].maxWidth;
                    }
                },
                {
                    name: "startWithNewLine:boolean",
                    default: true,
                    layout: "row"
                },
                {
                    name: "indent:number",
                    default: 0,
                    choices: [
                        0,
                        1,
                        2,
                        3
                    ],
                    layout: "row"
                },
                {
                    name: "page",
                    isSerializable: false,
                    visibleIf: function(obj) {
                        var survey = obj ? obj.survey : null;
                        return !survey || !survey.pages || survey.pages.length > 1;
                    },
                    choices: function(obj) {
                        var survey = obj ? obj.survey : null;
                        return survey ? survey.pages.map(function(p) {
                            return {
                                value: p.name,
                                text: p.title
                            };
                        }) : [];
                    }
                },
                {
                    name: "title:text",
                    serializationProperty: "locTitle",
                    layout: "row",
                    dependsOn: "name",
                    onPropertyEditorUpdate: function(obj, editor) {
                        if (!!obj && !!editor) editor.placeholder = obj.name;
                    }
                },
                {
                    name: "titleLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom",
                        "left",
                        "hidden"
                    ],
                    layout: "row"
                },
                {
                    name: "description:text",
                    serializationProperty: "locDescription",
                    layout: "row"
                },
                {
                    name: "descriptionLocation",
                    default: "default",
                    choices: [
                        "default",
                        "underInput",
                        "underTitle"
                    ]
                },
                {
                    name: "hideNumber:boolean",
                    dependsOn: "titleLocation",
                    visibleIf: function(obj) {
                        if (!obj) return true;
                        if (obj.titleLocation === "hidden") return false;
                        var parent = obj ? obj.parent : null;
                        var numberingAllowedByParent = !parent || parent.showQuestionNumbers !== "off";
                        if (!numberingAllowedByParent) return false;
                        var survey = obj ? obj.survey : null;
                        return !survey || survey.showQuestionNumbers !== "off" || !!parent && parent.showQuestionNumbers === "onpanel";
                    }
                },
                {
                    name: "valueName",
                    onSettingValue: function(obj, val1) {
                        return makeNameValid(val1);
                    }
                },
                "enableIf:condition",
                "resetValueIf:condition",
                "setValueIf:condition",
                "setValueExpression:expression",
                "defaultValue:value",
                {
                    name: "defaultValueExpression:expression",
                    category: "logic"
                },
                "correctAnswer:value",
                {
                    name: "clearIfInvisible",
                    default: "default",
                    choices: [
                        "default",
                        "none",
                        "onComplete",
                        "onHidden",
                        "onHiddenContainer"
                    ]
                },
                {
                    name: "isRequired:switch",
                    overridingProperty: "requiredIf"
                },
                "requiredIf:condition",
                {
                    name: "requiredErrorText:text",
                    serializationProperty: "locRequiredErrorText"
                },
                {
                    name: "errorLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom"
                    ]
                },
                {
                    name: "readOnly:switch",
                    overridingProperty: "enableIf"
                },
                {
                    name: "validators:validators",
                    baseClassName: "surveyvalidator",
                    classNamePart: "validator"
                },
                {
                    name: "bindings:bindings",
                    serializationProperty: "bindings",
                    visibleIf: function(obj) {
                        return obj.bindings.getNames().length > 0;
                    }
                },
                {
                    name: "renderAs",
                    default: "default",
                    visible: false
                },
                {
                    name: "showCommentArea",
                    visible: false,
                    default: false,
                    alternativeName: "hasComment",
                    category: "general"
                },
                {
                    name: "commentText",
                    dependsOn: "showCommentArea",
                    visibleIf: function(obj) {
                        return obj.showCommentArea;
                    },
                    serializationProperty: "locCommentText",
                    layout: "row"
                },
                {
                    name: "commentPlaceholder",
                    alternativeName: "commentPlaceHolder",
                    serializationProperty: "locCommentPlaceholder",
                    dependsOn: "showCommentArea",
                    visibleIf: function(obj) {
                        return obj.hasComment;
                    }
                }
            ]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addAlterNativeClassName("question", "questionbase");
        /***/ },
        /***/ "./src/questionCustomWidgets.ts": /*!**************************************!*\
  !*** ./src/questionCustomWidgets.ts ***!
  \**************************************/ /*! exports provided: QuestionCustomWidget, CustomWidgetCollection */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomWidget", function() {
                return QuestionCustomWidget;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomWidgetCollection", function() {
                return CustomWidgetCollection;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            var QuestionCustomWidget = /** @class */ function() {
                function QuestionCustomWidget(name, widgetJson) {
                    this.name = name;
                    this.widgetJson = widgetJson;
                    this.htmlTemplate = widgetJson.htmlTemplate ? widgetJson.htmlTemplate : "";
                }
                QuestionCustomWidget.prototype.afterRender = function(question, el) {
                    var _this = this;
                    if (!this.widgetJson.afterRender) return;
                    question.localeChangedCallback = function() {
                        if (_this.widgetJson.willUnmount) _this.widgetJson.willUnmount(question, el);
                        _this.widgetJson.afterRender(question, el);
                    };
                    this.widgetJson.afterRender(question, el);
                };
                QuestionCustomWidget.prototype.willUnmount = function(question, el) {
                    if (this.widgetJson.willUnmount) this.widgetJson.willUnmount(question, el);
                };
                QuestionCustomWidget.prototype.getDisplayValue = function(question, value) {
                    if (value === void 0) value = undefined;
                    if (this.widgetJson.getDisplayValue) return this.widgetJson.getDisplayValue(question, value);
                    return null;
                };
                QuestionCustomWidget.prototype.validate = function(question) {
                    if (this.widgetJson.validate) return this.widgetJson.validate(question);
                    return undefined;
                };
                QuestionCustomWidget.prototype.isFit = function(question) {
                    if (this.isLibraryLoaded() && this.widgetJson.isFit) return this.widgetJson.isFit(question);
                    return false;
                };
                Object.defineProperty(QuestionCustomWidget.prototype, "canShowInToolbox", {
                    get: function() {
                        if (this.widgetJson.showInToolbox === false) return false;
                        if (CustomWidgetCollection.Instance.getActivatedBy(this.name) != "customtype") return false;
                        return !this.widgetJson.widgetIsLoaded || this.widgetJson.widgetIsLoaded();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCustomWidget.prototype, "showInToolbox", {
                    get: function() {
                        return this.widgetJson.showInToolbox !== false;
                    },
                    set: function(val1) {
                        this.widgetJson.showInToolbox = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCustomWidget.prototype.init = function() {
                    if (this.widgetJson.init) this.widgetJson.init();
                };
                QuestionCustomWidget.prototype.activatedByChanged = function(activatedBy) {
                    if (this.isLibraryLoaded() && this.widgetJson.activatedByChanged) this.widgetJson.activatedByChanged(activatedBy);
                };
                QuestionCustomWidget.prototype.isLibraryLoaded = function() {
                    if (this.widgetJson.widgetIsLoaded) return this.widgetJson.widgetIsLoaded() == true;
                    return true;
                };
                Object.defineProperty(QuestionCustomWidget.prototype, "isDefaultRender", {
                    get: function() {
                        return this.widgetJson.isDefaultRender;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCustomWidget.prototype, "pdfQuestionType", {
                    get: function() {
                        return this.widgetJson.pdfQuestionType;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCustomWidget.prototype, "pdfRender", {
                    get: function() {
                        return this.widgetJson.pdfRender;
                    },
                    enumerable: false,
                    configurable: true
                });
                return QuestionCustomWidget;
            }();
            var CustomWidgetCollection = /** @class */ function() {
                function CustomWidgetCollection() {
                    this.widgetsValues = [];
                    this.widgetsActivatedBy = {};
                    this.onCustomWidgetAdded = new _base__WEBPACK_IMPORTED_MODULE_0__["Event"]();
                }
                Object.defineProperty(CustomWidgetCollection.prototype, "widgets", {
                    get: function() {
                        return this.widgetsValues;
                    },
                    enumerable: false,
                    configurable: true
                });
                CustomWidgetCollection.prototype.add = function(widgetJson, activatedBy) {
                    if (activatedBy === void 0) activatedBy = "property";
                    this.addCustomWidget(widgetJson, activatedBy);
                };
                CustomWidgetCollection.prototype.addCustomWidget = function(widgetJson, activatedBy) {
                    if (activatedBy === void 0) activatedBy = "property";
                    var name = widgetJson.name;
                    if (!name) name = "widget_" + this.widgets.length + 1;
                    var customWidget = new QuestionCustomWidget(name, widgetJson);
                    this.widgetsValues.push(customWidget);
                    customWidget.init();
                    this.widgetsActivatedBy[name] = activatedBy;
                    customWidget.activatedByChanged(activatedBy);
                    this.onCustomWidgetAdded.fire(customWidget, null);
                    return customWidget;
                };
                /**
     * Returns the way the custom wiget is activated. It can be activated by a property ("property"), question type ("type") or by new/custom question type ("customtype").
     * @param widgetName the custom widget name
     * @see setActivatedBy
     */ CustomWidgetCollection.prototype.getActivatedBy = function(widgetName) {
                    var res = this.widgetsActivatedBy[widgetName];
                    return res ? res : "property";
                };
                /**
     * Sets the way the custom wiget is activated. The activation types are: property ("property"), question type ("type") or new/custom question type ("customtype"). A custom wiget may support all or only some of this activation types.
     * @param widgetName
     * @param activatedBy there are three possible variants: "property", "type" and "customtype"
     */ CustomWidgetCollection.prototype.setActivatedBy = function(widgetName, activatedBy) {
                    if (!widgetName || !activatedBy) return;
                    var widget = this.getCustomWidgetByName(widgetName);
                    if (!widget) return;
                    this.widgetsActivatedBy[widgetName] = activatedBy;
                    widget.activatedByChanged(activatedBy);
                };
                CustomWidgetCollection.prototype.clear = function() {
                    this.widgetsValues = [];
                };
                CustomWidgetCollection.prototype.getCustomWidgetByName = function(name) {
                    for(var i = 0; i < this.widgets.length; i++){
                        if (this.widgets[i].name == name) return this.widgets[i];
                    }
                    return null;
                };
                CustomWidgetCollection.prototype.getCustomWidget = function(question) {
                    for(var i = 0; i < this.widgetsValues.length; i++){
                        if (this.widgetsValues[i].isFit(question)) return this.widgetsValues[i];
                    }
                    return null;
                };
                CustomWidgetCollection.Instance = new CustomWidgetCollection();
                return CustomWidgetCollection;
            }();
        /***/ },
        /***/ "./src/question_baseselect.ts": /*!************************************!*\
  !*** ./src/question_baseselect.ts ***!
  \************************************/ /*! exports provided: QuestionSelectBase, QuestionCheckboxBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionSelectBase", function() {
                return QuestionSelectBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionCheckboxBase", function() {
                return QuestionCheckboxBase;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _survey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./survey */ "./src/survey.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _choicesRestful__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./choicesRestful */ "./src/choicesRestful.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A base class for multiple-choice question types ([Checkboxes](https://surveyjs.io/form-library/documentation/questioncheckboxmodel), [Dropdown](https://surveyjs.io/form-library/documentation/questiondropdownmodel), [Radio Button Group](https://surveyjs.io/form-library/documentation/questionradiogroupmodel), etc.).
 */ var QuestionSelectBase = /** @class */ function(_super) {
                __extends(QuestionSelectBase, _super);
                function QuestionSelectBase(name) {
                    var _this = _super.call(this, name) || this;
                    _this.otherItemValue = new _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"]("other");
                    _this.isSettingDefaultValue = false;
                    _this.isSettingComment = false;
                    _this.isRunningChoices = false;
                    _this.isFirstLoadChoicesFromUrl = true;
                    _this.isUpdatingChoicesDependedQuestions = false;
                    _this.headItemsCount = 0;
                    _this.footItemsCount = 0;
                    _this.prevIsOtherSelected = false;
                    _this.noneItemValue = _this.createDefaultItem(_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].noneItemValue, "noneText", "noneItemText");
                    _this.refuseItemValue = _this.createDefaultItem(_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].refuseItemValue, "refuseText", "refuseItemText");
                    _this.dontKnowItemValue = _this.createDefaultItem(_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].dontKnowItemValue, "dontKnowText", "dontKnowItemText");
                    _this.createItemValues("choices");
                    _this.registerPropertyChangedHandlers([
                        "choices"
                    ], function() {
                        if (!_this.filterItems()) _this.onVisibleChoicesChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "choicesFromQuestion",
                        "choicesFromQuestionMode",
                        "choiceValuesFromQuestion",
                        "choiceTextsFromQuestion",
                        "showNoneItem",
                        "showRefuseItem",
                        "showDontKnowItem",
                        "isUsingRestful",
                        "isMessagePanelVisible"
                    ], function() {
                        _this.onVisibleChoicesChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "hideIfChoicesEmpty"
                    ], function() {
                        _this.onVisibleChanged();
                    });
                    _this.createNewArray("visibleChoices");
                    _this.setNewRestfulProperty();
                    var locOtherText = _this.createLocalizableString("otherText", _this.otherItemValue, true, "otherItemText");
                    _this.createLocalizableString("otherErrorText", _this, true, "otherRequiredError");
                    _this.otherItemValue.locOwner = _this;
                    _this.otherItemValue.setLocText(locOtherText);
                    _this.choicesByUrl.createItemValue = function(value) {
                        return _this.createItemValue(value);
                    };
                    _this.choicesByUrl.beforeSendRequestCallback = function() {
                        _this.onBeforeSendRequest();
                    };
                    _this.choicesByUrl.getResultCallback = function(items) {
                        _this.onLoadChoicesFromUrl(items);
                    };
                    _this.choicesByUrl.updateResultCallback = function(items, serverResult) {
                        if (_this.survey) return _this.survey.updateChoicesFromServer(_this, items, serverResult);
                        return items;
                    };
                    return _this;
                }
                Object.defineProperty(QuestionSelectBase.prototype, "waitingChoicesByURL", {
                    get: function() {
                        return !this.isChoicesLoaded && this.hasChoicesUrl;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.getType = function() {
                    return "selectbase";
                };
                QuestionSelectBase.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    var q = this.getQuestionWithChoices();
                    if (!!q) q.removeDependedQuestion(this);
                };
                QuestionSelectBase.prototype.resetDependedQuestion = function() {
                    this.choicesFromQuestion = "";
                };
                Object.defineProperty(QuestionSelectBase.prototype, "otherId", {
                    get: function() {
                        return this.id + "_other";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.getCommentElementsId = function() {
                    return [
                        this.commentId,
                        this.otherId
                    ];
                };
                QuestionSelectBase.prototype.getItemValueType = function() {
                    return "itemvalue";
                };
                QuestionSelectBase.prototype.createItemValue = function(value, text) {
                    var res = _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].createClass(this.getItemValueType(), value);
                    res.locOwner = this;
                    if (!!text) res.text = text;
                    return res;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "isUsingCarryForward", {
                    get: function() {
                        return !!this.carryForwardQuestionType;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "carryForwardQuestionType", {
                    get: function() {
                        return this.getPropertyValue("carryForwardQuestionType");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.setCarryForwardQuestionType = function(selBaseQuestion, arrayQuestion) {
                    var mode = selBaseQuestion ? "select" : arrayQuestion ? "array" : undefined;
                    this.setPropertyValue("carryForwardQuestionType", mode);
                };
                Object.defineProperty(QuestionSelectBase.prototype, "isUsingRestful", {
                    get: function() {
                        return this.getPropertyValueWithoutDefault("isUsingRestful") || false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.updateIsUsingRestful = function() {
                    this.setPropertyValueDirectly("isUsingRestful", this.hasChoicesUrl);
                };
                QuestionSelectBase.prototype.supportGoNextPageError = function() {
                    return !this.isOtherSelected || !!this.otherValue;
                };
                QuestionSelectBase.prototype.isLayoutTypeSupported = function(layoutType) {
                    return true;
                };
                QuestionSelectBase.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    if (this.choicesOrder !== "none") {
                        this.updateVisibleChoices();
                        this.onVisibleChoicesChanged();
                    }
                };
                QuestionSelectBase.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    if (!!this.choicesFromUrl) {
                        _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].locStrsChanged(this.choicesFromUrl);
                        _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].locStrsChanged(this.visibleChoices);
                    }
                };
                Object.defineProperty(QuestionSelectBase.prototype, "otherValue", {
                    get: function() {
                        if (!this.showCommentArea) return this.comment;
                        return this.otherValueCore;
                    },
                    set: function(val1) {
                        if (!this.showCommentArea) this.comment = val1;
                        else this.setOtherValueInternally(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "otherValueCore", {
                    get: function() {
                        return this.getPropertyValue("otherValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("otherValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "otherItem", {
                    /**
         * Returns the "Other" choice item. Use this property to change the item's `value` or `text`.
         * @see showOtherItem
         */ get: function() {
                        return this.otherItemValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "isOtherSelected", {
                    /**
         * Returns `true` if the "Other" choice item is selected.
         * @see showOtherItem
         */ get: function() {
                        return this.hasOther && this.getHasOther(this.renderedValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "isNoneSelected", {
                    get: function() {
                        return this.showNoneItem && this.getIsItemValue(this.renderedValue, this.noneItem);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "showNoneItem", {
                    /**
         * Specifies whether to display the "None" choice item.
         *
         * When users select the "None" item in multi-select questions, all other items become unselected.
         * @see noneItem
         * @see noneText
         * @see [settings.noneItemValue](https://surveyjs.io/form-library/documentation/api-reference/settings#noneItemValue)
         * @see [settings.specialChoicesOrder](https://surveyjs.io/form-library/documentation/api-reference/settings#specialChoicesOrder)
         */ get: function() {
                        return this.getPropertyValue("showNoneItem");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showNoneItem", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "hasNone", {
                    get: function() {
                        return this.showNoneItem;
                    },
                    set: function(val1) {
                        this.showNoneItem = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "noneItem", {
                    /**
         * Returns the "None" choice item. Use this property to change the item's `value` or `text`.
         * @see showNoneItem
         */ get: function() {
                        return this.noneItemValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "noneText", {
                    /**
         * Gets or sets a caption for the "None" choice item.
         * @see showNoneItem
         */ get: function() {
                        return this.getLocalizableStringText("noneText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("noneText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "locNoneText", {
                    get: function() {
                        return this.getLocalizableString("noneText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "showRefuseItem", {
                    /**
         * Specifies whether to display the "Refuse to answer" choice item.
         *
         * When users select the "Refuse to answer" item in multi-select questions, all other items become unselected.
         * @see refuseItem
         * @see refuseItemText
         * @see [settings.refuseItemValue](https://surveyjs.io/form-library/documentation/api-reference/settings#refuseItemValue)
         * @see [settings.specialChoicesOrder](https://surveyjs.io/form-library/documentation/api-reference/settings#specialChoicesOrder)
         */ get: function() {
                        return this.getPropertyValue("showRefuseItem");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showRefuseItem", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "refuseItem", {
                    /**
         * Returns the "Refuse to answer" choice item. Use this property to change the item's `value` or `text`.
         * @see showRefuseItem
         */ get: function() {
                        return this.refuseItemValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "refuseText", {
                    /**
         * Gets or sets a caption for the "Refuse to answer" choice item.
         * @see showRefuseItem
         */ get: function() {
                        return this.getLocalizableStringText("refuseText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("refuseText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "locRefuseText", {
                    get: function() {
                        return this.getLocalizableString("refuseText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "showDontKnowItem", {
                    /**
         * Specifies whether to display the "Don't know" choice item.
         *
         * When users select the "Don't know" item in multi-select questions, all other items become unselected.
         * @see dontKnowItem
         * @see dontKnowItemText
         * @see [settings.dontKnowItemValue](https://surveyjs.io/form-library/documentation/api-reference/settings#dontKnowItemValue)
         * @see [settings.specialChoicesOrder](https://surveyjs.io/form-library/documentation/api-reference/settings#specialChoicesOrder)
         */ get: function() {
                        return this.getPropertyValue("showDontKnowItem");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showDontKnowItem", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "dontKnowItem", {
                    /**
         * Returns the "Don't know" choice item. Use this property to change the item's `value` or `text`.
         * @see showDontKnowItem
         */ get: function() {
                        return this.dontKnowItemValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "dontKnowText", {
                    /**
         * Gets or sets a caption for the "Don't know" choice item.
         * @see showDontKnowItem
         */ get: function() {
                        return this.getLocalizableStringText("dontKnowText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("dontKnowText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "locDontKnowText", {
                    get: function() {
                        return this.getLocalizableString("dontKnowText");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.createDefaultItem = function(defaultValue, name, locName) {
                    var item = new _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"](defaultValue);
                    var locStr = this.createLocalizableString(name, item, true, locName);
                    item.locOwner = this;
                    item.setLocText(locStr);
                    return item;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "choicesVisibleIf", {
                    /**
         * A Boolean expression that is evaluated against each choice item. If the expression evaluates to `false`, the choice item becomes hidden.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Use the `{item}` placeholder to reference the current choice item in the expression.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see visibleIf
         * @see choicesEnableIf
         */ get: function() {
                        return this.getPropertyValue("choicesVisibleIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("choicesVisibleIf", val1);
                        this.filterItems();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "choicesEnableIf", {
                    /**
         * A Boolean expression that is evaluated against each choice item. If the expression evaluates to `false`, the choice item becomes read-only.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Use the `{item}` placeholder to reference the current choice item in the expression.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see enableIf
         * @see choicesVisibleIf
         */ get: function() {
                        return this.getPropertyValue("choicesEnableIf", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("choicesEnableIf", val1);
                        this.filterItems();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.surveyChoiceItemVisibilityChange = function() {
                    this.filterItems();
                };
                QuestionSelectBase.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    this.runItemsEnableCondition(values, properties);
                    this.runItemsCondition(values, properties);
                };
                QuestionSelectBase.prototype.isTextValue = function() {
                    return true; //for comments and others
                };
                QuestionSelectBase.prototype.setDefaultValue = function() {
                    this.isSettingDefaultValue = !this.isValueEmpty(this.defaultValue) && this.hasUnknownValue(this.defaultValue);
                    this.prevOtherValue = undefined;
                    var prevComment = this.comment;
                    _super.prototype.setDefaultValue.call(this);
                    this.isSettingDefaultValue = false;
                    if (this.comment && this.getStoreOthersAsComment() && prevComment !== this.comment) {
                        this.setValueCore(this.setOtherValueIntoValue(this.value));
                        this.setCommentIntoData(this.comment);
                    }
                };
                QuestionSelectBase.prototype.getIsMultipleValue = function() {
                    return false;
                };
                QuestionSelectBase.prototype.convertDefaultValue = function(val1) {
                    if (val1 == null || val1 == undefined) return val1;
                    if (this.getIsMultipleValue()) {
                        if (!Array.isArray(val1)) return [
                            val1
                        ];
                    } else {
                        if (Array.isArray(val1) && val1.length > 0) return val1[0];
                    }
                    return val1;
                };
                QuestionSelectBase.prototype.filterItems = function() {
                    if (this.isLoadingFromJson || !this.data || this.areInvisibleElementsShowing) return false;
                    var values = this.getDataFilteredValues();
                    var properties = this.getDataFilteredProperties();
                    this.runItemsEnableCondition(values, properties);
                    return this.runItemsCondition(values, properties);
                };
                QuestionSelectBase.prototype.runItemsCondition = function(values, properties) {
                    this.setConditionalChoicesRunner();
                    var hasChanges = this.runConditionsForItems(values, properties);
                    if (!!this.filteredChoicesValue && this.filteredChoicesValue.length === this.activeChoices.length) this.filteredChoicesValue = undefined;
                    if (hasChanges) {
                        this.onVisibleChoicesChanged();
                        this.clearIncorrectValues();
                    }
                    return hasChanges;
                };
                QuestionSelectBase.prototype.runItemsEnableCondition = function(values, properties) {
                    var _this = this;
                    this.setConditionalEnableChoicesRunner();
                    var hasChanged = _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].runEnabledConditionsForItems(this.activeChoices, this.conditionChoicesEnableIfRunner, values, properties, function(item, val1) {
                        return val1 && _this.onEnableItemCallBack(item);
                    });
                    if (hasChanged) this.clearDisabledValues();
                    this.onAfterRunItemsEnableCondition();
                };
                QuestionSelectBase.prototype.onAfterRunItemsEnableCondition = function() {};
                QuestionSelectBase.prototype.onEnableItemCallBack = function(item) {
                    return true;
                };
                QuestionSelectBase.prototype.onSelectedItemValuesChangedHandler = function(newValue) {
                    var _a;
                    (_a = this.survey) === null || _a === void 0 || _a.loadedChoicesFromServer(this);
                };
                QuestionSelectBase.prototype.getItemIfChoicesNotContainThisValue = function(value, text) {
                    if (this.waitingChoicesByURL) return this.createItemValue(value, text);
                    else return null;
                };
                QuestionSelectBase.prototype.getSingleSelectedItem = function() {
                    var selectedItemValues = this.selectedItemValues;
                    if (this.isEmpty()) return null;
                    var itemValue = _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getItemByValue(this.visibleChoices, this.value);
                    this.onGetSingleSelectedItem(itemValue);
                    if (!itemValue && (!selectedItemValues || this.value != selectedItemValues.id)) this.updateSelectedItemValues();
                    return itemValue || selectedItemValues || (this.isOtherSelected ? this.otherItem : this.getItemIfChoicesNotContainThisValue(this.value));
                };
                QuestionSelectBase.prototype.onGetSingleSelectedItem = function(selectedItemByValue) {};
                QuestionSelectBase.prototype.getMultipleSelectedItems = function() {
                    return [];
                };
                QuestionSelectBase.prototype.setConditionalChoicesRunner = function() {
                    if (this.choicesVisibleIf) {
                        if (!this.conditionChoicesVisibleIfRunner) this.conditionChoicesVisibleIfRunner = new _conditions__WEBPACK_IMPORTED_MODULE_7__["ConditionRunner"](this.choicesVisibleIf);
                        this.conditionChoicesVisibleIfRunner.expression = this.choicesVisibleIf;
                    } else this.conditionChoicesVisibleIfRunner = null;
                };
                QuestionSelectBase.prototype.setConditionalEnableChoicesRunner = function() {
                    if (this.choicesEnableIf) {
                        if (!this.conditionChoicesEnableIfRunner) this.conditionChoicesEnableIfRunner = new _conditions__WEBPACK_IMPORTED_MODULE_7__["ConditionRunner"](this.choicesEnableIf);
                        this.conditionChoicesEnableIfRunner.expression = this.choicesEnableIf;
                    } else this.conditionChoicesEnableIfRunner = null;
                };
                QuestionSelectBase.prototype.canSurveyChangeItemVisibility = function() {
                    return !!this.survey && this.survey.canChangeChoiceItemsVisibility();
                };
                QuestionSelectBase.prototype.changeItemVisisbility = function() {
                    var _this = this;
                    return this.canSurveyChangeItemVisibility() ? function(item, val1) {
                        return _this.survey.getChoiceItemVisibility(_this, item, val1);
                    } : null;
                };
                QuestionSelectBase.prototype.runConditionsForItems = function(values, properties) {
                    this.filteredChoicesValue = [];
                    var calcVisibility = this.changeItemVisisbility();
                    return _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].runConditionsForItems(this.activeChoices, this.getFilteredChoices(), this.areInvisibleElementsShowing ? null : this.conditionChoicesVisibleIfRunner, values, properties, !this.survey || !this.survey.areInvisibleElementsShowing, function(item, val1) {
                        return !!calcVisibility ? calcVisibility(item, val1) : val1;
                    });
                };
                QuestionSelectBase.prototype.getHasOther = function(val1) {
                    return this.getIsItemValue(val1, this.otherItem);
                };
                QuestionSelectBase.prototype.getIsItemValue = function(val1, item) {
                    return val1 === item.value;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "validatedValue", {
                    get: function() {
                        return this.rendredValueToDataCore(this.value);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.createRestful = function() {
                    return new _choicesRestful__WEBPACK_IMPORTED_MODULE_6__["ChoicesRestful"]();
                };
                QuestionSelectBase.prototype.setNewRestfulProperty = function() {
                    this.setPropertyValue("choicesByUrl", this.createRestful());
                    this.choicesByUrl.owner = this;
                    this.choicesByUrl.loadingOwner = this;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "autoOtherMode", {
                    get: function() {
                        return this.getPropertyValue("autoOtherMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("autoOtherMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.getQuestionComment = function() {
                    if (this.showCommentArea) return _super.prototype.getQuestionComment.call(this);
                    if (!!this.otherValueCore) return this.otherValueCore;
                    if (this.hasComment || this.getStoreOthersAsComment()) return _super.prototype.getQuestionComment.call(this);
                    return this.otherValueCore;
                };
                QuestionSelectBase.prototype.selectOtherValueFromComment = function(val1) {
                    this.value = val1 ? this.otherItem.value : undefined;
                };
                QuestionSelectBase.prototype.setQuestionComment = function(newValue) {
                    if (this.showCommentArea) {
                        _super.prototype.setQuestionComment.call(this, newValue);
                        return;
                    }
                    this.onUpdateCommentOnAutoOtherMode(newValue);
                    if (this.getStoreOthersAsComment()) _super.prototype.setQuestionComment.call(this, newValue);
                    else this.setOtherValueInternally(newValue);
                    this.updateChoicesDependedQuestions();
                };
                QuestionSelectBase.prototype.onUpdateCommentOnAutoOtherMode = function(newValue) {
                    if (!this.autoOtherMode) return;
                    this.prevOtherValue = undefined;
                    var isSelected = this.isOtherSelected;
                    if (!isSelected && !!newValue || isSelected && !newValue) this.selectOtherValueFromComment(!!newValue);
                };
                QuestionSelectBase.prototype.setOtherValueInternally = function(newValue) {
                    if (!this.isSettingComment && newValue != this.otherValueCore) {
                        this.isSettingComment = true;
                        this.otherValueCore = newValue;
                        if (this.isOtherSelected && !this.isRenderedValueSetting) this.value = this.rendredValueToData(this.renderedValue);
                        this.isSettingComment = false;
                    }
                };
                QuestionSelectBase.prototype.clearValue = function() {
                    _super.prototype.clearValue.call(this);
                    this.prevOtherValue = undefined;
                };
                QuestionSelectBase.prototype.updateCommentFromSurvey = function(newValue) {
                    _super.prototype.updateCommentFromSurvey.call(this, newValue);
                    this.prevOtherValue = undefined;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "renderedValue", {
                    get: function() {
                        return this.getPropertyValue("renderedValue", null);
                    },
                    set: function(val1) {
                        this.setPropertyValue("renderedValue", val1);
                        var val1 = this.rendredValueToData(val1);
                        if (!this.isTwoValueEquals(val1, this.value)) this.value = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.setQuestionValue = function(newValue, updateIsAnswered, updateComment) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    if (updateComment === void 0) updateComment = true;
                    if (this.isLoadingFromJson || this.isTwoValueEquals(this.value, newValue)) return;
                    _super.prototype.setQuestionValue.call(this, newValue, updateIsAnswered);
                    this.setPropertyValue("renderedValue", this.rendredValueFromData(newValue));
                    this.updateChoicesDependedQuestions();
                    if (this.hasComment || !updateComment) return;
                    var isOtherSel = this.isOtherSelected;
                    if (isOtherSel && !!this.prevOtherValue) {
                        var oldOtherValue = this.prevOtherValue;
                        this.prevOtherValue = undefined;
                        this.otherValue = oldOtherValue;
                    }
                    if (!isOtherSel && !!this.otherValue) {
                        if (this.getStoreOthersAsComment() && !this.autoOtherMode) this.prevOtherValue = this.otherValue;
                        this.makeCommentEmpty = true;
                        this.otherValueCore = "";
                        this.setPropertyValue("comment", "");
                    }
                };
                QuestionSelectBase.prototype.setValueCore = function(newValue) {
                    _super.prototype.setValueCore.call(this, newValue);
                    if (this.makeCommentEmpty) {
                        this.setCommentIntoData("");
                        this.makeCommentEmpty = false;
                    }
                };
                QuestionSelectBase.prototype.setNewValue = function(newValue) {
                    newValue = this.valueFromData(newValue);
                    if (!this.choicesByUrl.isRunning && !this.choicesByUrl.isWaitingForParameters || !this.isValueEmpty(newValue)) this.cachedValueForUrlRequests = newValue;
                    _super.prototype.setNewValue.call(this, newValue);
                };
                QuestionSelectBase.prototype.valueFromData = function(val1) {
                    var choiceitem = _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getItemByValue(this.activeChoices, val1);
                    if (!!choiceitem) return choiceitem.value;
                    return _super.prototype.valueFromData.call(this, val1);
                };
                QuestionSelectBase.prototype.rendredValueFromData = function(val1) {
                    if (this.getStoreOthersAsComment()) return val1;
                    return this.renderedValueFromDataCore(val1);
                };
                QuestionSelectBase.prototype.rendredValueToData = function(val1) {
                    if (this.getStoreOthersAsComment()) return val1;
                    return this.rendredValueToDataCore(val1);
                };
                QuestionSelectBase.prototype.renderedValueFromDataCore = function(val1) {
                    if (!this.hasUnknownValue(val1, true, false)) return this.valueFromData(val1);
                    this.otherValue = val1;
                    return this.otherItem.value;
                };
                QuestionSelectBase.prototype.rendredValueToDataCore = function(val1) {
                    if (val1 == this.otherItem.value && this.needConvertRenderedOtherToDataValue()) val1 = this.otherValue;
                    return val1;
                };
                QuestionSelectBase.prototype.needConvertRenderedOtherToDataValue = function() {
                    var val1 = this.otherValue;
                    if (!val1) return false;
                    val1 = val1.trim();
                    if (!val1) return false;
                    return this.hasUnknownValue(val1, true, false);
                };
                QuestionSelectBase.prototype.getIsQuestionReady = function() {
                    return _super.prototype.getIsQuestionReady.call(this) && !this.waitingChoicesByURL && !this.waitingGetChoiceDisplayValueResponse;
                };
                QuestionSelectBase.prototype.updateSelectedItemValues = function() {
                    var _this = this;
                    if (this.waitingGetChoiceDisplayValueResponse || !this.survey || this.isEmpty()) return;
                    var value = this.value;
                    var valueArray = Array.isArray(value) ? value : [
                        value
                    ];
                    var hasItemWithoutValues = valueArray.some(function(val1) {
                        return !_itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getItemByValue(_this.choices, val1);
                    });
                    if (hasItemWithoutValues && (this.choicesLazyLoadEnabled || this.hasChoicesUrl)) {
                        this.waitingGetChoiceDisplayValueResponse = true;
                        this.updateIsReady();
                        this.survey.getChoiceDisplayValue({
                            question: this,
                            values: valueArray,
                            setItems: function(displayValues) {
                                var customValues = [];
                                for(var _i = 1; _i < arguments.length; _i++)customValues[_i - 1] = arguments[_i];
                                _this.waitingGetChoiceDisplayValueResponse = false;
                                if (!displayValues || !displayValues.length) {
                                    _this.updateIsReady();
                                    return;
                                }
                                var items = displayValues.map(function(displayValue, index) {
                                    return _this.createItemValue(valueArray[index], displayValue);
                                });
                                _this.setCustomValuesIntoItems(items, customValues);
                                if (Array.isArray(value)) _this.selectedItemValues = items;
                                else _this.selectedItemValues = items[0];
                                _this.updateIsReady();
                            }
                        });
                    }
                };
                QuestionSelectBase.prototype.setCustomValuesIntoItems = function(items, customValues) {
                    if (!Array.isArray(customValues) || customValues.length === 0) return;
                    customValues.forEach(function(customValue) {
                        var vals = customValue.values;
                        var propName = customValue.propertyName;
                        if (Array.isArray(vals)) for(var i = 0; i < items.length && i < vals.length; i++)items[i][propName] = vals[i];
                    });
                };
                QuestionSelectBase.prototype.hasUnknownValue = function(val1, includeOther, isFilteredChoices, checkEmptyValue) {
                    if (includeOther === void 0) includeOther = false;
                    if (isFilteredChoices === void 0) isFilteredChoices = true;
                    if (checkEmptyValue === void 0) checkEmptyValue = false;
                    if (!Array.isArray(val1)) return this.hasUnknownValueItem(val1, includeOther, isFilteredChoices, checkEmptyValue);
                    for(var i = 0; i < val1.length; i++){
                        if (this.hasUnknownValueItem(val1, includeOther, isFilteredChoices, checkEmptyValue)) return true;
                    }
                    return false;
                };
                QuestionSelectBase.prototype.hasUnknownValueItem = function(val1, includeOther, isFilteredChoices, checkEmptyValue) {
                    if (includeOther === void 0) includeOther = false;
                    if (isFilteredChoices === void 0) isFilteredChoices = true;
                    if (checkEmptyValue === void 0) checkEmptyValue = false;
                    if (!checkEmptyValue && this.isValueEmpty(val1)) return false;
                    if (includeOther && val1 == this.otherItem.value) return false;
                    if (this.showNoneItem && val1 == this.noneItem.value) return false;
                    if (this.showRefuseItem && val1 == this.refuseItem.value) return false;
                    if (this.showDontKnowItem && val1 == this.dontKnowItem.value) return false;
                    var choices = isFilteredChoices ? this.getFilteredChoices() : this.activeChoices;
                    return _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getItemByValue(choices, val1) == null;
                };
                QuestionSelectBase.prototype.isValueDisabled = function(val1) {
                    var itemValue = _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getItemByValue(this.getFilteredChoices(), val1);
                    return !!itemValue && !itemValue.isEnabled;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "choicesByUrl", {
                    /**
         * Configures access to a RESTful service that returns choice items. Refer to the [`ChoicesRestful`](https://surveyjs.io/form-library/documentation/choicesrestful) class description for more information. You can also specify additional application-wide settings using the [`settings.web`](https://surveyjs.io/form-library/documentation/api-reference/settings#web) object.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/dropdown-menu-load-data-from-restful-service/ (linkStyle))
         * @see choices
         * @see [settings.specialChoicesOrder](https://surveyjs.io/form-library/documentation/api-reference/settings#specialChoicesOrder)
         */ get: function() {
                        return this.getPropertyValue("choicesByUrl");
                    },
                    set: function(val1) {
                        if (!val1) return;
                        this.setNewRestfulProperty();
                        this.choicesByUrl.fromJSON(val1.toJSON());
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "choices", {
                    /**
         * Gets or sets choice items. This property accepts an array of objects with the following structure:
         *
         * ```js
         * {
         *   "value": any, // A unique value to be saved in the survey results.
         *   "text": String, // A display text. This property supports Markdown. When `text` is undefined, `value` is used.
         *   "imageLink": String // A link to the image or video that represents this choice value. Applies only to Image Picker questions.
         *   "customProperty": any // Any property that you find useful.
         * }
         * ```
         *
         * To enable Markdown support for the `text` property, implement Markdown-to-HTML conversion in the [onTextMarkdown](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onTextMarkdown) event handler. For an example, refer to the following demo: [Convert Markdown to HTML with Showdown](https://surveyjs.io/form-library/examples/edit-survey-questions-markdown/).
         *
         * If you add custom properties, refer to the following help topic to learn how to serialize them into JSON: [Add Custom Properties to Property Grid](https://surveyjs.io/survey-creator/documentation/property-grid#add-custom-properties-to-the-property-grid).
         *
         * If you need to specify only the `value` property, you can set the `choices` property to an array of primitive values, for example, `[ "item1", "item2", "item3" ]`. These values are both saved in survey results and used as display text.
         * @see choicesByUrl
         * @see choicesFromQuestion
         * @see [settings.specialChoicesOrder](https://surveyjs.io/form-library/documentation/api-reference/settings#specialChoicesOrder)
         */ get: function() {
                        return this.getPropertyValue("choices");
                    },
                    set: function(newValue) {
                        this.setPropertyValue("choices", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "choicesFromQuestion", {
                    /**
         * Copies choice items from a specified question. Accepts a question name.
         *
         * If you specify this property, the `choices`, `choicesVisibleIf`, `choicesEnableIf`, and `choicesOrder` properties do not apply because their values are copied.
         *
         * In addition, you can specify the `choicesFromQuestionMode` property if you do not want to copy all choice items.
         * @see choicesFromQuestionMode
         * @see choices
         */ get: function() {
                        return this.getPropertyValue("choicesFromQuestion");
                    },
                    set: function(val1) {
                        var question = this.getQuestionWithChoices();
                        this.isLockVisibleChoices = !!question && question.name === val1;
                        if (!!question && question.name !== val1) question.removeDependedQuestion(this);
                        this.setPropertyValue("choicesFromQuestion", val1);
                        this.isLockVisibleChoices = false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "choicesFromQuestionMode", {
                    /**
         * Specifies which choice items to copy from another question. Applies only when the `choicesFromQuestion` property is specified.
         *
         * Possible values:
         *
         * - `"all"` (default) - Copies all choice items.
         * - `"selected"` - Copies only selected choice items.
         * - `"unselected"` - Copies only unselected choice items.
         *
         * Use the `visibleChoices` property to access copied choice items.
         * @see choicesFromQuestion
         * @see visibleChoices
         */ get: function() {
                        return this.getPropertyValue("choicesFromQuestionMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("choicesFromQuestionMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "choiceValuesFromQuestion", {
                    /**
         * Specifies which matrix column or dynamic panel question supplies choice values. Use this property to construct choice items based on cell values in Dynamic Matrix and question values in Dynamic Panel.
         *
         * Each choice item consists of a value saved in survey results and a text displayed in the UI. To construct a choice item, assign the `name` of a Dynamic Matrix or Dynamic Panel to the [`choicesFromQuestion`](#choicesFromQuestion) property and specify which dynamic panel question or matrix column supplies values and which provides texts. Use the `choiceValuesFromQuestion` and [`choiceTextsFromQuestion`](#choiceTextsFromQuestion) properties for this purpose. If a choice text is empty, a choice value is used as a display text and saved in survey results.
         */ get: function() {
                        return this.getPropertyValue("choiceValuesFromQuestion");
                    },
                    set: function(val1) {
                        this.setPropertyValue("choiceValuesFromQuestion", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "choiceTextsFromQuestion", {
                    /**
         * Specifies which matrix column or dynamic panel question supplies choice texts. Use this property to construct choice items based on cell values in Dynamic Matrix and question values in Dynamic Panel.
         *
         * Each choice item consists of a value saved in survey results and a text displayed in the UI. To construct a choice item, assign the `name` of a Dynamic Matrix or Dynamic Panel to the [`choicesFromQuestion`](#choicesFromQuestion) property and specify which dynamic panel question or matrix column supplies values and which provides texts. Use the [`choiceValuesFromQuestion`](#choiceValuesFromQuestion) and `choiceTextsFromQuestion` properties for this purpose. If a choice text is empty, a choice value is used as a display text and saved in survey results.
         */ get: function() {
                        return this.getPropertyValue("choiceTextsFromQuestion");
                    },
                    set: function(val1) {
                        this.setPropertyValue("choiceTextsFromQuestion", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "hideIfChoicesEmpty", {
                    /**
         * Specifies whether to hide the question if no choice items are visible.
         *
         * This property is useful if you show or hide choice items at runtime based on a [condition](https://surveyjs.io/form-library/documentation/questionselectbase#choicesVisibleIf).
         */ get: function() {
                        return this.getPropertyValue("hideIfChoicesEmpty");
                    },
                    set: function(val1) {
                        this.setPropertyValue("hideIfChoicesEmpty", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "keepIncorrectValues", {
                    /**
         * Specifies whether to keep values that cannot be assigned to this question, for example, choices unlisted in the `choices` array.
         *
         * > This property cannot be specified in the survey JSON schema. Use dot notation to specify it.
         * @see clearIncorrectValues
         */ get: function() {
                        return this.getPropertyValue("keepIncorrectValues", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("keepIncorrectValues", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "storeOthersAsComment", {
                    get: function() {
                        return this.getPropertyValue("storeOthersAsComment");
                    },
                    set: function(val1) {
                        this.setPropertyValue("storeOthersAsComment", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.hasOtherChanged = function() {
                    this.onVisibleChoicesChanged();
                };
                Object.defineProperty(QuestionSelectBase.prototype, "choicesOrder", {
                    /**
         * Specifies the sort order of choice items.
         *
         * Possible values:
         *
         * - `"none"` (default) - Preserves the original order of choice items.
         * - `"asc"`- Sorts choice items in ascending order.
         * - `"desc"`- Sorts choice items in ascending order.
         * - `"random"` - Displays choice items in random order.
         * @see [settings.specialChoicesOrder](https://surveyjs.io/form-library/documentation/api-reference/settings#specialChoicesOrder)
         */ get: function() {
                        return this.getPropertyValue("choicesOrder");
                    },
                    set: function(val1) {
                        val1 = val1.toLowerCase();
                        if (val1 == this.choicesOrder) return;
                        this.setPropertyValue("choicesOrder", val1);
                        this.onVisibleChoicesChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "otherText", {
                    /**
         * Gets or sets a caption for the "Other" choice item.
         * @see showOtherItem
         */ get: function() {
                        return this.getLocalizableStringText("otherText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("otherText", val1);
                        this.onVisibleChoicesChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "locOtherText", {
                    get: function() {
                        return this.getLocalizableString("otherText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "otherPlaceHolder", {
                    get: function() {
                        return this.otherPlaceholder;
                    },
                    set: function(newValue) {
                        this.otherPlaceholder = newValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "otherErrorText", {
                    /**
         * Gets or sets an error message displayed when users select the "Other" choice item but leave the comment area empty.
         * @see showOtherItem
         */ get: function() {
                        return this.getLocalizableStringText("otherErrorText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("otherErrorText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "locOtherErrorText", {
                    get: function() {
                        return this.getLocalizableString("otherErrorText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "visibleChoices", {
                    /**
         * An array of visible choice items. Includes the "Select All", "Other", and "None" choice items if they are visible. Items are sorted according to the `choicesOrder` value.
         * @see showNoneItem
         * @see showOtherItem
         * @see choicesOrder
         * @see choices
         * @see enabledChoices
         */ get: function() {
                        return this.getPropertyValue("visibleChoices");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "enabledChoices", {
                    /**
         * An array of choice items with which users can interact. Includes the "Select All", "Other", and "None" choice items if they are not disabled. Items are sorted according to the `choicesOrder` value.
         * @see showNoneItem
         * @see showOtherItem
         * @see choicesOrder
         * @see choices
         * @see visibleChoices
         */ get: function() {
                        var res = [];
                        var items = this.visibleChoices;
                        for(var i = 0; i < items.length; i++)if (items[i].isEnabled) res.push(items[i]);
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.updateVisibleChoices = function() {
                    if (this.isLoadingFromJson || this.isDisposed) return;
                    var newValue = new Array();
                    var calcValue = this.calcVisibleChoices();
                    if (!calcValue) calcValue = [];
                    for(var i = 0; i < calcValue.length; i++)newValue.push(calcValue[i]);
                    var oldValue = this.visibleChoices;
                    if (!this.isTwoValueEquals(oldValue, newValue) || this.choicesLazyLoadEnabled) this.setArrayPropertyDirectly("visibleChoices", newValue);
                };
                QuestionSelectBase.prototype.calcVisibleChoices = function() {
                    if (this.canUseFilteredChoices()) return this.getFilteredChoices();
                    var res = this.sortVisibleChoices(this.getFilteredChoices().slice());
                    this.addToVisibleChoices(res, this.isAddDefaultItems);
                    return res;
                };
                QuestionSelectBase.prototype.canUseFilteredChoices = function() {
                    return !this.isAddDefaultItems && !this.showNoneItem && !this.showRefuseItem && !this.showDontKnowItem && !this.hasOther && this.choicesOrder == "none";
                };
                QuestionSelectBase.prototype.setCanShowOptionItemCallback = function(func) {
                    this.canShowOptionItemCallback = func;
                    if (!!func) this.onVisibleChoicesChanged();
                };
                Object.defineProperty(QuestionSelectBase.prototype, "newItem", {
                    get: function() {
                        return this.newItemValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.addToVisibleChoices = function(items, isAddAll) {
                    this.headItemsCount = 0;
                    this.footItemsCount = 0;
                    if (!this.isEmptyActiveChoicesInDesign) this.addNewItemToVisibleChoices(items, isAddAll);
                    var dict = new Array();
                    this.addNonChoicesItems(dict, isAddAll);
                    dict.sort(function(a, b) {
                        if (a.index === b.index) return 0;
                        return a.index < b.index ? -1 : 1;
                    });
                    for(var i = 0; i < dict.length; i++){
                        var rec = dict[i];
                        if (rec.index < 0) {
                            items.splice(i, 0, rec.item);
                            this.headItemsCount++;
                        } else {
                            items.push(rec.item);
                            this.footItemsCount++;
                        }
                    }
                };
                QuestionSelectBase.prototype.addNewItemToVisibleChoices = function(items, isAddAll) {
                    if (!isAddAll) return;
                    if (!this.newItemValue) {
                        this.newItemValue = this.createItemValue("newitem"); //TODO
                        this.newItemValue.isGhost = true;
                    }
                    if (!this.isUsingCarryForward && this.canShowOptionItem(this.newItemValue, isAddAll, false)) {
                        this.footItemsCount = 1;
                        items.push(this.newItemValue);
                    }
                };
                QuestionSelectBase.prototype.addNonChoicesItems = function(dict, isAddAll) {
                    if (this.supportNone()) this.addNonChoiceItem(dict, this.noneItem, isAddAll, this.showNoneItem, _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].specialChoicesOrder.noneItem);
                    if (this.supportRefuse()) this.addNonChoiceItem(dict, this.refuseItem, isAddAll, this.showRefuseItem, _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].specialChoicesOrder.refuseItem);
                    if (this.supportDontKnow()) this.addNonChoiceItem(dict, this.dontKnowItem, isAddAll, this.showDontKnowItem, _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].specialChoicesOrder.dontKnowItem);
                    if (this.supportOther()) this.addNonChoiceItem(dict, this.otherItem, isAddAll, this.hasOther, _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].specialChoicesOrder.otherItem);
                };
                QuestionSelectBase.prototype.addNonChoiceItem = function(dict, item, isAddAll, showItem, order) {
                    if (this.canShowOptionItem(item, isAddAll, showItem)) order.forEach(function(val1) {
                        return dict.push({
                            index: val1,
                            item: item
                        });
                    });
                };
                QuestionSelectBase.prototype.canShowOptionItem = function(item, isAddAll, hasItem) {
                    var res = isAddAll && (!!this.canShowOptionItemCallback ? this.canShowOptionItemCallback(item) : true) || hasItem;
                    if (this.canSurveyChangeItemVisibility()) {
                        var calc = this.changeItemVisisbility();
                        return calc(item, res);
                    }
                    return res;
                };
                QuestionSelectBase.prototype.isItemInList = function(item) {
                    if (item === this.otherItem) return this.hasOther;
                    if (item === this.noneItem) return this.showNoneItem;
                    if (item === this.refuseItem) return this.showRefuseItem;
                    if (item === this.dontKnowItem) return this.showDontKnowItem;
                    if (item === this.newItemValue) return false;
                    return true;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "isAddDefaultItems", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].showDefaultItemsInCreatorV2 && this.isDesignModeV2 && !this.customWidget && !this.isContentElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.getPlainData = function(options) {
                    var _this = this;
                    if (options === void 0) options = {
                        includeEmpty: true,
                        includeQuestionTypes: false
                    };
                    var questionPlainData = _super.prototype.getPlainData.call(this, options);
                    if (!!questionPlainData) {
                        var values = Array.isArray(this.value) ? this.value : [
                            this.value
                        ];
                        questionPlainData.isNode = true;
                        questionPlainData.data = (questionPlainData.data || []).concat(values.map(function(dataValue, index) {
                            var choice = _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getItemByValue(_this.visibleChoices, dataValue);
                            var choiceDataItem = {
                                name: index,
                                title: "Choice",
                                value: dataValue,
                                displayValue: _this.getChoicesDisplayValue(_this.visibleChoices, dataValue),
                                getString: function(val1) {
                                    return typeof val1 === "object" ? JSON.stringify(val1) : val1;
                                },
                                isNode: false
                            };
                            if (!!choice) (options.calculations || []).forEach(function(calculation) {
                                choiceDataItem[calculation.propertyName] = choice[calculation.propertyName];
                            });
                            if (_this.isOtherSelected && _this.otherItemValue === choice) {
                                choiceDataItem.isOther = true;
                                choiceDataItem.displayValue = _this.otherValue;
                            }
                            return choiceDataItem;
                        }));
                    }
                    return questionPlainData;
                };
                QuestionSelectBase.prototype.getDisplayValueCore = function(keysAsText, value) {
                    return this.getChoicesDisplayValue(this.visibleChoices, value);
                };
                QuestionSelectBase.prototype.getDisplayValueEmpty = function() {
                    return _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getTextOrHtmlByValue(this.visibleChoices, undefined);
                };
                QuestionSelectBase.prototype.getChoicesDisplayValue = function(items, val1) {
                    if (val1 == this.otherItemValue.value) return this.otherValue ? this.otherValue : this.locOtherText.textOrHtml;
                    var selItem = this.getSingleSelectedItem();
                    if (!!selItem && this.isTwoValueEquals(selItem.value, val1)) return selItem.locText.textOrHtml;
                    var str = _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getTextOrHtmlByValue(items, val1);
                    return str == "" && val1 ? val1 : str;
                };
                QuestionSelectBase.prototype.getDisplayArrayValue = function(keysAsText, value, onGetValueCallback) {
                    var _this = this;
                    var items = this.visibleChoices;
                    var strs = [];
                    var vals = [];
                    for(var i = 0; i < value.length; i++)vals.push(!onGetValueCallback ? value[i] : onGetValueCallback(i));
                    if (_helpers__WEBPACK_IMPORTED_MODULE_8__["Helpers"].isTwoValueEquals(this.value, vals)) this.getMultipleSelectedItems().forEach(function(item, index) {
                        return strs.push(_this.getItemDisplayValue(item, vals[index]));
                    });
                    if (strs.length === 0) for(var i = 0; i < vals.length; i++){
                        var valStr = this.getChoicesDisplayValue(items, vals[i]);
                        if (valStr) strs.push(valStr);
                    }
                    return strs.join(", ");
                };
                QuestionSelectBase.prototype.getItemDisplayValue = function(item, val1) {
                    if (item === this.otherItem) {
                        if (this.hasOther && this.showCommentArea && !!val1) return val1;
                        if (this.comment) return this.comment;
                    }
                    return item.locText.textOrHtml;
                };
                QuestionSelectBase.prototype.getFilteredChoices = function() {
                    return this.filteredChoicesValue ? this.filteredChoicesValue : this.activeChoices;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "activeChoices", {
                    get: function() {
                        var question = this.getCarryForwardQuestion();
                        if (this.carryForwardQuestionType === "select") {
                            question.addDependedQuestion(this);
                            return this.getChoicesFromSelectQuestion(question);
                        }
                        if (this.carryForwardQuestionType === "array") {
                            question.addDependedQuestion(this);
                            return this.getChoicesFromArrayQuestion(question);
                        }
                        if (this.isEmptyActiveChoicesInDesign) return [];
                        return this.choicesFromUrl ? this.choicesFromUrl : this.getChoices();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "isMessagePanelVisible", {
                    get: function() {
                        return this.getPropertyValue("isMessagePanelVisible", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("isMessagePanelVisible", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "isEmptyActiveChoicesInDesign", {
                    get: function() {
                        return this.isDesignModeV2 && (this.hasChoicesUrl || this.isMessagePanelVisible);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.getCarryForwardQuestion = function(data) {
                    var question = this.findCarryForwardQuestion(data);
                    var selBaseQuestion = this.getQuestionWithChoicesCore(question);
                    var arrayQuestion = !selBaseQuestion ? this.getQuestionWithArrayValue(question) : null;
                    this.setCarryForwardQuestionType(!!selBaseQuestion, !!arrayQuestion);
                    return !!selBaseQuestion || !!arrayQuestion ? question : null;
                };
                QuestionSelectBase.prototype.getIsReadyDependsOn = function() {
                    var res = _super.prototype.getIsReadyDependsOn.call(this);
                    if (this.carryForwardQuestion) res.push(this.carryForwardQuestion);
                    return res;
                };
                QuestionSelectBase.prototype.getQuestionWithChoices = function() {
                    return this.getQuestionWithChoicesCore(this.findCarryForwardQuestion());
                };
                QuestionSelectBase.prototype.findCarryForwardQuestion = function(data) {
                    if (!data) data = this.data;
                    this.carryForwardQuestion = null;
                    if (this.choicesFromQuestion && data) this.carryForwardQuestion = data.findQuestionByName(this.choicesFromQuestion);
                    return this.carryForwardQuestion;
                };
                QuestionSelectBase.prototype.getQuestionWithChoicesCore = function(question) {
                    if (!!question && !!question.visibleChoices && _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].isDescendantOf(question.getType(), "selectbase") && question !== this) return question;
                    return null;
                };
                QuestionSelectBase.prototype.getQuestionWithArrayValue = function(question) {
                    return !!question && question.isValueArray ? question : null;
                };
                QuestionSelectBase.prototype.getChoicesFromArrayQuestion = function(question) {
                    if (this.isDesignMode) return [];
                    var val1 = question.value;
                    if (!Array.isArray(val1)) return [];
                    var res = [];
                    for(var i = 0; i < val1.length; i++){
                        var obj = val1[i];
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_8__["Helpers"].isValueObject(obj)) continue;
                        var key = this.getValueKeyName(obj);
                        if (!!key && !this.isValueEmpty(obj[key])) {
                            var text = !!this.choiceTextsFromQuestion ? obj[this.choiceTextsFromQuestion] : undefined;
                            res.push(this.createItemValue(obj[key], text));
                        }
                    }
                    return res;
                };
                QuestionSelectBase.prototype.getValueKeyName = function(obj) {
                    if (this.choiceValuesFromQuestion) return this.choiceValuesFromQuestion;
                    var keys = Object.keys(obj);
                    return keys.length > 0 ? keys[0] : undefined;
                };
                QuestionSelectBase.prototype.getChoicesFromSelectQuestion = function(question) {
                    if (this.isDesignMode) return [];
                    var res = [];
                    var isSelected = this.choicesFromQuestionMode == "selected" ? true : this.choicesFromQuestionMode == "unselected" ? false : undefined;
                    var choices = question.visibleChoices;
                    for(var i = 0; i < choices.length; i++){
                        if (question.isBuiltInChoice(choices[i])) continue;
                        if (isSelected === undefined) {
                            res.push(this.copyChoiceItem(choices[i]));
                            continue;
                        }
                        var itemsSelected = question.isItemSelected(choices[i]);
                        if (itemsSelected && isSelected || !itemsSelected && !isSelected) res.push(this.copyChoiceItem(choices[i]));
                    }
                    if (this.choicesFromQuestionMode === "selected" && !this.showOtherItem && question.isOtherSelected && !!question.comment) res.push(this.createItemValue(question.otherItem.value, question.comment));
                    return res;
                };
                QuestionSelectBase.prototype.copyChoiceItem = function(item) {
                    var res = this.createItemValue(item.value);
                    res.setData(item);
                    return res;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "hasActiveChoices", {
                    get: function() {
                        var choices = this.visibleChoices;
                        if (!choices || choices.length == 0) {
                            this.onVisibleChoicesChanged();
                            choices = this.visibleChoices;
                        }
                        for(var i = 0; i < choices.length; i++){
                            if (!this.isBuiltInChoice(choices[i])) return true;
                        }
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.isBuiltInChoice = function(item) {
                    return this.isNoneItem(item) || item === this.otherItem || item === this.newItemValue;
                };
                QuestionSelectBase.prototype.isNoneItem = function(item) {
                    return this.getNoneItems().indexOf(item) > -1;
                };
                QuestionSelectBase.prototype.getNoneItems = function() {
                    return [
                        this.noneItem,
                        this.refuseItem,
                        this.dontKnowItem
                    ];
                };
                QuestionSelectBase.prototype.getChoices = function() {
                    return this.choices;
                };
                QuestionSelectBase.prototype.supportOther = function() {
                    return this.isSupportProperty("showOtherItem");
                };
                QuestionSelectBase.prototype.supportNone = function() {
                    return this.isSupportProperty("showNoneItem");
                };
                QuestionSelectBase.prototype.supportRefuse = function() {
                    return this.isSupportProperty("showRefuseItem");
                };
                QuestionSelectBase.prototype.supportDontKnow = function() {
                    return this.isSupportProperty("showDontKnowItem");
                };
                QuestionSelectBase.prototype.isSupportProperty = function(propName) {
                    return !this.isDesignMode || this.getPropertyByName(propName).visible;
                };
                QuestionSelectBase.prototype.onCheckForErrors = function(errors, isOnValueChanged) {
                    var _this = this;
                    _super.prototype.onCheckForErrors.call(this, errors, isOnValueChanged);
                    if (!this.hasOther || !this.isOtherSelected || this.otherValue) return;
                    var otherEmptyError = new _error__WEBPACK_IMPORTED_MODULE_5__["OtherEmptyError"](this.otherErrorText, this);
                    otherEmptyError.onUpdateErrorTextCallback = function(err) {
                        err.text = _this.otherErrorText;
                    };
                    errors.push(otherEmptyError);
                };
                QuestionSelectBase.prototype.setSurveyImpl = function(value, isLight) {
                    this.isRunningChoices = true;
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    this.isRunningChoices = false;
                    this.runChoicesByUrl();
                    if (this.isAddDefaultItems) this.updateVisibleChoices();
                };
                QuestionSelectBase.prototype.setSurveyCore = function(value) {
                    _super.prototype.setSurveyCore.call(this, value);
                    if (!!value && !!this.choicesFromQuestion) this.onVisibleChoicesChanged();
                };
                QuestionSelectBase.prototype.getStoreOthersAsComment = function() {
                    if (this.isSettingDefaultValue) return false;
                    if (this.showCommentArea) return false;
                    return this.storeOthersAsComment === true || this.storeOthersAsComment == "default" && (this.survey != null ? this.survey.storeOthersAsComment : true) || this.hasChoicesUrl && !this.choicesFromUrl;
                };
                QuestionSelectBase.prototype.onSurveyLoad = function() {
                    this.runChoicesByUrl();
                    this.onVisibleChoicesChanged();
                    _super.prototype.onSurveyLoad.call(this);
                };
                QuestionSelectBase.prototype.onAnyValueChanged = function(name, questionName) {
                    _super.prototype.onAnyValueChanged.call(this, name, questionName);
                    if (name != this.getValueName()) this.runChoicesByUrl();
                    var chQuestion = this.choicesFromQuestion;
                    if (!!name && chQuestion && (name === chQuestion || questionName === chQuestion)) this.onVisibleChoicesChanged();
                };
                QuestionSelectBase.prototype.updateValueFromSurvey = function(newValue, clearData) {
                    var newComment = "";
                    if (this.hasOther && !this.isRunningChoices && !this.choicesByUrl.isRunning && this.getStoreOthersAsComment()) {
                        if (this.hasUnknownValue(newValue) && !this.getHasOther(newValue)) {
                            newComment = this.getCommentFromValue(newValue);
                            newValue = this.setOtherValueIntoValue(newValue);
                        } else if (this.data) newComment = this.data.getComment(this.getValueName());
                    }
                    _super.prototype.updateValueFromSurvey.call(this, newValue, clearData);
                    if ((this.isRunningChoices || this.choicesByUrl.isRunning) && !this.isEmpty()) this.cachedValueForUrlRequests = this.value;
                    if (!!newComment) this.setNewComment(newComment);
                };
                QuestionSelectBase.prototype.getCommentFromValue = function(newValue) {
                    return newValue;
                };
                QuestionSelectBase.prototype.setOtherValueIntoValue = function(newValue) {
                    return this.otherItem.value;
                };
                QuestionSelectBase.prototype.onOtherValueInput = function(event1) {
                    if (this.isInputTextUpdate) {
                        if (event1.target) this.otherValue = event1.target.value;
                    } else this.updateCommentElements();
                };
                QuestionSelectBase.prototype.onOtherValueChange = function(event1) {
                    this.otherValue = event1.target.value;
                    if (this.otherValue !== event1.target.value) event1.target.value = this.otherValue;
                };
                QuestionSelectBase.prototype.runChoicesByUrl = function() {
                    this.updateIsUsingRestful();
                    if (!this.choicesByUrl || this.isLoadingFromJson || this.isRunningChoices || this.isDesignModeV2) return;
                    var processor = this.surveyImpl ? this.surveyImpl.getTextProcessor() : this.textProcessor;
                    if (!processor) processor = this.survey;
                    if (!processor) return;
                    this.updateIsReady();
                    this.isRunningChoices = true;
                    this.choicesByUrl.run(processor);
                    this.isRunningChoices = false;
                };
                QuestionSelectBase.prototype.onBeforeSendRequest = function() {
                    if (_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].web.disableQuestionWhileLoadingChoices === true && !this.isReadOnly) {
                        this.enableOnLoadingChoices = true;
                        this.readOnly = true;
                    }
                };
                QuestionSelectBase.prototype.onLoadChoicesFromUrl = function(array) {
                    if (this.enableOnLoadingChoices) this.readOnly = false;
                    var errors = [];
                    if (!this.isReadOnly) {
                        if (this.choicesByUrl && this.choicesByUrl.error) errors.push(this.choicesByUrl.error);
                    }
                    var newChoices = null;
                    var checkCachedValuesOnExisting = true;
                    if (this.isFirstLoadChoicesFromUrl && !this.cachedValueForUrlRequests && this.defaultValue) {
                        this.cachedValueForUrlRequests = this.defaultValue;
                        checkCachedValuesOnExisting = false;
                    }
                    if (this.isValueEmpty(this.cachedValueForUrlRequests)) this.cachedValueForUrlRequests = this.value;
                    var cachedValues = this.createCachedValueForUrlRequests(this.cachedValueForUrlRequests, checkCachedValuesOnExisting);
                    if (array && (array.length > 0 || this.choicesByUrl.allowEmptyResponse)) {
                        newChoices = new Array();
                        _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].setData(newChoices, array);
                    }
                    if (!!newChoices) for(var i = 0; i < newChoices.length; i++)newChoices[i].locOwner = this;
                    this.setChoicesFromUrl(newChoices, errors, cachedValues);
                };
                QuestionSelectBase.prototype.canAvoidSettChoicesFromUrl = function(newChoices) {
                    if (this.isFirstLoadChoicesFromUrl) return false;
                    var chocesAreEmpty = !newChoices || Array.isArray(newChoices) && newChoices.length === 0;
                    if (chocesAreEmpty && !this.isEmpty()) return false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_8__["Helpers"].isTwoValueEquals(this.choicesFromUrl, newChoices);
                };
                QuestionSelectBase.prototype.setChoicesFromUrl = function(newChoices, errors, cachedValues) {
                    if (this.canAvoidSettChoicesFromUrl(newChoices)) return;
                    this.isFirstLoadChoicesFromUrl = false;
                    this.choicesFromUrl = newChoices;
                    this.filterItems();
                    this.onVisibleChoicesChanged();
                    if (newChoices) {
                        var newValue = this.updateCachedValueForUrlRequests(cachedValues, newChoices);
                        if (!!newValue && !this.isReadOnly) {
                            var hasChanged = !this.isTwoValueEquals(this.value, newValue.value);
                            try {
                                if (!this.isValueEmpty(newValue.value)) {
                                    this.allowNotifyValueChanged = false;
                                    this.setQuestionValue(undefined, true, false);
                                }
                                this.allowNotifyValueChanged = hasChanged;
                                if (hasChanged) this.value = newValue.value;
                                else this.setQuestionValue(newValue.value);
                            } finally{
                                this.allowNotifyValueChanged = true;
                            }
                        }
                    }
                    if (!this.isReadOnly && !newChoices && !this.isFirstLoadChoicesFromUrl) this.value = null;
                    this.errors = errors;
                    this.choicesLoaded();
                };
                QuestionSelectBase.prototype.createCachedValueForUrlRequests = function(val1, checkOnExisting) {
                    if (this.isValueEmpty(val1)) return null;
                    if (Array.isArray(val1)) {
                        var res = [];
                        for(var i = 0; i < val1.length; i++)res.push(this.createCachedValueForUrlRequests(val1[i], true));
                        return res;
                    }
                    var isExists = checkOnExisting ? !this.hasUnknownValue(val1) : true;
                    return {
                        value: val1,
                        isExists: isExists
                    };
                };
                QuestionSelectBase.prototype.updateCachedValueForUrlRequests = function(val1, newChoices) {
                    if (this.isValueEmpty(val1)) return null;
                    if (Array.isArray(val1)) {
                        var res = [];
                        for(var i = 0; i < val1.length; i++){
                            var updatedValue = this.updateCachedValueForUrlRequests(val1[i], newChoices);
                            if (updatedValue && !this.isValueEmpty(updatedValue.value)) {
                                var newValue = updatedValue.value;
                                var item = _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getItemByValue(newChoices, updatedValue.value);
                                if (!!item) newValue = item.value;
                                res.push(newValue);
                            }
                        }
                        return {
                            value: res
                        };
                    }
                    var value = val1.isExists && this.hasUnknownValue(val1.value) ? null : val1.value;
                    var item = _itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"].getItemByValue(newChoices, value);
                    if (!!item) value = item.value;
                    return {
                        value: value
                    };
                };
                QuestionSelectBase.prototype.updateChoicesDependedQuestions = function() {
                    if (this.isLoadingFromJson || this.isUpdatingChoicesDependedQuestions || !this.allowNotifyValueChanged || this.choicesByUrl.isRunning) return;
                    this.isUpdatingChoicesDependedQuestions = true;
                    this.updateDependedQuestions();
                    this.isUpdatingChoicesDependedQuestions = false;
                };
                QuestionSelectBase.prototype.updateDependedQuestion = function() {
                    this.onVisibleChoicesChanged();
                    this.clearIncorrectValues();
                };
                QuestionSelectBase.prototype.onSurveyValueChanged = function(newValue) {
                    _super.prototype.onSurveyValueChanged.call(this, newValue);
                    this.updateChoicesDependedQuestions();
                };
                QuestionSelectBase.prototype.onVisibleChoicesChanged = function() {
                    if (this.isLoadingFromJson || this.isLockVisibleChoices) return;
                    this.updateVisibleChoices();
                    this.onVisibleChanged();
                    if (!!this.visibleChoicesChangedCallback) this.visibleChoicesChangedCallback();
                    this.updateChoicesDependedQuestions();
                };
                QuestionSelectBase.prototype.isVisibleCore = function() {
                    var superVal = _super.prototype.isVisibleCore.call(this);
                    if (!this.hideIfChoicesEmpty || !superVal) return superVal;
                    var filteredChoices = this.getFilteredChoices();
                    return !filteredChoices || filteredChoices.length > 0;
                };
                QuestionSelectBase.prototype.sortVisibleChoices = function(array) {
                    if (this.isDesignMode) return array;
                    var order = this.choicesOrder.toLowerCase();
                    if (order == "asc") return this.sortArray(array, 1);
                    if (order == "desc") return this.sortArray(array, -1);
                    if (order == "random") return this.randomizeArray(array);
                    return array;
                };
                QuestionSelectBase.prototype.sortArray = function(array, mult) {
                    return array.sort(function(a, b) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_8__["Helpers"].compareStrings(a.calculatedText, b.calculatedText) * mult;
                    });
                };
                QuestionSelectBase.prototype.randomizeArray = function(array) {
                    return _helpers__WEBPACK_IMPORTED_MODULE_8__["Helpers"].randomizeArray(array);
                };
                Object.defineProperty(QuestionSelectBase.prototype, "hasChoicesUrl", {
                    get: function() {
                        return this.choicesByUrl && !!this.choicesByUrl.url;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.clearIncorrectValues = function() {
                    if (!this.hasValueToClearIncorrectValues() || !this.canClearIncorrectValues()) return;
                    if (this.clearIncorrectValuesCallback) this.clearIncorrectValuesCallback();
                    else this.clearIncorrectValuesCore();
                };
                QuestionSelectBase.prototype.canClearIncorrectValues = function() {
                    if (this.carryForwardQuestion && !this.carryForwardQuestion.isReady) return false;
                    if (!!this.survey && this.survey.questionsByValueName(this.getValueName()).length > 1) return false;
                    if (this.hasChoicesUrl && (!this.choicesFromUrl || this.choicesFromUrl.length == 0)) return false;
                    return true;
                };
                QuestionSelectBase.prototype.hasValueToClearIncorrectValues = function() {
                    if (!!this.survey && this.survey.keepIncorrectValues) return false;
                    return !this.keepIncorrectValues && !this.isEmpty();
                };
                QuestionSelectBase.prototype.clearValueIfInvisibleCore = function(reason) {
                    _super.prototype.clearValueIfInvisibleCore.call(this, reason);
                    this.clearIncorrectValues();
                };
                /**
     * Returns `true` if a passed choice item is selected.
     *
     * To obtain a choice item to check, use the `noneItem` or `otherItem` property or the `choices` array.
     * @param item A choice item.
     * @see noneItem
     * @see otherItem
     * @see choices
     */ QuestionSelectBase.prototype.isItemSelected = function(item) {
                    if (item === this.otherItem) return this.isOtherSelected;
                    return this.isItemSelectedCore(item);
                };
                QuestionSelectBase.prototype.isItemSelectedCore = function(item) {
                    return item.value === this.value;
                };
                QuestionSelectBase.prototype.clearDisabledValues = function() {
                    if (!this.survey || !this.survey.clearValueOnDisableItems) return;
                    this.clearDisabledValuesCore();
                };
                QuestionSelectBase.prototype.clearIncorrectValuesCore = function() {
                    var val1 = this.value;
                    if (this.canClearValueAnUnknown(val1)) this.clearValue();
                };
                QuestionSelectBase.prototype.canClearValueAnUnknown = function(val1) {
                    if (!this.getStoreOthersAsComment() && this.isOtherSelected) return false;
                    return this.hasUnknownValue(val1, true, true, true);
                };
                QuestionSelectBase.prototype.clearDisabledValuesCore = function() {
                    if (this.isValueDisabled(this.value)) this.clearValue();
                };
                QuestionSelectBase.prototype.clearUnusedValues = function() {
                    _super.prototype.clearUnusedValues.call(this);
                    if (!this.isOtherSelected) this.otherValue = "";
                    if (!this.showCommentArea && !this.getStoreOthersAsComment() && !this.isOtherSelected) this.comment = "";
                };
                QuestionSelectBase.prototype.getColumnClass = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.column).append("sv-q-column-" + this.colCount, this.hasColumns).toString();
                };
                QuestionSelectBase.prototype.getItemIndex = function(item) {
                    return this.visibleChoices.indexOf(item);
                };
                QuestionSelectBase.prototype.getItemClass = function(item) {
                    var options = {
                        item: item
                    };
                    var res = this.getItemClassCore(item, options);
                    options.css = res;
                    if (!!this.survey) this.survey.updateChoiceItemCss(this, options);
                    return options.css;
                };
                QuestionSelectBase.prototype.getCurrentColCount = function() {
                    return this.colCount;
                };
                QuestionSelectBase.prototype.getItemClassCore = function(item, options) {
                    var builder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.item).append(this.cssClasses.itemInline, !this.hasColumns && this.colCount === 0).append("sv-q-col-" + this.getCurrentColCount(), !this.hasColumns && this.colCount !== 0).append(this.cssClasses.itemOnError, this.hasCssError());
                    var isDisabled = this.isReadOnly || !item.isEnabled;
                    var isChecked = this.isItemSelected(item) || this.isOtherSelected && this.otherItem.value === item.value;
                    var allowHover = !isDisabled && !isChecked && !(!!this.survey && this.survey.isDesignMode);
                    var isNone = item === this.noneItem;
                    options.isDisabled = isDisabled;
                    options.isChecked = isChecked;
                    options.isNone = isNone;
                    return builder.append(this.cssClasses.itemDisabled, isDisabled).append(this.cssClasses.itemChecked, isChecked).append(this.cssClasses.itemHover, allowHover).append(this.cssClasses.itemNone, isNone).toString();
                };
                QuestionSelectBase.prototype.getLabelClass = function(item) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.label).append(this.cssClasses.labelChecked, this.isItemSelected(item)).toString();
                };
                QuestionSelectBase.prototype.getControlLabelClass = function(item) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.controlLabel).append(this.cssClasses.controlLabelChecked, this.isItemSelected(item)).toString() || undefined;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "headItems", {
                    get: function() {
                        var count = this.separateSpecialChoices || this.isDesignMode ? this.headItemsCount : 0;
                        var res = [];
                        for(var i = 0; i < count; i++)res.push(this.visibleChoices[i]);
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "footItems", {
                    get: function() {
                        var count = this.separateSpecialChoices || this.isDesignMode ? this.footItemsCount : 0;
                        var res = [];
                        var items = this.visibleChoices;
                        for(var i = 0; i < count; i++)res.push(items[items.length - count + i]);
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "dataChoices", {
                    get: function() {
                        var _this = this;
                        return this.visibleChoices.filter(function(item) {
                            return !_this.isBuiltInChoice(item);
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "bodyItems", {
                    get: function() {
                        return this.hasHeadItems || this.hasFootItems ? this.dataChoices : this.visibleChoices;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "hasHeadItems", {
                    get: function() {
                        return this.headItems.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "hasFootItems", {
                    get: function() {
                        return this.footItems.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "columns", {
                    get: function() {
                        var columns = [];
                        var colCount = this.getCurrentColCount();
                        if (this.hasColumns && this.visibleChoices.length > 0) {
                            var choicesToBuildColumns = !this.separateSpecialChoices && !this.isDesignMode ? this.visibleChoices : this.dataChoices;
                            if (_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].showItemsInOrder == "column") {
                                var prevIndex = 0;
                                var leftElementsCount = choicesToBuildColumns.length % colCount;
                                for(var i = 0; i < colCount; i++){
                                    var column = [];
                                    for(var j = prevIndex; j < prevIndex + Math.floor(choicesToBuildColumns.length / colCount); j++)column.push(choicesToBuildColumns[j]);
                                    if (leftElementsCount > 0) {
                                        leftElementsCount--;
                                        column.push(choicesToBuildColumns[j]);
                                        j++;
                                    }
                                    prevIndex = j;
                                    columns.push(column);
                                }
                            } else for(var i = 0; i < colCount; i++){
                                var column = [];
                                for(var j = i; j < choicesToBuildColumns.length; j += colCount)column.push(choicesToBuildColumns[j]);
                                columns.push(column);
                            }
                        }
                        return columns;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "hasColumns", {
                    get: function() {
                        return !this.isMobile && this.getCurrentColCount() > 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "rowLayout", {
                    get: function() {
                        return this.getCurrentColCount() == 0 && !(this.hasFootItems || this.hasHeadItems);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSelectBase.prototype, "blockedRow", {
                    get: function() {
                        return this.getCurrentColCount() == 0 && (this.hasFootItems || this.hasHeadItems);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.choicesLoaded = function() {
                    this.isChoicesLoaded = true;
                    this.updateIsReady();
                    if (this.survey) this.survey.loadedChoicesFromServer(this);
                    if (this.loadedChoicesFromServerCallback) this.loadedChoicesFromServerCallback();
                };
                QuestionSelectBase.prototype.getItemValueWrapperComponentName = function(item) {
                    var survey = this.survey;
                    if (survey) return survey.getItemValueWrapperComponentName(item, this);
                    return _survey__WEBPACK_IMPORTED_MODULE_1__["SurveyModel"].TemplateRendererComponentName;
                };
                QuestionSelectBase.prototype.getItemValueWrapperComponentData = function(item) {
                    var survey = this.survey;
                    if (survey) return survey.getItemValueWrapperComponentData(item, this);
                    return item;
                };
                QuestionSelectBase.prototype.ariaItemChecked = function(item) {
                    return this.renderedValue === item.value ? "true" : "false";
                };
                QuestionSelectBase.prototype.isOtherItem = function(item) {
                    return this.hasOther && item.value == this.otherItem.value;
                };
                Object.defineProperty(QuestionSelectBase.prototype, "itemSvgIcon", {
                    get: function() {
                        return this.cssClasses.itemSvgIconId;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.getSelectBaseRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.getQuestionRootCss()).append(this.cssClasses.rootRow, this.rowLayout).toString();
                };
                QuestionSelectBase.prototype.allowMobileInDesignMode = function() {
                    return true;
                };
                QuestionSelectBase.prototype.getAriaItemLabel = function(item) {
                    return item.locText.renderedHtml;
                };
                QuestionSelectBase.prototype.getItemId = function(item) {
                    return this.inputId + "_" + this.getItemIndex(item);
                };
                Object.defineProperty(QuestionSelectBase.prototype, "questionName", {
                    get: function() {
                        return this.name + "_" + this.id;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.getItemEnabled = function(item) {
                    return !this.isInputReadOnly && item.isEnabled;
                };
                QuestionSelectBase.prototype.afterRender = function(el) {
                    _super.prototype.afterRender.call(this, el);
                    this.rootElement = el;
                };
                QuestionSelectBase.prototype.beforeDestroyQuestionElement = function(el) {
                    _super.prototype.beforeDestroyQuestionElement.call(this, el);
                    this.rootElement = undefined;
                };
                QuestionSelectBase.prototype.focusOtherComment = function() {
                    var _this = this;
                    if (!!this.rootElement) setTimeout(function() {
                        var commentEl = _this.rootElement.querySelector("textarea");
                        if (!!commentEl) commentEl.focus();
                    }, 10);
                };
                QuestionSelectBase.prototype.onValueChanged = function() {
                    _super.prototype.onValueChanged.call(this);
                    if (!this.isDesignMode && !this.prevIsOtherSelected && this.isOtherSelected) this.focusOtherComment();
                    this.prevIsOtherSelected = this.isOtherSelected;
                };
                QuestionSelectBase.prototype.getDefaultItemComponent = function() {
                    return "";
                };
                Object.defineProperty(QuestionSelectBase.prototype, "itemComponent", {
                    /**
         * The name of a component used to render items.
         */ get: function() {
                        return this.getPropertyValue("itemComponent", this.getDefaultItemComponent());
                    },
                    set: function(value) {
                        this.setPropertyValue("itemComponent", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSelectBase.prototype.updateCssClasses = function(res, css) {
                    _super.prototype.updateCssClasses.call(this, res, css);
                    if (!!this.dropdownListModel) {
                        var listCssClasses = {};
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_11__["mergeValues"])(css.list, listCssClasses);
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_11__["mergeValues"])(res.list, listCssClasses);
                        res["list"] = listCssClasses;
                    }
                };
                QuestionSelectBase.prototype.calcCssClasses = function(css) {
                    var classes = _super.prototype.calcCssClasses.call(this, css);
                    if (this.dropdownListModel) this.dropdownListModel.updateCssClasses(classes.popup, classes.list);
                    return classes;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        onSet: function(newVal, target) {
                            target.onSelectedItemValuesChangedHandler(newVal);
                        }
                    })
                ], QuestionSelectBase.prototype, "selectedItemValues", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionSelectBase.prototype, "separateSpecialChoices", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        localizable: true
                    })
                ], QuestionSelectBase.prototype, "otherPlaceholder", void 0);
                return QuestionSelectBase;
            }(_question__WEBPACK_IMPORTED_MODULE_2__["Question"]);
            /**
 * A base class for multiple-selection question types that can display choice items in multiple columns ([Checkbox](https://surveyjs.io/form-library/documentation/questioncheckboxmodel), [Radiogroup](https://surveyjs.io/form-library/documentation/questionradiogroupmodel), [Image Picker](https://surveyjs.io/form-library/documentation/questionimagepickermodel)).
 */ var QuestionCheckboxBase = /** @class */ function(_super) {
                __extends(QuestionCheckboxBase, _super);
                function QuestionCheckboxBase(name) {
                    return _super.call(this, name) || this;
                }
                Object.defineProperty(QuestionCheckboxBase.prototype, "colCount", {
                    /**
         * Gets or sets the number of columns used to arrange choice items.
         *
         * Set this property to 0 if you want to display all items in one line. The default value depends on the available width.
         * @see separateSpecialChoices
         */ get: function() {
                        return this.getPropertyValue("colCount", this.isFlowLayout ? 0 : undefined);
                    },
                    set: function(value) {
                        if (value < 0 || value > 5 || this.isFlowLayout) return;
                        this.setPropertyValue("colCount", value);
                        this.fireCallback(this.colCountChangedCallback);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCheckboxBase.prototype.onParentChanged = function() {
                    _super.prototype.onParentChanged.call(this);
                    if (this.isFlowLayout) this.setPropertyValue("colCount", null);
                };
                QuestionCheckboxBase.prototype.onParentQuestionChanged = function() {
                    this.onVisibleChoicesChanged();
                };
                QuestionCheckboxBase.prototype.getSearchableItemValueKeys = function(keys) {
                    keys.push("choices");
                };
                return QuestionCheckboxBase;
            }(QuestionSelectBase);
            function checkCopyPropVisibility(obj, mode) {
                var _a;
                if (!obj) return false;
                if (!!obj.templateQuestion) {
                    var data = (_a = obj.colOwner) === null || _a === void 0 ? void 0 : _a.data;
                    obj = obj.templateQuestion;
                    if (!obj.getCarryForwardQuestion(data)) return false;
                }
                return obj.carryForwardQuestionType === mode;
            }
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("selectbase", [
                {
                    name: "showCommentArea:switch",
                    layout: "row",
                    visible: true,
                    category: "general"
                },
                "choicesFromQuestion:question_carryforward",
                {
                    name: "choices:itemvalue[]",
                    uniqueProperty: "value",
                    baseValue: function() {
                        return _surveyStrings__WEBPACK_IMPORTED_MODULE_4__["surveyLocalization"].getString("choices_Item");
                    },
                    dependsOn: "choicesFromQuestion",
                    visibleIf: function(obj) {
                        return !obj.choicesFromQuestion;
                    }
                },
                {
                    name: "choicesFromQuestionMode",
                    default: "all",
                    choices: [
                        "all",
                        "selected",
                        "unselected"
                    ],
                    dependsOn: "choicesFromQuestion",
                    visibleIf: function(obj) {
                        return checkCopyPropVisibility(obj, "select");
                    }
                },
                {
                    name: "choiceValuesFromQuestion",
                    dependsOn: "choicesFromQuestion",
                    visibleIf: function(obj) {
                        return checkCopyPropVisibility(obj, "array");
                    }
                },
                {
                    name: "choiceTextsFromQuestion",
                    dependsOn: "choicesFromQuestion",
                    visibleIf: function(obj) {
                        return checkCopyPropVisibility(obj, "array");
                    }
                },
                {
                    name: "choicesOrder",
                    default: "none",
                    choices: [
                        "none",
                        "asc",
                        "desc",
                        "random"
                    ],
                    dependsOn: "choicesFromQuestion",
                    visibleIf: function(obj) {
                        return !obj.choicesFromQuestion;
                    }
                },
                {
                    name: "choicesByUrl:restfull",
                    className: "choicesByUrl",
                    onGetValue: function(obj) {
                        return obj.choicesByUrl.getData();
                    },
                    onSetValue: function(obj, value) {
                        obj.choicesByUrl.setData(value);
                    }
                },
                "hideIfChoicesEmpty:boolean",
                "choicesVisibleIf:condition",
                {
                    name: "choicesEnableIf:condition",
                    dependsOn: "choicesFromQuestion",
                    visibleIf: function(obj) {
                        return !obj.choicesFromQuestion;
                    }
                },
                {
                    name: "separateSpecialChoices:boolean",
                    visible: false
                },
                {
                    name: "showOtherItem:boolean",
                    alternativeName: "hasOther"
                },
                {
                    name: "showNoneItem:boolean",
                    alternativeName: "hasNone"
                },
                {
                    name: "showRefuseItem:boolean",
                    visible: false,
                    version: "1.9.128"
                },
                {
                    name: "showDontKnowItem:boolean",
                    visible: false,
                    version: "1.9.128"
                },
                {
                    name: "otherPlaceholder",
                    alternativeName: "otherPlaceHolder",
                    serializationProperty: "locOtherPlaceholder",
                    dependsOn: "showOtherItem",
                    visibleIf: function(obj) {
                        return obj.hasOther;
                    }
                },
                {
                    name: "noneText",
                    serializationProperty: "locNoneText",
                    dependsOn: "showNoneItem",
                    visibleIf: function(obj) {
                        return obj.showNoneItem;
                    }
                },
                {
                    name: "refuseText",
                    serializationProperty: "locRefuseText",
                    dependsOn: "showRefuseItem",
                    visibleIf: function(obj) {
                        return obj.showRefuseItem;
                    }
                },
                {
                    name: "dontKnowText",
                    serializationProperty: "locDontKnowText",
                    dependsOn: "showDontKnowItem",
                    visibleIf: function(obj) {
                        return obj.showDontKnowItem;
                    }
                },
                {
                    name: "otherText",
                    serializationProperty: "locOtherText",
                    dependsOn: "showOtherItem",
                    visibleIf: function(obj) {
                        return obj.hasOther;
                    }
                },
                {
                    name: "otherErrorText",
                    serializationProperty: "locOtherErrorText",
                    dependsOn: "showOtherItem",
                    visibleIf: function(obj) {
                        return obj.hasOther;
                    }
                },
                {
                    name: "storeOthersAsComment",
                    default: "default",
                    choices: [
                        "default",
                        true,
                        false
                    ],
                    visible: false
                }
            ], null, "question");
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("checkboxbase", [
                {
                    name: "colCount:number",
                    default: 1,
                    choices: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5
                    ],
                    layout: "row"
                }
            ], null, "selectbase");
        /***/ },
        /***/ "./src/question_boolean.ts": /*!*********************************!*\
  !*** ./src/question_boolean.ts ***!
  \*********************************/ /*! exports provided: QuestionBooleanModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionBooleanModel", function() {
                return QuestionBooleanModel;
            });
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A class that describes the Yes/No (Boolean) question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-boolean/ (linkStyle))
 */ var QuestionBooleanModel = /** @class */ function(_super) {
                __extends(QuestionBooleanModel, _super);
                function QuestionBooleanModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.createLocalizableString("labelFalse", _this, true, "booleanUncheckedLabel");
                    _this.createLocalizableString("labelTrue", _this, true, "booleanCheckedLabel");
                    return _this;
                }
                QuestionBooleanModel.prototype.getType = function() {
                    return "boolean";
                };
                QuestionBooleanModel.prototype.isLayoutTypeSupported = function(layoutType) {
                    return true;
                };
                QuestionBooleanModel.prototype.supportGoNextPageAutomatic = function() {
                    return this.renderAs !== "checkbox";
                };
                Object.defineProperty(QuestionBooleanModel.prototype, "isIndeterminate", {
                    get: function() {
                        return this.isEmpty();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "hasTitle", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "booleanValue", {
                    /**
         * Gets or sets the question value as a Boolean value.
         *
         * If you set the `valueTrue` and `valueFalse` properties, the `value` property contains their values instead of Boolean values. This may be inconvenient when you operate the question value in code. To access the standard Boolean values, use the `booleanValue` property.
         * @see valueTrue
         * @see valueFalse
         */ get: function() {
                        if (this.isEmpty()) return null;
                        return this.value == this.getValueTrue();
                    },
                    set: function(val1) {
                        if (this.isReadOnly || this.isDesignMode) return;
                        this.setBooleanValue(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "checkedValue", {
                    get: function() {
                        return this.booleanValue;
                    },
                    set: function(val1) {
                        this.booleanValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionBooleanModel.prototype.setBooleanValue = function(val1) {
                    if (this.isValueEmpty(val1)) {
                        this.value = undefined;
                        this.booleanValueRendered = undefined;
                    } else {
                        this.value = val1 == true ? this.getValueTrue() : this.getValueFalse();
                        this.booleanValueRendered = val1;
                    }
                };
                Object.defineProperty(QuestionBooleanModel.prototype, "defaultValue", {
                    get: function() {
                        return this.getPropertyValue("defaultValue");
                    },
                    set: function(val1) {
                        if (val1 === true) val1 = "true";
                        if (val1 === false) val1 = "false";
                        this.setPropertyValue("defaultValue", val1);
                        this.updateValueWithDefaults();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionBooleanModel.prototype.getDefaultValue = function() {
                    var val1 = this.defaultValue;
                    if (val1 === "indeterminate" || val1 === undefined || val1 === null) return undefined;
                    return val1 == "true" ? this.getValueTrue() : this.getValueFalse();
                };
                Object.defineProperty(QuestionBooleanModel.prototype, "locTitle", {
                    get: function() {
                        var original = this.getLocalizableString("title");
                        if (!this.isValueEmpty(this.locLabel.text) && (this.isValueEmpty(original.text) || this.isLabelRendered && !this.showTitle)) return this.locLabel;
                        return original;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "labelRenderedAriaID", {
                    get: function() {
                        return this.isLabelRendered ? this.ariaTitleId : null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "isLabelRendered", {
                    get: function() {
                        return this.titleLocation === "hidden";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "canRenderLabelDescription", {
                    get: function() {
                        return this.isLabelRendered && this.hasDescription && (this.hasDescriptionUnderTitle || this.hasDescriptionUnderInput);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "labelTrue", {
                    /**
         * Gets or sets a text label that corresponds to a positive answer.
         *
         * Default value: "Yes"
         * @see valueTrue
         * @see valueFalse
         */ get: function() {
                        return this.getLocalizableStringText("labelTrue");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("labelTrue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "locLabelTrue", {
                    get: function() {
                        return this.getLocalizableString("labelTrue");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "isDeterminated", {
                    get: function() {
                        return this.booleanValue !== null && this.booleanValue !== undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "locLabelLeft", {
                    get: function() {
                        return this.swapOrder ? this.getLocalizableString("labelTrue") : this.getLocalizableString("labelFalse");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "locLabelRight", {
                    get: function() {
                        return this.swapOrder ? this.getLocalizableString("labelFalse") : this.getLocalizableString("labelTrue");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "labelFalse", {
                    /**
         * Gets or sets a text label that corresponds to a negative answer.
         *
         * Default value: "No"
         * @see valueTrue
         * @see valueFalse
         */ get: function() {
                        return this.getLocalizableStringText("labelFalse");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("labelFalse", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "locLabelFalse", {
                    get: function() {
                        return this.getLocalizableString("labelFalse");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionBooleanModel.prototype.getValueTrue = function() {
                    return this.valueTrue !== undefined ? this.valueTrue : true;
                };
                QuestionBooleanModel.prototype.getValueFalse = function() {
                    return this.valueFalse !== undefined ? this.valueFalse : false;
                };
                QuestionBooleanModel.prototype.setDefaultValue = function() {
                    if (this.isDefaultValueSet("true", this.valueTrue)) this.setBooleanValue(true);
                    if (this.isDefaultValueSet("false", this.valueFalse)) this.setBooleanValue(false);
                    var val1 = this.defaultValue;
                    if (val1 === "indeterminate" || val1 === null || val1 === undefined) this.setBooleanValue(undefined);
                };
                QuestionBooleanModel.prototype.isDefaultValueSet = function(defaultValueCheck, valueTrueOrFalse) {
                    return this.defaultValue == defaultValueCheck || valueTrueOrFalse !== undefined && this.defaultValue === valueTrueOrFalse;
                };
                QuestionBooleanModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    if (value == this.getValueTrue()) return this.locLabelTrue.textOrHtml;
                    return this.locLabelFalse.textOrHtml;
                };
                QuestionBooleanModel.prototype.getItemCssValue = function(css) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(css.item).append(css.itemOnError, this.hasCssError()).append(css.itemDisabled, this.isReadOnly).append(css.itemHover, !this.isDesignMode).append(css.itemChecked, !!this.booleanValue).append(css.itemExchanged, !!this.swapOrder).append(css.itemIndeterminate, !this.isDeterminated).toString();
                };
                QuestionBooleanModel.prototype.getItemCss = function() {
                    return this.getItemCssValue(this.cssClasses);
                };
                QuestionBooleanModel.prototype.getCheckboxItemCss = function() {
                    return this.getItemCssValue({
                        item: this.cssClasses.checkboxItem,
                        itemOnError: this.cssClasses.checkboxItemOnError,
                        itemDisabled: this.cssClasses.checkboxItemDisabled,
                        itemChecked: this.cssClasses.checkboxItemChecked,
                        itemIndeterminate: this.cssClasses.checkboxItemIndeterminate
                    });
                };
                QuestionBooleanModel.prototype.getLabelCss = function(checked) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.cssClasses.label).append(this.cssClasses.disabledLabel, this.booleanValue === !checked || this.isReadOnly).append(this.cssClasses.labelTrue, !this.isIndeterminate && checked === !this.swapOrder).append(this.cssClasses.labelFalse, !this.isIndeterminate && checked === this.swapOrder).toString();
                };
                Object.defineProperty(QuestionBooleanModel.prototype, "svgIcon", {
                    get: function() {
                        if (this.booleanValue && this.cssClasses.svgIconCheckedId) return this.cssClasses.svgIconCheckedId;
                        if (!this.isDeterminated && this.cssClasses.svgIconIndId) return this.cssClasses.svgIconIndId;
                        if (!this.booleanValue && this.cssClasses.svgIconUncheckedId) return this.cssClasses.svgIconUncheckedId;
                        return this.cssClasses.svgIconId;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "allowClick", {
                    get: function() {
                        return this.isIndeterminate && !this.isInputReadOnly;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionBooleanModel.prototype.getCheckedLabel = function() {
                    if (this.booleanValue === true) return this.locLabelTrue;
                    else if (this.booleanValue === false) return this.locLabelFalse;
                };
                QuestionBooleanModel.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    if (newValue === "true" && this.valueTrue !== "true") newValue = true;
                    if (newValue === "false" && this.valueFalse !== "false") newValue = false;
                    if (newValue === "indeterminate" || newValue === null) newValue = undefined;
                    _super.prototype.setQuestionValue.call(this, newValue, updateIsAnswered);
                };
                /* #region web-based methods */ QuestionBooleanModel.prototype.onLabelClick = function(event1, value) {
                    if (this.allowClick) {
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_4__["preventDefaults"])(event1);
                        this.booleanValue = value;
                    }
                    return true;
                };
                QuestionBooleanModel.prototype.calculateBooleanValueByEvent = function(event1, isRightClick) {
                    var isRtl = false;
                    if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_5__["DomDocumentHelper"].isAvailable()) isRtl = _global_variables_utils__WEBPACK_IMPORTED_MODULE_5__["DomDocumentHelper"].getComputedStyle(event1.target).direction == "rtl";
                    this.booleanValue = isRtl ? !isRightClick : isRightClick;
                };
                QuestionBooleanModel.prototype.onSwitchClickModel = function(event1) {
                    if (this.allowClick) {
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_4__["preventDefaults"])(event1);
                        var isRightClick = event1.offsetX / event1.target.offsetWidth > 0.5;
                        this.calculateBooleanValueByEvent(event1, isRightClick);
                        return;
                    }
                    return true;
                };
                QuestionBooleanModel.prototype.onKeyDownCore = function(event1) {
                    if (event1.key === "ArrowLeft" || event1.key === "ArrowRight") {
                        event1.stopPropagation();
                        this.calculateBooleanValueByEvent(event1, event1.key === "ArrowRight");
                    }
                    return true;
                };
                /* #endregion */ QuestionBooleanModel.prototype.getRadioItemClass = function(css, value) {
                    var className = undefined;
                    if (css.radioItem) className = css.radioItem;
                    if (css.radioItemChecked && value === this.booleanValue) className = (className ? className + " " : "") + css.radioItemChecked;
                    return className;
                };
                QuestionBooleanModel.prototype.supportResponsiveness = function() {
                    return true;
                };
                QuestionBooleanModel.prototype.getCompactRenderAs = function() {
                    return "radio";
                };
                QuestionBooleanModel.prototype.createActionContainer = function(allowAdaptiveActions) {
                    return _super.prototype.createActionContainer.call(this, this.renderAs !== "checkbox");
                };
                Object.defineProperty(QuestionBooleanModel.prototype, "isNewA11yStructure", {
                    //a11y
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionBooleanModel.prototype, "a11y_input_ariaRole", {
                    get: function() {
                        return "switch";
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionBooleanModel.prototype, "booleanValueRendered", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionBooleanModel.prototype, "showTitle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: true
                    })
                ], QuestionBooleanModel.prototype, "label", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], QuestionBooleanModel.prototype, "swapOrder", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionBooleanModel.prototype, "valueTrue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionBooleanModel.prototype, "valueFalse", void 0);
                return QuestionBooleanModel;
            }(_question__WEBPACK_IMPORTED_MODULE_2__["Question"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("boolean", [
                {
                    name: "showCommentArea:switch",
                    layout: "row",
                    visible: true,
                    category: "general"
                },
                {
                    name: "label:text",
                    serializationProperty: "locLabel",
                    isSerializable: false,
                    visible: false
                },
                {
                    name: "labelTrue:text",
                    serializationProperty: "locLabelTrue"
                },
                {
                    name: "labelFalse:text",
                    serializationProperty: "locLabelFalse"
                },
                "valueTrue",
                "valueFalse",
                {
                    name: "swapOrder:boolean",
                    category: "general"
                },
                {
                    name: "renderAs",
                    default: "default",
                    visible: false
                }
            ], function() {
                return new QuestionBooleanModel("");
            }, "question");
            _questionfactory__WEBPACK_IMPORTED_MODULE_0__["QuestionFactory"].Instance.registerQuestion("boolean", function(name) {
                return new QuestionBooleanModel(name);
            });
        /***/ },
        /***/ "./src/question_buttongroup.ts": /*!*************************************!*\
  !*** ./src/question_buttongroup.ts ***!
  \*************************************/ /*! exports provided: ButtonGroupItemValue, QuestionButtonGroupModel, ButtonGroupItemModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupItemValue", function() {
                return ButtonGroupItemValue;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionButtonGroupModel", function() {
                return QuestionButtonGroupModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ButtonGroupItemModel", function() {
                return ButtonGroupItemModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _question_baseselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_baseselect */ "./src/question_baseselect.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var ButtonGroupItemValue = /** @class */ function(_super) {
                __extends(ButtonGroupItemValue, _super);
                function ButtonGroupItemValue(value, text, typeName) {
                    if (text === void 0) text = null;
                    if (typeName === void 0) typeName = "buttongroupitemvalue";
                    var _this = _super.call(this, value, text, typeName) || this;
                    _this.typeName = typeName;
                    return _this;
                }
                ButtonGroupItemValue.prototype.getType = function() {
                    return !!this.typeName ? this.typeName : "buttongroupitemvalue";
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], ButtonGroupItemValue.prototype, "iconName", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], ButtonGroupItemValue.prototype, "iconSize", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], ButtonGroupItemValue.prototype, "showCaption", void 0);
                return ButtonGroupItemValue;
            }(_itemvalue__WEBPACK_IMPORTED_MODULE_1__["ItemValue"]);
            /**
 * A Model for a button group question.
 */ var QuestionButtonGroupModel = /** @class */ function(_super) {
                __extends(QuestionButtonGroupModel, _super);
                function QuestionButtonGroupModel(name) {
                    return _super.call(this, name) || this;
                }
                QuestionButtonGroupModel.prototype.getType = function() {
                    return "buttongroup";
                };
                QuestionButtonGroupModel.prototype.getItemValueType = function() {
                    return "buttongroupitemvalue";
                };
                QuestionButtonGroupModel.prototype.supportOther = function() {
                    return false;
                };
                return QuestionButtonGroupModel;
            }(_question_baseselect__WEBPACK_IMPORTED_MODULE_2__["QuestionCheckboxBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("buttongroup", [
                {
                    name: "choices:buttongroupitemvalue[]"
                }
            ], function() {
                return new QuestionButtonGroupModel("");
            }, "checkboxbase");
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("buttongroupitemvalue", [
                {
                    name: "showCaption:boolean",
                    default: true
                },
                {
                    name: "iconName:text"
                },
                {
                    name: "iconSize:number"
                }
            ], function(value) {
                return new ButtonGroupItemValue(value);
            }, "itemvalue");
            // QuestionFactory.Instance.registerQuestion("buttongroup", name => {
            //   var q = new QuestionButtonGroupModel(name);
            //   q.choices = QuestionFactory.DefaultChoices;
            //   return q;
            // });
            var ButtonGroupItemModel = /** @class */ function() {
                function ButtonGroupItemModel(question, item, index) {
                    this.question = question;
                    this.item = item;
                    this.index = index;
                }
                Object.defineProperty(ButtonGroupItemModel.prototype, "value", {
                    get: function() {
                        return this.item.value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "iconName", {
                    get: function() {
                        return this.item.iconName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "iconSize", {
                    get: function() {
                        return this.item.iconSize || 24;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "caption", {
                    get: function() {
                        return this.item.locText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "showCaption", {
                    get: function() {
                        return this.item.showCaption || this.item.showCaption === undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "isRequired", {
                    get: function() {
                        return this.question.isRequired;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "selected", {
                    get: function() {
                        return this.question.isItemSelected(this.item);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "readOnly", {
                    get: function() {
                        return this.question.isInputReadOnly || !this.item.isEnabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "name", {
                    get: function() {
                        return this.question.name + "_" + this.question.id;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "id", {
                    get: function() {
                        return this.question.inputId + "_" + this.index;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "hasErrors", {
                    get: function() {
                        return this.question.errors.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "describedBy", {
                    get: function() {
                        return this.question.errors.length > 0 ? this.question.id + "_errors" : null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "labelClass", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.question.cssClasses.item).append(this.question.cssClasses.itemSelected, this.selected).append(this.question.cssClasses.itemHover, !this.readOnly && !this.selected).append(this.question.cssClasses.itemDisabled, this.question.isReadOnly || !this.item.isEnabled).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ButtonGroupItemModel.prototype, "css", {
                    get: function() {
                        return {
                            label: this.labelClass,
                            icon: this.question.cssClasses.itemIcon,
                            control: this.question.cssClasses.itemControl,
                            caption: this.question.cssClasses.itemCaption,
                            decorator: this.question.cssClasses.itemDecorator
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                ButtonGroupItemModel.prototype.onChange = function() {
                    this.question.renderedValue = this.item.value;
                };
                return ButtonGroupItemModel;
            }();
        /***/ },
        /***/ "./src/question_checkbox.ts": /*!**********************************!*\
  !*** ./src/question_checkbox.ts ***!
  \**********************************/ /*! exports provided: QuestionCheckboxModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionCheckboxModel", function() {
                return QuestionCheckboxModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _question_baseselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_baseselect */ "./src/question_baseselect.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * A class that describes the Checkboxes question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-checkbox/ (linkStyle))
 */ var QuestionCheckboxModel = /** @class */ function(_super) {
                __extends(QuestionCheckboxModel, _super);
                function QuestionCheckboxModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.invisibleOldValues = {};
                    _this.isChangingValueOnClearIncorrect = false;
                    _this.selectAllItemValue = new _itemvalue__WEBPACK_IMPORTED_MODULE_4__["ItemValue"]("");
                    _this.selectAllItemValue.id = "selectall";
                    var selectAllItemText = _this.createLocalizableString("selectAllText", _this.selectAllItem, true, "selectAllItemText");
                    _this.selectAllItem.locOwner = _this;
                    _this.selectAllItem.setLocText(selectAllItemText);
                    _this.registerPropertyChangedHandlers([
                        "showSelectAllItem",
                        "selectAllText"
                    ], function() {
                        _this.onVisibleChoicesChanged();
                    });
                    return _this;
                }
                QuestionCheckboxModel.prototype.getDefaultItemComponent = function() {
                    return "survey-checkbox-item";
                };
                QuestionCheckboxModel.prototype.getType = function() {
                    return "checkbox";
                };
                QuestionCheckboxModel.prototype.onCreating = function() {
                    _super.prototype.onCreating.call(this);
                    this.createNewArray("renderedValue");
                    this.createNewArray("value");
                };
                QuestionCheckboxModel.prototype.getFirstInputElementId = function() {
                    return this.inputId + "_0";
                };
                Object.defineProperty(QuestionCheckboxModel.prototype, "valuePropertyName", {
                    /**
         * Specifies a property name used to store selected values.
         *
         * Set this property if you want to store selected values in an array of objects instead of an array of primitive values. For example, if you set `valuePropertyName` to `"car"`, the `value` property will contain an array of objects `[{ car: "Ford" }, { car: "Tesla" }]`, not an array of string values `[ "Ford", "Tesla" ]`.
         */ get: function() {
                        return this.getPropertyValue("valuePropertyName");
                    },
                    set: function(val1) {
                        this.setPropertyValue("valuePropertyName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCheckboxModel.prototype.getQuestionFromArray = function(name, index) {
                    if (!!name && name === this.valuePropertyName) {
                        var v = this.value;
                        if (Array.isArray(v) && index < v.length) return this;
                    }
                    return null;
                };
                Object.defineProperty(QuestionCheckboxModel.prototype, "selectAllItem", {
                    /**
         * Returns the "Select All" choice item. Use this property to change the item's `value` or `text`.
         * @see showSelectAllItem
         */ get: function() {
                        return this.selectAllItemValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "selectAllText", {
                    /**
         * Gets or sets a caption for the "Select All" choice item.
         * @see showSelectAllItem
         */ get: function() {
                        return this.getLocalizableStringText("selectAllText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("selectAllText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "locSelectAllText", {
                    get: function() {
                        return this.getLocalizableString("selectAllText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "showSelectAllItem", {
                    /**
         * Enable this property to display a "Select All" item. When users select it, all other choice items, except "Other" and "None", also become selected.
         * @see selectAll
         * @see isAllSelected
         * @see separateSpecialChoices
         */ get: function() {
                        return this.getPropertyValue("showSelectAllItem");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showSelectAllItem", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "hasSelectAll", {
                    get: function() {
                        return this.showSelectAllItem;
                    },
                    set: function(val1) {
                        this.showSelectAllItem = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "isAllSelected", {
                    /**
         * Returns `true` if all choice items, except "Other" and "None", are selected.
         * @see showSelectAllItem
         */ get: function() {
                        var noneItems = this.getNoneItems();
                        for(var i = 0; i < noneItems.length; i++){
                            if (this.isItemSelected(noneItems[i])) return false;
                        }
                        var items = this.getVisibleEnableItems();
                        if (items.length === 0) return false;
                        var val1 = this.value;
                        if (!val1 || !Array.isArray(val1) || val1.length === 0) return false;
                        if (val1.length < items.length) return false;
                        var rVal = [];
                        for(var i = 0; i < val1.length; i++)rVal.push(this.getRealValue(val1[i]));
                        for(var i = 0; i < items.length; i++){
                            if (rVal.indexOf(items[i].value) < 0) return false;
                        }
                        return true;
                    },
                    set: function(val1) {
                        if (val1) this.selectAll();
                        else this.clearValue();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCheckboxModel.prototype.toggleSelectAll = function() {
                    this.isAllSelected = !this.isAllSelected;
                };
                /**
     * Selects all choice items, except "Other" and "None".
     *
     * To clear selection, call the `clearValue()` method.
     * @see clearValue
     */ QuestionCheckboxModel.prototype.selectAll = function() {
                    var val1 = [];
                    var items = this.getVisibleEnableItems();
                    for(var i = 0; i < items.length; i++)val1.push(items[i].value);
                    this.renderedValue = val1;
                };
                QuestionCheckboxModel.prototype.clickItemHandler = function(item, checked) {
                    if (item === this.selectAllItem) {
                        if (checked === true || checked === false) this.isAllSelected = checked;
                        else this.toggleSelectAll();
                    } else if (this.isNoneItem(item)) this.renderedValue = [
                        item.value
                    ];
                    else {
                        var newValue = [].concat(this.renderedValue || []);
                        var index = newValue.indexOf(item.value);
                        if (checked) {
                            if (index < 0) newValue.push(item.value);
                        } else if (index > -1) newValue.splice(index, 1);
                        this.renderedValue = newValue;
                    }
                };
                QuestionCheckboxModel.prototype.isItemSelectedCore = function(item) {
                    if (item === this.selectAllItem) return this.isAllSelected;
                    var val1 = this.renderedValue;
                    if (!val1 || !Array.isArray(val1)) return false;
                    for(var i = 0; i < val1.length; i++){
                        if (this.isTwoValueEquals(val1[i], item.value)) return true;
                    }
                    return false;
                };
                QuestionCheckboxModel.prototype.getRealValue = function(val1) {
                    if (!val1) return val1;
                    return !this.valuePropertyName ? val1 : val1[this.valuePropertyName];
                };
                Object.defineProperty(QuestionCheckboxModel.prototype, "isValueArray", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "maxSelectedChoices", {
                    /**
         * Specifies the maximum number of selected choices.
         *
         * Default value: 0 (unlimited)
         *
         * > This property only limits the number of choice items that can be selected by users. You can select any number of choice items in code, regardless of the `maxSelectedChoices` value.
         * @see minSelectedChoices
         */ get: function() {
                        return this.getPropertyValue("maxSelectedChoices");
                    },
                    set: function(val1) {
                        if (val1 < 0) val1 = 0;
                        this.setPropertyValue("maxSelectedChoices", val1);
                        this.filterItems();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "minSelectedChoices", {
                    /**
         * Specifies the minimum number of selected choices.
         *
         * Default value: 0 (unlimited)
         *
         * > This property only limits the number of choice items that can be selected by users. You can select any number of choice items in code, regardless of the `minSelectedChoices` value.
         * @see maxSelectedChoices
         */ get: function() {
                        return this.getPropertyValue("minSelectedChoices");
                    },
                    set: function(val1) {
                        if (val1 < 0) val1 = 0;
                        this.setPropertyValue("minSelectedChoices", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "selectedChoices", {
                    /**
         * An array of selected choice items. Includes the "Other" and "None" choice items if they are selected, but not "Select All". Items are sorted in the order they were selected.
         * @see visibleChoices
         * @see enabledChoices
         */ get: function() {
                        var val1 = this.renderedValue;
                        var visChoices = this.visibleChoices;
                        var selectedItemValues = this.selectedItemValues;
                        if (this.isEmpty()) return [];
                        var allChoices = !!this.defaultSelectedItemValues ? [].concat(this.defaultSelectedItemValues, visChoices) : visChoices;
                        var itemValues = val1.map(function(item) {
                            return _itemvalue__WEBPACK_IMPORTED_MODULE_4__["ItemValue"].getItemByValue(allChoices, item);
                        }).filter(function(item) {
                            return !!item;
                        });
                        if (!itemValues.length && !selectedItemValues) this.updateSelectedItemValues();
                        return this.validateItemValues(itemValues);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "selectedItems", {
                    get: function() {
                        return this.selectedChoices;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "hasFilteredValue", {
                    get: function() {
                        return !!this.valuePropertyName;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCheckboxModel.prototype.getFilteredValue = function() {
                    if (this.hasFilteredValue) return this.renderedValue;
                    return _super.prototype.getFilteredValue.call(this);
                };
                QuestionCheckboxModel.prototype.getMultipleSelectedItems = function() {
                    return this.selectedChoices;
                };
                QuestionCheckboxModel.prototype.validateItemValues = function(itemValues) {
                    var _this = this;
                    if (!!itemValues.length) return itemValues;
                    var selectedItemValues = this.selectedItemValues;
                    if (!!selectedItemValues && !!selectedItemValues.length) {
                        this.defaultSelectedItemValues = [].concat(selectedItemValues);
                        return selectedItemValues;
                    }
                    var val1 = this.renderedValue;
                    return val1.map(function(item) {
                        return _this.createItemValue(item);
                    });
                };
                QuestionCheckboxModel.prototype.getAnswerCorrectIgnoreOrder = function() {
                    return true;
                };
                QuestionCheckboxModel.prototype.onCheckForErrors = function(errors, isOnValueChanged) {
                    _super.prototype.onCheckForErrors.call(this, errors, isOnValueChanged);
                    if (isOnValueChanged) return;
                    if (this.minSelectedChoices > 0 && this.checkMinSelectedChoicesUnreached()) {
                        var minError = new _error__WEBPACK_IMPORTED_MODULE_6__["CustomError"](this.getLocalizationFormatString("minSelectError", this.minSelectedChoices), this);
                        errors.push(minError);
                    }
                };
                QuestionCheckboxModel.prototype.onVisibleChoicesChanged = function() {
                    _super.prototype.onVisibleChoicesChanged.call(this);
                    this.updateSelectAllItemProps();
                };
                QuestionCheckboxModel.prototype.onEnableItemCallBack = function(item) {
                    if (!this.shouldCheckMaxSelectedChoices()) return true;
                    return this.isItemSelected(item);
                };
                QuestionCheckboxModel.prototype.onAfterRunItemsEnableCondition = function() {
                    this.updateSelectAllItemProps();
                    if (this.maxSelectedChoices < 1) {
                        this.otherItem.setIsEnabled(true);
                        return;
                    }
                    if (this.hasOther) this.otherItem.setIsEnabled(!this.shouldCheckMaxSelectedChoices() || this.isOtherSelected);
                };
                QuestionCheckboxModel.prototype.updateSelectAllItemProps = function() {
                    if (!this.hasSelectAll) return;
                    this.selectAllItem.setIsEnabled(this.getSelectAllEnabled());
                };
                QuestionCheckboxModel.prototype.getSelectAllEnabled = function() {
                    if (!this.hasSelectAll) return true;
                    var items = this.activeChoices;
                    var visCount = this.getVisibleEnableItems().length;
                    var max = this.maxSelectedChoices;
                    if (max > 0 && max < visCount) return false;
                    return visCount > 0;
                };
                QuestionCheckboxModel.prototype.getVisibleEnableItems = function() {
                    var res = new Array();
                    var items = this.activeChoices;
                    for(var i = 0; i < items.length; i++){
                        var item = items[i];
                        if (item.isEnabled && item.isVisible) res.push(item);
                    }
                    return res;
                };
                QuestionCheckboxModel.prototype.shouldCheckMaxSelectedChoices = function() {
                    if (this.maxSelectedChoices < 1) return false;
                    var val1 = this.value;
                    var len = !Array.isArray(val1) ? 0 : val1.length;
                    return len >= this.maxSelectedChoices;
                };
                QuestionCheckboxModel.prototype.checkMinSelectedChoicesUnreached = function() {
                    if (this.minSelectedChoices < 1) return false;
                    var val1 = this.value;
                    var len = !Array.isArray(val1) ? 0 : val1.length;
                    return len < this.minSelectedChoices;
                };
                QuestionCheckboxModel.prototype.getItemClassCore = function(item, options) {
                    var __dummy_value = this.value; //trigger dependencies from koValue for knockout
                    options.isSelectAllItem = item === this.selectAllItem;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(_super.prototype.getItemClassCore.call(this, item, options)).append(this.cssClasses.itemSelectAll, options.isSelectAllItem).toString();
                };
                QuestionCheckboxModel.prototype.updateValueFromSurvey = function(newValue, clearData) {
                    _super.prototype.updateValueFromSurvey.call(this, newValue, clearData);
                    this.invisibleOldValues = {};
                };
                QuestionCheckboxModel.prototype.setDefaultValue = function() {
                    _super.prototype.setDefaultValue.call(this);
                    var val1 = this.defaultValue;
                    if (Array.isArray(val1)) for(var i = 0; i < val1.length; i++){
                        var rVal = this.getRealValue(val1[i]);
                        if (this.canClearValueAnUnknown(rVal)) this.addIntoInvisibleOldValues(rVal);
                    }
                };
                QuestionCheckboxModel.prototype.addIntoInvisibleOldValues = function(val1) {
                    this.invisibleOldValues[val1] = val1;
                };
                QuestionCheckboxModel.prototype.hasValueToClearIncorrectValues = function() {
                    return _super.prototype.hasValueToClearIncorrectValues.call(this) || !_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isValueEmpty(this.invisibleOldValues);
                };
                QuestionCheckboxModel.prototype.setNewValue = function(newValue) {
                    if (!this.isChangingValueOnClearIncorrect) this.invisibleOldValues = {};
                    newValue = this.valueFromData(newValue);
                    var value = this.value;
                    if (!newValue) newValue = [];
                    if (!value) value = [];
                    if (this.isTwoValueEquals(value, newValue)) return;
                    this.removeNoneItemsValues(value, newValue);
                    _super.prototype.setNewValue.call(this, newValue);
                };
                QuestionCheckboxModel.prototype.getIsMultipleValue = function() {
                    return true;
                };
                QuestionCheckboxModel.prototype.getCommentFromValue = function(newValue) {
                    var ind = this.getFirstUnknownIndex(newValue);
                    if (ind < 0) return "";
                    return newValue[ind];
                };
                QuestionCheckboxModel.prototype.setOtherValueIntoValue = function(newValue) {
                    var ind = this.getFirstUnknownIndex(newValue);
                    if (ind < 0) return newValue;
                    newValue.splice(ind, 1, this.otherItem.value);
                    return newValue;
                };
                QuestionCheckboxModel.prototype.getFirstUnknownIndex = function(newValue) {
                    if (!Array.isArray(newValue)) return -1;
                    for(var i = 0; i < newValue.length; i++){
                        if (this.hasUnknownValueItem(newValue[i], false, false)) return i;
                    }
                    return -1;
                };
                QuestionCheckboxModel.prototype.removeNoneItemsValues = function(value, newValue) {
                    var noneValues = [];
                    if (this.showNoneItem) noneValues.push(this.noneItem.value);
                    if (this.showRefuseItem) noneValues.push(this.refuseItem.value);
                    if (this.showDontKnowItem) noneValues.push(this.dontKnowItem.value);
                    if (noneValues.length > 0) {
                        var prevNone = this.noneIndexInArray(value, noneValues);
                        var newNone = this.noneIndexInArray(newValue, noneValues);
                        if (prevNone.index > -1) {
                            if (prevNone.val === newNone.val) {
                                if (newValue.length > 0) newValue.splice(newNone.index, 1);
                            } else {
                                var prevNewNone = this.noneIndexInArray(newValue, [
                                    prevNone.val
                                ]);
                                if (prevNewNone.index > -1 && prevNewNone.index < newValue.length - 1) newValue.splice(prevNewNone.index, 1);
                            }
                        } else if (newNone.index > -1 && newValue.length > 1) {
                            var itemVal = this.convertValueToObject([
                                newNone.val
                            ])[0];
                            newValue.splice(0, newValue.length, itemVal);
                        }
                    }
                };
                QuestionCheckboxModel.prototype.noneIndexInArray = function(val1, noneValues) {
                    if (!Array.isArray(val1)) return {
                        index: -1,
                        val: undefined
                    };
                    for(var i = val1.length - 1; i >= 0; i--){
                        var index = noneValues.indexOf(this.getRealValue(val1[i]));
                        if (index > -1) return {
                            index: i,
                            val: noneValues[index]
                        };
                    }
                    return {
                        index: -1,
                        val: undefined
                    };
                };
                QuestionCheckboxModel.prototype.canUseFilteredChoices = function() {
                    return !this.hasSelectAll && _super.prototype.canUseFilteredChoices.call(this);
                };
                QuestionCheckboxModel.prototype.supportSelectAll = function() {
                    return this.isSupportProperty("showSelectAllItem");
                };
                QuestionCheckboxModel.prototype.addNonChoicesItems = function(dict, isAddAll) {
                    _super.prototype.addNonChoicesItems.call(this, dict, isAddAll);
                    if (this.supportSelectAll()) this.addNonChoiceItem(dict, this.selectAllItem, isAddAll, this.hasSelectAll, _settings__WEBPACK_IMPORTED_MODULE_7__["settings"].specialChoicesOrder.selectAllItem);
                };
                QuestionCheckboxModel.prototype.isBuiltInChoice = function(item) {
                    return item === this.selectAllItem || _super.prototype.isBuiltInChoice.call(this, item);
                };
                QuestionCheckboxModel.prototype.isItemInList = function(item) {
                    if (item == this.selectAllItem) return this.hasSelectAll;
                    return _super.prototype.isItemInList.call(this, item);
                };
                QuestionCheckboxModel.prototype.getDisplayValueEmpty = function() {
                    var _this = this;
                    return _itemvalue__WEBPACK_IMPORTED_MODULE_4__["ItemValue"].getTextOrHtmlByValue(this.visibleChoices.filter(function(choice) {
                        return choice != _this.selectAllItemValue;
                    }), undefined);
                };
                QuestionCheckboxModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    if (!Array.isArray(value)) return _super.prototype.getDisplayValueCore.call(this, keysAsText, value);
                    var valuePropName = this.valuePropertyName;
                    var onGetValueCallback = function(index) {
                        var val1 = value[index];
                        if (!!valuePropName && !!val1[valuePropName]) val1 = val1[valuePropName];
                        return val1;
                    };
                    return this.getDisplayArrayValue(keysAsText, value, onGetValueCallback);
                };
                QuestionCheckboxModel.prototype.clearIncorrectValuesCore = function() {
                    this.clearIncorrectAndDisabledValues(false);
                };
                QuestionCheckboxModel.prototype.clearDisabledValuesCore = function() {
                    this.clearIncorrectAndDisabledValues(true);
                };
                QuestionCheckboxModel.prototype.clearIncorrectAndDisabledValues = function(clearDisabled) {
                    var val1 = this.value;
                    var hasChanged = false;
                    var restoredValues = this.restoreValuesFromInvisible();
                    if (!val1 && restoredValues.length == 0) return;
                    if (!Array.isArray(val1) || val1.length == 0) {
                        this.isChangingValueOnClearIncorrect = true;
                        if (!clearDisabled) {
                            if (this.hasComment) this.value = null;
                            else this.clearValue();
                        }
                        this.isChangingValueOnClearIncorrect = false;
                        if (restoredValues.length == 0) return;
                        val1 = [];
                    }
                    var newValue = [];
                    for(var i = 0; i < val1.length; i++){
                        var rItemVal = this.getRealValue(val1[i]);
                        var isUnkown = this.canClearValueAnUnknown(rItemVal);
                        if (!clearDisabled && !isUnkown || clearDisabled && !this.isValueDisabled(rItemVal)) newValue.push(val1[i]);
                        else {
                            hasChanged = true;
                            if (isUnkown) this.addIntoInvisibleOldValues(val1[i]);
                        }
                    }
                    for(var i = 0; i < restoredValues.length; i++){
                        newValue.push(restoredValues[i]);
                        hasChanged = true;
                    }
                    if (!hasChanged) return;
                    this.isChangingValueOnClearIncorrect = true;
                    if (newValue.length == 0) this.clearValue();
                    else this.value = newValue;
                    this.isChangingValueOnClearIncorrect = false;
                };
                QuestionCheckboxModel.prototype.restoreValuesFromInvisible = function() {
                    var res = [];
                    var visItems = this.visibleChoices;
                    for(var i = 0; i < visItems.length; i++){
                        var item = visItems[i];
                        if (item === this.selectAllItem) continue;
                        var val1 = visItems[i].value;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isTwoValueEquals(val1, this.invisibleOldValues[val1])) {
                            if (!this.isItemSelected(item)) res.push(val1);
                            delete this.invisibleOldValues[val1];
                        }
                    }
                    return res;
                };
                QuestionCheckboxModel.prototype.getConditionJson = function(operator, path) {
                    if (operator === void 0) operator = null;
                    if (path === void 0) path = null;
                    var json = _super.prototype.getConditionJson.call(this);
                    if (operator == "contains" || operator == "notcontains") json["type"] = "radiogroup";
                    json["maxSelectedChoices"] = 0;
                    json["minSelectedChoices"] = 0;
                    return json;
                };
                QuestionCheckboxModel.prototype.isAnswerCorrect = function() {
                    return _helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isArrayContainsEqual(this.value, this.correctAnswer);
                };
                QuestionCheckboxModel.prototype.setDefaultValueWithOthers = function() {
                    this.value = this.renderedValueFromDataCore(this.defaultValue);
                };
                QuestionCheckboxModel.prototype.getIsItemValue = function(val1, item) {
                    if (!val1 || !Array.isArray(val1)) return false;
                    return val1.indexOf(item.value) >= 0;
                };
                QuestionCheckboxModel.prototype.valueFromData = function(val1) {
                    if (!val1) return val1;
                    if (!Array.isArray(val1)) return [
                        _super.prototype.valueFromData.call(this, val1)
                    ];
                    var value = [];
                    for(var i = 0; i < val1.length; i++){
                        var choiceitem = _itemvalue__WEBPACK_IMPORTED_MODULE_4__["ItemValue"].getItemByValue(this.activeChoices, val1[i]);
                        if (!!choiceitem) value.push(choiceitem.value);
                        else value.push(val1[i]);
                    }
                    return value;
                };
                QuestionCheckboxModel.prototype.rendredValueFromData = function(val1) {
                    val1 = this.convertValueFromObject(val1);
                    return _super.prototype.rendredValueFromData.call(this, val1);
                };
                QuestionCheckboxModel.prototype.rendredValueToData = function(val1) {
                    val1 = _super.prototype.rendredValueToData.call(this, val1);
                    return this.convertValueToObject(val1);
                };
                QuestionCheckboxModel.prototype.convertValueFromObject = function(val1) {
                    if (!this.valuePropertyName) return val1;
                    return _helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].convertArrayObjectToValue(val1, this.valuePropertyName);
                };
                QuestionCheckboxModel.prototype.convertValueToObject = function(val1) {
                    if (!this.valuePropertyName) return val1;
                    var dest = undefined;
                    if (!!this.survey && this.survey.questionsByValueName(this.getValueName()).length > 1) dest = this.data.getValue(this.getValueName());
                    return _helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].convertArrayValueToObject(val1, this.valuePropertyName, dest);
                };
                QuestionCheckboxModel.prototype.renderedValueFromDataCore = function(val1) {
                    if (!val1 || !Array.isArray(val1)) val1 = [];
                    if (!this.hasActiveChoices) return val1;
                    for(var i = 0; i < val1.length; i++){
                        if (val1[i] == this.otherItem.value) return val1;
                        if (this.hasUnknownValueItem(val1[i], true, false)) {
                            this.otherValue = val1[i];
                            var newVal = val1.slice();
                            newVal[i] = this.otherItem.value;
                            return newVal;
                        }
                    }
                    return val1;
                };
                QuestionCheckboxModel.prototype.rendredValueToDataCore = function(val1) {
                    if (!val1 || !val1.length) return val1;
                    for(var i = 0; i < val1.length; i++){
                        if (val1[i] == this.otherItem.value) {
                            if (this.needConvertRenderedOtherToDataValue()) {
                                var newVal = val1.slice();
                                newVal[i] = this.otherValue;
                                return newVal;
                            }
                        }
                    }
                    return val1;
                };
                QuestionCheckboxModel.prototype.selectOtherValueFromComment = function(val1) {
                    var newVal = [];
                    var rendVal = this.renderedValue;
                    if (Array.isArray(rendVal)) {
                        for(var i = 0; i < rendVal.length; i++)if (rendVal[i] !== this.otherItem.value) newVal.push(rendVal[i]);
                    }
                    if (val1) newVal.push(this.otherItem.value);
                    this.value = newVal;
                };
                Object.defineProperty(QuestionCheckboxModel.prototype, "checkBoxSvgPath", {
                    get: function() {
                        return "M5,13l2-2l3,3l7-7l2,2l-9,9L5,13z";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "isNewA11yStructure", {
                    //a11y
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCheckboxModel.prototype, "a11y_input_ariaRole", {
                    get: function() {
                        return "listbox";
                    },
                    enumerable: false,
                    configurable: true
                });
                return QuestionCheckboxModel;
            }(_question_baseselect__WEBPACK_IMPORTED_MODULE_2__["QuestionCheckboxBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("checkbox", [
                {
                    name: "showSelectAllItem:boolean",
                    alternativeName: "hasSelectAll"
                },
                {
                    name: "separateSpecialChoices",
                    visible: true
                },
                {
                    name: "maxSelectedChoices:number",
                    default: 0,
                    onSettingValue: function(obj, val1) {
                        if (val1 <= 0) return 0;
                        var min = obj.minSelectedChoices;
                        return min > 0 && val1 < min ? min : val1;
                    }
                },
                {
                    name: "minSelectedChoices:number",
                    default: 0,
                    onSettingValue: function(obj, val1) {
                        if (val1 <= 0) return 0;
                        var max = obj.maxSelectedChoices;
                        return max > 0 && val1 > max ? max : val1;
                    }
                },
                {
                    name: "selectAllText",
                    serializationProperty: "locSelectAllText",
                    dependsOn: "showSelectAllItem",
                    visibleIf: function(obj) {
                        return obj.hasSelectAll;
                    }
                },
                {
                    name: "valuePropertyName",
                    category: "data"
                },
                {
                    name: "itemComponent",
                    visible: false,
                    default: "survey-checkbox-item"
                }
            ], function() {
                return new QuestionCheckboxModel("");
            }, "checkboxbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].Instance.registerQuestion("checkbox", function(name) {
                var q = new QuestionCheckboxModel(name);
                q.choices = _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].DefaultChoices;
                return q;
            });
        /***/ },
        /***/ "./src/question_comment.ts": /*!*********************************!*\
  !*** ./src/question_comment.ts ***!
  \*********************************/ /*! exports provided: QuestionCommentModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionCommentModel", function() {
                return QuestionCommentModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _question_textbase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_textbase */ "./src/question_textbase.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * A class that describes the Long Text question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-comment/ (linkStyle))
 */ var QuestionCommentModel = /** @class */ function(_super) {
                __extends(QuestionCommentModel, _super);
                function QuestionCommentModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(QuestionCommentModel.prototype, "rows", {
                    /**
         * Specifies the visible height of the comment area, measured in lines.
         *
         * The value of this property is passed on to the `rows` attribute of the underlying `<textarea>` element.
         */ get: function() {
                        return this.getPropertyValue("rows");
                    },
                    set: function(val1) {
                        this.setPropertyValue("rows", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCommentModel.prototype, "cols", {
                    get: function() {
                        return this.getPropertyValue("cols");
                    },
                    set: function(val1) {
                        this.setPropertyValue("cols", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCommentModel.prototype, "acceptCarriageReturn", {
                    /**
         * Specifies whether the question allows line breaks.
         *
         * When this property is enabled, a user can press Enter to insert line breaks. They are saved as `\n` in survey results. The Comment question also recognizes and interprets the `\n` sequence as a line break when you set the question `value` in code.
         */ get: function() {
                        return this.getPropertyValue("acceptCarriageReturn");
                    },
                    set: function(val1) {
                        this.setPropertyValue("acceptCarriageReturn", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCommentModel.prototype, "autoGrow", {
                    /**
         * Specifies whether the comment area automatically increases its height to accomodate multi-line content.
         *
         * Default value: `false` (inherited from `SurveyModel`'s [`autoGrowComment`](https://surveyjs.io/form-library/documentation/surveymodel#autoGrowComment) property)
         * @see allowResize
         */ get: function() {
                        return this.getPropertyValue("autoGrow") || this.survey && this.survey.autoGrowComment;
                    },
                    set: function(val1) {
                        this.setPropertyValue("autoGrow", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCommentModel.prototype, "allowResize", {
                    /**
         * Specifies whether to display a resize handle for the comment area.
         *
         * Default value: `true` (inherited from `SurveyModel`'s [`allowResizeComment`](https://surveyjs.io/form-library/documentation/surveymodel#allowResizeComment) property)
         * @see autoGrow
         */ get: function() {
                        return this.getPropertyValue("allowResize");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowResize", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCommentModel.prototype, "renderedAllowResize", {
                    get: function() {
                        return this.allowResize && this.survey && this.survey.allowResizeComment;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCommentModel.prototype, "resizeStyle", {
                    get: function() {
                        return this.renderedAllowResize ? "both" : "none";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCommentModel.prototype.getType = function() {
                    return "comment";
                };
                QuestionCommentModel.prototype.afterRenderQuestionElement = function(el) {
                    var root = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root;
                    this.element = root.getElementById(this.inputId) || el;
                    this.updateElement();
                    _super.prototype.afterRenderQuestionElement.call(this, el);
                };
                QuestionCommentModel.prototype.updateElement = function() {
                    var _this = this;
                    if (this.element && this.autoGrow) setTimeout(function() {
                        return Object(_utils_utils__WEBPACK_IMPORTED_MODULE_3__["increaseHeightByContent"])(_this.element);
                    }, 1);
                };
                QuestionCommentModel.prototype.beforeDestroyQuestionElement = function(el) {
                    _super.prototype.beforeDestroyQuestionElement.call(this, el);
                    this.element = undefined;
                };
                QuestionCommentModel.prototype.onInput = function(event1) {
                    if (this.isInputTextUpdate) this.value = event1.target.value;
                    else this.updateElement();
                    this.updateRemainingCharacterCounter(event1.target.value);
                };
                QuestionCommentModel.prototype.onKeyDown = function(event1) {
                    this.onKeyDownPreprocess && this.onKeyDownPreprocess(event1);
                    if (!this.acceptCarriageReturn && (event1.key === "Enter" || event1.keyCode === 13)) {
                        event1.preventDefault();
                        event1.stopPropagation();
                    }
                };
                QuestionCommentModel.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    _super.prototype.setQuestionValue.call(this, newValue, updateIsAnswered);
                    this.updateElement();
                };
                QuestionCommentModel.prototype.onValueChanged = function() {
                    _super.prototype.onValueChanged.call(this);
                    this.updateElement();
                };
                QuestionCommentModel.prototype.setNewValue = function(newValue) {
                    if (!this.acceptCarriageReturn && !!newValue) // eslint-disable-next-line no-control-regex
                    newValue = newValue.replace(new RegExp("(\r\n|\n|\r)", "gm"), "");
                    _super.prototype.setNewValue.call(this, newValue);
                };
                QuestionCommentModel.prototype.getValueSeparator = function() {
                    return "\n";
                };
                Object.defineProperty(QuestionCommentModel.prototype, "className", {
                    get: function() {
                        return (this.cssClasses ? this.getControlClass() : "panel-comment-root") || undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                return QuestionCommentModel;
            }(_question_textbase__WEBPACK_IMPORTED_MODULE_2__["QuestionTextBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("comment", [
                {
                    name: "maxLength:number",
                    default: -1
                },
                {
                    name: "cols:number",
                    default: 50,
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "rows:number",
                    default: 4
                },
                {
                    name: "placeholder",
                    alternativeName: "placeHolder",
                    serializationProperty: "locPlaceholder"
                },
                {
                    name: "textUpdateMode",
                    default: "default",
                    choices: [
                        "default",
                        "onBlur",
                        "onTyping"
                    ]
                },
                {
                    name: "autoGrow:boolean"
                },
                {
                    name: "allowResize:boolean",
                    default: true
                },
                {
                    name: "acceptCarriageReturn:boolean",
                    default: true,
                    visible: false
                }
            ], function() {
                return new QuestionCommentModel("");
            }, "textbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].Instance.registerQuestion("comment", function(name) {
                return new QuestionCommentModel(name);
            });
        /***/ },
        /***/ "./src/question_custom.ts": /*!********************************!*\
  !*** ./src/question_custom.ts ***!
  \********************************/ /*! exports provided: ComponentQuestionJSON, ComponentCollection, QuestionCustomModelBase, QuestionCustomModel, QuestionCompositeModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentQuestionJSON", function() {
                return ComponentQuestionJSON;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentCollection", function() {
                return ComponentCollection;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomModelBase", function() {
                return QuestionCustomModelBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionCustomModel", function() {
                return QuestionCustomModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionCompositeModel", function() {
                return QuestionCompositeModel;
            });
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _textPreProcessor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./textPreProcessor */ "./src/textPreProcessor.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ComponentQuestionJSON = /** @class */ function() {
                function ComponentQuestionJSON(name, json) {
                    this.name = name;
                    this.json = json;
                    var self = this;
                    _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass(name, [], function(json) {
                        return ComponentCollection.Instance.createQuestion(!!json ? json.name : "", self);
                    }, "question");
                    this.onInit();
                }
                ComponentQuestionJSON.prototype.onInit = function() {
                    if (!this.json.onInit) return;
                    this.json.onInit();
                };
                ComponentQuestionJSON.prototype.onCreated = function(question) {
                    if (!this.json.onCreated) return;
                    this.json.onCreated(question);
                };
                ComponentQuestionJSON.prototype.onLoaded = function(question) {
                    if (!this.json.onLoaded) return;
                    this.json.onLoaded(question);
                };
                ComponentQuestionJSON.prototype.onAfterRender = function(question, htmlElement) {
                    if (!this.json.onAfterRender) return;
                    this.json.onAfterRender(question, htmlElement);
                };
                ComponentQuestionJSON.prototype.onAfterRenderContentElement = function(question, element, htmlElement) {
                    if (!this.json.onAfterRenderContentElement) return;
                    this.json.onAfterRenderContentElement(question, element, htmlElement);
                };
                ComponentQuestionJSON.prototype.onUpdateQuestionCssClasses = function(question, element, css) {
                    if (!this.json.onUpdateQuestionCssClasses) return;
                    this.json.onUpdateQuestionCssClasses(question, element, css);
                };
                ComponentQuestionJSON.prototype.onPropertyChanged = function(question, propertyName, newValue) {
                    if (!this.json.onPropertyChanged) return;
                    this.json.onPropertyChanged(question, propertyName, newValue);
                };
                ComponentQuestionJSON.prototype.onValueChanged = function(question, name, newValue) {
                    if (!this.json.onValueChanged) return;
                    this.json.onValueChanged(question, name, newValue);
                };
                ComponentQuestionJSON.prototype.onValueChanging = function(question, name, newValue) {
                    if (!this.json.onValueChanging) return newValue;
                    return this.json.onValueChanging(question, name, newValue);
                };
                ComponentQuestionJSON.prototype.onGetErrorText = function(question) {
                    if (!this.json.getErrorText) return undefined;
                    return this.json.getErrorText(question);
                };
                ComponentQuestionJSON.prototype.onItemValuePropertyChanged = function(question, item, propertyName, name, newValue) {
                    if (!this.json.onItemValuePropertyChanged) return;
                    this.json.onItemValuePropertyChanged(question, {
                        obj: item,
                        propertyName: propertyName,
                        name: name,
                        newValue: newValue
                    });
                };
                ComponentQuestionJSON.prototype.getDisplayValue = function(keyAsText, value, question) {
                    if (!this.json.getDisplayValue) return question.getDisplayValue(keyAsText, value);
                    return this.json.getDisplayValue(question);
                };
                Object.defineProperty(ComponentQuestionJSON.prototype, "defaultQuestionTitle", {
                    get: function() {
                        return this.json.defaultQuestionTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                ComponentQuestionJSON.prototype.setValueToQuestion = function(val1) {
                    var converter = this.json.valueToQuestion || this.json.setValue;
                    return !!converter ? converter(val1) : val1;
                };
                ComponentQuestionJSON.prototype.getValueFromQuestion = function(val1) {
                    var converter = this.json.valueFromQuestion || this.json.getValue;
                    return !!converter ? converter(val1) : val1;
                };
                Object.defineProperty(ComponentQuestionJSON.prototype, "isComposite", {
                    get: function() {
                        return !!this.json.elementsJSON || !!this.json.createElements;
                    },
                    enumerable: false,
                    configurable: true
                });
                ComponentQuestionJSON.prototype.getDynamicProperties = function() {
                    if (!Array.isArray(this.dynamicProperties)) this.dynamicProperties = this.calcDynamicProperties();
                    return this.dynamicProperties;
                };
                ComponentQuestionJSON.prototype.calcDynamicProperties = function() {
                    var baseProps = this.json.inheritBaseProps;
                    if (!baseProps || !this.json.questionJSON) return [];
                    var type = this.json.questionJSON.type;
                    if (!type) return [];
                    if (Array.isArray(baseProps)) {
                        var props_1 = [];
                        baseProps.forEach(function(name) {
                            var prop = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].findProperty(type, name);
                            if (prop) props_1.push(prop);
                        });
                        return props_1;
                    }
                    var invalidNames = [];
                    for(var key in this.json.questionJSON)invalidNames.push(key);
                    return _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].getDynamicPropertiesByTypes(this.name, type, invalidNames);
                };
                return ComponentQuestionJSON;
            }();
            var ComponentCollection = /** @class */ function() {
                function ComponentCollection() {
                    this.customQuestionValues = [];
                }
                ComponentCollection.prototype.add = function(json) {
                    if (!json) return;
                    var name = json.name;
                    if (!name) throw "Attribute name is missed";
                    name = name.toLowerCase();
                    if (!!this.getCustomQuestionByName(name)) throw "There is already registered custom question with name '" + name + "'";
                    if (!!_jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].findClass(name)) throw "There is already class with name '" + name + "'";
                    var customQuestion = new ComponentQuestionJSON(name, json);
                    if (!!this.onAddingJson) this.onAddingJson(name, customQuestion.isComposite);
                    this.customQuestionValues.push(customQuestion);
                };
                ComponentCollection.prototype.remove = function(componentName) {
                    if (!componentName) return false;
                    var index = this.getCustomQuestionIndex(componentName.toLowerCase());
                    if (index < 0) return false;
                    this.removeByIndex(index);
                    return true;
                };
                Object.defineProperty(ComponentCollection.prototype, "items", {
                    get: function() {
                        return this.customQuestionValues;
                    },
                    enumerable: false,
                    configurable: true
                });
                ComponentCollection.prototype.getCustomQuestionByName = function(name) {
                    var index = this.getCustomQuestionIndex(name);
                    return index >= 0 ? this.customQuestionValues[index] : undefined;
                };
                ComponentCollection.prototype.getCustomQuestionIndex = function(name) {
                    for(var i = 0; i < this.customQuestionValues.length; i++){
                        if (this.customQuestionValues[i].name === name) return i;
                    }
                    return -1;
                };
                ComponentCollection.prototype.removeByIndex = function(index) {
                    _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].removeClass(this.customQuestionValues[index].name);
                    this.customQuestionValues.splice(index, 1);
                };
                ComponentCollection.prototype.clear = function(includeInternal) {
                    for(var i = this.customQuestionValues.length - 1; i >= 0; i--)if (includeInternal || !this.customQuestionValues[i].json.internal) this.removeByIndex(i);
                };
                ComponentCollection.prototype.createQuestion = function(name, questionJSON) {
                    if (!!questionJSON.isComposite) return this.createCompositeModel(name, questionJSON);
                    return this.createCustomModel(name, questionJSON);
                };
                ComponentCollection.prototype.createCompositeModel = function(name, questionJSON) {
                    if (!!this.onCreateComposite) return this.onCreateComposite(name, questionJSON);
                    return new QuestionCompositeModel(name, questionJSON);
                };
                ComponentCollection.prototype.createCustomModel = function(name, questionJSON) {
                    if (!!this.onCreateCustom) return this.onCreateCustom(name, questionJSON);
                    return new QuestionCustomModel(name, questionJSON);
                };
                ComponentCollection.Instance = new ComponentCollection();
                return ComponentCollection;
            }();
            var QuestionCustomModelBase = /** @class */ function(_super) {
                __extends(QuestionCustomModelBase, _super);
                function QuestionCustomModelBase(name, customQuestion) {
                    var _this = _super.call(this, name) || this;
                    _this.customQuestion = customQuestion;
                    _jsonobject__WEBPACK_IMPORTED_MODULE_1__["CustomPropertiesCollection"].createProperties(_this);
                    _survey_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElement"].CreateDisabledDesignElements = true;
                    _this.locQuestionTitle = _this.createLocalizableString("questionTitle", _this);
                    _this.locQuestionTitle.setJson(_this.customQuestion.defaultQuestionTitle);
                    _this.createWrapper();
                    _survey_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElement"].CreateDisabledDesignElements = false;
                    if (!!_this.customQuestion) _this.customQuestion.onCreated(_this);
                    return _this;
                }
                QuestionCustomModelBase.prototype.getType = function() {
                    return !!this.customQuestion ? this.customQuestion.name : "custom";
                };
                QuestionCustomModelBase.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    if (!!this.getElement()) this.getElement().locStrsChanged();
                };
                QuestionCustomModelBase.prototype.localeChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    if (!!this.getElement()) this.getElement().localeChanged();
                };
                QuestionCustomModelBase.prototype.getDefaultTitle = function() {
                    if (!this.locQuestionTitle.isEmpty) return this.getProcessedText(this.locQuestionTitle.textOrHtml);
                    return _super.prototype.getDefaultTitle.call(this);
                };
                QuestionCustomModelBase.prototype.addUsedLocales = function(locales) {
                    _super.prototype.addUsedLocales.call(this, locales);
                    if (!!this.getElement()) this.getElement().addUsedLocales(locales);
                };
                QuestionCustomModelBase.prototype.needResponsiveWidth = function() {
                    var el = this.getElement();
                    return !!el ? el.needResponsiveWidth() : false;
                };
                QuestionCustomModelBase.prototype.createWrapper = function() {};
                QuestionCustomModelBase.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {
                    _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
                    if (!!this.customQuestion && !this.isLoadingFromJson) this.customQuestion.onPropertyChanged(this, name, newValue);
                };
                QuestionCustomModelBase.prototype.itemValuePropertyChanged = function(item, name, oldValue, newValue) {
                    _super.prototype.itemValuePropertyChanged.call(this, item, name, oldValue, newValue);
                    if (!!this.customQuestion && !this.isLoadingFromJson) this.customQuestion.onItemValuePropertyChanged(this, item, item.ownerPropertyName, name, newValue);
                };
                QuestionCustomModelBase.prototype.onFirstRendering = function() {
                    var el = this.getElement();
                    if (!!el) el.onFirstRendering();
                    _super.prototype.onFirstRendering.call(this);
                };
                QuestionCustomModelBase.prototype.onHidingContent = function() {
                    _super.prototype.onHidingContent.call(this);
                    var el = this.getElement();
                    if (!!el) el.onHidingContent();
                };
                QuestionCustomModelBase.prototype.getProgressInfo = function() {
                    var res = _super.prototype.getProgressInfo.call(this);
                    if (!!this.getElement()) res = this.getElement().getProgressInfo();
                    if (this.isRequired && res.requiredQuestionCount == 0) {
                        res.requiredQuestionCount = 1;
                        if (!this.isEmpty()) res.answeredQuestionCount = 1;
                    }
                    return res;
                };
                QuestionCustomModelBase.prototype.initElement = function(el) {
                    if (!el) return;
                    el.setSurveyImpl(this);
                    el.disableDesignActions = true;
                };
                QuestionCustomModelBase.prototype.setSurveyImpl = function(value, isLight) {
                    this.isSettingValOnLoading = true;
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    this.initElement(this.getElement());
                    this.isSettingValOnLoading = false;
                };
                QuestionCustomModelBase.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    if (!!this.getElement()) {
                        this.getElement().onSurveyLoad();
                        this.customQuestion.onLoaded(this);
                    }
                };
                QuestionCustomModelBase.prototype.afterRenderQuestionElement = function(el) {
                //Do nothing
                };
                QuestionCustomModelBase.prototype.afterRenderCore = function(el) {
                    _super.prototype.afterRenderCore.call(this, el);
                    if (!!this.customQuestion) this.customQuestion.onAfterRender(this, el);
                };
                QuestionCustomModelBase.prototype.onUpdateQuestionCssClasses = function(element, css) {
                    if (!!this.customQuestion) this.customQuestion.onUpdateQuestionCssClasses(this, element, css);
                };
                QuestionCustomModelBase.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    _super.prototype.setQuestionValue.call(this, newValue, updateIsAnswered);
                    this.updateElementCss();
                };
                QuestionCustomModelBase.prototype.setNewValue = function(newValue) {
                    _super.prototype.setNewValue.call(this, newValue);
                    this.updateElementCss();
                };
                QuestionCustomModelBase.prototype.onCheckForErrors = function(errors, isOnValueChanged) {
                    _super.prototype.onCheckForErrors.call(this, errors, isOnValueChanged);
                    if (!!this.customQuestion) {
                        var text = this.customQuestion.onGetErrorText(this);
                        if (!!text) errors.push(new _error__WEBPACK_IMPORTED_MODULE_6__["CustomError"](text, this));
                    }
                };
                //ISurveyImpl
                QuestionCustomModelBase.prototype.getSurveyData = function() {
                    return this;
                };
                QuestionCustomModelBase.prototype.getTextProcessor = function() {
                    return this.textProcessor;
                };
                //ISurveyData
                QuestionCustomModelBase.prototype.getValue = function(name) {
                    return this.value;
                };
                QuestionCustomModelBase.prototype.setValue = function(name, newValue, locNotification, allowNotifyValueChanged) {
                    if (!this.data) return;
                    var newName = this.convertDataName(name);
                    var valueForSurvey = this.convertDataValue(name, newValue);
                    if (this.valueToDataCallback) valueForSurvey = this.valueToDataCallback(valueForSurvey);
                    this.data.setValue(newName, valueForSurvey, locNotification, allowNotifyValueChanged);
                    this.updateIsAnswered();
                    this.updateElementCss();
                    if (!!this.customQuestion) this.customQuestion.onValueChanged(this, name, newValue);
                };
                QuestionCustomModelBase.prototype.getQuestionByName = function(name) {
                    return undefined;
                };
                QuestionCustomModelBase.prototype.isValueChanging = function(name, newValue) {
                    if (!!this.customQuestion) {
                        var qValue = newValue;
                        newValue = this.customQuestion.onValueChanging(this, name, newValue);
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isTwoValueEquals(newValue, qValue)) {
                            var q = this.getQuestionByName(name);
                            if (!!q) {
                                q.value = newValue;
                                return true;
                            }
                        }
                    }
                    return false;
                };
                QuestionCustomModelBase.prototype.convertDataName = function(name) {
                    return this.getValueName();
                };
                QuestionCustomModelBase.prototype.convertDataValue = function(name, newValue) {
                    return newValue;
                };
                QuestionCustomModelBase.prototype.getVariable = function(name) {
                    return !!this.data ? this.data.getVariable(name) : null;
                };
                QuestionCustomModelBase.prototype.setVariable = function(name, newValue) {
                    if (!this.data) return;
                    this.data.setVariable(name, newValue);
                };
                QuestionCustomModelBase.prototype.getComment = function(name) {
                    return !!this.data ? this.data.getComment(this.getValueName()) : "";
                };
                QuestionCustomModelBase.prototype.setComment = function(name, newValue, locNotification) {
                    if (!this.data) return;
                    this.data.setComment(this.getValueName(), newValue, locNotification);
                };
                QuestionCustomModelBase.prototype.getAllValues = function() {
                    return !!this.data ? this.data.getAllValues() : {};
                };
                QuestionCustomModelBase.prototype.getFilteredValues = function() {
                    return !!this.data ? this.data.getFilteredValues() : {};
                };
                QuestionCustomModelBase.prototype.getFilteredProperties = function() {
                    return !!this.data ? this.data.getFilteredProperties() : {};
                };
                QuestionCustomModelBase.prototype.findQuestionByName = function(name) {
                    return !!this.data ? this.data.findQuestionByName(name) : null;
                };
                //IPanel
                QuestionCustomModelBase.prototype.addElement = function(element, index) {};
                QuestionCustomModelBase.prototype.removeElement = function(element) {
                    return false;
                };
                QuestionCustomModelBase.prototype.getQuestionTitleLocation = function() {
                    return "left";
                };
                QuestionCustomModelBase.prototype.getQuestionStartIndex = function() {
                    return this.getStartIndex();
                };
                QuestionCustomModelBase.prototype.getChildrenLayoutType = function() {
                    return "row";
                };
                QuestionCustomModelBase.prototype.elementWidthChanged = function(el) {};
                Object.defineProperty(QuestionCustomModelBase.prototype, "elements", {
                    get: function() {
                        return [];
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCustomModelBase.prototype.indexOf = function(el) {
                    return -1;
                };
                QuestionCustomModelBase.prototype.ensureRowsVisibility = function() {
                // do nothing
                };
                QuestionCustomModelBase.prototype.validateContainerOnly = function() {
                // do nothing
                };
                QuestionCustomModelBase.prototype.getQuestionErrorLocation = function() {
                    return this.getErrorLocation();
                };
                QuestionCustomModelBase.prototype.getContentDisplayValueCore = function(keyAsText, value, question) {
                    if (!question) return _super.prototype.getDisplayValueCore.call(this, keyAsText, value);
                    return this.customQuestion.getDisplayValue(keyAsText, value, question);
                };
                return QuestionCustomModelBase;
            }(_question__WEBPACK_IMPORTED_MODULE_0__["Question"]);
            var QuestionCustomModel = /** @class */ function(_super) {
                __extends(QuestionCustomModel, _super);
                function QuestionCustomModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                QuestionCustomModel.prototype.getTemplate = function() {
                    return "custom";
                };
                QuestionCustomModel.prototype.getDynamicProperties = function() {
                    return this.customQuestion.getDynamicProperties() || [];
                };
                QuestionCustomModel.prototype.getDynamicType = function() {
                    return this.questionWrapper ? this.questionWrapper.getType() : "question";
                };
                QuestionCustomModel.prototype.getOriginalObj = function() {
                    return this.questionWrapper;
                };
                QuestionCustomModel.prototype.createWrapper = function() {
                    var _this = this;
                    this.questionWrapper = this.createQuestion();
                    this.createDynamicProperties(this.questionWrapper);
                    if (this.getDynamicProperties().length > 0) this.questionWrapper.onPropertyValueChangedCallback = function(name, oldValue, newValue, sender, arrayChanges) {
                        var prop = _this.getDynamicProperty(name);
                        if (prop) _this.propertyValueChanged(name, oldValue, newValue, arrayChanges);
                    };
                };
                QuestionCustomModel.prototype.getDynamicProperty = function(name) {
                    var props = this.getDynamicProperties();
                    for(var i = 0; i < props.length; i++){
                        if (props[i].name === name) return props[i];
                    }
                    return null;
                };
                QuestionCustomModel.prototype.getElement = function() {
                    return this.contentQuestion;
                };
                QuestionCustomModel.prototype.onAnyValueChanged = function(name, questionName) {
                    _super.prototype.onAnyValueChanged.call(this, name, questionName);
                    if (!!this.contentQuestion) this.contentQuestion.onAnyValueChanged(name, questionName);
                };
                QuestionCustomModel.prototype.getQuestionByName = function(name) {
                    return this.contentQuestion;
                };
                QuestionCustomModel.prototype.getDefaultTitle = function() {
                    if (this.hasJSONTitle && this.contentQuestion) return this.getProcessedText(this.contentQuestion.title);
                    return _super.prototype.getDefaultTitle.call(this);
                };
                QuestionCustomModel.prototype.setValue = function(name, newValue, locNotification, allowNotifyValueChanged) {
                    if (this.isValueChanging(name, newValue)) return;
                    _super.prototype.setValue.call(this, name, newValue, locNotification, allowNotifyValueChanged);
                };
                QuestionCustomModel.prototype.onSetData = function() {
                    _super.prototype.onSetData.call(this);
                    if (!!this.survey && !this.isEmpty()) this.setValue(this.name, this.value, false, this.allowNotifyValueChanged);
                };
                QuestionCustomModel.prototype.hasErrors = function(fireCallback, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (rec === void 0) rec = null;
                    if (!this.contentQuestion) return false;
                    var res = this.contentQuestion.hasErrors(fireCallback, rec);
                    this.errors = [];
                    for(var i = 0; i < this.contentQuestion.errors.length; i++)this.errors.push(this.contentQuestion.errors[i]);
                    if (!res) res = _super.prototype.hasErrors.call(this, fireCallback, rec);
                    this.updateElementCss();
                    return res;
                };
                QuestionCustomModel.prototype.focus = function(onError) {
                    if (onError === void 0) onError = false;
                    if (!!this.contentQuestion) this.contentQuestion.focus(onError);
                    else _super.prototype.focus.call(this, onError);
                };
                QuestionCustomModel.prototype.afterRenderCore = function(el) {
                    _super.prototype.afterRenderCore.call(this, el);
                    if (!!this.contentQuestion) this.contentQuestion.afterRender(el);
                };
                Object.defineProperty(QuestionCustomModel.prototype, "contentQuestion", {
                    get: function() {
                        return this.questionWrapper;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCustomModel.prototype.createQuestion = function() {
                    var _this = this;
                    var json = this.customQuestion.json;
                    var res = null;
                    if (!!json.questionJSON) {
                        this.hasJSONTitle = !!json.questionJSON.title;
                        var qType = json.questionJSON.type;
                        if (!qType || !_jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].findClass(qType)) throw "type attribute in questionJSON is empty or incorrect";
                        res = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass(qType);
                        this.initElement(res);
                        res.fromJSON(json.questionJSON);
                    } else if (!!json.createQuestion) {
                        res = json.createQuestion();
                        this.initElement(res);
                    }
                    if (!!res) {
                        res.isContentElement = true;
                        if (!res.name) res.name = "question";
                        res.onUpdateCssClassesCallback = function(css) {
                            _this.onUpdateQuestionCssClasses(res, css);
                        };
                        res.hasCssErrorCallback = function() {
                            return _this.errors.length > 0;
                        };
                        res.setValueChangedDirectlyCallback = function(val1) {
                            _this.setValueChangedDirectly(val1);
                        };
                    }
                    return res;
                };
                QuestionCustomModel.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    if (!this.contentQuestion) return;
                    if (this.isEmpty() && !this.contentQuestion.isEmpty()) this.value = this.getContentQuestionValue();
                };
                QuestionCustomModel.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    if (!!this.contentQuestion) this.contentQuestion.runCondition(values, properties);
                };
                QuestionCustomModel.prototype.convertDataName = function(name) {
                    var q = this.contentQuestion;
                    if (!q || name === this.getValueName()) return _super.prototype.convertDataName.call(this, name);
                    var newName = name.replace(q.getValueName(), this.getValueName());
                    return newName.indexOf(this.getValueName()) == 0 ? newName : _super.prototype.convertDataName.call(this, name);
                };
                QuestionCustomModel.prototype.convertDataValue = function(name, newValue) {
                    return this.convertDataName(name) == _super.prototype.convertDataName.call(this, name) ? this.getContentQuestionValue() : newValue;
                };
                QuestionCustomModel.prototype.getContentQuestionValue = function() {
                    if (!this.contentQuestion) return undefined;
                    var val1 = this.contentQuestion.value;
                    if (!!this.customQuestion) val1 = this.customQuestion.getValueFromQuestion(val1);
                    return val1;
                };
                QuestionCustomModel.prototype.setContentQuestionValue = function(val1) {
                    if (!this.contentQuestion) return;
                    if (!!this.customQuestion) val1 = this.customQuestion.setValueToQuestion(val1);
                    this.contentQuestion.value = val1;
                };
                QuestionCustomModel.prototype.canSetValueToSurvey = function() {
                    return false;
                };
                QuestionCustomModel.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    _super.prototype.setQuestionValue.call(this, newValue, updateIsAnswered);
                    if (!this.isLoadingFromJson && !!this.contentQuestion && !this.isTwoValueEquals(this.getContentQuestionValue(), newValue)) this.setContentQuestionValue(this.getUnbindValue(newValue));
                };
                QuestionCustomModel.prototype.onSurveyValueChanged = function(newValue) {
                    _super.prototype.onSurveyValueChanged.call(this, newValue);
                    if (!!this.contentQuestion) this.contentQuestion.onSurveyValueChanged(newValue);
                };
                QuestionCustomModel.prototype.getValueCore = function() {
                    if (!!this.contentQuestion) return this.getContentQuestionValue();
                    return _super.prototype.getValueCore.call(this);
                };
                QuestionCustomModel.prototype.setValueChangedDirectly = function(val1) {
                    if (this.isSettingValueChanged) return;
                    this.isSettingValueChanged = true;
                    _super.prototype.setValueChangedDirectly.call(this, val1);
                    if (!!this.contentQuestion) this.contentQuestion.setValueChangedDirectly(val1);
                    this.isSettingValueChanged = false;
                };
                QuestionCustomModel.prototype.createDynamicProperties = function(el) {
                    if (!el) return;
                    var props = this.getDynamicProperties();
                    if (Array.isArray(props)) _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addDynamicPropertiesIntoObj(this, el, props);
                };
                QuestionCustomModel.prototype.initElement = function(el) {
                    var _this = this;
                    _super.prototype.initElement.call(this, el);
                    if (!!el) {
                        el.parent = this;
                        el.afterRenderQuestionCallback = function(question, element) {
                            if (!!_this.customQuestion) _this.customQuestion.onAfterRenderContentElement(_this, question, element);
                        };
                    }
                };
                QuestionCustomModel.prototype.updateElementCss = function(reNew) {
                    if (!!this.contentQuestion) this.questionWrapper.updateElementCss(reNew);
                    _super.prototype.updateElementCss.call(this, reNew);
                };
                QuestionCustomModel.prototype.updateElementCssCore = function(cssClasses) {
                    if (!!this.contentQuestion) cssClasses = this.contentQuestion.cssClasses;
                    _super.prototype.updateElementCssCore.call(this, cssClasses);
                };
                QuestionCustomModel.prototype.getDisplayValueCore = function(keyAsText, value) {
                    return _super.prototype.getContentDisplayValueCore.call(this, keyAsText, value, this.contentQuestion);
                };
                return QuestionCustomModel;
            }(QuestionCustomModelBase);
            var QuestionCompositeTextProcessor = /** @class */ function(_super) {
                __extends(QuestionCompositeTextProcessor, _super);
                function QuestionCompositeTextProcessor(composite, variableName) {
                    var _this = _super.call(this, variableName) || this;
                    _this.composite = composite;
                    _this.variableName = variableName;
                    return _this;
                }
                Object.defineProperty(QuestionCompositeTextProcessor.prototype, "survey", {
                    get: function() {
                        return this.composite.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCompositeTextProcessor.prototype, "panel", {
                    get: function() {
                        return this.composite.contentPanel;
                    },
                    enumerable: false,
                    configurable: true
                });
                return QuestionCompositeTextProcessor;
            }(_textPreProcessor__WEBPACK_IMPORTED_MODULE_4__["QuestionTextProcessor"]);
            var QuestionCompositeModel = /** @class */ function(_super) {
                __extends(QuestionCompositeModel, _super);
                function QuestionCompositeModel(name, customQuestion) {
                    var _this = _super.call(this, name, customQuestion) || this;
                    _this.customQuestion = customQuestion;
                    _this.settingNewValue = false;
                    _this.textProcessing = new QuestionCompositeTextProcessor(_this, QuestionCompositeModel.ItemVariableName);
                    return _this;
                }
                QuestionCompositeModel.prototype.createWrapper = function() {
                    this.panelWrapper = this.createPanel();
                };
                QuestionCompositeModel.prototype.getTemplate = function() {
                    return "composite";
                };
                QuestionCompositeModel.prototype.getElement = function() {
                    return this.contentPanel;
                };
                QuestionCompositeModel.prototype.getCssRoot = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(_super.prototype.getCssRoot.call(this, cssClasses)).append(cssClasses.composite).toString();
                };
                Object.defineProperty(QuestionCompositeModel.prototype, "contentPanel", {
                    get: function() {
                        return this.panelWrapper;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCompositeModel.prototype.hasErrors = function(fireCallback, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (rec === void 0) rec = null;
                    var res = _super.prototype.hasErrors.call(this, fireCallback, rec);
                    if (!this.contentPanel) return res;
                    return this.contentPanel.hasErrors(fireCallback, false, rec) || res;
                };
                QuestionCompositeModel.prototype.updateElementCss = function(reNew) {
                    _super.prototype.updateElementCss.call(this, reNew);
                    if (this.contentPanel) this.contentPanel.updateElementCss(reNew);
                };
                QuestionCompositeModel.prototype.getTextProcessor = function() {
                    return this.textProcessing;
                };
                QuestionCompositeModel.prototype.findQuestionByName = function(name) {
                    var res = this.getQuestionByName(name);
                    if (!!res) return res;
                    return _super.prototype.findQuestionByName.call(this, name);
                };
                QuestionCompositeModel.prototype.clearValueIfInvisibleCore = function(reason) {
                    _super.prototype.clearValueIfInvisibleCore.call(this, reason);
                    var questions = this.contentPanel.questions;
                    for(var i = 0; i < questions.length; i++)questions[i].clearValueIfInvisible(reason);
                };
                QuestionCompositeModel.prototype.onAnyValueChanged = function(name, questionName) {
                    _super.prototype.onAnyValueChanged.call(this, name, questionName);
                    var questions = this.contentPanel.questions;
                    for(var i = 0; i < questions.length; i++)questions[i].onAnyValueChanged(name, questionName);
                };
                Object.defineProperty(QuestionCompositeModel.prototype, "hasSingleInput", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionCompositeModel.prototype, "isContainer", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionCompositeModel.prototype.createPanel = function() {
                    var _this = this;
                    var res = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass("panel");
                    res.showQuestionNumbers = "off";
                    res.renderWidth = "100%";
                    var json = this.customQuestion.json;
                    if (!!json.elementsJSON) res.fromJSON({
                        elements: json.elementsJSON
                    });
                    if (!!json.createElements) json.createElements(res, this);
                    this.initElement(res);
                    res.readOnly = this.isReadOnly;
                    res.questions.forEach(function(q) {
                        return q.onUpdateCssClassesCallback = function(css) {
                            _this.onUpdateQuestionCssClasses(q, css);
                        };
                    });
                    this.setAfterRenderCallbacks(res);
                    return res;
                };
                QuestionCompositeModel.prototype.onReadOnlyChanged = function() {
                    if (!!this.contentPanel) this.contentPanel.readOnly = this.isReadOnly;
                    _super.prototype.onReadOnlyChanged.call(this);
                };
                QuestionCompositeModel.prototype.onSurveyLoad = function() {
                    this.isSettingValOnLoading = true;
                    if (!!this.contentPanel) {
                        this.contentPanel.readOnly = this.isReadOnly;
                        this.setIsContentElement(this.contentPanel);
                    }
                    _super.prototype.onSurveyLoad.call(this);
                    if (!!this.contentPanel) {
                        var val1 = this.getContentPanelValue();
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isValueEmpty(val1)) this.value = val1;
                    }
                    this.isSettingValOnLoading = false;
                };
                QuestionCompositeModel.prototype.setIsContentElement = function(panel) {
                    panel.isContentElement = true;
                    var elements = panel.elements;
                    for(var i = 0; i < elements.length; i++){
                        var el = elements[i];
                        if (el.isPanel) this.setIsContentElement(el);
                        else el.isContentElement = true;
                    }
                };
                QuestionCompositeModel.prototype.setVisibleIndex = function(val1) {
                    var res = _super.prototype.setVisibleIndex.call(this, val1);
                    if (this.isVisible && !!this.contentPanel) res += this.contentPanel.setVisibleIndex(val1);
                    return res;
                };
                QuestionCompositeModel.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    if (!!this.contentPanel) {
                        var oldComposite = values[QuestionCompositeModel.ItemVariableName];
                        values[QuestionCompositeModel.ItemVariableName] = this.contentPanel.getValue();
                        this.contentPanel.runCondition(values, properties);
                        delete values[QuestionCompositeModel.ItemVariableName];
                        if (!!oldComposite) values[QuestionCompositeModel.ItemVariableName] = oldComposite;
                    }
                };
                QuestionCompositeModel.prototype.onSurveyValueChanged = function(newValue) {
                    _super.prototype.onSurveyValueChanged.call(this, newValue);
                    var val1 = !!newValue ? newValue : {};
                    if (!!this.contentPanel) this.contentPanel.questions.forEach(function(q) {
                        q.onSurveyValueChanged(val1[q.getValueName()]);
                    });
                };
                QuestionCompositeModel.prototype.getValue = function(name) {
                    var val1 = this.value;
                    return !!val1 ? val1[name] : null;
                };
                QuestionCompositeModel.prototype.getQuestionByName = function(name) {
                    return !!this.contentPanel ? this.contentPanel.getQuestionByName(name) : undefined;
                };
                QuestionCompositeModel.prototype.setValue = function(name, newValue, locNotification, allowNotifyValueChanged) {
                    if (this.settingNewValue) {
                        this.setNewValueIntoQuestion(name, newValue);
                        return;
                    }
                    if (this.isValueChanging(name, newValue)) return;
                    this.settingNewValue = true;
                    if (!this.isEditingSurveyElement && !!this.contentPanel) {
                        var index = 0;
                        var maxTimes = this.contentPanel.questions.length + 1;
                        while(index < maxTimes && this.updateValueCoreWithPanelValue())index++;
                    }
                    this.setNewValueIntoQuestion(name, newValue);
                    _super.prototype.setValue.call(this, name, newValue, locNotification, allowNotifyValueChanged);
                    this.settingNewValue = false;
                    this.runPanelTriggers(QuestionCompositeModel.ItemVariableName + "." + name, newValue);
                };
                QuestionCompositeModel.prototype.runPanelTriggers = function(name, value) {
                    if (!!this.contentPanel) this.contentPanel.questions.forEach(function(q) {
                        q.runTriggers(name, value);
                    });
                };
                QuestionCompositeModel.prototype.getFilteredValues = function() {
                    var values = !!this.data ? this.data.getFilteredValues() : {};
                    if (!!this.contentPanel) values[QuestionCompositeModel.ItemVariableName] = this.contentPanel.getValue();
                    return values;
                };
                QuestionCompositeModel.prototype.updateValueCoreWithPanelValue = function() {
                    var panelValue = this.getContentPanelValue();
                    if (this.isTwoValueEquals(this.getValueCore(), panelValue)) return false;
                    this.setValueCore(panelValue);
                    return true;
                };
                QuestionCompositeModel.prototype.getContentPanelValue = function(val1) {
                    if (!val1) val1 = this.contentPanel.getValue();
                    return this.customQuestion.setValueToQuestion(val1);
                };
                QuestionCompositeModel.prototype.getValueForContentPanel = function(val1) {
                    return this.customQuestion.getValueFromQuestion(val1);
                };
                QuestionCompositeModel.prototype.setNewValueIntoQuestion = function(name, newValue) {
                    var q = this.getQuestionByName(name);
                    if (!!q && !this.isTwoValueEquals(newValue, q.value)) q.value = newValue;
                };
                QuestionCompositeModel.prototype.addConditionObjectsByContext = function(objects, context) {
                    if (!this.contentPanel) return;
                    var questions = this.contentPanel.questions;
                    var prefixName = this.name;
                    var prefixText = this.title;
                    for(var i = 0; i < questions.length; i++)objects.push({
                        name: prefixName + "." + questions[i].name,
                        text: prefixText + "." + questions[i].title,
                        question: questions[i]
                    });
                };
                QuestionCompositeModel.prototype.collectNestedQuestionsCore = function(questions, visibleOnly) {
                    if (!this.contentPanel) return;
                    this.contentPanel.questions.forEach(function(q) {
                        return q.collectNestedQuestions(questions, visibleOnly);
                    });
                };
                QuestionCompositeModel.prototype.convertDataValue = function(name, newValue) {
                    var val1 = this.getValueForContentPanel(this.value);
                    if (!val1) val1 = {};
                    if (this.isValueEmpty(newValue) && !this.isEditingSurveyElement) delete val1[name];
                    else val1[name] = newValue;
                    return this.getContentPanelValue(val1);
                };
                QuestionCompositeModel.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    this.setValuesIntoQuestions(newValue);
                    if (!this.isEditingSurveyElement && !!this.contentPanel) newValue = this.getContentPanelValue();
                    _super.prototype.setQuestionValue.call(this, newValue, updateIsAnswered);
                };
                QuestionCompositeModel.prototype.setValuesIntoQuestions = function(newValue) {
                    if (!this.contentPanel) return;
                    newValue = this.getValueForContentPanel(newValue);
                    var oldSettingNewValue = this.settingNewValue;
                    this.settingNewValue = true;
                    var questions = this.contentPanel.questions;
                    for(var i = 0; i < questions.length; i++){
                        var key = questions[i].getValueName();
                        var val1 = !!newValue ? newValue[key] : undefined;
                        var q = questions[i];
                        if (!this.isTwoValueEquals(q.value, val1)) q.value = val1;
                    }
                    this.settingNewValue = oldSettingNewValue;
                };
                QuestionCompositeModel.prototype.getDisplayValueCore = function(keyAsText, value) {
                    return _super.prototype.getContentDisplayValueCore.call(this, keyAsText, value, this.contentPanel);
                };
                QuestionCompositeModel.prototype.setAfterRenderCallbacks = function(panel) {
                    var _this = this;
                    if (!panel || !this.customQuestion) return;
                    var questions = panel.questions;
                    for(var i = 0; i < questions.length; i++)questions[i].afterRenderQuestionCallback = function(question, element) {
                        _this.customQuestion.onAfterRenderContentElement(_this, question, element);
                    };
                };
                QuestionCompositeModel.ItemVariableName = "composite";
                return QuestionCompositeModel;
            }(QuestionCustomModelBase);
        /***/ },
        /***/ "./src/question_dropdown.ts": /*!**********************************!*\
  !*** ./src/question_dropdown.ts ***!
  \**********************************/ /*! exports provided: QuestionDropdownModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionDropdownModel", function() {
                return QuestionDropdownModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _question_baseselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_baseselect */ "./src/question_baseselect.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _dropdownListModel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./dropdownListModel */ "./src/dropdownListModel.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A class that describes the Dropdown question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-dropdown/ (linkStyle))
 */ var QuestionDropdownModel = /** @class */ function(_super) {
                __extends(QuestionDropdownModel, _super);
                function QuestionDropdownModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.lastSelectedItemValue = null;
                    _this.minMaxChoices = [];
                    _this.onOpened = _this.addEvent();
                    _this.createLocalizableString("placeholder", _this, false, true);
                    _this.createLocalizableString("clearCaption", _this, false, true);
                    _this.registerPropertyChangedHandlers([
                        "choicesMin",
                        "choicesMax",
                        "choicesStep"
                    ], function() {
                        _this.onVisibleChoicesChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "value",
                        "renderAs",
                        "showOtherItem",
                        "otherText",
                        "placeholder",
                        "choices",
                        "visibleChoices"
                    ], function() {
                        _this.updateReadOnlyText();
                    });
                    _this.updateReadOnlyText();
                    return _this;
                }
                QuestionDropdownModel.prototype.updateReadOnlyText = function() {
                    var result = !!this.selectedItem ? "" : this.placeholder;
                    if (this.renderAs == "select") {
                        if (this.isOtherSelected) result = this.otherText;
                        else if (this.isNoneSelected) result = this.noneText;
                        else if (!!this.selectedItem) result = this.selectedItemText;
                    }
                    this.readOnlyText = result;
                };
                QuestionDropdownModel.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.updateReadOnlyText();
                };
                Object.defineProperty(QuestionDropdownModel.prototype, "showOptionsCaption", {
                    get: function() {
                        return this.allowClear;
                    },
                    set: function(val1) {
                        this.allowClear = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "showClearButton", {
                    get: function() {
                        return this.allowClear && !this.isEmpty() && (!this.isDesignMode || _settings__WEBPACK_IMPORTED_MODULE_5__["settings"].supportCreatorV2);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "optionsCaption", {
                    get: function() {
                        return this.placeholder;
                    },
                    set: function(val1) {
                        this.placeholder = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "placeholder", {
                    /**
         * A placeholder for the input field.
         */ get: function() {
                        return this.getLocalizableStringText("placeholder");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("placeholder", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "locPlaceholder", {
                    get: function() {
                        return this.getLocalizableString("placeholder");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "clearCaption", {
                    get: function() {
                        return this.getLocalizableStringText("clearCaption");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("clearCaption", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "locClearCaption", {
                    get: function() {
                        return this.getLocalizableString("clearCaption");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionDropdownModel.prototype.getType = function() {
                    return "dropdown";
                };
                Object.defineProperty(QuestionDropdownModel.prototype, "ariaRole", {
                    get: function() {
                        return "combobox";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "selectedItem", {
                    get: function() {
                        return this.getSingleSelectedItem();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionDropdownModel.prototype.onGetSingleSelectedItem = function(selectedItemByValue) {
                    if (!!selectedItemByValue) this.lastSelectedItemValue = selectedItemByValue;
                };
                QuestionDropdownModel.prototype.supportGoNextPageAutomatic = function() {
                    return !this.isOtherSelected;
                };
                QuestionDropdownModel.prototype.getChoices = function() {
                    var items = _super.prototype.getChoices.call(this);
                    if (this.choicesMax <= this.choicesMin) return items;
                    var res = [];
                    for(var i = 0; i < items.length; i++)res.push(items[i]);
                    if (this.minMaxChoices.length === 0 || this.minMaxChoices.length !== (this.choicesMax - this.choicesMin) / this.choicesStep + 1) {
                        this.minMaxChoices = [];
                        for(var i = this.choicesMin; i <= this.choicesMax; i += this.choicesStep)this.minMaxChoices.push(this.createItemValue(i));
                    }
                    res = res.concat(this.minMaxChoices);
                    return res;
                };
                Object.defineProperty(QuestionDropdownModel.prototype, "choicesMin", {
                    /**
         * Use the `choicesMin`, `choicesMax`, and `choicesStep` properties to generate choice items automatically. For example, the configuration below generates three choice items: [10, 20, 30].
         *
         * ```js
         * "choicesMin": 10,
         * "choicesMax": 30
         * "choicesStep": 10
         * ```
         * @see choicesMax
         * @see choicesStep
         */ get: function() {
                        return this.getPropertyValue("choicesMin");
                    },
                    set: function(val1) {
                        this.setPropertyValue("choicesMin", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "choicesMax", {
                    /**
         * Use the `choicesMin`, `choicesMax`, and `choicesStep` properties to generate choice items automatically. For example, the configuration below generates three choice items: [10, 20, 30].
         *
         * ```js
         * "choicesMin": 10,
         * "choicesMax": 30
         * "choicesStep": 10
         * ```
         * @see choicesMin
         * @see choicesStep
         */ get: function() {
                        return this.getPropertyValue("choicesMax");
                    },
                    set: function(val1) {
                        this.setPropertyValue("choicesMax", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "choicesStep", {
                    /**
         * Use the `choicesMin`, `choicesMax`, and `choicesStep` properties to generate choice items automatically. For example, the configuration below generates three choice items: [10, 20, 30].
         *
         * ```js
         * "choicesMin": 10,
         * "choicesMax": 30
         * "choicesStep": 10
         * ```
         *
         * The default value of the `choicesStep` property is 1.
         * @see choicesMin
         * @see choicesMax
         */ get: function() {
                        return this.getPropertyValue("choicesStep");
                    },
                    set: function(val1) {
                        if (val1 < 1) val1 = 1;
                        this.setPropertyValue("choicesStep", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "autocomplete", {
                    get: function() {
                        return this.getPropertyValue("autocomplete", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("autocomplete", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionDropdownModel.prototype.getControlClass = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.cssClasses.control).append(this.cssClasses.controlEmpty, this.isEmpty()).append(this.cssClasses.onError, this.hasCssError()).append(this.cssClasses.controlDisabled, this.isReadOnly).append(this.cssClasses.controlInputFieldComponent, !!this.inputFieldComponentName).toString();
                };
                Object.defineProperty(QuestionDropdownModel.prototype, "selectedItemLocText", {
                    get: function() {
                        var item = this.suggestedItem || this.selectedItem;
                        return item === null || item === void 0 ? void 0 : item.locText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "inputFieldComponentName", {
                    get: function() {
                        return this.inputFieldComponent || this.itemComponent;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "showSelectedItemLocText", {
                    get: function() {
                        return !this.inputHasValue && !this.inputFieldComponentName && !!this.selectedItemLocText && this.dropdownListModel.canShowSelectedItem;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "showInputFieldComponent", {
                    get: function() {
                        return !this.inputHasValue && !!this.inputFieldComponentName && !this.isEmpty();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "selectedItemText", {
                    get: function() {
                        var item = this.selectedItem;
                        return !!item ? item.text : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "dropdownListModel", {
                    get: function() {
                        if (this.renderAs !== "select" && !this.dropdownListModelValue) this.dropdownListModelValue = new _dropdownListModel__WEBPACK_IMPORTED_MODULE_4__["DropdownListModel"](this);
                        return this.dropdownListModelValue;
                    },
                    set: function(val1) {
                        this.dropdownListModelValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "popupModel", {
                    get: function() {
                        var _a;
                        return (_a = this.dropdownListModel) === null || _a === void 0 ? void 0 : _a.popupModel;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionDropdownModel.prototype, "ariaExpanded", {
                    get: function() {
                        var popupModel = this.popupModel;
                        return !!popupModel && popupModel.isVisible ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionDropdownModel.prototype.onOpenedCallBack = function() {
                    this.onOpened.fire(this, {
                        question: this,
                        choices: this.choices
                    });
                };
                QuestionDropdownModel.prototype.onSelectedItemValuesChangedHandler = function(newValue) {
                    var _a;
                    (_a = this.dropdownListModel) === null || _a === void 0 || _a.setInputStringFromSelectedItem(newValue);
                    _super.prototype.onSelectedItemValuesChangedHandler.call(this, newValue);
                };
                QuestionDropdownModel.prototype.hasUnknownValue = function(val1, includeOther, isFilteredChoices, checkEmptyValue) {
                    if (this.choicesLazyLoadEnabled) return false;
                    return _super.prototype.hasUnknownValue.call(this, val1, includeOther, isFilteredChoices, checkEmptyValue);
                };
                QuestionDropdownModel.prototype.needConvertRenderedOtherToDataValue = function() {
                    var _a;
                    var val1 = (_a = this.otherValue) === null || _a === void 0 ? void 0 : _a.trim();
                    if (!val1) return false;
                    return _super.prototype.hasUnknownValue.call(this, val1, true, false);
                };
                QuestionDropdownModel.prototype.getItemIfChoicesNotContainThisValue = function(value, text) {
                    if (this.choicesLazyLoadEnabled && !this.dropdownListModel.isAllDataLoaded) return this.createItemValue(value, text);
                    else return _super.prototype.getItemIfChoicesNotContainThisValue.call(this, value, text);
                };
                QuestionDropdownModel.prototype.onVisibleChoicesChanged = function() {
                    _super.prototype.onVisibleChoicesChanged.call(this);
                    if (!this.isLoadingFromJson && this.popupModel) this.dropdownListModel.updateItems();
                };
                QuestionDropdownModel.prototype.getFirstInputElementId = function() {
                    return this.inputId + (this.searchEnabled ? "_0" : "");
                };
                QuestionDropdownModel.prototype.getInputId = function() {
                    return this.inputId + "_0";
                };
                QuestionDropdownModel.prototype.clearValue = function() {
                    var _a;
                    _super.prototype.clearValue.call(this);
                    this.lastSelectedItemValue = null;
                    (_a = this.dropdownListModel) === null || _a === void 0 || _a.clear();
                };
                QuestionDropdownModel.prototype.onClick = function(e) {
                    !!this.onOpenedCallBack && this.onOpenedCallBack();
                };
                QuestionDropdownModel.prototype.onKeyUp = function(event1) {
                    var char = event1.which || event1.keyCode;
                    if (char === 46) {
                        this.clearValue();
                        event1.preventDefault();
                        event1.stopPropagation();
                    }
                };
                QuestionDropdownModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (!!this.dropdownListModelValue) this.dropdownListModelValue.dispose();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionDropdownModel.prototype, "allowClear", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        onSet: function(newValue, target) {
                            if (!!target.dropdownListModel) target.dropdownListModel.setSearchEnabled(newValue);
                        }
                    })
                ], QuestionDropdownModel.prototype, "searchEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionDropdownModel.prototype, "searchMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionDropdownModel.prototype, "textWrapEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], QuestionDropdownModel.prototype, "inputHasValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: ""
                    })
                ], QuestionDropdownModel.prototype, "readOnlyText", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionDropdownModel.prototype, "choicesLazyLoadEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionDropdownModel.prototype, "choicesLazyLoadPageSize", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionDropdownModel.prototype, "suggestedItem", void 0);
                return QuestionDropdownModel;
            }(_question_baseselect__WEBPACK_IMPORTED_MODULE_2__["QuestionSelectBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("dropdown", [
                {
                    name: "placeholder",
                    alternativeName: "optionsCaption",
                    serializationProperty: "locPlaceholder"
                },
                {
                    name: "allowClear:boolean",
                    alternativeName: "showOptionsCaption",
                    default: true
                },
                {
                    name: "choicesMin:number",
                    default: 0
                },
                {
                    name: "choicesMax:number",
                    default: 0
                },
                {
                    name: "choicesStep:number",
                    default: 1,
                    minValue: 1
                },
                {
                    name: "autocomplete",
                    alternativeName: "autoComplete",
                    choices: _settings__WEBPACK_IMPORTED_MODULE_5__["settings"].questions.dataList
                },
                {
                    name: "textWrapEnabled:boolean",
                    default: true
                },
                {
                    name: "renderAs",
                    default: "default",
                    visible: false
                },
                {
                    name: "searchEnabled:boolean",
                    default: true,
                    visible: false
                },
                {
                    name: "searchMode",
                    default: "contains",
                    choices: [
                        "contains",
                        "startsWith"
                    ]
                },
                {
                    name: "choicesLazyLoadEnabled:boolean",
                    default: false,
                    visible: false
                },
                {
                    name: "choicesLazyLoadPageSize:number",
                    default: 25,
                    visible: false
                },
                {
                    name: "inputFieldComponent",
                    visible: false
                },
                {
                    name: "itemComponent",
                    visible: false,
                    default: ""
                }
            ], function() {
                return new QuestionDropdownModel("");
            }, "selectbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].Instance.registerQuestion("dropdown", function(name) {
                var q = new QuestionDropdownModel(name);
                q.choices = _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].DefaultChoices;
                return q;
            });
        /***/ },
        /***/ "./src/question_empty.ts": /*!*******************************!*\
  !*** ./src/question_empty.ts ***!
  \*******************************/ /*! exports provided: QuestionEmptyModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionEmptyModel", function() {
                return QuestionEmptyModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * A Model for an question that renders empty "div" tag. It used as a base class for some custom widgets
 */ var QuestionEmptyModel = /** @class */ function(_super) {
                __extends(QuestionEmptyModel, _super);
                function QuestionEmptyModel(name) {
                    return _super.call(this, name) || this;
                }
                QuestionEmptyModel.prototype.getType = function() {
                    return "empty";
                };
                return QuestionEmptyModel;
            }(_question__WEBPACK_IMPORTED_MODULE_1__["Question"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("empty", [], function() {
                return new QuestionEmptyModel("");
            }, "question");
        /***/ },
        /***/ "./src/question_expression.ts": /*!************************************!*\
  !*** ./src/question_expression.ts ***!
  \************************************/ /*! exports provided: QuestionExpressionModel, getCurrecyCodes */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionExpressionModel", function() {
                return QuestionExpressionModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCurrecyCodes", function() {
                return getCurrecyCodes;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * A class that describes the Expression question type. It is a read-only question type that calculates a value based on a specified expression.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-expression/ (linkStyle))
 */ var QuestionExpressionModel = /** @class */ function(_super) {
                __extends(QuestionExpressionModel, _super);
                function QuestionExpressionModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.createLocalizableString("format", _this);
                    _this.registerPropertyChangedHandlers([
                        "expression"
                    ], function() {
                        if (_this.expressionRunner) _this.expressionRunner = _this.createRunner();
                    });
                    _this.registerPropertyChangedHandlers([
                        "format",
                        "currency",
                        "displayStyle"
                    ], function() {
                        _this.updateFormatedValue();
                    });
                    return _this;
                }
                QuestionExpressionModel.prototype.getType = function() {
                    return "expression";
                };
                Object.defineProperty(QuestionExpressionModel.prototype, "hasInput", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "format", {
                    /**
         * A string that formats a question value. Use `{0}` to reference the question value in the format string.
         * @see displayStyle
         */ get: function() {
                        return this.getLocalizableStringText("format", "");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("format", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "locFormat", {
                    get: function() {
                        return this.getLocalizableString("format");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "expression", {
                    /**
         * An expression used to calculate the question value.
         *
         * Refer to the following help topic for more information: [Expressions](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#expressions).
         */ get: function() {
                        return this.getPropertyValue("expression", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("expression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionExpressionModel.prototype.locCalculation = function() {
                    this.expressionIsRunning = true;
                };
                QuestionExpressionModel.prototype.unlocCalculation = function() {
                    this.expressionIsRunning = false;
                };
                QuestionExpressionModel.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    if (!this.expression || this.expressionIsRunning || !this.runIfReadOnly && this.isReadOnly) return;
                    this.locCalculation();
                    if (!this.expressionRunner) this.expressionRunner = this.createRunner();
                    this.expressionRunner.run(values, properties);
                };
                QuestionExpressionModel.prototype.canCollectErrors = function() {
                    return true;
                };
                QuestionExpressionModel.prototype.hasRequiredError = function() {
                    return false;
                };
                QuestionExpressionModel.prototype.createRunner = function() {
                    var _this = this;
                    var res = this.createExpressionRunner(this.expression);
                    res.onRunComplete = function(newValue) {
                        _this.value = _this.roundValue(newValue);
                        _this.unlocCalculation();
                    };
                    return res;
                };
                Object.defineProperty(QuestionExpressionModel.prototype, "maximumFractionDigits", {
                    /**
         * The maximum number of fraction digits. Applies only if the `displayStyle` property is not `"none"`. Accepts values in the range from -1 to 20, where -1 disables the property.
         *
         * Default value: -1
         * @see displayStyle
         * @see minimumFractionDigits
         * @see precision
         */ get: function() {
                        return this.getPropertyValue("maximumFractionDigits");
                    },
                    set: function(val1) {
                        if (val1 < -1 || val1 > 20) return;
                        this.setPropertyValue("maximumFractionDigits", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "minimumFractionDigits", {
                    /**
         * The minimum number of fraction digits. Applies only if the `displayStyle` property is not `"none"`. Accepts values in the range from -1 to 20, where -1 disables the property.
         *
         * Default value: -1
         * @see displayStyle
         * @see maximumFractionDigits
         */ get: function() {
                        return this.getPropertyValue("minimumFractionDigits");
                    },
                    set: function(val1) {
                        if (val1 < -1 || val1 > 20) return;
                        this.setPropertyValue("minimumFractionDigits", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "runIfReadOnly", {
                    get: function() {
                        return this.runIfReadOnlyValue === true;
                    },
                    set: function(val1) {
                        this.runIfReadOnlyValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "formatedValue", {
                    get: function() {
                        return this.getPropertyValue("formatedValue", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionExpressionModel.prototype.updateFormatedValue = function() {
                    this.setPropertyValue("formatedValue", this.getDisplayValueCore(false, this.value));
                };
                QuestionExpressionModel.prototype.onValueChanged = function() {
                    this.updateFormatedValue();
                };
                QuestionExpressionModel.prototype.updateValueFromSurvey = function(newValue, clearData) {
                    _super.prototype.updateValueFromSurvey.call(this, newValue, clearData);
                    this.updateFormatedValue();
                };
                QuestionExpressionModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    var val1 = value === undefined || value === null ? this.defaultValue : value;
                    var res = "";
                    if (!this.isValueEmpty(val1)) {
                        var str = this.getValueAsStr(val1);
                        res = !this.format ? str : this.format["format"](str);
                    }
                    if (!!this.survey) res = this.survey.getExpressionDisplayValue(this, val1, res);
                    return res;
                };
                Object.defineProperty(QuestionExpressionModel.prototype, "displayStyle", {
                    /**
         * Specifies a display style for the question value.
         *
         * Possible values:
         *
         * - `"decimal"`
         * - `"currency"`
         * - `"percent"`
         * - `"date"`
         * - `"none"` (default)
         *
         * If you use the `"currency"` display style, you can also set the `currency` property to specify a currency other than USD.
         * @see currency
         * @see minimumFractionDigits
         * @see maximumFractionDigits
         * @see format
         */ get: function() {
                        return this.getPropertyValue("displayStyle");
                    },
                    set: function(val1) {
                        this.setPropertyValue("displayStyle", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "currency", {
                    /**
         * A three-letter currency code. Applies only if the `displayStyle` property is set to `"currency"`.
         *
         * Default value: "USD".
         * @see displayStyle
         * @see minimumFractionDigits
         * @see maximumFractionDigits
         * @see format
         */ get: function() {
                        return this.getPropertyValue("currency");
                    },
                    set: function(val1) {
                        if (getCurrecyCodes().indexOf(val1) < 0) return;
                        this.setPropertyValue("currency", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "useGrouping", {
                    /**
         * Specifies whether to use grouping separators in number representation. Separators depend on the selected [locale](https://surveyjs.io/form-library/documentation/surveymodel#locale).
         *
         * Default value: `true`
         */ get: function() {
                        return this.getPropertyValue("useGrouping");
                    },
                    set: function(val1) {
                        this.setPropertyValue("useGrouping", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionExpressionModel.prototype, "precision", {
                    /**
         * Specifies how many decimal digits to keep in the expression value.
         *
         * Default value: -1 (unlimited)
         * @see maximumFractionDigits
         */ get: function() {
                        return this.getPropertyValue("precision");
                    },
                    set: function(val1) {
                        this.setPropertyValue("precision", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionExpressionModel.prototype.roundValue = function(val1) {
                    if (val1 === Infinity) return undefined;
                    if (this.precision < 0) return val1;
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(val1)) return val1;
                    return parseFloat(val1.toFixed(this.precision));
                };
                QuestionExpressionModel.prototype.getValueAsStr = function(val1) {
                    if (this.displayStyle == "date") {
                        var d = new Date(val1);
                        if (!!d && !!d.toLocaleDateString) return d.toLocaleDateString();
                    }
                    if (this.displayStyle != "none" && _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(val1)) {
                        var locale = this.getLocale();
                        if (!locale) locale = "en";
                        var options = {
                            style: this.displayStyle,
                            currency: this.currency,
                            useGrouping: this.useGrouping
                        };
                        if (this.maximumFractionDigits > -1) options["maximumFractionDigits"] = this.maximumFractionDigits;
                        if (this.minimumFractionDigits > -1) options["minimumFractionDigits"] = this.minimumFractionDigits;
                        return val1.toLocaleString(locale, options);
                    }
                    return val1.toString();
                };
                return QuestionExpressionModel;
            }(_question__WEBPACK_IMPORTED_MODULE_1__["Question"]);
            function getCurrecyCodes() {
                return [
                    "AED",
                    "AFN",
                    "ALL",
                    "AMD",
                    "ANG",
                    "AOA",
                    "ARS",
                    "AUD",
                    "AWG",
                    "AZN",
                    "BAM",
                    "BBD",
                    "BDT",
                    "BGN",
                    "BHD",
                    "BIF",
                    "BMD",
                    "BND",
                    "BOB",
                    "BOV",
                    "BRL",
                    "BSD",
                    "BTN",
                    "BWP",
                    "BYN",
                    "BZD",
                    "CAD",
                    "CDF",
                    "CHE",
                    "CHF",
                    "CHW",
                    "CLF",
                    "CLP",
                    "CNY",
                    "COP",
                    "COU",
                    "CRC",
                    "CUC",
                    "CUP",
                    "CVE",
                    "CZK",
                    "DJF",
                    "DKK",
                    "DOP",
                    "DZD",
                    "EGP",
                    "ERN",
                    "ETB",
                    "EUR",
                    "FJD",
                    "FKP",
                    "GBP",
                    "GEL",
                    "GHS",
                    "GIP",
                    "GMD",
                    "GNF",
                    "GTQ",
                    "GYD",
                    "HKD",
                    "HNL",
                    "HRK",
                    "HTG",
                    "HUF",
                    "IDR",
                    "ILS",
                    "INR",
                    "IQD",
                    "IRR",
                    "ISK",
                    "JMD",
                    "JOD",
                    "JPY",
                    "KES",
                    "KGS",
                    "KHR",
                    "KMF",
                    "KPW",
                    "KRW",
                    "KWD",
                    "KYD",
                    "KZT",
                    "LAK",
                    "LBP",
                    "LKR",
                    "LRD",
                    "LSL",
                    "LYD",
                    "MAD",
                    "MDL",
                    "MGA",
                    "MKD",
                    "MMK",
                    "MNT",
                    "MOP",
                    "MRO",
                    "MUR",
                    "MVR",
                    "MWK",
                    "MXN",
                    "MXV",
                    "MYR",
                    "MZN",
                    "NAD",
                    "NGN",
                    "NIO",
                    "NOK",
                    "NPR",
                    "NZD",
                    "OMR",
                    "PAB",
                    "PEN",
                    "PGK",
                    "PHP",
                    "PKR",
                    "PLN",
                    "PYG",
                    "QAR",
                    "RON",
                    "RSD",
                    "RUB",
                    "RWF",
                    "SAR",
                    "SBD",
                    "SCR",
                    "SDG",
                    "SEK",
                    "SGD",
                    "SHP",
                    "SLL",
                    "SOS",
                    "SRD",
                    "SSP",
                    "STD",
                    "SVC",
                    "SYP",
                    "SZL",
                    "THB",
                    "TJS",
                    "TMT",
                    "TND",
                    "TOP",
                    "TRY",
                    "TTD",
                    "TWD",
                    "TZS",
                    "UAH",
                    "UGX",
                    "USD",
                    "USN",
                    "UYI",
                    "UYU",
                    "UZS",
                    "VEF",
                    "VND",
                    "VUV",
                    "WST",
                    "XAF",
                    "XAG",
                    "XAU",
                    "XBA",
                    "XBB",
                    "XBC",
                    "XBD",
                    "XCD",
                    "XDR",
                    "XOF",
                    "XPD",
                    "XPF",
                    "XPT",
                    "XSU",
                    "XTS",
                    "XUA",
                    "XXX",
                    "YER",
                    "ZAR",
                    "ZMW",
                    "ZWL"
                ];
            }
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("expression", [
                "expression:expression",
                {
                    name: "format",
                    serializationProperty: "locFormat"
                },
                {
                    name: "displayStyle",
                    default: "none",
                    choices: [
                        "none",
                        "decimal",
                        "currency",
                        "percent",
                        "date"
                    ]
                },
                {
                    name: "currency",
                    choices: function() {
                        return getCurrecyCodes();
                    },
                    default: "USD",
                    visibleIf: function(obj) {
                        return obj.displayStyle === "currency";
                    }
                },
                {
                    name: "maximumFractionDigits:number",
                    default: -1
                },
                {
                    name: "minimumFractionDigits:number",
                    default: -1
                },
                {
                    name: "useGrouping:boolean",
                    default: true
                },
                {
                    name: "precision:number",
                    default: -1,
                    category: "data"
                },
                {
                    name: "enableIf",
                    visible: false
                },
                {
                    name: "isRequired",
                    visible: false
                },
                {
                    name: "readOnly",
                    visible: false
                },
                {
                    name: "requiredErrorText",
                    visible: false
                },
                {
                    name: "defaultValueExpression",
                    visible: false
                },
                {
                    name: "defaultValue",
                    visible: false
                },
                {
                    name: "correctAnswer",
                    visible: false
                },
                {
                    name: "requiredIf",
                    visible: false
                }
            ], function() {
                return new QuestionExpressionModel("");
            }, "question");
            _questionfactory__WEBPACK_IMPORTED_MODULE_3__["QuestionFactory"].Instance.registerQuestion("expression", function(name) {
                return new QuestionExpressionModel(name);
            });
        /***/ },
        /***/ "./src/question_file.ts": /*!******************************!*\
  !*** ./src/question_file.ts ***!
  \******************************/ /*! exports provided: dataUrl2File, QuestionFileModelBase, QuestionFileModel, FileLoader */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "dataUrl2File", function() {
                return dataUrl2File;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionFileModelBase", function() {
                return QuestionFileModelBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionFileModel", function() {
                return QuestionFileModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FileLoader", function() {
                return FileLoader;
            });
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _utils_camera__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./utils/camera */ "./src/utils/camera.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            function dataUrl2File(dataUrl, fileName, type) {
                var str = atob(dataUrl.split(",")[1]);
                var buffer = new Uint8Array(str.split("").map(function(c) {
                    return c.charCodeAt(0);
                })).buffer;
                return new File([
                    buffer
                ], fileName, {
                    type: type
                });
            }
            /**
 * A base class for question types that support file upload: `QuestionFileModel` and `QuestionSignaturePadModel`.
 */ var QuestionFileModelBase = /** @class */ function(_super) {
                __extends(QuestionFileModelBase, _super);
                function QuestionFileModelBase() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.isUploading = false;
                    /**
         * An event that is raised after the upload state has changed.
         *
         * Parameters:
         *
         * - `sender`: `SurveyModel`\
         * A survey instance that raised the event.
         * - `options.state`: `string`\
         * The current upload state: `"empty"`, `"loading"`, `"loaded"`, or `"error"`.
         */ _this.onUploadStateChanged = _this.addEvent();
                    _this.onStateChanged = _this.addEvent();
                    return _this;
                }
                QuestionFileModelBase.prototype.stateChanged = function(state) {
                    if (this.currentState == state) return;
                    if (state === "loading") this.isUploading = true;
                    if (state === "loaded") this.isUploading = false;
                    if (state === "error") this.isUploading = false;
                    this.currentState = state;
                    this.onStateChanged.fire(this, {
                        state: state
                    });
                    this.onUploadStateChanged.fire(this, {
                        state: state
                    });
                };
                Object.defineProperty(QuestionFileModelBase.prototype, "showLoadingIndicator", {
                    get: function() {
                        return this.isUploading && this.isDefaultV2Theme;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModelBase.prototype, "storeDataAsText", {
                    /**
         * Specifies whether to store file or signature content as text in `SurveyModel`'s [`data`](https://surveyjs.io/form-library/documentation/surveymodel#data) property.
         *
         * If you disable this property, implement `SurveyModel`'s [`onUploadFiles`](https://surveyjs.io/form-library/documentation/surveymodel#onUploadFiles) event handler to specify how to store file content.
         */ get: function() {
                        return this.getPropertyValue("storeDataAsText");
                    },
                    set: function(val1) {
                        this.setPropertyValue("storeDataAsText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModelBase.prototype, "waitForUpload", {
                    /**
           * Enable this property if you want to wait until files are uploaded to complete the survey.
           *
           * Default value: `false`
           */ get: function() {
                        return this.getPropertyValue("waitForUpload");
                    },
                    set: function(val1) {
                        this.setPropertyValue("waitForUpload", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModelBase.prototype.clearValue = function() {
                    this.clearOnDeletingContainer();
                    _super.prototype.clearValue.call(this);
                };
                QuestionFileModelBase.prototype.clearOnDeletingContainer = function() {
                    if (!this.survey) return;
                    this.survey.clearFiles(this, this.name, this.value, null, function() {});
                };
                QuestionFileModelBase.prototype.onCheckForErrors = function(errors, isOnValueChanged) {
                    _super.prototype.onCheckForErrors.call(this, errors, isOnValueChanged);
                    if (this.isUploading && this.waitForUpload) errors.push(new _error__WEBPACK_IMPORTED_MODULE_4__["UploadingFileError"](this.getLocalizationString("uploadingFile"), this));
                };
                QuestionFileModelBase.prototype.uploadFiles = function(files) {
                    var _this = this;
                    if (this.survey) {
                        this.stateChanged("loading");
                        this.survey.uploadFiles(this, this.name, files, function(arg1, arg2) {
                            if (Array.isArray(arg1)) {
                                _this.setValueFromResult(arg1);
                                if (Array.isArray(arg2)) {
                                    arg2.forEach(function(error) {
                                        return _this.errors.push(new _error__WEBPACK_IMPORTED_MODULE_4__["UploadingFileError"](error, _this));
                                    });
                                    _this.stateChanged("error");
                                }
                            }
                            if (arg1 === "success" && Array.isArray(arg2)) _this.setValueFromResult(arg2);
                            if (arg1 === "error") {
                                if (typeof arg2 === "string") _this.errors.push(new _error__WEBPACK_IMPORTED_MODULE_4__["UploadingFileError"](arg2, _this));
                                if (Array.isArray(arg2) && arg2.length > 0) arg2.forEach(function(error) {
                                    return _this.errors.push(new _error__WEBPACK_IMPORTED_MODULE_4__["UploadingFileError"](error, _this));
                                });
                                _this.stateChanged("error");
                            }
                            _this.stateChanged("loaded");
                        });
                    }
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionFileModelBase.prototype, "isUploading", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "empty"
                    })
                ], QuestionFileModelBase.prototype, "currentState", void 0);
                return QuestionFileModelBase;
            }(_question__WEBPACK_IMPORTED_MODULE_0__["Question"]);
            /**
 * A class that describes the File Upload question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/file-upload/ (linkStyle))
 */ var QuestionFileModel = /** @class */ function(_super) {
                __extends(QuestionFileModel, _super);
                function QuestionFileModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.isDragging = false;
                    _this.fileNavigator = new _actions_container__WEBPACK_IMPORTED_MODULE_7__["ActionContainer"]();
                    _this.canFlipCameraValue = undefined;
                    _this.prevPreviewLength = 0;
                    _this.calcAvailableItemsCount = function(availableWidth, itemWidth, gap) {
                        var itemsCount = Math.floor(availableWidth / (itemWidth + gap));
                        if ((itemsCount + 1) * (itemWidth + gap) - gap <= availableWidth) itemsCount++;
                        return itemsCount;
                    };
                    _this.dragCounter = 0;
                    _this.onDragEnter = function(event1) {
                        if (_this.canDragDrop()) {
                            event1.preventDefault();
                            _this.isDragging = true;
                            _this.dragCounter++;
                        }
                    };
                    _this.onDragOver = function(event1) {
                        if (!_this.canDragDrop()) {
                            event1.returnValue = false;
                            return false;
                        }
                        event1.dataTransfer.dropEffect = "copy";
                        event1.preventDefault();
                    };
                    _this.onDrop = function(event1) {
                        if (_this.canDragDrop()) {
                            _this.isDragging = false;
                            _this.dragCounter = 0;
                            event1.preventDefault();
                            var src = event1.dataTransfer;
                            _this.onChange(src);
                        }
                    };
                    _this.onDragLeave = function(event1) {
                        if (_this.canDragDrop()) {
                            _this.dragCounter--;
                            if (_this.dragCounter === 0) _this.isDragging = false;
                        }
                    };
                    _this.doChange = function(event1) {
                        var src = event1.target || event1.srcElement;
                        _this.onChange(src);
                    };
                    _this.doClean = function() {
                        if (_this.needConfirmRemoveFile) {
                            Object(_utils_utils__WEBPACK_IMPORTED_MODULE_6__["confirmActionAsync"])(_this.confirmRemoveAllMessage, function() {
                                _this.clearFilesCore();
                            }, undefined, _this.getLocale(), _this.survey.rootElement);
                            return;
                        }
                        _this.clearFilesCore();
                    };
                    _this.doDownloadFile = function(event1, data) {
                        if (Object(_utils_utils__WEBPACK_IMPORTED_MODULE_6__["detectIEOrEdge"])()) {
                            event1.preventDefault();
                            Object(_utils_utils__WEBPACK_IMPORTED_MODULE_6__["loadFileFromBase64"])(data.content, data.name);
                        }
                    };
                    _this.createLocalizableString("takePhotoCaption", _this, false, true);
                    _this.actionsContainer = new _actions_container__WEBPACK_IMPORTED_MODULE_7__["ActionContainer"]();
                    _this.actionsContainer.locOwner = _this;
                    _this.fileIndexAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        id: "fileIndex",
                        title: _this.getFileIndexCaption(),
                        enabled: false
                    });
                    _this.prevFileAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        id: "prevPage",
                        iconSize: 16,
                        action: function() {
                            _this.indexToShow = _this.previewValue.length && (_this.indexToShow - 1 + _this.pagesCount) % _this.pagesCount || 0;
                            _this.fileIndexAction.title = _this.getFileIndexCaption();
                        }
                    });
                    _this.nextFileAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        id: "nextPage",
                        iconSize: 16,
                        action: function() {
                            _this.indexToShow = _this.previewValue.length && (_this.indexToShow + 1) % _this.pagesCount || 0;
                            _this.fileIndexAction.title = _this.getFileIndexCaption();
                        }
                    });
                    _this.takePictureAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        iconName: "icon-takepicture",
                        id: "sv-file-take-picture",
                        iconSize: "auto",
                        innerCss: new _base__WEBPACK_IMPORTED_MODULE_3__["ComputedUpdater"](function() {
                            return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(_this.cssClasses.contextButton).append(_this.cssClasses.takePictureButton).toString();
                        }),
                        locTitle: _this.locTakePhotoCaption,
                        showTitle: false,
                        action: function() {
                            _this.snapPicture();
                        }
                    });
                    _this.closeCameraAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        iconName: "icon-closecamera",
                        id: "sv-file-close-camera",
                        iconSize: "auto",
                        innerCss: new _base__WEBPACK_IMPORTED_MODULE_3__["ComputedUpdater"](function() {
                            return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(_this.cssClasses.contextButton).append(_this.cssClasses.closeCameraButton).toString();
                        }),
                        action: function() {
                            _this.stopVideo();
                        }
                    });
                    _this.changeCameraAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        iconName: "icon-changecamera",
                        id: "sv-file-change-camera",
                        iconSize: "auto",
                        innerCss: new _base__WEBPACK_IMPORTED_MODULE_3__["ComputedUpdater"](function() {
                            return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(_this.cssClasses.contextButton).append(_this.cssClasses.changeCameraButton).toString();
                        }),
                        visible: new _base__WEBPACK_IMPORTED_MODULE_3__["ComputedUpdater"](function() {
                            return _this.canFlipCamera();
                        }),
                        action: function() {
                            _this.flipCamera();
                        }
                    });
                    _this.chooseFileAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        iconName: "icon-choosefile",
                        id: "sv-file-choose-file",
                        iconSize: "auto",
                        data: {
                            question: _this
                        },
                        enabledIf: function() {
                            return !_this.isInputReadOnly;
                        },
                        component: "sv-file-choose-btn"
                    });
                    _this.startCameraAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        iconName: "icon-takepicture_24x24",
                        id: "sv-file-start-camera",
                        iconSize: "auto",
                        locTitle: _this.locTakePhotoCaption,
                        showTitle: new _base__WEBPACK_IMPORTED_MODULE_3__["ComputedUpdater"](function() {
                            return !_this.isAnswered;
                        }),
                        enabledIf: function() {
                            return !_this.isInputReadOnly;
                        },
                        action: function() {
                            _this.startVideo();
                        }
                    });
                    _this.cleanAction = new _actions_action__WEBPACK_IMPORTED_MODULE_8__["Action"]({
                        iconName: "icon-clear",
                        id: "sv-file-clean",
                        iconSize: "auto",
                        title: new _base__WEBPACK_IMPORTED_MODULE_3__["ComputedUpdater"](function() {
                            return _this.clearButtonCaption;
                        }),
                        showTitle: false,
                        enabledIf: function() {
                            return !_this.isInputReadOnly;
                        },
                        innerCss: new _base__WEBPACK_IMPORTED_MODULE_3__["ComputedUpdater"](function() {
                            return _this.cssClasses.removeButton;
                        }),
                        action: function() {
                            _this.doClean();
                        }
                    });
                    [
                        _this.closeCameraAction,
                        _this.changeCameraAction,
                        _this.takePictureAction
                    ].forEach(function(action) {
                        action.cssClasses = {};
                    });
                    _this.registerFunctionOnPropertiesValueChanged([
                        "sourceType",
                        "currentMode",
                        "isAnswered"
                    ], function() {
                        _this.updateActionsVisibility();
                    });
                    _this.actionsContainer.actions = [
                        _this.chooseFileAction,
                        _this.startCameraAction,
                        _this.cleanAction
                    ];
                    _this.fileNavigator.actions = [
                        _this.prevFileAction,
                        _this.fileIndexAction,
                        _this.nextFileAction
                    ];
                    return _this;
                }
                Object.defineProperty(QuestionFileModel.prototype, "fileNavigatorVisible", {
                    get: function() {
                        var isUploading = this.isUploading;
                        var isPlayingVideo = this.isPlayingVideo;
                        var containsMultipleFiles = this.containsMultiplyFiles;
                        var needToShowFileNavigator = this.pageSize < this.previewValue.length;
                        return !isUploading && !isPlayingVideo && containsMultipleFiles && needToShowFileNavigator && this.isDefaultV2Theme;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "pagesCount", {
                    get: function() {
                        return Math.ceil(this.previewValue.length / this.pageSize);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "actionsContainerVisible", {
                    get: function() {
                        var isUploading = this.isUploading;
                        var isPlayingVideo = this.isPlayingVideo;
                        var isDefaultV2Theme = this.isDefaultV2Theme;
                        return !isUploading && !isPlayingVideo && isDefaultV2Theme;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "videoId", {
                    get: function() {
                        return this.id + "_video";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "hasVideoUI", {
                    get: function() {
                        return this.currentMode !== "file";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "hasFileUI", {
                    get: function() {
                        return this.currentMode !== "camera";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModel.prototype.startVideo = function() {
                    var _this = this;
                    if (this.currentMode === "file" || this.isDesignMode || this.isPlayingVideo) return;
                    this.setIsPlayingVideo(true);
                    setTimeout(function() {
                        _this.startVideoInCamera();
                    }, 0);
                };
                QuestionFileModel.prototype.startVideoInCamera = function() {
                    var _this = this;
                    this.camera.startVideo(this.videoId, function(stream) {
                        _this.videoStream = stream;
                        if (!stream) _this.stopVideo();
                    }, Object(_utils_utils__WEBPACK_IMPORTED_MODULE_6__["getRenderedSize"])(this.imageWidth), Object(_utils_utils__WEBPACK_IMPORTED_MODULE_6__["getRenderedSize"])(this.imageHeight));
                };
                QuestionFileModel.prototype.stopVideo = function() {
                    this.setIsPlayingVideo(false);
                    this.closeVideoStream();
                };
                QuestionFileModel.prototype.snapPicture = function() {
                    var _this = this;
                    if (!this.isPlayingVideo) return;
                    var blobCallback = function(blob) {
                        if (blob) {
                            var file = new File([
                                blob
                            ], "snap_picture.png", {
                                type: "image/png"
                            });
                            _this.loadFiles([
                                file
                            ]);
                        }
                    };
                    this.camera.snap(this.videoId, blobCallback);
                    this.stopVideo();
                };
                QuestionFileModel.prototype.canFlipCamera = function() {
                    var _this = this;
                    if (this.canFlipCameraValue === undefined) this.canFlipCameraValue = this.camera.canFlip(function(res) {
                        _this.canFlipCameraValue = res;
                    });
                    return this.canFlipCameraValue;
                };
                QuestionFileModel.prototype.flipCamera = function() {
                    if (!this.canFlipCamera()) return;
                    this.closeVideoStream();
                    this.camera.flip();
                    this.startVideoInCamera();
                };
                QuestionFileModel.prototype.closeVideoStream = function() {
                    if (!!this.videoStream) {
                        this.videoStream.getTracks().forEach(function(track) {
                            track.stop();
                        });
                        this.videoStream = undefined;
                    }
                };
                QuestionFileModel.prototype.onHidingContent = function() {
                    _super.prototype.onHidingContent.call(this);
                    this.stopVideo();
                };
                QuestionFileModel.prototype.updateElementCssCore = function(cssClasses) {
                    _super.prototype.updateElementCssCore.call(this, cssClasses);
                    this.prevFileAction.iconName = this.cssClasses.leftIconId;
                    this.nextFileAction.iconName = this.cssClasses.rightIconId;
                //this.mobileFileNavigator.cssClasses = this.survey.getCss().actionBar;
                };
                QuestionFileModel.prototype.getFileIndexCaption = function() {
                    return this.getLocalizationFormatString("indexText", this.indexToShow + 1, this.pagesCount);
                };
                QuestionFileModel.prototype.updateFileNavigator = function() {
                    this.indexToShow = this.previewValue.length && (this.indexToShow + this.pagesCount) % this.pagesCount || 0;
                    this.fileIndexAction.title = this.getFileIndexCaption();
                };
                QuestionFileModel.prototype.previewValueChanged = function() {
                    var _this = this;
                    if (this.previewValue.length !== this.prevPreviewLength) {
                        if (this.previewValue.length > 0) {
                            if (this.prevPreviewLength > this.previewValue.length) this.indexToShow = this.indexToShow >= this.pagesCount && this.indexToShow > 0 ? this.pagesCount - 1 : this.indexToShow;
                            else this.indexToShow = Math.floor(this.prevPreviewLength / this.pageSize);
                        } else this.indexToShow = 0;
                    }
                    this.fileIndexAction.title = this.getFileIndexCaption();
                    this.containsMultiplyFiles = this.previewValue.length > 1;
                    if (this.previewValue.length > 0 && !this.calculatedGapBetweenItems && !this.calculatedItemWidth) setTimeout(function() {
                        _this.processResponsiveness(0, _this._width);
                    });
                    this.prevPreviewLength = this.previewValue.length;
                };
                QuestionFileModel.prototype.isPreviewVisible = function(index) {
                    var isFileNavigatorVisible = this.fileNavigatorVisible;
                    var isPreviewVisible = this.indexToShow * this.pageSize <= index && index < (this.indexToShow + 1) * this.pageSize;
                    return !isFileNavigatorVisible || isPreviewVisible;
                };
                QuestionFileModel.prototype.getType = function() {
                    return "file";
                };
                Object.defineProperty(QuestionFileModel.prototype, "showPreview", {
                    /**
         * Disable this property only to implement a custom preview.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/file-custom-preview/ (linkStyle))
         * @see allowImagesPreview
         */ get: function() {
                        return this.getPropertyValue("showPreview");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showPreview", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "allowMultiple", {
                    /**
         * Specifies whether users can upload multiple files.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("allowMultiple");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowMultiple", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "imageHeight", {
                    /**
         * The image height.
         */ get: function() {
                        return this.getPropertyValue("imageHeight");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageHeight", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "imageWidth", {
                    /**
         * The image width.
         */ get: function() {
                        return this.getPropertyValue("imageWidth");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "acceptedTypes", {
                    /**
         * An [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute value for the underlying `<input>` element.
         */ get: function() {
                        return this.getPropertyValue("acceptedTypes");
                    },
                    set: function(val1) {
                        this.setPropertyValue("acceptedTypes", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "allowImagesPreview", {
                    /**
         * Specifies whether to show a preview of image files.
         */ get: function() {
                        return this.getPropertyValue("allowImagesPreview");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowImagesPreview", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "maxSize", {
                    /**
         * Maximum allowed file size, measured in bytes.
         *
         * Default value: 0 (unlimited)
         */ get: function() {
                        return this.getPropertyValue("maxSize");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxSize", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModel.prototype.chooseFile = function(event1) {
                    var _this = this;
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_12__["DomDocumentHelper"].isAvailable()) return;
                    var inputElement = _global_variables_utils__WEBPACK_IMPORTED_MODULE_12__["DomDocumentHelper"].getDocument().getElementById(this.inputId);
                    event1.preventDefault();
                    event1.stopImmediatePropagation();
                    if (inputElement) {
                        if (this.survey) this.survey.chooseFiles(inputElement, function(files) {
                            return _this.loadFiles(files);
                        }, {
                            element: this,
                            elementType: this.getType(),
                            propertyName: this.name
                        });
                        else inputElement.click();
                    }
                };
                Object.defineProperty(QuestionFileModel.prototype, "needConfirmRemoveFile", {
                    /**
         * Specifies whether users should confirm file deletion.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("needConfirmRemoveFile");
                    },
                    set: function(val1) {
                        this.setPropertyValue("needConfirmRemoveFile", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModel.prototype.getConfirmRemoveMessage = function(fileName) {
                    return this.confirmRemoveMessage.format(fileName);
                };
                Object.defineProperty(QuestionFileModel.prototype, "takePhotoCaption", {
                    get: function() {
                        return this.getLocalizableStringText("takePhotoCaption");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("takePhotoCaption", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "locTakePhotoCaption", {
                    get: function() {
                        return this.getLocalizableString("takePhotoCaption");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "locRenderedPlaceholder", {
                    get: function() {
                        var _this = this;
                        if (this.locRenderedPlaceholderValue === undefined) this.locRenderedPlaceholderValue = new _base__WEBPACK_IMPORTED_MODULE_3__["ComputedUpdater"](function() {
                            var isReadOnly = _this.isReadOnly;
                            var hasFileUI = !_this.isDesignMode && _this.hasFileUI || _this.isDesignMode && _this.sourceType != "camera";
                            var hasVideoUI = !_this.isDesignMode && _this.hasVideoUI || _this.isDesignMode && _this.sourceType != "file";
                            var renderedPlaceholder;
                            if (isReadOnly) renderedPlaceholder = _this.locNoFileChosenCaption;
                            else if (hasFileUI && hasVideoUI) renderedPlaceholder = _this.locFileOrPhotoPlaceholder;
                            else if (hasFileUI) renderedPlaceholder = _this.locFilePlaceholder;
                            else renderedPlaceholder = _this.locPhotoPlaceholder;
                            return renderedPlaceholder;
                        });
                        return this.locRenderedPlaceholderValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "currentMode", {
                    get: function() {
                        return this.getPropertyValue("currentMode", this.sourceType);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "isPlayingVideo", {
                    get: function() {
                        return this.getPropertyValue("isPlayingVideo", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModel.prototype.setIsPlayingVideo = function(show) {
                    this.setPropertyValue("isPlayingVideo", show);
                };
                QuestionFileModel.prototype.updateCurrentMode = function() {
                    var _this = this;
                    if (!this.isDesignMode) {
                        if (this.sourceType !== "file") this.camera.hasCamera(function(res) {
                            _this.setPropertyValue("currentMode", res && _this.isDefaultV2Theme ? _this.sourceType : "file");
                        });
                        else this.setPropertyValue("currentMode", this.sourceType);
                    }
                };
                QuestionFileModel.prototype.updateActionsVisibility = function() {
                    var isDesignMode = this.isDesignMode;
                    this.chooseFileAction.visible = !isDesignMode && this.hasFileUI || isDesignMode && this.sourceType !== "camera";
                    this.startCameraAction.visible = !isDesignMode && this.hasVideoUI || isDesignMode && this.sourceType !== "file";
                    this.cleanAction.visible = !!this.isAnswered;
                };
                Object.defineProperty(QuestionFileModel.prototype, "inputTitle", {
                    get: function() {
                        if (this.isUploading) return this.loadingFileTitle;
                        if (this.isEmpty()) return this.chooseFileTitle;
                        return " ";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "chooseButtonText", {
                    get: function() {
                        return this.isEmpty() || this.allowMultiple ? this.chooseButtonCaption : this.replaceButtonCaption;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModel.prototype.clear = function(doneCallback) {
                    var _this = this;
                    if (!this.survey) return;
                    this.containsMultiplyFiles = false;
                    this.survey.clearFiles(this, this.name, this.value, null, function(status, data) {
                        if (status === "success") {
                            _this.value = undefined;
                            _this.errors = [];
                            !!doneCallback && doneCallback();
                            _this.indexToShow = 0;
                            _this.fileIndexAction.title = _this.getFileIndexCaption();
                        }
                    });
                };
                Object.defineProperty(QuestionFileModel.prototype, "renderCapture", {
                    get: function() {
                        return this.allowCameraAccess ? "user" : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "multipleRendered", {
                    get: function() {
                        return this.allowMultiple ? "multiple" : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "showChooseButton", {
                    //todo: remove it in V2
                    get: function() {
                        return !this.isReadOnly && !this.isDefaultV2Theme;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "showFileDecorator", {
                    //
                    get: function() {
                        var isPlayingVideo = this.isPlayingVideo;
                        var showLoadingIndicator = this.showLoadingIndicator;
                        return !isPlayingVideo && !showLoadingIndicator;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "allowShowPreview", {
                    get: function() {
                        var isShowLoadingIndicator = this.showLoadingIndicator;
                        var isPlayingVideo = this.isPlayingVideo;
                        return !isShowLoadingIndicator && !isPlayingVideo;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "showPreviewContainer", {
                    get: function() {
                        return this.previewValue && this.previewValue.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "showRemoveButtonCore", {
                    //todo: remove in V2
                    get: function() {
                        var showLoadingIndicator = this.showLoadingIndicator;
                        var isReadOnly = this.isReadOnly;
                        var isEmpty = this.isEmpty();
                        return !isReadOnly && !isEmpty && !showLoadingIndicator && !this.isDefaultV2Theme;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "showRemoveButton", {
                    get: function() {
                        return this.showRemoveButtonCore && this.cssClasses.removeButton;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFileModel.prototype, "showRemoveButtonBottom", {
                    get: function() {
                        var cssClasses = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.removeButtonBottom).append(this.cssClasses.contextButton).toString();
                        return this.showRemoveButtonCore && cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                //
                QuestionFileModel.prototype.defaultImage = function(data) {
                    return !this.canPreviewImage(data) && !!this.cssClasses.defaultImage;
                };
                /**
     * Removes a file with a specified name.
     */ QuestionFileModel.prototype.removeFile = function(name) {
                    this.removeFileByContent(this.value.filter(function(f) {
                        return f.name === name;
                    })[0]);
                };
                QuestionFileModel.prototype.removeFileByContent = function(content) {
                    var _this = this;
                    if (!this.survey) return;
                    this.survey.clearFiles(this, this.name, this.value, content.name, function(status, data) {
                        if (status === "success") {
                            var oldValue = _this.value;
                            if (Array.isArray(oldValue)) _this.value = oldValue.filter(function(f) {
                                return !_helpers__WEBPACK_IMPORTED_MODULE_9__["Helpers"].isTwoValueEquals(f, content, true, false, false);
                            });
                            else _this.value = undefined;
                        }
                    });
                };
                QuestionFileModel.prototype.setValueFromResult = function(arg) {
                    this.value = (this.value || []).concat(arg.map(function(r) {
                        return {
                            name: r.file.name,
                            type: r.file.type,
                            content: r.content
                        };
                    }));
                };
                /**
     * Loads multiple files into the question.
     * @param files An array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects.
     */ QuestionFileModel.prototype.loadFiles = function(files) {
                    var _this = this;
                    if (!this.survey) return;
                    this.errors = [];
                    if (!this.allFilesOk(files)) return;
                    var loadFilesProc = function() {
                        _this.stateChanged("loading");
                        var content = [];
                        if (_this.storeDataAsText) files.forEach(function(file) {
                            var fileReader = new FileReader();
                            fileReader.onload = function(e) {
                                content = content.concat([
                                    {
                                        name: file.name,
                                        type: file.type,
                                        content: fileReader.result
                                    }
                                ]);
                                if (content.length === files.length) _this.value = (_this.value || []).concat(content);
                            };
                            fileReader.readAsDataURL(file);
                        });
                        else _this.uploadFiles(files);
                    };
                    if (this.allowMultiple) loadFilesProc();
                    else this.clear(loadFilesProc);
                };
                Object.defineProperty(QuestionFileModel.prototype, "camera", {
                    get: function() {
                        if (!this.cameraValue) this.cameraValue = new _utils_camera__WEBPACK_IMPORTED_MODULE_10__["Camera"]();
                        return this.cameraValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModel.prototype.canPreviewImage = function(fileItem) {
                    return this.allowImagesPreview && !!fileItem && this.isFileImage(fileItem);
                };
                QuestionFileModel.prototype.loadPreview = function(newValue) {
                    var _this = this;
                    this.previewValue.splice(0, this.previewValue.length);
                    if (!this.showPreview || !newValue) return;
                    var newValues = Array.isArray(newValue) ? newValue : !!newValue ? [
                        newValue
                    ] : [];
                    if (this.storeDataAsText) newValues.forEach(function(value) {
                        var content = value.content || value;
                        _this.previewValue.push({
                            name: value.name,
                            type: value.type,
                            content: content
                        });
                    });
                    else {
                        if (!!this._previewLoader) this._previewLoader.dispose();
                        this.isFileLoading = true;
                        this._previewLoader = new FileLoader(this, function(status, loaded) {
                            if (status === "loaded") {
                                loaded.forEach(function(val1) {
                                    _this.previewValue.push(val1);
                                });
                                _this.previewValueChanged();
                            }
                            _this.isFileLoading = false;
                            _this._previewLoader.dispose();
                            _this._previewLoader = undefined;
                        });
                        this._previewLoader.load(newValues);
                    }
                    this.previewValueChanged();
                };
                Object.defineProperty(QuestionFileModel.prototype, "isFileLoading", {
                    get: function() {
                        return this.isFileLoadingValue;
                    },
                    set: function(val1) {
                        this.isFileLoadingValue = val1;
                        this.updateIsReady();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModel.prototype.getIsQuestionReady = function() {
                    return _super.prototype.getIsQuestionReady.call(this) && !this.isFileLoading;
                };
                QuestionFileModel.prototype.allFilesOk = function(files) {
                    var _this = this;
                    var errorLength = this.errors ? this.errors.length : 0;
                    (files || []).forEach(function(file) {
                        if (_this.maxSize > 0 && file.size > _this.maxSize) _this.errors.push(new _error__WEBPACK_IMPORTED_MODULE_4__["ExceedSizeError"](_this.maxSize, _this));
                    });
                    return errorLength === this.errors.length;
                };
                QuestionFileModel.prototype.isFileImage = function(file) {
                    if (!file || !file.content || !file.content.substring) return false;
                    var imagePrefix = "data:image";
                    var subStr = file.content && file.content.substring(0, imagePrefix.length);
                    subStr = subStr && subStr.toLowerCase();
                    var result = subStr === imagePrefix || !!file.type && file.type.toLowerCase().indexOf("image/") === 0;
                    return result;
                };
                QuestionFileModel.prototype.getPlainData = function(options) {
                    if (options === void 0) options = {
                        includeEmpty: true
                    };
                    var questionPlainData = _super.prototype.getPlainData.call(this, options);
                    if (!!questionPlainData && !this.isEmpty()) {
                        questionPlainData.isNode = false;
                        var values = Array.isArray(this.value) ? this.value : [
                            this.value
                        ];
                        questionPlainData.data = values.map(function(dataValue, index) {
                            return {
                                name: index,
                                title: "File",
                                value: dataValue.content && dataValue.content || dataValue,
                                displayValue: dataValue.name && dataValue.name || dataValue,
                                getString: function(val1) {
                                    return typeof val1 === "object" ? JSON.stringify(val1) : val1;
                                },
                                isNode: false
                            };
                        });
                    }
                    return questionPlainData;
                };
                QuestionFileModel.prototype.getImageWrapperCss = function(data) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.imageWrapper).append(this.cssClasses.imageWrapperDefaultImage, this.defaultImage(data)).toString();
                };
                QuestionFileModel.prototype.getActionsContainerCss = function(css) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(css.actionsContainer).append(css.actionsContainerAnswered, this.isAnswered).toString();
                };
                QuestionFileModel.prototype.getRemoveButtonCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.removeFileButton).append(this.cssClasses.contextButton).toString();
                };
                QuestionFileModel.prototype.getChooseFileCss = function() {
                    var isAnswered = this.isAnswered;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.chooseFile).append(this.cssClasses.controlDisabled, this.isReadOnly).append(this.cssClasses.chooseFileAsText, !isAnswered).append(this.cssClasses.chooseFileAsTextDisabled, !isAnswered && this.isInputReadOnly).append(this.cssClasses.contextButton, isAnswered).append(this.cssClasses.chooseFileAsIcon, isAnswered).toString();
                };
                QuestionFileModel.prototype.getReadOnlyFileCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append("form-control").append(this.cssClasses.placeholderInput).toString();
                };
                Object.defineProperty(QuestionFileModel.prototype, "fileRootCss", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.root).append(this.cssClasses.rootDragging, this.isDragging).append(this.cssClasses.rootAnswered, this.isAnswered).append(this.cssClasses.single, !this.allowMultiple).append(this.cssClasses.singleImage, !this.allowMultiple && this.isAnswered && this.canPreviewImage(this.value[0])).append(this.cssClasses.mobile, this.isMobile).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFileModel.prototype.getFileDecoratorCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.fileDecorator).append(this.cssClasses.onError, this.hasCssError()).append(this.cssClasses.fileDecoratorDrag, this.isDragging).toString();
                };
                QuestionFileModel.prototype.onChange = function(src) {
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_12__["DomWindowHelper"].isFileReaderAvailable()) return;
                    if (!src || !src.files || src.files.length < 1) return;
                    var files = [];
                    var allowCount = this.allowMultiple ? src.files.length : 1;
                    for(var i = 0; i < allowCount; i++)files.push(src.files[i]);
                    src.value = "";
                    this.loadFiles(files);
                };
                QuestionFileModel.prototype.onChangeQuestionValue = function(newValue) {
                    _super.prototype.onChangeQuestionValue.call(this, newValue);
                    this.stateChanged(this.isEmpty() ? "empty" : "loaded");
                    if (!this.isLoadingFromJson) this.loadPreview(newValue);
                };
                QuestionFileModel.prototype.calcCssClasses = function(css) {
                    var classes = _super.prototype.calcCssClasses.call(this, css);
                    this.actionsContainer.cssClasses = css.actionBar;
                    this.actionsContainer.cssClasses.itemWithTitle = this.actionsContainer.cssClasses.item;
                    this.actionsContainer.cssClasses.item = "";
                    this.actionsContainer.cssClasses.itemAsIcon = classes.contextButton;
                    this.actionsContainer.containerCss = classes.actionsContainer;
                    return classes;
                };
                //todo remove in v2
                QuestionFileModel.prototype.updateElementCss = function(reNew) {
                    _super.prototype.updateElementCss.call(this, reNew);
                    this.updateCurrentMode();
                };
                QuestionFileModel.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    this.updateCurrentMode();
                    this.updateActionsVisibility();
                    this.loadPreview(this.value);
                };
                QuestionFileModel.prototype.needResponsiveness = function() {
                    return this.supportResponsiveness() && this.isDefaultV2Theme;
                };
                QuestionFileModel.prototype.supportResponsiveness = function() {
                    return true;
                };
                QuestionFileModel.prototype.getObservedElementSelector = function() {
                    return Object(_utils_utils__WEBPACK_IMPORTED_MODULE_6__["classesToSelector"])(this.cssClasses.dragArea);
                };
                QuestionFileModel.prototype.getFileListSelector = function() {
                    return Object(_utils_utils__WEBPACK_IMPORTED_MODULE_6__["classesToSelector"])(this.cssClasses.fileList);
                };
                QuestionFileModel.prototype.triggerResponsiveness = function(hard) {
                    if (hard) {
                        this.calculatedGapBetweenItems = undefined;
                        this.calculatedItemWidth = undefined;
                    }
                    _super.prototype.triggerResponsiveness.call(this);
                };
                QuestionFileModel.prototype.processResponsiveness = function(_, availableWidth) {
                    var _this = this;
                    this._width = availableWidth;
                    if (this.rootElement) {
                        if ((!this.calculatedGapBetweenItems || !this.calculatedItemWidth) && this.allowMultiple) {
                            var fileListSelector = this.getFileListSelector();
                            var fileListElement = fileListSelector ? this.rootElement.querySelector(this.getFileListSelector()) : undefined;
                            if (fileListElement) {
                                this.calculatedGapBetweenItems = Math.ceil(Number.parseFloat(_global_variables_utils__WEBPACK_IMPORTED_MODULE_12__["DomDocumentHelper"].getComputedStyle(fileListElement).gap));
                                var firstVisibleItem = Array.from(fileListElement.children).filter(function(_, index) {
                                    return _this.isPreviewVisible(index);
                                })[0];
                                if (firstVisibleItem) this.calculatedItemWidth = Math.ceil(Number.parseFloat(_global_variables_utils__WEBPACK_IMPORTED_MODULE_12__["DomDocumentHelper"].getComputedStyle(firstVisibleItem).width));
                            }
                        }
                    }
                    if (this.calculatedGapBetweenItems && this.calculatedItemWidth) {
                        this.pageSize = this.calcAvailableItemsCount(availableWidth, this.calculatedItemWidth, this.calculatedGapBetweenItems);
                        return true;
                    }
                    return false;
                };
                QuestionFileModel.prototype.canDragDrop = function() {
                    return !this.isInputReadOnly && this.currentMode !== "camera" && !this.isPlayingVideo;
                };
                QuestionFileModel.prototype.afterRender = function(el) {
                    this.rootElement = el;
                    _super.prototype.afterRender.call(this, el);
                };
                QuestionFileModel.prototype.clearFilesCore = function() {
                    if (this.rootElement) {
                        var input = this.rootElement.querySelectorAll("input")[0];
                        if (input) input.value = "";
                    }
                    this.clear();
                };
                QuestionFileModel.prototype.doRemoveFile = function(data) {
                    var _this = this;
                    if (this.needConfirmRemoveFile) {
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_6__["confirmActionAsync"])(this.getConfirmRemoveMessage(data.name), function() {
                            _this.removeFileCore(data);
                        }, undefined, this.getLocale(), this.survey.rootElement);
                        return;
                    }
                    this.removeFileCore(data);
                };
                QuestionFileModel.prototype.removeFileCore = function(data) {
                    var previewIndex = this.previewValue.indexOf(data);
                    this.removeFileByContent(previewIndex === -1 ? data : this.value[previewIndex]);
                };
                //#endregion
                QuestionFileModel.prototype.dispose = function() {
                    this.cameraValue = undefined;
                    this.closeVideoStream();
                    _super.prototype.dispose.call(this);
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionFileModel.prototype, "isDragging", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["propertyArray"])({})
                ], QuestionFileModel.prototype, "previewValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: 0
                    })
                ], QuestionFileModel.prototype, "indexToShow", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: 1,
                        onSet: function(_, target) {
                            target.updateFileNavigator();
                        }
                    })
                ], QuestionFileModel.prototype, "pageSize", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], QuestionFileModel.prototype, "containsMultiplyFiles", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionFileModel.prototype, "allowCameraAccess", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        onSet: function(val1, obj) {
                            if (!obj.isLoadingFromJson) obj.updateCurrentMode();
                        }
                    })
                ], QuestionFileModel.prototype, "sourceType", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionFileModel.prototype, "canFlipCameraValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "confirmRemoveFile"
                        }
                    })
                ], QuestionFileModel.prototype, "confirmRemoveMessage", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "confirmRemoveAllFiles"
                        }
                    })
                ], QuestionFileModel.prototype, "confirmRemoveAllMessage", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "noFileChosen"
                        }
                    })
                ], QuestionFileModel.prototype, "noFileChosenCaption", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "chooseFileCaption"
                        }
                    })
                ], QuestionFileModel.prototype, "chooseButtonCaption", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "replaceFileCaption"
                        }
                    })
                ], QuestionFileModel.prototype, "replaceButtonCaption", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "clearCaption"
                        }
                    })
                ], QuestionFileModel.prototype, "clearButtonCaption", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "removeFileCaption"
                        }
                    })
                ], QuestionFileModel.prototype, "removeFileCaption", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "loadingFile"
                        }
                    })
                ], QuestionFileModel.prototype, "loadingFileTitle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "chooseFile"
                        }
                    })
                ], QuestionFileModel.prototype, "chooseFileTitle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "fileOrPhotoPlaceholder"
                        }
                    })
                ], QuestionFileModel.prototype, "fileOrPhotoPlaceholder", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "photoPlaceholder"
                        }
                    })
                ], QuestionFileModel.prototype, "photoPlaceholder", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: {
                            defaultStr: "filePlaceholder"
                        }
                    })
                ], QuestionFileModel.prototype, "filePlaceholder", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionFileModel.prototype, "locRenderedPlaceholderValue", void 0);
                return QuestionFileModel;
            }(QuestionFileModelBase);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("file", [
                {
                    name: "showCommentArea:switch",
                    layout: "row",
                    visible: true,
                    category: "general"
                },
                {
                    name: "showPreview:boolean",
                    default: true
                },
                "allowMultiple:boolean",
                {
                    name: "allowImagesPreview:boolean",
                    default: true,
                    dependsOn: "showPreview",
                    visibleIf: function(obj) {
                        return !!obj.showPreview;
                    }
                },
                "imageHeight",
                "imageWidth",
                "acceptedTypes",
                {
                    name: "storeDataAsText:boolean",
                    default: true
                },
                {
                    name: "waitForUpload:boolean",
                    default: false
                },
                {
                    name: "maxSize:number",
                    default: 0
                },
                {
                    name: "defaultValue",
                    visible: false
                },
                {
                    name: "correctAnswer",
                    visible: false
                },
                {
                    name: "validators",
                    visible: false
                },
                {
                    name: "needConfirmRemoveFile:boolean"
                },
                {
                    name: "sourceType",
                    choices: [
                        "file",
                        "camera",
                        "file-camera"
                    ],
                    default: "file",
                    category: "general",
                    visible: true,
                    visibleIf: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_11__["settings"].supportCreatorV2;
                    }
                },
                {
                    name: "fileOrPhotoPlaceholder:text",
                    serializationProperty: "locFileOrPhotoPlaceholder",
                    category: "general",
                    visibleIf: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_11__["settings"].supportCreatorV2;
                    }
                },
                {
                    name: "photoPlaceholder:text",
                    serializationProperty: "locPhotoPlaceholder",
                    category: "general",
                    visibleIf: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_11__["settings"].supportCreatorV2;
                    }
                },
                {
                    name: "filePlaceholder:text",
                    serializationProperty: "locFilePlaceholder",
                    category: "general",
                    visibleIf: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_11__["settings"].supportCreatorV2;
                    }
                },
                {
                    name: "allowCameraAccess:switch",
                    category: "general",
                    visible: false
                }
            ], function() {
                return new QuestionFileModel("");
            }, "question");
            _questionfactory__WEBPACK_IMPORTED_MODULE_2__["QuestionFactory"].Instance.registerQuestion("file", function(name) {
                return new QuestionFileModel(name);
            });
            var FileLoader = /** @class */ function() {
                function FileLoader(fileQuestion, callback) {
                    this.fileQuestion = fileQuestion;
                    this.callback = callback;
                    this.loaded = [];
                }
                FileLoader.prototype.load = function(files) {
                    var _this = this;
                    var downloadedCount = 0;
                    this.loaded = new Array(files.length);
                    files.forEach(function(value, index) {
                        if (_this.fileQuestion.survey) _this.fileQuestion.survey.downloadFile(_this.fileQuestion, _this.fileQuestion.name, value, function(status, data) {
                            if (!_this.fileQuestion || !_this.callback) return;
                            if (status === "success") {
                                _this.loaded[index] = {
                                    content: data,
                                    name: value.name,
                                    type: value.type
                                };
                                downloadedCount++;
                                if (downloadedCount === files.length) _this.callback("loaded", _this.loaded);
                            } else _this.callback("error", _this.loaded);
                        });
                    });
                };
                FileLoader.prototype.dispose = function() {
                    this.fileQuestion = undefined;
                    this.callback = undefined;
                };
                return FileLoader;
            }();
        /***/ },
        /***/ "./src/question_html.ts": /*!******************************!*\
  !*** ./src/question_html.ts ***!
  \******************************/ /*! exports provided: QuestionHtmlModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionHtmlModel", function() {
                return QuestionHtmlModel;
            });
            /* harmony import */ var _questionnonvalue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./questionnonvalue */ "./src/questionnonvalue.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
  * A class that describes the HTML question type. Unlike other question types, HTML cannot have a title or value.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-html/ (linkStyle))
 */ var QuestionHtmlModel = /** @class */ function(_super) {
                __extends(QuestionHtmlModel, _super);
                function QuestionHtmlModel(name) {
                    var _this = _super.call(this, name) || this;
                    var locHtml = _this.createLocalizableString("html", _this);
                    locHtml.onGetTextCallback = function(str) {
                        return !!_this.survey && !_this.ignoreHtmlProgressing ? _this.processHtml(str) : str;
                    };
                    return _this;
                }
                QuestionHtmlModel.prototype.getType = function() {
                    return "html";
                };
                Object.defineProperty(QuestionHtmlModel.prototype, "isCompositeQuestion", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionHtmlModel.prototype.getProcessedText = function(text) {
                    if (this.ignoreHtmlProgressing) return text;
                    return _super.prototype.getProcessedText.call(this, text);
                };
                Object.defineProperty(QuestionHtmlModel.prototype, "html", {
                    /**
         * HTML markup to display.
         *
         * > IMPORTANT: If you get the markup from a third party, ensure that it does not contain malicious code.
         */ get: function() {
                        return this.getLocalizableStringText("html", "");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("html", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionHtmlModel.prototype, "locHtml", {
                    get: function() {
                        return this.getLocalizableString("html");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionHtmlModel.prototype, "processedHtml", {
                    get: function() {
                        return this.processHtml(this.html);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionHtmlModel.prototype.processHtml = function(html) {
                    return this.survey ? this.survey.processHtml(html, "html-question") : this.html;
                };
                Object.defineProperty(QuestionHtmlModel.prototype, "isNewA11yStructure", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionHtmlModel.prototype, "renderCssRoot", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.cssClasses.root).append(this.cssClasses.nested, this.getIsNested()).toString() || undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                return QuestionHtmlModel;
            }(_questionnonvalue__WEBPACK_IMPORTED_MODULE_0__["QuestionNonValue"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("html", [
                {
                    name: "html:html",
                    serializationProperty: "locHtml"
                },
                {
                    name: "hideNumber",
                    visible: false
                },
                {
                    name: "state",
                    visible: false
                },
                {
                    name: "titleLocation",
                    visible: false
                },
                {
                    name: "descriptionLocation",
                    visible: false
                },
                {
                    name: "errorLocation",
                    visible: false
                },
                {
                    name: "indent",
                    visible: false
                },
                {
                    name: "width",
                    visible: false
                }
            ], function() {
                return new QuestionHtmlModel("");
            }, "nonvalue");
            _questionfactory__WEBPACK_IMPORTED_MODULE_2__["QuestionFactory"].Instance.registerQuestion("html", function(name) {
                return new QuestionHtmlModel(name);
            });
        /***/ },
        /***/ "./src/question_image.ts": /*!*******************************!*\
  !*** ./src/question_image.ts ***!
  \*******************************/ /*! exports provided: QuestionImageModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionImageModel", function() {
                return QuestionImageModel;
            });
            /* harmony import */ var _questionnonvalue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./questionnonvalue */ "./src/questionnonvalue.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var youtubeTags = [
                "youtube.com",
                "youtu.be"
            ];
            var videoSuffics = [
                ".mp4",
                ".mov",
                ".wmv",
                ".flv",
                ".avi",
                ".mkv"
            ];
            var youtubeUrl = "https://www.youtube.com/";
            var youtubeEmbed = "embed";
            function isUrlYoutubeVideo(url) {
                if (!url) return false;
                url = url.toLowerCase();
                for(var i = 0; i < youtubeTags.length; i++){
                    if (url.indexOf(youtubeTags[i]) !== -1) return true;
                }
                return false;
            }
            /**
  * A class that describes the Image question type. Unlike other question types, Image cannot have a title or value.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-image/ (linkStyle))
 */ var QuestionImageModel = /** @class */ function(_super) {
                __extends(QuestionImageModel, _super);
                function QuestionImageModel(name) {
                    var _this = _super.call(this, name) || this;
                    var locImageLink = _this.createLocalizableString("imageLink", _this, false);
                    locImageLink.onGetTextCallback = function(text) {
                        return getCorrectImageLink(text);
                    };
                    _this.createLocalizableString("altText", _this, false);
                    _this.registerPropertyChangedHandlers([
                        "contentMode",
                        "imageLink"
                    ], function() {
                        return _this.calculateRenderedMode();
                    });
                    return _this;
                }
                QuestionImageModel.prototype.getType = function() {
                    return "image";
                };
                Object.defineProperty(QuestionImageModel.prototype, "isCompositeQuestion", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImageModel.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    this.calculateRenderedMode();
                };
                Object.defineProperty(QuestionImageModel.prototype, "imageLink", {
                    /**
         * Specifies an image or video URL.
         * @see contentMode
         */ get: function() {
                        return this.getLocalizableStringText("imageLink");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("imageLink", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "locImageLink", {
                    get: function() {
                        return this.getLocalizableString("imageLink");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "altText", {
                    /**
         * Specifies a value for the `alt` attribute of the underlying `<img>` element.
         */ get: function() {
                        return this.getLocalizableStringText("altText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("altText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "locAltText", {
                    get: function() {
                        return this.getLocalizableString("altText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "imageHeight", {
                    /**
         * Specifies the height of a container for the image or video. Accepts positive numbers and CSS values.
         *
         * Default value: 150
         *
         * Use the `imageFit` property to specify how to fit the image or video into the container.
         * @see imageWidth
         * @see imageFit
         */ get: function() {
                        return this.getPropertyValue("imageHeight");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageHeight", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "renderedStyleHeight", {
                    get: function() {
                        return this.imageHeight ? Object(_utils_utils__WEBPACK_IMPORTED_MODULE_4__["getRenderedStyleSize"])(this.imageHeight) : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "renderedHeight", {
                    get: function() {
                        return this.imageHeight ? Object(_utils_utils__WEBPACK_IMPORTED_MODULE_4__["getRenderedSize"])(this.imageHeight) : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "imageWidth", {
                    /**
         * Specifies the width of a container for the image or video. Accepts positive numbers and CSS values.
         *
         * Default value: 200
         *
         * Use the `imageFit` property to specify how to fit the image or video into the container.
         * @see imageHeight
         * @see imageFit
         */ get: function() {
                        return this.getPropertyValue("imageWidth");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "renderedStyleWidth", {
                    get: function() {
                        return this.imageWidth ? Object(_utils_utils__WEBPACK_IMPORTED_MODULE_4__["getRenderedStyleSize"])(this.imageWidth) : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "renderedWidth", {
                    get: function() {
                        return this.imageWidth ? Object(_utils_utils__WEBPACK_IMPORTED_MODULE_4__["getRenderedSize"])(this.imageWidth) : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "imageFit", {
                    /**
         * Specifies how to resize the image or video to fit it into its container.
         *
         * Refer to the [`object-fit`](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit) CSS property description for information on accepted values.
         * @see imageHeight
         * @see imageWidth
         */ get: function() {
                        return this.getPropertyValue("imageFit");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageFit", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "contentMode", {
                    /**
         * Specifies the type of content that the Image question displays.
         *
         * Possible values:
         *
         * - `"image"` - An image in one of the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO.
         * - `"video"` - A video in one of the following formats: MP4, MOV, WMV, FLV, AVI, MKV.
         * - `"youtube"` - A link to a YouTube video.
         * - `"auto"` (default) - Selects one of the above based on the [`imageLink`](https://surveyjs.io/form-library/documentation/questionimagemodel#imageLink) property.
         */ get: function() {
                        return this.getPropertyValue("contentMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("contentMode", val1);
                        if (val1 === "video") this.showLabel = true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImageModel.prototype, "renderedMode", {
                    /**
         * Returns the type of content that the Image question displays: `"image"`, `"video"`, or `"youtube"`.
         * @see contentMode
         */ get: function() {
                        return this.getPropertyValue("renderedMode", "image");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImageModel.prototype.getImageCss = function() {
                    var imageHeightProperty = this.getPropertyByName("imageHeight");
                    var imageWidthProperty = this.getPropertyByName("imageWidth");
                    var isDefaultSize = imageHeightProperty.isDefaultValue(this.imageHeight) && imageWidthProperty.isDefaultValue(this.imageWidth);
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.cssClasses.image).append(this.cssClasses.adaptive, isDefaultSize).toString();
                };
                QuestionImageModel.prototype.onLoadHandler = function() {
                    this.contentNotLoaded = false;
                };
                QuestionImageModel.prototype.onErrorHandler = function() {
                    this.contentNotLoaded = true;
                };
                QuestionImageModel.prototype.setRenderedMode = function(val1) {
                    this.setPropertyValue("renderedMode", val1);
                };
                QuestionImageModel.prototype.calculateRenderedMode = function() {
                    if (this.contentMode !== "auto") this.setRenderedMode(this.contentMode);
                    else {
                        if (this.isYoutubeVideo()) this.setRenderedMode("youtube");
                        else if (this.isVideo()) this.setRenderedMode("video");
                        else this.setRenderedMode("image");
                    }
                };
                QuestionImageModel.prototype.isYoutubeVideo = function() {
                    return isUrlYoutubeVideo(this.imageLink);
                };
                QuestionImageModel.prototype.isVideo = function() {
                    var link = this.imageLink;
                    if (!link) return false;
                    link = link.toLowerCase();
                    for(var i = 0; i < videoSuffics.length; i++){
                        if (link.endsWith(videoSuffics[i])) return true;
                    }
                    return false;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], QuestionImageModel.prototype, "contentNotLoaded", void 0);
                return QuestionImageModel;
            }(_questionnonvalue__WEBPACK_IMPORTED_MODULE_0__["QuestionNonValue"]);
            function getCorrectImageLink(val1) {
                if (!val1 || !isUrlYoutubeVideo(val1)) return val1;
                var res = val1.toLocaleLowerCase();
                if (res.indexOf(youtubeEmbed) > -1) return val1;
                var id = "";
                for(var i = val1.length - 1; i >= 0; i--){
                    if (val1[i] === "=" || val1[i] === "/") break;
                    id = val1[i] + id;
                }
                return youtubeUrl + youtubeEmbed + "/" + id;
            }
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("image", [
                {
                    name: "imageLink:file",
                    serializationProperty: "locImageLink"
                },
                {
                    name: "altText",
                    serializationProperty: "locAltText",
                    alternativeName: "text",
                    category: "general"
                },
                {
                    name: "contentMode",
                    default: "auto",
                    choices: [
                        "auto",
                        "image",
                        "video",
                        "youtube"
                    ]
                },
                {
                    name: "imageFit",
                    default: "contain",
                    choices: [
                        "none",
                        "contain",
                        "cover",
                        "fill"
                    ]
                },
                {
                    name: "imageHeight",
                    default: "150"
                },
                {
                    name: "imageWidth",
                    default: "200"
                }
            ], function() {
                return new QuestionImageModel("");
            }, "nonvalue");
            _questionfactory__WEBPACK_IMPORTED_MODULE_2__["QuestionFactory"].Instance.registerQuestion("image", function(name) {
                return new QuestionImageModel(name);
            });
        /***/ },
        /***/ "./src/question_imagepicker.ts": /*!*************************************!*\
  !*** ./src/question_imagepicker.ts ***!
  \*************************************/ /*! exports provided: ImageItemValue, QuestionImagePickerModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ImageItemValue", function() {
                return ImageItemValue;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionImagePickerModel", function() {
                return QuestionImagePickerModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _question_baseselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_baseselect */ "./src/question_baseselect.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var ImageItemValue = /** @class */ function(_super) {
                __extends(ImageItemValue, _super);
                function ImageItemValue(value, text, typeName) {
                    if (text === void 0) text = null;
                    if (typeName === void 0) typeName = "imageitemvalue";
                    var _this = _super.call(this, value, text, typeName) || this;
                    _this.typeName = typeName;
                    _this.createLocalizableString("imageLink", _this, false);
                    return _this;
                }
                ImageItemValue.prototype.getType = function() {
                    return !!this.typeName ? this.typeName : "itemvalue";
                };
                Object.defineProperty(ImageItemValue.prototype, "imageLink", {
                    /**
         * The image or video link property.
         */ get: function() {
                        return this.getLocalizableStringText("imageLink");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("imageLink", val1);
                        this.imageNotLoaded = false;
                        this.videoNotLoaded = false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ImageItemValue.prototype, "locImageLink", {
                    get: function() {
                        return this.getLocalizableString("imageLink");
                    },
                    enumerable: false,
                    configurable: true
                });
                ImageItemValue.prototype.getLocale = function() {
                    return !!this.locOwner ? this.locOwner.getLocale() : "";
                };
                ImageItemValue.prototype.getMarkdownHtml = function(text, name) {
                    return !!this.locOwner ? this.locOwner.getMarkdownHtml(text, name) : undefined;
                };
                ImageItemValue.prototype.getRenderer = function(name) {
                    return !!this.locOwner ? this.locOwner.getRenderer(name) : null;
                };
                ImageItemValue.prototype.getRendererContext = function(locStr) {
                    return !!this.locOwner ? this.locOwner.getRendererContext(locStr) : locStr;
                };
                ImageItemValue.prototype.getProcessedText = function(text) {
                    return !!this.locOwner ? this.locOwner.getProcessedText(text) : text;
                };
                ImageItemValue.prototype.onErrorHandler = function() {
                    this.contentNotLoaded = true;
                };
                Object.defineProperty(ImageItemValue.prototype, "contentNotLoaded", {
                    get: function() {
                        return this.locOwner instanceof QuestionImagePickerModel && this.locOwner.contentMode == "video" ? this.videoNotLoaded : this.imageNotLoaded;
                    },
                    set: function(val1) {
                        if (this.locOwner instanceof QuestionImagePickerModel && this.locOwner.contentMode == "video") this.videoNotLoaded = val1;
                        else this.imageNotLoaded = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ImageItemValue.prototype, "videoNotLoaded", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ImageItemValue.prototype, "imageNotLoaded", void 0);
                return ImageItemValue;
            }(_itemvalue__WEBPACK_IMPORTED_MODULE_3__["ItemValue"]);
            /**
  * A class that describes the Image Picker question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/image-picker-question/ (linkStyle))
 */ var QuestionImagePickerModel = /** @class */ function(_super) {
                __extends(QuestionImagePickerModel, _super);
                function QuestionImagePickerModel(name) {
                    var _this = _super.call(this, name) || this;
                    //responsive mode
                    _this.isResponsiveValue = false;
                    _this.onContentLoaded = function(item, event1) {
                        item.contentNotLoaded = false;
                        var content = event1.target;
                        if (_this.contentMode == "video") item["aspectRatio"] = content.videoWidth / content.videoHeight;
                        else item["aspectRatio"] = content.naturalWidth / content.naturalHeight;
                        _this._width && _this.processResponsiveness(0, _this._width);
                    };
                    _this.colCount = 0;
                    _this.registerPropertyChangedHandlers([
                        "minImageWidth",
                        "maxImageWidth",
                        "minImageHeight",
                        "maxImageHeight",
                        "visibleChoices",
                        "colCount",
                        "isResponsiveValue"
                    ], function() {
                        if (!!_this._width) _this.processResponsiveness(0, _this._width);
                    });
                    _this.registerPropertyChangedHandlers([
                        "imageWidth",
                        "imageHeight"
                    ], function() {
                        _this.calcIsResponsive();
                    });
                    _this.calcIsResponsive();
                    return _this;
                }
                QuestionImagePickerModel.prototype.getType = function() {
                    return "imagepicker";
                };
                QuestionImagePickerModel.prototype.supportGoNextPageAutomatic = function() {
                    return !this.multiSelect;
                };
                Object.defineProperty(QuestionImagePickerModel.prototype, "hasSingleInput", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImagePickerModel.prototype.getItemValueType = function() {
                    return "imageitemvalue";
                };
                Object.defineProperty(QuestionImagePickerModel.prototype, "isCompositeQuestion", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImagePickerModel.prototype.supportOther = function() {
                    return false;
                };
                QuestionImagePickerModel.prototype.supportNone = function() {
                    return false;
                };
                QuestionImagePickerModel.prototype.supportRefuse = function() {
                    return false;
                };
                QuestionImagePickerModel.prototype.supportDontKnow = function() {
                    return false;
                };
                QuestionImagePickerModel.prototype.isAnswerCorrect = function() {
                    if (!this.multiSelect) return _super.prototype.isAnswerCorrect.call(this);
                    return _helpers__WEBPACK_IMPORTED_MODULE_4__["Helpers"].isArrayContainsEqual(this.value, this.correctAnswer);
                };
                Object.defineProperty(QuestionImagePickerModel.prototype, "multiSelect", {
                    /**
         * Specifies whether users can select multiple images or videos.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("multiSelect");
                    },
                    set: function(newValue) {
                        this.setPropertyValue("multiSelect", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImagePickerModel.prototype.isItemSelected = function(item) {
                    var val1 = this.value;
                    var imageItemValue = item;
                    if (this.isValueEmpty(val1)) return false;
                    if (!imageItemValue.imageLink || imageItemValue.contentNotLoaded) return false;
                    if (!this.multiSelect) return this.isTwoValueEquals(val1, item.value);
                    if (!Array.isArray(val1)) return false;
                    for(var i = 0; i < val1.length; i++){
                        if (this.isTwoValueEquals(val1[i], item.value)) return true;
                    }
                    return false;
                };
                QuestionImagePickerModel.prototype.getItemEnabled = function(item) {
                    var imageItemValue = item;
                    if (!imageItemValue.imageLink || imageItemValue.contentNotLoaded) return false;
                    return _super.prototype.getItemEnabled.call(this, item);
                };
                QuestionImagePickerModel.prototype.clearIncorrectValues = function() {
                    if (this.multiSelect) {
                        var val1 = this.value;
                        if (!val1) return;
                        if (!Array.isArray(val1) || val1.length == 0) {
                            this.clearValue();
                            return;
                        }
                        var newValue = [];
                        for(var i = 0; i < val1.length; i++)if (!this.hasUnknownValue(val1[i], true)) newValue.push(val1[i]);
                        if (newValue.length == val1.length) return;
                        if (newValue.length == 0) this.clearValue();
                        else this.value = newValue;
                    } else _super.prototype.clearIncorrectValues.call(this);
                };
                QuestionImagePickerModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    if (!this.multiSelect && !Array.isArray(value)) return _super.prototype.getDisplayValueCore.call(this, keysAsText, value);
                    return this.getDisplayArrayValue(keysAsText, value);
                };
                Object.defineProperty(QuestionImagePickerModel.prototype, "showLabel", {
                    /**
         * Specifies whether to display labels under images or videos. Labels text are taken from the `text` property of each object in the `choices` array.
         * @see choices
         */ get: function() {
                        return this.getPropertyValue("showLabel");
                    },
                    set: function(newValue) {
                        this.setPropertyValue("showLabel", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImagePickerModel.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    if (!this.isDesignMode && this.multiSelect) {
                        this.createNewArray("renderedValue");
                        this.createNewArray("value");
                    }
                    this.calcIsResponsive();
                };
                QuestionImagePickerModel.prototype.getValueCore = function() {
                    var value = _super.prototype.getValueCore.call(this);
                    if (value !== undefined) return value;
                    if (this.multiSelect) return [];
                    return value;
                };
                QuestionImagePickerModel.prototype.convertValToArrayForMultSelect = function(val1) {
                    if (!this.multiSelect) return val1;
                    if (this.isValueEmpty(val1) || Array.isArray(val1)) return val1;
                    return [
                        val1
                    ];
                };
                QuestionImagePickerModel.prototype.renderedValueFromDataCore = function(val1) {
                    return this.convertValToArrayForMultSelect(val1);
                };
                QuestionImagePickerModel.prototype.rendredValueToDataCore = function(val1) {
                    return this.convertValToArrayForMultSelect(val1);
                };
                Object.defineProperty(QuestionImagePickerModel.prototype, "imageHeight", {
                    /**
         * Specifies the height of containers for images or videos. Accepts positive numbers and CSS values.
         *
         * Default value: undefined
         *
         * Use the `imageFit` property to specify how to fit the images or videos into their containers.
         * @see imageWidth
         * @see imageFit
         */ get: function() {
                        return this.getPropertyValue("imageHeight");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageHeight", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImagePickerModel.prototype, "renderedImageHeight", {
                    get: function() {
                        var height = this.isResponsive ? Math.floor(this.responsiveImageHeight) : this.imageHeight;
                        return height ? height : 150;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImagePickerModel.prototype, "imageWidth", {
                    /**
         * Specifies the width of containers for images or videos. Accepts positive numbers and CSS values.
         *
         * Default value: 200
         *
         * Use the `imageFit` property to specify how to fit the images or videos into their containers.
         * @see imageHeight
         * @see imageFit
         */ get: function() {
                        return this.getPropertyValue("imageWidth");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImagePickerModel.prototype, "renderedImageWidth", {
                    get: function() {
                        var width = this.isResponsive ? Math.floor(this.responsiveImageWidth) : this.imageWidth;
                        return width ? width : 200;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImagePickerModel.prototype, "imageFit", {
                    /**
         * Specifies how to resize images or videos to fit them into their containers.
         *
         * Refer to the [`object-fit`](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit) CSS property description for information on accepted values.
         * @see imageHeight
         * @see imageWidth
         */ get: function() {
                        return this.getPropertyValue("imageFit");
                    },
                    set: function(val1) {
                        this.setPropertyValue("imageFit", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImagePickerModel.prototype, "contentMode", {
                    /**
         * Specifies the type of content that choice items display.
         *
         * Possible values:
         *
         * - `"image"` (default) - Images in one of the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO.
         * - `"video"` - Videos in one of the following formats: MP4, MOV, WMV, FLV, AVI, MKV.
         */ get: function() {
                        return this.getPropertyValue("contentMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("contentMode", val1);
                        if (val1 === "video") this.showLabel = true;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImagePickerModel.prototype.convertDefaultValue = function(val1) {
                    return val1;
                };
                Object.defineProperty(QuestionImagePickerModel.prototype, "inputType", {
                    get: function() {
                        return this.multiSelect ? "checkbox" : "radio";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImagePickerModel.prototype.isBuiltInChoice = function(item) {
                    return false;
                };
                QuestionImagePickerModel.prototype.addToVisibleChoices = function(items, isAddAll) {
                    this.addNewItemToVisibleChoices(items, isAddAll);
                };
                QuestionImagePickerModel.prototype.getSelectBaseRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(_super.prototype.getSelectBaseRootCss.call(this)).append(this.cssClasses.rootColumn, this.getCurrentColCount() == 1).toString();
                };
                Object.defineProperty(QuestionImagePickerModel.prototype, "isResponsive", {
                    get: function() {
                        return this.isResponsiveValue && this.isDefaultV2Theme;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionImagePickerModel.prototype, "exactSizesAreEmpty", {
                    get: function() {
                        var _this = this;
                        return ![
                            "imageHeight",
                            "imageWidth"
                        ].some(function(propName) {
                            return _this[propName] !== undefined && _this[propName] !== null;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionImagePickerModel.prototype.calcIsResponsive = function() {
                    this.isResponsiveValue = this.exactSizesAreEmpty;
                };
                QuestionImagePickerModel.prototype.getObservedElementSelector = function() {
                    return Object(_utils_utils__WEBPACK_IMPORTED_MODULE_7__["classesToSelector"])(this.cssClasses.root);
                };
                QuestionImagePickerModel.prototype.supportResponsiveness = function() {
                    return true;
                };
                QuestionImagePickerModel.prototype.needResponsiveness = function() {
                    return this.supportResponsiveness() && this.isDefaultV2Theme;
                };
                QuestionImagePickerModel.prototype.getCurrentColCount = function() {
                    if (this.responsiveColCount === undefined || this.colCount === 0) return this.colCount;
                    return this.responsiveColCount;
                };
                QuestionImagePickerModel.prototype.processResponsiveness = function(_, availableWidth) {
                    this._width = availableWidth = Math.floor(availableWidth);
                    var calcAvailableColumnsCount = function(availableWidth, minWidth, gap) {
                        var itemsInRow = Math.floor(availableWidth / (minWidth + gap));
                        if ((itemsInRow + 1) * (minWidth + gap) - gap <= availableWidth) itemsInRow++;
                        return itemsInRow;
                    };
                    if (this.isResponsive) {
                        var itemsCount = this.choices.length + (this.isDesignMode ? 1 : 0);
                        var gap = this.gapBetweenItems || 0;
                        var minWidth = this.minImageWidth;
                        var maxWidth = this.maxImageWidth;
                        var maxHeight = this.maxImageHeight;
                        var minHeight = this.minImageHeight;
                        var colCount = this.colCount;
                        var width_1;
                        if (colCount === 0) {
                            if ((gap + minWidth) * itemsCount - gap > availableWidth) {
                                var itemsInRow = calcAvailableColumnsCount(availableWidth, minWidth, gap);
                                width_1 = Math.floor((availableWidth - gap * (itemsInRow - 1)) / itemsInRow);
                            } else width_1 = Math.floor((availableWidth - gap * (itemsCount - 1)) / itemsCount);
                        } else {
                            var availableColumnsCount = calcAvailableColumnsCount(availableWidth, minWidth, gap);
                            if (availableColumnsCount < colCount) {
                                this.responsiveColCount = availableColumnsCount >= 1 ? availableColumnsCount : 1;
                                colCount = this.responsiveColCount;
                            } else this.responsiveColCount = colCount;
                            width_1 = Math.floor((availableWidth - gap * (colCount - 1)) / colCount);
                        }
                        width_1 = Math.max(minWidth, Math.min(width_1, maxWidth));
                        var height_1 = Number.MIN_VALUE;
                        this.choices.forEach(function(item) {
                            var tempHeight = width_1 / item["aspectRatio"];
                            height_1 = tempHeight > height_1 ? tempHeight : height_1;
                        });
                        if (height_1 > maxHeight) height_1 = maxHeight;
                        else if (height_1 < minHeight) height_1 = minHeight;
                        var oldResponsiveImageWidth = this.responsiveImageWidth;
                        var oldResponsiveImageHeight = this.responsiveImageHeight;
                        this.responsiveImageWidth = width_1;
                        this.responsiveImageHeight = height_1;
                        return oldResponsiveImageWidth !== this.responsiveImageWidth || oldResponsiveImageHeight !== this.responsiveImageHeight;
                    }
                    return false;
                };
                QuestionImagePickerModel.prototype.triggerResponsiveness = function(hard) {
                    if (hard === void 0) hard = true;
                    if (hard && this.reCalcGapBetweenItemsCallback) this.reCalcGapBetweenItemsCallback();
                    _super.prototype.triggerResponsiveness.call(this, hard);
                };
                QuestionImagePickerModel.prototype.afterRender = function(el) {
                    var _this = this;
                    _super.prototype.afterRender.call(this, el);
                    var selector = this.getObservedElementSelector();
                    var observedElement = el && selector ? el.querySelector(selector) : undefined;
                    if (!!observedElement) {
                        this.reCalcGapBetweenItemsCallback = function() {
                            _this.gapBetweenItems = Math.ceil(Number.parseFloat(_global_variables_utils__WEBPACK_IMPORTED_MODULE_8__["DomDocumentHelper"].getComputedStyle(observedElement).gap)) || 16;
                        };
                        this.reCalcGapBetweenItemsCallback();
                    }
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionImagePickerModel.prototype, "responsiveImageHeight", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionImagePickerModel.prototype, "responsiveImageWidth", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionImagePickerModel.prototype, "isResponsiveValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionImagePickerModel.prototype, "maxImageWidth", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionImagePickerModel.prototype, "minImageWidth", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionImagePickerModel.prototype, "maxImageHeight", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionImagePickerModel.prototype, "minImageHeight", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionImagePickerModel.prototype, "responsiveColCount", void 0);
                return QuestionImagePickerModel;
            }(_question_baseselect__WEBPACK_IMPORTED_MODULE_2__["QuestionCheckboxBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("imageitemvalue", [
                {
                    name: "imageLink:file",
                    serializationProperty: "locImageLink"
                }
            ], function(value) {
                return new ImageItemValue(value);
            }, "itemvalue");
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("responsiveImageSize", [], undefined, "number");
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("imagepicker", [
                {
                    name: "showOtherItem",
                    visible: false
                },
                {
                    name: "otherText",
                    visible: false
                },
                {
                    name: "showNoneItem",
                    visible: false
                },
                {
                    name: "showRefuseItem",
                    visible: false
                },
                {
                    name: "showDontKnowItem",
                    visible: false
                },
                {
                    name: "noneText",
                    visible: false
                },
                {
                    name: "optionsCaption",
                    visible: false
                },
                {
                    name: "otherErrorText",
                    visible: false
                },
                {
                    name: "storeOthersAsComment",
                    visible: false
                },
                {
                    name: "contentMode",
                    default: "image",
                    choices: [
                        "image",
                        "video"
                    ]
                },
                {
                    name: "imageFit",
                    default: "contain",
                    choices: [
                        "none",
                        "contain",
                        "cover",
                        "fill"
                    ]
                },
                {
                    name: "imageHeight:number",
                    minValue: 0
                },
                {
                    name: "imageWidth:number",
                    minValue: 0
                },
                {
                    name: "minImageWidth:responsiveImageSize",
                    default: 200,
                    minValue: 0,
                    visibleIf: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].supportCreatorV2;
                    }
                },
                {
                    name: "minImageHeight:responsiveImageSize",
                    default: 133,
                    minValue: 0,
                    visibleIf: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].supportCreatorV2;
                    }
                },
                {
                    name: "maxImageWidth:responsiveImageSize",
                    default: 400,
                    minValue: 0,
                    visibleIf: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].supportCreatorV2;
                    }
                },
                {
                    name: "maxImageHeight:responsiveImageSize",
                    default: 266,
                    minValue: 0,
                    visibleIf: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].supportCreatorV2;
                    }
                }
            ], function() {
                return new QuestionImagePickerModel("");
            }, "checkboxbase");
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addProperty("imagepicker", {
                name: "showLabel:boolean",
                default: false
            });
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addProperty("imagepicker", {
                name: "colCount:number",
                default: 0,
                choices: [
                    0,
                    1,
                    2,
                    3,
                    4,
                    5
                ]
            });
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addProperty("imagepicker", {
                name: "multiSelect:boolean",
                default: false
            });
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addProperty("imagepicker", {
                name: "choices:imageitemvalue[]"
            });
            _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].Instance.registerQuestion("imagepicker", function(name) {
                var q = new QuestionImagePickerModel(name);
                //q.choices = QuestionFactory.DefaultChoices;
                return q;
            });
        /***/ },
        /***/ "./src/question_matrix.ts": /*!********************************!*\
  !*** ./src/question_matrix.ts ***!
  \********************************/ /*! exports provided: MatrixRowModel, MatrixCells, QuestionMatrixModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixRowModel", function() {
                return MatrixRowModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixCells", function() {
                return MatrixCells;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixModel", function() {
                return QuestionMatrixModel;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _martixBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./martixBase */ "./src/martixBase.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _question_dropdown__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./question_dropdown */ "./src/question_dropdown.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var MatrixRowModel = /** @class */ function(_super) {
                __extends(MatrixRowModel, _super);
                function MatrixRowModel(item, fullName, data, value) {
                    var _this = _super.call(this) || this;
                    _this.item = item;
                    _this.fullName = fullName;
                    _this.data = data;
                    _this.setValueDirectly(value);
                    _this.cellClick = function(column) {
                        _this.value = column.value;
                    };
                    _this.registerPropertyChangedHandlers([
                        "value"
                    ], function() {
                        if (_this.data) _this.data.onMatrixRowChanged(_this);
                    });
                    return _this;
                }
                Object.defineProperty(MatrixRowModel.prototype, "name", {
                    get: function() {
                        return this.item.value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixRowModel.prototype, "text", {
                    get: function() {
                        return this.item.text;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixRowModel.prototype, "locText", {
                    get: function() {
                        return this.item.locText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixRowModel.prototype, "value", {
                    get: function() {
                        return this.getPropertyValue("value");
                    },
                    set: function(val1) {
                        if (!this.isReadOnly) this.setValueDirectly(this.data.getCorrectedRowValue(val1));
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixRowModel.prototype.setValueDirectly = function(val1) {
                    this.setPropertyValue("value", val1);
                };
                Object.defineProperty(MatrixRowModel.prototype, "isReadOnly", {
                    get: function() {
                        return !this.item.enabled || this.data.isInputReadOnly;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixRowModel.prototype, "rowTextClasses", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__["CssClassBuilder"]().append(this.data.cssClasses.rowTextCell).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixRowModel.prototype, "rowClasses", {
                    get: function() {
                        var cssClasses = this.data.cssClasses;
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__["CssClassBuilder"]().append(cssClasses.row).append(cssClasses.rowError, this.data.hasErrorInRow(this)).append(cssClasses.rowDisabled, this.isReadOnly).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                return MatrixRowModel;
            }(_base__WEBPACK_IMPORTED_MODULE_4__["Base"]);
            var MatrixCells = /** @class */ function() {
                function MatrixCells(cellsOwner) {
                    this.cellsOwner = cellsOwner;
                    this.values = {};
                }
                Object.defineProperty(MatrixCells.prototype, "isEmpty", {
                    get: function() {
                        return Object.keys(this.values).length == 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixCells.prototype.valuesChanged = function() {
                    if (!!this.onValuesChanged) this.onValuesChanged();
                };
                MatrixCells.prototype.setCellText = function(row, column, val1) {
                    row = this.getCellRowColumnValue(row, this.rows);
                    column = this.getCellRowColumnValue(column, this.columns);
                    if (!row || !column) return;
                    if (val1) {
                        if (!this.values[row]) this.values[row] = {};
                        if (!this.values[row][column]) this.values[row][column] = this.createString();
                        this.values[row][column].text = val1;
                    } else if (this.values[row] && this.values[row][column]) {
                        var loc = this.values[row][column];
                        loc.text = "";
                        if (loc.isEmpty) {
                            delete this.values[row][column];
                            if (Object.keys(this.values[row]).length == 0) delete this.values[row];
                        }
                    }
                    this.valuesChanged();
                };
                MatrixCells.prototype.setDefaultCellText = function(column, val1) {
                    this.setCellText(_settings__WEBPACK_IMPORTED_MODULE_10__["settings"].matrix.defaultRowName, column, val1);
                };
                MatrixCells.prototype.getCellLocText = function(row, column) {
                    row = this.getCellRowColumnValue(row, this.rows);
                    column = this.getCellRowColumnValue(column, this.columns);
                    if (!row || !column) return null;
                    if (!this.values[row]) return null;
                    if (!this.values[row][column]) return null;
                    return this.values[row][column];
                };
                MatrixCells.prototype.getDefaultCellLocText = function(column, val1) {
                    return this.getCellLocText(_settings__WEBPACK_IMPORTED_MODULE_10__["settings"].matrix.defaultRowName, column);
                };
                MatrixCells.prototype.getCellDisplayLocText = function(row, column) {
                    var cellText = this.getCellLocText(row, column);
                    if (cellText && !cellText.isEmpty) return cellText;
                    cellText = this.getCellLocText(_settings__WEBPACK_IMPORTED_MODULE_10__["settings"].matrix.defaultRowName, column);
                    if (cellText && !cellText.isEmpty) return cellText;
                    if (typeof column == "number") column = column >= 0 && column < this.columns.length ? this.columns[column] : null;
                    if (column && column.locText) return column.locText;
                    return null;
                };
                MatrixCells.prototype.getCellText = function(row, column) {
                    var loc = this.getCellLocText(row, column);
                    return loc ? loc.calculatedText : null;
                };
                MatrixCells.prototype.getDefaultCellText = function(column) {
                    var loc = this.getCellLocText(_settings__WEBPACK_IMPORTED_MODULE_10__["settings"].matrix.defaultRowName, column);
                    return loc ? loc.calculatedText : null;
                };
                MatrixCells.prototype.getCellDisplayText = function(row, column) {
                    var loc = this.getCellDisplayLocText(row, column);
                    return loc ? loc.calculatedText : null;
                };
                Object.defineProperty(MatrixCells.prototype, "rows", {
                    get: function() {
                        return this.cellsOwner ? this.cellsOwner.getRows() : [];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixCells.prototype, "columns", {
                    get: function() {
                        return this.cellsOwner ? this.cellsOwner.getColumns() : [];
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixCells.prototype.getCellRowColumnValue = function(val1, values) {
                    if (val1 === null || val1 === undefined) return null;
                    if (typeof val1 == "number") {
                        if (val1 < 0 || val1 >= values.length) return null;
                        val1 = values[val1].value;
                    }
                    if (val1.value) return val1.value;
                    return val1;
                };
                MatrixCells.prototype.getJson = function() {
                    if (this.isEmpty) return null;
                    var res = {};
                    for(var row in this.values){
                        var resRow = {};
                        var rowValues = this.values[row];
                        for(var col in rowValues)resRow[col] = rowValues[col].getJson();
                        res[row] = resRow;
                    }
                    return res;
                };
                MatrixCells.prototype.setJson = function(value) {
                    this.values = {};
                    if (!!value) for(var row in value){
                        if (row == "pos") continue;
                        var rowValues = value[row];
                        this.values[row] = {};
                        for(var col in rowValues){
                            if (col == "pos") continue;
                            var loc = this.createString();
                            loc.setJson(rowValues[col]);
                            this.values[row][col] = loc;
                        }
                    }
                    this.valuesChanged();
                };
                MatrixCells.prototype.locStrsChanged = function() {
                    if (this.isEmpty) return;
                    for(var row in this.values){
                        var rowValues = this.values[row];
                        for(var col in rowValues)rowValues[col].strChanged();
                    }
                };
                MatrixCells.prototype.createString = function() {
                    return new _localizablestring__WEBPACK_IMPORTED_MODULE_8__["LocalizableString"](this.cellsOwner, true);
                };
                return MatrixCells;
            }();
            /**
  * A class that describes the Single-Select Matrix question type.
  *
  * [View Demo](https://surveyjs.io/form-library/examples/single-selection-matrix-table-question/ (linkStyle))
  */ var QuestionMatrixModel = /** @class */ function(_super) {
                __extends(QuestionMatrixModel, _super);
                function QuestionMatrixModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.isRowChanging = false;
                    _this.emptyLocalizableString = new _localizablestring__WEBPACK_IMPORTED_MODULE_8__["LocalizableString"](_this);
                    _this.cellsValue = new MatrixCells(_this);
                    _this.cellsValue.onValuesChanged = function() {
                        _this.updateHasCellText();
                        _this.propertyValueChanged("cells", _this.cells, _this.cells);
                    };
                    _this.registerPropertyChangedHandlers([
                        "columns"
                    ], function() {
                        _this.onColumnsChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "rows"
                    ], function() {
                        if (!_this.filterItems()) _this.onRowsChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "hideIfRowsEmpty"
                    ], function() {
                        _this.updateVisibilityBasedOnRows();
                    });
                    return _this;
                }
                QuestionMatrixModel.prototype.getType = function() {
                    return "matrix";
                };
                Object.defineProperty(QuestionMatrixModel.prototype, "cellComponent", {
                    /**
         * The name of a component used to render cells.
         */ get: function() {
                        return this.getPropertyValue("cellComponent");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "itemComponent", {
                    set: function(value) {
                        this.setPropertyValue("cellComponent", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "hasSingleInput", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "isAllRowRequired", {
                    /**
         * Specifies whether each row requires an answer. If a respondent skips a row, the question displays a validation error.
         * @see isRequired
         * @see eachRowUnique
         * @see validators
         */ get: function() {
                        return this.getPropertyValue("isAllRowRequired");
                    },
                    set: function(val1) {
                        this.setPropertyValue("isAllRowRequired", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "eachRowUnique", {
                    /**
         * Specifies whether answers in all rows should be unique. If any answers duplicate, the question displays a validation error.
         * @see isAllRowRequired
         * @see validators
         */ get: function() {
                        return this.getPropertyValue("eachRowUnique");
                    },
                    set: function(val1) {
                        this.setPropertyValue("eachRowUnique", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "hasRows", {
                    get: function() {
                        return this.rows.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "rowsOrder", {
                    /**
         * Specifies a sort order for matrix rows.
         *
         * Possible values:
         *
         * - "initial" (default) - Preserves the original order of the `rows` array.
         * - "random" - Arranges matrix rows in random order each time the question is displayed.
         * @see rows
         */ get: function() {
                        return this.getPropertyValue("rowsOrder");
                    },
                    set: function(val1) {
                        val1 = val1.toLowerCase();
                        if (val1 == this.rowsOrder) return;
                        this.setPropertyValue("rowsOrder", val1);
                        this.onRowsChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "hideIfRowsEmpty", {
                    /**
         * Specifies whether to hide the question when the matrix has no visible rows.
         * @see rowsVisibleIf
         */ get: function() {
                        return this.getPropertyValue("hideIfRowsEmpty");
                    },
                    set: function(val1) {
                        this.setPropertyValue("hideIfRowsEmpty", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixModel.prototype.getRows = function() {
                    return this.rows;
                };
                QuestionMatrixModel.prototype.getColumns = function() {
                    return this.visibleColumns;
                };
                QuestionMatrixModel.prototype.addColumn = function(value, text) {
                    var col = new _itemvalue__WEBPACK_IMPORTED_MODULE_1__["ItemValue"](value, text);
                    this.columns.push(col);
                    return col;
                };
                QuestionMatrixModel.prototype.getItemClass = function(row, column) {
                    var isChecked = row.value == column.value;
                    var isDisabled = this.isReadOnly;
                    var allowHover = !isChecked && !isDisabled;
                    var hasCellText = this.hasCellText;
                    var css = this.cssClasses;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__["CssClassBuilder"]().append(css.cell, hasCellText).append(hasCellText ? css.cellText : css.label).append(css.itemOnError, !hasCellText && (this.isAllRowRequired ? this.hasErrorInRow(row) : this.hasCssError())).append(hasCellText ? css.cellTextSelected : css.itemChecked, isChecked).append(hasCellText ? css.cellTextDisabled : css.itemDisabled, isDisabled).append(css.itemHover, allowHover && !hasCellText).toString();
                };
                Object.defineProperty(QuestionMatrixModel.prototype, "itemSvgIcon", {
                    get: function() {
                        return this.cssClasses.itemSvgIconId;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixModel.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.cells.locStrsChanged();
                };
                QuestionMatrixModel.prototype.getQuizQuestionCount = function() {
                    var res = 0;
                    for(var i = 0; i < this.rows.length; i++)if (!this.isValueEmpty(this.correctAnswer[this.rows[i].value])) res++;
                    return res;
                };
                QuestionMatrixModel.prototype.getCorrectAnswerCount = function() {
                    var res = 0;
                    var value = this.value;
                    for(var i = 0; i < this.rows.length; i++){
                        var row = this.rows[i].value;
                        if (!this.isValueEmpty(value[row]) && this.isTwoValueEquals(this.correctAnswer[row], value[row])) res++;
                    }
                    return res;
                };
                QuestionMatrixModel.prototype.runItemsCondition = function(values, properties) {
                    _itemvalue__WEBPACK_IMPORTED_MODULE_1__["ItemValue"].runEnabledConditionsForItems(this.rows, undefined, values, properties);
                    return _super.prototype.runItemsCondition.call(this, values, properties);
                };
                QuestionMatrixModel.prototype.getVisibleRows = function() {
                    var result = new Array();
                    var val1 = this.value;
                    if (!val1) val1 = {};
                    var rows = !!this.filteredRows ? this.filteredRows : this.rows;
                    for(var i = 0; i < rows.length; i++){
                        var row = rows[i];
                        if (this.isValueEmpty(row.value)) continue;
                        result.push(this.createMatrixRow(row, this.id + "_" + row.value.toString().replace(/\s/g, "_"), val1[row.value]));
                    }
                    this.generatedVisibleRows = result;
                    return result;
                };
                QuestionMatrixModel.prototype.sortVisibleRows = function(array) {
                    if (!!this.survey && this.survey.isDesignMode) return array;
                    var order = this.rowsOrder.toLowerCase();
                    if (order === "random") return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].randomizeArray(array);
                    return array;
                };
                QuestionMatrixModel.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    this.rows = this.sortVisibleRows(this.rows);
                };
                QuestionMatrixModel.prototype.isNewValueCorrect = function(val1) {
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueObject(val1, true);
                };
                QuestionMatrixModel.prototype.processRowsOnSet = function(newRows) {
                    return this.sortVisibleRows(newRows);
                };
                Object.defineProperty(QuestionMatrixModel.prototype, "visibleRows", {
                    get: function() {
                        return this.getVisibleRows();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "cells", {
                    /**
         * An array of matrix cells. Use this array to get or set cell values.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/questiontype-matrix-rubric/ (linkStyle))
         */ get: function() {
                        return this.cellsValue;
                    },
                    set: function(value) {
                        this.cells.setJson(value && value.getJson ? value.getJson() : null);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixModel.prototype, "hasCellText", {
                    get: function() {
                        return this.getPropertyValue("hasCellText", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixModel.prototype.updateHasCellText = function() {
                    this.setPropertyValue("hasCellText", !this.cells.isEmpty);
                };
                QuestionMatrixModel.prototype.setCellText = function(row, column, val1) {
                    this.cells.setCellText(row, column, val1);
                };
                QuestionMatrixModel.prototype.getCellText = function(row, column) {
                    return this.cells.getCellText(row, column);
                };
                QuestionMatrixModel.prototype.setDefaultCellText = function(column, val1) {
                    this.cells.setDefaultCellText(column, val1);
                };
                QuestionMatrixModel.prototype.getDefaultCellText = function(column) {
                    return this.cells.getDefaultCellText(column);
                };
                QuestionMatrixModel.prototype.getCellDisplayText = function(row, column) {
                    return this.cells.getCellDisplayText(row, column);
                };
                QuestionMatrixModel.prototype.getCellDisplayLocText = function(row, column) {
                    var loc = this.cells.getCellDisplayLocText(row, column);
                    return loc ? loc : this.emptyLocalizableString;
                };
                QuestionMatrixModel.prototype.supportGoNextPageAutomatic = function() {
                    return this.isMouseDown === true && this.hasValuesInAllRows(false);
                };
                QuestionMatrixModel.prototype.onCheckForErrors = function(errors, isOnValueChanged) {
                    _super.prototype.onCheckForErrors.call(this, errors, isOnValueChanged);
                    this.errorsInRow = undefined;
                    if (!isOnValueChanged || this.hasCssError()) {
                        if (this.hasErrorAllRowsRequired()) errors.push(new _error__WEBPACK_IMPORTED_MODULE_6__["RequiredInAllRowsError"](null, this));
                        if (this.hasErrorEachRowUnique()) errors.push(new _error__WEBPACK_IMPORTED_MODULE_6__["EachRowUniqueError"](null, this));
                    }
                };
                QuestionMatrixModel.prototype.hasErrorAllRowsRequired = function() {
                    return this.isAllRowRequired && !this.hasValuesInAllRows(true);
                };
                QuestionMatrixModel.prototype.hasErrorEachRowUnique = function() {
                    return this.eachRowUnique && this.hasNonUniqueValueInRow();
                };
                QuestionMatrixModel.prototype.hasValuesInAllRows = function(addError) {
                    var rows = this.generatedVisibleRows;
                    if (!rows) rows = this.visibleRows;
                    if (!rows) return true;
                    var res = true;
                    for(var i = 0; i < rows.length; i++){
                        var row = rows[i];
                        var hasValue = !this.isValueEmpty(row.value);
                        if (addError && !hasValue) this.addErrorIntoRow(row);
                        res = res && hasValue;
                    }
                    return res;
                };
                QuestionMatrixModel.prototype.hasNonUniqueValueInRow = function() {
                    var rows = this.generatedVisibleRows;
                    if (!rows) rows = this.visibleRows;
                    if (!rows) return false;
                    var hash = {};
                    var res = true;
                    for(var i = 0; i < rows.length; i++){
                        var val1 = rows[i].value;
                        var isEmpty = this.isValueEmpty(val1);
                        var isUnique = isEmpty || hash[val1] !== true;
                        if (!isUnique) this.addErrorIntoRow(rows[i]);
                        res = res && isUnique;
                        if (!isEmpty) hash[val1] = true;
                    }
                    return !res;
                };
                QuestionMatrixModel.prototype.addErrorIntoRow = function(row) {
                    if (!this.errorsInRow) this.errorsInRow = {};
                    this.errorsInRow[row.name] = true;
                };
                QuestionMatrixModel.prototype.getIsAnswered = function() {
                    return _super.prototype.getIsAnswered.call(this) && this.hasValuesInAllRows(false);
                };
                QuestionMatrixModel.prototype.createMatrixRow = function(item, fullName, value) {
                    var row = new MatrixRowModel(item, fullName, this, value);
                    this.onMatrixRowCreated(row);
                    return row;
                };
                QuestionMatrixModel.prototype.onMatrixRowCreated = function(row) {};
                QuestionMatrixModel.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    _super.prototype.setQuestionValue.call(this, newValue, this.isRowChanging || updateIsAnswered);
                    if (!this.generatedVisibleRows || this.generatedVisibleRows.length == 0) return;
                    this.isRowChanging = true;
                    var val1 = this.value;
                    if (!val1) val1 = {};
                    if (this.rows.length == 0) this.generatedVisibleRows[0].setValueDirectly(val1);
                    else for(var i = 0; i < this.generatedVisibleRows.length; i++){
                        var row = this.generatedVisibleRows[i];
                        var rowVal = val1[row.name];
                        if (this.isValueEmpty(rowVal)) rowVal = null;
                        this.generatedVisibleRows[i].setValueDirectly(rowVal);
                    }
                    this.updateIsAnswered();
                    this.isRowChanging = false;
                };
                QuestionMatrixModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    var res = {};
                    for(var key in value){
                        var newKey = keysAsText ? _itemvalue__WEBPACK_IMPORTED_MODULE_1__["ItemValue"].getTextOrHtmlByValue(this.rows, key) : key;
                        if (!newKey) newKey = key;
                        var newValue = _itemvalue__WEBPACK_IMPORTED_MODULE_1__["ItemValue"].getTextOrHtmlByValue(this.columns, value[key]);
                        if (!newValue) newValue = value[key];
                        res[newKey] = newValue;
                    }
                    return res;
                };
                QuestionMatrixModel.prototype.getPlainData = function(options) {
                    var _this = this;
                    if (options === void 0) options = {
                        includeEmpty: true
                    };
                    var questionPlainData = _super.prototype.getPlainData.call(this, options);
                    if (!!questionPlainData) {
                        var values = this.createValueCopy();
                        questionPlainData.isNode = true;
                        questionPlainData.data = Object.keys(values || {}).map(function(rowName) {
                            var row = _this.rows.filter(function(r) {
                                return r.value === rowName;
                            })[0];
                            var rowDataItem = {
                                name: rowName,
                                title: !!row ? row.text : "row",
                                value: values[rowName],
                                displayValue: _itemvalue__WEBPACK_IMPORTED_MODULE_1__["ItemValue"].getTextOrHtmlByValue(_this.visibleColumns, values[rowName]),
                                getString: function(val1) {
                                    return typeof val1 === "object" ? JSON.stringify(val1) : val1;
                                },
                                isNode: false
                            };
                            var item = _itemvalue__WEBPACK_IMPORTED_MODULE_1__["ItemValue"].getItemByValue(_this.visibleColumns, values[rowName]);
                            if (!!item) (options.calculations || []).forEach(function(calculation) {
                                rowDataItem[calculation.propertyName] = item[calculation.propertyName];
                            });
                            return rowDataItem;
                        });
                    }
                    return questionPlainData;
                };
                QuestionMatrixModel.prototype.addConditionObjectsByContext = function(objects, context) {
                    for(var i = 0; i < this.rows.length; i++){
                        var row = this.rows[i];
                        if (!!row.value) objects.push({
                            name: this.getValueName() + "." + row.value,
                            text: this.processedTitle + "." + row.calculatedText,
                            question: this
                        });
                    }
                };
                QuestionMatrixModel.prototype.getConditionJson = function(operator, path) {
                    if (operator === void 0) operator = null;
                    if (path === void 0) path = null;
                    if (!path) return _super.prototype.getConditionJson.call(this);
                    var question = new _question_dropdown__WEBPACK_IMPORTED_MODULE_9__["QuestionDropdownModel"](path);
                    question.choices = this.columns;
                    var json = new _jsonobject__WEBPACK_IMPORTED_MODULE_3__["JsonObject"]().toJsonObject(question);
                    json["type"] = question.getType();
                    return json;
                };
                QuestionMatrixModel.prototype.clearValueIfInvisibleCore = function(reason) {
                    _super.prototype.clearValueIfInvisibleCore.call(this, reason);
                    if (this.hasRows) this.clearInvisibleValuesInRows();
                };
                QuestionMatrixModel.prototype.getFirstInputElementId = function() {
                    var rows = this.generatedVisibleRows;
                    if (!rows) rows = this.visibleRows;
                    if (rows.length > 0 && this.visibleColumns.length > 0) return this.inputId + "_" + rows[0].name + "_" + 0;
                    return _super.prototype.getFirstInputElementId.call(this);
                };
                //IMatrixData
                QuestionMatrixModel.prototype.onMatrixRowChanged = function(row) {
                    if (this.isRowChanging) return;
                    this.isRowChanging = true;
                    if (!this.hasRows) this.setNewValue(row.value);
                    else {
                        var newValue = this.value;
                        if (!newValue) newValue = {};
                        newValue[row.name] = row.value;
                        this.setNewValue(newValue);
                    }
                    this.isRowChanging = false;
                };
                QuestionMatrixModel.prototype.getCorrectedRowValue = function(value) {
                    for(var i = 0; i < this.columns.length; i++){
                        if (value === this.columns[i].value) return value;
                    }
                    for(var i = 0; i < this.columns.length; i++){
                        if (this.isTwoValueEquals(value, this.columns[i].value)) return this.columns[i].value;
                    }
                    return value;
                };
                QuestionMatrixModel.prototype.hasErrorInRow = function(row) {
                    return !!this.errorsInRow && !!this.errorsInRow[row.name];
                };
                QuestionMatrixModel.prototype.getSearchableItemValueKeys = function(keys) {
                    keys.push("columns");
                    keys.push("rows");
                };
                Object.defineProperty(QuestionMatrixModel.prototype, "SurveyModel", {
                    get: function() {
                        return this.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixModel.prototype.getColumnHeaderWrapperComponentName = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentName({
                        column: cell
                    }, "column-header");
                };
                QuestionMatrixModel.prototype.getColumnHeaderWrapperComponentData = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentData({
                        column: cell
                    }, "column-header");
                };
                QuestionMatrixModel.prototype.getRowHeaderWrapperComponentName = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentName({
                        row: cell
                    }, "row-header");
                };
                QuestionMatrixModel.prototype.getRowHeaderWrapperComponentData = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentData({
                        row: cell
                    }, "row-header");
                };
                return QuestionMatrixModel;
            }(_martixBase__WEBPACK_IMPORTED_MODULE_2__["QuestionMatrixBaseModel"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_3__["Serializer"].addClass("matrix", [
                "rowTitleWidth",
                {
                    name: "columns:itemvalue[]",
                    uniqueProperty: "value",
                    baseValue: function() {
                        return _surveyStrings__WEBPACK_IMPORTED_MODULE_5__["surveyLocalization"].getString("matrix_column");
                    }
                },
                {
                    name: "rows:itemvalue[]",
                    uniqueProperty: "value",
                    baseValue: function() {
                        return _surveyStrings__WEBPACK_IMPORTED_MODULE_5__["surveyLocalization"].getString("matrix_row");
                    }
                },
                {
                    name: "cells:cells",
                    serializationProperty: "cells"
                },
                {
                    name: "rowsOrder",
                    default: "initial",
                    choices: [
                        "initial",
                        "random"
                    ]
                },
                "isAllRowRequired:boolean",
                {
                    name: "eachRowUnique:boolean",
                    category: "validation"
                },
                "hideIfRowsEmpty:boolean",
                {
                    name: "cellComponent",
                    visible: false,
                    default: "survey-matrix-cell"
                }
            ], function() {
                return new QuestionMatrixModel("");
            }, "matrixbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_7__["QuestionFactory"].Instance.registerQuestion("matrix", function(name) {
                var q = new QuestionMatrixModel(name);
                q.rows = _questionfactory__WEBPACK_IMPORTED_MODULE_7__["QuestionFactory"].DefaultRows;
                q.columns = _questionfactory__WEBPACK_IMPORTED_MODULE_7__["QuestionFactory"].DefaultColums;
                return q;
            });
        /***/ },
        /***/ "./src/question_matrixdropdown.ts": /*!****************************************!*\
  !*** ./src/question_matrixdropdown.ts ***!
  \****************************************/ /*! exports provided: MatrixDropdownRowModel, QuestionMatrixDropdownModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownRowModel", function() {
                return MatrixDropdownRowModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownModel", function() {
                return QuestionMatrixDropdownModel;
            });
            /* harmony import */ var _question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./question_matrixdropdownbase */ "./src/question_matrixdropdownbase.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var MatrixDropdownRowModel = /** @class */ function(_super) {
                __extends(MatrixDropdownRowModel, _super);
                function MatrixDropdownRowModel(name, item, data, value) {
                    var _this = _super.call(this, data, value) || this;
                    _this.name = name;
                    _this.item = item;
                    _this.buildCells(value);
                    return _this;
                }
                Object.defineProperty(MatrixDropdownRowModel.prototype, "rowName", {
                    get: function() {
                        return this.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModel.prototype, "text", {
                    get: function() {
                        return this.item.text;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModel.prototype, "locText", {
                    get: function() {
                        return this.item.locText;
                    },
                    enumerable: false,
                    configurable: true
                });
                return MatrixDropdownRowModel;
            }(_question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_0__["MatrixDropdownRowModelBase"]);
            /**
  * A class that describes the Multi-Select Matrix question type. Multi-Select Matrix allows you to use the [Dropdown](https://surveyjs.io/form-library/documentation/questiondropdownmodel), [Checkbox](https://surveyjs.io/form-library/documentation/questioncheckboxmodel), [Radiogroup](https://surveyjs.io/form-library/documentation/questionradiogroupmodel), [Text](https://surveyjs.io/form-library/documentation/questiontextmodel), and [Comment](https://surveyjs.io/form-library/documentation/questioncommentmodel) question types as cell editors.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-matrixdropdown/ (linkStyle))
 */ var QuestionMatrixDropdownModel = /** @class */ function(_super) {
                __extends(QuestionMatrixDropdownModel, _super);
                function QuestionMatrixDropdownModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.createLocalizableString("totalText", _this, true);
                    _this.registerPropertyChangedHandlers([
                        "rows"
                    ], function() {
                        _this.clearGeneratedRows();
                        _this.resetRenderedTable();
                        if (!_this.filterItems()) _this.onRowsChanged();
                        _this.clearIncorrectValues();
                    });
                    _this.registerPropertyChangedHandlers([
                        "hideIfRowsEmpty"
                    ], function() {
                        _this.updateVisibilityBasedOnRows();
                    });
                    return _this;
                }
                QuestionMatrixDropdownModel.prototype.getType = function() {
                    return "matrixdropdown";
                };
                Object.defineProperty(QuestionMatrixDropdownModel.prototype, "totalText", {
                    /**
         * A title for the total row. Applies if at least one column displays total values.
         * @see rowTitleWidth
         * @see columns
         */ get: function() {
                        return this.getLocalizableStringText("totalText", "");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("totalText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModel.prototype, "locTotalText", {
                    get: function() {
                        return this.getLocalizableString("totalText");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModel.prototype.getFooterText = function() {
                    return this.locTotalText;
                };
                QuestionMatrixDropdownModel.prototype.getRowTitleWidth = function() {
                    return this.rowTitleWidth;
                };
                Object.defineProperty(QuestionMatrixDropdownModel.prototype, "hideIfRowsEmpty", {
                    /**
         * Specifies whether to hide the question when the matrix has no visible rows.
         * @see rowsVisibleIf
         */ get: function() {
                        return this.getPropertyValue("hideIfRowsEmpty");
                    },
                    set: function(val1) {
                        this.setPropertyValue("hideIfRowsEmpty", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    if (!value) return value;
                    var rows = this.visibleRows;
                    var res = {};
                    if (!rows) return res;
                    for(var i = 0; i < rows.length; i++){
                        var rowValue = rows[i].rowName;
                        var val1 = value[rowValue];
                        if (!val1) continue;
                        if (keysAsText) {
                            var displayRowValue = _itemvalue__WEBPACK_IMPORTED_MODULE_2__["ItemValue"].getTextOrHtmlByValue(this.rows, rowValue);
                            if (!!displayRowValue) rowValue = displayRowValue;
                        }
                        res[rowValue] = this.getRowDisplayValue(keysAsText, rows[i], val1);
                    }
                    return res;
                };
                QuestionMatrixDropdownModel.prototype.getConditionObjectRowName = function(index) {
                    return "." + this.rows[index].value;
                };
                QuestionMatrixDropdownModel.prototype.getConditionObjectRowText = function(index) {
                    return "." + this.rows[index].calculatedText;
                };
                QuestionMatrixDropdownModel.prototype.getConditionObjectsRowIndeces = function() {
                    var res = [];
                    for(var i = 0; i < this.rows.length; i++)res.push(i);
                    return res;
                };
                QuestionMatrixDropdownModel.prototype.isNewValueCorrect = function(val1) {
                    return _helpers__WEBPACK_IMPORTED_MODULE_4__["Helpers"].isValueObject(val1, true);
                };
                QuestionMatrixDropdownModel.prototype.clearIncorrectValues = function() {
                    var val1 = this.value;
                    if (!val1) return;
                    var newVal = null;
                    var isChanged = false;
                    var rows = !!this.filteredRows ? this.filteredRows : this.rows;
                    for(var key in val1)if (_itemvalue__WEBPACK_IMPORTED_MODULE_2__["ItemValue"].getItemByValue(rows, key)) {
                        if (newVal == null) newVal = {};
                        newVal[key] = val1[key];
                    } else isChanged = true;
                    if (isChanged) this.value = newVal;
                    _super.prototype.clearIncorrectValues.call(this);
                };
                QuestionMatrixDropdownModel.prototype.clearValueIfInvisibleCore = function(reason) {
                    _super.prototype.clearValueIfInvisibleCore.call(this, reason);
                    this.clearInvisibleValuesInRows();
                };
                QuestionMatrixDropdownModel.prototype.generateRows = function() {
                    var result = new Array();
                    var rows = !!this.filteredRows ? this.filteredRows : this.rows;
                    if (!rows || rows.length === 0) return result;
                    var val1 = this.value;
                    if (!val1) val1 = {};
                    for(var i = 0; i < rows.length; i++){
                        if (this.isValueEmpty(rows[i].value)) continue;
                        result.push(this.createMatrixRow(rows[i], val1[rows[i].value]));
                    }
                    return result;
                };
                QuestionMatrixDropdownModel.prototype.createMatrixRow = function(item, value) {
                    return new MatrixDropdownRowModel(item.value, item, this, value);
                };
                QuestionMatrixDropdownModel.prototype.getSearchableItemValueKeys = function(keys) {
                    keys.push("rows");
                };
                QuestionMatrixDropdownModel.prototype.updateProgressInfoByValues = function(res) {
                    var val1 = this.value;
                    if (!val1) val1 = {};
                    for(var i = 0; i < this.rows.length; i++){
                        var row = this.rows[i];
                        var rowValue = val1[row.value];
                        this.updateProgressInfoByRow(res, !!rowValue ? rowValue : {});
                    }
                };
                return QuestionMatrixDropdownModel;
            }(_question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownModelBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("matrixdropdown", [
                {
                    name: "rows:itemvalue[]",
                    uniqueProperty: "value"
                },
                "rowsVisibleIf:condition",
                "rowTitleWidth",
                {
                    name: "totalText",
                    serializationProperty: "locTotalText"
                },
                "hideIfRowsEmpty:boolean"
            ], function() {
                return new QuestionMatrixDropdownModel("");
            }, "matrixdropdownbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_3__["QuestionFactory"].Instance.registerQuestion("matrixdropdown", function(name) {
                var q = new QuestionMatrixDropdownModel(name);
                q.choices = [
                    1,
                    2,
                    3,
                    4,
                    5
                ];
                q.rows = _questionfactory__WEBPACK_IMPORTED_MODULE_3__["QuestionFactory"].DefaultRows;
                _question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_0__["QuestionMatrixDropdownModelBase"].addDefaultColumns(q);
                return q;
            });
        /***/ },
        /***/ "./src/question_matrixdropdownbase.ts": /*!********************************************!*\
  !*** ./src/question_matrixdropdownbase.ts ***!
  \********************************************/ /*! exports provided: MatrixDropdownCell, MatrixDropdownTotalCell, MatrixDropdownRowModelBase, MatrixDropdownTotalRowModel, QuestionMatrixDropdownModelBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownCell", function() {
                return MatrixDropdownCell;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownTotalCell", function() {
                return MatrixDropdownTotalCell;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownRowModelBase", function() {
                return MatrixDropdownRowModelBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownTotalRowModel", function() {
                return MatrixDropdownTotalRowModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownModelBase", function() {
                return QuestionMatrixDropdownModelBase;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _martixBase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./martixBase */ "./src/martixBase.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /* harmony import */ var _textPreProcessor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./textPreProcessor */ "./src/textPreProcessor.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _functionsfactory__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./functionsfactory */ "./src/functionsfactory.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _question_matrixdropdowncolumn__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./question_matrixdropdowncolumn */ "./src/question_matrixdropdowncolumn.ts");
            /* harmony import */ var _question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./question_matrixdropdownrendered */ "./src/question_matrixdropdownrendered.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var MatrixDropdownCell = /** @class */ function() {
                function MatrixDropdownCell(column, row, data) {
                    this.column = column;
                    this.row = row;
                    this.data = data;
                    this.questionValue = this.createQuestion(column, row, data);
                    this.questionValue.updateCustomWidget();
                    this.updateCellQuestionTitleDueToAccessebility(row);
                }
                MatrixDropdownCell.prototype.updateCellQuestionTitleDueToAccessebility = function(row) {
                    var _this = this;
                    this.questionValue.locTitle.onGetTextCallback = function(str) {
                        if (!row || !row.getSurvey()) return _this.questionValue.title;
                        var rowTitle = row.getAccessbilityText();
                        if (!rowTitle) return _this.questionValue.title;
                        return _this.column.colOwner.getCellAriaLabel(rowTitle, _this.questionValue.title);
                    };
                };
                MatrixDropdownCell.prototype.locStrsChanged = function() {
                    this.question.locStrsChanged();
                };
                MatrixDropdownCell.prototype.createQuestion = function(column, row, data) {
                    var res = data.createQuestion(this.row, this.column);
                    res.validateValueCallback = function() {
                        return data.validateCell(row, column.name, row.value);
                    };
                    _jsonobject__WEBPACK_IMPORTED_MODULE_0__["CustomPropertiesCollection"].getProperties(column.getType()).forEach(function(property) {
                        var propertyName = property.name;
                        if (column[propertyName] !== undefined) res[propertyName] = column[propertyName];
                    });
                    return res;
                };
                Object.defineProperty(MatrixDropdownCell.prototype, "question", {
                    get: function() {
                        return this.questionValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownCell.prototype, "value", {
                    get: function() {
                        return this.question.value;
                    },
                    set: function(value) {
                        this.question.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownCell.prototype.getQuestionWrapperClassName = function(className) {
                    return className;
                };
                MatrixDropdownCell.prototype.runCondition = function(values, properties) {
                    this.question.runCondition(values, properties);
                };
                return MatrixDropdownCell;
            }();
            var MatrixDropdownTotalCell = /** @class */ function(_super) {
                __extends(MatrixDropdownTotalCell, _super);
                function MatrixDropdownTotalCell(column, row, data) {
                    var _this = _super.call(this, column, row, data) || this;
                    _this.column = column;
                    _this.row = row;
                    _this.data = data;
                    _this.updateCellQuestion();
                    return _this;
                }
                MatrixDropdownTotalCell.prototype.createQuestion = function(column, row, data) {
                    var res = _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].createClass("expression");
                    res.setSurveyImpl(row);
                    return res;
                };
                MatrixDropdownTotalCell.prototype.locStrsChanged = function() {
                    this.updateCellQuestion();
                    _super.prototype.locStrsChanged.call(this);
                };
                MatrixDropdownTotalCell.prototype.updateCellQuestion = function() {
                    this.question.locCalculation();
                    this.column.updateCellQuestion(this.question, null, function(json) {
                        delete json["defaultValue"];
                    });
                    this.question.expression = this.getTotalExpression();
                    this.question.format = this.column.totalFormat;
                    this.question.currency = this.column.totalCurrency;
                    this.question.displayStyle = this.column.totalDisplayStyle;
                    this.question.maximumFractionDigits = this.column.totalMaximumFractionDigits;
                    this.question.minimumFractionDigits = this.column.totalMinimumFractionDigits;
                    this.question.unlocCalculation();
                    this.question.runIfReadOnly = true;
                };
                MatrixDropdownTotalCell.prototype.getQuestionWrapperClassName = function(className) {
                    var result = _super.prototype.getQuestionWrapperClassName.call(this, className);
                    if (!result) return result;
                    if (this.question.expression && this.question.expression != "''") result += " " + className + "--expression";
                    var alignment = this.column.totalAlignment;
                    if (alignment === "auto") {
                        if (this.column.cellType === "dropdown") alignment = "left";
                    }
                    return result + " " + className + "--" + alignment;
                };
                MatrixDropdownTotalCell.prototype.getTotalExpression = function() {
                    if (!!this.column.totalExpression) return this.column.totalExpression;
                    if (this.column.totalType == "none") return "''";
                    var funName = this.column.totalType + "InArray";
                    if (!_functionsfactory__WEBPACK_IMPORTED_MODULE_8__["FunctionFactory"].Instance.hasFunction(funName)) return "";
                    return funName + "({self}, '" + this.column.name + "')";
                };
                return MatrixDropdownTotalCell;
            }(MatrixDropdownCell);
            var MatrixDropdownRowTextProcessor = /** @class */ function(_super) {
                __extends(MatrixDropdownRowTextProcessor, _super);
                function MatrixDropdownRowTextProcessor(row, variableName, parentTextProcessor) {
                    var _this = _super.call(this, variableName) || this;
                    _this.row = row;
                    _this.variableName = variableName;
                    _this.parentTextProcessor = parentTextProcessor;
                    return _this;
                }
                MatrixDropdownRowTextProcessor.prototype.getParentTextProcessor = function() {
                    return this.parentTextProcessor;
                };
                Object.defineProperty(MatrixDropdownRowTextProcessor.prototype, "survey", {
                    get: function() {
                        return this.row.getSurvey();
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownRowTextProcessor.prototype.getValues = function() {
                    return this.row.value;
                };
                MatrixDropdownRowTextProcessor.prototype.getQuestionByName = function(name) {
                    return this.row.getQuestionByName(name);
                };
                MatrixDropdownRowTextProcessor.prototype.onCustomProcessText = function(textValue) {
                    if (textValue.name == MatrixDropdownRowModelBase.IndexVariableName) {
                        textValue.isExists = true;
                        textValue.value = this.row.rowIndex;
                        return true;
                    }
                    if (textValue.name == MatrixDropdownRowModelBase.RowValueVariableName) {
                        textValue.isExists = true;
                        textValue.value = this.row.rowName;
                        return true;
                    }
                    return false;
                };
                return MatrixDropdownRowTextProcessor;
            }(_textPreProcessor__WEBPACK_IMPORTED_MODULE_5__["QuestionTextProcessor"]);
            var MatrixDropdownRowModelBase = /** @class */ function() {
                function MatrixDropdownRowModelBase(data, value) {
                    var _this = this;
                    this.isSettingValue = false;
                    this.detailPanelValue = null;
                    this.cells = [];
                    this.isCreatingDetailPanel = false;
                    this.data = data;
                    this.subscribeToChanges(value);
                    this.textPreProcessor = new MatrixDropdownRowTextProcessor(this, MatrixDropdownRowModelBase.RowVariableName, !!data ? data.getParentTextProcessor() : null);
                    this.showHideDetailPanelClick = function() {
                        if (_this.getSurvey().isDesignMode) return true;
                        _this.showHideDetailPanel();
                    };
                    this.idValue = MatrixDropdownRowModelBase.getId();
                }
                MatrixDropdownRowModelBase.getId = function() {
                    return "srow_" + MatrixDropdownRowModelBase.idCounter++;
                };
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "id", {
                    get: function() {
                        return this.idValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "rowName", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "dataName", {
                    get: function() {
                        return this.rowName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "text", {
                    get: function() {
                        return this.rowName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "value", {
                    get: function() {
                        var result = {};
                        var questions = this.questions;
                        for(var i = 0; i < questions.length; i++){
                            var question = questions[i];
                            if (!question.isEmpty()) result[question.getValueName()] = question.value;
                            if (!!question.comment && !!this.getSurvey() && this.getSurvey().storeOthersAsComment) result[question.getValueName() + _base__WEBPACK_IMPORTED_MODULE_3__["Base"].commentSuffix] = question.comment;
                        }
                        return result;
                    },
                    set: function(value) {
                        this.isSettingValue = true;
                        this.subscribeToChanges(value);
                        var questions = this.questions;
                        for(var i = 0; i < questions.length; i++){
                            var question = questions[i];
                            var val1 = this.getCellValue(value, question.getValueName());
                            var oldComment = question.comment;
                            var comment = !!value ? value[question.getValueName() + _base__WEBPACK_IMPORTED_MODULE_3__["Base"].commentSuffix] : "";
                            if (comment == undefined) comment = "";
                            question.updateValueFromSurvey(val1);
                            if (!!comment || this.isTwoValueEquals(oldComment, question.comment)) question.updateCommentFromSurvey(comment);
                            question.onSurveyValueChanged(val1);
                        }
                        this.isSettingValue = false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "locText", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownRowModelBase.prototype.getAccessbilityText = function() {
                    return this.locText && this.locText.renderedHtml;
                };
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "hasPanel", {
                    get: function() {
                        if (!this.data) return false;
                        return this.data.hasDetailPanel(this);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "detailPanel", {
                    get: function() {
                        return this.detailPanelValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "detailPanelId", {
                    get: function() {
                        return !!this.detailPanel ? this.detailPanel.id : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "isDetailPanelShowing", {
                    get: function() {
                        return !!this.data ? this.data.getIsDetailPanelShowing(this) : false;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownRowModelBase.prototype.setIsDetailPanelShowing = function(val1) {
                    if (!val1 && this.detailPanel) this.detailPanel.onHidingContent();
                    if (!!this.data) this.data.setIsDetailPanelShowing(this, val1);
                    if (!!this.onDetailPanelShowingChanged) this.onDetailPanelShowingChanged();
                };
                MatrixDropdownRowModelBase.prototype.showHideDetailPanel = function() {
                    if (this.isDetailPanelShowing) this.hideDetailPanel();
                    else this.showDetailPanel();
                };
                MatrixDropdownRowModelBase.prototype.showDetailPanel = function() {
                    this.ensureDetailPanel();
                    if (!this.detailPanelValue) return;
                    this.setIsDetailPanelShowing(true);
                };
                MatrixDropdownRowModelBase.prototype.hideDetailPanel = function(destroyPanel) {
                    if (destroyPanel === void 0) destroyPanel = false;
                    this.setIsDetailPanelShowing(false);
                    if (destroyPanel) this.detailPanelValue = null;
                };
                MatrixDropdownRowModelBase.prototype.ensureDetailPanel = function() {
                    if (this.isCreatingDetailPanel) return;
                    if (!!this.detailPanelValue || !this.hasPanel || !this.data) return;
                    this.isCreatingDetailPanel = true;
                    this.detailPanelValue = this.data.createRowDetailPanel(this);
                    var questions = this.detailPanelValue.questions;
                    var value = this.data.getRowValue(this.data.getRowIndex(this));
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(value)) for(var i = 0; i < questions.length; i++){
                        var key = questions[i].getValueName();
                        var val1 = !!this.editingObj ? _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].getObjPropertyValue(this.editingObj, key) : value[key];
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(val1)) questions[i].value = val1;
                    }
                    this.detailPanelValue.setSurveyImpl(this);
                    this.isCreatingDetailPanel = false;
                };
                MatrixDropdownRowModelBase.prototype.getAllValues = function() {
                    return this.value;
                };
                MatrixDropdownRowModelBase.prototype.getFilteredValues = function() {
                    var res = this.data ? this.data.getDataFilteredValues() : {};
                    var values = this.validationValues;
                    if (values) for(var key in values)res[key] = values[key];
                    res.row = this.getAllValues();
                    return res;
                };
                MatrixDropdownRowModelBase.prototype.getFilteredProperties = function() {
                    return {
                        survey: this.getSurvey(),
                        row: this
                    };
                };
                MatrixDropdownRowModelBase.prototype.runCondition = function(values, properties) {
                    if (!!this.data) values[MatrixDropdownRowModelBase.OwnerVariableName] = this.data.value;
                    var rowIndex = this.rowIndex;
                    values[MatrixDropdownRowModelBase.IndexVariableName] = rowIndex;
                    values[MatrixDropdownRowModelBase.RowValueVariableName] = this.rowName;
                    var newProps = _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].createCopy(properties);
                    newProps[MatrixDropdownRowModelBase.RowVariableName] = this;
                    var rowValues = rowIndex > 0 ? this.data.getRowValue(this.rowIndex - 1) : this.value;
                    for(var i = 0; i < this.cells.length; i++){
                        if (i > 0) Object(_utils_utils__WEBPACK_IMPORTED_MODULE_14__["mergeValues"])(this.value, rowValues);
                        values[MatrixDropdownRowModelBase.RowVariableName] = rowValues;
                        this.cells[i].runCondition(values, newProps);
                    }
                    if (!!this.detailPanel) this.detailPanel.runCondition(values, newProps);
                };
                MatrixDropdownRowModelBase.prototype.clearValue = function() {
                    var questions = this.questions;
                    for(var i = 0; i < questions.length; i++)questions[i].clearValue();
                };
                MatrixDropdownRowModelBase.prototype.onAnyValueChanged = function(name, questionName) {
                    var questions = this.questions;
                    for(var i = 0; i < questions.length; i++)questions[i].onAnyValueChanged(name, questionName);
                };
                MatrixDropdownRowModelBase.prototype.getDataValueCore = function(valuesHash, key) {
                    var survey = this.getSurvey();
                    if (!!survey) return survey.getDataValueCore(valuesHash, key);
                    else return valuesHash[key];
                };
                MatrixDropdownRowModelBase.prototype.getValue = function(name) {
                    var question = this.getQuestionByName(name);
                    return !!question ? question.value : null;
                };
                MatrixDropdownRowModelBase.prototype.setValue = function(name, newColumnValue) {
                    this.setValueCore(name, newColumnValue, false);
                };
                MatrixDropdownRowModelBase.prototype.getVariable = function(name) {
                    return undefined;
                };
                MatrixDropdownRowModelBase.prototype.setVariable = function(name, newValue) {};
                MatrixDropdownRowModelBase.prototype.getComment = function(name) {
                    var question = this.getQuestionByName(name);
                    return !!question ? question.comment : "";
                };
                MatrixDropdownRowModelBase.prototype.setComment = function(name, newValue, locNotification) {
                    this.setValueCore(name, newValue, true);
                };
                MatrixDropdownRowModelBase.prototype.findQuestionByName = function(name) {
                    if (!name) return undefined;
                    var prefix = MatrixDropdownRowModelBase.RowVariableName + ".";
                    if (name.indexOf(prefix) === 0) return this.getQuestionByName(name.substring(prefix.length));
                    var survey = this.getSurvey();
                    return !!survey ? survey.getQuestionByName(name) : null;
                };
                MatrixDropdownRowModelBase.prototype.setValueCore = function(name, newColumnValue, isComment) {
                    if (this.isSettingValue) return;
                    this.updateQuestionsValue(name, newColumnValue, isComment);
                    var newValue = this.value;
                    var changedName = isComment ? name + _base__WEBPACK_IMPORTED_MODULE_3__["Base"].commentSuffix : name;
                    var changedValue = newColumnValue;
                    var changedQuestion = this.getQuestionByName(name);
                    var changingValue = this.data.onRowChanging(this, changedName, newValue);
                    if (!!changedQuestion && !this.isTwoValueEquals(changingValue, changedValue)) {
                        this.isSettingValue = true;
                        if (isComment) changedQuestion.comment = changingValue;
                        else changedQuestion.value = changingValue;
                        this.isSettingValue = false;
                        newValue = this.value;
                    }
                    if (this.data.isValidateOnValueChanging && this.hasQuestonError(changedQuestion)) return;
                    var isDeleting = newColumnValue == null && !changedQuestion || isComment && !newColumnValue && !!changedQuestion;
                    this.data.onRowChanged(this, changedName, newValue, isDeleting);
                    if (changedName) this.runTriggers(MatrixDropdownTotalRowModel.RowVariableName + "." + changedName, newValue);
                    this.onAnyValueChanged(MatrixDropdownRowModelBase.RowVariableName, "");
                };
                MatrixDropdownRowModelBase.prototype.updateQuestionsValue = function(name, newColumnValue, isComment) {
                    if (!this.detailPanel) return;
                    var colQuestion = this.getQuestionByColumnName(name);
                    var detailQuestion = this.detailPanel.getQuestionByName(name);
                    if (!colQuestion || !detailQuestion) return;
                    var isColQuestion = this.isTwoValueEquals(newColumnValue, isComment ? colQuestion.comment : colQuestion.value);
                    var question = isColQuestion ? detailQuestion : colQuestion;
                    this.isSettingValue = true;
                    if (!isComment) question.value = newColumnValue;
                    else question.comment = newColumnValue;
                    this.isSettingValue = false;
                };
                MatrixDropdownRowModelBase.prototype.runTriggers = function(name, value) {
                    if (!name) return;
                    this.questions.forEach(function(q) {
                        return q.runTriggers(name, value);
                    });
                };
                MatrixDropdownRowModelBase.prototype.hasQuestonError = function(question) {
                    if (!question) return false;
                    if (question.hasErrors(true, {
                        isOnValueChanged: !this.data.isValidateOnValueChanging
                    })) return true;
                    if (question.isEmpty()) return false;
                    var cell = this.getCellByColumnName(question.name);
                    if (!cell || !cell.column || !cell.column.isUnique) return false;
                    return this.data.checkIfValueInRowDuplicated(this, question);
                };
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "isEmpty", {
                    get: function() {
                        var val1 = this.value;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(val1)) return true;
                        for(var key in val1){
                            if (val1[key] !== undefined && val1[key] !== null) return false;
                        }
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownRowModelBase.prototype.getQuestionByColumn = function(column) {
                    var cell = this.getCellByColumn(column);
                    return !!cell ? cell.question : null;
                };
                MatrixDropdownRowModelBase.prototype.getCellByColumn = function(column) {
                    for(var i = 0; i < this.cells.length; i++){
                        if (this.cells[i].column == column) return this.cells[i];
                    }
                    return null;
                };
                MatrixDropdownRowModelBase.prototype.getCellByColumnName = function(columnName) {
                    for(var i = 0; i < this.cells.length; i++){
                        if (this.cells[i].column.name == columnName) return this.cells[i];
                    }
                    return null;
                };
                MatrixDropdownRowModelBase.prototype.getQuestionByColumnName = function(columnName) {
                    var cell = this.getCellByColumnName(columnName);
                    return !!cell ? cell.question : null;
                };
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "questions", {
                    get: function() {
                        var res = [];
                        for(var i = 0; i < this.cells.length; i++)res.push(this.cells[i].question);
                        var detailQuestions = !!this.detailPanel ? this.detailPanel.questions : [];
                        for(var i = 0; i < detailQuestions.length; i++)res.push(detailQuestions[i]);
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownRowModelBase.prototype.getQuestionByName = function(name) {
                    var res = this.getQuestionByColumnName(name);
                    if (!!res) return res;
                    return !!this.detailPanel ? this.detailPanel.getQuestionByName(name) : null;
                };
                MatrixDropdownRowModelBase.prototype.getQuestionsByName = function(name) {
                    var res = [];
                    var q = this.getQuestionByColumnName(name);
                    if (!!q) res.push(q);
                    if (!!this.detailPanel) {
                        q = this.detailPanel.getQuestionByName(name);
                        if (!!q) res.push(q);
                    }
                    return res;
                };
                MatrixDropdownRowModelBase.prototype.getSharedQuestionByName = function(columnName) {
                    return !!this.data ? this.data.getSharedQuestionByName(columnName, this) : null;
                };
                MatrixDropdownRowModelBase.prototype.clearIncorrectValues = function(val1) {
                    for(var key in val1){
                        var question = this.getQuestionByName(key);
                        if (question) {
                            var qVal = question.value;
                            question.clearIncorrectValues();
                            if (!this.isTwoValueEquals(qVal, question.value)) this.setValue(key, question.value);
                        } else if (!this.getSharedQuestionByName(key) && key.indexOf(_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].matrix.totalsSuffix) < 0) this.setValue(key, null);
                    }
                };
                MatrixDropdownRowModelBase.prototype.getLocale = function() {
                    return this.data ? this.data.getLocale() : "";
                };
                MatrixDropdownRowModelBase.prototype.getMarkdownHtml = function(text, name) {
                    return this.data ? this.data.getMarkdownHtml(text, name) : undefined;
                };
                MatrixDropdownRowModelBase.prototype.getRenderer = function(name) {
                    return this.data ? this.data.getRenderer(name) : null;
                };
                MatrixDropdownRowModelBase.prototype.getRendererContext = function(locStr) {
                    return this.data ? this.data.getRendererContext(locStr) : locStr;
                };
                MatrixDropdownRowModelBase.prototype.getProcessedText = function(text) {
                    return this.data ? this.data.getProcessedText(text) : text;
                };
                MatrixDropdownRowModelBase.prototype.locStrsChanged = function() {
                    for(var i = 0; i < this.cells.length; i++)this.cells[i].locStrsChanged();
                    if (!!this.detailPanel) this.detailPanel.locStrsChanged();
                };
                MatrixDropdownRowModelBase.prototype.updateCellQuestionOnColumnChanged = function(column, name, newValue) {
                    var cell = this.getCellByColumn(column);
                    if (!cell) return;
                    this.updateCellOnColumnChanged(cell, name, newValue);
                };
                MatrixDropdownRowModelBase.prototype.updateCellQuestionOnColumnItemValueChanged = function(column, propertyName, obj, name, newValue, oldValue) {
                    var cell = this.getCellByColumn(column);
                    if (!cell) return;
                    this.updateCellOnColumnItemValueChanged(cell, propertyName, obj, name, newValue, oldValue);
                };
                MatrixDropdownRowModelBase.prototype.onQuestionReadOnlyChanged = function(parentIsReadOnly) {
                    var questions = this.questions;
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        q.setPropertyValue("isReadOnly", q.isReadOnly);
                    }
                    if (!!this.detailPanel) this.detailPanel.readOnly = parentIsReadOnly;
                };
                MatrixDropdownRowModelBase.prototype.hasErrors = function(fireCallback, rec, raiseOnCompletedAsyncValidators) {
                    var res = false;
                    var cells = this.cells;
                    if (!cells) return res;
                    this.validationValues = rec.validationValues;
                    for(var colIndex = 0; colIndex < cells.length; colIndex++){
                        if (!cells[colIndex]) continue;
                        var question = cells[colIndex].question;
                        if (!question || !question.visible) continue;
                        question.onCompletedAsyncValidators = function(hasErrors) {
                            raiseOnCompletedAsyncValidators();
                        };
                        if (!!rec && rec.isOnValueChanged === true && question.isEmpty()) continue;
                        res = question.hasErrors(fireCallback, rec) || res;
                    }
                    if (this.hasPanel) {
                        this.ensureDetailPanel();
                        var panelHasError = this.detailPanel.hasErrors(fireCallback, false, rec);
                        if (!rec.hideErroredPanel && panelHasError && fireCallback) {
                            if (rec.isSingleDetailPanel) rec.hideErroredPanel = true;
                            this.showDetailPanel();
                        }
                        res = panelHasError || res;
                    }
                    this.validationValues = undefined;
                    return res;
                };
                MatrixDropdownRowModelBase.prototype.updateCellOnColumnChanged = function(cell, name, newValue) {
                    cell.question[name] = newValue;
                };
                MatrixDropdownRowModelBase.prototype.updateCellOnColumnItemValueChanged = function(cell, propertyName, obj, name, newValue, oldValue) {
                    var items = cell.question[propertyName];
                    if (!Array.isArray(items)) return;
                    var val1 = name === "value" ? oldValue : obj["value"];
                    var item = _itemvalue__WEBPACK_IMPORTED_MODULE_6__["ItemValue"].getItemByValue(items, val1);
                    if (!item) return;
                    item[name] = newValue;
                };
                MatrixDropdownRowModelBase.prototype.buildCells = function(value) {
                    this.isSettingValue = true;
                    var columns = this.data.columns;
                    for(var i = 0; i < columns.length; i++){
                        var column = columns[i];
                        var cell = this.createCell(column);
                        this.cells.push(cell);
                        var cellValue = this.getCellValue(value, column.name);
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(cellValue)) {
                            cell.question.value = cellValue;
                            var commentKey = column.name + _base__WEBPACK_IMPORTED_MODULE_3__["Base"].commentSuffix;
                            if (!!value && !_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(value[commentKey])) cell.question.comment = value[commentKey];
                        }
                    }
                    this.isSettingValue = false;
                };
                MatrixDropdownRowModelBase.prototype.isTwoValueEquals = function(val1, val2) {
                    return _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(val1, val2, false, true, false);
                };
                MatrixDropdownRowModelBase.prototype.getCellValue = function(value, name) {
                    if (!!this.editingObj) return _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].getObjPropertyValue(this.editingObj, name);
                    return !!value ? value[name] : undefined;
                };
                MatrixDropdownRowModelBase.prototype.createCell = function(column) {
                    return new MatrixDropdownCell(column, this, this.data);
                };
                MatrixDropdownRowModelBase.prototype.getSurveyData = function() {
                    return this;
                };
                MatrixDropdownRowModelBase.prototype.getSurvey = function() {
                    return this.data ? this.data.getSurvey() : null;
                };
                MatrixDropdownRowModelBase.prototype.getTextProcessor = function() {
                    return this.textPreProcessor;
                };
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "rowIndex", {
                    get: function() {
                        return !!this.data ? this.data.getRowIndex(this) + 1 : -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownRowModelBase.prototype, "editingObj", {
                    get: function() {
                        return this.editingObjValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownRowModelBase.prototype.dispose = function() {
                    if (!!this.editingObj) {
                        this.editingObj.onPropertyChanged.remove(this.onEditingObjPropertyChanged);
                        this.editingObjValue = null;
                    }
                };
                MatrixDropdownRowModelBase.prototype.subscribeToChanges = function(value) {
                    var _this = this;
                    if (!value || !value.getType || !value.onPropertyChanged) return;
                    if (value === this.editingObj) return;
                    this.editingObjValue = value;
                    this.onEditingObjPropertyChanged = function(sender, options) {
                        _this.updateOnSetValue(options.name, options.newValue);
                    };
                    this.editingObj.onPropertyChanged.add(this.onEditingObjPropertyChanged);
                };
                MatrixDropdownRowModelBase.prototype.updateOnSetValue = function(name, newValue) {
                    this.isSettingValue = true;
                    var questions = this.getQuestionsByName(name);
                    for(var i = 0; i < questions.length; i++)questions[i].value = newValue;
                    this.isSettingValue = false;
                };
                MatrixDropdownRowModelBase.RowVariableName = "row";
                MatrixDropdownRowModelBase.OwnerVariableName = "self";
                MatrixDropdownRowModelBase.IndexVariableName = "rowIndex";
                MatrixDropdownRowModelBase.RowValueVariableName = "rowValue";
                MatrixDropdownRowModelBase.idCounter = 1;
                return MatrixDropdownRowModelBase;
            }();
            var MatrixDropdownTotalRowModel = /** @class */ function(_super) {
                __extends(MatrixDropdownTotalRowModel, _super);
                function MatrixDropdownTotalRowModel(data) {
                    var _this = _super.call(this, data, null) || this;
                    _this.buildCells(null);
                    return _this;
                }
                MatrixDropdownTotalRowModel.prototype.createCell = function(column) {
                    return new MatrixDropdownTotalCell(column, this, this.data);
                };
                MatrixDropdownTotalRowModel.prototype.setValue = function(name, newValue) {
                    if (!!this.data && !this.isSettingValue) this.data.onTotalValueChanged();
                };
                MatrixDropdownTotalRowModel.prototype.runCondition = function(values, properties) {
                    var counter = 0;
                    var prevValue;
                    do {
                        prevValue = _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].getUnbindValue(this.value);
                        _super.prototype.runCondition.call(this, values, properties);
                        counter++;
                    }while (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(prevValue, this.value) && counter < 3);
                };
                MatrixDropdownTotalRowModel.prototype.updateCellOnColumnChanged = function(cell, name, newValue) {
                    cell.updateCellQuestion();
                };
                return MatrixDropdownTotalRowModel;
            }(MatrixDropdownRowModelBase);
            /**
 * A base class for the [QuestionMatrixDropdownModel](https://surveyjs.io/form-library/documentation/questionmatrixdropdownmodel) and [QuestionMatrixDynamicModel](https://surveyjs.io/form-library/documentation/questionmatrixdynamicmodel) classes.
 */ var QuestionMatrixDropdownModelBase = /** @class */ function(_super) {
                __extends(QuestionMatrixDropdownModelBase, _super);
                function QuestionMatrixDropdownModelBase(name) {
                    var _this = _super.call(this, name) || this;
                    _this.isRowChanging = false;
                    _this.lockResetRenderedTable = false;
                    _this.isDoingonAnyValueChanged = false;
                    _this.createItemValues("choices");
                    _this.createLocalizableString("placeholder", _this, false, true);
                    _this.createLocalizableString("keyDuplicationError", _this, false, true);
                    _this.detailPanelValue = _this.createNewDetailPanel();
                    _this.detailPanel.selectedElementInDesign = _this;
                    _this.detailPanel.renderWidth = "100%";
                    _this.detailPanel.isInteractiveDesignElement = false;
                    _this.detailPanel.showTitle = false;
                    _this.registerPropertyChangedHandlers([
                        "columns",
                        "cellType"
                    ], function() {
                        _this.updateColumnsAndRows();
                    });
                    _this.registerPropertyChangedHandlers([
                        "placeholder",
                        "columnColCount",
                        "rowTitleWidth",
                        "choices"
                    ], function() {
                        _this.clearRowsAndResetRenderedTable();
                    });
                    _this.registerPropertyChangedHandlers([
                        "transposeData",
                        "addRowLocation",
                        "hideColumnsIfEmpty",
                        "showHeader",
                        "minRowCount",
                        "isReadOnly",
                        "rowCount",
                        "hasFooter",
                        "detailPanelMode"
                    ], function() {
                        _this.resetRenderedTable();
                    });
                    _this.registerPropertyChangedHandlers([
                        "isMobile"
                    ], function() {
                        _this.resetRenderedTable();
                    });
                    return _this;
                }
                Object.defineProperty(QuestionMatrixDropdownModelBase, "defaultCellType", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].matrix.defaultCellType;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].matrix.defaultCellType = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.addDefaultColumns = function(matrix) {
                    var colNames = _questionfactory__WEBPACK_IMPORTED_MODULE_7__["QuestionFactory"].DefaultColums;
                    for(var i = 0; i < colNames.length; i++)matrix.addColumn(colNames[i]);
                };
                QuestionMatrixDropdownModelBase.prototype.createColumnValues = function() {
                    var _this = this;
                    return this.createNewArray("columns", function(item) {
                        item.colOwner = _this;
                        if (_this.onAddColumn) _this.onAddColumn(item);
                        if (_this.survey) _this.survey.matrixColumnAdded(_this, item);
                    }, function(item) {
                        item.colOwner = null;
                        if (_this.onRemoveColumn) _this.onRemoveColumn(item);
                    });
                };
                QuestionMatrixDropdownModelBase.prototype.getType = function() {
                    return "matrixdropdownbase";
                };
                QuestionMatrixDropdownModelBase.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.clearGeneratedRows();
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "hasSingleInput", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "isContainer", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "isRowsDynamic", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "isUpdateLocked", {
                    get: function() {
                        return this.isLoadingFromJson || this.isUpdating;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.beginUpdate = function() {
                    this.isUpdating = true;
                };
                QuestionMatrixDropdownModelBase.prototype.endUpdate = function() {
                    this.isUpdating = false;
                    this.updateColumnsAndRows();
                };
                QuestionMatrixDropdownModelBase.prototype.updateColumnsAndRows = function() {
                    this.updateColumnsIndexes(this.columns);
                    this.updateColumnsCellType();
                    this.generatedTotalRow = null;
                    this.clearRowsAndResetRenderedTable();
                };
                QuestionMatrixDropdownModelBase.prototype.itemValuePropertyChanged = function(item, name, oldValue, newValue) {
                    _super.prototype.itemValuePropertyChanged.call(this, item, name, oldValue, newValue);
                    if (item.ownerPropertyName === "choices") this.clearRowsAndResetRenderedTable();
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "transposeData", {
                    /**
         * Specifies whether to display [`columns`](#columns) as rows and [`rows`](#rows) as columns.
         *
         * Default value: `false`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/transpose-dynamic-rows-to-columns-in-matrix/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("transposeData");
                    },
                    set: function(val1) {
                        this.setPropertyValue("transposeData", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "columnLayout", {
                    /**
         * This property is obsolete. Use the [`transposeData`](#transposeData) property instead.
         */ get: function() {
                        return this.transposeData ? "vertical" : "horizontal";
                    },
                    set: function(val1) {
                        this.transposeData = val1 === "vertical";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "columnsLocation", {
                    get: function() {
                        return this.columnLayout;
                    },
                    set: function(val1) {
                        this.columnLayout = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "detailErrorLocation", {
                    /**
         * Specifies the error message position for questions within detail sections.
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the [`errorLocation`](#errorLocation) property.
         * - `"top"` - Displays error messages above questions.
         * - `"bottom"` - Displays error messages below questions.
         * @see cellErrorLocation
         */ get: function() {
                        return this.getPropertyValue("detailErrorLocation");
                    },
                    set: function(value) {
                        this.setPropertyValue("detailErrorLocation", value.toLowerCase());
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "cellErrorLocation", {
                    /**
         * Specifies the error message position relative to matrix cells.
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the [`errorLocation`](#errorLocation) property.
         * - `"top"` - Displays error messages above matrix cells.
         * - `"bottom"` - Displays error messages below matrix cells.
         * @see detailErrorLocation
         */ get: function() {
                        return this.getPropertyValue("cellErrorLocation");
                    },
                    set: function(value) {
                        this.setPropertyValue("cellErrorLocation", value.toLowerCase());
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getChildErrorLocation = function(child) {
                    var errLocation = !!child.parent ? this.detailErrorLocation : this.cellErrorLocation;
                    if (errLocation !== "default") return errLocation;
                    return _super.prototype.getChildErrorLocation.call(this, child);
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "isColumnLayoutHorizontal", {
                    /**
         * Returns `true` if [`columns`](#columns) are placed in the horizontal direction and [`rows`](#columns) in the vertical direction.
         *
         * To specify the layout, use the [`transposeData`](#transposeData) property. If you set it to `true`, the survey applies it only when the screen has enough space. Otherwise, the survey falls back to the original layout, but the `transposeData` property remains set to `true`. Unlike `transposeData`, the `isColumnLayoutHorizontal` property always indicates the current layout.
         * @see transposeData
         */ get: function() {
                        return this.isMobile ? true : !this.transposeData;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "isUniqueCaseSensitive", {
                    /**
         * Enables case-sensitive comparison in columns with the `isUnique` property set to `true`.
         *
         * When this property is `true`, `"ABC"` and `"abc"` are considered different values.
         *
         * Default value: `false`
         * @see keyDuplicationError
         */ get: function() {
                        return this.isUniqueCaseSensitiveValue !== undefined ? this.isUniqueCaseSensitiveValue : _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].comparator.caseSensitive;
                    },
                    set: function(val1) {
                        this.isUniqueCaseSensitiveValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "detailPanelMode", {
                    /**
         * Specifies the location of detail sections.
         *
         * Possible values:
         *
         * - `"underRow"` - Displays detail sections under their respective rows. Users can expand any number of detail sections.
         * - `"underRowSingle"` - Displays detail sections under their respective rows, but only one detail section can be expanded at a time.
         * - `"none"` (default) - Hides detail sections.
         *
         * Use the `detailElements` property to specify content of detail sections.
         * @see detailElements
         * @see detailPanel
         */ get: function() {
                        return this.getPropertyValue("detailPanelMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("detailPanelMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "detailPanel", {
                    /**
         * Contains a [`PanelModel`](https://surveyjs.io/form-library/documentation/panelmodel) instance that represents a detail section template.
         * @see detailElements
         * @see detailPanelMode
         */ get: function() {
                        return this.detailPanelValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getPanel = function() {
                    return this.detailPanel;
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "detailElements", {
                    /**
         * An array of survey elements (questions and panels) to be displayed in detail sections.
         *
         * Detail sections are expandable panels displayed under each matrix row. You can use them to display questions that do not fit into the row.
         *
         * Set the `detailPanelMode` property to `"underRow"` or `"underRowSingle"` to display detail sections.
         * @see detailPanelMode
         * @see detailPanel
         */ get: function() {
                        return this.detailPanel.elements;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.createNewDetailPanel = function() {
                    return _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].createClass("panel");
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "hasRowText", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getFooterText = function() {
                    return null;
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "canAddRow", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "canRemoveRows", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.canRemoveRow = function(row) {
                    return true;
                };
                QuestionMatrixDropdownModelBase.prototype.onPointerDown = function(pointerDownEvent, row) {};
                QuestionMatrixDropdownModelBase.prototype.onRowsChanged = function() {
                    this.resetRenderedTable();
                    _super.prototype.onRowsChanged.call(this);
                };
                QuestionMatrixDropdownModelBase.prototype.onStartRowAddingRemoving = function() {
                    this.lockResetRenderedTable = true;
                    this.setValueChangedDirectly(true);
                };
                QuestionMatrixDropdownModelBase.prototype.onEndRowAdding = function() {
                    this.lockResetRenderedTable = false;
                    if (!this.renderedTable) return;
                    if (this.renderedTable.isRequireReset()) this.resetRenderedTable();
                    else {
                        var index = this.visibleRows.length - 1;
                        this.renderedTable.onAddedRow(this.visibleRows[index], index);
                    }
                };
                QuestionMatrixDropdownModelBase.prototype.onEndRowRemoving = function(row) {
                    this.lockResetRenderedTable = false;
                    if (this.renderedTable.isRequireReset()) this.resetRenderedTable();
                    else if (!!row) this.renderedTable.onRemovedRow(row);
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "renderedTableValue", {
                    get: function() {
                        return this.getPropertyValue("renderedTable", null);
                    },
                    set: function(val1) {
                        this.setPropertyValue("renderedTable", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.clearRowsAndResetRenderedTable = function() {
                    this.clearGeneratedRows();
                    this.resetRenderedTable();
                    this.fireCallback(this.columnsChangedCallback);
                };
                //For internal use
                QuestionMatrixDropdownModelBase.prototype.resetRenderedTable = function() {
                    if (this.lockResetRenderedTable || this.isUpdateLocked) return;
                    this.renderedTableValue = null;
                    this.fireCallback(this.onRenderedTableResetCallback);
                };
                QuestionMatrixDropdownModelBase.prototype.clearGeneratedRows = function() {
                    if (!this.generatedVisibleRows) return;
                    for(var i = 0; i < this.generatedVisibleRows.length; i++)this.generatedVisibleRows[i].dispose();
                    _super.prototype.clearGeneratedRows.call(this);
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "isRendredTableCreated", {
                    get: function() {
                        return !!this.renderedTableValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "renderedTable", {
                    get: function() {
                        if (!this.renderedTableValue) {
                            this.renderedTableValue = this.createRenderedTable();
                            if (!!this.onRenderedTableCreatedCallback) this.onRenderedTableCreatedCallback(this.renderedTableValue);
                        }
                        return this.renderedTableValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.createRenderedTable = function() {
                    return new _question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_13__["QuestionMatrixDropdownRenderedTable"](this);
                };
                QuestionMatrixDropdownModelBase.prototype.onMatrixRowCreated = function(row) {
                    if (!this.survey) return;
                    var options = {
                        rowValue: row.value,
                        row: row,
                        column: null,
                        columnName: null,
                        cell: null,
                        cellQuestion: null,
                        value: null
                    };
                    for(var i = 0; i < this.visibleColumns.length; i++){
                        options.column = this.visibleColumns[i];
                        options.columnName = options.column.name;
                        var cell = row.cells[i];
                        options.cell = cell;
                        options.cellQuestion = cell.question;
                        options.value = cell.value;
                        if (!!this.onCellCreatedCallback) this.onCellCreatedCallback(options);
                        this.survey.matrixCellCreated(this, options);
                    }
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "cellType", {
                    /**
         * Specifies the type of matrix cells. You can override this property for individual columns.
         *
         * Possible values:
         *
         * - [`"dropdown"`](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model)
         * - [`"checkbox"`](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model)
         * - [`"radiogroup"`](https://surveyjs.io/form-library/documentation/api-reference/radio-button-question-model)
         * - [`"tagbox"`](https://surveyjs.io/form-library/documentation/api-reference/dropdown-tag-box-model)
         * - [`"text"`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model)
         * - [`"comment"`](https://surveyjs.io/form-library/documentation/api-reference/comment-field-model)
         * - [`"boolean"`](https://surveyjs.io/form-library/documentation/api-reference/boolean-question-model)
         * - [`"expression"`](https://surveyjs.io/form-library/documentation/api-reference/expression-model)
         * - [`"rating"`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model)
         *
         * Default value: `"dropdown"` (inherited from [`settings.matrix.defaultCellType`](https://surveyjs.io/form-library/documentation/settings#matrixDefaultCellType))
         */ get: function() {
                        return this.getPropertyValue("cellType", _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].matrix.defaultCellType);
                    },
                    set: function(val1) {
                        val1 = val1.toLowerCase();
                        this.setPropertyValue("cellType", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.updateColumnsCellType = function() {
                    for(var i = 0; i < this.columns.length; i++)this.columns[i].defaultCellTypeChanged();
                };
                QuestionMatrixDropdownModelBase.prototype.updateColumnsIndexes = function(cols) {
                    for(var i = 0; i < cols.length; i++)cols[i].setIndex(i);
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "columnColCount", {
                    /**
         * Specifies the number of columns in Radiogroup and Checkbox cells.
         *
         * Default value: 0 (the number of columns is selected automatically based on the available column width)
         * @see cellType
         */ get: function() {
                        return this.getPropertyValue("columnColCount");
                    },
                    set: function(value) {
                        if (value < 0 || value > 4) return;
                        this.setPropertyValue("columnColCount", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "horizontalScroll", {
                    get: function() {
                        return this.getPropertyValue("horizontalScroll");
                    },
                    set: function(val1) {
                        this.setPropertyValue("horizontalScroll", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "allowAdaptiveActions", {
                    get: function() {
                        return this.getPropertyValue("allowAdaptiveActions");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowAdaptiveActions", val1);
                        if (!!this.detailPanel) this.detailPanel.allowAdaptiveActions = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getRequiredText = function() {
                    return this.survey ? this.survey.requiredText : "";
                };
                QuestionMatrixDropdownModelBase.prototype.hasChoices = function() {
                    return this.choices.length > 0;
                };
                QuestionMatrixDropdownModelBase.prototype.onColumnPropertyChanged = function(column, name, newValue) {
                    this.updateHasFooter();
                    if (!this.generatedVisibleRows) return;
                    for(var i = 0; i < this.generatedVisibleRows.length; i++)this.generatedVisibleRows[i].updateCellQuestionOnColumnChanged(column, name, newValue);
                    if (!!this.generatedTotalRow) this.generatedTotalRow.updateCellQuestionOnColumnChanged(column, name, newValue);
                    this.onColumnsChanged();
                    if (name == "isRequired") this.resetRenderedTable();
                };
                QuestionMatrixDropdownModelBase.prototype.onColumnItemValuePropertyChanged = function(column, propertyName, obj, name, newValue, oldValue) {
                    if (!this.generatedVisibleRows) return;
                    for(var i = 0; i < this.generatedVisibleRows.length; i++)this.generatedVisibleRows[i].updateCellQuestionOnColumnItemValueChanged(column, propertyName, obj, name, newValue, oldValue);
                };
                QuestionMatrixDropdownModelBase.prototype.onShowInMultipleColumnsChanged = function(column) {
                    this.resetTableAndRows();
                };
                QuestionMatrixDropdownModelBase.prototype.onColumnVisibilityChanged = function(column) {
                    this.resetTableAndRows();
                };
                QuestionMatrixDropdownModelBase.prototype.onColumnCellTypeChanged = function(column) {
                    this.resetTableAndRows();
                };
                QuestionMatrixDropdownModelBase.prototype.resetTableAndRows = function() {
                    this.clearGeneratedRows();
                    this.resetRenderedTable();
                };
                QuestionMatrixDropdownModelBase.prototype.getRowTitleWidth = function() {
                    return "";
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "hasFooter", {
                    get: function() {
                        return this.getPropertyValue("hasFooter", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getAddRowLocation = function() {
                    return "default";
                };
                QuestionMatrixDropdownModelBase.prototype.getShowColumnsIfEmpty = function() {
                    return false;
                };
                QuestionMatrixDropdownModelBase.prototype.updateShowTableAndAddRow = function() {
                    if (!!this.renderedTable) this.renderedTable.updateShowTableAndAddRow();
                };
                QuestionMatrixDropdownModelBase.prototype.updateHasFooter = function() {
                    this.setPropertyValue("hasFooter", this.hasTotal);
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "hasTotal", {
                    get: function() {
                        for(var i = 0; i < this.columns.length; i++){
                            if (this.columns[i].hasTotal) return true;
                        }
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getCellType = function() {
                    return this.cellType;
                };
                QuestionMatrixDropdownModelBase.prototype.getCustomCellType = function(column, row, cellType) {
                    if (!this.survey) return cellType;
                    var options = {
                        rowValue: row.value,
                        row: row,
                        column: column,
                        columnName: column.name,
                        cellType: cellType
                    };
                    this.survey.matrixCellCreating(this, options);
                    return options.cellType;
                };
                QuestionMatrixDropdownModelBase.prototype.getConditionJson = function(operator, path) {
                    if (operator === void 0) operator = null;
                    if (path === void 0) path = null;
                    if (!path) return _super.prototype.getConditionJson.call(this);
                    var columnName = "";
                    for(var i = path.length - 1; i >= 0; i--){
                        if (path[i] == ".") break;
                        columnName = path[i] + columnName;
                    }
                    var column = this.getColumnByName(columnName);
                    if (!column) return null;
                    var question = column.createCellQuestion(null);
                    if (!question) return null;
                    return question.getConditionJson(operator);
                };
                QuestionMatrixDropdownModelBase.prototype.clearIncorrectValues = function() {
                    var rows = this.visibleRows;
                    if (!rows) return;
                    for(var i = 0; i < rows.length; i++)rows[i].clearIncorrectValues(this.getRowValue(i));
                };
                QuestionMatrixDropdownModelBase.prototype.clearErrors = function() {
                    _super.prototype.clearErrors.call(this);
                    this.runFuncForCellQuestions(function(q) {
                        q.clearErrors();
                    });
                };
                QuestionMatrixDropdownModelBase.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    this.runFuncForCellQuestions(function(q) {
                        q.localeChanged();
                    });
                };
                QuestionMatrixDropdownModelBase.prototype.runFuncForCellQuestions = function(func) {
                    if (!!this.generatedVisibleRows) for(var i = 0; i < this.generatedVisibleRows.length; i++){
                        var row = this.generatedVisibleRows[i];
                        for(var j = 0; j < row.cells.length; j++)func(row.cells[j].question);
                    }
                };
                QuestionMatrixDropdownModelBase.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    var counter = 0;
                    var prevTotalValue;
                    do {
                        prevTotalValue = _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].getUnbindValue(this.totalValue);
                        this.runCellsCondition(values, properties);
                        this.runTotalsCondition(values, properties);
                        counter++;
                    }while (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(prevTotalValue, this.totalValue) && counter < 3);
                };
                QuestionMatrixDropdownModelBase.prototype.runTriggers = function(name, value) {
                    _super.prototype.runTriggers.call(this, name, value);
                    this.runFuncForCellQuestions(function(q) {
                        q.runTriggers(name, value);
                    });
                };
                QuestionMatrixDropdownModelBase.prototype.shouldRunColumnExpression = function() {
                    return false;
                };
                QuestionMatrixDropdownModelBase.prototype.runCellsCondition = function(values, properties) {
                    if (!this.generatedVisibleRows) return;
                    var newValues = this.getRowConditionValues(values);
                    var rows = this.generatedVisibleRows;
                    for(var i = 0; i < rows.length; i++)rows[i].runCondition(newValues, properties);
                    this.checkColumnsVisibility();
                    this.checkColumnsRenderedRequired();
                };
                QuestionMatrixDropdownModelBase.prototype.checkColumnsVisibility = function() {
                    if (this.isDesignMode) return;
                    var hasChanged = false;
                    for(var i = 0; i < this.visibleColumns.length; i++){
                        var column = this.visibleColumns[i];
                        if (!column.visibleIf && !column.isFilteredMultipleColumns) continue;
                        hasChanged = this.isColumnVisibilityChanged(column) || hasChanged;
                    }
                    if (hasChanged) this.resetRenderedTable();
                };
                QuestionMatrixDropdownModelBase.prototype.checkColumnsRenderedRequired = function() {
                    var rows = this.generatedVisibleRows;
                    for(var i = 0; i < this.visibleColumns.length; i++){
                        var column = this.visibleColumns[i];
                        if (!column.requiredIf) continue;
                        var required = rows.length > 0;
                        for(var j = 0; j < rows.length; j++)if (!rows[j].cells[i].question.isRequired) {
                            required = false;
                            break;
                        }
                        column.updateIsRenderedRequired(required);
                    }
                };
                QuestionMatrixDropdownModelBase.prototype.isColumnVisibilityChanged = function(column) {
                    var curVis = column.isColumnVisible;
                    var isMultipleColumnsVisibility = column.isFilteredMultipleColumns;
                    var curVisibleChoices = isMultipleColumnsVisibility ? column.getVisibleChoicesInCell : [];
                    var newVisibleChoices = new Array();
                    var hasVisCell = false;
                    var rows = this.generatedVisibleRows;
                    for(var i = 0; i < rows.length; i++){
                        var cell = rows[i].cells[column.index];
                        var q = cell === null || cell === void 0 ? void 0 : cell.question;
                        if (!!q && q.isVisible) {
                            hasVisCell = true;
                            if (isMultipleColumnsVisibility) this.updateNewVisibleChoices(q, newVisibleChoices);
                            else break;
                        }
                    }
                    column.hasVisibleCell = hasVisCell;
                    if (isMultipleColumnsVisibility) {
                        column.setVisibleChoicesInCell(newVisibleChoices);
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isArraysEqual(curVisibleChoices, newVisibleChoices, true, false, false)) return true;
                    }
                    return curVis !== column.isColumnVisible;
                };
                QuestionMatrixDropdownModelBase.prototype.updateNewVisibleChoices = function(q, dest) {
                    var choices = q.visibleChoices;
                    if (!Array.isArray(choices)) return;
                    for(var i = 0; i < choices.length; i++){
                        var ch = choices[i];
                        if (dest.indexOf(ch.value) < 0) dest.push(ch.value);
                    }
                };
                QuestionMatrixDropdownModelBase.prototype.runTotalsCondition = function(values, properties) {
                    if (!this.generatedTotalRow) return;
                    this.generatedTotalRow.runCondition(this.getRowConditionValues(values), properties);
                };
                QuestionMatrixDropdownModelBase.prototype.getRowConditionValues = function(values) {
                    var newValues = values;
                    if (!newValues) newValues = {};
                    /*
        var newValues: { [index: string]: any } = {};
        if (values && values instanceof Object) {
          newValues = JSON.parse(JSON.stringify(values));
        }
        */ var totalRow = {};
                    if (!this.isValueEmpty(this.totalValue)) totalRow = JSON.parse(JSON.stringify(this.totalValue));
                    newValues["row"] = {};
                    newValues["totalRow"] = totalRow;
                    return newValues;
                };
                QuestionMatrixDropdownModelBase.prototype.IsMultiplyColumn = function(column) {
                    return column.isShowInMultipleColumns && !this.isMobile;
                };
                QuestionMatrixDropdownModelBase.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    var columns = this.columns;
                    for(var i = 0; i < columns.length; i++)columns[i].locStrsChanged();
                    var rows = this.generatedVisibleRows;
                    if (!rows) return;
                    for(var i = 0; i < rows.length; i++)rows[i].locStrsChanged();
                    if (!!this.generatedTotalRow) this.generatedTotalRow.locStrsChanged();
                };
                /**
     * Returns a matrix column with a given `name` or `null` if a column with this is not found.
     * @param columnName A column name.
     */ QuestionMatrixDropdownModelBase.prototype.getColumnByName = function(columnName) {
                    for(var i = 0; i < this.columns.length; i++){
                        if (this.columns[i].name == columnName) return this.columns[i];
                    }
                    return null;
                };
                QuestionMatrixDropdownModelBase.prototype.getColumnName = function(columnName) {
                    return this.getColumnByName(columnName);
                };
                QuestionMatrixDropdownModelBase.prototype.getColumnWidth = function(column) {
                    var _a;
                    return column.minWidth ? column.minWidth : this.columnMinWidth ? this.columnMinWidth : ((_a = _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].matrix.columnWidthsByType[column.cellType]) === null || _a === void 0 ? void 0 : _a.minWidth) || "";
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "choices", {
                    /**
         * Gets or sets choice items for Dropdown, Checkbox, and Radiogroup matrix cells. You can override this property for individual columns.
         *
         * This property accepts an array of objects with the following structure:
         *
         * ```js
         * {
         *   "value": any, // A value to be saved in survey results
         *   "text": String, // A display text. This property supports Markdown. When `text` is undefined, `value` is used.
         *   "customProperty": any // Any property that you find useful.
         * }
         * ```
         *
         * To enable Markdown support for the `text` property, implement Markdown-to-HTML conversion in the [onTextMarkdown](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onTextMarkdown) event handler. For an example, refer to the following demo: [Convert Markdown to HTML with Showdown](https://surveyjs.io/form-library/examples/edit-survey-questions-markdown/).
         *
         * If you add custom properties, refer to the following help topic to learn how to serialize them into JSON: [Add Custom Properties to Property Grid](https://surveyjs.io/survey-creator/documentation/property-grid#add-custom-properties-to-the-property-grid).
         *
         * If you need to specify only the `value` property, you can set the `choices` property to an array of primitive values, for example, `[ "item1", "item2", "item3" ]`. These values are both saved in survey results and used as display text.
         * @see cellType
         */ get: function() {
                        return this.getPropertyValue("choices");
                    },
                    set: function(val1) {
                        this.setPropertyValue("choices", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "placeholder", {
                    /**
         * A placeholder for Dropdown matrix cells.
         * @see cellType
         */ get: function() {
                        return this.getLocalizableStringText("placeholder");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("placeholder", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "locPlaceholder", {
                    get: function() {
                        return this.getLocalizableString("placeholder");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "optionsCaption", {
                    get: function() {
                        return this.placeholder;
                    },
                    set: function(val1) {
                        this.placeholder = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "keyDuplicationError", {
                    /**
         * An error message displayed when users enter a duplicate value into a column that accepts only unique values (`isUnique` is set to `true` or `keyName` is specified).
         *
         * A default value for this property is taken from a [localization dictionary](https://github.com/surveyjs/survey-library/tree/master/src/localization). Refer to the following help topic for more information: [Localization & Globalization](https://surveyjs.io/form-library/documentation/localization).
         * @see isUniqueCaseSensitive
         */ get: function() {
                        return this.getLocalizableStringText("keyDuplicationError");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("keyDuplicationError", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "locKeyDuplicationError", {
                    get: function() {
                        return this.getLocalizableString("keyDuplicationError");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "storeOthersAsComment", {
                    get: function() {
                        return !!this.survey ? this.survey.storeOthersAsComment : false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.addColumn = function(name, title) {
                    if (title === void 0) title = null;
                    var column = new _question_matrixdropdowncolumn__WEBPACK_IMPORTED_MODULE_12__["MatrixDropdownColumn"](name, title);
                    this.columns.push(column);
                    return column;
                };
                QuestionMatrixDropdownModelBase.prototype.getVisibleRows = function() {
                    var _this = this;
                    if (this.isUpdateLocked) return null;
                    if (!this.generatedVisibleRows) {
                        this.generatedVisibleRows = this.generateRows();
                        this.generatedVisibleRows.forEach(function(row) {
                            return _this.onMatrixRowCreated(row);
                        });
                        if (this.data) this.runCellsCondition(this.data.getFilteredValues(), this.data.getFilteredProperties());
                        this.updateValueOnRowsGeneration(this.generatedVisibleRows);
                        this.updateIsAnswered();
                    }
                    return this.generatedVisibleRows;
                };
                QuestionMatrixDropdownModelBase.prototype.updateValueOnRowsGeneration = function(rows) {
                    var oldValue = this.createNewValue(true);
                    var newValue = this.createNewValue();
                    for(var i = 0; i < rows.length; i++){
                        var row = rows[i];
                        if (!!row.editingObj) continue;
                        var rowValue = this.getRowValue(i);
                        var rValue = row.value;
                        if (this.isTwoValueEquals(rowValue, rValue)) continue;
                        newValue = this.getNewValueOnRowChanged(row, "", rValue, false, newValue).value;
                    }
                    if (this.isTwoValueEquals(oldValue, newValue)) return;
                    this.isRowChanging = true;
                    this.setNewValue(newValue);
                    this.isRowChanging = false;
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "totalValue", {
                    get: function() {
                        if (!this.hasTotal || !this.visibleTotalRow) return {};
                        return this.visibleTotalRow.value;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getVisibleTotalRow = function() {
                    if (this.isUpdateLocked) return null;
                    if (this.hasTotal) {
                        if (!this.generatedTotalRow) {
                            this.generatedTotalRow = this.generateTotalRow();
                            if (this.data) {
                                var properties = {
                                    survey: this.survey
                                };
                                this.runTotalsCondition(this.data.getAllValues(), properties);
                            }
                        }
                    } else this.generatedTotalRow = null;
                    return this.generatedTotalRow;
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "visibleTotalRow", {
                    get: function() {
                        return this.getVisibleTotalRow();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    this.updateColumnsIndexes(this.columns);
                    this.clearGeneratedRows();
                    this.generatedTotalRow = null;
                    this.updateHasFooter();
                };
                /**
     * Returns an object with row values. If a row has no answers, this method returns an empty object.
     * @param rowIndex A zero-based row index.
     * @see setRowValue
     */ QuestionMatrixDropdownModelBase.prototype.getRowValue = function(rowIndex) {
                    if (rowIndex < 0) return null;
                    var visRows = this.visibleRows;
                    if (rowIndex >= visRows.length) return null;
                    var newValue = this.createNewValue();
                    return this.getRowValueCore(visRows[rowIndex], newValue);
                };
                QuestionMatrixDropdownModelBase.prototype.checkIfValueInRowDuplicated = function(checkedRow, cellQuestion) {
                    if (!this.generatedVisibleRows) return false;
                    var res = false;
                    for(var i = 0; i < this.generatedVisibleRows.length; i++){
                        var row = this.generatedVisibleRows[i];
                        if (checkedRow === row) continue;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(row.getValue(cellQuestion.name), cellQuestion.value, true, this.isUniqueCaseSensitive)) {
                            res = true;
                            break;
                        }
                    }
                    if (res) this.addDuplicationError(cellQuestion);
                    else cellQuestion.clearErrors();
                    return res;
                };
                /**
     * Assigns values to a row.
     * @param rowIndex A zero-based row index.
     * @param rowValue An object with the following structure: `{ "column_name": columnValue, ... }`
     * @see getRowValue
     */ QuestionMatrixDropdownModelBase.prototype.setRowValue = function(rowIndex, rowValue) {
                    if (rowIndex < 0) return null;
                    var visRows = this.visibleRows;
                    if (rowIndex >= visRows.length) return null;
                    visRows[rowIndex].value = rowValue;
                    this.onRowChanged(visRows[rowIndex], "", rowValue, false);
                };
                QuestionMatrixDropdownModelBase.prototype.generateRows = function() {
                    return null;
                };
                QuestionMatrixDropdownModelBase.prototype.generateTotalRow = function() {
                    return new MatrixDropdownTotalRowModel(this);
                };
                QuestionMatrixDropdownModelBase.prototype.createNewValue = function(nullOnEmpty) {
                    if (nullOnEmpty === void 0) nullOnEmpty = false;
                    var res = !this.value ? {} : this.createValueCopy();
                    if (nullOnEmpty && this.isMatrixValueEmpty(res)) return null;
                    return res;
                };
                QuestionMatrixDropdownModelBase.prototype.getRowValueCore = function(row, questionValue, create) {
                    if (create === void 0) create = false;
                    var result = !!questionValue && !!questionValue[row.rowName] ? questionValue[row.rowName] : null;
                    if (!result && create) {
                        result = {};
                        if (!!questionValue) questionValue[row.rowName] = result;
                    }
                    return result;
                };
                QuestionMatrixDropdownModelBase.prototype.getRowObj = function(row) {
                    var obj = this.getRowValueCore(row, this.value);
                    return !!obj && !!obj.getType ? obj : null;
                };
                QuestionMatrixDropdownModelBase.prototype.getRowDisplayValue = function(keysAsText, row, rowValue) {
                    if (!rowValue) return rowValue;
                    if (!!row.editingObj) return rowValue;
                    var keys = Object.keys(rowValue);
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        var question = row.getQuestionByName(key);
                        if (!question) question = this.getSharedQuestionByName(key, row);
                        if (!!question) {
                            var displayvalue = question.getDisplayValue(keysAsText, rowValue[key]);
                            if (keysAsText && !!question.title && question.title !== key) {
                                rowValue[question.title] = displayvalue;
                                delete rowValue[key];
                            } else rowValue[key] = displayvalue;
                        }
                    }
                    return rowValue;
                };
                QuestionMatrixDropdownModelBase.prototype.getPlainData = function(options) {
                    var _this = this;
                    if (options === void 0) options = {
                        includeEmpty: true
                    };
                    var questionPlainData = _super.prototype.getPlainData.call(this, options);
                    if (!!questionPlainData) {
                        questionPlainData.isNode = true;
                        var prevData = Array.isArray(questionPlainData.data) ? [].concat(questionPlainData.data) : [];
                        questionPlainData.data = this.visibleRows.map(function(row) {
                            var rowDataItem = {
                                name: row.dataName,
                                title: row.text,
                                value: row.value,
                                displayValue: _this.getRowDisplayValue(false, row, row.value),
                                getString: function(val1) {
                                    return typeof val1 === "object" ? JSON.stringify(val1) : val1;
                                },
                                isNode: true,
                                data: row.cells.map(function(cell) {
                                    return cell.question.getPlainData(options);
                                }).filter(function(d) {
                                    return !!d;
                                })
                            };
                            (options.calculations || []).forEach(function(calculation) {
                                rowDataItem[calculation.propertyName] = row[calculation.propertyName];
                            });
                            return rowDataItem;
                        });
                        questionPlainData.data = questionPlainData.data.concat(prevData);
                    }
                    return questionPlainData;
                };
                QuestionMatrixDropdownModelBase.prototype.addConditionObjectsByContext = function(objects, context) {
                    var hasContext = !!context ? context === true || this.columns.indexOf(context) > -1 : false;
                    var rowsIndeces = this.getConditionObjectsRowIndeces();
                    if (hasContext) rowsIndeces.push(-1);
                    for(var i = 0; i < rowsIndeces.length; i++){
                        var index = rowsIndeces[i];
                        var rowName = index > -1 ? this.getConditionObjectRowName(index) : "row";
                        if (!rowName) continue;
                        var rowText = index > -1 ? this.getConditionObjectRowText(index) : "row";
                        var hasQuestionPrefix = index > -1 || context === true;
                        var dot = hasQuestionPrefix && index === -1 ? "." : "";
                        var prefixName = (hasQuestionPrefix ? this.getValueName() : "") + dot + rowName + ".";
                        var prefixTitle = (hasQuestionPrefix ? this.processedTitle : "") + dot + rowText + ".";
                        for(var j = 0; j < this.columns.length; j++){
                            var column = this.columns[j];
                            if (index === -1 && context === column) continue;
                            var obj = {
                                name: prefixName + column.name,
                                text: prefixTitle + column.fullTitle,
                                question: this
                            };
                            if (index === -1 && context === true) obj.context = this;
                            objects.push(obj);
                        }
                    }
                };
                QuestionMatrixDropdownModelBase.prototype.onHidingContent = function() {
                    _super.prototype.onHidingContent.call(this);
                    var questions = [];
                    this.collectNestedQuestions(questions, true);
                    questions.forEach(function(q) {
                        return q.onHidingContent();
                    });
                };
                QuestionMatrixDropdownModelBase.prototype.getIsReadyNestedQuestions = function() {
                    if (!this.generatedVisibleRows) return [];
                    var res = new Array();
                    this.collectNestedQuestonsInRows(this.generatedVisibleRows, res, false);
                    if (!!this.generatedTotalRow) this.collectNestedQuestonsInRows([
                        this.generatedTotalRow
                    ], res, false);
                    return res;
                };
                QuestionMatrixDropdownModelBase.prototype.collectNestedQuestionsCore = function(questions, visibleOnly) {
                    this.collectNestedQuestonsInRows(this.visibleRows, questions, visibleOnly);
                };
                QuestionMatrixDropdownModelBase.prototype.collectNestedQuestonsInRows = function(rows, questions, visibleOnly) {
                    if (!Array.isArray(rows)) return;
                    rows.forEach(function(row) {
                        row.questions.forEach(function(q) {
                            return q.collectNestedQuestions(questions, visibleOnly);
                        });
                    });
                };
                QuestionMatrixDropdownModelBase.prototype.getConditionObjectRowName = function(index) {
                    return "";
                };
                QuestionMatrixDropdownModelBase.prototype.getConditionObjectRowText = function(index) {
                    return this.getConditionObjectRowName(index);
                };
                QuestionMatrixDropdownModelBase.prototype.getConditionObjectsRowIndeces = function() {
                    return [];
                };
                QuestionMatrixDropdownModelBase.prototype.getProgressInfo = function() {
                    if (!!this.generatedVisibleRows) return _survey_element__WEBPACK_IMPORTED_MODULE_4__["SurveyElement"].getProgressInfoByElements(this.getCellQuestions(), this.isRequired);
                    var res = _base__WEBPACK_IMPORTED_MODULE_3__["Base"].createProgressInfo();
                    this.updateProgressInfoByValues(res);
                    if (res.requiredQuestionCount === 0 && this.isRequired) {
                        res.requiredQuestionCount = 1;
                        res.requiredAnsweredQuestionCount = !this.isEmpty() ? 1 : 0;
                    }
                    return res;
                };
                QuestionMatrixDropdownModelBase.prototype.updateProgressInfoByValues = function(res) {};
                QuestionMatrixDropdownModelBase.prototype.updateProgressInfoByRow = function(res, rowValue) {
                    for(var i = 0; i < this.columns.length; i++){
                        var col = this.columns[i];
                        if (!col.templateQuestion.hasInput) continue;
                        res.questionCount += 1;
                        res.requiredQuestionCount += col.isRequired;
                        var hasValue = !_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(rowValue[col.name]);
                        res.answeredQuestionCount += hasValue ? 1 : 0;
                        res.requiredAnsweredQuestionCount += hasValue && col.isRequired ? 1 : 0;
                    }
                };
                QuestionMatrixDropdownModelBase.prototype.getCellQuestions = function() {
                    var res = [];
                    this.runFuncForCellQuestions(function(q) {
                        res.push(q);
                    });
                    return res;
                };
                QuestionMatrixDropdownModelBase.prototype.onBeforeValueChanged = function(val1) {};
                QuestionMatrixDropdownModelBase.prototype.onSetQuestionValue = function() {
                    if (this.isRowChanging) return;
                    this.onBeforeValueChanged(this.value);
                    if (!this.generatedVisibleRows || this.generatedVisibleRows.length == 0) return;
                    this.isRowChanging = true;
                    var val1 = this.createNewValue();
                    for(var i = 0; i < this.generatedVisibleRows.length; i++){
                        var row = this.generatedVisibleRows[i];
                        this.generatedVisibleRows[i].value = this.getRowValueCore(row, val1);
                    }
                    this.isRowChanging = false;
                };
                QuestionMatrixDropdownModelBase.prototype.setQuestionValue = function(newValue) {
                    _super.prototype.setQuestionValue.call(this, newValue, false);
                    this.onSetQuestionValue();
                    this.updateIsAnswered();
                };
                QuestionMatrixDropdownModelBase.prototype.supportGoNextPageAutomatic = function() {
                    var rows = this.generatedVisibleRows;
                    if (!rows) rows = this.visibleRows;
                    if (!rows) return true;
                    for(var i = 0; i < rows.length; i++){
                        var cells = this.generatedVisibleRows[i].cells;
                        if (!cells) continue;
                        for(var colIndex = 0; colIndex < cells.length; colIndex++){
                            var question = cells[colIndex].question;
                            if (question && (!question.supportGoNextPageAutomatic() || !question.value)) return false;
                        }
                    }
                    return true;
                };
                QuestionMatrixDropdownModelBase.prototype.getContainsErrors = function() {
                    return _super.prototype.getContainsErrors.call(this) || this.checkForAnswersOrErrors(function(question) {
                        return question.containsErrors;
                    }, false);
                };
                QuestionMatrixDropdownModelBase.prototype.getIsAnswered = function() {
                    return _super.prototype.getIsAnswered.call(this) && this.checkForAnswersOrErrors(function(question) {
                        return question.isAnswered;
                    }, true);
                };
                QuestionMatrixDropdownModelBase.prototype.checkForAnswersOrErrors = function(predicate, every) {
                    if (every === void 0) every = false;
                    var rows = this.generatedVisibleRows;
                    if (!rows) return false;
                    for(var i = 0; i < rows.length; i++){
                        var cells = rows[i].cells;
                        if (!cells) continue;
                        for(var colIndex = 0; colIndex < cells.length; colIndex++){
                            if (!cells[colIndex]) continue;
                            var question = cells[colIndex].question;
                            if (question && question.isVisible) {
                                if (predicate(question)) {
                                    if (!every) return true;
                                } else {
                                    if (every) return false;
                                }
                            }
                        }
                    }
                    return every ? true : false;
                };
                QuestionMatrixDropdownModelBase.prototype.hasErrors = function(fireCallback, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (rec === void 0) rec = null;
                    var errosInRows = this.hasErrorInRows(fireCallback, rec);
                    var isDuplicated = this.isValueDuplicated();
                    return _super.prototype.hasErrors.call(this, fireCallback, rec) || errosInRows || isDuplicated;
                };
                QuestionMatrixDropdownModelBase.prototype.getIsRunningValidators = function() {
                    if (_super.prototype.getIsRunningValidators.call(this)) return true;
                    if (!this.generatedVisibleRows) return false;
                    for(var i = 0; i < this.generatedVisibleRows.length; i++){
                        var cells = this.generatedVisibleRows[i].cells;
                        if (!cells) continue;
                        for(var colIndex = 0; colIndex < cells.length; colIndex++){
                            if (!cells[colIndex]) continue;
                            var question = cells[colIndex].question;
                            if (!!question && question.isRunningValidators) return true;
                        }
                    }
                    return false;
                };
                QuestionMatrixDropdownModelBase.prototype.getAllErrors = function() {
                    var result = _super.prototype.getAllErrors.call(this);
                    var rows = this.generatedVisibleRows;
                    if (rows === null) return result;
                    for(var i = 0; i < rows.length; i++){
                        var row = rows[i];
                        for(var j = 0; j < row.cells.length; j++){
                            var errors = row.cells[j].question.getAllErrors();
                            if (errors && errors.length > 0) result = result.concat(errors);
                        }
                    }
                    return result;
                };
                QuestionMatrixDropdownModelBase.prototype.hasErrorInRows = function(fireCallback, rec) {
                    var _this = this;
                    var rows = this.generatedVisibleRows;
                    if (!this.generatedVisibleRows) rows = this.visibleRows;
                    var res = false;
                    if (!rec) rec = {};
                    if (!rows) return rec;
                    rec.validationValues = this.getDataFilteredValues();
                    rec.isSingleDetailPanel = this.detailPanelMode === "underRowSingle";
                    for(var i = 0; i < rows.length; i++)res = rows[i].hasErrors(fireCallback, rec, function() {
                        _this.raiseOnCompletedAsyncValidators();
                    }) || res;
                    return res;
                };
                QuestionMatrixDropdownModelBase.prototype.isValueDuplicated = function() {
                    if (!this.generatedVisibleRows) return false;
                    var columns = this.getUniqueColumns();
                    var res = false;
                    for(var i = 0; i < columns.length; i++)res = this.isValueInColumnDuplicated(columns[i]) || res;
                    return res;
                };
                QuestionMatrixDropdownModelBase.prototype.isValueInColumnDuplicated = function(column) {
                    var keyValues = [];
                    var res = false;
                    for(var i = 0; i < this.generatedVisibleRows.length; i++)res = this.isValueDuplicatedInRow(this.generatedVisibleRows[i], column, keyValues) || res;
                    return res;
                };
                QuestionMatrixDropdownModelBase.prototype.getUniqueColumns = function() {
                    var res = new Array();
                    for(var i = 0; i < this.columns.length; i++)if (this.columns[i].isUnique) res.push(this.columns[i]);
                    return res;
                };
                QuestionMatrixDropdownModelBase.prototype.isValueDuplicatedInRow = function(row, column, keyValues) {
                    var question = row.getQuestionByColumn(column);
                    if (!question || question.isEmpty()) return false;
                    var value = question.value;
                    for(var i = 0; i < keyValues.length; i++)if (_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(value, keyValues[i], true, this.isUniqueCaseSensitive)) {
                        this.addDuplicationError(question);
                        return true;
                    }
                    keyValues.push(value);
                    return false;
                };
                QuestionMatrixDropdownModelBase.prototype.addDuplicationError = function(question) {
                    var keyError = question.errors.find(function(error) {
                        return error.getErrorType() === "keyduplicationerror";
                    });
                    if (!keyError) question.addError(new _error__WEBPACK_IMPORTED_MODULE_10__["KeyDuplicationError"](this.keyDuplicationError, this));
                };
                QuestionMatrixDropdownModelBase.prototype.getFirstQuestionToFocus = function(withError) {
                    return this.getFirstCellQuestion(withError);
                };
                QuestionMatrixDropdownModelBase.prototype.getFirstInputElementId = function() {
                    var question = this.getFirstCellQuestion(false);
                    return question ? question.inputId : _super.prototype.getFirstInputElementId.call(this);
                };
                QuestionMatrixDropdownModelBase.prototype.getFirstErrorInputElementId = function() {
                    var question = this.getFirstCellQuestion(true);
                    return question ? question.inputId : _super.prototype.getFirstErrorInputElementId.call(this);
                };
                QuestionMatrixDropdownModelBase.prototype.getFirstCellQuestion = function(onError) {
                    if (!this.generatedVisibleRows) return null;
                    for(var i = 0; i < this.generatedVisibleRows.length; i++){
                        var cells = this.generatedVisibleRows[i].cells;
                        for(var colIndex = 0; colIndex < cells.length; colIndex++){
                            if (!onError) return cells[colIndex].question;
                            if (cells[colIndex].question.currentErrorCount > 0) return cells[colIndex].question;
                        }
                    }
                    return null;
                };
                QuestionMatrixDropdownModelBase.prototype.onReadOnlyChanged = function() {
                    _super.prototype.onReadOnlyChanged.call(this);
                    if (!this.generateRows) return;
                    for(var i = 0; i < this.visibleRows.length; i++)this.visibleRows[i].onQuestionReadOnlyChanged(this.isReadOnly);
                };
                //IMatrixDropdownData
                QuestionMatrixDropdownModelBase.prototype.createQuestion = function(row, column) {
                    return this.createQuestionCore(row, column);
                };
                QuestionMatrixDropdownModelBase.prototype.createQuestionCore = function(row, column) {
                    var question = column.createCellQuestion(row);
                    question.setSurveyImpl(row);
                    question.setParentQuestion(this);
                    question.inMatrixMode = true;
                    return question;
                };
                QuestionMatrixDropdownModelBase.prototype.deleteRowValue = function(newValue, row) {
                    if (!newValue) return newValue;
                    delete newValue[row.rowName];
                    return this.isObject(newValue) && Object.keys(newValue).length == 0 ? null : newValue;
                };
                QuestionMatrixDropdownModelBase.prototype.onAnyValueChanged = function(name, questionName) {
                    if (this.isUpdateLocked || this.isDoingonAnyValueChanged || !this.generatedVisibleRows) return;
                    this.isDoingonAnyValueChanged = true;
                    var rows = this.visibleRows;
                    for(var i = 0; i < rows.length; i++)rows[i].onAnyValueChanged(name, questionName);
                    var totalRow = this.visibleTotalRow;
                    if (!!totalRow) totalRow.onAnyValueChanged(name, questionName);
                    this.isDoingonAnyValueChanged = false;
                };
                QuestionMatrixDropdownModelBase.prototype.isObject = function(value) {
                    return value !== null && typeof value === "object";
                };
                QuestionMatrixDropdownModelBase.prototype.getOnCellValueChangedOptions = function(row, columnName, rowValue) {
                    var getQuestion = function(colName) {
                        return row.getQuestionByName(colName);
                    };
                    return {
                        row: row,
                        columnName: columnName,
                        rowValue: rowValue,
                        value: !!rowValue ? rowValue[columnName] : null,
                        getCellQuestion: getQuestion,
                        cellQuestion: row.getQuestionByName(columnName),
                        column: this.getColumnByName(columnName)
                    };
                };
                QuestionMatrixDropdownModelBase.prototype.onCellValueChanged = function(row, columnName, rowValue) {
                    if (!this.survey) return;
                    var options = this.getOnCellValueChangedOptions(row, columnName, rowValue);
                    if (!!this.onCellValueChangedCallback) this.onCellValueChangedCallback(options);
                    this.survey.matrixCellValueChanged(this, options);
                };
                QuestionMatrixDropdownModelBase.prototype.validateCell = function(row, columnName, rowValue) {
                    if (!this.survey) return;
                    var options = this.getOnCellValueChangedOptions(row, columnName, rowValue);
                    return this.survey.matrixCellValidate(this, options);
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "isValidateOnValueChanging", {
                    get: function() {
                        return !!this.survey ? this.survey.isValidateOnValueChanging : false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.onRowChanging = function(row, columnName, rowValue) {
                    if (!this.survey && !this.cellValueChangingCallback) return !!rowValue ? rowValue[columnName] : null;
                    var options = this.getOnCellValueChangedOptions(row, columnName, rowValue);
                    var oldRowValue = this.getRowValueCore(row, this.createNewValue(), true);
                    options.oldValue = !!oldRowValue ? oldRowValue[columnName] : null;
                    if (!!this.cellValueChangingCallback) options.value = this.cellValueChangingCallback(row, columnName, options.value, options.oldValue);
                    if (!!this.survey) this.survey.matrixCellValueChanging(this, options);
                    return options.value;
                };
                QuestionMatrixDropdownModelBase.prototype.onRowChanged = function(row, columnName, newRowValue, isDeletingValue) {
                    var rowObj = !!columnName ? this.getRowObj(row) : null;
                    if (!!rowObj) {
                        var columnValue = null;
                        if (!!newRowValue && !isDeletingValue) columnValue = newRowValue[columnName];
                        this.isRowChanging = true;
                        _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].setObjPropertyValue(rowObj, columnName, columnValue);
                        this.isRowChanging = false;
                        this.onCellValueChanged(row, columnName, rowObj);
                    } else {
                        var oldValue = this.createNewValue(true);
                        var combine = this.getNewValueOnRowChanged(row, columnName, newRowValue, isDeletingValue, this.createNewValue());
                        if (this.isTwoValueEquals(oldValue, combine.value)) return;
                        this.isRowChanging = true;
                        this.setNewValue(combine.value);
                        this.isRowChanging = false;
                        if (columnName) this.onCellValueChanged(row, columnName, combine.rowValue);
                    }
                };
                QuestionMatrixDropdownModelBase.prototype.getNewValueOnRowChanged = function(row, columnName, newRowValue, isDeletingValue, newValue) {
                    var rowValue = this.getRowValueCore(row, newValue, true);
                    if (isDeletingValue) delete rowValue[columnName];
                    for(var i = 0; i < row.cells.length; i++){
                        var key = row.cells[i].question.getValueName();
                        delete rowValue[key];
                    }
                    if (newRowValue) {
                        newRowValue = JSON.parse(JSON.stringify(newRowValue));
                        for(var key in newRowValue)if (!this.isValueEmpty(newRowValue[key])) rowValue[key] = newRowValue[key];
                    }
                    if (this.isObject(rowValue) && Object.keys(rowValue).length === 0) newValue = this.deleteRowValue(newValue, row);
                    return {
                        value: newValue,
                        rowValue: rowValue
                    };
                };
                QuestionMatrixDropdownModelBase.prototype.getRowIndex = function(row) {
                    if (!this.generatedVisibleRows) return -1;
                    return this.visibleRows.indexOf(row);
                };
                QuestionMatrixDropdownModelBase.prototype.getElementsInDesign = function(includeHidden) {
                    if (includeHidden === void 0) includeHidden = false;
                    var elements;
                    if (this.detailPanelMode == "none") elements = _super.prototype.getElementsInDesign.call(this, includeHidden);
                    else elements = includeHidden ? [
                        this.detailPanel
                    ] : this.detailElements;
                    return this.columns.concat(elements);
                };
                QuestionMatrixDropdownModelBase.prototype.hasDetailPanel = function(row) {
                    if (this.detailPanelMode == "none") return false;
                    if (this.isDesignMode) return true;
                    if (!!this.onHasDetailPanelCallback) return this.onHasDetailPanelCallback(row);
                    return this.detailElements.length > 0;
                };
                QuestionMatrixDropdownModelBase.prototype.getIsDetailPanelShowing = function(row) {
                    if (this.detailPanelMode == "none") return false;
                    if (this.isDesignMode) {
                        var res = this.visibleRows.indexOf(row) == 0;
                        if (res) {
                            if (!row.detailPanel) row.showDetailPanel();
                        }
                        return res;
                    }
                    return this.getPropertyValue("isRowShowing" + row.id, false);
                };
                QuestionMatrixDropdownModelBase.prototype.setIsDetailPanelShowing = function(row, val1) {
                    if (val1 == this.getIsDetailPanelShowing(row)) return;
                    this.setPropertyValue("isRowShowing" + row.id, val1);
                    this.updateDetailPanelButtonCss(row);
                    if (!!this.renderedTable) this.renderedTable.onDetailPanelChangeVisibility(row, val1);
                    if (this.survey) this.survey.matrixDetailPanelVisibleChanged(this, row.rowIndex - 1, row, val1);
                    if (val1 && this.detailPanelMode === "underRowSingle") {
                        var rows = this.visibleRows;
                        for(var i = 0; i < rows.length; i++)if (rows[i].id !== row.id && rows[i].isDetailPanelShowing) rows[i].hideDetailPanel();
                    }
                };
                QuestionMatrixDropdownModelBase.prototype.getDetailPanelButtonCss = function(row) {
                    var builder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__["CssClassBuilder"]().append(this.getPropertyValue("detailButtonCss" + row.id));
                    return builder.append(this.cssClasses.detailButton, builder.toString() === "").toString();
                };
                QuestionMatrixDropdownModelBase.prototype.getDetailPanelIconCss = function(row) {
                    var builder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__["CssClassBuilder"]().append(this.getPropertyValue("detailIconCss" + row.id));
                    return builder.append(this.cssClasses.detailIcon, builder.toString() === "").toString();
                };
                QuestionMatrixDropdownModelBase.prototype.getDetailPanelIconId = function(row) {
                    return this.getIsDetailPanelShowing(row) ? this.cssClasses.detailIconExpandedId : this.cssClasses.detailIconId;
                };
                QuestionMatrixDropdownModelBase.prototype.updateDetailPanelButtonCss = function(row) {
                    var classes = this.cssClasses;
                    var isPanelShowing = this.getIsDetailPanelShowing(row);
                    var iconBuilder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__["CssClassBuilder"]().append(classes.detailIcon).append(classes.detailIconExpanded, isPanelShowing);
                    this.setPropertyValue("detailIconCss" + row.id, iconBuilder.toString());
                    var buttonBuilder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__["CssClassBuilder"]().append(classes.detailButton).append(classes.detailButtonExpanded, isPanelShowing);
                    this.setPropertyValue("detailButtonCss" + row.id, buttonBuilder.toString());
                };
                QuestionMatrixDropdownModelBase.prototype.createRowDetailPanel = function(row) {
                    var _this = this;
                    if (this.isDesignMode) return this.detailPanel;
                    var panel = this.createNewDetailPanel();
                    panel.readOnly = this.isReadOnly;
                    panel.setSurveyImpl(row);
                    var json = this.detailPanel.toJSON();
                    new _jsonobject__WEBPACK_IMPORTED_MODULE_0__["JsonObject"]().toObject(json, panel);
                    panel.renderWidth = "100%";
                    panel.updateCustomWidgets();
                    if (!!this.onCreateDetailPanelCallback) this.onCreateDetailPanelCallback(row, panel);
                    panel.questions.forEach(function(q) {
                        return q.setParentQuestion(_this);
                    });
                    panel.onSurveyLoad();
                    return panel;
                };
                QuestionMatrixDropdownModelBase.prototype.getSharedQuestionByName = function(columnName, row) {
                    if (!this.survey || !this.valueName) return null;
                    var index = this.getRowIndex(row);
                    if (index < 0) return null;
                    return this.survey.getQuestionByValueNameFromArray(this.valueName, columnName, index);
                };
                QuestionMatrixDropdownModelBase.prototype.onTotalValueChanged = function() {
                    if (!!this.data && !!this.visibleTotalRow && !this.isUpdateLocked && !this.isSett) this.data.setValue(this.getValueName() + _settings__WEBPACK_IMPORTED_MODULE_9__["settings"].matrix.totalsSuffix, this.totalValue, false);
                };
                QuestionMatrixDropdownModelBase.prototype.getDataFilteredValues = function() {
                    return this.data ? this.data.getFilteredValues() : {};
                };
                QuestionMatrixDropdownModelBase.prototype.getParentTextProcessor = function() {
                    if (!this.parentQuestion || !this.parent) return null;
                    var data = this.parent.data;
                    if (!!data && !!data.getTextProcessor) return data.getTextProcessor();
                    return null;
                };
                QuestionMatrixDropdownModelBase.prototype.getQuestionFromArray = function(name, index) {
                    if (index >= this.visibleRows.length) return null;
                    return this.visibleRows[index].getQuestionByName(name);
                };
                QuestionMatrixDropdownModelBase.prototype.isMatrixValueEmpty = function(val1) {
                    if (!val1) return;
                    if (Array.isArray(val1)) {
                        for(var i = 0; i < val1.length; i++){
                            if (this.isObject(val1[i]) && Object.keys(val1[i]).length > 0) return false;
                        }
                        return true;
                    }
                    return Object.keys(val1).length == 0;
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "SurveyModel", {
                    get: function() {
                        return this.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getCellTemplateData = function(cell) {
                    // return cell.cell.column.templateQuestion;
                    return this.SurveyModel.getMatrixCellTemplateData(cell);
                };
                QuestionMatrixDropdownModelBase.prototype.getCellWrapperComponentName = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentName(cell, cell.row instanceof MatrixDropdownTotalRowModel ? "row-footer" : "cell");
                };
                QuestionMatrixDropdownModelBase.prototype.getCellWrapperComponentData = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentData(cell, cell.row instanceof MatrixDropdownTotalRowModel ? "row-footer" : "cell");
                };
                QuestionMatrixDropdownModelBase.prototype.getColumnHeaderWrapperComponentName = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentName(cell, "column-header");
                };
                QuestionMatrixDropdownModelBase.prototype.getColumnHeaderWrapperComponentData = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentData(cell, "column-header");
                };
                QuestionMatrixDropdownModelBase.prototype.getRowHeaderWrapperComponentName = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentName(cell, "row-header");
                };
                QuestionMatrixDropdownModelBase.prototype.getRowHeaderWrapperComponentData = function(cell) {
                    return this.SurveyModel.getElementWrapperComponentData(cell, "row-header");
                };
                Object.defineProperty(QuestionMatrixDropdownModelBase.prototype, "showHorizontalScroll", {
                    get: function() {
                        return !this.isDefaultV2Theme && this.horizontalScroll;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownModelBase.prototype.getRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_11__["CssClassBuilder"]().append(_super.prototype.getRootCss.call(this)).append(this.cssClasses.rootScroll, this.horizontalScroll).toString();
                };
                return QuestionMatrixDropdownModelBase;
            }(_martixBase__WEBPACK_IMPORTED_MODULE_1__["QuestionMatrixBaseModel"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("matrixdropdownbase", [
                {
                    name: "columns:matrixdropdowncolumns",
                    className: "matrixdropdowncolumn",
                    isArray: true
                },
                {
                    name: "columnLayout",
                    alternativeName: "columnsLocation",
                    choices: [
                        "horizontal",
                        "vertical"
                    ],
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "transposeData:boolean",
                    version: "1.9.130",
                    oldName: "columnLayout"
                },
                {
                    name: "detailElements",
                    visible: false,
                    isLightSerializable: false
                },
                {
                    name: "detailPanelMode",
                    choices: [
                        "none",
                        "underRow",
                        "underRowSingle"
                    ],
                    default: "none"
                },
                {
                    name: "cellErrorLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom"
                    ]
                },
                {
                    name: "detailErrorLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom"
                    ],
                    visibleIf: function(obj) {
                        return !!obj && obj.detailPanelMode != "none";
                    }
                },
                {
                    name: "horizontalScroll:boolean",
                    visible: false
                },
                {
                    name: "choices:itemvalue[]",
                    uniqueProperty: "value"
                },
                {
                    name: "placeholder",
                    alternativeName: "optionsCaption",
                    serializationProperty: "locPlaceholder"
                },
                {
                    name: "keyDuplicationError",
                    serializationProperty: "locKeyDuplicationError"
                },
                {
                    name: "cellType",
                    default: "dropdown",
                    choices: function() {
                        return _question_matrixdropdowncolumn__WEBPACK_IMPORTED_MODULE_12__["MatrixDropdownColumn"].getColumnTypes();
                    }
                },
                {
                    name: "columnColCount",
                    default: 0,
                    choices: [
                        0,
                        1,
                        2,
                        3,
                        4
                    ]
                },
                "columnMinWidth",
                {
                    name: "allowAdaptiveActions:boolean",
                    default: false,
                    visible: false
                }
            ], function() {
                return new QuestionMatrixDropdownModelBase("");
            }, "matrixbase");
        /***/ },
        /***/ "./src/question_matrixdropdowncolumn.ts": /*!**********************************************!*\
  !*** ./src/question_matrixdropdowncolumn.ts ***!
  \**********************************************/ /*! exports provided: matrixDropdownColumnTypes, MatrixDropdownColumn */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "matrixDropdownColumnTypes", function() {
                return matrixDropdownColumnTypes;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixDropdownColumn", function() {
                return MatrixDropdownColumn;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _question_expression__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_expression */ "./src/question_expression.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            function onUpdateSelectBaseCellQuestion(cellQuestion, column, question, data) {
                cellQuestion.storeOthersAsComment = !!question ? question.storeOthersAsComment : false;
                if ((!cellQuestion.choices || cellQuestion.choices.length == 0) && cellQuestion.choicesByUrl.isEmpty) cellQuestion.choices = question.choices;
                if (!cellQuestion.choicesByUrl.isEmpty) cellQuestion.choicesByUrl.run(data.getTextProcessor());
            }
            function onUpdateSelectDropdownCellQuestion(cellQuestion, column, question, data) {
                onUpdateSelectBaseCellQuestion(cellQuestion, column, question, data);
                if (!!cellQuestion.locPlaceholder && cellQuestion.locPlaceholder.isEmpty && !question.locPlaceholder.isEmpty) cellQuestion.optionsCaption = question.optionsCaption;
            }
            var matrixDropdownColumnTypes = {
                dropdown: {
                    onCellQuestionUpdate: function(cellQuestion, column, question, data) {
                        onUpdateSelectDropdownCellQuestion(cellQuestion, column, question, data);
                    }
                },
                checkbox: {
                    onCellQuestionUpdate: function(cellQuestion, column, question, data) {
                        onUpdateSelectBaseCellQuestion(cellQuestion, column, question, data);
                        cellQuestion.colCount = column.colCount > -1 ? column.colCount : question.columnColCount;
                    }
                },
                radiogroup: {
                    onCellQuestionUpdate: function(cellQuestion, column, question, data) {
                        onUpdateSelectBaseCellQuestion(cellQuestion, column, question, data);
                        cellQuestion.colCount = column.colCount > -1 ? column.colCount : question.columnColCount;
                    }
                },
                tagbox: {
                    onCellQuestionUpdate: function(cellQuestion, column, question, data) {
                        onUpdateSelectBaseCellQuestion(cellQuestion, column, question, data);
                    }
                },
                text: {},
                comment: {},
                boolean: {
                    onCellQuestionUpdate: function(cellQuestion, column, question, data) {
                        cellQuestion.renderAs = column.renderAs;
                    }
                },
                expression: {},
                rating: {}
            };
            /**
 * An auxiliary class that describes a column in a [Multi-Select Matrix](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list) or [Dynamic Matrix](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model).
 *
 * You can get an object of this class from the [`columns`](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list#columns) array or by calling the [`getColumnByName()`](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list#getColumnByName) method on a matrix instance.
 */ var MatrixDropdownColumn = /** @class */ function(_super) {
                __extends(MatrixDropdownColumn, _super);
                function MatrixDropdownColumn(name, title) {
                    if (title === void 0) title = null;
                    var _this = _super.call(this) || this;
                    _this.colOwnerValue = null;
                    _this.indexValue = -1;
                    _this._hasVisibleCell = true;
                    _this.previousChoicesId = undefined;
                    _this.createLocalizableString("totalFormat", _this);
                    _this.createLocalizableString("cellHint", _this);
                    _this.registerPropertyChangedHandlers([
                        "showInMultipleColumns"
                    ], function() {
                        _this.doShowInMultipleColumnsChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "visible"
                    ], function() {
                        _this.doColumnVisibilityChanged();
                    });
                    _this.updateTemplateQuestion();
                    _this.name = name;
                    if (title) _this.title = title;
                    else _this.templateQuestion.locTitle.strChanged();
                    return _this;
                }
                MatrixDropdownColumn.getColumnTypes = function() {
                    var res = [];
                    for(var key in matrixDropdownColumnTypes)res.push(key);
                    return res;
                };
                MatrixDropdownColumn.prototype.getOriginalObj = function() {
                    return this.templateQuestion;
                };
                MatrixDropdownColumn.prototype.getClassNameProperty = function() {
                    return "cellType";
                };
                MatrixDropdownColumn.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    return !!this.colOwner ? this.colOwner.survey : null;
                };
                MatrixDropdownColumn.prototype.endLoadingFromJson = function() {
                    var _this = this;
                    _super.prototype.endLoadingFromJson.call(this);
                    this.templateQuestion.autoOtherMode = this.isShowInMultipleColumns;
                    this.templateQuestion.endLoadingFromJson();
                    this.templateQuestion.onGetSurvey = function() {
                        return _this.getSurvey();
                    };
                };
                MatrixDropdownColumn.prototype.getDynamicPropertyName = function() {
                    return "cellType";
                };
                MatrixDropdownColumn.prototype.getDynamicType = function() {
                    if (this.cellType === "default") return "question";
                    return this.calcCellQuestionType(null);
                };
                Object.defineProperty(MatrixDropdownColumn.prototype, "colOwner", {
                    get: function() {
                        return this.colOwnerValue;
                    },
                    set: function(value) {
                        this.colOwnerValue = value;
                        if (!!value) {
                            this.updateTemplateQuestion();
                            this.setParentQuestionToTemplate(this.templateQuestion);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownColumn.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.locTitle.strChanged();
                };
                MatrixDropdownColumn.prototype.addUsedLocales = function(locales) {
                    _super.prototype.addUsedLocales.call(this, locales);
                    this.templateQuestion.addUsedLocales(locales);
                };
                Object.defineProperty(MatrixDropdownColumn.prototype, "index", {
                    get: function() {
                        return this.indexValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownColumn.prototype.setIndex = function(val1) {
                    this.indexValue = val1;
                };
                MatrixDropdownColumn.prototype.getType = function() {
                    return "matrixdropdowncolumn";
                };
                Object.defineProperty(MatrixDropdownColumn.prototype, "cellType", {
                    /**
         * Specifies the type of column cells.
         *
         * Possible values:
         *
         * - [`"dropdown"`](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model)
         * - [`"checkbox"`](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model)
         * - [`"radiogroup"`](https://surveyjs.io/form-library/documentation/api-reference/radio-button-question-model)
         * - [`"tagbox"`](https://surveyjs.io/form-library/documentation/api-reference/dropdown-tag-box-model)
         * - [`"text"`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model)
         * - [`"comment"`](https://surveyjs.io/form-library/documentation/api-reference/comment-field-model)
         * - [`"boolean"`](https://surveyjs.io/form-library/documentation/api-reference/boolean-question-model)
         * - [`"expression"`](https://surveyjs.io/form-library/documentation/api-reference/expression-model)
         * - [`"rating"`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model)
         * - `"default"` (default) - Inherits the input type from the [`cellType`](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list#cellType) property specified for the parent matrix.
         *
         * The input types are based upon standalone question types. Depending on the selected input type, the matrix column can have additional configuration properties inherited from the corresponding question type. For instance, Dropdown, Checkboxes, Radio Button Group, and Tag Box columns can specify the [`choices`](https://surveyjs.io/form-library/documentation/api-reference/radio-button-question-model#choices) array, similar to the question types upon which they are based. Refer to the API Reference of these question types for a full list of available properties.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/aggregate-data-within-form/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("cellType");
                    },
                    set: function(val1) {
                        val1 = val1.toLocaleLowerCase();
                        this.updateTemplateQuestion(val1);
                        this.setPropertyValue("cellType", val1);
                        if (!!this.colOwner) this.colOwner.onColumnCellTypeChanged(this);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "templateQuestion", {
                    get: function() {
                        return this.templateQuestionValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "value", {
                    get: function() {
                        return this.templateQuestion.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "isVisible", {
                    //For filtering columns
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "isColumnVisible", {
                    get: function() {
                        if (this.isDesignMode) return true;
                        return this.visible && this.hasVisibleCell;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "visible", {
                    /**
         * Gets or sets column visibility.
         *
         * If you want to display or hide a column based on a condition, specify the [`visibleIf`](#visibleIf) property.
         * @see isRequired
         * @see readOnly
         */ get: function() {
                        return this.getPropertyValue("visible");
                    },
                    set: function(val1) {
                        this.setPropertyValue("visible", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "hasVisibleCell", {
                    get: function() {
                        return this._hasVisibleCell;
                    },
                    set: function(newVal) {
                        this._hasVisibleCell = newVal;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownColumn.prototype.getVisibleMultipleChoices = function() {
                    var choices = this.templateQuestion.visibleChoices;
                    if (!Array.isArray(choices)) return [];
                    if (!Array.isArray(this._visiblechoices)) return choices;
                    var res = new Array();
                    for(var i = 0; i < choices.length; i++){
                        var item = choices[i];
                        if (this._visiblechoices.indexOf(item.value) > -1) res.push(item);
                    }
                    return res;
                };
                Object.defineProperty(MatrixDropdownColumn.prototype, "getVisibleChoicesInCell", {
                    get: function() {
                        if (Array.isArray(this._visiblechoices)) return this._visiblechoices;
                        var res = this.templateQuestion.visibleChoices;
                        return Array.isArray(res) ? res : [];
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownColumn.prototype.setVisibleChoicesInCell = function(val1) {
                    this._visiblechoices = val1;
                };
                Object.defineProperty(MatrixDropdownColumn.prototype, "isFilteredMultipleColumns", {
                    get: function() {
                        if (!this.showInMultipleColumns) return false;
                        var choices = this.templateQuestion.choices;
                        if (!Array.isArray(choices)) return false;
                        for(var i = 0; i < choices.length; i++){
                            if (choices[i].visibleIf) return true;
                        }
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "name", {
                    /**
         * A column ID that is not visible to respondents.
         *
         * > Column IDs must be unique.
         * @see title
         */ get: function() {
                        return this.templateQuestion.name;
                    },
                    set: function(val1) {
                        this.templateQuestion.name = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "title", {
                    /**
         * A user-friendly column caption to display. If `title` is undefined, [`name`](#name) is displayed instead.
         */ get: function() {
                        return this.templateQuestion.title;
                    },
                    set: function(val1) {
                        this.templateQuestion.title = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "locTitle", {
                    get: function() {
                        return this.templateQuestion.locTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "fullTitle", {
                    get: function() {
                        return this.locTitle.textOrHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "isRequired", {
                    /**
         * Marks the column as required. If a respondent skips any cell in a required column, the matrix displays a [validation error](#requiredErrorText).
         *
         * If you want to mark the column as required based on a condition, specify the [`requiredIf`](#requiredIf) property.
         * @see visible
         * @see readOnly
         */ get: function() {
                        return this.templateQuestion.isRequired;
                    },
                    set: function(val1) {
                        this.templateQuestion.isRequired = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "isRenderedRequired", {
                    get: function() {
                        return this.getPropertyValue("isRenderedRequired", this.isRequired);
                    },
                    set: function(val1) {
                        this.setPropertyValue("isRenderedRequired", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownColumn.prototype.updateIsRenderedRequired = function(val1) {
                    this.isRenderedRequired = val1 || this.isRequired;
                };
                Object.defineProperty(MatrixDropdownColumn.prototype, "requiredText", {
                    get: function() {
                        return this.isRenderedRequired && this.getSurvey() ? this.getSurvey().requiredText : this.templateQuestion.requiredText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "requiredErrorText", {
                    /**
         * Specifies a custom error message for a required column.
         * @see isRequired
         */ get: function() {
                        return this.templateQuestion.requiredErrorText;
                    },
                    set: function(val1) {
                        this.templateQuestion.requiredErrorText = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "locRequiredErrorText", {
                    get: function() {
                        return this.templateQuestion.locRequiredErrorText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "readOnly", {
                    /**
         * Makes the column read-only.
         *
         * If you want to switch the column to the read-only state based on a condition, specify the [`enableIf`](#enableIf) property.
         * @see visible
         * @see isRequired
         */ get: function() {
                        return this.templateQuestion.readOnly;
                    },
                    set: function(val1) {
                        this.templateQuestion.readOnly = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "hasOther", {
                    get: function() {
                        return this.templateQuestion.hasOther;
                    },
                    set: function(val1) {
                        this.templateQuestion.hasOther = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "visibleIf", {
                    /**
         * A Boolean expression. If it evaluates to `false`, this column becomes hidden.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see visible
         */ get: function() {
                        return this.templateQuestion.visibleIf;
                    },
                    set: function(val1) {
                        this.templateQuestion.visibleIf = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "enableIf", {
                    /**
         * A Boolean expression. If it evaluates to `false`, this column becomes read-only.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see readOnly
         */ get: function() {
                        return this.templateQuestion.enableIf;
                    },
                    set: function(val1) {
                        this.templateQuestion.enableIf = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "requiredIf", {
                    /**
         * A Boolean expression. If it evaluates to `true`, this column becomes required.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see isRequired
         */ get: function() {
                        return this.templateQuestion.requiredIf;
                    },
                    set: function(val1) {
                        this.templateQuestion.requiredIf = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "resetValueIf", {
                    /**
         * A Boolean expression. If it evaluates to `true`, all cells in this column are set to a value calculated using the [`defaultValueExpression`](#defaultValueExpression).
         *
         * [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions (linkStyle))
         * @see setValueIf
         */ get: function() {
                        return this.templateQuestion.resetValueIf;
                    },
                    set: function(val1) {
                        this.templateQuestion.resetValueIf = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "defaultValueExpression", {
                    /**
         * An expression used to calculate the column's default value. This expression applies to all cells of this column until the cell value is specified by an end user or programmatically.
         *
         * [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions (linkStyle))
         * @see setValueExpression
         */ get: function() {
                        return this.templateQuestion.defaultValueExpression;
                    },
                    set: function(val1) {
                        this.templateQuestion.defaultValueExpression = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "setValueIf", {
                    /**
         * A Boolean expression. If it evaluates to `true`, all cells in this column are set to a value calculated using the [`setValueExpression`](#setValueExpression).
         *
         * [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions (linkStyle))
         * @see resetValueIf
         */ get: function() {
                        return this.templateQuestion.setValueIf;
                    },
                    set: function(val1) {
                        this.templateQuestion.setValueIf = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "setValueExpression", {
                    /**
         * An expression used to calculate a value for all column cells.
         *
         * You can use `setValueExpression` as a standalone property or in conjunction with the [`setValueIf`](#setValueIf) expression, in which case the calculated cell value applies only when `setValueIf` evaluates to `true`.
         *
         * [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions (linkStyle))
         * @see defaultValueExpression
         * @see resetValueIf
         */ get: function() {
                        return this.templateQuestion.setValueExpression;
                    },
                    set: function(val1) {
                        this.templateQuestion.setValueExpression = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "isUnique", {
                    /**
         * Specifies whether a respondent is required to provide a unique response for each question within this column.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("isUnique");
                    },
                    set: function(val1) {
                        this.setPropertyValue("isUnique", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "showInMultipleColumns", {
                    /**
         * Specifies whether to create an individual column for each choice option. Applies only to columns of `"checkbox"` or `"radiogroup"` [`cellType`](#cellType).
         */ get: function() {
                        return this.getPropertyValue("showInMultipleColumns");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showInMultipleColumns", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "isSupportMultipleColumns", {
                    get: function() {
                        return [
                            "checkbox",
                            "radiogroup"
                        ].indexOf(this.cellType) > -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "isShowInMultipleColumns", {
                    get: function() {
                        return this.showInMultipleColumns && this.isSupportMultipleColumns;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "validators", {
                    /**
         * Column validators.
         *
         * [Data Validation](https://surveyjs.io/form-library/documentation/data-validation (linkStyle))
         * @see isRequired
         */ get: function() {
                        return this.templateQuestion.validators;
                    },
                    set: function(val1) {
                        this.templateQuestion.validators = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "totalType", {
                    /**
         * An aggregation method used to calculate the column total.
         *
         * Possible values:
         *
         * - `"none"` (default) - Disables total calculations.
         * - `"sum"`
         * - `"count"`
         * - `"min"`
         * - `"max"`
         * - `"avg"`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/aggregate-data-within-form/ (linkStyle))
         * @see totalFormat
         * @see totalDisplayStyle
         */ get: function() {
                        return this.getPropertyValue("totalType");
                    },
                    set: function(val1) {
                        this.setPropertyValue("totalType", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "totalExpression", {
                    /**
         * An expression used to calculate total values. Overrides the [`totalType`](#totalType) property.
         *
         * [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("totalExpression");
                    },
                    set: function(val1) {
                        this.setPropertyValue("totalExpression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "hasTotal", {
                    get: function() {
                        return this.totalType != "none" || !!this.totalExpression;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "totalFormat", {
                    /**
         * A string pattern used to display column totals. To reference a total value within this pattern, use the `{0}` placeholder.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/aggregate-data-within-form/ (linkStyle))
         * @see totalType
         * @see totalDisplayStyle
         */ get: function() {
                        return this.getLocalizableStringText("totalFormat", "");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("totalFormat", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "locTotalFormat", {
                    get: function() {
                        return this.getLocalizableString("totalFormat");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "cellHint", {
                    get: function() {
                        return this.getLocalizableStringText("cellHint", "");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("cellHint", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "locCellHint", {
                    get: function() {
                        return this.getLocalizableString("cellHint");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "renderAs", {
                    get: function() {
                        return this.getPropertyValue("renderAs");
                    },
                    set: function(val1) {
                        this.setPropertyValue("renderAs", val1);
                        if (!!this.templateQuestion) this.templateQuestion.renderAs = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "totalMaximumFractionDigits", {
                    get: function() {
                        return this.getPropertyValue("totalMaximumFractionDigits");
                    },
                    set: function(val1) {
                        if (val1 < -1 || val1 > 20) return;
                        this.setPropertyValue("totalMaximumFractionDigits", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "totalMinimumFractionDigits", {
                    get: function() {
                        return this.getPropertyValue("totalMinimumFractionDigits");
                    },
                    set: function(val1) {
                        if (val1 < -1 || val1 > 20) return;
                        this.setPropertyValue("totalMinimumFractionDigits", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "totalDisplayStyle", {
                    /**
         * A format for calculated total values.
         *
         * Possible values:
         *
         * - `"none"` (default)
         * - `"decimal"`
         * - `"currency"`
         * - `"percent"`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/aggregate-data-within-form/ (linkStyle))
         * @see totalType
         * @see totalFormat
         * @see totalCurrency
         */ get: function() {
                        return this.getPropertyValue("totalDisplayStyle");
                    },
                    set: function(val1) {
                        this.setPropertyValue("totalDisplayStyle", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "totalAlignment", {
                    /**
         * An alignment for calculated total values.
         *
         * Possible values:
         *
         * - `"left"`
         * - `"center"`
         * - `"right"`
         * - `"auto"` (default) - Applies one of the values above based on the column's [cell type](#cellType).
         *
         * [View Demo](https://surveyjs.io/form-library/examples/aggregate-data-within-form/ (linkStyle))
         * @see totalType
         * @see totalFormat
         * @see totalCurrency
         * @see totalDisplayStyle
         */ get: function() {
                        return this.getPropertyValue("totalAlignment");
                    },
                    set: function(val1) {
                        this.setPropertyValue("totalAlignment", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "totalCurrency", {
                    /**
         * Specifies a currency used to display calculated total values. Applies only if [`totalDisplayStyle`](#totalDisplayStyle) is set to `"currency"`.
         * @see totalType
         */ get: function() {
                        return this.getPropertyValue("totalCurrency");
                    },
                    set: function(val1) {
                        if (Object(_question_expression__WEBPACK_IMPORTED_MODULE_2__["getCurrecyCodes"])().indexOf(val1) < 0) return;
                        this.setPropertyValue("totalCurrency", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "minWidth", {
                    /**
         * Gets or sets minimum column width in CSS values. By default, the matrix calculates column widths to optimally fit the content of all columns.
         * @see width
         */ get: function() {
                        return this.getPropertyValue("minWidth", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("minWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "width", {
                    /**
         * Gets or sets column width in CSS values. By default, the matrix calculates column widths to optimally fit the content of all columns.
         * @see minWidth
        */ get: function() {
                        return this.templateQuestion.width;
                    },
                    set: function(val1) {
                        this.templateQuestion.width = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDropdownColumn.prototype, "colCount", {
                    /**
         * Gets or sets the number of columns used to arrange choice options. Applies only to columns of `"checkbox"` or `"radiogroup"` [`cellType`](#cellType).
         *
         * Default value: -1 (inherits the actual value from the parent matrix's [`columnColCount`](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list#columnColCount) property)
         */ get: function() {
                        return this.getPropertyValue("colCount");
                    },
                    set: function(val1) {
                        if (val1 < -1 || val1 > 4) return;
                        this.setPropertyValue("colCount", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDropdownColumn.prototype.getLocale = function() {
                    return this.colOwner ? this.colOwner.getLocale() : "";
                };
                MatrixDropdownColumn.prototype.getMarkdownHtml = function(text, name) {
                    return this.colOwner ? this.colOwner.getMarkdownHtml(text, name) : undefined;
                };
                MatrixDropdownColumn.prototype.getRenderer = function(name) {
                    return !!this.colOwner ? this.colOwner.getRenderer(name) : null;
                };
                MatrixDropdownColumn.prototype.getRendererContext = function(locStr) {
                    return !!this.colOwner ? this.colOwner.getRendererContext(locStr) : locStr;
                };
                MatrixDropdownColumn.prototype.getProcessedText = function(text) {
                    return this.colOwner ? this.colOwner.getProcessedText(text) : text;
                };
                MatrixDropdownColumn.prototype.createCellQuestion = function(row) {
                    var qType = this.calcCellQuestionType(row);
                    var cellQuestion = this.createNewQuestion(qType);
                    this.callOnCellQuestionUpdate(cellQuestion, row);
                    return cellQuestion;
                };
                MatrixDropdownColumn.prototype.startLoadingFromJson = function(json) {
                    _super.prototype.startLoadingFromJson.call(this, json);
                    if (!!json && !json.cellType && !!json.choices) json.cellType = this.colOwner.getCellType();
                };
                MatrixDropdownColumn.prototype.updateCellQuestion = function(cellQuestion, data, onUpdateJson) {
                    if (onUpdateJson === void 0) onUpdateJson = null;
                    this.setQuestionProperties(cellQuestion, onUpdateJson);
                };
                MatrixDropdownColumn.prototype.callOnCellQuestionUpdate = function(cellQuestion, data) {
                    var qType = cellQuestion.getType();
                    var qDefinition = matrixDropdownColumnTypes[qType];
                    if (qDefinition && qDefinition["onCellQuestionUpdate"]) qDefinition["onCellQuestionUpdate"](cellQuestion, this, this.colOwner, data);
                };
                MatrixDropdownColumn.prototype.defaultCellTypeChanged = function() {
                    this.updateTemplateQuestion();
                };
                MatrixDropdownColumn.prototype.calcCellQuestionType = function(row) {
                    var cellType = this.getDefaultCellQuestionType();
                    if (!!row && !!this.colOwner) cellType = this.colOwner.getCustomCellType(this, row, cellType);
                    return cellType;
                };
                MatrixDropdownColumn.prototype.getDefaultCellQuestionType = function(cellType) {
                    if (!cellType) cellType = this.cellType;
                    if (cellType !== "default") return cellType;
                    if (this.colOwner) return this.colOwner.getCellType();
                    return _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].matrix.defaultCellType;
                };
                MatrixDropdownColumn.prototype.updateTemplateQuestion = function(newCellType) {
                    var _this = this;
                    var curCellType = this.getDefaultCellQuestionType(newCellType);
                    var prevCellType = this.templateQuestion ? this.templateQuestion.getType() : "";
                    if (curCellType === prevCellType) return;
                    if (this.templateQuestion) this.removeProperties(prevCellType);
                    this.templateQuestionValue = this.createNewQuestion(curCellType);
                    this.templateQuestion.locOwner = this;
                    this.addProperties(curCellType);
                    this.templateQuestion.onPropertyChanged.add(function(sender, options) {
                        _this.propertyValueChanged(options.name, options.oldValue, options.newValue);
                    });
                    this.templateQuestion.onItemValuePropertyChanged.add(function(sender, options) {
                        _this.doItemValuePropertyChanged(options.propertyName, options.obj, options.name, options.newValue, options.oldValue);
                    });
                    this.templateQuestion.isContentElement = true;
                    if (!this.isLoadingFromJson) this.templateQuestion.onGetSurvey = function() {
                        return _this.getSurvey();
                    };
                    this.templateQuestion.locTitle.strChanged();
                };
                MatrixDropdownColumn.prototype.createNewQuestion = function(cellType) {
                    var question = _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].createClass(cellType);
                    if (!question) question = _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].createClass("text");
                    question.loadingOwner = this;
                    question.isEditableTemplateElement = true;
                    question.autoOtherMode = this.isShowInMultipleColumns;
                    this.setQuestionProperties(question);
                    this.setParentQuestionToTemplate(question);
                    return question;
                };
                MatrixDropdownColumn.prototype.setParentQuestionToTemplate = function(question) {
                    if (!!this.colOwner && this.colOwner.isQuestion) question.setParentQuestion(this.colOwner);
                };
                MatrixDropdownColumn.prototype.setQuestionProperties = function(question, onUpdateJson) {
                    var _this = this;
                    if (onUpdateJson === void 0) onUpdateJson = null;
                    if (this.templateQuestion) {
                        var json = new _jsonobject__WEBPACK_IMPORTED_MODULE_0__["JsonObject"]().toJsonObject(this.templateQuestion, true);
                        if (onUpdateJson) onUpdateJson(json);
                        json.type = question.getType();
                        if (this.cellType === "default" && !!this.colOwner && this.colOwner.hasChoices()) delete json["choices"];
                        delete json["itemComponent"];
                        if (this.jsonObj) Object.keys(this.jsonObj).forEach(function(prop) {
                            json[prop] = _this.jsonObj[prop];
                        });
                        new _jsonobject__WEBPACK_IMPORTED_MODULE_0__["JsonObject"]().toObject(json, question);
                        question.isContentElement = this.templateQuestion.isContentElement;
                        this.previousChoicesId = undefined;
                        question.loadedChoicesFromServerCallback = function() {
                            if (!_this.isShowInMultipleColumns) return;
                            if (!!_this.previousChoicesId && _this.previousChoicesId !== question.id) return;
                            _this.previousChoicesId = question.id;
                            var choices = question.visibleChoices;
                            _this.templateQuestion.choices = choices;
                            _this.propertyValueChanged("choices", choices, choices);
                        };
                    }
                };
                MatrixDropdownColumn.prototype.propertyValueChanged = function(name, oldValue, newValue) {
                    _super.prototype.propertyValueChanged.call(this, name, oldValue, newValue);
                    if (name === "isRequired") this.updateIsRenderedRequired(newValue);
                    if (!this.colOwner || this.isLoadingFromJson) return;
                    if (this.isShowInMultipleColumns && [
                        "visibleChoices",
                        "choices"
                    ].indexOf(name) > -1) this.colOwner.onShowInMultipleColumnsChanged(this);
                    if (!_jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].hasOriginalProperty(this, name)) return;
                    this.colOwner.onColumnPropertyChanged(this, name, newValue);
                };
                MatrixDropdownColumn.prototype.doItemValuePropertyChanged = function(propertyName, obj, name, newValue, oldValue) {
                    if (!_jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].hasOriginalProperty(obj, name)) return;
                    if (this.colOwner != null && !this.isLoadingFromJson) this.colOwner.onColumnItemValuePropertyChanged(this, propertyName, obj, name, newValue, oldValue);
                };
                MatrixDropdownColumn.prototype.doShowInMultipleColumnsChanged = function() {
                    if (this.colOwner != null) this.colOwner.onShowInMultipleColumnsChanged(this);
                    if (this.templateQuestion) this.templateQuestion.autoOtherMode = this.isShowInMultipleColumns;
                };
                MatrixDropdownColumn.prototype.doColumnVisibilityChanged = function() {
                    if (this.colOwner != null && !this.isDesignMode) this.colOwner.onColumnVisibilityChanged(this);
                };
                MatrixDropdownColumn.prototype.getProperties = function(curCellType) {
                    return _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].getDynamicPropertiesByObj(this, curCellType);
                };
                MatrixDropdownColumn.prototype.removeProperties = function(curCellType) {
                    var properties = this.getProperties(curCellType);
                    for(var i = 0; i < properties.length; i++){
                        var prop = properties[i];
                        delete this[prop.name];
                        if (prop.serializationProperty) delete this[prop.serializationProperty];
                    }
                };
                MatrixDropdownColumn.prototype.addProperties = function(curCellType) {
                    var props = this.getProperties(curCellType);
                    _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addDynamicPropertiesIntoObj(this, this.templateQuestion, props);
                };
                return MatrixDropdownColumn;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("matrixdropdowncolumn", [
                {
                    name: "!name",
                    isUnique: true
                },
                {
                    name: "title",
                    serializationProperty: "locTitle",
                    dependsOn: "name",
                    onPropertyEditorUpdate: function(obj, editor) {
                        if (!!obj && !!editor) editor.placeholder = obj.name;
                    }
                },
                {
                    name: "cellHint",
                    serializationProperty: "locCellHint",
                    visible: false
                },
                {
                    name: "cellType",
                    default: "default",
                    choices: function() {
                        var res = MatrixDropdownColumn.getColumnTypes();
                        res.splice(0, 0, "default");
                        return res;
                    }
                },
                {
                    name: "colCount",
                    default: -1,
                    choices: [
                        -1,
                        0,
                        1,
                        2,
                        3,
                        4
                    ]
                },
                "isRequired:boolean",
                "isUnique:boolean",
                {
                    name: "requiredErrorText:text",
                    serializationProperty: "locRequiredErrorText"
                },
                "readOnly:boolean",
                {
                    name: "minWidth",
                    onPropertyEditorUpdate: function(obj, editor) {
                        if (!!obj && !!editor) editor.value = obj.minWidth;
                    }
                },
                "width",
                {
                    name: "visible:switch",
                    default: true,
                    overridingProperty: "visibleIf"
                },
                "visibleIf:condition",
                "enableIf:condition",
                "requiredIf:condition",
                "resetValueIf:condition",
                "setValueIf:condition",
                "setValueExpression:expression",
                {
                    name: "showInMultipleColumns:boolean",
                    dependsOn: "cellType",
                    visibleIf: function(obj) {
                        return obj.isSupportMultipleColumns;
                    }
                },
                {
                    name: "validators:validators",
                    baseClassName: "surveyvalidator",
                    classNamePart: "validator"
                },
                {
                    name: "totalType",
                    default: "none",
                    choices: [
                        "none",
                        "sum",
                        "count",
                        "min",
                        "max",
                        "avg"
                    ]
                },
                "totalExpression:expression",
                {
                    name: "totalFormat",
                    serializationProperty: "locTotalFormat"
                },
                {
                    name: "totalDisplayStyle",
                    default: "none",
                    choices: [
                        "none",
                        "decimal",
                        "currency",
                        "percent"
                    ]
                },
                {
                    name: "totalAlignment",
                    default: "auto",
                    choices: [
                        "auto",
                        "left",
                        "center",
                        "right"
                    ]
                },
                {
                    name: "totalCurrency",
                    choices: function() {
                        return Object(_question_expression__WEBPACK_IMPORTED_MODULE_2__["getCurrecyCodes"])();
                    },
                    default: "USD"
                },
                {
                    name: "totalMaximumFractionDigits:number",
                    default: -1
                },
                {
                    name: "totalMinimumFractionDigits:number",
                    default: -1
                },
                {
                    name: "renderAs",
                    default: "default",
                    visible: false
                }
            ], function() {
                return new MatrixDropdownColumn("");
            });
        /***/ },
        /***/ "./src/question_matrixdropdownrendered.ts": /*!************************************************!*\
  !*** ./src/question_matrixdropdownrendered.ts ***!
  \************************************************/ /*! exports provided: QuestionMatrixDropdownRenderedCell, QuestionMatrixDropdownRenderedRow, QuestionMatrixDropdownRenderedErrorRow, QuestionMatrixDropdownRenderedTable */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedCell", function() {
                return QuestionMatrixDropdownRenderedCell;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedRow", function() {
                return QuestionMatrixDropdownRenderedRow;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedErrorRow", function() {
                return QuestionMatrixDropdownRenderedErrorRow;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDropdownRenderedTable", function() {
                return QuestionMatrixDropdownRenderedTable;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./actions/adaptive-container */ "./src/actions/adaptive-container.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var __spreadArray = function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            var QuestionMatrixDropdownRenderedCell = /** @class */ function() {
                function QuestionMatrixDropdownRenderedCell() {
                    this.minWidth = "";
                    this.width = "";
                    this.colSpans = 1;
                    this.isActionsCell = false;
                    this.isErrorsCell = false;
                    this.isDragHandlerCell = false;
                    this.isDetailRowCell = false;
                    this.classNameValue = "";
                    this.idValue = QuestionMatrixDropdownRenderedCell.counter++;
                }
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "requiredText", {
                    get: function() {
                        return this.column && this.column.isRenderedRequired ? this.column.requiredText : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "hasQuestion", {
                    get: function() {
                        return !!this.question && !this.isErrorsCell;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "hasTitle", {
                    get: function() {
                        return !!this.locTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "hasPanel", {
                    get: function() {
                        return !!this.panel;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "id", {
                    get: function() {
                        return this.idValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "item", {
                    get: function() {
                        return this.itemValue;
                    },
                    set: function(val1) {
                        this.itemValue = val1;
                        if (!!val1) val1.hideCaption = true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "isChoice", {
                    get: function() {
                        return !!this.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "isItemChoice", {
                    get: function() {
                        return this.isChoice && !this.isOtherChoice;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "choiceValue", {
                    get: function() {
                        return this.isChoice ? this.item.value : null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "isCheckbox", {
                    get: function() {
                        return this.isItemChoice && this.question.isDescendantOf("checkbox");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "isRadio", {
                    get: function() {
                        return this.isItemChoice && this.question.isDescendantOf("radiogroup");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "isFirstChoice", {
                    get: function() {
                        return this.choiceIndex === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "className", {
                    get: function() {
                        var builder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.classNameValue);
                        if (this.hasQuestion) builder.append(this.question.cssClasses.hasError, this.question.errors.length > 0).append(this.question.cssClasses.answered, this.question.isAnswered);
                        return builder.toString();
                    },
                    set: function(val1) {
                        this.classNameValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "cellQuestionWrapperClassName", {
                    get: function() {
                        return this.cell.getQuestionWrapperClassName(this.matrix.cssClasses.cellQuestionWrapper);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedCell.prototype, "headers", {
                    get: function() {
                        if (this.cell && this.cell.column) {
                            if (this.matrix.IsMultiplyColumn(this.cell.column)) {
                                if (!!this.item) return this.item.locText.renderedHtml;
                                else return "";
                            }
                            var cellHint = this.cell.column.cellHint;
                            if (!!cellHint) {
                                if (cellHint.trim() === "") return "";
                                return this.cell.column.locCellHint.renderedHtml;
                            }
                            if (this.hasQuestion && this.question.isVisible && this.question.title) return this.question.title;
                            return this.cell.column.title;
                        }
                        if (this.hasQuestion && this.question.isVisible) return this.question.locTitle.renderedHtml;
                        if (this.hasTitle) return this.locTitle.renderedHtml || "";
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownRenderedCell.prototype.getTitle = function() {
                    return this.matrix && this.matrix.showHeader ? this.headers : "";
                };
                QuestionMatrixDropdownRenderedCell.prototype.calculateFinalClassName = function(matrixCssClasses) {
                    var questionCss = this.cell.question.cssClasses;
                    // 'text-align': $data.isChoice ? 'center':
                    var builder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(questionCss.itemValue, !!questionCss).append(questionCss.asCell, !!questionCss);
                    return builder.append(matrixCssClasses.cell, builder.isEmpty() && !!matrixCssClasses).append(matrixCssClasses.choiceCell, this.isChoice).toString();
                };
                QuestionMatrixDropdownRenderedCell.prototype.focusIn = function() {
                    if (this.question) this.question.focusIn();
                };
                QuestionMatrixDropdownRenderedCell.counter = 1;
                return QuestionMatrixDropdownRenderedCell;
            }();
            var QuestionMatrixDropdownRenderedRow = /** @class */ function(_super) {
                __extends(QuestionMatrixDropdownRenderedRow, _super);
                function QuestionMatrixDropdownRenderedRow(cssClasses, isDetailRow) {
                    if (isDetailRow === void 0) isDetailRow = false;
                    var _this = _super.call(this) || this;
                    _this.cssClasses = cssClasses;
                    _this.isDetailRow = isDetailRow;
                    _this.hasEndActions = false;
                    _this.isErrorsRow = false;
                    _this.cells = [];
                    _this.idValue = QuestionMatrixDropdownRenderedRow.counter++;
                    return _this;
                }
                Object.defineProperty(QuestionMatrixDropdownRenderedRow.prototype, "id", {
                    get: function() {
                        return this.idValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedRow.prototype, "attributes", {
                    get: function() {
                        if (!this.row) return {};
                        return {
                            "data-sv-drop-target-matrix-row": this.row.id
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedRow.prototype, "className", {
                    get: function() {
                        var _a, _b;
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.row).append(this.cssClasses.detailRow, this.isDetailRow).append(this.cssClasses.rowHasPanel, (_a = this.row) === null || _a === void 0 ? void 0 : _a.hasPanel).append(this.cssClasses.expandedRow, ((_b = this.row) === null || _b === void 0 ? void 0 : _b.isDetailPanelShowing) && !this.isDetailRow).append(this.cssClasses.rowHasEndActions, this.hasEndActions).append(this.cssClasses.ghostRow, this.isGhostRow).append(this.cssClasses.rowAdditional, this.isAdditionalClasses).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownRenderedRow.counter = 1;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], QuestionMatrixDropdownRenderedRow.prototype, "isGhostRow", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], QuestionMatrixDropdownRenderedRow.prototype, "isAdditionalClasses", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], QuestionMatrixDropdownRenderedRow.prototype, "visible", void 0);
                return QuestionMatrixDropdownRenderedRow;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
            var QuestionMatrixDropdownRenderedErrorRow = /** @class */ function(_super) {
                __extends(QuestionMatrixDropdownRenderedErrorRow, _super);
                function QuestionMatrixDropdownRenderedErrorRow(cssClasses) {
                    var _this = _super.call(this, cssClasses) || this;
                    _this.isErrorsRow = true;
                    return _this;
                }
                Object.defineProperty(QuestionMatrixDropdownRenderedErrorRow.prototype, "attributes", {
                    get: function() {
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedErrorRow.prototype, "className", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.row).append(this.cssClasses.errorRow).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownRenderedErrorRow.prototype.onAfterCreated = function() {
                    var _this = this;
                    var callback = function() {
                        _this.visible = _this.cells.some(function(cell) {
                            return cell.question && cell.question.hasVisibleErrors;
                        });
                    };
                    this.cells.forEach(function(cell) {
                        if (cell.question) cell.question.registerFunctionOnPropertyValueChanged("hasVisibleErrors", callback);
                    });
                    callback();
                };
                return QuestionMatrixDropdownRenderedErrorRow;
            }(QuestionMatrixDropdownRenderedRow);
            var QuestionMatrixDropdownRenderedTable = /** @class */ function(_super) {
                __extends(QuestionMatrixDropdownRenderedTable, _super);
                function QuestionMatrixDropdownRenderedTable(matrix) {
                    var _this = _super.call(this) || this;
                    _this.matrix = matrix;
                    _this.renderedRowsChangedCallback = function() {};
                    _this.hasActionCellInRowsValues = {};
                    _this.build();
                    return _this;
                }
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showTable", {
                    get: function() {
                        return this.getPropertyValue("showTable", true);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showHeader", {
                    get: function() {
                        return this.getPropertyValue("showHeader");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showAddRow", {
                    get: function() {
                        return this.getPropertyValue("showAddRow", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showAddRowOnTop", {
                    get: function() {
                        return this.getPropertyValue("showAddRowOnTop", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showAddRowOnBottom", {
                    get: function() {
                        return this.getPropertyValue("showAddRowOnBottom", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showFooter", {
                    get: function() {
                        return this.matrix.hasFooter && this.matrix.isColumnLayoutHorizontal;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "hasFooter", {
                    get: function() {
                        return !!this.footerRow;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "hasRemoveRows", {
                    get: function() {
                        return this.hasRemoveRowsValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownRenderedTable.prototype.isRequireReset = function() {
                    return this.hasRemoveRows != this.matrix.canRemoveRows || !this.matrix.isColumnLayoutHorizontal;
                };
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "headerRow", {
                    get: function() {
                        return this.headerRowValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "footerRow", {
                    get: function() {
                        return this.footerRowValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "isRowsDragAndDrop", {
                    get: function() {
                        return this.matrix.isRowsDragAndDrop && this.matrix.isColumnLayoutHorizontal;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showCellErrorsTop", {
                    get: function() {
                        //todo
                        return this.matrix.getErrorLocation() === "top";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showCellErrorsBottom", {
                    get: function() {
                        //todo
                        return this.matrix.getErrorLocation() === "bottom";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownRenderedTable.prototype.build = function() {
                    this.hasRemoveRowsValue = this.matrix.canRemoveRows;
                    //build rows now
                    var rows = this.matrix.visibleRows;
                    this.cssClasses = this.matrix.cssClasses;
                    this.buildRowsActions();
                    this.buildHeader();
                    this.buildRows();
                    this.buildFooter();
                    this.updateShowTableAndAddRow();
                };
                QuestionMatrixDropdownRenderedTable.prototype.updateShowTableAndAddRow = function() {
                    var showTable = this.rows.length > 0 || this.matrix.isDesignMode || !this.matrix.getShowColumnsIfEmpty();
                    this.setPropertyValue("showTable", showTable);
                    var showAddRow = this.matrix.canAddRow && showTable;
                    var showAddRowOnTop = showAddRow;
                    var showAddRowOnBottom = showAddRow;
                    if (showAddRowOnTop) {
                        if (this.matrix.getAddRowLocation() === "default") showAddRowOnTop = !this.matrix.isColumnLayoutHorizontal;
                        else showAddRowOnTop = this.matrix.getAddRowLocation() !== "bottom";
                    }
                    if (showAddRowOnBottom && this.matrix.getAddRowLocation() !== "topBottom") showAddRowOnBottom = !showAddRowOnTop;
                    this.setPropertyValue("showAddRow", this.matrix.canAddRow);
                    this.setPropertyValue("showAddRowOnTop", showAddRowOnTop);
                    this.setPropertyValue("showAddRowOnBottom", showAddRowOnBottom);
                };
                QuestionMatrixDropdownRenderedTable.prototype.onAddedRow = function(row, index) {
                    if (this.getRenderedDataRowCount() >= this.matrix.visibleRows.length) return;
                    var rowIndex = this.getRenderedRowIndexByIndex(index);
                    this.rowsActions.splice(index, 0, this.buildRowActions(row));
                    this.addHorizontalRow(this.rows, row, this.matrix.visibleRows.length == 1 && !this.matrix.showHeader, rowIndex);
                    this.updateShowTableAndAddRow();
                };
                QuestionMatrixDropdownRenderedTable.prototype.getRenderedRowIndexByIndex = function(index) {
                    var res = 0;
                    var dataRowIndex = 0;
                    for(var i = 0; i < this.rows.length; i++){
                        if (dataRowIndex === index) {
                            if (this.rows[i].isErrorsRow || this.rows[i].isDetailRow) res++;
                            break;
                        }
                        res++;
                        if (!this.rows[i].isErrorsRow && !this.rows[i].isDetailRow) dataRowIndex++;
                    }
                    if (dataRowIndex < index) return this.rows.length;
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.getRenderedDataRowCount = function() {
                    var res = 0;
                    for(var i = 0; i < this.rows.length; i++)if (!this.rows[i].isErrorsRow && !this.rows[i].isDetailRow) res++;
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.onRemovedRow = function(row) {
                    var rowIndex = this.getRenderedRowIndex(row);
                    if (rowIndex < 0) return;
                    this.rowsActions.splice(rowIndex, 1);
                    var removeCount = 1;
                    if (rowIndex < this.rows.length - 1 && this.showCellErrorsBottom && this.rows[rowIndex + 1].isErrorsRow) removeCount++;
                    if (rowIndex < this.rows.length - 1 && (this.rows[rowIndex + 1].isDetailRow || this.showCellErrorsBottom && rowIndex + 1 < this.rows.length - 1 && this.rows[rowIndex + 2].isDetailRow)) removeCount++;
                    if (rowIndex > 0 && this.showCellErrorsTop && this.rows[rowIndex - 1].isErrorsRow) {
                        rowIndex--;
                        removeCount++;
                    }
                    this.rows.splice(rowIndex, removeCount);
                    this.updateShowTableAndAddRow();
                };
                QuestionMatrixDropdownRenderedTable.prototype.onDetailPanelChangeVisibility = function(row, isShowing) {
                    var rowIndex = this.getRenderedRowIndex(row);
                    if (rowIndex < 0) return;
                    var currentIndex = rowIndex;
                    if (this.showCellErrorsBottom) currentIndex++;
                    var panelRowIndex = currentIndex < this.rows.length - 1 && this.rows[currentIndex + 1].isDetailRow ? currentIndex + 1 : -1;
                    if (isShowing && panelRowIndex > -1 || !isShowing && panelRowIndex < 0) return;
                    if (isShowing) {
                        var detailRow = this.createDetailPanelRow(row, this.rows[rowIndex]);
                        this.rows.splice(currentIndex + 1, 0, detailRow);
                    } else this.rows.splice(panelRowIndex, 1);
                };
                QuestionMatrixDropdownRenderedTable.prototype.getRenderedRowIndex = function(row) {
                    for(var i = 0; i < this.rows.length; i++){
                        if (this.rows[i].row == row) return i;
                    }
                    return -1;
                };
                QuestionMatrixDropdownRenderedTable.prototype.buildRowsActions = function() {
                    this.rowsActions = [];
                    var rows = this.matrix.visibleRows;
                    for(var i = 0; i < rows.length; i++)this.rowsActions.push(this.buildRowActions(rows[i]));
                };
                QuestionMatrixDropdownRenderedTable.prototype.createRenderedRow = function(cssClasses, isDetailRow) {
                    if (isDetailRow === void 0) isDetailRow = false;
                    return new QuestionMatrixDropdownRenderedRow(cssClasses, isDetailRow);
                };
                QuestionMatrixDropdownRenderedTable.prototype.createErrorRenderedRow = function(cssClasses) {
                    return new QuestionMatrixDropdownRenderedErrorRow(cssClasses);
                };
                QuestionMatrixDropdownRenderedTable.prototype.buildHeader = function() {
                    var colHeaders = this.matrix.isColumnLayoutHorizontal && this.matrix.showHeader;
                    var isShown = colHeaders || this.matrix.hasRowText && !this.matrix.isColumnLayoutHorizontal;
                    this.setPropertyValue("showHeader", isShown);
                    if (!isShown) return;
                    this.headerRowValue = this.createRenderedRow(this.cssClasses);
                    if (this.isRowsDragAndDrop) this.headerRow.cells.push(this.createHeaderCell(null, "action"));
                    if (this.hasActionCellInRows("start")) this.headerRow.cells.push(this.createHeaderCell(null, "action"));
                    if (this.matrix.hasRowText && this.matrix.showHeader) this.headerRow.cells.push(this.createHeaderCell(null));
                    if (this.matrix.isColumnLayoutHorizontal) for(var i = 0; i < this.matrix.visibleColumns.length; i++){
                        var column = this.matrix.visibleColumns[i];
                        if (!column.isColumnVisible) continue;
                        if (this.matrix.IsMultiplyColumn(column)) this.createMutlipleColumnsHeader(column);
                        else this.headerRow.cells.push(this.createHeaderCell(column));
                    }
                    else {
                        var rows = this.matrix.visibleRows;
                        for(var i = 0; i < rows.length; i++){
                            var cell = this.createTextCell(rows[i].locText);
                            this.setHeaderCellCssClasses(cell);
                            cell.row = rows[i];
                            this.headerRow.cells.push(cell);
                        }
                        if (this.matrix.hasFooter) {
                            var cell = this.createTextCell(this.matrix.getFooterText());
                            this.setHeaderCellCssClasses(cell);
                            this.headerRow.cells.push(cell);
                        }
                    }
                    if (this.hasActionCellInRows("end")) this.headerRow.cells.push(this.createHeaderCell(null, "action"));
                };
                QuestionMatrixDropdownRenderedTable.prototype.buildFooter = function() {
                    if (!this.showFooter) return;
                    this.footerRowValue = this.createRenderedRow(this.cssClasses);
                    if (this.isRowsDragAndDrop) this.footerRow.cells.push(this.createHeaderCell(null));
                    if (this.hasActionCellInRows("start")) this.footerRow.cells.push(this.createHeaderCell(null, "action"));
                    if (this.matrix.hasRowText) {
                        var cell_1 = this.createTextCell(this.matrix.getFooterText());
                        cell_1.className = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(cell_1.className).append(this.cssClasses.footerTotalCell).toString();
                        this.footerRow.cells.push(cell_1);
                    }
                    var cells = this.matrix.visibleTotalRow.cells;
                    for(var i = 0; i < cells.length; i++){
                        var cell = cells[i];
                        if (!cell.column.isColumnVisible) continue;
                        if (this.matrix.IsMultiplyColumn(cell.column)) this.createMutlipleColumnsFooter(this.footerRow, cell);
                        else {
                            var editCell = this.createEditCell(cell);
                            if (cell.column) this.setHeaderCellWidth(cell.column, editCell);
                            editCell.className = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(editCell.className).append(this.cssClasses.footerCell).toString();
                            this.footerRow.cells.push(editCell);
                        }
                    }
                    if (this.hasActionCellInRows("end")) this.footerRow.cells.push(this.createHeaderCell(null, "action"));
                };
                QuestionMatrixDropdownRenderedTable.prototype.buildRows = function() {
                    var rows = this.matrix.isColumnLayoutHorizontal ? this.buildHorizontalRows() : this.buildVerticalRows();
                    this.rows = rows;
                };
                QuestionMatrixDropdownRenderedTable.prototype.hasActionCellInRows = function(location) {
                    if (this.hasActionCellInRowsValues[location] === undefined) this.hasActionCellInRowsValues[location] = this.hasActionsCellInLocaltion(location);
                    return this.hasActionCellInRowsValues[location];
                };
                QuestionMatrixDropdownRenderedTable.prototype.hasActionsCellInLocaltion = function(location) {
                    var _this = this;
                    if (location == "end" && this.hasRemoveRows) return true;
                    return this.matrix.visibleRows.some(function(row, index) {
                        return !_this.isValueEmpty(_this.getRowActions(index, location));
                    });
                };
                QuestionMatrixDropdownRenderedTable.prototype.canRemoveRow = function(row) {
                    return this.matrix.canRemoveRow(row);
                };
                QuestionMatrixDropdownRenderedTable.prototype.buildHorizontalRows = function() {
                    var rows = this.matrix.visibleRows;
                    var renderedRows = [];
                    for(var i = 0; i < rows.length; i++)this.addHorizontalRow(renderedRows, rows[i], i == 0 && !this.matrix.showHeader);
                    return renderedRows;
                };
                QuestionMatrixDropdownRenderedTable.prototype.addHorizontalRow = function(renderedRows, row, useAsHeader, index) {
                    if (index === void 0) index = -1;
                    var renderedRow = this.createHorizontalRow(row, useAsHeader);
                    var errorRow = this.createErrorRow(renderedRow);
                    renderedRow.row = row;
                    if (index < 0) index = renderedRows.length;
                    if (this.matrix.isMobile) {
                        var cells = [];
                        for(var i = 0; i < renderedRow.cells.length; i++){
                            if (this.showCellErrorsTop && !errorRow.cells[i].isEmpty) cells.push(errorRow.cells[i]);
                            cells.push(renderedRow.cells[i]);
                            if (this.showCellErrorsBottom && !errorRow.cells[i].isEmpty) cells.push(errorRow.cells[i]);
                        }
                        renderedRow.cells = cells;
                        renderedRows.splice(index, 0, renderedRow);
                    } else {
                        renderedRows.splice.apply(renderedRows, __spreadArray([
                            index,
                            0
                        ], this.showCellErrorsTop ? [
                            errorRow,
                            renderedRow
                        ] : [
                            renderedRow,
                            errorRow
                        ]));
                        index++;
                    }
                    if (row.isDetailPanelShowing) renderedRows.splice(index + 1, 0, this.createDetailPanelRow(row, renderedRow));
                };
                QuestionMatrixDropdownRenderedTable.prototype.getRowDragCell = function(rowIndex) {
                    var cell = new QuestionMatrixDropdownRenderedCell();
                    cell.isDragHandlerCell = true;
                    cell.className = this.getActionsCellClassName(cell);
                    cell.row = this.matrix.visibleRows[rowIndex];
                    return cell;
                };
                QuestionMatrixDropdownRenderedTable.prototype.getActionsCellClassName = function(cell) {
                    var _this = this;
                    if (cell === void 0) cell = null;
                    var classBuilder = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.actionsCell).append(this.cssClasses.actionsCellDrag, cell === null || cell === void 0 ? void 0 : cell.isDragHandlerCell).append(this.cssClasses.detailRowCell, cell === null || cell === void 0 ? void 0 : cell.isDetailRowCell).append(this.cssClasses.verticalCell, !this.matrix.isColumnLayoutHorizontal);
                    if (cell.isActionsCell) {
                        var actions = cell.item.value.actions;
                        if (this.cssClasses.actionsCellPrefix) actions.forEach(function(action) {
                            classBuilder.append(_this.cssClasses.actionsCellPrefix + "--" + action.id);
                        });
                    }
                    return classBuilder.toString();
                };
                QuestionMatrixDropdownRenderedTable.prototype.getRowActionsCell = function(rowIndex, location, isDetailRow) {
                    if (isDetailRow === void 0) isDetailRow = false;
                    var rowActions = this.getRowActions(rowIndex, location);
                    if (!this.isValueEmpty(rowActions)) {
                        var cell = new QuestionMatrixDropdownRenderedCell();
                        var actionContainer = this.matrix.allowAdaptiveActions ? new _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_4__["AdaptiveActionContainer"]() : new _actions_container__WEBPACK_IMPORTED_MODULE_6__["ActionContainer"]();
                        if (!!this.matrix.survey && this.matrix.survey.getCss().actionBar) actionContainer.cssClasses = this.matrix.survey.getCss().actionBar;
                        actionContainer.setItems(rowActions);
                        var itemValue = new _itemvalue__WEBPACK_IMPORTED_MODULE_2__["ItemValue"](actionContainer);
                        cell.item = itemValue;
                        cell.isActionsCell = true;
                        cell.isDragHandlerCell = false;
                        cell.isDetailRowCell = isDetailRow;
                        cell.className = this.getActionsCellClassName(cell);
                        cell.row = this.matrix.visibleRows[rowIndex];
                        return cell;
                    }
                    return null;
                };
                QuestionMatrixDropdownRenderedTable.prototype.getRowActions = function(rowIndex, location) {
                    var actions = this.rowsActions[rowIndex];
                    if (!Array.isArray(actions)) return [];
                    return actions.filter(function(action) {
                        if (!action.location) action.location = "start";
                        return action.location === location;
                    });
                };
                QuestionMatrixDropdownRenderedTable.prototype.buildRowActions = function(row) {
                    var actions = [];
                    this.setDefaultRowActions(row, actions);
                    if (!!this.matrix.survey) actions = this.matrix.survey.getUpdatedMatrixRowActions(this.matrix, row, actions);
                    return actions;
                };
                Object.defineProperty(QuestionMatrixDropdownRenderedTable.prototype, "showRemoveButtonAsIcon", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_7__["settings"].matrix.renderRemoveAsIcon && this.matrix.survey && this.matrix.survey.css.root === "sd-root-modern";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDropdownRenderedTable.prototype.setDefaultRowActions = function(row, actions) {
                    var _this = this;
                    var matrix = this.matrix;
                    if (this.hasRemoveRows && this.canRemoveRow(row)) {
                        if (!this.showRemoveButtonAsIcon) actions.push(new _actions_action__WEBPACK_IMPORTED_MODULE_3__["Action"]({
                            id: "remove-row",
                            location: "end",
                            enabled: !this.matrix.isInputReadOnly,
                            component: "sv-matrix-remove-button",
                            data: {
                                row: row,
                                question: this.matrix
                            }
                        }));
                        else actions.push(new _actions_action__WEBPACK_IMPORTED_MODULE_3__["Action"]({
                            id: "remove-row",
                            iconName: "icon-delete",
                            iconSize: "auto",
                            component: "sv-action-bar-item",
                            innerCss: new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.matrix.cssClasses.button).append(this.matrix.cssClasses.buttonRemove).toString(),
                            location: "end",
                            showTitle: false,
                            title: matrix.removeRowText,
                            enabled: !matrix.isInputReadOnly,
                            data: {
                                row: row,
                                question: matrix
                            },
                            action: function() {
                                matrix.removeRowUI(row);
                            }
                        }));
                    }
                    if (row.hasPanel) {
                        if (this.matrix.isMobile) actions.unshift(new _actions_action__WEBPACK_IMPORTED_MODULE_3__["Action"]({
                            id: "show-detail-mobile",
                            title: "Show Details",
                            showTitle: true,
                            location: "end",
                            action: function(context) {
                                context.title = row.isDetailPanelShowing ? _this.matrix.getLocalizationString("showDetails") : _this.matrix.getLocalizationString("hideDetails");
                                row.showHideDetailPanelClick();
                            }
                        }));
                        else actions.push(new _actions_action__WEBPACK_IMPORTED_MODULE_3__["Action"]({
                            id: "show-detail",
                            title: this.matrix.getLocalizationString("editText"),
                            showTitle: false,
                            location: "start",
                            component: "sv-matrix-detail-button",
                            data: {
                                row: row,
                                question: this.matrix
                            }
                        }));
                    }
                };
                QuestionMatrixDropdownRenderedTable.prototype.createErrorRow = function(row) {
                    var res = this.createErrorRenderedRow(this.cssClasses);
                    for(var i = 0; i < row.cells.length; i++){
                        var cell = row.cells[i];
                        if (!cell.hasQuestion) res.cells.push(this.createEmptyCell(true));
                        else if (this.matrix.IsMultiplyColumn(cell.cell.column)) {
                            if (cell.isFirstChoice) res.cells.push(this.createErrorCell(cell.cell));
                            else res.cells.push(this.createEmptyCell(true));
                        } else res.cells.push(this.createErrorCell(cell.cell));
                    }
                    res.onAfterCreated();
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.createHorizontalRow = function(row, useAsHeader) {
                    var res = this.createRenderedRow(this.cssClasses);
                    if (this.isRowsDragAndDrop) {
                        var rowIndex = this.matrix.visibleRows.indexOf(row);
                        res.cells.push(this.getRowDragCell(rowIndex));
                    }
                    this.addRowActionsCell(row, res, "start");
                    if (this.matrix.hasRowText) {
                        var renderedCell = this.createTextCell(row.locText);
                        renderedCell.row = row;
                        res.cells.push(renderedCell);
                        this.setHeaderCellWidth(null, renderedCell);
                        renderedCell.className = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(renderedCell.className).append(this.cssClasses.rowTextCell).append(this.cssClasses.columnTitleCell, !this.matrix.isColumnLayoutHorizontal).append(this.cssClasses.detailRowText, row.hasPanel).toString();
                    }
                    for(var i = 0; i < row.cells.length; i++){
                        var cell = row.cells[i];
                        if (!cell.column.isColumnVisible) continue;
                        if (this.matrix.IsMultiplyColumn(cell.column)) this.createMutlipleEditCells(res, cell);
                        else {
                            if (cell.column.isShowInMultipleColumns) cell.question.visibleChoices.map(function(c) {
                                return c.hideCaption = false;
                            });
                            var renderedCell = this.createEditCell(cell);
                            res.cells.push(renderedCell);
                            if (useAsHeader) this.setHeaderCellWidth(cell.column, renderedCell);
                        }
                    }
                    this.addRowActionsCell(row, res, "end");
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.addRowActionsCell = function(row, renderedRow, location) {
                    var rowIndex = this.matrix.visibleRows.indexOf(row);
                    if (this.hasActionCellInRows(location)) {
                        var actions = this.getRowActionsCell(rowIndex, location, renderedRow.isDetailRow);
                        if (!!actions) {
                            renderedRow.cells.push(actions);
                            renderedRow.hasEndActions = true;
                        } else {
                            var cell = new QuestionMatrixDropdownRenderedCell();
                            cell.isEmpty = true;
                            cell.isDetailRowCell = renderedRow.isDetailRow;
                            renderedRow.cells.push(cell);
                        }
                    }
                };
                QuestionMatrixDropdownRenderedTable.prototype.createDetailPanelRow = function(row, renderedRow) {
                    var panelFullWidth = this.matrix.isDesignMode;
                    var res = this.createRenderedRow(this.cssClasses, true);
                    res.row = row;
                    var buttonCell = new QuestionMatrixDropdownRenderedCell();
                    if (this.matrix.hasRowText) buttonCell.colSpans = 2;
                    buttonCell.isEmpty = true;
                    if (!panelFullWidth) res.cells.push(buttonCell);
                    var actionsCell = null;
                    if (this.hasActionCellInRows("end")) {
                        actionsCell = new QuestionMatrixDropdownRenderedCell();
                        actionsCell.isEmpty = true;
                    }
                    var cell = new QuestionMatrixDropdownRenderedCell();
                    cell.panel = row.detailPanel;
                    cell.colSpans = renderedRow.cells.length - (!panelFullWidth ? buttonCell.colSpans : 0) - (!!actionsCell ? actionsCell.colSpans : 0);
                    cell.className = this.cssClasses.detailPanelCell;
                    res.cells.push(cell);
                    if (!!actionsCell) {
                        if (this.matrix.isMobile) this.addRowActionsCell(row, res, "end");
                        else res.cells.push(actionsCell);
                    }
                    if (typeof this.matrix.onCreateDetailPanelRenderedRowCallback === "function") this.matrix.onCreateDetailPanelRenderedRowCallback(res);
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.buildVerticalRows = function() {
                    var columns = this.matrix.columns;
                    var renderedRows = [];
                    for(var i = 0; i < columns.length; i++){
                        var col = columns[i];
                        if (col.isColumnVisible) {
                            if (this.matrix.IsMultiplyColumn(col)) this.createMutlipleVerticalRows(renderedRows, col, i);
                            else {
                                var renderedRow = this.createVerticalRow(col, i);
                                var errorRow = this.createErrorRow(renderedRow);
                                if (this.showCellErrorsTop) {
                                    renderedRows.push(errorRow);
                                    renderedRows.push(renderedRow);
                                } else {
                                    renderedRows.push(renderedRow);
                                    renderedRows.push(errorRow);
                                }
                            }
                        }
                    }
                    if (this.hasActionCellInRows("end")) renderedRows.push(this.createEndVerticalActionRow());
                    return renderedRows;
                };
                QuestionMatrixDropdownRenderedTable.prototype.createMutlipleVerticalRows = function(renderedRows, column, index) {
                    var choices = this.getMultipleColumnChoices(column);
                    if (!choices) return;
                    for(var i = 0; i < choices.length; i++){
                        var renderedRow = this.createVerticalRow(column, index, choices[i], i);
                        var errorRow = this.createErrorRow(renderedRow);
                        if (this.showCellErrorsTop) {
                            renderedRows.push(errorRow);
                            renderedRows.push(renderedRow);
                        } else {
                            renderedRows.push(renderedRow);
                            renderedRows.push(errorRow);
                        }
                    }
                };
                QuestionMatrixDropdownRenderedTable.prototype.createVerticalRow = function(column, index, choice, choiceIndex) {
                    if (choice === void 0) choice = null;
                    if (choiceIndex === void 0) choiceIndex = -1;
                    var res = this.createRenderedRow(this.cssClasses);
                    if (this.matrix.showHeader) {
                        var lTitle = !!choice ? choice.locText : column.locTitle;
                        var hCell = this.createTextCell(lTitle);
                        hCell.column = column;
                        hCell.className = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(hCell.className).append(this.cssClasses.rowTextCell).append(this.cssClasses.columnTitleCell).toString();
                        res.cells.push(hCell);
                    }
                    var rows = this.matrix.visibleRows;
                    for(var i = 0; i < rows.length; i++){
                        var rChoice = choice;
                        var rChoiceIndex = choiceIndex >= 0 ? choiceIndex : i;
                        var cell = rows[i].cells[index];
                        var visChoices = !!choice ? cell.question.visibleChoices : undefined;
                        if (!!visChoices && rChoiceIndex < visChoices.length) rChoice = visChoices[rChoiceIndex];
                        var rCell = this.createEditCell(cell, rChoice);
                        rCell.item = rChoice;
                        rCell.choiceIndex = rChoiceIndex;
                        res.cells.push(rCell);
                    }
                    if (this.matrix.hasTotal) res.cells.push(this.createEditCell(this.matrix.visibleTotalRow.cells[index]));
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.createEndVerticalActionRow = function() {
                    var res = this.createRenderedRow(this.cssClasses);
                    if (this.matrix.showHeader) res.cells.push(this.createEmptyCell());
                    var rows = this.matrix.visibleRows;
                    for(var i = 0; i < rows.length; i++)res.cells.push(this.getRowActionsCell(i, "end"));
                    if (this.matrix.hasTotal) res.cells.push(this.createEmptyCell());
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.createMutlipleEditCells = function(rRow, cell, isFooter) {
                    if (isFooter === void 0) isFooter = false;
                    var choices = isFooter ? this.getMultipleColumnChoices(cell.column) : cell.question.visibleChoices;
                    if (!choices) return;
                    for(var i = 0; i < choices.length; i++){
                        var rCell = this.createEditCell(cell, !isFooter ? choices[i] : undefined);
                        if (!isFooter) {
                            //rCell.item = choices[i];
                            this.setItemCellCssClasses(rCell);
                            rCell.choiceIndex = i;
                        }
                        rRow.cells.push(rCell);
                    }
                };
                QuestionMatrixDropdownRenderedTable.prototype.setItemCellCssClasses = function(cell) {
                    cell.className = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.cell).append(this.cssClasses.itemCell).append(this.cssClasses.radioCell, cell.isRadio).append(this.cssClasses.checkboxCell, cell.isCheckbox).toString();
                };
                QuestionMatrixDropdownRenderedTable.prototype.createEditCell = function(cell, choiceItem) {
                    if (choiceItem === void 0) choiceItem = undefined;
                    var res = new QuestionMatrixDropdownRenderedCell();
                    res.cell = cell;
                    res.row = cell.row;
                    res.question = cell.question;
                    res.matrix = this.matrix;
                    res.item = choiceItem;
                    res.isOtherChoice = !!choiceItem && !!cell.question && cell.question.otherItem === choiceItem;
                    res.className = res.calculateFinalClassName(this.cssClasses);
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.createErrorCell = function(cell, choiceItem) {
                    if (choiceItem === void 0) choiceItem = undefined;
                    var res = new QuestionMatrixDropdownRenderedCell();
                    res.question = cell.question;
                    res.row = cell.row;
                    res.matrix = this.matrix;
                    res.isErrorsCell = true;
                    res.className = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.cell).append(this.cssClasses.errorsCell).append(this.cssClasses.errorsCellTop, this.showCellErrorsTop).append(this.cssClasses.errorsCellBottom, this.showCellErrorsBottom).toString();
                    return res;
                };
                QuestionMatrixDropdownRenderedTable.prototype.createMutlipleColumnsFooter = function(rRow, cell) {
                    this.createMutlipleEditCells(rRow, cell, true);
                };
                QuestionMatrixDropdownRenderedTable.prototype.createMutlipleColumnsHeader = function(column) {
                    var choices = this.getMultipleColumnChoices(column);
                    if (!choices) return;
                    for(var i = 0; i < choices.length; i++){
                        var cell = this.createTextCell(choices[i].locText);
                        this.setHeaderCell(column, cell);
                        this.setHeaderCellCssClasses(cell);
                        this.headerRow.cells.push(cell);
                    }
                };
                QuestionMatrixDropdownRenderedTable.prototype.getMultipleColumnChoices = function(column) {
                    var choices = column.templateQuestion.choices;
                    if (!!choices && Array.isArray(choices) && choices.length == 0) return this.matrix.choices;
                    choices = column.getVisibleMultipleChoices();
                    if (!choices || !Array.isArray(choices)) return null;
                    return choices;
                };
                QuestionMatrixDropdownRenderedTable.prototype.setHeaderCellCssClasses = function(cell, cellType) {
                    cell.className = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.headerCell).append(this.cssClasses.columnTitleCell, this.matrix.isColumnLayoutHorizontal).append(this.cssClasses.emptyCell, !!cell.isEmpty).append(this.cssClasses.cell + "--" + cellType, !!cellType).toString();
                };
                QuestionMatrixDropdownRenderedTable.prototype.createHeaderCell = function(column, cellType) {
                    if (cellType === void 0) cellType = null;
                    var cell = !!column ? this.createTextCell(column.locTitle) : this.createEmptyCell();
                    cell.column = column;
                    this.setHeaderCell(column, cell);
                    if (!cellType) cellType = !!column && column.cellType !== "default" ? column.cellType : this.matrix.cellType;
                    this.setHeaderCellCssClasses(cell, cellType);
                    return cell;
                };
                QuestionMatrixDropdownRenderedTable.prototype.setHeaderCell = function(column, cell) {
                    this.setHeaderCellWidth(column, cell);
                };
                QuestionMatrixDropdownRenderedTable.prototype.setHeaderCellWidth = function(column, cell) {
                    cell.minWidth = column != null ? this.matrix.getColumnWidth(column) : this.matrix.getRowTitleWidth();
                    cell.width = column != null ? column.width : this.matrix.getRowTitleWidth();
                };
                QuestionMatrixDropdownRenderedTable.prototype.createTextCell = function(locTitle) {
                    var cell = new QuestionMatrixDropdownRenderedCell();
                    cell.locTitle = locTitle;
                    if (!!locTitle) locTitle.strChanged();
                    if (!!this.cssClasses.cell) cell.className = this.cssClasses.cell;
                    return cell;
                };
                QuestionMatrixDropdownRenderedTable.prototype.createEmptyCell = function(isError) {
                    if (isError === void 0) isError = false;
                    var res = this.createTextCell(null);
                    res.isEmpty = true;
                    res.className = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.cell).append(this.cssClasses.emptyCell).append(this.cssClasses.errorsCell, isError).toString();
                    return res;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["propertyArray"])({
                        onPush: function(_, i, target) {
                            target.renderedRowsChangedCallback();
                        }
                    })
                ], QuestionMatrixDropdownRenderedTable.prototype, "rows", void 0);
                return QuestionMatrixDropdownRenderedTable;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
        /***/ },
        /***/ "./src/question_matrixdynamic.ts": /*!***************************************!*\
  !*** ./src/question_matrixdynamic.ts ***!
  \***************************************/ /*! exports provided: MatrixDynamicRowModel, QuestionMatrixDynamicModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixDynamicRowModel", function() {
                return MatrixDynamicRowModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMatrixDynamicModel", function() {
                return QuestionMatrixDynamicModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_matrixdropdownbase */ "./src/question_matrixdropdownbase.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _dragdrop_matrix_rows__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./dragdrop/matrix-rows */ "./src/dragdrop/matrix-rows.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./question_matrixdropdownrendered */ "./src/question_matrixdropdownrendered.ts");
            /* harmony import */ var _utils_dragOrClickHelper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utils/dragOrClickHelper */ "./src/utils/dragOrClickHelper.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var MatrixDynamicRowModel = /** @class */ function(_super) {
                __extends(MatrixDynamicRowModel, _super);
                function MatrixDynamicRowModel(index, data, value) {
                    var _this = _super.call(this, data, value) || this;
                    _this.index = index;
                    _this.buildCells(value);
                    return _this;
                }
                Object.defineProperty(MatrixDynamicRowModel.prototype, "rowName", {
                    get: function() {
                        return this.id;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDynamicRowModel.prototype, "dataName", {
                    get: function() {
                        return "row" + (this.index + 1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixDynamicRowModel.prototype, "text", {
                    get: function() {
                        return "row " + (this.index + 1);
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixDynamicRowModel.prototype.getAccessbilityText = function() {
                    return (this.index + 1).toString();
                };
                Object.defineProperty(MatrixDynamicRowModel.prototype, "shortcutText", {
                    get: function() {
                        var matrix = this.data;
                        var index = matrix.visibleRows.indexOf(this) + 1;
                        var questionValue1 = this.cells.length > 1 ? this.cells[1]["questionValue"] : undefined;
                        var questionValue0 = this.cells.length > 0 ? this.cells[0]["questionValue"] : undefined;
                        return questionValue1 && questionValue1.value || questionValue0 && questionValue0.value || "" + index;
                    },
                    enumerable: false,
                    configurable: true
                });
                return MatrixDynamicRowModel;
            }(_question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_2__["MatrixDropdownRowModelBase"]);
            /**
  * A class that describes the Dynamic Matrix question type.
  *
  * Dynamic Matrix allows respondents to add and delete matrix rows. You can use the [Dropdown](https://surveyjs.io/form-library/documentation/questiondropdownmodel), [Checkbox](https://surveyjs.io/form-library/documentation/questioncheckboxmodel), [Radiogroup](https://surveyjs.io/form-library/documentation/questionradiogroupmodel), [Text](https://surveyjs.io/form-library/documentation/questiontextmodel), and [Comment](https://surveyjs.io/form-library/documentation/questioncommentmodel) question types as cell editors.
  *
  * [View Demo](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/ (linkStyle))
  */ var QuestionMatrixDynamicModel = /** @class */ function(_super) {
                __extends(QuestionMatrixDynamicModel, _super);
                function QuestionMatrixDynamicModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.rowCounter = 0;
                    _this.initialRowCount = 2;
                    _this.setRowCountValueFromData = false;
                    _this.startDragMatrixRow = function(event1, currentTarget) {
                        _this.dragDropMatrixRows.startDrag(event1, _this.draggedRow, _this, event1.target);
                    };
                    _this.createLocalizableString("confirmDeleteText", _this, false, "confirmDelete");
                    var locAddRowText = _this.createLocalizableString("addRowText", _this);
                    locAddRowText.onGetTextCallback = function(text) {
                        return !!text ? text : _this.defaultAddRowText;
                    };
                    _this.createLocalizableString("removeRowText", _this, false, "removeRow");
                    _this.createLocalizableString("emptyRowsText", _this, false, true);
                    _this.registerPropertyChangedHandlers([
                        "hideColumnsIfEmpty",
                        "allowAddRows"
                    ], function() {
                        _this.updateShowTableAndAddRow();
                    });
                    _this.registerPropertyChangedHandlers([
                        "allowRowsDragAndDrop",
                        "isReadOnly"
                    ], function() {
                        _this.clearRowsAndResetRenderedTable();
                    });
                    _this.dragOrClickHelper = new _utils_dragOrClickHelper__WEBPACK_IMPORTED_MODULE_9__["DragOrClickHelper"](_this.startDragMatrixRow);
                    return _this;
                }
                QuestionMatrixDynamicModel.prototype.setSurveyImpl = function(value, isLight) {
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    this.dragDropMatrixRows = new _dragdrop_matrix_rows__WEBPACK_IMPORTED_MODULE_6__["DragDropMatrixRows"](this.survey, null, true);
                };
                QuestionMatrixDynamicModel.prototype.isBanStartDrag = function(pointerDownEvent) {
                    var target = pointerDownEvent.target;
                    return target.getAttribute("contenteditable") === "true" || target.nodeName === "INPUT" || !this.isDragHandleAreaValid(target);
                };
                QuestionMatrixDynamicModel.prototype.isDragHandleAreaValid = function(node) {
                    if (this.survey.matrixDragHandleArea === "icon") return node.classList.contains(this.cssClasses.dragElementDecorator);
                    return true;
                };
                QuestionMatrixDynamicModel.prototype.onPointerDown = function(pointerDownEvent, row) {
                    if (!row || !this.isRowsDragAndDrop) return;
                    if (this.isBanStartDrag(pointerDownEvent)) return;
                    if (row.isDetailPanelShowing) return;
                    this.draggedRow = row;
                    this.dragOrClickHelper.onPointerDown(pointerDownEvent);
                };
                QuestionMatrixDynamicModel.prototype.getType = function() {
                    return "matrixdynamic";
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "isRowsDynamic", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "confirmDelete", {
                    /**
         * Specifies whether to display a confirmation dialog when a respondent wants to delete a row.
         *
         * Default value: `false`
         * @see confirmDeleteText
         */ get: function() {
                        return this.getPropertyValue("confirmDelete");
                    },
                    set: function(val1) {
                        this.setPropertyValue("confirmDelete", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "isValueArray", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "keyName", {
                    /**
         * Specifies a key column. Set this property to a column name, and the question will display `keyDuplicationError` if a user tries to enter a duplicate value in this column.
         * @see keyDuplicationError
         */ get: function() {
                        return this.getPropertyValue("keyName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("keyName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "defaultRowValue", {
                    /**
         * If it is not empty, then this value is set to every new row, including rows created initially, unless the defaultValue is not empty
         * @see defaultValue
         * @see defaultValueFromLastRow
         */ get: function() {
                        return this.getPropertyValue("defaultRowValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("defaultRowValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "defaultValueFromLastRow", {
                    /**
         * Specifies whether default values for a new row/column should be copied from the last row/column.
         *
         * If you also specify `defaultValue`, it will be merged with the copied values.
         * @see defaultValue
         */ get: function() {
                        return this.getPropertyValue("defaultValueFromLastRow");
                    },
                    set: function(val1) {
                        this.setPropertyValue("defaultValueFromLastRow", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.isDefaultValueEmpty = function() {
                    return _super.prototype.isDefaultValueEmpty.call(this) && this.isValueEmpty(this.defaultRowValue);
                };
                QuestionMatrixDynamicModel.prototype.valueFromData = function(val1) {
                    if (this.minRowCount < 1) return _super.prototype.valueFromData.call(this, val1);
                    if (!Array.isArray(val1)) val1 = [];
                    for(var i = val1.length; i < this.minRowCount; i++)val1.push({});
                    return val1;
                };
                QuestionMatrixDynamicModel.prototype.isNewValueCorrect = function(val1) {
                    return Array.isArray(val1);
                };
                QuestionMatrixDynamicModel.prototype.setDefaultValue = function() {
                    if (this.isValueEmpty(this.defaultRowValue) || !this.isValueEmpty(this.defaultValue)) {
                        _super.prototype.setDefaultValue.call(this);
                        return;
                    }
                    if (!this.isEmpty() || this.rowCount == 0) return;
                    var newValue = [];
                    for(var i = 0; i < this.rowCount; i++)newValue.push(this.defaultRowValue);
                    this.value = newValue;
                };
                QuestionMatrixDynamicModel.prototype.moveRowByIndex = function(fromIndex, toIndex) {
                    var value = this.createNewValue();
                    if (!Array.isArray(value) && Math.max(fromIndex, toIndex) >= value.length) return;
                    var movableRow = value[fromIndex];
                    value.splice(fromIndex, 1);
                    value.splice(toIndex, 0, movableRow);
                    this.value = value;
                };
                QuestionMatrixDynamicModel.prototype.clearOnDrop = function() {
                    if (!this.isEditingSurveyElement) this.resetRenderedTable();
                };
                QuestionMatrixDynamicModel.prototype.initDataUI = function() {
                    if (!this.generatedVisibleRows) this.visibleRows;
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "rowCount", {
                    /**
         * The number of rows in the matrix.
         * @see minRowCount
         * @see maxRowCount
         */ get: function() {
                        return this.rowCountValue;
                    },
                    set: function(val1) {
                        if (val1 < 0 || val1 > _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].matrix.maxRowCount) return;
                        this.setRowCountValueFromData = false;
                        var prevValue = this.rowCountValue;
                        this.rowCountValue = val1;
                        if (this.value && this.value.length > val1) {
                            var qVal = this.value;
                            qVal.splice(val1);
                            this.value = qVal;
                        }
                        if (this.isUpdateLocked) {
                            this.initialRowCount = val1;
                            return;
                        }
                        if (this.generatedVisibleRows || prevValue == 0) {
                            if (!this.generatedVisibleRows) this.generatedVisibleRows = [];
                            this.generatedVisibleRows.splice(val1);
                            for(var i = prevValue; i < val1; i++){
                                var newRow = this.createMatrixRow(this.getValueForNewRow());
                                this.generatedVisibleRows.push(newRow);
                                this.onMatrixRowCreated(newRow);
                            }
                            this.runCondition(this.getDataFilteredValues(), this.getDataFilteredProperties());
                        }
                        this.onRowsChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.updateProgressInfoByValues = function(res) {
                    var val1 = this.value;
                    if (!Array.isArray(val1)) val1 = [];
                    for(var i = 0; i < this.rowCount; i++){
                        var rowValue = i < val1.length ? val1[i] : {};
                        this.updateProgressInfoByRow(res, rowValue);
                    }
                };
                QuestionMatrixDynamicModel.prototype.getValueForNewRow = function() {
                    var res = null;
                    if (!!this.onGetValueForNewRowCallBack) res = this.onGetValueForNewRowCallBack(this);
                    return res;
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "allowRowsDragAndDrop", {
                    /**
         * Specifies whether users can drag and drop matrix rows to reorder them. Applies only if [`transposeData`](#transposeData) is `false`.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("allowRowsDragAndDrop");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowRowsDragAndDrop", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "isRowsDragAndDrop", {
                    get: function() {
                        return this.allowRowsDragAndDrop && !this.isReadOnly;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "iconDragElement", {
                    get: function() {
                        return this.cssClasses.iconDragElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.createRenderedTable = function() {
                    return new QuestionMatrixDynamicRenderedTable(this);
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "rowCountValue", {
                    get: function() {
                        return this.getPropertyValue("rowCount");
                    },
                    set: function(val1) {
                        this.setPropertyValue("rowCount", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "minRowCount", {
                    /**
         * A minimum number of rows in the matrix. Users cannot delete rows if `rowCount` equals `minRowCount`.
         *
         * Default value: 0
         * @see rowCount
         * @see maxRowCount
         * @see allowRemoveRows
         */ get: function() {
                        return this.getPropertyValue("minRowCount");
                    },
                    set: function(val1) {
                        if (val1 < 0) val1 = 0;
                        this.setPropertyValue("minRowCount", val1);
                        if (val1 > this.maxRowCount) this.maxRowCount = val1;
                        if (this.rowCount < val1) this.rowCount = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "maxRowCount", {
                    /**
         * A maximum number of rows in the matrix. Users cannot add new rows if `rowCount` equals `maxRowCount`.
         *
         * Default value: 1000 (inherited from [`settings.matrix.maxRowCount`](https://surveyjs.io/form-library/documentation/settings#matrixMaximumRowCount))
         * @see rowCount
         * @see minRowCount
         * @see allowAddRows
         */ get: function() {
                        return this.getPropertyValue("maxRowCount");
                    },
                    set: function(val1) {
                        if (val1 <= 0) return;
                        if (val1 > _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].matrix.maxRowCount) val1 = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].matrix.maxRowCount;
                        if (val1 == this.maxRowCount) return;
                        this.setPropertyValue("maxRowCount", val1);
                        if (val1 < this.minRowCount) this.minRowCount = val1;
                        if (this.rowCount > val1) this.rowCount = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "allowAddRows", {
                    /**
         * Specifies whether users are allowed to add new rows.
         *
         * Default value: `true`
         * @see canAddRow
         * @see allowRemoveRows
         */ get: function() {
                        return this.getPropertyValue("allowAddRows");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowAddRows", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "allowRemoveRows", {
                    /**
         * Specifies whether users are allowed to delete rows.
         *
         * Default value: `true`
         * @see canRemoveRows
         * @see allowAddRows
         */ get: function() {
                        return this.getPropertyValue("allowRemoveRows");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowRemoveRows", val1);
                        if (!this.isUpdateLocked) this.resetRenderedTable();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "canAddRow", {
                    /**
         * Indicates whether it is possible to add a new row.
         *
         * This property returns `true` when all of the following conditions apply:
         *
         * - Users are allowed to add new rows (`allowAddRows` is `true`).
         * - The question, its parent panel, or survey is not in read-only state.
         * - `rowCount` is less than `maxRowCount`.
         * @see allowAddRows
         * @see isReadOnly
         * @see rowCount
         * @see maxRowCount
         * @see canRemoveRows
         */ get: function() {
                        return this.allowAddRows && !this.isReadOnly && this.rowCount < this.maxRowCount;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "canRemoveRows", {
                    /**
         * Indicates whether it is possible to delete rows.
         *
         * This property returns `true` when all of the following conditions apply:
         *
         * - Users are allowed to delete rows (`allowRemoveRows` is `true`).
         * - The question, its parent panel, or survey is not in read-only state.
         * - `rowCount` exceeds `minRowCount`.
         * @see allowRemoveRows
         * @see isReadOnly
         * @see rowCount
         * @see minRowCount
         * @see canAddRow
         */ get: function() {
                        var res = this.allowRemoveRows && !this.isReadOnly && this.rowCount > this.minRowCount;
                        return !!this.canRemoveRowsCallback ? this.canRemoveRowsCallback(res) : res;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.canRemoveRow = function(row) {
                    if (!this.survey) return true;
                    return this.survey.matrixAllowRemoveRow(this, row.index, row);
                };
                QuestionMatrixDynamicModel.prototype.addRowUI = function() {
                    this.addRow(true);
                };
                QuestionMatrixDynamicModel.prototype.getQuestionToFocusOnAddingRow = function() {
                    var row = this.visibleRows[this.visibleRows.length - 1];
                    for(var i = 0; i < row.cells.length; i++){
                        var q = row.cells[i].question;
                        if (!!q && q.isVisible && !q.isReadOnly) return q;
                    }
                    return null;
                };
                /**
     * Creates and adds a new row to the matrix.
     * @param setFocus *(Optional)* Pass `true` to focus the cell in the first column.
     */ QuestionMatrixDynamicModel.prototype.addRow = function(setFocus) {
                    var oldRowCount = this.rowCount;
                    var allow = this.canAddRow;
                    var options = {
                        question: this,
                        canAddRow: allow,
                        allow: allow
                    };
                    if (!!this.survey) this.survey.matrixBeforeRowAdded(options);
                    var newAllow = allow !== options.allow ? options.allow : allow !== options.canAddRow ? options.canAddRow : allow;
                    if (!newAllow) return;
                    this.onStartRowAddingRemoving();
                    this.addRowCore();
                    this.onEndRowAdding();
                    if (this.detailPanelShowOnAdding && this.visibleRows.length > 0) this.visibleRows[this.visibleRows.length - 1].showDetailPanel();
                    if (setFocus && oldRowCount !== this.rowCount) {
                        var q = this.getQuestionToFocusOnAddingRow();
                        if (!!q) q.focus();
                    }
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "detailPanelShowOnAdding", {
                    /**
         * Specifies whether to expand the detail section immediately when a respondent adds a new row.
         * @see detailPanelMode
         */ get: function() {
                        return this.getPropertyValue("detailPanelShowOnAdding");
                    },
                    set: function(val1) {
                        this.setPropertyValue("detailPanelShowOnAdding", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.hasRowsAsItems = function() {
                    return false;
                };
                QuestionMatrixDynamicModel.prototype.unbindValue = function() {
                    this.clearGeneratedRows();
                    this.clearPropertyValue("value");
                    this.rowCountValue = 0;
                    _super.prototype.unbindValue.call(this);
                };
                QuestionMatrixDynamicModel.prototype.isValueSurveyElement = function(val1) {
                    return this.isEditingSurveyElement || _super.prototype.isValueSurveyElement.call(this, val1);
                };
                QuestionMatrixDynamicModel.prototype.addRowCore = function() {
                    var prevRowCount = this.rowCount;
                    this.rowCount = this.rowCount + 1;
                    var defaultValue = this.getDefaultRowValue(true);
                    var newValue = null;
                    if (!this.isValueEmpty(defaultValue)) {
                        newValue = this.createNewValue();
                        if (newValue.length == this.rowCount) {
                            newValue[newValue.length - 1] = defaultValue;
                            this.value = newValue;
                        }
                    }
                    if (this.data) {
                        this.runCellsCondition(this.getDataFilteredValues(), this.getDataFilteredProperties());
                        if (this.isValueEmpty(defaultValue)) {
                            var row = this.visibleRows[this.rowCount - 1];
                            if (!this.isValueEmpty(row.value)) {
                                if (!newValue) newValue = this.createNewValue();
                                if (!this.isValueSurveyElement(newValue) && !this.isTwoValueEquals(newValue[newValue.length - 1], row.value)) {
                                    newValue[newValue.length - 1] = row.value;
                                    this.value = newValue;
                                }
                            }
                        }
                    }
                    if (this.survey) {
                        if (prevRowCount + 1 == this.rowCount) {
                            this.survey.matrixRowAdded(this, this.visibleRows[this.visibleRows.length - 1]);
                            this.onRowsChanged();
                        }
                    }
                };
                QuestionMatrixDynamicModel.prototype.getDefaultRowValue = function(isRowAdded) {
                    var res = null;
                    for(var i = 0; i < this.columns.length; i++){
                        var q = this.columns[i].templateQuestion;
                        if (!!q && !this.isValueEmpty(q.getDefaultValue())) {
                            res = res || {};
                            res[this.columns[i].name] = q.getDefaultValue();
                        }
                    }
                    if (!this.isValueEmpty(this.defaultRowValue)) for(var key in this.defaultRowValue){
                        res = res || {};
                        res[key] = this.defaultRowValue[key];
                    }
                    if (isRowAdded && this.defaultValueFromLastRow) {
                        var val1 = this.value;
                        if (!!val1 && Array.isArray(val1) && val1.length >= this.rowCount - 1) {
                            var rowValue = val1[this.rowCount - 2];
                            for(var key in rowValue){
                                res = res || {};
                                res[key] = rowValue[key];
                            }
                        }
                    }
                    return res;
                };
                QuestionMatrixDynamicModel.prototype.removeRowUI = function(value) {
                    if (!!value && !!value.rowName) {
                        var index = this.visibleRows.indexOf(value);
                        if (index < 0) return;
                        value = index;
                    }
                    this.removeRow(value);
                };
                QuestionMatrixDynamicModel.prototype.isRequireConfirmOnRowDelete = function(index) {
                    if (!this.confirmDelete) return false;
                    if (index < 0 || index >= this.rowCount) return false;
                    var value = this.createNewValue();
                    if (this.isValueEmpty(value) || !Array.isArray(value)) return false;
                    if (index >= value.length) return false;
                    return !this.isValueEmpty(value[index]);
                };
                /**
     * Removes a matrix row with a specified index.
     * @param index A zero-based row index.
     * @param confirmDelete *(Optional)* A Boolean value that specifies whether to display a confirmation dialog. If you do not specify this parameter, the [`confirmDelete`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model#confirmDelete) property value is used.
     */ QuestionMatrixDynamicModel.prototype.removeRow = function(index, confirmDelete) {
                    var _this = this;
                    if (!this.canRemoveRows) return;
                    if (index < 0 || index >= this.rowCount) return;
                    var row = !!this.visibleRows && index < this.visibleRows.length ? this.visibleRows[index] : null;
                    if (confirmDelete === undefined) confirmDelete = this.isRequireConfirmOnRowDelete(index);
                    if (confirmDelete) {
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_5__["confirmActionAsync"])(this.confirmDeleteText, function() {
                            _this.removeRowAsync(index, row);
                        }, undefined, this.getLocale(), this.survey.rootElement);
                        return;
                    }
                    this.removeRowAsync(index, row);
                };
                QuestionMatrixDynamicModel.prototype.removeRowAsync = function(index, row) {
                    if (!!row && !!this.survey && !this.survey.matrixRowRemoving(this, index, row)) return;
                    this.onStartRowAddingRemoving();
                    this.removeRowCore(index);
                    this.onEndRowRemoving(row);
                };
                QuestionMatrixDynamicModel.prototype.removeRowCore = function(index) {
                    var row = this.generatedVisibleRows ? this.generatedVisibleRows[index] : null;
                    if (this.generatedVisibleRows && index < this.generatedVisibleRows.length) this.generatedVisibleRows.splice(index, 1);
                    this.rowCountValue--;
                    if (this.value) {
                        var val1 = [];
                        if (Array.isArray(this.value) && index < this.value.length) val1 = this.createValueCopy();
                        else val1 = this.createNewValue();
                        val1.splice(index, 1);
                        val1 = this.deleteRowValue(val1, null);
                        this.isRowChanging = true;
                        this.value = val1;
                        this.isRowChanging = false;
                    }
                    this.onRowsChanged();
                    if (this.survey) this.survey.matrixRowRemoved(this, index, row);
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "confirmDeleteText", {
                    /**
         * A message displayed in a confirmation dialog that appears when a respondent wants to delete a row.
         * @see confirmDelete
         */ get: function() {
                        return this.getLocalizableStringText("confirmDeleteText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("confirmDeleteText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "locConfirmDeleteText", {
                    get: function() {
                        return this.getLocalizableString("confirmDeleteText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "addRowText", {
                    /**
         * A caption for the Add Row button.
         * @see addRowLocation
         */ get: function() {
                        return this.getLocalizableStringText("addRowText", this.defaultAddRowText);
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("addRowText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "locAddRowText", {
                    get: function() {
                        return this.getLocalizableString("addRowText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "defaultAddRowText", {
                    get: function() {
                        return this.getLocalizationString(this.isColumnLayoutHorizontal ? "addRow" : "addColumn");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "addRowLocation", {
                    /**
         * Specifies the location of the Add Row button.
         *
         * Possible values:
         *
         * - `"top"` - Displays the Add Row button at the top of the matrix.
         * - `"bottom"` - Displays the Add Row button at the bottom of the matrix.
         * - `"topBottom"` - Displays the Add Row button at the top and bottom of the matrix.
         *
         * Default value: `"top"` if [`transposeData`](#transposeData) is `true`; `"bottom"` if `transposeData` is `false` or the matrix is in compact mode.
         * @see addRowText
         */ get: function() {
                        return this.getPropertyValue("addRowLocation");
                    },
                    set: function(val1) {
                        this.setPropertyValue("addRowLocation", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.getAddRowLocation = function() {
                    return this.addRowLocation;
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "hideColumnsIfEmpty", {
                    /**
         * Specifies whether to hide columns when the matrix does not contain any rows. If you enable this property, the matrix displays the `emptyRowsText` message and the Add Row button.
         *
         * Default value: `false`
         * @see emptyRowsText
         */ get: function() {
                        return this.getPropertyValue("hideColumnsIfEmpty");
                    },
                    set: function(val1) {
                        this.setPropertyValue("hideColumnsIfEmpty", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.getShowColumnsIfEmpty = function() {
                    return this.hideColumnsIfEmpty;
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "removeRowText", {
                    /**
         * Use this property to change the default value of remove row button text.
         */ get: function() {
                        return this.getLocalizableStringText("removeRowText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("removeRowText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "locRemoveRowText", {
                    get: function() {
                        return this.getLocalizableString("removeRowText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "emptyRowsText", {
                    /**
         * A message displayed when the matrix does not contain any rows. Applies only if `hideColumnsIfEmpty` is enabled.
         * @see hideColumnsIfEmpty
         */ get: function() {
                        return this.getLocalizableStringText("emptyRowsText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("emptyRowsText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "locEmptyRowsText", {
                    get: function() {
                        return this.getLocalizableString("emptyRowsText");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    if (!value || !Array.isArray(value)) return value;
                    var values = this.getUnbindValue(value);
                    var rows = this.visibleRows;
                    for(var i = 0; i < rows.length && i < values.length; i++){
                        var val1 = values[i];
                        if (!val1) continue;
                        values[i] = this.getRowDisplayValue(keysAsText, rows[i], val1);
                    }
                    return values;
                };
                QuestionMatrixDynamicModel.prototype.getConditionObjectRowName = function(index) {
                    return "[" + index.toString() + "]";
                };
                QuestionMatrixDynamicModel.prototype.getConditionObjectsRowIndeces = function() {
                    var res = [];
                    var rowCount = Math.max(this.rowCount, 1);
                    for(var i = 0; i < Math.min(_settings__WEBPACK_IMPORTED_MODULE_4__["settings"].matrix.maxRowCountInCondition, rowCount); i++)res.push(i);
                    return res;
                };
                QuestionMatrixDynamicModel.prototype.supportGoNextPageAutomatic = function() {
                    return false;
                };
                Object.defineProperty(QuestionMatrixDynamicModel.prototype, "hasRowText", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMatrixDynamicModel.prototype.onCheckForErrors = function(errors, isOnValueChanged) {
                    _super.prototype.onCheckForErrors.call(this, errors, isOnValueChanged);
                    if (!isOnValueChanged && this.hasErrorInMinRows()) errors.push(new _error__WEBPACK_IMPORTED_MODULE_3__["MinRowCountError"](this.minRowCount, this));
                };
                QuestionMatrixDynamicModel.prototype.hasErrorInMinRows = function() {
                    if (this.minRowCount <= 0 || !this.isRequired || !this.generatedVisibleRows) return false;
                    var setRowCount = 0;
                    for(var rowIndex = 0; rowIndex < this.generatedVisibleRows.length; rowIndex++){
                        var row = this.generatedVisibleRows[rowIndex];
                        if (!row.isEmpty) setRowCount++;
                    }
                    return setRowCount < this.minRowCount;
                };
                QuestionMatrixDynamicModel.prototype.getUniqueColumns = function() {
                    var res = _super.prototype.getUniqueColumns.call(this);
                    if (!!this.keyName) {
                        var column = this.getColumnByName(this.keyName);
                        if (!!column && res.indexOf(column) < 0) res.push(column);
                    }
                    return res;
                };
                QuestionMatrixDynamicModel.prototype.generateRows = function() {
                    var result = new Array();
                    if (this.rowCount === 0) return result;
                    var val1 = this.createNewValue();
                    for(var i = 0; i < this.rowCount; i++)result.push(this.createMatrixRow(this.getRowValueByIndex(val1, i)));
                    if (!this.isValueEmpty(this.getDefaultRowValue(false))) this.value = val1;
                    return result;
                };
                QuestionMatrixDynamicModel.prototype.createMatrixRow = function(value) {
                    return new MatrixDynamicRowModel(this.rowCounter++, this, value);
                };
                QuestionMatrixDynamicModel.prototype.getInsertedDeletedIndex = function(rows, val1) {
                    var len = Math.min(rows.length, val1.length);
                    for(var i = 0; i < len; i++){
                        if (val1[i] !== rows[i].editingObj) return i;
                    }
                    return len;
                };
                QuestionMatrixDynamicModel.prototype.isEditingObjectValueChanged = function() {
                    var val1 = this.value;
                    if (!this.generatedVisibleRows || !this.isValueSurveyElement(val1)) return false;
                    var lastDelRow = this.lastDeletedRow;
                    this.lastDeletedRow = undefined;
                    var rows = this.generatedVisibleRows;
                    if (!Array.isArray(val1) || Math.abs(rows.length - val1.length) > 1 || rows.length === val1.length) return false;
                    var index = this.getInsertedDeletedIndex(rows, val1);
                    if (rows.length > val1.length) {
                        this.lastDeletedRow = rows[index];
                        var row = rows[index];
                        rows.splice(index, 1);
                        if (this.isRendredTableCreated) this.renderedTable.onRemovedRow(row);
                    } else {
                        var newRow = undefined;
                        if (!!lastDelRow && lastDelRow.editingObj === val1[index]) newRow = lastDelRow;
                        else newRow = this.createMatrixRow(val1[index]);
                        rows.splice(index, 0, newRow);
                        if (!lastDelRow) this.onMatrixRowCreated(newRow);
                        if (this.isRendredTableCreated) this.renderedTable.onAddedRow(newRow, index);
                    }
                    this.setPropertyValueDirectly("rowCount", val1.length);
                    return true;
                };
                QuestionMatrixDynamicModel.prototype.onBeforeValueChanged = function(val1) {
                    if (!val1 || !Array.isArray(val1)) return;
                    var newRowCount = val1.length;
                    if (newRowCount == this.rowCount) return;
                    if (!this.setRowCountValueFromData && newRowCount < this.initialRowCount) return;
                    if (this.isEditingObjectValueChanged()) return;
                    this.setRowCountValueFromData = true;
                    this.rowCountValue = newRowCount;
                    if (!this.generatedVisibleRows) return;
                    if (newRowCount == this.generatedVisibleRows.length + 1) {
                        this.onStartRowAddingRemoving();
                        var newValue = this.getRowValueByIndex(val1, newRowCount - 1);
                        var newRow = this.createMatrixRow(newValue);
                        this.generatedVisibleRows.push(newRow);
                        this.onMatrixRowCreated(newRow);
                        this.onEndRowAdding();
                    } else {
                        this.clearGeneratedRows();
                        this.generatedVisibleRows = this.visibleRows;
                        this.onRowsChanged();
                    }
                    this.setRowCountValueFromData = false;
                };
                QuestionMatrixDynamicModel.prototype.createNewValue = function() {
                    var result = this.createValueCopy();
                    if (!result || !Array.isArray(result)) result = [];
                    if (result.length > this.rowCount) result.splice(this.rowCount);
                    var rowValue = this.getDefaultRowValue(false);
                    rowValue = rowValue || {};
                    for(var i = result.length; i < this.rowCount; i++)result.push(this.getUnbindValue(rowValue));
                    return result;
                };
                QuestionMatrixDynamicModel.prototype.deleteRowValue = function(newValue, row) {
                    var isEmpty = true;
                    for(var i = 0; i < newValue.length; i++)if (this.isObject(newValue[i]) && Object.keys(newValue[i]).length > 0) {
                        isEmpty = false;
                        break;
                    }
                    return isEmpty ? null : newValue;
                };
                QuestionMatrixDynamicModel.prototype.getRowValueByIndex = function(questionValue, index) {
                    return Array.isArray(questionValue) && index >= 0 && index < questionValue.length ? questionValue[index] : null;
                };
                QuestionMatrixDynamicModel.prototype.getRowValueCore = function(row, questionValue, create) {
                    if (create === void 0) create = false;
                    if (!this.generatedVisibleRows) return {};
                    var res = this.getRowValueByIndex(questionValue, this.generatedVisibleRows.indexOf(row));
                    if (!res && create) res = {};
                    return res;
                };
                QuestionMatrixDynamicModel.prototype.getAddRowButtonCss = function(isEmptySection) {
                    if (isEmptySection === void 0) isEmptySection = false;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__["CssClassBuilder"]().append(this.cssClasses.button).append(this.cssClasses.buttonAdd).append(this.cssClasses.emptyRowsButton, isEmptySection).toString();
                };
                QuestionMatrixDynamicModel.prototype.getRemoveRowButtonCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__["CssClassBuilder"]().append(this.cssClasses.button).append(this.cssClasses.buttonRemove).toString();
                };
                QuestionMatrixDynamicModel.prototype.getRootCss = function() {
                    var _a;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__["CssClassBuilder"]().append(_super.prototype.getRootCss.call(this)).append(this.cssClasses.empty, !((_a = this.renderedTable) === null || _a === void 0 ? void 0 : _a.showTable)).toString();
                };
                return QuestionMatrixDynamicModel;
            }(_question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_2__["QuestionMatrixDropdownModelBase"]);
            var QuestionMatrixDynamicRenderedTable = /** @class */ function(_super) {
                __extends(QuestionMatrixDynamicRenderedTable, _super);
                function QuestionMatrixDynamicRenderedTable() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                QuestionMatrixDynamicRenderedTable.prototype.setDefaultRowActions = function(row, actions) {
                    _super.prototype.setDefaultRowActions.call(this, row, actions);
                };
                return QuestionMatrixDynamicRenderedTable;
            }(_question_matrixdropdownrendered__WEBPACK_IMPORTED_MODULE_8__["QuestionMatrixDropdownRenderedTable"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("matrixdynamic", [
                {
                    name: "rowsVisibleIf:condition",
                    visible: false
                },
                {
                    name: "allowAddRows:boolean",
                    default: true
                },
                {
                    name: "allowRemoveRows:boolean",
                    default: true
                },
                {
                    name: "rowCount:number",
                    default: 2,
                    minValue: 0,
                    isBindable: true
                },
                {
                    name: "minRowCount:number",
                    default: 0,
                    minValue: 0
                },
                {
                    name: "maxRowCount:number",
                    default: _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].matrix.maxRowCount
                },
                {
                    name: "keyName"
                },
                "defaultRowValue:rowvalue",
                "defaultValueFromLastRow:boolean",
                {
                    name: "confirmDelete:boolean"
                },
                {
                    name: "confirmDeleteText",
                    dependsOn: "confirmDelete",
                    visibleIf: function(obj) {
                        return !obj || obj.confirmDelete;
                    },
                    serializationProperty: "locConfirmDeleteText"
                },
                {
                    name: "addRowLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom",
                        "topBottom"
                    ]
                },
                {
                    name: "addRowText",
                    serializationProperty: "locAddRowText"
                },
                {
                    name: "removeRowText",
                    serializationProperty: "locRemoveRowText"
                },
                "hideColumnsIfEmpty:boolean",
                {
                    name: "emptyRowsText:text",
                    serializationProperty: "locEmptyRowsText",
                    dependsOn: "hideColumnsIfEmpty",
                    visibleIf: function(obj) {
                        return !obj || obj.hideColumnsIfEmpty;
                    }
                },
                {
                    name: "detailPanelShowOnAdding:boolean",
                    dependsOn: "detailPanelMode",
                    visibleIf: function(obj) {
                        return obj.detailPanelMode !== "none";
                    }
                },
                "allowRowsDragAndDrop:switch"
            ], function() {
                return new QuestionMatrixDynamicModel("");
            }, "matrixdropdownbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].Instance.registerQuestion("matrixdynamic", function(name) {
                var q = new QuestionMatrixDynamicModel(name);
                q.choices = [
                    1,
                    2,
                    3,
                    4,
                    5
                ];
                _question_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_2__["QuestionMatrixDropdownModelBase"].addDefaultColumns(q);
                return q;
            });
        /***/ },
        /***/ "./src/question_multipletext.ts": /*!**************************************!*\
  !*** ./src/question_multipletext.ts ***!
  \**************************************/ /*! exports provided: MultipleTextEditorModel, MultipleTextItemModel, QuestionMultipleTextModel, MutlipleTextRow, MutlipleTextErrorRow, MultipleTextCell, MultipleTextErrorCell */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultipleTextEditorModel", function() {
                return MultipleTextEditorModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultipleTextItemModel", function() {
                return MultipleTextItemModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionMultipleTextModel", function() {
                return QuestionMultipleTextModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MutlipleTextRow", function() {
                return MutlipleTextRow;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MutlipleTextErrorRow", function() {
                return MutlipleTextErrorRow;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultipleTextCell", function() {
                return MultipleTextCell;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MultipleTextErrorCell", function() {
                return MultipleTextErrorCell;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _question_text__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./question_text */ "./src/question_text.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var MultipleTextEditorModel = /** @class */ function(_super) {
                __extends(MultipleTextEditorModel, _super);
                function MultipleTextEditorModel() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(MultipleTextEditorModel.prototype, "a11y_input_ariaLabel", {
                    get: function() {
                        return this.locTitle.renderedHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextEditorModel.prototype, "a11y_input_ariaLabelledBy", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextEditorModel.prototype, "a11y_input_ariaDescribedBy", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                return MultipleTextEditorModel;
            }(_question_text__WEBPACK_IMPORTED_MODULE_3__["QuestionTextModel"]);
            /**
 * A class that describes an [item](https://surveyjs.io/form-library/documentation/api-reference/multiple-text-entry-question-model#items) in a Multiple Textboxes question.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/multiple-text-box-question/ (linkStyle))
 */ var MultipleTextItemModel = /** @class */ function(_super) {
                __extends(MultipleTextItemModel, _super);
                function MultipleTextItemModel(name, title) {
                    if (name === void 0) name = null;
                    if (title === void 0) title = null;
                    var _this = _super.call(this) || this;
                    _this.focusIn = function() {
                        _this.editor.focusIn();
                    };
                    _this.editorValue = _this.createEditor(name);
                    _this.maskSettings = _this.editorValue.maskSettings;
                    _this.editor.questionTitleTemplateCallback = function() {
                        return "";
                    };
                    _this.editor.titleLocation = "left";
                    if (title) _this.title = title;
                    return _this;
                }
                MultipleTextItemModel.prototype.getType = function() {
                    return "multipletextitem";
                };
                Object.defineProperty(MultipleTextItemModel.prototype, "id", {
                    get: function() {
                        return this.editor.id;
                    },
                    enumerable: false,
                    configurable: true
                });
                MultipleTextItemModel.prototype.getOriginalObj = function() {
                    return this.editor;
                };
                Object.defineProperty(MultipleTextItemModel.prototype, "name", {
                    /**
         * An item ID that is not visible to respondents.
         *
         * > Item IDs must be unique.
         * @see title
         */ get: function() {
                        return this.editor.name;
                    },
                    set: function(val1) {
                        this.editor.name = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "question", {
                    get: function() {
                        return this.data;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "editor", {
                    get: function() {
                        return this.editorValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                MultipleTextItemModel.prototype.createEditor = function(name) {
                    return new MultipleTextEditorModel(name);
                };
                MultipleTextItemModel.prototype.addUsedLocales = function(locales) {
                    _super.prototype.addUsedLocales.call(this, locales);
                    this.editor.addUsedLocales(locales);
                };
                MultipleTextItemModel.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    this.editor.localeChanged();
                };
                MultipleTextItemModel.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.editor.locStrsChanged();
                };
                MultipleTextItemModel.prototype.setData = function(data) {
                    this.data = data;
                    if (!!data) {
                        this.editor.defaultValue = data.getItemDefaultValue(this.name);
                        this.editor.setSurveyImpl(this);
                        this.editor.parent = data;
                        this.editor.setParentQuestion(data);
                    }
                };
                Object.defineProperty(MultipleTextItemModel.prototype, "isRequired", {
                    /**
         * Marks the item as required. If a respondent leaves this item empty, the question displays a [validation error](#requiredErrorText).
         */ get: function() {
                        return this.editor.isRequired;
                    },
                    set: function(val1) {
                        this.editor.isRequired = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "inputType", {
                    /**
         * A value passed on to the [`type`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#input_types) attribute of the underlying `<input>` element.
         *
         * Default value: `"text"`
         */ get: function() {
                        return this.editor.inputType;
                    },
                    set: function(val1) {
                        this.editor.inputType = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "title", {
                    /**
         * A user-friendly item label to display. If `title` is undefined, [`name`](https://surveyjs.io/form-library/documentation/api-reference/multipletextitemmodel#name) is displayed instead.
         */ get: function() {
                        return this.editor.title;
                    },
                    set: function(val1) {
                        this.editor.title = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "locTitle", {
                    get: function() {
                        return this.editor.locTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "fullTitle", {
                    get: function() {
                        return this.editor.fullTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "maxLength", {
                    /**
         * The maximum text length measured in characters. Assign 0 if the length should be unlimited.
         *
         * Default value: -1 (inherits the actual value from the `SurveyModel`'s [`maxTextLength`](https://surveyjs.io/form-library/documentation/surveymodel#maxTextLength) property).
         */ get: function() {
                        return this.editor.maxLength;
                    },
                    set: function(val1) {
                        this.editor.maxLength = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                MultipleTextItemModel.prototype.getMaxLength = function() {
                    var survey = this.getSurvey();
                    return _helpers__WEBPACK_IMPORTED_MODULE_6__["Helpers"].getMaxLength(this.maxLength, survey ? survey.maxTextLength : -1);
                };
                Object.defineProperty(MultipleTextItemModel.prototype, "placeholder", {
                    /**
         * A placeholder for the input field.
         */ get: function() {
                        return this.editor.placeholder;
                    },
                    set: function(val1) {
                        this.editor.placeholder = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "locPlaceholder", {
                    get: function() {
                        return this.editor.locPlaceholder;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "placeHolder", {
                    get: function() {
                        return this.placeholder;
                    },
                    set: function(val1) {
                        this.placeholder = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "locPlaceHolder", {
                    get: function() {
                        return this.locPlaceholder;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "requiredErrorText", {
                    /**
         * Specifies a custom error message for a [required item](#isRequired).
         */ get: function() {
                        return this.editor.requiredErrorText;
                    },
                    set: function(val1) {
                        this.editor.requiredErrorText = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "locRequiredErrorText", {
                    get: function() {
                        return this.editor.locRequiredErrorText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "size", {
                    /**
         * A value passed on to the [`size`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/size) attribute of the underlying `<input>` element.
         *
         * If you want to set a uniform `size` for all text box items, use the [`itemSize`](https://surveyjs.io/form-library/documentation/api-reference/multiple-text-entry-question-model#itemSize) within the Multiple Textboxes configuration.
         */ get: function() {
                        return this.editor.size;
                    },
                    set: function(val1) {
                        this.editor.size = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "defaultValueExpression", {
                    /**
         * An [expression](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions) used to calculate the default item value.
         * @see minValueExpression
         * @see maxValueExpression
         */ get: function() {
                        return this.editor.defaultValueExpression;
                    },
                    set: function(val1) {
                        this.editor.defaultValueExpression = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "minValueExpression", {
                    /**
         * An [expression](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions) used to calculate the minimum item value.
         * @see maxValueExpression
         * @see defaultValueExpression
         */ get: function() {
                        return this.editor.minValueExpression;
                    },
                    set: function(val1) {
                        this.editor.minValueExpression = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "maxValueExpression", {
                    /**
         * An [expression](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions) used to calculate the maximum item value.
         * @see minValueExpression
         * @see defaultValueExpression
         */ get: function() {
                        return this.editor.maxValueExpression;
                    },
                    set: function(val1) {
                        this.editor.maxValueExpression = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "validators", {
                    /**
         * Item validators.
         *
         * [Data Validation](https://surveyjs.io/form-library/documentation/data-validation (linkStyle))
         */ get: function() {
                        return this.editor.validators;
                    },
                    set: function(val1) {
                        this.editor.validators = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                MultipleTextItemModel.prototype.getValidators = function() {
                    return this.validators;
                };
                Object.defineProperty(MultipleTextItemModel.prototype, "maskType", {
                    /**
         * Specifies the type of a mask applied to the input.
         *
         * Possible values:
         *
         * - `"none"` (default)
         * - `"numeric"`
         * - `"currency"`
         * - `"datetime"`
         * - `"pattern"`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/masked-input-fields/ (linkStyle))
         * @see maskSettings
         */ get: function() {
                        return this.editor.maskType;
                    },
                    set: function(val1) {
                        this.editor.maskType = val1;
                        this.maskSettings = this.editor.maskSettings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "maskSettings", {
                    /**
         * An object with properties that configure the mask applied to the input.
         *
         * Available properties depend on the specified [`maskType`](#maskType) and belong to corresponding classes. Refer to the class APIs for a full list of properties:
         *
         * | `maskType` | Class |
         * | ---------- | ----- |
         * | `"numeric"` | [`InputMaskNumeric`](https://surveyjs.io/form-library/documentation/api-reference/inputmasknumeric) |
         * | `"currency"` | [`InputMaskCurrency`](https://surveyjs.io/form-library/documentation/api-reference/inputmaskcurrency) |
         * | `"datetime"` | [`InputMaskDateTime`](https://surveyjs.io/form-library/documentation/api-reference/inputmaskdatetime) |
         * | `"pattern"` | [`InputMaskPattern`](https://surveyjs.io/form-library/documentation/api-reference/inputmaskpattern) |
         *
         * [View Demo](https://surveyjs.io/form-library/examples/masked-input-fields/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("maskSettings");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maskSettings", val1);
                        if (this.editor.maskSettings !== val1) this.editor.maskSettings = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "inputTextAlignment", {
                    get: function() {
                        return this.editor.inputTextAlignment;
                    },
                    set: function(val1) {
                        this.editor.inputTextAlignment = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MultipleTextItemModel.prototype, "value", {
                    /**
         * An item value.
         */ get: function() {
                        return this.data ? this.data.getMultipleTextValue(this.name) : null;
                    },
                    set: function(value) {
                        if (this.data != null) this.data.setMultipleTextValue(this.name, value);
                    },
                    enumerable: false,
                    configurable: true
                });
                MultipleTextItemModel.prototype.isEmpty = function() {
                    return this.editor.isEmpty();
                };
                MultipleTextItemModel.prototype.onValueChanged = function(newValue) {
                    if (this.valueChangedCallback) this.valueChangedCallback(newValue);
                };
                //ISurveyImpl
                MultipleTextItemModel.prototype.getSurveyData = function() {
                    return this;
                };
                MultipleTextItemModel.prototype.getSurvey = function() {
                    return this.data ? this.data.getSurvey() : null;
                };
                MultipleTextItemModel.prototype.getTextProcessor = function() {
                    return this.data ? this.data.getTextProcessor() : null;
                };
                //ISurveyData
                MultipleTextItemModel.prototype.getValue = function(name) {
                    if (!this.data) return null;
                    return this.data.getMultipleTextValue(name);
                };
                MultipleTextItemModel.prototype.setValue = function(name, value) {
                    if (this.data) this.data.setMultipleTextValue(name, value);
                };
                MultipleTextItemModel.prototype.getVariable = function(name) {
                    return undefined;
                };
                MultipleTextItemModel.prototype.setVariable = function(name, newValue) {};
                MultipleTextItemModel.prototype.getComment = function(name) {
                    return null;
                };
                MultipleTextItemModel.prototype.setComment = function(name, newValue) {};
                MultipleTextItemModel.prototype.getAllValues = function() {
                    if (this.data) return this.data.getAllValues();
                    return this.value;
                };
                MultipleTextItemModel.prototype.getFilteredValues = function() {
                    return this.getAllValues();
                };
                MultipleTextItemModel.prototype.getFilteredProperties = function() {
                    return {
                        survey: this.getSurvey()
                    };
                };
                MultipleTextItemModel.prototype.findQuestionByName = function(name) {
                    var survey = this.getSurvey();
                    return !!survey ? survey.getQuestionByName(name) : null;
                };
                //IValidatorOwner
                MultipleTextItemModel.prototype.getValidatorTitle = function() {
                    return this.title;
                };
                Object.defineProperty(MultipleTextItemModel.prototype, "validatedValue", {
                    get: function() {
                        return this.value;
                    },
                    set: function(val1) {
                        this.value = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                MultipleTextItemModel.prototype.getDataFilteredValues = function() {
                    return this.getFilteredValues();
                };
                MultipleTextItemModel.prototype.getDataFilteredProperties = function() {
                    return this.getFilteredProperties();
                };
                return MultipleTextItemModel;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            /**
 * A class that describes the Multiple Text question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-multipletext/ (linkStyle))
 */ var QuestionMultipleTextModel = /** @class */ function(_super) {
                __extends(QuestionMultipleTextModel, _super);
                function QuestionMultipleTextModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.isMultipleItemValueChanging = false;
                    _this.createNewArray("items", function(item) {
                        item.setData(_this);
                        if (_this.survey) _this.survey.multipleTextItemAdded(_this, item);
                    });
                    _this.registerPropertyChangedHandlers([
                        "items",
                        "colCount",
                        "itemErrorLocation"
                    ], function() {
                        _this.calcVisibleRows();
                    });
                    _this.registerPropertyChangedHandlers([
                        "itemSize"
                    ], function() {
                        _this.updateItemsSize();
                    });
                    return _this;
                }
                QuestionMultipleTextModel.addDefaultItems = function(question) {
                    var names = _questionfactory__WEBPACK_IMPORTED_MODULE_5__["QuestionFactory"].DefaultMutlipleTextItems;
                    for(var i = 0; i < names.length; i++)question.addItem(names[i]);
                };
                QuestionMultipleTextModel.prototype.getType = function() {
                    return "multipletext";
                };
                QuestionMultipleTextModel.prototype.setSurveyImpl = function(value, isLight) {
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    for(var i = 0; i < this.items.length; i++)this.items[i].setData(this);
                };
                Object.defineProperty(QuestionMultipleTextModel.prototype, "isAllowTitleLeft", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMultipleTextModel.prototype, "hasSingleInput", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMultipleTextModel.prototype, "isContainer", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMultipleTextModel.prototype, "id", {
                    get: function() {
                        return this.getPropertyValue("id");
                    },
                    set: function(val1) {
                        var _a;
                        (_a = this.items) === null || _a === void 0 || _a.map(function(item, index) {
                            return item.editor.id = val1 + "_" + index;
                        });
                        this.setPropertyValue("id", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMultipleTextModel.prototype.onSurveyLoad = function() {
                    this.editorsOnSurveyLoad();
                    _super.prototype.onSurveyLoad.call(this);
                };
                QuestionMultipleTextModel.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    _super.prototype.setQuestionValue.call(this, newValue, updateIsAnswered);
                    this.performForEveryEditor(function(item) {
                        item.editor.updateValueFromSurvey(item.value);
                    });
                    this.updateIsAnswered();
                };
                QuestionMultipleTextModel.prototype.onSurveyValueChanged = function(newValue) {
                    _super.prototype.onSurveyValueChanged.call(this, newValue);
                    this.performForEveryEditor(function(item) {
                        item.editor.onSurveyValueChanged(item.value);
                    });
                };
                QuestionMultipleTextModel.prototype.updateItemsSize = function() {
                    this.performForEveryEditor(function(item) {
                        item.editor.updateInputSize();
                    });
                };
                QuestionMultipleTextModel.prototype.editorsOnSurveyLoad = function() {
                    this.performForEveryEditor(function(item) {
                        item.editor.onSurveyLoad();
                    });
                };
                QuestionMultipleTextModel.prototype.performForEveryEditor = function(func) {
                    for(var i = 0; i < this.items.length; i++){
                        var item = this.items[i];
                        if (item.editor) func(item);
                    }
                };
                Object.defineProperty(QuestionMultipleTextModel.prototype, "items", {
                    /**
         * Gets or sets an array of [`MultipleTextItemModel`](https://surveyjs.io/form-library/documentation/api-reference/multipletextitemmodel) objects that represent input items.
         *
         * Each object in this array should have at least the following properties:
         *
         * ```js
         * {
         *   "name": any, // A unique value used to identify an input item and save an item value to survey results.
         *   "title": String // An item caption. When `title` is undefined, `name` is used. This property supports Markdown.
         * }
         * ```
         *
         * To enable Markdown support for the `title` property, implement Markdown-to-HTML conversion in the [`onTextMarkdown`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onTextMarkdown) event handler. For an example, refer to the following demo: [Convert Markdown to HTML with Showdown](https://surveyjs.io/form-library/examples/edit-survey-questions-markdown/).
         * @see itemTitleWidth
         * @see addItem
         */ get: function() {
                        return this.getPropertyValue("items");
                    },
                    set: function(val1) {
                        this.setPropertyValue("items", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Adds a new input item.
     * @param name An item name.
     * @param title *(Optional)* An item title.
     * @see items
     */ QuestionMultipleTextModel.prototype.addItem = function(name, title) {
                    if (title === void 0) title = null;
                    var item = this.createTextItem(name, title);
                    this.items.push(item);
                    return item;
                };
                QuestionMultipleTextModel.prototype.getItemByName = function(name) {
                    for(var i = 0; i < this.items.length; i++){
                        if (this.items[i].name == name) return this.items[i];
                    }
                    return null;
                };
                QuestionMultipleTextModel.prototype.getElementsInDesign = function(includeHidden) {
                    if (includeHidden === void 0) includeHidden = false;
                    var elements;
                    elements = _super.prototype.getElementsInDesign.call(this, includeHidden);
                    return elements.concat(this.items);
                };
                QuestionMultipleTextModel.prototype.addConditionObjectsByContext = function(objects, context) {
                    for(var i = 0; i < this.items.length; i++){
                        var item = this.items[i];
                        objects.push({
                            name: this.getValueName() + "." + item.name,
                            text: this.processedTitle + "." + item.fullTitle,
                            question: this
                        });
                    }
                };
                QuestionMultipleTextModel.prototype.collectNestedQuestionsCore = function(questions, visibleOnly) {
                    this.items.forEach(function(item) {
                        return item.editor.collectNestedQuestions(questions, visibleOnly);
                    });
                };
                QuestionMultipleTextModel.prototype.getConditionJson = function(operator, path) {
                    if (operator === void 0) operator = null;
                    if (path === void 0) path = null;
                    if (!path) return _super.prototype.getConditionJson.call(this);
                    var item = this.getItemByName(path);
                    if (!item) return null;
                    var json = new _jsonobject__WEBPACK_IMPORTED_MODULE_4__["JsonObject"]().toJsonObject(item);
                    json["type"] = "text";
                    return json;
                };
                QuestionMultipleTextModel.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    for(var i = 0; i < this.items.length; i++)this.items[i].locStrsChanged();
                };
                QuestionMultipleTextModel.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    for(var i = 0; i < this.items.length; i++)this.items[i].localeChanged();
                };
                Object.defineProperty(QuestionMultipleTextModel.prototype, "itemErrorLocation", {
                    /**
         * Specifies the error message position relative to individual input fields.
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the [`errorLocation`](#errorLocation) property.
         * - `"top"` - Displays error messages above input fields.
         * - `"bottom"` - Displays error messages below input fields.
         */ get: function() {
                        return this.getPropertyValue("itemErrorLocation");
                    },
                    set: function(val1) {
                        this.setPropertyValue("itemErrorLocation", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMultipleTextModel.prototype.getQuestionErrorLocation = function() {
                    if (this.itemErrorLocation !== "default") return this.itemErrorLocation;
                    return this.getErrorLocation();
                };
                Object.defineProperty(QuestionMultipleTextModel.prototype, "showItemErrorOnTop", {
                    get: function() {
                        return this.getQuestionErrorLocation() == "top";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMultipleTextModel.prototype, "showItemErrorOnBottom", {
                    get: function() {
                        return this.getQuestionErrorLocation() == "bottom";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMultipleTextModel.prototype.getChildErrorLocation = function(child) {
                    return this.getQuestionErrorLocation();
                };
                QuestionMultipleTextModel.prototype.isNewValueCorrect = function(val1) {
                    return _helpers__WEBPACK_IMPORTED_MODULE_6__["Helpers"].isValueObject(val1, true);
                };
                QuestionMultipleTextModel.prototype.supportGoNextPageAutomatic = function() {
                    for(var i = 0; i < this.items.length; i++){
                        if (this.items[i].isEmpty()) return false;
                    }
                    return true;
                };
                Object.defineProperty(QuestionMultipleTextModel.prototype, "colCount", {
                    /**
         * The number of columns used to arrange input items. Accepts the following values: 1, 2, 3, 4, 5.
         *
         * Default value: 1
         */ get: function() {
                        return this.getPropertyValue("colCount");
                    },
                    set: function(val1) {
                        if (val1 < 1 || val1 > 5) return;
                        this.setPropertyValue("colCount", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMultipleTextModel.prototype, "itemSize", {
                    /**
         * A value passed on to the [`size`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/size) attribute of the underlying `<input>` elements.
         */ get: function() {
                        return this.getPropertyValue("itemSize");
                    },
                    set: function(val1) {
                        this.setPropertyValue("itemSize", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionMultipleTextModel.prototype, "itemTitleWidth", {
                    /**
         * Specifies a uniform width for all text box titles. Accepts CSS values.
         *
         * Default value: `""` (the width of each title depends on the title length)
         * @see items
         * @see itemErrorLocation
         */ get: function() {
                        return this.getPropertyValue("itemTitleWidth") || "";
                    },
                    set: function(val1) {
                        this.setPropertyValue("itemTitleWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMultipleTextModel.prototype.onRowCreated = function(row) {
                    return row;
                };
                QuestionMultipleTextModel.prototype.calcVisibleRows = function() {
                    var colCount = this.colCount;
                    var items = this.items;
                    var index = 0;
                    var row;
                    var errorRow;
                    var rows = [];
                    for(var i = 0; i < items.length; i++){
                        if (index == 0) {
                            row = this.onRowCreated(new MutlipleTextRow());
                            errorRow = this.onRowCreated(new MutlipleTextErrorRow());
                            if (this.showItemErrorOnTop) {
                                rows.push(errorRow);
                                rows.push(row);
                            } else {
                                rows.push(row);
                                rows.push(errorRow);
                            }
                        }
                        row.cells.push(new MultipleTextCell(items[i], this));
                        errorRow.cells.push(new MultipleTextErrorCell(items[i], this));
                        index++;
                        if (index >= colCount || i == items.length - 1) {
                            index = 0;
                            errorRow.onAfterCreated();
                        }
                    }
                    this.rows = rows;
                };
                QuestionMultipleTextModel.prototype.getRows = function() {
                    if (_helpers__WEBPACK_IMPORTED_MODULE_6__["Helpers"].isValueEmpty(this.rows)) this.calcVisibleRows();
                    return this.rows;
                };
                QuestionMultipleTextModel.prototype.onValueChanged = function() {
                    _super.prototype.onValueChanged.call(this);
                    this.onItemValueChanged();
                };
                QuestionMultipleTextModel.prototype.createTextItem = function(name, title) {
                    return new MultipleTextItemModel(name, title);
                };
                QuestionMultipleTextModel.prototype.onItemValueChanged = function() {
                    if (this.isMultipleItemValueChanging) return;
                    for(var i = 0; i < this.items.length; i++){
                        var itemValue = null;
                        if (this.value && this.items[i].name in this.value) itemValue = this.value[this.items[i].name];
                        this.items[i].onValueChanged(itemValue);
                    }
                };
                QuestionMultipleTextModel.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    this.items.forEach(function(item) {
                        return item.editor.runCondition(values, properties);
                    });
                };
                QuestionMultipleTextModel.prototype.getIsRunningValidators = function() {
                    if (_super.prototype.getIsRunningValidators.call(this)) return true;
                    for(var i = 0; i < this.items.length; i++){
                        if (this.items[i].editor.isRunningValidators) return true;
                    }
                    return false;
                };
                QuestionMultipleTextModel.prototype.hasErrors = function(fireCallback, rec) {
                    var _this = this;
                    if (fireCallback === void 0) fireCallback = true;
                    if (rec === void 0) rec = null;
                    var res = false;
                    for(var i = 0; i < this.items.length; i++){
                        this.items[i].editor.onCompletedAsyncValidators = function(hasErrors) {
                            _this.raiseOnCompletedAsyncValidators();
                        };
                        if (!!rec && rec.isOnValueChanged === true && this.items[i].editor.isEmpty()) continue;
                        res = this.items[i].editor.hasErrors(fireCallback, rec) || res;
                    }
                    return _super.prototype.hasErrors.call(this, fireCallback) || res;
                };
                QuestionMultipleTextModel.prototype.getAllErrors = function() {
                    var result = _super.prototype.getAllErrors.call(this);
                    for(var i = 0; i < this.items.length; i++){
                        var errors = this.items[i].editor.getAllErrors();
                        if (errors && errors.length > 0) result = result.concat(errors);
                    }
                    return result;
                };
                QuestionMultipleTextModel.prototype.clearErrors = function() {
                    _super.prototype.clearErrors.call(this);
                    for(var i = 0; i < this.items.length; i++)this.items[i].editor.clearErrors();
                };
                QuestionMultipleTextModel.prototype.getContainsErrors = function() {
                    var res = _super.prototype.getContainsErrors.call(this);
                    if (res) return res;
                    var items = this.items;
                    for(var i = 0; i < items.length; i++){
                        if (items[i].editor.containsErrors) return true;
                    }
                    return false;
                };
                QuestionMultipleTextModel.prototype.getIsAnswered = function() {
                    if (!_super.prototype.getIsAnswered.call(this)) return false;
                    for(var i = 0; i < this.items.length; i++){
                        var editor = this.items[i].editor;
                        if (editor.isVisible && !editor.isAnswered) return false;
                    }
                    return true;
                };
                QuestionMultipleTextModel.prototype.getProgressInfo = function() {
                    var elements = [];
                    for(var i = 0; i < this.items.length; i++)elements.push(this.items[i].editor);
                    return _survey_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElement"].getProgressInfoByElements(elements, this.isRequired);
                };
                QuestionMultipleTextModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    if (!value) return value;
                    var res = {};
                    for(var i = 0; i < this.items.length; i++){
                        var item = this.items[i];
                        var val1 = value[item.name];
                        if (_helpers__WEBPACK_IMPORTED_MODULE_6__["Helpers"].isValueEmpty(val1)) continue;
                        var itemName = item.name;
                        if (keysAsText && !!item.title) itemName = item.title;
                        res[itemName] = item.editor.getDisplayValue(keysAsText, val1);
                    }
                    return res;
                };
                QuestionMultipleTextModel.prototype.allowMobileInDesignMode = function() {
                    return true;
                };
                //IMultipleTextData
                QuestionMultipleTextModel.prototype.getMultipleTextValue = function(name) {
                    if (!this.value) return null;
                    return this.value[name];
                };
                QuestionMultipleTextModel.prototype.setMultipleTextValue = function(name, value) {
                    this.isMultipleItemValueChanging = true;
                    if (this.isValueEmpty(value)) value = undefined;
                    var newValue = this.value;
                    if (!newValue) newValue = {};
                    newValue[name] = value;
                    this.setNewValue(newValue);
                    this.isMultipleItemValueChanging = false;
                };
                QuestionMultipleTextModel.prototype.getItemDefaultValue = function(name) {
                    return !!this.defaultValue ? this.defaultValue[name] : null;
                };
                QuestionMultipleTextModel.prototype.getTextProcessor = function() {
                    return this.textProcessor;
                };
                QuestionMultipleTextModel.prototype.getAllValues = function() {
                    return this.data ? this.data.getAllValues() : null;
                };
                QuestionMultipleTextModel.prototype.getIsRequiredText = function() {
                    return this.survey ? this.survey.requiredText : "";
                };
                //IPanel
                QuestionMultipleTextModel.prototype.addElement = function(element, index) {};
                QuestionMultipleTextModel.prototype.removeElement = function(element) {
                    return false;
                };
                QuestionMultipleTextModel.prototype.getQuestionTitleLocation = function() {
                    return "left";
                };
                QuestionMultipleTextModel.prototype.getQuestionStartIndex = function() {
                    return this.getStartIndex();
                };
                QuestionMultipleTextModel.prototype.getChildrenLayoutType = function() {
                    return "row";
                };
                QuestionMultipleTextModel.prototype.elementWidthChanged = function(el) {};
                Object.defineProperty(QuestionMultipleTextModel.prototype, "elements", {
                    get: function() {
                        return [];
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionMultipleTextModel.prototype.indexOf = function(el) {
                    return -1;
                };
                QuestionMultipleTextModel.prototype.ensureRowsVisibility = function() {
                // do nothing
                };
                QuestionMultipleTextModel.prototype.validateContainerOnly = function() {
                // do nothing
                };
                QuestionMultipleTextModel.prototype.getItemLabelCss = function(item) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__["CssClassBuilder"]().append(this.cssClasses.itemLabel).append(this.cssClasses.itemLabelAnswered, item.editor.isAnswered).append(this.cssClasses.itemLabelAllowFocus, !this.isDesignMode).append(this.cssClasses.itemLabelOnError, item.editor.errors.length > 0).append(this.cssClasses.itemWithCharacterCounter, !!item.getMaxLength()).toString();
                };
                QuestionMultipleTextModel.prototype.getItemCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__["CssClassBuilder"]().append(this.cssClasses.item).toString();
                };
                QuestionMultipleTextModel.prototype.getItemTitleCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__["CssClassBuilder"]().append(this.cssClasses.itemTitle).toString();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_4__["propertyArray"])()
                ], QuestionMultipleTextModel.prototype, "rows", void 0);
                return QuestionMultipleTextModel;
            }(_question__WEBPACK_IMPORTED_MODULE_2__["Question"]);
            var MutlipleTextRow = /** @class */ function(_super) {
                __extends(MutlipleTextRow, _super);
                function MutlipleTextRow() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.isVisible = true;
                    _this.cells = [];
                    return _this;
                }
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_4__["property"])()
                ], MutlipleTextRow.prototype, "isVisible", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_4__["propertyArray"])()
                ], MutlipleTextRow.prototype, "cells", void 0);
                return MutlipleTextRow;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            var MutlipleTextErrorRow = /** @class */ function(_super) {
                __extends(MutlipleTextErrorRow, _super);
                function MutlipleTextErrorRow() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                MutlipleTextErrorRow.prototype.onAfterCreated = function() {
                    var _this = this;
                    var callback = function() {
                        _this.isVisible = _this.cells.some(function(cell) {
                            var _a, _b;
                            return ((_a = cell.item) === null || _a === void 0 ? void 0 : _a.editor) && ((_b = cell.item) === null || _b === void 0 ? void 0 : _b.editor.hasVisibleErrors);
                        });
                    };
                    this.cells.forEach(function(cell) {
                        var _a, _b;
                        if ((_a = cell.item) === null || _a === void 0 ? void 0 : _a.editor) (_b = cell.item) === null || _b === void 0 || _b.editor.registerFunctionOnPropertyValueChanged("hasVisibleErrors", callback);
                    });
                    callback();
                };
                return MutlipleTextErrorRow;
            }(MutlipleTextRow);
            var MultipleTextCell = /** @class */ function() {
                function MultipleTextCell(item, question) {
                    this.item = item;
                    this.question = question;
                    this.isErrorsCell = false;
                }
                MultipleTextCell.prototype.getClassName = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__["CssClassBuilder"]().append(this.question.cssClasses.cell).toString();
                };
                Object.defineProperty(MultipleTextCell.prototype, "className", {
                    get: function() {
                        return this.getClassName();
                    },
                    enumerable: false,
                    configurable: true
                });
                return MultipleTextCell;
            }();
            var MultipleTextErrorCell = /** @class */ function(_super) {
                __extends(MultipleTextErrorCell, _super);
                function MultipleTextErrorCell() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.isErrorsCell = true;
                    return _this;
                }
                MultipleTextErrorCell.prototype.getClassName = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_7__["CssClassBuilder"]().append(_super.prototype.getClassName.call(this)).append(this.question.cssClasses.cellError).append(this.question.cssClasses.cellErrorTop, this.question.showItemErrorOnTop).append(this.question.cssClasses.cellErrorBottom, this.question.showItemErrorOnBottom).toString();
                };
                return MultipleTextErrorCell;
            }(MultipleTextCell);
            _jsonobject__WEBPACK_IMPORTED_MODULE_4__["Serializer"].addClass("multipletextitem", [
                {
                    name: "!name",
                    isUnique: true
                },
                "isRequired:boolean",
                {
                    name: "placeholder",
                    alternativeName: "placeHolder",
                    serializationProperty: "locPlaceholder"
                },
                {
                    name: "inputType",
                    default: "text",
                    choices: _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].questions.inputTypes
                },
                {
                    name: "maskType:masktype",
                    default: "none",
                    visibleIndex: 0,
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return obj.inputType === "text";
                    }
                },
                {
                    name: "maskSettings:masksettings",
                    className: "masksettings",
                    visibleIndex: 1,
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return obj.inputType === "text";
                    },
                    onGetValue: function(obj) {
                        return obj.maskSettings.getData();
                    },
                    onSetValue: function(obj, value) {
                        obj.maskSettings.setData(value);
                    }
                },
                {
                    name: "inputTextAlignment",
                    default: "auto",
                    choices: [
                        "left",
                        "right",
                        "auto"
                    ],
                    visible: false
                },
                {
                    name: "title",
                    serializationProperty: "locTitle"
                },
                {
                    name: "maxLength:number",
                    default: -1
                },
                {
                    name: "size:number",
                    minValue: 0
                },
                {
                    name: "requiredErrorText:text",
                    serializationProperty: "locRequiredErrorText"
                },
                {
                    name: "defaultValueExpression:expression",
                    visible: false
                },
                {
                    name: "minValueExpression:expression",
                    category: "logic",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return Object(_question_text__WEBPACK_IMPORTED_MODULE_3__["isMinMaxType"])(obj);
                    }
                },
                {
                    name: "maxValueExpression:expression",
                    category: "logic",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return Object(_question_text__WEBPACK_IMPORTED_MODULE_3__["isMinMaxType"])(obj);
                    }
                },
                {
                    name: "validators:validators",
                    baseClassName: "surveyvalidator",
                    classNamePart: "validator"
                }
            ], function() {
                return new MultipleTextItemModel("");
            });
            _jsonobject__WEBPACK_IMPORTED_MODULE_4__["Serializer"].addClass("multipletext", [
                {
                    name: "!items:textitems",
                    className: "multipletextitem",
                    isArray: true
                },
                {
                    name: "itemSize:number",
                    minValue: 0,
                    visible: false
                },
                {
                    name: "colCount:number",
                    default: 1,
                    choices: [
                        1,
                        2,
                        3,
                        4,
                        5
                    ]
                },
                {
                    name: "itemErrorLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom"
                    ],
                    visible: false
                },
                {
                    name: "itemTitleWidth",
                    category: "layout"
                }
            ], function() {
                return new QuestionMultipleTextModel("");
            }, "question");
            _questionfactory__WEBPACK_IMPORTED_MODULE_5__["QuestionFactory"].Instance.registerQuestion("multipletext", function(name) {
                var q = new QuestionMultipleTextModel(name);
                QuestionMultipleTextModel.addDefaultItems(q);
                return q;
            });
        /***/ },
        /***/ "./src/question_paneldynamic.ts": /*!**************************************!*\
  !*** ./src/question_paneldynamic.ts ***!
  \**************************************/ /*! exports provided: QuestionPanelDynamicItem, QuestionPanelDynamicTemplateSurveyImpl, QuestionPanelDynamicModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicItem", function() {
                return QuestionPanelDynamicItem;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicTemplateSurveyImpl", function() {
                return QuestionPanelDynamicTemplateSurveyImpl;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionPanelDynamicModel", function() {
                return QuestionPanelDynamicModel;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _textPreProcessor__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./textPreProcessor */ "./src/textPreProcessor.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./actions/adaptive-container */ "./src/actions/adaptive-container.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var __spreadArray = function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            var QuestionPanelDynamicItemTextProcessor = /** @class */ function(_super) {
                __extends(QuestionPanelDynamicItemTextProcessor, _super);
                function QuestionPanelDynamicItemTextProcessor(data, panelItem, variableName) {
                    var _this = _super.call(this, variableName) || this;
                    _this.data = data;
                    _this.panelItem = panelItem;
                    _this.variableName = variableName;
                    _this.sharedQuestions = {};
                    return _this;
                }
                Object.defineProperty(QuestionPanelDynamicItemTextProcessor.prototype, "survey", {
                    get: function() {
                        return this.panelItem.getSurvey();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicItemTextProcessor.prototype, "panel", {
                    get: function() {
                        return this.panelItem.panel;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicItemTextProcessor.prototype, "panelIndex", {
                    get: function() {
                        return !!this.data ? this.data.getItemIndex(this.panelItem) : -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicItemTextProcessor.prototype, "visiblePanelIndex", {
                    get: function() {
                        return !!this.data ? this.data.getVisibleItemIndex(this.panelItem) : -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicItemTextProcessor.prototype.getValues = function() {
                    return this.panelItem.getAllValues();
                };
                QuestionPanelDynamicItemTextProcessor.prototype.getQuestionByName = function(name) {
                    var res = _super.prototype.getQuestionByName.call(this, name);
                    if (!!res) return res;
                    var index = this.panelIndex;
                    res = index > -1 ? this.data.getSharedQuestionFromArray(name, index) : undefined;
                    var qName = !!res ? res.name : name;
                    this.sharedQuestions[qName] = name;
                    return res;
                };
                QuestionPanelDynamicItemTextProcessor.prototype.getQuestionDisplayText = function(question) {
                    var name = this.sharedQuestions[question.name];
                    if (!name) return _super.prototype.getQuestionDisplayText.call(this, question);
                    var val1 = this.panelItem.getValue(name);
                    return question.getDisplayValue(true, val1);
                };
                QuestionPanelDynamicItemTextProcessor.prototype.onCustomProcessText = function(textValue) {
                    if (textValue.name == QuestionPanelDynamicItem.IndexVariableName) {
                        var index = this.panelIndex;
                        if (index > -1) {
                            textValue.isExists = true;
                            textValue.value = index + 1;
                            return true;
                        }
                    }
                    if (textValue.name == QuestionPanelDynamicItem.VisibleIndexVariableName) {
                        var index = this.visiblePanelIndex;
                        if (index > -1) {
                            textValue.isExists = true;
                            textValue.value = index + 1;
                            return true;
                        }
                    }
                    if (textValue.name.toLowerCase().indexOf(QuestionPanelDynamicItem.ParentItemVariableName + ".") == 0) {
                        var q = this.data;
                        if (!!q && !!q.parentQuestion && !!q.parent && !!q.parent.data) {
                            var processor = new QuestionPanelDynamicItemTextProcessor(q.parentQuestion, q.parent.data, QuestionPanelDynamicItem.ItemVariableName);
                            var text = QuestionPanelDynamicItem.ItemVariableName + textValue.name.substring(QuestionPanelDynamicItem.ParentItemVariableName.length);
                            var res = processor.processValue(text, textValue.returnDisplayValue);
                            textValue.isExists = res.isExists;
                            textValue.value = res.value;
                        }
                        return true;
                    }
                    return false;
                };
                return QuestionPanelDynamicItemTextProcessor;
            }(_textPreProcessor__WEBPACK_IMPORTED_MODULE_3__["QuestionTextProcessor"]);
            var QuestionPanelDynamicItem = /** @class */ function() {
                function QuestionPanelDynamicItem(data, panel) {
                    this.data = data;
                    this.panelValue = panel;
                    this.textPreProcessor = new QuestionPanelDynamicItemTextProcessor(data, this, QuestionPanelDynamicItem.ItemVariableName);
                    this.setSurveyImpl();
                }
                Object.defineProperty(QuestionPanelDynamicItem.prototype, "panel", {
                    get: function() {
                        return this.panelValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicItem.prototype.setSurveyImpl = function() {
                    this.panel.setSurveyImpl(this);
                };
                QuestionPanelDynamicItem.prototype.getValue = function(name) {
                    var values = this.getAllValues();
                    return values[name];
                };
                QuestionPanelDynamicItem.prototype.setValue = function(name, newValue) {
                    var oldItemData = this.data.getPanelItemData(this);
                    var oldValue = !!oldItemData ? oldItemData[name] : undefined;
                    if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(newValue, oldValue, false, true, false)) return;
                    this.data.setPanelItemData(this, name, _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].getUnbindValue(newValue));
                    var questions = this.panel.questions;
                    var triggerName = QuestionPanelDynamicItem.ItemVariableName + "." + name;
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        if (q.getValueName() !== name) q.checkBindings(name, newValue);
                        q.runTriggers(triggerName, newValue);
                    }
                };
                QuestionPanelDynamicItem.prototype.getVariable = function(name) {
                    return undefined;
                };
                QuestionPanelDynamicItem.prototype.setVariable = function(name, newValue) {};
                QuestionPanelDynamicItem.prototype.getComment = function(name) {
                    var result = this.getValue(name + _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].commentSuffix);
                    return result ? result : "";
                };
                QuestionPanelDynamicItem.prototype.setComment = function(name, newValue, locNotification) {
                    this.setValue(name + _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].commentSuffix, newValue);
                };
                QuestionPanelDynamicItem.prototype.findQuestionByName = function(name) {
                    if (!name) return undefined;
                    var prefix = QuestionPanelDynamicItem.ItemVariableName + ".";
                    if (name.indexOf(prefix) === 0) return this.panel.getQuestionByName(name.substring(prefix.length));
                    var survey = this.getSurvey();
                    return !!survey ? survey.getQuestionByName(name) : null;
                };
                QuestionPanelDynamicItem.prototype.getAllValues = function() {
                    return this.data.getPanelItemData(this);
                };
                QuestionPanelDynamicItem.prototype.getFilteredValues = function() {
                    var values = {};
                    var surveyValues = !!this.data && !!this.data.getRootData() ? this.data.getRootData().getFilteredValues() : {};
                    for(var key in surveyValues)values[key] = surveyValues[key];
                    values[QuestionPanelDynamicItem.ItemVariableName] = this.getAllValues();
                    if (!!this.data) {
                        var indexStr = QuestionPanelDynamicItem.IndexVariableName;
                        var visibleIndexStr = QuestionPanelDynamicItem.VisibleIndexVariableName;
                        delete values[indexStr];
                        delete values[visibleIndexStr];
                        values[indexStr.toLowerCase()] = this.data.getItemIndex(this);
                        values[visibleIndexStr.toLowerCase()] = this.data.getVisibleItemIndex(this);
                        var q = this.data;
                        if (!!q && !!q.parentQuestion && !!q.parent) values[QuestionPanelDynamicItem.ParentItemVariableName] = q.parent.getValue();
                    }
                    return values;
                };
                QuestionPanelDynamicItem.prototype.getFilteredProperties = function() {
                    if (!!this.data && !!this.data.getRootData()) return this.data.getRootData().getFilteredProperties();
                    return {
                        survey: this.getSurvey()
                    };
                };
                QuestionPanelDynamicItem.prototype.getSurveyData = function() {
                    return this;
                };
                QuestionPanelDynamicItem.prototype.getSurvey = function() {
                    return this.data ? this.data.getSurvey() : null;
                };
                QuestionPanelDynamicItem.prototype.getTextProcessor = function() {
                    return this.textPreProcessor;
                };
                QuestionPanelDynamicItem.ItemVariableName = "panel";
                QuestionPanelDynamicItem.ParentItemVariableName = "parentpanel";
                QuestionPanelDynamicItem.IndexVariableName = "panelIndex";
                QuestionPanelDynamicItem.VisibleIndexVariableName = "visiblePanelIndex";
                return QuestionPanelDynamicItem;
            }();
            var QuestionPanelDynamicTemplateSurveyImpl = /** @class */ function() {
                function QuestionPanelDynamicTemplateSurveyImpl(data) {
                    this.data = data;
                }
                QuestionPanelDynamicTemplateSurveyImpl.prototype.getSurveyData = function() {
                    return null;
                };
                QuestionPanelDynamicTemplateSurveyImpl.prototype.getSurvey = function() {
                    return this.data.getSurvey();
                };
                QuestionPanelDynamicTemplateSurveyImpl.prototype.getTextProcessor = function() {
                    return null;
                };
                return QuestionPanelDynamicTemplateSurveyImpl;
            }();
            /**
  * A class that describes the Dynamic Panel question type.
  *
  * Dynamic Panel allows respondents to add panels based on a panel template and delete them. Specify the [`templateElements`](https://surveyjs.io/form-library/documentation/questionpaneldynamicmodel#templateElements) property to configure panel template elements.
  *
  * [View Demo](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/ (linkStyle))
  */ var QuestionPanelDynamicModel = /** @class */ function(_super) {
                __extends(QuestionPanelDynamicModel, _super);
                function QuestionPanelDynamicModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.isAddingNewPanels = false;
                    _this.isSetPanelItemData = {};
                    _this.createNewArray("panels", function(panel) {
                        _this.onPanelAdded(panel);
                    }, function(panel) {
                        _this.onPanelRemoved(panel);
                    });
                    _this.createNewArray("visiblePanels");
                    _this.templateValue = _this.createAndSetupNewPanelObject();
                    _this.template.renderWidth = "100%";
                    _this.template.selectedElementInDesign = _this;
                    _this.template.addElementCallback = function(element) {
                        _this.addOnPropertyChangedCallback(element);
                        _this.rebuildPanels();
                    };
                    _this.template.removeElementCallback = function() {
                        _this.rebuildPanels();
                    };
                    _this.createLocalizableString("confirmDeleteText", _this, false, "confirmDelete");
                    _this.createLocalizableString("keyDuplicationError", _this, false, true);
                    _this.createLocalizableString("panelAddText", _this, false, "addPanel");
                    _this.createLocalizableString("panelRemoveText", _this, false, "removePanel");
                    _this.createLocalizableString("panelPrevText", _this, false, "pagePrevText");
                    _this.createLocalizableString("panelNextText", _this, false, "pageNextText");
                    _this.createLocalizableString("noEntriesText", _this, false, "noEntriesText");
                    _this.createLocalizableString("templateTabTitle", _this, true, "panelDynamicTabTextFormat");
                    _this.registerPropertyChangedHandlers([
                        "panelsState"
                    ], function() {
                        _this.setPanelsState();
                    });
                    _this.registerPropertyChangedHandlers([
                        "isMobile",
                        "newPanelPosition",
                        "showRangeInProgress",
                        "renderMode"
                    ], function() {
                        _this.updateFooterActions();
                    });
                    _this.registerPropertyChangedHandlers([
                        "allowAddPanel"
                    ], function() {
                        _this.updateNoEntriesTextDefaultLoc();
                    });
                    return _this;
                }
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isCompositeQuestion", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "hasSingleInput", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isContainer", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.getFirstQuestionToFocus = function(withError) {
                    for(var i = 0; i < this.visiblePanelsCore.length; i++){
                        var res = this.visiblePanelsCore[i].getFirstQuestionToFocus(withError);
                        if (!!res) return res;
                    }
                    return null;
                };
                QuestionPanelDynamicModel.prototype.setSurveyImpl = function(value, isLight) {
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    this.setTemplatePanelSurveyImpl();
                    this.setPanelsSurveyImpl();
                };
                QuestionPanelDynamicModel.prototype.assignOnPropertyChangedToTemplate = function() {
                    var elements = this.template.elements;
                    for(var i = 0; i < elements.length; i++)this.addOnPropertyChangedCallback(elements[i]);
                };
                QuestionPanelDynamicModel.prototype.addOnPropertyChangedCallback = function(element) {
                    var _this = this;
                    if (element.isQuestion) element.setParentQuestion(this);
                    element.onPropertyChanged.add(function(element, options) {
                        _this.onTemplateElementPropertyChanged(element, options);
                    });
                    if (element.isPanel) element.addElementCallback = function(element) {
                        _this.addOnPropertyChangedCallback(element);
                    };
                };
                QuestionPanelDynamicModel.prototype.onTemplateElementPropertyChanged = function(element, options) {
                    if (this.isLoadingFromJson || this.useTemplatePanel || this.panelsCore.length == 0) return;
                    var property = _jsonobject__WEBPACK_IMPORTED_MODULE_5__["Serializer"].findProperty(element.getType(), options.name);
                    if (!property) return;
                    var panels = this.panelsCore;
                    for(var i = 0; i < panels.length; i++){
                        var question = panels[i].getQuestionByName(element.name);
                        if (!!question && question[options.name] !== options.newValue) question[options.name] = options.newValue;
                    }
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "useTemplatePanel", {
                    get: function() {
                        return this.isDesignMode && !this.isContentElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.getType = function() {
                    return "paneldynamic";
                };
                QuestionPanelDynamicModel.prototype.clearOnDeletingContainer = function() {
                    this.panelsCore.forEach(function(panel) {
                        panel.clearOnDeletingContainer();
                    });
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isAllowTitleLeft", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.removeElement = function(element) {
                    return this.template.removeElement(element);
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "template", {
                    /**
         * A `PanelModel` object used as a template to create dynamic panels.
         * @see PanelModel
         * @see templateElements
         * @see templateTitle
         * @see panels
         * @see panelCount
         */ get: function() {
                        return this.templateValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.getPanel = function() {
                    return this.template;
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "templateElements", {
                    /**
         * An array of questions and panels included in a panel template.
         * @see template
         * @see panels
         * @see panelCount
         */ get: function() {
                        return this.template.elements;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "templateTitle", {
                    /**
         * A template for panel titles.
         *
         * The template can contain the following placeholders:
         *
         * - `{panelIndex}` - A panel index within the collection of all panels. Starts with 1.
         * - `{visiblePanelIndex}` - A panel index within the collection of visible panels. Starts with 1.
         * @see template
         * @see templateDescription
         * @see templateElements
         * @see panels
         * @see panelCount
         */ get: function() {
                        return this.template.title;
                    },
                    set: function(newValue) {
                        this.template.title = newValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locTemplateTitle", {
                    get: function() {
                        return this.template.locTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "templateTabTitle", {
                    /**
         * A template for tab titles. Applies when [`renderMode`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model#renderMode) is `"tab"`.
         *
         * The template can contain the following placeholders:
         *
         * - `{panelIndex}` - A panel index within the collection of all panels. Starts with 1.
         * - `{visiblePanelIndex}` - A panel index within the collection of visible panels. Starts with 1.
         *
         * If you want to customize individual tab titles, handle `SurveyModel`'s [`onGetDynamicPanelTabTitle`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onGetDynamicPanelTabTitle) event.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/tabbed-interface-for-duplicate-group-option/ (linkStyle))
         * @see templateTitle
         * @see renderMode
         */ get: function() {
                        return this.locTemplateTabTitle.text;
                    },
                    set: function(newValue) {
                        this.locTemplateTabTitle.text = newValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locTemplateTabTitle", {
                    get: function() {
                        return this.getLocalizableString("templateTabTitle");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "templateDescription", {
                    /**
         * A template for panel descriptions.
         * @see template
         * @see templateTitle
         * @see templateElements
         * @see panels
         * @see panelCount
         */ get: function() {
                        return this.template.description;
                    },
                    set: function(newValue) {
                        this.template.description = newValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locTemplateDescription", {
                    get: function() {
                        return this.template.locDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "templateVisibleIf", {
                    /**
         * A Boolean expression that is evaluated against each panel. If the expression evaluates to `false`, the panel becomes hidden.
         *
         * A survey parses and runs all expressions on startup. If any values used in the expression change, the survey re-evaluates it.
         *
         * Use the `{panel}` placeholder to reference the current panel in the expression.
         *
         * Refer to the following help topic for more information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-visibility).
         * @see visibleIf
         * @see visiblePanels
         */ get: function() {
                        return this.getPropertyValue("templateVisibleIf");
                    },
                    set: function(val1) {
                        this.setPropertyValue("templateVisibleIf", val1);
                        this.template.visibleIf = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "items", {
                    get: function() {
                        var res = [];
                        for(var i = 0; i < this.panelsCore.length; i++)res.push(this.panelsCore[i].data);
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panels", {
                    /**
         * An array of `PanelModel` objects created based on a panel template.
         * @see PanelModel
         * @see template
         * @see panelCount
         */ get: function() {
                        this.buildPanelsFirstTime(this.canBuildPanels);
                        return this.panelsCore;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "visiblePanels", {
                    /**
         * An array of currently visible panels ([`PanelModel`](https://surveyjs.io/form-library/documentation/api-reference/panel-model) objects).
         * @see templateVisibleIf
         */ get: function() {
                        this.buildPanelsFirstTime(this.canBuildPanels);
                        return this.visiblePanelsCore;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panelsCore", {
                    get: function() {
                        return this.getPropertyValue("panels");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "visiblePanelsCore", {
                    get: function() {
                        return this.getPropertyValue("visiblePanels");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.onPanelAdded = function(panel) {
                    this.onPanelRemovedCore(panel);
                    if (!panel.visible) return;
                    var index = 0;
                    var panels = this.panelsCore;
                    for(var i = 0; i < panels.length; i++){
                        if (panels[i] === panel) break;
                        if (panels[i].visible) index++;
                    }
                    this.visiblePanelsCore.splice(index, 0, panel);
                    this.addTabFromToolbar(panel, index);
                    if (!this.currentPanel) this.currentPanel = panel;
                };
                QuestionPanelDynamicModel.prototype.onPanelRemoved = function(panel) {
                    var index = this.onPanelRemovedCore(panel);
                    if (this.currentPanel === panel) {
                        var visPanels = this.visiblePanelsCore;
                        if (index >= visPanels.length) index = visPanels.length - 1;
                        this.currentPanel = index >= 0 ? visPanels[index] : null;
                    }
                };
                QuestionPanelDynamicModel.prototype.onPanelRemovedCore = function(panel) {
                    var visPanels = this.visiblePanelsCore;
                    var index = visPanels.indexOf(panel);
                    if (index > -1) {
                        visPanels.splice(index, 1);
                        this.removeTabFromToolbar(panel);
                    }
                    return index;
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "currentIndex", {
                    /**
         * A zero-based index of the currently displayed panel.
         *
         * When `renderMode` is `"list"` or Dynamic Panel is empty (`panelCount` is 0), this property contains -1.
         * @see currentPanel
         * @see panels
         * @see panelCount
         * @see renderMode
         */ get: function() {
                        if (this.isRenderModeList) return -1;
                        if (this.useTemplatePanel) return 0;
                        return this.visiblePanelsCore.indexOf(this.currentPanel);
                    },
                    set: function(val1) {
                        if (val1 < 0 || this.visiblePanelCount < 1) return;
                        if (val1 >= this.visiblePanelCount) val1 = this.visiblePanelCount - 1;
                        this.currentPanel = this.visiblePanelsCore[val1];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "currentPanel", {
                    /**
         * A `PanelModel` object that is the currently displayed panel.
         *
         * When `renderMode` is `"list"` or Dynamic Panel is empty (`panelCount` is 0), this property contains `null`.
         * @see currentIndex
         * @see panels
         * @see panelCount
         * @see renderMode
         */ get: function() {
                        if (this.isDesignMode) return this.template;
                        if (this.isRenderModeList || this.useTemplatePanel) return null;
                        var res = this.getPropertyValue("currentPanel", null);
                        if (!res && this.visiblePanelCount > 0) {
                            res = this.visiblePanelsCore[0];
                            this.currentPanel = res;
                        }
                        return res;
                    },
                    set: function(val1) {
                        if (this.isRenderModeList || this.useTemplatePanel) return;
                        var curPanel = this.getPropertyValue("currentPanel");
                        var index = !!val1 ? this.visiblePanelsCore.indexOf(val1) : -1;
                        if (!!val1 && index < 0 || val1 === curPanel) return;
                        if (curPanel) curPanel.onHidingContent();
                        this.setPropertyValue("currentPanel", val1);
                        this.updateFooterActions();
                        this.updateTabToolbarItemsPressedState();
                        this.fireCallback(this.currentIndexChangedCallback);
                        if (index > -1 && this.survey) {
                            var options = {
                                panel: val1,
                                visiblePanelIndex: index
                            };
                            this.survey.dynamicPanelCurrentIndexChanged(this, options);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.onHidingContent = function() {
                    _super.prototype.onHidingContent.call(this);
                    if (this.currentPanel) this.currentPanel.onHidingContent();
                    else this.visiblePanelsCore.forEach(function(panel) {
                        return panel.onHidingContent();
                    });
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "confirmDelete", {
                    /**
         * Specifies whether to display a confirmation dialog when a respondent wants to delete a panel.
         * @see confirmDeleteText
         */ get: function() {
                        return this.getPropertyValue("confirmDelete");
                    },
                    set: function(val1) {
                        this.setPropertyValue("confirmDelete", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "keyName", {
                    /**
         * Specifies a key question. Set this property to the name of a question used in the template, and Dynamic Panel will display `keyDuplicationError` if a user tries to enter a duplicate value in this question.
         * @see keyDuplicationError
         */ get: function() {
                        return this.getPropertyValue("keyName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("keyName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "confirmDeleteText", {
                    /**
         * A message displayed in a confirmation dialog that appears when a respondent wants to delete a panel.
         * @see confirmDelete
         */ get: function() {
                        return this.getLocalizableStringText("confirmDeleteText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("confirmDeleteText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locConfirmDeleteText", {
                    get: function() {
                        return this.getLocalizableString("confirmDeleteText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "keyDuplicationError", {
                    /**
         * An error message displayed when users enter a duplicate value into a question that accepts only unique values (`isUnique` is set to `true` or `keyName` is specified).
         *
         * A default value for this property is taken from a [localization dictionary](https://github.com/surveyjs/survey-library/tree/master/src/localization). Refer to the following help topic for more information: [Localization & Globalization](https://surveyjs.io/form-library/documentation/localization).
         * @see keyName
         */ get: function() {
                        return this.getLocalizableStringText("keyDuplicationError");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("keyDuplicationError", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locKeyDuplicationError", {
                    get: function() {
                        return this.getLocalizableString("keyDuplicationError");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panelPrevText", {
                    /**
         * A caption for the Previous button. Applies only if `renderMode` is different from `"list"`.
         * @see renderMode
         * @see isPrevButtonVisible
         */ get: function() {
                        return this.getLocalizableStringText("panelPrevText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("panelPrevText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locPanelPrevText", {
                    get: function() {
                        return this.getLocalizableString("panelPrevText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panelNextText", {
                    /**
         * A caption for the Next button. Applies only if `renderMode` is different from `"list"`.
         * @see renderMode
         * @see isNextButtonVisible
         */ get: function() {
                        return this.getLocalizableStringText("panelNextText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("panelNextText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locPanelNextText", {
                    get: function() {
                        return this.getLocalizableString("panelNextText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panelAddText", {
                    /**
         * A caption for the Add Panel button.
         */ get: function() {
                        return this.getLocalizableStringText("panelAddText");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("panelAddText", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locPanelAddText", {
                    get: function() {
                        return this.getLocalizableString("panelAddText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panelRemoveText", {
                    /**
         * A caption for the Delete Panel button.
         * @see panelRemoveButtonLocation
         */ get: function() {
                        return this.getLocalizableStringText("panelRemoveText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("panelRemoveText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locPanelRemoveText", {
                    get: function() {
                        return this.getLocalizableString("panelRemoveText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isProgressTopShowing", {
                    /**
         * Returns true when the renderMode equals to "progressTop" or "progressTopBottom"
         */ get: function() {
                        return this.renderMode === "progressTop" || this.renderMode === "progressTopBottom";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isProgressBottomShowing", {
                    /**
         * Returns true when the renderMode equals to "progressBottom" or "progressTopBottom"
         */ get: function() {
                        return this.renderMode === "progressBottom" || this.renderMode === "progressTopBottom";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isPrevButtonVisible", {
                    /**
         * Indicates whether the Previous button is visible.
         * @see currentIndex
         * @see currentPanel
         * @see panelPrevText
         */ get: function() {
                        return this.currentIndex > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isPrevButtonShowing", {
                    get: function() {
                        return this.isPrevButtonVisible;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isNextButtonVisible", {
                    /**
         * Indicates whether the Next button is visible.
         * @see currentIndex
         * @see currentPanel
         * @see panelNextText
         */ get: function() {
                        return this.currentIndex >= 0 && this.currentIndex < this.visiblePanelCount - 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isNextButtonShowing", {
                    get: function() {
                        return this.isNextButtonVisible;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isRangeShowing", {
                    /**
         * Returns true when showRangeInProgress equals to true, renderMode doesn't equal to "list" and visiblePanelCount is >= 2.
         */ get: function() {
                        return this.showRangeInProgress && this.currentIndex >= 0 && this.visiblePanelCount > 1;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.getElementsInDesign = function(includeHidden) {
                    if (includeHidden === void 0) includeHidden = false;
                    return includeHidden ? [
                        this.template
                    ] : this.templateElements;
                };
                QuestionPanelDynamicModel.prototype.prepareValueForPanelCreating = function() {
                    this.addingNewPanelsValue = this.value;
                    this.isAddingNewPanels = true;
                    this.isNewPanelsValueChanged = false;
                };
                QuestionPanelDynamicModel.prototype.setValueAfterPanelsCreating = function() {
                    this.isAddingNewPanels = false;
                    if (this.isNewPanelsValueChanged) {
                        this.isValueChangingInternally = true;
                        this.value = this.addingNewPanelsValue;
                        this.isValueChangingInternally = false;
                    }
                };
                QuestionPanelDynamicModel.prototype.getValueCore = function() {
                    return this.isAddingNewPanels ? this.addingNewPanelsValue : _super.prototype.getValueCore.call(this);
                };
                QuestionPanelDynamicModel.prototype.setValueCore = function(newValue) {
                    if (this.isAddingNewPanels) {
                        this.isNewPanelsValueChanged = true;
                        this.addingNewPanelsValue = newValue;
                    } else _super.prototype.setValueCore.call(this, newValue);
                };
                QuestionPanelDynamicModel.prototype.setIsMobile = function(val1) {
                    _super.prototype.setIsMobile.call(this, val1);
                    (this.panelsCore || []).forEach(function(panel) {
                        return panel.getQuestions(true).forEach(function(question) {
                            question.setIsMobile(val1);
                        });
                    });
                };
                QuestionPanelDynamicModel.prototype.themeChanged = function(theme) {
                    _super.prototype.themeChanged.call(this, theme);
                    (this.panelsCore || []).forEach(function(panel) {
                        return panel.getQuestions(true).forEach(function(question) {
                            question.themeChanged(theme);
                        });
                    });
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panelCount", {
                    /**
         * The number of panels in Dynamic Panel.
         * @see minPanelCount
         * @see maxPanelCount
         */ get: function() {
                        return !this.canBuildPanels || this.wasNotRenderedInSurvey ? this.getPropertyValue("panelCount") : this.panelsCore.length;
                    },
                    set: function(val1) {
                        if (val1 < 0) return;
                        if (!this.canBuildPanels || this.wasNotRenderedInSurvey) {
                            this.setPropertyValue("panelCount", val1);
                            return;
                        }
                        if (val1 == this.panelsCore.length || this.useTemplatePanel) return;
                        this.updateBindings("panelCount", val1);
                        this.prepareValueForPanelCreating();
                        for(var i = this.panelCount; i < val1; i++){
                            var panel = this.createNewPanel();
                            this.panelsCore.push(panel);
                            if (this.renderMode == "list" && this.panelsState != "default") {
                                if (this.panelsState === "expand") panel.expand();
                                else if (!!panel.title) panel.collapse();
                            }
                        }
                        if (val1 < this.panelCount) this.panelsCore.splice(val1, this.panelCount - val1);
                        this.setValueAfterPanelsCreating();
                        this.setValueBasedOnPanelCount();
                        this.reRunCondition();
                        this.updateFooterActions();
                        this.fireCallback(this.panelCountChangedCallback);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "visiblePanelCount", {
                    /**
         * Returns the number of visible panels in Dynamic Panel.
         * @see templateVisibleIf
         */ get: function() {
                        return this.visiblePanels.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panelsState", {
                    /**
         * Specifies whether users can expand and collapse panels. Applies if `renderMode` is `"list"` and the `templateTitle` property is specified.
         *
         * Possible values:
         *
         * - `"default"` (default) - All panels are displayed in full and cannot be collapsed.
         * - `"expanded"` - All panels are displayed in full and can be collapsed in the UI.
         * - `"collapsed"` - All panels display only their titles and descriptions and can be expanded in the UI.
         * - `"firstExpanded"` - Only the first panel is displayed in full; other panels are collapsed and can be expanded in the UI.
         * @see renderMode
         * @see templateTitle
         */ get: function() {
                        return this.getPropertyValue("panelsState");
                    },
                    set: function(val1) {
                        this.setPropertyValue("panelsState", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.setTemplatePanelSurveyImpl = function() {
                    this.template.setSurveyImpl(this.useTemplatePanel ? this.surveyImpl : new QuestionPanelDynamicTemplateSurveyImpl(this));
                };
                QuestionPanelDynamicModel.prototype.setPanelsSurveyImpl = function() {
                    for(var i = 0; i < this.panelsCore.length; i++){
                        var panel = this.panelsCore[i];
                        if (panel == this.template) continue;
                        panel.setSurveyImpl(panel.data);
                    }
                };
                QuestionPanelDynamicModel.prototype.setPanelsState = function() {
                    if (this.useTemplatePanel || this.renderMode != "list" || !this.templateTitle) return;
                    for(var i = 0; i < this.panelsCore.length; i++){
                        var state = this.panelsState;
                        if (state === "firstExpanded") state = i === 0 ? "expanded" : "collapsed";
                        this.panelsCore[i].state = state;
                    }
                };
                QuestionPanelDynamicModel.prototype.setValueBasedOnPanelCount = function() {
                    var value = this.value;
                    if (!value || !Array.isArray(value)) value = [];
                    if (value.length == this.panelCount) return;
                    for(var i = value.length; i < this.panelCount; i++)value.push({});
                    if (value.length > this.panelCount) value.splice(this.panelCount, value.length - this.panelCount);
                    this.isValueChangingInternally = true;
                    this.value = value;
                    this.isValueChangingInternally = false;
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "minPanelCount", {
                    /**
         * A minimum number of panels in Dynamic Panel. Users cannot delete panels if `panelCount` equals `minPanelCount`.
         *
         * Default value: 0
         * @see panelCount
         * @see maxPanelCount
         * @see allowRemovePanel
         */ get: function() {
                        return this.getPropertyValue("minPanelCount");
                    },
                    set: function(val1) {
                        if (val1 < 0) val1 = 0;
                        if (val1 == this.minPanelCount) return;
                        this.setPropertyValue("minPanelCount", val1);
                        if (val1 > this.maxPanelCount) this.maxPanelCount = val1;
                        if (this.panelCount < val1) this.panelCount = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "maxPanelCount", {
                    /**
         * A maximum number of panels in Dynamic Panel. Users cannot add new panels if `panelCount` equals `maxPanelCount`.
         *
         * Default value: 100 (inherited from [`settings.panel.maxPanelCount`](https://surveyjs.io/form-library/documentation/settings#panelMaximumPanelCount))
         * @see panelCount
         * @see minPanelCount
         * @see allowAddPanel
         */ get: function() {
                        return this.getPropertyValue("maxPanelCount");
                    },
                    set: function(val1) {
                        if (val1 <= 0) return;
                        if (val1 > _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].panel.maxPanelCount) val1 = _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].panel.maxPanelCount;
                        if (val1 == this.maxPanelCount) return;
                        this.setPropertyValue("maxPanelCount", val1);
                        if (val1 < this.minPanelCount) this.minPanelCount = val1;
                        if (this.panelCount > val1) this.panelCount = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "allowAddPanel", {
                    /**
         * Specifies whether users are allowed to add new panels.
         *
         * Default value: `true`
         *
         * By default, users add new panels to the end. If you want to let users insert a new panel after the current panel, set the [`newPanelPosition`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model#newPanelPosition) property to `"next"`.
         * @see canAddPanel
         * @see allowRemovePanel
         */ get: function() {
                        return this.getPropertyValue("allowAddPanel");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowAddPanel", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "newPanelPosition", {
                    /**
         * Specifies the position of newly added panels.
         *
         * Possible values:
         *
         * - `"last"` (default) - New panels are added to the end.
         * - `"next"` - New panels are inserted after the current panel.
         * @see allowAddPanel
         * @see addPanel
         */ get: function() {
                        return this.getPropertyValue("newPanelPosition");
                    },
                    set: function(val1) {
                        this.setPropertyValue("newPanelPosition", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "allowRemovePanel", {
                    /**
         * Specifies whether users are allowed to delete panels.
         *
         * Default value: `true`
         * @see canRemovePanel
         * @see allowAddPanel
         */ get: function() {
                        return this.getPropertyValue("allowRemovePanel");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowRemovePanel", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "templateTitleLocation", {
                    /**
         * Gets or sets the location of question titles relative to their input fields.
         *
         * - `"default"` (default) - Inherits the setting from the Dynamic Panel's `titleLocation` property, which in turn inherits the [`questionTitleLocation`](https://surveyjs.io/form-library/documentation/surveymodel#questionTitleLocation) property value specified for the Dynamic Panel's container (page or survey).
         * - `"top"` - Displays question titles above input fields.
         * - `"bottom"` - Displays question titles below input fields.
         * - `"left"` - Displays question titles to the left of input fields.
         * - `"hidden"` - Hides question titles.
         * @see titleLocation
         */ get: function() {
                        return this.getPropertyValue("templateTitleLocation");
                    },
                    set: function(value) {
                        this.setPropertyValue("templateTitleLocation", value.toLowerCase());
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "templateErrorLocation", {
                    /**
         * Specifies the error message position.
         *
         * Possible values:
         *
         * - `"default"` (default) - Inherits the setting from the [`errorLocation`](#errorLocation) property.
         * - `"top"` - Displays error messages above questions.
         * - `"bottom"` - Displays error messages below questions.
         */ get: function() {
                        return this.getPropertyValue("templateErrorLocation");
                    },
                    set: function(value) {
                        this.setPropertyValue("templateErrorLocation", value.toLowerCase());
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "showQuestionNumbers", {
                    /**
         * Use this property to show/hide the numbers in titles in questions inside a dynamic panel.
         * By default the value is "off". You may set it to "onPanel" and the first question inside a dynamic panel will start with 1 or "onSurvey" to include nested questions in dymamic panels into global survey question numbering.
         */ get: function() {
                        return this.getPropertyValue("showQuestionNumbers");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showQuestionNumbers", val1);
                        if (!this.isLoadingFromJson && this.survey) this.survey.questionVisibilityChanged(this, this.visible);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "panelRemoveButtonLocation", {
                    /**
         * Specifies the location of the Delete Panel button relative to panel content.
         *
         * Possible values:
         *
         * - `"bottom"` (default) - Displays the Delete Panel button below panel content.
         * - `"right"` - Displays the Delete Panel button to the right of panel content.
         * @see panelRemoveText
         */ get: function() {
                        return this.getPropertyValue("panelRemoveButtonLocation");
                    },
                    set: function(val1) {
                        this.setPropertyValue("panelRemoveButtonLocation", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "showRangeInProgress", {
                    /**
         * Shows the range from 1 to panelCount when renderMode doesn't equal to "list". Set to false to hide this element.
         * @see panelCount
         * @see renderMode
         */ get: function() {
                        return this.getPropertyValue("showRangeInProgress");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showRangeInProgress", val1);
                        this.fireCallback(this.currentIndexChangedCallback);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "renderMode", {
                    /**
         * Specifies how to render panels.
         *
         * Possible values:
         *
         * - `"list"` (default) - Renders panels one under the other. [View Demo](https://surveyjs.io/form-library/examples/how-to-use-expressions-in-dynamic-panel/)
         * - `"progressTop"` - Renders each panel as a card and displays a progress bar at the top. [View Demo](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/)
         * - `"progressBottom"` - Renders each panel panel as a card and displays a progress bar at the bottom.
         * - `"progressTopBottom"` - Renders each panel as a card and displays a progress bar at the top and bottom.
         * - `"tab"` - Renders each panel within a tab. Use the [`templateTabTitle`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model#templateTabTitle) to specify a template for tab titles. [View Demo](https://surveyjs.io/form-library/examples/tabbed-interface-for-duplicate-group-option/)
         */ get: function() {
                        return this.getPropertyValue("renderMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("renderMode", val1);
                        this.fireCallback(this.renderModeChangedCallback);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "tabAlign", {
                    get: function() {
                        return this.getPropertyValue("tabAlign");
                    },
                    set: function(val1) {
                        this.setPropertyValue("tabAlign", val1);
                        if (this.isRenderModeTab) this.additionalTitleToolbar.containerCss = this.getAdditionalTitleToolbarCss();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isRenderModeList", {
                    get: function() {
                        return this.renderMode === "list";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isRenderModeTab", {
                    get: function() {
                        return this.renderMode === "tab";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "hasTitleOnLeftTop", {
                    get: function() {
                        if (this.isRenderModeTab && this.visiblePanelCount > 0) return true;
                        if (!this.hasTitle) return false;
                        var location = this.getTitleLocation();
                        return location === "left" || location === "top";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.setVisibleIndex = function(value) {
                    if (!this.isVisible) return 0;
                    var startIndex = this.showQuestionNumbers == "onSurvey" ? value : 0;
                    for(var i = 0; i < this.visiblePanelsCore.length; i++){
                        var counter = this.setPanelVisibleIndex(this.visiblePanelsCore[i], startIndex, this.showQuestionNumbers != "off");
                        if (this.showQuestionNumbers == "onSurvey") startIndex += counter;
                    }
                    _super.prototype.setVisibleIndex.call(this, this.showQuestionNumbers != "onSurvey" ? value : -1);
                    return this.showQuestionNumbers != "onSurvey" ? 1 : startIndex - value;
                };
                QuestionPanelDynamicModel.prototype.setPanelVisibleIndex = function(panel, index, showIndex) {
                    if (!showIndex) {
                        panel.setVisibleIndex(-1);
                        return 0;
                    }
                    return panel.setVisibleIndex(index);
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "canAddPanel", {
                    /**
         * Indicates whether it is possible to add a new panel.
         *
         * This property returns `true` when all of the following conditions apply:
         *
         * - Users are allowed to add new panels (`allowAddPanel` is `true`).
         * - Dynamic Panel or its parent survey is not in read-only state.
         * - `panelCount` is less than `maxPanelCount`.
         * @see allowAddPanel
         * @see isReadOnly
         * @see panelCount
         * @see maxPanelCount
         * @see canRemovePanel
         */ get: function() {
                        if (this.isDesignMode) return false;
                        if (this.isDefaultV2Theme && !this.legacyNavigation && !this.isRenderModeList && this.currentIndex < this.visiblePanelCount - 1 && this.newPanelPosition !== "next") return false;
                        return this.allowAddPanel && !this.isReadOnly && this.panelCount < this.maxPanelCount;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "canRemovePanel", {
                    /**
         * Indicates whether it is possible to delete panels.
         *
         * This property returns `true` when all of the following conditions apply:
         *
         * - Users are allowed to delete panels (`allowRemovePanel` is `true`).
         * - Dynamic Panel or its parent survey is not in read-only state.
         * - `panelCount` exceeds `minPanelCount`.
         * @see allowRemovePanel
         * @see isReadOnly
         * @see panelCount
         * @see minPanelCount
         * @see canAddPanel
         */ get: function() {
                        if (this.isDesignMode) return false;
                        return this.allowRemovePanel && !this.isReadOnly && this.panelCount > this.minPanelCount;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.rebuildPanels = function() {
                    var _a;
                    if (this.isLoadingFromJson) return;
                    this.prepareValueForPanelCreating();
                    var panels = [];
                    var panel;
                    if (this.useTemplatePanel) {
                        panel = new QuestionPanelDynamicItem(this, this.template);
                        panels.push(this.template);
                    } else for(var i = 0; i < this.panelCount; i++){
                        panel = this.createNewPanel();
                        panels.push(this.createNewPanel());
                    }
                    (_a = this.panelsCore).splice.apply(_a, __spreadArray([
                        0,
                        this.panelsCore.length
                    ], panels));
                    this.setValueAfterPanelsCreating();
                    this.setPanelsState();
                    this.reRunCondition();
                    this.updateFooterActions();
                    this.fireCallback(this.panelCountChangedCallback);
                    this.updateTabToolbar();
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "defaultPanelValue", {
                    /**
         * If it is not empty, then this value is set to every new panel, including panels created initially, unless the defaultValue is not empty
         * @see defaultValue
         * @see defaultValueFromLastPanel
         */ get: function() {
                        return this.getPropertyValue("defaultPanelValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("defaultPanelValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "defaultValueFromLastPanel", {
                    /**
         * Specifies whether default values for a new panel should be copied from the last panel.
         *
         * If you also specify `defaultValue`, it will be merged with the copied values.
         * @see defaultValue
         */ get: function() {
                        return this.getPropertyValue("defaultValueFromLastPanel");
                    },
                    set: function(val1) {
                        this.setPropertyValue("defaultValueFromLastPanel", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.isDefaultValueEmpty = function() {
                    return _super.prototype.isDefaultValueEmpty.call(this) && this.isValueEmpty(this.defaultPanelValue);
                };
                QuestionPanelDynamicModel.prototype.setDefaultValue = function() {
                    if (this.isValueEmpty(this.defaultPanelValue) || !this.isValueEmpty(this.defaultValue)) {
                        _super.prototype.setDefaultValue.call(this);
                        return;
                    }
                    if (!this.isEmpty() || this.panelCount == 0) return;
                    var newValue = [];
                    for(var i = 0; i < this.panelCount; i++)newValue.push(this.defaultPanelValue);
                    this.value = newValue;
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "isValueArray", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.isEmpty = function() {
                    var val1 = this.value;
                    if (!val1 || !Array.isArray(val1)) return true;
                    for(var i = 0; i < val1.length; i++){
                        if (!this.isRowEmpty(val1[i])) return false;
                    }
                    return true;
                };
                QuestionPanelDynamicModel.prototype.getProgressInfo = function() {
                    return _survey_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElement"].getProgressInfoByElements(this.visiblePanelsCore, this.isRequired);
                };
                QuestionPanelDynamicModel.prototype.isRowEmpty = function(val1) {
                    for(var prop in val1){
                        if (val1.hasOwnProperty(prop)) return false;
                    }
                    return true;
                };
                /**
     * Add a new dynamic panel based on the template Panel. It checks if canAddPanel returns true and then calls addPanel method.
     * If a renderMode is different from "list" and the current panel has erros, then
     * @see template
     * @see panelCount
     * @see panels
     * @see canAddPanel
     */ QuestionPanelDynamicModel.prototype.addPanelUI = function() {
                    if (!this.canAddPanel) return null;
                    if (!this.canLeaveCurrentPanel()) return null;
                    var newPanel = this.addPanel();
                    if (this.renderMode === "list" && this.panelsState !== "default") newPanel.expand();
                    newPanel.focusFirstQuestion();
                    return newPanel;
                };
                /**
     * Adds a new panel based on the [template](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model#template).
     * @param index *(Optional)* An index at which to insert the new panel. `undefined` adds the panel to the end or inserts it after the current panel if [`renderMode`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model#renderMode) is `"tab"`. A negative index (for instance, -1) adds the panel to the end in all cases, regardless of the `renderMode` value.
     * @see panelCount
     * @see panels
     * @see allowAddPanel
     * @see newPanelPosition
     */ QuestionPanelDynamicModel.prototype.addPanel = function(index) {
                    var curIndex = this.currentIndex;
                    if (index === undefined) index = curIndex < 0 ? this.panelCount : curIndex + 1;
                    if (index < 0 || index > this.panelCount) index = this.panelCount;
                    this.updateValueOnAddingPanel(curIndex < 0 ? this.panelCount - 1 : curIndex, index);
                    if (!this.isRenderModeList) this.currentIndex = index;
                    if (this.survey) this.survey.dynamicPanelAdded(this);
                    return this.panelsCore[index];
                };
                QuestionPanelDynamicModel.prototype.updateValueOnAddingPanel = function(prevIndex, index) {
                    this.panelCount++;
                    var newValue = this.value;
                    if (!Array.isArray(newValue) || newValue.length !== this.panelCount) return;
                    var hasModified = false;
                    var lastIndex = this.panelCount - 1;
                    if (index < lastIndex) {
                        hasModified = true;
                        var rec = newValue[lastIndex];
                        newValue.splice(lastIndex, 1);
                        newValue.splice(index, 0, rec);
                    }
                    if (!this.isValueEmpty(this.defaultPanelValue)) {
                        hasModified = true;
                        this.copyValue(newValue[index], this.defaultPanelValue);
                    }
                    if (this.defaultValueFromLastPanel && newValue.length > 1) {
                        var fromIndex = prevIndex > -1 && prevIndex <= lastIndex ? prevIndex : lastIndex;
                        hasModified = true;
                        this.copyValue(newValue[index], newValue[fromIndex]);
                    }
                    if (hasModified) this.value = newValue;
                };
                QuestionPanelDynamicModel.prototype.canLeaveCurrentPanel = function() {
                    return !(this.renderMode !== "list" && this.currentPanel && this.currentPanel.hasErrors(true, true));
                };
                QuestionPanelDynamicModel.prototype.copyValue = function(dest, src) {
                    for(var key in src)dest[key] = src[key];
                };
                /**
     * Call removePanel function. Do nothing is canRemovePanel returns false. If confirmDelete set to true, it shows the confirmation dialog first.
     * @param value a panel or panel index
     * @see removePanel
     * @see confirmDelete
     * @see confirmDeleteText
     * @see canRemovePanel
     *
     */ QuestionPanelDynamicModel.prototype.removePanelUI = function(value) {
                    var _this = this;
                    if (!this.canRemovePanel) return;
                    if (this.isRequireConfirmOnDelete(value)) Object(_utils_utils__WEBPACK_IMPORTED_MODULE_9__["confirmActionAsync"])(this.confirmDeleteText, function() {
                        _this.removePanel(value);
                    }, undefined, this.getLocale(), this.survey.rootElement);
                    else this.removePanel(value);
                };
                QuestionPanelDynamicModel.prototype.isRequireConfirmOnDelete = function(val1) {
                    if (!this.confirmDelete) return false;
                    var index = this.getVisualPanelIndex(val1);
                    if (index < 0 || index >= this.visiblePanelCount) return false;
                    var panelValue = this.visiblePanelsCore[index].getValue();
                    return !this.isValueEmpty(panelValue) && (this.isValueEmpty(this.defaultPanelValue) || !this.isTwoValueEquals(panelValue, this.defaultPanelValue));
                };
                /**
     * Switches Dynamic Panel to the next panel. Returns `true` in case of success, or `false` if `renderMode` is `"list"` or the current panel contains validation errors.
     * @see renderMode
     */ QuestionPanelDynamicModel.prototype.goToNextPanel = function() {
                    if (this.currentIndex < 0) return false;
                    if (!this.canLeaveCurrentPanel()) return false;
                    this.currentIndex++;
                    return true;
                };
                /**
     * Switches Dynamic Panel to the previous panel.
     */ QuestionPanelDynamicModel.prototype.goToPrevPanel = function() {
                    if (this.currentIndex < 0) return;
                    this.currentIndex--;
                };
                /**
     * Removes a dynamic panel from the panels array.
     * @param value a panel or panel index
     * @see panels
     * @see template
     */ QuestionPanelDynamicModel.prototype.removePanel = function(value) {
                    var visIndex = this.getVisualPanelIndex(value);
                    if (visIndex < 0 || visIndex >= this.visiblePanelCount) return;
                    var panel = this.visiblePanelsCore[visIndex];
                    var index = this.panelsCore.indexOf(panel);
                    if (index < 0) return;
                    if (this.survey && !this.survey.dynamicPanelRemoving(this, index, panel)) return;
                    this.panelsCore.splice(index, 1);
                    this.updateBindings("panelCount", this.panelCount);
                    var value = this.value;
                    if (!value || !Array.isArray(value) || index >= value.length) return;
                    this.isValueChangingInternally = true;
                    value.splice(index, 1);
                    this.value = value;
                    this.updateFooterActions();
                    this.fireCallback(this.panelCountChangedCallback);
                    if (this.survey) this.survey.dynamicPanelRemoved(this, index, panel);
                    this.isValueChangingInternally = false;
                };
                QuestionPanelDynamicModel.prototype.getVisualPanelIndex = function(val1) {
                    if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(val1)) return val1;
                    var visPanels = this.visiblePanelsCore;
                    for(var i = 0; i < visPanels.length; i++){
                        if (visPanels[i] === val1 || visPanels[i].data === val1) return i;
                    }
                    return -1;
                };
                QuestionPanelDynamicModel.prototype.getPanelIndexById = function(id) {
                    for(var i = 0; i < this.panelsCore.length; i++){
                        if (this.panelsCore[i].id === id) return i;
                    }
                    return -1;
                };
                QuestionPanelDynamicModel.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    var panels = this.panelsCore;
                    for(var i = 0; i < panels.length; i++)panels[i].locStrsChanged();
                    if (this.additionalTitleToolbar) this.additionalTitleToolbar.locStrsChanged();
                };
                QuestionPanelDynamicModel.prototype.clearIncorrectValues = function() {
                    for(var i = 0; i < this.panelsCore.length; i++)this.clearIncorrectValuesInPanel(i);
                };
                QuestionPanelDynamicModel.prototype.clearErrors = function() {
                    _super.prototype.clearErrors.call(this);
                    for(var i = 0; i < this.panelsCore.length; i++)this.panelsCore[i].clearErrors();
                };
                QuestionPanelDynamicModel.prototype.getQuestionFromArray = function(name, index) {
                    if (index < 0 || index >= this.panelsCore.length) return null;
                    return this.panelsCore[index].getQuestionByName(name);
                };
                QuestionPanelDynamicModel.prototype.clearIncorrectValuesInPanel = function(index) {
                    var panel = this.panelsCore[index];
                    panel.clearIncorrectValues();
                    var val1 = this.value;
                    var values = !!val1 && index < val1.length ? val1[index] : null;
                    if (!values) return;
                    var isChanged = false;
                    for(var key in values){
                        if (this.getSharedQuestionFromArray(key, index)) continue;
                        var q = panel.getQuestionByName(key);
                        if (!!q) continue;
                        if (this.iscorrectValueWithPostPrefix(panel, key, _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].commentSuffix) || this.iscorrectValueWithPostPrefix(panel, key, _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].matrix.totalsSuffix)) continue;
                        delete values[key];
                        isChanged = true;
                    }
                    if (isChanged) {
                        val1[index] = values;
                        this.value = val1;
                    }
                };
                QuestionPanelDynamicModel.prototype.iscorrectValueWithPostPrefix = function(panel, key, postPrefix) {
                    if (key.indexOf(postPrefix) !== key.length - postPrefix.length) return false;
                    return !!panel.getQuestionByName(key.substring(0, key.indexOf(postPrefix)));
                };
                QuestionPanelDynamicModel.prototype.getSharedQuestionFromArray = function(name, panelIndex) {
                    return !!this.survey && !!this.valueName ? this.survey.getQuestionByValueNameFromArray(this.valueName, name, panelIndex) : null;
                };
                QuestionPanelDynamicModel.prototype.addConditionObjectsByContext = function(objects, context) {
                    var hasContext = !!context ? context === true || this.template.questions.indexOf(context) > -1 : false;
                    var panelObjs = new Array();
                    var questions = this.template.questions;
                    for(var i = 0; i < questions.length; i++)questions[i].addConditionObjectsByContext(panelObjs, context);
                    for(var index = 0; index < _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].panel.maxPanelCountInCondition; index++){
                        var indexStr = "[" + index + "].";
                        var prefixName = this.getValueName() + indexStr;
                        var prefixText = this.processedTitle + indexStr;
                        for(var i = 0; i < panelObjs.length; i++)objects.push({
                            name: prefixName + panelObjs[i].name,
                            text: prefixText + panelObjs[i].text,
                            question: panelObjs[i].question
                        });
                    }
                    if (hasContext) {
                        var prefixName = context === true ? this.getValueName() + "." : "";
                        var prefixText = context === true ? this.processedTitle + "." : "";
                        for(var i = 0; i < panelObjs.length; i++){
                            if (panelObjs[i].question == context) continue;
                            var obj = {
                                name: prefixName + QuestionPanelDynamicItem.ItemVariableName + "." + panelObjs[i].name,
                                text: prefixText + QuestionPanelDynamicItem.ItemVariableName + "." + panelObjs[i].text,
                                question: panelObjs[i].question
                            };
                            if (context === true) obj.context = this;
                            objects.push(obj);
                        }
                    }
                };
                QuestionPanelDynamicModel.prototype.collectNestedQuestionsCore = function(questions, visibleOnly) {
                    var panels = visibleOnly ? this.visiblePanelsCore : this.panelsCore;
                    if (!Array.isArray(panels)) return;
                    panels.forEach(function(panel) {
                        panel.questions.forEach(function(q) {
                            return q.collectNestedQuestions(questions, visibleOnly);
                        });
                    });
                };
                QuestionPanelDynamicModel.prototype.getConditionJson = function(operator, path) {
                    if (operator === void 0) operator = null;
                    if (path === void 0) path = null;
                    if (!path) return _super.prototype.getConditionJson.call(this, operator, path);
                    var questionName = path;
                    var pos = path.indexOf(".");
                    if (pos > -1) {
                        questionName = path.substring(0, pos);
                        path = path.substring(pos + 1);
                    }
                    var question = this.template.getQuestionByName(questionName);
                    if (!question) return null;
                    return question.getConditionJson(operator, path);
                };
                QuestionPanelDynamicModel.prototype.onReadOnlyChanged = function() {
                    var readOnly = this.isReadOnly;
                    this.template.readOnly = readOnly;
                    for(var i = 0; i < this.panelsCore.length; i++)this.panelsCore[i].readOnly = readOnly;
                    this.updateNoEntriesTextDefaultLoc();
                    this.updateFooterActions();
                    _super.prototype.onReadOnlyChanged.call(this);
                };
                QuestionPanelDynamicModel.prototype.updateNoEntriesTextDefaultLoc = function() {
                    var loc = this.getLocalizableString("noEntriesText");
                    if (!loc) return;
                    loc.localizationName = this.isReadOnly || !this.allowAddPanel ? "noEntriesReadonlyText" : "noEntriesText";
                    loc.strChanged();
                };
                QuestionPanelDynamicModel.prototype.onSurveyLoad = function() {
                    this.template.readOnly = this.isReadOnly;
                    this.template.onSurveyLoad();
                    this.buildPanelsFirstTime();
                    _super.prototype.onSurveyLoad.call(this);
                };
                QuestionPanelDynamicModel.prototype.buildPanelsFirstTime = function(force) {
                    if (force === void 0) force = false;
                    if (this.hasPanelBuildFirstTime) return;
                    if (!force && this.wasNotRenderedInSurvey) return;
                    this.hasPanelBuildFirstTime = true;
                    this.isBuildingPanelsFirstTime = true;
                    if (this.getPropertyValue("panelCount") > 0) this.panelCount = this.getPropertyValue("panelCount");
                    if (this.useTemplatePanel) this.rebuildPanels();
                    this.setPanelsSurveyImpl();
                    this.setPanelsState();
                    this.assignOnPropertyChangedToTemplate();
                    if (!!this.survey) for(var i = 0; i < this.panelCount; i++)this.survey.dynamicPanelAdded(this);
                    this.updateIsReady();
                    if (this.isReadOnly || !this.allowAddPanel) this.updateNoEntriesTextDefaultLoc();
                    this.updateFooterActions();
                    this.isBuildingPanelsFirstTime = false;
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "wasNotRenderedInSurvey", {
                    get: function() {
                        return !this.hasPanelBuildFirstTime && !this.wasRendered && !!this.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "canBuildPanels", {
                    get: function() {
                        return !this.isLoadingFromJson && !this.useTemplatePanel;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.onFirstRendering = function() {
                    _super.prototype.onFirstRendering.call(this);
                    this.buildPanelsFirstTime();
                    this.template.onFirstRendering();
                    for(var i = 0; i < this.panelsCore.length; i++)this.panelsCore[i].onFirstRendering();
                };
                QuestionPanelDynamicModel.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    for(var i = 0; i < this.panelsCore.length; i++)this.panelsCore[i].localeChanged();
                };
                QuestionPanelDynamicModel.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    this.runPanelsCondition(this.panelsCore, values, properties);
                };
                QuestionPanelDynamicModel.prototype.runTriggers = function(name, value) {
                    _super.prototype.runTriggers.call(this, name, value);
                    this.visiblePanelsCore.forEach(function(p) {
                        p.questions.forEach(function(q) {
                            return q.runTriggers(name, value);
                        });
                    });
                };
                QuestionPanelDynamicModel.prototype.reRunCondition = function() {
                    if (!this.data) return;
                    this.runCondition(this.getDataFilteredValues(), this.getDataFilteredProperties());
                };
                QuestionPanelDynamicModel.prototype.runPanelsCondition = function(panels, values, properties) {
                    var cachedValues = {};
                    if (values && values instanceof Object) cachedValues = JSON.parse(JSON.stringify(values));
                    if (!!this.parentQuestion && !!this.parent) cachedValues[QuestionPanelDynamicItem.ParentItemVariableName] = this.parent.getValue();
                    this.isValueChangingInternally = true;
                    for(var i = 0; i < panels.length; i++){
                        var panel = panels[i];
                        var panelValues = this.getPanelItemData(panel.data);
                        //Should be unique for every panel due async expression support
                        var newValues = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(cachedValues);
                        var panelName = QuestionPanelDynamicItem.ItemVariableName;
                        newValues[panelName] = panelValues;
                        newValues[QuestionPanelDynamicItem.IndexVariableName.toLowerCase()] = i;
                        var newProps = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(properties);
                        newProps[panelName] = panel;
                        panel.runCondition(newValues, newProps);
                    }
                    this.isValueChangingInternally = false;
                };
                QuestionPanelDynamicModel.prototype.onAnyValueChanged = function(name, questionName) {
                    _super.prototype.onAnyValueChanged.call(this, name, questionName);
                    for(var i = 0; i < this.panelsCore.length; i++){
                        this.panelsCore[i].onAnyValueChanged(name, questionName);
                        this.panelsCore[i].onAnyValueChanged(QuestionPanelDynamicItem.ItemVariableName, "");
                    }
                };
                QuestionPanelDynamicModel.prototype.hasKeysDuplicated = function(fireCallback, rec) {
                    if (rec === void 0) rec = null;
                    var keyValues = [];
                    var res;
                    for(var i = 0; i < this.panelsCore.length; i++)res = this.isValueDuplicated(this.panelsCore[i], keyValues, rec, fireCallback) || res;
                    return res;
                };
                QuestionPanelDynamicModel.prototype.updatePanelsContainsErrors = function() {
                    var question = this.changingValueQuestion;
                    var parent = question.parent;
                    while(!!parent){
                        parent.updateContainsErrors();
                        parent = parent.parent;
                    }
                    this.updateContainsErrors();
                };
                QuestionPanelDynamicModel.prototype.hasErrors = function(fireCallback, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (rec === void 0) rec = null;
                    if (this.isValueChangingInternally || this.isBuildingPanelsFirstTime) return false;
                    var res = false;
                    if (!!this.changingValueQuestion) {
                        var res = this.changingValueQuestion.hasErrors(fireCallback, rec);
                        res = this.hasKeysDuplicated(fireCallback, rec) || res;
                        this.updatePanelsContainsErrors();
                    } else res = this.hasErrorInPanels(fireCallback, rec);
                    return _super.prototype.hasErrors.call(this, fireCallback, rec) || res;
                };
                QuestionPanelDynamicModel.prototype.getContainsErrors = function() {
                    var res = _super.prototype.getContainsErrors.call(this);
                    if (res) return res;
                    var panels = this.panelsCore;
                    for(var i = 0; i < panels.length; i++){
                        if (panels[i].containsErrors) return true;
                    }
                    return false;
                };
                QuestionPanelDynamicModel.prototype.getIsAnswered = function() {
                    if (!_super.prototype.getIsAnswered.call(this)) return false;
                    var panels = this.visiblePanelsCore;
                    for(var i = 0; i < panels.length; i++){
                        var visibleQuestions = [];
                        panels[i].addQuestionsToList(visibleQuestions, true);
                        for(var j = 0; j < visibleQuestions.length; j++){
                            if (!visibleQuestions[j].isAnswered) return false;
                        }
                    }
                    return true;
                };
                QuestionPanelDynamicModel.prototype.clearValueOnHidding = function(isClearOnHidden) {
                    if (!isClearOnHidden) {
                        if (!!this.survey && this.survey.getQuestionClearIfInvisible("onHidden") === "none") return;
                        this.clearValueInPanelsIfInvisible("onHiddenContainer");
                    }
                    _super.prototype.clearValueOnHidding.call(this, isClearOnHidden);
                };
                QuestionPanelDynamicModel.prototype.clearValueIfInvisible = function(reason) {
                    if (reason === void 0) reason = "onHidden";
                    var panelReason = reason === "onHidden" ? "onHiddenContainer" : reason;
                    this.clearValueInPanelsIfInvisible(panelReason);
                    _super.prototype.clearValueIfInvisible.call(this, reason);
                };
                QuestionPanelDynamicModel.prototype.clearValueInPanelsIfInvisible = function(reason) {
                    for(var i = 0; i < this.panelsCore.length; i++){
                        var panel = this.panelsCore[i];
                        var questions = panel.questions;
                        this.isSetPanelItemData = {};
                        for(var j = 0; j < questions.length; j++){
                            var q = questions[j];
                            if (q.visible && !panel.isVisible) continue;
                            q.clearValueIfInvisible(reason);
                            this.isSetPanelItemData[q.getValueName()] = this.maxCheckCount + 1;
                        }
                    }
                    this.isSetPanelItemData = {};
                };
                QuestionPanelDynamicModel.prototype.getIsRunningValidators = function() {
                    if (_super.prototype.getIsRunningValidators.call(this)) return true;
                    for(var i = 0; i < this.panelsCore.length; i++){
                        var questions = this.panelsCore[i].questions;
                        for(var j = 0; j < questions.length; j++){
                            if (questions[j].isRunningValidators) return true;
                        }
                    }
                    return false;
                };
                QuestionPanelDynamicModel.prototype.getAllErrors = function() {
                    var result = _super.prototype.getAllErrors.call(this);
                    var panels = this.visiblePanelsCore;
                    for(var i = 0; i < panels.length; i++){
                        var questions = panels[i].questions;
                        for(var j = 0; j < questions.length; j++){
                            var errors = questions[j].getAllErrors();
                            if (errors && errors.length > 0) result = result.concat(errors);
                        }
                    }
                    return result;
                };
                QuestionPanelDynamicModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    var values = this.getUnbindValue(value);
                    if (!values || !Array.isArray(values)) return values;
                    for(var i = 0; i < this.panelsCore.length && i < values.length; i++){
                        var val1 = values[i];
                        if (!val1) continue;
                        values[i] = this.getPanelDisplayValue(i, val1, keysAsText);
                    }
                    return values;
                };
                QuestionPanelDynamicModel.prototype.getPanelDisplayValue = function(panelIndex, val1, keysAsText) {
                    if (!val1) return val1;
                    var panel = this.panelsCore[panelIndex];
                    var keys = Object.keys(val1);
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        var question = panel.getQuestionByValueName(key);
                        if (!question) question = this.getSharedQuestionFromArray(key, panelIndex);
                        if (!!question) {
                            var qValue = question.getDisplayValue(keysAsText, val1[key]);
                            val1[key] = qValue;
                            if (keysAsText && !!question.title && question.title !== key) {
                                val1[question.title] = qValue;
                                delete val1[key];
                            }
                        }
                    }
                    return val1;
                };
                QuestionPanelDynamicModel.prototype.hasErrorInPanels = function(fireCallback, rec) {
                    var res = false;
                    var panels = this.visiblePanelsCore;
                    var keyValues = [];
                    for(var i = 0; i < panels.length; i++)this.setOnCompleteAsyncInPanel(panels[i]);
                    for(var i = 0; i < panels.length; i++){
                        var pnlError = panels[i].hasErrors(fireCallback, !!rec && rec.focuseOnFirstError, rec);
                        pnlError = this.isValueDuplicated(panels[i], keyValues, rec, fireCallback) || pnlError;
                        if (!this.isRenderModeList && pnlError && !res) this.currentIndex = i;
                        res = pnlError || res;
                    }
                    return res;
                };
                QuestionPanelDynamicModel.prototype.setOnCompleteAsyncInPanel = function(panel) {
                    var _this = this;
                    var questions = panel.questions;
                    for(var i = 0; i < questions.length; i++)questions[i].onCompletedAsyncValidators = function(hasErrors) {
                        _this.raiseOnCompletedAsyncValidators();
                    };
                };
                QuestionPanelDynamicModel.prototype.isValueDuplicated = function(panel, keyValues, rec, fireCallback) {
                    if (!this.keyName) return false;
                    var question = panel.getQuestionByValueName(this.keyName);
                    if (!question || question.isEmpty()) return false;
                    var value = question.value;
                    if (!!this.changingValueQuestion && question != this.changingValueQuestion) question.hasErrors(fireCallback, rec);
                    for(var i = 0; i < keyValues.length; i++)if (value == keyValues[i]) {
                        if (fireCallback) question.addError(new _error__WEBPACK_IMPORTED_MODULE_7__["KeyDuplicationError"](this.keyDuplicationError, this));
                        if (!!rec && !rec.firstErrorQuestion) rec.firstErrorQuestion = question;
                        return true;
                    }
                    keyValues.push(value);
                    return false;
                };
                QuestionPanelDynamicModel.prototype.getPanelActions = function(panel) {
                    var _this = this;
                    var actions = panel.footerActions;
                    if (this.panelRemoveButtonLocation !== "right") actions.push(new _actions_action__WEBPACK_IMPORTED_MODULE_11__["Action"]({
                        id: "remove-panel-" + panel.id,
                        component: "sv-paneldynamic-remove-btn",
                        visible: new _base__WEBPACK_IMPORTED_MODULE_12__["ComputedUpdater"](function() {
                            return [
                                _this.canRemovePanel,
                                panel.state !== "collapsed",
                                _this.panelRemoveButtonLocation !== "right"
                            ].every(function(val1) {
                                return val1 === true;
                            });
                        }),
                        data: {
                            question: this,
                            panel: panel
                        }
                    }));
                    if (!!this.survey) actions = this.survey.getUpdatedPanelFooterActions(panel, actions, this);
                    return actions;
                };
                QuestionPanelDynamicModel.prototype.createNewPanel = function() {
                    var _this = this;
                    var panel = this.createAndSetupNewPanelObject();
                    var json = this.template.toJSON();
                    new _jsonobject__WEBPACK_IMPORTED_MODULE_5__["JsonObject"]().toObject(json, panel);
                    panel.renderWidth = "100%";
                    panel.updateCustomWidgets();
                    new QuestionPanelDynamicItem(this, panel);
                    if (!this.isDesignMode && !this.isReadOnly && !this.isValueEmpty(panel.getValue())) this.runPanelsCondition([
                        panel
                    ], this.getDataFilteredValues(), this.getDataFilteredProperties());
                    panel.onFirstRendering();
                    var questions = panel.questions;
                    for(var i = 0; i < questions.length; i++)questions[i].setParentQuestion(this);
                    panel.locStrsChanged();
                    panel.onGetFooterActionsCallback = function() {
                        return _this.getPanelActions(panel);
                    };
                    panel.onGetFooterToolbarCssCallback = function() {
                        return _this.cssClasses.panelFooter;
                    };
                    panel.registerPropertyChangedHandlers([
                        "visible"
                    ], function() {
                        if (panel.visible) _this.onPanelAdded(panel);
                        else _this.onPanelRemoved(panel);
                        _this.updateFooterActions();
                    });
                    return panel;
                };
                QuestionPanelDynamicModel.prototype.createAndSetupNewPanelObject = function() {
                    var _this = this;
                    var panel = this.createNewPanelObject();
                    panel.isInteractiveDesignElement = false;
                    panel.setParentQuestion(this);
                    panel.onGetQuestionTitleLocation = function() {
                        return _this.getTemplateQuestionTitleLocation();
                    };
                    return panel;
                };
                QuestionPanelDynamicModel.prototype.getTemplateQuestionTitleLocation = function() {
                    return this.templateTitleLocation != "default" ? this.templateTitleLocation : this.getTitleLocationCore();
                };
                QuestionPanelDynamicModel.prototype.getChildErrorLocation = function(child) {
                    if (this.templateErrorLocation !== "default") return this.templateErrorLocation;
                    return _super.prototype.getChildErrorLocation.call(this, child);
                };
                QuestionPanelDynamicModel.prototype.createNewPanelObject = function() {
                    return _jsonobject__WEBPACK_IMPORTED_MODULE_5__["Serializer"].createClass("panel");
                };
                QuestionPanelDynamicModel.prototype.setPanelCountBasedOnValue = function() {
                    if (this.isValueChangingInternally || this.useTemplatePanel) return;
                    var val1 = this.value;
                    var newPanelCount = val1 && Array.isArray(val1) ? val1.length : 0;
                    if (newPanelCount == 0 && this.getPropertyValue("panelCount") > 0) newPanelCount = this.getPropertyValue("panelCount");
                    this.settingPanelCountBasedOnValue = true;
                    this.panelCount = newPanelCount;
                    this.settingPanelCountBasedOnValue = false;
                };
                QuestionPanelDynamicModel.prototype.setQuestionValue = function(newValue) {
                    if (this.settingPanelCountBasedOnValue) return;
                    _super.prototype.setQuestionValue.call(this, newValue, false);
                    this.setPanelCountBasedOnValue();
                    for(var i = 0; i < this.panelsCore.length; i++)this.panelUpdateValueFromSurvey(this.panelsCore[i]);
                    this.updateIsAnswered();
                };
                QuestionPanelDynamicModel.prototype.onSurveyValueChanged = function(newValue) {
                    if (newValue === undefined && this.isAllPanelsEmpty()) return;
                    _super.prototype.onSurveyValueChanged.call(this, newValue);
                    for(var i = 0; i < this.panelsCore.length; i++)this.panelSurveyValueChanged(this.panelsCore[i]);
                    if (newValue === undefined) this.setValueBasedOnPanelCount();
                    this.updateIsReady();
                };
                QuestionPanelDynamicModel.prototype.isAllPanelsEmpty = function() {
                    for(var i = 0; i < this.panelsCore.length; i++){
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(this.panelsCore[i].getValue())) return false;
                    }
                    return true;
                };
                QuestionPanelDynamicModel.prototype.panelUpdateValueFromSurvey = function(panel) {
                    var questions = panel.questions;
                    var values = this.getPanelItemData(panel.data);
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        q.updateValueFromSurvey(values[q.getValueName()]);
                        q.updateCommentFromSurvey(values[q.getValueName() + _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].commentSuffix]);
                        q.initDataUI();
                    }
                };
                QuestionPanelDynamicModel.prototype.panelSurveyValueChanged = function(panel) {
                    var questions = panel.questions;
                    var values = this.getPanelItemData(panel.data);
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        q.onSurveyValueChanged(values[q.getValueName()]);
                    }
                };
                QuestionPanelDynamicModel.prototype.onSetData = function() {
                    _super.prototype.onSetData.call(this);
                    if (this.useTemplatePanel) {
                        this.setTemplatePanelSurveyImpl();
                        this.rebuildPanels();
                    }
                };
                QuestionPanelDynamicModel.prototype.isNewValueCorrect = function(val1) {
                    return Array.isArray(val1);
                };
                //IQuestionPanelDynamicData
                QuestionPanelDynamicModel.prototype.getItemIndex = function(item) {
                    var res = this.items.indexOf(item);
                    return res > -1 ? res : this.items.length;
                };
                QuestionPanelDynamicModel.prototype.getVisibleItemIndex = function(item) {
                    var visPanels = this.visiblePanelsCore;
                    for(var i = 0; i < visPanels.length; i++){
                        if (visPanels[i].data === item) return i;
                    }
                    return visPanels.length;
                };
                QuestionPanelDynamicModel.prototype.getPanelItemData = function(item) {
                    var items = this.items;
                    var index = items.indexOf(item);
                    var qValue = this.value;
                    if (index < 0 && Array.isArray(qValue) && qValue.length > items.length) index = items.length;
                    if (index < 0) return {};
                    if (!qValue || !Array.isArray(qValue) || qValue.length <= index) return {};
                    return qValue[index];
                };
                QuestionPanelDynamicModel.prototype.setPanelItemData = function(item, name, val1) {
                    if (this.isSetPanelItemData[name] > this.maxCheckCount) return;
                    if (!this.isSetPanelItemData[name]) this.isSetPanelItemData[name] = 0;
                    this.isSetPanelItemData[name]++;
                    var items = this.items;
                    var index = items.indexOf(item);
                    if (index < 0) index = items.length;
                    var qValue = this.getUnbindValue(this.value);
                    if (!qValue || !Array.isArray(qValue)) qValue = [];
                    if (qValue.length <= index) for(var i = qValue.length; i <= index; i++)qValue.push({});
                    if (!qValue[index]) qValue[index] = {};
                    if (!this.isValueEmpty(val1)) qValue[index][name] = val1;
                    else delete qValue[index][name];
                    if (index >= 0 && index < this.panelsCore.length) this.changingValueQuestion = this.panelsCore[index].getQuestionByValueName(name);
                    this.value = qValue;
                    this.changingValueQuestion = null;
                    if (this.survey) {
                        var options = {
                            question: this,
                            panel: item.panel,
                            name: name,
                            itemIndex: index,
                            itemValue: qValue[index],
                            value: val1
                        };
                        this.survey.dynamicPanelItemValueChanged(this, options);
                    }
                    this.isSetPanelItemData[name]--;
                    if (this.isSetPanelItemData[name] - 1) delete this.isSetPanelItemData[name];
                };
                QuestionPanelDynamicModel.prototype.getRootData = function() {
                    return this.data;
                };
                QuestionPanelDynamicModel.prototype.getPlainData = function(options) {
                    if (options === void 0) options = {
                        includeEmpty: true
                    };
                    var questionPlainData = _super.prototype.getPlainData.call(this, options);
                    if (!!questionPlainData) {
                        questionPlainData.isNode = true;
                        var prevData = Array.isArray(questionPlainData.data) ? [].concat(questionPlainData.data) : [];
                        questionPlainData.data = this.panels.map(function(panel, index) {
                            var panelDataItem = {
                                name: panel.name || index,
                                title: panel.title || "Panel",
                                value: panel.getValue(),
                                displayValue: panel.getValue(),
                                getString: function(val1) {
                                    return typeof val1 === "object" ? JSON.stringify(val1) : val1;
                                },
                                isNode: true,
                                data: panel.questions.map(function(question) {
                                    return question.getPlainData(options);
                                }).filter(function(d) {
                                    return !!d;
                                })
                            };
                            (options.calculations || []).forEach(function(calculation) {
                                panelDataItem[calculation.propertyName] = panel[calculation.propertyName];
                            });
                            return panelDataItem;
                        });
                        questionPlainData.data = questionPlainData.data.concat(prevData);
                    }
                    return questionPlainData;
                };
                QuestionPanelDynamicModel.prototype.updateElementCss = function(reNew) {
                    _super.prototype.updateElementCss.call(this, reNew);
                    for(var i = 0; i < this.panelsCore.length; i++){
                        var el = this.panelsCore[i];
                        el.updateElementCss(reNew);
                    }
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "progressText", {
                    get: function() {
                        var rangeMax = this.visiblePanelCount;
                        return this.getLocalizationFormatString("panelDynamicProgressText", this.currentIndex + 1, rangeMax);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "progress", {
                    get: function() {
                        return (this.currentIndex + 1) / this.visiblePanelCount * 100 + "%";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.getRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(_super.prototype.getRootCss.call(this)).append(this.cssClasses.empty, this.getShowNoEntriesPlaceholder()).toString();
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "cssHeader", {
                    get: function() {
                        var showTab = this.isRenderModeTab && !!this.panelCount;
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.header).append(this.cssClasses.headerTop, this.hasTitleOnTop || showTab).append(this.cssClasses.headerTab, showTab).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.getPanelWrapperCss = function(panel) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.panelWrapper, !panel || panel.visible).append(this.cssClasses.panelWrapperInRow, this.panelRemoveButtonLocation === "right").toString();
                };
                QuestionPanelDynamicModel.prototype.getPanelRemoveButtonCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.button).append(this.cssClasses.buttonRemove).append(this.cssClasses.buttonRemoveRight, this.panelRemoveButtonLocation === "right").toString();
                };
                QuestionPanelDynamicModel.prototype.getAddButtonCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.button).append(this.cssClasses.buttonAdd).append(this.cssClasses.buttonAdd + "--list-mode", this.renderMode === "list").toString();
                };
                QuestionPanelDynamicModel.prototype.getPrevButtonCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.buttonPrev).append(this.cssClasses.buttonPrevDisabled, !this.isPrevButtonVisible).toString();
                };
                QuestionPanelDynamicModel.prototype.getNextButtonCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(this.cssClasses.buttonNext).append(this.cssClasses.buttonNextDisabled, !this.isNextButtonVisible).toString();
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "noEntriesText", {
                    /**
         * A text displayed when Dynamic Panel contains no entries.
         */ get: function() {
                        return this.getLocalizableStringText("noEntriesText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("noEntriesText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "locNoEntriesText", {
                    get: function() {
                        return this.getLocalizableString("noEntriesText");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.getShowNoEntriesPlaceholder = function() {
                    return !!this.cssClasses.noEntriesPlaceholder && !this.isDesignMode && this.visiblePanelCount === 0;
                };
                QuestionPanelDynamicModel.prototype.needResponsiveWidth = function() {
                    var panel = this.getPanel();
                    if (!!panel && panel.needResponsiveWidth()) return true;
                    return false;
                };
                QuestionPanelDynamicModel.prototype.getAdditionalTitleToolbar = function() {
                    if (!this.isRenderModeTab) return null;
                    if (!this.additionalTitleToolbarValue) {
                        this.additionalTitleToolbarValue = new _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_13__["AdaptiveActionContainer"]();
                        this.additionalTitleToolbarValue.dotsItem.popupModel.showPointer = false;
                        this.additionalTitleToolbarValue.dotsItem.popupModel.verticalPosition = "bottom";
                        this.additionalTitleToolbarValue.dotsItem.popupModel.horizontalPosition = "center";
                        this.updateElementCss(false);
                    }
                    return this.additionalTitleToolbarValue;
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "footerToolbar", {
                    get: function() {
                        if (!this.footerToolbarValue) this.initFooterToolbar();
                        return this.footerToolbarValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.updateFooterActions = function() {
                    if (!!this.updateFooterActionsCallback) this.updateFooterActionsCallback();
                };
                QuestionPanelDynamicModel.prototype.initFooterToolbar = function() {
                    var _this = this;
                    this.footerToolbarValue = this.createActionContainer();
                    var items = [];
                    var prevTextBtn = new _actions_action__WEBPACK_IMPORTED_MODULE_11__["Action"]({
                        id: "sv-pd-prev-btn",
                        title: this.panelPrevText,
                        action: function() {
                            _this.goToPrevPanel();
                        }
                    });
                    var nextTextBtn = new _actions_action__WEBPACK_IMPORTED_MODULE_11__["Action"]({
                        id: "sv-pd-next-btn",
                        title: this.panelNextText,
                        action: function() {
                            _this.goToNextPanel();
                        }
                    });
                    var addBtn = new _actions_action__WEBPACK_IMPORTED_MODULE_11__["Action"]({
                        id: "sv-pd-add-btn",
                        component: "sv-paneldynamic-add-btn",
                        data: {
                            question: this
                        }
                    });
                    var prevBtnIcon = new _actions_action__WEBPACK_IMPORTED_MODULE_11__["Action"]({
                        id: "sv-prev-btn-icon",
                        component: "sv-paneldynamic-prev-btn",
                        data: {
                            question: this
                        }
                    });
                    var progressText = new _actions_action__WEBPACK_IMPORTED_MODULE_11__["Action"]({
                        id: "sv-pd-progress-text",
                        component: "sv-paneldynamic-progress-text",
                        data: {
                            question: this
                        }
                    });
                    var nextBtnIcon = new _actions_action__WEBPACK_IMPORTED_MODULE_11__["Action"]({
                        id: "sv-pd-next-btn-icon",
                        component: "sv-paneldynamic-next-btn",
                        data: {
                            question: this
                        }
                    });
                    items.push(prevTextBtn, nextTextBtn, addBtn, prevBtnIcon, progressText, nextBtnIcon);
                    this.updateFooterActionsCallback = function() {
                        var isLegacyNavigation = _this.legacyNavigation;
                        var isRenderModeList = _this.isRenderModeList;
                        var isMobile = _this.isMobile;
                        var showNavigation = !isLegacyNavigation && !isRenderModeList;
                        prevTextBtn.visible = showNavigation && _this.currentIndex > 0;
                        nextTextBtn.visible = showNavigation && _this.currentIndex < _this.visiblePanelCount - 1;
                        nextTextBtn.needSpace = isMobile && nextTextBtn.visible && prevTextBtn.visible;
                        addBtn.visible = _this.canAddPanel;
                        addBtn.needSpace = _this.isMobile && !nextTextBtn.visible && prevTextBtn.visible;
                        progressText.visible = !_this.isRenderModeList && !isMobile;
                        progressText.needSpace = !isLegacyNavigation && !_this.isMobile;
                        var showLegacyNavigation = isLegacyNavigation && !isRenderModeList;
                        prevBtnIcon.visible = showLegacyNavigation;
                        nextBtnIcon.visible = showLegacyNavigation;
                        prevBtnIcon.needSpace = showLegacyNavigation;
                    };
                    this.updateFooterActionsCallback();
                    this.footerToolbarValue.setItems(items);
                };
                QuestionPanelDynamicModel.prototype.createTabByPanel = function(panel, visPanelIndex) {
                    var _this = this;
                    if (!this.isRenderModeTab) return;
                    var locTitle = new _localizablestring__WEBPACK_IMPORTED_MODULE_2__["LocalizableString"](panel, true);
                    locTitle.onGetTextCallback = function(str) {
                        if (!_this.survey) return str;
                        var options = {
                            title: str,
                            panel: panel,
                            visiblePanelIndex: visPanelIndex
                        };
                        _this.survey.dynamicPanelGetTabTitle(_this, options);
                        return options.title;
                    };
                    locTitle.sharedData = this.locTemplateTabTitle;
                    var isActive = this.getPanelIndexById(panel.id) === this.currentIndex;
                    var newItem = new _actions_action__WEBPACK_IMPORTED_MODULE_11__["Action"]({
                        id: panel.id,
                        pressed: isActive,
                        locTitle: locTitle,
                        disableHide: isActive,
                        action: function() {
                            _this.currentIndex = _this.getPanelIndexById(newItem.id);
                        }
                    });
                    return newItem;
                };
                QuestionPanelDynamicModel.prototype.getAdditionalTitleToolbarCss = function(cssClasses) {
                    var css = cssClasses !== null && cssClasses !== void 0 ? cssClasses : this.cssClasses;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_10__["CssClassBuilder"]().append(css.tabsRoot).append(css.tabsLeft, this.tabAlign === "left").append(css.tabsRight, this.tabAlign === "right").append(css.tabsCenter, this.tabAlign === "center").toString();
                };
                QuestionPanelDynamicModel.prototype.updateTabToolbarItemsPressedState = function() {
                    if (!this.isRenderModeTab) return;
                    if (this.currentIndex < 0 || this.currentIndex >= this.visiblePanelCount) return;
                    var panel = this.visiblePanelsCore[this.currentIndex];
                    this.additionalTitleToolbar.renderedActions.forEach(function(action) {
                        var isActive = action.id === panel.id;
                        action.pressed = isActive;
                        action.disableHide = isActive;
                        //should raise update if dimensions are not changed but action is active now
                        if (action.mode === "popup" && action.disableHide) action["raiseUpdate"]();
                    });
                };
                QuestionPanelDynamicModel.prototype.updateTabToolbar = function() {
                    var _this = this;
                    if (!this.isRenderModeTab) return;
                    var items = [];
                    var visPanels = this.visiblePanelsCore;
                    var _loop_1 = function(i) {
                        this_1.visiblePanelsCore.forEach(function(panel) {
                            return items.push(_this.createTabByPanel(visPanels[i], i));
                        });
                    };
                    var this_1 = this;
                    for(var i = 0; i < visPanels.length; i++)_loop_1(i);
                    this.additionalTitleToolbar.setItems(items);
                };
                QuestionPanelDynamicModel.prototype.addTabFromToolbar = function(panel, index) {
                    if (!this.isRenderModeTab) return;
                    var newItem = this.createTabByPanel(panel, index);
                    this.additionalTitleToolbar.actions.splice(index, 0, newItem);
                    this.updateTabToolbarItemsPressedState();
                };
                QuestionPanelDynamicModel.prototype.removeTabFromToolbar = function(panel) {
                    if (!this.isRenderModeTab) return;
                    var removedItem = this.additionalTitleToolbar.getActionById(panel.id);
                    if (!removedItem) return;
                    this.additionalTitleToolbar.actions.splice(this.additionalTitleToolbar.actions.indexOf(removedItem), 1);
                    this.updateTabToolbarItemsPressedState();
                };
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "showLegacyNavigation", {
                    get: function() {
                        return !this.isDefaultV2Theme;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionPanelDynamicModel.prototype, "showNavigation", {
                    get: function() {
                        return this.visiblePanelCount > 0 && !this.showLegacyNavigation && !!this.cssClasses.footer;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionPanelDynamicModel.prototype.showSeparator = function(index) {
                    return this.isRenderModeList && index < this.visiblePanelCount - 1;
                };
                QuestionPanelDynamicModel.prototype.calcCssClasses = function(css) {
                    var classes = _super.prototype.calcCssClasses.call(this, css);
                    var additionalTitleToolbar = this.additionalTitleToolbar;
                    if (!!additionalTitleToolbar) {
                        additionalTitleToolbar.containerCss = this.getAdditionalTitleToolbarCss(classes);
                        additionalTitleToolbar.cssClasses = classes.tabs;
                        additionalTitleToolbar.dotsItem.cssClasses = classes.tabs;
                        additionalTitleToolbar.dotsItem.popupModel.contentComponentData.model.cssClasses = css.list;
                    }
                    return classes;
                };
                QuestionPanelDynamicModel.maxCheckCount = 3;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_5__["property"])({
                        defaultValue: false,
                        onSet: function(_, target) {
                            target.updateFooterActions();
                        }
                    })
                ], QuestionPanelDynamicModel.prototype, "legacyNavigation", void 0);
                return QuestionPanelDynamicModel;
            }(_question__WEBPACK_IMPORTED_MODULE_4__["Question"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_5__["Serializer"].addClass("paneldynamic", [
                {
                    name: "showCommentArea:switch",
                    layout: "row",
                    visible: true,
                    category: "general"
                },
                {
                    name: "templateElements",
                    alternativeName: "questions",
                    baseClassName: "question",
                    visible: false,
                    isLightSerializable: false
                },
                {
                    name: "templateTitle:text",
                    serializationProperty: "locTemplateTitle"
                },
                {
                    name: "templateTabTitle",
                    serializationProperty: "locTemplateTabTitle",
                    visibleIf: function(obj) {
                        return obj.renderMode === "tab";
                    }
                },
                {
                    name: "templateDescription:text",
                    serializationProperty: "locTemplateDescription"
                },
                {
                    name: "minWidth",
                    defaultFunc: function() {
                        return "auto";
                    }
                },
                {
                    name: "noEntriesText:text",
                    serializationProperty: "locNoEntriesText"
                },
                {
                    name: "allowAddPanel:boolean",
                    default: true
                },
                {
                    name: "allowRemovePanel:boolean",
                    default: true
                },
                {
                    name: "newPanelPosition",
                    choices: [
                        "next",
                        "last"
                    ],
                    default: "last",
                    category: "layout"
                },
                {
                    name: "panelCount:number",
                    isBindable: true,
                    default: 0,
                    choices: [
                        0,
                        1,
                        2,
                        3,
                        4,
                        5,
                        6,
                        7,
                        8,
                        9,
                        10
                    ]
                },
                {
                    name: "minPanelCount:number",
                    default: 0,
                    minValue: 0
                },
                {
                    name: "maxPanelCount:number",
                    default: _settings__WEBPACK_IMPORTED_MODULE_8__["settings"].panel.maxPanelCount
                },
                "defaultPanelValue:panelvalue",
                "defaultValueFromLastPanel:boolean",
                {
                    name: "panelsState",
                    default: "default",
                    choices: [
                        "default",
                        "collapsed",
                        "expanded",
                        "firstExpanded"
                    ],
                    visibleIf: function(obj) {
                        return obj.renderMode === "list";
                    }
                },
                {
                    name: "keyName"
                },
                {
                    name: "keyDuplicationError",
                    serializationProperty: "locKeyDuplicationError"
                },
                {
                    name: "confirmDelete:boolean"
                },
                {
                    name: "confirmDeleteText",
                    serializationProperty: "locConfirmDeleteText",
                    visibleIf: function(obj) {
                        return obj.confirmDelete;
                    }
                },
                {
                    name: "panelAddText",
                    serializationProperty: "locPanelAddText",
                    visibleIf: function(obj) {
                        return obj.allowAddPanel;
                    }
                },
                {
                    name: "panelRemoveText",
                    serializationProperty: "locPanelRemoveText",
                    visibleIf: function(obj) {
                        return obj.allowRemovePanel;
                    }
                },
                {
                    name: "panelPrevText",
                    serializationProperty: "locPanelPrevText",
                    visibleIf: function(obj) {
                        return obj.renderMode !== "list";
                    }
                },
                {
                    name: "panelNextText",
                    serializationProperty: "locPanelNextText",
                    visibleIf: function(obj) {
                        return obj.renderMode !== "list";
                    }
                },
                {
                    name: "showQuestionNumbers",
                    default: "off",
                    choices: [
                        "off",
                        "onPanel",
                        "onSurvey"
                    ]
                },
                {
                    name: "showRangeInProgress:boolean",
                    default: true,
                    visibleIf: function(obj) {
                        return obj.renderMode !== "list";
                    }
                },
                {
                    name: "renderMode",
                    default: "list",
                    choices: [
                        "list",
                        "progressTop",
                        "progressBottom",
                        "progressTopBottom",
                        "tab"
                    ]
                },
                {
                    name: "tabAlign",
                    default: "center",
                    choices: [
                        "left",
                        "center",
                        "right"
                    ],
                    visibleIf: function(obj) {
                        return obj.renderMode === "tab";
                    }
                },
                {
                    name: "templateTitleLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom",
                        "left"
                    ]
                },
                {
                    name: "templateErrorLocation",
                    default: "default",
                    choices: [
                        "default",
                        "top",
                        "bottom"
                    ]
                },
                {
                    name: "templateVisibleIf:expression",
                    category: "logic"
                },
                {
                    name: "panelRemoveButtonLocation",
                    default: "bottom",
                    choices: [
                        "bottom",
                        "right"
                    ],
                    visibleIf: function(obj) {
                        return obj.allowRemovePanel;
                    }
                }
            ], function() {
                return new QuestionPanelDynamicModel("");
            }, "question");
            _questionfactory__WEBPACK_IMPORTED_MODULE_6__["QuestionFactory"].Instance.registerQuestion("paneldynamic", function(name) {
                return new QuestionPanelDynamicModel(name);
            });
        /***/ },
        /***/ "./src/question_radiogroup.ts": /*!************************************!*\
  !*** ./src/question_radiogroup.ts ***!
  \************************************/ /*! exports provided: QuestionRadiogroupModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionRadiogroupModel", function() {
                return QuestionRadiogroupModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _question_baseselect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_baseselect */ "./src/question_baseselect.ts");
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * A class that describes the Radio Button Group question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-radiogroup/ (linkStyle))
 */ var QuestionRadiogroupModel = /** @class */ function(_super) {
                __extends(QuestionRadiogroupModel, _super);
                function QuestionRadiogroupModel(name) {
                    return _super.call(this, name) || this;
                }
                QuestionRadiogroupModel.prototype.getDefaultItemComponent = function() {
                    return "survey-radiogroup-item";
                };
                QuestionRadiogroupModel.prototype.getType = function() {
                    return "radiogroup";
                };
                QuestionRadiogroupModel.prototype.getFirstInputElementId = function() {
                    return this.inputId + "_0";
                };
                Object.defineProperty(QuestionRadiogroupModel.prototype, "selectedItem", {
                    /**
         * Returns the selected choice item. If no item is selected, returns `null`.
         */ get: function() {
                        return this.getSingleSelectedItem();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRadiogroupModel.prototype, "showClearButton", {
                    /**
         * Specifies whether to display a button that clears the question value.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("showClearButton");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showClearButton", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRadiogroupModel.prototype, "canShowClearButton", {
                    get: function() {
                        return this.showClearButton && !this.isReadOnly;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRadiogroupModel.prototype, "clearButtonCaption", {
                    get: function() {
                        return this.getLocalizationString("clearCaption");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRadiogroupModel.prototype.supportGoNextPageAutomatic = function() {
                    return this.isMouseDown === true && !this.isOtherSelected;
                };
                QuestionRadiogroupModel.prototype.setNewComment = function(newValue) {
                    this.isMouseDown = true;
                    _super.prototype.setNewComment.call(this, newValue);
                    this.isMouseDown = false;
                };
                Object.defineProperty(QuestionRadiogroupModel.prototype, "showClearButtonInContent", {
                    get: function() {
                        return !this.isDefaultV2Theme && this.canShowClearButton;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRadiogroupModel.prototype.clickItemHandler = function(item) {
                    this.renderedValue = item.value;
                };
                QuestionRadiogroupModel.prototype.getDefaultTitleActions = function() {
                    var _this = this;
                    var actions = [];
                    if (this.isDefaultV2Theme && !this.isDesignMode) {
                        var clearAction = new _actions_action__WEBPACK_IMPORTED_MODULE_3__["Action"]({
                            title: this.clearButtonCaption,
                            id: "sv-clr-btn-" + this.id,
                            action: function() {
                                _this.clearValue();
                            },
                            innerCss: this.cssClasses.clearButton,
                            visible: new _base__WEBPACK_IMPORTED_MODULE_4__["ComputedUpdater"](function() {
                                return _this.canShowClearButton;
                            })
                        });
                        actions.push(clearAction);
                    }
                    return actions;
                };
                Object.defineProperty(QuestionRadiogroupModel.prototype, "isNewA11yStructure", {
                    //a11y
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRadiogroupModel.prototype, "a11y_input_ariaRole", {
                    get: function() {
                        return "radiogroup";
                    },
                    enumerable: false,
                    configurable: true
                });
                return QuestionRadiogroupModel;
            }(_question_baseselect__WEBPACK_IMPORTED_MODULE_2__["QuestionCheckboxBase"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("radiogroup", [
                {
                    name: "showClearButton:boolean",
                    default: false
                },
                {
                    name: "separateSpecialChoices",
                    visible: true
                },
                {
                    name: "itemComponent",
                    visible: false,
                    default: "survey-radiogroup-item"
                }
            ], function() {
                return new QuestionRadiogroupModel("");
            }, "checkboxbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].Instance.registerQuestion("radiogroup", function(name) {
                var q = new QuestionRadiogroupModel(name);
                q.choices = _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].DefaultChoices;
                return q;
            });
        /***/ },
        /***/ "./src/question_ranking.ts": /*!*********************************!*\
  !*** ./src/question_ranking.ts ***!
  \*********************************/ /*! exports provided: QuestionRankingModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionRankingModel", function() {
                return QuestionRankingModel;
            });
            /* harmony import */ var _dragdrop_ranking_choices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./dragdrop/ranking-choices */ "./src/dragdrop/ranking-choices.ts");
            /* harmony import */ var _dragdrop_ranking_select_to_rank__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./dragdrop/ranking-select-to-rank */ "./src/dragdrop/ranking-select-to-rank.ts");
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _question_checkbox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./question_checkbox */ "./src/question_checkbox.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_devices__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils/devices */ "./src/utils/devices.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _src_settings__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../src/settings */ "./src/settings.ts");
            /* harmony import */ var _utils_animation__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./utils/animation */ "./src/utils/animation.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A class that describes the Ranking question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-ranking/ (linkStyle))
 */ var QuestionRankingModel = /** @class */ function(_super) {
                __extends(QuestionRankingModel, _super);
                function QuestionRankingModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.domNode = null;
                    _this.onVisibleChoicesChanged = function() {
                        _super.prototype.onVisibleChoicesChanged.call(_this);
                        if (_this.carryForwardStartUnranked && !_this.isValueSetByUser && !_this.selectToRankEnabled) _this.value = [];
                        // ranking question with only one choice doesn't make sense
                        if (_this.visibleChoices.length === 1 && !_this.selectToRankEnabled) {
                            _this.value = [];
                            _this.value.push(_this.visibleChoices[0].value);
                            _this.updateRankingChoicesSync();
                            return;
                        }
                        if (_this.isEmpty()) {
                            _this.updateRankingChoicesSync();
                            return;
                        }
                        if (_this.selectToRankEnabled) {
                            _this.updateRankingChoicesSync();
                            return;
                        }
                        if (_this.visibleChoices.length > _this.value.length) _this.addToValueByVisibleChoices();
                        if (_this.visibleChoices.length < _this.value.length) _this.removeFromValueByVisibleChoices();
                        _this.updateRankingChoicesSync();
                    };
                    _this.localeChanged = function() {
                        _super.prototype.localeChanged.call(_this);
                        _this.updateRankingChoicesSync();
                    };
                    _this._rankingChoicesAnimation = new _utils_animation__WEBPACK_IMPORTED_MODULE_10__["AnimationGroup"](_this.getChoicesAnimation(true), function(val1) {
                        _this.setPropertyValue("rankingChoices", val1);
                    }, function() {
                        return _this.rankingChoices;
                    });
                    _this._unRankingChoicesAnimation = new _utils_animation__WEBPACK_IMPORTED_MODULE_10__["AnimationGroup"](_this.getChoicesAnimation(false), function(val1) {
                        _this.setPropertyValue("unRankingChoices", val1);
                    }, function() {
                        return _this.unRankingChoices;
                    });
                    _this.handlePointerDown = function(event1, choice, node) {
                        var target = event1.target;
                        if (!_this.isDragStartNodeValid(target)) return;
                        if (_this.allowStartDrag && _this.canStartDragDueMaxSelectedChoices(target) && _this.canStartDragDueItemEnabled(choice)) _this.dragDropRankingChoices.startDrag(event1, choice, _this, node);
                    };
                    _this.handleKeydown = function(event1, choice) {
                        if (!_this.isDesignMode) {
                            var key = event1.key;
                            var index = _this.rankingChoices.indexOf(choice);
                            if (_this.selectToRankEnabled) {
                                _this.handleKeydownSelectToRank(event1, choice);
                                return;
                            }
                            if (key === "ArrowUp" && index) {
                                _this.handleArrowKeys(index, choice, false);
                                event1.preventDefault();
                            }
                            if (key === "ArrowDown" && index !== _this.rankingChoices.length - 1) {
                                _this.handleArrowKeys(index, choice, true);
                                event1.preventDefault();
                            }
                        }
                    };
                    _this.handleArrowKeys = function(index, choice, isDown) {
                        var delta = isDown ? 1 : -1;
                        var choices = _this.rankingChoices;
                        choices.splice(index, 1);
                        choices.splice(index + delta, 0, choice);
                        _this.setValue();
                        setTimeout(function() {
                            _this.focusItem(index + delta);
                        }, 1);
                    };
                    _this.focusItem = function(index, container) {
                        if (_this.selectToRankEnabled && container) {
                            var containerSelector = "[data-ranking='" + container + "']";
                            var itemsNodes = _this.domNode.querySelectorAll(containerSelector + " " + "." + _this.cssClasses.item);
                            itemsNodes[index].focus();
                        } else {
                            var itemsNodes = _this.domNode.querySelectorAll("." + _this.cssClasses.item);
                            itemsNodes[index].focus();
                        }
                    };
                    _this.isValueSetByUser = false;
                    _this.setValue = function() {
                        var value = [];
                        _this.rankingChoicesAnimation.cancel();
                        _this.unRankingChoicesAnimation.cancel();
                        _this.rankingChoices.forEach(function(choice) {
                            value.push(choice.value);
                        });
                        _this.value = value;
                        _this.isValueSetByUser = true;
                    };
                    _this.createNewArray("rankingChoices");
                    _this.createNewArray("unRankingChoices");
                    _this.registerFunctionOnPropertyValueChanged("selectToRankEnabled", function() {
                        _this.clearValue();
                        _this.setDragDropRankingChoices();
                        _this.updateRankingChoicesSync();
                    });
                    return _this;
                }
                QuestionRankingModel.prototype.getDefaultItemComponent = function() {
                    return "";
                };
                QuestionRankingModel.prototype.getType = function() {
                    return "ranking";
                };
                QuestionRankingModel.prototype.getItemTabIndex = function(item) {
                    if (this.isDesignMode || item.disabled) return undefined;
                    return 0;
                };
                QuestionRankingModel.prototype.supportContainerQueries = function() {
                    return this.selectToRankEnabled;
                };
                Object.defineProperty(QuestionRankingModel.prototype, "rootClass", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(this.cssClasses.root).append(this.cssClasses.rootMobileMod, this.isMobileMode()).append(this.cssClasses.rootDisabled, this.isReadOnly).append(this.cssClasses.rootDesignMode, !!this.isDesignMode).append(this.cssClasses.itemOnError, this.hasCssError()).append(this.cssClasses.rootDragHandleAreaIcon, _src_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].rankingDragHandleArea === "icon").append(this.cssClasses.rootSelectToRankMod, this.selectToRankEnabled).append(this.cssClasses.rootSelectToRankAlignHorizontal, this.selectToRankEnabled && this.renderedSelectToRankAreasLayout === "horizontal").append(this.cssClasses.rootSelectToRankAlignVertical, this.selectToRankEnabled && this.renderedSelectToRankAreasLayout === "vertical").toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRankingModel.prototype.getItemClassCore = function(item, options) {
                    var itemIndex = this.rankingChoices.indexOf(item);
                    var unrankedItemIndex = this.unRankingChoices.indexOf(item);
                    var dropTargetIndex = this.rankingChoices.indexOf(this.currentDropTarget);
                    var isDrop = this.selectToRankEnabled && itemIndex > -1 && unrankedItemIndex > -1 || this.currentDropTarget === item;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(_super.prototype.getItemClassCore.call(this, item, options)).append(this.cssClasses.itemGhostMod, isDrop).append("sv-dragdrop-movedown", itemIndex === dropTargetIndex + 1 && this.dropTargetNodeMove === "down").append("sv-dragdrop-moveup", itemIndex === dropTargetIndex - 1 && this.dropTargetNodeMove === "up").toString();
                };
                QuestionRankingModel.prototype.getContainerClasses = function(containerType) {
                    var isEmpty = false;
                    var isToContainer = containerType === "to";
                    var isFromContainer = containerType === "from";
                    if (isToContainer) isEmpty = this.rankingChoices.length === 0;
                    else if (isFromContainer) isEmpty = this.unRankingChoices.length === 0;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(this.cssClasses.container).append(this.cssClasses.containerToMode, isToContainer).append(this.cssClasses.containerFromMode, isFromContainer).append(this.cssClasses.containerEmptyMode, isEmpty).toString();
                };
                QuestionRankingModel.prototype.isItemCurrentDropTarget = function(item) {
                    return this.dragDropRankingChoices.dropTarget === item;
                };
                Object.defineProperty(QuestionRankingModel.prototype, "ghostPositionCssClass", {
                    get: function() {
                        if (this.ghostPosition === "top") return this.cssClasses.dragDropGhostPositionTop;
                        if (this.ghostPosition === "bottom") return this.cssClasses.dragDropGhostPositionBottom;
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRankingModel.prototype.getItemIndexClasses = function(item) {
                    var noNumber;
                    if (this.selectToRankEnabled) noNumber = this.unRankingChoices.indexOf(item) !== -1;
                    else noNumber = this.isEmpty();
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(this.cssClasses.itemIndex).append(this.cssClasses.itemIndexEmptyMode, noNumber).toString();
                };
                QuestionRankingModel.prototype.getNumberByIndex = function(index) {
                    return this.isEmpty() ? "" : index + 1 + "";
                };
                QuestionRankingModel.prototype.updateRankingChoicesSync = function() {
                    this.animationAllowed = false;
                    this.updateRankingChoices();
                    this.animationAllowed = true;
                };
                QuestionRankingModel.prototype.setSurveyImpl = function(value, isLight) {
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    this.setDragDropRankingChoices();
                    this.updateRankingChoicesSync();
                };
                QuestionRankingModel.prototype.isAnswerCorrect = function() {
                    return _helpers__WEBPACK_IMPORTED_MODULE_8__["Helpers"].isArraysEqual(this.value, this.correctAnswer, false);
                };
                Object.defineProperty(QuestionRankingModel.prototype, "requireStrictCompare", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRankingModel.prototype.onSurveyValueChanged = function(newValue) {
                    _super.prototype.onSurveyValueChanged.call(this, newValue);
                    if (this.isLoadingFromJson) return;
                    this.updateRankingChoicesSync();
                };
                QuestionRankingModel.prototype.addToValueByVisibleChoices = function() {
                    var newValue = this.value.slice();
                    this.visibleChoices.forEach(function(choice) {
                        if (newValue.indexOf(choice.value) === -1) newValue.push(choice.value);
                    });
                    this.value = newValue;
                };
                QuestionRankingModel.prototype.removeFromValueByVisibleChoices = function() {
                    var newValue = this.value.slice();
                    var choices = this.visibleChoices;
                    for(var i = this.value.length - 1; i >= 0; i--)if (!_itemvalue__WEBPACK_IMPORTED_MODULE_2__["ItemValue"].getItemByValue(choices, this.value[i])) newValue.splice(i, 1);
                    this.value = newValue;
                };
                QuestionRankingModel.prototype.getChoicesAnimation = function(isRankingChoices) {
                    var _this = this;
                    return {
                        isAnimationEnabled: function() {
                            return _src_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].animationEnabled && _this.animationAllowed;
                        },
                        getLeaveOptions: function(item) {
                            var choices = isRankingChoices ? _this.rankingChoices : _this.unRankingChoices;
                            if (_this.renderedSelectToRankAreasLayout == "vertical" && choices.length == 1 && choices.indexOf(item) >= 0) return {
                                cssClass: "sv-ranking-item--animate-item-removing-empty"
                            };
                            return {
                                cssClass: "sv-ranking-item--animate-item-removing"
                            };
                        },
                        getEnterOptions: function(item) {
                            var choices = isRankingChoices ? _this.rankingChoices : _this.unRankingChoices;
                            if (_this.renderedSelectToRankAreasLayout == "vertical" && choices.length == 1 && choices.indexOf(item) >= 0) return {
                                cssClass: "sv-ranking-item--animate-item-adding-empty"
                            };
                            return {
                                cssClass: "sv-ranking-item--animate-item-adding"
                            };
                        },
                        getAnimatedElement: function(item) {
                            var _a;
                            var containerSelector = isRankingChoices ? ".sv-ranking__container--to" : ".sv-ranking__container--from";
                            return (_a = _this.getWrapperElement()) === null || _a === void 0 ? void 0 : _a.querySelector(containerSelector + " .sv-ranking-item--ghost");
                        }
                    };
                };
                Object.defineProperty(QuestionRankingModel.prototype, "rankingChoicesAnimation", {
                    get: function() {
                        return this._rankingChoicesAnimation;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "unRankingChoicesAnimation", {
                    get: function() {
                        return this._unRankingChoicesAnimation;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "rankingChoices", {
                    get: function() {
                        return this.getPropertyValue("rankingChoices", []);
                    },
                    set: function(val1) {
                        this._rankingChoicesAnimation.sync(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "unRankingChoices", {
                    get: function() {
                        return this.getPropertyValue("unRankingChoices", []);
                    },
                    set: function(val1) {
                        this._unRankingChoicesAnimation.sync(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRankingModel.prototype.updateRankingChoices = function(forceUpdate) {
                    var _this = this;
                    if (forceUpdate === void 0) forceUpdate = false;
                    if (this.selectToRankEnabled) {
                        this.updateRankingChoicesSelectToRankMode(forceUpdate);
                        return;
                    }
                    var newRankingChoices = [];
                    // ranking question with only one choice doesn't make sense
                    // if (this.visibleChoices.length === 1) {
                    //   this.setPropertyValue("rankingChoices", newRankingChoices);
                    //   return;
                    // }
                    if (forceUpdate) this.setPropertyValue("rankingChoices", []);
                    if (this.isEmpty()) {
                        this.setPropertyValue("rankingChoices", this.visibleChoices);
                        return;
                    }
                    this.value.forEach(function(valueItem) {
                        _this.visibleChoices.forEach(function(choice) {
                            if (choice.value === valueItem) newRankingChoices.push(choice);
                        });
                    });
                    this.setPropertyValue("rankingChoices", newRankingChoices);
                };
                QuestionRankingModel.prototype.updateUnRankingChoices = function(newRankingChoices) {
                    var unRankingChoices = [];
                    this.visibleChoices.forEach(function(choice) {
                        unRankingChoices.push(choice);
                    });
                    newRankingChoices.forEach(function(rankingChoice) {
                        unRankingChoices.forEach(function(choice, index) {
                            if (choice.value === rankingChoice.value) unRankingChoices.splice(index, 1);
                        });
                    });
                    this.unRankingChoices = unRankingChoices;
                };
                QuestionRankingModel.prototype.updateRankingChoicesSelectToRankMode = function(forceUpdate) {
                    var _this = this;
                    var newRankingChoices = [];
                    if (!this.isEmpty()) this.value.forEach(function(valueItem) {
                        _this.visibleChoices.forEach(function(choice) {
                            if (choice.value === valueItem) newRankingChoices.push(choice);
                        });
                    });
                    this.updateUnRankingChoices(newRankingChoices);
                    this.rankingChoices = newRankingChoices;
                };
                QuestionRankingModel.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    this.setDragDropRankingChoices();
                };
                QuestionRankingModel.prototype.setDragDropRankingChoices = function() {
                    this.dragDropRankingChoices = this.createDragDropRankingChoices();
                };
                QuestionRankingModel.prototype.createDragDropRankingChoices = function() {
                    if (this.selectToRankEnabled) return new _dragdrop_ranking_select_to_rank__WEBPACK_IMPORTED_MODULE_1__["DragDropRankingSelectToRank"](this.survey, null, this.longTap);
                    return new _dragdrop_ranking_choices__WEBPACK_IMPORTED_MODULE_0__["DragDropRankingChoices"](this.survey, null, this.longTap);
                };
                QuestionRankingModel.prototype.isDragStartNodeValid = function(target) {
                    if (_src_settings__WEBPACK_IMPORTED_MODULE_9__["settings"].rankingDragHandleArea === "icon") return target.classList.contains(this.cssClasses.itemIconHoverMod);
                    return true;
                };
                Object.defineProperty(QuestionRankingModel.prototype, "allowStartDrag", {
                    get: function() {
                        return !this.isReadOnly && !this.isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRankingModel.prototype.canStartDragDueMaxSelectedChoices = function(target) {
                    if (!this.selectToRankEnabled) return true;
                    var fromContainer = target.closest("[data-ranking='from-container']");
                    if (fromContainer) return this.checkMaxSelectedChoicesUnreached();
                    return true;
                };
                QuestionRankingModel.prototype.canStartDragDueItemEnabled = function(item) {
                    return item.enabled;
                };
                QuestionRankingModel.prototype.checkMaxSelectedChoicesUnreached = function() {
                    if (this.maxSelectedChoices < 1) return true;
                    var val1 = this.value;
                    var len = !Array.isArray(val1) ? 0 : val1.length;
                    return len < this.maxSelectedChoices;
                };
                //cross framework initialization
                QuestionRankingModel.prototype.afterRenderQuestionElement = function(el) {
                    this.domNode = el;
                    _super.prototype.afterRenderQuestionElement.call(this, el);
                };
                //cross framework destroy
                QuestionRankingModel.prototype.beforeDestroyQuestionElement = function(el) {
                    _super.prototype.beforeDestroyQuestionElement.call(this, el);
                };
                QuestionRankingModel.prototype.supportSelectAll = function() {
                    return false;
                };
                QuestionRankingModel.prototype.supportOther = function() {
                    return false;
                };
                QuestionRankingModel.prototype.supportNone = function() {
                    return false;
                };
                QuestionRankingModel.prototype.supportRefuse = function() {
                    return false;
                };
                QuestionRankingModel.prototype.supportDontKnow = function() {
                    return false;
                };
                QuestionRankingModel.prototype.handleKeydownSelectToRank = function(event1, movedElement) {
                    if (this.isDesignMode) return;
                    var key = event1.key;
                    if (key !== " " && key !== "ArrowUp" && key !== "ArrowDown") return;
                    var dnd = this.dragDropRankingChoices; //????
                    var rankingChoices = this.rankingChoices;
                    var isMovedElementRanked = rankingChoices.indexOf(movedElement) !== -1;
                    var choices = isMovedElementRanked ? rankingChoices : this.unRankingChoices;
                    var fromIndex = choices.indexOf(movedElement);
                    if (fromIndex < 0) return;
                    var toIndex;
                    if (key === " " && !isMovedElementRanked) {
                        toIndex = 0;
                        dnd.selectToRank(this, fromIndex, toIndex);
                        this.setValueAfterKeydown(toIndex, "to-container");
                        return;
                    }
                    if (!isMovedElementRanked) return;
                    if (key === " ") {
                        dnd.unselectFromRank(this, fromIndex);
                        toIndex = this.unRankingChoices.indexOf(movedElement); //'this.' leads to actual array after the 'unselectFromRank' method
                        this.setValueAfterKeydown(toIndex, "from-container");
                        return;
                    }
                    var delta = key === "ArrowUp" ? -1 : key === "ArrowDown" ? 1 : 0;
                    if (delta === 0) return;
                    toIndex = fromIndex + delta;
                    if (toIndex < 0 || toIndex >= rankingChoices.length) return;
                    dnd.reorderRankedItem(this, fromIndex, toIndex);
                    this.setValueAfterKeydown(toIndex, "to-container");
                };
                QuestionRankingModel.prototype.setValueAfterKeydown = function(index, container) {
                    var _this = this;
                    this.setValue();
                    setTimeout(function() {
                        _this.focusItem(index, container);
                    }, 1);
                    event.preventDefault();
                };
                QuestionRankingModel.prototype.getIconHoverCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(this.cssClasses.itemIcon).append(this.cssClasses.itemIconHoverMod).toString();
                };
                QuestionRankingModel.prototype.getIconFocusCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(this.cssClasses.itemIcon).append(this.cssClasses.itemIconFocusMod).toString();
                };
                Object.defineProperty(QuestionRankingModel.prototype, "longTap", {
                    /**
         * Specifies whether to use a long tap (press and hold) gesture to start dragging.
         *
         * Default value: `true`
         *
         * Disable this property if you want to start dragging when users perform a scroll gesture.
        */ get: function() {
                        return this.getPropertyValue("longTap");
                    },
                    set: function(val1) {
                        this.setPropertyValue("longTap", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "selectToRankEnabled", {
                    /**
         * Specifies whether users can select choices they want to rank.
         *
         * When you enable this property, the Ranking question displays two areas for ranked and unranked choices. To order choices, users should first drag them from the unranked to the ranked area. Use this mode if you want to let users order only the choices they select.
         *
         * Default value: `false`
         * @see selectToRankAreasLayout
        */ get: function() {
                        return this.getPropertyValue("selectToRankEnabled", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("selectToRankEnabled", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "selectToRankAreasLayout", {
                    /**
         * Specifies the layout of the ranked and unranked areas. Applies when [`selectToRankEnabled`](https://surveyjs.io/form-library/documentation/api-reference/ranking-question-model#selectToRankEnabled) is `true`.
         *
         * Possible values:
         *
         * - `"horizontal"` (default) - The ranked and unranked areas are positioned next to each other. Users drag and drop choices between them in the horizontal direction.
         * - `"vertical"`- The ranked area is positioned above the unranked area. Users drag and drop choices between them in the vertical direction.
         * @see selectToRankAreasLayout
        */ get: function() {
                        return this.getPropertyValue("selectToRankAreasLayout");
                    },
                    set: function(val1) {
                        this.setPropertyValue("selectToRankAreasLayout", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "renderedSelectToRankAreasLayout", {
                    get: function() {
                        if (this.isMobileMode()) return "vertical";
                        return this.selectToRankAreasLayout;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRankingModel.prototype.isMobileMode = function() {
                    return _utils_devices__WEBPACK_IMPORTED_MODULE_7__["IsMobile"];
                };
                Object.defineProperty(QuestionRankingModel.prototype, "useFullItemSizeForShortcut", {
                    get: function() {
                        return this.getPropertyValue("useFullItemSizeForShortcut");
                    },
                    set: function(val1) {
                        this.setPropertyValue("useFullItemSizeForShortcut", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "dragDropSvgIcon", {
                    get: function() {
                        return this.cssClasses.dragDropSvgIconId || "#icon-drag-n-drop";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "arrowsSvgIcon", {
                    get: function() {
                        return this.cssClasses.arrowsSvgIconId || "#icon-ranking-arrows";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "dashSvgIcon", {
                    get: function() {
                        return this.cssClasses.dashSvgIconId || "#icon-ranking-dash";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRankingModel.prototype, "isNewA11yStructure", {
                    //a11y
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: null
                    })
                ], QuestionRankingModel.prototype, "currentDropTarget", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: null
                    })
                ], QuestionRankingModel.prototype, "dropTargetNodeMove", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        defaultValue: true
                    })
                ], QuestionRankingModel.prototype, "carryForwardStartUnranked", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        localizable: {
                            defaultStr: "selectToRankEmptyRankedAreaText"
                        }
                    })
                ], QuestionRankingModel.prototype, "selectToRankEmptyRankedAreaText", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_3__["property"])({
                        localizable: {
                            defaultStr: "selectToRankEmptyUnrankedAreaText"
                        }
                    })
                ], QuestionRankingModel.prototype, "selectToRankEmptyUnrankedAreaText", void 0);
                return QuestionRankingModel;
            }(_question_checkbox__WEBPACK_IMPORTED_MODULE_5__["QuestionCheckboxModel"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_3__["Serializer"].addClass("ranking", [
                {
                    name: "showOtherItem",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "otherText",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "otherErrorText",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "storeOthersAsComment",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "showNoneItem",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "showRefuseItem",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "showDontKnowItem",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "noneText",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "showSelectAllItem",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "selectAllText",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "colCount:number",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "separateSpecialChoices",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "longTap",
                    default: true,
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "selectToRankEnabled:switch",
                    default: false,
                    visible: true,
                    isSerializable: true
                },
                {
                    name: "selectToRankAreasLayout",
                    default: "horizontal",
                    choices: [
                        "horizontal",
                        "vertical"
                    ],
                    dependsOn: "selectToRankEnabled",
                    visibleIf: function(obj) {
                        return !!obj.selectToRankEnabled;
                    },
                    visible: true,
                    isSerializable: true
                },
                {
                    name: "selectToRankEmptyRankedAreaText:text",
                    serializationProperty: "locSelectToRankEmptyRankedAreaText",
                    category: "general",
                    dependsOn: "selectToRankEnabled",
                    visibleIf: function(obj) {
                        return !!obj.selectToRankEnabled;
                    }
                },
                {
                    name: "selectToRankEmptyUnrankedAreaText:text",
                    serializationProperty: "locSelectToRankEmptyUnrankedAreaText",
                    category: "general",
                    dependsOn: "selectToRankEnabled",
                    visibleIf: function(obj) {
                        return !!obj.selectToRankEnabled;
                    }
                },
                {
                    name: "maxSelectedChoices:number",
                    visible: true,
                    default: 0,
                    dependsOn: "selectToRankEnabled",
                    visibleIf: function(obj) {
                        return !!obj.selectToRankEnabled;
                    },
                    isSerializable: true
                },
                {
                    name: "minSelectedChoices:number",
                    visible: true,
                    default: 0,
                    dependsOn: "selectToRankEnabled",
                    visibleIf: function(obj) {
                        return !!obj.selectToRankEnabled;
                    },
                    isSerializable: true
                },
                {
                    name: "itemComponent",
                    visible: false,
                    default: ""
                }
            ], function() {
                return new QuestionRankingModel("");
            }, "checkbox");
            _questionfactory__WEBPACK_IMPORTED_MODULE_4__["QuestionFactory"].Instance.registerQuestion("ranking", function(name) {
                var q = new QuestionRankingModel(name);
                q.choices = _questionfactory__WEBPACK_IMPORTED_MODULE_4__["QuestionFactory"].DefaultChoices;
                return q;
            });
        /***/ },
        /***/ "./src/question_rating.ts": /*!********************************!*\
  !*** ./src/question_rating.ts ***!
  \********************************/ /*! exports provided: RenderedRatingItem, QuestionRatingModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RenderedRatingItem", function() {
                return RenderedRatingItem;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionRatingModel", function() {
                return QuestionRatingModel;
            });
            /* harmony import */ var _itemvalue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./itemvalue */ "./src/itemvalue.ts");
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _utils_devices__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./utils/devices */ "./src/utils/devices.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var RenderedRatingItem = /** @class */ function(_super) {
                __extends(RenderedRatingItem, _super);
                function RenderedRatingItem(itemValue, locString) {
                    if (locString === void 0) locString = null;
                    var _this = _super.call(this) || this;
                    _this.itemValue = itemValue;
                    _this.locString = locString;
                    _this.locText.onStringChanged.add(_this.onStringChangedCallback.bind(_this));
                    _this.onStringChangedCallback();
                    return _this;
                }
                RenderedRatingItem.prototype.onStringChangedCallback = function() {
                    this.text = this.itemValue.text;
                };
                Object.defineProperty(RenderedRatingItem.prototype, "value", {
                    get: function() {
                        return this.itemValue.getPropertyValue("value");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RenderedRatingItem.prototype, "locText", {
                    get: function() {
                        return this.locString || this.itemValue.locText;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: ""
                    })
                ], RenderedRatingItem.prototype, "highlight", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: ""
                    })
                ], RenderedRatingItem.prototype, "text", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], RenderedRatingItem.prototype, "style", void 0);
                return RenderedRatingItem;
            }(_base__WEBPACK_IMPORTED_MODULE_7__["Base"]);
            var RatingItemValue = /** @class */ function(_super) {
                __extends(RatingItemValue, _super);
                function RatingItemValue(value, description) {
                    var _this = _super.call(this, value) || this;
                    _this.description = description;
                    return _this;
                }
                return RatingItemValue;
            }(_itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"]);
            /**
 * A class that describes the Rating Scale question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/rating-scale/ (linkStyle))
 */ var QuestionRatingModel = /** @class */ function(_super) {
                __extends(QuestionRatingModel, _super);
                function QuestionRatingModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this._syncPropertiesChanging = false;
                    _this.createItemValues("rateValues");
                    _this.createRenderedRateItems();
                    _this.createLocalizableString("ratingOptionsCaption", _this, false, true);
                    _this.registerFunctionOnPropertiesValueChanged([
                        "rateMin",
                        "rateMax",
                        "minRateDescription",
                        "maxRateDescription",
                        "rateStep",
                        "displayRateDescriptionsAsExtremeItems"
                    ], function() {
                        return _this.createRenderedRateItems();
                    });
                    _this.registerFunctionOnPropertiesValueChanged([
                        "rateType"
                    ], function() {
                        _this.setIconsToRateValues();
                        _this.createRenderedRateItems();
                        _this.updateRateCount();
                    });
                    _this.registerFunctionOnPropertiesValueChanged([
                        "rateValues"
                    ], function() {
                        _this.autoGenerate = false;
                        _this.setIconsToRateValues();
                        _this.createRenderedRateItems();
                    });
                    _this.registerFunctionOnPropertiesValueChanged([
                        "rateColorMode",
                        "scaleColorMode"
                    ], function() {
                        _this.updateColors(_this.survey.themeVariables);
                    });
                    _this.registerFunctionOnPropertiesValueChanged([
                        "autoGenerate"
                    ], function() {
                        if (!_this.autoGenerate && _this.rateValues.length === 0) _this.setPropertyValue("rateValues", _this.visibleRateValues);
                        if (_this.autoGenerate) {
                            _this.rateValues.length = 0;
                            _this.updateRateMax();
                        }
                        _this.createRenderedRateItems();
                    });
                    _this.createLocalizableString("minRateDescription", _this, true);
                    _this.createLocalizableString("maxRateDescription", _this, true);
                    _this.initPropertyDependencies();
                    return _this;
                }
                QuestionRatingModel.prototype.setIconsToRateValues = function() {
                    var _this = this;
                    if (this.rateType == "smileys") this.rateValues.map(function(item) {
                        return item.icon = _this.getItemSmiley(item);
                    });
                };
                QuestionRatingModel.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    this.hasMinRateDescription = !!this.minRateDescription;
                    this.hasMaxRateDescription = !!this.maxRateDescription;
                    if (this.jsonObj.rateMin !== undefined && this.jsonObj.rateCount !== undefined && this.jsonObj.rateMax === undefined) this.updateRateMax();
                    if (this.jsonObj.rateMax !== undefined && this.jsonObj.rateCount !== undefined && this.jsonObj.rateMin === undefined) this.updateRateMin();
                    if (this.jsonObj.autoGenerate === undefined && this.jsonObj.rateValues !== undefined) this.autoGenerate = !this.jsonObj.rateValues.length;
                    this.updateRateCount();
                    this.setIconsToRateValues();
                    this.createRenderedRateItems();
                };
                QuestionRatingModel.prototype.registerSychProperties = function(names, func) {
                    var _this = this;
                    this.registerFunctionOnPropertiesValueChanged(names, function() {
                        if (!_this._syncPropertiesChanging) {
                            _this._syncPropertiesChanging = true;
                            func();
                            _this._syncPropertiesChanging = false;
                        }
                    });
                };
                QuestionRatingModel.prototype.useRateValues = function() {
                    return !!this.rateValues.length && !this.autoGenerate;
                };
                QuestionRatingModel.prototype.updateRateMax = function() {
                    this.rateMax = this.rateMin + this.rateStep * (this.rateCount - 1);
                };
                QuestionRatingModel.prototype.updateRateMin = function() {
                    this.rateMin = this.rateMax - this.rateStep * (this.rateCount - 1);
                };
                QuestionRatingModel.prototype.updateRateCount = function() {
                    var newCount = 0;
                    if (this.useRateValues()) newCount = this.rateValues.length;
                    else newCount = Math.trunc((this.rateMax - this.rateMin) / (this.rateStep || 1)) + 1;
                    if (newCount > 10 && this.rateDisplayMode == "smileys") newCount = 10;
                    this.rateCount = newCount;
                    if (this.rateValues.length > newCount) this.rateValues.splice(newCount, this.rateValues.length - newCount);
                };
                QuestionRatingModel.prototype.initPropertyDependencies = function() {
                    var _this = this;
                    this.registerSychProperties([
                        "rateCount"
                    ], function() {
                        if (!_this.useRateValues()) _this.rateMax = _this.rateMin + _this.rateStep * (_this.rateCount - 1);
                        else {
                            if (_this.rateCount < _this.rateValues.length) {
                                if (_this.rateCount >= 10 && _this.rateDisplayMode == "smileys") return;
                                _this.rateValues.splice(_this.rateCount, _this.rateValues.length - _this.rateCount);
                            } else for(var i = _this.rateValues.length; i < _this.rateCount; i++)_this.rateValues.push(new _itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"](_surveyStrings__WEBPACK_IMPORTED_MODULE_5__["surveyLocalization"].getString("choices_Item") + (i + 1)));
                        }
                    });
                    this.registerSychProperties([
                        "rateMin",
                        "rateMax",
                        "rateStep",
                        "rateValues"
                    ], function() {
                        _this.updateRateCount();
                    });
                };
                Object.defineProperty(QuestionRatingModel.prototype, "showSelectedItemLocText", {
                    get: function() {
                        return !this.readOnly && !this.inputHasValue && !!this.selectedItemLocText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "selectedItemLocText", {
                    get: function() {
                        var _this = this;
                        var _a;
                        return !this.readOnly && ((_a = this.visibleRateValues.filter(function(v) {
                            return v.value == _this.value;
                        })[0]) === null || _a === void 0 ? void 0 : _a.locText);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "rateValues", {
                    /**
         * A list of rate values.
         *
         * This property accepts an array of objects with the following structure:
         *
         * ```js
         * {
         *   "value": any, // A value to be saved in survey results
         *   "text": String, // A display text. This property supports Markdown. When `text` is undefined, `value` is used.
         *   "customProperty": any // Any property that you find useful.
         * }
         * ```
         *
         * If you add custom properties, refer to the following help topic to learn how to serialize them into JSON: [Add Custom Properties to Property Grid](https://surveyjs.io/survey-creator/documentation/property-grid#add-custom-properties-to-the-property-grid).
         *
         * To enable Markdown support for the `text` property, implement Markdown-to-HTML conversion in the [onTextMarkdown](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onTextMarkdown) event handler. For an example, refer to the following demo: [Convert Markdown to HTML with Showdown](https://surveyjs.io/form-library/examples/edit-survey-questions-markdown/).
         *
         * If you need to specify only the `value` property, you can set the `rateValues` property to an array of numbers, for example, `[ 3, 6, 10 ]`. These values are both saved in survey results and used as display text.
         *
         * If you do not specify the `rateValues` property, rate values are generated automatically based upon the [`rateMin`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model#rateMin), [`rateMax`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model#rateMax), [`rateStep`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model#rateStep), and [`rateCount`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model#rateCount) property values.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/rating-scale/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("rateValues");
                    },
                    set: function(val1) {
                        this.setPropertyValue("rateValues", val1);
                        this.createRenderedRateItems();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "rateMin", {
                    /**
         * Specifies the first rate value in the generated sequence of rate values. Applies if the [`rateValues`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model#rateValues) array is empty.
         *
         * Default value: 1
         *
         * [View Demo](https://surveyjs.io/form-library/examples/rating-scale/ (linkStyle))
         * @see rateMax
         * @see rateStep
         * @see rateCount
         */ get: function() {
                        return this.getPropertyValue("rateMin");
                    },
                    set: function(val1) {
                        this.setPropertyValue("rateMin", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "rateMax", {
                    /**
         * Specifies the last rate value in the generated sequence of rate values. Applies if the [`rateValues`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model#rateValues) array is empty.
         *
         * Default value: 5
         *
         * [View Demo](https://surveyjs.io/form-library/examples/rating-scale/ (linkStyle))
         * @see rateMin
         * @see rateStep
         * @see rateCount
         */ get: function() {
                        return this.getPropertyValue("rateMax");
                    },
                    set: function(val1) {
                        this.setPropertyValue("rateMax", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "rateStep", {
                    /**
         * Specifies a step with which to generate rate values. Applies if the [`rateValues`](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model#rateValues) array is empty.
         *
         * Default value: 1
         *
         * [View Demo](https://surveyjs.io/form-library/examples/rating-scale/ (linkStyle))
         * @see rateMin
         * @see rateMax
         * @see rateCount
         */ get: function() {
                        return this.getPropertyValue("rateStep");
                    },
                    set: function(val1) {
                        this.setPropertyValue("rateStep", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRatingModel.prototype.updateColors = function(themeVariables) {
                    if (this.colorMode === "monochrome") return;
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_10__["DomDocumentHelper"].isAvailable()) return;
                    if (QuestionRatingModel.colorsCalculated) return;
                    function getRGBColor(colorName, varName) {
                        var str = !!themeVariables && themeVariables[colorName];
                        if (!str) {
                            var style = getComputedStyle(_global_variables_utils__WEBPACK_IMPORTED_MODULE_10__["DomDocumentHelper"].getDocumentElement());
                            str = style.getPropertyValue && style.getPropertyValue(varName);
                        }
                        if (!str) return null;
                        var canvasElement = _global_variables_utils__WEBPACK_IMPORTED_MODULE_10__["DomDocumentHelper"].createElement("canvas");
                        if (!canvasElement) return null;
                        var ctx = canvasElement.getContext("2d");
                        ctx.fillStyle = str;
                        var newStr = ctx.fillStyle;
                        if (newStr.startsWith("rgba")) return newStr.substring(5, newStr.length - 1).split(",").map(function(c) {
                            return +c.trim();
                        });
                        var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(newStr);
                        return result ? [
                            parseInt(result[1], 16),
                            parseInt(result[2], 16),
                            parseInt(result[3], 16),
                            1
                        ] : null;
                    }
                    QuestionRatingModel.badColor = getRGBColor("--sjs-special-red", "--sd-rating-bad-color");
                    QuestionRatingModel.normalColor = getRGBColor("--sjs-special-yellow", "--sd-rating-normal-color");
                    QuestionRatingModel.goodColor = getRGBColor("--sjs-special-green", "--sd-rating-good-color");
                    QuestionRatingModel.badColorLight = getRGBColor("--sjs-special-red-light", "--sd-rating-bad-color-light");
                    QuestionRatingModel.normalColorLight = getRGBColor("--sjs-special-yellow-light", "--sd-rating-normal-color-light");
                    QuestionRatingModel.goodColorLight = getRGBColor("--sjs-special-green-light", "--sd-rating-good-color-light");
                    this.colorsCalculated = true;
                };
                QuestionRatingModel.prototype.getDisplayValueCore = function(keysAsText, value) {
                    if (!this.useRateValues) return _super.prototype.getDisplayValueCore.call(this, keysAsText, value);
                    var res = _itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].getTextOrHtmlByValue(this.visibleRateValues, value);
                    return !!res ? res : value;
                };
                Object.defineProperty(QuestionRatingModel.prototype, "visibleRateValues", {
                    get: function() {
                        return this.renderedRateItems.map(function(i) {
                            return i.itemValue;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRatingModel.prototype.itemValuePropertyChanged = function(item, name, oldValue, newValue) {
                    if (!this.useRateValues() && newValue !== undefined) this.autoGenerate = false;
                    _super.prototype.itemValuePropertyChanged.call(this, item, name, oldValue, newValue);
                };
                QuestionRatingModel.prototype.createRenderedRateItems = function() {
                    var _this = this;
                    var rateValues = [];
                    if (this.useRateValues()) rateValues = this.rateValues;
                    else rateValues = this.createRateValues();
                    if (this.autoGenerate) this.rateMax = rateValues[rateValues.length - 1].value;
                    if (this.rateType == "smileys" && rateValues.length > 10) rateValues = rateValues.slice(0, 10);
                    this.renderedRateItems = rateValues.map(function(v, i) {
                        var renderedItem = null;
                        if (_this.displayRateDescriptionsAsExtremeItems) {
                            if (i == 0) renderedItem = new RenderedRatingItem(v, _this.minRateDescription && _this.locMinRateDescription || v.locText);
                            if (i == rateValues.length - 1) renderedItem = new RenderedRatingItem(v, _this.maxRateDescription && _this.locMaxRateDescription || v.locText);
                        }
                        if (!renderedItem) renderedItem = new RenderedRatingItem(v);
                        return renderedItem;
                    });
                };
                QuestionRatingModel.prototype.createRateValues = function() {
                    var res = [];
                    var value = this.rateMin;
                    var step = this.rateStep;
                    while(value <= this.rateMax && res.length < _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].ratingMaximumRateValueCount){
                        var description = void 0;
                        if (value === this.rateMin) description = this.minRateDescription && this.locMinRateDescription;
                        if (value === this.rateMax || res.length === _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].ratingMaximumRateValueCount) description = this.maxRateDescription && this.locMaxRateDescription;
                        var item = new RatingItemValue(value, description);
                        item.locOwner = this;
                        item.ownerPropertyName = "rateValues";
                        res.push(item);
                        value = this.correctValue(value + step, step);
                    }
                    return res;
                };
                QuestionRatingModel.prototype.correctValue = function(value, step) {
                    if (!value) return value;
                    if (Math.round(value) == value) return value;
                    var fr = 0;
                    while(Math.round(step) != step){
                        step *= 10;
                        fr++;
                    }
                    return parseFloat(value.toFixed(fr));
                };
                QuestionRatingModel.prototype.getType = function() {
                    return "rating";
                };
                QuestionRatingModel.prototype.getFirstInputElementId = function() {
                    return this.inputId + "_0";
                };
                QuestionRatingModel.prototype.getInputId = function(index) {
                    return this.inputId + "_" + index;
                };
                QuestionRatingModel.prototype.supportGoNextPageAutomatic = function() {
                    return this.isMouseDown === true || this.renderAs === "dropdown";
                };
                QuestionRatingModel.prototype.supportOther = function() {
                    return false;
                };
                QuestionRatingModel.prototype.getPlainDataCalculatedValue = function(propName) {
                    var res = _super.prototype.getPlainDataCalculatedValue.call(this, propName);
                    if (res !== undefined || !this.useRateValues || this.isEmpty()) return res;
                    var item = _itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].getItemByValue(this.visibleRateValues, this.value);
                    return item ? item[propName] : undefined;
                };
                Object.defineProperty(QuestionRatingModel.prototype, "minRateDescription", {
                    /**
         * Specifies a description for the minimum (first) rate value.
         * @see rateDescriptionLocation
         * @see displayRateDescriptionsAsExtremeItems
         * @see rateValues
         * @see rateMin
         */ get: function() {
                        return this.getLocalizableStringText("minRateDescription");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("minRateDescription", val1);
                        this.hasMinRateDescription = !!this.minRateDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "locMinRateDescription", {
                    get: function() {
                        return this.getLocalizableString("minRateDescription");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "maxRateDescription", {
                    /**
         * Specifies a description for the maximum (last) rate value.
         * @see rateDescriptionLocation
         * @see displayRateDescriptionsAsExtremeItems
         * @see rateValues
         * @see rateMax
         */ get: function() {
                        return this.getLocalizableStringText("maxRateDescription");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("maxRateDescription", val1);
                        this.hasMaxRateDescription = !!this.maxRateDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "locMaxRateDescription", {
                    get: function() {
                        return this.getLocalizableString("maxRateDescription");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "hasMinLabel", {
                    get: function() {
                        return !this.displayRateDescriptionsAsExtremeItems && !!this.hasMinRateDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "hasMaxLabel", {
                    get: function() {
                        return !this.displayRateDescriptionsAsExtremeItems && !!this.hasMaxRateDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "rateDisplayMode", {
                    get: function() {
                        return this.rateType;
                    },
                    set: function(val1) {
                        this.rateType = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "isStar", {
                    get: function() {
                        return this.rateType == "stars";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "isSmiley", {
                    get: function() {
                        return this.rateType == "smileys";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRatingModel.prototype.getDefaultItemComponent = function() {
                    if (this.renderAs == "dropdown") return "sv-rating-dropdown-item";
                    if (this.isStar) return "sv-rating-item-star";
                    if (this.isSmiley) return "sv-rating-item-smiley";
                    return "sv-rating-item";
                };
                Object.defineProperty(QuestionRatingModel.prototype, "itemComponent", {
                    /**
         * The name of a component used to render items.
         */ get: function() {
                        return this.getPropertyValue("itemComponent", this.getDefaultItemComponent());
                    },
                    set: function(value) {
                        this.setPropertyValue("itemComponent", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRatingModel.prototype.valueToData = function(val1) {
                    if (this.useRateValues()) {
                        var item = _itemvalue__WEBPACK_IMPORTED_MODULE_0__["ItemValue"].getItemByValue(this.rateValues, val1);
                        return !!item ? item.value : val1;
                    }
                    return !isNaN(val1) ? parseFloat(val1) : val1;
                };
                QuestionRatingModel.prototype.setValueFromClick = function(value) {
                    if (this.value === parseFloat(value)) this.clearValue();
                    else this.value = value;
                    for(var i = 0; i < this.renderedRateItems.length; i++)this.renderedRateItems[i].highlight = "none";
                };
                QuestionRatingModel.prototype.onItemMouseIn = function(item) {
                    if (_utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"]) return;
                    if (this.isReadOnly || !item.itemValue.isEnabled || this.isDesignMode) return;
                    var high = true;
                    var selected = this.value != null;
                    if (this.rateType !== "stars") {
                        item.highlight = "highlighted";
                        return;
                    }
                    for(var i = 0; i < this.renderedRateItems.length; i++){
                        this.renderedRateItems[i].highlight = high && !selected && "highlighted" || !high && selected && "unhighlighted" || "none";
                        if (this.renderedRateItems[i] == item) high = false;
                        if (this.renderedRateItems[i].itemValue.value == this.value) selected = false;
                    }
                };
                QuestionRatingModel.prototype.onItemMouseOut = function(item) {
                    if (_utils_devices__WEBPACK_IMPORTED_MODULE_9__["IsTouch"]) return;
                    this.renderedRateItems.forEach(function(item) {
                        return item.highlight = "none";
                    });
                };
                Object.defineProperty(QuestionRatingModel.prototype, "itemSmallMode", {
                    get: function() {
                        return this.inMatrixMode && _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].matrix.rateSize == "small";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "ratingRootCss", {
                    get: function() {
                        var baseClassModifier = (this.displayMode == "buttons" || !!this.survey && this.survey.isDesignMode) && this.cssClasses.rootWrappable ? this.cssClasses.rootWrappable : "";
                        var rootClassModifier = "";
                        if (this.hasMaxLabel || this.hasMinLabel) {
                            if (this.rateDescriptionLocation == "top") rootClassModifier = this.cssClasses.rootLabelsTop;
                            if (this.rateDescriptionLocation == "bottom") rootClassModifier = this.cssClasses.rootLabelsBottom;
                            if (this.rateDescriptionLocation == "topBottom") rootClassModifier = this.cssClasses.rootLabelsDiagonal;
                        }
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(this.cssClasses.root).append(baseClassModifier).append(rootClassModifier).append(this.cssClasses.itemSmall, this.itemSmallMode && this.rateType != "labels").toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "itemStarIcon", {
                    get: function() {
                        return this.itemSmallMode ? "icon-rating-star-small" : "icon-rating-star";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "itemStarIconAlt", {
                    get: function() {
                        return this.itemStarIcon + "-2";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRatingModel.prototype.getItemSmiley = function(item) {
                    var icons = [
                        "terrible",
                        "very-poor",
                        "poor",
                        "not-good",
                        "average",
                        "normal",
                        "good",
                        "very-good",
                        "excellent",
                        "perfect"
                    ];
                    var priority = [
                        "very-good",
                        "not-good",
                        "normal",
                        "good",
                        "average",
                        "excellent",
                        "poor",
                        "perfect",
                        "very-poor",
                        "terrible"
                    ];
                    var count = this.useRateValues() ? this.rateValues.length : this.rateMax - this.rateMin + 1;
                    var selectedPriority = priority.slice(0, count);
                    var selectedIcons = icons.filter(function(i) {
                        return selectedPriority.indexOf(i) != -1;
                    });
                    if (!this.useRateValues()) return selectedIcons[item.value - this.rateMin];
                    else return selectedIcons[this.rateValues.indexOf(item)];
                };
                QuestionRatingModel.prototype.getItemSmileyIconName = function(item) {
                    return "icon-" + this.getItemSmiley(item);
                };
                QuestionRatingModel.prototype.getItemClassByText = function(item, text) {
                    return this.getItemClass(item);
                };
                QuestionRatingModel.prototype.getRenderedItemColor = function(index, light) {
                    var startColor = light ? QuestionRatingModel.badColorLight : QuestionRatingModel.badColor;
                    var endColor = light ? QuestionRatingModel.goodColorLight : QuestionRatingModel.goodColor;
                    var normalIndex = (this.rateCount - 1) / 2.0;
                    var middleColor = light ? QuestionRatingModel.normalColorLight : QuestionRatingModel.normalColor;
                    if (index < normalIndex) endColor = middleColor;
                    else {
                        startColor = middleColor;
                        index -= normalIndex;
                    }
                    if (!startColor || !endColor) return null;
                    var curColor = [
                        0,
                        0,
                        0,
                        0
                    ];
                    for(var i = 0; i < 4; i++){
                        curColor[i] = startColor[i] + (endColor[i] - startColor[i]) * index / normalIndex;
                        if (i < 3) curColor[i] = Math.trunc(curColor[i]);
                    }
                    return "rgba(" + curColor[0] + ", " + curColor[1] + ", " + curColor[2] + ", " + curColor[3] + ")";
                };
                QuestionRatingModel.prototype.getItemStyle = function(item, highlight) {
                    if (highlight === void 0) highlight = "none";
                    if (this.scaleColorMode === "monochrome" && this.rateColorMode == "default") return {
                        borderColor: null,
                        fill: null,
                        backgroundColor: null
                    };
                    var index = this.visibleRateValues.indexOf(item);
                    var color = this.getRenderedItemColor(index, false);
                    if (this.value != this.renderedRateItems[index].value) {
                        var colorLight = this.getRenderedItemColor(index, true);
                        if (highlight == "highlighted" && this.scaleColorMode === "colored") return {
                            borderColor: color,
                            fill: color,
                            backgroundColor: colorLight
                        };
                        if (this.scaleColorMode === "colored" && this.errors.length == 0) return {
                            borderColor: color,
                            fill: color,
                            backgroundColor: null
                        };
                        return {
                            borderColor: null,
                            fill: null,
                            backgroundColor: null
                        };
                    } else return {
                        borderColor: color,
                        fill: null,
                        backgroundColor: color
                    };
                };
                QuestionRatingModel.prototype.getItemClass = function(item, highlight) {
                    var _this = this;
                    if (highlight === void 0) highlight = "none";
                    var isSelected = this.value == item.value;
                    if (this.isStar) {
                        if (!this.useRateValues()) isSelected = this.value >= item.value;
                        else isSelected = this.rateValues.indexOf(this.rateValues.filter(function(i) {
                            return i.value == _this.value;
                        })[0]) >= this.rateValues.indexOf(item);
                    }
                    var isDisabled = this.isReadOnly || !item.isEnabled;
                    var allowHover = !isDisabled && this.value != item.value && !(!!this.survey && this.survey.isDesignMode);
                    var renderedItem = this.renderedRateItems.filter(function(i) {
                        return i.itemValue == item;
                    })[0];
                    var isHighlighted = this.isStar && (renderedItem === null || renderedItem === void 0 ? void 0 : renderedItem.highlight) == "highlighted";
                    var isUnhighlighted = this.isStar && (renderedItem === null || renderedItem === void 0 ? void 0 : renderedItem.highlight) == "unhighlighted";
                    var itemClass = this.cssClasses.item;
                    var itemSelectedClass = this.cssClasses.selected;
                    var itemDisabledClass = this.cssClasses.itemDisabled;
                    var itemHoverClass = this.cssClasses.itemHover;
                    var itemitemOnErrorClass = this.cssClasses.itemOnError;
                    var itemHighlightedClass = null;
                    var itemUnhighlightedClass = null;
                    var itemScaleColoredClass = null;
                    var itemRateColoredClass = null;
                    var itemSmallClass = null;
                    if (this.isStar) {
                        itemClass = this.cssClasses.itemStar;
                        itemSelectedClass = this.cssClasses.itemStarSelected;
                        itemDisabledClass = this.cssClasses.itemStarDisabled;
                        itemHoverClass = this.cssClasses.itemStarHover;
                        itemitemOnErrorClass = this.cssClasses.itemStarOnError;
                        itemHighlightedClass = this.cssClasses.itemStarHighlighted;
                        itemUnhighlightedClass = this.cssClasses.itemStarUnhighlighted;
                        itemSmallClass = this.cssClasses.itemStarSmall;
                    }
                    if (this.isSmiley) {
                        itemClass = this.cssClasses.itemSmiley;
                        itemSelectedClass = this.cssClasses.itemSmileySelected;
                        itemDisabledClass = this.cssClasses.itemSmileyDisabled;
                        itemHoverClass = this.cssClasses.itemSmileyHover;
                        itemitemOnErrorClass = this.cssClasses.itemSmileyOnError;
                        itemHighlightedClass = this.cssClasses.itemSmileyHighlighted;
                        itemScaleColoredClass = this.cssClasses.itemSmileyScaleColored;
                        itemRateColoredClass = this.cssClasses.itemSmileyRateColored;
                        itemSmallClass = this.cssClasses.itemSmileySmall;
                    }
                    var hasFixedSize = !this.isStar && !this.isSmiley && (!this.displayRateDescriptionsAsExtremeItems || this.useRateValues() && item != this.rateValues[0] && item != this.rateValues[this.rateValues.length - 1] || !this.useRateValues() && item.value != this.rateMin && item.value != this.rateMax) && item.locText.calculatedText.length <= 2 && Number.isInteger(Number(item.locText.calculatedText));
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(itemClass).append(itemSelectedClass, isSelected).append(itemDisabledClass, this.isReadOnly).append(itemHoverClass, allowHover).append(itemHighlightedClass, isHighlighted).append(itemScaleColoredClass, this.scaleColorMode == "colored").append(itemRateColoredClass, this.rateColorMode == "scale" && isSelected).append(itemUnhighlightedClass, isUnhighlighted).append(itemitemOnErrorClass, this.hasCssError()).append(itemSmallClass, this.itemSmallMode).append(this.cssClasses.itemFixedSize, hasFixedSize).toString();
                };
                //methods for mobile view
                QuestionRatingModel.prototype.getControlClass = function() {
                    this.isEmpty();
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(this.cssClasses.control).append(this.cssClasses.controlEmpty, this.isEmpty()).append(this.cssClasses.onError, this.hasCssError()).append(this.cssClasses.controlDisabled, this.isReadOnly).toString();
                };
                Object.defineProperty(QuestionRatingModel.prototype, "placeholder", {
                    get: function() {
                        return this.getLocalizableStringText("ratingOptionsCaption");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("ratingOptionsCaption", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "locPlaceholder", {
                    get: function() {
                        return this.getLocalizableString("ratingOptionsCaption");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "allowClear", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "searchEnabled", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "renderedValue", {
                    get: function() {
                        return this.value;
                    },
                    set: function(val1) {
                        this.value = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRatingModel.prototype.isItemSelected = function(item) {
                    return item.value == this.value;
                };
                Object.defineProperty(QuestionRatingModel.prototype, "visibleChoices", {
                    get: function() {
                        return this.visibleRateValues;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "readOnlyText", {
                    get: function() {
                        if (this.readOnly) return this.displayValue || this.placeholder;
                        return this.isEmpty() ? this.placeholder : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRatingModel.prototype.needResponsiveWidth = function() {
                    var rateValues = this.getPropertyValue("rateValues");
                    var rateStep = this.getPropertyValue("rateStep");
                    var rateMax = this.getPropertyValue("rateMax");
                    var rateMin = this.getPropertyValue("rateMin");
                    return this.displayMode != "dropdown" && !!(this.hasMinRateDescription || this.hasMaxRateDescription || rateStep && (rateMax - rateMin) / rateStep > 9);
                };
                // TODO: return responsiveness after design improvement
                QuestionRatingModel.prototype.supportResponsiveness = function() {
                    return true;
                };
                QuestionRatingModel.prototype.getCompactRenderAs = function() {
                    return this.displayMode == "buttons" ? "default" : "dropdown";
                };
                QuestionRatingModel.prototype.getDesktopRenderAs = function() {
                    return this.displayMode == "dropdown" ? "dropdown" : "default";
                };
                Object.defineProperty(QuestionRatingModel.prototype, "ariaExpanded", {
                    get: function() {
                        var _a;
                        var popupModel = (_a = this.dropdownListModel) === null || _a === void 0 ? void 0 : _a.popupModel;
                        if (!popupModel) return null;
                        return popupModel.isVisible ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionRatingModel.prototype, "dropdownListModel", {
                    get: function() {
                        return this.dropdownListModelValue;
                    },
                    set: function(val1) {
                        this.dropdownListModelValue = val1;
                        this.updateElementCss();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionRatingModel.prototype.updateCssClasses = function(res, css) {
                    _super.prototype.updateCssClasses.call(this, res, css);
                    if (!!this.dropdownListModel) {
                        var listCssClasses = {};
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_8__["mergeValues"])(css.list, listCssClasses);
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_8__["mergeValues"])(res.list, listCssClasses);
                        res["list"] = listCssClasses;
                    }
                };
                QuestionRatingModel.prototype.calcCssClasses = function(css) {
                    var classes = _super.prototype.calcCssClasses.call(this, css);
                    if (this.dropdownListModel) this.dropdownListModel.updateCssClasses(classes.popup, classes.list);
                    return classes;
                };
                QuestionRatingModel.prototype.themeChanged = function(theme) {
                    this.colorsCalculated = false;
                    this.updateColors(theme.cssVariables);
                    this.createRenderedRateItems();
                };
                QuestionRatingModel.prototype.setSurveyImpl = function(value, isLight) {
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    if (!this.survey) return;
                    this.updateColors(this.survey.themeVariables);
                };
                QuestionRatingModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (!!this.dropdownListModelValue) this.dropdownListModelValue.dispose();
                };
                QuestionRatingModel.colorsCalculated = false;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: false
                    })
                ], QuestionRatingModel.prototype, "inputHasValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionRatingModel.prototype, "autoGenerate", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionRatingModel.prototype, "rateCount", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["propertyArray"])()
                ], QuestionRatingModel.prototype, "renderedRateItems", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: false
                    })
                ], QuestionRatingModel.prototype, "hasMinRateDescription", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: false
                    })
                ], QuestionRatingModel.prototype, "hasMaxRateDescription", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionRatingModel.prototype, "displayRateDescriptionsAsExtremeItems", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        onSet: function(val1, target) {
                            if (!target.isDesignMode) {
                                if (val1 === "dropdown") target.renderAs = "dropdown";
                                else target.renderAs = "default";
                            }
                        }
                    })
                ], QuestionRatingModel.prototype, "displayMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionRatingModel.prototype, "rateDescriptionLocation", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionRatingModel.prototype, "rateType", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionRatingModel.prototype, "scaleColorMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], QuestionRatingModel.prototype, "rateColorMode", void 0);
                return QuestionRatingModel;
            }(_question__WEBPACK_IMPORTED_MODULE_1__["Question"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("rating", [
                {
                    name: "showCommentArea:switch",
                    layout: "row",
                    visible: true,
                    category: "general"
                },
                {
                    name: "rateType",
                    alternativeName: "rateDisplayMode",
                    default: "labels",
                    category: "rateValues",
                    choices: [
                        "labels",
                        "stars",
                        "smileys"
                    ],
                    visibleIndex: 1
                },
                {
                    name: "scaleColorMode",
                    category: "rateValues",
                    default: "monochrome",
                    choices: [
                        "monochrome",
                        "colored"
                    ],
                    visibleIf: function(obj) {
                        return obj.rateDisplayMode == "smileys";
                    },
                    visibleIndex: 2
                },
                {
                    name: "rateColorMode",
                    category: "rateValues",
                    default: "scale",
                    choices: [
                        "default",
                        "scale"
                    ],
                    visibleIf: function(obj) {
                        return obj.rateDisplayMode == "smileys" && obj.scaleColorMode == "monochrome";
                    },
                    visibleIndex: 3
                },
                {
                    name: "autoGenerate",
                    category: "rateValues",
                    default: true,
                    choices: [
                        true,
                        false
                    ],
                    visibleIndex: 5
                },
                {
                    name: "rateCount:number",
                    default: 5,
                    category: "rateValues",
                    visibleIndex: 4,
                    onSettingValue: function(obj, val1) {
                        if (val1 < 2) return 2;
                        if (val1 > _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].ratingMaximumRateValueCount && val1 > obj.rateValues.length) return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].ratingMaximumRateValueCount;
                        if (val1 > 10 && obj.rateDisplayMode == "smileys") return 10;
                        return val1;
                    }
                },
                {
                    name: "rateValues:itemvalue[]",
                    baseValue: function() {
                        return _surveyStrings__WEBPACK_IMPORTED_MODULE_5__["surveyLocalization"].getString("choices_Item");
                    },
                    category: "rateValues",
                    visibleIf: function(obj) {
                        return !obj.autoGenerate;
                    },
                    visibleIndex: 6
                },
                {
                    name: "rateMin:number",
                    default: 1,
                    onSettingValue: function(obj, val1) {
                        return val1 > obj.rateMax - obj.rateStep ? obj.rateMax - obj.rateStep : val1;
                    },
                    visibleIf: function(obj) {
                        return !!obj.autoGenerate;
                    },
                    visibleIndex: 7
                },
                {
                    name: "rateMax:number",
                    default: 5,
                    onSettingValue: function(obj, val1) {
                        return val1 < obj.rateMin + obj.rateStep ? obj.rateMin + obj.rateStep : val1;
                    },
                    visibleIf: function(obj) {
                        return !!obj.autoGenerate;
                    },
                    visibleIndex: 8
                },
                {
                    name: "rateStep:number",
                    default: 1,
                    minValue: 0.1,
                    onSettingValue: function(obj, val1) {
                        if (val1 <= 0) val1 = 1;
                        if (val1 > obj.rateMax - obj.rateMin) val1 = obj.rateMax - obj.rateMin;
                        return val1;
                    },
                    visibleIf: function(obj) {
                        return !!obj.autoGenerate;
                    },
                    visibleIndex: 9
                },
                {
                    name: "minRateDescription",
                    alternativeName: "mininumRateDescription",
                    serializationProperty: "locMinRateDescription",
                    visibleIndex: 18
                },
                {
                    name: "maxRateDescription",
                    alternativeName: "maximumRateDescription",
                    serializationProperty: "locMaxRateDescription",
                    visibleIndex: 19
                },
                {
                    name: "displayRateDescriptionsAsExtremeItems:boolean",
                    default: false,
                    visibleIndex: 21,
                    visibleIf: function(obj) {
                        return obj.rateType == "labels";
                    }
                },
                {
                    name: "rateDescriptionLocation",
                    default: "leftRight",
                    choices: [
                        "leftRight",
                        "top",
                        "bottom",
                        "topBottom"
                    ],
                    visibleIndex: 20
                },
                {
                    name: "displayMode",
                    default: "auto",
                    choices: [
                        "auto",
                        "buttons",
                        "dropdown"
                    ],
                    visibleIndex: 0
                },
                {
                    name: "itemComponent",
                    visible: false,
                    defaultFunc: function(obj) {
                        if (!obj) return "sv-rating-item";
                        if (!!obj.getOriginalObj) obj = obj.getOriginalObj();
                        return obj.getDefaultItemComponent();
                    }
                }
            ], function() {
                return new QuestionRatingModel("");
            }, "question");
            _questionfactory__WEBPACK_IMPORTED_MODULE_3__["QuestionFactory"].Instance.registerQuestion("rating", function(name) {
                return new QuestionRatingModel(name);
            });
        /***/ },
        /***/ "./src/question_signaturepad.ts": /*!**************************************!*\
  !*** ./src/question_signaturepad.ts ***!
  \**************************************/ /*! exports provided: QuestionSignaturePadModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionSignaturePadModel", function() {
                return QuestionSignaturePadModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var signature_pad__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! signature_pad */ "./node_modules/signature_pad/dist/signature_pad.js");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            /* harmony import */ var _question_file__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./question_file */ "./src/question_file.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var defaultWidth = 300;
            var defaultHeight = 200;
            /**
 * A class that describes the Signature question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/signature-pad-widget-javascript/ (linkStyle))
 */ var QuestionSignaturePadModel = /** @class */ function(_super) {
                __extends(QuestionSignaturePadModel, _super);
                function QuestionSignaturePadModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.valueIsUpdatingInternally = false;
                    _this.updateValueHandler = function() {
                        _this.scaleCanvas(false, true);
                        _this.refreshCanvas();
                    };
                    _this.onBlur = function(event1) {
                        if (!_this.storeDataAsText) {
                            if (!_this.element.contains(event1.relatedTarget)) {
                                if (!_this.valueWasChangedFromLastUpload) return;
                                _this.uploadFiles([
                                    Object(_question_file__WEBPACK_IMPORTED_MODULE_5__["dataUrl2File"])(_this.signaturePad.toDataURL(_this.getFormat()), _this.name + "." + correctFormatData(_this.dataFormat), _this.getFormat())
                                ]);
                                _this.valueWasChangedFromLastUpload = false;
                            }
                        }
                    };
                    return _this;
                }
                QuestionSignaturePadModel.prototype.getPenColorFromTheme = function() {
                    var _survey = this.survey;
                    return !!_survey && !!_survey.themeVariables && _survey.themeVariables["--sjs-primary-backcolor"];
                };
                QuestionSignaturePadModel.prototype.updateColors = function(signaturePad) {
                    var penColorFromTheme = this.getPenColorFromTheme();
                    var penColorProperty = this.getPropertyByName("penColor");
                    signaturePad.penColor = this.penColor || penColorFromTheme || penColorProperty.defaultValue || "#1ab394";
                    var backgroundColorProperty = this.getPropertyByName("backgroundColor");
                    var backgroundColorFromTheme = penColorFromTheme ? "transparent" : undefined;
                    var background = !!this.backgroundImage ? "transparent" : this.backgroundColor;
                    signaturePad.backgroundColor = background || backgroundColorFromTheme || backgroundColorProperty.defaultValue || "#ffffff";
                };
                QuestionSignaturePadModel.prototype.getCssRoot = function(cssClasses) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(_super.prototype.getCssRoot.call(this, cssClasses)).append(cssClasses.small, this.signatureWidth.toString() === "300").toString();
                };
                QuestionSignaturePadModel.prototype.getFormat = function() {
                    return this.dataFormat === "jpeg" ? "image/jpeg" : this.dataFormat === "svg" ? "image/svg+xml" : "";
                };
                QuestionSignaturePadModel.prototype.updateValue = function() {
                    if (this.signaturePad) {
                        var data = this.signaturePad.toDataURL(this.getFormat());
                        this.valueIsUpdatingInternally = true;
                        this.value = data;
                        this.valueIsUpdatingInternally = false;
                    }
                };
                QuestionSignaturePadModel.prototype.getType = function() {
                    return "signaturepad";
                };
                QuestionSignaturePadModel.prototype.afterRenderQuestionElement = function(el) {
                    if (!!el) {
                        this.initSignaturePad(el);
                        this.element = el;
                    }
                    _super.prototype.afterRenderQuestionElement.call(this, el);
                };
                QuestionSignaturePadModel.prototype.beforeDestroyQuestionElement = function(el) {
                    if (!!el) this.destroySignaturePad(el);
                };
                QuestionSignaturePadModel.prototype.themeChanged = function(theme) {
                    if (!!this.signaturePad) this.updateColors(this.signaturePad);
                };
                QuestionSignaturePadModel.prototype.resizeCanvas = function() {
                    this.canvas.width = this.containerWidth;
                    this.canvas.height = this.containerHeight;
                };
                QuestionSignaturePadModel.prototype.scaleCanvas = function(refresh, resize) {
                    if (refresh === void 0) refresh = true;
                    if (resize === void 0) resize = false;
                    var canvas = this.canvas;
                    var scale = canvas.offsetWidth / this.containerWidth;
                    if (this.scale != scale || resize) {
                        this.scale = scale;
                        canvas.style.width = this.renderedCanvasWidth;
                        this.resizeCanvas();
                        this.signaturePad.minWidth = this.penMinWidth * scale;
                        this.signaturePad.maxWidth = this.penMaxWidth * scale;
                        canvas.getContext("2d").scale(1 / scale, 1 / scale);
                        if (refresh) this.refreshCanvas();
                    }
                };
                QuestionSignaturePadModel.prototype.fromDataUrl = function(data) {
                    this.signaturePad.fromDataURL(data, {
                        width: this.canvas.width * this.scale,
                        height: this.canvas.height * this.scale
                    });
                };
                QuestionSignaturePadModel.prototype.fromUrl = function(url) {
                    var _this = this;
                    var img = new Image();
                    img.crossOrigin = "anonymous";
                    img.src = url;
                    img.onload = function() {
                        var ctx = _this.canvas.getContext("2d");
                        ctx.drawImage(img, 0, 0);
                        var dataURL = _this.canvas.toDataURL(_this.getFormat());
                        _this.fromDataUrl(dataURL);
                    };
                };
                QuestionSignaturePadModel.prototype.refreshCanvas = function() {
                    if (!this.canvas) return;
                    if (!this.value) {
                        this.canvas.getContext("2d").clearRect(0, 0, this.canvas.width * this.scale, this.canvas.height * this.scale);
                        this.signaturePad.clear();
                        this.valueWasChangedFromLastUpload = false;
                    } else if (this.storeDataAsText) this.fromDataUrl(this.value);
                    else this.fromUrl(this.value);
                };
                QuestionSignaturePadModel.prototype.initSignaturePad = function(el) {
                    var _this = this;
                    var canvas = el.getElementsByTagName("canvas")[0];
                    this.canvas = canvas;
                    this.resizeCanvas();
                    var signaturePad = new signature_pad__WEBPACK_IMPORTED_MODULE_2__["default"](canvas, {
                        backgroundColor: "#ffffff"
                    });
                    this.signaturePad = signaturePad;
                    if (this.isInputReadOnly) signaturePad.off();
                    this.readOnlyChangedCallback = function() {
                        if (_this.isInputReadOnly) signaturePad.off();
                        else signaturePad.on();
                    };
                    this.updateColors(signaturePad);
                    signaturePad.addEventListener("beginStroke", function() {
                        _this.scaleCanvas();
                        _this.isDrawingValue = true;
                        canvas.focus();
                    }, {
                        once: false
                    });
                    signaturePad.addEventListener("endStroke", function() {
                        _this.isDrawingValue = false;
                        if (_this.storeDataAsText) _this.updateValue();
                        else _this.valueWasChangedFromLastUpload = true;
                    }, {
                        once: false
                    });
                    this.updateValueHandler();
                    this.readOnlyChangedCallback();
                    var propertyChangedHandler = function(sender, options) {
                        if (options.name === "signatureWidth" || options.name === "signatureHeight" || options.name === "value") {
                            if (!_this.valueIsUpdatingInternally) _this.updateValueHandler();
                        }
                    };
                    this.onPropertyChanged.add(propertyChangedHandler);
                    this.signaturePad.propertyChangedHandler = propertyChangedHandler;
                };
                QuestionSignaturePadModel.prototype.destroySignaturePad = function(el) {
                    if (this.signaturePad) {
                        this.onPropertyChanged.remove(this.signaturePad.propertyChangedHandler);
                        this.signaturePad.off();
                    }
                    this.readOnlyChangedCallback = null;
                    this.signaturePad = null;
                };
                Object.defineProperty(QuestionSignaturePadModel.prototype, "dataFormat", {
                    /**
         * Specifies the format in which to store the signature image.
         *
         * Possible values:
         *
         * - `"png"` (default)
         * - `"jpeg"`
         * - `"svg"`
         */ get: function() {
                        return this.getPropertyValue("dataFormat");
                    },
                    set: function(val1) {
                        this.setPropertyValue("dataFormat", correctFormatData(val1));
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "signatureWidth", {
                    /**
         * Specifies the width of the signature area. Accepts positive integer numbers.
         */ get: function() {
                        return this.getPropertyValue("signatureWidth");
                    },
                    set: function(val1) {
                        this.setPropertyValue("signatureWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "signatureHeight", {
                    /**
         * Specifies the height of the signature area. Accepts positive integer numbers.
         */ get: function() {
                        return this.getPropertyValue("signatureHeight");
                    },
                    set: function(val1) {
                        this.setPropertyValue("signatureHeight", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "containerHeight", {
                    get: function() {
                        return this.signatureHeight || defaultHeight;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "containerWidth", {
                    get: function() {
                        return this.signatureWidth || defaultWidth;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "renderedCanvasWidth", {
                    get: function() {
                        return this.signatureAutoScaleEnabled ? "100%" : this.containerWidth + "px";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "height", {
                    //todo: need to remove this property
                    get: function() {
                        return this.getPropertyValue("height");
                    },
                    set: function(val1) {
                        this.setPropertyValue("height", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "allowClear", {
                    /**
         * Specifies whether to display a button that clears the signature area.
         *
         * Default value: `true`
         */ get: function() {
                        return this.getPropertyValue("allowClear");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowClear", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "canShowClearButton", {
                    get: function() {
                        var hasSignature = !this.nothingIsDrawn();
                        var isUploading = this.isUploading;
                        return !this.isInputReadOnly && this.allowClear && hasSignature && !isUploading;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "penColor", {
                    /**
         * Specifies a color for the pen.
         *
         * This property accepts color values in the following formats:
         *
         * - Hexadecimal colors (`"#FF0000"`)
         * - RGB colors (`"rgb(255,0,0)"`)
         * - Color names (`"red"`)
         * @see backgroundColor
         */ get: function() {
                        return this.getPropertyValue("penColor");
                    },
                    set: function(val1) {
                        this.setPropertyValue("penColor", val1);
                        !!this.signaturePad && this.updateColors(this.signaturePad);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "backgroundColor", {
                    /**
         * Specifies a color for the signature area background. Ignored if [`backgroundImage`](#backgroundImage) is set.
         *
         * This property accepts color values in the following formats:
         *
         * - Hexadecimal colors (`"#FF0000"`)
         * - RGB colors (`"rgb(255,0,0)"`)
         * - Color names (`"red"`)
         * @see penColor
         */ get: function() {
                        return this.getPropertyValue("backgroundColor");
                    },
                    set: function(val1) {
                        this.setPropertyValue("backgroundColor", val1);
                        !!this.signaturePad && this.updateColors(this.signaturePad);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "backgroundImage", {
                    /**
         * An image to display in the background of the signature area. Accepts a base64 or URL string value.
         * @see backgroundColor
         */ get: function() {
                        return this.getPropertyValue("backgroundImage");
                    },
                    set: function(val1) {
                        this.setPropertyValue("backgroundImage", val1);
                        !!this.signaturePad && this.updateColors(this.signaturePad);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionSignaturePadModel.prototype, "clearButtonCaption", {
                    get: function() {
                        return this.getLocalizationString("clearCaption");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionSignaturePadModel.prototype.nothingIsDrawn = function() {
                    var isDrawing = this.isDrawingValue;
                    var isEmpty = this.isEmpty();
                    var isUploading = this.isUploading;
                    var valueWasChangedFromLastUpload = this.valueWasChangedFromLastUpload;
                    return !isDrawing && isEmpty && !isUploading && !valueWasChangedFromLastUpload;
                };
                QuestionSignaturePadModel.prototype.needShowPlaceholder = function() {
                    return this.showPlaceholder && this.nothingIsDrawn();
                };
                QuestionSignaturePadModel.prototype.uploadResultItemToValue = function(r) {
                    return r.content;
                };
                QuestionSignaturePadModel.prototype.setValueFromResult = function(arg) {
                    this.valueIsUpdatingInternally = true;
                    this.value = (arg === null || arg === void 0 ? void 0 : arg.length) ? arg.map(function(r) {
                        return r.content;
                    })[0] : undefined;
                    this.valueIsUpdatingInternally = false;
                };
                QuestionSignaturePadModel.prototype.clearValue = function() {
                    this.valueWasChangedFromLastUpload = false;
                    _super.prototype.clearValue.call(this);
                    this.refreshCanvas();
                };
                QuestionSignaturePadModel.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    //todo: need to remove this code
                    if (this.signatureWidth === 300 && !!this.width && typeof this.width === "number" && this.width) {
                        _console_warnings__WEBPACK_IMPORTED_MODULE_4__["ConsoleWarnings"].warn("Use signatureWidth property to set width for the signature pad");
                        this.signatureWidth = this.width;
                        this.width = undefined;
                    }
                    if (this.signatureHeight === 200 && !!this.height) {
                        _console_warnings__WEBPACK_IMPORTED_MODULE_4__["ConsoleWarnings"].warn("Use signatureHeight property to set width for the signature pad");
                        this.signatureHeight = this.height;
                        this.height = undefined;
                    }
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], QuestionSignaturePadModel.prototype, "isDrawingValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], QuestionSignaturePadModel.prototype, "isReadyForUpload", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], QuestionSignaturePadModel.prototype, "valueWasChangedFromLastUpload", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionSignaturePadModel.prototype, "signatureAutoScaleEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionSignaturePadModel.prototype, "penMinWidth", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionSignaturePadModel.prototype, "penMaxWidth", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], QuestionSignaturePadModel.prototype, "showPlaceholder", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        localizable: {
                            defaultStr: "signaturePlaceHolder"
                        }
                    })
                ], QuestionSignaturePadModel.prototype, "placeholder", void 0);
                return QuestionSignaturePadModel;
            }(_question_file__WEBPACK_IMPORTED_MODULE_5__["QuestionFileModelBase"]);
            function correctFormatData(val1) {
                if (!val1) val1 = "png";
                val1 = val1.replace("image/", "").replace("+xml", "");
                if (val1 !== "jpeg" && val1 !== "svg") val1 = "png";
                return val1;
            }
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("signaturepad", [
                {
                    name: "signatureWidth:number",
                    category: "general",
                    default: 300
                },
                {
                    name: "signatureHeight:number",
                    category: "general",
                    default: 200
                },
                {
                    name: "signatureAutoScaleEnabled:boolean",
                    category: "general",
                    default: false
                },
                {
                    name: "penMinWidth:number",
                    category: "general",
                    default: 0.5
                },
                {
                    name: "penMaxWidth:number",
                    category: "general",
                    default: 2.5
                },
                //need to remove this property
                {
                    name: "height:number",
                    category: "general",
                    visible: false
                },
                {
                    name: "allowClear:boolean",
                    category: "general",
                    default: true
                },
                {
                    name: "showPlaceholder:boolean",
                    category: "general",
                    default: true
                },
                {
                    name: "placeholder:text",
                    serializationProperty: "locPlaceholder",
                    category: "general",
                    dependsOn: "showPlaceholder",
                    visibleIf: function(obj) {
                        return obj.showPlaceholder;
                    }
                },
                {
                    name: "backgroundImage:file",
                    category: "general"
                },
                {
                    name: "penColor:color",
                    category: "general"
                },
                {
                    name: "backgroundColor:color",
                    category: "general"
                },
                {
                    name: "dataFormat",
                    category: "general",
                    default: "png",
                    choices: [
                        {
                            value: "png",
                            text: "PNG"
                        },
                        {
                            value: "image/jpeg",
                            text: "JPEG"
                        },
                        {
                            value: "image/svg+xml",
                            text: "SVG"
                        }
                    ],
                    onSettingValue: function(obj, val1) {
                        return correctFormatData(val1);
                    }
                },
                {
                    name: "defaultValue",
                    visible: false
                },
                {
                    name: "correctAnswer",
                    visible: false
                },
                {
                    name: "storeDataAsText:boolean",
                    default: true
                },
                {
                    name: "waitForUpload:boolean",
                    default: false
                }
            ], function() {
                return new QuestionSignaturePadModel("");
            }, "question");
            _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].Instance.registerQuestion("signaturepad", function(name) {
                return new QuestionSignaturePadModel(name);
            });
        /***/ },
        /***/ "./src/question_tagbox.ts": /*!********************************!*\
  !*** ./src/question_tagbox.ts ***!
  \********************************/ /*! exports provided: QuestionTagboxModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionTagboxModel", function() {
                return QuestionTagboxModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _question_checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./question_checkbox */ "./src/question_checkbox.ts");
            /* harmony import */ var _dropdownMultiSelectListModel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./dropdownMultiSelectListModel */ "./src/dropdownMultiSelectListModel.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A class that describes the Multi-Select Dropdown (Tag Box) question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/how-to-create-multiselect-tag-box/ (linkStyle))
 */ var QuestionTagboxModel = /** @class */ function(_super) {
                __extends(QuestionTagboxModel, _super);
                function QuestionTagboxModel(name) {
                    var _this = _super.call(this, name) || this;
                    _this.itemDisplayNameMap = {};
                    _this.onOpened = _this.addEvent();
                    _this.createLocalizableString("placeholder", _this, false, true);
                    _this.createLocalizableString("clearCaption", _this, false, true);
                    _this.createLocalizableString("readOnlyText", _this, true);
                    _this.registerPropertyChangedHandlers([
                        "value",
                        "renderAs",
                        "showOtherItem",
                        "otherText",
                        "placeholder",
                        "choices",
                        "visibleChoices"
                    ], function() {
                        _this.updateReadOnlyText();
                    });
                    _this.updateReadOnlyText();
                    return _this;
                }
                QuestionTagboxModel.prototype.locStrsChanged = function() {
                    var _a;
                    _super.prototype.locStrsChanged.call(this);
                    this.updateReadOnlyText();
                    (_a = this.dropdownListModel) === null || _a === void 0 || _a.locStrsChanged();
                };
                QuestionTagboxModel.prototype.updateReadOnlyText = function() {
                    this.readOnlyText = this.displayValue || this.placeholder;
                };
                QuestionTagboxModel.prototype.getDefaultItemComponent = function() {
                    return "";
                };
                QuestionTagboxModel.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    if (!this.dropdownListModel) this.dropdownListModel = new _dropdownMultiSelectListModel__WEBPACK_IMPORTED_MODULE_4__["DropdownMultiSelectListModel"](this);
                };
                Object.defineProperty(QuestionTagboxModel.prototype, "placeholder", {
                    /**
         * A text displayed in the input field when it doesn't have a value.
         */ get: function() {
                        return this.getLocalizableStringText("placeholder");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("placeholder", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTagboxModel.prototype, "locPlaceholder", {
                    get: function() {
                        return this.getLocalizableString("placeholder");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTagboxModel.prototype, "clearCaption", {
                    get: function() {
                        return this.getLocalizableStringText("clearCaption");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("clearCaption", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTagboxModel.prototype, "locClearCaption", {
                    get: function() {
                        return this.getLocalizableString("clearCaption");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTagboxModel.prototype, "readOnlyText", {
                    get: function() {
                        return this.getLocalizableStringText("readOnlyText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("readOnlyText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTagboxModel.prototype, "locReadOnlyText", {
                    get: function() {
                        return this.getLocalizableString("readOnlyText");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTagboxModel.prototype.getType = function() {
                    return "tagbox";
                };
                Object.defineProperty(QuestionTagboxModel.prototype, "ariaRole", {
                    get: function() {
                        return "combobox";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTagboxModel.prototype, "popupModel", {
                    get: function() {
                        var _a;
                        return (_a = this.dropdownListModel) === null || _a === void 0 ? void 0 : _a.popupModel;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTagboxModel.prototype, "ariaExpanded", {
                    get: function() {
                        var popupModel = this.popupModel;
                        return !!popupModel && popupModel.isVisible ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTagboxModel.prototype.getControlClass = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append(this.cssClasses.control).append(this.cssClasses.controlEmpty, this.isEmpty()).append(this.cssClasses.onError, this.hasCssError()).append(this.cssClasses.controlDisabled, this.isReadOnly).toString();
                };
                QuestionTagboxModel.prototype.onOpenedCallBack = function() {
                    this.onOpened.fire(this, {
                        question: this,
                        choices: this.choices
                    });
                };
                QuestionTagboxModel.prototype.hasUnknownValue = function(val1, includeOther, isFilteredChoices, checkEmptyValue) {
                    if (this.choicesLazyLoadEnabled) return false;
                    return _super.prototype.hasUnknownValue.call(this, val1, includeOther, isFilteredChoices, checkEmptyValue);
                };
                QuestionTagboxModel.prototype.needConvertRenderedOtherToDataValue = function() {
                    var _a;
                    var val1 = (_a = this.otherValue) === null || _a === void 0 ? void 0 : _a.trim();
                    if (!val1) return false;
                    return _super.prototype.hasUnknownValue.call(this, val1, true, false);
                };
                QuestionTagboxModel.prototype.onVisibleChoicesChanged = function() {
                    _super.prototype.onVisibleChoicesChanged.call(this);
                    if (this.popupModel) this.dropdownListModel.updateItems();
                };
                QuestionTagboxModel.prototype.getItemIfChoicesNotContainThisValue = function(value, text) {
                    var _a;
                    if (this.choicesLazyLoadEnabled && !((_a = this.dropdownListModel) === null || _a === void 0 ? void 0 : _a.isAllDataLoaded)) return this.createItemValue(value, text);
                    else return _super.prototype.getItemIfChoicesNotContainThisValue.call(this, value, text);
                };
                QuestionTagboxModel.prototype.validateItemValues = function(itemValues) {
                    var _this = this;
                    this.updateItemDisplayNameMap();
                    var val1 = this.renderedValue;
                    if (!!itemValues.length && itemValues.length === val1.length) return itemValues;
                    var selectedItemValues = this.selectedItemValues;
                    if (!itemValues.length && !!selectedItemValues && !!selectedItemValues.length) {
                        this.defaultSelectedItemValues = [].concat(selectedItemValues);
                        return selectedItemValues;
                    }
                    var itemValueValues = itemValues.map(function(iV) {
                        return iV.value;
                    });
                    val1.filter(function(item) {
                        return itemValueValues.indexOf(item) === -1;
                    }).forEach(function(item) {
                        var newItem = _this.getItemIfChoicesNotContainThisValue(item, _this.itemDisplayNameMap[item]);
                        if (newItem) itemValues.push(newItem);
                    });
                    itemValues.sort(function(a, b) {
                        return val1.indexOf(a.value) - val1.indexOf(b.value);
                    });
                    return itemValues;
                };
                QuestionTagboxModel.prototype.updateItemDisplayNameMap = function() {
                    var _this = this;
                    var func = function(item) {
                        _this.itemDisplayNameMap[item.value] = item.text;
                    };
                    (this.defaultSelectedItemValues || []).forEach(func);
                    (this.selectedItemValues || []).forEach(func);
                    this.visibleChoices.forEach(func);
                };
                QuestionTagboxModel.prototype.getFirstInputElementId = function() {
                    return this.inputId + (this.searchEnabled ? "_0" : "");
                };
                QuestionTagboxModel.prototype.getInputId = function() {
                    return this.inputId + "_0";
                };
                QuestionTagboxModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (!!this.dropdownListModel) this.dropdownListModel.dispose();
                };
                QuestionTagboxModel.prototype.clearValue = function() {
                    var _a;
                    _super.prototype.clearValue.call(this);
                    (_a = this.dropdownListModel) === null || _a === void 0 || _a.clear();
                };
                Object.defineProperty(QuestionTagboxModel.prototype, "showClearButton", {
                    get: function() {
                        return this.allowClear && !this.isEmpty() && (!this.isDesignMode || _settings__WEBPACK_IMPORTED_MODULE_5__["settings"].supportCreatorV2);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTagboxModel.prototype, "isNewA11yStructure", {
                    //a11y
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionTagboxModel.prototype, "searchMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionTagboxModel.prototype, "allowClear", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        onSet: function(newValue, target) {
                            if (!!target.dropdownListModel) target.dropdownListModel.setSearchEnabled(newValue);
                        }
                    })
                ], QuestionTagboxModel.prototype, "searchEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        onSet: function(newValue, target) {
                            if (!!target.dropdownListModel) target.dropdownListModel.setHideSelectedItems(newValue);
                        }
                    })
                ], QuestionTagboxModel.prototype, "hideSelectedItems", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionTagboxModel.prototype, "choicesLazyLoadEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionTagboxModel.prototype, "choicesLazyLoadPageSize", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        getDefaultValue: function() {
                            return _settings__WEBPACK_IMPORTED_MODULE_5__["settings"].tagboxCloseOnSelect;
                        }
                    })
                ], QuestionTagboxModel.prototype, "closeOnSelect", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], QuestionTagboxModel.prototype, "textWrapEnabled", void 0);
                return QuestionTagboxModel;
            }(_question_checkbox__WEBPACK_IMPORTED_MODULE_3__["QuestionCheckboxModel"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].addClass("tagbox", [
                {
                    name: "placeholder",
                    serializationProperty: "locPlaceholder"
                },
                {
                    name: "allowClear:boolean",
                    default: true
                },
                {
                    name: "searchEnabled:boolean",
                    default: true
                },
                {
                    name: "textWrapEnabled:boolean",
                    default: true
                },
                {
                    name: "choicesLazyLoadEnabled:boolean",
                    default: false,
                    visible: false
                },
                {
                    name: "choicesLazyLoadPageSize:number",
                    default: 25,
                    visible: false
                },
                {
                    name: "hideSelectedItems:boolean",
                    default: false
                },
                {
                    name: "closeOnSelect:boolean"
                },
                {
                    name: "itemComponent",
                    visible: false,
                    default: ""
                },
                {
                    name: "searchMode",
                    default: "contains",
                    choices: [
                        "contains",
                        "startsWith"
                    ]
                }
            ], function() {
                return new QuestionTagboxModel("");
            }, "checkbox");
            _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].Instance.registerQuestion("tagbox", function(name) {
                var q = new QuestionTagboxModel(name);
                q.choices = _questionfactory__WEBPACK_IMPORTED_MODULE_1__["QuestionFactory"].DefaultChoices;
                return q;
            });
        /***/ },
        /***/ "./src/question_text.ts": /*!******************************!*\
  !*** ./src/question_text.ts ***!
  \******************************/ /*! exports provided: QuestionTextModel, isMinMaxType */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionTextModel", function() {
                return QuestionTextModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMinMaxType", function() {
                return isMinMaxType;
            });
            /* harmony import */ var _questionfactory__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./questionfactory */ "./src/questionfactory.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _validator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./validator */ "./src/validator.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _question_textbase__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./question_textbase */ "./src/question_textbase.ts");
            /* harmony import */ var _mask_input_element_adapter__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./mask/input_element_adapter */ "./src/mask/input_element_adapter.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A class that describes the Single-Line Input question type.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/questiontype-text/ (linkStyle))
 */ var QuestionTextModel = /** @class */ function(_super) {
                __extends(QuestionTextModel, _super);
                function QuestionTextModel(name) {
                    var _this = _super.call(this, name) || this;
                    //web-based methods
                    _this._isWaitingForEnter = false;
                    _this.onCompositionUpdate = function(event1) {
                        if (_this.isInputTextUpdate) setTimeout(function() {
                            _this.updateValueOnEvent(event1);
                        }, 1);
                        _this.updateRemainingCharacterCounter(event1.target.value);
                    };
                    _this.onKeyUp = function(event1) {
                        if (_this.isInputTextUpdate) {
                            if (!_this._isWaitingForEnter || event1.keyCode === 13) {
                                _this.updateValueOnEvent(event1);
                                _this._isWaitingForEnter = false;
                            }
                        } else if (event1.keyCode === 13) _this.updateValueOnEvent(event1);
                        _this.updateRemainingCharacterCounter(event1.target.value);
                    };
                    _this.onKeyDown = function(event1) {
                        _this.onKeyDownPreprocess && _this.onKeyDownPreprocess(event1);
                        if (_this.isInputTextUpdate) _this._isWaitingForEnter = event1.keyCode === 229;
                        _this.onTextKeyDownHandler(event1);
                    };
                    _this.onChange = function(event1) {
                        var elementIsFocused = event1.target === _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].environment.root.activeElement;
                        if (elementIsFocused) {
                            if (_this.isInputTextUpdate) _this.updateValueOnEvent(event1);
                        } else _this.updateValueOnEvent(event1);
                        _this.updateRemainingCharacterCounter(event1.target.value);
                    };
                    _this.onBlur = function(event1) {
                        _this.updateValueOnEvent(event1);
                        _this.updateRemainingCharacterCounter(event1.target.value);
                    };
                    _this.onFocus = function(event1) {
                        _this.updateRemainingCharacterCounter(event1.target.value);
                    };
                    _this.createLocalizableString("minErrorText", _this, true, "minError");
                    _this.createLocalizableString("maxErrorText", _this, true, "maxError");
                    _this.setNewMaskSettingsProperty();
                    _this.locDataListValue = new _localizablestring__WEBPACK_IMPORTED_MODULE_2__["LocalizableStrings"](_this);
                    _this.locDataListValue.onValueChanged = function(oldValue, newValue) {
                        _this.propertyValueChanged("dataList", oldValue, newValue);
                    };
                    _this.registerPropertyChangedHandlers([
                        "min",
                        "max",
                        "inputType",
                        "minValueExpression",
                        "maxValueExpression"
                    ], function() {
                        _this.setRenderedMinMax();
                    });
                    _this.registerPropertyChangedHandlers([
                        "inputType",
                        "size"
                    ], function() {
                        _this.updateInputSize();
                        _this.calcRenderedPlaceholder();
                    });
                    return _this;
                }
                QuestionTextModel.prototype.createMaskAdapter = function() {
                    if (!!this.input && !this.maskTypeIsEmpty) this.maskInputAdapter = new _mask_input_element_adapter__WEBPACK_IMPORTED_MODULE_8__["InputElementAdapter"](this.maskInstance, this.input, this.value);
                };
                QuestionTextModel.prototype.deleteMaskAdapter = function() {
                    if (this.maskInputAdapter) {
                        this.maskInputAdapter.dispose();
                        this.maskInputAdapter = undefined;
                    }
                };
                QuestionTextModel.prototype.updateMaskAdapter = function() {
                    this.deleteMaskAdapter();
                    this.createMaskAdapter();
                };
                QuestionTextModel.prototype.onSetMaskType = function(newValue) {
                    this.setNewMaskSettingsProperty();
                    this.updateMaskAdapter();
                };
                Object.defineProperty(QuestionTextModel.prototype, "maskTypeIsEmpty", {
                    get: function() {
                        return this.maskType === "none";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "maskSettings", {
                    /**
         * An object with properties that configure the mask applied to the input.
         *
         * Available properties depend on the specified [`maskType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#maskType) and belong to corresponding classes. Refer to the class APIs for a full list of properties:
         *
         * | `maskType` | Class |
         * | ---------- | ----- |
         * | `"numeric"` | [`InputMaskNumeric`](https://surveyjs.io/form-library/documentation/api-reference/inputmasknumeric) |
         * | `"currency"` | [`InputMaskCurrency`](https://surveyjs.io/form-library/documentation/api-reference/inputmaskcurrency) |
         * | `"datetime"` | [`InputMaskDateTime`](https://surveyjs.io/form-library/documentation/api-reference/inputmaskdatetime) |
         * | `"pattern"` | [`InputMaskPattern`](https://surveyjs.io/form-library/documentation/api-reference/inputmaskpattern) |
         *
         * [View Demo](https://surveyjs.io/form-library/examples/masked-input-fields/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("maskSettings");
                    },
                    set: function(val1) {
                        if (!val1) return;
                        this.setNewMaskSettingsProperty();
                        this.maskSettings.fromJSON(val1.toJSON());
                        this.updateMaskAdapter();
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextModel.prototype.setNewMaskSettingsProperty = function() {
                    this.setPropertyValue("maskSettings", this.createMaskSettings());
                };
                QuestionTextModel.prototype.createMaskSettings = function() {
                    var maskClassName = !this.maskType || this.maskType === "none" ? "masksettings" : this.maskType + "mask";
                    if (!_jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].findClass(maskClassName)) maskClassName = "masksettings";
                    var inputMask = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass(maskClassName);
                    return inputMask;
                };
                QuestionTextModel.prototype.isTextValue = function() {
                    return [
                        "text",
                        "number",
                        "password"
                    ].indexOf(this.inputType) > -1;
                };
                QuestionTextModel.prototype.getType = function() {
                    return "text";
                };
                QuestionTextModel.prototype.onSurveyLoad = function() {
                    _super.prototype.onSurveyLoad.call(this);
                    this.setRenderedMinMax();
                    this.updateInputSize();
                };
                Object.defineProperty(QuestionTextModel.prototype, "inputType", {
                    /**
         * A value passed on to the [`type`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#input_types) attribute of the underlying `<input>` element.
         *
         * Default value: `"text"`
         */ get: function() {
                        return this.getPropertyValue("inputType");
                    },
                    set: function(val1) {
                        val1 = val1.toLowerCase();
                        if (val1 === "datetime_local" || val1 === "datetime") val1 = "datetime-local";
                        this.setPropertyValue("inputType", val1.toLowerCase());
                        if (!this.isLoadingFromJson) {
                            this.min = undefined;
                            this.max = undefined;
                            this.step = undefined;
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextModel.prototype.getMaxLength = function() {
                    if (!this.isTextInput) return null;
                    return _super.prototype.getMaxLength.call(this);
                };
                QuestionTextModel.prototype.runCondition = function(values, properties) {
                    _super.prototype.runCondition.call(this, values, properties);
                    if (!!this.minValueExpression || !!this.maxValueExpression) this.setRenderedMinMax(values, properties);
                };
                QuestionTextModel.prototype.isLayoutTypeSupported = function(layoutType) {
                    return true;
                };
                Object.defineProperty(QuestionTextModel.prototype, "size", {
                    /**
         * A value passed on to the [`size`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/size) attribute of the underlying `<input>` element.
         */ get: function() {
                        return this.getPropertyValue("size");
                    },
                    set: function(val1) {
                        this.setPropertyValue("size", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "isTextInput", {
                    get: function() {
                        return [
                            "text",
                            "search",
                            "tel",
                            "url",
                            "email",
                            "password"
                        ].indexOf(this.inputType) > -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "inputSize", {
                    get: function() {
                        return this.getPropertyValue("inputSize", 0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "renderedInputSize", {
                    get: function() {
                        return this.getPropertyValue("inputSize") || null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "inputWidth", {
                    get: function() {
                        return this.getPropertyValue("inputWidth");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextModel.prototype.updateInputSize = function() {
                    var size = this.isTextInput && this.size > 0 ? this.size : 0;
                    if (this.isTextInput && size < 1 && this.parent && !!this.parent["itemSize"]) size = this.parent["itemSize"];
                    this.setPropertyValue("inputSize", size);
                    this.setPropertyValue("inputWidth", size > 0 ? "auto" : "");
                };
                Object.defineProperty(QuestionTextModel.prototype, "autocomplete", {
                    /**
         * A value passed on to the [`autocomplete`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/autocomplete) attribute of the underlying `<input>` element.
         */ get: function() {
                        return this.getPropertyValue("autocomplete", null);
                    },
                    set: function(val1) {
                        this.setPropertyValue("autocomplete", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "min", {
                    /**
         * A value passed on to the [`min`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/min) attribute of the underlying `<input>` element.
         * @see minValueExpression
         */ get: function() {
                        return this.getPropertyValue("min");
                    },
                    set: function(val1) {
                        if (this.isValueExpression(val1)) {
                            this.minValueExpression = val1.substring(1);
                            return;
                        }
                        this.setPropertyValue("min", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "max", {
                    /**
         * A value passed on to the [`max`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/max) attribute of the underlying `<input>` element.
         * @see maxValueExpression
         */ get: function() {
                        return this.getPropertyValue("max");
                    },
                    set: function(val1) {
                        if (this.isValueExpression(val1)) {
                            this.maxValueExpression = val1.substring(1);
                            return;
                        }
                        this.setPropertyValue("max", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "minValueExpression", {
                    /**
         * The minimum value specified as an expression. For example, `"minValueExpression": "today(-1)"` sets the minimum value to yesterday.
         * @see min
         */ get: function() {
                        return this.getPropertyValue("minValueExpression", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("minValueExpression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "maxValueExpression", {
                    /**
         * The maximum value specified as an expression. For example, `"maxValueExpression": "today(1)"` sets the maximum value to tomorrow.
         * @see max
         */ get: function() {
                        return this.getPropertyValue("maxValueExpression", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxValueExpression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "renderedMin", {
                    get: function() {
                        return this.getPropertyValue("renderedMin");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "renderedMax", {
                    get: function() {
                        return this.getPropertyValue("renderedMax");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "minErrorText", {
                    /**
         * An error message to display when the question value is less than the minimum accepted value.
         * @see min
         * @see minValueExpression
         */ get: function() {
                        return this.getLocalizableStringText("minErrorText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("minErrorText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "locMinErrorText", {
                    get: function() {
                        return this.getLocalizableString("minErrorText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "maxErrorText", {
                    /**
         * An error message to display when the question value exceeds the maximum accepted value.
         * @see max
         * @see maxValueExpression
         */ get: function() {
                        return this.getLocalizableStringText("maxErrorText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("maxErrorText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "locMaxErrorText", {
                    get: function() {
                        return this.getLocalizableString("maxErrorText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "isMinMaxType", {
                    /**
         * Returns `true` if the specified `inputType` supports the `min` and `max` properties.
         * @see inputType
         * @see min
         * @see max
         */ get: function() {
                        return isMinMaxType(this);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "maskInstance", {
                    get: function() {
                        return this.maskSettings;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "inputValue", {
                    get: function() {
                        return this._inputValue;
                    },
                    set: function(val1) {
                        var value = val1;
                        this._inputValue = val1;
                        if (!this.maskTypeIsEmpty) {
                            value = this.maskInstance.getUnmaskedValue(val1);
                            this._inputValue = this.maskInstance.getMaskedValue(value);
                            if (!!value && this.maskSettings.saveMaskedValue) value = this.maskInstance.getMaskedValue(value);
                        }
                        this.value = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextModel.prototype.onChangeQuestionValue = function(newValue) {
                    _super.prototype.onChangeQuestionValue.call(this, newValue);
                    this.updateInputValue();
                };
                QuestionTextModel.prototype.updateInputValue = function() {
                    if (this.maskTypeIsEmpty) this._inputValue = this.value;
                    else if (this.maskSettings.saveMaskedValue) this._inputValue = !!this.value ? this.value : this.maskInstance.getMaskedValue("");
                    else this._inputValue = this.maskInstance.getMaskedValue(this.value);
                };
                QuestionTextModel.prototype.onCheckForErrors = function(errors, isOnValueChanged) {
                    var _this = this;
                    _super.prototype.onCheckForErrors.call(this, errors, isOnValueChanged);
                    if (isOnValueChanged) return;
                    if (this.isValueLessMin) {
                        var minError = new _error__WEBPACK_IMPORTED_MODULE_5__["CustomError"](this.getMinMaxErrorText(this.minErrorText, this.getCalculatedMinMax(this.renderedMin)), this);
                        minError.onUpdateErrorTextCallback = function(err) {
                            err.text = _this.getMinMaxErrorText(_this.minErrorText, _this.getCalculatedMinMax(_this.renderedMin));
                        };
                        errors.push(minError);
                    }
                    if (this.isValueGreaterMax) {
                        var maxError = new _error__WEBPACK_IMPORTED_MODULE_5__["CustomError"](this.getMinMaxErrorText(this.maxErrorText, this.getCalculatedMinMax(this.renderedMax)), this);
                        maxError.onUpdateErrorTextCallback = function(err) {
                            err.text = _this.getMinMaxErrorText(_this.maxErrorText, _this.getCalculatedMinMax(_this.renderedMax));
                        };
                        errors.push(maxError);
                    }
                    var valName = this.getValidatorTitle();
                    var emailValidator = new _validator__WEBPACK_IMPORTED_MODULE_4__["EmailValidator"]();
                    if (this.inputType === "email" && !this.validators.some(function(v) {
                        return v.getType() === "emailvalidator";
                    })) {
                        var validateResult = emailValidator.validate(this.value, valName);
                        if (!!validateResult && !!validateResult.error) errors.push(validateResult.error);
                    }
                };
                QuestionTextModel.prototype.canSetValueToSurvey = function() {
                    if (!this.isMinMaxType) return true;
                    var isValid = !this.isValueLessMin && !this.isValueGreaterMax;
                    if (this.inputType === "number" && !!this.survey && (this.survey.isValidateOnValueChanging || this.survey.isValidateOnValueChanged)) this.hasErrors();
                    return isValid;
                };
                QuestionTextModel.prototype.convertFuncValuetoQuestionValue = function(val1) {
                    return _helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].convertValToQuestionVal(val1, this.inputType);
                };
                QuestionTextModel.prototype.getMinMaxErrorText = function(errorText, value) {
                    if (_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isValueEmpty(value)) return errorText;
                    var errorValue = value.toString();
                    if (this.inputType === "date" && !!value.toDateString) errorValue = value.toDateString();
                    return errorText.replace("{0}", errorValue);
                };
                Object.defineProperty(QuestionTextModel.prototype, "isValueLessMin", {
                    get: function() {
                        return !this.isValueEmpty(this.renderedMin) && !this.isEmpty() && this.getCalculatedMinMax(this.value) < this.getCalculatedMinMax(this.renderedMin);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "isValueGreaterMax", {
                    get: function() {
                        return !this.isValueEmpty(this.renderedMax) && !this.isEmpty() && this.getCalculatedMinMax(this.value) > this.getCalculatedMinMax(this.renderedMax);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "isDateInputType", {
                    get: function() {
                        return this.inputType === "date" || this.inputType === "datetime-local";
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextModel.prototype.getCalculatedMinMax = function(minMax) {
                    if (this.isValueEmpty(minMax)) return minMax;
                    return this.isDateInputType ? new Date(minMax) : minMax;
                };
                QuestionTextModel.prototype.setRenderedMinMax = function(values, properties) {
                    var _this = this;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    this.minValueRunner = this.getDefaultRunner(this.minValueRunner, this.minValueExpression);
                    this.setValueAndRunExpression(this.minValueRunner, this.min, function(val1) {
                        if (!val1 && _this.isDateInputType && !!_settings__WEBPACK_IMPORTED_MODULE_6__["settings"].minDate) val1 = _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].minDate;
                        _this.setPropertyValue("renderedMin", val1);
                    }, values, properties);
                    this.maxValueRunner = this.getDefaultRunner(this.maxValueRunner, this.maxValueExpression);
                    this.setValueAndRunExpression(this.maxValueRunner, this.max, function(val1) {
                        if (!val1 && _this.isDateInputType) val1 = !!_settings__WEBPACK_IMPORTED_MODULE_6__["settings"].maxDate ? _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].maxDate : "2999-12-31";
                        _this.setPropertyValue("renderedMax", val1);
                    }, values, properties);
                };
                Object.defineProperty(QuestionTextModel.prototype, "step", {
                    /**
         * A value passed on to the [`step`](https://developer.mozilla.org/en-US/docs/Web/HTML/Attributes/step) attribute of the underlying `<input>` element.
         */ get: function() {
                        return this.getPropertyValue("step");
                    },
                    set: function(val1) {
                        this.setPropertyValue("step", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "renderedStep", {
                    get: function() {
                        if (this.isValueEmpty(this.step)) return this.inputType !== "number" ? undefined : "any";
                        return this.step;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextModel.prototype.supportGoNextPageAutomatic = function() {
                    return !this.isSurveyInputTextUpdate && [
                        "date",
                        "datetime-local"
                    ].indexOf(this.inputType) < 0;
                };
                QuestionTextModel.prototype.supportGoNextPageError = function() {
                    return [
                        "date",
                        "datetime-local"
                    ].indexOf(this.inputType) < 0;
                };
                Object.defineProperty(QuestionTextModel.prototype, "dataList", {
                    /**
         * An array of predefined options from which users can select. This property configures an HTML [`<datalist>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/datalist) element and associates it with the underlying `input` element.
         */ get: function() {
                        return this.locDataList.value;
                    },
                    set: function(val1) {
                        this.locDataList.value = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "locDataList", {
                    get: function() {
                        return this.locDataListValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextModel.prototype, "dataListId", {
                    get: function() {
                        return this.locDataList.hasValue() ? this.id + "_datalist" : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextModel.prototype.canRunValidators = function(isOnValueChanged) {
                    return this.errors.length > 0 || !isOnValueChanged || this.supportGoNextPageError();
                };
                QuestionTextModel.prototype.setNewValue = function(newValue) {
                    newValue = this.correctValueType(newValue);
                    _super.prototype.setNewValue.call(this, newValue);
                };
                QuestionTextModel.prototype.correctValueType = function(newValue) {
                    if (!newValue) return newValue;
                    if (this.inputType == "number" || this.inputType == "range") return _helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isNumber(newValue) ? _helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].getNumber(newValue) : "";
                    return newValue;
                };
                QuestionTextModel.prototype.hasPlaceholder = function() {
                    return !this.isReadOnly && this.inputType !== "range";
                };
                QuestionTextModel.prototype.getControlCssClassBuilder = function() {
                    var maxLength = this.getMaxLength();
                    return _super.prototype.getControlCssClassBuilder.call(this).append(this.cssClasses.constrolWithCharacterCounter, !!maxLength).append(this.cssClasses.characterCounterBig, maxLength > 99);
                };
                QuestionTextModel.prototype.isReadOnlyRenderDiv = function() {
                    return this.isReadOnly && _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].readOnly.textRenderMode === "div";
                };
                Object.defineProperty(QuestionTextModel.prototype, "inputStyle", {
                    get: function() {
                        var style = {};
                        style.width = this.inputWidth;
                        this.updateTextAlign(style);
                        return style;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextModel.prototype.updateTextAlign = function(style) {
                    if (this.inputTextAlignment !== "auto") style.textAlign = this.inputTextAlignment;
                    else if (this.maskType === "numeric" || this.maskType === "currency") style.textAlign = "right";
                };
                QuestionTextModel.prototype.updateValueOnEvent = function(event1) {
                    var newValue = event1.target.value;
                    if (!this.isTwoValueEquals(this.value, newValue)) this.inputValue = newValue;
                };
                QuestionTextModel.prototype.afterRenderQuestionElement = function(el) {
                    if (!!el) {
                        this.input = el instanceof HTMLInputElement ? el : el.querySelector("input");
                        this.createMaskAdapter();
                    }
                    _super.prototype.afterRenderQuestionElement.call(this, el);
                };
                QuestionTextModel.prototype.beforeDestroyQuestionElement = function(el) {
                    this.deleteMaskAdapter();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        onSet: function(newValue, target) {
                            target.onSetMaskType(newValue);
                        }
                    })
                ], QuestionTextModel.prototype, "maskType", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionTextModel.prototype, "inputTextAlignment", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], QuestionTextModel.prototype, "_inputValue", void 0);
                return QuestionTextModel;
            }(_question_textbase__WEBPACK_IMPORTED_MODULE_7__["QuestionTextBase"]);
            var minMaxTypes = [
                "number",
                "range",
                "date",
                "datetime-local",
                "month",
                "time",
                "week"
            ];
            function isMinMaxType(obj) {
                var t = !!obj ? obj.inputType : "";
                if (!t) return false;
                return minMaxTypes.indexOf(t) > -1;
            }
            function getWeekTimeNumber(str, delimiter) {
                var strs = str.split(delimiter);
                if (strs.length !== 2) return -1;
                if (!_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isNumber(strs[0]) || !_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isNumber(strs[1])) return -1;
                return parseFloat(strs[0]) * 60 + parseFloat(strs[1]);
            }
            function isMinBiggerWeekTime(minStr, maxStr, delimiter) {
                var min = getWeekTimeNumber(minStr, delimiter);
                var max = getWeekTimeNumber(maxStr, delimiter);
                if (min < 0 || max < 0) return false;
                return min > max;
            }
            function getCorrectMinMax(obj, min, max, isMax) {
                var val1 = isMax ? max : min;
                if (!isMinMaxType(obj)) return val1;
                if (_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isValueEmpty(min) || _helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isValueEmpty(max)) return val1;
                if (obj.inputType.indexOf("date") === 0 || obj.inputType === "month") {
                    var isMonth = obj.inputType === "month";
                    var dMin = new Date(isMonth ? min + "-1" : min);
                    var dMax = new Date(isMonth ? max + "-1" : max);
                    if (!dMin || !dMax) return val1;
                    if (dMin > dMax) return isMax ? min : max;
                }
                if (obj.inputType === "week" || obj.inputType === "time") {
                    var delimiter = obj.inputType === "week" ? "-W" : ":";
                    if (isMinBiggerWeekTime(min, max, delimiter)) return isMax ? min : max;
                    return val1;
                }
                if (obj.inputType === "number") {
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isNumber(min) || !_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isNumber(max)) return val1;
                    if (_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].getNumber(min) > _helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].getNumber(max)) return isMax ? min : max;
                }
                if (typeof min === "string" || typeof max === "string") return val1;
                if (min > max) return isMax ? min : max;
                return val1;
            }
            function propertyEditorMinMaxUpdate(obj, propertyEditor) {
                if (!!obj && !!obj.inputType) {
                    propertyEditor.inputType = obj.inputType !== "range" ? obj.inputType : "number";
                    propertyEditor.textUpdateMode = "onBlur";
                }
            }
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("text", [
                {
                    name: "inputType",
                    default: "text",
                    choices: _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].questions.inputTypes
                },
                {
                    name: "size:number",
                    minValue: 0,
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        if (!obj) return false;
                        return obj.isTextInput;
                    }
                },
                {
                    name: "textUpdateMode",
                    default: "default",
                    choices: [
                        "default",
                        "onBlur",
                        "onTyping"
                    ],
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        if (!obj) return false;
                        return obj.isTextInput;
                    }
                },
                {
                    name: "autocomplete",
                    alternativeName: "autoComplete",
                    choices: _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].questions.dataList
                },
                {
                    name: "min",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return isMinMaxType(obj);
                    },
                    onPropertyEditorUpdate: function(obj, propertyEditor) {
                        propertyEditorMinMaxUpdate(obj, propertyEditor);
                    },
                    onSettingValue: function(obj, val1) {
                        return getCorrectMinMax(obj, val1, obj.max, false);
                    }
                },
                {
                    name: "max",
                    dependsOn: "inputType",
                    nextToProperty: "*min",
                    visibleIf: function(obj) {
                        return isMinMaxType(obj);
                    },
                    onSettingValue: function(obj, val1) {
                        return getCorrectMinMax(obj, obj.min, val1, true);
                    },
                    onPropertyEditorUpdate: function(obj, propertyEditor) {
                        propertyEditorMinMaxUpdate(obj, propertyEditor);
                    }
                },
                {
                    name: "minValueExpression:expression",
                    category: "logic",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return isMinMaxType(obj);
                    }
                },
                {
                    name: "maxValueExpression:expression",
                    category: "logic",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return isMinMaxType(obj);
                    }
                },
                {
                    name: "minErrorText",
                    serializationProperty: "locMinErrorText",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return isMinMaxType(obj);
                    }
                },
                {
                    name: "maxErrorText",
                    serializationProperty: "locMaxErrorText",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return isMinMaxType(obj);
                    }
                },
                {
                    name: "inputTextAlignment",
                    default: "auto",
                    choices: [
                        "left",
                        "right",
                        "auto"
                    ],
                    visible: false
                },
                {
                    name: "maskType:masktype",
                    default: "none",
                    visibleIndex: 0,
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return obj.inputType === "text";
                    }
                },
                {
                    name: "maskSettings:masksettings",
                    className: "masksettings",
                    visibleIndex: 1,
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        return obj.inputType === "text";
                    },
                    onGetValue: function(obj) {
                        return obj.maskSettings.getData();
                    },
                    onSetValue: function(obj, value) {
                        obj.maskSettings.setData(value);
                    }
                },
                {
                    name: "step:number",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        if (!obj) return false;
                        return obj.inputType === "number" || obj.inputType === "range";
                    }
                },
                {
                    name: "maxLength:number",
                    default: -1,
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        if (!obj) return false;
                        return obj.isTextInput;
                    }
                },
                {
                    name: "placeholder",
                    alternativeName: "placeHolder",
                    serializationProperty: "locPlaceholder",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        if (!obj) return false;
                        return obj.isTextInput;
                    }
                },
                {
                    name: "dataList:string[]",
                    serializationProperty: "locDataList",
                    dependsOn: "inputType",
                    visibleIf: function(obj) {
                        if (!obj) return false;
                        return obj.inputType === "text";
                    }
                }
            ], function() {
                return new QuestionTextModel("");
            }, "textbase");
            _questionfactory__WEBPACK_IMPORTED_MODULE_0__["QuestionFactory"].Instance.registerQuestion("text", function(name) {
                return new QuestionTextModel(name);
            });
        /***/ },
        /***/ "./src/question_textbase.ts": /*!**********************************!*\
  !*** ./src/question_textbase.ts ***!
  \**********************************/ /*! exports provided: CharacterCounter, QuestionTextBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CharacterCounter", function() {
                return CharacterCounter;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionTextBase", function() {
                return QuestionTextBase;
            });
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var CharacterCounter = /** @class */ function(_super) {
                __extends(CharacterCounter, _super);
                function CharacterCounter() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                CharacterCounter.prototype.updateRemainingCharacterCounter = function(newValue, maxLength) {
                    this.remainingCharacterCounter = _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].getRemainingCharacterCounterText(newValue, maxLength);
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], CharacterCounter.prototype, "remainingCharacterCounter", void 0);
                return CharacterCounter;
            }(_base__WEBPACK_IMPORTED_MODULE_4__["Base"]);
            /**
 * A base class for the [Single-Line Input](https://surveyjs.io/form-library/documentation/questiontextmodel) and [Long Text](https://surveyjs.io/form-library/documentation/questioncommentmodel) question types.
 */ var QuestionTextBase = /** @class */ function(_super) {
                __extends(QuestionTextBase, _super);
                function QuestionTextBase(name) {
                    var _this = _super.call(this, name) || this;
                    _this.characterCounter = new CharacterCounter();
                    return _this;
                }
                QuestionTextBase.prototype.isTextValue = function() {
                    return true;
                };
                Object.defineProperty(QuestionTextBase.prototype, "maxLength", {
                    /**
         * The maximum text length measured in characters. Assign 0 if the length should be unlimited.
         *
         * Default value: -1 (inherits the actual value from the `SurveyModel`'s [`maxTextLength`](https://surveyjs.io/form-library/documentation/surveymodel#maxTextLength) property).
         */ get: function() {
                        return this.getPropertyValue("maxLength");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxLength", val1);
                        this.updateRemainingCharacterCounter(this.value);
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextBase.prototype.getMaxLength = function() {
                    return _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].getMaxLength(this.maxLength, this.survey ? this.survey.maxTextLength : -1);
                };
                QuestionTextBase.prototype.updateRemainingCharacterCounter = function(newValue) {
                    this.characterCounter.updateRemainingCharacterCounter(newValue, this.getMaxLength());
                };
                Object.defineProperty(QuestionTextBase.prototype, "placeHolder", {
                    get: function() {
                        return this.placeholder;
                    },
                    set: function(val1) {
                        this.placeholder = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextBase.prototype, "locPlaceHolder", {
                    get: function() {
                        return this.locPlaceholder;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextBase.prototype.getType = function() {
                    return "textbase";
                };
                QuestionTextBase.prototype.isEmpty = function() {
                    return _super.prototype.isEmpty.call(this) || this.value === "";
                };
                Object.defineProperty(QuestionTextBase.prototype, "textUpdateMode", {
                    /**
         * Specifies when to update the question value.
         *
         * Possible values:
         *
         * - `"onBlur"` - Updates the value after the input field loses focus.
         * - `"onTyping"` - Updates the value on every key press.
         * - `"default"` (default) - Inherits the value from the `SurveyModel`'s [`textUpdateMode`](https://surveyjs.io/form-library/documentation/surveymodel#textUpdateMode) property.
         *
         * > Do not use the `"onTyping"` mode if your survey contains many expressions. Expressions are reevaluated each time a question value is changed. In `"onTyping"` mode, the question value changes frequently. This may cause performance degradation.
         */ get: function() {
                        return this.getPropertyValue("textUpdateMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("textUpdateMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextBase.prototype, "isSurveyInputTextUpdate", {
                    get: function() {
                        if (this.textUpdateMode == "default") return !!this.survey ? this.survey.isUpdateValueTextOnTyping : false;
                        return this.textUpdateMode == "onTyping";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextBase.prototype, "renderedPlaceholder", {
                    get: function() {
                        return this.getPropertyValue("renderedPlaceholder");
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextBase.prototype.setRenderedPlaceholder = function(val1) {
                    this.setPropertyValue("renderedPlaceholder", val1);
                };
                QuestionTextBase.prototype.onReadOnlyChanged = function() {
                    _super.prototype.onReadOnlyChanged.call(this);
                    this.calcRenderedPlaceholder();
                };
                QuestionTextBase.prototype.onSurveyLoad = function() {
                    this.calcRenderedPlaceholder();
                    _super.prototype.onSurveyLoad.call(this);
                };
                QuestionTextBase.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    this.calcRenderedPlaceholder();
                };
                QuestionTextBase.prototype.setSurveyImpl = function(value, isLight) {
                    _super.prototype.setSurveyImpl.call(this, value, isLight);
                    this.calcRenderedPlaceholder();
                };
                QuestionTextBase.prototype.calcRenderedPlaceholder = function() {
                    var res = this.placeHolder;
                    if (!!res && !this.hasPlaceholder()) res = undefined;
                    this.setRenderedPlaceholder(res);
                };
                QuestionTextBase.prototype.hasPlaceholder = function() {
                    return !this.isReadOnly;
                };
                QuestionTextBase.prototype.setNewValue = function(newValue) {
                    _super.prototype.setNewValue.call(this, newValue);
                    this.updateRemainingCharacterCounter(newValue);
                };
                QuestionTextBase.prototype.setQuestionValue = function(newValue, updateIsAnswered) {
                    if (updateIsAnswered === void 0) updateIsAnswered = true;
                    _super.prototype.setQuestionValue.call(this, newValue, updateIsAnswered);
                    this.updateRemainingCharacterCounter(newValue);
                };
                QuestionTextBase.prototype.convertToCorrectValue = function(val1) {
                    if (Array.isArray(val1)) return val1.join(this.getValueSeparator());
                    return val1;
                };
                QuestionTextBase.prototype.getValueSeparator = function() {
                    return ", ";
                };
                QuestionTextBase.prototype.getControlCssClassBuilder = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.cssClasses.root).append(this.cssClasses.onError, this.hasCssError()).append(this.cssClasses.controlDisabled, this.isReadOnly);
                };
                QuestionTextBase.prototype.getControlClass = function() {
                    return this.getControlCssClassBuilder().toString();
                };
                Object.defineProperty(QuestionTextBase.prototype, "isNewA11yStructure", {
                    //a11y
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        localizable: true,
                        onSet: function(val1, target) {
                            return target.calcRenderedPlaceholder();
                        }
                    })
                ], QuestionTextBase.prototype, "placeholder", void 0);
                return QuestionTextBase;
            }(_question__WEBPACK_IMPORTED_MODULE_0__["Question"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("textbase", [], function() {
                return new QuestionTextBase("");
            }, "question");
        /***/ },
        /***/ "./src/questionfactory.ts": /*!********************************!*\
  !*** ./src/questionfactory.ts ***!
  \********************************/ /*! exports provided: QuestionFactory, ElementFactory */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionFactory", function() {
                return QuestionFactory;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementFactory", function() {
                return ElementFactory;
            });
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _question_custom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question_custom */ "./src/question_custom.ts");
            var QuestionFactory = /** @class */ function() {
                function QuestionFactory() {}
                Object.defineProperty(QuestionFactory, "DefaultChoices", {
                    get: function() {
                        return [
                            _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString("choices_Item") + "1",
                            _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString("choices_Item") + "2",
                            _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString("choices_Item") + "3"
                        ];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFactory, "DefaultColums", {
                    get: function() {
                        var colName = _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString("matrix_column") + " ";
                        return [
                            colName + "1",
                            colName + "2",
                            colName + "3"
                        ];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFactory, "DefaultRows", {
                    get: function() {
                        var rowName = _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString("matrix_row") + " ";
                        return [
                            rowName + "1",
                            rowName + "2"
                        ];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionFactory, "DefaultMutlipleTextItems", {
                    get: function() {
                        var itemName = _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString("multipletext_itemname");
                        return [
                            itemName + "1",
                            itemName + "2"
                        ];
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionFactory.prototype.registerQuestion = function(questionType, questionCreator) {
                    ElementFactory.Instance.registerElement(questionType, questionCreator);
                };
                QuestionFactory.prototype.registerCustomQuestion = function(questionType) {
                    ElementFactory.Instance.registerCustomQuestion(questionType);
                };
                QuestionFactory.prototype.unregisterElement = function(elementType, removeFromSerializer) {
                    if (removeFromSerializer === void 0) removeFromSerializer = false;
                    ElementFactory.Instance.unregisterElement(elementType, removeFromSerializer);
                };
                QuestionFactory.prototype.clear = function() {
                    ElementFactory.Instance.clear();
                };
                QuestionFactory.prototype.getAllTypes = function() {
                    return ElementFactory.Instance.getAllTypes();
                };
                QuestionFactory.prototype.createQuestion = function(questionType, name) {
                    return ElementFactory.Instance.createElement(questionType, name);
                };
                QuestionFactory.Instance = new QuestionFactory();
                return QuestionFactory;
            }();
            var ElementFactory = /** @class */ function() {
                function ElementFactory() {
                    var _this = this;
                    this.creatorHash = {};
                    this.registerCustomQuestion = function(questionType) {
                        var creator = function(name) {
                            var el = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass(questionType);
                            if (!!el) el.name = name;
                            return el;
                        };
                        _this.registerElement(questionType, creator);
                    };
                }
                ElementFactory.prototype.registerElement = function(elementType, elementCreator) {
                    this.creatorHash[elementType] = elementCreator;
                };
                ElementFactory.prototype.clear = function() {
                    this.creatorHash = {};
                };
                ElementFactory.prototype.unregisterElement = function(elementType, removeFromSerializer) {
                    if (removeFromSerializer === void 0) removeFromSerializer = false;
                    delete this.creatorHash[elementType];
                    if (removeFromSerializer) _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].removeClass(elementType);
                };
                ElementFactory.prototype.getAllTypes = function() {
                    var result = new Array();
                    for(var key in this.creatorHash)result.push(key);
                    return result.sort();
                };
                ElementFactory.prototype.createElement = function(elementType, name) {
                    var creator = this.creatorHash[elementType];
                    if (!!creator) return creator(name);
                    var compJSON = _question_custom__WEBPACK_IMPORTED_MODULE_2__["ComponentCollection"].Instance.getCustomQuestionByName(elementType);
                    if (!!compJSON) return _question_custom__WEBPACK_IMPORTED_MODULE_2__["ComponentCollection"].Instance.createQuestion(name, compJSON);
                    return null;
                };
                ElementFactory.Instance = new ElementFactory();
                return ElementFactory;
            }();
        /***/ },
        /***/ "./src/questionnonvalue.ts": /*!*********************************!*\
  !*** ./src/questionnonvalue.ts ***!
  \*********************************/ /*! exports provided: QuestionNonValue */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionNonValue", function() {
                return QuestionNonValue;
            });
            /* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./question */ "./src/question.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * A base class for question types that cannot have a value ([Html](https://surveyjs.io/form-library/documentation/questionhtmlmodel), [Image](https://surveyjs.io/form-library/documentation/questionimagemodel)).
 *
 * This class does not implement new functionality&mdash;it only redefines default values of certain properties inherited from the [`Question`](https://surveyjs.io/form-library/documentation/question) class.
 */ var QuestionNonValue = /** @class */ function(_super) {
                __extends(QuestionNonValue, _super);
                function QuestionNonValue(name) {
                    return _super.call(this, name) || this;
                }
                QuestionNonValue.prototype.getType = function() {
                    return "nonvalue";
                };
                Object.defineProperty(QuestionNonValue.prototype, "hasInput", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionNonValue.prototype, "hasTitle", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionNonValue.prototype.getTitleLocation = function() {
                    return "";
                };
                Object.defineProperty(QuestionNonValue.prototype, "hasComment", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionNonValue.prototype.hasErrors = function(fireCallback, rec) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (rec === void 0) rec = null;
                    return false;
                };
                QuestionNonValue.prototype.getAllErrors = function() {
                    return [];
                };
                QuestionNonValue.prototype.supportGoNextPageAutomatic = function() {
                    return false;
                };
                QuestionNonValue.prototype.addConditionObjectsByContext = function(objects, context) {};
                QuestionNonValue.prototype.getConditionJson = function(operator, path) {
                    if (operator === void 0) operator = null;
                    if (path === void 0) path = null;
                    return null;
                };
                Object.defineProperty(QuestionNonValue.prototype, "ariaRole", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionNonValue.prototype, "ariaRequired", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                return QuestionNonValue;
            }(_question__WEBPACK_IMPORTED_MODULE_0__["Question"]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("nonvalue", [
                {
                    name: "title",
                    visible: false
                },
                {
                    name: "description",
                    visible: false
                },
                {
                    name: "valueName",
                    visible: false
                },
                {
                    name: "enableIf",
                    visible: false
                },
                {
                    name: "defaultValue",
                    visible: false
                },
                {
                    name: "correctAnswer",
                    visible: false
                },
                {
                    name: "clearIfInvisible",
                    visible: false
                },
                {
                    name: "isRequired",
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "requiredErrorText",
                    visible: false
                },
                {
                    name: "readOnly",
                    visible: false
                },
                {
                    name: "requiredIf",
                    visible: false
                },
                {
                    name: "validators",
                    visible: false
                },
                {
                    name: "titleLocation",
                    visible: false
                },
                {
                    name: "showCommentArea",
                    visible: false
                },
                {
                    name: "useDisplayValuesInDynamicTexts",
                    alternativeName: "useDisplayValuesInTitle",
                    visible: false
                }
            ], function() {
                return new QuestionNonValue("");
            }, "question");
        /***/ },
        /***/ "./src/rendererFactory.ts": /*!********************************!*\
  !*** ./src/rendererFactory.ts ***!
  \********************************/ /*! exports provided: RendererFactory */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RendererFactory", function() {
                return RendererFactory;
            });
            var RendererFactory = /** @class */ function() {
                function RendererFactory() {
                    this.renderersHash = {};
                }
                RendererFactory.prototype.unregisterRenderer = function(questionType, rendererAs) {
                    delete this.renderersHash[questionType][rendererAs];
                };
                RendererFactory.prototype.registerRenderer = function(questionType, renderAs, renderer) {
                    if (!this.renderersHash[questionType]) this.renderersHash[questionType] = {};
                    this.renderersHash[questionType][renderAs] = renderer;
                };
                RendererFactory.prototype.getRenderer = function(questionType, renderAs) {
                    return this.renderersHash[questionType] && this.renderersHash[questionType][renderAs] || "default";
                };
                RendererFactory.prototype.getRendererByQuestion = function(question) {
                    return this.getRenderer(question.getType(), question.renderAs);
                };
                RendererFactory.prototype.clear = function() {
                    this.renderersHash = {};
                };
                RendererFactory.Instance = new RendererFactory();
                return RendererFactory;
            }();
        /***/ },
        /***/ "./src/settings.ts": /*!*************************!*\
  !*** ./src/settings.ts ***!
  \*************************/ /*! exports provided: settings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settings", function() {
                return settings;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            var document1 = typeof globalThis !== "undefined" ? globalThis.document : undefined.document;
            var defaultEnvironment = !!document1 ? {
                root: document1,
                _rootElement: _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody(),
                get rootElement () {
                    var _a;
                    return (_a = this._rootElement) !== null && _a !== void 0 ? _a : _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody();
                },
                set rootElement (rootElement){
                    this._rootElement = rootElement;
                },
                _popupMountContainer: _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody(),
                get popupMountContainer () {
                    var _a1;
                    return (_a1 = this._popupMountContainer) !== null && _a1 !== void 0 ? _a1 : _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody();
                },
                set popupMountContainer (popupMountContainer){
                    this._popupMountContainer = popupMountContainer;
                },
                svgMountContainer: document1.head,
                stylesSheetsMountContainer: document1.head
            } : undefined;
            var columnWidthsByType = {
                "file": {
                    minWidth: "240px"
                },
                "comment": {
                    minWidth: "200px"
                }
            };
            /**
 * Global settings that apply to all surveys on the page. To specify one of the settings, use the code below:
 *
 * ```js
 * import { settings } from "survey-core";
 *
 * settings.settingName = "value";
 * ```
 */ var settings = {
                /**
     * An object that configures survey appearance when the survey is being designed in Survey Creator.
     *
     * Nested properties:
     *
     * - `showEmptyDescriptions`: `boolean`\
     * Specifies whether to display an empty description for pages and panels. Default value: `true`.
     *
     * - `showEmptyTitles`: `boolean`\
     * Specifies whether to display an empty title for pages and panels. Default value: `true`.
     */ designMode: {
                    showEmptyDescriptions: true,
                    showEmptyTitles: true
                },
                //#region designMode section, Obsolete properties
                get allowShowEmptyDescriptionInDesignMode () {
                    return this.designMode.showEmptyDescriptions;
                },
                set allowShowEmptyDescriptionInDesignMode (val){
                    this.designMode.showEmptyDescriptions = val;
                },
                get allowShowEmptyTitleInDesignMode () {
                    return this.designMode.showEmptyTitles;
                },
                set allowShowEmptyTitleInDesignMode (val){
                    this.designMode.showEmptyTitles = val;
                },
                //#endregion
                /**
     * An object that contains properties related to localization.
     *
     * Nested properties:
     *
     * - `useLocalTimeZone`: `boolean`\
     * Disable this property if you want internal SurveyJS functions to use methods that work with UTC date and time (`setUTCDate()` `setUTCHours()`, etc.) instead of methods that work with local date and time (`setYear()`, `setHours()`, etc.). Default value: `true`.
     *
     * - `defaultLocaleName`: `string`\
     * A property key that stores a translation for the default locale. Default value: `"default"`.
     *
     * - `storeDuplicatedTranslations`: `boolean`\
     * Specifies whether surveys should store translation strings that equal the translation strings in the default locale. Default value: `false`.
     */ localization: {
                    useLocalTimeZone: true,
                    storeDuplicatedTranslations: false,
                    defaultLocaleName: "default"
                },
                //#region localization section, obsolete properties
                get useLocalTimeZone () {
                    return this.localization.useLocalTimeZone;
                },
                set useLocalTimeZone (val){
                    this.localization.useLocalTimeZone = val;
                },
                get storeDuplicatedTranslations () {
                    return this.localization.storeDuplicatedTranslations;
                },
                set storeDuplicatedTranslations (val){
                    this.localization.storeDuplicatedTranslations = val;
                },
                get defaultLocaleName () {
                    return this.localization.defaultLocaleName;
                },
                set defaultLocaleName (val){
                    this.localization.defaultLocaleName = val;
                },
                //#endregion
                /**
     * An object with properties that configure surveys when they work with a web service.
     *
     * Nested properties:
     *
     * - `encodeUrlParams`: `boolean`\
     * Specifies whether to encode URL parameters when you access a web service. Default value: `true`.
     *
     * - `cacheLoadedChoices`: `boolean`\
     * Specifies whether to cache [choices loaded from a web service](https://surveyjs.io/form-library/documentation/api-reference/questionselectbase#choicesByUrl). Default value: `true`.
     *
     * - `disableQuestionWhileLoadingChoices`: `boolean`\
     * Disables a question while its choices are being loaded from a web service. Default value: `false`.
     *
     * - `surveyServiceUrl`: `string`\
     * The URL of the SurveyJS Service API endpoint.
     *
     * - `onBeforeRequestChoices`: `(sender: ChoicesRestful, options: { request: XMLHttpRequest })`\
     * An event that is raised before a request for choices is send. Applies to questions with a specified [`choiceByUrl`](https://surveyjs.io/form-library/documentation/api-reference/questionselectbase#choicesByUrl) property. Use the `options.request` parameter to access and modify the `XMLHttpRequest` object. For instance, you can add authentication headers to it:
     *
     *     ```js
     *     import { settings } from "survey-core";
     *
     *     settings.web.onBeforeSendRequest = (sender, options) => {
     *       options.request.setRequestHeader('RequestVerificationToken', requestVerificationToken);
     *     };
     *     ```
     */ web: {
                    onBeforeRequestChoices: function(sender, options) {},
                    encodeUrlParams: true,
                    cacheLoadedChoices: true,
                    disableQuestionWhileLoadingChoices: false,
                    surveyServiceUrl: "https://api.surveyjs.io/public/v1/Survey"
                },
                //#region web section, obsolete properties
                get webserviceEncodeParameters () {
                    return this.web.encodeUrlParams;
                },
                set webserviceEncodeParameters (val){
                    this.web.encodeUrlParams = val;
                },
                get useCachingForChoicesRestful () {
                    return this.web.cacheLoadedChoices;
                },
                set useCachingForChoicesRestful (val){
                    this.web.cacheLoadedChoices = val;
                },
                get useCachingForChoicesRestfull () {
                    return this.web.cacheLoadedChoices;
                },
                set useCachingForChoicesRestfull (val){
                    this.web.cacheLoadedChoices = val;
                },
                get disableOnGettingChoicesFromWeb () {
                    return this.web.disableQuestionWhileLoadingChoices;
                },
                set disableOnGettingChoicesFromWeb (val){
                    this.web.disableQuestionWhileLoadingChoices = val;
                },
                get surveyServiceUrl () {
                    return this.web.surveyServiceUrl;
                },
                set surveyServiceUrl (val){
                    this.web.surveyServiceUrl = val;
                },
                //#endregion
                /**
     * An object that contains properties related to [triggers](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-survey-logic-triggers).
     *
     * Nested properties:
     *
     * - `changeNavigationButtonsOnComplete`: `boolean`\
     * Specifies whether to re-evaluate an expression associated with the [Complete trigger](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#complete) immediately when a question value changes. If the expression evaluates to `true`, the trigger is executed. Default value: `false`.\
     * Keep this property set to `false` if you want to re-evaluate the Complete trigger's expression only when the respondents navigate to another page.
     *
     * - `executeCompleteOnValueChanged`: `boolean`\
     * Specifies whether to replace the Next button with the Complete button when the [Complete trigger](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#complete) is going to be executed. Default value: `true`.
     *
     * - `executeSkipOnValueChanged`: `boolean`\
     * Specifies whether to re-evaluate an expression associated with the [Skip trigger](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#skip) immediately when a question value changes. If the expression evaluates to `true`, the trigger is executed. Default value: `true`.\
     * Disable this property if you want to re-evaluate the Skip trigger's expression only when respondents navigate to another page.
     */ triggers: {
                    changeNavigationButtonsOnComplete: true,
                    executeCompleteOnValueChanged: false,
                    executeSkipOnValueChanged: true
                },
                //#region triggers section, Obsolete properties
                get executeCompleteTriggerOnValueChanged () {
                    return this.triggers.executeCompleteOnValueChanged;
                },
                set executeCompleteTriggerOnValueChanged (val){
                    this.triggers.executeCompleteOnValueChanged = val;
                },
                get changeNavigationButtonsOnCompleteTrigger () {
                    return this.triggers.changeNavigationButtonsOnComplete;
                },
                set changeNavigationButtonsOnCompleteTrigger (val){
                    this.triggers.changeNavigationButtonsOnComplete = val;
                },
                get executeSkipTriggerOnValueChanged () {
                    return this.triggers.executeSkipOnValueChanged;
                },
                set executeSkipTriggerOnValueChanged (val){
                    this.triggers.executeSkipOnValueChanged = val;
                },
                //#endregion
                /**
     * An object that contains properties related to JSON serialization.
     *
     * Nested properties:
     *
     * - `itemValueSerializeAsObject`: `boolean`\
     * Enable this property if you want to serialize [`ItemValue`](https://surveyjs.io/form-library/documentation/api-reference/itemvalue) instances as objects even when they include only the `value` property. Default value: `false`. View an example below.
     *
     * - `itemValueSerializeDisplayText`: `boolean`\
     * Enable this property if you want to serialize the `text` property of [`ItemValue`](https://surveyjs.io/form-library/documentation/api-reference/itemvalue) objects even when it is empty or equal to the `value` property. Default value: `false`. View an example below.
     *
     * - `localizableStringSerializeAsObject`: `boolean`\
     * Enable this property if you want to serialize [`LocalizableString`](https://surveyjs.io/form-library/documentation/api-reference/localizablestring) instances as objects even when they include only a translation string for the default locale. For example, `"Custom String"` will be serialized as `{ default: "Custom String" }`. Default value: `false`.
     *
     * ```js
     * import { ItemValue, settings } from "survey-core";
     *
     * // `itemValueSerializeAsObject` example
     * settings.serialization.itemValueSerializeAsObject = true;
     * const item = new ItemValue(5);
     * const itemString = item.toJSON(); // Produces { value: 5 } instead of 5
     *
     * // `itemValueSerializeDisplayText` example
     * settings.serialization.itemValueSerializeDisplayText = true;
     * const item = new ItemValue("item1");
     * const itemString = item.toJSON(); // Produces { value: "item1", text: "item1" } instead of "item1"
     * ```
     */ serialization: {
                    itemValueSerializeAsObject: false,
                    itemValueSerializeDisplayText: false,
                    localizableStringSerializeAsObject: false
                },
                //#region serialization section, Obsolete properties
                get itemValueAlwaysSerializeAsObject () {
                    return this.serialization.itemValueSerializeAsObject;
                },
                set itemValueAlwaysSerializeAsObject (val){
                    this.serialization.itemValueSerializeAsObject = val;
                },
                get itemValueAlwaysSerializeText () {
                    return this.serialization.itemValueSerializeDisplayText;
                },
                set itemValueAlwaysSerializeText (val){
                    this.serialization.itemValueSerializeDisplayText = val;
                },
                get serializeLocalizableStringAsObject () {
                    return this.serialization.localizableStringSerializeAsObject;
                },
                set serializeLocalizableStringAsObject (val){
                    this.serialization.localizableStringSerializeAsObject = val;
                },
                //#endregion
                /**
     * An object that configures lazy rendering.
     *
     * Nested properties:
     *
     * - `enabled`: `boolean`\
     * Specifies whether to add questions to the DOM only when they get into the viewport. Default value: `false`.
     *
     * [View Demo](https://surveyjs.io/form-library/examples/survey-lazy/ (linkStyle))
     * @see [SurveyModel.lazyRendering](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#lazyRendering)
     */ lazyRender: {
                    enabled: false,
                    firstBatchSize: 3
                },
                //#region lazyRender section, Obsolete properties
                get lazyRowsRendering () {
                    return this.lazyRender.enabled;
                },
                set lazyRowsRendering (val){
                    this.lazyRender.enabled = val;
                },
                get lazyRowsRenderingStartRow () {
                    return this.lazyRender.firstBatchSize;
                },
                set lazyRowsRenderingStartRow (val){
                    this.lazyRender.firstBatchSize = val;
                },
                //#endregion
                /**
     * An object with properties that apply to [Single-Choice](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-question-model), [Multiple-Choice](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list), and [Dynamic Matrix](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model) questions.
     *
     * Nested properties:
     *
     * - `defaultRowName`: `string`\
     * A property key that stores an object with default cell values. Default value: "default".
     *
     * - `defaultCellType`: `string`\
     * The default type of matrix cells. Default value: `"dropdown"`.\
     * You can specify this setting for individual questions or matrix columns: [`cellType`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model#cellType). Refer to the `cellType` property description for information on possible values.
     *
     * - `totalsSuffix`: `string`\
     * A suffix added to the name of the property that stores total values. The resulting property name consists of the matrix name and the suffix. Default value: `"-total"`.
     *
     * - `maxRowCount`: `number`\
     * A maximum number of rows in a Dynamic Matrix. Default value: 1000.\
     * You can specify this setting for an individual Dynamic Matrix: [`maxRowCount`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model#maxRowCount).
     *
     * - `maxRowCountInCondition`: `number`\
     * A maximum number of matrix rows included in the Condition drop-down menu in Survey Creator. This menu is used to configure conditional survey logic. Default value: 1.\
     * If you set this property to 0, the Condition menu does not include any matrix rows. Users still can specify conditions that use matrix rows but only with Manual Entry.
     *
     * - `renderRemoveAsIcon`: `boolean`\
     * Disable this property if you want to render the Remove action in Dynamic Matrix as a button. Otherwise, the action is rendered as an icon. Default value: `true`.
     *
     * - `columnWidthsByType`: `object`\
     * An object that specifies fixed and minimum column width based on the column type.\
     * Example: `settings.matrix.columnWidthsByType = { "tagbox": { minWidth: "240px", width: "300px" } }`
     *
     * - `rateSize`: `"small"` (default) | `"normal"`\
     * Specifies the size of rate values. Applies to [Rating Scale](https://surveyjs.io/form-library/examples/rating-scale/) questions within matrixes.
     */ matrix: {
                    defaultCellType: "dropdown",
                    defaultRowName: "default",
                    totalsSuffix: "-total",
                    maxRowCount: 1000,
                    maxRowCountInCondition: 1,
                    renderRemoveAsIcon: true,
                    columnWidthsByType: columnWidthsByType,
                    rateSize: "small"
                },
                //#region matrix section, Obsolete properties
                get matrixDefaultRowName () {
                    return this.matrix.defaultRowName;
                },
                set matrixDefaultRowName (val){
                    this.matrix.defaultRowName = val;
                },
                get matrixDefaultCellType () {
                    return this.matrix.defaultCellType;
                },
                set matrixDefaultCellType (val){
                    this.matrix.defaultCellType = val;
                },
                get matrixTotalValuePostFix () {
                    return this.matrix.totalsSuffix;
                },
                set matrixTotalValuePostFix (val){
                    this.matrix.totalsSuffix = val;
                },
                get matrixMaximumRowCount () {
                    return this.matrix.maxRowCount;
                },
                set matrixMaximumRowCount (val){
                    this.matrix.maxRowCount = val;
                },
                get matrixMaxRowCountInCondition () {
                    return this.matrix.maxRowCountInCondition;
                },
                set matrixMaxRowCountInCondition (val){
                    this.matrix.maxRowCountInCondition = val;
                },
                get matrixRenderRemoveAsIcon () {
                    return this.matrix.renderRemoveAsIcon;
                },
                set matrixRenderRemoveAsIcon (val){
                    this.matrix.renderRemoveAsIcon = val;
                },
                //#endregion
                /**
     * An object with properties that apply to [Dynamic Panel](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model) questions.
     *
     * Nested properties:
     *
     * - `maxPanelCount`: `number`\
     * A maximum number of panels in Dynamic Panel. Default value: 100.\
     * You can specify this setting for an individual Dynamic Panel: [`maxPanelCount`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model#maxPanelCount).
     *
     * - `maxPanelCountInCondition`: `number`\
     * A maximum number of Dynamic Panel panels included in the Condition drop-down menu in Survey Creator. This menu is used to configure conditional survey logic. Default value: 1.\
     * If you set this property to 0, the Condition menu does not include any panel questions. Users still can specify conditions that use panel questions but only with Manual Entry.
     */ panel: {
                    maxPanelCount: 100,
                    maxPanelCountInCondition: 1
                },
                //#region panel section, Obsolete properties
                get panelDynamicMaxPanelCountInCondition () {
                    return this.panel.maxPanelCountInCondition;
                },
                set panelDynamicMaxPanelCountInCondition (val){
                    this.panel.maxPanelCountInCondition = val;
                },
                get panelMaximumPanelCount () {
                    return this.panel.maxPanelCount;
                },
                set panelMaximumPanelCount (val){
                    this.panel.maxPanelCount = val;
                },
                //#endregion
                /**
     * An object with properties that configure questions in read-only mode.
     *
     * Nested properties:
     *
     * - `commentRenderMode`: `"textarea"` (default) | `"div"`\
     * Specifies how to render the input field of [Comment](https://surveyjs.io/form-library/documentation/api-reference/comment-field-model) questions in [read-only](https://surveyjs.io/form-library/documentation/api-reference/comment-field-model#readOnly) mode: as a disabled `<textarea>` element or as a `<div>` element with a non-editable question value within it.
     *
     * - `textRenderMode`: `"input"` (default) | `"div"`\
     * Specifies how to render the input field of [Text](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model) questions in [read-only](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#readOnly) mode: as a disabled `<input>` element or as a `<div>` element with a non-editable question value within it.
     */ readOnly: {
                    enableValidation: false,
                    commentRenderMode: "textarea",
                    textRenderMode: "input"
                },
                //#region readOnly section, Obsolete properties
                get readOnlyCommentRenderMode () {
                    return this.readOnly.commentRenderMode;
                },
                set readOnlyCommentRenderMode (val){
                    this.readOnly.commentRenderMode = val;
                },
                get readOnlyTextRenderMode () {
                    return this.readOnly.textRenderMode;
                },
                set readOnlyTextRenderMode (val){
                    this.readOnly.textRenderMode = val;
                },
                //#endregion
                /**
     * An object with properties that configure question numbering.
     *
     * Nested properties:
     *
     * - `includeQuestionsWithHiddenNumber`: `boolean`\
     * Specifies whether to number questions whose [`hideNumber`](https://surveyjs.io/form-library/documentation/api-reference/question#hideNumber) property is enabled. Default value: `false`.
     *
     * - `includeQuestionsWithHiddenTitle`: `boolean`\
     * Specifies whether to number questions whose [`titleLocation`](https://surveyjs.io/form-library/documentation/api-reference/question#titleLocation) property is set to `"hidden"`. Default value: `false`.
     */ numbering: {
                    includeQuestionsWithHiddenNumber: false,
                    includeQuestionsWithHiddenTitle: false
                },
                //#region numbering section, Obsolete properties
                get setQuestionVisibleIndexForHiddenTitle () {
                    return this.numbering.includeQuestionsWithHiddenTitle;
                },
                set setQuestionVisibleIndexForHiddenTitle (val){
                    this.numbering.includeQuestionsWithHiddenTitle = val;
                },
                get setQuestionVisibleIndexForHiddenNumber () {
                    return this.numbering.includeQuestionsWithHiddenNumber;
                },
                set setQuestionVisibleIndexForHiddenNumber (val){
                    this.numbering.includeQuestionsWithHiddenNumber = val;
                },
                //#endregion
                /**
     * Specifies an action to perform when users press the Enter key within a survey.
     *
     * Possible values:
     *
     * - `"moveToNextEditor"` - Moves focus to the next editor.
     * - `"loseFocus"` - Removes focus from the current editor.
     * - `"default"` - Behaves as a standard `<input>` element.
     */ enterKeyAction: "default",
                /**
     * An object that configures string comparison.
     *
     * Nested properties:
     *
     * - `trimStrings`: `boolean`\
     * Specifies whether to remove whitespace from both ends of a string before the comparison. Default value: `true`.
     *
     * - `caseSensitive`: `boolean`\
     * Specifies whether to differentiate between capital and lower-case letters. Default value: `false`.
     */ comparator: {
                    trimStrings: true,
                    caseSensitive: false,
                    normalizeTextCallback: function(str, reason) {
                        return str;
                    }
                },
                expressionDisableConversionChar: "#",
                get commentPrefix () {
                    return settings.commentSuffix;
                },
                set commentPrefix (val){
                    settings.commentSuffix = val;
                },
                /**
     * A suffix added to the name of the property that stores comments.
     *
     * Default value: "-Comment"
     *
     * You can specify this setting for an individual survey: [`commentSuffix`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#commentSuffix).
     */ commentSuffix: "-Comment",
                /**
     * A separator used in a shorthand notation that specifies a value and display text for an [`ItemValue`](https://surveyjs.io/form-library/documentation/api-reference/itemvalue) object: `"value|text"`.
     *
     * Default value: `"|"`
     */ itemValueSeparator: "|",
                /**
     * A maximum number of rate values in a [Rating](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model) question.
     *
     * Default value: 20
     */ ratingMaximumRateValueCount: 20,
                /**
     * Specifies whether to close the drop-down menu of a [TagBox](https://surveyjs.io/form-library/examples/how-to-create-multiselect-tag-box/) question after a user selects a value.
     *
     * This setting applies to all TagBox questions on a page. You can use the [closeOnSelect](https://surveyjs.io/form-library/documentation/api-reference/dropdown-tag-box-model#closeOnSelect) property to specify the same setting for an individual TagBox question.
     */ tagboxCloseOnSelect: false,
                /**
     * A function that activates a browser confirm dialog.
     *
     * Use the following code to execute this function:
     *
     * ```js
     * import { settings } from "survey-core";
     *
     * // `result` contains `true` if the action was confirmed or `false` otherwise
     * const result = settings.confirmActionFunc("Are you sure?");
     * ```
     *
     * You can redefine the `confirmActionFunc` function if you want to display a custom dialog window. Your function should return `true` if a user confirms an action or `false` otherwise.
     * @param message A message to be displayed in the confirm dialog window.
     */ confirmActionFunc: function(message) {
                    return confirm(message);
                },
                /**
     * A function that activates a proprietary SurveyJS confirm dialog.
     *
     * Use the following code to execute this function:
     *
     * ```js
     * import { settings } from "survey-core";
     *
     * settings.confirmActionAsync("Are you sure?", (confirmed) => {
     *   if (confirmed) {
     *     // ...
     *     // Proceed with the action
     *     // ...
     *   } else {
     *     // ...
     *     // Cancel the action
     *     // ...
     *   }
     * });
     * ```
     *
     * You can redefine the `confirmActionAsync` function if you want to display a custom dialog window. Your function should return `true` to be enabled; otherwise, a survey executes the [`confirmActionFunc`](#confirmActionFunc) function. Pass the dialog result as the `callback` parameter: `true` if a user confirms an action, `false` otherwise.
     * @param message A message to be displayed in the confirm dialog window.
     * @param callback A callback function that should be called with `true` if a user confirms an action or `false` otherwise.
     */ confirmActionAsync: function(message, callback, applyTitle, locale, rootElement1) {
                    return Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__["showConfirmDialog"])(message, callback, applyTitle, locale, rootElement1);
                },
                /**
     * A minimum width value for all survey elements.
     *
     * Default value: `"300px"`
     *
     * You can override this setting for individual elements: [`minWidth`](https://surveyjs.io/form-library/documentation/api-reference/surveyelement#minWidth).
     */ minWidth: "300px",
                /**
     * A maximum width value for all survey elements.
     *
     * Default value: `"100%"`
     *
     * You can override this setting for individual elements: [`maxWidth`](https://surveyjs.io/form-library/documentation/api-reference/surveyelement#maxWidth).
     */ maxWidth: "100%",
                /**
     * Specifies how many times surveys can re-evaluate expressions when a question value changes. This limit helps avoid recursions in expressions.
     *
     * Default value: 10
     */ maxConditionRunCountOnValueChanged: 10,
                /**
     * An object that configures notifications.
     *
     * Nested properties:
     *
     * - `lifetime`: `number`\
     * Specifies a time period during which a notification is displayed; measured in milliseconds.
     */ notifications: {
                    lifetime: 2000
                },
                /**
     * Specifies how many milliseconds a survey should wait before it automatically switches to the next page. Applies only when [auto-advance](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#goNextPageAutomatic) is enabled.
     *
     * Default value: 300
     */ autoAdvanceDelay: 300,
                /**
     * Specifies the direction in which to lay out Checkbox and Radiogroup items. This setting affects the resulting UI when items are arranged in [more than one column](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model#colCount).
     *
     * Possible values:
     *
     * - `"row"` (default) - Items fill the current row, then move on to the next row.
     * - `"column"` - Items fill the current column, then move on to the next column.
     */ showItemsInOrder: "default",
                /**
     * A value to save in survey results when respondents select the "None" choice item.
     *
     * Default value: `"none"`
     */ noneItemValue: "none",
                /**
     * A value to save in survey results when respondents select the "Refuse to answer" choice item.
     *
     * Default value: `"refused"`
     */ refuseItemValue: "refused",
                /**
     * A value to save in survey results when respondents select the "Don't know" choice item.
     *
     * Default value: `"dontknow"`
     */ dontKnowItemValue: "dontknow",
                /**
     * An object whose properties specify the order of the special choice items ("None", "Other", "Select All", "Refuse to answer", "Don't know") in select-based questions.
     *
     * Default value: `{ selectAllItem: [-1], noneItem: [1], otherItem: [2], dontKnowItem: [3], otherItem: [4] }`
     *
     * Use this object to reorder special choices. Each property accepts an array of integer numbers. Negative numbers place a special choice item above regular choice items, positive numbers place it below them. For instance, the code below specifies the following order of choices: None, Select All, regular choices, Other.
     *
     * ```js
     * import { settings } from "survey-core";
     *
     * settings.specialChoicesOrder.noneItem = [-2];
     * settings.specialChoicesOrder.selectAllItem = [-1];
     * settings.specialChoicesOrder.otherItem = [1];
     * ```
     *
     * If you want to duplicate a special choice item above and below other choices, add two numbers to the corresponding array:
     *
     * ```js
     * settings.specialChoicesOrder.selectAllItem = [-1, 3] // Displays Select All above and below other choices
     * ```
     */ specialChoicesOrder: {
                    selectAllItem: [
                        -1
                    ],
                    noneItem: [
                        1
                    ],
                    refuseItem: [
                        2
                    ],
                    dontKnowItem: [
                        3
                    ],
                    otherItem: [
                        4
                    ]
                },
                /**
     * A list of supported validators by question type.
     */ supportedValidators: {
                    question: [
                        "expression"
                    ],
                    comment: [
                        "text",
                        "regex"
                    ],
                    text: [
                        "numeric",
                        "text",
                        "regex",
                        "email"
                    ],
                    checkbox: [
                        "answercount"
                    ],
                    imagepicker: [
                        "answercount"
                    ]
                },
                /**
     * Specifies a minimum date that users can enter into a [Text](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model) question with [`inputType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#inputType) set to `"date"` or `"datetime-local"`. Set this property to a string with the folllowing format: `"yyyy-mm-dd"`.
     */ minDate: "",
                /**
     * Specifies a maximum date that users can enter into a [Text](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model) question with [`inputType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#inputType) set to `"date"` or `"datetime-local"`. Set this property to a string with the folllowing format: `"yyyy-mm-dd"`.
     */ maxDate: "",
                showModal: undefined,
                showDialog: undefined,
                supportCreatorV2: false,
                showDefaultItemsInCreatorV2: true,
                /**
     * An object that specifies icon replacements. Object keys are built-in icon names. To use a custom icon, assign its name to the key of the icon you want to replace:
     *
     * ```js
     * import { settings } from "survey-core";
     *
     * settings.customIcons["icon-redo"] = "custom-redo-icon";
     * ```
     *
     * For more information about icons in SurveyJS, refer to the following help topic: [UI Icons](https://surveyjs.io/form-library/documentation/icons).
     */ customIcons: {},
                /**
     * Specifies which part of a choice item responds to a drag gesture in Ranking questions.
     *
     * Possible values:
     *
     * - `"entireItem"` (default) - Users can use the entire choice item as a drag handle.
     * - `"icon"` - Users can only use the choice item icon as a drag handle.
     */ rankingDragHandleArea: "entireItem",
                environment: defaultEnvironment,
                /**
     * Allows you to hide the maximum length indicator in text input questions.
     *
     * If you specify a question's [`maxLength`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#maxLength) property or a survey's [`maxTextLength`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#maxTextLength) property, text input questions indicate the number of entered characters and the character limit. Assign `false` to the `settings.showMaxLengthIndicator` property if you want to hide this indicator.
     *
     * Default value: `true`
     */ showMaxLengthIndicator: true,
                /**
     * Specifies whether to animate survey elements.
     *
     * Default value: `true`
    */ animationEnabled: true,
                /**
     * An object that specifies heading levels (`<h1>`, `<h2>`, etc.) to use when rendering survey, page, panel, and question titles.
     *
     * Default value: `{ survey: "h3", page: "h4", panel: "h4", question: "h5" }`
     *
     * If you want to modify heading levels for individual titles, handle `SurveyModel`'s [`onGetTitleTagName`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onGetTitleTagName) event.
     */ titleTags: {
                    survey: "h3",
                    page: "h4",
                    panel: "h4",
                    question: "h5"
                },
                questions: {
                    inputTypes: [
                        "color",
                        "date",
                        "datetime-local",
                        "email",
                        "month",
                        "number",
                        "password",
                        "range",
                        "tel",
                        "text",
                        "time",
                        "url",
                        "week"
                    ],
                    dataList: [
                        "",
                        "name",
                        "honorific-prefix",
                        "given-name",
                        "additional-name",
                        "family-name",
                        "honorific-suffix",
                        "nickname",
                        "organization-title",
                        "username",
                        "new-password",
                        "current-password",
                        "organization",
                        "street-address",
                        "address-line1",
                        "address-line2",
                        "address-line3",
                        "address-level4",
                        "address-level3",
                        "address-level2",
                        "address-level1",
                        "country",
                        "country-name",
                        "postal-code",
                        "cc-name",
                        "cc-given-name",
                        "cc-additional-name",
                        "cc-family-name",
                        "cc-number",
                        "cc-exp",
                        "cc-exp-month",
                        "cc-exp-year",
                        "cc-csc",
                        "cc-type",
                        "transaction-currency",
                        "transaction-amount",
                        "language",
                        "bday",
                        "bday-day",
                        "bday-month",
                        "bday-year",
                        "sex",
                        "url",
                        "photo",
                        "tel",
                        "tel-country-code",
                        "tel-national",
                        "tel-area-code",
                        "tel-local",
                        "tel-local-prefix",
                        "tel-local-suffix",
                        "tel-extension",
                        "email",
                        "impp"
                    ]
                },
                legacyProgressBarView: false,
                /**
     * An object with properties that configure input masks.
     *
     * Nested properties:
     *
     * - `patternPlaceholderChar`: `string`\
     * A symbol used as a placeholder for characters to be entered in [pattern masks](https://surveyjs.io/form-library/documentation/api-reference/inputmaskpattern). Default value: `"_"`.
     *
     * - `patternEscapeChar`: `string`\
     * A symbol used to insert literal representations of special characters in [pattern masks](https://surveyjs.io/form-library/documentation/api-reference/inputmaskpattern). Default value: `"\\"`.
     *
     * - `patternDefinitions`: `<{ [key: string]: RegExp }>`\
     * An object that maps placeholder symbols to regular expressions in [pattern masks](https://surveyjs.io/form-library/documentation/api-reference/inputmaskpattern). Default value: `{ "9": /[0-9]/, "a": /[a-zA-Z]/, "#": /[a-zA-Z0-9]/ }`.
     */ maskSettings: {
                    patternPlaceholderChar: "_",
                    patternEscapeChar: "\\",
                    patternDefinitions: {
                        "9": /[0-9]/,
                        "a": /[a-zA-Z]/,
                        "#": /[a-zA-Z0-9]/
                    }
                }
            };
        /***/ },
        /***/ "./src/stylesmanager.ts": /*!******************************!*\
  !*** ./src/stylesmanager.ts ***!
  \******************************/ /*! exports provided: modernThemeColors, defaultThemeColors, orangeThemeColors, darkblueThemeColors, darkroseThemeColors, stoneThemeColors, winterThemeColors, winterstoneThemeColors, StylesManager */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "modernThemeColors", function() {
                return modernThemeColors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultThemeColors", function() {
                return defaultThemeColors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "orangeThemeColors", function() {
                return orangeThemeColors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkblueThemeColors", function() {
                return darkblueThemeColors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "darkroseThemeColors", function() {
                return darkroseThemeColors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stoneThemeColors", function() {
                return stoneThemeColors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "winterThemeColors", function() {
                return winterThemeColors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "winterstoneThemeColors", function() {
                return winterstoneThemeColors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "StylesManager", function() {
                return StylesManager;
            });
            /* harmony import */ var _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./defaultCss/defaultV2Css */ "./src/defaultCss/defaultV2Css.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            var modernThemeColors = {
                "$main-color": "#1ab394",
                "$add-button-color": "#1948b3",
                "$remove-button-color": "#ff1800",
                "$disable-color": "#dbdbdb",
                "$progress-text-color": "#9d9d9d",
                "$disabled-label-color": "rgba(64, 64, 64, 0.5)",
                "$slider-color": "white",
                "$disabled-slider-color": "#cfcfcf",
                "$error-color": "#d52901",
                "$text-color": "#404040",
                "$light-text-color": "#fff",
                "$checkmark-color": "#fff",
                "$progress-buttons-color": "#8dd9ca",
                "$inputs-background-color": "transparent",
                "$main-hover-color": "#9f9f9f",
                "$body-container-background-color": "#f4f4f4",
                "$text-border-color": "#d4d4d4",
                "$disabled-text-color": "rgba(64, 64, 64, 0.5)",
                "$border-color": "rgb(64, 64, 64, 0.5)",
                "$header-background-color": "#e7e7e7",
                "$answer-background-color": "rgba(26, 179, 148, 0.2)",
                "$error-background-color": "rgba(213, 41, 1, 0.2)",
                "$radio-checked-color": "#404040",
                "$clean-button-color": "#1948b3",
                "$body-background-color": "#ffffff",
                "$foreground-light": "#909090",
                "$font-family": "Raleway"
            };
            var defaultThemeColors = {
                "$header-background-color": "#e7e7e7",
                "$body-container-background-color": "#f4f4f4",
                "$main-color": "#1ab394",
                "$main-hover-color": "#0aa384",
                "$body-background-color": "white",
                "$inputs-background-color": "white",
                "$text-color": "#6d7072",
                "$text-input-color": "#6d7072",
                "$header-color": "#6d7072",
                "$border-color": "#e7e7e7",
                "$error-color": "#ed5565",
                "$error-background-color": "#fcdfe2",
                "$progress-text-color": "#9d9d9d",
                "$disable-color": "#dbdbdb",
                "$disabled-label-color": "rgba(64, 64, 64, 0.5)",
                "$slider-color": "white",
                "$disabled-switch-color": "#9f9f9f",
                "$disabled-slider-color": "#cfcfcf",
                "$foreground-light": "#909090",
                "$foreground-disabled": "#161616",
                "$background-dim": "#f3f3f3",
                "$progress-buttons-color": "#8dd9ca",
                "$progress-buttons-line-color": "#d4d4d4"
            };
            var orangeThemeColors = {
                "$header-background-color": "#4a4a4a",
                "$body-container-background-color": "#f8f8f8",
                "$main-color": "#f78119",
                "$main-hover-color": "#e77109",
                "$body-background-color": "white",
                "$inputs-background-color": "white",
                "$text-color": "#4a4a4a",
                "$text-input-color": "#4a4a4a",
                "$header-color": "#f78119",
                "$border-color": "#e7e7e7",
                "$error-color": "#ed5565",
                "$error-background-color": "#fcdfe2",
                "$progress-text-color": "#9d9d9d",
                "$disable-color": "#dbdbdb",
                "$disabled-label-color": "rgba(64, 64, 64, 0.5)",
                "$slider-color": "white",
                "$disabled-switch-color": "#9f9f9f",
                "$disabled-slider-color": "#cfcfcf",
                "$foreground-light": "#909090",
                "$foreground-disabled": "#161616",
                "$background-dim": "#f3f3f3",
                "$progress-buttons-color": "#f7b781",
                "$progress-buttons-line-color": "#d4d4d4"
            };
            var darkblueThemeColors = {
                "$header-background-color": "#d9d8dd",
                "$body-container-background-color": "#f6f7f2",
                "$main-color": "#3c4f6d",
                "$main-hover-color": "#2c3f5d",
                "$body-background-color": "white",
                "$inputs-background-color": "white",
                "$text-color": "#4a4a4a",
                "$text-input-color": "#4a4a4a",
                "$header-color": "#6d7072",
                "$border-color": "#e7e7e7",
                "$error-color": "#ed5565",
                "$error-background-color": "#fcdfe2",
                "$progress-text-color": "#9d9d9d",
                "$disable-color": "#dbdbdb",
                "$disabled-label-color": "rgba(64, 64, 64, 0.5)",
                "$slider-color": "white",
                "$disabled-switch-color": "#9f9f9f",
                "$disabled-slider-color": "#cfcfcf",
                "$foreground-light": "#909090",
                "$foreground-disabled": "#161616",
                "$background-dim": "#f3f3f3",
                "$progress-buttons-color": "#839ec9",
                "$progress-buttons-line-color": "#d4d4d4"
            };
            var darkroseThemeColors = {
                "$header-background-color": "#ddd2ce",
                "$body-container-background-color": "#f7efed",
                "$main-color": "#68656e",
                "$main-hover-color": "#58555e",
                "$body-background-color": "white",
                "$inputs-background-color": "white",
                "$text-color": "#4a4a4a",
                "$text-input-color": "#4a4a4a",
                "$header-color": "#6d7072",
                "$border-color": "#e7e7e7",
                "$error-color": "#ed5565",
                "$error-background-color": "#fcdfe2",
                "$progress-text-color": "#9d9d9d",
                "$disable-color": "#dbdbdb",
                "$disabled-label-color": "rgba(64, 64, 64, 0.5)",
                "$slider-color": "white",
                "$disabled-switch-color": "#9f9f9f",
                "$disabled-slider-color": "#cfcfcf",
                "$foreground-light": "#909090",
                "$foreground-disabled": "#161616",
                "$background-dim": "#f3f3f3",
                "$progress-buttons-color": "#c6bed4",
                "$progress-buttons-line-color": "#d4d4d4"
            };
            var stoneThemeColors = {
                "$header-background-color": "#cdccd2",
                "$body-container-background-color": "#efedf4",
                "$main-color": "#0f0f33",
                "$main-hover-color": "#191955",
                "$body-background-color": "white",
                "$inputs-background-color": "white",
                "$text-color": "#0f0f33",
                "$text-input-color": "#0f0f33",
                "$header-color": "#0f0f33",
                "$border-color": "#e7e7e7",
                "$error-color": "#ed5565",
                "$error-background-color": "#fcdfe2",
                "$progress-text-color": "#9d9d9d",
                "$disable-color": "#dbdbdb",
                "$disabled-label-color": "rgba(64, 64, 64, 0.5)",
                "$slider-color": "white",
                "$disabled-switch-color": "#9f9f9f",
                "$disabled-slider-color": "#cfcfcf",
                "$foreground-light": "#909090",
                "$foreground-disabled": "#161616",
                "$background-dim": "#f3f3f3",
                "$progress-buttons-color": "#747491",
                "$progress-buttons-line-color": "#d4d4d4"
            };
            var winterThemeColors = {
                "$header-background-color": "#82b8da",
                "$body-container-background-color": "#dae1e7",
                "$main-color": "#3c3b40",
                "$main-hover-color": "#1e1d20",
                "$body-background-color": "white",
                "$inputs-background-color": "white",
                "$text-color": "#000",
                "$text-input-color": "#000",
                "$header-color": "#000",
                "$border-color": "#e7e7e7",
                "$error-color": "#ed5565",
                "$error-background-color": "#fcdfe2",
                "$disable-color": "#dbdbdb",
                "$progress-text-color": "#9d9d9d",
                "$disabled-label-color": "rgba(64, 64, 64, 0.5)",
                "$slider-color": "white",
                "$disabled-switch-color": "#9f9f9f",
                "$disabled-slider-color": "#cfcfcf",
                "$foreground-light": "#909090",
                "$foreground-disabled": "#161616",
                "$background-dim": "#f3f3f3",
                "$progress-buttons-color": "#d1c9f5",
                "$progress-buttons-line-color": "#d4d4d4"
            };
            var winterstoneThemeColors = {
                "$header-background-color": "#323232",
                "$body-container-background-color": "#f8f8f8",
                "$main-color": "#5ac8fa",
                "$main-hover-color": "#06a1e7",
                "$body-background-color": "white",
                "$inputs-background-color": "white",
                "$text-color": "#000",
                "$text-input-color": "#000",
                "$header-color": "#000",
                "$border-color": "#e7e7e7",
                "$error-color": "#ed5565",
                "$error-background-color": "#fcdfe2",
                "$disable-color": "#dbdbdb",
                "$progress-text-color": "#9d9d9d",
                "$disabled-label-color": "rgba(64, 64, 64, 0.5)",
                "$slider-color": "white",
                "$disabled-switch-color": "#9f9f9f",
                "$disabled-slider-color": "#cfcfcf",
                "$foreground-light": "#909090",
                "$foreground-disabled": "#161616",
                "$background-dim": "#f3f3f3",
                "$progress-buttons-color": "#acdcf2",
                "$progress-buttons-line-color": "#d4d4d4"
            };
            function setCssVariables(vars, element) {
                Object.keys(vars || {}).forEach(function(sassVarName) {
                    var name = sassVarName.substring(1);
                    element.style.setProperty("--" + name, vars[sassVarName]);
                });
            }
            var StylesManager = /** @class */ function() {
                function StylesManager() {
                    StylesManager.autoApplyTheme();
                }
                StylesManager.autoApplyTheme = function() {
                    if (_defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"].currentType === "bootstrap" || _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"].currentType === "bootstrapmaterial") return;
                    var includedThemeCss = StylesManager.getIncludedThemeCss();
                    if (includedThemeCss.length === 1) StylesManager.applyTheme(includedThemeCss[0].name);
                };
                StylesManager.getAvailableThemes = function() {
                    var themeMapper = _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"].getAvailableThemes().filter(function(themeName) {
                        return [
                            "defaultV2",
                            "default",
                            "modern"
                        ].indexOf(themeName) !== -1;
                    }).map(function(themeName) {
                        return {
                            name: themeName,
                            theme: _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"][themeName]
                        };
                    });
                    return themeMapper;
                };
                StylesManager.getIncludedThemeCss = function() {
                    if (typeof _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment === "undefined") return [];
                    var rootElement1 = _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment.rootElement;
                    var themeMapper = StylesManager.getAvailableThemes();
                    var element = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_3__["isShadowDOM"])(rootElement1) ? rootElement1.host : rootElement1;
                    if (!!element) {
                        var styles_1 = getComputedStyle(element);
                        if (styles_1.length) return themeMapper.filter(function(item) {
                            return item.theme.variables && styles_1.getPropertyValue(item.theme.variables.themeMark);
                        });
                    }
                    return [];
                };
                StylesManager.findSheet = function(styleSheetId) {
                    if (typeof _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment === "undefined") return null;
                    var styleSheets = _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment.root.styleSheets;
                    for(var i = 0; i < styleSheets.length; i++){
                        if (!!styleSheets[i].ownerNode && styleSheets[i].ownerNode["id"] === styleSheetId) return styleSheets[i];
                    }
                    return null;
                };
                StylesManager.createSheet = function(styleSheetId) {
                    var stylesSheetsMountContainer = _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment.stylesSheetsMountContainer;
                    var style = _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__["DomDocumentHelper"].createElement("style");
                    style.id = styleSheetId;
                    // Add a media (and/or media query) here if you'd like!
                    // style.setAttribute("media", "screen")
                    // style.setAttribute("media", "only screen and (max-width : 1024px)")
                    style.appendChild(new Text(""));
                    Object(_utils_utils__WEBPACK_IMPORTED_MODULE_3__["getElement"])(stylesSheetsMountContainer).appendChild(style);
                    if (!!StylesManager.Logger) StylesManager.Logger.log("style sheet " + styleSheetId + " created");
                    return style.sheet;
                };
                StylesManager.applyTheme = function(themeName, themeSelector) {
                    if (themeName === void 0) themeName = "default";
                    if (typeof _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment === "undefined") return;
                    var rootElement1 = _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].environment.rootElement;
                    var element = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_3__["isShadowDOM"])(rootElement1) ? rootElement1.host : rootElement1;
                    _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"].currentType = themeName;
                    if (StylesManager.Enabled) {
                        if (themeName !== "bootstrap" && themeName !== "bootstrapmaterial") {
                            setCssVariables(StylesManager.ThemeColors[themeName], element);
                            if (!!StylesManager.Logger) StylesManager.Logger.log("apply theme " + themeName + " completed");
                            return;
                        }
                        var themeCss_1 = StylesManager.ThemeCss[themeName];
                        if (!themeCss_1) {
                            _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_0__["surveyCss"].currentType = "defaultV2";
                            return;
                        }
                        StylesManager.insertStylesRulesIntoDocument();
                        var currentThemeSelector_1 = themeSelector || StylesManager.ThemeSelector[themeName] || StylesManager.ThemeSelector["default"];
                        var styleSheetId = (themeName + currentThemeSelector_1).trim();
                        var sheet_1 = StylesManager.findSheet(styleSheetId);
                        if (!sheet_1) {
                            sheet_1 = StylesManager.createSheet(styleSheetId);
                            var themeColors_1 = StylesManager.ThemeColors[themeName] || StylesManager.ThemeColors["default"];
                            Object.keys(themeCss_1).forEach(function(selector) {
                                var cssRuleText = themeCss_1[selector];
                                Object.keys(themeColors_1 || {}).forEach(function(colorVariableName) {
                                    return cssRuleText = cssRuleText.replace(new RegExp("\\" + colorVariableName, "g"), themeColors_1[colorVariableName]);
                                });
                                try {
                                    if (selector.indexOf("body") === 0) sheet_1.insertRule(selector + " { " + cssRuleText + " }", 0);
                                    else sheet_1.insertRule(currentThemeSelector_1 + selector + " { " + cssRuleText + " }", 0);
                                } catch (e) {}
                            });
                        }
                    }
                    if (!!StylesManager.Logger) StylesManager.Logger.log("apply theme " + themeName + " completed");
                };
                StylesManager.insertStylesRulesIntoDocument = function() {
                    if (StylesManager.Enabled) {
                        var sheet_2 = StylesManager.findSheet(StylesManager.SurveyJSStylesSheetId);
                        if (!sheet_2) sheet_2 = StylesManager.createSheet(StylesManager.SurveyJSStylesSheetId);
                        if (Object.keys(StylesManager.Styles).length) Object.keys(StylesManager.Styles).forEach(function(selector) {
                            try {
                                sheet_2.insertRule(selector + " { " + StylesManager.Styles[selector] + " }", 0);
                            } catch (e) {}
                        });
                        if (Object.keys(StylesManager.Media).length) Object.keys(StylesManager.Media).forEach(function(selector) {
                            try {
                                sheet_2.insertRule(StylesManager.Media[selector].media + " { " + selector + " { " + StylesManager.Media[selector].style + " } }", 0);
                            } catch (e) {}
                        });
                    }
                };
                StylesManager.SurveyJSStylesSheetId = "surveyjs-styles";
                StylesManager.Styles = {};
                StylesManager.Media = {};
                StylesManager.ThemeColors = {
                    "modern": modernThemeColors,
                    "default": defaultThemeColors,
                    "orange": orangeThemeColors,
                    "darkblue": darkblueThemeColors,
                    "darkrose": darkroseThemeColors,
                    "stone": stoneThemeColors,
                    "winter": winterThemeColors,
                    "winterstone": winterstoneThemeColors
                };
                StylesManager.ThemeCss = {};
                StylesManager.ThemeSelector = {
                    "default": ".sv_main ",
                    "modern": ".sv-root-modern "
                };
                StylesManager.Enabled = true;
                return StylesManager;
            }();
        /***/ },
        /***/ "./src/survey-element.ts": /*!*******************************!*\
  !*** ./src/survey-element.ts ***!
  \*******************************/ /*! exports provided: SurveyElementCore, DragTypeOverMeEnum, SurveyElement */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyElementCore", function() {
                return SurveyElementCore;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragTypeOverMeEnum", function() {
                return DragTypeOverMeEnum;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyElement", function() {
                return SurveyElement;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./actions/adaptive-container */ "./src/actions/adaptive-container.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_animation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils/animation */ "./src/utils/animation.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A base class for the [`SurveyElement`](https://surveyjs.io/form-library/documentation/surveyelement) and [`SurveyModel`](https://surveyjs.io/form-library/documentation/surveymodel) classes.
 */ var SurveyElementCore = /** @class */ function(_super) {
                __extends(SurveyElementCore, _super);
                function SurveyElementCore() {
                    var _this = _super.call(this) || this;
                    _this.createLocTitleProperty();
                    return _this;
                }
                SurveyElementCore.prototype.createLocTitleProperty = function() {
                    return this.createLocalizableString("title", this, true);
                };
                Object.defineProperty(SurveyElementCore.prototype, "title", {
                    /**
         * A title for the survey element. If `title` is undefined, the `name` property value is displayed instead.
         *
         * Empty pages and panels do not display their titles or names.
         *
         * @see [Configure Question Titles](https://surveyjs.io/form-library/documentation/design-survey-question-titles)
        */ get: function() {
                        return this.getLocalizableStringText("title", this.getDefaultTitleValue());
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("title", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "locTitle", {
                    get: function() {
                        return this.getLocalizableString("title");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.getDefaultTitleValue = function() {
                    return undefined;
                };
                SurveyElementCore.prototype.updateDescriptionVisibility = function(newDescription) {
                    var showPlaceholder = false;
                    if (this.isDesignMode) {
                        var property_1 = _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].findProperty(this.getType(), "description");
                        showPlaceholder = !!(property_1 === null || property_1 === void 0 ? void 0 : property_1.placeholder);
                    }
                    this.hasDescription = !!newDescription || showPlaceholder && this.isDesignMode;
                };
                Object.defineProperty(SurveyElementCore.prototype, "locDescription", {
                    get: function() {
                        return this.getLocalizableString("description");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleTagName", {
                    get: function() {
                        var titleTagName = this.getDefaultTitleTagName();
                        var survey = this.getSurvey();
                        return !!survey ? survey.getElementTitleTagName(this, titleTagName) : titleTagName;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.getDefaultTitleTagName = function() {
                    return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].titleTags[this.getType()];
                };
                Object.defineProperty(SurveyElementCore.prototype, "hasTitle", {
                    get: function() {
                        return this.title.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "hasTitleActions", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "hasTitleEvents", {
                    get: function() {
                        return this.hasTitleActions;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.getTitleToolbar = function() {
                    return null;
                };
                SurveyElementCore.prototype.getTitleOwner = function() {
                    return undefined;
                };
                Object.defineProperty(SurveyElementCore.prototype, "isTitleOwner", {
                    get: function() {
                        return !!this.getTitleOwner();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "isTitleRenderedAsString", {
                    get: function() {
                        return this.getIsTitleRenderedAsString();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.toggleState = function() {
                    return undefined;
                };
                Object.defineProperty(SurveyElementCore.prototype, "cssClasses", {
                    get: function() {
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "cssTitle", {
                    get: function() {
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "ariaTitleId", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "ariaDescriptionId", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleTabIndex", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleAriaExpanded", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleAriaRole", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "ariaLabel", {
                    get: function() {
                        return this.locTitle.renderedHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleAriaLabel", {
                    get: function() {
                        return this.ariaLabel;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.getIsTitleRenderedAsString = function() {
                    return !this.isTitleOwner;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], SurveyElementCore.prototype, "hasDescription", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        localizable: true,
                        onSet: function(newDescription, self) {
                            self.updateDescriptionVisibility(newDescription);
                        }
                    })
                ], SurveyElementCore.prototype, "description", void 0);
                return SurveyElementCore;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
            // TODO: rename
            var DragTypeOverMeEnum;
            (function(DragTypeOverMeEnum) {
                DragTypeOverMeEnum[DragTypeOverMeEnum["InsideEmptyPanel"] = 1] = "InsideEmptyPanel";
                DragTypeOverMeEnum[DragTypeOverMeEnum["MultilineRight"] = 2] = "MultilineRight";
                DragTypeOverMeEnum[DragTypeOverMeEnum["MultilineLeft"] = 3] = "MultilineLeft";
                DragTypeOverMeEnum[DragTypeOverMeEnum["Top"] = 4] = "Top";
                DragTypeOverMeEnum[DragTypeOverMeEnum["Right"] = 5] = "Right";
                DragTypeOverMeEnum[DragTypeOverMeEnum["Bottom"] = 6] = "Bottom";
                DragTypeOverMeEnum[DragTypeOverMeEnum["Left"] = 7] = "Left";
            })(DragTypeOverMeEnum || (DragTypeOverMeEnum = {}));
            /**
 * A base class for all survey elements.
 */ var SurveyElement = /** @class */ function(_super) {
                __extends(SurveyElement, _super);
                function SurveyElement(name) {
                    var _this = _super.call(this) || this;
                    _this.selectedElementInDesignValue = _this;
                    _this.disableDesignActions = SurveyElement.CreateDisabledDesignElements;
                    _this.parentQuestionValue = null;
                    _this.isContentElement = false;
                    _this.isEditableTemplateElement = false;
                    _this.isInteractiveDesignElement = true;
                    _this.isSingleInRow = true;
                    _this._renderedIsExpanded = true;
                    _this._isAnimatingCollapseExpand = false;
                    _this.animationCollapsed = new _utils_animation__WEBPACK_IMPORTED_MODULE_7__["AnimationBoolean"](_this.getExpandCollapseAnimationOptions(), function(val1) {
                        _this._renderedIsExpanded = val1;
                        if (_this.animationAllowed) {
                            if (val1) _this.isAnimatingCollapseExpand = true;
                            else _this.updateElementCss(false);
                        }
                    }, function() {
                        return _this.renderedIsExpanded;
                    });
                    _this.animationAllowedValue = true;
                    _this.name = name;
                    _this.createNewArray("errors");
                    _this.createNewArray("titleActions");
                    _this.registerPropertyChangedHandlers([
                        "isReadOnly"
                    ], function() {
                        _this.onReadOnlyChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "errors"
                    ], function() {
                        _this.updateVisibleErrors();
                    });
                    _this.registerPropertyChangedHandlers([
                        "isSingleInRow"
                    ], function() {
                        _this.updateElementCss(false);
                    });
                    return _this;
                }
                SurveyElement.getProgressInfoByElements = function(children, isRequired) {
                    var info = _base__WEBPACK_IMPORTED_MODULE_1__["Base"].createProgressInfo();
                    for(var i = 0; i < children.length; i++){
                        if (!children[i].isVisible) continue;
                        var childInfo = children[i].getProgressInfo();
                        info.questionCount += childInfo.questionCount;
                        info.answeredQuestionCount += childInfo.answeredQuestionCount;
                        info.requiredQuestionCount += childInfo.requiredQuestionCount;
                        info.requiredAnsweredQuestionCount += childInfo.requiredAnsweredQuestionCount;
                    }
                    if (isRequired && info.questionCount > 0) {
                        if (info.requiredQuestionCount == 0) info.requiredQuestionCount = 1;
                        if (info.answeredQuestionCount > 0) info.requiredAnsweredQuestionCount = 1;
                    }
                    return info;
                };
                SurveyElement.ScrollElementToTop = function(elementId, scrollIfVisible) {
                    var root = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root;
                    if (!elementId || typeof root === "undefined") return false;
                    var el = root.getElementById(elementId);
                    return SurveyElement.ScrollElementToViewCore(el, false, scrollIfVisible);
                };
                SurveyElement.ScrollElementToViewCore = function(el, checkLeft, scrollIfVisible) {
                    if (!el || !el.scrollIntoView) return false;
                    var elTop = scrollIfVisible ? -1 : el.getBoundingClientRect().top;
                    var needScroll = elTop < 0;
                    var elLeft = -1;
                    if (!needScroll && checkLeft) {
                        elLeft = el.getBoundingClientRect().left;
                        needScroll = elLeft < 0;
                    }
                    if (!needScroll && _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomWindowHelper"].isAvailable()) {
                        var height = _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomWindowHelper"].getInnerHeight();
                        needScroll = height > 0 && height < elTop;
                        if (!needScroll && checkLeft) {
                            var width = _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomWindowHelper"].getInnerWidth();
                            needScroll = width > 0 && width < elLeft;
                        }
                    }
                    if (needScroll) el.scrollIntoView();
                    return needScroll;
                };
                SurveyElement.GetFirstNonTextElement = function(elements, removeSpaces) {
                    if (removeSpaces === void 0) removeSpaces = false;
                    if (!elements || !elements.length || elements.length == 0) return null;
                    if (removeSpaces) {
                        var tEl = elements[0];
                        if (tEl.nodeName === "#text") tEl.data = "";
                        tEl = elements[elements.length - 1];
                        if (tEl.nodeName === "#text") tEl.data = "";
                    }
                    for(var i = 0; i < elements.length; i++){
                        if (elements[i].nodeName != "#text" && elements[i].nodeName != "#comment") return elements[i];
                    }
                    return null;
                };
                SurveyElement.FocusElement = function(elementId) {
                    if (!elementId || !_global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomDocumentHelper"].isAvailable()) return false;
                    var res = SurveyElement.focusElementCore(elementId);
                    if (!res) setTimeout(function() {
                        SurveyElement.focusElementCore(elementId);
                    }, 10);
                    return res;
                };
                SurveyElement.focusElementCore = function(elementId) {
                    var root = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root;
                    if (!root) return false;
                    var el = root.getElementById(elementId);
                    // https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom
                    if (el && !el["disabled"] && el.style.display !== "none" && el.offsetParent !== null) {
                        SurveyElement.ScrollElementToViewCore(el, true, false);
                        el.focus();
                        return true;
                    }
                    return false;
                };
                SurveyElement.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {
                    _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
                    if (name === "state") {
                        this.updateElementCss(false);
                        this.notifyStateChanged(oldValue);
                        if (this.stateChangedCallback) this.stateChangedCallback();
                    }
                };
                SurveyElement.prototype.getSkeletonComponentNameCore = function() {
                    if (this.survey) return this.survey.getSkeletonComponentName(this);
                    return "";
                };
                Object.defineProperty(SurveyElement.prototype, "parentQuestion", {
                    /**
         * A Dynamic Panel, Dynamic Matrix, or Dropdown Matrix that includes the current question.
         *
         * This property is `null` for standalone questions.
         */ get: function() {
                        return this.parentQuestionValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.setParentQuestion = function(val1) {
                    this.parentQuestionValue = val1;
                    this.onParentQuestionChanged();
                };
                SurveyElement.prototype.onParentQuestionChanged = function() {};
                Object.defineProperty(SurveyElement.prototype, "skeletonComponentName", {
                    get: function() {
                        return this.getSkeletonComponentNameCore();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "state", {
                    /**
         * Gets and sets the survey element's expand state.
         *
         * Possible values:
         *
         * - `"default"` (default) - The survey element is displayed in full and cannot be collapsed in the UI.
         * - `"expanded"` - The survey element is displayed in full and can be collapsed in the UI.
         * - `"collapsed"` - The survey element displays only `title` and `description` and can be expanded in the UI.
         *
         * @see toggleState
         * @see collapse
         * @see expand
         * @see isCollapsed
         * @see isExpanded
         */ get: function() {
                        return this.getPropertyValue("state");
                    },
                    set: function(val1) {
                        this.setPropertyValue("state", val1);
                        this.renderedIsExpanded = !(this.state === "collapsed" && !this.isDesignMode);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.notifyStateChanged = function(prevState) {
                    if (this.survey) this.survey.elementContentVisibilityChanged(this);
                };
                Object.defineProperty(SurveyElement.prototype, "isCollapsed", {
                    /**
         * Returns `true` if the survey element is collapsed.
         * @see state
         * @see toggleState
         * @see collapse
         * @see expand
         * @see isExpanded
         */ get: function() {
                        return this.state === "collapsed" && !this.isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isExpanded", {
                    /**
         * Returns `true` if the survey element is expanded.
         * @see state
         * @see toggleState
         * @see collapse
         * @see expand
         * @see isCollapsed
         */ get: function() {
                        return this.state === "expanded";
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Collapses the survey element.
     *
     * In collapsed state, the element displays only `title` and `description`.
     * @see title
     * @see description
     * @see state
     * @see toggleState
     * @see expand
     * @see isCollapsed
     * @see isExpanded
     */ SurveyElement.prototype.collapse = function() {
                    if (this.isDesignMode) return;
                    this.state = "collapsed";
                };
                /**
     * Expands the survey element.
     * @see state
     * @see toggleState
     * @see collapse
     * @see isCollapsed
     * @see isExpanded
     */ SurveyElement.prototype.expand = function() {
                    this.state = "expanded";
                };
                /**
     * Toggles the survey element's `state` between collapsed and expanded.
     * @see state
     * @see collapse
     * @see expand
     * @see isCollapsed
     * @see isExpanded
     */ SurveyElement.prototype.toggleState = function() {
                    if (this.isCollapsed) {
                        this.expand();
                        return true;
                    }
                    if (this.isExpanded) {
                        this.collapse();
                        return false;
                    }
                    return true;
                };
                Object.defineProperty(SurveyElement.prototype, "hasStateButton", {
                    get: function() {
                        return this.isExpanded || this.isCollapsed;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "shortcutText", {
                    get: function() {
                        return this.title || this.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getTitleToolbar = function() {
                    if (!this.titleToolbarValue) {
                        this.titleToolbarValue = this.createActionContainer(true);
                        this.titleToolbarValue.containerCss = (this.isPanel ? this.cssClasses.panel.titleBar : this.cssClasses.titleBar) || "sv-action-title-bar";
                        this.titleToolbarValue.setItems(this.getTitleActions());
                    }
                    return this.titleToolbarValue;
                };
                SurveyElement.prototype.createActionContainer = function(allowAdaptiveActions) {
                    var actionContainer = allowAdaptiveActions ? new _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_2__["AdaptiveActionContainer"]() : new _actions_container__WEBPACK_IMPORTED_MODULE_5__["ActionContainer"]();
                    if (this.survey && !!this.survey.getCss().actionBar) actionContainer.cssClasses = this.survey.getCss().actionBar;
                    return actionContainer;
                };
                Object.defineProperty(SurveyElement.prototype, "titleActions", {
                    get: function() {
                        return this.getPropertyValue("titleActions");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getTitleActions = function() {
                    if (!this.isTitleActionRequested) {
                        this.updateTitleActions();
                        this.isTitleActionRequested = true;
                    }
                    return this.titleActions;
                };
                SurveyElement.prototype.getDefaultTitleActions = function() {
                    return [];
                };
                SurveyElement.prototype.updateTitleActions = function() {
                    var actions = this.getDefaultTitleActions();
                    if (!!this.survey) actions = this.survey.getUpdatedElementTitleActions(this, actions);
                    this.setPropertyValue("titleActions", actions);
                };
                Object.defineProperty(SurveyElement.prototype, "hasTitleActions", {
                    get: function() {
                        return this.getTitleActions().length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "hasTitleEvents", {
                    get: function() {
                        return this.state !== undefined && this.state !== "default";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "titleTabIndex", {
                    get: function() {
                        return !this.isPage && this.state !== "default" ? 0 : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "titleAriaExpanded", {
                    get: function() {
                        if (this.isPage || this.state === "default") return undefined;
                        return this.state === "expanded" ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "titleAriaRole", {
                    get: function() {
                        if (this.isPage || this.state === "default") return undefined;
                        return "button";
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.setSurveyImpl = function(value, isLight) {
                    this.surveyImplValue = value;
                    if (!this.surveyImplValue) {
                        this.setSurveyCore(null);
                        this.surveyDataValue = null;
                    } else {
                        this.surveyDataValue = this.surveyImplValue.getSurveyData();
                        this.setSurveyCore(this.surveyImplValue.getSurvey());
                        this.textProcessorValue = this.surveyImplValue.getTextProcessor();
                        this.onSetData();
                    }
                    if (!!this.survey) {
                        this.updateDescriptionVisibility(this.description);
                        this.clearCssClasses();
                    }
                };
                SurveyElement.prototype.canRunConditions = function() {
                    return _super.prototype.canRunConditions.call(this) && !!this.data;
                };
                SurveyElement.prototype.getDataFilteredValues = function() {
                    return !!this.data ? this.data.getFilteredValues() : {};
                };
                SurveyElement.prototype.getDataFilteredProperties = function() {
                    var props = !!this.data ? this.data.getFilteredProperties() : {};
                    props.question = this;
                    return props;
                };
                Object.defineProperty(SurveyElement.prototype, "surveyImpl", {
                    get: function() {
                        return this.surveyImplValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                /* You shouldn't use this method ever */ SurveyElement.prototype.__setData = function(data) {
                    if (_settings__WEBPACK_IMPORTED_MODULE_4__["settings"].supportCreatorV2) this.surveyDataValue = data;
                };
                Object.defineProperty(SurveyElement.prototype, "data", {
                    get: function() {
                        return this.surveyDataValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "survey", {
                    /**
         * Returns the survey object.
         */ get: function() {
                        return this.getSurvey();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    if (!!this.surveyValue) return this.surveyValue;
                    if (!!this.surveyImplValue) this.setSurveyCore(this.surveyImplValue.getSurvey());
                    return this.surveyValue;
                };
                SurveyElement.prototype.setSurveyCore = function(value) {
                    this.surveyValue = value;
                    if (!!this.surveyChangedCallback) this.surveyChangedCallback();
                };
                Object.defineProperty(SurveyElement.prototype, "isInternal", {
                    get: function() {
                        return this.isContentElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "areInvisibleElementsShowing", {
                    get: function() {
                        return !!this.survey && this.survey.areInvisibleElementsShowing && !this.isContentElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isVisible", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isReadOnly", {
                    /**
         * Returns `true` if the survey element or its parent element is read-only.
         *
         * If you want to switch a survey element to the read-only state based on a condition, specify the [`enableIf`](https://surveyjs.io/form-library/documentation/question#enableIf) property. Refer to the following help topic for information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see readOnly
         */ get: function() {
                        return this.readOnly;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "readOnly", {
                    /**
         * Makes the survey element read-only.
         *
         * If you want to switch a survey element to the read-only state based on a condition, specify the [`enableIf`](https://surveyjs.io/form-library/documentation/question#enableIf) property. Refer to the following help topic for information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see isReadOnly
         */ get: function() {
                        return this.getPropertyValue("readOnly");
                    },
                    set: function(val1) {
                        if (this.readOnly == val1) return;
                        this.setPropertyValue("readOnly", val1);
                        if (!this.isLoadingFromJson) this.setPropertyValue("isReadOnly", this.isReadOnly);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.onReadOnlyChanged = function() {
                    if (!!this.readOnlyChangedCallback) this.readOnlyChangedCallback();
                };
                Object.defineProperty(SurveyElement.prototype, "css", {
                    get: function() {
                        return !!this.survey ? this.survey.getCss() : {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "cssClassesValue", {
                    get: function() {
                        return this.getPropertyValueWithoutDefault("cssClassesValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("cssClassesValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.ensureCssClassesValue = function() {
                    if (!this.cssClassesValue) {
                        this.cssClassesValue = this.calcCssClasses(this.css);
                        this.updateElementCssCore(this.cssClassesValue);
                    }
                };
                Object.defineProperty(SurveyElement.prototype, "cssClasses", {
                    /**
         * Returns an object in which keys are UI elements and values are CSS classes applied to them.
         *
         * Use the following events of the [`SurveyModel`](https://surveyjs.io/form-library/documentation/surveymodel) object to override CSS classes:
         *
         * - [`onUpdateQuestionCssClasses`](https://surveyjs.io/form-library/documentation/surveymodel#onUpdateQuestionCssClasses)
         * - [`onUpdatePanelCssClasses`](https://surveyjs.io/form-library/documentation/surveymodel#onUpdatePanelCssClasses)
         * - [`onUpdatePageCssClasses`](https://surveyjs.io/form-library/documentation/surveymodel#onUpdatePageCssClasses)
         * - [`onUpdateChoiceItemCss`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onUpdateChoiceItemCss)
         */ get: function() {
                        var _dummy = this.cssClassesValue;
                        if (!this.survey) return this.calcCssClasses(this.css);
                        this.ensureCssClassesValue();
                        return this.cssClassesValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "cssTitleNumber", {
                    get: function() {
                        var css = this.cssClasses;
                        if (css.number) return css.number;
                        return css.panel ? css.panel.number : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.calcCssClasses = function(css) {
                    return undefined;
                };
                SurveyElement.prototype.updateElementCssCore = function(cssClasses) {};
                Object.defineProperty(SurveyElement.prototype, "cssError", {
                    get: function() {
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.updateElementCss = function(reNew) {
                    this.clearCssClasses();
                };
                SurveyElement.prototype.clearCssClasses = function() {
                    this.cssClassesValue = undefined;
                };
                SurveyElement.prototype.getIsLoadingFromJson = function() {
                    if (_super.prototype.getIsLoadingFromJson.call(this)) return true;
                    return this.surveyValue ? this.surveyValue.isLoadingFromJson : false;
                };
                Object.defineProperty(SurveyElement.prototype, "name", {
                    /**
         * A survey element identifier.
         *
         * > Question names must be unique.
         */ get: function() {
                        return this.getPropertyValue("name", "");
                    },
                    set: function(val1) {
                        var oldValue = this.name;
                        this.setPropertyValue("name", this.getValidName(val1));
                        if (!this.isLoadingFromJson && !!oldValue) this.onNameChanged(oldValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getValidName = function(name) {
                    return name;
                };
                SurveyElement.prototype.onNameChanged = function(oldValue) {};
                SurveyElement.prototype.updateBindingValue = function(valueName, value) {
                    if (!!this.data && !this.isTwoValueEquals(value, this.data.getValue(valueName))) this.data.setValue(valueName, value, false);
                };
                Object.defineProperty(SurveyElement.prototype, "errors", {
                    /**
         * Validation errors. Call the `validate()` method to validate survey element data.
         * @see validate
         */ get: function() {
                        return this.getPropertyValue("errors");
                    },
                    set: function(val1) {
                        this.setPropertyValue("errors", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.updateVisibleErrors = function() {
                    var counter = 0;
                    for(var i = 0; i < this.errors.length; i++)if (this.errors[i].visible) counter++;
                    this.hasVisibleErrors = counter > 0;
                };
                Object.defineProperty(SurveyElement.prototype, "containsErrors", {
                    /**
         * Returns `true` if the survey element or its child elements have validation errors.
         *
         * This property contains the result of the most recent validation. This result may be outdated. Call the `validate` method to get an up-to-date value.
         * @see errors
         */ get: function() {
                        return this.getPropertyValue("containsErrors", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.updateContainsErrors = function() {
                    this.setPropertyValue("containsErrors", this.getContainsErrors());
                };
                SurveyElement.prototype.getContainsErrors = function() {
                    return this.errors.length > 0;
                };
                Object.defineProperty(SurveyElement.prototype, "selectedElementInDesign", {
                    get: function() {
                        return this.selectedElementInDesignValue;
                    },
                    set: function(val1) {
                        this.selectedElementInDesignValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.updateCustomWidgets = function() {};
                SurveyElement.prototype.onSurveyLoad = function() {};
                Object.defineProperty(SurveyElement.prototype, "wasRendered", {
                    get: function() {
                        return !!this.wasRenderedValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.onFirstRendering = function() {
                    this.wasRenderedValue = true;
                    this.ensureCssClassesValue();
                };
                SurveyElement.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    if (!this.survey) this.onSurveyLoad();
                    this.updateDescriptionVisibility(this.description);
                };
                SurveyElement.prototype.setVisibleIndex = function(index) {
                    return 0;
                };
                Object.defineProperty(SurveyElement.prototype, "isPage", {
                    /**
         * Returns `true` if the survey element is a page.
         * @see Base.getType
         */ get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isPanel", {
                    /**
         * Returns `true` if the survey element is a panel.
         * @see Base.getType
         */ get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isQuestion", {
                    /**
         * Returns `true` if the survey element is a question.
         * @see Base.getType
         */ get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.delete = function(doDispose) {};
                /**
     * Returns the survey's [locale](https://surveyjs.io/form-library/documentation/surveymodel#locale).
     *
     * If a default locale is used, this method returns an empty string. To get the applied locale in this case, use the following code:
     *
     * ```js
     * import { surveyLocalization } from 'survey-core';
     * const defaultLocale = surveyLocalization.defaultLocale;
     * ```
     *
     * @see [Localization & Globalization](https://surveyjs.io/form-library/documentation/localization)
     */ SurveyElement.prototype.getLocale = function() {
                    return this.survey ? this.survey.getLocale() : this.locOwner ? this.locOwner.getLocale() : "";
                };
                SurveyElement.prototype.getMarkdownHtml = function(text, name) {
                    return this.survey ? this.survey.getSurveyMarkdownHtml(this, text, name) : this.locOwner ? this.locOwner.getMarkdownHtml(text, name) : undefined;
                };
                SurveyElement.prototype.getRenderer = function(name) {
                    return this.survey && typeof this.survey.getRendererForString === "function" ? this.survey.getRendererForString(this, name) : this.locOwner && typeof this.locOwner.getRenderer === "function" ? this.locOwner.getRenderer(name) : null;
                };
                SurveyElement.prototype.getRendererContext = function(locStr) {
                    return this.survey && typeof this.survey.getRendererContextForString === "function" ? this.survey.getRendererContextForString(this, locStr) : this.locOwner && typeof this.locOwner.getRendererContext === "function" ? this.locOwner.getRendererContext(locStr) : locStr;
                };
                SurveyElement.prototype.getProcessedText = function(text) {
                    if (this.isLoadingFromJson) return text;
                    if (this.textProcessor) return this.textProcessor.processText(text, this.getUseDisplayValuesInDynamicTexts());
                    if (this.locOwner) return this.locOwner.getProcessedText(text);
                    return text;
                };
                SurveyElement.prototype.getUseDisplayValuesInDynamicTexts = function() {
                    return true;
                };
                SurveyElement.prototype.removeSelfFromList = function(list) {
                    if (!list || !Array.isArray(list)) return;
                    var index = list.indexOf(this);
                    if (index > -1) list.splice(index, 1);
                };
                Object.defineProperty(SurveyElement.prototype, "textProcessor", {
                    get: function() {
                        return this.textProcessorValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getProcessedHtml = function(html) {
                    if (!html || !this.textProcessor) return html;
                    return this.textProcessor.processText(html, true);
                };
                SurveyElement.prototype.onSetData = function() {};
                Object.defineProperty(SurveyElement.prototype, "parent", {
                    get: function() {
                        return this.getPropertyValue("parent", null);
                    },
                    set: function(val1) {
                        this.setPropertyValue("parent", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getPage = function(parent) {
                    while(parent && parent.parent)parent = parent.parent;
                    if (parent && parent.getType() == "page") return parent;
                    return null;
                };
                SurveyElement.prototype.moveToBase = function(parent, container, insertBefore) {
                    if (insertBefore === void 0) insertBefore = null;
                    if (!container) return false;
                    parent.removeElement(this);
                    var index = -1;
                    if (_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isNumber(insertBefore)) index = parseInt(insertBefore);
                    if (index == -1 && !!insertBefore && !!insertBefore.getType) index = container.indexOf(insertBefore);
                    container.addElement(this, index);
                    return true;
                };
                SurveyElement.prototype.setPage = function(parent, newPage) {
                    var oldPage = this.getPage(parent);
                    //fix for the creator v1: https://github.com/surveyjs/survey-creator/issues/1744
                    if (typeof newPage === "string") {
                        var survey = this.getSurvey();
                        survey.pages.forEach(function(page) {
                            if (newPage === page.name) newPage = page;
                        });
                    }
                    if (oldPage === newPage) return;
                    if (parent) parent.removeElement(this);
                    if (newPage) newPage.addElement(this, -1);
                };
                SurveyElement.prototype.getSearchableLocKeys = function(keys) {
                    keys.push("title");
                    keys.push("description");
                };
                Object.defineProperty(SurveyElement.prototype, "isDefaultV2Theme", {
                    get: function() {
                        return this.survey && this.survey.getCss().root == "sd-root-modern";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "hasParent", {
                    get: function() {
                        return this.parent && !this.parent.isPage && !this.parent.originalPage || this.parent === undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.shouldAddRunnerStyles = function() {
                    return !this.isDesignMode && this.isDefaultV2Theme;
                };
                Object.defineProperty(SurveyElement.prototype, "isCompact", {
                    get: function() {
                        return this.survey && this.survey["isCompact"];
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getHasFrameV2 = function() {
                    return this.shouldAddRunnerStyles() && !this.hasParent;
                };
                SurveyElement.prototype.getIsNested = function() {
                    return this.shouldAddRunnerStyles() && this.hasParent;
                };
                SurveyElement.prototype.getCssRoot = function(cssClasses) {
                    var isExpanadable = !!this.isCollapsed || !!this.isExpanded;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(cssClasses.withFrame, this.getHasFrameV2() && !this.isCompact).append(cssClasses.compact, this.isCompact && this.getHasFrameV2()).append(cssClasses.collapsed, !!this.isCollapsed).append(cssClasses.expandableAnimating, isExpanadable && this.isAnimatingCollapseExpand).append(cssClasses.expanded, !!this.isExpanded && this.renderedIsExpanded).append(cssClasses.expandable, isExpanadable).append(cssClasses.nested, this.getIsNested()).toString();
                };
                Object.defineProperty(SurveyElement.prototype, "width", {
                    /**
         * Sets survey element width in CSS values.
         *
         * Default value: ""
         * @see minWidth
         * @see maxWidth
        */ get: function() {
                        return this.getPropertyValue("width", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("width", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "minWidth", {
                    /**
         * Gets or sets minimum survey element width in CSS values.
         *
         * Default value: "300px" (taken from [`settings.minWidth`](https://surveyjs.io/form-library/documentation/settings#minWidth))
         * @see maxWidth
         * @see renderWidth
         * @see width
         */ get: function() {
                        return this.getPropertyValue("minWidth");
                    },
                    set: function(val1) {
                        this.setPropertyValue("minWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "maxWidth", {
                    /**
         * Gets or sets maximum survey element width in CSS values.
         *
         * Default value: "100%" (taken from [`settings.maxWidth`](https://surveyjs.io/form-library/documentation/settings#maxWidth))
         * @see minWidth
         * @see renderWidth
         * @see width
         */ get: function() {
                        return this.getPropertyValue("maxWidth");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "renderWidth", {
                    /**
         * Returns a calculated width of the rendered survey element in CSS values.
         * @see width
         * @see minWidth
         * @see maxWidth
         */ get: function() {
                        return this.getPropertyValue("renderWidth", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("renderWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "indent", {
                    /**
         * Increases or decreases an indent of survey element content from the left edge. Accepts positive integer values and 0. Does not apply in the Default V2 theme.
         * @see rightIndent
         */ get: function() {
                        return this.getPropertyValue("indent");
                    },
                    set: function(val1) {
                        this.setPropertyValue("indent", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "rightIndent", {
                    /**
         * Increases or decreases an indent of survey element content from the right edge. Accepts positive integer values and 0. Does not apply in the Default V2 theme.
         * @see indent
         */ get: function() {
                        return this.getPropertyValue("rightIndent", 0);
                    },
                    set: function(val1) {
                        this.setPropertyValue("rightIndent", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getRootStyle = function() {
                    var style = {};
                    if (!!this.paddingLeft) style["--sv-element-add-padding-left"] = this.paddingLeft;
                    if (!!this.paddingRight) style["--sv-element-add-padding-right"] = this.paddingRight;
                    return style;
                };
                Object.defineProperty(SurveyElement.prototype, "paddingLeft", {
                    get: function() {
                        return this.getPropertyValue("paddingLeft", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("paddingLeft", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "paddingRight", {
                    get: function() {
                        return this.getPropertyValue("paddingRight", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("paddingRight", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "rootStyle", {
                    get: function() {
                        var style = {};
                        var minWidth = this.minWidth;
                        if (minWidth != "auto") minWidth = "min(100%, " + this.minWidth + ")";
                        if (this.allowRootStyle && this.renderWidth) {
                            // style["width"] = this.renderWidth;
                            style["flexGrow"] = 1;
                            style["flexShrink"] = 1;
                            style["flexBasis"] = this.renderWidth;
                            style["minWidth"] = minWidth;
                            style["maxWidth"] = this.maxWidth;
                        }
                        return style;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.isContainsSelection = function(el) {
                    var elementWithSelection = undefined;
                    var _document = _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomDocumentHelper"].getDocument();
                    if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomDocumentHelper"].isAvailable() && !!_document && _document["selection"]) elementWithSelection = _document["selection"].createRange().parentElement();
                    else {
                        var selection = _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomWindowHelper"].getSelection();
                        if (!!selection && selection.rangeCount > 0) {
                            var range = selection.getRangeAt(0);
                            if (range.startOffset !== range.endOffset) elementWithSelection = range.startContainer.parentNode;
                        }
                    }
                    return elementWithSelection == el;
                };
                Object.defineProperty(SurveyElement.prototype, "clickTitleFunction", {
                    get: function() {
                        var _this = this;
                        if (this.needClickTitleFunction()) return function(event1) {
                            if (!!event1 && _this.isContainsSelection(event1.target)) return;
                            return _this.processTitleClick();
                        };
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.needClickTitleFunction = function() {
                    return this.state !== "default";
                };
                SurveyElement.prototype.processTitleClick = function() {
                    if (this.state !== "default") this.toggleState();
                };
                Object.defineProperty(SurveyElement.prototype, "additionalTitleToolbar", {
                    get: function() {
                        return this.getAdditionalTitleToolbar();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getAdditionalTitleToolbar = function() {
                    return null;
                };
                SurveyElement.prototype.getCssTitle = function(cssClasses) {
                    var isExpandable = this.state !== "default";
                    var numInlineLimit = 4;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(cssClasses.title).append(cssClasses.titleNumInline, (this.no || "").length > numInlineLimit || isExpandable).append(cssClasses.titleExpandable, isExpandable).append(cssClasses.titleExpanded, this.isExpanded).append(cssClasses.titleCollapsed, this.isCollapsed).append(cssClasses.titleDisabled, this.isReadOnly).append(cssClasses.titleOnError, this.containsErrors).toString();
                };
                SurveyElement.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    this.updateDescriptionVisibility(this.description);
                    if (this.errors.length > 0) this.errors.forEach(function(err) {
                        err.updateText();
                    });
                };
                SurveyElement.prototype.setWrapperElement = function(element) {
                    this.wrapperElement = element;
                };
                SurveyElement.prototype.getWrapperElement = function() {
                    return this.wrapperElement;
                };
                Object.defineProperty(SurveyElement.prototype, "isAnimatingCollapseExpand", {
                    get: function() {
                        return this._isAnimatingCollapseExpand || this._renderedIsExpanded != this.isExpanded;
                    },
                    set: function(val1) {
                        if (val1 !== this._isAnimatingCollapseExpand) {
                            this._isAnimatingCollapseExpand = val1;
                            this.updateElementCss(false);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getExpandCollapseAnimationOptions = function() {
                    var _this = this;
                    var beforeRunAnimation = function(el) {
                        _this.isAnimatingCollapseExpand = true;
                        el.style.setProperty("--animation-height", el.offsetHeight + "px");
                    };
                    var afterRunAnimation = function(el) {
                        _this.isAnimatingCollapseExpand = false;
                    };
                    return {
                        getEnterOptions: function() {
                            var cssClasses = _this.isPanel ? _this.cssClasses.panel : _this.cssClasses;
                            return {
                                cssClass: cssClasses.contentFadeIn,
                                onBeforeRunAnimation: beforeRunAnimation,
                                onAfterRunAnimation: afterRunAnimation
                            };
                        },
                        getLeaveOptions: function() {
                            var cssClasses = _this.isPanel ? _this.cssClasses.panel : _this.cssClasses;
                            return {
                                cssClass: cssClasses.contentFadeOut,
                                onBeforeRunAnimation: beforeRunAnimation,
                                onAfterRunAnimation: afterRunAnimation
                            };
                        },
                        getAnimatedElement: function() {
                            var _a;
                            var cssClasses = _this.isPanel ? _this.cssClasses.panel : _this.cssClasses;
                            if (cssClasses.content) {
                                var selector = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_8__["classesToSelector"])(cssClasses.content);
                                if (selector) return (_a = _this.getWrapperElement()) === null || _a === void 0 ? void 0 : _a.querySelector(selector);
                            }
                            return undefined;
                        },
                        isAnimationEnabled: function() {
                            return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].animationEnabled && _this.animationAllowed && !_this.isDesignMode;
                        }
                    };
                };
                Object.defineProperty(SurveyElement.prototype, "renderedIsExpanded", {
                    get: function() {
                        return !!this._renderedIsExpanded;
                    },
                    set: function(val1) {
                        this.animationCollapsed.sync(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "animationAllowed", {
                    get: function() {
                        return !this.isLoadingFromJson && !this.isDisposed && !!this.survey && this.animationAllowedValue;
                    },
                    set: function(val1) {
                        this.animationAllowedValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (this.titleToolbarValue) this.titleToolbarValue.dispose();
                };
                SurveyElement.CreateDisabledDesignElements = false;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: null
                    })
                ], SurveyElement.prototype, "dragTypeOverMe", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], SurveyElement.prototype, "isDragMe", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], SurveyElement.prototype, "hasVisibleErrors", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], SurveyElement.prototype, "isSingleInRow", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], SurveyElement.prototype, "allowRootStyle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], SurveyElement.prototype, "_renderedIsExpanded", void 0);
                return SurveyElement;
            }(SurveyElementCore);
        /***/ },
        /***/ "./src/survey-error.ts": /*!*****************************!*\
  !*** ./src/survey-error.ts ***!
  \*****************************/ /*! exports provided: SurveyError */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyError", function() {
                return SurveyError;
            });
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            var SurveyError = /** @class */ function() {
                function SurveyError(text, errorOwner) {
                    if (text === void 0) text = null;
                    if (errorOwner === void 0) errorOwner = null;
                    this.text = text;
                    this.errorOwner = errorOwner;
                    this.visible = true;
                    this.onUpdateErrorTextCallback = undefined;
                }
                SurveyError.prototype.equals = function(error) {
                    if (!error || !error.getErrorType) return false;
                    if (this.getErrorType() !== error.getErrorType()) return false;
                    return this.text === error.text && this.visible === error.visible;
                };
                Object.defineProperty(SurveyError.prototype, "locText", {
                    get: function() {
                        if (!this.locTextValue) {
                            this.locTextValue = new _localizablestring__WEBPACK_IMPORTED_MODULE_0__["LocalizableString"](this.errorOwner, true);
                            this.locTextValue.storeDefaultText = true;
                            this.locTextValue.text = this.getText();
                        }
                        return this.locTextValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyError.prototype.getText = function() {
                    var res = this.text;
                    if (!res) res = this.getDefaultText();
                    if (!!this.errorOwner) res = this.errorOwner.getErrorCustomText(res, this);
                    return res;
                };
                SurveyError.prototype.getErrorType = function() {
                    return "base";
                };
                SurveyError.prototype.getDefaultText = function() {
                    return "";
                };
                SurveyError.prototype.getLocale = function() {
                    return !!this.errorOwner ? this.errorOwner.getLocale() : "";
                };
                SurveyError.prototype.getLocalizationString = function(locStrName) {
                    return _surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].getString(locStrName, this.getLocale());
                };
                SurveyError.prototype.updateText = function() {
                    if (this.onUpdateErrorTextCallback) this.onUpdateErrorTextCallback(this);
                    this.locText.text = this.getText();
                };
                return SurveyError;
            }();
        /***/ },
        /***/ "./src/survey-events-api.ts": /*!**********************************!*\
  !*** ./src/survey-events-api.ts ***!
  \**********************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
        /***/ },
        /***/ "./src/survey.ts": /*!***********************!*\
  !*** ./src/survey.ts ***!
  \***********************/ /*! exports provided: SurveyModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyModel", function() {
                return SurveyModel;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /* harmony import */ var _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./defaultCss/defaultV2Css */ "./src/defaultCss/defaultV2Css.ts");
            /* harmony import */ var _textPreProcessor__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./textPreProcessor */ "./src/textPreProcessor.ts");
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./conditionProcessValue */ "./src/conditionProcessValue.ts");
            /* harmony import */ var _dxSurveyService__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./dxSurveyService */ "./src/dxSurveyService.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _stylesmanager__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./stylesmanager */ "./src/stylesmanager.ts");
            /* harmony import */ var _surveyTimerModel__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./surveyTimerModel */ "./src/surveyTimerModel.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _notifier__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./notifier */ "./src/notifier.ts");
            /* harmony import */ var _header__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./header */ "./src/header.ts");
            /* harmony import */ var _surveytimer__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ./surveytimer */ "./src/surveytimer.ts");
            /* harmony import */ var _surveyTaskManager__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./surveyTaskManager */ "./src/surveyTaskManager.ts");
            /* harmony import */ var _progress_buttons__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./progress-buttons */ "./src/progress-buttons.ts");
            /* harmony import */ var _surveyToc__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./surveyToc */ "./src/surveyToc.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * The `SurveyModel` object contains properties and methods that allow you to control the survey and access its elements.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/nps-question/ (linkStyle))
 */ var SurveyModel = /** @class */ function(_super) {
                __extends(SurveyModel, _super);
                //#endregion
                function SurveyModel(jsonObj, renderedElement) {
                    if (jsonObj === void 0) jsonObj = null;
                    if (renderedElement === void 0) renderedElement = null;
                    var _this = _super.call(this) || this;
                    _this.valuesHash = {};
                    _this.variablesHash = {};
                    //#region Event declarations
                    /**
         * An event that is raised after a [trigger](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#triggers) is executed.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [Conditional Survey Logic (Triggers)](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-survey-logic-triggers (linkStyle)).
         * @see triggers
         * @see runTriggers
         */ _this.onTriggerExecuted = _this.addEvent();
                    /**
         * An event that is raised before the survey is completed. Use this event to prevent survey completion.
         * @see onComplete
         * @see doComplete
         * @see allowCompleteSurveyAutomatic
         */ _this.onCompleting = _this.addEvent();
                    /**
         * An event that is raised after the survey is completed. Use this event to send survey results to the server.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * For an example of how to use the methods described above, refer to the following help topic: [Store Survey Results in Your Own Database](https://surveyjs.io/form-library/documentation/handle-survey-results-store#store-survey-results-in-your-own-database).
         *
         * > Do not disable the [`showCompletedPage`](https://surveyjs.io/form-library/documentation/surveymodel#showCompletedPage) property if you call one of the `options.showSave...` methods. This is required because the UI that indicates data saving progress is integrated into the complete page. If you hide the complete page, the UI also becomes invisible.
         * @see onPartialSend
         * @see doComplete
         * @see allowCompleteSurveyAutomatic
         */ _this.onComplete = _this.addEvent();
                    /**
         * An event that is raised before the survey displays a [preview of given answers](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#preview-page). Use this event to cancel the preview.
         * @see showPreviewBeforeComplete
         * @see showPreview
         * @see cancelPreview
         */ _this.onShowingPreview = _this.addEvent();
                    /**
         * An event that is raised before the survey navigates to a specified URL. Use this event to change the URL or cancel the navigation.
         * @see navigateToUrl
         * @see navigateToUrlOnCondition
         */ _this.onNavigateToUrl = _this.addEvent();
                    /**
         * An event that is raised when the survey [`state`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#state) changes to `"running"`.
         * @see firstPageIsStarted
         */ _this.onStarted = _this.addEvent();
                    /**
         * An event that is raised to save incomplete survey results. Enable the [`sendResultOnPageNext`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#sendResultOnPageNext) property for this event to occur.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * Alternatively, you can handle the [`onCurrentPageChanged`](#onCurrentPageChanged) and [`onValueChanged`](#onValueChanged) events, as shown in the following demo: [Continue an Incomplete Survey](https://surveyjs.io/form-library/examples/survey-editprevious/).
         */ _this.onPartialSend = _this.addEvent();
                    /**
         * An event that is raised before the current page is switched.
         *
         * @see currentPageNo
         * @see nextPage
         * @see prevPage
         **/ _this.onCurrentPageChanging = _this.addEvent();
                    /**
         * An event that is raised after the current page is switched.
         *
         * @see currentPageNo
         * @see nextPage
         * @see prevPage
         */ _this.onCurrentPageChanged = _this.addEvent();
                    /**
         * An event that is raised before a question value is changed.
         * @see setValue
         */ _this.onValueChanging = _this.addEvent();
                    /**
         * An event that is raised after a question value is changed.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * To handle value changes in matrix cells or panels within a [Dynamic Panel](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model), use the [`onMatrixCellValueChanged`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onMatrixCellValueChanged) or [`onDynamicPanelItemValueChanged`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onDynamicPanelItemValueChanged) event.
         * @see setValue
         */ _this.onValueChanged = _this.addEvent();
                    /**
         * An event that is raised after a [variable](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#variables) or [calculated value](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#calculated-values) is changed.
         *
         * @see setVariable
         * @see calculatedValues
         */ _this.onVariableChanged = _this.addEvent();
                    /**
         * An event that is raised after question visibility is changed.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * Refer to the following help topic for information on how to implement conditional visibility: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-visibility).
         */ _this.onQuestionVisibleChanged = _this.addEvent();
                    _this.onVisibleChanged = _this.onQuestionVisibleChanged;
                    /**
         * An event that is raised after page visibility is changed.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * Refer to the following help topic for information on how to implement conditional visibility: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-visibility).
         */ _this.onPageVisibleChanged = _this.addEvent();
                    /**
         * An event that is raised after panel visibility is changed.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * Refer to the following help topic for information on how to implement conditional visibility: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-visibility).
         */ _this.onPanelVisibleChanged = _this.addEvent();
                    /**
         * An event that is raised when the survey creates any new object derived from [`Question`](https://surveyjs.io/form-library/documentation/api-reference/question).
         *
         * In a survey, complex elements ([Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/), [Multiple Text](https://surveyjs.io/form-library/examples/questiontype-multipletext/), and [Dynamic Panel](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/)) are composed of questions. Use this event to customize any question regardless of which survey element it belongs to.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * To use this event for questions loaded from JSON, create an empty survey model, add an event handler, and only then populate the model from the JSON object:
         *
         * ```js
         * import { Model } from "survey-core";
         *
         * const surveyJson = {
         *    // ...
         * };
         * // Create an empty model
         * const survey = new Model();
         * // Add an event handler
         * survey.onQuestionCreated.add((sender, options) => {
         *   //...
         * });
         * // Load the survey JSON schema
         * survey.fromJSON(surveyJson);
         * ```
         * @see onQuestionAdded
         */ _this.onQuestionCreated = _this.addEvent();
                    /**
         * An event that is raised when a new question is added to a panel or page.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * To use this event for questions loaded from JSON, create an empty survey model, add an event handler, and only then populate the model from the JSON object:
         *
         * ```js
         * import { Model } from "survey-core";
         *
         * const surveyJson = {
         *    // ...
         * };
         * // Create an empty model
         * const survey = new Model();
         * // Add an event handler
         * survey.onQuestionAdded.add((sender, options) => {
         *   //...
         * });
         * // Load the survey JSON schema
         * survey.fromJSON(surveyJson);
         * ```
         * @see onQuestionCreated
         */ _this.onQuestionAdded = _this.addEvent();
                    /**
         * An event that is raised after a question is deleted from the survey.
         */ _this.onQuestionRemoved = _this.addEvent();
                    /**
         * An event that is raised when a new panel is added to a page.
         */ _this.onPanelAdded = _this.addEvent();
                    /**
         * An event that is raised after a panel is deleted from the survey.
         */ _this.onPanelRemoved = _this.addEvent();
                    /**
         * An event that is raised when a new page is added to the survey.
         * @see PanelModel
         */ _this.onPageAdded = _this.addEvent();
                    /**
         * An event that is raised when a question value is being validated. Use this event to specify a custom error message.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/add-custom-input-validation/ (linkStyle))
         * @see onServerValidateQuestions
         * @see onValidatePanel
         * @see onMatrixCellValidate
         * @see onSettingQuestionErrors
         */ _this.onValidateQuestion = _this.addEvent();
                    /**
         * An event that is raised before errors are assigned to a question. Use this event to add/remove/modify errors.
         * @see onValidateQuestion
         */ _this.onSettingQuestionErrors = _this.addEvent();
                    /**
         * Use this event to validate data on your server.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/javascript-server-side-form-validation/ (linkStyle))
         * @see onValidateQuestion
         * @see onValidatePanel
         * @see isValidatingOnServer
         */ _this.onServerValidateQuestions = _this.addEvent();
                    /**
         * An event that is raised when a panel is being validated. Use this event to specify a custom error message.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/add-custom-input-validation/ (linkStyle))
         * @see onValidateQuestion
         * @see onServerValidateQuestions
         */ _this.onValidatePanel = _this.addEvent();
                    /**
         * An event that is raised to change default error messages.
         */ _this.onErrorCustomText = _this.addEvent();
                    /**
         * An event that is raised when the [current page](#currentPage) is being validated. Handle this event to be notified of current page validation.
         */ _this.onValidatedErrorsOnCurrentPage = _this.addEvent();
                    /**
         * An event that is raised when the survey processes HTML content. Handle this event to modify HTML content before displaying.
         * @see completedHtml
         * @see loadingHtml
         * @see QuestionHtmlModel.html
         */ _this.onProcessHtml = _this.addEvent();
                    /**
         * Use this event to change a question's display text.
         */ _this.onGetQuestionDisplayValue = _this.addEvent();
                    /**
         * An event that is raised before the survey displays a question title. Handle this event to modify question titles.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * If you want to modify question numbers, handle the [`onGetQuestionNo`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onGetQuestionNo) event.
         * @see requiredText
         */ _this.onGetQuestionTitle = _this.addEvent();
                    /**
         * An event that is raised when the survey calculates heading levels (`<h1>`, `<h2>`, etc.) for a survey, page, panel, and question title. Handle this event to change the heading level of individual titles.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * If you want to specify heading levels for all titles, use the [`titleTags`](https://surveyjs.io/form-library/documentation/api-reference/settings#titleTags) object in [global settings](https://surveyjs.io/form-library/documentation/api-reference/settings).
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-titletagnames/ (linkStyle))
         * @see onGetQuestionTitle
         * @see onGetQuestionNo
         */ _this.onGetTitleTagName = _this.addEvent();
                    /**
         * An event that is raised before the survey calculates a question number. Handle this event to modify question numbers.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * If you want to hide question numbers, disable the [`showQuestionNumbers`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#showQuestionNumbers) property.
         * @see onGetQuestionTitle
         * @see questionStartIndex
         */ _this.onGetQuestionNo = _this.addEvent();
                    /**
         * An event that is raised before the survey displays progress text. Handle this event to change the progress text in code.
         * @see showProgressBar
         * @see progressBarType
         */ _this.onProgressText = _this.addEvent();
                    /**
         * An event that is raised to convert Markdown content to HTML.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/edit-survey-questions-markdown/ (linkStyle))
         */ _this.onTextMarkdown = _this.addEvent();
                    _this.onTextRenderAs = _this.addEvent();
                    /**
         * An event that is raised after a request to save survey results on [SurveyJS Service](https://api.surveyjs.io/) has been completed. Use this event to find out if the results have been saved successfully.
         */ _this.onSendResult = _this.addEvent();
                    /**
         * An event that is raised when the [`getResult(resultId, questionName)`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#getResult) method is called. Use this event to obtain answers to an individual question from [SurveyJS Service](https://api.surveyjs.io/).
         * @see getResult
         */ _this.onGetResult = _this.addEvent();
                    /**
         * An event that is raised when Survey Creator opens a dialog window for users to select files.
         * @see onUploadFile
         * @see uploadFiles
         */ _this.onOpenFileChooser = _this.addEvent();
                    /**
         * An event that is raised when a File Upload or Signature Pad question starts to upload a file. Applies only if [`storeDataAsText`](https://surveyjs.io/form-library/documentation/api-reference/file-model#storeDataAsText) is `false`. Use this event to upload files to your server.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/file-upload/ (linkStyle))
         * @see uploadFiles
         * @see onDownloadFile
         * @see onClearFiles
         */ _this.onUploadFiles = _this.addEvent();
                    /**
         * An event that is raised when a File Upload question starts to download a file. Use this event to implement file preview when your server stores only file names.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/store-file-names-in-survey-results/ (linkStyle))
         * @see downloadFile
         * @see onClearFiles
         * @see onUploadFiles
         */ _this.onDownloadFile = _this.addEvent();
                    /**
         * An event that is raised when users clear files in a [File Upload](https://surveyjs.io/form-library/documentation/api-reference/file-model) question or clear signature in a [Signature Pad](https://surveyjs.io/form-library/documentation/api-reference/signature-pad-model) question. Use this event to delete files from your server.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/file-delayed-upload/ (linkStyle))
         * @see clearFiles
         * @see onDownloadFile
         * @see onUploadFiles
         */ _this.onClearFiles = _this.addEvent();
                    /**
         * An event that is raised after choices are loaded from a server but before they are assigned to a choice-based question, such as [Dropdown](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model) or [Checkboxes](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model). Handle this event if you need to modify the loaded choices.
         */ _this.onLoadChoicesFromServer = _this.addEvent();
                    /**
         * An event that is raised after a survey JSON schema is loaded from the [SurveyJS Service](https://api.surveyjs.io). Use this event to modify the loaded schema.
         * @see surveyId
         * @see clientId
         * @see loadSurveyFromService
         */ _this.onLoadedSurveyFromService = _this.addEvent();
                    /**
         * An event that is raised when the survey processes [dynamic texts](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#dynamic-texts) and any text in curly brackets. Use this event, for instance, to substitute parameters in a RESTful URL with real values when you [load choices by URL](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model#choicesByUrl).
         */ _this.onProcessTextValue = _this.addEvent();
                    /**
         * An event that is raised before rendering a question. Use it to override default question CSS classes.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/customize-survey-with-css/ (linkStyle))
         * @see css
         */ _this.onUpdateQuestionCssClasses = _this.addEvent();
                    /**
         * An event that is raised before rendering a standalone panel and panels within [Dynamic Panel](https://surveyjs.io/form-library/examples/duplicate-group-of-fields-in-form/). Use it to override default panel CSS classes.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/customize-survey-with-css/ (linkStyle))
         * @see css
         */ _this.onUpdatePanelCssClasses = _this.addEvent();
                    /**
         * An event that is raised before rendering a page. Use it to override default page CSS classes.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/customize-survey-with-css/ (linkStyle))
         * @see css
         */ _this.onUpdatePageCssClasses = _this.addEvent();
                    /**
         * An event that is raised before rendering a choice item in Radio Button Group, Checkboxes, and Dropdown questions. Use it to override default CSS classes applied to choice items.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/customize-survey-with-css/ (linkStyle))
         * @see css
         */ _this.onUpdateChoiceItemCss = _this.addEvent();
                    /**
         * An event that is raised after the survey is rendered to the DOM. Use this event to modify survey markup.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-animation/ (linkStyle))
         */ _this.onAfterRenderSurvey = _this.addEvent();
                    _this.onAfterRenderHeader = _this.addEvent();
                    /**
         * An event that is raised after a page is rendered to the DOM. Use it to modify page markup.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-afterrender/ (linkStyle))
         */ _this.onAfterRenderPage = _this.addEvent();
                    /**
         * An event that is raised after a question is rendered to the DOM. Use it to modify question markup.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-afterrender/ (linkStyle))
         */ _this.onAfterRenderQuestion = _this.addEvent();
                    /**
         * An event that is raised after a question with a single input field is rendered to the DOM. Use it to modify question markup.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * > This event is not raised for questions without input fields ([HTML](https://surveyjs.io/form-library/documentation/questionhtmlmodel), [Image](https://surveyjs.io/form-library/documentation/questionimagemodel)) or questions with multiple input fields ([Matrix](https://surveyjs.io/form-library/documentation/questionmatrixmodel), [Multiple Text](https://surveyjs.io/form-library/documentation/questionmultipletextmodel)).
         */ _this.onAfterRenderQuestionInput = _this.addEvent();
                    /**
         * An event that is raised after a panel is rendered to the DOM. Use it to modify panel markup.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * > This event is raised for static [Panels](https://surveyjs.io/form-library/examples/set-properties-on-multiple-questions-using-panel/) as well as panels within a [Dynamic Panel](https://surveyjs.io/form-library/examples/duplicate-group-of-fields-in-form/).
         */ _this.onAfterRenderPanel = _this.addEvent();
                    /**
         * An event that is raised when an element (input field, checkbox, radio button) within a question gets focus.
         * @see onFocusInPanel
         * @see focusFirstQuestionAutomatic
         * @see focusQuestion
         */ _this.onFocusInQuestion = _this.addEvent();
                    /**
         * An event that is raised when an element within a panel gets focus.
         * @see onFocusInQuestion
         * @see focusFirstQuestionAutomatic
         * @see focusQuestion
         */ _this.onFocusInPanel = _this.addEvent();
                    /**
         * An event that is raised before a [choice item](https://surveyjs.io/form-library/documentation/api-reference/questionselectbase#choices) is displayed. Use this event to change the visibility of individual choice items in [Checkboxes](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model), [Dropdown](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model), [Radio Button Group](https://surveyjs.io/form-library/documentation/api-reference/radio-button-question-model), and other similar question types.
         */ _this.onShowingChoiceItem = _this.addEvent();
                    /**
         * Use this event to load choice items in [Dropdown](https://surveyjs.io/form-library/documentation/questiondropdownmodel) and [Tag Box](https://surveyjs.io/form-library/documentation/questiontagboxmodel) questions on demand.
         *
         * This event is raised only for those questions that have the [`choicesLazyLoadEnabled`](https://surveyjs.io/form-library/documentation/questiondropdownmodel#choicesLazyLoadEnabled) property set to `true`.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/lazy-loading-dropdown/ (linkStyle))
         */ _this.onChoicesLazyLoad = _this.addEvent();
                    /**
         * An event that is raised each time a search string in a [Dropdown](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model) or [Tag Box](https://surveyjs.io/form-library/documentation/api-reference/dropdown-tag-box-model) question changes. Use this event to implement custom filtering of choice options.
         * @see [QuestionDropdownModel.searchEnabled](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model#searchEnabled)
         * @see [QuestionDropdownModel.searchMode](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model#searchMode)
         */ _this.onChoicesSearch = _this.addEvent();
                    /**
         * Use this event to load a display text for the [default choice item](https://surveyjs.io/form-library/documentation/questiondropdownmodel#defaultValue) in [Dropdown](https://surveyjs.io/form-library/documentation/questiondropdownmodel) and [Tag Box](https://surveyjs.io/form-library/documentation/questiontagboxmodel) questions.
         *
         * If you load choices from a server (use [`choicesByUrl`](https://surveyjs.io/form-library/documentation/questiondropdownmodel#choicesByUrl) or [`onChoicesLazyLoad`](https://surveyjs.io/form-library/documentation/surveymodel#onChoicesLazyLoad)), display texts become available only when data is loaded, which does not happen until a user opens the drop-down menu. However, a display text for a default choice item is required before that. In this case, you can load data individually for the default item within the `onGetChoiceDisplayValue` event handler.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/lazy-loading-dropdown/ (linkStyle))
         */ _this.onGetChoiceDisplayValue = _this.addEvent();
                    /**
         * An event that is raised after a new row is added to a [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/).
         */ _this.onMatrixRowAdded = _this.addEvent();
                    /**
         * An event that is raised before a new row is added to a [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/).
         */ _this.onMatrixRowAdding = _this.addEvent();
                    /**
         * This event is obsolete. Use the [`onMatrixRowAdding`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onMatrixRowAdding) event instead.
         */ _this.onMatrixBeforeRowAdded = _this.onMatrixRowAdding;
                    /**
         * An event that is raised before a row is deleted from a [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/). You can cancel row deletion and clear row data instead.
         * @see onMatrixRenderRemoveButton
         */ _this.onMatrixRowRemoving = _this.addEvent();
                    /**
         * An event that is raised after a row is deleted from a [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/).
         * @see onMatrixRenderRemoveButton
         */ _this.onMatrixRowRemoved = _this.addEvent();
                    /**
         * An event that is raised before rendering the Remove button in a row of a [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/). Use this event to hide the Remove button for individual matrix rows.
         * @see onMatrixRowRemoving
         * @see onMatrixRowRemoved
         */ _this.onMatrixRenderRemoveButton = _this.addEvent();
                    /**
         * This event is obsolete. Use the [`onMatrixRenderRemoveButton`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onMatrixRenderRemoveButton) event instead.
         */ _this.onMatrixAllowRemoveRow = _this.onMatrixRenderRemoveButton;
                    /**
         * An event that is raised after the visibility of an [expandable detail section](https://surveyjs.io/form-library/examples/add-expandable-details-section-under-matrix-rows/) is changed. This event can be raised for [Multi-Select](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list) and [Dynamic Matrix](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model) questions.
         */ _this.onMatrixDetailPanelVisibleChanged = _this.addEvent();
                    /**
         * An event that is raised before a cell in a [Multi-Select Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdropdown/) or [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/) is created. Use this event to change the type of individual matrix cells.
         * @see onAfterRenderMatrixCell
         */ _this.onMatrixCellCreating = _this.addEvent();
                    /**
          * An event that is raised after a cell in a [Multi-Select Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdropdown/) or [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/) is created.
          * @see onAfterRenderMatrixCell
          */ _this.onMatrixCellCreated = _this.addEvent();
                    /**
         * An event that is raised for every matrix cell after it is rendered to the DOM.
         * @see onMatrixCellCreated
         */ _this.onAfterRenderMatrixCell = _this.addEvent();
                    /**
         * This event is obsolete. Use the [`onAfterRenderMatrixCell`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onAfterRenderMatrixCell) event instead.
         */ _this.onMatrixAfterCellRender = _this.onAfterRenderMatrixCell;
                    /**
         * An event that is raised after a cell value is changed in a [Multi-Select Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdropdown/) or [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/).
         * @see onMatrixRowAdding
         */ _this.onMatrixCellValueChanged = _this.addEvent();
                    /**
         * An event that is raised before a cell value is changed in a [Multi-Select Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdropdown/) or [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/). Use this event to change the cell value.
         * @see onMatrixRowAdding
         */ _this.onMatrixCellValueChanging = _this.addEvent();
                    /**
         * An event that is raised for [Multi-Select Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdropdown/) and [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/) questions when they validate a cell value. Use this event to display a custom error message based on a condition.
         * @see onMatrixRowAdding
         */ _this.onMatrixCellValidate = _this.addEvent();
                    /**
         * An event that is raised after a new column is added to a [Multi-Select Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdropdown/) or [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/).
         */ _this.onMatrixColumnAdded = _this.addEvent();
                    /**
         * An event that is raised on adding a new item in Multiple Text question.
         */ _this.onMultipleTextItemAdded = _this.addEvent();
                    /**
         * An event that is raised after a new panel is added to a [Dynamic Panel](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/) question.
         */ _this.onDynamicPanelAdded = _this.addEvent();
                    /**
         * An event that is raised after a panel is deleted from a [Dynamic Panel](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/) question.
         */ _this.onDynamicPanelRemoved = _this.addEvent();
                    /**
         * An event that is raised before a panel is deleted from a [Dynamic Panel](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/) question. Use this event to cancel the deletion.
         */ _this.onDynamicPanelRemoving = _this.addEvent();
                    /**
        * An event that is raised every second while the timer is running.
        *
        * Use the [`timeSpent`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#timeSpent) property to find out how many seconds have elapsed.
        * @see maxTimeToFinish
        * @see maxTimeToFinishPage
        * @see showTimerPanel
        * @see startTimer
        */ _this.onTimer = _this.addEvent();
                    _this.onTimerPanelInfoText = _this.addEvent();
                    /**
         * An event that is raised after an item value is changed in a panel within a [Dynamic Panel](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/) question.
         */ _this.onDynamicPanelItemValueChanged = _this.addEvent();
                    /**
         * An event that is raised before a [Dynamic Panel](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/) renders [tab titles](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model#templateTabTitle). Use this event to change individual tab titles.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/tabbed-interface-for-duplicate-group-option/ (linkStyle))
         */ _this.onGetDynamicPanelTabTitle = _this.addEvent();
                    /**
         * An event that is raised after the current panel is changed in a [Dynamic Panel](https://surveyjs.io/form-library/examples/questiontype-paneldynamic/) question.
         */ _this.onDynamicPanelCurrentIndexChanged = _this.addEvent();
                    /**
         * An event that is raised to define whether a question answer is correct. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey/create-a-quiz).
         */ _this.onIsAnswerCorrect = _this.addEvent();
                    /**
         * An event that is raised when users drag and drop survey elements while designing the survey in [Survey Creator](https://surveyjs.io/survey-creator/documentation/overview). Use this event to control drag and drop operations.
         * @see isDesignMode
         */ _this.onDragDropAllow = _this.addEvent();
                    /**
         * An event this is raised before a survey element (usually page) is scrolled to the top. Use this event to cancel the scroll operation.
         */ _this.onScrollingElementToTop = _this.addEvent();
                    _this.onLocaleChangedEvent = _this.addEvent();
                    /**
         * An event that allows you to add, delete, or modify actions in a question title.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-titleactions/ (linkStyle))
         * @see [IAction](https://surveyjs.io/form-library/documentation/api-reference/iaction)
        */ _this.onGetQuestionTitleActions = _this.addEvent();
                    /**
         * An event that allows you to add, delete, or modify actions in a panel title.
         * @see [IAction](https://surveyjs.io/form-library/documentation/api-reference/iaction)
         */ _this.onGetPanelTitleActions = _this.addEvent();
                    /**
         * An event that allows you to add, delete, or modify actions in a page title.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/modify-titles-of-survey-elements/ (linkStyle))
         * @see [IAction](https://surveyjs.io/form-library/documentation/api-reference/iaction)
         */ _this.onGetPageTitleActions = _this.addEvent();
                    /**
         * An event that allows you to add, delete, or modify actions in the footer of a [Panel](https://surveyjs.io/form-library/documentation/panelmodel).
         * @see [IAction](https://surveyjs.io/form-library/documentation/api-reference/iaction)
         */ _this.onGetPanelFooterActions = _this.addEvent();
                    /**
         * An event that allows you to add, delete, or modify actions in rows of a [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/).
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/employee-information-form/ (linkStyle))
         * @see [IAction](https://surveyjs.io/form-library/documentation/api-reference/iaction)
         */ _this.onGetMatrixRowActions = _this.addEvent();
                    /**
         * An event that is raised after a survey element is [expanded or collapsed](https://surveyjs.io/form-library/documentation/api-reference/question#state).
         */ _this.onElementContentVisibilityChanged = _this.addEvent();
                    /**
         * An event that is raised before an [Expression](https://surveyjs.io/form-library/documentation/api-reference/expression-model) question displays a value. Use this event to override the display value.
         */ _this.onGetExpressionDisplayValue = _this.addEvent();
                    /**
         * An event that is raised after the visibility of a popup is changed. This event can be raised for [Single-](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model) and [Multi-Select Dropdown](https://surveyjs.io/form-library/documentation/api-reference/dropdown-tag-box-model) questions and [Rating](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model) questions [rendered as drop-down menus](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model#displayMode).
         */ _this.onPopupVisibleChanged = _this.addEvent();
                    /**
         * A list of errors in a survey JSON schema.
         * @see ensureUniqueNames
         */ _this.jsonErrors = null;
                    _this.cssValue = null;
                    /**
         * Specifies whether to hide validation errors thrown by the Required validation in the UI.
         *
         * [Built-In Client-Side Validators](https://surveyjs.io/form-library/documentation/data-validation#built-in-client-side-validators (linkStyle))
         * @see validationEnabled
         * @see validationAllowSwitchPages
         */ _this.hideRequiredErrors = false;
                    //#endregion
                    _this.cssVariables = {};
                    _this._isMobile = false;
                    _this._isCompact = false;
                    _this._isDesignMode = false;
                    /**
         * Specifies whether data validation is enabled.
         *
         * Default value: `true`
         * @see checkErrorsMode
         * @see hideRequiredErrors
         */ _this.validationEnabled = true;
                    /**
         * Specifies whether respondents can switch the current page even if it contains validation errors.
         *
         * Default value: `false`
         * @see checkErrorsMode
         */ _this.validationAllowSwitchPages = false;
                    /**
         * Specifies whether respondents can end a survey with validation errors.
         *
         * Default value: `false`
         * @see checkErrorsMode
         */ _this.validationAllowComplete = false;
                    _this.isNavigationButtonPressed = false;
                    _this.mouseDownPage = null;
                    _this.isCalculatingProgressText = false;
                    _this.isFirstPageRendering = true;
                    _this.isCurrentPageRendering = true;
                    _this.isTriggerIsRunning = false;
                    _this.triggerValues = null;
                    _this.triggerKeys = null;
                    _this.conditionValues = null;
                    _this.isValueChangedOnRunningCondition = false;
                    _this.conditionRunnerCounter = 0;
                    _this.conditionUpdateVisibleIndexes = false;
                    _this.conditionNotifyElementsOnAnyValueOrVariableChanged = false;
                    _this.isEndLoadingFromJson = null;
                    _this.questionHashes = {
                        names: {},
                        namesInsensitive: {},
                        valueNames: {},
                        valueNamesInsensitive: {}
                    };
                    _this.needRenderIcons = true;
                    _this.skippedPages = [];
                    _this.skeletonComponentName = "sv-skeleton";
                    _this.taskManager = new _surveyTaskManager__WEBPACK_IMPORTED_MODULE_22__["SurveyTaskManagerModel"]();
                    if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_25__["DomDocumentHelper"].isAvailable()) SurveyModel.stylesManager = new _stylesmanager__WEBPACK_IMPORTED_MODULE_11__["StylesManager"]();
                    var htmlCallBack = function(str) {
                        return "<h3>" + str + "</h3>";
                    };
                    _this.createHtmlLocString("completedHtml", "completingSurvey", htmlCallBack);
                    _this.createHtmlLocString("completedBeforeHtml", "completingSurveyBefore", htmlCallBack, "completed-before");
                    _this.createHtmlLocString("loadingHtml", "loadingSurvey", htmlCallBack, "loading");
                    _this.createLocalizableString("emptySurveyText", _this, true, "emptySurvey");
                    _this.createLocalizableString("logo", _this, false);
                    _this.createLocalizableString("startSurveyText", _this, false, true);
                    _this.createLocalizableString("pagePrevText", _this, false, true);
                    _this.createLocalizableString("pageNextText", _this, false, true);
                    _this.createLocalizableString("completeText", _this, false, true);
                    _this.createLocalizableString("previewText", _this, false, true);
                    _this.createLocalizableString("editText", _this, false, true);
                    _this.createLocalizableString("questionTitleTemplate", _this, true);
                    _this.timerModelValue = new _surveyTimerModel__WEBPACK_IMPORTED_MODULE_12__["SurveyTimerModel"](_this);
                    _this.timerModelValue.onTimer = function(page) {
                        _this.doTimer(page);
                    };
                    _this.createNewArray("pages", function(value) {
                        _this.doOnPageAdded(value);
                    }, function(value) {
                        _this.doOnPageRemoved(value);
                    });
                    _this.createNewArray("triggers", function(value) {
                        value.setOwner(_this);
                    });
                    _this.createNewArray("calculatedValues", function(value) {
                        value.setOwner(_this);
                    });
                    _this.createNewArray("completedHtmlOnCondition", function(value) {
                        value.locOwner = _this;
                    });
                    _this.createNewArray("navigateToUrlOnCondition", function(value) {
                        value.locOwner = _this;
                    });
                    _this.registerPropertyChangedHandlers([
                        "locale"
                    ], function() {
                        _this.onSurveyLocaleChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "firstPageIsStarted"
                    ], function() {
                        _this.onFirstPageIsStartedChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "mode"
                    ], function() {
                        _this.onModeChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "progressBarType"
                    ], function() {
                        _this.updateProgressText();
                    });
                    _this.registerPropertyChangedHandlers([
                        "questionStartIndex",
                        "requiredText",
                        "questionTitlePattern"
                    ], function() {
                        _this.resetVisibleIndexes();
                    });
                    _this.registerPropertyChangedHandlers([
                        "isLoading",
                        "isCompleted",
                        "isCompletedBefore",
                        "mode",
                        "isStartedState",
                        "currentPage",
                        "isShowingPreview"
                    ], function() {
                        _this.updateState();
                    });
                    _this.registerPropertyChangedHandlers([
                        "state",
                        "currentPage",
                        "showPreviewBeforeComplete"
                    ], function() {
                        _this.onStateAndCurrentPageChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "logo",
                        "logoPosition"
                    ], function() {
                        _this.updateHasLogo();
                    });
                    _this.registerPropertyChangedHandlers([
                        "backgroundImage"
                    ], function() {
                        _this.updateRenderBackgroundImage();
                    });
                    _this.registerPropertyChangedHandlers([
                        "renderBackgroundImage",
                        "backgroundOpacity",
                        "backgroundImageFit",
                        "fitToContainer",
                        "backgroundImageAttachment"
                    ], function() {
                        _this.updateBackgroundImageStyle();
                    });
                    _this.registerPropertyChangedHandlers([
                        "showPrevButton",
                        "showCompleteButton"
                    ], function() {
                        _this.updateButtonsVisibility();
                    });
                    _this.onGetQuestionNo.onCallbacksChanged = function() {
                        _this.resetVisibleIndexes();
                    };
                    _this.onProgressText.onCallbacksChanged = function() {
                        _this.updateProgressText();
                    };
                    _this.onTextMarkdown.onCallbacksChanged = function() {
                        _this.locStrsChanged();
                    };
                    _this.onProcessHtml.onCallbacksChanged = function() {
                        _this.locStrsChanged();
                    };
                    _this.onGetQuestionTitle.onCallbacksChanged = function() {
                        _this.locStrsChanged();
                    };
                    _this.onUpdatePageCssClasses.onCallbacksChanged = function() {
                        _this.currentPage && _this.currentPage.updateElementCss();
                    };
                    _this.onUpdatePanelCssClasses.onCallbacksChanged = function() {
                        _this.currentPage && _this.currentPage.updateElementCss();
                    };
                    _this.onUpdateQuestionCssClasses.onCallbacksChanged = function() {
                        _this.currentPage && _this.currentPage.updateElementCss();
                    };
                    _this.onShowingChoiceItem.onCallbacksChanged = function() {
                        _this.rebuildQuestionChoices();
                    };
                    _this.navigationBarValue = _this.createNavigationBar();
                    _this.navigationBar.locOwner = _this;
                    _this.onBeforeCreating();
                    if (jsonObj) {
                        if (typeof jsonObj === "string" || jsonObj instanceof String) jsonObj = JSON.parse(jsonObj);
                        if (jsonObj && jsonObj.clientId) _this.clientId = jsonObj.clientId;
                        _this.fromJSON(jsonObj);
                        if (_this.surveyId) _this.loadSurveyFromService(_this.surveyId, _this.clientId);
                    }
                    _this.onCreating();
                    if (!!renderedElement) _this.render(renderedElement);
                    _this.updateCss();
                    _this.setCalculatedWidthModeUpdater();
                    _this.notifier = new _notifier__WEBPACK_IMPORTED_MODULE_19__["Notifier"](_this.css.saveData);
                    _this.notifier.addAction(_this.createTryAgainAction(), "error");
                    _this.onPopupVisibleChanged.add(function(_, opt) {
                        if (opt.visible) _this.onScrollCallback = function() {
                            opt.popup.toggleVisibility();
                        };
                        else _this.onScrollCallback = undefined;
                    });
                    _this.progressBarValue = new _progress_buttons__WEBPACK_IMPORTED_MODULE_23__["ProgressButtons"](_this);
                    _this.layoutElements.push({
                        id: "timerpanel",
                        template: "survey-timerpanel",
                        component: "sv-timerpanel",
                        data: _this.timerModel
                    });
                    _this.layoutElements.push({
                        id: "progress-buttons",
                        component: "sv-progress-buttons",
                        data: _this.progressBar,
                        processResponsiveness: function(width) {
                            return _this.progressBar.processResponsiveness && _this.progressBar.processResponsiveness(width);
                        }
                    });
                    _this.layoutElements.push({
                        id: "progress-questions",
                        component: "sv-progress-questions",
                        data: _this
                    });
                    _this.layoutElements.push({
                        id: "progress-pages",
                        component: "sv-progress-pages",
                        data: _this
                    });
                    _this.layoutElements.push({
                        id: "progress-correctquestions",
                        component: "sv-progress-correctquestions",
                        data: _this
                    });
                    _this.layoutElements.push({
                        id: "progress-requiredquestions",
                        component: "sv-progress-requiredquestions",
                        data: _this
                    });
                    _this.addLayoutElement({
                        id: "toc-navigation",
                        component: "sv-navigation-toc",
                        data: new _surveyToc__WEBPACK_IMPORTED_MODULE_24__["TOCModel"](_this)
                    });
                    _this.layoutElements.push({
                        id: "buttons-navigation",
                        component: "sv-action-bar",
                        data: _this.navigationBar
                    });
                    _this.locTitle.onStringChanged.add(function() {
                        return _this.titleIsEmpty = _this.locTitle.isEmpty;
                    });
                    return _this;
                }
                Object.defineProperty(SurveyModel, "cssType", {
                    get: function() {
                        return _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_4__["surveyCss"].currentType;
                    },
                    set: function(value) {
                        _stylesmanager__WEBPACK_IMPORTED_MODULE_11__["StylesManager"].applyTheme(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "platformName", {
                    get: function() {
                        return SurveyModel.platform;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "commentSuffix", {
                    /**
         * A suffix added to the name of the property that stores comments.
         *
         * Default value: "-Comment"
         *
         * Many question types allow respondents to leave comments. To enable this functionality, set a question's [`showCommentArea`](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model#showCommentArea) property to `true`. Comment values are saved in a separate property. The property name is composed of the question `name` and `commentSuffix`.
         *
         * Respondents can also leave comments when they select "Other" in choice-based questions, such as Dropdown or Checkboxes. The property name for the comment value is composed according to the same rules. However, you can use the question `name` as a key to store the comment value instead. Disable the [`storeOthersAsComment`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#storeOthersAsComment) property in this case.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/create-checkboxes-question-in-javascript/ (linkStyle))
         */ get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].commentSuffix;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].commentSuffix = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "commentPrefix", {
                    get: function() {
                        return this.commentSuffix;
                    },
                    set: function(val1) {
                        this.commentSuffix = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.processClosedPopup = function(question, popupModel) {
                    throw new Error("Method not implemented.");
                };
                SurveyModel.prototype.createTryAgainAction = function() {
                    var _this = this;
                    return {
                        id: "save-again",
                        title: this.getLocalizationString("saveAgainButton"),
                        action: function() {
                            if (_this.isCompleted) _this.saveDataOnComplete();
                            else _this.doComplete();
                        }
                    };
                };
                SurveyModel.prototype.createHtmlLocString = function(name, locName, func, reason) {
                    var _this = this;
                    var res = this.createLocalizableString(name, this, false, locName);
                    res.onGetLocalizationTextCallback = func;
                    if (reason) res.onGetTextCallback = function(str) {
                        return _this.processHtml(str, reason);
                    };
                };
                SurveyModel.prototype.getType = function() {
                    return "survey";
                };
                SurveyModel.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {
                    if (name === "questionsOnPageMode") this.onQuestionsOnPageModeChanged(oldValue);
                };
                Object.defineProperty(SurveyModel.prototype, "pages", {
                    /**
         * Returns an array of all pages in the survey.
         *
         * To get an array of only visible pages, use the [`visiblePages`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#visiblePages) array.
         * @see PageModel
         */ get: function() {
                        return this.getPropertyValue("pages");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.render = function(element) {
                    if (element === void 0) element = null;
                    if (this.renderCallback) this.renderCallback();
                };
                SurveyModel.prototype.updateSurvey = function(newProps, oldProps) {
                    var _loop_1 = function() {
                        if (key == "model" || key == "children") return "continue";
                        if (key.indexOf("on") == 0 && this_1[key] && this_1[key].add) {
                            var funcBody_1 = newProps[key];
                            var func = function(sender, options) {
                                funcBody_1(sender, options);
                            };
                            this_1[key].add(func);
                        } else this_1[key] = newProps[key];
                    };
                    var this_1 = this;
                    for(var key in newProps)_loop_1();
                    if (newProps && newProps.data) this.onValueChanged.add(function(sender, options) {
                        newProps.data[options.name] = options.value;
                    });
                };
                SurveyModel.prototype.getCss = function() {
                    return this.css;
                };
                SurveyModel.prototype.updateCompletedPageCss = function() {
                    this.containerCss = this.css.container;
                    this.completedCss = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.body).append(this.css.completedPage).toString(); // for completed page
                    this.completedBeforeCss = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.body).append(this.css.completedBeforePage).toString();
                    this.loadingBodyCss = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.body).append(this.css.bodyLoading).toString();
                };
                SurveyModel.prototype.updateCss = function() {
                    this.rootCss = this.getRootCss();
                    this.updateNavigationCss();
                    this.updateCompletedPageCss();
                    this.updateWrapperFormCss();
                };
                Object.defineProperty(SurveyModel.prototype, "css", {
                    /**
         * Gets or sets an object in which keys are UI elements and values are CSS classes applied to them.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/customize-survey-with-css/ (linkStyle))
         */ get: function() {
                        if (!this.cssValue) {
                            this.cssValue = {};
                            this.copyCssClasses(this.cssValue, _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_4__["surveyCss"].getCss());
                        }
                        return this.cssValue;
                    },
                    set: function(value) {
                        this.setCss(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.setCss = function(value, needMerge) {
                    if (needMerge === void 0) needMerge = true;
                    if (needMerge) this.mergeValues(value, this.css);
                    else this.cssValue = value;
                    this.updateCss();
                    this.updateElementCss(false);
                };
                Object.defineProperty(SurveyModel.prototype, "cssTitle", {
                    get: function() {
                        return this.css.title;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "cssNavigationComplete", {
                    get: function() {
                        return this.getNavigationCss(this.cssSurveyNavigationButton, this.css.navigation.complete);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "cssNavigationPreview", {
                    get: function() {
                        return this.getNavigationCss(this.cssSurveyNavigationButton, this.css.navigation.preview);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "cssNavigationEdit", {
                    get: function() {
                        return this.getNavigationCss(this.css.navigationButton, this.css.navigation.edit);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "cssNavigationPrev", {
                    get: function() {
                        return this.getNavigationCss(this.cssSurveyNavigationButton, this.css.navigation.prev);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "cssNavigationStart", {
                    get: function() {
                        return this.getNavigationCss(this.cssSurveyNavigationButton, this.css.navigation.start);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "cssNavigationNext", {
                    get: function() {
                        return this.getNavigationCss(this.cssSurveyNavigationButton, this.css.navigation.next);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "cssSurveyNavigationButton", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.navigationButton).append(this.css.bodyNavigationButton).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "bodyCss", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.body).append(this.css.bodyWithTimer, this.showTimerPanel != "none" && this.state === "running").append(this.css.body + "--" + this.calculatedWidthMode).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "bodyContainerCss", {
                    get: function() {
                        return this.css.bodyContainer;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.insertAdvancedHeader = function(advHeader) {
                    advHeader.survey = this;
                    this.layoutElements.push({
                        id: "advanced-header",
                        container: "header",
                        component: "sv-header",
                        index: -100,
                        data: advHeader,
                        processResponsiveness: function(width) {
                            return advHeader.processResponsiveness(width);
                        }
                    });
                };
                SurveyModel.prototype.getNavigationCss = function(main, btn) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(main).append(btn).toString();
                };
                Object.defineProperty(SurveyModel.prototype, "lazyRendering", {
                    /**
         * Specifies whether to enable lazy rendering.
         *
         * In default mode, a survey renders the entire current page. With lazy rendering, the survey renders the page gradually as a user scrolls it. This helps reduce survey startup time and optimizes large surveys for low-end devices.
         *
         * Default value: `false`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-lazy/ (linkStyle))
         * @see [settings.lazyRender](https://surveyjs.io/form-library/documentation/api-reference/settings#lazyRender)
         */ get: function() {
                        return this.lazyRenderingValue === true;
                    },
                    set: function(val1) {
                        if (this.lazyRendering === val1) return;
                        this.lazyRenderingValue = val1;
                        var page = this.currentPage;
                        if (!!page) page.updateRows();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isLazyRendering", {
                    get: function() {
                        return this.lazyRendering || _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].lazyRender.enabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "lazyRenderingFirstBatchSize", {
                    get: function() {
                        return this.lazyRenderingFirstBatchSizeValue || _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].lazyRender.firstBatchSize;
                    },
                    set: function(val1) {
                        this.lazyRenderingFirstBatchSizeValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateLazyRenderingRowsOnRemovingElements = function() {
                    if (!this.isLazyRendering) return;
                    var page = this.currentPage;
                    if (!!page) Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["scrollElementByChildId"])(page.id);
                };
                Object.defineProperty(SurveyModel.prototype, "triggers", {
                    /**
         * A list of triggers in the survey.
         *
         * [Conditional Survey Logic (Triggers)](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-survey-logic-triggers (linkStyle))
         * @see runTriggers
         * @see onTriggerExecuted
         */ get: function() {
                        return this.getPropertyValue("triggers");
                    },
                    set: function(val1) {
                        this.setPropertyValue("triggers", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "calculatedValues", {
                    /**
         * An array of [calculated values](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#calculated-values).
         */ get: function() {
                        return this.getPropertyValue("calculatedValues");
                    },
                    set: function(val1) {
                        this.setPropertyValue("calculatedValues", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "surveyId", {
                    /**
         * The identifier of a survey JSON schema to load from [SurveyJS Service](https://api.surveyjs.io).
         *
         * Refer to the following help topic for more information: [Store Survey Results in the SurveyJS Service](https://surveyjs.io/form-library/documentation/handle-survey-results-store#store-survey-results-in-the-surveyjs-service).
         * @see loadSurveyFromService
         * @see onLoadedSurveyFromService
         */ get: function() {
                        return this.getPropertyValue("surveyId", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("surveyId", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "surveyPostId", {
                    /**
         * An identifier used to save survey results to [SurveyJS Service](https://api.surveyjs.io).
         *
         * Refer to the following help topic for more information: [Store Survey Results in the SurveyJS Service](https://surveyjs.io/form-library/documentation/handle-survey-results-store#store-survey-results-in-the-surveyjs-service).
         * @see onComplete
         * @see surveyShowDataSaving
         */ get: function() {
                        return this.getPropertyValue("surveyPostId", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("surveyPostId", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "clientId", {
                    /**
         * A user identifier (e-mail or other unique ID).
         *
         * If your application works with [SurveyJS Service](https://api.surveyjs.io), the ID ensures that users do not pass the same survey twice. On the second run, they will see the [Completed Before page](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#completedBeforeHtml).
         * @see cookieName
         */ get: function() {
                        return this.getPropertyValue("clientId", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("clientId", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "cookieName", {
                    /**
         * A cookie name used to save information about survey completion.
         *
         * When this property has a value, the survey creates a cookie with the specified name on completion. This cookie helps ensure that users do not pass the same survey twice. On the second run, they will see the [Completed Before page](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#completedBeforeHtml).
         * @see clientId
         */ get: function() {
                        return this.getPropertyValue("cookieName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("cookieName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "sendResultOnPageNext", {
                    /**
         * Specifies whether to save survey results when respondents switch between pages. Handle the [`onPartialSend`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onPartialSend) event to implement the save operation.
         *
         * Alternatively, you can handle the [`onCurrentPageChanged`](#onCurrentPageChanged) and [`onValueChanged`](#onValueChanged) events, as shown in the following demo: [Continue an Incomplete Survey](https://surveyjs.io/form-library/examples/survey-editprevious/).
         */ get: function() {
                        return this.getPropertyValue("sendResultOnPageNext");
                    },
                    set: function(val1) {
                        this.setPropertyValue("sendResultOnPageNext", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "surveyShowDataSaving", {
                    /**
         * Specifies whether to show progress when the survey sends data to [SurveyJS Service](https://api.surveyjs.io).
         *
         * [View Demo](https://surveyjs.io/form-library/examples/save-survey-results-and-load-surveys-from-surveyjs-service/ (linkStyle))
         * @see surveyPostId
         */ get: function() {
                        return this.getPropertyValue("surveyShowDataSaving");
                    },
                    set: function(val1) {
                        this.setPropertyValue("surveyShowDataSaving", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "focusFirstQuestionAutomatic", {
                    /**
         * Specifies whether to focus the first question on the page on survey startup or when users switch between pages.
         *
         * Default value: `false` in v1.9.114 and later, `true` in earlier versions
         * @see focusOnFirstError
         * @see focusFirstQuestion
         * @see focusQuestion
         */ get: function() {
                        return this.getPropertyValue("focusFirstQuestionAutomatic");
                    },
                    set: function(val1) {
                        this.setPropertyValue("focusFirstQuestionAutomatic", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "focusOnFirstError", {
                    /**
         * Specifies whether to focus the first question with a validation error on the current page.
         *
         * Default value: `true`
         * @see validate
         * @see focusFirstQuestionAutomatic
         */ get: function() {
                        return this.getPropertyValue("focusOnFirstError");
                    },
                    set: function(val1) {
                        this.setPropertyValue("focusOnFirstError", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showNavigationButtons", {
                    /**
         * Gets or sets the position of the Start, Next, Previous, and Complete navigation buttons and controls their visibility.
         *
         * Possible values:
         *
         * - `"bottom"` (default) - Displays the navigation buttons below survey content.
         * - `"top"` - Displays the navigation buttons above survey content.
         * - `"both"` - Displays the navigation buttons above and below survey content.
         * - `"none"` - Hides the navigation buttons. This setting may be useful if you [implement custom external navigation](https://surveyjs.io/form-library/examples/external-form-navigation-system/).
         * @see goNextPageAutomatic
         * @see showPrevButton
         * @see showCompleteButton
         */ get: function() {
                        return this.getPropertyValue("showNavigationButtons");
                    },
                    set: function(val1) {
                        if (val1 === true || val1 === undefined) val1 = "bottom";
                        if (val1 === false) val1 = "none";
                        this.setPropertyValue("showNavigationButtons", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showPrevButton", {
                    /**
         * Specifies whether to display the Previous button. Set this property to `false` if respondents should not move backward along the survey.
         * @see showNavigationButtons
         * @see showCompleteButton
         */ get: function() {
                        return this.getPropertyValue("showPrevButton");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showPrevButton", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showCompleteButton", {
                    /**
         * Specifies whether to display the Complete button. Set this property to `false` if respondents should not complete the survey.
         * @see showNavigationButtons
         * @see showPrevButton
         */ get: function() {
                        return this.getPropertyValue("showCompleteButton", true);
                    },
                    set: function(val1) {
                        this.setPropertyValue("showCompleteButton", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showTOC", {
                    /**
         * Gets or sets the visibility of the table of contents.
         *
         * Default value: `false`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/toc-feature/ (linkStyle))
         * @see tocLocation
         */ get: function() {
                        return this.getPropertyValue("showTOC");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showTOC", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "tocLocation", {
                    /**
         * Gets or sets the position of the table of contents. Applies only when the table of contents is visible.
         *
         * Possible values:
         *
         * - `"left"` (default)
         * - `"right"`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/toc-feature/ (linkStyle))
         * @see showTOC
         */ get: function() {
                        return this.getPropertyValue("tocLocation");
                    },
                    set: function(val1) {
                        this.setPropertyValue("tocLocation", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showTitle", {
                    /**
         * Specifies whether to display the [survey title](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#title).
         *
         * [View Demo](https://surveyjs.io/form-library/examples/brand-your-survey-header/ (linkStyle))
         * @see title
         */ get: function() {
                        return this.getPropertyValue("showTitle");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showTitle", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showPageTitles", {
                    /**
         * Specifies whether to display [page titles](https://surveyjs.io/form-library/documentation/api-reference/page-model#title).
         */ get: function() {
                        return this.getPropertyValue("showPageTitles");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showPageTitles", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showCompletedPage", {
                    /**
         * Specifies whether to show the [complete page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#complete-page).
         * @see onComplete
         * @see navigateToUrl
         */ get: function() {
                        return this.getPropertyValue("showCompletedPage");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showCompletedPage", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "navigateToUrl", {
                    /**
         * A URL to which respondents should be navigated after survey completion.
         * @see onNavigateToUrl
         * @see navigateToUrlOnCondition
         */ get: function() {
                        return this.getPropertyValue("navigateToUrl");
                    },
                    set: function(val1) {
                        this.setPropertyValue("navigateToUrl", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "navigateToUrlOnCondition", {
                    /**
         * An array of objects that allows you to navigate respondents to different URLs after survey completion.
         *
         * Each object should include the [`expression`](https://surveyjs.io/form-library/documentation/api-reference/urlconditionitem#url) and [`url`](https://surveyjs.io/form-library/documentation/api-reference/urlconditionitem#expression) properties. When `expression` evaluates to `true`, the survey navigates to the corresponding `url`. Refer to the following help topic for more information about expressions: [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions).
         * @see onNavigateToUrl
         * @see navigateToUrl
         */ get: function() {
                        return this.getPropertyValue("navigateToUrlOnCondition");
                    },
                    set: function(val1) {
                        this.setPropertyValue("navigateToUrlOnCondition", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getNavigateToUrl = function() {
                    var item = this.getExpressionItemOnRunCondition(this.navigateToUrlOnCondition);
                    var url = !!item ? item.url : this.navigateToUrl;
                    if (!!url) url = this.processText(url, false);
                    return url;
                };
                SurveyModel.prototype.navigateTo = function() {
                    var url = this.getNavigateToUrl();
                    var options = {
                        url: url,
                        allow: true
                    };
                    this.onNavigateToUrl.fire(this, options);
                    if (!options.url || !options.allow) return;
                    Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["navigateToUrl"])(options.url);
                };
                Object.defineProperty(SurveyModel.prototype, "requiredText", {
                    /**
         * Specifies one or multiple characters that designate required questions.
         *
         * Default value: `*`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/modify-question-title/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("requiredText", "*");
                    },
                    set: function(val1) {
                        this.setPropertyValue("requiredText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.beforeSettingQuestionErrors = function(question, errors) {
                    this.makeRequiredErrorsInvisible(errors);
                    this.onSettingQuestionErrors.fire(this, {
                        question: question,
                        errors: errors
                    });
                };
                SurveyModel.prototype.beforeSettingPanelErrors = function(question, errors) {
                    this.makeRequiredErrorsInvisible(errors);
                };
                SurveyModel.prototype.makeRequiredErrorsInvisible = function(errors) {
                    if (!this.hideRequiredErrors) return;
                    for(var i = 0; i < errors.length; i++){
                        var erType = errors[i].getErrorType();
                        if (erType == "required" || erType == "requireoneanswer") errors[i].visible = false;
                    }
                };
                Object.defineProperty(SurveyModel.prototype, "questionStartIndex", {
                    /**
         * Specifies the initial number or letter from which to start question numbering.
         *
         * [Question Numbers](https://surveyjs.io/form-library/documentation/design-survey/configure-question-titles#question-numbers (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("questionStartIndex", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("questionStartIndex", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "storeOthersAsComment", {
                    /**
         * Specifies whether to store the "Other" option response in a separate property.
         *
         * Default value: `true`
         *
         * Respondents can leave comments when they select "Other" in choice-based questions, such as Dropdown or Checkboxes. Comment values are saved in a separate property. The property name is composed of the question `name` and [`commentSuffix`](#commentSuffix). However, you can use the question `name` as a key to store the comment value instead. Disable the `storeOthersAsComment` property in this case.
         * @see maxOthersLength
         */ get: function() {
                        return this.getPropertyValue("storeOthersAsComment");
                    },
                    set: function(val1) {
                        this.setPropertyValue("storeOthersAsComment", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "maxTextLength", {
                    /**
         * Specifies the maximum text length in textual questions ([Single-Line Input](https://surveyjs.io/form-library/examples/text-entry-question/), [Long Text](https://surveyjs.io/form-library/examples/add-open-ended-question-to-a-form/), [Multiple Textboxes](https://surveyjs.io/form-library/examples/multiple-text-box-question/)), measured in characters.
         *
         * Default value: 0 (unlimited)
         *
         * You can override this setting for individual questions if you specify their [`maxLength`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#maxLength) property.
         * @see maxOthersLength
         */ get: function() {
                        return this.getPropertyValue("maxTextLength");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxTextLength", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "maxOthersLength", {
                    /**
         * Specifies the maximum text length for question comments. Applies to questions with the [`showCommentArea`](https://surveyjs.io/form-library/documentation/api-reference/question#showCommentArea) or [`showOtherItem`](https://surveyjs.io/form-library/documentation/api-reference/question#showOtherItem) property set to `true`.
         *
         * Default value: 0 (unlimited)
         * @see maxTextLength
         */ get: function() {
                        return this.getPropertyValue("maxOthersLength");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxOthersLength", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "goNextPageAutomatic", {
                    /**
         * Specifies whether the survey switches to the next page automatically after a user answers all questions on the current page.
         *
         * Default value: `false`
         *
         * If you enable this property, the survey is also completed automatically. Set the [`allowCompleteSurveyAutomatic`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#allowCompleteSurveyAutomatic) property to `false` if you want to disable this behavior.
         *
         * > If any of the following questions is answered last, the survey does not switch to the next page: Checkboxes, Yes/No (Boolean) (rendered as Checkbox), Long Text, Signature, Image Picker (with Multi Select), File Upload, Single-Select Matrix (not all rows are answered), Dynamic Matrix, Dynamic Panel.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/automatically-move-to-next-page-if-answer-selected/ (linkStyle))
         * @see [`settings.autoAdvanceDelay`](https://surveyjs.io/form-library/documentation/api-reference/settings#autoAdvanceDelay)
         */ get: function() {
                        return this.getPropertyValue("goNextPageAutomatic");
                    },
                    set: function(val1) {
                        this.setPropertyValue("goNextPageAutomatic", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "allowCompleteSurveyAutomatic", {
                    /**
         * Specifies whether to complete the survey automatically after a user answers all questions on the last page. Applies only if the [`goNextPageAutomatic`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#goNextPageAutomatic) property is `true`.
         *
         * Default value: `true`
         * @see [`settings.autoAdvanceDelay`](https://surveyjs.io/form-library/documentation/api-reference/settings#autoAdvanceDelay)
         */ get: function() {
                        return this.getPropertyValue("allowCompleteSurveyAutomatic");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowCompleteSurveyAutomatic", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "checkErrorsMode", {
                    /**
         * Specifies when the survey validates answers.
         *
         * Possible values:
         *
         * - `"onNextPage"` (default) - Triggers validation before the survey is switched to the next page or completed.
         * - `"onValueChanged"` - Triggers validation each time a question value is changed.
         * - `"onComplete"` - Triggers validation when a user clicks the Complete button. If previous pages contain errors, the survey switches to the page with the first error.
         *
         * Refer to the following help topic for more information: [Data Validation](https://surveyjs.io/form-library/documentation/data-validation).
         * @see validationEnabled
         * @see validationAllowSwitchPages
         * @see validationAllowComplete
         * @see validate
         */ get: function() {
                        return this.getPropertyValue("checkErrorsMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("checkErrorsMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "autoGrowComment", {
                    /**
         * Specifies whether to increase the height of [Long Text](https://surveyjs.io/form-library/examples/add-open-ended-question-to-a-form/) questions and other text areas to accommodate multi-line text content.
         *
         * Default value: `false`
         *
         * You can override this property for individual Long Text questions: [`autoGrow`](https://surveyjs.io/form-library/documentation/api-reference/comment-field-model#autoGrow).
         * @see allowResizeComment
         */ get: function() {
                        return this.getPropertyValue("autoGrowComment");
                    },
                    set: function(val1) {
                        this.setPropertyValue("autoGrowComment", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "allowResizeComment", {
                    /**
         * Specifies whether to display a resize handle for [Long Text](https://surveyjs.io/form-library/examples/add-open-ended-question-to-a-form/) questions and other text areas intended for multi-line text content.
         *
         * Default value: `true`
         *
         * You can override this property for individual Long Text questions: [`allowResize`](https://surveyjs.io/form-library/documentation/api-reference/comment-field-model#allowResize).
         * @see autoGrowComment
         */ get: function() {
                        return this.getPropertyValue("allowResizeComment");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowResizeComment", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "textUpdateMode", {
                    /**
         * Specifies when to update the question value in questions with a text input field.
         *
         * Possible values:
         *
         * - `"onBlur"` (default) - Updates the value after the input field loses focus.
         * - `"onTyping"` - Updates the value on every key press.
         *
         * > Do not use the `"onTyping"` mode if your survey contains many expressions. Expressions are reevaluated each time a question value is changed. In `"onTyping"` mode, the question value changes frequently. This may cause performance degradation.
         *
         * You can override this setting for individual questions: [`textUpdateMode`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#textUpdateMode).
         */ get: function() {
                        return this.getPropertyValue("textUpdateMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("textUpdateMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "clearInvisibleValues", {
                    /**
         * Specifies when to remove values of invisible questions from [survey results](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#data).
         *
         * Possible values:
         *
         * - `"onComplete"` (default) - Clears invisible question values when the survey is complete.
         * - `"onHidden"` - Clears a question value when the question becomes invisible. If the question is invisible initially, its value is removed on survey completion.
         * - `"onHiddenContainer"` - Clears a question value when the question or its containter (page or panel) becomes invisible. If the question is invisible initially, its value is removed on survey completion.
         * - `"none"` - Keeps invisible values in survey results.
         * - `true` - Equivalent to `"onComplete"`.
         * - `false` - Equivalent to `"none"`.
         * @see [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-visibility)
         * @see onComplete
         */ get: function() {
                        return this.getPropertyValue("clearInvisibleValues");
                    },
                    set: function(val1) {
                        if (val1 === true) val1 = "onComplete";
                        if (val1 === false) val1 = "none";
                        this.setPropertyValue("clearInvisibleValues", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Removes values that cannot be assigned to a question, for example, choices unlisted in the `choices` array.
     *
     * Call this method after you assign new question values in code to ensure that they are acceptable.
     *
     * > This method does not remove values that fail validation. Call the [`validate()`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#validate) method to validate newly assigned values.
     * @param removeNonExistingRootKeys Pass `true` to remove values that do not correspond to any question or [calculated value](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#calculated-values).
     */ SurveyModel.prototype.clearIncorrectValues = function(removeNonExistingRootKeys) {
                    if (removeNonExistingRootKeys === void 0) removeNonExistingRootKeys = false;
                    for(var i = 0; i < this.pages.length; i++)this.pages[i].clearIncorrectValues();
                    if (!removeNonExistingRootKeys) return;
                    var data = this.data;
                    var hasChanges = false;
                    for(var key in data){
                        if (!!this.getQuestionByValueName(key)) continue;
                        if (this.iscorrectValueWithPostPrefix(key, _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].commentSuffix) || this.iscorrectValueWithPostPrefix(key, _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].matrix.totalsSuffix)) continue;
                        var calcValue = this.getCalculatedValueByName(key);
                        if (!!calcValue && calcValue.includeIntoResult) continue;
                        hasChanges = true;
                        delete data[key];
                    }
                    if (hasChanges) this.data = data;
                };
                SurveyModel.prototype.iscorrectValueWithPostPrefix = function(key, postPrefix) {
                    if (key.indexOf(postPrefix) !== key.length - postPrefix.length) return false;
                    return !!this.getQuestionByValueName(key.substring(0, key.indexOf(postPrefix)));
                };
                Object.defineProperty(SurveyModel.prototype, "keepIncorrectValues", {
                    /**
         * Specifies whether to keep values that cannot be assigned to questions, for example, choices unlisted in the `choices` array.
         *
         * > This property cannot be specified in the survey JSON schema. Use dot notation to specify it.
         * @see clearIncorrectValues
         */ get: function() {
                        return this.getPropertyValue("keepIncorrectValues");
                    },
                    set: function(val1) {
                        this.setPropertyValue("keepIncorrectValues", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locale", {
                    /**
         * Specifies the survey's locale.
         *
         * Default value: `""` (a default locale is used)
         *
         * [Localization & Globalization help topic](https://surveyjs.io/form-library/documentation/survey-localization (linkStyle))
         *
         * [Survey Localization demo](https://surveyjs.io/form-library/examples/survey-localization/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValueWithoutDefault("locale") || _surveyStrings__WEBPACK_IMPORTED_MODULE_8__["surveyLocalization"].currentLocale;
                    },
                    set: function(value) {
                        if (value === _surveyStrings__WEBPACK_IMPORTED_MODULE_8__["surveyLocalization"].defaultLocale && !_surveyStrings__WEBPACK_IMPORTED_MODULE_8__["surveyLocalization"].currentLocale) value = "";
                        this.setPropertyValue("locale", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.onSurveyLocaleChanged = function() {
                    this.notifyElementsOnAnyValueOrVariableChanged("locale");
                    this.localeChanged();
                    this.onLocaleChangedEvent.fire(this, this.locale);
                };
                /**
     * Returns an array of locales whose translations are used in the survey.
     *
     * [Localization & Globalization help topic](https://surveyjs.io/form-library/documentation/survey-localization (linkStyle))
     *
     * [Survey Localization demo](https://surveyjs.io/form-library/examples/survey-localization/ (linkStyle))
     */ SurveyModel.prototype.getUsedLocales = function() {
                    var locs = new Array();
                    this.addUsedLocales(locs);
                    //Replace the default locale with the real one
                    var index = locs.indexOf("default");
                    if (index > -1) {
                        var defaultLoc = _surveyStrings__WEBPACK_IMPORTED_MODULE_8__["surveyLocalization"].defaultLocale;
                        //Remove the defaultLoc
                        var defIndex = locs.indexOf(defaultLoc);
                        if (defIndex > -1) locs.splice(defIndex, 1);
                        index = locs.indexOf("default");
                        locs[index] = defaultLoc;
                    }
                    return locs;
                };
                SurveyModel.prototype.localeChanged = function() {
                    for(var i = 0; i < this.pages.length; i++)this.pages[i].localeChanged();
                };
                //ILocalizableOwner
                SurveyModel.prototype.getLocale = function() {
                    return this.locale;
                };
                SurveyModel.prototype.locStrsChanged = function() {
                    if (this.isClearingUnsedValues) return;
                    _super.prototype.locStrsChanged.call(this);
                    if (!this.currentPage) return;
                    if (this.isDesignMode) this.pages.forEach(function(page) {
                        return page.locStrsChanged();
                    });
                    else {
                        var page = this.activePage;
                        if (!!page) page.locStrsChanged();
                        var visPages = this.visiblePages;
                        for(var i = 0; i < visPages.length; i++)visPages[i].navigationLocStrChanged();
                    }
                    if (!this.isShowStartingPage) this.updateProgressText();
                    this.navigationBar.locStrsChanged();
                };
                SurveyModel.prototype.getMarkdownHtml = function(text, name) {
                    return this.getSurveyMarkdownHtml(this, text, name);
                };
                SurveyModel.prototype.getRenderer = function(name) {
                    return this.getRendererForString(this, name);
                };
                SurveyModel.prototype.getRendererContext = function(locStr) {
                    return this.getRendererContextForString(this, locStr);
                };
                SurveyModel.prototype.getRendererForString = function(element, name) {
                    var renderAs = this.getBuiltInRendererForString(element, name);
                    var options = {
                        element: element,
                        name: name,
                        renderAs: renderAs
                    };
                    this.onTextRenderAs.fire(this, options);
                    return options.renderAs;
                };
                SurveyModel.prototype.getRendererContextForString = function(element, locStr) {
                    return locStr;
                };
                SurveyModel.prototype.getExpressionDisplayValue = function(question, value, displayValue) {
                    var options = {
                        question: question,
                        value: value,
                        displayValue: displayValue
                    };
                    this.onGetExpressionDisplayValue.fire(this, options);
                    return options.displayValue;
                };
                SurveyModel.prototype.getBuiltInRendererForString = function(element, name) {
                    if (this.isDesignMode) return _localizablestring__WEBPACK_IMPORTED_MODULE_10__["LocalizableString"].editableRenderer;
                    return undefined;
                };
                SurveyModel.prototype.getProcessedText = function(text) {
                    return this.processText(text, true);
                };
                SurveyModel.prototype.getLocString = function(str) {
                    return this.getLocalizationString(str);
                };
                //ISurveyErrorOwner
                SurveyModel.prototype.getErrorCustomText = function(text, error) {
                    return this.getSurveyErrorCustomText(this, text, error);
                };
                SurveyModel.prototype.getSurveyErrorCustomText = function(obj, text, error) {
                    var options = {
                        text: text,
                        name: error.getErrorType(),
                        obj: obj,
                        error: error
                    };
                    this.onErrorCustomText.fire(this, options);
                    return options.text;
                };
                SurveyModel.prototype.getQuestionDisplayValue = function(question, displayValue) {
                    var options = {
                        question: question,
                        displayValue: displayValue
                    };
                    this.onGetQuestionDisplayValue.fire(this, options);
                    return options.displayValue;
                };
                Object.defineProperty(SurveyModel.prototype, "emptySurveyText", {
                    /**
         * A message that is displayed when a survey does not contain visible pages or questions.
         * @see [Localization & Globalization](https://surveyjs.io/form-library/documentation/survey-localization)
         */ get: function() {
                        return this.getLocalizableStringText("emptySurveyText");
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("emptySurveyText", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "logo", {
                    //#region Title/Header options
                    /**
         * An image URL or a Base64-encoded image to use as a survey logo.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-logo/ (linkStyle))
         * @see logoPosition
         * @see logoFit
         */ get: function() {
                        return this.getLocalizableStringText("logo");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("logo", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locLogo", {
                    get: function() {
                        return this.getLocalizableString("logo");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "logoWidth", {
                    /**
         * A logo width in CSS-accepted values.
         *
         * Default value: `300px`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-logo/ (linkStyle))
         * @see logoHeight
         * @see logo
         * @see logoPosition
         * @see logoFit
         */ get: function() {
                        return this.getPropertyValue("logoWidth");
                    },
                    set: function(value) {
                        this.setPropertyValue("logoWidth", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedLogoWidth", {
                    get: function() {
                        return this.logoWidth ? Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["getRenderedSize"])(this.logoWidth) : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedStyleLogoWidth", {
                    get: function() {
                        return this.logoWidth ? Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["getRenderedStyleSize"])(this.logoWidth) : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "logoHeight", {
                    /**
         * A logo height in CSS-accepted values.
         *
         * Default value: `200px`
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-logo/ (linkStyle))
         * @see logoHeight
         * @see logo
         * @see logoPosition
         * @see logoFit
         */ get: function() {
                        return this.getPropertyValue("logoHeight");
                    },
                    set: function(value) {
                        this.setPropertyValue("logoHeight", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedLogoHeight", {
                    get: function() {
                        return this.logoHeight ? Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["getRenderedSize"])(this.logoHeight) : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedStyleLogoHeight", {
                    get: function() {
                        return this.logoHeight ? Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["getRenderedStyleSize"])(this.logoHeight) : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "logoPosition", {
                    /**
         * A logo position relative to the [survey title](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#title).
         *
         * Possible values:
         *
         * - `"left"` (default) - Places the logo to the left of the survey title.
         * - `"right"` - Places the logo to the right of the survey title.
         * - `"none"` - Hides the logo.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-logo/ (linkStyle))
         * @see logo
         * @see logoFit
         */ get: function() {
                        return this.getPropertyValue("logoPosition");
                    },
                    set: function(value) {
                        this.setPropertyValue("logoPosition", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "hasLogo", {
                    get: function() {
                        return this.getPropertyValue("hasLogo", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateHasLogo = function() {
                    this.setPropertyValue("hasLogo", !!this.logo && this.logoPosition !== "none");
                };
                Object.defineProperty(SurveyModel.prototype, "isLogoBefore", {
                    get: function() {
                        if (this.isDesignMode) return false;
                        return this.renderedHasLogo && (this.logoPosition === "left" || this.logoPosition === "top");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isLogoAfter", {
                    get: function() {
                        if (this.isDesignMode) return this.renderedHasLogo;
                        return this.renderedHasLogo && (this.logoPosition === "right" || this.logoPosition === "bottom");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "logoClassNames", {
                    get: function() {
                        var logoClasses = {
                            left: "sv-logo--left",
                            right: "sv-logo--right",
                            top: "sv-logo--top",
                            bottom: "sv-logo--bottom"
                        };
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.logo).append(logoClasses[this.logoPosition]).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedHasTitle", {
                    get: function() {
                        if (this.isDesignMode) return this.isPropertyVisible("title");
                        return !this.titleIsEmpty && this.showTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedHasDescription", {
                    get: function() {
                        if (this.isDesignMode) return this.isPropertyVisible("description");
                        return !!this.hasDescription;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "hasTitle", {
                    get: function() {
                        return this.renderedHasTitle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedHasLogo", {
                    get: function() {
                        if (this.isDesignMode) return this.isPropertyVisible("logo");
                        return this.hasLogo;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedHasHeader", {
                    get: function() {
                        return this.renderedHasTitle || this.renderedHasLogo;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "logoFit", {
                    /**
         * Specifies how to resize a logo to fit it into its container.
         *
         * Possible values:
         *
         * - `"contain"` (default)
         * - `"cover"`
         * - `"fill"`
         * - `"none"`
         *
         * Refer to the [`object-fit`](https://developer.mozilla.org/en-US/docs/Web/CSS/object-fit) CSS property description for information on the possible values.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-logo/ (linkStyle))
         * @see logo
         * @see logoPosition
         */ get: function() {
                        return this.getPropertyValue("logoFit");
                    },
                    set: function(val1) {
                        this.setPropertyValue("logoFit", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "themeVariables", {
                    get: function() {
                        return Object.assign({}, this.cssVariables);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.setIsMobile = function(newVal) {
                    if (newVal === void 0) newVal = true;
                    if (this._isMobile !== newVal) {
                        this._isMobile = newVal;
                        this.updateCss();
                        this.getAllQuestions().forEach(function(q) {
                            return q.setIsMobile(newVal);
                        });
                    }
                };
                Object.defineProperty(SurveyModel.prototype, "isMobile", {
                    get: function() {
                        return this._isMobile && !this.isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isCompact", {
                    get: function() {
                        return this._isCompact;
                    },
                    set: function(newVal) {
                        if (newVal !== this._isCompact) {
                            this._isCompact = newVal;
                            this.updateElementCss();
                            this.triggerResponsiveness(true);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.isLogoImageChoosen = function() {
                    return this.locLogo.renderedHtml;
                };
                Object.defineProperty(SurveyModel.prototype, "titleMaxWidth", {
                    get: function() {
                        if (!(Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["isMobile"])() || this.isMobile) && !this.isValueEmpty(this.isLogoImageChoosen()) && !_settings__WEBPACK_IMPORTED_MODULE_14__["settings"].supportCreatorV2) {
                            var logoWidth = this.logoWidth;
                            if (this.logoPosition === "left" || this.logoPosition === "right") return "calc(100% - 5px - 2em - " + logoWidth + ")";
                        }
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateRenderBackgroundImage = function() {
                    var path = this.backgroundImage;
                    this.renderBackgroundImage = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["wrapUrlForBackgroundImage"])(path);
                };
                Object.defineProperty(SurveyModel.prototype, "backgroundOpacity", {
                    /**
         * A value from 0 to 1 that specifies how transparent the [background image](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#backgroundImage) should be: 0 makes the image completely transparent, and 1 makes it opaque.
         */ get: function() {
                        return this.getPropertyValue("backgroundOpacity");
                    },
                    set: function(val1) {
                        this.setPropertyValue("backgroundOpacity", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateBackgroundImageStyle = function() {
                    this.backgroundImageStyle = {
                        opacity: this.backgroundOpacity,
                        backgroundImage: this.renderBackgroundImage,
                        backgroundSize: this.backgroundImageFit,
                        backgroundAttachment: !this.fitToContainer ? this.backgroundImageAttachment : undefined
                    };
                };
                SurveyModel.prototype.updateWrapperFormCss = function() {
                    this.wrapperFormCss = new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.rootWrapper).append(this.css.rootWrapperFixed, this.backgroundImageAttachment === "fixed").toString();
                };
                Object.defineProperty(SurveyModel.prototype, "completedHtml", {
                    /**
         * HTML content displayed on the [complete page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#complete-page).
         *
         * [View Demo](https://surveyjs.io/form-library/examples/modify-survey-navigation-settings/ (linkStyle))
         * @see showCompletedPage
         * @see completedHtmlOnCondition
         */ get: function() {
                        return this.getLocalizableStringText("completedHtml");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("completedHtml", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locCompletedHtml", {
                    get: function() {
                        return this.getLocalizableString("completedHtml");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "completedHtmlOnCondition", {
                    /**
         * An array of objects that allows you to specify different HTML content for the [complete page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#complete-page).
         *
         * Each object should include the [`expression`](https://surveyjs.io/form-library/documentation/api-reference/htmlconditionitem#expression) and [`html`](https://surveyjs.io/form-library/documentation/api-reference/htmlconditionitem#html) properties. When `expression` evaluates to `true`, the survey uses the corresponding HTML markup instead of [`completedHtml`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#completedHtml). Refer to the following help topic for more information about expressions: [Expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions).
         *
         * [View Demo](https://surveyjs.io/form-library/examples/nps-question/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("completedHtmlOnCondition");
                    },
                    set: function(val1) {
                        this.setPropertyValue("completedHtmlOnCondition", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Calculates a given [expression](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions) and returns a result value.
     * @param expression An expression to calculate.
     */ SurveyModel.prototype.runExpression = function(expression) {
                    if (!expression) return null;
                    var values = this.getFilteredValues();
                    var properties = this.getFilteredProperties();
                    return new _conditions__WEBPACK_IMPORTED_MODULE_13__["ExpressionRunner"](expression).run(values, properties);
                };
                /**
     * Calculates a given [expression](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions) and returns `true` or `false`.
     * @param expression An expression to calculate.
     */ SurveyModel.prototype.runCondition = function(expression) {
                    if (!expression) return false;
                    var values = this.getFilteredValues();
                    var properties = this.getFilteredProperties();
                    return new _conditions__WEBPACK_IMPORTED_MODULE_13__["ConditionRunner"](expression).run(values, properties);
                };
                /**
     * Executes [all triggers](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#triggers), except ["complete"](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#complete).
     *
     * [Conditional Survey Logic (Triggers)](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-survey-logic-triggers (linkStyle))
     * @see onTriggerExecuted
     */ SurveyModel.prototype.runTriggers = function() {
                    this.checkTriggers(this.getFilteredValues(), false);
                };
                Object.defineProperty(SurveyModel.prototype, "renderedCompletedHtml", {
                    get: function() {
                        var item = this.getExpressionItemOnRunCondition(this.completedHtmlOnCondition);
                        return !!item ? item.html : this.completedHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getExpressionItemOnRunCondition = function(items) {
                    if (items.length == 0) return null;
                    var values = this.getFilteredValues();
                    var properties = this.getFilteredProperties();
                    for(var i = 0; i < items.length; i++){
                        if (items[i].runCondition(values, properties)) return items[i];
                    }
                    return null;
                };
                Object.defineProperty(SurveyModel.prototype, "completedBeforeHtml", {
                    /**
         * HTML content displayed to a user who has completed the survey before. To identify such users, the survey uses a [cookie name](#cookieName) or [client ID](#clientId).
         * @see processedCompletedBeforeHtml
         */ get: function() {
                        return this.getLocalizableStringText("completedBeforeHtml");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("completedBeforeHtml", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locCompletedBeforeHtml", {
                    get: function() {
                        return this.getLocalizableString("completedBeforeHtml");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "loadingHtml", {
                    /**
         * HTML content displayed while a survey JSON schema is being loaded from [SurveyJS Service](https://api.surveyjs.io).
         * @see surveyId
         * @see processedLoadingHtml
         */ get: function() {
                        return this.getLocalizableStringText("loadingHtml");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("loadingHtml", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locLoadingHtml", {
                    get: function() {
                        return this.getLocalizableString("loadingHtml");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "defaultLoadingHtml", {
                    get: function() {
                        return "<h3>" + this.getLocalizationString("loadingSurvey") + "</h3>";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "navigationBar", {
                    get: function() {
                        return this.navigationBarValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Adds a custom navigation item similar to the Previous Page, Next Page, and Complete buttons.
     * Accepts an object described in the [IAction](https://surveyjs.io/Documentation/Library?id=IAction) help section.
     *
     * [View Demo](https://surveyjs.io/form-library/examples/survey-changenavigation/ (linkStyle))
    */ SurveyModel.prototype.addNavigationItem = function(val1) {
                    if (!val1.component) val1.component = "sv-nav-btn";
                    if (!val1.innerCss) val1.innerCss = this.cssSurveyNavigationButton;
                    return this.navigationBar.addAction(val1);
                };
                Object.defineProperty(SurveyModel.prototype, "startSurveyText", {
                    /**
         * Gets or sets a caption for the Start button.
         * @see firstPageIsStarted
         * @see [Localization & Globalization](https://surveyjs.io/form-library/documentation/survey-localization)
         */ get: function() {
                        return this.getLocalizableStringText("startSurveyText");
                    },
                    set: function(newValue) {
                        this.setLocalizableStringText("startSurveyText", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locStartSurveyText", {
                    get: function() {
                        return this.getLocalizableString("startSurveyText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "pagePrevText", {
                    /**
         * Gets or sets a caption for the Previous button.
         * @see [Localization & Globalization](https://surveyjs.io/form-library/documentation/survey-localization)
         */ get: function() {
                        return this.getLocalizableStringText("pagePrevText");
                    },
                    set: function(newValue) {
                        this.setLocalizableStringText("pagePrevText", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locPagePrevText", {
                    get: function() {
                        return this.getLocalizableString("pagePrevText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "pageNextText", {
                    /**
         * Gets or sets a caption for the Next button.
         * @see [Localization & Globalization](https://surveyjs.io/form-library/documentation/survey-localization)
         */ get: function() {
                        return this.getLocalizableStringText("pageNextText");
                    },
                    set: function(newValue) {
                        this.setLocalizableStringText("pageNextText", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locPageNextText", {
                    get: function() {
                        return this.getLocalizableString("pageNextText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "completeText", {
                    /**
         * Gets or sets a caption for the Complete button.
         * @see [Localization & Globalization](https://surveyjs.io/form-library/documentation/survey-localization)
         */ get: function() {
                        return this.getLocalizableStringText("completeText");
                    },
                    set: function(newValue) {
                        this.setLocalizableStringText("completeText", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locCompleteText", {
                    get: function() {
                        return this.getLocalizableString("completeText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "previewText", {
                    /**
         * Gets or sets a caption for the Preview button.
         * @see showPreviewBeforeComplete
         * @see showPreview
         * @see editText
         */ get: function() {
                        return this.getLocalizableStringText("previewText");
                    },
                    set: function(newValue) {
                        this.setLocalizableStringText("previewText", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locPreviewText", {
                    get: function() {
                        return this.getLocalizableString("previewText");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "editText", {
                    /**
         * Gets or sets a caption for the Edit button displayed when the survey shows a [preview of given answers](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#preview-page).
         * @see showPreviewBeforeComplete
         * @see cancelPreview
         * @see previewText
         */ get: function() {
                        return this.getLocalizableStringText("editText");
                    },
                    set: function(newValue) {
                        this.setLocalizableStringText("editText", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "locEditText", {
                    get: function() {
                        return this.getLocalizableString("editText");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getElementTitleTagName = function(element, tagName) {
                    if (this.onGetTitleTagName.isEmpty) return tagName;
                    var options = {
                        element: element,
                        tagName: tagName
                    };
                    this.onGetTitleTagName.fire(this, options);
                    return options.tagName;
                };
                Object.defineProperty(SurveyModel.prototype, "questionTitlePattern", {
                    /**
         * Specifies a pattern for question titles.
         *
         * Refer to the following help topic for more information: [Title Pattern](https://surveyjs.io/form-library/documentation/design-survey/configure-question-titles#title-pattern).
         */ get: function() {
                        return this.getPropertyValue("questionTitlePattern", "numTitleRequire");
                    },
                    set: function(val1) {
                        if (val1 !== "numRequireTitle" && val1 !== "requireNumTitle" && val1 != "numTitle") val1 = "numTitleRequire";
                        this.setPropertyValue("questionTitlePattern", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getQuestionTitlePatternOptions = function() {
                    var res = new Array();
                    var title = this.getLocalizationString("questionTitlePatternText");
                    var num = !!this.questionStartIndex ? this.questionStartIndex : "1.";
                    res.push({
                        value: "numTitleRequire",
                        text: num + " " + title + " " + this.requiredText
                    });
                    res.push({
                        value: "numRequireTitle",
                        text: num + " " + this.requiredText + " " + title
                    });
                    res.push({
                        value: "requireNumTitle",
                        text: this.requiredText + " " + num + " " + title
                    });
                    res.push({
                        value: "numTitle",
                        text: num + " " + title
                    });
                    return res;
                };
                Object.defineProperty(SurveyModel.prototype, "questionTitleTemplate", {
                    get: function() {
                        return this.getLocalizableStringText("questionTitleTemplate");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("questionTitleTemplate", value);
                        this.questionTitlePattern = this.getNewTitlePattern(value);
                        this.questionStartIndex = this.getNewQuestionTitleElement(value, "no", this.questionStartIndex, "1");
                        this.requiredText = this.getNewQuestionTitleElement(value, "require", this.requiredText, "*");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getNewTitlePattern = function(template) {
                    if (!!template) {
                        var strs = [];
                        while(template.indexOf("{") > -1){
                            template = template.substring(template.indexOf("{") + 1);
                            var ind = template.indexOf("}");
                            if (ind < 0) break;
                            strs.push(template.substring(0, ind));
                            template = template.substring(ind + 1);
                        }
                        if (strs.length > 1) {
                            if (strs[0] == "require") return "requireNumTitle";
                            if (strs[1] == "require" && strs.length == 3) return "numRequireTitle";
                            if (strs.indexOf("require") < 0) return "numTitle";
                        }
                        if (strs.length == 1 && strs[0] == "title") return "numTitle";
                    }
                    return "numTitleRequire";
                };
                SurveyModel.prototype.getNewQuestionTitleElement = function(template, name, currentValue, defaultValue) {
                    name = "{" + name + "}";
                    if (!template || template.indexOf(name) < 0) return currentValue;
                    var ind = template.indexOf(name);
                    var prefix = "";
                    var postfix = "";
                    var i = ind - 1;
                    for(; i >= 0; i--){
                        if (template[i] == "}") break;
                    }
                    if (i < ind - 1) prefix = template.substring(i + 1, ind);
                    ind += name.length;
                    i = ind;
                    for(; i < template.length; i++){
                        if (template[i] == "{") break;
                    }
                    if (i > ind) postfix = template.substring(ind, i);
                    i = 0;
                    while(i < prefix.length && prefix.charCodeAt(i) < 33)i++;
                    prefix = prefix.substring(i);
                    i = postfix.length - 1;
                    while(i >= 0 && postfix.charCodeAt(i) < 33)i--;
                    postfix = postfix.substring(0, i + 1);
                    if (!prefix && !postfix) return currentValue;
                    var value = !!currentValue ? currentValue : defaultValue;
                    return prefix + value + postfix;
                };
                Object.defineProperty(SurveyModel.prototype, "locQuestionTitleTemplate", {
                    get: function() {
                        return this.getLocalizableString("questionTitleTemplate");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getUpdatedQuestionTitle = function(question, title) {
                    if (this.onGetQuestionTitle.isEmpty) return title;
                    var options = {
                        question: question,
                        title: title
                    };
                    this.onGetQuestionTitle.fire(this, options);
                    return options.title;
                };
                SurveyModel.prototype.getUpdatedQuestionNo = function(question, no) {
                    if (this.onGetQuestionNo.isEmpty) return no;
                    var options = {
                        question: question,
                        no: no
                    };
                    this.onGetQuestionNo.fire(this, options);
                    return options.no;
                };
                Object.defineProperty(SurveyModel.prototype, "showPageNumbers", {
                    /**
         * Specifies whether page titles contain page numbers.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/how-to-number-pages-and-questions/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("showPageNumbers");
                    },
                    set: function(value) {
                        if (value === this.showPageNumbers) return;
                        this.setPropertyValue("showPageNumbers", value);
                        this.updateVisibleIndexes();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showQuestionNumbers", {
                    /**
         * Specifies whether to display question numbers and how to calculate them.
         *
         * Possible values:
         *
         * - `true` or `"on"` - Displays question numbers.
         * - `"onpage"` - Displays question numbers and starts numbering on each page from scratch.
         * - `false` or `"off"` - Hides question numbers.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/how-to-number-pages-and-questions/ (linkStyle))
         *
         * If you want to hide the number of an individual question, enable its [`hideNumber`](https://surveyjs.io/form-library/documentation/api-reference/question#hideNumber) property.
         */ get: function() {
                        return this.getPropertyValue("showQuestionNumbers");
                    },
                    set: function(value) {
                        if (value === true) value = "on";
                        if (value === false) value = "off";
                        value = value.toLowerCase();
                        value = value === "onpage" ? "onPage" : value;
                        if (value === this.showQuestionNumbers) return;
                        this.setPropertyValue("showQuestionNumbers", value);
                        this.updateVisibleIndexes();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "progressBar", {
                    get: function() {
                        return this.progressBarValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showProgressBar", {
                    /**
         * Controls the visibility of the progress bar and specifies its position.
         *
         * Possible values:
         *
         * - `"off"` (default) - Hides the progress bar.
         * - `"aboveHeader"` - Displays the progress bar above the survey header.
         * - `"belowHeader"` - Displays the progress bar below the survey header.
         * - `"bottom"` - Displays the progress bar below survey content.
         * - `"topBottom"` - Displays the progress bar above and below survey content.
         * - `"auto"` - Displays the progress bar below the survey header if the header has a [background image](https://surveyjs.io/form-library/documentation/api-reference/iheader#backgroundImage) or color. Otherwise, the progress bar is displayed above the header.
         * - `"top"` - *(Obsolete)* Use the `"aboveHeader"` or `"belowHeader"` property value instead.
         * - `"both"` - *(Obsolete)* Use the `"topBottom"` property value instead.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/navigation-default/ (linkStyle))
         * @see progressBarType
         * @see progressValue
         */ get: function() {
                        return this.getPropertyValue("showProgressBar");
                    },
                    set: function(newValue) {
                        this.setPropertyValue("showProgressBar", newValue.toLowerCase());
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "progressBarType", {
                    /**
         * Specifies the type of information displayed by the progress bar. Applies only when [`showProgressBar`](#showProgressBar) is not `"off"`.
         *
         * Possible values:
         *
         * - `"pages"` (default) - The number of completed pages.
         * - `"questions"` - The number of answered questions.
         * - `"requiredQuestions"` - The number of answered [required questions](https://surveyjs.io/form-library/documentation/api-reference/question#isRequired).
         * - `"correctQuestions"` - The number of correct questions in a [quiz](https://surveyjs.io/form-library/documentation/design-survey/create-a-quiz).
         * - `"buttons"` - *(Obsolete)* Use the `"pages"` property value with the [`progressBarShowPageTitles`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#progressBarShowPageTitles) property set to `true` instead.
         *
         * > When `progressBarType` is set to `"pages"`, you can also enable the [`progressBarShowPageNumbers`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#progressBarShowPageNumbers) and [`progressBarShowPageTitles`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#progressBarShowPageTitles) properties if you want to display page numbers and titles in the progress bar.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/navigation-buttons/ (linkStyle))
         * @see progressValue
         */ get: function() {
                        return this.getPropertyValue("progressBarType");
                    },
                    set: function(newValue) {
                        if (newValue === "correctquestion") newValue = "correctQuestion";
                        if (newValue === "requiredquestion") newValue = "requiredQuestion";
                        // if (newValue === "buttons") {
                        //   newValue = "pages";
                        //   this.progressBarShowPageTitles = true;
                        // }
                        this.setPropertyValue("progressBarType", newValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "progressBarComponentName", {
                    get: function() {
                        var actualProgressBarType = this.progressBarType;
                        if (!_settings__WEBPACK_IMPORTED_MODULE_14__["settings"].legacyProgressBarView && _defaultCss_defaultV2Css__WEBPACK_IMPORTED_MODULE_4__["surveyCss"].currentType === "defaultV2") {
                            if (isStrCiEqual(actualProgressBarType, "pages")) actualProgressBarType = "buttons";
                        }
                        return "progress-" + actualProgressBarType;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isShowProgressBarOnTop", {
                    get: function() {
                        if (!this.canShowProresBar()) return false;
                        return [
                            "auto",
                            "aboveheader",
                            "belowheader",
                            "topbottom",
                            "top",
                            "both"
                        ].indexOf(this.showProgressBar) !== -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isShowProgressBarOnBottom", {
                    get: function() {
                        if (!this.canShowProresBar()) return false;
                        return this.showProgressBar === "bottom" || this.showProgressBar === "both" || this.showProgressBar === "topbottom";
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getProgressTypeComponent = function() {
                    return "sv-progress-" + this.progressBarType.toLowerCase();
                };
                SurveyModel.prototype.getProgressCssClasses = function(container) {
                    if (container === void 0) container = "";
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.progress).append(this.css.progressTop, this.isShowProgressBarOnTop && (!container || container == "header")).append(this.css.progressBottom, this.isShowProgressBarOnBottom && (!container || container == "footer")).toString();
                };
                SurveyModel.prototype.canShowProresBar = function() {
                    return !this.isShowingPreview || this.showPreviewBeforeComplete != "showAllQuestions";
                };
                Object.defineProperty(SurveyModel.prototype, "processedTitle", {
                    get: function() {
                        return this.locTitle.renderedHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "questionTitleLocation", {
                    /**
         * Gets or sets question title location relative to the input field: `"top"`, `"bottom"`, or `"left"`.
         *
         * > Certain question types (Matrix, Multiple Text) do not support the `"left"` value. For them, the `"top"` value is used.
         *
         * You can override this setting if you specify the `questionTitleLocation` property for an [individual page](https://surveyjs.io/form-library/documentation/pagemodel#questionTitleLocation) or [panel](https://surveyjs.io/form-library/documentation/panelmodel#questionTitleLocation) or set the `titleLocation` property for a [specific question](https://surveyjs.io/form-library/documentation/question#titleLocation).
         */ get: function() {
                        return this.getPropertyValue("questionTitleLocation");
                    },
                    set: function(value) {
                        this.setPropertyValue("questionTitleLocation", value.toLowerCase());
                        if (!this.isLoadingFromJson) this.updateElementCss(true);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateElementCss = function(reNew) {
                    if (!!this.startedPage) this.startedPage.updateElementCss(reNew);
                    var pages = this.visiblePages;
                    for(var i = 0; i < pages.length; i++)pages[i].updateElementCss(reNew);
                    this.updateCss();
                };
                Object.defineProperty(SurveyModel.prototype, "questionErrorLocation", {
                    /**
         * Specifies the error message position.
         *
         * Possible values:
         *
         * - `"top"` (default) - Displays error messages above questions.
         * - `"bottom"` - Displays error messages below questions.
         *
         * You can override this setting if you specify the `questionErrorLocation` property for an [individual page](https://surveyjs.io/form-library/documentation/pagemodel#questionErrorLocation) or [panel](https://surveyjs.io/form-library/documentation/panelmodel#questionErrorLocation) or set the `errorLocation` property for a [specific question](https://surveyjs.io/form-library/documentation/question#errorLocation).
         */ get: function() {
                        return this.getPropertyValue("questionErrorLocation");
                    },
                    set: function(value) {
                        this.setPropertyValue("questionErrorLocation", value.toLowerCase());
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "questionDescriptionLocation", {
                    /**
         * Specifies where to display question descriptions.
         *
         * Possible values:
         *
         * - `"underTitle"` (default) - Displays descriptions under question titles.
         * - `"underInput"` - Displays descriptions under the interactive area.
         *
         * You can override this setting for individual questions if you specify their [`descriptionLocation`](https://surveyjs.io/form-library/documentation/api-reference/question#descriptionLocation) property.
         *
         */ get: function() {
                        return this.getPropertyValue("questionDescriptionLocation");
                    },
                    set: function(value) {
                        this.setPropertyValue("questionDescriptionLocation", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "mode", {
                    /**
         * Specifies whether users can take the survey or only view it.
         *
         * Possible values:
         *
         * - `"edit"` (default) - Allows users to take the survey.
         * - `"display"` - Makes the survey read-only.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-displaymode/ (linkStyle))
         */ get: function() {
                        return this.getPropertyValue("mode");
                    },
                    set: function(value) {
                        value = value.toLowerCase();
                        if (value == this.mode) return;
                        if (value != "edit" && value != "display") return;
                        this.setPropertyValue("mode", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.onModeChanged = function() {
                    for(var i = 0; i < this.pages.length; i++){
                        var page = this.pages[i];
                        page.setPropertyValue("isReadOnly", page.isReadOnly);
                    }
                    this.updateButtonsVisibility();
                    this.updateCss();
                };
                Object.defineProperty(SurveyModel.prototype, "data", {
                    /**
         * Gets or sets an object with survey results. You can set this property with an object of the following structure:
         *
         * ```js
         * {
         *   question1Name: question1Value,
         *   question2Name: question2Value,
         *   // ...
         * }
         * ```
         *
         * When you set this property in code, the new object overrides the old object that may contain default question values and entered data. If you want to *merge* the new and old objects, call the [`mergeData(newDataObj)`](https://surveyjs.io/form-library/documentation/surveymodel#mergeData) method.
         *
         * If you assign a new object while a respondent takes the survey, set the [`currentPageNo`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#currentPageNo) property to 0 to start the survey from the beginning. This will also cause the survey to re-evaluate the [`visibleIf`](https://surveyjs.io/form-library/documentation/api-reference/question#visibleIf), [`enableIf`](https://surveyjs.io/form-library/documentation/api-reference/question#enableIf), and other [expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions).
         * @see setValue
         * @see getValue
         */ get: function() {
                        var result = {};
                        var keys = this.getValuesKeys();
                        for(var i = 0; i < keys.length; i++){
                            var key = keys[i];
                            var dataValue = this.getDataValueCore(this.valuesHash, key);
                            if (dataValue !== undefined) result[key] = dataValue;
                        }
                        this.setCalculatedValuesIntoResult(result);
                        return result;
                    },
                    set: function(data) {
                        this.valuesHash = {};
                        this.setDataCore(data, !data);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Merges a specified data object with the object from the [`data`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#data) property.
     *
     * Refer to the following help topic for more information: [Populate Form Fields | Multiple Question Values](https://surveyjs.io/form-library/documentation/design-survey/pre-populate-form-fields#multiple-question-values).
     *
     * @param data A data object to merge. It should have the following structure: `{ questionName: questionValue, ... }`
     * @see setValue
     */ SurveyModel.prototype.mergeData = function(data) {
                    if (!data) return;
                    var newData = this.data;
                    this.mergeValues(data, newData);
                    this.setDataCore(newData);
                };
                SurveyModel.prototype.setDataCore = function(data, clearData) {
                    if (clearData === void 0) clearData = false;
                    if (clearData) this.valuesHash = {};
                    if (data) for(var key in data)this.setDataValueCore(this.valuesHash, key, data[key]);
                    this.updateAllQuestionsValue(clearData);
                    this.notifyAllQuestionsOnValueChanged();
                    this.notifyElementsOnAnyValueOrVariableChanged("");
                    this.runConditions();
                    this.updateAllQuestionsValue(clearData);
                };
                SurveyModel.prototype.getStructuredData = function(includePages, level) {
                    if (includePages === void 0) includePages = true;
                    if (level === void 0) level = -1;
                    if (level === 0) return this.data;
                    var data = {};
                    this.pages.forEach(function(p) {
                        if (includePages) {
                            var pageValues = {};
                            if (p.collectValues(pageValues, level - 1)) data[p.name] = pageValues;
                        } else p.collectValues(data, level);
                    });
                    return data;
                };
                SurveyModel.prototype.setStructuredData = function(data, doMerge) {
                    if (doMerge === void 0) doMerge = false;
                    if (!data) return;
                    var res = {};
                    for(var key in data){
                        var q = this.getQuestionByValueName(key);
                        if (q) res[key] = data[key];
                        else {
                            var panel = this.getPageByName(key);
                            if (!panel) panel = this.getPanelByName(key);
                            if (panel) this.collectDataFromPanel(panel, res, data[key]);
                        }
                    }
                    if (doMerge) this.mergeData(res);
                    else this.data = res;
                };
                SurveyModel.prototype.collectDataFromPanel = function(panel, output, data) {
                    for(var key in data){
                        var el = panel.getElementByName(key);
                        if (!el) continue;
                        if (el.isPanel) this.collectDataFromPanel(el, output, data[key]);
                        else output[key] = data[key];
                    }
                };
                Object.defineProperty(SurveyModel.prototype, "editingObj", {
                    get: function() {
                        return this.editingObjValue;
                    },
                    set: function(val1) {
                        var _this = this;
                        if (this.editingObj == val1) return;
                        if (!!this.editingObj) this.editingObj.onPropertyChanged.remove(this.onEditingObjPropertyChanged);
                        this.editingObjValue = val1;
                        if (this.isDisposed) return;
                        if (!val1) {
                            var questions = this.getAllQuestions();
                            for(var i = 0; i < questions.length; i++)questions[i].unbindValue();
                        }
                        if (!!this.editingObj) {
                            this.setDataCore({});
                            this.onEditingObjPropertyChanged = function(sender, options) {
                                if (!_jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].hasOriginalProperty(_this.editingObj, options.name)) return;
                                if (options.name === "locale") _this.setDataCore({});
                                _this.updateOnSetValue(options.name, _this.editingObj[options.name], options.oldValue);
                            };
                            this.editingObj.onPropertyChanged.add(this.onEditingObjPropertyChanged);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isEditingSurveyElement", {
                    get: function() {
                        return !!this.editingObj;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.setCalculatedValuesIntoResult = function(result) {
                    for(var i = 0; i < this.calculatedValues.length; i++){
                        var calValue = this.calculatedValues[i];
                        if (calValue.includeIntoResult && !!calValue.name && this.getVariable(calValue.name) !== undefined) result[calValue.name] = this.getVariable(calValue.name);
                    }
                };
                SurveyModel.prototype.getAllValues = function() {
                    return this.data;
                };
                /**
     * Returns survey results as an array of objects in which the question name, title, value, and other parameters are stored as individual properties.
     *
     * If a question can have more than one value (Matrix, Multiple Text), its object enables the `isNode` flag and stores information about these values in the `data` property. Refer to the following help topic for more information: [Access Full Survey Results](https://surveyjs.io/form-library/documentation/handle-survey-results-access#access-full-survey-results).
     *
     * If you want to skip empty answers, pass an object with the `includeEmpty` property set to `false`.
     */ SurveyModel.prototype.getPlainData = function(options) {
                    if (!options) options = {
                        includeEmpty: true,
                        includeQuestionTypes: false,
                        includeValues: false
                    };
                    var result = [];
                    var questionValueNames = [];
                    this.getAllQuestions().forEach(function(question) {
                        var resultItem = question.getPlainData(options);
                        if (!!resultItem) {
                            result.push(resultItem);
                            questionValueNames.push(question.valueName || question.name);
                        }
                    });
                    if (!!options.includeValues) {
                        var keys = this.getValuesKeys();
                        for(var i = 0; i < keys.length; i++){
                            var key = keys[i];
                            if (questionValueNames.indexOf(key) == -1) {
                                var dataValue = this.getDataValueCore(this.valuesHash, key);
                                if (!!dataValue) result.push({
                                    name: key,
                                    title: key,
                                    value: dataValue,
                                    displayValue: dataValue,
                                    isNode: false,
                                    getString: function(val1) {
                                        return typeof val1 === "object" ? JSON.stringify(val1) : val1;
                                    }
                                });
                            }
                        }
                    }
                    return result;
                };
                SurveyModel.prototype.getFilteredValues = function() {
                    var values = {};
                    for(var key in this.variablesHash)values[key] = this.variablesHash[key];
                    this.addCalculatedValuesIntoFilteredValues(values);
                    var keys = this.getValuesKeys();
                    for(var i = 0; i < keys.length; i++){
                        var key = keys[i];
                        values[key] = this.getDataValueCore(this.valuesHash, key);
                    }
                    this.getAllQuestions().forEach(function(q) {
                        if (q.hasFilteredValue) values[q.getValueName()] = q.getFilteredValue();
                    });
                    return values;
                };
                SurveyModel.prototype.addCalculatedValuesIntoFilteredValues = function(values) {
                    var caclValues = this.calculatedValues;
                    for(var i = 0; i < caclValues.length; i++)values[caclValues[i].name] = caclValues[i].value;
                };
                SurveyModel.prototype.getFilteredProperties = function() {
                    return {
                        survey: this
                    };
                };
                SurveyModel.prototype.getValuesKeys = function() {
                    if (!this.editingObj) return Object.keys(this.valuesHash);
                    var props = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].getPropertiesByObj(this.editingObj);
                    var res = [];
                    for(var i = 0; i < props.length; i++)res.push(props[i].name);
                    return res;
                };
                SurveyModel.prototype.getDataValueCore = function(valuesHash, key) {
                    if (!!this.editingObj) return _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].getObjPropertyValue(this.editingObj, key);
                    return this.getDataFromValueHash(valuesHash, key);
                };
                SurveyModel.prototype.setDataValueCore = function(valuesHash, key, value) {
                    if (!!this.editingObj) _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].setObjPropertyValue(this.editingObj, key, value);
                    else this.setDataToValueHash(valuesHash, key, value);
                };
                SurveyModel.prototype.deleteDataValueCore = function(valuesHash, key) {
                    if (!!this.editingObj) this.editingObj[key] = null;
                    else this.deleteDataFromValueHash(valuesHash, key);
                };
                SurveyModel.prototype.getDataFromValueHash = function(valuesHash, key) {
                    if (!!this.valueHashGetDataCallback) return this.valueHashGetDataCallback(valuesHash, key);
                    return valuesHash[key];
                };
                SurveyModel.prototype.setDataToValueHash = function(valuesHash, key, value) {
                    if (!!this.valueHashSetDataCallback) this.valueHashSetDataCallback(valuesHash, key, value);
                    else valuesHash[key] = value;
                };
                SurveyModel.prototype.deleteDataFromValueHash = function(valuesHash, key) {
                    if (!!this.valueHashDeleteDataCallback) this.valueHashDeleteDataCallback(valuesHash, key);
                    else delete valuesHash[key];
                };
                Object.defineProperty(SurveyModel.prototype, "comments", {
                    /**
         * An object with all comment values.
         * @see Question.showCommentArea
         * @see storeOthersAsComment
         */ get: function() {
                        var result = {};
                        var keys = this.getValuesKeys();
                        for(var i = 0; i < keys.length; i++){
                            var key = keys[i];
                            if (key.indexOf(this.commentSuffix) > 0) result[key] = this.getDataValueCore(this.valuesHash, key);
                        }
                        return result;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "visiblePages", {
                    /**
         * Returns an array of visible pages without the start page.
         *
         * To get an array of all pages, use the [`pages`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#pages) property. If all pages are visible, the `pages` and `visiblePages` arrays are identical.
         * @see [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-visibility)
         */ get: function() {
                        if (this.isDesignMode) return this.pages;
                        var result = new Array();
                        for(var i = 0; i < this.pages.length; i++)if (this.isPageInVisibleList(this.pages[i])) result.push(this.pages[i]);
                        return result;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.isPageInVisibleList = function(page) {
                    return this.isDesignMode || page.isVisible && !page.isStartPage;
                };
                Object.defineProperty(SurveyModel.prototype, "isEmpty", {
                    /**
         * Returns `true` if the survey contains zero pages.
         * @see emptySurveyText
         */ get: function() {
                        return this.pages.length == 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "PageCount", {
                    get: function() {
                        return this.pageCount;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "pageCount", {
                    /**
         * Returns a total number of survey pages.
         *
         * To get the number of visible pages, use the [`visiblePageCount`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#visiblePageCount) property.
         * @see pages
         */ get: function() {
                        return this.pages.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "visiblePageCount", {
                    /**
         * Returns the number of visible survey pages.
         *
         * To get a total number of survey pages, use the [`pageCount`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#pageCount) property.
         * @see visiblePages
         * @see [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-visibility)
         */ get: function() {
                        return this.visiblePages.length;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "startedPage", {
                    /**
         * Returns the start page. Applies only if the [`firstPageIsStarted`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#firstPageIsStarted) property is set to `true`.
         *
         * Refer to the following help topic for more information: [Start Page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#start-page).
         * @see firstPageIsStarted
         * @see activePage
         */ get: function() {
                        var page = this.firstPageIsStarted && this.pages.length > 1 ? this.pages[0] : null;
                        if (!!page) {
                            page.onFirstRendering();
                            page.setWasShown(true);
                        }
                        return page;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "currentPage", {
                    /**
         * Gets or sets the current page.
         *
         * If you want to change the current page, set this property to a `PageModel` object. You can get this object in different ways. For example, you can call the [`getPageByName()`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#getPageByName) method to obtain a `PageModel` object with a specific name:
         *
         * ```js
         * survey.currentPage = survey.getPageByName("my-page-name");
         * ```
         *
         * Alternatively, you can change the current page if you set the [`currentPageNo`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#currentPageNo) property to the index of the required page.
         *
         * The `currentPage` property does not return the start page even if it is current. Use the [`activePage`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#activePage) property instead if your survey contains a start page.
         */ get: function() {
                        return this.getPropertyValue("currentPage", null);
                    },
                    set: function(value) {
                        if (this.isLoadingFromJson) return;
                        var newPage = this.getPageByObject(value);
                        if (!!value && !newPage) return;
                        if (!newPage && this.isCurrentPageAvailable) return;
                        var vPages = this.visiblePages;
                        if (newPage != null && vPages.indexOf(newPage) < 0) return;
                        if (newPage == this.currentPage) return;
                        var oldValue = this.currentPage;
                        if (!this.isShowingPreview && !this.currentPageChanging(newPage, oldValue)) return;
                        this.setPropertyValue("currentPage", newPage);
                        if (!!newPage) {
                            newPage.onFirstRendering();
                            newPage.updateCustomWidgets();
                            newPage.setWasShown(true);
                        }
                        this.locStrsChanged();
                        if (!this.isShowingPreview) this.currentPageChanged(newPage, oldValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.tryNavigateToPage = function(page) {
                    if (this.isDesignMode) return false;
                    var index = this.visiblePages.indexOf(page);
                    if (index < 0 || index >= this.visiblePageCount) return false;
                    if (index === this.currentPageNo) return false;
                    if (index < this.currentPageNo || this.isValidateOnComplete) {
                        this.currentPageNo = index;
                        return true;
                    }
                    for(var i = this.currentPageNo; i < index; i++){
                        var page_1 = this.visiblePages[i];
                        if (!page_1.validate(true, true)) return false;
                        page_1.passed = true;
                    }
                    this.currentPage = page;
                    return true;
                };
                SurveyModel.prototype.updateCurrentPage = function() {
                    if (this.isCurrentPageAvailable) return;
                    this.currentPage = this.firstVisiblePage;
                };
                Object.defineProperty(SurveyModel.prototype, "isCurrentPageAvailable", {
                    get: function() {
                        var page = this.currentPage;
                        return !!page && this.isPageInVisibleList(page) && this.isPageExistsInSurvey(page);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.isPageExistsInSurvey = function(page) {
                    if (this.pages.indexOf(page) > -1) return true;
                    return !!this.onContainsPageCallback && this.onContainsPageCallback(page);
                };
                Object.defineProperty(SurveyModel.prototype, "activePage", {
                    /**
         * Returns [`startedPage`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#startedPage) if the survey currently displays a start page; otherwise, returns [`currentPage`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#currentPage).
         * @see startedPage
         * @see currentPage
         * @see firstPageIsStarted
         */ get: function() {
                        return this.getPropertyValue("activePage");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isShowStartingPage", {
                    /**
         * A Boolean value that indicates whether the [start page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#start-page) is currently displayed.
         */ get: function() {
                        return this.state === "starting";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "matrixDragHandleArea", {
                    /**
         * Specifies which part of a matrix row responds to a drag gesture in [Dynamic Matrix](https://surveyjs.io/form-library/examples/questiontype-matrixdynamic/) questions.
         *
         * Possible values:
         *
         * - `"entireItem"` (default) - Users can use the entire matrix row as a drag handle.
         * - `"icon"` - Users can only use a drag icon as a drag handle.
         */ get: function() {
                        return this.getPropertyValue("matrixDragHandleArea", "entireItem");
                    },
                    set: function(val1) {
                        this.setPropertyValue("matrixDragHandleArea", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isShowingPage", {
                    get: function() {
                        return this.state == "running" || this.state == "preview" || this.isShowStartingPage;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateActivePage = function() {
                    var newPage = this.isShowStartingPage ? this.startedPage : this.currentPage;
                    this.setPropertyValue("activePage", newPage);
                };
                SurveyModel.prototype.onStateAndCurrentPageChanged = function() {
                    this.updateActivePage();
                    this.updateButtonsVisibility();
                };
                SurveyModel.prototype.getPageByObject = function(value) {
                    if (!value) return null;
                    if (value.getType && value.getType() == "page") return value;
                    if (typeof value === "string" || value instanceof String) return this.getPageByName(String(value));
                    if (!isNaN(value)) {
                        var index = Number(value);
                        var vPages = this.visiblePages;
                        if (value < 0 || value >= vPages.length) return null;
                        return vPages[index];
                    }
                    return value;
                };
                Object.defineProperty(SurveyModel.prototype, "currentPageNo", {
                    /**
         * A zero-based index of the current page in the [`visiblePages`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#visiblePages) array.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-editprevious/ (linkStyle))
         * @see visiblePages
         */ get: function() {
                        return this.visiblePages.indexOf(this.currentPage);
                    },
                    set: function(value) {
                        var vPages = this.visiblePages;
                        if (value < 0 || value >= vPages.length) return;
                        this.currentPage = vPages[value];
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "questionsOrder", {
                    /**
         * Specifies the sort order of questions in the survey.
         *
         * Possible values:
         *
         * - `"initial"` (default) - Preserves the original order of questions.
         * - `"random"` - Displays questions in random order.
         *
         * You can override this property for individual pages and panels.
         * @see PageModel.questionsOrder
         * @see PanelModel.questionsOrder
         */ get: function() {
                        return this.getPropertyValue("questionsOrder");
                    },
                    set: function(val1) {
                        this.setPropertyValue("questionsOrder", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Focuses the first question on the current page.
     * @see focusQuestion
     * @see focusFirstQuestionAutomatic
     */ SurveyModel.prototype.focusFirstQuestion = function() {
                    if (this.focusingQuestionInfo) return;
                    var page = this.activePage;
                    if (page) {
                        page.scrollToTop();
                        page.focusFirstQuestion();
                    }
                };
                SurveyModel.prototype.scrollToTopOnPageChange = function(doScroll) {
                    if (doScroll === void 0) doScroll = true;
                    var page = this.activePage;
                    if (!page) return;
                    if (doScroll) page.scrollToTop();
                    if (this.isCurrentPageRendering && this.focusFirstQuestionAutomatic && !this.focusingQuestionInfo) {
                        page.focusFirstQuestion();
                        this.isCurrentPageRendering = false;
                    }
                };
                Object.defineProperty(SurveyModel.prototype, "state", {
                    /**
         * Returns the current survey state.
         *
         * Possible values:
         *
         * - `"loading"` - The survey is being loaded from a JSON schema.
         * - `"empty"` - The survey has no elements to display.
         * - `"starting"` - The survey displays a [start page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#start-page).
         * - `"running"` - A respondent is taking the survey.
         * - `"preview"` - A respondent is [previewing](https://surveyjs.io/form-library/examples/survey-showpreview/) answers before submitting them.
         * - `"completed"` - A respondent has completed the survey and submitted the results.
         */ get: function() {
                        return this.getPropertyValue("state", "empty");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateState = function() {
                    this.setPropertyValue("state", this.calcState());
                };
                SurveyModel.prototype.calcState = function() {
                    if (this.isLoading) return "loading";
                    if (this.isCompleted) return "completed";
                    if (this.isCompletedBefore) return "completedbefore";
                    if (!this.isDesignMode && this.isEditMode && this.isStartedState && this.startedPage) return "starting";
                    if (this.isShowingPreview) return this.currentPage ? "preview" : "empty";
                    return this.currentPage ? "running" : "empty";
                };
                Object.defineProperty(SurveyModel.prototype, "isCompleted", {
                    get: function() {
                        return this.getPropertyValue("isCompleted", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("isCompleted", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isShowingPreview", {
                    get: function() {
                        return this.getPropertyValue("isShowingPreview", false);
                    },
                    set: function(val1) {
                        if (this.isShowingPreview == val1) return;
                        this.setPropertyValue("isShowingPreview", val1);
                        this.onShowingPreviewChanged();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isStartedState", {
                    get: function() {
                        return this.getPropertyValue("isStartedState", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("isStartedState", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isCompletedBefore", {
                    get: function() {
                        return this.getPropertyValue("isCompletedBefore", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("isCompletedBefore", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isLoading", {
                    get: function() {
                        return this.getPropertyValue("isLoading", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("isLoading", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "completedState", {
                    get: function() {
                        return this.getPropertyValue("completedState", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "completedStateText", {
                    get: function() {
                        return this.getPropertyValue("completedStateText", "");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.setCompletedState = function(value, text) {
                    this.setPropertyValue("completedState", value);
                    if (!text) {
                        if (value == "saving") text = this.getLocalizationString("savingData");
                        if (value == "error") text = this.getLocalizationString("savingDataError");
                        if (value == "success") text = this.getLocalizationString("savingDataSuccess");
                    }
                    this.setPropertyValue("completedStateText", text);
                    if (this.state === "completed" && this.showCompletedPage && !!this.completedState) this.notify(this.completedStateText, this.completedState, value === "error");
                };
                /**
     * Displays a toast notification with a specified message.
     *
     * Depending on the `type` argument, a survey can display the following notification types:
     *
     * ![Toast notification types in SurveyJS Form Library](https://surveyjs.io//Content/Images/docs/notification-types.png)
     * @param message A message to display.
     * @param type A notification type: `"info"` (default), `"success"`, or `"error"`.
     * @param showActions For internal use.
     */ SurveyModel.prototype.notify = function(message, type, showActions) {
                    if (showActions === void 0) showActions = false;
                    this.notifier.showActions = showActions;
                    this.notifier.notify(message, type, showActions);
                };
                /**
     * Resets the survey [`state`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#state) and, optionally, [`data`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#data). If `state` is `"completed"`, it becomes `"running"`.
     * @param clearData *(Optional)* Specifies whether to clear survey data. Default value: `true`.
     * @param goToFirstPage *(Optional)* Specifies whether to switch the survey to the first page. Default value: `true`.
     */ SurveyModel.prototype.clear = function(clearData, goToFirstPage) {
                    if (clearData === void 0) clearData = true;
                    if (goToFirstPage === void 0) goToFirstPage = true;
                    this.isCompleted = false;
                    this.isCompletedBefore = false;
                    this.isLoading = false;
                    this.completedByTriggers = undefined;
                    if (clearData) this.setDataCore(null, true);
                    this.timerModel.spent = 0;
                    for(var i = 0; i < this.pages.length; i++){
                        this.pages[i].timeSpent = 0;
                        this.pages[i].setWasShown(false);
                        this.pages[i].passed = false;
                    }
                    this.onFirstPageIsStartedChanged();
                    if (goToFirstPage) this.currentPage = this.firstVisiblePage;
                    if (clearData) this.updateValuesWithDefaults();
                };
                SurveyModel.prototype.mergeValues = function(src, dest) {
                    Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["mergeValues"])(src, dest);
                };
                SurveyModel.prototype.updateValuesWithDefaults = function() {
                    if (this.isDesignMode || this.isLoading) return;
                    for(var i = 0; i < this.pages.length; i++){
                        var questions = this.pages[i].questions;
                        for(var j = 0; j < questions.length; j++)questions[j].updateValueWithDefaults();
                    }
                };
                SurveyModel.prototype.updateCustomWidgets = function(page) {
                    if (!page) return;
                    page.updateCustomWidgets();
                };
                SurveyModel.prototype.currentPageChanging = function(newValue, oldValue) {
                    var options = this.createPageChangeEventOptions(newValue, oldValue);
                    options.allow = true;
                    options.allowChanging = true;
                    this.onCurrentPageChanging.fire(this, options);
                    var allow = options.allowChanging && options.allow;
                    if (allow) this.isCurrentPageRendering = true;
                    return allow;
                };
                SurveyModel.prototype.currentPageChanged = function(newValue, oldValue) {
                    this.notifyQuestionsOnHidingContent(oldValue);
                    var options = this.createPageChangeEventOptions(newValue, oldValue);
                    if (oldValue && !oldValue.passed) {
                        if (oldValue.validate(false)) oldValue.passed = true;
                    }
                    this.onCurrentPageChanged.fire(this, options);
                };
                SurveyModel.prototype.notifyQuestionsOnHidingContent = function(page) {
                    if (!page) return;
                    page.questions.forEach(function(q) {
                        return q.onHidingContent();
                    });
                };
                SurveyModel.prototype.createPageChangeEventOptions = function(newValue, oldValue) {
                    var diff = !!newValue && !!oldValue ? newValue.visibleIndex - oldValue.visibleIndex : 0;
                    return {
                        oldCurrentPage: oldValue,
                        newCurrentPage: newValue,
                        isNextPage: diff === 1,
                        isPrevPage: diff === -1,
                        isGoingForward: diff > 0,
                        isGoingBackward: diff < 0,
                        isAfterPreview: this.changeCurrentPageFromPreview === true
                    };
                };
                SurveyModel.prototype.getProgress = function() {
                    if (this.currentPage == null) return 0;
                    if (this.progressBarType !== "pages") {
                        var info = this.getProgressInfo();
                        if (this.progressBarType === "requiredQuestions") return info.requiredQuestionCount >= 1 ? Math.ceil(info.requiredAnsweredQuestionCount * 100 / info.requiredQuestionCount) : 100;
                        return info.questionCount >= 1 ? Math.ceil(info.answeredQuestionCount * 100 / info.questionCount) : 100;
                    }
                    var visPages = this.visiblePages;
                    var index = visPages.indexOf(this.currentPage);
                    return Math.ceil(index * 100 / visPages.length);
                };
                Object.defineProperty(SurveyModel.prototype, "progressValue", {
                    /**
         * Returns a percentage value that indicates user progress in the survey.
         * @see showProgressBar
         * @see progressBarType
         * @see progressText
         */ get: function() {
                        return this.getPropertyValue("progressValue", 0);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isNavigationButtonsShowing", {
                    get: function() {
                        if (this.isDesignMode) return "none";
                        var page = this.currentPage;
                        if (!page) return "none";
                        if (page.navigationButtonsVisibility === "show") return this.showNavigationButtons === "none" ? "bottom" : this.showNavigationButtons;
                        if (page.navigationButtonsVisibility === "hide") return "none";
                        return this.showNavigationButtons;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isNavigationButtonsShowingOnTop", {
                    get: function() {
                        return this.getIsNavigationButtonsShowingOn("top");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isNavigationButtonsShowingOnBottom", {
                    get: function() {
                        return this.getIsNavigationButtonsShowingOn("bottom");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getIsNavigationButtonsShowingOn = function(buttonPosition) {
                    var res = this.isNavigationButtonsShowing;
                    return res == "both" || res == buttonPosition;
                };
                Object.defineProperty(SurveyModel.prototype, "isEditMode", {
                    get: function() {
                        return this.mode == "edit";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isDisplayMode", {
                    get: function() {
                        return this.mode == "display" && !this.isDesignMode || this.state == "preview";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isUpdateValueTextOnTyping", {
                    get: function() {
                        return this.textUpdateMode == "onTyping";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isDesignMode", {
                    /**
         * Indicates whether the survey is being designed in [Survey Creator](https://surveyjs.io/survey-creator/documentation/overview).
         */ get: function() {
                        return this._isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.setDesignMode = function(value) {
                    if (!!this._isDesignMode != !!value) {
                        this._isDesignMode = !!value;
                        this.onQuestionsOnPageModeChanged("standard");
                    }
                };
                Object.defineProperty(SurveyModel.prototype, "showInvisibleElements", {
                    /**
         * Specifies whether to show all survey elements, regardless of their visibility.
         *
         * Default value: `false`
         */ get: function() {
                        return this.getPropertyValue("showInvisibleElements", false);
                    },
                    set: function(val1) {
                        var visPages = this.visiblePages;
                        this.setPropertyValue("showInvisibleElements", val1);
                        if (this.isLoadingFromJson) return;
                        this.runConditions();
                        this.updateAllElementsVisibility(visPages);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateAllElementsVisibility = function(visPages) {
                    for(var i = 0; i < this.pages.length; i++){
                        var page = this.pages[i];
                        page.updateElementVisibility();
                        if (visPages.indexOf(page) > -1 != page.isVisible) this.onPageVisibleChanged.fire(this, {
                            page: page,
                            visible: page.isVisible
                        });
                    }
                };
                Object.defineProperty(SurveyModel.prototype, "areInvisibleElementsShowing", {
                    get: function() {
                        return this.isDesignMode || this.showInvisibleElements;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "areEmptyElementsHidden", {
                    get: function() {
                        return this.isShowingPreview && this.showPreviewBeforeComplete == "showAnsweredQuestions" && this.isAnyQuestionAnswered;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isAnyQuestionAnswered", {
                    get: function() {
                        var questions = this.getAllQuestions(true);
                        for(var i = 0; i < questions.length; i++){
                            if (!questions[i].isEmpty()) return true;
                        }
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "hasCookie", {
                    /**
         * Indicates whether the browser has a cookie with a specified [`cookieName`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#cookieName). If this property's value is `true`, the respondent has passed the survey previously.
         * @see setCookie
         * @see deleteCookie
         */ get: function() {
                        if (!this.cookieName) return false;
                        var cookies = _global_variables_utils__WEBPACK_IMPORTED_MODULE_25__["DomDocumentHelper"].getCookie();
                        return cookies && cookies.indexOf(this.cookieName + "=true") > -1;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Sets a cookie with a specified [`cookieName`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#cookieName) in the browser. If the `cookieName` property value is defined, this method is automatically called on survey completion.
     * @see hasCookie
     * @see deleteCookie
     */ SurveyModel.prototype.setCookie = function() {
                    if (!this.cookieName) return;
                    _global_variables_utils__WEBPACK_IMPORTED_MODULE_25__["DomDocumentHelper"].setCookie(this.cookieName + "=true; expires=Fri, 31 Dec 9999 0:0:0 GMT");
                };
                /**
     * Deletes a cookie with a specified [`cookieName`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#cookieName) from the browser.
     * @see hasCookie
     * @see setCookie
     */ SurveyModel.prototype.deleteCookie = function() {
                    if (!this.cookieName) return;
                    _global_variables_utils__WEBPACK_IMPORTED_MODULE_25__["DomDocumentHelper"].setCookie(this.cookieName + "=;");
                };
                Object.defineProperty(SurveyModel.prototype, "ignoreValidation", {
                    /**
         * This property is obsolete. Use the [`validationEnabled`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#validationEnabled) property instead.
         */ get: function() {
                        return !this.validationEnabled;
                    },
                    set: function(val1) {
                        this.validationEnabled = !val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Switches the survey to the next page.
     *
     * This method returns a Boolean value that indicates whether the page was successfully switched. `false` is returned if the current page is the last page or if it contains validation errors.
     * @returns `true` if the page was successfully switched; `false` otherwise.
     * @see isLastPage
     * @see prevPage
     * @see completeLastPage
     */ SurveyModel.prototype.nextPage = function() {
                    if (this.isLastPage) return false;
                    return this.doCurrentPageComplete(false);
                };
                SurveyModel.prototype.hasErrorsOnNavigate = function(doComplete) {
                    var _this = this;
                    if (!this.isEditMode || this.ignoreValidation) return false;
                    var skipValidation = doComplete && this.validationAllowComplete || !doComplete && this.validationAllowSwitchPages;
                    var func = function(hasErrors) {
                        if (!hasErrors || skipValidation) _this.doCurrentPageCompleteCore(doComplete);
                    };
                    if (this.isValidateOnComplete) {
                        if (!this.isLastPage) return false;
                        return this.validate(true, true, func) !== true && !skipValidation;
                    }
                    return this.validateCurrentPage(func) !== true && !skipValidation;
                };
                SurveyModel.prototype.checkForAsyncQuestionValidation = function(questions, func) {
                    var _this = this;
                    this.clearAsyncValidationQuesitons();
                    var _loop_2 = function() {
                        if (questions[i].isRunningValidators) {
                            var q_1 = questions[i];
                            q_1.onCompletedAsyncValidators = function(hasErrors) {
                                _this.onCompletedAsyncQuestionValidators(q_1, func, hasErrors);
                            };
                            this_2.asyncValidationQuesitons.push(questions[i]);
                        }
                    };
                    var this_2 = this;
                    for(var i = 0; i < questions.length; i++)_loop_2();
                    return this.asyncValidationQuesitons.length > 0;
                };
                SurveyModel.prototype.clearAsyncValidationQuesitons = function() {
                    if (!!this.asyncValidationQuesitons) {
                        var asynQuestions = this.asyncValidationQuesitons;
                        for(var i = 0; i < asynQuestions.length; i++)asynQuestions[i].onCompletedAsyncValidators = null;
                    }
                    this.asyncValidationQuesitons = [];
                };
                SurveyModel.prototype.onCompletedAsyncQuestionValidators = function(question, func, hasErrors) {
                    if (hasErrors) {
                        this.clearAsyncValidationQuesitons();
                        func(true);
                        if (this.focusOnFirstError && !!question && !!question.page && question.page === this.currentPage) {
                            var questions = this.currentPage.questions;
                            for(var i_1 = 0; i_1 < questions.length; i_1++){
                                if (questions[i_1] !== question && questions[i_1].errors.length > 0) return;
                            }
                            question.focus(true);
                        }
                        return;
                    }
                    var asynQuestions = this.asyncValidationQuesitons;
                    for(var i = 0; i < asynQuestions.length; i++){
                        if (asynQuestions[i].isRunningValidators) return;
                    }
                    func(false);
                };
                Object.defineProperty(SurveyModel.prototype, "isCurrentPageHasErrors", {
                    get: function() {
                        return this.checkIsCurrentPageHasErrors();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isCurrentPageValid", {
                    /**
         * Returns `true` if the current page does not contain errors.
         * @see currentPage
         */ get: function() {
                        return !this.checkIsCurrentPageHasErrors();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.hasCurrentPageErrors = function(onAsyncValidation) {
                    return this.hasPageErrors(undefined, onAsyncValidation);
                };
                /**
     * Validates all questions on the current page and returns `false` if the validation fails.
     *
     * If you use validation expressions and at least one of them calls an async function, the `validateCurrentPage` method returns `undefined`. In this case, you should pass a callback function as the `onAsyncValidation` parameter. The function's `hasErrors` Boolean parameter will contain the validation result.
     * @param onAsyncValidation *(Optional)* Pass a callback function. It accepts a Boolean `hasErrors` parameter that equals `true` if the validation fails or `false` otherwise.
     * @see currentPage
     * @see validate
     * @see validateCurrentPage
     */ SurveyModel.prototype.validateCurrentPage = function(onAsyncValidation) {
                    return this.validatePage(undefined, onAsyncValidation);
                };
                SurveyModel.prototype.hasPageErrors = function(page, onAsyncValidation) {
                    var res = this.validatePage(page, onAsyncValidation);
                    if (res === undefined) return res;
                    return !res;
                };
                /**
     * Validates all questions on a specified page and returns `false` if the validation fails.
     *
     * If you use validation expressions and at least one of them calls an async function, the `validatePage` method returns `undefined`. In this case, you should pass a callback function as the `onAsyncValidation` parameter. The function's `hasErrors` Boolean parameter will contain the validation result.
     * @param page Pass the `PageModel` that you want to validate. You can pass `undefined` to validate the [`activePage`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#activePage).
     * @param onAsyncValidation *(Optional)* Pass a callback function. It accepts a Boolean `hasErrors` parameter that equals `true` if the validation fails or `false` otherwise.
     * @see validate
     * @see validateCurrentPage
     */ SurveyModel.prototype.validatePage = function(page, onAsyncValidation) {
                    if (!page) page = this.activePage;
                    if (!page) return true;
                    if (this.checkIsPageHasErrors(page)) return false;
                    if (!onAsyncValidation) return true;
                    return this.checkForAsyncQuestionValidation(page.questions, function(hasErrors) {
                        return onAsyncValidation(hasErrors);
                    }) ? undefined : true;
                };
                SurveyModel.prototype.hasErrors = function(fireCallback, focusOnFirstError, onAsyncValidation) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (focusOnFirstError === void 0) focusOnFirstError = false;
                    var res = this.validate(fireCallback, focusOnFirstError, onAsyncValidation);
                    if (res === undefined) return res;
                    return !res;
                };
                /**
     * Validates all questions and returns `false` if the validation fails.
     *
     * If you use validation expressions and at least one of them calls an async function, the `validate` method returns `undefined`. In this case, you should pass a callback function as the `onAsyncValidation` parameter. The function's `hasErrors` Boolean parameter will contain the validation result.
     * @param fireCallback *(Optional)* Pass `false` if you do not want to show validation errors in the UI.
     * @param focusOnFirstError *(Optional)* Pass `true` if you want to focus the first question with a validation error. The survey will be switched to the page that contains this question if required.
     * @param onAsyncValidation *(Optional)* Pass a callback function. It accepts a Boolean `hasErrors` parameter that equals `true` if the validation fails or `false` otherwise.
     * @see validateCurrentPage
     * @see validatePage
     */ SurveyModel.prototype.validate = function(fireCallback, focusOnFirstError, onAsyncValidation) {
                    if (fireCallback === void 0) fireCallback = true;
                    if (focusOnFirstError === void 0) focusOnFirstError = false;
                    if (!!onAsyncValidation) fireCallback = true;
                    var visPages = this.visiblePages;
                    var firstErrorPage = null;
                    var res = true;
                    var rec = {
                        fireCallback: fireCallback,
                        focuseOnFirstError: focusOnFirstError,
                        firstErrorQuestion: null,
                        result: false
                    };
                    for(var i = 0; i < visPages.length; i++)if (!visPages[i].validate(fireCallback, focusOnFirstError, rec)) {
                        if (!firstErrorPage) firstErrorPage = visPages[i];
                        res = false;
                    }
                    if (focusOnFirstError && !!firstErrorPage && !!rec.firstErrorQuestion) rec.firstErrorQuestion.focus(true);
                    if (!res || !onAsyncValidation) return res;
                    return this.checkForAsyncQuestionValidation(this.getAllQuestions(), function(hasErrors) {
                        return onAsyncValidation(hasErrors);
                    }) ? undefined : true;
                };
                SurveyModel.prototype.ensureUniqueNames = function(element) {
                    if (element === void 0) element = null;
                    if (element == null) for(var i = 0; i < this.pages.length; i++)this.ensureUniqueName(this.pages[i]);
                    else this.ensureUniqueName(element);
                };
                SurveyModel.prototype.ensureUniqueName = function(element) {
                    if (element.isPage) this.ensureUniquePageName(element);
                    if (element.isPanel) this.ensureUniquePanelName(element);
                    if (element.isPage || element.isPanel) {
                        var elements = element.elements;
                        for(var i = 0; i < elements.length; i++)this.ensureUniqueNames(elements[i]);
                    } else this.ensureUniqueQuestionName(element);
                };
                SurveyModel.prototype.ensureUniquePageName = function(element) {
                    var _this = this;
                    return this.ensureUniqueElementName(element, function(name) {
                        return _this.getPageByName(name);
                    });
                };
                SurveyModel.prototype.ensureUniquePanelName = function(element) {
                    var _this = this;
                    return this.ensureUniqueElementName(element, function(name) {
                        return _this.getPanelByName(name);
                    });
                };
                SurveyModel.prototype.ensureUniqueQuestionName = function(element) {
                    var _this = this;
                    return this.ensureUniqueElementName(element, function(name) {
                        return _this.getQuestionByName(name);
                    });
                };
                SurveyModel.prototype.ensureUniqueElementName = function(element, getElementByName) {
                    var existingElement = getElementByName(element.name);
                    if (!existingElement || existingElement == element) return;
                    var newName = this.getNewName(element.name);
                    while(!!getElementByName(newName))var newName = this.getNewName(element.name);
                    element.name = newName;
                };
                SurveyModel.prototype.getNewName = function(name) {
                    var pos = name.length;
                    while(pos > 0 && name[pos - 1] >= "0" && name[pos - 1] <= "9")pos--;
                    var base = name.substring(0, pos);
                    var num = 0;
                    if (pos < name.length) num = parseInt(name.substring(pos));
                    num++;
                    return base + num;
                };
                SurveyModel.prototype.checkIsCurrentPageHasErrors = function(isFocuseOnFirstError) {
                    if (isFocuseOnFirstError === void 0) isFocuseOnFirstError = undefined;
                    return this.checkIsPageHasErrors(this.activePage, isFocuseOnFirstError);
                };
                SurveyModel.prototype.checkIsPageHasErrors = function(page, isFocuseOnFirstError) {
                    if (isFocuseOnFirstError === void 0) isFocuseOnFirstError = undefined;
                    if (isFocuseOnFirstError === undefined) isFocuseOnFirstError = this.focusOnFirstError;
                    if (!page) return true;
                    var res = !page.validate(true, isFocuseOnFirstError);
                    this.fireValidatedErrorsOnPage(page);
                    return res;
                };
                SurveyModel.prototype.fireValidatedErrorsOnPage = function(page) {
                    if (this.onValidatedErrorsOnCurrentPage.isEmpty || !page) return;
                    var questionsOnPage = page.questions;
                    var questions = new Array();
                    var errors = new Array();
                    for(var i = 0; i < questionsOnPage.length; i++){
                        var q = questionsOnPage[i];
                        if (q.errors.length > 0) {
                            questions.push(q);
                            for(var j = 0; j < q.errors.length; j++)errors.push(q.errors[j]);
                        }
                    }
                    this.onValidatedErrorsOnCurrentPage.fire(this, {
                        questions: questions,
                        errors: errors,
                        page: page
                    });
                };
                /**
     * Switches the survey to the previous page.
     *
     * This method returns a Boolean value that indicates whether the page was successfully switched. `false` is returned if the current page is the first page.
     * @returns `true` if the page was successfully switched; `false` otherwise.
     * @see isFirstPage
     * @see nextPage
     */ SurveyModel.prototype.prevPage = function() {
                    var _this = this;
                    if (this.isFirstPage || this.state === "starting") return false;
                    this.resetNavigationButton();
                    var skipped = this.skippedPages.find(function(sp) {
                        return sp.to == _this.currentPage;
                    });
                    if (skipped) {
                        this.currentPage = skipped.from;
                        this.skippedPages.splice(this.skippedPages.indexOf(skipped), 1);
                    } else {
                        var vPages = this.visiblePages;
                        var index = vPages.indexOf(this.currentPage);
                        this.currentPage = vPages[index - 1];
                    }
                    return true;
                };
                /**
     * Completes the survey if it currently displays the last page and the page contains no validation errors. If both these conditions are met, this method returns `true`; otherwise, `false`.
     *
     * If you want to complete the survey regardless of the current page and validation errors, use the [`doComplete()`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#completeLastPage) event.
     * @see isCurrentPageValid
     * @see nextPage
     */ SurveyModel.prototype.completeLastPage = function() {
                    if (this.isValidateOnComplete) this.cancelPreview();
                    var res = this.doCurrentPageComplete(true);
                    if (res) this.cancelPreview();
                    return res;
                };
                SurveyModel.prototype.navigationMouseDown = function() {
                    this.isNavigationButtonPressed = true;
                    return true;
                };
                SurveyModel.prototype.resetNavigationButton = function() {
                    this.isNavigationButtonPressed = false;
                };
                SurveyModel.prototype.nextPageUIClick = function() {
                    if (!!this.mouseDownPage && this.mouseDownPage !== this.activePage) return;
                    this.mouseDownPage = null;
                    return this.nextPage();
                };
                SurveyModel.prototype.nextPageMouseDown = function() {
                    this.mouseDownPage = this.activePage;
                    return this.navigationMouseDown();
                };
                /**
     * Displays a [preview of given answers](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#preview-page). Returns `false` if the preview cannot be displayed because of validation errors.
     * @see cancelPreview
     * @see showPreviewBeforeComplete
     * @see onShowingPreview
     * @see state
     */ SurveyModel.prototype.showPreview = function() {
                    this.resetNavigationButton();
                    if (!this.isValidateOnComplete) {
                        if (this.hasErrorsOnNavigate(true)) return false;
                        if (this.doServerValidation(true, true)) return false;
                    }
                    this.showPreviewCore();
                    return true;
                };
                SurveyModel.prototype.showPreviewCore = function() {
                    var options = {
                        allowShowPreview: true,
                        allow: true
                    };
                    this.onShowingPreview.fire(this, options);
                    this.isShowingPreview = options.allowShowPreview && options.allow;
                };
                /**
     * Cancels a [preview of given answers](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#preview-page) and switches the survey to the page specified by the `currentPage` parameter.
     * @param currentPage A new current page. If you do not specify this parameter, the survey displays the last page.
     * @see showPreview
     * @see showPreviewBeforeComplete
     * @see state
     */ SurveyModel.prototype.cancelPreview = function(currentPage) {
                    if (currentPage === void 0) currentPage = null;
                    if (!this.isShowingPreview) return;
                    this.gotoPageFromPreview = currentPage;
                    this.isShowingPreview = false;
                };
                SurveyModel.prototype.cancelPreviewByPage = function(panel) {
                    this.cancelPreview(panel["originalPage"]);
                };
                SurveyModel.prototype.doCurrentPageComplete = function(doComplete) {
                    if (this.isValidatingOnServer) return false;
                    this.resetNavigationButton();
                    if (this.hasErrorsOnNavigate(doComplete)) return false;
                    return this.doCurrentPageCompleteCore(doComplete);
                };
                SurveyModel.prototype.doCurrentPageCompleteCore = function(doComplete) {
                    if (this.doServerValidation(doComplete)) return false;
                    if (doComplete) {
                        this.currentPage.passed = true;
                        return this.doComplete(this.canBeCompletedByTrigger, this.completedTrigger);
                    }
                    this.doNextPage();
                    return true;
                };
                Object.defineProperty(SurveyModel.prototype, "isSinglePage", {
                    get: function() {
                        return this.questionsOnPageMode == "singlePage";
                    },
                    set: function(val1) {
                        this.questionsOnPageMode = val1 ? "singlePage" : "standard";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "questionsOnPageMode", {
                    /**
         * Specifies how to distribute survey elements between pages.
         *
         * Possible values:
         *
         * - `"singlePage"` - Combines all survey pages into a single page.
         * - `"questionPerPage"` - Creates a separate page for every question.
         * - `"standard"` (default) - Retains the original structure specified in the JSON schema.
         */ get: function() {
                        return this.getPropertyValue("questionsOnPageMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("questionsOnPageMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "firstPageIsStarted", {
                    /**
         * Gets or sets a Boolean value that specifies whether the first page is a start page.
         *
         * Refer to the following help topic for more information: [Start Page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#start-page).
         * @see startedPage
         * @see activePage
         */ get: function() {
                        return this.getPropertyValue("firstPageIsStarted");
                    },
                    set: function(val1) {
                        this.setPropertyValue("firstPageIsStarted", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.isPageStarted = function(page) {
                    return this.firstPageIsStarted && this.pages.length > 1 && this.pages[0] === page;
                };
                Object.defineProperty(SurveyModel.prototype, "showPreviewBeforeComplete", {
                    /**
         * Allows respondents to preview answers before they are submitted.
         *
         * Possible values:
         *
         * - `"showAllQuestions"` - Displays all questions in the preview.
         * - `"showAnsweredQuestions"` - Displays only answered questions in the preview.
         * - `"noPreview"` (default) - Hides the preview.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/survey-showpreview/ (linkStyle))
         * @see showPreview
         * @see cancelPreview
         */ get: function() {
                        return this.getPropertyValue("showPreviewBeforeComplete");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showPreviewBeforeComplete", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isShowPreviewBeforeComplete", {
                    get: function() {
                        var preview = this.showPreviewBeforeComplete;
                        return preview == "showAllQuestions" || preview == "showAnsweredQuestions";
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.onFirstPageIsStartedChanged = function() {
                    this.isStartedState = this.firstPageIsStarted && this.pages.length > 1;
                    this.pageVisibilityChanged(this.pages[0], !this.isStartedState);
                };
                SurveyModel.prototype.onShowingPreviewChanged = function() {
                    if (this.isDesignMode) return;
                    if (this.isShowingPreview) {
                        this.runningPages = this.pages.slice(0, this.pages.length);
                        this.setupPagesForPageModes(true, false);
                    } else {
                        if (this.runningPages) this.restoreOriginalPages(this.runningPages);
                        this.runningPages = undefined;
                    }
                    this.runConditions();
                    this.updateAllElementsVisibility(this.pages);
                    this.updateVisibleIndexes();
                    if (this.isShowingPreview) this.currentPageNo = 0;
                    else {
                        var curPage = this.gotoPageFromPreview;
                        this.gotoPageFromPreview = null;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(curPage) && this.visiblePageCount > 0) curPage = this.visiblePages[this.visiblePageCount - 1];
                        if (!!curPage) {
                            this.changeCurrentPageFromPreview = true;
                            this.currentPage = curPage;
                            this.changeCurrentPageFromPreview = false;
                        }
                    }
                };
                SurveyModel.prototype.onQuestionsOnPageModeChanged = function(oldValue, isFirstLoad) {
                    if (isFirstLoad === void 0) isFirstLoad = false;
                    if (this.isShowingPreview) return;
                    if (this.questionsOnPageMode == "standard" || this.isDesignMode) {
                        if (this.originalPages) this.restoreOriginalPages(this.originalPages);
                        this.originalPages = undefined;
                    } else {
                        if (!oldValue || oldValue == "standard") this.originalPages = this.pages.slice(0, this.pages.length);
                        this.setupPagesForPageModes(this.isSinglePage, isFirstLoad);
                    }
                    this.runConditions();
                    this.updateVisibleIndexes();
                };
                SurveyModel.prototype.restoreOriginalPages = function(originalPages) {
                    this.questionHashesClear();
                    this.pages.splice(0, this.pages.length);
                    for(var i = 0; i < originalPages.length; i++){
                        var page = originalPages[i];
                        page.setWasShown(false);
                        this.pages.push(page);
                    }
                };
                SurveyModel.prototype.getPageStartIndex = function() {
                    return this.firstPageIsStarted && this.pages.length > 0 ? 1 : 0;
                };
                SurveyModel.prototype.setupPagesForPageModes = function(isSinglePage, isFirstLoad) {
                    this.questionHashesClear();
                    this.isLockingUpdateOnPageModes = !isFirstLoad;
                    var startIndex = this.getPageStartIndex();
                    _super.prototype.startLoadingFromJson.call(this);
                    var newPages = this.createPagesForQuestionOnPageMode(isSinglePage, startIndex);
                    var deletedLen = this.pages.length - startIndex;
                    this.pages.splice(startIndex, deletedLen);
                    for(var i = 0; i < newPages.length; i++)this.pages.push(newPages[i]);
                    _super.prototype.endLoadingFromJson.call(this);
                    for(var i = 0; i < newPages.length; i++)newPages[i].setSurveyImpl(this, true);
                    this.doElementsOnLoad();
                    this.updateCurrentPage();
                    this.isLockingUpdateOnPageModes = false;
                };
                SurveyModel.prototype.createPagesForQuestionOnPageMode = function(isSinglePage, startIndex) {
                    if (isSinglePage) return [
                        this.createSinglePage(startIndex)
                    ];
                    return this.createPagesForEveryQuestion(startIndex);
                };
                SurveyModel.prototype.createSinglePage = function(startIndex) {
                    var single = this.createNewPage("all");
                    single.setSurveyImpl(this);
                    for(var i = startIndex; i < this.pages.length; i++){
                        var page = this.pages[i];
                        var panel = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass("panel");
                        panel.originalPage = page;
                        single.addPanel(panel);
                        var json = new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]().toJsonObject(page);
                        new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]().toObject(json, panel);
                        if (!this.showPageTitles) panel.title = "";
                    }
                    return single;
                };
                SurveyModel.prototype.createPagesForEveryQuestion = function(startIndex) {
                    var res = [];
                    for(var i = startIndex; i < this.pages.length; i++){
                        var originalPage = this.pages[i];
                        // Initialize randomization
                        originalPage.setWasShown(true);
                        for(var j = 0; j < originalPage.elements.length; j++){
                            var originalElement = originalPage.elements[j];
                            var element = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass(originalElement.getType());
                            if (!element) continue;
                            var jsonObj = new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]();
                            //Deserialize page properties only, excluding elements
                            jsonObj.lightSerializing = true;
                            var pageJson = jsonObj.toJsonObject(originalPage);
                            var page = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass(originalPage.getType());
                            page.fromJSON(pageJson);
                            page.name = originalElement.name;
                            page.setSurveyImpl(this);
                            res.push(page);
                            var json = new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]().toJsonObject(originalElement);
                            page.addElement(element);
                            new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]().toObject(json, element);
                            for(var k = 0; k < page.questions.length; k++)this.questionHashesAdded(page.questions[k]);
                        }
                    }
                    return res;
                };
                Object.defineProperty(SurveyModel.prototype, "isFirstPage", {
                    /**
         * Indicates whether the [current page](#currentPage) is the first page.
         *
         * > If the survey displays the [start page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#start-page), this property contains `false`. Use the [`isShowStartingPage`](#isShowStartingPage) property to find out whether the start page is currently displayed.
         */ get: function() {
                        return this.getPropertyValue("isFirstPage");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isLastPage", {
                    /**
         * Indicates whether the [current page](#currentPage) is the last page.
         */ get: function() {
                        return this.getPropertyValue("isLastPage");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateButtonsVisibility = function() {
                    this.updateIsFirstLastPageState();
                    this.setPropertyValue("isShowPrevButton", this.calcIsShowPrevButton());
                    this.setPropertyValue("isShowNextButton", this.calcIsShowNextButton());
                    this.setPropertyValue("isCompleteButtonVisible", this.calcIsCompleteButtonVisible());
                    this.setPropertyValue("isPreviewButtonVisible", this.calcIsPreviewButtonVisible());
                    this.setPropertyValue("isCancelPreviewButtonVisible", this.calcIsCancelPreviewButtonVisible());
                };
                Object.defineProperty(SurveyModel.prototype, "isShowPrevButton", {
                    get: function() {
                        return this.getPropertyValue("isShowPrevButton");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isShowNextButton", {
                    get: function() {
                        return this.getPropertyValue("isShowNextButton");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isCompleteButtonVisible", {
                    get: function() {
                        return this.getPropertyValue("isCompleteButtonVisible");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isPreviewButtonVisible", {
                    get: function() {
                        return this.getPropertyValue("isPreviewButtonVisible");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isCancelPreviewButtonVisible", {
                    get: function() {
                        return this.getPropertyValue("isCancelPreviewButtonVisible");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateIsFirstLastPageState = function() {
                    var curPage = this.currentPage;
                    this.setPropertyValue("isFirstPage", !!curPage && curPage === this.firstVisiblePage);
                    this.setPropertyValue("isLastPage", !!curPage && curPage === this.lastVisiblePage);
                };
                SurveyModel.prototype.calcIsShowPrevButton = function() {
                    if (this.isFirstPage || !this.showPrevButton || this.state !== "running") return false;
                    var page = this.visiblePages[this.currentPageNo - 1];
                    return this.getPageMaxTimeToFinish(page) <= 0;
                };
                SurveyModel.prototype.calcIsShowNextButton = function() {
                    return this.state === "running" && !this.isLastPage && !this.canBeCompletedByTrigger;
                };
                SurveyModel.prototype.calcIsCompleteButtonVisible = function() {
                    var state = this.state;
                    return this.isEditMode && (this.state === "running" && (this.isLastPage && !this.isShowPreviewBeforeComplete || this.canBeCompletedByTrigger) || state === "preview") && this.showCompleteButton;
                };
                SurveyModel.prototype.calcIsPreviewButtonVisible = function() {
                    return this.isEditMode && this.isShowPreviewBeforeComplete && this.state == "running" && this.isLastPage;
                };
                SurveyModel.prototype.calcIsCancelPreviewButtonVisible = function() {
                    return this.isEditMode && this.isShowPreviewBeforeComplete && this.state == "preview";
                };
                Object.defineProperty(SurveyModel.prototype, "firstVisiblePage", {
                    get: function() {
                        var pages = this.pages;
                        for(var i = 0; i < pages.length; i++){
                            if (this.isPageInVisibleList(pages[i])) return pages[i];
                        }
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "lastVisiblePage", {
                    get: function() {
                        var pages = this.pages;
                        for(var i = pages.length - 1; i >= 0; i--){
                            if (this.isPageInVisibleList(pages[i])) return pages[i];
                        }
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Completes the survey.
     *
     * When you call this method, Form Library performs the following actions:
     *
     * 1. Saves a cookie if the [`cookieName`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#cookieName) property is set.
     * 1. Switches the survey [`state`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#state) to `"completed"`.
     * 1. Raises the [`onComplete`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onComplete) event.
     * 1. Navigates the user to a URL specified by the [`navigateToUrl`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#navigateToUrl) or [`navigateToUrlOnCondition`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#navigateToUrlOnCondition) property.
     * 1. Calls the [`sendResult()`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#sendResult) method if Form Library works with [SurveyJS Service](https://api.surveyjs.io/).
     *
     * The `doComplete()` method completes the survey regardless of validation errors and the current page. If you need to ensure that survey results are valid and full, call the [`completeLastPage()`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#completeLastPage) method instead.
     *
     * @param isCompleteOnTrigger For internal use.
     * @param completeTrigger For internal use.
     * @returns `false` if survey completion is cancelled within the [`onCompleting`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onCompleting) event handler; otherwise, `true`.
     * @see surveyPostId
     */ SurveyModel.prototype.doComplete = function(isCompleteOnTrigger, completeTrigger) {
                    if (isCompleteOnTrigger === void 0) isCompleteOnTrigger = false;
                    if (this.isCompleted) return;
                    if (!this.checkOnCompletingEvent(isCompleteOnTrigger, completeTrigger)) {
                        this.isCompleted = false;
                        return false;
                    }
                    this.checkOnPageTriggers(true);
                    this.stopTimer();
                    this.notifyQuestionsOnHidingContent(this.currentPage);
                    this.isCompleted = true;
                    this.clearUnusedValues();
                    this.saveDataOnComplete(isCompleteOnTrigger, completeTrigger);
                    this.setCookie();
                    return true;
                };
                SurveyModel.prototype.saveDataOnComplete = function(isCompleteOnTrigger, completeTrigger) {
                    var _this = this;
                    if (isCompleteOnTrigger === void 0) isCompleteOnTrigger = false;
                    var previousCookie = this.hasCookie;
                    var showSaveInProgress = function(text) {
                        savingDataStarted = true;
                        _this.setCompletedState("saving", text);
                    };
                    var showSaveError = function(text) {
                        _this.setCompletedState("error", text);
                    };
                    var showSaveSuccess = function(text) {
                        _this.setCompletedState("success", text);
                        _this.navigateTo();
                    };
                    var clearSaveMessages = function(text) {
                        _this.setCompletedState("", "");
                    };
                    var savingDataStarted = false;
                    var onCompleteOptions = {
                        isCompleteOnTrigger: isCompleteOnTrigger,
                        completeTrigger: completeTrigger,
                        showSaveInProgress: showSaveInProgress,
                        showSaveError: showSaveError,
                        showSaveSuccess: showSaveSuccess,
                        clearSaveMessages: clearSaveMessages,
                        //Obsolete functions
                        showDataSaving: showSaveInProgress,
                        showDataSavingError: showSaveError,
                        showDataSavingSuccess: showSaveSuccess,
                        showDataSavingClear: clearSaveMessages
                    };
                    this.onComplete.fire(this, onCompleteOptions);
                    if (!previousCookie && this.surveyPostId) this.sendResult();
                    if (!savingDataStarted) this.navigateTo();
                };
                SurveyModel.prototype.checkOnCompletingEvent = function(isCompleteOnTrigger, completeTrigger) {
                    var options = {
                        allowComplete: true,
                        allow: true,
                        isCompleteOnTrigger: isCompleteOnTrigger,
                        completeTrigger: completeTrigger
                    };
                    this.onCompleting.fire(this, options);
                    return options.allowComplete && options.allow;
                };
                /**
     * Starts the survey. Applies only if the survey has a [start page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#start-page).
     * @see firstPageIsStarted
     * @see completeLastPage
     */ SurveyModel.prototype.start = function() {
                    if (!this.firstPageIsStarted) return false;
                    this.isCurrentPageRendering = true;
                    if (this.checkIsPageHasErrors(this.startedPage, true)) return false;
                    this.isStartedState = false;
                    this.notifyQuestionsOnHidingContent(this.pages[0]);
                    this.startTimerFromUI();
                    this.onStarted.fire(this, {});
                    this.updateVisibleIndexes();
                    if (!!this.currentPage) this.currentPage.locStrsChanged();
                    return true;
                };
                Object.defineProperty(SurveyModel.prototype, "isValidatingOnServer", {
                    /**
         * Indicates whether the current page is being [validated on a server](#onServerValidateQuestions).
         */ get: function() {
                        return this.getPropertyValue("isValidatingOnServer", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.setIsValidatingOnServer = function(val1) {
                    if (val1 == this.isValidatingOnServer) return;
                    this.setPropertyValue("isValidatingOnServer", val1);
                    this.onIsValidatingOnServerChanged();
                };
                SurveyModel.prototype.createServerValidationOptions = function(doComplete, isPreview) {
                    var self = this;
                    var options = {
                        data: {},
                        errors: {},
                        survey: this,
                        complete: function() {
                            self.completeServerValidation(options, isPreview);
                        }
                    };
                    if (doComplete && this.isValidateOnComplete) options.data = this.data;
                    else {
                        var questions = this.activePage.questions;
                        for(var i = 0; i < questions.length; i++){
                            var question = questions[i];
                            if (!question.visible) continue;
                            var value = this.getValue(question.getValueName());
                            if (!this.isValueEmpty(value)) options.data[question.getValueName()] = value;
                        }
                    }
                    return options;
                };
                SurveyModel.prototype.onIsValidatingOnServerChanged = function() {};
                SurveyModel.prototype.doServerValidation = function(doComplete, isPreview) {
                    var _this = this;
                    if (isPreview === void 0) isPreview = false;
                    if (!this.onServerValidateQuestions || this.onServerValidateQuestions.isEmpty) return false;
                    if (!doComplete && this.isValidateOnComplete) return false;
                    this.setIsValidatingOnServer(true);
                    var isFunc = typeof this.onServerValidateQuestions === "function";
                    this.serverValidationEventCount = !isFunc ? this.onServerValidateQuestions.length : 1;
                    if (isFunc) this.onServerValidateQuestions(this, this.createServerValidationOptions(doComplete, isPreview));
                    else this.onServerValidateQuestions.fireByCreatingOptions(this, function() {
                        return _this.createServerValidationOptions(doComplete, isPreview);
                    });
                    return true;
                };
                SurveyModel.prototype.completeServerValidation = function(options, isPreview) {
                    if (this.serverValidationEventCount > 1) {
                        this.serverValidationEventCount--;
                        if (!!options && !!options.errors && Object.keys(options.errors).length === 0) return;
                    }
                    this.serverValidationEventCount = 0;
                    this.setIsValidatingOnServer(false);
                    if (!options && !options.survey) return;
                    var self = options.survey;
                    var hasErrors = false;
                    if (options.errors) {
                        var hasToFocus = this.focusOnFirstError;
                        for(var name in options.errors){
                            var question = self.getQuestionByName(name);
                            if (question && question["errors"]) {
                                hasErrors = true;
                                question.addError(new _error__WEBPACK_IMPORTED_MODULE_9__["CustomError"](options.errors[name], this));
                                if (hasToFocus) {
                                    hasToFocus = false;
                                    if (!!question.page) this.currentPage = question.page;
                                    question.focus(true);
                                }
                            }
                        }
                        this.fireValidatedErrorsOnPage(this.currentPage);
                    }
                    if (!hasErrors) {
                        if (isPreview) this.showPreviewCore();
                        else if (self.isLastPage) self.doComplete();
                        else self.doNextPage();
                    }
                };
                SurveyModel.prototype.doNextPage = function() {
                    var curPage = this.currentPage;
                    this.checkOnPageTriggers(false);
                    if (!this.isCompleted) {
                        if (this.sendResultOnPageNext) this.sendResult(this.surveyPostId, this.clientId, true);
                        if (curPage === this.currentPage) {
                            var vPages = this.visiblePages;
                            var index = vPages.indexOf(this.currentPage);
                            this.currentPage = vPages[index + 1];
                        }
                    } else this.doComplete(true);
                };
                SurveyModel.prototype.setCompleted = function(trigger) {
                    this.doComplete(true, trigger);
                };
                SurveyModel.prototype.canBeCompleted = function(trigger, isCompleted) {
                    var _a;
                    if (!_settings__WEBPACK_IMPORTED_MODULE_14__["settings"].triggers.changeNavigationButtonsOnComplete) return;
                    var prevCanBeCompleted = this.canBeCompletedByTrigger;
                    if (!this.completedByTriggers) this.completedByTriggers = {};
                    if (isCompleted) this.completedByTriggers[trigger.id] = {
                        trigger: trigger,
                        pageId: (_a = this.currentPage) === null || _a === void 0 ? void 0 : _a.id
                    };
                    else delete this.completedByTriggers[trigger.id];
                    if (prevCanBeCompleted !== this.canBeCompletedByTrigger) this.updateButtonsVisibility();
                };
                Object.defineProperty(SurveyModel.prototype, "canBeCompletedByTrigger", {
                    get: function() {
                        var _a;
                        if (!this.completedByTriggers) return false;
                        var keys = Object.keys(this.completedByTriggers);
                        if (keys.length === 0) return false;
                        var id = (_a = this.currentPage) === null || _a === void 0 ? void 0 : _a.id;
                        if (!id) return true;
                        for(var i = 0; i < keys.length; i++){
                            if (id === this.completedByTriggers[keys[i]].pageId) return true;
                        }
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "completedTrigger", {
                    get: function() {
                        if (!this.canBeCompletedByTrigger) return undefined;
                        var key = Object.keys(this.completedByTriggers)[0];
                        return this.completedByTriggers[key].trigger;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "processedCompletedHtml", {
                    /**
         * Returns HTML content displayed on the [complete page](https://surveyjs.io/form-library/documentation/design-survey/create-a-multi-page-survey#complete-page).
         *
         * To specify HTML content, use the [`completedHtml`](#completedHtml) property.
         */ get: function() {
                        var html = this.renderedCompletedHtml;
                        return !!html ? this.processHtml(html, "completed") : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "processedCompletedBeforeHtml", {
                    /**
         * Returns HTML content displayed to a user who has completed the survey before. To identify such users, the survey uses a [cookie name](#cookieName) or [client ID](#clientId).
         *
         * To specify HTML content, use the [`completedBeforeHtml`](#completedBeforeHtml) property.
         */ get: function() {
                        return this.locCompletedBeforeHtml.textOrHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "processedLoadingHtml", {
                    /**
         * Returns HTML content displayed while a survey JSON schema is being loaded from [SurveyJS Service](https://api.surveyjs.io).
         *
         * To specify HTML content, use the [`loadingHtml`](#loadingHtml) property.
         */ get: function() {
                        return this.locLoadingHtml.textOrHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getProgressInfo = function() {
                    var pages = this.isDesignMode ? this.pages : this.visiblePages;
                    return _survey_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElement"].getProgressInfoByElements(pages, false);
                };
                Object.defineProperty(SurveyModel.prototype, "progressText", {
                    /**
         * Returns text displayed by the progress bar (for instance, "Page 2 of 3" or "Answered 3/8 questions"). Handle the [`onProgressText`](#onProgressText) event to change this text.
         * @see progressValue
         * @see showProgressBar
         * @see progressBarType
         */ get: function() {
                        var res = this.getPropertyValue("progressText", "");
                        if (!res) {
                            this.updateProgressText();
                            res = this.getPropertyValue("progressText", "");
                        }
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.updateProgressText = function(onValueChanged) {
                    if (onValueChanged === void 0) onValueChanged = false;
                    if (this.isCalculatingProgressText) return;
                    if (onValueChanged && this.progressBarType == "pages" && this.onProgressText.isEmpty) return;
                    this.isCalculatingProgressText = true;
                    this.setPropertyValue("progressText", this.getProgressText());
                    this.setPropertyValue("progressValue", this.getProgress());
                    this.isCalculatingProgressText = false;
                };
                SurveyModel.prototype.getProgressText = function() {
                    if (!this.isDesignMode && this.currentPage == null) return "";
                    var options = {
                        questionCount: 0,
                        answeredQuestionCount: 0,
                        requiredQuestionCount: 0,
                        requiredAnsweredQuestionCount: 0,
                        text: ""
                    };
                    var type = this.progressBarType.toLowerCase();
                    if (type === "questions" || type === "requiredquestions" || type === "correctquestions" || !this.onProgressText.isEmpty) {
                        var info = this.getProgressInfo();
                        options.questionCount = info.questionCount;
                        options.answeredQuestionCount = info.answeredQuestionCount;
                        options.requiredQuestionCount = info.requiredQuestionCount;
                        options.requiredAnsweredQuestionCount = info.requiredAnsweredQuestionCount;
                    }
                    options.text = this.getProgressTextCore(options);
                    this.onProgressText.fire(this, options);
                    return options.text;
                };
                SurveyModel.prototype.getProgressTextCore = function(info) {
                    var type = this.progressBarType.toLowerCase();
                    if (type === "questions") return this.getLocalizationFormatString("questionsProgressText", info.answeredQuestionCount, info.questionCount);
                    if (type === "requiredquestions") return this.getLocalizationFormatString("questionsProgressText", info.requiredAnsweredQuestionCount, info.requiredQuestionCount);
                    if (type === "correctquestions") {
                        var correctAnswersCount = this.getCorrectedAnswerCount();
                        return this.getLocalizationFormatString("questionsProgressText", correctAnswersCount, info.questionCount);
                    }
                    var vPages = this.isDesignMode ? this.pages : this.visiblePages;
                    var index = vPages.indexOf(this.currentPage) + 1;
                    return this.getLocalizationFormatString("progressText", index, vPages.length);
                };
                SurveyModel.prototype.getRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_18__["CssClassBuilder"]().append(this.css.root).append(this.css.rootMobile, this.isMobile).append(this.css.rootAnimationDisabled, !_settings__WEBPACK_IMPORTED_MODULE_14__["settings"].animationEnabled).append(this.css.rootReadOnly, this.mode === "display" && !this.isDesignMode).append(this.css.rootCompact, this.isCompact).append(this.css.rootFitToContainer, this.fitToContainer).toString();
                };
                SurveyModel.prototype.afterRenderSurvey = function(htmlElement) {
                    var _this = this;
                    this.destroyResizeObserver();
                    if (Array.isArray(htmlElement)) htmlElement = _survey_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElement"].GetFirstNonTextElement(htmlElement);
                    var observedElement = htmlElement;
                    var cssVariables = this.css.variables;
                    if (!!cssVariables) {
                        var mobileWidth_1 = Number.parseFloat(_global_variables_utils__WEBPACK_IMPORTED_MODULE_25__["DomDocumentHelper"].getComputedStyle(observedElement).getPropertyValue(cssVariables.mobileWidth));
                        if (!!mobileWidth_1) {
                            var isProcessed_1 = false;
                            this.resizeObserver = new ResizeObserver(function(entries) {
                                _global_variables_utils__WEBPACK_IMPORTED_MODULE_25__["DomWindowHelper"].requestAnimationFrame(function() {
                                    if (isProcessed_1 || !Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["isContainerVisible"])(observedElement)) isProcessed_1 = false;
                                    else isProcessed_1 = _this.processResponsiveness(observedElement.offsetWidth, mobileWidth_1);
                                });
                            });
                            this.resizeObserver.observe(observedElement);
                        }
                    }
                    this.onAfterRenderSurvey.fire(this, {
                        survey: this,
                        htmlElement: htmlElement
                    });
                    this.rootElement = htmlElement;
                    this.addScrollEventListener();
                };
                SurveyModel.prototype.processResponsiveness = function(width, mobileWidth) {
                    var isMobile = width < mobileWidth;
                    var isMobileChanged = this.isMobile !== isMobile;
                    if (isMobileChanged) this.setIsMobile(isMobile);
                    this.layoutElements.forEach(function(layoutElement) {
                        return layoutElement.processResponsiveness && layoutElement.processResponsiveness(width);
                    });
                    return isMobileChanged;
                };
                SurveyModel.prototype.triggerResponsiveness = function(hard) {
                    this.getAllQuestions().forEach(function(question) {
                        question.triggerResponsiveness(hard);
                    });
                };
                SurveyModel.prototype.destroyResizeObserver = function() {
                    if (!!this.resizeObserver) {
                        this.resizeObserver.disconnect();
                        this.resizeObserver = undefined;
                    }
                };
                SurveyModel.prototype.updateQuestionCssClasses = function(question, cssClasses) {
                    this.onUpdateQuestionCssClasses.fire(this, {
                        question: question,
                        cssClasses: cssClasses
                    });
                };
                SurveyModel.prototype.updatePanelCssClasses = function(panel, cssClasses) {
                    this.onUpdatePanelCssClasses.fire(this, {
                        panel: panel,
                        cssClasses: cssClasses
                    });
                };
                SurveyModel.prototype.updatePageCssClasses = function(page, cssClasses) {
                    this.onUpdatePageCssClasses.fire(this, {
                        page: page,
                        cssClasses: cssClasses
                    });
                };
                SurveyModel.prototype.updateChoiceItemCss = function(question, options) {
                    options.question = question;
                    this.onUpdateChoiceItemCss.fire(this, options);
                };
                SurveyModel.prototype.afterRenderPage = function(htmlElement) {
                    var _this = this;
                    if (!this.isDesignMode && !this.focusingQuestionInfo) {
                        var doScroll_1 = !this.isFirstPageRendering;
                        setTimeout(function() {
                            return _this.scrollToTopOnPageChange(doScroll_1);
                        }, 1);
                    }
                    this.focusQuestionInfo();
                    this.isFirstPageRendering = false;
                    if (this.onAfterRenderPage.isEmpty) return;
                    this.onAfterRenderPage.fire(this, {
                        page: this.activePage,
                        htmlElement: htmlElement
                    });
                };
                SurveyModel.prototype.afterRenderHeader = function(htmlElement) {
                    if (this.onAfterRenderHeader.isEmpty) return;
                    this.onAfterRenderHeader.fire(this, {
                        htmlElement: htmlElement
                    });
                };
                SurveyModel.prototype.afterRenderQuestion = function(question, htmlElement) {
                    this.onAfterRenderQuestion.fire(this, {
                        question: question,
                        htmlElement: htmlElement
                    });
                };
                SurveyModel.prototype.afterRenderQuestionInput = function(question, htmlElement) {
                    if (this.onAfterRenderQuestionInput.isEmpty) return;
                    var id = question.inputId;
                    var root = _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].environment.root;
                    if (!!id && htmlElement.id !== id && typeof root !== "undefined") {
                        var el = root.getElementById(id);
                        if (!!el) htmlElement = el;
                    }
                    this.onAfterRenderQuestionInput.fire(this, {
                        question: question,
                        htmlElement: htmlElement
                    });
                };
                SurveyModel.prototype.afterRenderPanel = function(panel, htmlElement) {
                    this.onAfterRenderPanel.fire(this, {
                        panel: panel,
                        htmlElement: htmlElement
                    });
                };
                SurveyModel.prototype.whenQuestionFocusIn = function(question) {
                    this.onFocusInQuestion.fire(this, {
                        question: question
                    });
                };
                SurveyModel.prototype.whenPanelFocusIn = function(panel) {
                    this.onFocusInPanel.fire(this, {
                        panel: panel
                    });
                };
                SurveyModel.prototype.rebuildQuestionChoices = function() {
                    this.getAllQuestions().forEach(function(q) {
                        return q.surveyChoiceItemVisibilityChange();
                    });
                };
                SurveyModel.prototype.canChangeChoiceItemsVisibility = function() {
                    return !this.onShowingChoiceItem.isEmpty;
                };
                SurveyModel.prototype.getChoiceItemVisibility = function(question, item, val1) {
                    var options = {
                        question: question,
                        item: item,
                        visible: val1
                    };
                    this.onShowingChoiceItem.fire(this, options);
                    return options.visible;
                };
                SurveyModel.prototype.loadQuestionChoices = function(options) {
                    this.onChoicesLazyLoad.fire(this, options);
                };
                SurveyModel.prototype.getChoiceDisplayValue = function(options) {
                    if (this.onGetChoiceDisplayValue.isEmpty) options.setItems(null);
                    else this.onGetChoiceDisplayValue.fire(this, options);
                };
                SurveyModel.prototype.matrixBeforeRowAdded = function(options) {
                    this.onMatrixRowAdding.fire(this, options);
                };
                SurveyModel.prototype.matrixRowAdded = function(question, row) {
                    this.onMatrixRowAdded.fire(this, {
                        question: question,
                        row: row
                    });
                };
                SurveyModel.prototype.matrixColumnAdded = function(question, column) {
                    this.onMatrixColumnAdded.fire(this, {
                        question: question,
                        column: column
                    });
                };
                SurveyModel.prototype.multipleTextItemAdded = function(question, item) {
                    this.onMultipleTextItemAdded.fire(this, {
                        question: question,
                        item: item
                    });
                };
                SurveyModel.prototype.getQuestionByValueNameFromArray = function(valueName, name, index) {
                    var questions = this.getQuestionsByValueName(valueName);
                    if (!questions) return;
                    for(var i = 0; i < questions.length; i++){
                        var res = questions[i].getQuestionFromArray(name, index);
                        if (!!res) return res;
                    }
                    return null;
                };
                SurveyModel.prototype.matrixRowRemoved = function(question, rowIndex, row) {
                    this.onMatrixRowRemoved.fire(this, {
                        question: question,
                        rowIndex: rowIndex,
                        row: row
                    });
                };
                SurveyModel.prototype.matrixRowRemoving = function(question, rowIndex, row) {
                    var options = {
                        question: question,
                        rowIndex: rowIndex,
                        row: row,
                        allow: true
                    };
                    this.onMatrixRowRemoving.fire(this, options);
                    return options.allow;
                };
                SurveyModel.prototype.matrixAllowRemoveRow = function(question, rowIndex, row) {
                    var options = {
                        question: question,
                        rowIndex: rowIndex,
                        row: row,
                        allow: true
                    };
                    this.onMatrixRenderRemoveButton.fire(this, options);
                    return options.allow;
                };
                SurveyModel.prototype.matrixDetailPanelVisibleChanged = function(question, rowIndex, row, visible) {
                    var options = {
                        question: question,
                        rowIndex: rowIndex,
                        row: row,
                        visible: visible,
                        detailPanel: row.detailPanel
                    };
                    this.onMatrixDetailPanelVisibleChanged.fire(this, options);
                };
                SurveyModel.prototype.matrixCellCreating = function(question, options) {
                    options.question = question;
                    this.onMatrixCellCreating.fire(this, options);
                };
                SurveyModel.prototype.matrixCellCreated = function(question, options) {
                    options.question = question;
                    this.onMatrixCellCreated.fire(this, options);
                };
                SurveyModel.prototype.matrixAfterCellRender = function(question, options) {
                    options.question = question;
                    this.onAfterRenderMatrixCell.fire(this, options);
                };
                SurveyModel.prototype.matrixCellValueChanged = function(question, options) {
                    options.question = question;
                    this.onMatrixCellValueChanged.fire(this, options);
                };
                SurveyModel.prototype.matrixCellValueChanging = function(question, options) {
                    options.question = question;
                    this.onMatrixCellValueChanging.fire(this, options);
                };
                Object.defineProperty(SurveyModel.prototype, "isValidateOnValueChanging", {
                    get: function() {
                        return this.checkErrorsMode === "onValueChanging";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isValidateOnValueChanged", {
                    get: function() {
                        return this.checkErrorsMode === "onValueChanged";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isValidateOnComplete", {
                    get: function() {
                        return this.checkErrorsMode === "onComplete" || this.validationAllowSwitchPages && !this.validationAllowComplete;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.matrixCellValidate = function(question, options) {
                    options.question = question;
                    this.onMatrixCellValidate.fire(this, options);
                    return options.error ? new _error__WEBPACK_IMPORTED_MODULE_9__["CustomError"](options.error, this) : null;
                };
                SurveyModel.prototype.dynamicPanelAdded = function(question, panelIndex, panel) {
                    if (!this.isLoadingFromJson) this.updateVisibleIndexes();
                    if (this.onDynamicPanelAdded.isEmpty) return;
                    var panels = question.panels;
                    if (panelIndex === undefined) {
                        panelIndex = panels.length - 1;
                        panel = panels[panelIndex];
                    }
                    this.onDynamicPanelAdded.fire(this, {
                        question: question,
                        panel: panel,
                        panelIndex: panelIndex
                    });
                };
                SurveyModel.prototype.dynamicPanelRemoved = function(question, panelIndex, panel) {
                    var questions = !!panel ? panel.questions : [];
                    for(var i = 0; i < questions.length; i++)questions[i].clearOnDeletingContainer();
                    this.updateVisibleIndexes();
                    this.onDynamicPanelRemoved.fire(this, {
                        question: question,
                        panelIndex: panelIndex,
                        panel: panel
                    });
                };
                SurveyModel.prototype.dynamicPanelRemoving = function(question, panelIndex, panel) {
                    var options = {
                        question: question,
                        panelIndex: panelIndex,
                        panel: panel,
                        allow: true
                    };
                    this.onDynamicPanelRemoving.fire(this, options);
                    return options.allow;
                };
                SurveyModel.prototype.dynamicPanelItemValueChanged = function(question, options) {
                    options.question = question;
                    options.panelIndex = options.itemIndex;
                    options.panelData = options.itemValue;
                    this.onDynamicPanelItemValueChanged.fire(this, options);
                };
                SurveyModel.prototype.dynamicPanelGetTabTitle = function(question, options) {
                    options.question = question;
                    this.onGetDynamicPanelTabTitle.fire(this, options);
                };
                SurveyModel.prototype.dynamicPanelCurrentIndexChanged = function(question, options) {
                    options.question = question;
                    this.onDynamicPanelCurrentIndexChanged.fire(this, options);
                };
                SurveyModel.prototype.dragAndDropAllow = function(options) {
                    this.onDragDropAllow.fire(this, options);
                    return options.allow;
                };
                SurveyModel.prototype.elementContentVisibilityChanged = function(element) {
                    if (this.currentPage) this.currentPage.ensureRowsVisibility();
                    this.onElementContentVisibilityChanged.fire(this, {
                        element: element
                    });
                };
                SurveyModel.prototype.getUpdatedPanelFooterActions = function(panel, actions, question) {
                    var options = {
                        question: question,
                        panel: panel,
                        actions: actions
                    };
                    this.onGetPanelFooterActions.fire(this, options);
                    return options.actions;
                };
                SurveyModel.prototype.getUpdatedElementTitleActions = function(element, titleActions) {
                    if (element.isPage) return this.getUpdatedPageTitleActions(element, titleActions);
                    if (element.isPanel) return this.getUpdatedPanelTitleActions(element, titleActions);
                    return this.getUpdatedQuestionTitleActions(element, titleActions);
                };
                SurveyModel.prototype.getUpdatedQuestionTitleActions = function(question, titleActions) {
                    var options = {
                        question: question,
                        titleActions: titleActions
                    };
                    this.onGetQuestionTitleActions.fire(this, options);
                    return options.titleActions;
                };
                SurveyModel.prototype.getUpdatedPanelTitleActions = function(panel, titleActions) {
                    var options = {
                        panel: panel,
                        titleActions: titleActions
                    };
                    this.onGetPanelTitleActions.fire(this, options);
                    return options.titleActions;
                };
                SurveyModel.prototype.getUpdatedPageTitleActions = function(page, titleActions) {
                    var options = {
                        page: page,
                        titleActions: titleActions
                    };
                    this.onGetPageTitleActions.fire(this, options);
                    return options.titleActions;
                };
                SurveyModel.prototype.getUpdatedMatrixRowActions = function(question, row, actions) {
                    var options = {
                        question: question,
                        actions: actions,
                        row: row
                    };
                    this.onGetMatrixRowActions.fire(this, options);
                    return options.actions;
                };
                SurveyModel.prototype.scrollElementToTop = function(element, question, page, id, scrollIfVisible) {
                    var options = {
                        element: element,
                        question: question,
                        page: page,
                        elementId: id,
                        cancel: false
                    };
                    this.onScrollingElementToTop.fire(this, options);
                    if (!options.cancel) _survey_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElement"].ScrollElementToTop(options.elementId, scrollIfVisible);
                };
                /**
     * Opens a dialog window for users to select files.
     * @param input A [file input HTML element](https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement).
     * @param callback A callback function that you can use to process selected files. Accepts an array of JavaScript <a href="https://developer.mozilla.org/en-US/docs/Web/API/File" target="_blank">File</a> objects.
     * @see onOpenFileChooser
     * @see onUploadFile
     */ SurveyModel.prototype.chooseFiles = function(input, callback, context) {
                    if (this.onOpenFileChooser.isEmpty) Object(_utils_utils__WEBPACK_IMPORTED_MODULE_15__["chooseFiles"])(input, callback);
                    else this.onOpenFileChooser.fire(this, {
                        input: input,
                        element: context && context.element || this.survey,
                        elementType: context && context.elementType,
                        item: context && context.item,
                        propertyName: context && context.propertyName,
                        callback: callback,
                        context: context
                    });
                };
                /**
     * Uploads files to a server.
     *
     * The following code shows how to call this method:
     *
     * ```js
     * const question = survey.getQuestionByName("myFileQuestion");
     * survey.uploadFiles(
     *   question,
     *   question.name,
     *   question.value,
     *   (data, errors) => {
     *     // ...
     *   }
     * );
     * ```
     * @param question A [File Upload question instance](https://surveyjs.io/form-library/documentation/api-reference/file-model) or [Signature Pad question instance](https://surveyjs.io/form-library/documentation/api-reference/signature-pad-model).
     * @param name The File Upload question's [`name`](https://surveyjs.io/form-library/documentation/api-reference/file-model#name) or Signature Pad question's [`name`](https://surveyjs.io/form-library/documentation/api-reference/signature-pad-model#name).
     * @param files An array of JavaScript <a href="https://developer.mozilla.org/en-US/docs/Web/API/File" target="_blank">File</a> objects that represent files to upload.
     * @param callback A callback function that allows you to access successfully uploaded files as the first argument. If any files fail to upload, the second argument contains an array of error messages.
     * @see onUploadFiles
     * @see downloadFile
     */ SurveyModel.prototype.uploadFiles = function(question, name, files, callback) {
                    var _this = this;
                    if (this.onUploadFiles.isEmpty) callback("error", this.getLocString("noUploadFilesHandler"));
                    else this.taskManager.runTask("file", function(done) {
                        _this.onUploadFiles.fire(_this, {
                            question: question,
                            name: name,
                            files: files || [],
                            callback: function(status, data) {
                                callback(status, data);
                                done();
                            }
                        });
                    });
                    if (this.surveyPostId) this.uploadFilesCore(name, files, callback);
                };
                /**
     * Downloads a file from a server.
     *
     * The following code shows how to call this method:
     *
     * ```js
     * const question = survey.getQuestionByName("myFileQuestion");
     * survey.downloadFile(
     *   question,
     *   question.name,
     *   // Download the first uploaded file
     *   question.value[0],
     *   (status, data) => {
     *     if (status === "success") {
     *       // Use `data` to retrieve the file
     *     }
     *     if (status === "error") {
     *       // Handle error
     *     }
     *   }
     * );
     * ```
     *
     * @param question A [File Upload question instance](https://surveyjs.io/form-library/documentation/api-reference/file-model).
     * @param questionName The File Upload question's [`name`](https://surveyjs.io/form-library/documentation/api-reference/file-model#name).
     * @param fileValue An object from File Upload's [`value`](https://surveyjs.io/form-library/documentation/api-reference/file-model#value) array. This object contains metadata about the file you want to download.
     * @param callback A callback function that allows you to get the download status (`"success"` or `"error"`) and the file identifier (URL, file name, etc.) that you can use to retrieve the file.
     * @see onDownloadFile
     * @see uploadFiles
     */ SurveyModel.prototype.downloadFile = function(question, questionName, fileValue, callback) {
                    if (this.onDownloadFile.isEmpty) !!callback && callback("success", fileValue.content || fileValue);
                    this.onDownloadFile.fire(this, {
                        question: question,
                        name: questionName,
                        content: fileValue.content || fileValue,
                        fileValue: fileValue,
                        callback: callback
                    });
                };
                SurveyModel.prototype.clearFiles = function(question, name, value, fileName, callback) {
                    if (this.onClearFiles.isEmpty) !!callback && callback("success", value);
                    this.onClearFiles.fire(this, {
                        question: question,
                        name: name,
                        value: value,
                        fileName: fileName,
                        callback: callback
                    });
                };
                SurveyModel.prototype.updateChoicesFromServer = function(question, choices, serverResult) {
                    var options = {
                        question: question,
                        choices: choices,
                        serverResult: serverResult
                    };
                    this.onLoadChoicesFromServer.fire(this, options);
                    return options.choices;
                };
                SurveyModel.prototype.loadedChoicesFromServer = function(question) {
                    this.locStrsChanged();
                };
                SurveyModel.prototype.createSurveyService = function() {
                    return new _dxSurveyService__WEBPACK_IMPORTED_MODULE_7__["dxSurveyService"]();
                };
                SurveyModel.prototype.uploadFilesCore = function(name, files, uploadingCallback) {
                    var _this = this;
                    var responses = [];
                    files.forEach(function(file) {
                        if (uploadingCallback) uploadingCallback("uploading", file);
                        _this.createSurveyService().sendFile(_this.surveyPostId, file, function(success, response) {
                            if (success) {
                                responses.push({
                                    content: response,
                                    file: file
                                });
                                if (responses.length === files.length) {
                                    if (uploadingCallback) uploadingCallback("success", responses);
                                }
                            } else if (uploadingCallback) uploadingCallback("error", {
                                response: response,
                                file: file
                            });
                        });
                    });
                };
                SurveyModel.prototype.getPage = function(index) {
                    return this.pages[index];
                };
                /**
     * Adds an existing page to the survey.
     * @param page A page to add.
     * @param index An index at which to insert the page. If you do not specify this parameter, the page will be added to the end.
     * @see addNewPage
     * @see createNewPage
     */ SurveyModel.prototype.addPage = function(page, index) {
                    if (index === void 0) index = -1;
                    if (page == null) return;
                    if (index < 0 || index >= this.pages.length) this.pages.push(page);
                    else this.pages.splice(index, 0, page);
                };
                /**
     * Creates a new page and adds it to the survey.
     *
     * If you want to switch a survey to the newly added page, assign its index to the [`currentPageNo`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#currentPageNo) property or assign the entire page to the [`currentPage`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#currentPage) property.
     *
     * @param name A page name. If you do not specify this parameter, it will be generated automatically.
     * @param index An index at which to insert the page. If you do not specify this parameter, the page will be added to the end.
     * @returns The created and added page.
     * @see addPage
     * @see createNewPage
     */ SurveyModel.prototype.addNewPage = function(name, index) {
                    if (name === void 0) name = null;
                    if (index === void 0) index = -1;
                    var page = this.createNewPage(name);
                    this.addPage(page, index);
                    return page;
                };
                /**
     * Removes a page from the survey.
     *
     * Pass a `PageModel` object to this method. You can get this object in different ways. For example, you can call the [`getPageByName()`](#getPageByName) method to obtain a `PageModel` object with a specific name or use the [`currentPage`](#currentPage) property to access and delete the current page, as shown in the code below.
     *
     * ```js
     * // Delete the current page
     * survey.removePage(survey.currentPage);
     * ```
     * @param page A page to remove.
     * @see addNewPage
     */ SurveyModel.prototype.removePage = function(page) {
                    var index = this.pages.indexOf(page);
                    if (index < 0) return;
                    this.pages.splice(index, 1);
                    if (this.currentPage == page) this.currentPage = this.pages.length > 0 ? this.pages[0] : null;
                };
                /**
     * Returns a question with a specified [`name`](https://surveyjs.io/form-library/documentation/api-reference/question#name).
     * @param name A question name
     * @param caseInsensitive *(Optional)* A Boolean value that specifies case sensitivity when searching for the question. Default value: `false` (uppercase and lowercase letters are treated as distinct).
     * @returns A question with a specified name.
     * @see getAllQuestions
     * @see getQuestionByValueName
     */ SurveyModel.prototype.getQuestionByName = function(name, caseInsensitive) {
                    if (caseInsensitive === void 0) caseInsensitive = false;
                    if (!name) return null;
                    if (caseInsensitive) name = name.toLowerCase();
                    var hash = !!caseInsensitive ? this.questionHashes.namesInsensitive : this.questionHashes.names;
                    var res = hash[name];
                    if (!res) return null;
                    return res[0];
                };
                SurveyModel.prototype.findQuestionByName = function(name) {
                    return this.getQuestionByName(name);
                };
                /**
     * Returns a question with a specified [`valueName`](https://surveyjs.io/form-library/documentation/api-reference/question#valueName).
     *
     * > Since `valueName` does not have to be unique, multiple questions can have the same `valueName` value. In this case, the `getQuestionByValueName()` method returns the first such question. If you need to get all questions with the same `valueName`, call the `getQuestionsByValueName()` method.
     * @param valueName A question's `valueName` property value.
     * @param caseInsensitive *(Optional)* A Boolean value that specifies case sensitivity when searching for the question. Default value: `false` (uppercase and lowercase letters are treated as distinct).
     * @returns A question with a specified `valueName`.
     * @see getAllQuestions
     * @see getQuestionByName
     */ SurveyModel.prototype.getQuestionByValueName = function(valueName, caseInsensitive) {
                    if (caseInsensitive === void 0) caseInsensitive = false;
                    var res = this.getQuestionsByValueName(valueName, caseInsensitive);
                    return !!res ? res[0] : null;
                };
                /**
     * Returns all questions with a specified [`valueName`](https://surveyjs.io/form-library/documentation/api-reference/question#valueName). If a question's `valueName` is undefined, its [`name`](https://surveyjs.io/form-library/documentation/api-reference/question#name) property is used.
     * @param valueName A question's `valueName` property value.
     * @param caseInsensitive *(Optional)* A Boolean value that specifies case sensitivity when searching for the questions. Default value: `false` (uppercase and lowercase letters are treated as distinct).
     * @returns An array of questions with a specified `valueName`.
     * @see getAllQuestions
     * @see getQuestionByName
     */ SurveyModel.prototype.getQuestionsByValueName = function(valueName, caseInsensitive) {
                    if (caseInsensitive === void 0) caseInsensitive = false;
                    var hash = !!caseInsensitive ? this.questionHashes.valueNamesInsensitive : this.questionHashes.valueNames;
                    var res = hash[valueName];
                    if (!res) return null;
                    return res;
                };
                SurveyModel.prototype.getCalculatedValueByName = function(name) {
                    for(var i = 0; i < this.calculatedValues.length; i++){
                        if (name == this.calculatedValues[i].name) return this.calculatedValues[i];
                    }
                    return null;
                };
                /**
     * Returns an array of questions with specified [names](https://surveyjs.io/form-library/documentation/api-reference/question#name).
     * @param names An array of question names.
     * @param caseInsensitive *(Optional)* A Boolean value that specifies case sensitivity when searching for the questions. Default value: `false` (uppercase and lowercase letters are treated as distinct).
     * @returns An array of questions with specified names
     * @see getAllQuestions
     */ SurveyModel.prototype.getQuestionsByNames = function(names, caseInsensitive) {
                    if (caseInsensitive === void 0) caseInsensitive = false;
                    var result = [];
                    if (!names) return result;
                    for(var i = 0; i < names.length; i++){
                        if (!names[i]) continue;
                        var question = this.getQuestionByName(names[i], caseInsensitive);
                        if (question) result.push(question);
                    }
                    return result;
                };
                /**
     * Returns a page to which a specified survey element (question or panel) belongs.
     * @param element A question or panel instance.
     */ SurveyModel.prototype.getPageByElement = function(element) {
                    for(var i = 0; i < this.pages.length; i++){
                        var page = this.pages[i];
                        if (page.containsElement(element)) return page;
                    }
                    return null;
                };
                /**
     * Returns a page to which a specified question belongs.
     * @param question A question instance.
     */ SurveyModel.prototype.getPageByQuestion = function(question) {
                    return this.getPageByElement(question);
                };
                /**
     * Returns a page with a specified name.
     * @param name A page [name](https://surveyjs.io/form-library/documentation/api-reference/page-model#name).
     */ SurveyModel.prototype.getPageByName = function(name) {
                    for(var i = 0; i < this.pages.length; i++){
                        if (this.pages[i].name == name) return this.pages[i];
                    }
                    return null;
                };
                /**
     * Returns an array of pages with specified names.
     * @param names An array of page names.
     */ SurveyModel.prototype.getPagesByNames = function(names) {
                    var result = [];
                    if (!names) return result;
                    for(var i = 0; i < names.length; i++){
                        if (!names[i]) continue;
                        var page = this.getPageByName(names[i]);
                        if (page) result.push(page);
                    }
                    return result;
                };
                /**
     * Returns a list of all [questions](https://surveyjs.io/form-library/documentation/api-reference/question) in the survey.
     * @param visibleOnly A Boolean value that specifies whether to include only visible questions.
     * @param includeDesignTime For internal use.
     * @param includeNested A Boolean value that specifies whether to include nested questions, such as questions within matrix cells.
     * @returns An array of questions.
     * @see getQuestionByName
     */ SurveyModel.prototype.getAllQuestions = function(visibleOnly, includeDesignTime, includeNested) {
                    if (visibleOnly === void 0) visibleOnly = false;
                    if (includeDesignTime === void 0) includeDesignTime = false;
                    if (includeNested === void 0) includeNested = false;
                    if (includeNested) includeDesignTime = false;
                    var res = [];
                    for(var i = 0; i < this.pages.length; i++)this.pages[i].addQuestionsToList(res, visibleOnly, includeDesignTime);
                    if (!includeNested) return res;
                    var res2 = [];
                    res.forEach(function(q) {
                        res2.push(q);
                        q.getNestedQuestions(visibleOnly).forEach(function(nQ) {
                            return res2.push(nQ);
                        });
                    });
                    return res2;
                };
                /**
     * Returns an array of quiz questions. A question counts if it is visible, has an input field, and specifies [`correctAnswer`](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model#correctAnswer).
     *
     * For more information about quizzes, refer to the following tutorial: [Create a Quiz](https://surveyjs.io/form-library/documentation/design-survey/create-a-quiz).
     * @returns An array of quiz questions.
     * @see getQuizQuestionCount
     */ SurveyModel.prototype.getQuizQuestions = function() {
                    var result = new Array();
                    var startIndex = this.getPageStartIndex();
                    for(var i = startIndex; i < this.pages.length; i++){
                        if (!this.pages[i].isVisible) continue;
                        var questions = this.pages[i].questions;
                        for(var j = 0; j < questions.length; j++){
                            var q = questions[j];
                            if (q.quizQuestionCount > 0) result.push(q);
                        }
                    }
                    return result;
                };
                /**
     * Returns a [panel](https://surveyjs.io/form-library/documentation/api-reference/panel-model) with a specified [`name`](https://surveyjs.io/form-library/documentation/api-reference/panel-model#name).
     * @param name A panel name.
     * @param caseInsensitive *(Optional)* A Boolean value that specifies case sensitivity when searching for the panel. Default value: `false` (uppercase and lowercase letters are treated as distinct).
     * @returns A panel with a specified name.
     * @see getAllPanels
     */ SurveyModel.prototype.getPanelByName = function(name, caseInsensitive) {
                    if (caseInsensitive === void 0) caseInsensitive = false;
                    var panels = this.getAllPanels();
                    if (caseInsensitive) name = name.toLowerCase();
                    for(var i = 0; i < panels.length; i++){
                        var panelName = panels[i].name;
                        if (caseInsensitive) panelName = panelName.toLowerCase();
                        if (panelName == name) return panels[i];
                    }
                    return null;
                };
                /**
     * Returns a list of all [panels](https://surveyjs.io/form-library/documentation/api-reference/panel-model) in the survey.
     * @param visibleOnly A Boolean value that specifies whether to include only visible panels.
     * @param includeDesignTime For internal use.
     * @returns An array of panels.
     * @see getPanelByName
     */ SurveyModel.prototype.getAllPanels = function(visibleOnly, includeDesignTime) {
                    if (visibleOnly === void 0) visibleOnly = false;
                    if (includeDesignTime === void 0) includeDesignTime = false;
                    var result = new Array();
                    for(var i = 0; i < this.pages.length; i++)this.pages[i].addPanelsIntoList(result, visibleOnly, includeDesignTime);
                    return result;
                };
                /**
     * Creates and returns a new page but does not add it to the survey.
     *
     * Call the [`addPage(page)`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#addPage) method to add the created page to the survey later or the [`addNewPage(name, index)`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#addNewPage) method to create _and_ add a page to the survey.
     * @see addPage
     * @see addNewPage
     */ SurveyModel.prototype.createNewPage = function(name) {
                    var page = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].createClass("page");
                    page.name = name;
                    return page;
                };
                SurveyModel.prototype.questionOnValueChanging = function(valueName, newValue) {
                    if (!!this.editingObj) {
                        var prop = _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].findProperty(this.editingObj.getType(), valueName);
                        if (!!prop) newValue = prop.settingValue(this.editingObj, newValue);
                    }
                    if (this.onValueChanging.isEmpty) return newValue;
                    var options = {
                        name: valueName,
                        question: this.getQuestionByValueName(valueName),
                        value: this.getUnbindValue(newValue),
                        oldValue: this.getValue(valueName)
                    };
                    this.onValueChanging.fire(this, options);
                    return options.value;
                };
                SurveyModel.prototype.updateQuestionValue = function(valueName, newValue) {
                    if (this.isLoadingFromJson) return;
                    var questions = this.getQuestionsByValueName(valueName);
                    if (!!questions) for(var i = 0; i < questions.length; i++){
                        var qValue = questions[i].value;
                        if (qValue === newValue && Array.isArray(qValue) && !!this.editingObj || !this.isTwoValueEquals(qValue, newValue)) questions[i].updateValueFromSurvey(newValue, false);
                    }
                };
                SurveyModel.prototype.checkQuestionErrorOnValueChanged = function(question) {
                    if (!this.isNavigationButtonPressed && (this.isValidateOnValueChanged || question.getAllErrors().length > 0)) this.checkQuestionErrorOnValueChangedCore(question);
                };
                SurveyModel.prototype.checkQuestionErrorOnValueChangedCore = function(question) {
                    var oldErrorCount = question.getAllErrors().length;
                    var res = !question.validate(true, {
                        isOnValueChanged: !this.isValidateOnValueChanging
                    });
                    var isCheckErrorOnChanged = this.checkErrorsMode.indexOf("Value") > -1;
                    if (!!question.page && isCheckErrorOnChanged && (oldErrorCount > 0 || question.getAllErrors().length > 0)) this.fireValidatedErrorsOnPage(question.page);
                    return res;
                };
                SurveyModel.prototype.checkErrorsOnValueChanging = function(valueName, newValue) {
                    if (this.isLoadingFromJson) return false;
                    var questions = this.getQuestionsByValueName(valueName);
                    if (!questions) return false;
                    var res = false;
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        if (!this.isTwoValueEquals(q.valueForSurvey, newValue)) q.value = newValue;
                        if (this.checkQuestionErrorOnValueChangedCore(q)) res = true;
                        res = res || q.errors.length > 0;
                    }
                    return res;
                };
                SurveyModel.prototype.notifyQuestionOnValueChanged = function(valueName, newValue, questionName) {
                    if (this.isLoadingFromJson) return;
                    var questions = this.getQuestionsByValueName(valueName);
                    if (!!questions) for(var i = 0; i < questions.length; i++){
                        var question = questions[i];
                        this.checkQuestionErrorOnValueChanged(question);
                        question.onSurveyValueChanged(newValue);
                        this.onValueChanged.fire(this, {
                            name: valueName,
                            question: question,
                            value: newValue
                        });
                    }
                    else this.onValueChanged.fire(this, {
                        name: valueName,
                        question: null,
                        value: newValue
                    });
                    if (this.isDisposed) return;
                    this.checkElementsBindings(valueName, newValue);
                    this.notifyElementsOnAnyValueOrVariableChanged(valueName, questionName);
                };
                SurveyModel.prototype.checkElementsBindings = function(valueName, newValue) {
                    this.isRunningElementsBindings = true;
                    for(var i = 0; i < this.pages.length; i++)this.pages[i].checkBindings(valueName, newValue);
                    this.isRunningElementsBindings = false;
                    if (this.updateVisibleIndexAfterBindings) {
                        this.updateVisibleIndexes();
                        this.updateVisibleIndexAfterBindings = false;
                    }
                };
                SurveyModel.prototype.notifyElementsOnAnyValueOrVariableChanged = function(name, questionName) {
                    if (this.isEndLoadingFromJson === "processing") return;
                    if (this.isRunningConditions) {
                        this.conditionNotifyElementsOnAnyValueOrVariableChanged = true;
                        return;
                    }
                    for(var i = 0; i < this.pages.length; i++)this.pages[i].onAnyValueChanged(name, questionName);
                    if (!this.isEndLoadingFromJson) this.locStrsChanged();
                };
                SurveyModel.prototype.updateAllQuestionsValue = function(clearData) {
                    var questions = this.getAllQuestions();
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        var valName = q.getValueName();
                        q.updateValueFromSurvey(this.getValue(valName), clearData);
                        if (q.requireUpdateCommentValue) q.updateCommentFromSurvey(this.getComment(valName));
                    }
                };
                SurveyModel.prototype.notifyAllQuestionsOnValueChanged = function() {
                    var questions = this.getAllQuestions();
                    for(var i = 0; i < questions.length; i++)questions[i].onSurveyValueChanged(this.getValue(questions[i].getValueName()));
                };
                SurveyModel.prototype.checkOnPageTriggers = function(isOnComplete) {
                    var questions = this.getCurrentPageQuestions(true);
                    var values = {};
                    for(var i = 0; i < questions.length; i++){
                        var question = questions[i];
                        var name = question.getValueName();
                        values[name] = this.getValue(name);
                    }
                    this.addCalculatedValuesIntoFilteredValues(values);
                    this.checkTriggers(values, true, isOnComplete);
                };
                SurveyModel.prototype.getCurrentPageQuestions = function(includeInvsible) {
                    if (includeInvsible === void 0) includeInvsible = false;
                    var result = [];
                    var page = this.currentPage;
                    if (!page) return result;
                    for(var i = 0; i < page.questions.length; i++){
                        var question = page.questions[i];
                        if (!includeInvsible && !question.visible || !question.name) continue;
                        result.push(question);
                    }
                    return result;
                };
                SurveyModel.prototype.checkTriggers = function(key, isOnNextPage, isOnComplete, name) {
                    if (isOnComplete === void 0) isOnComplete = false;
                    if (this.isCompleted || this.triggers.length == 0 || this.isDisplayMode) return;
                    if (this.isTriggerIsRunning) {
                        this.triggerValues = this.getFilteredValues();
                        for(var k in key)this.triggerKeys[k] = key[k];
                        return;
                    }
                    var isQuestionInvalid = false;
                    if (!isOnComplete && name && this.hasRequiredValidQuestionTrigger) {
                        var question = this.getQuestionByValueName(name);
                        isQuestionInvalid = question && !question.validate(false);
                    }
                    this.isTriggerIsRunning = true;
                    this.triggerKeys = key;
                    this.triggerValues = this.getFilteredValues();
                    var properties = this.getFilteredProperties();
                    var prevCanBeCompleted = this.canBeCompletedByTrigger;
                    for(var i = 0; i < this.triggers.length; i++){
                        var trigger = this.triggers[i];
                        if (isQuestionInvalid && trigger.requireValidQuestion) continue;
                        trigger.checkExpression(isOnNextPage, isOnComplete, this.triggerKeys, this.triggerValues, properties);
                    }
                    if (prevCanBeCompleted !== this.canBeCompletedByTrigger) this.updateButtonsVisibility();
                    this.isTriggerIsRunning = false;
                };
                Object.defineProperty(SurveyModel.prototype, "hasRequiredValidQuestionTrigger", {
                    get: function() {
                        for(var i = 0; i < this.triggers.length; i++){
                            if (this.triggers[i].requireValidQuestion) return true;
                        }
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.doElementsOnLoad = function() {
                    for(var i = 0; i < this.pages.length; i++)this.pages[i].onSurveyLoad();
                };
                Object.defineProperty(SurveyModel.prototype, "isRunningConditions", {
                    get: function() {
                        return !!this.conditionValues;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Recalculates all [expressions](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#expressions) in the survey.
     */ SurveyModel.prototype.runExpressions = function() {
                    this.runConditions();
                };
                SurveyModel.prototype.runConditions = function() {
                    if (this.isCompleted || this.isEndLoadingFromJson === "processing" || this.isRunningConditions) return;
                    this.conditionValues = this.getFilteredValues();
                    var properties = this.getFilteredProperties();
                    var oldCurrentPageIndex = this.pages.indexOf(this.currentPage);
                    this.runConditionsCore(properties);
                    this.checkIfNewPagesBecomeVisible(oldCurrentPageIndex);
                    this.conditionValues = null;
                    if (this.isValueChangedOnRunningCondition && this.conditionRunnerCounter < _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].maxConditionRunCountOnValueChanged) {
                        this.isValueChangedOnRunningCondition = false;
                        this.conditionRunnerCounter++;
                        this.runConditions();
                    } else {
                        this.isValueChangedOnRunningCondition = false;
                        this.conditionRunnerCounter = 0;
                        if (this.conditionUpdateVisibleIndexes) {
                            this.conditionUpdateVisibleIndexes = false;
                            this.updateVisibleIndexes();
                        }
                        if (this.conditionNotifyElementsOnAnyValueOrVariableChanged) {
                            this.conditionNotifyElementsOnAnyValueOrVariableChanged = false;
                            this.notifyElementsOnAnyValueOrVariableChanged("");
                        }
                    }
                };
                SurveyModel.prototype.runConditionOnValueChanged = function(name, value) {
                    if (this.isRunningConditions) {
                        this.conditionValues[name] = value;
                        this.isValueChangedOnRunningCondition = true;
                    } else {
                        this.runConditions();
                        this.runQuestionsTriggers(name, value);
                    }
                };
                SurveyModel.prototype.runConditionsCore = function(properties) {
                    var pages = this.pages;
                    for(var i = 0; i < this.calculatedValues.length; i++)this.calculatedValues[i].resetCalculation();
                    for(var i = 0; i < this.calculatedValues.length; i++)this.calculatedValues[i].doCalculation(this.calculatedValues, this.conditionValues, properties);
                    _super.prototype.runConditionCore.call(this, this.conditionValues, properties);
                    for(var i_2 = 0; i_2 < pages.length; i_2++)pages[i_2].runCondition(this.conditionValues, properties);
                };
                SurveyModel.prototype.runQuestionsTriggers = function(name, value) {
                    if (this.isDisplayMode || this.isDesignMode) return;
                    var questions = this.getAllQuestions();
                    questions.forEach(function(q) {
                        return q.runTriggers(name, value);
                    });
                };
                SurveyModel.prototype.checkIfNewPagesBecomeVisible = function(oldCurrentPageIndex) {
                    var newCurrentPageIndex = this.pages.indexOf(this.currentPage);
                    if (newCurrentPageIndex <= oldCurrentPageIndex + 1) return;
                    for(var i = oldCurrentPageIndex + 1; i < newCurrentPageIndex; i++)if (this.pages[i].isVisible) {
                        this.currentPage = this.pages[i];
                        break;
                    }
                };
                /**
     * Posts a survey result to [SurveyJS Service](https://api.surveyjs.io/).
     * @param postId An identifier used to save survey results. You can find it on the [My Surveys](https://surveyjs.io/service/mysurveys) page. If you do not specify this parameter, the survey uses the [`surveyPostId`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#surveyPostId) property value.
     * @param clientId A respondent identifier (e-mail or other unique ID). This ID ensures that the respondent does not pass the same survey twice.
     * @param isPartial Pass `true` to save partial survey results (see [Continue an Incomplete Survey](https://surveyjs.io/form-library/documentation/handle-survey-results-continue-incomplete)).
     */ SurveyModel.prototype.sendResult = function(postId, clientId, isPartial) {
                    if (postId === void 0) postId = null;
                    if (clientId === void 0) clientId = null;
                    if (isPartial === void 0) isPartial = false;
                    if (!this.isEditMode) return;
                    if (isPartial && this.onPartialSend) this.onPartialSend.fire(this, null);
                    if (!postId && this.surveyPostId) postId = this.surveyPostId;
                    if (!postId) return;
                    if (clientId) this.clientId = clientId;
                    if (isPartial && !this.clientId) return;
                    var self = this;
                    if (this.surveyShowDataSaving) this.setCompletedState("saving", "");
                    this.createSurveyService().sendResult(postId, this.data, function(success, response, request) {
                        if (self.surveyShowDataSaving) {
                            if (success) self.setCompletedState("success", "");
                            else self.setCompletedState("error", response);
                        }
                        self.onSendResult.fire(self, {
                            success: success,
                            response: response,
                            request: request
                        });
                    }, this.clientId, isPartial);
                };
                /**
     * Requests [SurveyJS Service](https://api.surveyjs.io/) to retrieve all answers to a specified question. Handle the [`onGetResult`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onGetResult) event to access the answers.
     * @param resultId A result ID that identifies the required survey. You can find it on the [My Surveys](https://surveyjs.io/service/mysurveys) page.
     * @param questionName A question name.
     */ SurveyModel.prototype.getResult = function(resultId, questionName) {
                    var self = this;
                    this.createSurveyService().getResult(resultId, questionName, function(success, data, dataList, response) {
                        self.onGetResult.fire(self, {
                            success: success,
                            data: data,
                            dataList: dataList,
                            response: response
                        });
                    });
                };
                /**
     * Loads a survey JSON schema from the [SurveyJS Service](https://api.surveyjs.io). You can handle the [`onLoadedSurveyFromService`](#onLoadedSurveyFromService) event to modify the schema after loading if required.
     * @param surveyId The identifier of a survey JSON schema to load. Refer to the following help topic for more information: [Store Survey Results in the SurveyJS Service](https://surveyjs.io/form-library/documentation/handle-survey-results-store#store-survey-results-in-the-surveyjs-service).
     * @param clientId A user identifier (e-mail or other unique ID) used to determine whether the user has already taken the survey.
     */ SurveyModel.prototype.loadSurveyFromService = function(surveyId, clientId) {
                    if (surveyId === void 0) surveyId = null;
                    if (clientId === void 0) clientId = null;
                    if (surveyId) this.surveyId = surveyId;
                    if (clientId) this.clientId = clientId;
                    var self = this;
                    this.isLoading = true;
                    this.onLoadingSurveyFromService();
                    if (clientId) this.createSurveyService().getSurveyJsonAndIsCompleted(this.surveyId, this.clientId, function(success, json, isCompleted, response) {
                        self.isLoading = false;
                        if (success) {
                            self.isCompletedBefore = isCompleted == "completed";
                            self.loadSurveyFromServiceJson(json);
                        }
                    });
                    else this.createSurveyService().loadSurvey(this.surveyId, function(success, result, response) {
                        self.isLoading = false;
                        if (success) self.loadSurveyFromServiceJson(result);
                    });
                };
                SurveyModel.prototype.loadSurveyFromServiceJson = function(json) {
                    if (!json) return;
                    this.fromJSON(json);
                    this.notifyAllQuestionsOnValueChanged();
                    this.onLoadSurveyFromService();
                    this.onLoadedSurveyFromService.fire(this, {});
                };
                SurveyModel.prototype.onLoadingSurveyFromService = function() {};
                SurveyModel.prototype.onLoadSurveyFromService = function() {};
                SurveyModel.prototype.resetVisibleIndexes = function() {
                    var questions = this.getAllQuestions(true);
                    for(var i = 0; i < questions.length; i++)questions[i].setVisibleIndex(-1);
                    this.updateVisibleIndexes();
                };
                SurveyModel.prototype.updateVisibleIndexes = function() {
                    if (this.isLoadingFromJson || !!this.isEndLoadingFromJson) return;
                    if (this.isRunningConditions && this.onQuestionVisibleChanged.isEmpty && this.onPageVisibleChanged.isEmpty) {
                        //Run update visible index only one time on finishing running conditions
                        this.conditionUpdateVisibleIndexes = true;
                        return;
                    }
                    if (this.isRunningElementsBindings) {
                        this.updateVisibleIndexAfterBindings = true;
                        return;
                    }
                    this.updatePageVisibleIndexes(this.showPageNumbers);
                    if (this.showQuestionNumbers == "onPage") {
                        var visPages = this.visiblePages;
                        for(var i = 0; i < visPages.length; i++)visPages[i].setVisibleIndex(0);
                    } else {
                        var index = this.showQuestionNumbers == "on" ? 0 : -1;
                        for(var i = 0; i < this.pages.length; i++)index += this.pages[i].setVisibleIndex(index);
                    }
                    this.updateProgressText(true);
                };
                SurveyModel.prototype.updatePageVisibleIndexes = function(showIndex) {
                    this.updateButtonsVisibility();
                    var index = 0;
                    for(var i = 0; i < this.pages.length; i++){
                        var page = this.pages[i];
                        var isPageVisible = page.isVisible && (i > 0 || !page.isStartPage);
                        page.visibleIndex = isPageVisible ? index++ : -1;
                        page.num = isPageVisible ? page.visibleIndex + 1 : -1;
                    }
                };
                SurveyModel.prototype.fromJSON = function(json, options) {
                    if (!json) return;
                    this.questionHashesClear();
                    this.jsonErrors = null;
                    var jsonConverter = new _jsonobject__WEBPACK_IMPORTED_MODULE_1__["JsonObject"]();
                    jsonConverter.toObject(json, this, options);
                    if (jsonConverter.errors.length > 0) this.jsonErrors = jsonConverter.errors;
                    this.onStateAndCurrentPageChanged();
                    this.updateState();
                };
                SurveyModel.prototype.startLoadingFromJson = function(json) {
                    _super.prototype.startLoadingFromJson.call(this, json);
                    if (json && json.locale) this.locale = json.locale;
                };
                SurveyModel.prototype.setJsonObject = function(jsonObj) {
                    this.fromJSON(jsonObj);
                };
                SurveyModel.prototype.endLoadingFromJson = function() {
                    this.isEndLoadingFromJson = "processing";
                    this.onFirstPageIsStartedChanged();
                    this.onQuestionsOnPageModeChanged("standard", true);
                    _super.prototype.endLoadingFromJson.call(this);
                    if (this.hasCookie) this.isCompletedBefore = true;
                    this.doElementsOnLoad();
                    this.isEndLoadingFromJson = "conditions";
                    this.runConditions();
                    this.notifyElementsOnAnyValueOrVariableChanged("");
                    this.isEndLoadingFromJson = null;
                    this.updateVisibleIndexes();
                    this.updateHasLogo();
                    this.updateRenderBackgroundImage();
                    this.updateCurrentPage();
                    this.hasDescription = !!this.description;
                    this.titleIsEmpty = this.locTitle.isEmpty;
                    this.setCalculatedWidthModeUpdater();
                };
                SurveyModel.prototype.updateNavigationCss = function() {
                    if (!!this.navigationBar) {
                        this.updateNavigationBarCss();
                        !!this.updateNavigationItemCssCallback && this.updateNavigationItemCssCallback();
                    }
                };
                SurveyModel.prototype.updateNavigationBarCss = function() {
                    var val1 = this.navigationBar;
                    val1.cssClasses = this.css.actionBar;
                    val1.containerCss = this.css.footer;
                };
                SurveyModel.prototype.createNavigationBar = function() {
                    var res = new _actions_container__WEBPACK_IMPORTED_MODULE_17__["ActionContainer"]();
                    res.setItems(this.createNavigationActions());
                    return res;
                };
                SurveyModel.prototype.createNavigationActions = function() {
                    var _this = this;
                    var defaultComponent = "sv-nav-btn";
                    var navStart = new _actions_action__WEBPACK_IMPORTED_MODULE_16__["Action"]({
                        id: "sv-nav-start",
                        visible: new _base__WEBPACK_IMPORTED_MODULE_2__["ComputedUpdater"](function() {
                            return _this.isShowStartingPage;
                        }),
                        visibleIndex: 10,
                        locTitle: this.locStartSurveyText,
                        action: function() {
                            return _this.start();
                        },
                        component: defaultComponent
                    });
                    var navPrev = new _actions_action__WEBPACK_IMPORTED_MODULE_16__["Action"]({
                        id: "sv-nav-prev",
                        visible: new _base__WEBPACK_IMPORTED_MODULE_2__["ComputedUpdater"](function() {
                            return _this.isShowPrevButton;
                        }),
                        visibleIndex: 20,
                        data: {
                            mouseDown: function() {
                                return _this.navigationMouseDown();
                            }
                        },
                        locTitle: this.locPagePrevText,
                        action: function() {
                            return _this.prevPage();
                        },
                        component: defaultComponent
                    });
                    var navNext = new _actions_action__WEBPACK_IMPORTED_MODULE_16__["Action"]({
                        id: "sv-nav-next",
                        visible: new _base__WEBPACK_IMPORTED_MODULE_2__["ComputedUpdater"](function() {
                            return _this.isShowNextButton;
                        }),
                        visibleIndex: 30,
                        data: {
                            mouseDown: function() {
                                return _this.nextPageMouseDown();
                            }
                        },
                        locTitle: this.locPageNextText,
                        action: function() {
                            return _this.nextPageUIClick();
                        },
                        component: defaultComponent
                    });
                    var navPreview = new _actions_action__WEBPACK_IMPORTED_MODULE_16__["Action"]({
                        id: "sv-nav-preview",
                        visible: new _base__WEBPACK_IMPORTED_MODULE_2__["ComputedUpdater"](function() {
                            return _this.isPreviewButtonVisible;
                        }),
                        visibleIndex: 40,
                        data: {
                            mouseDown: function() {
                                return _this.navigationMouseDown();
                            }
                        },
                        locTitle: this.locPreviewText,
                        action: function() {
                            return _this.showPreview();
                        },
                        component: defaultComponent
                    });
                    var navComplete = new _actions_action__WEBPACK_IMPORTED_MODULE_16__["Action"]({
                        id: "sv-nav-complete",
                        visible: new _base__WEBPACK_IMPORTED_MODULE_2__["ComputedUpdater"](function() {
                            return _this.isCompleteButtonVisible;
                        }),
                        visibleIndex: 50,
                        data: {
                            mouseDown: function() {
                                return _this.navigationMouseDown();
                            }
                        },
                        locTitle: this.locCompleteText,
                        action: function() {
                            return _this.taskManager.waitAndExecute(function() {
                                return _this.completeLastPage();
                            });
                        },
                        component: defaultComponent
                    });
                    this.updateNavigationItemCssCallback = function() {
                        navStart.innerCss = _this.cssNavigationStart;
                        navPrev.innerCss = _this.cssNavigationPrev;
                        navNext.innerCss = _this.cssNavigationNext;
                        navPreview.innerCss = _this.cssNavigationPreview;
                        navComplete.innerCss = _this.cssNavigationComplete;
                    };
                    return [
                        navStart,
                        navPrev,
                        navNext,
                        navPreview,
                        navComplete
                    ];
                };
                SurveyModel.prototype.onBeforeCreating = function() {};
                SurveyModel.prototype.onCreating = function() {};
                SurveyModel.prototype.getProcessedTextValue = function(textValue) {
                    this.getProcessedTextValueCore(textValue);
                    if (!this.onProcessTextValue.isEmpty) {
                        var wasEmpty = this.isValueEmpty(textValue.value);
                        this.onProcessTextValue.fire(this, textValue);
                        textValue.isExists = textValue.isExists || wasEmpty && !this.isValueEmpty(textValue.value);
                    }
                };
                SurveyModel.prototype.getBuiltInVariableValue = function(name) {
                    if (name === "pageno") {
                        var page = this.currentPage;
                        return page != null ? this.visiblePages.indexOf(page) + 1 : 0;
                    }
                    if (name === "pagecount") return this.visiblePageCount;
                    if (name === "correctedanswers" || name === "correctanswers" || name === "correctedanswercount") return this.getCorrectedAnswerCount();
                    if (name === "incorrectedanswers" || name === "incorrectanswers" || name === "incorrectedanswercount") return this.getInCorrectedAnswerCount();
                    if (name === "questioncount") return this.getQuizQuestionCount();
                    return undefined;
                };
                SurveyModel.prototype.getProcessedTextValueCore = function(textValue) {
                    var name = textValue.name.toLocaleLowerCase();
                    if ([
                        "no",
                        "require",
                        "title"
                    ].indexOf(name) !== -1) return;
                    var builtInVar = this.getBuiltInVariableValue(name);
                    if (builtInVar !== undefined) {
                        textValue.isExists = true;
                        textValue.value = builtInVar;
                        return;
                    }
                    if (name === "locale") {
                        textValue.isExists = true;
                        textValue.value = !!this.locale ? this.locale : _surveyStrings__WEBPACK_IMPORTED_MODULE_8__["surveyLocalization"].defaultLocale;
                        return;
                    }
                    var variable = this.getVariable(name);
                    if (variable !== undefined) {
                        textValue.isExists = true;
                        textValue.value = variable;
                        return;
                    }
                    var question = this.getFirstName(name);
                    if (question) {
                        var questionUseDisplayText = question.useDisplayValuesInDynamicTexts;
                        textValue.isExists = true;
                        var firstName = question.getValueName().toLowerCase();
                        name = firstName + name.substring(firstName.length);
                        name = name.toLocaleLowerCase();
                        var values = {};
                        values[firstName] = textValue.returnDisplayValue && questionUseDisplayText ? question.getDisplayValue(false, undefined) : question.value;
                        textValue.value = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_6__["ProcessValue"]().getValue(name, values);
                        return;
                    }
                    this.getProcessedValuesWithoutQuestion(textValue);
                };
                SurveyModel.prototype.getProcessedValuesWithoutQuestion = function(textValue) {
                    var value = this.getValue(textValue.name);
                    if (value !== undefined) {
                        textValue.isExists = true;
                        textValue.value = value;
                        return;
                    }
                    var processor = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_6__["ProcessValue"]();
                    var firstName = processor.getFirstName(textValue.name);
                    if (firstName === textValue.name) return;
                    var data = {};
                    var val1 = this.getValue(firstName);
                    if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(val1)) val1 = this.getVariable(firstName);
                    if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(val1)) return;
                    data[firstName] = val1;
                    textValue.value = processor.getValue(textValue.name, data);
                    textValue.isExists = processor.hasValue(textValue.name, data);
                };
                SurveyModel.prototype.getFirstName = function(name) {
                    name = name.toLowerCase();
                    var question;
                    do {
                        question = this.getQuestionByValueName(name, true);
                        name = this.reduceFirstName(name);
                    }while (!question && !!name);
                    return question;
                };
                SurveyModel.prototype.reduceFirstName = function(name) {
                    var pos1 = name.lastIndexOf(".");
                    var pos2 = name.lastIndexOf("[");
                    if (pos1 < 0 && pos2 < 0) return "";
                    var pos = Math.max(pos1, pos2);
                    return name.substring(0, pos);
                };
                SurveyModel.prototype.clearUnusedValues = function() {
                    this.isClearingUnsedValues = true;
                    var questions = this.getAllQuestions();
                    for(var i = 0; i < questions.length; i++)questions[i].clearUnusedValues();
                    this.clearInvisibleQuestionValues();
                    this.isClearingUnsedValues = false;
                };
                SurveyModel.prototype.hasVisibleQuestionByValueName = function(valueName) {
                    var questions = this.getQuestionsByValueName(valueName);
                    if (!questions) return false;
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        if (q.isVisible && q.isParentVisible && !q.parentQuestion) return true;
                    }
                    return false;
                };
                SurveyModel.prototype.questionsByValueName = function(valueName) {
                    var questions = this.getQuestionsByValueName(valueName);
                    return !!questions ? questions : [];
                };
                SurveyModel.prototype.clearInvisibleQuestionValues = function() {
                    var reason = this.clearInvisibleValues === "none" ? "none" : "onComplete";
                    var questions = this.getAllQuestions();
                    for(var i = 0; i < questions.length; i++)questions[i].clearValueIfInvisible(reason);
                };
                /**
     * Returns a variable value.
     *
     * [Variables help topic](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#variables (linkStyle))
     * @param name A variable name.
     * @return A variable value.
     * @see setVariable
     * @see getVariableNames
     */ SurveyModel.prototype.getVariable = function(name) {
                    if (!name) return null;
                    name = name.toLowerCase();
                    var res = this.variablesHash[name];
                    if (!this.isValueEmpty(res)) return res;
                    if (name.indexOf(".") > -1 || name.indexOf("[") > -1) {
                        if (new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_6__["ProcessValue"]().hasValue(name, this.variablesHash)) return new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_6__["ProcessValue"]().getValue(name, this.variablesHash);
                    }
                    return res;
                };
                /**
     * Sets a variable value.
     *
     * [Variables help topic](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#variables (linkStyle))
     * @param name A variable name.
     * @param newValue A new variable value.
     * @see getVariable
     * @see getVariableNames
     */ SurveyModel.prototype.setVariable = function(name, newValue) {
                    if (!name) return;
                    if (!!this.valuesHash) delete this.valuesHash[name];
                    name = name.toLowerCase();
                    this.variablesHash[name] = newValue;
                    this.notifyElementsOnAnyValueOrVariableChanged(name);
                    this.runConditionOnValueChanged(name, newValue);
                    this.onVariableChanged.fire(this, {
                        name: name,
                        value: newValue
                    });
                };
                /**
     * Returns the names of all variables in the survey.
     *
     * [Variables help topic](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#variables (linkStyle))
     * @returns An array of variable names.
     * @see getVariable
     * @see setVariable
     */ SurveyModel.prototype.getVariableNames = function() {
                    var res = [];
                    for(var key in this.variablesHash)res.push(key);
                    return res;
                };
                //ISurvey data
                SurveyModel.prototype.getUnbindValue = function(value) {
                    if (!!this.editingObj) return value;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].getUnbindValue(value);
                };
                /**
     * Returns a value (answer) for a question with a specified `name`.
     * @param name A question name.
     * @returns A question value (answer).
     * @see data
     * @see setValue
     */ SurveyModel.prototype.getValue = function(name) {
                    if (!name || name.length == 0) return null;
                    var value = this.getDataValueCore(this.valuesHash, name);
                    return this.getUnbindValue(value);
                };
                /**
     * Sets a question value (answer).
     *
     * > This method executes all triggers and reevaluates conditions (`visibleIf`, `requiredId`, and others). It also switches the survey to the next page if the [`goNextPageAutomatic`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#goNextPageAutomatic) property is enabled and all questions on the current page have correct answers.
     * @param name A question name.
     * @param newValue A new question value.
     * @param locNotification For internal use.
     * @param allowNotifyValueChanged For internal use.
     * @see data
     * @see getValue
     */ SurveyModel.prototype.setValue = function(name, newQuestionValue, locNotification, allowNotifyValueChanged, questionName) {
                    if (locNotification === void 0) locNotification = false;
                    if (allowNotifyValueChanged === void 0) allowNotifyValueChanged = true;
                    if (this.isLockingUpdateOnPageModes) return;
                    var newValue = newQuestionValue;
                    if (allowNotifyValueChanged) newValue = this.questionOnValueChanging(name, newQuestionValue);
                    if (this.isValidateOnValueChanging && this.checkErrorsOnValueChanging(name, newValue)) return;
                    if (!this.editingObj && this.isValueEqual(name, newValue) && this.isTwoValueEquals(newValue, newQuestionValue)) return;
                    var oldValue = this.getValue(name);
                    if (this.isValueEmpyOnSetValue(name, newValue)) this.deleteDataValueCore(this.valuesHash, name);
                    else {
                        newValue = this.getUnbindValue(newValue);
                        this.setDataValueCore(this.valuesHash, name, newValue);
                    }
                    this.updateOnSetValue(name, newValue, oldValue, locNotification, allowNotifyValueChanged, questionName);
                };
                SurveyModel.prototype.isValueEmpyOnSetValue = function(name, val1) {
                    if (!this.isValueEmpty(val1, false)) return false;
                    if (!this.editingObj || val1 === null || val1 === undefined) return true;
                    return this.editingObj.getDefaultPropertyValue(name) === val1;
                };
                SurveyModel.prototype.updateOnSetValue = function(name, newValue, oldValue, locNotification, allowNotifyValueChanged, questionName) {
                    if (locNotification === void 0) locNotification = false;
                    if (allowNotifyValueChanged === void 0) allowNotifyValueChanged = true;
                    this.updateQuestionValue(name, newValue);
                    if (locNotification === true || this.isDisposed || this.isRunningElementsBindings) return;
                    questionName = questionName || name;
                    var triggerKeys = {};
                    triggerKeys[name] = {
                        newValue: newValue,
                        oldValue: oldValue
                    };
                    this.runConditionOnValueChanged(name, newValue);
                    this.checkTriggers(triggerKeys, false, false, name);
                    if (allowNotifyValueChanged) this.notifyQuestionOnValueChanged(name, newValue, questionName);
                    if (locNotification !== "text") this.tryGoNextPageAutomatic(name);
                };
                SurveyModel.prototype.isValueEqual = function(name, newValue) {
                    if (newValue === "" || newValue === undefined) newValue = null;
                    var oldValue = this.getValue(name);
                    if (oldValue === "" || oldValue === undefined) oldValue = null;
                    if (newValue === null || oldValue === null) return newValue === oldValue;
                    return this.isTwoValueEquals(newValue, oldValue);
                };
                SurveyModel.prototype.doOnPageAdded = function(page) {
                    page.setSurveyImpl(this);
                    if (!page.name) page.name = this.generateNewName(this.pages, "page");
                    this.questionHashesPanelAdded(page);
                    this.updateVisibleIndexes();
                    if (!!this.runningPages) return;
                    if (!this.isLoadingFromJson) {
                        this.updateProgressText();
                        this.updateCurrentPage();
                    }
                    var options = {
                        page: page
                    };
                    this.onPageAdded.fire(this, options);
                };
                SurveyModel.prototype.doOnPageRemoved = function(page) {
                    page.setSurveyImpl(null);
                    if (!!this.runningPages) return;
                    if (page === this.currentPage) this.updateCurrentPage();
                    this.updateVisibleIndexes();
                    this.updateProgressText();
                    this.updateLazyRenderingRowsOnRemovingElements();
                };
                SurveyModel.prototype.generateNewName = function(elements, baseName) {
                    var keys = {};
                    for(var i = 0; i < elements.length; i++)keys[elements[i]["name"]] = true;
                    var index = 1;
                    while(keys[baseName + index])index++;
                    return baseName + index;
                };
                SurveyModel.prototype.tryGoNextPageAutomatic = function(name) {
                    var _this = this;
                    if (!!this.isEndLoadingFromJson || !this.goNextPageAutomatic || !this.currentPage) return;
                    var question = this.getQuestionByValueName(name);
                    if (!question || !!question && (!question.visible || !question.supportGoNextPageAutomatic())) return;
                    if (!question.validate(false) && !question.supportGoNextPageError()) return;
                    var questions = this.getCurrentPageQuestions();
                    if (questions.indexOf(question) < 0) return;
                    for(var i = 0; i < questions.length; i++){
                        if (questions[i].hasInput && questions[i].isEmpty()) return;
                    }
                    if (this.isLastPage && (this.goNextPageAutomatic !== true || !this.allowCompleteSurveyAutomatic)) return;
                    if (this.checkIsCurrentPageHasErrors(false)) return;
                    var goNextPage = function() {
                        if (!_this.isLastPage) _this.nextPage();
                        else if (_this.isShowPreviewBeforeComplete) _this.showPreview();
                        else _this.completeLastPage();
                    };
                    _surveytimer__WEBPACK_IMPORTED_MODULE_21__["surveyTimerFunctions"].safeTimeOut(goNextPage, _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].autoAdvanceDelay);
                };
                /**
     * Returns a comment value from a question with a specified `name`.
     * @param name A question name.
     * @returns A comment.
     * @see setComment
     */ SurveyModel.prototype.getComment = function(name) {
                    var res = this.getValue(name + this.commentSuffix);
                    return res || "";
                };
                /**
     * Sets a comment value to a question with a specified `name`.
     * @param name A question name.
     * @param newValue A new comment value.
     * @param locNotification For internal use.
     * @see getComment
     */ SurveyModel.prototype.setComment = function(name, newValue, locNotification) {
                    if (locNotification === void 0) locNotification = false;
                    if (!newValue) newValue = "";
                    if (this.isTwoValueEquals(newValue, this.getComment(name))) return;
                    var commentName = name + this.commentSuffix;
                    if (this.isValueEmpty(newValue)) this.deleteDataValueCore(this.valuesHash, commentName);
                    else this.setDataValueCore(this.valuesHash, commentName, newValue);
                    var questions = this.getQuestionsByValueName(name);
                    if (!!questions) for(var i = 0; i < questions.length; i++){
                        questions[i].updateCommentFromSurvey(newValue);
                        this.checkQuestionErrorOnValueChanged(questions[i]);
                    }
                    if (!locNotification) this.runConditionOnValueChanged(name, this.getValue(name));
                    if (locNotification !== "text") this.tryGoNextPageAutomatic(name);
                    var question = this.getQuestionByName(name);
                    if (question) this.onValueChanged.fire(this, {
                        name: commentName,
                        question: question,
                        value: newValue
                    });
                };
                /**
     * Deletes an answer from survey results.
     * @param {string} name An object property that stores the answer to delete. Pass a question's [`valueName`](https://surveyjs.io/form-library/documentation/api-reference/question#valueName) or [`name`](https://surveyjs.io/form-library/documentation/api-reference/question#name).
     */ SurveyModel.prototype.clearValue = function(name) {
                    this.setValue(name, null);
                    this.setComment(name, null);
                };
                Object.defineProperty(SurveyModel.prototype, "clearValueOnDisableItems", {
                    /**
         * Specifies whether to remove disabled choices from the value in [Dropdown](https://surveyjs.io/form-library/documentation/api-reference/dropdown-menu-model), [Checkboxes](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model), and [Radio Button Group](https://surveyjs.io/form-library/documentation/api-reference/radio-button-question-model) questions.
         *
         * Default value: `false`
         *
         * > This property cannot be specified in the survey JSON schema. Use dot notation to specify it.
         */ get: function() {
                        return this.getPropertyValue("clearValueOnDisableItems", false);
                    },
                    set: function(val1) {
                        this.setPropertyValue("clearValueOnDisableItems", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getQuestionClearIfInvisible = function(questionClearIf) {
                    if (this.isShowingPreview || this.runningPages) return "none";
                    if (questionClearIf !== "default") return questionClearIf;
                    return this.clearInvisibleValues;
                };
                SurveyModel.prototype.questionVisibilityChanged = function(question, newValue) {
                    this.updateVisibleIndexes();
                    this.onQuestionVisibleChanged.fire(this, {
                        question: question,
                        name: question.name,
                        visible: newValue
                    });
                };
                SurveyModel.prototype.pageVisibilityChanged = function(page, newValue) {
                    if (this.isLoadingFromJson) return;
                    if (newValue && !this.currentPage || page === this.currentPage) this.updateCurrentPage();
                    this.updateVisibleIndexes();
                    this.onPageVisibleChanged.fire(this, {
                        page: page,
                        visible: newValue
                    });
                };
                SurveyModel.prototype.panelVisibilityChanged = function(panel, newValue) {
                    this.updateVisibleIndexes();
                    this.onPanelVisibleChanged.fire(this, {
                        panel: panel,
                        visible: newValue
                    });
                };
                SurveyModel.prototype.questionCreated = function(question) {
                    this.onQuestionCreated.fire(this, {
                        question: question
                    });
                };
                SurveyModel.prototype.questionAdded = function(question, index, parentPanel, rootPanel) {
                    if (!question.name) question.name = this.generateNewName(this.getAllQuestions(false, true), "question");
                    if (!!question.page) this.questionHashesAdded(question);
                    if (!this.currentPage) this.updateCurrentPage();
                    this.updateVisibleIndexes();
                    this.setCalculatedWidthModeUpdater();
                    if (this.canFireAddElement()) this.onQuestionAdded.fire(this, {
                        question: question,
                        name: question.name,
                        index: index,
                        parent: parentPanel,
                        page: rootPanel,
                        parentPanel: parentPanel,
                        rootPanel: rootPanel
                    });
                };
                SurveyModel.prototype.canFireAddElement = function() {
                    return !this.isMovingQuestion || this.isDesignMode && !_settings__WEBPACK_IMPORTED_MODULE_14__["settings"].supportCreatorV2;
                };
                SurveyModel.prototype.questionRemoved = function(question) {
                    this.questionHashesRemoved(question, question.name, question.getValueName());
                    this.updateVisibleIndexes();
                    this.onQuestionRemoved.fire(this, {
                        question: question,
                        name: question.name
                    });
                    this.updateLazyRenderingRowsOnRemovingElements();
                };
                SurveyModel.prototype.questionRenamed = function(question, oldName, oldValueName) {
                    this.questionHashesRemoved(question, oldName, oldValueName);
                    this.questionHashesAdded(question);
                };
                SurveyModel.prototype.questionHashesClear = function() {
                    this.questionHashes.names = {};
                    this.questionHashes.namesInsensitive = {};
                    this.questionHashes.valueNames = {};
                    this.questionHashes.valueNamesInsensitive = {};
                };
                SurveyModel.prototype.questionHashesPanelAdded = function(panel) {
                    if (this.isLoadingFromJson) return;
                    var questions = panel.questions;
                    for(var i = 0; i < questions.length; i++)this.questionHashesAdded(questions[i]);
                };
                SurveyModel.prototype.questionHashesAdded = function(question) {
                    this.questionHashAddedCore(this.questionHashes.names, question, question.name);
                    this.questionHashAddedCore(this.questionHashes.namesInsensitive, question, question.name.toLowerCase());
                    this.questionHashAddedCore(this.questionHashes.valueNames, question, question.getValueName());
                    this.questionHashAddedCore(this.questionHashes.valueNamesInsensitive, question, question.getValueName().toLowerCase());
                };
                SurveyModel.prototype.questionHashesRemoved = function(question, name, valueName) {
                    if (!!name) {
                        this.questionHashRemovedCore(this.questionHashes.names, question, name);
                        this.questionHashRemovedCore(this.questionHashes.namesInsensitive, question, name.toLowerCase());
                    }
                    if (!!valueName) {
                        this.questionHashRemovedCore(this.questionHashes.valueNames, question, valueName);
                        this.questionHashRemovedCore(this.questionHashes.valueNamesInsensitive, question, valueName.toLowerCase());
                    }
                };
                SurveyModel.prototype.questionHashAddedCore = function(hash, question, name) {
                    var res = hash[name];
                    if (!!res) {
                        var res = hash[name];
                        if (res.indexOf(question) < 0) res.push(question);
                    } else hash[name] = [
                        question
                    ];
                };
                SurveyModel.prototype.questionHashRemovedCore = function(hash, question, name) {
                    var res = hash[name];
                    if (!res) return;
                    var index = res.indexOf(question);
                    if (index > -1) res.splice(index, 1);
                    if (res.length == 0) delete hash[name];
                };
                SurveyModel.prototype.panelAdded = function(panel, index, parentPanel, rootPanel) {
                    if (!panel.name) panel.name = this.generateNewName(this.getAllPanels(false, true), "panel");
                    this.questionHashesPanelAdded(panel);
                    this.updateVisibleIndexes();
                    if (this.canFireAddElement()) this.onPanelAdded.fire(this, {
                        panel: panel,
                        name: panel.name,
                        index: index,
                        parent: parentPanel,
                        page: rootPanel,
                        parentPanel: parentPanel,
                        rootPanel: rootPanel
                    });
                };
                SurveyModel.prototype.panelRemoved = function(panel) {
                    this.updateVisibleIndexes();
                    this.onPanelRemoved.fire(this, {
                        panel: panel,
                        name: panel.name
                    });
                    this.updateLazyRenderingRowsOnRemovingElements();
                };
                SurveyModel.prototype.validateQuestion = function(question) {
                    if (this.onValidateQuestion.isEmpty) return null;
                    var options = {
                        name: question.name,
                        question: question,
                        value: question.value,
                        error: null
                    };
                    this.onValidateQuestion.fire(this, options);
                    return options.error ? new _error__WEBPACK_IMPORTED_MODULE_9__["CustomError"](options.error, this) : null;
                };
                SurveyModel.prototype.validatePanel = function(panel) {
                    if (this.onValidatePanel.isEmpty) return null;
                    var options = {
                        name: panel.name,
                        panel: panel,
                        error: null
                    };
                    this.onValidatePanel.fire(this, options);
                    return options.error ? new _error__WEBPACK_IMPORTED_MODULE_9__["CustomError"](options.error, this) : null;
                };
                SurveyModel.prototype.processHtml = function(html, reason) {
                    if (!reason) reason = "";
                    var options = {
                        html: html,
                        reason: reason
                    };
                    this.onProcessHtml.fire(this, options);
                    return this.processText(options.html, true);
                };
                SurveyModel.prototype.processText = function(text, returnDisplayValue) {
                    return this.processTextEx(text, returnDisplayValue, false).text;
                };
                SurveyModel.prototype.processTextEx = function(text, returnDisplayValue, doEncoding) {
                    var res = {
                        text: this.processTextCore(text, returnDisplayValue, doEncoding),
                        hasAllValuesOnLastRun: true
                    };
                    res.hasAllValuesOnLastRun = this.textPreProcessor.hasAllValuesOnLastRun;
                    return res;
                };
                Object.defineProperty(SurveyModel.prototype, "textPreProcessor", {
                    get: function() {
                        var _this = this;
                        if (!this.textPreProcessorValue) {
                            this.textPreProcessorValue = new _textPreProcessor__WEBPACK_IMPORTED_MODULE_5__["TextPreProcessor"]();
                            this.textPreProcessorValue.onProcess = function(textValue) {
                                _this.getProcessedTextValue(textValue);
                            };
                        }
                        return this.textPreProcessorValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.processTextCore = function(text, returnDisplayValue, doEncoding) {
                    if (doEncoding === void 0) doEncoding = false;
                    if (this.isDesignMode) return text;
                    return this.textPreProcessor.process(text, returnDisplayValue, doEncoding);
                };
                SurveyModel.prototype.getSurveyMarkdownHtml = function(element, text, name) {
                    var options = {
                        element: element,
                        text: text,
                        name: name,
                        html: null
                    };
                    this.onTextMarkdown.fire(this, options);
                    return options.html;
                };
                SurveyModel.prototype.getCorrectedAnswerCount = function() {
                    return this.getCorrectAnswerCount();
                };
                /**
     * Returns the number of correct answers in a quiz.
     *
     * For more information about quizzes, refer to the following tutorial: [Create a Quiz](https://surveyjs.io/form-library/documentation/design-survey/create-a-quiz).
     * @returns The number of correct answers in a quiz.
     * @see getQuizQuestionCount
     * @see getInCorrectAnswerCount
     */ SurveyModel.prototype.getCorrectAnswerCount = function() {
                    return this.getCorrectedAnswerCountCore(true);
                };
                /**
     * Returns the number of quiz questions. A question counts if it is visible, has an input field, and specifies [`correctAnswer`](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model#correctAnswer).
     *
     * This number may be different from `getQuizQuestions().length` because certain question types (for instance, matrix-like types) include more than one question.
     *
     * For more information about quizzes, refer to the following tutorial: [Create a Quiz](https://surveyjs.io/form-library/documentation/design-survey/create-a-quiz).
     * @returns The number of quiz questions.
     * @see getQuizQuestions
     */ SurveyModel.prototype.getQuizQuestionCount = function() {
                    var questions = this.getQuizQuestions();
                    var res = 0;
                    for(var i = 0; i < questions.length; i++)res += questions[i].quizQuestionCount;
                    return res;
                };
                SurveyModel.prototype.getInCorrectedAnswerCount = function() {
                    return this.getInCorrectAnswerCount();
                };
                /**
     * Returns the number of incorrect answers in a quiz.
     *
     * For more information about quizzes, refer to the following tutorial: [Create a Quiz](https://surveyjs.io/form-library/documentation/design-survey/create-a-quiz).
     * @returns The number of incorrect answers in a quiz.
     * @see getCorrectAnswerCount
     */ SurveyModel.prototype.getInCorrectAnswerCount = function() {
                    return this.getCorrectedAnswerCountCore(false);
                };
                SurveyModel.prototype.onCorrectQuestionAnswer = function(question, options) {
                    if (this.onIsAnswerCorrect.isEmpty) return;
                    options.question = question;
                    this.onIsAnswerCorrect.fire(this, options);
                };
                SurveyModel.prototype.getCorrectedAnswerCountCore = function(isCorrect) {
                    var questions = this.getQuizQuestions();
                    var counter = 0;
                    for(var i = 0; i < questions.length; i++){
                        var q = questions[i];
                        var correctCount = q.correctAnswerCount;
                        if (isCorrect) counter += correctCount;
                        else counter += q.quizQuestionCount - correctCount;
                    }
                    return counter;
                };
                SurveyModel.prototype.getCorrectedAnswers = function() {
                    return this.getCorrectedAnswerCount();
                };
                SurveyModel.prototype.getInCorrectedAnswers = function() {
                    return this.getInCorrectedAnswerCount();
                };
                Object.defineProperty(SurveyModel.prototype, "showTimerPanel", {
                    /**
         * Displays the timer panel and specifies its position. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
         *
         * Possible values:
         *
         * - `"top"` - Displays the timer panel at the top of the survey.
         * - `"bottom"` - Displays the timer panel at the bottom of the survey.
         * - `"none"` (default) - Hides the timer panel.
         *
         * If the timer panel is displayed, the timer starts automatically when the survey begins. To specify time limits, use the [`maxTimeToFinish`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#maxTimeToFinish) and [`maxTimeToFinishPage`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#maxTimeToFinishPage) properties.
         *
         * The timer panel displays information about time spent on an individual page and the entire survey. If you want to display only the page timer or the survey timer, set the [`showTimerPanelMode`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#showTimerPanelMode) property to `"page"` or `"survey"`.
         * @see startTimer
         * @see stopTimer
         * @see timeSpent
         * @see onTimer
         */ get: function() {
                        return this.getPropertyValue("showTimerPanel");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showTimerPanel", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isTimerPanelShowingOnTop", {
                    get: function() {
                        return this.showTimerPanel == "top";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "isTimerPanelShowingOnBottom", {
                    get: function() {
                        return this.showTimerPanel == "bottom";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "showTimerPanelMode", {
                    /**
         * Specifies whether the timer panel displays timers for the current page, the entire survey, or both. Applies only if the timer panel is [visible](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#showTimerPanel).
         *
         * Possible values:
         *
         * - `"survey"` - Displays only the survey timer.
         * - `"page"` - Displays only the page timer.
         * - `"all"` (default) - Displays both the survey and page timers.
         * @see timeSpent
         * @see onTimer
         * @see startTimer
         * @see stopTimer
         */ get: function() {
                        return this.getPropertyValue("showTimerPanelMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("showTimerPanelMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "widthMode", {
                    /**
          * Specifies how to calculate the survey width.
          *
          * Possible values:
          *
          * - `"static"` - A survey has a [fixed width](#width).
          * - `"responsive"` - A survey occupies all available horizontal space and stretches or shrinks horizontally to fit in the screen size.
          * - `"auto"` (default) - Survey width depends on a question type and corresponds to the `"static"` or `"responsive"` mode.
        */ // `custom/precise` - The survey width is specified by the width property. // in-future
                    get: function() {
                        return this.getPropertyValue("widthMode");
                    },
                    set: function(val1) {
                        this.setPropertyValue("widthMode", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.setCalculatedWidthModeUpdater = function() {
                    var _this = this;
                    if (this.calculatedWidthModeUpdater) this.calculatedWidthModeUpdater.dispose();
                    this.calculatedWidthModeUpdater = new _base__WEBPACK_IMPORTED_MODULE_2__["ComputedUpdater"](function() {
                        return _this.calculateWidthMode();
                    });
                    this.calculatedWidthMode = this.calculatedWidthModeUpdater;
                };
                SurveyModel.prototype.calculateWidthMode = function() {
                    if (this.widthMode == "auto") {
                        var isResponsive_1 = false;
                        this.pages.forEach(function(page) {
                            if (page.needResponsiveWidth()) isResponsive_1 = true;
                        });
                        return isResponsive_1 ? "responsive" : "static";
                    }
                    return this.widthMode;
                };
                Object.defineProperty(SurveyModel.prototype, "width", {
                    /**
         * A survey width in CSS values.
         *
         * Default value: `undefined` (the survey inherits the width from its container)
         */ get: function() {
                        return this.getPropertyValue("width");
                    },
                    set: function(val1) {
                        this.setPropertyValue("width", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "renderedWidth", {
                    get: function() {
                        var width = this.getPropertyValue("width");
                        if (width && !isNaN(width)) width = width + "px";
                        return this.getPropertyValue("calculatedWidthMode") == "static" && width || undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "timerInfo", {
                    get: function() {
                        return this.getTimerInfo();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "timerClock", {
                    get: function() {
                        var major;
                        var minor;
                        if (!!this.currentPage) {
                            var _a = this.getTimerInfo(), spent = _a.spent, limit = _a.limit, minorSpent = _a.minorSpent, minorLimit = _a.minorLimit;
                            if (limit > 0) major = this.getDisplayClockTime(limit - spent);
                            else major = this.getDisplayClockTime(spent);
                            if (minorSpent !== undefined) {
                                if (minorLimit > 0) minor = this.getDisplayClockTime(minorLimit - minorSpent);
                                else minor = this.getDisplayClockTime(minorSpent);
                            }
                        }
                        return {
                            majorText: major,
                            minorText: minor
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "timerInfoText", {
                    get: function() {
                        var options = {
                            text: this.getTimerInfoText()
                        };
                        this.onTimerPanelInfoText.fire(this, options);
                        var loc = new _localizablestring__WEBPACK_IMPORTED_MODULE_10__["LocalizableString"](this, true);
                        loc.text = options.text;
                        return loc.textOrHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getTimerInfo = function() {
                    var page = this.currentPage;
                    if (!page) return {
                        spent: 0,
                        limit: 0
                    };
                    var pageSpent = page.timeSpent;
                    var surveySpent = this.timeSpent;
                    var pageLimitSec = this.getPageMaxTimeToFinish(page);
                    var surveyLimit = this.maxTimeToFinish;
                    if (this.showTimerPanelMode == "page") return {
                        spent: pageSpent,
                        limit: pageLimitSec
                    };
                    if (this.showTimerPanelMode == "survey") return {
                        spent: surveySpent,
                        limit: surveyLimit
                    };
                    else {
                        if (pageLimitSec > 0 && surveyLimit > 0) return {
                            spent: pageSpent,
                            limit: pageLimitSec,
                            minorSpent: surveySpent,
                            minorLimit: surveyLimit
                        };
                        else if (pageLimitSec > 0) return {
                            spent: pageSpent,
                            limit: pageLimitSec,
                            minorSpent: surveySpent
                        };
                        else if (surveyLimit > 0) return {
                            spent: surveySpent,
                            limit: surveyLimit,
                            minorSpent: pageSpent
                        };
                        else return {
                            spent: pageSpent,
                            minorSpent: surveySpent
                        };
                    }
                };
                SurveyModel.prototype.getTimerInfoText = function() {
                    var page = this.currentPage;
                    if (!page) return "";
                    var pageSpent = this.getDisplayTime(page.timeSpent);
                    var surveySpent = this.getDisplayTime(this.timeSpent);
                    var pageLimitSec = this.getPageMaxTimeToFinish(page);
                    var pageLimit = this.getDisplayTime(pageLimitSec);
                    var surveyLimit = this.getDisplayTime(this.maxTimeToFinish);
                    if (this.showTimerPanelMode == "page") return this.getTimerInfoPageText(page, pageSpent, pageLimit);
                    if (this.showTimerPanelMode == "survey") return this.getTimerInfoSurveyText(surveySpent, surveyLimit);
                    if (this.showTimerPanelMode == "all") {
                        if (pageLimitSec <= 0 && this.maxTimeToFinish <= 0) return this.getLocalizationFormatString("timerSpentAll", pageSpent, surveySpent);
                        if (pageLimitSec > 0 && this.maxTimeToFinish > 0) return this.getLocalizationFormatString("timerLimitAll", pageSpent, pageLimit, surveySpent, surveyLimit);
                        var pageText = this.getTimerInfoPageText(page, pageSpent, pageLimit);
                        var surveyText = this.getTimerInfoSurveyText(surveySpent, surveyLimit);
                        return pageText + " " + surveyText;
                    }
                    return "";
                };
                SurveyModel.prototype.getTimerInfoPageText = function(page, pageSpent, pageLimit) {
                    return this.getPageMaxTimeToFinish(page) > 0 ? this.getLocalizationFormatString("timerLimitPage", pageSpent, pageLimit) : this.getLocalizationFormatString("timerSpentPage", pageSpent, pageLimit);
                };
                SurveyModel.prototype.getTimerInfoSurveyText = function(surveySpent, surveyLimit) {
                    var strName = this.maxTimeToFinish > 0 ? "timerLimitSurvey" : "timerSpentSurvey";
                    return this.getLocalizationFormatString(strName, surveySpent, surveyLimit);
                };
                SurveyModel.prototype.getDisplayClockTime = function(val1) {
                    if (val1 < 0) val1 = 0;
                    var min = Math.floor(val1 / 60);
                    var sec = val1 % 60;
                    var secStr = sec.toString();
                    if (sec < 10) secStr = "0" + secStr;
                    return min + ":" + secStr;
                };
                SurveyModel.prototype.getDisplayTime = function(val1) {
                    var min = Math.floor(val1 / 60);
                    var sec = val1 % 60;
                    var res = "";
                    if (min > 0) res += min + " " + this.getLocalizationString("timerMin");
                    if (res && sec == 0) return res;
                    if (res) res += " ";
                    return res + sec + " " + this.getLocalizationString("timerSec");
                };
                Object.defineProperty(SurveyModel.prototype, "timerModel", {
                    get: function() {
                        return this.timerModelValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Starts a timer that calculates how many seconds a respondent has spent on the survey. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
     * @see stopTimer
     * @see maxTimeToFinish
     * @see maxTimeToFinishPage
     * @see timeSpent
     * @see onTimer
     */ SurveyModel.prototype.startTimer = function() {
                    if (this.isEditMode) this.timerModel.start();
                };
                SurveyModel.prototype.startTimerFromUI = function() {
                    if (this.showTimerPanel != "none" && this.state === "running") this.startTimer();
                };
                /**
     * Stops the timer. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
     * @see startTimer
     * @see maxTimeToFinish
     * @see maxTimeToFinishPage
     * @see timeSpent
     * @see onTimer
     */ SurveyModel.prototype.stopTimer = function() {
                    this.timerModel.stop();
                };
                Object.defineProperty(SurveyModel.prototype, "timeSpent", {
                    /**
         * A time period that a respondent has spent on the survey so far; measured in seconds. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
         *
         * Assign a number to this property if you need to start the quiz timer from a specific time (for instance, if you want to continue an interrupted quiz).
         *
         * You can also find out how many seconds a respondent has spent on an individual survey page. To do this, use the [`timeSpent`](https://surveyjs.io/form-library/documentation/api-reference/page-model#timeSpent) property of a [`PageModel`](https://surveyjs.io/form-library/documentation/api-reference/page-model) object.
         * @see maxTimeToFinish
         * @see maxTimeToFinishPage
         * @see startTimer
         */ get: function() {
                        return this.timerModel.spent;
                    },
                    set: function(val1) {
                        this.timerModel.spent = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "maxTimeToFinish", {
                    /**
         * A time period that a respondent has to complete the survey; measured in seconds. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
         *
         * A negative value or 0 sets an unlimited time period.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/make-quiz-javascript/ (linkStyle))
         * @see maxTimeToFinishPage
         * @see startTimer
         * @see timeSpent
         */ get: function() {
                        return this.getPropertyValue("maxTimeToFinish", 0);
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxTimeToFinish", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyModel.prototype, "maxTimeToFinishPage", {
                    /**
         * A time period that a respondent has to complete each survey page; measured in seconds. Applies only to [quiz surveys](https://surveyjs.io/form-library/documentation/design-survey-create-a-quiz).
         *
         * A negative value or 0 sets an unlimited time period.
         *
         * You can also use `PageModel`'s [`maxTimeToFinish`](https://surveyjs.io/form-library/documentation/api-reference/page-model#maxTimeToFinish) property to specify a time period for an individual survey page.
         *
         * [View Demo](https://surveyjs.io/form-library/examples/make-quiz-javascript/ (linkStyle))
         * @see maxTimeToFinish
         * @see startTimer
         * @see timeSpent
         */ get: function() {
                        return this.getPropertyValue("maxTimeToFinishPage", 0);
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxTimeToFinishPage", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyModel.prototype.getPageMaxTimeToFinish = function(page) {
                    if (!page || page.maxTimeToFinish < 0) return 0;
                    return page.maxTimeToFinish > 0 ? page.maxTimeToFinish : this.maxTimeToFinishPage;
                };
                SurveyModel.prototype.doTimer = function(page) {
                    this.onTimer.fire(this, {});
                    if (this.maxTimeToFinish > 0 && this.maxTimeToFinish == this.timeSpent) this.completeLastPage();
                    if (page) {
                        var pageLimit = this.getPageMaxTimeToFinish(page);
                        if (pageLimit > 0 && pageLimit == page.timeSpent) {
                            if (this.isLastPage) this.completeLastPage();
                            else this.nextPage();
                        }
                    }
                };
                Object.defineProperty(SurveyModel.prototype, "inSurvey", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                //ISurveyImplementor
                SurveyModel.prototype.getSurveyData = function() {
                    return this;
                };
                SurveyModel.prototype.getSurvey = function() {
                    return this;
                };
                SurveyModel.prototype.getTextProcessor = function() {
                    return this;
                };
                //ISurveyTriggerOwner
                SurveyModel.prototype.getObjects = function(pages, questions) {
                    var result = [];
                    Array.prototype.push.apply(result, this.getPagesByNames(pages));
                    Array.prototype.push.apply(result, this.getQuestionsByNames(questions));
                    return result;
                };
                SurveyModel.prototype.setTriggerValue = function(name, value, isVariable) {
                    if (!name) return;
                    if (isVariable) this.setVariable(name, value);
                    else {
                        var question = this.getQuestionByName(name);
                        if (!!question) question.value = value;
                        else {
                            var processor = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_6__["ProcessValue"]();
                            var firstName = processor.getFirstName(name);
                            if (firstName == name) this.setValue(name, value);
                            else {
                                if (!this.getQuestionByName(firstName)) return;
                                var data = this.getUnbindValue(this.getFilteredValues());
                                processor.setValue(data, name, value);
                                this.setValue(firstName, data[firstName]);
                            }
                        }
                    }
                };
                SurveyModel.prototype.copyTriggerValue = function(name, fromName, copyDisplayValue) {
                    if (!name || !fromName) return;
                    var value;
                    if (copyDisplayValue) value = this.processText("{" + fromName + "}", true);
                    else {
                        var processor = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_6__["ProcessValue"]();
                        value = processor.getValue(fromName, this.getFilteredValues());
                    }
                    this.setTriggerValue(name, value, false);
                };
                SurveyModel.prototype.triggerExecuted = function(trigger) {
                    this.onTriggerExecuted.fire(this, {
                        trigger: trigger
                    });
                };
                SurveyModel.prototype.startMovingQuestion = function() {
                    this.isMovingQuestion = true;
                };
                SurveyModel.prototype.stopMovingQuestion = function() {
                    this.isMovingQuestion = false;
                };
                Object.defineProperty(SurveyModel.prototype, "isQuestionDragging", {
                    get: function() {
                        return this.isMovingQuestion;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Focuses a question with a specified name. Switches the current page if needed.
     * @param name A question name.
     * @returns `false` if the survey does not contain a question with a specified name or this question is hidden; otherwise, `true`.
     * @see focusFirstQuestion
     * @see focusFirstQuestionAutomatic
     */ SurveyModel.prototype.focusQuestion = function(name) {
                    return this.focusQuestionByInstance(this.getQuestionByName(name, true));
                };
                SurveyModel.prototype.focusQuestionByInstance = function(question, onError) {
                    var _a;
                    if (onError === void 0) onError = false;
                    if (!question || !question.isVisible || !question.page) return false;
                    var oldQuestion = (_a = this.focusingQuestionInfo) === null || _a === void 0 ? void 0 : _a.question;
                    if (oldQuestion === question) return false;
                    this.focusingQuestionInfo = {
                        question: question,
                        onError: onError
                    };
                    this.skippedPages.push({
                        from: this.currentPage,
                        to: question.page
                    });
                    var isNeedWaitForPageRendered = this.activePage !== question.page && !question.page.isStartPage;
                    if (isNeedWaitForPageRendered) this.currentPage = question.page;
                    if (!isNeedWaitForPageRendered) this.focusQuestionInfo();
                    return true;
                };
                SurveyModel.prototype.focusQuestionInfo = function() {
                    var _a;
                    var question = (_a = this.focusingQuestionInfo) === null || _a === void 0 ? void 0 : _a.question;
                    if (!!question && !question.isDisposed) question.focus(this.focusingQuestionInfo.onError);
                    this.focusingQuestionInfo = undefined;
                };
                SurveyModel.prototype.questionEditFinishCallback = function(question, event1) {
                    var enterKeyAction = this.enterKeyAction || _settings__WEBPACK_IMPORTED_MODULE_14__["settings"].enterKeyAction;
                    if (enterKeyAction == "loseFocus") event1.target.blur();
                    if (enterKeyAction == "moveToNextEditor") {
                        var allQuestions = this.currentPage.questions;
                        var questionIndex = allQuestions.indexOf(question);
                        if (questionIndex > -1 && questionIndex < allQuestions.length - 1) allQuestions[questionIndex + 1].focus();
                        else event1.target.blur();
                    }
                };
                SurveyModel.prototype.getElementWrapperComponentName = function(element, reason) {
                    if (reason === "logo-image") return "sv-logo-image";
                    return SurveyModel.TemplateRendererComponentName;
                };
                SurveyModel.prototype.getQuestionContentWrapperComponentName = function(element) {
                    return SurveyModel.TemplateRendererComponentName;
                };
                SurveyModel.prototype.getRowWrapperComponentName = function(row) {
                    return SurveyModel.TemplateRendererComponentName;
                };
                SurveyModel.prototype.getElementWrapperComponentData = function(element, reason) {
                    return element;
                };
                SurveyModel.prototype.getRowWrapperComponentData = function(row) {
                    return row;
                };
                SurveyModel.prototype.getItemValueWrapperComponentName = function(item, question) {
                    return SurveyModel.TemplateRendererComponentName;
                };
                SurveyModel.prototype.getItemValueWrapperComponentData = function(item, question) {
                    return item;
                };
                SurveyModel.prototype.getMatrixCellTemplateData = function(cell) {
                    return cell.question;
                };
                SurveyModel.prototype.searchText = function(text) {
                    if (!!text) text = text.toLowerCase();
                    var res = [];
                    for(var i = 0; i < this.pages.length; i++)this.pages[i].searchText(text, res);
                    return res;
                };
                SurveyModel.prototype.getSkeletonComponentName = function(element) {
                    return this.skeletonComponentName;
                };
                /**
     * Adds an element to the survey layout.
     *
     * This method accepts an object with the following layout element properties:
     *
     * - `id`: `string` | `"timerpanel"` | `"progress-buttons"` | `"progress-questions"` | `"progress-pages"` | `"progress-correctquestions"` | `"progress-requiredquestions"` | `"toc-navigation"` | `"buttons-navigation"`\
     * A layout element identifier. You can use possible values to access and relocate or customize predefined layout elements.
     *
     * - `container`: `"header"` | `"footer"` | `"left"` | `"right"` | `"contentTop"` | `"contentBottom"`\
     * A layout container that holds the element. If you want to display the element within multiple containers, set this property to an array of possible values.
     *
     * - `component`: `string`\
     * The name of the component that renders the layout element.
     *
     * - `data`: `any`\
     * Data passed as props to `component`.
     *
     * [View Demo](https://surveyjs.io/form-library/examples/progress-bar-with-percentage/ (linkStyle))
     * @param layoutElement A layout element configuration.
     * @returns The configuration of the previous layout element with the same `id`.
     */ SurveyModel.prototype.addLayoutElement = function(layoutElement) {
                    var existingLayoutElement = this.removeLayoutElement(layoutElement.id);
                    this.layoutElements.push(layoutElement);
                    return existingLayoutElement;
                };
                SurveyModel.prototype.findLayoutElement = function(layoutElementId) {
                    var layoutElement = this.layoutElements.filter(function(a) {
                        return a.id === layoutElementId;
                    })[0];
                    return layoutElement;
                };
                SurveyModel.prototype.removeLayoutElement = function(layoutElementId) {
                    var layoutElement = this.findLayoutElement(layoutElementId);
                    if (!!layoutElement) {
                        var layoutElementIndex = this.layoutElements.indexOf(layoutElement);
                        this.layoutElements.splice(layoutElementIndex, 1);
                    }
                    return layoutElement;
                };
                SurveyModel.prototype.getContainerContent = function(container) {
                    var containerLayoutElements = [];
                    for(var _i = 0, _a = this.layoutElements; _i < _a.length; _i++){
                        var layoutElement = _a[_i];
                        if (this.mode !== "display" && isStrCiEqual(layoutElement.id, "timerpanel")) {
                            if (container === "header") {
                                if (this.isTimerPanelShowingOnTop && !this.isShowStartingPage) containerLayoutElements.push(layoutElement);
                            }
                            if (container === "footer") {
                                if (this.isTimerPanelShowingOnBottom && !this.isShowStartingPage) containerLayoutElements.push(layoutElement);
                            }
                        } else if (this.state === "running" && isStrCiEqual(layoutElement.id, this.progressBarComponentName)) {
                            var headerLayoutElement = this.findLayoutElement("advanced-header");
                            var advHeader = headerLayoutElement && headerLayoutElement.data;
                            var isBelowHeader = !advHeader || advHeader.hasBackground;
                            if (isStrCiEqual(this.showProgressBar, "aboveHeader")) isBelowHeader = false;
                            if (isStrCiEqual(this.showProgressBar, "belowHeader")) isBelowHeader = true;
                            if (container === "header" && !isBelowHeader) {
                                layoutElement.index = -150;
                                if (this.isShowProgressBarOnTop && !this.isShowStartingPage) containerLayoutElements.push(layoutElement);
                            }
                            if (container === "center" && isBelowHeader) {
                                if (!!layoutElement.index) delete layoutElement.index;
                                if (this.isShowProgressBarOnTop && !this.isShowStartingPage) containerLayoutElements.push(layoutElement);
                            }
                            if (container === "footer") {
                                if (this.isShowProgressBarOnBottom && !this.isShowStartingPage) containerLayoutElements.push(layoutElement);
                            }
                        } else if (isStrCiEqual(layoutElement.id, "buttons-navigation")) {
                            if (container === "contentTop") {
                                if ([
                                    "top",
                                    "both"
                                ].indexOf(this.isNavigationButtonsShowing) !== -1) containerLayoutElements.push(layoutElement);
                            }
                            if (container === "contentBottom") {
                                if ([
                                    "bottom",
                                    "both"
                                ].indexOf(this.isNavigationButtonsShowing) !== -1) containerLayoutElements.push(layoutElement);
                            }
                        } else if (this.state === "running" && isStrCiEqual(layoutElement.id, "toc-navigation") && this.showTOC) {
                            if (container === "left") {
                                if ([
                                    "left",
                                    "both"
                                ].indexOf(this.tocLocation) !== -1) containerLayoutElements.push(layoutElement);
                            }
                            if (container === "right") {
                                if ([
                                    "right",
                                    "both"
                                ].indexOf(this.tocLocation) !== -1) containerLayoutElements.push(layoutElement);
                            }
                        } else if (isStrCiEqual(layoutElement.id, "advanced-header")) {
                            if ((this.state === "running" || this.state === "starting") && layoutElement.container === container) containerLayoutElements.push(layoutElement);
                        } else if (Array.isArray(layoutElement.container) && layoutElement.container.indexOf(container) !== -1 || layoutElement.container === container) containerLayoutElements.push(layoutElement);
                    }
                    containerLayoutElements.sort(function(a, b) {
                        return (a.index || 0) - (b.index || 0);
                    });
                    return containerLayoutElements;
                };
                SurveyModel.prototype.processPopupVisiblityChanged = function(question, popup, visible) {
                    this.onPopupVisibleChanged.fire(this, {
                        question: question,
                        popup: popup,
                        visible: visible
                    });
                };
                /**
     * Applies a specified theme to the survey.
     *
     * [Themes & Styles](https://surveyjs.io/form-library/documentation/manage-default-themes-and-styles (linkStyle))
     * @param theme An [`ITheme`](https://surveyjs.io/form-library/documentation/api-reference/itheme) object with theme settings.
     */ SurveyModel.prototype.applyTheme = function(theme) {
                    var _this = this;
                    if (!theme) return;
                    Object.keys(theme).forEach(function(key) {
                        if (key === "header") {
                            _this.removeLayoutElement("advanced-header");
                            var advHeader = new _header__WEBPACK_IMPORTED_MODULE_20__["Cover"]();
                            advHeader.fromTheme(theme);
                            _this.insertAdvancedHeader(advHeader);
                        }
                        if (key === "isPanelless") _this.isCompact = theme[key];
                        else _this[key] = theme[key];
                    });
                    this.themeChanged(theme);
                };
                SurveyModel.prototype.themeChanged = function(theme) {
                    this.getAllQuestions().forEach(function(q) {
                        return q.themeChanged(theme);
                    });
                };
                /**
     * Disposes of the survey model.
     *
     * Call this method to release resources if your application contains multiple survey models or if you re-create a survey model at runtime.
     */ SurveyModel.prototype.dispose = function() {
                    this.removeScrollEventListener();
                    this.destroyResizeObserver();
                    this.rootElement = undefined;
                    if (this.layoutElements) {
                        for(var i = 0; i < this.layoutElements.length; i++)if (!!this.layoutElements[i].data && this.layoutElements[i].data !== this && this.layoutElements[i].data.dispose) this.layoutElements[i].data.dispose();
                        this.layoutElements.splice(0, this.layoutElements.length);
                    }
                    _super.prototype.dispose.call(this);
                    this.editingObj = null;
                    if (!this.pages) return;
                    this.currentPage = null;
                    for(var i = 0; i < this.pages.length; i++){
                        this.pages[i].setSurveyImpl(undefined);
                        this.pages[i].dispose();
                    }
                    this.pages.splice(0, this.pages.length);
                    if (this.disposeCallback) this.disposeCallback();
                };
                SurveyModel.prototype.onScroll = function() {
                    if (this.onScrollCallback) this.onScrollCallback();
                };
                SurveyModel.prototype.addScrollEventListener = function() {
                    var _this = this;
                    var _a;
                    this.scrollHandler = function() {
                        _this.onScroll();
                    };
                    this.rootElement.addEventListener("scroll", this.scrollHandler);
                    if (!!this.rootElement.getElementsByTagName("form")[0]) this.rootElement.getElementsByTagName("form")[0].addEventListener("scroll", this.scrollHandler);
                    if (!!this.css.rootWrapper) (_a = this.rootElement.getElementsByClassName(this.css.rootWrapper)[0]) === null || _a === void 0 || _a.addEventListener("scroll", this.scrollHandler);
                };
                SurveyModel.prototype.removeScrollEventListener = function() {
                    var _a;
                    if (!!this.rootElement && !!this.scrollHandler) {
                        this.rootElement.removeEventListener("scroll", this.scrollHandler);
                        if (!!this.rootElement.getElementsByTagName("form")[0]) this.rootElement.getElementsByTagName("form")[0].removeEventListener("scroll", this.scrollHandler);
                        if (!!this.css.rootWrapper) (_a = this.rootElement.getElementsByClassName(this.css.rootWrapper)[0]) === null || _a === void 0 || _a.removeEventListener("scroll", this.scrollHandler);
                    }
                };
                SurveyModel.TemplateRendererComponentName = "sv-template-renderer";
                SurveyModel.stylesManager = null;
                SurveyModel.platform = "unknown";
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "completedCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "completedBeforeCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "loadingBodyCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "containerCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        onSet: function(newValue, target) {
                            target.updateCss();
                        }
                    })
                ], SurveyModel.prototype, "fitToContainer", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        onSet: function(newValue, target) {
                            if (newValue === "advanced") {
                                var layoutElement = target.findLayoutElement("advanced-header");
                                if (!layoutElement) {
                                    var advHeader = new _header__WEBPACK_IMPORTED_MODULE_20__["Cover"]();
                                    advHeader.logoPositionX = target.logoPosition === "right" ? "right" : "left";
                                    advHeader.logoPositionY = "middle";
                                    advHeader.titlePositionX = target.logoPosition === "right" ? "left" : "right";
                                    advHeader.titlePositionY = "middle";
                                    advHeader.descriptionPositionX = target.logoPosition === "right" ? "left" : "right";
                                    advHeader.descriptionPositionY = "middle";
                                    target.insertAdvancedHeader(advHeader);
                                }
                            } else target.removeLayoutElement("advanced-header");
                        }
                    })
                ], SurveyModel.prototype, "headerView", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "showBrandInfo", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "enterKeyAction", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "lazyRenderingFirstBatchSizeValue", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: true
                    })
                ], SurveyModel.prototype, "titleIsEmpty", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: {}
                    })
                ], SurveyModel.prototype, "cssVariables", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "_isMobile", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "_isCompact", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "backgroundImage", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "renderBackgroundImage", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "backgroundImageFit", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        onSet: function(newValue, target) {
                            target.updateCss();
                        }
                    })
                ], SurveyModel.prototype, "backgroundImageAttachment", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "backgroundImageStyle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "wrapperFormCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        getDefaultValue: function(self) {
                            return self.progressBarType === "buttons";
                        }
                    })
                ], SurveyModel.prototype, "progressBarShowPageTitles", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "progressBarShowPageNumbers", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "progressBarInheritWidthFrom", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "rootCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], SurveyModel.prototype, "calculatedWidthMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["propertyArray"])()
                ], SurveyModel.prototype, "layoutElements", void 0);
                return SurveyModel;
            }(_survey_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElementCore"]);
            function isStrCiEqual(a, b) {
                if (!a) return false;
                if (!b) return false;
                return a.toUpperCase() === b.toUpperCase();
            }
            _jsonobject__WEBPACK_IMPORTED_MODULE_1__["Serializer"].addClass("survey", [
                {
                    name: "locale",
                    choices: function() {
                        return _surveyStrings__WEBPACK_IMPORTED_MODULE_8__["surveyLocalization"].getLocales(true);
                    },
                    onGetValue: function(obj) {
                        return obj.locale == _surveyStrings__WEBPACK_IMPORTED_MODULE_8__["surveyLocalization"].defaultLocale ? null : obj.locale;
                    }
                },
                {
                    name: "title",
                    serializationProperty: "locTitle",
                    dependsOn: "locale"
                },
                {
                    name: "description:text",
                    serializationProperty: "locDescription",
                    dependsOn: "locale"
                },
                {
                    name: "logo:file",
                    serializationProperty: "locLogo"
                },
                {
                    name: "logoWidth",
                    default: "300px",
                    minValue: 0
                },
                {
                    name: "logoHeight",
                    default: "200px",
                    minValue: 0
                },
                {
                    name: "logoFit",
                    default: "contain",
                    choices: [
                        "none",
                        "contain",
                        "cover",
                        "fill"
                    ]
                },
                {
                    name: "logoPosition",
                    default: "left",
                    choices: [
                        "none",
                        "left",
                        "right",
                        "top",
                        "bottom"
                    ]
                },
                {
                    name: "focusFirstQuestionAutomatic:boolean"
                },
                {
                    name: "focusOnFirstError:boolean",
                    default: true
                },
                {
                    name: "completedHtml:html",
                    serializationProperty: "locCompletedHtml"
                },
                {
                    name: "completedBeforeHtml:html",
                    serializationProperty: "locCompletedBeforeHtml"
                },
                {
                    name: "completedHtmlOnCondition:htmlconditions",
                    className: "htmlconditionitem",
                    isArray: true
                },
                {
                    name: "loadingHtml:html",
                    serializationProperty: "locLoadingHtml"
                },
                {
                    name: "pages:surveypages",
                    className: "page",
                    isArray: true,
                    onSerializeValue: function(obj) {
                        return obj.originalPages || obj.pages;
                    }
                },
                {
                    name: "elements",
                    alternativeName: "questions",
                    baseClassName: "question",
                    visible: false,
                    isLightSerializable: false,
                    onGetValue: function(obj) {
                        return null;
                    },
                    onSetValue: function(obj, value, jsonConverter) {
                        obj.pages.splice(0, obj.pages.length);
                        var page = obj.addNewPage("");
                        jsonConverter.toObject({
                            questions: value
                        }, page, jsonConverter === null || jsonConverter === void 0 ? void 0 : jsonConverter.options);
                    }
                },
                {
                    name: "triggers:triggers",
                    baseClassName: "surveytrigger",
                    classNamePart: "trigger"
                },
                {
                    name: "calculatedValues:calculatedvalues",
                    className: "calculatedvalue",
                    isArray: true
                },
                {
                    name: "surveyId",
                    visible: false
                },
                {
                    name: "surveyPostId",
                    visible: false
                },
                {
                    name: "surveyShowDataSaving:boolean",
                    visible: false
                },
                "cookieName",
                "sendResultOnPageNext:boolean",
                {
                    name: "showNavigationButtons",
                    default: "bottom",
                    choices: [
                        "none",
                        "top",
                        "bottom",
                        "both"
                    ]
                },
                {
                    name: "showPrevButton:boolean",
                    default: true,
                    visibleIf: function(obj) {
                        return obj.showNavigationButtons !== "none";
                    }
                },
                {
                    name: "showTitle:boolean",
                    default: true
                },
                {
                    name: "showPageTitles:boolean",
                    default: true
                },
                {
                    name: "showCompletedPage:boolean",
                    default: true
                },
                "navigateToUrl",
                {
                    name: "navigateToUrlOnCondition:urlconditions",
                    className: "urlconditionitem",
                    isArray: true
                },
                {
                    name: "questionsOrder",
                    default: "initial",
                    choices: [
                        "initial",
                        "random"
                    ]
                },
                {
                    name: "matrixDragHandleArea",
                    visible: false,
                    default: "entireItem",
                    choices: [
                        "entireItem",
                        "icon"
                    ]
                },
                "showPageNumbers:boolean",
                {
                    name: "showQuestionNumbers",
                    default: "on",
                    choices: [
                        "on",
                        "onPage",
                        "off"
                    ]
                },
                {
                    name: "questionTitleLocation",
                    default: "top",
                    choices: [
                        "top",
                        "bottom",
                        "left"
                    ]
                },
                {
                    name: "questionDescriptionLocation",
                    default: "underTitle",
                    choices: [
                        "underInput",
                        "underTitle"
                    ]
                },
                {
                    name: "questionErrorLocation",
                    default: "top",
                    choices: [
                        "top",
                        "bottom"
                    ]
                },
                {
                    name: "showProgressBar",
                    default: "off",
                    choices: [
                        "off",
                        "auto",
                        "aboveHeader",
                        "belowHeader",
                        "bottom",
                        "topBottom"
                    ]
                },
                {
                    name: "progressBarType",
                    default: "pages",
                    choices: [
                        "pages",
                        "questions",
                        "requiredQuestions",
                        "correctQuestions"
                    ],
                    visibleIf: function(obj) {
                        return obj.showProgressBar !== "off";
                    }
                },
                {
                    name: "progressBarShowPageTitles:switch",
                    category: "navigation",
                    visibleIf: function(obj) {
                        return obj.showProgressBar !== "off" && obj.progressBarType === "pages";
                    }
                },
                {
                    name: "progressBarShowPageNumbers:switch",
                    default: false,
                    category: "navigation",
                    visibleIf: function(obj) {
                        return obj.showProgressBar !== "off" && obj.progressBarType === "pages";
                    }
                },
                {
                    name: "progressBarInheritWidthFrom",
                    default: "container",
                    choices: [
                        "container",
                        "survey"
                    ],
                    category: "navigation",
                    visibleIf: function(obj) {
                        return obj.showProgressBar !== "off" && obj.progressBarType === "pages";
                    }
                },
                {
                    name: "showTOC:switch",
                    default: false
                },
                {
                    name: "tocLocation",
                    default: "left",
                    choices: [
                        "left",
                        "right"
                    ],
                    dependsOn: [
                        "showTOC"
                    ],
                    visibleIf: function(survey) {
                        return !!survey && survey.showTOC;
                    }
                },
                {
                    name: "mode",
                    default: "edit",
                    choices: [
                        "edit",
                        "display"
                    ]
                },
                {
                    name: "storeOthersAsComment:boolean",
                    default: true
                },
                {
                    name: "maxTextLength:number",
                    default: 0,
                    minValue: 0
                },
                {
                    name: "maxOthersLength:number",
                    default: 0,
                    minValue: 0
                },
                {
                    name: "goNextPageAutomatic:boolean",
                    onSetValue: function(obj, value) {
                        if (value !== "autogonext") value = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(value, true);
                        obj.setPropertyValue("goNextPageAutomatic", value);
                    }
                },
                {
                    name: "allowCompleteSurveyAutomatic:boolean",
                    default: true,
                    visibleIf: function(obj) {
                        return obj.goNextPageAutomatic === true;
                    }
                },
                {
                    name: "clearInvisibleValues",
                    default: "onComplete",
                    choices: [
                        "none",
                        "onComplete",
                        "onHidden",
                        "onHiddenContainer"
                    ]
                },
                {
                    name: "checkErrorsMode",
                    default: "onNextPage",
                    choices: [
                        "onNextPage",
                        "onValueChanged",
                        "onComplete"
                    ]
                },
                {
                    name: "textUpdateMode",
                    default: "onBlur",
                    choices: [
                        "onBlur",
                        "onTyping"
                    ]
                },
                {
                    name: "autoGrowComment:boolean",
                    default: false
                },
                {
                    name: "allowResizeComment:boolean",
                    default: true
                },
                {
                    name: "startSurveyText",
                    serializationProperty: "locStartSurveyText",
                    visibleIf: function(obj) {
                        return obj.firstPageIsStarted;
                    }
                },
                {
                    name: "pagePrevText",
                    serializationProperty: "locPagePrevText",
                    visibleIf: function(obj) {
                        return obj.showNavigationButtons !== "none" && obj.showPrevButton;
                    }
                },
                {
                    name: "pageNextText",
                    serializationProperty: "locPageNextText",
                    visibleIf: function(obj) {
                        return obj.showNavigationButtons !== "none";
                    }
                },
                {
                    name: "completeText",
                    serializationProperty: "locCompleteText",
                    visibleIf: function(obj) {
                        return obj.showNavigationButtons !== "none";
                    }
                },
                {
                    name: "previewText",
                    serializationProperty: "locPreviewText",
                    visibleIf: function(obj) {
                        return obj.showPreviewBeforeComplete !== "noPreview";
                    }
                },
                {
                    name: "editText",
                    serializationProperty: "locEditText",
                    visibleIf: function(obj) {
                        return obj.showPreviewBeforeComplete !== "noPreview";
                    }
                },
                {
                    name: "requiredText",
                    default: "*"
                },
                {
                    name: "questionStartIndex",
                    dependsOn: [
                        "showQuestionNumbers"
                    ],
                    visibleIf: function(survey) {
                        return !survey || survey.showQuestionNumbers !== "off";
                    }
                },
                {
                    name: "questionTitlePattern",
                    default: "numTitleRequire",
                    dependsOn: [
                        "questionStartIndex",
                        "requiredText"
                    ],
                    choices: function(obj) {
                        if (!obj) return [];
                        return obj.getQuestionTitlePatternOptions();
                    }
                },
                {
                    name: "questionTitleTemplate",
                    visible: false,
                    isSerializable: false,
                    serializationProperty: "locQuestionTitleTemplate"
                },
                {
                    name: "firstPageIsStarted:boolean",
                    default: false
                },
                {
                    name: "isSinglePage:boolean",
                    default: false,
                    visible: false,
                    isSerializable: false
                },
                {
                    name: "questionsOnPageMode",
                    default: "standard",
                    choices: [
                        "standard",
                        "singlePage",
                        "questionPerPage"
                    ]
                },
                {
                    name: "showPreviewBeforeComplete",
                    default: "noPreview",
                    choices: [
                        "noPreview",
                        "showAllQuestions",
                        "showAnsweredQuestions"
                    ]
                },
                {
                    name: "maxTimeToFinish:number",
                    default: 0,
                    minValue: 0
                },
                {
                    name: "maxTimeToFinishPage:number",
                    default: 0,
                    minValue: 0
                },
                {
                    name: "showTimerPanel",
                    default: "none",
                    choices: [
                        "none",
                        "top",
                        "bottom"
                    ]
                },
                {
                    name: "showTimerPanelMode",
                    default: "all",
                    choices: [
                        "page",
                        "survey",
                        "all"
                    ]
                },
                {
                    name: "widthMode",
                    default: "auto",
                    choices: [
                        "auto",
                        "static",
                        "responsive"
                    ]
                },
                {
                    name: "width",
                    visibleIf: function(obj) {
                        return obj.widthMode === "static";
                    }
                },
                {
                    name: "fitToContainer:boolean",
                    default: true,
                    visible: false
                },
                {
                    name: "headerView",
                    default: "basic",
                    choices: [
                        "basic",
                        "advanced"
                    ],
                    visible: false
                },
                {
                    name: "backgroundImage:file",
                    visible: false
                },
                {
                    name: "backgroundImageFit",
                    default: "cover",
                    choices: [
                        "auto",
                        "contain",
                        "cover"
                    ],
                    visible: false
                },
                {
                    name: "backgroundImageAttachment",
                    default: "scroll",
                    choices: [
                        "scroll",
                        "fixed"
                    ],
                    visible: false
                },
                {
                    name: "backgroundOpacity:number",
                    minValue: 0,
                    maxValue: 1,
                    default: 1,
                    visible: false
                },
                {
                    name: "showBrandInfo:boolean",
                    default: false,
                    visible: false
                }
            ]);
        /***/ },
        /***/ "./src/surveyProgress.ts": /*!*******************************!*\
  !*** ./src/surveyProgress.ts ***!
  \*******************************/ /*! exports provided: SurveyProgressModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressModel", function() {
                return SurveyProgressModel;
            });
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            var SurveyProgressModel = /** @class */ function() {
                function SurveyProgressModel() {}
                SurveyProgressModel.getProgressTextInBarCss = function(css) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_0__["CssClassBuilder"]().append(css.progressText).append(css.progressTextInBar).toString();
                };
                SurveyProgressModel.getProgressTextUnderBarCss = function(css) {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_0__["CssClassBuilder"]().append(css.progressText).append(css.progressTextUnderBar).toString();
                };
                return SurveyProgressModel;
            }();
        /***/ },
        /***/ "./src/surveyStrings.ts": /*!******************************!*\
  !*** ./src/surveyStrings.ts ***!
  \******************************/ /*! exports provided: surveyLocalization, surveyStrings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "surveyLocalization", function() {
                return surveyLocalization;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "surveyStrings", function() {
                return surveyStrings;
            });
            /* harmony import */ var _localization_english__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./localization/english */ "./src/localization/english.ts");
            var surveyLocalization = {
                currentLocaleValue: "",
                defaultLocaleValue: "en",
                locales: {},
                localeNames: {},
                supportedLocales: [],
                get currentLocale () {
                    return this.currentLocaleValue === this.defaultLocaleValue ? "" : this.currentLocaleValue;
                },
                set currentLocale (val){
                    if (val === "cz") val = "cs";
                    this.currentLocaleValue = val;
                },
                get defaultLocale () {
                    return this.defaultLocaleValue;
                },
                set defaultLocale (val){
                    if (val === "cz") val = "cs";
                    this.defaultLocaleValue = val;
                },
                getLocaleStrings: function(loc) {
                    return this.locales[loc];
                },
                getString: function(strName, locale) {
                    var _this = this;
                    if (locale === void 0) locale = null;
                    var locs = new Array();
                    var addLocaleCore = function(locName) {
                        var strs = _this.locales[locName];
                        if (!!strs) locs.push(strs);
                    };
                    var addLocale = function(locName) {
                        if (!locName) return;
                        addLocaleCore(locName);
                        var index = locName.indexOf("-");
                        if (index < 1) return;
                        locName = locName.substring(0, index);
                        addLocaleCore(locName);
                    };
                    addLocale(locale);
                    addLocale(this.currentLocale);
                    addLocale(this.defaultLocale);
                    if (this.defaultLocale !== "en") addLocaleCore("en");
                    for(var i = 0; i < locs.length; i++){
                        var res = locs[i][strName];
                        if (res !== undefined) return res;
                    }
                    return this.onGetExternalString(strName, locale);
                },
                getLocales: function(removeDefaultLoc) {
                    if (removeDefaultLoc === void 0) removeDefaultLoc = false;
                    var res = [];
                    res.push("");
                    var locs = this.locales;
                    if (this.supportedLocales && this.supportedLocales.length > 0) {
                        locs = {};
                        for(var i = 0; i < this.supportedLocales.length; i++)locs[this.supportedLocales[i]] = true;
                    }
                    for(var key in locs){
                        if (removeDefaultLoc && key == this.defaultLocale) continue;
                        res.push(key);
                    }
                    var locName = function(loc) {
                        if (!loc) return "";
                        var res = surveyLocalization.localeNames[loc];
                        if (!res) res = loc;
                        return res.toLowerCase();
                    };
                    res.sort(function(a, b) {
                        var str1 = locName(a);
                        var str2 = locName(b);
                        if (str1 === str2) return 0;
                        return str1 < str2 ? -1 : 1;
                    });
                    return res;
                },
                onGetExternalString: function(name, locale) {
                    return undefined;
                }
            };
            var surveyStrings = _localization_english__WEBPACK_IMPORTED_MODULE_0__["englishStrings"];
            surveyLocalization.locales["en"] = _localization_english__WEBPACK_IMPORTED_MODULE_0__["englishStrings"];
            surveyLocalization.localeNames["en"] = "english";
        /***/ },
        /***/ "./src/surveyTaskManager.ts": /*!**********************************!*\
  !*** ./src/surveyTaskManager.ts ***!
  \**********************************/ /*! exports provided: SurveyTaskManagerModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTaskManagerModel", function() {
                return SurveyTaskManagerModel;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var SurveyTaskModel = /** @class */ function() {
                function SurveyTaskModel(type) {
                    this.type = type;
                    this.timestamp = new Date();
                }
                return SurveyTaskModel;
            }();
            var SurveyTaskManagerModel = /** @class */ function(_super) {
                __extends(SurveyTaskManagerModel, _super);
                function SurveyTaskManagerModel() {
                    var _this = _super.call(this) || this;
                    _this.taskList = [];
                    _this.onAllTasksCompleted = _this.addEvent();
                    return _this;
                }
                SurveyTaskManagerModel.prototype.runTask = function(type, func) {
                    var _this = this;
                    var task = new SurveyTaskModel(type);
                    this.taskList.push(task);
                    this.hasActiveTasks = true;
                    func(function() {
                        return _this.taskFinished(task);
                    });
                    return task;
                };
                SurveyTaskManagerModel.prototype.waitAndExecute = function(action) {
                    if (!this.hasActiveTasks) {
                        action();
                        return;
                    }
                    this.onAllTasksCompleted.add(function() {
                        action();
                    });
                };
                SurveyTaskManagerModel.prototype.taskFinished = function(task) {
                    var index = this.taskList.indexOf(task);
                    if (index > -1) this.taskList.splice(index, 1);
                    if (this.hasActiveTasks && this.taskList.length == 0) {
                        this.hasActiveTasks = false;
                        this.onAllTasksCompleted.fire(this, {});
                    }
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], SurveyTaskManagerModel.prototype, "hasActiveTasks", void 0);
                return SurveyTaskManagerModel;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
        /***/ },
        /***/ "./src/surveyTimerModel.ts": /*!*********************************!*\
  !*** ./src/surveyTimerModel.ts ***!
  \*********************************/ /*! exports provided: SurveyTimerModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTimerModel", function() {
                return SurveyTimerModel;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _surveytimer__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./surveytimer */ "./src/surveytimer.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var SurveyTimerModel = /** @class */ function(_super) {
                __extends(SurveyTimerModel, _super);
                function SurveyTimerModel(survey) {
                    var _this = _super.call(this) || this;
                    _this.timerFunc = null;
                    _this.surveyValue = survey;
                    _this.onCreating();
                    return _this;
                }
                Object.defineProperty(SurveyTimerModel.prototype, "survey", {
                    get: function() {
                        return this.surveyValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTimerModel.prototype.onCreating = function() {};
                SurveyTimerModel.prototype.start = function() {
                    var _this = this;
                    if (!this.survey) return;
                    if (this.isRunning || this.isDesignMode) return;
                    this.survey.onCurrentPageChanged.add(function() {
                        _this.update();
                    });
                    this.timerFunc = function() {
                        _this.doTimer();
                    };
                    this.setIsRunning(true);
                    this.update();
                    _surveytimer__WEBPACK_IMPORTED_MODULE_1__["SurveyTimer"].instance.start(this.timerFunc);
                };
                SurveyTimerModel.prototype.stop = function() {
                    if (!this.isRunning) return;
                    this.setIsRunning(false);
                    _surveytimer__WEBPACK_IMPORTED_MODULE_1__["SurveyTimer"].instance.stop(this.timerFunc);
                };
                Object.defineProperty(SurveyTimerModel.prototype, "isRunning", {
                    get: function() {
                        return this.getPropertyValue("isRunning", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTimerModel.prototype.setIsRunning = function(val1) {
                    this.setPropertyValue("isRunning", val1);
                };
                SurveyTimerModel.prototype.update = function() {
                    this.updateText();
                    this.updateProgress();
                };
                SurveyTimerModel.prototype.doTimer = function() {
                    var page = this.survey.currentPage;
                    if (page) page.timeSpent = page.timeSpent + 1;
                    this.spent = this.spent + 1;
                    this.update();
                    if (this.onTimer) this.onTimer(page);
                };
                SurveyTimerModel.prototype.updateProgress = function() {
                    var _this = this;
                    var _a = this.survey.timerInfo, spent = _a.spent, limit = _a.limit;
                    if (!limit) this.progress = undefined;
                    else {
                        if (spent == 0) {
                            this.progress = 0;
                            setTimeout(function() {
                                _this.progress = Math.floor((spent + 1) / limit * 100) / 100;
                            }, 0);
                        } else if (spent <= limit) this.progress = Math.floor((spent + 1) / limit * 100) / 100;
                        if (this.progress > 1) this.progress = undefined;
                    }
                };
                SurveyTimerModel.prototype.updateText = function() {
                    var timerClock = this.survey.timerClock;
                    this.clockMajorText = timerClock.majorText;
                    this.clockMinorText = timerClock.minorText;
                    this.text = this.survey.timerInfoText;
                };
                Object.defineProperty(SurveyTimerModel.prototype, "showProgress", {
                    get: function() {
                        return this.progress !== undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTimerModel.prototype, "showTimerAsClock", {
                    get: function() {
                        return !!this.survey.getCss().clockTimerRoot;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTimerModel.prototype, "rootCss", {
                    get: function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.survey.getCss().clockTimerRoot).append(this.survey.getCss().clockTimerRootTop, this.survey.isTimerPanelShowingOnTop).append(this.survey.getCss().clockTimerRootBottom, this.survey.isTimerPanelShowingOnBottom).toString();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTimerModel.prototype.getProgressCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.survey.getCss().clockTimerProgress).append(this.survey.getCss().clockTimerProgressAnimation, this.progress > 0).toString();
                };
                Object.defineProperty(SurveyTimerModel.prototype, "textContainerCss", {
                    get: function() {
                        return this.survey.getCss().clockTimerTextContainer;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTimerModel.prototype, "minorTextCss", {
                    get: function() {
                        return this.survey.getCss().clockTimerMinorText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTimerModel.prototype, "majorTextCss", {
                    get: function() {
                        return this.survey.getCss().clockTimerMajorText;
                    },
                    enumerable: false,
                    configurable: true
                });
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], SurveyTimerModel.prototype, "text", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], SurveyTimerModel.prototype, "progress", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], SurveyTimerModel.prototype, "clockMajorText", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], SurveyTimerModel.prototype, "clockMinorText", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: 0
                    })
                ], SurveyTimerModel.prototype, "spent", void 0);
                return SurveyTimerModel;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
        /***/ },
        /***/ "./src/surveyToc.ts": /*!**************************!*\
  !*** ./src/surveyToc.ts ***!
  \**************************/ /*! exports provided: tryFocusPage, createTOCListModel, getTocRootCss, TOCModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "tryFocusPage", function() {
                return tryFocusPage;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createTOCListModel", function() {
                return createTOCListModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getTocRootCss", function() {
                return getTocRootCss;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TOCModel", function() {
                return TOCModel;
            });
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./list */ "./src/list.ts");
            /* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./page */ "./src/page.ts");
            /* harmony import */ var _popup__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./popup */ "./src/popup.ts");
            function tryFocusPage(survey, panel) {
                if (survey.isDesignMode) return true;
                panel.focusFirstQuestion();
                return true;
            }
            function createTOCListModel(survey, onAction) {
                var _a;
                var pagesSource = survey.questionsOnPageMode === "singlePage" ? (_a = survey.pages[0]) === null || _a === void 0 ? void 0 : _a.elements : survey.pages;
                var items = (pagesSource || []).map(function(page) {
                    var _a, _b;
                    return new _actions_action__WEBPACK_IMPORTED_MODULE_0__["Action"]({
                        id: page.name,
                        locTitle: ((_a = page.locNavigationTitle) === null || _a === void 0 ? void 0 : _a.text) ? page.locNavigationTitle : ((_b = page.locTitle) === null || _b === void 0 ? void 0 : _b.text) ? page.locTitle : undefined,
                        title: page.renderedNavigationTitle,
                        action: function() {
                            _global_variables_utils__WEBPACK_IMPORTED_MODULE_2__["DomDocumentHelper"].activeElementBlur();
                            !!onAction && onAction();
                            if (page instanceof _page__WEBPACK_IMPORTED_MODULE_4__["PageModel"]) return survey.tryNavigateToPage(page);
                            return tryFocusPage(survey, page);
                        },
                        visible: new _base__WEBPACK_IMPORTED_MODULE_1__["ComputedUpdater"](function() {
                            return page.isVisible && !page["isStartPage"];
                        })
                    });
                });
                var listModel = new _list__WEBPACK_IMPORTED_MODULE_3__["ListModel"](items, function(item) {
                    if (!!item.action()) listModel.selectedItem = item;
                }, true, items.filter(function(i) {
                    return !!survey.currentPage && i.id === survey.currentPage.name;
                })[0] || items.filter(function(i) {
                    return i.id === pagesSource[0].name;
                })[0]);
                listModel.allowSelection = false;
                listModel.locOwner = survey;
                listModel.searchEnabled = false;
                survey.onCurrentPageChanged.add(function(s, o) {
                    listModel.selectedItem = items.filter(function(i) {
                        return !!survey.currentPage && i.id === survey.currentPage.name;
                    })[0];
                });
                return listModel;
            }
            function getTocRootCss(survey, isMobile) {
                if (isMobile === void 0) isMobile = false;
                if (isMobile) return "sv_progress-toc sv_progress-toc--mobile";
                return "sv_progress-toc" + (" sv_progress-toc--" + (survey.tocLocation || "").toLowerCase());
            }
            var TOCModel = /** @class */ function() {
                function TOCModel(survey) {
                    var _this = this;
                    this.survey = survey;
                    this.icon = "icon-navmenu_24x24";
                    this.togglePopup = function() {
                        _this.popupModel.toggleVisibility();
                    };
                    this.listModel = createTOCListModel(survey, function() {
                        _this.popupModel.isVisible = false;
                    });
                    this.popupModel = new _popup__WEBPACK_IMPORTED_MODULE_5__["PopupModel"]("sv-list", {
                        model: this.listModel
                    });
                    this.popupModel.overlayDisplayMode = "overlay";
                    this.popupModel.displayMode = new _base__WEBPACK_IMPORTED_MODULE_1__["ComputedUpdater"](function() {
                        return _this.isMobile ? "overlay" : "popup";
                    });
                }
                Object.defineProperty(TOCModel.prototype, "isMobile", {
                    get: function() {
                        return this.survey.isMobile;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TOCModel.prototype, "containerCss", {
                    get: function() {
                        return getTocRootCss(this.survey, this.isMobile);
                    },
                    enumerable: false,
                    configurable: true
                });
                TOCModel.prototype.dispose = function() {
                    this.popupModel.dispose();
                    this.listModel.dispose();
                };
                return TOCModel;
            }();
        /***/ },
        /***/ "./src/surveytimer.ts": /*!****************************!*\
  !*** ./src/surveytimer.ts ***!
  \****************************/ /*! exports provided: surveyTimerFunctions, SurveyTimer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "surveyTimerFunctions", function() {
                return surveyTimerFunctions;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTimer", function() {
                return SurveyTimer;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            var surveyTimerFunctions = {
                setTimeout: function(func) {
                    return surveyTimerFunctions.safeTimeOut(func, 1000);
                },
                clearTimeout: function(timerId) {
                    clearTimeout(timerId);
                },
                safeTimeOut: function(func, delay) {
                    if (delay <= 0) {
                        func();
                        return 0;
                    } else return setTimeout(func, delay);
                }
            };
            var SurveyTimer = /** @class */ function() {
                function SurveyTimer() {
                    this.listenerCounter = 0;
                    this.timerId = -1;
                    this.onTimer = new _base__WEBPACK_IMPORTED_MODULE_0__["Event"]();
                }
                Object.defineProperty(SurveyTimer, "instance", {
                    get: function() {
                        if (!SurveyTimer.instanceValue) SurveyTimer.instanceValue = new SurveyTimer();
                        return SurveyTimer.instanceValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTimer.prototype.start = function(func) {
                    var _this = this;
                    if (func === void 0) func = null;
                    if (func) this.onTimer.add(func);
                    if (this.timerId < 0) this.timerId = surveyTimerFunctions.setTimeout(function() {
                        _this.doTimer();
                    });
                    this.listenerCounter++;
                };
                SurveyTimer.prototype.stop = function(func) {
                    if (func === void 0) func = null;
                    if (func) this.onTimer.remove(func);
                    this.listenerCounter--;
                    if (this.listenerCounter == 0 && this.timerId > -1) {
                        surveyTimerFunctions.clearTimeout(this.timerId);
                        this.timerId = -1;
                    }
                };
                SurveyTimer.prototype.doTimer = function() {
                    var _this = this;
                    if (this.onTimer.isEmpty || this.listenerCounter == 0) this.timerId = -1;
                    if (this.timerId < 0) return;
                    var prevItem = this.timerId;
                    this.onTimer.fire(this, {});
                    //We have to check that we have the same timerId
                    //It could be changed during events execution and it will lead to double timer events
                    if (prevItem !== this.timerId) return;
                    this.timerId = surveyTimerFunctions.setTimeout(function() {
                        _this.doTimer();
                    });
                };
                SurveyTimer.instanceValue = null;
                return SurveyTimer;
            }();
        /***/ },
        /***/ "./src/svgbundle.ts": /*!**************************!*\
  !*** ./src/svgbundle.ts ***!
  \**************************/ /*! exports provided: SvgIconRegistry, SvgRegistry, SvgBundleViewModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgIconRegistry", function() {
                return SvgIconRegistry;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgRegistry", function() {
                return SvgRegistry;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgBundleViewModel", function() {
                return SvgBundleViewModel;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var SvgIconData = /** @class */ function() {
                function SvgIconData() {}
                return SvgIconData;
            }();
            var SvgIconRegistry = /** @class */ function() {
                function SvgIconRegistry() {
                    this.icons = {};
                    this.iconPrefix = "icon-";
                }
                SvgIconRegistry.prototype.processId = function(iconId, iconPrefix) {
                    if (iconId.indexOf(iconPrefix) == 0) iconId = iconId.substring(iconPrefix.length);
                    return iconId;
                };
                SvgIconRegistry.prototype.registerIconFromSymbol = function(iconId, iconSymbolSvg) {
                    this.icons[iconId] = iconSymbolSvg;
                };
                SvgIconRegistry.prototype.registerIconFromSvgViaElement = function(iconId, iconSvg, iconPrefix) {
                    if (iconPrefix === void 0) iconPrefix = this.iconPrefix;
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].isAvailable()) return;
                    iconId = this.processId(iconId, iconPrefix);
                    var divSvg = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].createElement("div");
                    divSvg.innerHTML = iconSvg;
                    var symbol = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].createElement("symbol");
                    var svg = divSvg.querySelector("svg");
                    symbol.innerHTML = svg.innerHTML;
                    for(var i = 0; i < svg.attributes.length; i++)symbol.setAttributeNS("http://www.w3.org/2000/svg", svg.attributes[i].name, svg.attributes[i].value);
                    symbol.id = iconPrefix + iconId;
                    this.registerIconFromSymbol(iconId, symbol.outerHTML);
                };
                SvgIconRegistry.prototype.registerIconFromSvg = function(iconId, iconSvg, iconPrefix) {
                    if (iconPrefix === void 0) iconPrefix = this.iconPrefix;
                    iconId = this.processId(iconId, iconPrefix);
                    var startStr = "<svg ";
                    var endStr = "</svg>";
                    iconSvg = iconSvg.trim();
                    var str = iconSvg.toLowerCase();
                    if (str.substring(0, startStr.length) === startStr && str.substring(str.length - endStr.length, str.length) === endStr) {
                        this.registerIconFromSymbol(iconId, '<symbol id="' + iconPrefix + iconId + '" ' + iconSvg.substring(startStr.length, str.length - endStr.length) + "</symbol>");
                        return true;
                    } else return false;
                };
                SvgIconRegistry.prototype.registerIconsFromFolder = function(r) {
                    var _this = this;
                    r.keys().forEach(function(key) {
                        _this.registerIconFromSvg(key.substring(2, key.length - 4).toLowerCase(), r(key));
                    });
                };
                SvgIconRegistry.prototype.iconsRenderedHtml = function() {
                    var _this = this;
                    return Object.keys(this.icons).map(function(icon) {
                        return _this.icons[icon];
                    }).join("");
                };
                return SvgIconRegistry;
            }();
            var SvgRegistry = new SvgIconRegistry();
            var SvgBundleViewModel;
            var path = __webpack_require__("./src/images sync \\.svg$");
            var pathSmiley = __webpack_require__("./src/images/smiley sync \\.svg$");
            SvgRegistry.registerIconsFromFolder(path);
            SvgRegistry.registerIconsFromFolder(pathSmiley);
        /***/ },
        /***/ "./src/template-renderer.ts": /*!**********************************!*\
  !*** ./src/template-renderer.ts ***!
  \**********************************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
        /***/ },
        /***/ "./src/textPreProcessor.ts": /*!*********************************!*\
  !*** ./src/textPreProcessor.ts ***!
  \*********************************/ /*! exports provided: TextPreProcessorItem, TextPreProcessorValue, TextPreProcessor, QuestionTextProcessor */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextPreProcessorItem", function() {
                return TextPreProcessorItem;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextPreProcessorValue", function() {
                return TextPreProcessorValue;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextPreProcessor", function() {
                return TextPreProcessor;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "QuestionTextProcessor", function() {
                return QuestionTextProcessor;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./conditionProcessValue */ "./src/conditionProcessValue.ts");
            var TextPreProcessorItem = /** @class */ function() {
                function TextPreProcessorItem() {}
                return TextPreProcessorItem;
            }();
            var TextPreProcessorValue = /** @class */ function() {
                function TextPreProcessorValue(name, returnDisplayValue) {
                    this.name = name;
                    this.returnDisplayValue = returnDisplayValue;
                    this.isExists = false;
                    this.canProcess = true;
                }
                return TextPreProcessorValue;
            }();
            var TextPreProcessor = /** @class */ function() {
                function TextPreProcessor() {
                    this._unObservableValues = [
                        undefined
                    ];
                }
                Object.defineProperty(TextPreProcessor.prototype, "hasAllValuesOnLastRunValue", {
                    get: function() {
                        return this._unObservableValues[0];
                    },
                    set: function(val1) {
                        this._unObservableValues[0] = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                TextPreProcessor.prototype.process = function(text, returnDisplayValue, doEncoding) {
                    if (returnDisplayValue === void 0) returnDisplayValue = false;
                    if (doEncoding === void 0) doEncoding = false;
                    this.hasAllValuesOnLastRunValue = true;
                    if (!text) return text;
                    if (!this.onProcess) return text;
                    var items = this.getItems(text);
                    for(var i = items.length - 1; i >= 0; i--){
                        var item = items[i];
                        var name = this.getName(text.substring(item.start + 1, item.end));
                        if (!name) continue;
                        var textValue = new TextPreProcessorValue(name, returnDisplayValue);
                        this.onProcess(textValue);
                        if (!textValue.isExists) {
                            if (textValue.canProcess) this.hasAllValuesOnLastRunValue = false;
                            continue;
                        }
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(textValue.value)) this.hasAllValuesOnLastRunValue = false;
                        var replacedValue = !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(textValue.value) ? textValue.value : "";
                        if (doEncoding) replacedValue = encodeURIComponent(replacedValue);
                        text = text.substring(0, item.start) + replacedValue + text.substring(item.end + 1);
                    }
                    return text;
                };
                TextPreProcessor.prototype.processValue = function(name, returnDisplayValue) {
                    var textValue = new TextPreProcessorValue(name, returnDisplayValue);
                    if (!!this.onProcess) this.onProcess(textValue);
                    return textValue;
                };
                Object.defineProperty(TextPreProcessor.prototype, "hasAllValuesOnLastRun", {
                    get: function() {
                        return !!this.hasAllValuesOnLastRunValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                TextPreProcessor.prototype.getItems = function(text) {
                    var items = [];
                    var length = text.length;
                    var start = -1;
                    var ch = "";
                    for(var i = 0; i < length; i++){
                        ch = text[i];
                        if (ch == "{") start = i;
                        if (ch == "}") {
                            if (start > -1) {
                                var item = new TextPreProcessorItem();
                                item.start = start;
                                item.end = i;
                                items.push(item);
                            }
                            start = -1;
                        }
                    }
                    return items;
                };
                TextPreProcessor.prototype.getName = function(name) {
                    if (!name) return;
                    return name.trim();
                };
                return TextPreProcessor;
            }();
            var QuestionTextProcessor = /** @class */ function() {
                function QuestionTextProcessor(variableName) {
                    var _this = this;
                    this.variableName = variableName;
                    this.textPreProcessor = new TextPreProcessor();
                    this.textPreProcessor.onProcess = function(textValue) {
                        _this.getProcessedTextValue(textValue);
                    };
                }
                QuestionTextProcessor.prototype.processValue = function(name, returnDisplayValue) {
                    return this.textPreProcessor.processValue(name, returnDisplayValue);
                };
                Object.defineProperty(QuestionTextProcessor.prototype, "survey", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(QuestionTextProcessor.prototype, "panel", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                QuestionTextProcessor.prototype.getValues = function() {
                    return !!this.panel ? this.panel.getValue() : null;
                };
                QuestionTextProcessor.prototype.getQuestionByName = function(name) {
                    return !!this.panel ? this.panel.getQuestionByValueName(name) : null;
                };
                QuestionTextProcessor.prototype.getParentTextProcessor = function() {
                    return null;
                };
                QuestionTextProcessor.prototype.onCustomProcessText = function(textValue) {
                    return false;
                };
                QuestionTextProcessor.prototype.getQuestionDisplayText = function(question) {
                    return question.displayValue;
                };
                //ITextProcessor
                QuestionTextProcessor.prototype.getProcessedTextValue = function(textValue) {
                    if (!textValue) return;
                    if (this.onCustomProcessText(textValue)) return;
                    var firstName = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_1__["ProcessValue"]().getFirstName(textValue.name);
                    textValue.isExists = firstName == this.variableName;
                    textValue.canProcess = textValue.isExists;
                    if (!textValue.canProcess) return;
                    //name should start with the variable name
                    textValue.name = textValue.name.replace(this.variableName + ".", "");
                    var firstName = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_1__["ProcessValue"]().getFirstName(textValue.name);
                    var question = this.getQuestionByName(firstName);
                    var values = {};
                    if (question) values[firstName] = textValue.returnDisplayValue ? this.getQuestionDisplayText(question) : question.value;
                    else {
                        var allValues = !!this.panel ? this.getValues() : null;
                        if (allValues) values[firstName] = allValues[firstName];
                    }
                    textValue.value = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_1__["ProcessValue"]().getValue(textValue.name, values);
                };
                QuestionTextProcessor.prototype.processText = function(text, returnDisplayValue) {
                    if (this.survey && this.survey.isDesignMode) return text;
                    text = this.textPreProcessor.process(text, returnDisplayValue);
                    text = this.processTextCore(this.getParentTextProcessor(), text, returnDisplayValue);
                    return this.processTextCore(this.survey, text, returnDisplayValue);
                };
                QuestionTextProcessor.prototype.processTextEx = function(text, returnDisplayValue) {
                    text = this.processText(text, returnDisplayValue);
                    var hasAllValuesOnLastRun = this.textPreProcessor.hasAllValuesOnLastRun;
                    var res = {
                        hasAllValuesOnLastRun: true,
                        text: text
                    };
                    if (this.survey) res = this.survey.processTextEx(text, returnDisplayValue, false);
                    res.hasAllValuesOnLastRun = res.hasAllValuesOnLastRun && hasAllValuesOnLastRun;
                    return res;
                };
                QuestionTextProcessor.prototype.processTextCore = function(textProcessor, text, returnDisplayValue) {
                    if (!textProcessor) return text;
                    return textProcessor.processText(text, returnDisplayValue);
                };
                return QuestionTextProcessor;
            }();
        /***/ },
        /***/ "./src/themes.ts": /*!***********************!*\
  !*** ./src/themes.ts ***!
  \***********************/ /*! no exports provided */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
        /***/ },
        /***/ "./src/trigger.ts": /*!************************!*\
  !*** ./src/trigger.ts ***!
  \************************/ /*! exports provided: Trigger, SurveyTrigger, SurveyTriggerVisible, SurveyTriggerComplete, SurveyTriggerSetValue, SurveyTriggerSkip, SurveyTriggerRunExpression, SurveyTriggerCopyValue */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Trigger", function() {
                return Trigger;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTrigger", function() {
                return SurveyTrigger;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerVisible", function() {
                return SurveyTriggerVisible;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerComplete", function() {
                return SurveyTriggerComplete;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerSetValue", function() {
                return SurveyTriggerSetValue;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerSkip", function() {
                return SurveyTriggerSkip;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerRunExpression", function() {
                return SurveyTriggerRunExpression;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTriggerCopyValue", function() {
                return SurveyTriggerCopyValue;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _expressions_expressions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./expressions/expressions */ "./src/expressions/expressions.ts");
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./conditionProcessValue */ "./src/conditionProcessValue.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /**
 * A base class for all triggers.
 * A trigger calls a method when the expression change the result: from false to true or from true to false.
 * Please note, it runs only one changing the expression result.
 */ var Trigger = /** @class */ function(_super) {
                __extends(Trigger, _super);
                function Trigger() {
                    var _this = _super.call(this) || this;
                    _this.idValue = Trigger.idCounter++;
                    _this.registerPropertyChangedHandlers([
                        "operator",
                        "value",
                        "name"
                    ], function() {
                        _this.oldPropertiesChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "expression"
                    ], function() {
                        _this.onExpressionChanged();
                    });
                    return _this;
                }
                Object.defineProperty(Trigger, "operators", {
                    get: function() {
                        if (Trigger.operatorsValue != null) return Trigger.operatorsValue;
                        Trigger.operatorsValue = {
                            empty: function(value, expectedValue) {
                                return !value;
                            },
                            notempty: function(value, expectedValue) {
                                return !!value;
                            },
                            equal: function(value, expectedValue) {
                                return value == expectedValue;
                            },
                            notequal: function(value, expectedValue) {
                                return value != expectedValue;
                            },
                            contains: function(value, expectedValue) {
                                return value && value["indexOf"] && value.indexOf(expectedValue) > -1;
                            },
                            notcontains: function(value, expectedValue) {
                                return !value || !value["indexOf"] || value.indexOf(expectedValue) == -1;
                            },
                            greater: function(value, expectedValue) {
                                return value > expectedValue;
                            },
                            less: function(value, expectedValue) {
                                return value < expectedValue;
                            },
                            greaterorequal: function(value, expectedValue) {
                                return value >= expectedValue;
                            },
                            lessorequal: function(value, expectedValue) {
                                return value <= expectedValue;
                            }
                        };
                        return Trigger.operatorsValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Trigger.prototype, "id", {
                    get: function() {
                        return this.idValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Trigger.prototype.getType = function() {
                    return "triggerbase";
                };
                Trigger.prototype.toString = function() {
                    var res = this.getType().replace("trigger", "");
                    var exp = !!this.expression ? this.expression : this.buildExpression();
                    if (exp) res += ", " + exp;
                    return res;
                };
                Object.defineProperty(Trigger.prototype, "isInternal", {
                    get: function() {
                        return this.isGhost === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Trigger.prototype, "operator", {
                    get: function() {
                        return this.getPropertyValue("operator", "equal");
                    },
                    set: function(value) {
                        if (!value) return;
                        value = value.toLowerCase();
                        if (!Trigger.operators[value]) return;
                        this.setPropertyValue("operator", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Trigger.prototype, "value", {
                    get: function() {
                        return this.getPropertyValue("value", null);
                    },
                    set: function(val1) {
                        this.setPropertyValue("value", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Trigger.prototype, "name", {
                    get: function() {
                        return this.getPropertyValue("name", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("name", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Trigger.prototype, "expression", {
                    get: function() {
                        return this.getPropertyValue("expression", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("expression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Trigger.prototype.canBeExecuted = function(isOnNextPage) {
                    return true;
                };
                Trigger.prototype.canBeExecutedOnComplete = function() {
                    return false;
                };
                Trigger.prototype.checkExpression = function(isOnNextPage, isOnComplete, keys, values, properties) {
                    if (properties === void 0) properties = null;
                    this.isExecutingOnNextPage = isOnNextPage;
                    if (!this.canBeExecuted(isOnNextPage)) return;
                    if (isOnComplete && !this.canBeExecutedOnComplete()) return;
                    if (!this.isCheckRequired(keys)) return;
                    if (!!this.conditionRunner) this.perform(values, properties);
                    else if (this.canSuccessOnEmptyExpression()) this.triggerResult(true, values, properties);
                };
                Trigger.prototype.canSuccessOnEmptyExpression = function() {
                    return false;
                };
                Trigger.prototype.check = function(value) {
                    var triggerResult = Trigger.operators[this.operator](value, this.value);
                    if (triggerResult) this.onSuccess({}, null);
                    else this.onFailure();
                };
                Object.defineProperty(Trigger.prototype, "requireValidQuestion", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Trigger.prototype.perform = function(values, properties) {
                    var _this = this;
                    this.conditionRunner.onRunComplete = function(res) {
                        _this.triggerResult(res, values, properties);
                    };
                    this.conditionRunner.run(values, properties);
                };
                Trigger.prototype.triggerResult = function(res, values, properties) {
                    if (res) {
                        this.onSuccess(values, properties);
                        this.onSuccessExecuted();
                    } else this.onFailure();
                };
                Trigger.prototype.onSuccess = function(values, properties) {};
                Trigger.prototype.onFailure = function() {};
                Trigger.prototype.onSuccessExecuted = function() {};
                Trigger.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    this.oldPropertiesChanged();
                };
                Trigger.prototype.oldPropertiesChanged = function() {
                    this.onExpressionChanged();
                };
                Trigger.prototype.onExpressionChanged = function() {
                    this.conditionRunner = null;
                };
                Trigger.prototype.buildExpression = function() {
                    if (!this.name) return "";
                    if (this.isValueEmpty(this.value) && this.isRequireValue) return "";
                    return "{" + this.name + "} " + this.operator + " " + _expressions_expressions__WEBPACK_IMPORTED_MODULE_4__["OperandMaker"].toOperandString(this.value);
                };
                Trigger.prototype.isCheckRequired = function(keys) {
                    if (!keys) return false;
                    this.createConditionRunner();
                    if (this.conditionRunner && this.conditionRunner.hasFunction() === true) return true;
                    return new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_5__["ProcessValue"]().isAnyKeyChanged(keys, this.getUsedVariables());
                };
                Trigger.prototype.getUsedVariables = function() {
                    if (!this.conditionRunner) return [];
                    return this.conditionRunner.getVariables();
                };
                Trigger.prototype.createConditionRunner = function() {
                    if (!!this.conditionRunner) return;
                    var expression = this.expression;
                    if (!expression) expression = this.buildExpression();
                    if (!expression) return;
                    this.conditionRunner = new _conditions__WEBPACK_IMPORTED_MODULE_3__["ConditionRunner"](expression);
                };
                Object.defineProperty(Trigger.prototype, "isRequireValue", {
                    get: function() {
                        return this.operator !== "empty" && this.operator != "notempty";
                    },
                    enumerable: false,
                    configurable: true
                });
                Trigger.idCounter = 1;
                Trigger.operatorsValue = null;
                return Trigger;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
            /**
 * It extends the Trigger base class and add properties required for SurveyJS classes.
 */ var SurveyTrigger = /** @class */ function(_super) {
                __extends(SurveyTrigger, _super);
                function SurveyTrigger() {
                    var _this = _super.call(this) || this;
                    _this.ownerValue = null;
                    return _this;
                }
                Object.defineProperty(SurveyTrigger.prototype, "owner", {
                    get: function() {
                        return this.ownerValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTrigger.prototype.setOwner = function(owner) {
                    this.ownerValue = owner;
                };
                SurveyTrigger.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    return !!this.owner && !!this.owner["getSurvey"] ? this.owner.getSurvey() : null;
                };
                SurveyTrigger.prototype.isRealExecution = function() {
                    return true;
                };
                SurveyTrigger.prototype.onSuccessExecuted = function() {
                    if (!!this.owner && this.isRealExecution()) this.owner.triggerExecuted(this);
                };
                return SurveyTrigger;
            }(Trigger);
            /**
 * If expression returns true, it makes questions/pages visible.
 * Ohterwise it makes them invisible.
 */ var SurveyTriggerVisible = /** @class */ function(_super) {
                __extends(SurveyTriggerVisible, _super);
                function SurveyTriggerVisible() {
                    var _this = _super.call(this) || this;
                    _this.pages = [];
                    _this.questions = [];
                    return _this;
                }
                SurveyTriggerVisible.prototype.getType = function() {
                    return "visibletrigger";
                };
                SurveyTriggerVisible.prototype.onSuccess = function(values, properties) {
                    this.onTrigger(this.onItemSuccess);
                };
                SurveyTriggerVisible.prototype.onFailure = function() {
                    this.onTrigger(this.onItemFailure);
                };
                SurveyTriggerVisible.prototype.onTrigger = function(func) {
                    if (!this.owner) return;
                    var objects = this.owner.getObjects(this.pages, this.questions);
                    for(var i = 0; i < objects.length; i++)func(objects[i]);
                };
                SurveyTriggerVisible.prototype.onItemSuccess = function(item) {
                    item.visible = true;
                };
                SurveyTriggerVisible.prototype.onItemFailure = function(item) {
                    item.visible = false;
                };
                return SurveyTriggerVisible;
            }(SurveyTrigger);
            /**
 * If expression returns true, it completes the survey.
 */ var SurveyTriggerComplete = /** @class */ function(_super) {
                __extends(SurveyTriggerComplete, _super);
                function SurveyTriggerComplete() {
                    return _super.call(this) || this;
                }
                SurveyTriggerComplete.prototype.getType = function() {
                    return "completetrigger";
                };
                Object.defineProperty(SurveyTriggerComplete.prototype, "requireValidQuestion", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTriggerComplete.prototype.isRealExecution = function() {
                    return !_settings__WEBPACK_IMPORTED_MODULE_6__["settings"].triggers.executeCompleteOnValueChanged === this.isExecutingOnNextPage;
                };
                SurveyTriggerComplete.prototype.onSuccess = function(values, properties) {
                    if (!this.owner) return;
                    if (this.isRealExecution()) this.owner.setCompleted(this);
                    else this.owner.canBeCompleted(this, true);
                };
                SurveyTriggerComplete.prototype.onFailure = function() {
                    this.owner.canBeCompleted(this, false);
                };
                return SurveyTriggerComplete;
            }(SurveyTrigger);
            /**
 * If expression returns true, the value from property **setValue** will be set to **setToName**
 */ var SurveyTriggerSetValue = /** @class */ function(_super) {
                __extends(SurveyTriggerSetValue, _super);
                function SurveyTriggerSetValue() {
                    return _super.call(this) || this;
                }
                SurveyTriggerSetValue.prototype.getType = function() {
                    return "setvaluetrigger";
                };
                SurveyTriggerSetValue.prototype.canBeExecuted = function(isOnNextPage) {
                    return !isOnNextPage && !!this.setToName;
                };
                SurveyTriggerSetValue.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {
                    _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
                    if (name !== "setToName") return;
                    var survey = this.getSurvey();
                    if (survey && !survey.isLoadingFromJson && survey.isDesignMode) this.setValue = undefined;
                };
                Object.defineProperty(SurveyTriggerSetValue.prototype, "setToName", {
                    get: function() {
                        return this.getPropertyValue("setToName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("setToName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTriggerSetValue.prototype, "setValue", {
                    get: function() {
                        return this.getPropertyValue("setValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("setValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTriggerSetValue.prototype, "isVariable", {
                    get: function() {
                        return this.getPropertyValue("isVariable");
                    },
                    set: function(val1) {
                        this.setPropertyValue("isVariable", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTriggerSetValue.prototype.onSuccess = function(values, properties) {
                    if (!this.setToName || !this.owner) return;
                    this.owner.setTriggerValue(this.setToName, this.setValue, this.isVariable);
                };
                return SurveyTriggerSetValue;
            }(SurveyTrigger);
            /**
 * If expression returns true, the survey go to question **gotoName** and focus it.
 */ var SurveyTriggerSkip = /** @class */ function(_super) {
                __extends(SurveyTriggerSkip, _super);
                function SurveyTriggerSkip() {
                    return _super.call(this) || this;
                }
                SurveyTriggerSkip.prototype.getType = function() {
                    return "skiptrigger";
                };
                Object.defineProperty(SurveyTriggerSkip.prototype, "requireValidQuestion", {
                    get: function() {
                        return this.canBeExecuted(false);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTriggerSkip.prototype, "gotoName", {
                    get: function() {
                        return this.getPropertyValue("gotoName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("gotoName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTriggerSkip.prototype.canBeExecuted = function(isOnNextPage) {
                    return isOnNextPage === !_settings__WEBPACK_IMPORTED_MODULE_6__["settings"].triggers.executeSkipOnValueChanged;
                };
                SurveyTriggerSkip.prototype.onSuccess = function(values, properties) {
                    if (!this.gotoName || !this.owner) return;
                    this.owner.focusQuestion(this.gotoName);
                };
                return SurveyTriggerSkip;
            }(SurveyTrigger);
            /**
 * If expression returns true, the **runExpression** will be run. If **setToName** property is not empty then the result of **runExpression** will be set to it.
 */ var SurveyTriggerRunExpression = /** @class */ function(_super) {
                __extends(SurveyTriggerRunExpression, _super);
                function SurveyTriggerRunExpression() {
                    return _super.call(this) || this;
                }
                SurveyTriggerRunExpression.prototype.getType = function() {
                    return "runexpressiontrigger";
                };
                Object.defineProperty(SurveyTriggerRunExpression.prototype, "setToName", {
                    get: function() {
                        return this.getPropertyValue("setToName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("setToName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTriggerRunExpression.prototype, "runExpression", {
                    get: function() {
                        return this.getPropertyValue("runExpression", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("runExpression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTriggerRunExpression.prototype.onSuccess = function(values, properties) {
                    var _this = this;
                    if (!this.owner || !this.runExpression) return;
                    var expression = new _conditions__WEBPACK_IMPORTED_MODULE_3__["ExpressionRunner"](this.runExpression);
                    if (expression.canRun) {
                        expression.onRunComplete = function(res) {
                            _this.onCompleteRunExpression(res);
                        };
                        expression.run(values, properties);
                    }
                };
                SurveyTriggerRunExpression.prototype.onCompleteRunExpression = function(newValue) {
                    if (!!this.setToName && newValue !== undefined) this.owner.setTriggerValue(this.setToName, _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].convertValToQuestionVal(newValue), false);
                };
                return SurveyTriggerRunExpression;
            }(SurveyTrigger);
            /**
 * If expression returns true, the value from question **fromName** will be set into **setToName**.
 */ var SurveyTriggerCopyValue = /** @class */ function(_super) {
                __extends(SurveyTriggerCopyValue, _super);
                function SurveyTriggerCopyValue() {
                    return _super.call(this) || this;
                }
                SurveyTriggerCopyValue.prototype.canBeExecuted = function(isOnNextPage) {
                    return !isOnNextPage && !!this.setToName && !!this.fromName;
                };
                Object.defineProperty(SurveyTriggerCopyValue.prototype, "setToName", {
                    get: function() {
                        return this.getPropertyValue("setToName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("setToName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTriggerCopyValue.prototype, "fromName", {
                    get: function() {
                        return this.getPropertyValue("fromName", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("fromName", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTriggerCopyValue.prototype, "copyDisplayValue", {
                    get: function() {
                        return this.getPropertyValue("copyDisplayValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("copyDisplayValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTriggerCopyValue.prototype.getType = function() {
                    return "copyvaluetrigger";
                };
                SurveyTriggerCopyValue.prototype.onSuccess = function(values, properties) {
                    if (!this.setToName || !this.owner) return;
                    this.owner.copyTriggerValue(this.setToName, this.fromName, this.copyDisplayValue);
                };
                SurveyTriggerCopyValue.prototype.canSuccessOnEmptyExpression = function() {
                    return true;
                };
                SurveyTriggerCopyValue.prototype.getUsedVariables = function() {
                    var res = _super.prototype.getUsedVariables.call(this);
                    if (res.length === 0 && !!this.fromName) res.push(this.fromName);
                    return res;
                };
                return SurveyTriggerCopyValue;
            }(SurveyTrigger);
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("trigger", [
                {
                    name: "operator",
                    default: "equal",
                    visible: false
                },
                {
                    name: "value",
                    visible: false
                },
                "expression:condition"
            ]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("surveytrigger", [
                {
                    name: "name",
                    visible: false
                }
            ], null, "trigger");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("visibletrigger", [
                "pages:pages",
                "questions:questions"
            ], function() {
                return new SurveyTriggerVisible();
            }, "surveytrigger");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("completetrigger", [], function() {
                return new SurveyTriggerComplete();
            }, "surveytrigger");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("setvaluetrigger", [
                {
                    name: "!setToName:questionvalue"
                },
                {
                    name: "setValue:triggervalue",
                    dependsOn: "setToName",
                    visibleIf: function(obj) {
                        return !!obj && !!obj["setToName"];
                    }
                },
                {
                    name: "isVariable:boolean",
                    visible: false
                }
            ], function() {
                return new SurveyTriggerSetValue();
            }, "surveytrigger");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("copyvaluetrigger", [
                {
                    name: "!fromName:questionvalue"
                },
                {
                    name: "!setToName:questionvalue"
                },
                {
                    name: "copyDisplayValue:boolean",
                    visible: false
                }
            ], function() {
                return new SurveyTriggerCopyValue();
            }, "surveytrigger");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("skiptrigger", [
                {
                    name: "!gotoName:question"
                }
            ], function() {
                return new SurveyTriggerSkip();
            }, "surveytrigger");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("runexpressiontrigger", [
                {
                    name: "setToName:questionvalue"
                },
                "runExpression:expression"
            ], function() {
                return new SurveyTriggerRunExpression();
            }, "surveytrigger");
        /***/ },
        /***/ "./src/utils/animation.ts": /*!********************************!*\
  !*** ./src/utils/animation.ts ***!
  \********************************/ /*! exports provided: AnimationUtils, AnimationPropertyUtils, AnimationGroupUtils, AnimationBoolean, AnimationGroup */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationUtils", function() {
                return AnimationUtils;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationPropertyUtils", function() {
                return AnimationPropertyUtils;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationGroupUtils", function() {
                return AnimationGroupUtils;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationBoolean", function() {
                return AnimationBoolean;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationGroup", function() {
                return AnimationGroup;
            });
            /* harmony import */ var _taskmanager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./taskmanager */ "./src/utils/taskmanager.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var AnimationUtils = /** @class */ function() {
                function AnimationUtils() {
                    this.cancelQueue = [];
                }
                AnimationUtils.prototype.getMsFromRule = function(value) {
                    if (value === "auto") return 0;
                    return Number(value.slice(0, -1).replace(",", ".")) * 1000;
                };
                AnimationUtils.prototype.getAnimationsCount = function(element) {
                    var animationName = "";
                    if (getComputedStyle) animationName = getComputedStyle(element).animationName;
                    return animationName && animationName != "none" ? animationName.split(", ").length : 0;
                };
                AnimationUtils.prototype.getAnimationDuration = function(element) {
                    var style = getComputedStyle(element);
                    var delays = style["animationDelay"].split(", ");
                    var durations = style["animationDuration"].split(", ");
                    var duration = 0;
                    for(var i = 0; i < Math.max(durations.length, delays.length); i++)duration = Math.max(duration, this.getMsFromRule(durations[i % durations.length]) + this.getMsFromRule(delays[i % delays.length]));
                    return duration;
                };
                AnimationUtils.prototype.onAnimationEnd = function(element, callback, options) {
                    var _this = this;
                    var cancelTimeout;
                    var animationsCount = this.getAnimationsCount(element);
                    var onEndCallback = function(isCancel) {
                        if (isCancel === void 0) isCancel = true;
                        options.onAfterRunAnimation && options.onAfterRunAnimation(element);
                        callback(isCancel);
                        clearTimeout(cancelTimeout);
                        _this.cancelQueue.splice(_this.cancelQueue.indexOf(onEndCallback), 1);
                        element.removeEventListener("animationend", onAnimationEndCallback);
                    };
                    var onAnimationEndCallback = function(event1) {
                        if (event1.target == event1.currentTarget && --animationsCount <= 0) onEndCallback(false);
                    };
                    if (animationsCount > 0) {
                        element.addEventListener("animationend", onAnimationEndCallback);
                        this.cancelQueue.push(onEndCallback);
                        cancelTimeout = setTimeout(function() {
                            onEndCallback(false);
                        }, this.getAnimationDuration(element) + 10);
                    } else callback(true);
                };
                AnimationUtils.prototype.beforeAnimationRun = function(element, options) {
                    if (element) options.onBeforeRunAnimation && options.onBeforeRunAnimation(element);
                };
                AnimationUtils.prototype.runLeaveAnimation = function(element, options, callback) {
                    if (element && options.cssClass) {
                        element.classList.add(options.cssClass);
                        var onAnimationEndCallback = function(isCancel) {
                            callback();
                            if (isCancel) element.classList.remove(options.cssClass);
                            else requestAnimationFrame(function() {
                                requestAnimationFrame(function() {
                                    element.classList.remove(options.cssClass);
                                });
                            });
                        };
                        this.onAnimationEnd(element, onAnimationEndCallback, options);
                    } else callback();
                };
                AnimationUtils.prototype.runEnterAnimation = function(element, options) {
                    if (element && options.cssClass) {
                        element.classList.add(options.cssClass);
                        this.onAnimationEnd(element, function() {
                            element.classList.remove(options.cssClass);
                        }, options);
                    }
                };
                AnimationUtils.prototype.cancel = function() {
                    this.cancelQueue.forEach(function(func) {
                        return func();
                    });
                    this.cancelQueue = [];
                };
                return AnimationUtils;
            }();
            var AnimationPropertyUtils = /** @class */ function(_super) {
                __extends(AnimationPropertyUtils, _super);
                function AnimationPropertyUtils() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                AnimationPropertyUtils.prototype.onEnter = function(getElement, options) {
                    var _this = this;
                    var callback = function() {
                        var element = getElement();
                        _this.beforeAnimationRun(element, options);
                        _this.runEnterAnimation(element, options);
                    };
                    requestAnimationFrame(function() {
                        if (getElement()) callback();
                        else requestAnimationFrame(callback);
                    });
                };
                AnimationPropertyUtils.prototype.onLeave = function(getElement, callback, options) {
                    var element = getElement();
                    this.beforeAnimationRun(element, options);
                    this.runLeaveAnimation(element, options, callback);
                };
                return AnimationPropertyUtils;
            }(AnimationUtils);
            var AnimationGroupUtils = /** @class */ function(_super) {
                __extends(AnimationGroupUtils, _super);
                function AnimationGroupUtils() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                AnimationGroupUtils.prototype.onEnter = function(getElement, getOptions, elements) {
                    var _this = this;
                    if (elements.length == 0) return;
                    requestAnimationFrame(function() {
                        var callback = function() {
                            elements.forEach(function(el) {
                                _this.beforeAnimationRun(getElement(el), getOptions(el));
                            });
                            elements.forEach(function(el) {
                                _this.runEnterAnimation(getElement(el), getOptions(el));
                            });
                        };
                        if (!getElement(elements[0])) requestAnimationFrame(callback);
                        else callback();
                    });
                };
                AnimationGroupUtils.prototype.onLeave = function(getElement, callback, getOptions, elements) {
                    var _this = this;
                    elements.forEach(function(el) {
                        _this.beforeAnimationRun(getElement(el), getOptions(el));
                    });
                    var counter = elements.length;
                    var onEndCallback = function() {
                        if (--counter <= 0) callback();
                    };
                    elements.forEach(function(el) {
                        _this.runLeaveAnimation(getElement(el), getOptions(el), onEndCallback);
                    });
                };
                return AnimationGroupUtils;
            }(AnimationUtils);
            var AnimationProperty = /** @class */ function() {
                function AnimationProperty(animationOptions, update, getCurrentValue) {
                    var _this = this;
                    this.animationOptions = animationOptions;
                    this.update = update;
                    this.getCurrentValue = getCurrentValue;
                    this._debouncedSync = Object(_taskmanager__WEBPACK_IMPORTED_MODULE_0__["debounce"])(function(newValue) {
                        _this.animation.cancel();
                        _this._sync(newValue);
                    });
                }
                AnimationProperty.prototype.sync = function(newValue) {
                    if (this.animationOptions.isAnimationEnabled()) this._debouncedSync.run(newValue);
                    else this.update(newValue);
                };
                AnimationProperty.prototype.cancel = function() {
                    this.animation.cancel();
                    this._debouncedSync.cancel();
                };
                return AnimationProperty;
            }();
            var AnimationBoolean = /** @class */ function(_super) {
                __extends(AnimationBoolean, _super);
                function AnimationBoolean() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.animation = new AnimationPropertyUtils();
                    return _this;
                }
                AnimationBoolean.prototype._sync = function(newValue) {
                    var _this = this;
                    if (newValue !== this.getCurrentValue()) {
                        if (newValue) {
                            this.update(newValue);
                            this.animation.onEnter(function() {
                                return _this.animationOptions.getAnimatedElement();
                            }, this.animationOptions.getEnterOptions());
                        } else this.animation.onLeave(function() {
                            return _this.animationOptions.getAnimatedElement();
                        }, function() {
                            _this.update(newValue);
                        }, this.animationOptions.getLeaveOptions());
                    } else this.update(newValue);
                };
                return AnimationBoolean;
            }(AnimationProperty);
            var AnimationGroup = /** @class */ function(_super) {
                __extends(AnimationGroup, _super);
                function AnimationGroup() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.animation = new AnimationGroupUtils();
                    return _this;
                }
                AnimationGroup.prototype._sync = function(newValue) {
                    var _this = this;
                    var oldValue = this.getCurrentValue();
                    var itemsToAdd = newValue.filter(function(el) {
                        return oldValue.indexOf(el) < 0;
                    });
                    var deletedItems = oldValue.filter(function(el) {
                        return newValue.indexOf(el) < 0;
                    });
                    this.animation.onEnter(function(el) {
                        return _this.animationOptions.getAnimatedElement(el);
                    }, function(el) {
                        return _this.animationOptions.getEnterOptions(el);
                    }, itemsToAdd);
                    if (itemsToAdd.length == 0 && (deletedItems === null || deletedItems === void 0 ? void 0 : deletedItems.length) > 0) this.animation.onLeave(function(el) {
                        return _this.animationOptions.getAnimatedElement(el);
                    }, function() {
                        _this.update(newValue);
                    }, function(el) {
                        return _this.animationOptions.getLeaveOptions(el);
                    }, deletedItems);
                    else this.update(newValue);
                };
                return AnimationGroup;
            }(AnimationProperty);
        /***/ },
        /***/ "./src/utils/camera.ts": /*!*****************************!*\
  !*** ./src/utils/camera.ts ***!
  \*****************************/ /*! exports provided: Camera */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Camera", function() {
                return Camera;
            });
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../settings */ "./src/settings.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            var Camera = /** @class */ function() {
                function Camera() {
                    this.canFlipValue = undefined;
                }
                Camera.clear = function() {
                    Camera.cameraList = undefined;
                    Camera.cameraIndex = -1;
                };
                Camera.setCameraList = function(list) {
                    var getDeviceType = function(device) {
                        var lbl = device.label.toLocaleLowerCase();
                        if (lbl.indexOf("user") > -1) return "user";
                        if (lbl.indexOf("enviroment") > -1) return "enviroment";
                        return "";
                    };
                    Camera.clear();
                    if (Array.isArray(list) && list.length > 0) {
                        Camera.cameraIndex = -1;
                        list.sort(function(a, b) {
                            if (a === b) return 0;
                            if (a.label !== b.label) {
                                var lblA = getDeviceType(a);
                                var lblB = getDeviceType(b);
                                if (lblA !== lblB) {
                                    if (lblA === "user") return -1;
                                    if (lblB === "user") return 1;
                                    if (lblA === "enviroment") return -1;
                                    if (lblB === "enviroment") return 1;
                                }
                            }
                            var iA = list.indexOf(a);
                            var iB = list.indexOf(b);
                            return iA < iB ? -1 : 1;
                        });
                    }
                    Camera.cameraList = list;
                };
                Camera.prototype.hasCamera = function(callback) {
                    var _this = this;
                    if (Camera.cameraList !== undefined) {
                        this.hasCameraCallback(callback);
                        return;
                    }
                    if (Camera.mediaDevicesCallback) {
                        var devicesCallback = function(devices) {
                            _this.setVideoInputs(devices);
                            _this.hasCameraCallback(callback);
                        };
                        Camera.mediaDevicesCallback(devicesCallback);
                        return;
                    }
                    if (typeof navigator !== "undefined" && navigator.mediaDevices) navigator.mediaDevices.enumerateDevices().then(function(devices) {
                        _this.setVideoInputs(devices);
                        _this.hasCameraCallback(callback);
                        _this.updateCanFlipValue();
                    }).catch(function(error) {
                        Camera.cameraList = null;
                        _this.hasCameraCallback(callback);
                    });
                    else {
                        Camera.cameraList = null;
                        this.hasCameraCallback(callback);
                    }
                };
                Camera.prototype.getMediaConstraints = function(videoSize) {
                    var devices = Camera.cameraList;
                    if (!Array.isArray(devices) || devices.length < 1) return undefined;
                    if (Camera.cameraIndex < 0) Camera.cameraIndex = 0;
                    var selDevice = devices[Camera.cameraIndex];
                    var videoConstraints = {};
                    if (selDevice && selDevice.deviceId) videoConstraints.deviceId = {
                        exact: selDevice.deviceId
                    };
                    else videoConstraints.facingMode = Camera.cameraFacingMode;
                    if (videoSize) {
                        if (videoSize === null || videoSize === void 0 ? void 0 : videoSize.height) videoConstraints.height = {
                            ideal: videoSize.height
                        };
                        if (videoSize === null || videoSize === void 0 ? void 0 : videoSize.width) videoConstraints.width = {
                            ideal: videoSize.width
                        };
                    }
                    return {
                        video: videoConstraints,
                        audio: false
                    };
                };
                Camera.prototype.startVideo = function(videoElementId, callback, imageWidth, imageHeight) {
                    var _this = this;
                    var _a;
                    var videoEl = (_a = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].environment.root) === null || _a === void 0 ? void 0 : _a.getElementById(videoElementId);
                    if (!videoEl) {
                        callback(undefined);
                        return;
                    }
                    videoEl.style.width = "100%";
                    videoEl.style.height = "auto";
                    videoEl.style.height = "100%";
                    videoEl.style.objectFit = "contain";
                    var mediaConstraints = this.getMediaConstraints({
                        width: imageWidth,
                        height: imageHeight
                    });
                    navigator.mediaDevices.getUserMedia(mediaConstraints).then(function(stream) {
                        var _a;
                        videoEl.srcObject = stream;
                        if (!((_a = Camera.cameraList[Camera.cameraIndex]) === null || _a === void 0 ? void 0 : _a.deviceId) && !!stream.getTracks()[0].getCapabilities().facingMode) {
                            Camera.canSwitchFacingMode = true;
                            _this.updateCanFlipValue();
                        }
                        videoEl.play();
                        callback(stream);
                    }).catch(function(error) {
                        callback(undefined);
                    });
                };
                Camera.prototype.getImageSize = function(videoEl) {
                    return {
                        width: videoEl.videoWidth,
                        height: videoEl.videoHeight
                    };
                };
                Camera.prototype.snap = function(videoElementId, callback) {
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_1__["DomDocumentHelper"].isAvailable()) return false;
                    var root = _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__["DomDocumentHelper"].getDocument();
                    var videoEl = root === null || root === void 0 ? void 0 : root.getElementById(videoElementId);
                    if (!videoEl) return false;
                    var canvasEl = root.createElement("canvas");
                    var imageSize = this.getImageSize(videoEl);
                    canvasEl.height = imageSize.height;
                    canvasEl.width = imageSize.width;
                    var context = canvasEl.getContext("2d");
                    /*
        if(this._facingMode == 'user'){
          context.translate(canvasEl.width, 0);
          context.scale(-1, 1);
        }
        */ context.clearRect(0, 0, canvasEl.width, canvasEl.height);
                    context.drawImage(videoEl, 0, 0, canvasEl.width, canvasEl.height);
                    canvasEl.toBlob(callback, "image/png");
                    return true;
                };
                Camera.prototype.updateCanFlipValue = function() {
                    var list = Camera.cameraList;
                    this.canFlipValue = Array.isArray(list) && list.length > 1 || Camera.canSwitchFacingMode;
                    if (this.onCanFlipChangedCallback) this.onCanFlipChangedCallback(this.canFlipValue);
                };
                Camera.prototype.canFlip = function(onCanFlipChangedCallback) {
                    if (this.canFlipValue === undefined) this.updateCanFlipValue();
                    if (onCanFlipChangedCallback) this.onCanFlipChangedCallback = onCanFlipChangedCallback;
                    return this.canFlipValue;
                };
                Camera.prototype.flip = function() {
                    if (!this.canFlip()) return;
                    if (Camera.canSwitchFacingMode) Camera.cameraFacingMode = Camera.cameraFacingMode === "user" ? "environment" : "user";
                    else if (Camera.cameraIndex >= Camera.cameraList.length - 1) Camera.cameraIndex = 0;
                    else Camera.cameraIndex++;
                };
                Camera.prototype.hasCameraCallback = function(callback) {
                    callback(Array.isArray(Camera.cameraList));
                };
                Camera.prototype.setVideoInputs = function(devices) {
                    var list = [];
                    devices.forEach(function(device) {
                        if (device.kind === "videoinput") list.push(device);
                    });
                    Camera.setCameraList(list.length > 0 ? list : null);
                };
                Camera.cameraIndex = -1;
                Camera.cameraFacingMode = "user";
                Camera.canSwitchFacingMode = false;
                return Camera;
            }();
        /***/ },
        /***/ "./src/utils/cssClassBuilder.ts": /*!**************************************!*\
  !*** ./src/utils/cssClassBuilder.ts ***!
  \**************************************/ /*! exports provided: CssClassBuilder */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CssClassBuilder", function() {
                return CssClassBuilder;
            });
            var CssClassBuilder = /** @class */ function() {
                function CssClassBuilder() {
                    this.classes = [];
                }
                CssClassBuilder.prototype.isEmpty = function() {
                    return this.toString() === "";
                };
                CssClassBuilder.prototype.append = function(value, condition) {
                    if (condition === void 0) condition = true;
                    if (!!value && condition) {
                        if (typeof value === "string") value = value.trim();
                        this.classes.push(value);
                    }
                    return this;
                };
                CssClassBuilder.prototype.toString = function() {
                    return this.classes.join(" ");
                };
                return CssClassBuilder;
            }();
        /***/ },
        /***/ "./src/utils/devices.ts": /*!******************************!*\
  !*** ./src/utils/devices.ts ***!
  \******************************/ /*! exports provided: IsMobile, mouseInfo, IsTouch, _setIsTouch */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsMobile", function() {
                return IsMobile;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mouseInfo", function() {
                return mouseInfo;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "IsTouch", function() {
                return IsTouch;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "_setIsTouch", function() {
                return _setIsTouch;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            // isMobile
            var _isMobile = false;
            var vendor = null;
            if (typeof navigator !== "undefined" && !!navigator && _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomWindowHelper"].isAvailable()) vendor = navigator.userAgent || navigator.vendor || _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomWindowHelper"].hasOwn("opera");
            (function(a) {
                if (!a) return;
                if (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 0 || navigator.platform === "iPad") _isMobile = true;
                else if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substring(0, 4))) _isMobile = true;
            })(vendor);
            var _IPad = false;
            var IsMobile = _isMobile || _IPad;
            var mouseInfo = {
                get isTouch () {
                    return !this.hasMouse && this.hasTouchEvent;
                },
                get hasTouchEvent () {
                    return _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomWindowHelper"].isAvailable() && (_global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomWindowHelper"].hasOwn("ontouchstart") || navigator.maxTouchPoints > 0);
                },
                hasMouse: true
            };
            var pointerMatches = typeof matchMedia !== "undefined" && !!matchMedia && matchMedia("(pointer:fine)") || undefined;
            mouseInfo.hasMouse = !!pointerMatches && !!pointerMatches.matches;
            var IsTouch = mouseInfo.isTouch;
            //for tests
            function _setIsTouch(val1) {
                IsTouch = val1;
            }
        /***/ },
        /***/ "./src/utils/dragOrClickHelper.ts": /*!****************************************!*\
  !*** ./src/utils/dragOrClickHelper.ts ***!
  \****************************************/ /*! exports provided: DragOrClickHelper */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragOrClickHelper", function() {
                return DragOrClickHelper;
            });
            /* harmony import */ var _devices__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./devices */ "./src/utils/devices.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            var DragOrClickHelper = /** @class */ function() {
                function DragOrClickHelper(dragHandler) {
                    var _this = this;
                    this.dragHandler = dragHandler;
                    this.onPointerUp = function(pointerUpEvent) {
                        _this.clearListeners();
                    };
                    this.tryToStartDrag = function(pointerMoveEvent) {
                        _this.currentX = pointerMoveEvent.pageX;
                        _this.currentY = pointerMoveEvent.pageY;
                        if (_this.isMicroMovement) return;
                        _this.clearListeners();
                        _this.dragHandler(_this.pointerDownEvent, _this.currentTarget, _this.itemModel);
                        return true;
                    };
                }
                DragOrClickHelper.prototype.onPointerDown = function(pointerDownEvent, itemModel) {
                    if (_devices__WEBPACK_IMPORTED_MODULE_0__["IsTouch"]) {
                        this.dragHandler(pointerDownEvent, pointerDownEvent.currentTarget, itemModel); //TODO handle inside in the library's drag drop core, need refactoring
                        return;
                    }
                    this.pointerDownEvent = pointerDownEvent;
                    this.currentTarget = pointerDownEvent.currentTarget;
                    this.startX = pointerDownEvent.pageX;
                    this.startY = pointerDownEvent.pageY;
                    _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__["DomDocumentHelper"].addEventListener("pointermove", this.tryToStartDrag);
                    this.currentTarget.addEventListener("pointerup", this.onPointerUp);
                    this.itemModel = itemModel;
                };
                Object.defineProperty(DragOrClickHelper.prototype, "isMicroMovement", {
                    // see https://stackoverflow.com/questions/6042202/how-to-distinguish-mouse-click-and-drag
                    get: function() {
                        var delta = 10;
                        var diffX = Math.abs(this.currentX - this.startX);
                        var diffY = Math.abs(this.currentY - this.startY);
                        return diffX < delta && diffY < delta;
                    },
                    enumerable: false,
                    configurable: true
                });
                DragOrClickHelper.prototype.clearListeners = function() {
                    if (!this.pointerDownEvent) return;
                    _global_variables_utils__WEBPACK_IMPORTED_MODULE_1__["DomDocumentHelper"].removeEventListener("pointermove", this.tryToStartDrag);
                    this.currentTarget.removeEventListener("pointerup", this.onPointerUp);
                };
                return DragOrClickHelper;
            }();
        /***/ },
        /***/ "./src/utils/popup.ts": /*!****************************!*\
  !*** ./src/utils/popup.ts ***!
  \****************************/ /*! exports provided: PopupUtils */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupUtils", function() {
                return PopupUtils;
            });
            var PopupUtils = /** @class */ function() {
                function PopupUtils() {}
                PopupUtils.calculatePosition = function(targetRect, height, width, verticalPosition, horizontalPosition, showPointer, positionMode) {
                    if (positionMode === void 0) positionMode = "flex";
                    var currentLeft = targetRect.left;
                    var currentTop = targetRect.top;
                    if (positionMode === "flex") {
                        if (horizontalPosition == "center") currentLeft = (targetRect.left + targetRect.right - width) / 2;
                        else if (horizontalPosition == "left") currentLeft = targetRect.left - width;
                        else currentLeft = targetRect.right;
                    }
                    if (verticalPosition == "middle") currentTop = (targetRect.top + targetRect.bottom - height) / 2;
                    else if (verticalPosition == "top") currentTop = targetRect.top - height;
                    else currentTop = targetRect.bottom;
                    if (showPointer) {
                        if (horizontalPosition != "center" && verticalPosition != "middle") {
                            if (verticalPosition == "top") currentTop = currentTop + targetRect.height;
                            else currentTop = currentTop - targetRect.height;
                        }
                    }
                    return {
                        left: Math.round(currentLeft),
                        top: Math.round(currentTop)
                    };
                };
                PopupUtils.getCorrectedVerticalDimensions = function(top, height, windowHeight, verticalPosition) {
                    var result;
                    if (verticalPosition === "top") result = {
                        height: height,
                        top: top
                    };
                    if (top < 0) result = {
                        height: height + top,
                        top: 0
                    };
                    else if (height + top > windowHeight) {
                        var newHeight = Math.min(height, windowHeight - top - PopupUtils.bottomIndent);
                        result = {
                            height: newHeight,
                            top: top
                        };
                    }
                    return result;
                };
                PopupUtils.updateHorizontalDimensions = function(left, width, windowWidth, horizontalPosition, positionMode, margins) {
                    if (positionMode === void 0) positionMode = "flex";
                    if (margins === void 0) margins = {
                        left: 0,
                        right: 0
                    };
                    width += margins.left + margins.right;
                    var newWidth = undefined, newLeft = left;
                    if (horizontalPosition === "center") {
                        if (positionMode === "fixed") {
                            if (left + width > windowWidth) newWidth = windowWidth - left;
                            newLeft -= margins.left;
                        } else {
                            if (left < 0) {
                                newLeft = margins.left;
                                newWidth = Math.min(width, windowWidth);
                            } else if (width + left > windowWidth) {
                                newLeft = windowWidth - width;
                                newLeft = Math.max(newLeft, margins.left);
                                newWidth = Math.min(width, windowWidth);
                            }
                        }
                    }
                    if (horizontalPosition === "left") {
                        if (left < 0) {
                            newLeft = margins.left;
                            newWidth = Math.min(width, windowWidth);
                        }
                    }
                    if (horizontalPosition === "right") {
                        if (width + left > windowWidth) newWidth = windowWidth - left;
                    }
                    return {
                        width: newWidth - margins.left - margins.right,
                        left: newLeft
                    };
                };
                PopupUtils.updateVerticalPosition = function(targetRect, height, verticalPosition, showPointer, windowHeight) {
                    var deltaTop = height - (targetRect.top + (showPointer ? targetRect.height : 0));
                    var deltaBottom = height + targetRect.bottom - (showPointer ? targetRect.height : 0) - windowHeight;
                    if (deltaTop > 0 && deltaBottom <= 0 && verticalPosition == "top") verticalPosition = "bottom";
                    else if (deltaBottom > 0 && deltaTop <= 0 && verticalPosition == "bottom") verticalPosition = "top";
                    else if (deltaBottom > 0 && deltaTop > 0) verticalPosition = deltaTop < deltaBottom ? "top" : "bottom";
                    return verticalPosition;
                };
                PopupUtils.calculatePopupDirection = function(verticalPosition, horizontalPosition) {
                    var popupDirection;
                    if (horizontalPosition == "center" && verticalPosition != "middle") popupDirection = verticalPosition;
                    else if (horizontalPosition != "center") popupDirection = horizontalPosition;
                    return popupDirection;
                };
                //called when showPointer  is true
                PopupUtils.calculatePointerTarget = function(targetRect, top, left, verticalPosition, horizontalPosition, marginLeft, marginRight) {
                    if (marginLeft === void 0) marginLeft = 0;
                    if (marginRight === void 0) marginRight = 0;
                    var targetPos = {};
                    if (horizontalPosition != "center") {
                        targetPos.top = targetRect.top + targetRect.height / 2;
                        targetPos.left = targetRect[horizontalPosition];
                    } else if (verticalPosition != "middle") {
                        targetPos.top = targetRect[verticalPosition];
                        targetPos.left = targetRect.left + targetRect.width / 2;
                    }
                    targetPos.left = Math.round(targetPos.left - left);
                    targetPos.top = Math.round(targetPos.top - top);
                    if (horizontalPosition == "left") targetPos.left -= marginLeft + marginRight;
                    if (horizontalPosition === "center") targetPos.left -= marginLeft;
                    return targetPos;
                };
                PopupUtils.bottomIndent = 16;
                return PopupUtils;
            }();
        /***/ },
        /***/ "./src/utils/responsivity-manager.ts": /*!*******************************************!*\
  !*** ./src/utils/responsivity-manager.ts ***!
  \*******************************************/ /*! exports provided: ResponsivityManager, VerticalResponsivityManager */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponsivityManager", function() {
                return ResponsivityManager;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalResponsivityManager", function() {
                return VerticalResponsivityManager;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ResponsivityManager = /** @class */ function() {
                function ResponsivityManager(container, model, itemsSelector, dotsItemSize, delayedUpdateFunction) {
                    var _this = this;
                    if (dotsItemSize === void 0) dotsItemSize = null;
                    this.container = container;
                    this.model = model;
                    this.itemsSelector = itemsSelector;
                    this.dotsItemSize = dotsItemSize;
                    this.delayedUpdateFunction = delayedUpdateFunction;
                    this.resizeObserver = undefined;
                    this.isInitialized = false;
                    this.minDimensionConst = 56;
                    this.separatorSize = 17;
                    this.separatorAddConst = 1;
                    this.paddingSizeConst = 8;
                    this.dotsSizeConst = 48;
                    this.recalcMinDimensionConst = true;
                    this.getComputedStyle = function(elt) {
                        return _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getComputedStyle(elt);
                    };
                    this.model.updateCallback = function(isResetInitialized) {
                        if (isResetInitialized) _this.isInitialized = false;
                        setTimeout(function() {
                            _this.process();
                        }, 1);
                    };
                    if (typeof ResizeObserver !== "undefined") {
                        this.resizeObserver = new ResizeObserver(function(entries) {
                            _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomWindowHelper"].requestAnimationFrame(function() {
                                _this.process();
                            });
                        });
                        this.resizeObserver.observe(this.container.parentElement);
                    }
                }
                ResponsivityManager.prototype.getDimensions = function(element) {
                    return {
                        scroll: element.scrollWidth,
                        offset: element.offsetWidth
                    };
                };
                ResponsivityManager.prototype.getAvailableSpace = function() {
                    var style = this.getComputedStyle(this.container);
                    var space = this.container.offsetWidth;
                    if (style.boxSizing === "border-box") space -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
                    return space;
                };
                ResponsivityManager.prototype.calcItemSize = function(item) {
                    return item.offsetWidth;
                };
                ResponsivityManager.prototype.calcMinDimension = function(currentAction) {
                    var minDimensionConst = this.minDimensionConst;
                    if (currentAction.iconSize && this.recalcMinDimensionConst) minDimensionConst = 2 * currentAction.iconSize + this.paddingSizeConst;
                    return currentAction.canShrink ? minDimensionConst + (currentAction.needSeparator ? this.separatorSize : 0) : currentAction.maxDimension;
                };
                ResponsivityManager.prototype.getRenderedVisibleActionsCount = function() {
                    var _this = this;
                    var count = 0;
                    this.container.querySelectorAll(this.itemsSelector).forEach(function(item) {
                        if (_this.calcItemSize(item) > 0) count++;
                    });
                    return count;
                };
                ResponsivityManager.prototype.calcItemsSizes = function() {
                    var _this = this;
                    var actions = this.model.actions;
                    var _items = this.container.querySelectorAll(this.itemsSelector);
                    (_items || []).forEach(function(item, index) {
                        var currentAction = actions[index];
                        _this.calcActionDimensions(currentAction, item);
                    });
                };
                ResponsivityManager.prototype.calcActionDimensions = function(currentAction, item) {
                    currentAction.maxDimension = this.calcItemSize(item);
                    currentAction.minDimension = this.calcMinDimension(currentAction);
                };
                Object.defineProperty(ResponsivityManager.prototype, "isContainerVisible", {
                    get: function() {
                        return Object(_utils__WEBPACK_IMPORTED_MODULE_1__["isContainerVisible"])(this.container);
                    },
                    enumerable: false,
                    configurable: true
                });
                ResponsivityManager.prototype.process = function() {
                    var _this = this;
                    if (this.isContainerVisible && !this.model.isResponsivenessDisabled) {
                        if (!this.isInitialized) this.model.setActionsMode("large");
                        var processResponsiveness_1 = function() {
                            var _a;
                            var dotsItemSize = _this.dotsItemSize;
                            if (!_this.dotsItemSize) {
                                var dotsItemElement = (_a = _this.container) === null || _a === void 0 ? void 0 : _a.querySelector(".sv-dots");
                                dotsItemSize = dotsItemElement && _this.calcItemSize(dotsItemElement) || _this.dotsSizeConst;
                            }
                            _this.model.fit(_this.getAvailableSpace(), dotsItemSize);
                        };
                        if (!this.isInitialized) {
                            var callback = function() {
                                _this.calcItemsSizes();
                                _this.isInitialized = true;
                                processResponsiveness_1();
                            };
                            if (this.getRenderedVisibleActionsCount() < this.model.visibleActions.length) {
                                if (this.delayedUpdateFunction) this.delayedUpdateFunction(callback);
                                else if (queueMicrotask) queueMicrotask(callback);
                                else callback();
                            } else callback();
                        } else processResponsiveness_1();
                    }
                };
                ResponsivityManager.prototype.dispose = function() {
                    this.model.updateCallback = undefined;
                    if (!!this.resizeObserver) this.resizeObserver.disconnect();
                };
                return ResponsivityManager;
            }();
            var VerticalResponsivityManager = /** @class */ function(_super) {
                __extends(VerticalResponsivityManager, _super);
                function VerticalResponsivityManager(container, model, itemsSelector, dotsItemSize, minDimension, delayedUpdateFunction) {
                    if (minDimension === void 0) minDimension = 40;
                    var _this = _super.call(this, container, model, itemsSelector, dotsItemSize, delayedUpdateFunction) || this;
                    _this.minDimensionConst = minDimension;
                    _this.recalcMinDimensionConst = false;
                    return _this;
                }
                VerticalResponsivityManager.prototype.getDimensions = function() {
                    return {
                        scroll: this.container.scrollHeight,
                        offset: this.container.offsetHeight
                    };
                };
                VerticalResponsivityManager.prototype.getAvailableSpace = function() {
                    var style = this.getComputedStyle(this.container);
                    var space = this.container.offsetHeight;
                    if (style.boxSizing === "border-box") space -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
                    return space;
                };
                VerticalResponsivityManager.prototype.calcItemSize = function(item) {
                    return item.offsetHeight;
                };
                VerticalResponsivityManager.prototype.calcActionDimensions = function(currentAction, item) {
                    currentAction.maxDimension = this.calcItemSize(item);
                    currentAction.minDimension = this.calcItemSize(item);
                };
                return VerticalResponsivityManager;
            }(ResponsivityManager);
        /***/ },
        /***/ "./src/utils/taskmanager.ts": /*!**********************************!*\
  !*** ./src/utils/taskmanager.ts ***!
  \**********************************/ /*! exports provided: Task, TaskManger, debounce */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Task", function() {
                return Task;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TaskManger", function() {
                return TaskManger;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() {
                return debounce;
            });
            var Task = /** @class */ function() {
                function Task(func, isMultiple) {
                    var _this = this;
                    if (isMultiple === void 0) isMultiple = false;
                    this.func = func;
                    this.isMultiple = isMultiple;
                    this._isCompleted = false;
                    this.execute = function() {
                        if (!_this._isCompleted) {
                            _this.func();
                            _this._isCompleted = !_this.isMultiple;
                        }
                    };
                }
                Task.prototype.discard = function() {
                    this._isCompleted = true;
                };
                Object.defineProperty(Task.prototype, "isCompleted", {
                    get: function() {
                        return this._isCompleted;
                    },
                    enumerable: false,
                    configurable: true
                });
                return Task;
            }();
            var TaskManger = /** @class */ function() {
                function TaskManger(interval) {
                    if (interval === void 0) interval = 100;
                    this.interval = interval;
                    setTimeout(TaskManger.Instance().tick, interval);
                }
                // dispose
                TaskManger.Instance = function() {
                    if (!TaskManger.instance) TaskManger.instance = new TaskManger();
                    return TaskManger.instance;
                };
                TaskManger.prototype.tick = function() {
                    try {
                        var newTasks = [];
                        for(var i = 0; i < TaskManger.tasks.length; i++){
                            var task = TaskManger.tasks[i];
                            task.execute();
                            if (!task.isCompleted) newTasks.push(task);
                            else if (typeof task.dispose === "function") task.dispose();
                        }
                        TaskManger.tasks = newTasks;
                    } finally{
                        setTimeout(TaskManger.Instance().tick, this.interval);
                    }
                };
                TaskManger.schedule = function(task) {
                    TaskManger.tasks.push(task);
                };
                TaskManger.instance = undefined;
                TaskManger.tasks = [];
                return TaskManger;
            }();
            function debounce(func) {
                var _this = this;
                var isSheduled = false;
                var isCanceled = false;
                var funcArgs;
                return {
                    run: function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        isCanceled = false;
                        funcArgs = args;
                        if (!isSheduled) {
                            isSheduled = true;
                            queueMicrotask(function() {
                                if (!isCanceled) func.apply(_this, funcArgs);
                                isCanceled = false;
                                isSheduled = false;
                            });
                        }
                    },
                    cancel: function() {
                        isCanceled = true;
                    }
                };
            }
        /***/ },
        /***/ "./src/utils/utils.ts": /*!****************************!*\
  !*** ./src/utils/utils.ts ***!
  \****************************/ /*! exports provided: unwrap, getRenderedSize, getRenderedStyleSize, doKey2ClickBlur, doKey2ClickUp, doKey2ClickDown, sanitizeEditableContent, Logger, showConfirmDialog, configConfirmDialog, mergeValues, getElementWidth, isContainerVisible, classesToSelector, compareVersions, confirmAction, confirmActionAsync, detectIEOrEdge, detectIEBrowser, loadFileFromBase64, isMobile, isShadowDOM, getElement, isElementVisible, findScrollableParent, scrollElementByChildId, navigateToUrl, wrapUrlForBackgroundImage, createSvg, getIconNameFromProxy, increaseHeightByContent, getOriginalEvent, preventDefaults, findParentByClassNames, getFirstVisibleChild, chooseFiles */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unwrap", function() {
                return unwrap;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRenderedSize", function() {
                return getRenderedSize;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRenderedStyleSize", function() {
                return getRenderedStyleSize;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickBlur", function() {
                return doKey2ClickBlur;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickUp", function() {
                return doKey2ClickUp;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickDown", function() {
                return doKey2ClickDown;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sanitizeEditableContent", function() {
                return sanitizeEditableContent;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() {
                return Logger;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showConfirmDialog", function() {
                return showConfirmDialog;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configConfirmDialog", function() {
                return configConfirmDialog;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeValues", function() {
                return mergeValues;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementWidth", function() {
                return getElementWidth;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isContainerVisible", function() {
                return isContainerVisible;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classesToSelector", function() {
                return classesToSelector;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareVersions", function() {
                return compareVersions;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmAction", function() {
                return confirmAction;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmActionAsync", function() {
                return confirmActionAsync;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detectIEOrEdge", function() {
                return detectIEOrEdge;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detectIEBrowser", function() {
                return detectIEBrowser;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadFileFromBase64", function() {
                return loadFileFromBase64;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() {
                return isMobile;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isShadowDOM", function() {
                return isShadowDOM;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElement", function() {
                return getElement;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isElementVisible", function() {
                return isElementVisible;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findScrollableParent", function() {
                return findScrollableParent;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollElementByChildId", function() {
                return scrollElementByChildId;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "navigateToUrl", function() {
                return navigateToUrl;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapUrlForBackgroundImage", function() {
                return wrapUrlForBackgroundImage;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSvg", function() {
                return createSvg;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIconNameFromProxy", function() {
                return getIconNameFromProxy;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "increaseHeightByContent", function() {
                return increaseHeightByContent;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOriginalEvent", function() {
                return getOriginalEvent;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preventDefaults", function() {
                return preventDefaults;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findParentByClassNames", function() {
                return findParentByClassNames;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFirstVisibleChild", function() {
                return getFirstVisibleChild;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chooseFiles", function() {
                return chooseFiles;
            });
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../settings */ "./src/settings.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            function compareVersions(a, b) {
                var regExStrip0 = /(\.0+)+$/;
                var segmentsA = a.replace(regExStrip0, "").split(".");
                var segmentsB = b.replace(regExStrip0, "").split(".");
                var len = Math.min(segmentsA.length, segmentsB.length);
                for(var i = 0; i < len; i++){
                    var diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
                    if (diff) return diff;
                }
                return segmentsA.length - segmentsB.length;
            }
            function confirmAction(message) {
                if (!!_settings__WEBPACK_IMPORTED_MODULE_1__["settings"] && !!_settings__WEBPACK_IMPORTED_MODULE_1__["settings"].confirmActionFunc) return _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].confirmActionFunc(message);
                return confirm(message);
            }
            function confirmActionAsync(message, funcOnYes, funcOnNo, locale, rootElement1) {
                var callbackFunc = function(res) {
                    if (res) funcOnYes();
                    else if (!!funcOnNo) funcOnNo();
                };
                if (!!_settings__WEBPACK_IMPORTED_MODULE_1__["settings"] && !!_settings__WEBPACK_IMPORTED_MODULE_1__["settings"].confirmActionAsync) {
                    if (_settings__WEBPACK_IMPORTED_MODULE_1__["settings"].confirmActionAsync(message, callbackFunc, undefined, locale, rootElement1)) return;
                }
                callbackFunc(confirmAction(message));
            }
            function detectIEBrowser() {
                var ua = navigator.userAgent;
                var oldIe = ua.indexOf("MSIE ");
                var elevenIe = ua.indexOf("Trident/");
                return oldIe > -1 || elevenIe > -1;
            }
            function detectIEOrEdge() {
                if (typeof detectIEOrEdge.isIEOrEdge === "undefined") {
                    var ua = navigator.userAgent;
                    var msie = ua.indexOf("MSIE ");
                    var trident = ua.indexOf("Trident/");
                    var edge = ua.indexOf("Edge/");
                    detectIEOrEdge.isIEOrEdge = edge > 0 || trident > 0 || msie > 0;
                }
                return detectIEOrEdge.isIEOrEdge;
            }
            function loadFileFromBase64(b64Data, fileName) {
                try {
                    var byteString = atob(b64Data.split(",")[1]);
                    // separate out the mime component
                    var mimeString = b64Data.split(",")[0].split(":")[1].split(";")[0];
                    // write the bytes of the string to an ArrayBuffer
                    var ab = new ArrayBuffer(byteString.length);
                    var ia = new Uint8Array(ab);
                    for(var i = 0; i < byteString.length; i++)ia[i] = byteString.charCodeAt(i);
                    // write the ArrayBuffer to a blob, and you're done
                    var bb = new Blob([
                        ab
                    ], {
                        type: mimeString
                    });
                    if (!!navigator && navigator["msSaveBlob"]) navigator["msSaveOrOpenBlob"](bb, fileName);
                } catch (err) {}
            }
            function isMobile() {
                return _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].isAvailable() && _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].hasOwn("orientation");
            }
            var isShadowDOM = function(rootElement1) {
                return !!rootElement1 && !!("host" in rootElement1 && rootElement1.host);
            };
            var getElement = function(element) {
                var root = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                return typeof element === "string" ? root.getElementById(element) : element;
            };
            function isElementVisible(element, threshold) {
                if (threshold === void 0) threshold = 0;
                if (typeof _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment === "undefined") return false;
                var root = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                var clientHeight = isShadowDOM(root) ? root.host.clientHeight : root.documentElement.clientHeight;
                var elementRect = element.getBoundingClientRect();
                var viewHeight = Math.max(clientHeight, _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].getInnerHeight());
                var topWin = -threshold;
                var bottomWin = viewHeight + threshold;
                var topEl = elementRect.top;
                var bottomEl = elementRect.bottom;
                var maxTop = Math.max(topWin, topEl);
                var minBottom = Math.min(bottomWin, bottomEl);
                return maxTop <= minBottom;
            }
            function findScrollableParent(element) {
                var root = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                if (!element) return isShadowDOM(root) ? root.host : root.documentElement;
                if (element.scrollHeight > element.clientHeight && (getComputedStyle(element).overflowY === "scroll" || getComputedStyle(element).overflowY === "auto")) return element;
                if (element.scrollWidth > element.clientWidth && (getComputedStyle(element).overflowX === "scroll" || getComputedStyle(element).overflowX === "auto")) return element;
                return findScrollableParent(element.parentElement);
            }
            function scrollElementByChildId(id) {
                var environment = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment;
                if (!environment) return;
                var root = environment.root;
                var el = root.getElementById(id);
                if (!el) return;
                var scrollableEl = findScrollableParent(el);
                if (!!scrollableEl) setTimeout(function() {
                    return scrollableEl.dispatchEvent(new CustomEvent("scroll"));
                }, 10);
            }
            function navigateToUrl(url) {
                var location = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].getLocation();
                if (!url || !location) return;
                location.href = url;
            }
            function wrapUrlForBackgroundImage(url) {
                return !!url ? [
                    "url(",
                    url,
                    ")"
                ].join("") : "";
            }
            function getIconNameFromProxy(iconName) {
                if (!iconName) return iconName;
                var proxyName = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].customIcons[iconName];
                return !!proxyName ? proxyName : iconName;
            }
            function createSvg(size, width, height, iconName, svgElem, title) {
                if (!svgElem) return;
                if (size !== "auto") {
                    svgElem.style.width = (size || width || 16) + "px";
                    svgElem.style.height = (size || height || 16) + "px";
                }
                var node = svgElem.childNodes[0];
                var realIconName = getIconNameFromProxy(iconName);
                node.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#" + realIconName);
                var titleElement = svgElem.getElementsByTagName("title")[0];
                if (!title) {
                    if (!!titleElement) svgElem.removeChild(titleElement);
                    return;
                } else if (!titleElement) {
                    titleElement = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].getDocument().createElementNS("http://www.w3.org/2000/svg", "title");
                    svgElem.appendChild(titleElement);
                }
                titleElement.textContent = title;
            }
            function unwrap(value) {
                if (typeof value !== "function") return value;
                else return value();
            }
            // export function getSize(value: any): number {
            //   if (typeof value === "number") {
            //     return value;
            //   }
            //   if (typeof value === "string" && value.includes("px")) {
            //     return parseInt(value);
            //   }
            //   if (!!value && typeof value === "string" && value.length > 0) {
            //     const lastSymbol: string = value[value.length - 1];
            //     if ((lastSymbol >= "0" && lastSymbol <= "9") || lastSymbol == ".") {
            //       try {
            //         const num: number = parseInt(value);
            //         return num;
            //       } catch { }
            //     }
            //   }
            //   return value;
            // }
            function getRenderedSize(val1) {
                if (typeof val1 == "string") {
                    if (!isNaN(Number(val1))) return Number(val1);
                    else if (val1.includes("px")) return parseFloat(val1);
                }
                if (typeof val1 == "number") return val1;
                return undefined;
            }
            function getRenderedStyleSize(val1) {
                if (getRenderedSize(val1) !== undefined) return undefined;
                return val1;
            }
            var keyFocusedClassName = "sv-focused--by-key";
            function doKey2ClickBlur(evt) {
                var element = evt.target;
                if (!element || !element.classList) return;
                element.classList.remove(keyFocusedClassName);
            }
            function doKey2ClickUp(evt, options) {
                if (!!evt.target && evt.target["contentEditable"] === "true") return;
                var element = evt.target;
                if (!element) return;
                var char = evt.which || evt.keyCode;
                if (char === 9) {
                    if (!!element.classList && !element.classList.contains(keyFocusedClassName)) element.classList.add(keyFocusedClassName);
                    return;
                }
                if (options) {
                    if (!options.__keyDownReceived) return;
                    options.__keyDownReceived = false;
                }
                if (char === 13 || char === 32) {
                    if (element.click) element.click();
                } else if ((!options || options.processEsc) && char === 27) {
                    if (element.blur) element.blur();
                }
            }
            function doKey2ClickDown(evt, options) {
                if (options === void 0) options = {
                    processEsc: true
                };
                if (options) options.__keyDownReceived = true;
                if (!!evt.target && evt.target["contentEditable"] === "true") return;
                var char = evt.which || evt.keyCode;
                var supportedCodes = [
                    13,
                    32
                ];
                if (options.processEsc) supportedCodes.push(27);
                if (supportedCodes.indexOf(char) !== -1) evt.preventDefault();
            }
            function increaseHeightByContent(element, getComputedStyle1) {
                if (!element) return;
                if (!getComputedStyle1) getComputedStyle1 = function(elt) {
                    return _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].getComputedStyle(elt);
                };
                var style = getComputedStyle1(element);
                element.style.height = "auto";
                if (!!element.scrollHeight) element.style.height = element.scrollHeight + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth) + "px";
            }
            function getOriginalEvent(event1) {
                return event1.originalEvent || event1;
            }
            function preventDefaults(event1) {
                event1.preventDefault();
                event1.stopPropagation();
            }
            function classesToSelector(str) {
                var re = /\s*?([\w-]+)\s*?/g;
                return str.replace(re, ".$1");
            }
            function getElementWidth(el) {
                return !!getComputedStyle ? Number.parseFloat(getComputedStyle(el).width) : el.offsetWidth;
            }
            function isContainerVisible(el) {
                return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
            }
            function getFirstVisibleChild(el) {
                var result;
                for(var index = 0; index < el.children.length; index++)if (!result && getComputedStyle(el.children[index]).display !== "none") result = el.children[index];
                return result;
            }
            function findParentByClassNames(element, classNames) {
                if (!!element) {
                    if (classNames.every(function(className) {
                        return !className || element.classList.contains(className);
                    })) return element;
                    else return findParentByClassNames(element.parentElement, classNames);
                }
            }
            function sanitizeEditableContent(element, cleanLineBreaks) {
                if (cleanLineBreaks === void 0) cleanLineBreaks = true;
                if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].isAvailable() && _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].isAvailable() && element.childNodes.length > 0) {
                    var selection = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].getSelection();
                    if (selection.rangeCount == 0) return;
                    var range = selection.getRangeAt(0);
                    range.setStart(range.endContainer, range.endOffset);
                    range.setEndAfter(element.lastChild);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    var tail = selection.toString();
                    var innerText = element.innerText;
                    tail = tail.replace(/\r/g, "");
                    if (cleanLineBreaks) {
                        tail = tail.replace(/\n/g, "");
                        innerText = innerText.replace(/\n/g, "");
                    }
                    var tail_len = tail.length;
                    element.innerText = innerText;
                    range = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].getDocument().createRange();
                    range.setStart(element.firstChild, 0);
                    range.setEnd(element.firstChild, 0);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    while(selection.toString().length < innerText.length - tail_len){
                        var selLen = selection.toString().length;
                        selection.modify("extend", "forward", "character");
                        if (selection.toString().length == selLen) break;
                    }
                    range = selection.getRangeAt(0);
                    range.setStart(range.endContainer, range.endOffset);
                }
            }
            function mergeValues(src, dest) {
                if (!dest || !src) return;
                if (typeof dest !== "object") return;
                for(var key in src){
                    var value = src[key];
                    if (!Array.isArray(value) && value && typeof value === "object") {
                        if (!dest[key] || typeof dest[key] !== "object") dest[key] = {};
                        mergeValues(value, dest[key]);
                    } else dest[key] = value;
                }
            }
            var Logger = /** @class */ function() {
                function Logger() {
                    this._result = "";
                }
                Logger.prototype.log = function(action) {
                    this._result += "->" + action;
                };
                Object.defineProperty(Logger.prototype, "result", {
                    get: function() {
                        return this._result;
                    },
                    enumerable: false,
                    configurable: true
                });
                return Logger;
            }();
            function showConfirmDialog(message, callback, applyTitle, locale, rootElement1) {
                var locStr = new _localizablestring__WEBPACK_IMPORTED_MODULE_0__["LocalizableString"](undefined);
                var popupViewModel = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].showDialog({
                    componentName: "sv-string-viewer",
                    data: {
                        locStr: locStr,
                        locString: locStr,
                        model: locStr
                    },
                    onApply: function() {
                        callback(true);
                        return true;
                    },
                    onCancel: function() {
                        callback(false);
                        return false;
                    },
                    title: message,
                    displayMode: "popup",
                    isFocusedContent: false,
                    cssClass: "sv-popup--confirm-delete"
                }, rootElement1);
                var toolbar = popupViewModel.footerToolbar;
                var applyBtn = toolbar.getActionById("apply");
                var cancelBtn = toolbar.getActionById("cancel");
                cancelBtn.title = _surveyStrings__WEBPACK_IMPORTED_MODULE_2__["surveyLocalization"].getString("cancel", locale);
                cancelBtn.innerCss = "sv-popup__body-footer-item sv-popup__button sd-btn sd-btn--small";
                applyBtn.title = applyTitle || _surveyStrings__WEBPACK_IMPORTED_MODULE_2__["surveyLocalization"].getString("ok", locale);
                applyBtn.innerCss = "sv-popup__body-footer-item sv-popup__button sv-popup__button--danger sd-btn sd-btn--small sd-btn--danger";
                configConfirmDialog(popupViewModel);
                return true;
            }
            function configConfirmDialog(popupViewModel) {
                popupViewModel.width = "min-content";
            }
            function chooseFiles(input, callback) {
                if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].isFileReaderAvailable()) return;
                input.value = "";
                input.onchange = function(event1) {
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].isFileReaderAvailable()) return;
                    if (!input || !input.files || input.files.length < 1) return;
                    var files = [];
                    for(var i = 0; i < input.files.length; i++)files.push(input.files[i]);
                    callback(files);
                };
                input.click();
            }
        /***/ },
        /***/ "./src/validator.ts": /*!**************************!*\
  !*** ./src/validator.ts ***!
  \**************************/ /*! exports provided: ValidatorResult, SurveyValidator, ValidatorRunner, NumericValidator, TextValidator, AnswerCountValidator, RegexValidator, EmailValidator, ExpressionValidator */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidatorResult", function() {
                return ValidatorResult;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyValidator", function() {
                return SurveyValidator;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ValidatorRunner", function() {
                return ValidatorRunner;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NumericValidator", function() {
                return NumericValidator;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TextValidator", function() {
                return TextValidator;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnswerCountValidator", function() {
                return AnswerCountValidator;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RegexValidator", function() {
                return RegexValidator;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EmailValidator", function() {
                return EmailValidator;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionValidator", function() {
                return ExpressionValidator;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _error__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./error */ "./src/error.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ValidatorResult = /** @class */ function() {
                function ValidatorResult(value, error) {
                    if (error === void 0) error = null;
                    this.value = value;
                    this.error = error;
                }
                return ValidatorResult;
            }();
            /**
 * Base SurveyJS validator class.
 */ var SurveyValidator = /** @class */ function(_super) {
                __extends(SurveyValidator, _super);
                function SurveyValidator() {
                    var _this = _super.call(this) || this;
                    _this.createLocalizableString("text", _this, true);
                    return _this;
                }
                SurveyValidator.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    return !!this.errorOwner && !!this.errorOwner["getSurvey"] ? this.errorOwner.getSurvey() : null;
                };
                Object.defineProperty(SurveyValidator.prototype, "text", {
                    get: function() {
                        return this.getLocalizableStringText("text");
                    },
                    set: function(value) {
                        this.setLocalizableStringText("text", value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyValidator.prototype, "isValidateAllValues", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyValidator.prototype, "locText", {
                    get: function() {
                        return this.getLocalizableString("text");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyValidator.prototype.getErrorText = function(name) {
                    if (this.text) return this.text;
                    return this.getDefaultErrorText(name);
                };
                SurveyValidator.prototype.getDefaultErrorText = function(name) {
                    return "";
                };
                SurveyValidator.prototype.validate = function(value, name, values, properties) {
                    if (name === void 0) name = null;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    return null;
                };
                Object.defineProperty(SurveyValidator.prototype, "isRunning", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyValidator.prototype, "isAsync", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyValidator.prototype.getLocale = function() {
                    return !!this.errorOwner ? this.errorOwner.getLocale() : "";
                };
                SurveyValidator.prototype.getMarkdownHtml = function(text, name) {
                    return !!this.errorOwner ? this.errorOwner.getMarkdownHtml(text, name) : undefined;
                };
                SurveyValidator.prototype.getRenderer = function(name) {
                    return !!this.errorOwner ? this.errorOwner.getRenderer(name) : null;
                };
                SurveyValidator.prototype.getRendererContext = function(locStr) {
                    return !!this.errorOwner ? this.errorOwner.getRendererContext(locStr) : locStr;
                };
                SurveyValidator.prototype.getProcessedText = function(text) {
                    return !!this.errorOwner ? this.errorOwner.getProcessedText(text) : text;
                };
                SurveyValidator.prototype.createCustomError = function(name) {
                    var _this = this;
                    var err = new _error__WEBPACK_IMPORTED_MODULE_1__["CustomError"](this.getErrorText(name), this.errorOwner);
                    err.onUpdateErrorTextCallback = function(err) {
                        return err.text = _this.getErrorText(name);
                    };
                    return err;
                };
                SurveyValidator.prototype.toString = function() {
                    var res = this.getType().replace("validator", "");
                    if (!!this.text) res += ", " + this.text;
                    return res;
                };
                return SurveyValidator;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            var ValidatorRunner = /** @class */ function() {
                function ValidatorRunner() {}
                ValidatorRunner.prototype.run = function(owner) {
                    var _this = this;
                    var res = [];
                    var values = null;
                    var properties = null;
                    this.prepareAsyncValidators();
                    var asyncResults = [];
                    var validators = owner.getValidators();
                    for(var i = 0; i < validators.length; i++){
                        var validator = validators[i];
                        if (!values && validator.isValidateAllValues) {
                            values = owner.getDataFilteredValues();
                            properties = owner.getDataFilteredProperties();
                        }
                        if (validator.isAsync) {
                            this.asyncValidators.push(validator);
                            validator.onAsyncCompleted = function(result) {
                                if (!!result && !!result.error) asyncResults.push(result.error);
                                if (!_this.onAsyncCompleted) return;
                                for(var i = 0; i < _this.asyncValidators.length; i++){
                                    if (_this.asyncValidators[i].isRunning) return;
                                }
                                _this.onAsyncCompleted(asyncResults);
                            };
                        }
                    }
                    validators = owner.getValidators();
                    for(var i = 0; i < validators.length; i++){
                        var validator = validators[i];
                        var validatorResult = validator.validate(owner.validatedValue, owner.getValidatorTitle(), values, properties);
                        if (!!validatorResult && !!validatorResult.error) res.push(validatorResult.error);
                    }
                    if (this.asyncValidators.length == 0 && !!this.onAsyncCompleted) this.onAsyncCompleted([]);
                    return res;
                };
                ValidatorRunner.prototype.prepareAsyncValidators = function() {
                    if (!!this.asyncValidators) for(var i = 0; i < this.asyncValidators.length; i++)this.asyncValidators[i].onAsyncCompleted = null;
                    this.asyncValidators = [];
                };
                return ValidatorRunner;
            }();
            /**
 * Validate numeric values.
 */ var NumericValidator = /** @class */ function(_super) {
                __extends(NumericValidator, _super);
                function NumericValidator(minValue, maxValue) {
                    if (minValue === void 0) minValue = null;
                    if (maxValue === void 0) maxValue = null;
                    var _this = _super.call(this) || this;
                    _this.minValue = minValue;
                    _this.maxValue = maxValue;
                    return _this;
                }
                NumericValidator.prototype.getType = function() {
                    return "numericvalidator";
                };
                NumericValidator.prototype.validate = function(value, name, values, properties) {
                    if (name === void 0) name = null;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    if (this.isValueEmpty(value)) return null;
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_4__["Helpers"].isNumber(value)) return new ValidatorResult(null, new _error__WEBPACK_IMPORTED_MODULE_1__["RequreNumericError"](this.text, this.errorOwner));
                    var result = new ValidatorResult(_helpers__WEBPACK_IMPORTED_MODULE_4__["Helpers"].getNumber(value));
                    if (this.minValue !== null && this.minValue > result.value) {
                        result.error = this.createCustomError(name);
                        return result;
                    }
                    if (this.maxValue !== null && this.maxValue < result.value) {
                        result.error = this.createCustomError(name);
                        return result;
                    }
                    return typeof value === "number" ? null : result;
                };
                NumericValidator.prototype.getDefaultErrorText = function(name) {
                    var vName = name ? name : this.getLocalizationString("value");
                    if (this.minValue !== null && this.maxValue !== null) return this.getLocalizationFormatString("numericMinMax", vName, this.minValue, this.maxValue);
                    else {
                        if (this.minValue !== null) return this.getLocalizationFormatString("numericMin", vName, this.minValue);
                        return this.getLocalizationFormatString("numericMax", vName, this.maxValue);
                    }
                };
                Object.defineProperty(NumericValidator.prototype, "minValue", {
                    /**
         * The minValue property.
         */ get: function() {
                        return this.getPropertyValue("minValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("minValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(NumericValidator.prototype, "maxValue", {
                    /**
         * The maxValue property.
         */ get: function() {
                        return this.getPropertyValue("maxValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                return NumericValidator;
            }(SurveyValidator);
            /**
 * Validate text values.
 */ var TextValidator = /** @class */ function(_super) {
                __extends(TextValidator, _super);
                function TextValidator() {
                    return _super.call(this) || this;
                }
                TextValidator.prototype.getType = function() {
                    return "textvalidator";
                };
                TextValidator.prototype.validate = function(value, name, values, properties) {
                    if (name === void 0) name = null;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    if (this.isValueEmpty(value)) return null;
                    if (!this.allowDigits) {
                        var reg = /^[A-Za-z\s\.]*$/;
                        if (!reg.test(value)) return new ValidatorResult(null, this.createCustomError(name));
                    }
                    if (this.minLength > 0 && value.length < this.minLength) return new ValidatorResult(null, this.createCustomError(name));
                    if (this.maxLength > 0 && value.length > this.maxLength) return new ValidatorResult(null, this.createCustomError(name));
                    return null;
                };
                TextValidator.prototype.getDefaultErrorText = function(name) {
                    if (this.minLength > 0 && this.maxLength > 0) return this.getLocalizationFormatString("textMinMaxLength", this.minLength, this.maxLength);
                    if (this.minLength > 0) return this.getLocalizationFormatString("textMinLength", this.minLength);
                    return this.getLocalizationFormatString("textMaxLength", this.maxLength);
                };
                Object.defineProperty(TextValidator.prototype, "minLength", {
                    /**
         * The minLength property.
         */ get: function() {
                        return this.getPropertyValue("minLength");
                    },
                    set: function(val1) {
                        this.setPropertyValue("minLength", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TextValidator.prototype, "maxLength", {
                    /**
         * The maxLength property.
         */ get: function() {
                        return this.getPropertyValue("maxLength");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxLength", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TextValidator.prototype, "allowDigits", {
                    /**
         * The allowDigits property.
         */ get: function() {
                        return this.getPropertyValue("allowDigits");
                    },
                    set: function(val1) {
                        this.setPropertyValue("allowDigits", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                return TextValidator;
            }(SurveyValidator);
            /**
 * Validates the number of answers.
 */ var AnswerCountValidator = /** @class */ function(_super) {
                __extends(AnswerCountValidator, _super);
                function AnswerCountValidator(minCount, maxCount) {
                    if (minCount === void 0) minCount = null;
                    if (maxCount === void 0) maxCount = null;
                    var _this = _super.call(this) || this;
                    _this.minCount = minCount;
                    _this.maxCount = maxCount;
                    return _this;
                }
                AnswerCountValidator.prototype.getType = function() {
                    return "answercountvalidator";
                };
                AnswerCountValidator.prototype.validate = function(value, name, values, properties) {
                    if (name === void 0) name = null;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    if (value == null || value.constructor != Array) return null;
                    var count = value.length;
                    if (count == 0) return null;
                    if (this.minCount && count < this.minCount) return new ValidatorResult(null, this.createCustomError(this.getLocalizationFormatString("minSelectError", this.minCount)));
                    if (this.maxCount && count > this.maxCount) return new ValidatorResult(null, this.createCustomError(this.getLocalizationFormatString("maxSelectError", this.maxCount)));
                    return null;
                };
                AnswerCountValidator.prototype.getDefaultErrorText = function(name) {
                    return name;
                };
                Object.defineProperty(AnswerCountValidator.prototype, "minCount", {
                    /**
         * The minCount property.
         */ get: function() {
                        return this.getPropertyValue("minCount");
                    },
                    set: function(val1) {
                        this.setPropertyValue("minCount", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(AnswerCountValidator.prototype, "maxCount", {
                    /**
         * The maxCount property.
         */ get: function() {
                        return this.getPropertyValue("maxCount");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxCount", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                return AnswerCountValidator;
            }(SurveyValidator);
            /**
 * Use it to validate the text by regular expressions.
 *
 * [View Demo](https://surveyjs.io/form-library/examples/javascript-form-validation/ (linkStyle))
 */ var RegexValidator = /** @class */ function(_super) {
                __extends(RegexValidator, _super);
                function RegexValidator(regex) {
                    if (regex === void 0) regex = null;
                    var _this = _super.call(this) || this;
                    _this.regex = regex;
                    return _this;
                }
                RegexValidator.prototype.getType = function() {
                    return "regexvalidator";
                };
                RegexValidator.prototype.validate = function(value, name, values, properties) {
                    if (name === void 0) name = null;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    if (!this.regex || this.isValueEmpty(value)) return null;
                    var re = this.createRegExp();
                    if (Array.isArray(value)) for(var i = 0; i < value.length; i++){
                        var res = this.hasError(re, value[i], name);
                        if (res) return res;
                    }
                    return this.hasError(re, value, name);
                };
                RegexValidator.prototype.hasError = function(re, value, name) {
                    if (re.test(value)) return null;
                    return new ValidatorResult(value, this.createCustomError(name));
                };
                Object.defineProperty(RegexValidator.prototype, "regex", {
                    /**
         * The regex property.
         */ get: function() {
                        return this.getPropertyValue("regex");
                    },
                    set: function(val1) {
                        this.setPropertyValue("regex", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RegexValidator.prototype, "insensitive", {
                    get: function() {
                        return this.getPropertyValue("insensitive");
                    },
                    set: function(val1) {
                        this.setPropertyValue("insensitive", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                RegexValidator.prototype.createRegExp = function() {
                    return new RegExp(this.regex, this.insensitive ? "i" : "");
                };
                return RegexValidator;
            }(SurveyValidator);
            /**
 * Validate e-mail address in the text input
 */ var EmailValidator = /** @class */ function(_super) {
                __extends(EmailValidator, _super);
                function EmailValidator() {
                    var _this = _super.call(this) || this;
                    _this.re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()=[\]\.,;:\s@\"]+\.)+[^<>()=[\]\.,;:\s@\"]{2,})$/i;
                    return _this;
                }
                EmailValidator.prototype.getType = function() {
                    return "emailvalidator";
                };
                EmailValidator.prototype.validate = function(value, name, values, properties) {
                    if (name === void 0) name = null;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    if (!value) return null;
                    if (this.re.test(value)) return null;
                    return new ValidatorResult(value, this.createCustomError(name));
                };
                EmailValidator.prototype.getDefaultErrorText = function(name) {
                    return this.getLocalizationString("invalidEmail");
                };
                return EmailValidator;
            }(SurveyValidator);
            /**
 * Show error if expression returns false
 */ var ExpressionValidator = /** @class */ function(_super) {
                __extends(ExpressionValidator, _super);
                function ExpressionValidator(expression) {
                    if (expression === void 0) expression = null;
                    var _this = _super.call(this) || this;
                    _this.conditionRunner = null;
                    _this.isRunningValue = false;
                    _this.expression = expression;
                    return _this;
                }
                ExpressionValidator.prototype.getType = function() {
                    return "expressionvalidator";
                };
                Object.defineProperty(ExpressionValidator.prototype, "isValidateAllValues", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExpressionValidator.prototype, "isAsync", {
                    get: function() {
                        if (!this.ensureConditionRunner()) return false;
                        return this.conditionRunner.isAsync;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExpressionValidator.prototype, "isRunning", {
                    get: function() {
                        return this.isRunningValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionValidator.prototype.validate = function(value, name, values, properties) {
                    var _this = this;
                    if (name === void 0) name = null;
                    if (values === void 0) values = null;
                    if (properties === void 0) properties = null;
                    if (!this.ensureConditionRunner()) return null;
                    this.conditionRunner.onRunComplete = function(res) {
                        _this.isRunningValue = false;
                        if (!!_this.onAsyncCompleted) _this.onAsyncCompleted(_this.generateError(res, value, name));
                    };
                    this.isRunningValue = true;
                    var res = this.conditionRunner.run(values, properties);
                    if (this.conditionRunner.isAsync) return null;
                    this.isRunningValue = false;
                    return this.generateError(res, value, name);
                };
                ExpressionValidator.prototype.generateError = function(res, value, name) {
                    if (!res) return new ValidatorResult(value, this.createCustomError(name));
                    return null;
                };
                ExpressionValidator.prototype.getDefaultErrorText = function(name) {
                    return this.getLocalizationFormatString("invalidExpression", this.expression);
                };
                ExpressionValidator.prototype.ensureConditionRunner = function() {
                    if (!!this.conditionRunner) {
                        this.conditionRunner.expression = this.expression;
                        return true;
                    }
                    if (!this.expression) return false;
                    this.conditionRunner = new _conditions__WEBPACK_IMPORTED_MODULE_3__["ConditionRunner"](this.expression);
                    return true;
                };
                Object.defineProperty(ExpressionValidator.prototype, "expression", {
                    /**
         * The expression property.
         */ get: function() {
                        return this.getPropertyValue("expression");
                    },
                    set: function(val1) {
                        this.setPropertyValue("expression", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                return ExpressionValidator;
            }(SurveyValidator);
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("surveyvalidator", [
                {
                    name: "text",
                    serializationProperty: "locText"
                }
            ]);
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("numericvalidator", [
                "minValue:number",
                "maxValue:number"
            ], function() {
                return new NumericValidator();
            }, "surveyvalidator");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("textvalidator", [
                {
                    name: "minLength:number",
                    default: 0
                },
                {
                    name: "maxLength:number",
                    default: 0
                },
                {
                    name: "allowDigits:boolean",
                    default: true
                }
            ], function() {
                return new TextValidator();
            }, "surveyvalidator");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("answercountvalidator", [
                "minCount:number",
                "maxCount:number"
            ], function() {
                return new AnswerCountValidator();
            }, "surveyvalidator");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("regexvalidator", [
                "regex",
                {
                    name: "insensitive:boolean",
                    visible: false
                }
            ], function() {
                return new RegexValidator();
            }, "surveyvalidator");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("emailvalidator", [], function() {
                return new EmailValidator();
            }, "surveyvalidator");
            _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].addClass("expressionvalidator", [
                "expression:condition"
            ], function() {
                return new ExpressionValidator();
            }, "surveyvalidator");
        /***/ }
    });
});

});

var $7b02d682eb115277$exports = {};
"use strict";

$7b02d682eb115277$exports = (parcelRequire("1b2ls"));


var $7e96a608cb33bf79$export$882461b6382ed46c;
var $7e96a608cb33bf79$export$757ceba2d55c277e;
"use strict";

var $1u0KT = parcelRequire("1u0KT");
var $7e96a608cb33bf79$var$i;
$7e96a608cb33bf79$export$882461b6382ed46c = $1u0KT.createRoot;
$7e96a608cb33bf79$export$757ceba2d55c277e = $1u0KT.hydrateRoot;



parcelRequire("acw62");
/**
 * React Router DOM v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
/**
 * @remix-run/router v1.15.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $1d34d5c4a288b213$var$_extends() {
    $1d34d5c4a288b213$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $1d34d5c4a288b213$var$_extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $1d34d5c4a288b213$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($1d34d5c4a288b213$export$e19cd5f9376f8cee || ($1d34d5c4a288b213$export$e19cd5f9376f8cee = {}));
const $1d34d5c4a288b213$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $1d34d5c4a288b213$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $1d34d5c4a288b213$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $1d34d5c4a288b213$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $1d34d5c4a288b213$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $1d34d5c4a288b213$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $1d34d5c4a288b213$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $1d34d5c4a288b213$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $1d34d5c4a288b213$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $1d34d5c4a288b213$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $1d34d5c4a288b213$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $1d34d5c4a288b213$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $1d34d5c4a288b213$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $1d34d5c4a288b213$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $1d34d5c4a288b213$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $1d34d5c4a288b213$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($1d34d5c4a288b213$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let location = $1d34d5c4a288b213$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $1d34d5c4a288b213$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $1d34d5c4a288b213$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $1d34d5c4a288b213$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($1d34d5c4a288b213$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $1d34d5c4a288b213$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($1d34d5c4a288b213$var$ResultType || ($1d34d5c4a288b213$var$ResultType = {}));
const $1d34d5c4a288b213$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $1d34d5c4a288b213$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            index
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $1d34d5c4a288b213$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $1d34d5c4a288b213$export$3e9cee6b33872309(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if ($1d34d5c4a288b213$var$isIndexRoute(route)) {
            let indexRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $1d34d5c4a288b213$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $1d34d5c4a288b213$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function $1d34d5c4a288b213$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    let location = typeof locationArg === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $1d34d5c4a288b213$var$flattenRoutes(routes);
    $1d34d5c4a288b213$var$rankRouteBranches(branches);
    let matches = null;
    for(let i = 0; matches == null && i < branches.length; ++i){
        // Incoming pathnames are generally encoded from either window.location
        // or from router.navigate, but we want to match against the unencoded
        // paths in the route definitions.  Memory router locations won't be
        // encoded here but there also shouldn't be anything to decode so this
        // should be a safe operation.  This avoids needing matchRoutes to be
        // history-aware.
        let decoded = $1d34d5c4a288b213$var$decodePath(pathname);
        matches = $1d34d5c4a288b213$var$matchRouteBranch(branches[i], decoded);
    }
    return matches;
}
function $1d34d5c4a288b213$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $1d34d5c4a288b213$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $1d34d5c4a288b213$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            $1d34d5c4a288b213$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $1d34d5c4a288b213$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $1d34d5c4a288b213$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $1d34d5c4a288b213$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $1d34d5c4a288b213$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $1d34d5c4a288b213$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $1d34d5c4a288b213$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $1d34d5c4a288b213$var$paramRe = /^:[\w-]+$/;
const $1d34d5c4a288b213$var$dynamicSegmentValue = 3;
const $1d34d5c4a288b213$var$indexRouteValue = 2;
const $1d34d5c4a288b213$var$emptySegmentValue = 1;
const $1d34d5c4a288b213$var$staticSegmentValue = 10;
const $1d34d5c4a288b213$var$splatPenalty = -2;
const $1d34d5c4a288b213$var$isSplat = (s)=>s === "*";
function $1d34d5c4a288b213$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($1d34d5c4a288b213$var$isSplat)) initialScore += $1d34d5c4a288b213$var$splatPenalty;
    if (index) initialScore += $1d34d5c4a288b213$var$indexRouteValue;
    return segments.filter((s)=>!$1d34d5c4a288b213$var$isSplat(s)).reduce((score, segment)=>score + ($1d34d5c4a288b213$var$paramRe.test(segment) ? $1d34d5c4a288b213$var$dynamicSegmentValue : segment === "" ? $1d34d5c4a288b213$var$emptySegmentValue : $1d34d5c4a288b213$var$staticSegmentValue), initialScore);
}
function $1d34d5c4a288b213$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $1d34d5c4a288b213$var$matchRouteBranch(branch, pathname) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $1d34d5c4a288b213$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        let route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $1d34d5c4a288b213$export$a5c6d149b50c1d86($1d34d5c4a288b213$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $1d34d5c4a288b213$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function $1d34d5c4a288b213$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $1d34d5c4a288b213$export$3e9cee6b33872309(optional === "?" || param != null, 'Missing ":' + key + '" param');
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function $1d34d5c4a288b213$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $1d34d5c4a288b213$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $1d34d5c4a288b213$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $1d34d5c4a288b213$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $1d34d5c4a288b213$var$decodePath(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $1d34d5c4a288b213$export$c0e02632e14916fd(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to) : to;
    let pathname = toPathname ? toPathname.startsWith("/") ? toPathname : $1d34d5c4a288b213$var$resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname: pathname,
        search: $1d34d5c4a288b213$var$normalizeSearch(search),
        hash: $1d34d5c4a288b213$var$normalizeHash(hash)
    };
}
function $1d34d5c4a288b213$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $1d34d5c4a288b213$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $1d34d5c4a288b213$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $1d34d5c4a288b213$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === matches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $1d34d5c4a288b213$export$8ccf933b0513f8d0(toArg);
    else {
        to = $1d34d5c4a288b213$var$_extends({}, toArg);
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $1d34d5c4a288b213$var$getInvalidPathError("?", "pathname", "search", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "pathname", "hash", to));
        $1d34d5c4a288b213$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $1d34d5c4a288b213$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $1d34d5c4a288b213$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $1d34d5c4a288b213$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
/**
 * @private
 */ const $1d34d5c4a288b213$export$86d9a7913e44197e = (paths)=>paths.join("/").replace(/\/\/+/g, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $1d34d5c4a288b213$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ const $1d34d5c4a288b213$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $1d34d5c4a288b213$export$42a99a7a4bc0e76a extends Error {
}
class $1d34d5c4a288b213$export$61d759255b4eec65 {
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $1d34d5c4a288b213$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $1d34d5c4a288b213$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $1d34d5c4a288b213$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error('Deferred data for key "' + key + '" resolved/rejected with `undefined`, ' + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $1d34d5c4a288b213$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $1d34d5c4a288b213$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
}
function $1d34d5c4a288b213$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $1d34d5c4a288b213$var$unwrapTrackedPromise(value) {
    if (!$1d34d5c4a288b213$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
const $1d34d5c4a288b213$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $1d34d5c4a288b213$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $1d34d5c4a288b213$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $1d34d5c4a288b213$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $1d34d5c4a288b213$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $1d34d5c4a288b213$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $1d34d5c4a288b213$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $1d34d5c4a288b213$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $1d34d5c4a288b213$var$validMutationMethods = new Set($1d34d5c4a288b213$var$validMutationMethodsArr);
const $1d34d5c4a288b213$var$validRequestMethodsArr = [
    "get",
    ...$1d34d5c4a288b213$var$validMutationMethodsArr
];
const $1d34d5c4a288b213$var$validRequestMethods = new Set($1d34d5c4a288b213$var$validRequestMethodsArr);
const $1d34d5c4a288b213$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $1d34d5c4a288b213$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $1d34d5c4a288b213$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $1d34d5c4a288b213$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $1d34d5c4a288b213$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $1d34d5c4a288b213$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    let initialized;
    let hasLazyRoutes = initialMatches.some((m)=>m.route.lazy);
    let hasLoaders = initialMatches.some((m)=>m.route.loader);
    if (hasLazyRoutes) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!hasLoaders) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        let isRouteInitialized = (m)=>{
            // No loader, nothing to initialize
            if (!m.route.loader) return true;
            // Explicitly opting-in to running on hydration
            if (m.route.loader.hydrate === true) return false;
            // Otherwise, initialized if hydrated with data or an error
            return loaderData && loaderData[m.route.id] !== undefined || errors && errors[m.route.id] !== undefined;
        };
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every(isRouteInitialized);
        } else initialized = initialMatches.every(isRouteInitialized);
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = [];
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let ignoreNextHistoryUpdate = false;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            $1d34d5c4a288b213$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $1d34d5c4a288b213$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$1d34d5c4a288b213$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $1d34d5c4a288b213$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                unstable_viewTransitionOpts: opts.viewTransitionOpts,
                unstable_flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        }
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $1d34d5c4a288b213$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $1d34d5c4a288b213$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($1d34d5c4a288b213$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $1d34d5c4a288b213$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $1d34d5c4a288b213$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $1d34d5c4a288b213$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $1d34d5c4a288b213$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.unstable_viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(routesToUse);
            // Cancel all pending deferred on 404s since we don't keep any routes
            cancelActiveDeferreds();
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial load will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (state.initialized && !isRevalidationRequired && $1d34d5c4a288b213$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $1d34d5c4a288b213$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionData;
        let pendingError;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingError = {
            [$1d34d5c4a288b213$var$findNearestBoundary(matches).route.id]: opts.pendingError
        };
        else if (opts && opts.submission && $1d34d5c4a288b213$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionOutput = await handleAction(request, location, opts.submission, matches, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionOutput.shortCircuited) return;
            pendingActionData = actionOutput.pendingActionData;
            pendingError = actionOutput.pendingActionError;
            loadingNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // Create a GET request for the loaders
            request = new Request(request.url, {
                signal: request.signal
            });
        }
        // Call loaders
        let { shortCircuited: shortCircuited, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionData, pendingError);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $1d34d5c4a288b213$var$_extends({
            matches: matches
        }, pendingActionData ? {
            actionData: pendingActionData
        } : {}, {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        // Call our action and get the result
        let result;
        let actionMatch = $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else // If the user didn't explicity indicate replace behavior, replace if
            // we redirected to the exact same location we're currently at to avoid
            // double back-buttons
            replace = result.location === state.location.pathname + state.location.search;
            await startRedirectNavigation(state, result, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions are REPLACE navigations, but if the
            // action threw an error that'll be rendered in an errorElement, we fall
            // back to PUSH so that the user can use the back button to get back to
            // the pre-submission form location to try again
            if ((opts && opts.replace) !== true) pendingAction = $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
            return {
                // Send back an empty object we can use to clear out any prior actionData
                pendingActionData: {},
                pendingActionError: {
                    [boundaryMatch.route.id]: result.error
                }
            };
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        return {
            pendingActionData: {
                [actionMatch.route.id]: result.data
            }
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionData, pendingError) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $1d34d5c4a288b213$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $1d34d5c4a288b213$var$getSubmissionFromNavigation(loadingNavigation);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $1d34d5c4a288b213$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingError || null
            }, pendingActionData ? {
                actionData: pendingActionData
            } : {}, updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        if (!isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration)) {
            revalidatingFetchers.forEach((rf)=>{
                let fetcher = state.fetchers.get(rf.key);
                let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
                state.fetchers.set(rf.key, revalidatingFetcher);
            });
            let actionData = pendingActionData || state.actionData;
            updateState($1d34d5c4a288b213$var$_extends({
                navigation: loadingNavigation
            }, actionData ? Object.keys(actionData).length === 0 ? {
                actionData: null
            } : {
                actionData: actionData
            } : {}, revalidatingFetchers.length > 0 ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            if (fetchControllers.has(rf.key)) abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            await startRedirectNavigation(state, redirect.result, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // During partial hydration, preserve SSR errors for routes that don't re-run
        if (future.v7_partialHydration && initialHydration && state.errors) Object.entries(state.errors).filter((_ref2)=>{
            let [id] = _ref2;
            return !matchesToLoad.some((m)=>m.route.id === id);
        }).forEach((_ref3)=>{
            let [routeId, error] = _ref3;
            errors = Object.assign(errors || {}, {
                [routeId]: error
            });
        });
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $1d34d5c4a288b213$var$_extends({
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        let flushSync = (opts && opts.unstable_flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $1d34d5c4a288b213$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $1d34d5c4a288b213$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $1d34d5c4a288b213$var$getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, flushSync, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, flushSync, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        if (!match.route.action && !match.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            });
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        // Call the action for the fetcher
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResult = await $1d34d5c4a288b213$var$callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult) || $1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($1d34d5c4a288b213$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(state, actionResult, {
                        fetcherSubmission: submission
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($1d34d5c4a288b213$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($1d34d5c4a288b213$var$isDeferredResult(actionResult)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $1d34d5c4a288b213$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $1d34d5c4a288b213$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, {
            [match.route.id]: actionResult.data
        }, undefined // No need to send through errors since we short circuit above
        );
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $1d34d5c4a288b213$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            if (fetchControllers.has(staleKey)) abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { results: results, loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $1d34d5c4a288b213$var$findRedirect(results);
        if (redirect) {
            if (redirect.idx >= matchesToLoad.length) {
                // If this redirect came from a fetcher make sure we mark it in
                // fetchRedirectIds so it doesn't get revalidated on the next set of
                // loader executions
                let fetcherKey = revalidatingFetchers[redirect.idx - matchesToLoad.length].key;
                fetchRedirectIds.add(fetcherKey);
            }
            return startRedirectNavigation(state, redirect.result);
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $1d34d5c4a288b213$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $1d34d5c4a288b213$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, flushSync, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $1d34d5c4a288b213$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        // Call the loader for this fetcher route match
        let abortController = new AbortController();
        let fetchRequest = $1d34d5c4a288b213$var$createClientSideRequest(init.history, path, abortController.signal);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let result = await $1d34d5c4a288b213$var$callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) result = await $1d34d5c4a288b213$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(state, result);
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $1d34d5c4a288b213$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(state, redirect, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.revalidate) isRevalidationRequired = true;
        let redirectLocation = $1d34d5c4a288b213$var$createLocation(state.location, redirect.location, {
            _isRedirect: true
        });
        $1d34d5c4a288b213$export$3e9cee6b33872309(redirectLocation, "Expected a location on the redirect navigation");
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.reloadDocument) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(redirect.location)) {
                const url = init.history.createURL(redirect.location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(redirect.location);
                else routerWindow.location.assign(redirect.location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true ? $1d34d5c4a288b213$export$e19cd5f9376f8cee.Replace : $1d34d5c4a288b213$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $1d34d5c4a288b213$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($1d34d5c4a288b213$var$redirectPreserveMethodStatusCodes.has(redirect.status) && activeSubmission && $1d34d5c4a288b213$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $1d34d5c4a288b213$var$_extends({}, activeSubmission, {
                formAction: redirect.location
            }),
            // Preserve this flag across redirects
            preventScrollReset: pendingPreventScrollReset
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $1d34d5c4a288b213$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve this flag across redirects
                preventScrollReset: pendingPreventScrollReset
            });
        }
    }
    async function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        // Call all navigation loaders and revalidating fetcher loaders in parallel,
        // then slice off the results into separate arrays so we can handle them
        // accordingly
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath)),
            ...fetchersToLoad.map((f)=>{
                if (f.matches && f.match && f.controller) return $1d34d5c4a288b213$var$callLoaderOrAction("loader", $1d34d5c4a288b213$var$createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath);
                else {
                    let error = {
                        type: $1d34d5c4a288b213$var$ResultType.error,
                        error: $1d34d5c4a288b213$var$getInternalRouterError(404, {
                            pathname: f.path
                        })
                    };
                    return error;
                }
            })
        ]);
        let loaderResults = results.slice(0, matchesToLoad.length);
        let fetcherResults = results.slice(matchesToLoad.length);
        await Promise.all([
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(()=>request.signal), false, state.loaderData),
            $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, fetchersToLoad.map((f)=>f.match), fetcherResults, fetchersToLoad.map((f)=>f.controller ? f.controller.signal : null), true)
        ]);
        return {
            results: results,
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        if (future.v7_fetcherPersist) {
            activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
            // If this fetcher was previously marked for deletion, unmark it since we
            // have a new instance
            if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        }
        return state.fetchers.get(key) || $1d34d5c4a288b213$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        deletedFetchers.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        if (future.v7_fetcherPersist) {
            let count = (activeFetchers.get(key) || 0) - 1;
            if (count <= 0) {
                activeFetchers.delete(key);
                deletedFetchers.add(key);
            } else activeFetchers.set(key, count);
        } else deleteFetcher(key);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        $1d34d5c4a288b213$export$3e9cee6b33872309(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $1d34d5c4a288b213$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $1d34d5c4a288b213$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $1d34d5c4a288b213$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref4) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref4;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $1d34d5c4a288b213$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $1d34d5c4a288b213$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$1d34d5c4a288b213$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $1d34d5c4a288b213$export$4d0306f8f6a4585b = Symbol("deferred");
function $1d34d5c4a288b213$export$3336b097a6fbc59a(routes, opts) {
    $1d34d5c4a288b213$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $1d34d5c4a288b213$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $1d34d5c4a288b213$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $1d34d5c4a288b213$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ async function query(request, _temp3) {
        let { requestContext: requestContext } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD") {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $1d34d5c4a288b213$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $1d34d5c4a288b213$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $1d34d5c4a288b213$var$createLocation("", $1d34d5c4a288b213$export$fe53371bee54353d(url), null, "default");
        let matches = $1d34d5c4a288b213$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$1d34d5c4a288b213$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $1d34d5c4a288b213$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $1d34d5c4a288b213$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, match);
        if ($1d34d5c4a288b213$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$1d34d5c4a288b213$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, routeMatch) {
        $1d34d5c4a288b213$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($1d34d5c4a288b213$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $1d34d5c4a288b213$var$getTargetMatch(matches, location), requestContext, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, routeMatch);
            return $1d34d5c4a288b213$var$isResponse(result) ? result : $1d34d5c4a288b213$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction, we throw
            // it to bail out and then return or throw here based on whether the user
            // returned or threw
            if ($1d34d5c4a288b213$var$isQueryRouteResponse(e)) {
                if (e.type === $1d34d5c4a288b213$var$ResultType.error) throw e.response;
                return e.response;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($1d34d5c4a288b213$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        } else {
            result = await $1d34d5c4a288b213$var$callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                isStaticRequest: true,
                isRouteRequest: isRouteRequest,
                requestContext: requestContext
            });
            if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.status,
            headers: {
                Location: result.location
            }
        });
        if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
            let error = $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($1d34d5c4a288b213$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(request, matches, requestContext, undefined, {
                [boundaryMatch.route.id]: result.error
            });
            // action status codes take precedence over loader status codes
            return $1d34d5c4a288b213$var$_extends({}, context, {
                statusCode: $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500,
                actionData: null,
                actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        let context = await loadRouteData(loaderRequest, matches, requestContext);
        return $1d34d5c4a288b213$var$_extends({}, context, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionData: {
                [actionMatch.route.id]: result.data
            },
            actionHeaders: $1d34d5c4a288b213$var$_extends({}, result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {})
        });
    }
    async function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $1d34d5c4a288b213$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionError || null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await Promise.all([
            ...matchesToLoad.map((match)=>$1d34d5c4a288b213$var$callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, future.v7_relativeSplatPath, {
                    isStaticRequest: true,
                    isRouteRequest: isRouteRequest,
                    requestContext: requestContext
                }))
        ]);
        if (request.signal.aborted) $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $1d34d5c4a288b213$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $1d34d5c4a288b213$export$fec11da027c70692(routes, context, error) {
    let newContext = $1d34d5c4a288b213$var$_extends({}, context, {
        statusCode: $1d34d5c4a288b213$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $1d34d5c4a288b213$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $1d34d5c4a288b213$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $1d34d5c4a288b213$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $1d34d5c4a288b213$export$cae722b0cc860f13(to ? to : ".", $1d34d5c4a288b213$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $1d34d5c4a288b213$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !$1d34d5c4a288b213$var$hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $1d34d5c4a288b213$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $1d34d5c4a288b213$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $1d34d5c4a288b213$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$1d34d5c4a288b213$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$1d34d5c4a288b213$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $1d34d5c4a288b213$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $1d34d5c4a288b213$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $1d34d5c4a288b213$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref5)=>{
                let [name, value] = _ref5;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$1d34d5c4a288b213$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $1d34d5c4a288b213$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $1d34d5c4a288b213$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $1d34d5c4a288b213$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $1d34d5c4a288b213$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $1d34d5c4a288b213$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId) {
    let boundaryMatches = matches;
    if (boundaryId) {
        let index = matches.findIndex((m)=>m.route.id === boundaryId);
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function $1d34d5c4a288b213$var$getMatchesToLoad(history, state, matches, submission, location, isInitialLoad, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionData, pendingError) {
    let actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    let boundaryMatches = $1d34d5c4a288b213$var$getLoaderMatchesUntilBoundary(matches, boundaryId);
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (isInitialLoad) {
            if (route.loader.hydrate) return true;
            return state.loaderData[route.id] === undefined && // Don't re-run if the loader ran and threw an error
            (!state.errors || state.errors[route.id] === undefined);
        }
        // Always call the loader on new route instances and pending defer cancellations
        if ($1d34d5c4a288b213$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $1d34d5c4a288b213$var$shouldRevalidateLoader(match, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $1d34d5c4a288b213$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial load (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (isInitialLoad || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $1d34d5c4a288b213$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $1d34d5c4a288b213$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.includes(key)) // Always revalidate if the fetcher was cancelled
        shouldRevalidate = true;
        else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $1d34d5c4a288b213$var$shouldRevalidateLoader(fetcherMatch, $1d34d5c4a288b213$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $1d34d5c4a288b213$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $1d34d5c4a288b213$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $1d34d5c4a288b213$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $1d34d5c4a288b213$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $1d34d5c4a288b213$export$c0e02632e14916fd(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
        if (!isPropertyStaticallyDefined && !$1d34d5c4a288b213$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $1d34d5c4a288b213$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
async function $1d34d5c4a288b213$var$callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, v7_relativeSplatPath, opts) {
    if (opts === void 0) opts = {};
    let resultType;
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        return Promise.race([
            handler({
                request: request,
                params: match.params,
                context: opts.requestContext
            }),
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        if (match.route.lazy) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let values = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                ]);
                if (handlerError) throw handlerError;
                result = values[0];
            } else {
                // Load lazy route module, then run any returned handler
                await $1d34d5c4a288b213$var$loadLazyRouteModule(match.route, mapRouteProperties, manifest);
                handler = match.route[type];
                if (handler) // Handler still run even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $1d34d5c4a288b213$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $1d34d5c4a288b213$var$ResultType.data,
                    data: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $1d34d5c4a288b213$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $1d34d5c4a288b213$export$3e9cee6b33872309(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        resultType = $1d34d5c4a288b213$var$ResultType.error;
        result = e;
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    if ($1d34d5c4a288b213$var$isResponse(result)) {
        let status = result.status;
        // Process redirects
        if ($1d34d5c4a288b213$var$redirectStatusCodes.has(status)) {
            let location = result.headers.get("Location");
            $1d34d5c4a288b213$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
            // Support relative routing in internal redirects
            if (!$1d34d5c4a288b213$var$ABSOLUTE_URL_REGEX.test(location)) location = $1d34d5c4a288b213$var$normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location, v7_relativeSplatPath);
            else if (!opts.isStaticRequest) {
                // Strip off the protocol+origin for same-origin + same-basename absolute
                // redirects. If this is a static request, we can let it go back to the
                // browser as-is
                let currentUrl = new URL(request.url);
                let url = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                let isSameBasename = $1d34d5c4a288b213$export$b69e3301ce081aa3(url.pathname, basename) != null;
                if (url.origin === currentUrl.origin && isSameBasename) location = url.pathname + url.search + url.hash;
            }
            // Don't process redirects in the router during static requests requests.
            // Instead, throw the Response and let the server handle it with an HTTP
            // redirect.  We also update the Location header in place in this flow so
            // basename and relative routing is taken into account
            if (opts.isStaticRequest) {
                result.headers.set("Location", location);
                throw result;
            }
            return {
                type: $1d34d5c4a288b213$var$ResultType.redirect,
                status: status,
                location: location,
                revalidate: result.headers.get("X-Remix-Revalidate") !== null,
                reloadDocument: result.headers.get("X-Remix-Reload-Document") !== null
            };
        }
        // For SSR single-route requests, we want to hand Responses back directly
        // without unwrapping.  We do this with the QueryRouteResponse wrapper
        // interface so we can know whether it was returned or thrown
        if (opts.isRouteRequest) {
            let queryRouteResponse = {
                type: resultType === $1d34d5c4a288b213$var$ResultType.error ? $1d34d5c4a288b213$var$ResultType.error : $1d34d5c4a288b213$var$ResultType.data,
                response: result
            };
            throw queryRouteResponse;
        }
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $1d34d5c4a288b213$var$ResultType.error,
                error: e
            };
        }
        if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
            type: resultType,
            error: new $1d34d5c4a288b213$export$6c6580e81da25755(status, result.statusText, data),
            headers: result.headers
        };
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (resultType === $1d34d5c4a288b213$var$ResultType.error) return {
        type: resultType,
        error: result
    };
    if ($1d34d5c4a288b213$export$fbcedacb60443473(result)) {
        var _result$init, _result$init2;
        return {
            type: $1d34d5c4a288b213$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
            headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result
    };
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $1d34d5c4a288b213$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($1d34d5c4a288b213$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $1d34d5c4a288b213$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $1d34d5c4a288b213$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $1d34d5c4a288b213$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $1d34d5c4a288b213$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    // Process loader results into state.loaderData/state.errors
    results.forEach((result, index)=>{
        let id = matchesToLoad[index].route.id;
        $1d34d5c4a288b213$export$3e9cee6b33872309(!$1d34d5c4a288b213$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(matches, id);
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {};
            // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $1d34d5c4a288b213$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if ($1d34d5c4a288b213$var$isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $1d34d5c4a288b213$var$processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $1d34d5c4a288b213$var$processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds);
    // Process results from our revalidating fetchers
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, match: match, controller: controller } = revalidatingFetchers[index];
        $1d34d5c4a288b213$export$3e9cee6b33872309(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        let result = fetcherResults[index];
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if ($1d34d5c4a288b213$var$isErrorResult(result)) {
            let boundaryMatch = $1d34d5c4a288b213$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $1d34d5c4a288b213$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($1d34d5c4a288b213$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($1d34d5c4a288b213$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $1d34d5c4a288b213$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $1d34d5c4a288b213$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $1d34d5c4a288b213$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $1d34d5c4a288b213$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $1d34d5c4a288b213$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $1d34d5c4a288b213$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $1d34d5c4a288b213$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new $1d34d5c4a288b213$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $1d34d5c4a288b213$var$findRedirect(results) {
    for(let i = results.length - 1; i >= 0; i--){
        let result = results[i];
        if ($1d34d5c4a288b213$var$isRedirectResult(result)) return {
            result: result,
            idx: i
        };
    }
}
function $1d34d5c4a288b213$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(path) : path;
    return $1d34d5c4a288b213$export$fe53371bee54353d($1d34d5c4a288b213$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $1d34d5c4a288b213$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $1d34d5c4a288b213$var$isDeferredResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.deferred;
}
function $1d34d5c4a288b213$var$isErrorResult(result) {
    return result.type === $1d34d5c4a288b213$var$ResultType.error;
}
function $1d34d5c4a288b213$var$isRedirectResult(result) {
    return (result && result.type) === $1d34d5c4a288b213$var$ResultType.redirect;
}
function $1d34d5c4a288b213$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $1d34d5c4a288b213$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $1d34d5c4a288b213$var$isRedirectResponse(result) {
    if (!$1d34d5c4a288b213$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $1d34d5c4a288b213$var$isQueryRouteResponse(obj) {
    return obj && $1d34d5c4a288b213$var$isResponse(obj.response) && (obj.type === $1d34d5c4a288b213$var$ResultType.data || obj.type === $1d34d5c4a288b213$var$ResultType.error);
}
function $1d34d5c4a288b213$var$isValidMethod(method) {
    return $1d34d5c4a288b213$var$validRequestMethods.has(method.toLowerCase());
}
function $1d34d5c4a288b213$var$isMutationMethod(method) {
    return $1d34d5c4a288b213$var$validMutationMethods.has(method.toLowerCase());
}
async function $1d34d5c4a288b213$var$resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    for(let index = 0; index < results.length; index++){
        let result = results[index];
        let match = matchesToLoad[index];
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$1d34d5c4a288b213$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($1d34d5c4a288b213$var$isDeferredResult(result) && (isFetcher || isRevalidatingLoader)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            let signal = signals[index];
            $1d34d5c4a288b213$export$3e9cee6b33872309(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
            await $1d34d5c4a288b213$var$resolveDeferredData(result, signal, isFetcher).then((result)=>{
                if (result) results[index] = result || results[index];
            });
        }
    }
}
async function $1d34d5c4a288b213$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $1d34d5c4a288b213$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $1d34d5c4a288b213$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $1d34d5c4a288b213$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $1d34d5c4a288b213$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $1d34d5c4a288b213$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $1d34d5c4a288b213$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $1d34d5c4a288b213$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $1d34d5c4a288b213$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $1d34d5c4a288b213$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $1d34d5c4a288b213$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $1d34d5c4a288b213$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $1d34d5c4a288b213$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $1d34d5c4a288b213$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $1d34d5c4a288b213$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $1d34d5c4a288b213$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($1d34d5c4a288b213$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $1d34d5c4a288b213$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.22.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $acw62 = parcelRequire("acw62");

function $7939e29d663dd3ed$var$_extends() {
    $7939e29d663dd3ed$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $7939e29d663dd3ed$var$_extends.apply(this, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $7939e29d663dd3ed$export$3add0d5dce533e2e = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$145dfa71566a64dc = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$var$AwaitContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $7939e29d663dd3ed$export$26749e8557646306 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$c7914228fb69b0f5 = /*#__PURE__*/ $acw62.createContext(null);
const $7939e29d663dd3ed$export$9072aa6dd1f93057 = /*#__PURE__*/ $acw62.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $7939e29d663dd3ed$var$RouteErrorContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function $7939e29d663dd3ed$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function $7939e29d663dd3ed$export$9c954a9d03d32f4a() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function $7939e29d663dd3ed$export$45d76561a5302f2b() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function $7939e29d663dd3ed$export$1b3f31771c5d07c() {
    return $acw62.useContext($7939e29d663dd3ed$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function $7939e29d663dd3ed$export$6c330e8992e8a295(pattern) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$81336c211d5ff295)(pattern, pathname), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $7939e29d663dd3ed$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $acw62.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function $7939e29d663dd3ed$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $7939e29d663dd3ed$var$useNavigateStable() : $7939e29d663dd3ed$var$useNavigateUnstable();
}
function $7939e29d663dd3ed$var$useNavigateUnstable() {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$OutletContext = /*#__PURE__*/ $acw62.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function $7939e29d663dd3ed$export$4138103a3ae699cc() {
    return $acw62.useContext($7939e29d663dd3ed$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function $7939e29d663dd3ed$export$a3be3530d8e40d0b(context) {
    let outlet = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function $7939e29d663dd3ed$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function $7939e29d663dd3ed$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $acw62.useMemo(()=>(0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function $7939e29d663dd3ed$export$5d3fca4a98652595(routes, locationArg) {
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: parentMatches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $1d34d5c4a288b213$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $7939e29d663dd3ed$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $7939e29d663dd3ed$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $7939e29d663dd3ed$var$DefaultErrorComponent() {
    let error = $7939e29d663dd3ed$export$ed527bf60f6e05f2();
    let message = (0, $1d34d5c4a288b213$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $acw62.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $acw62.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $7939e29d663dd3ed$var$defaultErrorElement = /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DefaultErrorComponent, null);
class $7939e29d663dd3ed$var$RenderErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
}
function $7939e29d663dd3ed$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $7939e29d663dd3ed$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]));
        !(errorIndex >= 0) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $7939e29d663dd3ed$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $7939e29d663dd3ed$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $acw62.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $7939e29d663dd3ed$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($7939e29d663dd3ed$var$DataRouterHook || {});
var $7939e29d663dd3ed$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($7939e29d663dd3ed$var$DataRouterStateHook || {});
function $7939e29d663dd3ed$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $7939e29d663dd3ed$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext($7939e29d663dd3ed$export$3add0d5dce533e2e);
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $7939e29d663dd3ed$var$useDataRouterState(hookName) {
    let state = $acw62.useContext($7939e29d663dd3ed$export$145dfa71566a64dc);
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
function $7939e29d663dd3ed$var$useRouteContext(hookName) {
    let route = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $7939e29d663dd3ed$var$useCurrentRouteId(hookName) {
    let route = $7939e29d663dd3ed$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $7939e29d663dd3ed$export$5fc8298006ad9e58() {
    return $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $7939e29d663dd3ed$export$d0fd4b7106de2769() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $7939e29d663dd3ed$export$600dc272ed516c15() {
    let dataRouterContext = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseRevalidator);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRevalidator);
    return $acw62.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $7939e29d663dd3ed$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseMatches);
    return $acw62.useMemo(()=>matches.map((m)=>(0, $1d34d5c4a288b213$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $7939e29d663dd3ed$export$1448a5050d252c4d() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $7939e29d663dd3ed$export$fd5d37484eab868d(routeId) {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $7939e29d663dd3ed$export$fdc00f3f26066d5e() {
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseActionData);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $7939e29d663dd3ed$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $acw62.useContext($7939e29d663dd3ed$var$RouteErrorContext);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    let routeId = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$78a72ddb39bdd145() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $7939e29d663dd3ed$export$17f53340677d5831() {
    let value = $acw62.useContext($7939e29d663dd3ed$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $7939e29d663dd3ed$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $7939e29d663dd3ed$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseBlocker);
    let state = $7939e29d663dd3ed$var$useDataRouterState($7939e29d663dd3ed$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $acw62.useState("");
    let blockerFunction = $acw62.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $7939e29d663dd3ed$var$_extends({}, currentLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $7939e29d663dd3ed$var$_extends({}, nextLocation, {
                pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $acw62.useEffect(()=>{
        let key = String(++$7939e29d663dd3ed$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $acw62.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $1d34d5c4a288b213$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $7939e29d663dd3ed$var$useNavigateStable() {
    let { router: router } = $7939e29d663dd3ed$var$useDataRouterContext($7939e29d663dd3ed$var$DataRouterHook.UseNavigateStable);
    let id = $7939e29d663dd3ed$var$useCurrentRouteId($7939e29d663dd3ed$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $acw62.useRef(false);
    $7939e29d663dd3ed$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $acw62.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $7939e29d663dd3ed$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $7939e29d663dd3ed$var$alreadyWarned = {};
function $7939e29d663dd3ed$var$warningOnce(key, cond, message) {
    if (!cond && !$7939e29d663dd3ed$var$alreadyWarned[key]) $7939e29d663dd3ed$var$alreadyWarned[key] = true;
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $7939e29d663dd3ed$var$START_TRANSITION = "startTransition";
const $7939e29d663dd3ed$var$startTransitionImpl = $acw62[$7939e29d663dd3ed$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $7939e29d663dd3ed$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        if (v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl) $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $7939e29d663dd3ed$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $7939e29d663dd3ed$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function $7939e29d663dd3ed$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $7939e29d663dd3ed$var$startTransitionImpl ? $7939e29d663dd3ed$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function $7939e29d663dd3ed$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $acw62.useContext($7939e29d663dd3ed$export$26749e8557646306);
    let { matches: matches } = $acw62.useContext($7939e29d663dd3ed$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $7939e29d663dd3ed$export$45d76561a5302f2b();
    let navigate = $7939e29d663dd3ed$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $1d34d5c4a288b213$export$cae722b0cc860f13)(to, (0, $1d34d5c4a288b213$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $acw62.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function $7939e29d663dd3ed$export$910ae8079b2c2852(props) {
    return $7939e29d663dd3ed$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function $7939e29d663dd3ed$export$e7b0ac011bb776c6(_props) {
    (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function $7939e29d663dd3ed$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $1d34d5c4a288b213$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$7939e29d663dd3ed$export$9c954a9d03d32f4a() && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $acw62.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $7939e29d663dd3ed$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $1d34d5c4a288b213$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $acw62.useMemo(()=>{
        let trailingPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function $7939e29d663dd3ed$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $7939e29d663dd3ed$export$5d3fca4a98652595($7939e29d663dd3ed$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $7939e29d663dd3ed$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$ResolveAwait, null, children));
}
var $7939e29d663dd3ed$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($7939e29d663dd3ed$var$AwaitRenderStatus || {});
const $7939e29d663dd3ed$var$neverSettledPromise = new Promise(()=>{});
class $7939e29d663dd3ed$var$AwaitErrorBoundary extends $acw62.Component {
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = promise._error !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.error : promise._data !== undefined ? $7939e29d663dd3ed$var$AwaitRenderStatus.success : $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $7939e29d663dd3ed$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && promise._error instanceof (0, $1d34d5c4a288b213$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $7939e29d663dd3ed$var$neverSettledPromise;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $7939e29d663dd3ed$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $acw62.createElement($7939e29d663dd3ed$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $7939e29d663dd3ed$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $7939e29d663dd3ed$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function $7939e29d663dd3ed$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $acw62.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $acw62.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $acw62.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $7939e29d663dd3ed$export$e7b0ac011bb776c6) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $7939e29d663dd3ed$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $7939e29d663dd3ed$export$daf73786167a7f72(matches) {
    return $7939e29d663dd3ed$var$_renderMatches(matches);
}
function $7939e29d663dd3ed$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $acw62.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $acw62.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $acw62.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $7939e29d663dd3ed$export$f30f7e456d254e83(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $7939e29d663dd3ed$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $7939e29d663dd3ed$export$52b333d321859367
    }).initialize();
}



function $040dbb9c344a508d$var$_extends() {
    $040dbb9c344a508d$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $040dbb9c344a508d$var$_extends.apply(this, arguments);
}
function $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
const $040dbb9c344a508d$var$defaultMethod = "get";
const $040dbb9c344a508d$var$defaultEncType = "application/x-www-form-urlencoded";
function $040dbb9c344a508d$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $040dbb9c344a508d$var$isButtonElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $040dbb9c344a508d$var$isFormElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $040dbb9c344a508d$var$isInputElement(object) {
    return $040dbb9c344a508d$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $040dbb9c344a508d$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $040dbb9c344a508d$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$040dbb9c344a508d$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $040dbb9c344a508d$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $040dbb9c344a508d$var$_formDataSupportsSubmitter = null;
function $040dbb9c344a508d$var$isFormDataSubmitterSupported() {
    if ($040dbb9c344a508d$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $040dbb9c344a508d$var$_formDataSupportsSubmitter = true;
    }
    return $040dbb9c344a508d$var$_formDataSupportsSubmitter;
}
const $040dbb9c344a508d$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $040dbb9c344a508d$var$getFormEncType(encType) {
    if (encType != null && !$040dbb9c344a508d$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($040dbb9c344a508d$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        formData = new FormData(target);
    } else if ($040dbb9c344a508d$var$isButtonElement(target) || $040dbb9c344a508d$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $040dbb9c344a508d$var$defaultMethod;
        encType = $040dbb9c344a508d$var$getFormEncType(target.getAttribute("formenctype")) || $040dbb9c344a508d$var$getFormEncType(form.getAttribute("enctype")) || $040dbb9c344a508d$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$040dbb9c344a508d$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($040dbb9c344a508d$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $040dbb9c344a508d$var$defaultMethod;
        action = null;
        encType = $040dbb9c344a508d$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $040dbb9c344a508d$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "unstable_viewTransition"
], $040dbb9c344a508d$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "unstable_viewTransition",
    "children"
], $040dbb9c344a508d$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "unstable_viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $040dbb9c344a508d$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $040dbb9c344a508d$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $040dbb9c344a508d$export$1f3f55432a00e06d(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $1d34d5c4a288b213$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $040dbb9c344a508d$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $040dbb9c344a508d$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $7939e29d663dd3ed$export$52b333d321859367),
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $040dbb9c344a508d$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $040dbb9c344a508d$var$_extends({}, state, {
        errors: $040dbb9c344a508d$var$deserializeErrors(state.errors)
    });
    return state;
}
function $040dbb9c344a508d$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $1d34d5c4a288b213$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $040dbb9c344a508d$export$7ad602f0e94e62d1 = /*#__PURE__*/ $acw62.createContext({
    isTransitioning: false
});
const $040dbb9c344a508d$export$148fd98d095596d4 = /*#__PURE__*/ $acw62.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $040dbb9c344a508d$var$START_TRANSITION = "startTransition";
const $040dbb9c344a508d$var$startTransitionImpl = $acw62[$040dbb9c344a508d$var$START_TRANSITION];
const $040dbb9c344a508d$var$FLUSH_SYNC = "flushSync";
const $040dbb9c344a508d$var$flushSyncImpl = $1u0KT[$040dbb9c344a508d$var$FLUSH_SYNC];
const $040dbb9c344a508d$var$USE_ID = "useId";
const $040dbb9c344a508d$var$useIdImpl = $acw62[$040dbb9c344a508d$var$USE_ID];
function $040dbb9c344a508d$var$startTransitionSafe(cb) {
    if ($040dbb9c344a508d$var$startTransitionImpl) $040dbb9c344a508d$var$startTransitionImpl(cb);
    else cb();
}
function $040dbb9c344a508d$var$flushSyncSafe(cb) {
    if ($040dbb9c344a508d$var$flushSyncImpl) $040dbb9c344a508d$var$flushSyncImpl(cb);
    else cb();
}
class $040dbb9c344a508d$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $040dbb9c344a508d$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $acw62.useState(router.state);
    let [pendingState, setPendingState] = $acw62.useState();
    let [vtContext, setVtContext] = $acw62.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $acw62.useState();
    let [transition, setTransition] = $acw62.useState();
    let [interruption, setInterruption] = $acw62.useState();
    let fetcherData = $acw62.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $acw62.useCallback((cb)=>{
        if (v7_startTransition) $040dbb9c344a508d$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $acw62.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, unstable_flushSync: flushSync, unstable_viewTransitionOpts: viewTransitionOpts } = _ref2;
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        let isViewTransitionUnavailable = router.window == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $040dbb9c344a508d$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $040dbb9c344a508d$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $040dbb9c344a508d$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $acw62.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $acw62.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $040dbb9c344a508d$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $acw62.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $acw62.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $acw62.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $acw62.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $acw62.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $acw62.createElement($acw62.Fragment, null, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
function $040dbb9c344a508d$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $7939e29d663dd3ed$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $040dbb9c344a508d$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $040dbb9c344a508d$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $acw62.useRef();
    if (historyRef.current == null) historyRef.current = (0, $1d34d5c4a288b213$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $040dbb9c344a508d$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $acw62.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $acw62.useCallback((newState)=>{
        v7_startTransition && $040dbb9c344a508d$var$startTransitionImpl ? $040dbb9c344a508d$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $acw62.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /*#__PURE__*/ $acw62.createElement((0, $7939e29d663dd3ed$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $040dbb9c344a508d$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $040dbb9c344a508d$export$a6c7ac8248d6e38a = /*#__PURE__*/ $acw62.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref7, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref7, $040dbb9c344a508d$var$_excluded);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $040dbb9c344a508d$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($040dbb9c344a508d$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $7939e29d663dd3ed$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $040dbb9c344a508d$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        unstable_viewTransition: unstable_viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $acw62.createElement("a", $040dbb9c344a508d$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $040dbb9c344a508d$export$b0d92dbee9b5b60d = /*#__PURE__*/ $acw62.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, unstable_viewTransition: unstable_viewTransition, children: children } = _ref8, rest = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref8, $040dbb9c344a508d$var$_excluded2);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let routerState = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $040dbb9c344a508d$export$328fe15191788e7f(path) && unstable_viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a6c7ac8248d6e38a, $040dbb9c344a508d$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        unstable_viewTransition: unstable_viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $040dbb9c344a508d$export$a7fed597f4b8afd8 = /*#__PURE__*/ $acw62.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $040dbb9c344a508d$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, unstable_viewTransition: unstable_viewTransition } = _ref9, props = $040dbb9c344a508d$var$_objectWithoutPropertiesLoose(_ref9, $040dbb9c344a508d$var$_excluded3);
    let submit = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let formAction = $040dbb9c344a508d$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            unstable_viewTransition: unstable_viewTransition
        });
    };
    return /*#__PURE__*/ $acw62.createElement("form", $040dbb9c344a508d$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $040dbb9c344a508d$export$11aac1aab828f1fa(_ref10) {
    let { getKey: getKey, storageKey: storageKey } = _ref10;
    $040dbb9c344a508d$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $040dbb9c344a508d$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($040dbb9c344a508d$var$DataRouterHook || ($040dbb9c344a508d$var$DataRouterHook = {}));
var $040dbb9c344a508d$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($040dbb9c344a508d$var$DataRouterStateHook || ($040dbb9c344a508d$var$DataRouterStateHook = {}));
// Internal hooks
function $040dbb9c344a508d$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function $040dbb9c344a508d$var$useDataRouterContext(hookName) {
    let ctx = $acw62.useContext((0, $7939e29d663dd3ed$export$3add0d5dce533e2e));
    !ctx && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return ctx;
}
function $040dbb9c344a508d$var$useDataRouterState(hookName) {
    let state = $acw62.useContext((0, $7939e29d663dd3ed$export$145dfa71566a64dc));
    !state && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $040dbb9c344a508d$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, unstable_viewTransition: unstable_viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $acw62.useCallback((event)=>{
        if ($040dbb9c344a508d$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $1d34d5c4a288b213$export$fe53371bee54353d)(location) === (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                unstable_viewTransition: unstable_viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        unstable_viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $040dbb9c344a508d$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $acw62.useRef($040dbb9c344a508d$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $acw62.useRef(false);
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let searchParams = $acw62.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $040dbb9c344a508d$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $7939e29d663dd3ed$export$9770f232ac06a008)();
    let setSearchParams = $acw62.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $040dbb9c344a508d$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $040dbb9c344a508d$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $040dbb9c344a508d$var$fetcherId = 0;
let $040dbb9c344a508d$var$getUniqueFetcherId = ()=>"__" + String(++$040dbb9c344a508d$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $040dbb9c344a508d$export$47c85c6e3a081d3() {
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let currentRouteId = (0, $7939e29d663dd3ed$export$5fc8298006ad9e58)();
    return $acw62.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $040dbb9c344a508d$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $040dbb9c344a508d$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $040dbb9c344a508d$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                unstable_flushSync: options.unstable_flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            unstable_flushSync: options.unstable_flushSync,
            unstable_viewTransition: options.unstable_viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $040dbb9c344a508d$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let routeContext = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    !routeContext && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $040dbb9c344a508d$var$_extends({}, (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        if (params.has("index") && params.get("index") === "") {
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $1d34d5c4a288b213$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $1d34d5c4a288b213$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $040dbb9c344a508d$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseFetcher);
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $acw62.useContext($040dbb9c344a508d$export$148fd98d095596d4);
    let route = $acw62.useContext((0, $7939e29d663dd3ed$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !route && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $040dbb9c344a508d$var$useIdImpl ? $040dbb9c344a508d$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $acw62.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($040dbb9c344a508d$var$getUniqueFetcherId());
    // Registration/cleanup
    $acw62.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $acw62.useCallback((href, opts)=>{
        !routeId && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $040dbb9c344a508d$export$47c85c6e3a081d3();
    let submit = $acw62.useCallback((target, opts)=>{
        submitImpl(target, $040dbb9c344a508d$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $acw62.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $acw62.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $acw62.createElement($040dbb9c344a508d$export$a7fed597f4b8afd8, $040dbb9c344a508d$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $1d34d5c4a288b213$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $acw62.useMemo(()=>$040dbb9c344a508d$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $040dbb9c344a508d$export$fa996778a3a31087() {
    let state = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref11)=>{
        let [key, fetcher] = _ref11;
        return $040dbb9c344a508d$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $040dbb9c344a508d$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $040dbb9c344a508d$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $040dbb9c344a508d$var$useDataRouterState($040dbb9c344a508d$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $acw62.useContext((0, $7939e29d663dd3ed$export$26749e8557646306));
    let location = (0, $7939e29d663dd3ed$export$45d76561a5302f2b)();
    let matches = (0, $7939e29d663dd3ed$export$2378eb7f5ff86053)();
    let navigation = (0, $7939e29d663dd3ed$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $acw62.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $040dbb9c344a508d$var$usePageHide($acw62.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $040dbb9c344a508d$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($040dbb9c344a508d$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $040dbb9c344a508d$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $040dbb9c344a508d$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($040dbb9c344a508d$var$_extends({}, location, {
                    pathname: (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($040dbb9c344a508d$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $acw62.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $040dbb9c344a508d$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $acw62.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $040dbb9c344a508d$export$39f4eb3dbd812741(_ref12) {
    let { when: when, message: message } = _ref12;
    let blocker = (0, $7939e29d663dd3ed$export$b273b3273281a049)(when);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $acw62.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $040dbb9c344a508d$export$328fe15191788e7f(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $acw62.useContext($040dbb9c344a508d$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $1d34d5c4a288b213$export$3e9cee6b33872309)(false);
    let { basename: basename } = $040dbb9c344a508d$var$useDataRouterContext($040dbb9c344a508d$var$DataRouterHook.useViewTransitionState);
    let path = (0, $7939e29d663dd3ed$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $1d34d5c4a288b213$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" unstable_viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" unstable_viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $1d34d5c4a288b213$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("acw62");

parcelRequire("acw62");

function $e9bd92b954fbb741$var$Header() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("header", {
        className: "bg-blue-500 text-white p-6",
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h1", {
                className: "text-4xl",
                children: "Logan County Recovery"
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/",
                        end: true,
                        className: ({ isActive: isActive })=>isActive ? "text-white mx-4 hover:text-yellow-300 underline" : "text-white mx-2 hover:text-yellow-300",
                        children: "Home"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/want-to-help",
                        className: ({ isActive: isActive })=>isActive ? "text-white mx-4 hover:text-yellow-300 underline" : "text-white mx-2 hover:text-yellow-300",
                        children: "Volunteers"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$b0d92dbee9b5b60d), {
                        to: "/need-help",
                        className: ({ isActive: isActive })=>isActive ? "text-white mx-4 hover:text-yellow-300 underline" : "text-white mx-2 hover:text-yellow-300",
                        children: "Need Help"
                    })
                ]
            })
        ]
    });
}
var $e9bd92b954fbb741$export$2e2bcd8739ae039 = $e9bd92b954fbb741$var$Header;



parcelRequire("acw62");
function $5686e64eaa3841eb$var$Footer() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("footer", {
        className: "bg-blue-500 text-white p-8 mt-36 fixed bottom-0 left-0 w-screen h-12",
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
            children: [
                "Developed by ",
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                    href: "https://codefordayton.org",
                    className: "text-white underline",
                    children: "Code For Dayton"
                })
            ]
        })
    });
}
var $5686e64eaa3841eb$export$2e2bcd8739ae039 = $5686e64eaa3841eb$var$Footer;



function $a878297d5108f03e$var$HomePage() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9bd92b954fbb741$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: "p-6 mb-12",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "mb-12 w-full md:w-1/2 p-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("a", {
                            href: "https://www.uwlogan.org/indian-lake-tornado-community-response",
                            target: "_blank",
                            className: "block bg-white shadow-md rounded p-6 text-black no-underline",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl mb-4",
                                    children: "Want to Help?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Volunteers are needed to provide physical labor, remote phone support, and financial donations. Logan County United Way is coordinating these activities."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("section", {
                        className: "mb-12 w-full md:w-1/2 p-4",
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $040dbb9c344a508d$export$a6c7ac8248d6e38a), {
                            to: "/need-help",
                            className: "block bg-white shadow-md rounded p-6 text-black no-underline",
                            children: [
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                    className: "text-2xl mb-4",
                                    children: "Need Help?"
                                }),
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    children: "Information about resources and requirements for repair, reconstruction, and demolition, information on financial aid."
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("section", {
                        className: "mt-12",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("h2", {
                                className: "text-2xl mb-4",
                                children: "Resources"
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                children: "Links to useful resources for both those who want to help and those who need help."
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("ul", {
                                className: "list-disc list-inside",
                                children: [
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "https://loganco.nyc3.digitaloceanspaces.com/Ohio-Governor-DeWine-Presidential-Disaster-Declaration-Request-Letter-3-29-2024.pdf",
                                            target: "_blank",
                                            download: true,
                                            className: "text-blue-500 underline",
                                            children: "Declaration of Emergency"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "https://loganco.nyc3.digitaloceanspaces.com/Private%20Property%20Debris%20Removal%20-%20FEMA%20Guidance.pdf",
                                            target: "_blank",
                                            download: true,
                                            className: "text-blue-500 underline",
                                            children: "FEMA Debris Removal Guidance"
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                                            href: "https://www.epa.gov/natural-disasters/dealing-debris-and-damaged-buildings",
                                            target: "_blank",
                                            className: "text-blue-500 underline",
                                            children: "EPA Debris Removal Guidance"
                                        })
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5686e64eaa3841eb$export$2e2bcd8739ae039), {})
        ]
    });
}
var $a878297d5108f03e$export$2e2bcd8739ae039 = $a878297d5108f03e$var$HomePage;



parcelRequire("acw62");


function $3079aca9503d0e47$var$WantToHelp() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9bd92b954fbb741$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("main", {
                className: "p-6",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("p", {
                    children: [
                        "All volunteering is currently running through the United Way of Logan County. Find out how you can help ",
                        /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("a", {
                            className: "underline text-blue-500",
                            href: "https://www.uwlogan.org/indian-lake-tornado-community-response",
                            children: "HERE."
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5686e64eaa3841eb$export$2e2bcd8739ae039), {})
        ]
    });
}
var $3079aca9503d0e47$export$2e2bcd8739ae039 = $3079aca9503d0e47$var$WantToHelp;




var $acw62 = parcelRequire("acw62");



var $8dUxG = parcelRequire("8dUxG");
var $661535155caf22bb$exports = {};



/*!
 * surveyjs - Survey JavaScript library v1.9.137
 * Copyright (c) 2015-2024 Devsoft Baltic OÜ  - http://surveyjs.io/
 * License: MIT (http://www.opensource.org/licenses/mit-license.php)
 */ (function webpackUniversalModuleDefinition(root, factory) {
    $661535155caf22bb$exports = factory((parcelRequire("acw62")), (parcelRequire("1u0KT")), (parcelRequire("8dUxG")));
})($661535155caf22bb$exports, function(__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__, __WEBPACK_EXTERNAL_MODULE_survey_core__) {
    return /******/ function(modules) {
        /******/ // The module cache
        /******/ var installedModules = {};
        /******/ /******/ // The require function
        /******/ function __webpack_require__(moduleId) {
            /******/ /******/ // Check if module is in cache
            /******/ if (installedModules[moduleId]) /******/ return installedModules[moduleId].exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = installedModules[moduleId] = {
                /******/ i: moduleId,
                /******/ l: false,
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ modules[moduleId].call(module1.exports, module1, module1.exports, __webpack_require__);
            /******/ /******/ // Flag the module as loaded
            /******/ module1.l = true;
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /******/ /******/ // expose the modules object (__webpack_modules__)
        /******/ __webpack_require__.m = modules;
        /******/ /******/ // expose the module cache
        /******/ __webpack_require__.c = installedModules;
        /******/ /******/ // define getter function for harmony exports
        /******/ __webpack_require__.d = function(exports, name, getter) {
            /******/ if (!__webpack_require__.o(exports, name)) /******/ Object.defineProperty(exports, name, {
                enumerable: true,
                get: getter
            });
        /******/ };
        /******/ /******/ // define __esModule on exports
        /******/ __webpack_require__.r = function(exports) {
            /******/ if (typeof Symbol !== "undefined" && Symbol.toStringTag) /******/ Object.defineProperty(exports, Symbol.toStringTag, {
                value: "Module"
            });
            /******/ Object.defineProperty(exports, "__esModule", {
                value: true
            });
        /******/ };
        /******/ /******/ // create a fake namespace object
        /******/ // mode & 1: value is a module id, require it
        /******/ // mode & 2: merge all properties of value into the ns
        /******/ // mode & 4: return value when already ns object
        /******/ // mode & 8|1: behave like require
        /******/ __webpack_require__.t = function(value, mode) {
            /******/ if (mode & 1) value = __webpack_require__(value);
            /******/ if (mode & 8) return value;
            /******/ if (mode & 4 && typeof value === "object" && value && value.__esModule) return value;
            /******/ var ns = Object.create(null);
            /******/ __webpack_require__.r(ns);
            /******/ Object.defineProperty(ns, "default", {
                enumerable: true,
                value: value
            });
            /******/ if (mode & 2 && typeof value != "string") for(var key in value)__webpack_require__.d(ns, key, (function(key) {
                return value[key];
            }).bind(null, key));
            /******/ return ns;
        /******/ };
        /******/ /******/ // getDefaultExport function for compatibility with non-harmony modules
        /******/ __webpack_require__.n = function(module1) {
            /******/ var getter = module1 && module1.__esModule ? /******/ function getDefault() {
                return module1["default"];
            } : /******/ function getModuleExports() {
                return module1;
            };
            /******/ __webpack_require__.d(getter, "a", getter);
            /******/ return getter;
        /******/ };
        /******/ /******/ // Object.prototype.hasOwnProperty.call
        /******/ __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        };
        /******/ /******/ // __webpack_public_path__
        /******/ __webpack_require__.p = "";
        /******/ /******/ /******/ // Load entry module and return exports
        /******/ return __webpack_require__(__webpack_require__.s = "./src/entries/react-ui.ts");
    /******/ }({
        /***/ "./src/actions/action.ts": /*!*******************************!*\
  !*** ./src/actions/action.ts ***!
  \*******************************/ /*! exports provided: createDropdownActionModel, createDropdownActionModelAdvanced, getActionDropdownButtonTarget, BaseAction, Action, ActionDropdownViewModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDropdownActionModel", function() {
                return createDropdownActionModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDropdownActionModelAdvanced", function() {
                return createDropdownActionModelAdvanced;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getActionDropdownButtonTarget", function() {
                return getActionDropdownButtonTarget;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BaseAction", function() {
                return BaseAction;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Action", function() {
                return Action;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionDropdownViewModel", function() {
                return ActionDropdownViewModel;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../base */ "./src/base.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../list */ "./src/list.ts");
            /* harmony import */ var _popup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../popup */ "./src/popup.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./container */ "./src/actions/container.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            function createDropdownActionModel(actionOptions, dropdownOptions, locOwner) {
                return createDropdownActionModelAdvanced(actionOptions, dropdownOptions, dropdownOptions, locOwner);
            }
            function createDropdownActionModelAdvanced(actionOptions, listOptions, popupOptions, locOwner) {
                var listModel = new _list__WEBPACK_IMPORTED_MODULE_3__["ListModel"](listOptions.items, function(item) {
                    if (newAction.hasTitle) newAction.title = item.title;
                    listOptions.onSelectionChanged(item);
                    innerPopupModel.toggleVisibility();
                }, listOptions.allowSelection, listOptions.selectedItem, listOptions.onFilterStringChangedCallback);
                listModel.locOwner = locOwner;
                var innerPopupModel = new _popup__WEBPACK_IMPORTED_MODULE_4__["PopupModel"]("sv-list", {
                    model: listModel
                }, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.verticalPosition, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.horizontalPosition, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.showPointer, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.isModal, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.onCancel, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.onApply, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.onHide, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.onShow, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.cssClass, popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.title, function() {
                    listModel.dispose();
                });
                innerPopupModel.displayMode = popupOptions === null || popupOptions === void 0 ? void 0 : popupOptions.displayMode;
                var newActionOptions = Object.assign({}, actionOptions, {
                    component: "sv-action-bar-item-dropdown",
                    popupModel: innerPopupModel,
                    action: function(action, isUserAction) {
                        !!actionOptions.action && actionOptions.action();
                        innerPopupModel.isFocusedContent = !isUserAction || listModel.showFilter;
                        innerPopupModel.toggleVisibility();
                        listModel.scrollToSelectedItem();
                    }
                });
                var newAction = new Action(newActionOptions);
                newAction.data = listModel;
                return newAction;
            }
            function getActionDropdownButtonTarget(container) {
                return container === null || container === void 0 ? void 0 : container.previousElementSibling;
            }
            var BaseAction = /** @class */ function(_super) {
                __extends(BaseAction, _super);
                function BaseAction() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.iconSize = 24;
                    return _this;
                }
                Object.defineProperty(BaseAction.prototype, "visible", {
                    get: function() {
                        return this.getVisible();
                    },
                    set: function(val1) {
                        this.setVisible(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "enabled", {
                    get: function() {
                        return this.getEnabled();
                    },
                    set: function(val1) {
                        this.setEnabled(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "component", {
                    get: function() {
                        return this.getComponent();
                    },
                    set: function(val1) {
                        this.setComponent(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "locTitle", {
                    get: function() {
                        return this.getLocTitle();
                    },
                    set: function(val1) {
                        this.setLocTitle(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "title", {
                    get: function() {
                        return this.getTitle();
                    },
                    set: function(val1) {
                        this.setTitle(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "cssClasses", {
                    get: function() {
                        return this.cssClassesValue || _container__WEBPACK_IMPORTED_MODULE_6__["defaultActionBarCss"];
                    },
                    set: function(val1) {
                        this.cssClassesValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "isVisible", {
                    get: function() {
                        return this.visible && this.mode !== "popup" && this.mode !== "removed";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "disabled", {
                    get: function() {
                        return this.enabled !== undefined && !this.enabled;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "canShrink", {
                    get: function() {
                        return !!this.iconName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BaseAction.prototype, "hasTitle", {
                    get: function() {
                        return (this.mode != "small" && (this.showTitle || this.showTitle === undefined) || !this.iconName) && !!this.title;
                    },
                    enumerable: false,
                    configurable: true
                });
                BaseAction.prototype.getActionBarItemTitleCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.itemTitle).append(this.cssClasses.itemTitleWithIcon, !!this.iconName).toString();
                };
                BaseAction.prototype.getActionBarItemCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append(this.cssClasses.item).append(this.cssClasses.itemWithTitle, this.hasTitle).append(this.cssClasses.itemAsIcon, !this.hasTitle).append(this.cssClasses.itemActive, !!this.active).append(this.cssClasses.itemPressed, !!this.pressed).append(this.innerCss).toString();
                };
                BaseAction.prototype.getActionRootCss = function() {
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_5__["CssClassBuilder"]().append("sv-action").append(this.css).append("sv-action--space", this.needSpace).append("sv-action--hidden", !this.isVisible).toString();
                };
                BaseAction.prototype.getTooltip = function() {
                    return this.tooltip || this.title;
                };
                BaseAction.prototype.getIsTrusted = function(args) {
                    if (!!args.originalEvent) return args.originalEvent.isTrusted;
                    return args.isTrusted;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "tooltip", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "showTitle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "innerCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "active", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "pressed", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "data", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "popupModel", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "needSeparator", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "template", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: "large"
                    })
                ], BaseAction.prototype, "mode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "visibleIndex", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "disableTabStop", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "disableShrink", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "disableHide", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: false
                    })
                ], BaseAction.prototype, "needSpace", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "ariaChecked", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "ariaExpanded", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: "button"
                    })
                ], BaseAction.prototype, "ariaRole", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "iconName", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "iconSize", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], BaseAction.prototype, "css", void 0);
                return BaseAction;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            var Action = /** @class */ function(_super) {
                __extends(Action, _super);
                function Action(innerItem) {
                    var _this = _super.call(this) || this;
                    _this.innerItem = innerItem;
                    _this.locTitleChanged = function() {
                        var val1 = _this.locTitle.renderedHtml;
                        _this.setPropertyValue("_title", !!val1 ? val1 : undefined);
                    };
                    _this.locTitle = !!innerItem ? innerItem["locTitle"] : null;
                    //Object.assign(this, item) to support IE11
                    if (!!innerItem) {
                        for(var key in innerItem)if (key !== "locTitle") _this[key] = innerItem[key];
                    }
                    if (!!_this.locTitleName) _this.locTitleChanged();
                    _this.registerFunctionOnPropertyValueChanged("_title", function() {
                        _this.raiseUpdate(true);
                    });
                    _this.locStrChangedInPopupModel();
                    return _this;
                }
                Action.prototype.raiseUpdate = function(isResetInitialized) {
                    if (isResetInitialized === void 0) isResetInitialized = false;
                    this.updateCallback && this.updateCallback(isResetInitialized);
                };
                Action.prototype.createLocTitle = function() {
                    return this.createLocalizableString("title", this, true);
                };
                Action.prototype.getLocTitle = function() {
                    return this.locTitleValue;
                };
                Action.prototype.setLocTitle = function(val1) {
                    if (!val1 && !this.locTitleValue) val1 = this.createLocTitle();
                    if (!!this.locTitleValue) this.locTitleValue.onStringChanged.remove(this.locTitleChanged);
                    this.locTitleValue = val1;
                    this.locTitleValue.onStringChanged.add(this.locTitleChanged);
                    this.locTitleChanged();
                };
                Action.prototype.getTitle = function() {
                    return this._title;
                };
                Action.prototype.setTitle = function(val1) {
                    this._title = val1;
                };
                Object.defineProperty(Action.prototype, "locTitleName", {
                    get: function() {
                        return this.locTitle.localizationName;
                    },
                    set: function(val1) {
                        this.locTitle.localizationName = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Action.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.locTooltipChanged();
                    this.locStrChangedInPopupModel();
                };
                Action.prototype.locStrChangedInPopupModel = function() {
                    if (!this.popupModel || !this.popupModel.contentComponentData || !this.popupModel.contentComponentData.model) return;
                    var model = this.popupModel.contentComponentData.model;
                    if (Array.isArray(model.actions)) {
                        var actions = model.actions;
                        actions.forEach(function(item) {
                            if (!!item.locStrsChanged) item.locStrsChanged();
                        });
                    }
                };
                Action.prototype.locTooltipChanged = function() {
                    if (!this.locTooltipName) return;
                    this.tooltip = _surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].getString(this.locTooltipName, this.locTitle.locale);
                };
                //ILocalizableOwner
                Action.prototype.getLocale = function() {
                    return this.owner ? this.owner.getLocale() : "";
                };
                Action.prototype.getMarkdownHtml = function(text, name) {
                    return this.owner ? this.owner.getMarkdownHtml(text, name) : undefined;
                };
                Action.prototype.getProcessedText = function(text) {
                    return this.owner ? this.owner.getProcessedText(text) : text;
                };
                Action.prototype.getRenderer = function(name) {
                    return this.owner ? this.owner.getRenderer(name) : null;
                };
                Action.prototype.getRendererContext = function(locStr) {
                    return this.owner ? this.owner.getRendererContext(locStr) : locStr;
                };
                Action.prototype.setVisible = function(val1) {
                    this._visible = val1;
                };
                Action.prototype.getVisible = function() {
                    return this._visible;
                };
                Action.prototype.setEnabled = function(val1) {
                    this._enabled = val1;
                };
                Action.prototype.getEnabled = function() {
                    if (this.enabledIf) return this.enabledIf();
                    return this._enabled;
                };
                Action.prototype.setComponent = function(val1) {
                    this._component = val1;
                };
                Action.prototype.getComponent = function() {
                    return this._component;
                };
                Action.prototype.dispose = function() {
                    this.updateCallback = undefined;
                    this.action = undefined;
                    _super.prototype.dispose.call(this);
                    if (this.popupModel) this.popupModel.dispose();
                    if (!!this.locTitleValue) {
                        this.locTitleValue.onStringChanged.remove(this.locTitleChanged);
                        this.locTitleChanged = undefined;
                    }
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "id", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        defaultValue: true,
                        onSet: function(_, target) {
                            target.raiseUpdate();
                        }
                    })
                ], Action.prototype, "_visible", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        onSet: function(_, target) {
                            target.locTooltipChanged();
                        }
                    })
                ], Action.prototype, "locTooltipName", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "_enabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "action", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "_component", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])()
                ], Action.prototype, "items", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_2__["property"])({
                        onSet: function(val1, target) {
                            if (target.locTitleValue.text === val1) return;
                            target.locTitleValue.text = val1;
                        }
                    })
                ], Action.prototype, "_title", void 0);
                return Action;
            }(BaseAction);
            var ActionDropdownViewModel = /** @class */ function() {
                function ActionDropdownViewModel(item) {
                    this.item = item;
                    this.funcKey = "sv-dropdown-action";
                    this.setupPopupCallbacks();
                }
                ActionDropdownViewModel.prototype.setupPopupCallbacks = function() {
                    var _this = this;
                    var popupModel = this.popupModel = this.item.popupModel;
                    if (!popupModel) return;
                    popupModel.registerPropertyChangedHandlers([
                        "isVisible"
                    ], function() {
                        if (!popupModel.isVisible) _this.item.pressed = false;
                        else _this.item.pressed = true;
                    }, this.funcKey);
                };
                ActionDropdownViewModel.prototype.removePopupCallbacks = function() {
                    if (!!this.popupModel) this.popupModel.unregisterPropertyChangedHandlers([
                        "isVisible"
                    ], this.funcKey);
                };
                ActionDropdownViewModel.prototype.dispose = function() {
                    this.removePopupCallbacks();
                };
                return ActionDropdownViewModel;
            }();
        /***/ },
        /***/ "./src/actions/adaptive-container.ts": /*!*******************************************!*\
  !*** ./src/actions/adaptive-container.ts ***!
  \*******************************************/ /*! exports provided: AdaptiveActionContainer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AdaptiveActionContainer", function() {
                return AdaptiveActionContainer;
            });
            /* harmony import */ var _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/responsivity-manager */ "./src/utils/responsivity-manager.ts");
            /* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./action */ "./src/actions/action.ts");
            /* harmony import */ var _container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./container */ "./src/actions/container.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../surveyStrings */ "./src/surveyStrings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var AdaptiveActionContainer = /** @class */ function(_super) {
                __extends(AdaptiveActionContainer, _super);
                function AdaptiveActionContainer() {
                    var _this = _super.call(this) || this;
                    _this.minVisibleItemsCount = 0;
                    _this.isResponsivenessDisabled = false;
                    _this.dotsItem = Object(_action__WEBPACK_IMPORTED_MODULE_1__["createDropdownActionModelAdvanced"])({
                        id: "dotsItem-id" + AdaptiveActionContainer.ContainerID++,
                        css: "sv-dots",
                        innerCss: "sv-dots__item",
                        iconName: "icon-more",
                        visible: false,
                        tooltip: _surveyStrings__WEBPACK_IMPORTED_MODULE_3__["surveyLocalization"].getString("more")
                    }, {
                        items: [],
                        onSelectionChanged: function(item) {
                            _this.hiddenItemSelected(item);
                        },
                        allowSelection: false
                    });
                    return _this;
                }
                AdaptiveActionContainer.prototype.hideItemsGreaterN = function(visibleItemsCount) {
                    var actionsToHide = this.getActionsToHide();
                    visibleItemsCount = Math.max(visibleItemsCount, this.minVisibleItemsCount - (this.visibleActions.length - actionsToHide.length));
                    var hiddenItems = [];
                    actionsToHide.forEach(function(item) {
                        if (visibleItemsCount <= 0) {
                            if (item.removePriority) item.mode = "removed";
                            else {
                                item.mode = "popup";
                                hiddenItems.push(item.innerItem);
                            }
                        }
                        visibleItemsCount--;
                    });
                    this.hiddenItemsListModel.setItems(hiddenItems);
                };
                AdaptiveActionContainer.prototype.getActionsToHide = function() {
                    return this.visibleActions.filter(function(action) {
                        return !action.disableHide;
                    }).sort(function(a, b) {
                        return a.removePriority || 0 - b.removePriority || 0;
                    });
                };
                AdaptiveActionContainer.prototype.getVisibleItemsCount = function(availableSize) {
                    this.visibleActions.filter(function(action) {
                        return action.disableHide;
                    }).forEach(function(action) {
                        return availableSize -= action.minDimension;
                    });
                    var itemsSizes = this.getActionsToHide().map(function(item) {
                        return item.minDimension;
                    });
                    var currSize = 0;
                    for(var i = 0; i < itemsSizes.length; i++){
                        currSize += itemsSizes[i];
                        if (currSize > availableSize) return i;
                    }
                    return i;
                };
                AdaptiveActionContainer.prototype.updateItemMode = function(availableSize, itemsSize) {
                    var items = this.visibleActions;
                    for(var index = items.length - 1; index >= 0; index--)if (itemsSize > availableSize && !items[index].disableShrink) {
                        itemsSize -= items[index].maxDimension - items[index].minDimension;
                        items[index].mode = "small";
                    } else items[index].mode = "large";
                    if (itemsSize > availableSize) {
                        var hidableItems = this.visibleActions.filter(function(a) {
                            return a.removePriority;
                        });
                        hidableItems.sort(function(a, b) {
                            return a.removePriority - b.removePriority;
                        });
                        for(var index = 0; index < hidableItems.length; index++)if (itemsSize > availableSize) {
                            itemsSize -= items[index].disableShrink ? hidableItems[index].maxDimension : hidableItems[index].minDimension;
                            hidableItems[index].mode = "removed";
                        }
                    }
                };
                Object.defineProperty(AdaptiveActionContainer.prototype, "hiddenItemsListModel", {
                    get: function() {
                        return this.dotsItem.data;
                    },
                    enumerable: false,
                    configurable: true
                });
                AdaptiveActionContainer.prototype.hiddenItemSelected = function(item) {
                    if (!!item && typeof item.action === "function") item.action();
                };
                AdaptiveActionContainer.prototype.onSet = function() {
                    var _this = this;
                    this.actions.forEach(function(action) {
                        return action.updateCallback = function(isResetInitialized) {
                            return _this.raiseUpdate(isResetInitialized);
                        };
                    });
                    _super.prototype.onSet.call(this);
                };
                AdaptiveActionContainer.prototype.onPush = function(item) {
                    var _this = this;
                    item.updateCallback = function(isResetInitialized) {
                        return _this.raiseUpdate(isResetInitialized);
                    };
                    _super.prototype.onPush.call(this, item);
                };
                AdaptiveActionContainer.prototype.getRenderedActions = function() {
                    if (this.actions.length === 1 && !!this.actions[0].iconName) return this.actions;
                    return this.actions.concat([
                        this.dotsItem
                    ]);
                };
                AdaptiveActionContainer.prototype.raiseUpdate = function(isResetInitialized) {
                    if (!this.isResponsivenessDisabled) _super.prototype.raiseUpdate.call(this, isResetInitialized);
                };
                AdaptiveActionContainer.prototype.fit = function(dimension, dotsItemSize) {
                    if (dimension <= 0) return;
                    this.dotsItem.visible = false;
                    var minSize = 0;
                    var maxSize = 0;
                    var items = this.visibleActions;
                    items.forEach(function(item) {
                        minSize += item.minDimension;
                        maxSize += item.maxDimension;
                    });
                    if (dimension >= maxSize) this.setActionsMode("large");
                    else if (dimension < minSize) {
                        this.setActionsMode("small");
                        this.hideItemsGreaterN(this.getVisibleItemsCount(dimension - dotsItemSize));
                        this.dotsItem.visible = !!this.hiddenItemsListModel.actions.length;
                    } else this.updateItemMode(dimension, maxSize);
                };
                AdaptiveActionContainer.prototype.initResponsivityManager = function(container, delayedUpdateFunction) {
                    this.responsivityManager = new _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_0__["ResponsivityManager"](container, this, ":scope > .sv-action:not(.sv-dots) > .sv-action__content", null, delayedUpdateFunction);
                };
                AdaptiveActionContainer.prototype.resetResponsivityManager = function() {
                    if (!!this.responsivityManager) {
                        this.responsivityManager.dispose();
                        this.responsivityManager = undefined;
                    }
                };
                AdaptiveActionContainer.prototype.setActionsMode = function(mode) {
                    this.actions.forEach(function(action) {
                        if (mode == "small" && action.disableShrink) return;
                        action.mode = mode;
                    });
                };
                AdaptiveActionContainer.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.dotsItem.data.dispose();
                    this.dotsItem.dispose();
                    this.resetResponsivityManager();
                };
                AdaptiveActionContainer.ContainerID = 1;
                return AdaptiveActionContainer;
            }(_container__WEBPACK_IMPORTED_MODULE_2__["ActionContainer"]);
        /***/ },
        /***/ "./src/actions/container.ts": /*!**********************************!*\
  !*** ./src/actions/container.ts ***!
  \**********************************/ /*! exports provided: defaultActionBarCss, ActionContainer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultActionBarCss", function() {
                return defaultActionBarCss;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ActionContainer", function() {
                return ActionContainer;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../base */ "./src/base.ts");
            /* harmony import */ var _action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./action */ "./src/actions/action.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var defaultActionBarCss = {
                root: "sv-action-bar",
                defaultSizeMode: "sv-action-bar--default-size-mode",
                smallSizeMode: "sv-action-bar--small-size-mode",
                item: "sv-action-bar-item",
                itemWithTitle: "",
                itemAsIcon: "sv-action-bar-item--icon",
                itemActive: "sv-action-bar-item--active",
                itemPressed: "sv-action-bar-item--pressed",
                itemIcon: "sv-action-bar-item__icon",
                itemTitle: "sv-action-bar-item__title",
                itemTitleWithIcon: "sv-action-bar-item__title--with-icon"
            };
            var ActionContainer = /** @class */ function(_super) {
                __extends(ActionContainer, _super);
                function ActionContainer() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.sizeMode = "default";
                    return _this;
                }
                ActionContainer.prototype.getMarkdownHtml = function(text, name) {
                    return !!this.locOwner ? this.locOwner.getMarkdownHtml(text, name) : undefined;
                };
                ActionContainer.prototype.getRenderer = function(name) {
                    return !!this.locOwner ? this.locOwner.getRenderer(name) : null;
                };
                ActionContainer.prototype.getRendererContext = function(locStr) {
                    return !!this.locOwner ? this.locOwner.getRendererContext(locStr) : locStr;
                };
                ActionContainer.prototype.getProcessedText = function(text) {
                    return this.locOwner ? this.locOwner.getProcessedText(text) : text;
                };
                ActionContainer.prototype.getLocale = function() {
                    return !!this.locOwner ? this.locOwner.getLocale() : "";
                };
                ActionContainer.prototype.getRenderedActions = function() {
                    return this.actions;
                };
                ActionContainer.prototype.locStrsChanged = function() {
                    _super.prototype.locStrsChanged.call(this);
                    this.actions.forEach(function(item) {
                        if (item.locTitle) item.locTitle.strChanged();
                        item.locStrsChanged();
                    });
                };
                ActionContainer.prototype.raiseUpdate = function(isResetInitialized) {
                    this.isEmpty = !this.actions.some(function(action) {
                        return action.visible;
                    });
                    this.updateCallback && this.updateCallback(isResetInitialized);
                };
                ActionContainer.prototype.onSet = function() {
                    var _this = this;
                    this.actions.forEach(function(item) {
                        _this.setActionCssClasses(item);
                    });
                    this.raiseUpdate(true);
                };
                ActionContainer.prototype.onPush = function(item) {
                    this.setActionCssClasses(item);
                    item.owner = this;
                    this.raiseUpdate(true);
                };
                ActionContainer.prototype.onRemove = function(item) {
                    item.owner = null;
                    this.raiseUpdate(true);
                };
                ActionContainer.prototype.setActionCssClasses = function(item) {
                    item.cssClasses = this.cssClasses;
                };
                Object.defineProperty(ActionContainer.prototype, "hasActions", {
                    get: function() {
                        return (this.actions || []).length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ActionContainer.prototype, "renderedActions", {
                    get: function() {
                        return this.getRenderedActions();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ActionContainer.prototype, "visibleActions", {
                    get: function() {
                        return this.actions.filter(function(action) {
                            return action.visible !== false;
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                ActionContainer.prototype.getRootCss = function() {
                    var sizeModeClass = this.sizeMode === "small" ? this.cssClasses.smallSizeMode : this.cssClasses.defaultSizeMode;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(this.cssClasses.root + (!!sizeModeClass ? " " + sizeModeClass : "") + (!!this.containerCss ? " " + this.containerCss : "")).append(this.cssClasses.root + "--empty", this.isEmpty).toString();
                };
                ActionContainer.prototype.getDefaultCssClasses = function() {
                    return defaultActionBarCss;
                };
                Object.defineProperty(ActionContainer.prototype, "cssClasses", {
                    get: function() {
                        if (!this.cssClassesValue) this.cssClassesValue = this.getDefaultCssClasses();
                        return this.cssClassesValue;
                    },
                    set: function(val1) {
                        var _this = this;
                        this.cssClassesValue = {};
                        this.copyCssClasses(this.cssClassesValue, this.getDefaultCssClasses());
                        Object(_utils_utils__WEBPACK_IMPORTED_MODULE_4__["mergeValues"])(val1, this.cssClasses);
                        this.actions.forEach(function(action) {
                            _this.setActionCssClasses(action);
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                ActionContainer.prototype.createAction = function(item) {
                    return item instanceof _action__WEBPACK_IMPORTED_MODULE_2__["BaseAction"] ? item : new _action__WEBPACK_IMPORTED_MODULE_2__["Action"](item);
                };
                ActionContainer.prototype.addAction = function(val1, sortByVisibleIndex) {
                    if (sortByVisibleIndex === void 0) sortByVisibleIndex = true;
                    var res = this.createAction(val1);
                    this.actions.push(res);
                    this.sortItems();
                    return res;
                };
                ActionContainer.prototype.sortItems = function() {
                    this.actions = [].concat(this.actions.filter(function(item) {
                        return item.visibleIndex === undefined || item.visibleIndex >= 0;
                    })).sort(function(firstItem, secondItem) {
                        return firstItem.visibleIndex - secondItem.visibleIndex;
                    });
                };
                ActionContainer.prototype.setItems = function(items, sortByVisibleIndex) {
                    var _this = this;
                    if (sortByVisibleIndex === void 0) sortByVisibleIndex = true;
                    this.actions = items.map(function(item) {
                        return _this.createAction(item);
                    });
                    if (sortByVisibleIndex) this.sortItems();
                };
                ActionContainer.prototype.initResponsivityManager = function(container, delayedUpdateFunction) {
                    return;
                };
                ActionContainer.prototype.resetResponsivityManager = function() {};
                ActionContainer.prototype.getActionById = function(id) {
                    for(var i = 0; i < this.actions.length; i++){
                        if (this.actions[i].id === id) return this.actions[i];
                    }
                    return null;
                };
                ActionContainer.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.actions.forEach(function(action) {
                        return action.dispose();
                    });
                    this.actions.length = 0;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["propertyArray"])({
                        onSet: function(_, target) {
                            target.onSet();
                        },
                        onPush: function(item, i, target) {
                            target.onPush(item);
                        },
                        onRemove: function(item, i, target) {
                            target.onRemove(item);
                        }
                    })
                ], ActionContainer.prototype, "actions", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], ActionContainer.prototype, "containerCss", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ActionContainer.prototype, "isEmpty", void 0);
                return ActionContainer;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
        /***/ },
        /***/ "./src/base.ts": /*!*********************!*\
  !*** ./src/base.ts ***!
  \*********************/ /*! exports provided: Bindings, Dependencies, ComputedUpdater, Base, ArrayChanges, Event, EventBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Bindings", function() {
                return Bindings;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Dependencies", function() {
                return Dependencies;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComputedUpdater", function() {
                return ComputedUpdater;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Base", function() {
                return Base;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayChanges", function() {
                return ArrayChanges;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Event", function() {
                return Event;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "EventBase", function() {
                return EventBase;
            });
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _conditions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./conditions */ "./src/conditions.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __spreadArray = function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            var Bindings = /** @class */ function() {
                function Bindings(obj) {
                    this.obj = obj;
                    this.properties = null;
                    this.values = null;
                }
                Bindings.prototype.getType = function() {
                    return "bindings";
                };
                Bindings.prototype.getNames = function() {
                    var res = [];
                    this.fillProperties();
                    for(var i = 0; i < this.properties.length; i++)if (this.properties[i].isVisible("", this.obj)) res.push(this.properties[i].name);
                    return res;
                };
                Bindings.prototype.getProperties = function() {
                    var res = [];
                    this.fillProperties();
                    for(var i = 0; i < this.properties.length; i++)res.push(this.properties[i]);
                    return res;
                };
                Bindings.prototype.setBinding = function(propertyName, valueName) {
                    if (!this.values) this.values = {};
                    var oldValue = this.getJson();
                    if (oldValue === valueName) return;
                    if (!!valueName) this.values[propertyName] = valueName;
                    else {
                        delete this.values[propertyName];
                        if (Object.keys(this.values).length == 0) this.values = null;
                    }
                    this.onChangedJSON(oldValue);
                };
                Bindings.prototype.clearBinding = function(propertyName) {
                    this.setBinding(propertyName, "");
                };
                Bindings.prototype.isEmpty = function() {
                    if (!this.values) return true;
                    for(var key in this.values)return false;
                    return true;
                };
                Bindings.prototype.getValueNameByPropertyName = function(propertyName) {
                    if (!this.values) return undefined;
                    return this.values[propertyName];
                };
                Bindings.prototype.getPropertiesByValueName = function(valueName) {
                    if (!this.values) return [];
                    var res = [];
                    for(var key in this.values)if (this.values[key] == valueName) res.push(key);
                    return res;
                };
                Bindings.prototype.getJson = function() {
                    if (this.isEmpty()) return undefined;
                    var res = {};
                    for(var key in this.values)res[key] = this.values[key];
                    return res;
                };
                Bindings.prototype.setJson = function(value) {
                    var oldValue = this.getJson();
                    this.values = null;
                    if (!!value) {
                        this.values = {};
                        for(var key in value)this.values[key] = value[key];
                    }
                    this.onChangedJSON(oldValue);
                };
                Bindings.prototype.fillProperties = function() {
                    if (this.properties !== null) return;
                    this.properties = [];
                    var objProperties = _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].getPropertiesByObj(this.obj);
                    for(var i = 0; i < objProperties.length; i++)if (objProperties[i].isBindable) this.properties.push(objProperties[i]);
                };
                Bindings.prototype.onChangedJSON = function(oldValue) {
                    if (this.obj) this.obj.onBindingChanged(oldValue, this.getJson());
                };
                return Bindings;
            }();
            var Dependencies = /** @class */ function() {
                function Dependencies(currentDependency, target, property) {
                    this.currentDependency = currentDependency;
                    this.target = target;
                    this.property = property;
                    this.dependencies = [];
                    this.id = "" + ++Dependencies.DependenciesCount;
                }
                Dependencies.prototype.addDependency = function(target, property) {
                    if (this.target === target && this.property === property) return;
                    if (this.dependencies.some(function(dependency) {
                        return dependency.obj === target && dependency.prop === property;
                    })) return;
                    this.dependencies.push({
                        obj: target,
                        prop: property,
                        id: this.id
                    });
                    target.registerPropertyChangedHandlers([
                        property
                    ], this.currentDependency, this.id);
                };
                Dependencies.prototype.dispose = function() {
                    this.dependencies.forEach(function(dependency) {
                        dependency.obj.unregisterPropertyChangedHandlers([
                            dependency.prop
                        ], dependency.id);
                    });
                // this.currentDependency = undefined;
                };
                Dependencies.DependenciesCount = 0;
                return Dependencies;
            }();
            var ComputedUpdater = /** @class */ function() {
                function ComputedUpdater(_updater) {
                    this._updater = _updater;
                    this.dependencies = undefined;
                    this.type = ComputedUpdater.ComputedUpdaterType;
                }
                Object.defineProperty(ComputedUpdater.prototype, "updater", {
                    get: function() {
                        return this._updater;
                    },
                    enumerable: false,
                    configurable: true
                });
                ComputedUpdater.prototype.setDependencies = function(dependencies) {
                    this.clearDependencies();
                    this.dependencies = dependencies;
                };
                ComputedUpdater.prototype.getDependencies = function() {
                    return this.dependencies;
                };
                ComputedUpdater.prototype.clearDependencies = function() {
                    if (this.dependencies) {
                        this.dependencies.dispose();
                        this.dependencies = undefined;
                    }
                };
                ComputedUpdater.prototype.dispose = function() {
                    this.clearDependencies();
                };
                ComputedUpdater.ComputedUpdaterType = "__dependency_computed";
                return ComputedUpdater;
            }();
            /**
 * A base class for all SurveyJS objects.
 */ var Base = /** @class */ function() {
                function Base() {
                    this.dependencies = {};
                    this.propertyHash = Base.createPropertiesHash();
                    this.eventList = [];
                    this.isLoadingFromJsonValue = false;
                    this.loadingOwner = null;
                    /**
         * An event that is raised when a property of this SurveyJS object has changed.
         *
         * Parameters:
         *
         * - `sender`: `this`\
         * A SurveyJS object whose property has changed.
         * - `options.name`: `string`\
         * The name of the changed property.
         * - `options.newValue`: `any`\
         * A new value for the property.
         * - `options.oldValue`: `any`\
         * An old value of the property. If the property is an array, `oldValue` contains the same array as `newValue` does.
         */ this.onPropertyChanged = this.addEvent();
                    /**
         * An event that is raised when an [`ItemValue`](https://surveyjs.io/form-library/documentation/itemvalue) property is changed.
         *
         * Parameters:
         *
         * - `sender`: `this`\
         * A SurveyJS object whose property contains an array of `ItemValue` objects.
         * - `options.obj`: [`ItemValue`](https://surveyjs.io/form-library/documentation/itemvalue)\
         * An `ItemValue` object.
         * - `options.propertyName`: `string`\
         * The name of the property to which an array of `ItemValue` objects is assigned (for example, `"choices"` or `"rows"`).
         * - `options.name`: `"text"` | `"value"`\
         * The name of the changed property.
         * - `options.newValue`: `any`\
         * A new value for the property.
         */ this.onItemValuePropertyChanged = this.addEvent();
                    this.isCreating = true;
                    this.bindingsValue = new Bindings(this);
                    _jsonobject__WEBPACK_IMPORTED_MODULE_2__["CustomPropertiesCollection"].createProperties(this);
                    this.onBaseCreating();
                    this.isCreating = false;
                }
                Base.finishCollectDependencies = function() {
                    var deps = Base.currentDependencis;
                    Base.currentDependencis = undefined;
                    return deps;
                };
                Base.startCollectDependencies = function(updater, target, property) {
                    if (Base.currentDependencis !== undefined) throw new Error("Attempt to collect nested dependencies. Nested dependencies are not supported.");
                    Base.currentDependencis = new Dependencies(updater, target, property);
                };
                Base.collectDependency = function(target, property) {
                    if (Base.currentDependencis === undefined) return;
                    Base.currentDependencis.addDependency(target, property);
                };
                Object.defineProperty(Base, "commentSuffix", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].commentSuffix;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].commentSuffix = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Base, "commentPrefix", {
                    get: function() {
                        return Base.commentSuffix;
                    },
                    set: function(val1) {
                        Base.commentSuffix = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Returns `true` if a passed `value` is an empty string, array, or object or if it equals to `undefined` or `null`.
     *
     * @param value A value to be checked.
     * @param trimString *(Optional)* When this parameter is `true`, the method ignores whitespace characters at the beginning and end of a string value. Pass `false` to disable this functionality.
     */ Base.prototype.isValueEmpty = function(value, trimString) {
                    if (trimString === void 0) trimString = true;
                    if (trimString) value = this.trimValue(value);
                    return _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isValueEmpty(value);
                };
                Base.prototype.equals = function(obj) {
                    if (!obj) return false;
                    if (this.isDisposed || obj.isDisposed) return false;
                    if (this.getType() != obj.getType()) return false;
                    return this.equalsCore(obj);
                };
                Base.prototype.equalsCore = function(obj) {
                    if (this.name !== obj.name) return false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(this.toJSON(), obj.toJSON(), false, true, false);
                };
                Base.prototype.trimValue = function(value) {
                    if (!!value && (typeof value === "string" || value instanceof String)) return value.trim();
                    return value;
                };
                Base.prototype.isPropertyEmpty = function(value) {
                    return value !== "" && this.isValueEmpty(value);
                };
                Base.createPropertiesHash = function() {
                    return {};
                };
                Base.prototype.dispose = function() {
                    var _this = this;
                    for(var i = 0; i < this.eventList.length; i++)this.eventList[i].clear();
                    this.onPropertyValueChangedCallback = undefined;
                    this.isDisposedValue = true;
                    Object.keys(this.dependencies).forEach(function(key) {
                        return _this.dependencies[key].dispose();
                    });
                };
                Object.defineProperty(Base.prototype, "isDisposed", {
                    get: function() {
                        return this.isDisposedValue === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.addEvent = function() {
                    var res = new EventBase();
                    this.eventList.push(res);
                    return res;
                };
                Base.prototype.onBaseCreating = function() {};
                /**
     * Returns the object type as it is used in the JSON schema.
     */ Base.prototype.getType = function() {
                    return "base";
                };
                /**
     * Use this method to find out if the current object is of a given `typeName` or inherited from it.
     *
     * @param typeName One of the values listed in the [getType()](https://surveyjs.io/form-library/documentation/question#getType) description.
     * @returns `true` if the current object is of a given `typeName` or inherited from it.
     * @see getType
     */ Base.prototype.isDescendantOf = function(typeName) {
                    return _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].isDescendantOf(this.getType(), typeName);
                };
                Base.prototype.getSurvey = function(isLive) {
                    if (isLive === void 0) isLive = false;
                    return null;
                };
                Object.defineProperty(Base.prototype, "isDesignMode", {
                    /**
         * Returns `true` if the survey is being designed in Survey Creator.
         */ get: function() {
                        var survey = this.getSurvey();
                        return !!survey && survey.isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Base.prototype, "isDesignModeV2", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].supportCreatorV2 && this.isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Base.prototype, "inSurvey", {
                    /**
         * Returns `true` if the object is included in a survey.
         *
         * This property may return `false`, for example, when you [create a survey model dynamically](https://surveyjs.io/form-library/documentation/design-survey-create-a-simple-survey#create-or-change-a-survey-model-dynamically).
         */ get: function() {
                        return !!this.getSurvey(true);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Base.prototype, "bindings", {
                    get: function() {
                        return this.bindingsValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.checkBindings = function(valueName, value) {};
                Base.prototype.updateBindings = function(propertyName, value) {
                    var valueName = this.bindings.getValueNameByPropertyName(propertyName);
                    if (!!valueName) this.updateBindingValue(valueName, value);
                };
                Base.prototype.updateBindingValue = function(valueName, value) {};
                Base.prototype.getTemplate = function() {
                    return this.getType();
                };
                Object.defineProperty(Base.prototype, "isLoadingFromJson", {
                    /**
         * Returns `true` if the object configuration is being loaded from JSON.
         */ get: function() {
                        return this.isLoadingFromJsonValue || this.getIsLoadingFromJson();
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.getIsLoadingFromJson = function() {
                    if (!!this.loadingOwner && this.loadingOwner.isLoadingFromJson) return true;
                    return this.isLoadingFromJsonValue;
                };
                Base.prototype.startLoadingFromJson = function(json) {
                    this.isLoadingFromJsonValue = true;
                    this.jsonObj = json;
                };
                Base.prototype.endLoadingFromJson = function() {
                    this.isLoadingFromJsonValue = false;
                };
                /**
     * Returns a JSON object that corresponds to the current SurveyJS object.
     * @see fromJSON
     */ Base.prototype.toJSON = function(options) {
                    return new _jsonobject__WEBPACK_IMPORTED_MODULE_2__["JsonObject"]().toJsonObject(this, options);
                };
                /**
     * Assigns a new configuration to the current SurveyJS object. This configuration is taken from a passed JSON object.
     *
     * The JSON object should contain only serializable properties of this SurveyJS object. Event handlers and properties that do not belong to the SurveyJS object are ignored.
     *
     * @param json A JSON object with properties that you want to apply to the current SurveyJS object.
     * @param options An object with configuration options.
     * @param {boolean} options.validatePropertyValues Pass `true` if you want to validate property values. Use the [`jsonErrors`](#jsonErrors) array to access validation errors.
     * @see toJSON
     */ Base.prototype.fromJSON = function(json, options) {
                    new _jsonobject__WEBPACK_IMPORTED_MODULE_2__["JsonObject"]().toObject(json, this, options);
                    this.onSurveyLoad();
                };
                Base.prototype.onSurveyLoad = function() {};
                /**
     * Creates a new object that has the same type and properties as the current SurveyJS object.
     */ Base.prototype.clone = function() {
                    var clonedObj = _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].createClass(this.getType());
                    clonedObj.fromJSON(this.toJSON());
                    return clonedObj;
                };
                /**
     * Returns a `JsonObjectProperty` object with metadata about a serializable property that belongs to the current SurveyJS object.
     *
     * If the property is not found, this method returns `null`.
     * @param propName A property name.
     */ Base.prototype.getPropertyByName = function(propName) {
                    var type = this.getType();
                    if (!this.classMetaData || this.classMetaData.name !== type) this.classMetaData = _jsonobject__WEBPACK_IMPORTED_MODULE_2__["Serializer"].findClass(type);
                    return !!this.classMetaData ? this.classMetaData.findProperty(propName) : null;
                };
                Base.prototype.isPropertyVisible = function(propName) {
                    var prop = this.getPropertyByName(propName);
                    return !!prop ? prop.isVisible("", this) : false;
                };
                Base.createProgressInfo = function() {
                    return {
                        questionCount: 0,
                        answeredQuestionCount: 0,
                        requiredQuestionCount: 0,
                        requiredAnsweredQuestionCount: 0
                    };
                };
                Base.prototype.getProgressInfo = function() {
                    return Base.createProgressInfo();
                };
                Base.prototype.localeChanged = function() {};
                Base.prototype.locStrsChanged = function() {
                    if (!!this.arraysInfo) for(var key in this.arraysInfo){
                        var item = this.arraysInfo[key];
                        if (item && item.isItemValues) {
                            var arr = this.getPropertyValue(key);
                            if (arr && !!Base.itemValueLocStrChanged) Base.itemValueLocStrChanged(arr);
                        }
                    }
                    if (!!this.localizableStrings) for(var key in this.localizableStrings){
                        var item = this.getLocalizableString(key);
                        if (item) item.strChanged();
                    }
                };
                /**
     * Returns the value of a property with a specified name.
     *
     * If the property is not found or does not have a value, this method returns either `undefined`, `defaultValue` specified in the property configuration, or a value passed as the `defaultValue` parameter.
     *
     * @param name A property name.
     * @param defaultValue *(Optional)* A value to return if the property is not found or does not have a value.
     */ Base.prototype.getPropertyValue = function(name, defaultValue) {
                    if (defaultValue === void 0) defaultValue = null;
                    var res = this.getPropertyValueWithoutDefault(name);
                    if (this.isPropertyEmpty(res)) {
                        var locStr = this.localizableStrings ? this.localizableStrings[name] : undefined;
                        if (locStr) return locStr.text;
                        if (defaultValue !== null && defaultValue !== undefined) return defaultValue;
                        var propDefaultValue = this.getDefaultPropertyValue(name);
                        if (propDefaultValue !== undefined) return propDefaultValue;
                    }
                    return res;
                };
                Base.prototype.getDefaultPropertyValue = function(name) {
                    var prop = this.getPropertyByName(name);
                    if (!prop || prop.isCustom && this.isCreating) return undefined;
                    var dValue = prop.defaultValue;
                    if (!this.isPropertyEmpty(dValue) && !Array.isArray(dValue)) return dValue;
                    var locStr = this.localizableStrings ? this.localizableStrings[name] : undefined;
                    if (locStr && locStr.localizationName) return this.getLocalizationString(locStr.localizationName);
                    if (prop.type == "boolean" || prop.type == "switch") return false;
                    if (prop.isCustom && !!prop.onGetValue) return prop.onGetValue(this);
                    return undefined;
                };
                Base.prototype.hasDefaultPropertyValue = function(name) {
                    return this.getDefaultPropertyValue(name) !== undefined;
                };
                Base.prototype.resetPropertyValue = function(name) {
                    var locStr = this.localizableStrings ? this.localizableStrings[name] : undefined;
                    if (locStr) {
                        this.setLocalizableStringText(name, undefined);
                        locStr.clear();
                    } else this.setPropertyValue(name, undefined);
                };
                Base.prototype.getPropertyValueWithoutDefault = function(name) {
                    return this.getPropertyValueCore(this.propertyHash, name);
                };
                Base.prototype.getPropertyValueCore = function(propertiesHash, name) {
                    if (!this.isLoadingFromJson) Base.collectDependency(this, name);
                    if (this.getPropertyValueCoreHandler) return this.getPropertyValueCoreHandler(propertiesHash, name);
                    else return propertiesHash[name];
                };
                Base.prototype.geValueFromHash = function() {
                    return this.propertyHash["value"];
                };
                Base.prototype.setPropertyValueCore = function(propertiesHash, name, val1) {
                    if (this.setPropertyValueCoreHandler) {
                        if (!this.isDisposedValue) this.setPropertyValueCoreHandler(propertiesHash, name, val1);
                        else _console_warnings__WEBPACK_IMPORTED_MODULE_6__["ConsoleWarnings"].disposedObjectChangedProperty(name, this.getType());
                    } else propertiesHash[name] = val1;
                };
                Object.defineProperty(Base.prototype, "isEditingSurveyElement", {
                    get: function() {
                        var survey = this.getSurvey();
                        return !!survey && survey.isEditingSurveyElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.iteratePropertiesHash = function(func) {
                    var _this = this;
                    var keys = [];
                    for(var key in this.propertyHash){
                        if (key === "value" && this.isEditingSurveyElement && Array.isArray(this.value)) continue;
                        keys.push(key);
                    }
                    keys.forEach(function(key) {
                        return func(_this.propertyHash, key);
                    });
                };
                /**
     * Assigns a new value to a specified property.
     * @param name A property name.
     * @param val A new value for the property.
     */ Base.prototype.setPropertyValue = function(name, val1) {
                    name;
                    if (!this.isLoadingFromJson) {
                        var prop = this.getPropertyByName(name);
                        if (!!prop) val1 = prop.settingValue(this, val1);
                    }
                    var oldValue = this.getPropertyValue(name);
                    if (oldValue && Array.isArray(oldValue) && !!this.arraysInfo && (!val1 || Array.isArray(val1))) {
                        if (!this.isTwoValueEquals(oldValue, val1)) this.setArrayPropertyDirectly(name, val1);
                    } else {
                        this.setPropertyValueDirectly(name, val1);
                        if (!this.isDisposedValue && !this.isTwoValueEquals(oldValue, val1)) this.propertyValueChanged(name, oldValue, val1);
                    }
                };
                Base.prototype.setArrayPropertyDirectly = function(name, val1, sendNotification) {
                    if (sendNotification === void 0) sendNotification = true;
                    var arrayInfo = this.arraysInfo[name];
                    this.setArray(name, this.getPropertyValue(name), val1, arrayInfo ? arrayInfo.isItemValues : false, arrayInfo ? sendNotification && arrayInfo.onPush : null);
                };
                Base.prototype.setPropertyValueDirectly = function(name, val1) {
                    this.setPropertyValueCore(this.propertyHash, name, val1);
                };
                Base.prototype.clearPropertyValue = function(name) {
                    this.setPropertyValueCore(this.propertyHash, name, null);
                    delete this.propertyHash[name];
                };
                Base.prototype.onPropertyValueChangedCallback = function(name, oldValue, newValue, sender, arrayChanges) {};
                Base.prototype.itemValuePropertyChanged = function(item, name, oldValue, newValue) {
                    this.onItemValuePropertyChanged.fire(this, {
                        obj: item,
                        name: name,
                        oldValue: oldValue,
                        newValue: newValue,
                        propertyName: item.ownerPropertyName
                    });
                };
                Base.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {};
                Base.prototype.propertyValueChanged = function(name, oldValue, newValue, arrayChanges, target) {
                    if (this.isLoadingFromJson) return;
                    this.updateBindings(name, newValue);
                    this.onPropertyValueChanged(name, oldValue, newValue);
                    this.onPropertyChanged.fire(this, {
                        name: name,
                        oldValue: oldValue,
                        newValue: newValue
                    });
                    this.doPropertyValueChangedCallback(name, oldValue, newValue, arrayChanges, this);
                    this.checkConditionPropertyChanged(name);
                    if (!this.onPropChangeFunctions) return;
                    for(var i = 0; i < this.onPropChangeFunctions.length; i++)if (this.onPropChangeFunctions[i].name == name) this.onPropChangeFunctions[i].func(newValue, arrayChanges);
                };
                Base.prototype.onBindingChanged = function(oldValue, newValue) {
                    if (this.isLoadingFromJson) return;
                    this.doPropertyValueChangedCallback("bindings", oldValue, newValue);
                };
                Object.defineProperty(Base.prototype, "isInternal", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.doPropertyValueChangedCallback = function(name, oldValue, newValue, arrayChanges, target) {
                    var fireCallback = function(obj) {
                        if (!!obj && !!obj.onPropertyValueChangedCallback) obj.onPropertyValueChangedCallback(name, oldValue, newValue, target, arrayChanges);
                    };
                    if (this.isInternal) {
                        fireCallback(this);
                        return;
                    }
                    if (!target) target = this;
                    var notifier = this.getSurvey();
                    if (!notifier) notifier = this;
                    fireCallback(notifier);
                    if (notifier !== this) fireCallback(this);
                };
                Base.prototype.addExpressionProperty = function(name, onExecute, canRun) {
                    if (!this.expressionInfo) this.expressionInfo = {};
                    this.expressionInfo[name] = {
                        onExecute: onExecute,
                        canRun: canRun
                    };
                };
                Base.prototype.getDataFilteredValues = function() {
                    return {};
                };
                Base.prototype.getDataFilteredProperties = function() {
                    return {};
                };
                Base.prototype.runConditionCore = function(values, properties) {
                    if (!this.expressionInfo) return;
                    for(var key in this.expressionInfo)this.runConditionItemCore(key, values, properties);
                };
                Base.prototype.canRunConditions = function() {
                    return !this.isDesignMode;
                };
                Base.prototype.checkConditionPropertyChanged = function(propName) {
                    if (!this.expressionInfo || !this.expressionInfo[propName]) return;
                    if (!this.canRunConditions()) return;
                    this.runConditionItemCore(propName, this.getDataFilteredValues(), this.getDataFilteredProperties());
                };
                Base.prototype.runConditionItemCore = function(propName, values, properties) {
                    var _this = this;
                    var info = this.expressionInfo[propName];
                    var expression = this.getPropertyValue(propName);
                    if (!expression) return;
                    if (!!info.canRun && !info.canRun(this)) return;
                    if (!info.runner) {
                        info.runner = this.createExpressionRunner(expression);
                        info.runner.onRunComplete = function(res) {
                            info.onExecute(_this, res);
                        };
                    }
                    info.runner.expression = expression;
                    info.runner.run(values, properties);
                };
                Base.prototype.doBeforeAsynRun = function(id) {
                    if (!this.asynExpressionHash) this.asynExpressionHash = [];
                    var isChanged = !this.isAsyncExpressionRunning;
                    this.asynExpressionHash[id] = true;
                    if (isChanged) this.onAsyncRunningChanged();
                };
                Base.prototype.doAfterAsynRun = function(id) {
                    if (!!this.asynExpressionHash) {
                        delete this.asynExpressionHash[id];
                        if (!this.isAsyncExpressionRunning) this.onAsyncRunningChanged();
                    }
                };
                Base.prototype.onAsyncRunningChanged = function() {};
                Object.defineProperty(Base.prototype, "isAsyncExpressionRunning", {
                    get: function() {
                        return !!this.asynExpressionHash && Object.keys(this.asynExpressionHash).length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Base.prototype.createExpressionRunner = function(expression) {
                    var _this = this;
                    var res = new _conditions__WEBPACK_IMPORTED_MODULE_4__["ExpressionRunner"](expression);
                    res.onBeforeAsyncRun = function(id) {
                        _this.doBeforeAsynRun(id);
                    };
                    res.onAfterAsyncRun = function(id) {
                        _this.doAfterAsynRun(id);
                    };
                    return res;
                };
                /**
     * Registers a function to call when a property value changes.
     * @param propertyNames An array of one or multiple property names.
     * @param handler A function to call when one of the listed properties change.
     * @param key *(Optional)* A key that identifies the current registration. If a function for one of the properties is already registered with the same key, the function will be overwritten. You can also use the key to subsequently unregister handlers.
     * @see unregisterPropertyChangedHandlers
     */ Base.prototype.registerPropertyChangedHandlers = function(propertyNames, handler, key) {
                    if (key === void 0) key = null;
                    for(var i = 0; i < propertyNames.length; i++)this.registerFunctionOnPropertyValueChanged(propertyNames[i], handler, key);
                };
                /**
     * Unregisters value change event handlers for the specified properties.
     * @param propertyNames An array of one or multiple property names.
     * @param key *(Optional)* A key of the registration that you want to cancel.
     * @see registerPropertyChangedHandlers
     */ Base.prototype.unregisterPropertyChangedHandlers = function(propertyNames, key) {
                    if (key === void 0) key = null;
                    for(var i = 0; i < propertyNames.length; i++)this.unRegisterFunctionOnPropertyValueChanged(propertyNames[i], key);
                };
                Base.prototype.registerFunctionOnPropertyValueChanged = function(name, func, key) {
                    if (key === void 0) key = null;
                    if (!this.onPropChangeFunctions) this.onPropChangeFunctions = [];
                    if (key) for(var i = 0; i < this.onPropChangeFunctions.length; i++){
                        var item = this.onPropChangeFunctions[i];
                        if (item.name == name && item.key == key) {
                            item.func = func;
                            return;
                        }
                    }
                    this.onPropChangeFunctions.push({
                        name: name,
                        func: func,
                        key: key
                    });
                };
                Base.prototype.registerFunctionOnPropertiesValueChanged = function(names, func, key) {
                    if (key === void 0) key = null;
                    this.registerPropertyChangedHandlers(names, func, key);
                };
                Base.prototype.unRegisterFunctionOnPropertyValueChanged = function(name, key) {
                    if (key === void 0) key = null;
                    if (!this.onPropChangeFunctions) return;
                    for(var i = 0; i < this.onPropChangeFunctions.length; i++){
                        var item = this.onPropChangeFunctions[i];
                        if (item.name == name && item.key == key) {
                            this.onPropChangeFunctions.splice(i, 1);
                            return;
                        }
                    }
                };
                Base.prototype.unRegisterFunctionOnPropertiesValueChanged = function(names, key) {
                    if (key === void 0) key = null;
                    this.unregisterPropertyChangedHandlers(names, key);
                };
                Base.prototype.createCustomLocalizableObj = function(name) {
                    var locStr = this.getLocalizableString(name);
                    if (locStr) return locStr;
                    return this.createLocalizableString(name, this, false, true);
                };
                Base.prototype.getLocale = function() {
                    var locOwner = this.getSurvey();
                    return !!locOwner ? locOwner.getLocale() : "";
                };
                Base.prototype.getLocalizationString = function(strName) {
                    return _surveyStrings__WEBPACK_IMPORTED_MODULE_5__["surveyLocalization"].getString(strName, this.getLocale());
                };
                Base.prototype.getLocalizationFormatString = function(strName) {
                    var args = [];
                    for(var _i = 1; _i < arguments.length; _i++)args[_i - 1] = arguments[_i];
                    var str = this.getLocalizationString(strName);
                    if (!str || !str.format) return "";
                    return str.format.apply(str, args);
                };
                Base.prototype.createLocalizableString = function(name, owner, useMarkDown, defaultStr) {
                    var _this = this;
                    if (useMarkDown === void 0) useMarkDown = false;
                    if (defaultStr === void 0) defaultStr = false;
                    var locStr = new _localizablestring__WEBPACK_IMPORTED_MODULE_0__["LocalizableString"](owner, useMarkDown, name);
                    if (defaultStr) locStr.localizationName = defaultStr === true ? name : defaultStr;
                    locStr.onStrChanged = function(oldValue, newValue) {
                        _this.propertyValueChanged(name, oldValue, newValue);
                    };
                    if (!this.localizableStrings) this.localizableStrings = {};
                    this.localizableStrings[name] = locStr;
                    var prop = this.getPropertyByName(name);
                    locStr.disableLocalization = prop && prop.isLocalizable === false;
                    return locStr;
                };
                Base.prototype.getLocalizableString = function(name) {
                    return !!this.localizableStrings ? this.localizableStrings[name] : null;
                };
                Base.prototype.getLocalizableStringText = function(name, defaultStr) {
                    if (defaultStr === void 0) defaultStr = "";
                    Base.collectDependency(this, name);
                    var locStr = this.getLocalizableString(name);
                    if (!locStr) return "";
                    var res = locStr.text;
                    return res ? res : defaultStr;
                };
                Base.prototype.setLocalizableStringText = function(name, value) {
                    var locStr = this.getLocalizableString(name);
                    if (!locStr) return;
                    var oldValue = locStr.text;
                    if (oldValue != value) locStr.text = value;
                };
                Base.prototype.addUsedLocales = function(locales) {
                    if (!!this.localizableStrings) for(var key in this.localizableStrings){
                        var item = this.getLocalizableString(key);
                        if (item) this.AddLocStringToUsedLocales(item, locales);
                    }
                    if (!!this.arraysInfo) for(var key in this.arraysInfo){
                        var items = this.getPropertyValue(key);
                        if (!items || !items.length) continue;
                        for(var i = 0; i < items.length; i++){
                            var item = items[i];
                            if (item && item.addUsedLocales) item.addUsedLocales(locales);
                        }
                    }
                };
                Base.prototype.searchText = function(text, founded) {
                    var strs = [];
                    this.getSearchableLocalizedStrings(strs);
                    for(var i = 0; i < strs.length; i++)if (strs[i].setFindText(text)) founded.push({
                        element: this,
                        str: strs[i]
                    });
                };
                Base.prototype.getSearchableLocalizedStrings = function(arr) {
                    if (!!this.localizableStrings) {
                        var keys_1 = [];
                        this.getSearchableLocKeys(keys_1);
                        for(var i = 0; i < keys_1.length; i++){
                            var item = this.getLocalizableString(keys_1[i]);
                            if (item) arr.push(item);
                        }
                    }
                    if (!this.arraysInfo) return;
                    var keys = [];
                    this.getSearchableItemValueKeys(keys);
                    for(var i = 0; i < keys.length; i++){
                        var items = this.getPropertyValue(keys[i]);
                        if (!items) continue;
                        for(var j = 0; j < items.length; j++)arr.push(items[j].locText);
                    }
                };
                Base.prototype.getSearchableLocKeys = function(keys) {};
                Base.prototype.getSearchableItemValueKeys = function(keys) {};
                Base.prototype.AddLocStringToUsedLocales = function(locStr, locales) {
                    var locs = locStr.getLocales();
                    for(var i = 0; i < locs.length; i++)if (locales.indexOf(locs[i]) < 0) locales.push(locs[i]);
                };
                Base.prototype.createItemValues = function(name) {
                    var self = this;
                    var result = this.createNewArray(name, function(item) {
                        item.locOwner = self;
                        item.ownerPropertyName = name;
                        if (typeof item.getSurvey == "function") {
                            var survey = item.getSurvey();
                            if (!!survey && typeof survey.makeReactive == "function") survey.makeReactive(item);
                        }
                    });
                    this.arraysInfo[name].isItemValues = true;
                    return result;
                };
                Base.prototype.notifyArrayChanged = function(ar, arrayChanges) {
                    !!ar.onArrayChanged && ar.onArrayChanged(arrayChanges);
                };
                Base.prototype.createNewArrayCore = function(name) {
                    var res = null;
                    if (!!this.createArrayCoreHandler) res = this.createArrayCoreHandler(this.propertyHash, name);
                    if (!res) {
                        res = new Array();
                        this.setPropertyValueCore(this.propertyHash, name, res);
                    }
                    return res;
                };
                Base.prototype.ensureArray = function(name, onPush, onRemove) {
                    if (onPush === void 0) onPush = null;
                    if (onRemove === void 0) onRemove = null;
                    if (this.arraysInfo && this.arraysInfo[name]) return;
                    return this.createNewArray(name, onPush, onRemove);
                };
                Base.prototype.createNewArray = function(name, onPush, onRemove) {
                    if (onPush === void 0) onPush = null;
                    if (onRemove === void 0) onRemove = null;
                    var newArray = this.createNewArrayCore(name);
                    if (!this.arraysInfo) this.arraysInfo = {};
                    this.arraysInfo[name] = {
                        onPush: onPush,
                        isItemValues: false
                    };
                    var self = this;
                    newArray.push = function(value) {
                        var result = Object.getPrototypeOf(newArray).push.call(newArray, value);
                        if (!self.isDisposedValue) {
                            if (onPush) onPush(value, newArray.length - 1);
                            var arrayChanges = new ArrayChanges(newArray.length - 1, 0, [
                                value
                            ], []);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    newArray.shift = function() {
                        var result = Object.getPrototypeOf(newArray).shift.call(newArray);
                        if (!self.isDisposedValue && result) {
                            if (onRemove) onRemove(result);
                            var arrayChanges = new ArrayChanges(newArray.length - 1, 1, [], []);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    newArray.unshift = function(value) {
                        var result = Object.getPrototypeOf(newArray).unshift.call(newArray, value);
                        if (!self.isDisposedValue) {
                            if (onPush) onPush(value, newArray.length - 1);
                            var arrayChanges = new ArrayChanges(0, 0, [
                                value
                            ], []);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    newArray.pop = function() {
                        var result = Object.getPrototypeOf(newArray).pop.call(newArray);
                        if (!self.isDisposedValue) {
                            if (onRemove) onRemove(result);
                            var arrayChanges = new ArrayChanges(newArray.length - 1, 1, [], []);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    newArray.splice = function(start, deleteCount) {
                        var _a;
                        var items = [];
                        for(var _i = 2; _i < arguments.length; _i++)items[_i - 2] = arguments[_i];
                        if (!start) start = 0;
                        if (!deleteCount) deleteCount = 0;
                        var result = (_a = Object.getPrototypeOf(newArray).splice).call.apply(_a, __spreadArray([
                            newArray,
                            start,
                            deleteCount
                        ], items));
                        if (!items) items = [];
                        if (!self.isDisposedValue) {
                            if (onRemove && result) for(var i = 0; i < result.length; i++)onRemove(result[i]);
                            if (onPush) for(var i = 0; i < items.length; i++)onPush(items[i], start + i);
                            var arrayChanges = new ArrayChanges(start, deleteCount, items, result);
                            self.propertyValueChanged(name, newArray, newArray, arrayChanges);
                            self.notifyArrayChanged(newArray, arrayChanges);
                        }
                        return result;
                    };
                    return newArray;
                };
                Base.prototype.getItemValueType = function() {
                    return undefined;
                };
                Base.prototype.setArray = function(name, src, dest, isItemValues, onPush) {
                    var deletedItems = [].concat(src);
                    Object.getPrototypeOf(src).splice.call(src, 0, src.length);
                    if (!!dest) for(var i = 0; i < dest.length; i++){
                        var item = dest[i];
                        if (isItemValues) {
                            if (!!Base.createItemValue) item = Base.createItemValue(item, this.getItemValueType());
                        }
                        Object.getPrototypeOf(src).push.call(src, item);
                        if (onPush) onPush(src[i]);
                    }
                    var arrayChanges = new ArrayChanges(0, deletedItems.length, src, deletedItems);
                    this.propertyValueChanged(name, deletedItems, src, arrayChanges);
                    this.notifyArrayChanged(src, arrayChanges);
                };
                Base.prototype.isTwoValueEquals = function(x, y, caseInSensitive, trimString) {
                    if (caseInSensitive === void 0) caseInSensitive = false;
                    if (trimString === void 0) trimString = false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(x, y, false, !caseInSensitive, trimString);
                };
                Base.copyObject = function(dst, src) {
                    for(var key in src){
                        var source = src[key];
                        if (typeof source === "object") {
                            source = {};
                            this.copyObject(source, src[key]);
                        }
                        dst[key] = source;
                    }
                };
                Base.prototype.copyCssClasses = function(dest, source) {
                    if (!source) return;
                    if (typeof source === "string" || source instanceof String) dest["root"] = source;
                    else Base.copyObject(dest, source);
                };
                Base.prototype.getValueInLowCase = function(val1) {
                    if (!!val1 && typeof val1 == "string") return val1.toLowerCase();
                    return val1;
                };
                Base.prototype.getElementsInDesign = function(includeHidden) {
                    if (includeHidden === void 0) includeHidden = false;
                    return [];
                };
                Base.currentDependencis = undefined;
                return Base;
            }();
            var ArrayChanges = /** @class */ function() {
                function ArrayChanges(index, deleteCount, itemsToAdd, deletedItems) {
                    this.index = index;
                    this.deleteCount = deleteCount;
                    this.itemsToAdd = itemsToAdd;
                    this.deletedItems = deletedItems;
                }
                return ArrayChanges;
            }();
            var Event = /** @class */ function() {
                function Event() {}
                Object.defineProperty(Event.prototype, "isEmpty", {
                    get: function() {
                        return this.length === 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Event.prototype, "length", {
                    get: function() {
                        return !!this.callbacks ? this.callbacks.length : 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Event.prototype.fireByCreatingOptions = function(sender, createOptions) {
                    if (!this.callbacks) return;
                    for(var i = 0; i < this.callbacks.length; i++){
                        this.callbacks[i](sender, createOptions());
                        if (!this.callbacks) return;
                    }
                };
                Event.prototype.fire = function(sender, options) {
                    if (!this.callbacks) return;
                    for(var i = 0; i < this.callbacks.length; i++){
                        this.callbacks[i](sender, options);
                        if (!this.callbacks) return;
                    }
                };
                Event.prototype.clear = function() {
                    this.callbacks = undefined;
                };
                Event.prototype.add = function(func) {
                    if (this.hasFunc(func)) return;
                    if (!this.callbacks) this.callbacks = new Array();
                    this.callbacks.push(func);
                    this.fireCallbackChanged();
                };
                Event.prototype.remove = function(func) {
                    if (this.hasFunc(func)) {
                        var index = this.callbacks.indexOf(func, 0);
                        this.callbacks.splice(index, 1);
                        this.fireCallbackChanged();
                    }
                };
                Event.prototype.hasFunc = function(func) {
                    if (this.callbacks == null) return false;
                    return this.callbacks.indexOf(func, 0) > -1;
                };
                Event.prototype.fireCallbackChanged = function() {
                    if (!!this.onCallbacksChanged) this.onCallbacksChanged();
                };
                return Event;
            }();
            var EventBase = /** @class */ function(_super) {
                __extends(EventBase, _super);
                function EventBase() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return EventBase;
            }(Event);
        /***/ },
        /***/ "./src/conditionProcessValue.ts": /*!**************************************!*\
  !*** ./src/conditionProcessValue.ts ***!
  \**************************************/ /*! exports provided: ProcessValue */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ProcessValue", function() {
                return ProcessValue;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            var surveyBuiltInVarible = "@survey";
            var ProcessValue = /** @class */ function() {
                function ProcessValue() {
                    this.values = null;
                    this.properties = null;
                }
                ProcessValue.prototype.getFirstName = function(text, obj) {
                    if (obj === void 0) obj = null;
                    if (!text) return text;
                    var res = "";
                    if (!!obj) {
                        res = this.getFirstPropertyName(text, obj);
                        if (!!res) return res;
                    }
                    for(var i = 0; i < text.length; i++){
                        var ch = text[i];
                        if (ch == "." || ch == "[") break;
                        res += ch;
                    }
                    return res;
                };
                ProcessValue.prototype.hasValue = function(text, values) {
                    if (values === void 0) values = null;
                    if (!values) values = this.values;
                    var res = this.getValueCore(text, values);
                    return res.hasValue;
                };
                ProcessValue.prototype.getValue = function(text, values) {
                    if (values === void 0) values = null;
                    if (!values) values = this.values;
                    var res = this.getValueCore(text, values);
                    return res.value;
                };
                ProcessValue.prototype.setValue = function(obj, text, value) {
                    if (!text) return;
                    var nonNestedObj = this.getNonNestedObject(obj, text, true);
                    if (!nonNestedObj) return;
                    obj = nonNestedObj.value;
                    text = nonNestedObj.text;
                    if (!!obj && !!text) obj[text] = value;
                };
                ProcessValue.prototype.getValueInfo = function(valueInfo) {
                    if (!!valueInfo.path) {
                        valueInfo.value = this.getValueFromPath(valueInfo.path, this.values);
                        valueInfo.hasValue = valueInfo.value !== null && !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(valueInfo.value);
                        if (!valueInfo.hasValue && valueInfo.path.length > 1 && valueInfo.path[valueInfo.path.length - 1] == "length") {
                            valueInfo.hasValue = true;
                            valueInfo.value = 0;
                        }
                        return;
                    }
                    var res = this.getValueCore(valueInfo.name, this.values);
                    valueInfo.value = res.value;
                    valueInfo.hasValue = res.hasValue;
                    valueInfo.path = res.hasValue ? res.path : null;
                    valueInfo.sctrictCompare = res.sctrictCompare;
                };
                ProcessValue.prototype.isAnyKeyChanged = function(keys, usedNames) {
                    for(var i = 0; i < usedNames.length; i++){
                        var name = usedNames[i];
                        if (keys.hasOwnProperty(name)) return true;
                        var firstName = this.getFirstName(name);
                        if (!keys.hasOwnProperty(firstName)) continue;
                        if (name === firstName) return true;
                        var keyValue = keys[firstName];
                        if (keyValue == undefined) continue;
                        if (!keyValue.hasOwnProperty("oldValue") || !keyValue.hasOwnProperty("newValue")) return true;
                        var v = {};
                        v[firstName] = keyValue["oldValue"];
                        var oldValue = this.getValue(name, v);
                        v[firstName] = keyValue["newValue"];
                        var newValue = this.getValue(name, v);
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(oldValue, newValue, false, false, false)) return true;
                    }
                    return false;
                };
                ProcessValue.prototype.getValueFromPath = function(path, values) {
                    if (path.length === 2 && path[0] === surveyBuiltInVarible) return this.getValueFromSurvey(path[1]);
                    var index = 0;
                    while(!!values && index < path.length){
                        var ind_name = path[index];
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(ind_name) && Array.isArray(values) && ind_name >= values.length) return null;
                        values = values[ind_name];
                        index++;
                    }
                    return values;
                };
                ProcessValue.prototype.getValueCore = function(text, values) {
                    var question = this.getQuestionDirectly(text);
                    if (question) return {
                        hasValue: true,
                        value: question.value,
                        path: [
                            text
                        ],
                        sctrictCompare: question.requireStrictCompare
                    };
                    var res = this.getValueFromValues(text, values);
                    if (!!text && !res.hasValue) {
                        var val1 = this.getValueFromSurvey(text);
                        if (val1 !== undefined) {
                            res.hasValue = true;
                            res.value = val1;
                            res.path = [
                                surveyBuiltInVarible,
                                text
                            ];
                        }
                    }
                    return res;
                };
                ProcessValue.prototype.getQuestionDirectly = function(name) {
                    if (!!this.properties && !!this.properties.survey) return this.properties.survey.getQuestionByValueName(name);
                    return undefined;
                };
                ProcessValue.prototype.getValueFromSurvey = function(name) {
                    if (!!this.properties && !!this.properties.survey) return this.properties.survey.getBuiltInVariableValue(name.toLocaleLowerCase());
                    return undefined;
                };
                ProcessValue.prototype.getValueFromValues = function(text, values) {
                    var res = {
                        hasValue: false,
                        value: null,
                        path: null
                    };
                    var curValue = values;
                    if (!curValue && curValue !== 0 && curValue !== false) return res;
                    if (text && text.lastIndexOf(".length") > -1 && text.lastIndexOf(".length") === text.length - 7) {
                        res.value = 0;
                        res.hasValue = true;
                    }
                    var nonNestedObj = this.getNonNestedObject(curValue, text, false);
                    if (!nonNestedObj) return res;
                    res.path = nonNestedObj.path;
                    res.value = !!nonNestedObj.text ? this.getObjectValue(nonNestedObj.value, nonNestedObj.text) : nonNestedObj.value;
                    res.hasValue = !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(res.value);
                    return res;
                };
                ProcessValue.prototype.getNonNestedObject = function(obj, text, createPath) {
                    var checkedKeys = new Array();
                    var len = 0;
                    var res = this.getNonNestedObjectCore(obj, text, createPath, checkedKeys);
                    while(!res && len < checkedKeys.length){
                        len = checkedKeys.length;
                        res = this.getNonNestedObjectCore(obj, text, createPath, checkedKeys);
                    }
                    return res;
                };
                ProcessValue.prototype.getNonNestedObjectCore = function(obj, text, createPath, checkedKeys) {
                    var curName = this.getFirstPropertyName(text, obj, createPath, checkedKeys);
                    if (!!curName) checkedKeys.push(curName);
                    var path = !!curName ? [
                        curName
                    ] : null;
                    while(text != curName && !!obj){
                        var isArray = text[0] == "[";
                        if (!isArray) {
                            if (!curName && text == this.getFirstName(text)) return {
                                value: obj,
                                text: text,
                                path: path
                            };
                            obj = this.getObjectValue(obj, curName);
                            if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(obj) && !createPath) return null;
                            text = text.substring(curName.length);
                        } else {
                            var objInArray = this.getObjInArray(obj, text);
                            if (!objInArray) return null;
                            obj = objInArray.value;
                            text = objInArray.text;
                            path.push(objInArray.index);
                        }
                        if (!!text && text[0] == ".") text = text.substring(1);
                        curName = this.getFirstPropertyName(text, obj, createPath, checkedKeys);
                        if (!!curName) path.push(curName);
                    }
                    return {
                        value: obj,
                        text: text,
                        path: path
                    };
                };
                ProcessValue.prototype.getObjInArray = function(curValue, text) {
                    if (!Array.isArray(curValue)) return null;
                    var index = 1;
                    var str = "";
                    while(index < text.length && text[index] != "]"){
                        str += text[index];
                        index++;
                    }
                    text = index < text.length ? text.substring(index + 1) : "";
                    index = this.getIntValue(str);
                    if (index < 0 || index >= curValue.length) return null;
                    return {
                        value: curValue[index],
                        text: text,
                        index: index
                    };
                };
                ProcessValue.prototype.getFirstPropertyName = function(name, obj, createProp, checkedKeys) {
                    if (createProp === void 0) createProp = false;
                    if (checkedKeys === void 0) checkedKeys = undefined;
                    if (!name) return name;
                    if (!obj) obj = {};
                    if (obj.hasOwnProperty(name)) return name;
                    var nameInLow = name.toLowerCase();
                    var A = nameInLow[0];
                    var a = A.toUpperCase();
                    for(var key in obj){
                        if (Array.isArray(checkedKeys) && checkedKeys.indexOf(key) > -1) continue;
                        var first = key[0];
                        if (first === a || first === A) {
                            var keyName = key.toLowerCase();
                            if (keyName == nameInLow) return key;
                            if (nameInLow.length <= keyName.length) continue;
                            var ch = nameInLow[keyName.length];
                            if (ch != "." && ch != "[") continue;
                            if (keyName == nameInLow.substring(0, keyName.length)) return key;
                        }
                    }
                    if (createProp && name[0] !== "[") {
                        var ind = name.indexOf(".");
                        if (ind > -1) {
                            name = name.substring(0, ind);
                            obj[name] = {};
                        }
                        return name;
                    }
                    return "";
                };
                ProcessValue.prototype.getObjectValue = function(obj, name) {
                    if (!name) return null;
                    return obj[name];
                };
                ProcessValue.prototype.getIntValue = function(str) {
                    if (str == "0" || (str | 0) > 0 && str % 1 == 0) return Number(str);
                    return -1;
                };
                return ProcessValue;
            }();
        /***/ },
        /***/ "./src/conditions.ts": /*!***************************!*\
  !*** ./src/conditions.ts ***!
  \***************************/ /*! exports provided: ExpressionExecutor, ExpressionRunnerBase, ConditionRunner, ExpressionRunner */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionExecutor", function() {
                return ExpressionExecutor;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionRunnerBase", function() {
                return ExpressionRunnerBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConditionRunner", function() {
                return ConditionRunner;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ExpressionRunner", function() {
                return ExpressionRunner;
            });
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./conditionProcessValue */ "./src/conditionProcessValue.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            /* harmony import */ var _conditionsParser__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./conditionsParser */ "./src/conditionsParser.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ExpressionExecutor = /** @class */ function() {
                function ExpressionExecutor(expression) {
                    this.processValue = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_0__["ProcessValue"]();
                    this.parser = new _conditionsParser__WEBPACK_IMPORTED_MODULE_2__["ConditionsParser"]();
                    this.isAsyncValue = false;
                    this.hasFunctionValue = false;
                    this.setExpression(expression);
                }
                Object.defineProperty(ExpressionExecutor.prototype, "expression", {
                    get: function() {
                        return this.expressionValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionExecutor.prototype.setExpression = function(value) {
                    if (this.expression === value) return;
                    this.expressionValue = value;
                    this.operand = this.parser.parseExpression(value);
                    this.hasFunctionValue = this.canRun() ? this.operand.hasFunction() : false;
                    this.isAsyncValue = this.hasFunction() ? this.operand.hasAsyncFunction() : false;
                };
                ExpressionExecutor.prototype.getVariables = function() {
                    if (!this.operand) return [];
                    var variables = [];
                    this.operand.setVariables(variables);
                    return variables;
                };
                ExpressionExecutor.prototype.hasFunction = function() {
                    return this.hasFunctionValue;
                };
                Object.defineProperty(ExpressionExecutor.prototype, "isAsync", {
                    get: function() {
                        return this.isAsyncValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionExecutor.prototype.canRun = function() {
                    return !!this.operand;
                };
                ExpressionExecutor.prototype.run = function(values, properties) {
                    var _this = this;
                    if (properties === void 0) properties = null;
                    if (!this.operand) {
                        if (!!this.expression) _console_warnings__WEBPACK_IMPORTED_MODULE_1__["ConsoleWarnings"].warn("Invalid expression: " + this.expression);
                        return null;
                    }
                    this.processValue.values = values;
                    this.processValue.properties = properties;
                    if (!this.isAsync) return this.runValues();
                    this.asyncFuncList = [];
                    this.operand.addToAsyncList(this.asyncFuncList);
                    for(var i = 0; i < this.asyncFuncList.length; i++)this.asyncFuncList[i].onAsyncReady = function() {
                        _this.doAsyncFunctionReady();
                    };
                    for(var i = 0; i < this.asyncFuncList.length; i++)this.asyncFuncList[i].evaluateAsync(this.processValue);
                    return false;
                };
                ExpressionExecutor.prototype.doAsyncFunctionReady = function() {
                    for(var i = 0; i < this.asyncFuncList.length; i++){
                        if (!this.asyncFuncList[i].isReady) return;
                    }
                    this.runValues();
                };
                ExpressionExecutor.prototype.runValues = function() {
                    var res = this.operand.evaluate(this.processValue);
                    if (!!this.onComplete) this.onComplete(res);
                    return res;
                };
                ExpressionExecutor.createExpressionExecutor = function(expression) {
                    return new ExpressionExecutor(expression);
                };
                return ExpressionExecutor;
            }();
            var ExpressionRunnerBase = /** @class */ function() {
                function ExpressionRunnerBase(expression) {
                    this._id = ExpressionRunnerBase.IdCounter++;
                    this.expression = expression;
                }
                Object.defineProperty(ExpressionRunnerBase.prototype, "id", {
                    get: function() {
                        return this._id;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ExpressionRunnerBase.prototype, "expression", {
                    get: function() {
                        return !!this.expressionExecutor ? this.expressionExecutor.expression : "";
                    },
                    set: function(value) {
                        var _this = this;
                        if (!!this.expressionExecutor && value === this.expression) return;
                        this.expressionExecutor = ExpressionExecutor.createExpressionExecutor(value);
                        this.expressionExecutor.onComplete = function(res) {
                            _this.doOnComplete(res);
                        };
                        this.variables = undefined;
                        this.containsFunc = undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionRunnerBase.prototype.getVariables = function() {
                    if (this.variables === undefined) this.variables = this.expressionExecutor.getVariables();
                    return this.variables;
                };
                ExpressionRunnerBase.prototype.hasFunction = function() {
                    if (this.containsFunc === undefined) this.containsFunc = this.expressionExecutor.hasFunction();
                    return this.containsFunc;
                };
                Object.defineProperty(ExpressionRunnerBase.prototype, "isAsync", {
                    get: function() {
                        return this.expressionExecutor.isAsync;
                    },
                    enumerable: false,
                    configurable: true
                });
                ExpressionRunnerBase.prototype.canRun = function() {
                    return this.expressionExecutor.canRun();
                };
                ExpressionRunnerBase.prototype.runCore = function(values, properties) {
                    if (properties === void 0) properties = null;
                    if (this.onBeforeAsyncRun && this.isAsync) this.onBeforeAsyncRun(this.id);
                    return this.expressionExecutor.run(values, properties);
                };
                ExpressionRunnerBase.prototype.doOnComplete = function(res) {
                    if (this.onAfterAsyncRun && this.isAsync) this.onAfterAsyncRun(this.id);
                };
                ExpressionRunnerBase.IdCounter = 1;
                return ExpressionRunnerBase;
            }();
            var ConditionRunner = /** @class */ function(_super) {
                __extends(ConditionRunner, _super);
                function ConditionRunner() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ConditionRunner.prototype.run = function(values, properties) {
                    if (properties === void 0) properties = null;
                    return this.runCore(values, properties) == true;
                };
                ConditionRunner.prototype.doOnComplete = function(res) {
                    if (!!this.onRunComplete) this.onRunComplete(res == true);
                    _super.prototype.doOnComplete.call(this, res);
                };
                return ConditionRunner;
            }(ExpressionRunnerBase);
            var ExpressionRunner = /** @class */ function(_super) {
                __extends(ExpressionRunner, _super);
                function ExpressionRunner() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ExpressionRunner.prototype.run = function(values, properties) {
                    if (properties === void 0) properties = null;
                    return this.runCore(values, properties);
                };
                ExpressionRunner.prototype.doOnComplete = function(res) {
                    if (!!this.onRunComplete) this.onRunComplete(res);
                    _super.prototype.doOnComplete.call(this, res);
                };
                return ExpressionRunner;
            }(ExpressionRunnerBase);
        /***/ },
        /***/ "./src/conditionsParser.ts": /*!*********************************!*\
  !*** ./src/conditionsParser.ts ***!
  \*********************************/ /*! exports provided: ConditionsParserError, ConditionsParser */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConditionsParserError", function() {
                return ConditionsParserError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConditionsParser", function() {
                return ConditionsParser;
            });
            /* harmony import */ var _expressions_expressionParser__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./expressions/expressionParser */ "./src/expressions/expressionParser.ts");
            var ConditionsParserError = /** @class */ function() {
                function ConditionsParserError(at, code) {
                    this.at = at;
                    this.code = code;
                }
                return ConditionsParserError;
            }();
            var ConditionsParser = /** @class */ function() {
                function ConditionsParser() {}
                ConditionsParser.prototype.patchExpression = function(text) {
                    return text.replace(/=>/g, ">=").replace(/=</g, "<=").replace(/<>/g, "!=").replace(/equals/g, "equal ").replace(/notequals/g, "notequal ");
                };
                ConditionsParser.prototype.createCondition = function(text) {
                    return this.parseExpression(text);
                };
                ConditionsParser.prototype.parseExpression = function(text) {
                    try {
                        var result = ConditionsParser.parserCache[text];
                        if (result === undefined) {
                            result = Object(_expressions_expressionParser__WEBPACK_IMPORTED_MODULE_0__["parse"])(this.patchExpression(text));
                            if (!result.hasAsyncFunction()) ConditionsParser.parserCache[text] = result;
                        }
                        return result;
                    } catch (e) {
                        if (e instanceof _expressions_expressionParser__WEBPACK_IMPORTED_MODULE_0__["SyntaxError"]) this.conditionError = new ConditionsParserError(e.location.start.offset, e.message);
                    }
                };
                Object.defineProperty(ConditionsParser.prototype, "error", {
                    get: function() {
                        return this.conditionError;
                    },
                    enumerable: false,
                    configurable: true
                });
                ConditionsParser.parserCache = {};
                return ConditionsParser;
            }();
        /***/ },
        /***/ "./src/console-warnings.ts": /*!*********************************!*\
  !*** ./src/console-warnings.ts ***!
  \*********************************/ /*! exports provided: ConsoleWarnings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ConsoleWarnings", function() {
                return ConsoleWarnings;
            });
            var ConsoleWarnings = /** @class */ function() {
                function ConsoleWarnings() {}
                ConsoleWarnings.disposedObjectChangedProperty = function(propName, objType) {
                    ConsoleWarnings.warn('An attempt to set a property "' + propName + '" of a disposed object "' + objType + '"');
                };
                ConsoleWarnings.inCorrectQuestionValue = function(questionName, val1) {
                    var valStr = JSON.stringify(val1, null, 3);
                    ConsoleWarnings.warn("An attempt to assign an incorrect value" + valStr + ' to the following question: "' + questionName + '"');
                };
                ConsoleWarnings.warn = function(text) {
                    // eslint-disable-next-line no-console
                    console.warn(text);
                };
                ConsoleWarnings.error = function(text) {
                    // eslint-disable-next-line no-console
                    console.error(text);
                };
                return ConsoleWarnings;
            }();
        /***/ },
        /***/ "./src/element-helper.ts": /*!*******************************!*\
  !*** ./src/element-helper.ts ***!
  \*******************************/ /*! exports provided: ElementHelper */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ElementHelper", function() {
                return ElementHelper;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var ElementHelper = /** @class */ function() {
                function ElementHelper() {}
                ElementHelper.focusElement = function(element) {
                    element && element.focus();
                };
                ElementHelper.visibility = function(node) {
                    var style = _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getComputedStyle(node);
                    if (style.display === "none" || style.visibility === "hidden") return false;
                    return node.parentElement ? this.visibility(node.parentElement) : true;
                };
                ElementHelper.getNextElementPreorder = function(element) {
                    var result = !!element.nextElementSibling ? element.nextElementSibling : element.parentElement.firstElementChild;
                    if (this.visibility(result)) return result;
                    else return this.getNextElementPreorder(result);
                };
                ElementHelper.getNextElementPostorder = function(element) {
                    var result = !!element.previousElementSibling ? element.previousElementSibling : element.parentElement.lastElementChild;
                    if (this.visibility(result)) return result;
                    else return this.getNextElementPostorder(result);
                };
                ElementHelper.hasHorizontalScroller = function(element) {
                    if (!!element) return element.scrollWidth > element.offsetWidth;
                    return false;
                };
                ElementHelper.hasVerticalScroller = function(element) {
                    if (!!element) return element.scrollHeight > element.offsetHeight;
                    return false;
                };
                return ElementHelper;
            }();
        /***/ },
        /***/ "./src/entries/core-export.ts": /*!************************************!*\
  !*** ./src/entries/core-export.ts ***!
  \************************************/ /*! exports provided: SurveyModel, SurveyWindowModel, settings, surveyLocalization, surveyStrings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyModel", function() {
                return survey_core__WEBPACK_IMPORTED_MODULE_0__["SurveyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyWindowModel", function() {
                return survey_core__WEBPACK_IMPORTED_MODULE_0__["SurveyWindowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "settings", function() {
                return survey_core__WEBPACK_IMPORTED_MODULE_0__["settings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyLocalization", function() {
                return survey_core__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyStrings", function() {
                return survey_core__WEBPACK_IMPORTED_MODULE_0__["surveyStrings"];
            });
        /***/ },
        /***/ "./src/entries/react-ui-model.ts": /*!***************************************!*\
  !*** ./src/entries/react-ui-model.ts ***!
  \***************************************/ /*! exports provided: Survey, attachKey2click, ReactSurveyElementsWrapper, SurveyNavigationBase, SurveyTimerPanel, SurveyPage, SurveyRow, SurveyPanel, SurveyFlowPanel, SurveyQuestion, SurveyElementErrors, SurveyQuestionAndErrorsCell, ReactSurveyElement, SurveyElementBase, SurveyQuestionElementBase, SurveyQuestionCommentItem, SurveyQuestionComment, SurveyQuestionCheckbox, SurveyQuestionCheckboxItem, SurveyQuestionRanking, SurveyQuestionRankingItem, RatingItem, RatingItemStar, RatingItemSmiley, RatingDropdownItem, TagboxFilterString, SurveyQuestionOptionItem, SurveyQuestionDropdownBase, SurveyQuestionDropdown, SurveyQuestionTagboxItem, SurveyQuestionTagbox, SurveyQuestionDropdownSelect, SurveyQuestionMatrix, SurveyQuestionMatrixRow, SurveyQuestionMatrixCell, SurveyQuestionHtml, SurveyQuestionFile, SurveyFileChooseButton, SurveyFilePreview, SurveyQuestionMultipleText, SurveyQuestionRadiogroup, SurveyQuestionRadioItem, SurveyQuestionText, SurveyQuestionBoolean, SurveyQuestionBooleanCheckbox, SurveyQuestionBooleanRadio, SurveyQuestionEmpty, SurveyQuestionMatrixDropdownCell, SurveyQuestionMatrixDropdownBase, SurveyQuestionMatrixDropdown, SurveyQuestionMatrixDynamic, SurveyQuestionMatrixDynamicAddButton, SurveyQuestionPanelDynamic, SurveyProgress, SurveyProgressButtons, SurveyProgressToc, SurveyQuestionRating, SurveyQuestionRatingDropdown, SurveyQuestionExpression, PopupSurvey, SurveyWindow, ReactQuestionFactory, ReactElementFactory, SurveyQuestionImagePicker, SurveyQuestionImage, SurveyQuestionSignaturePad, SurveyQuestionButtonGroup, SurveyQuestionCustom, SurveyQuestionComposite, Popup, List, TitleActions, TitleElement, SurveyActionBar, LogoImage, SurveyHeader, SvgIcon, SurveyQuestionMatrixDynamicRemoveButton, SurveyQuestionMatrixDetailButton, SurveyQuestionMatrixDynamicDragDropIcon, SurveyQuestionPanelDynamicAddButton, SurveyQuestionPanelDynamicRemoveButton, SurveyQuestionPanelDynamicPrevButton, SurveyQuestionPanelDynamicNextButton, SurveyQuestionPanelDynamicProgressText, SurveyNavigationButton, MatrixRow, Skeleton, NotifierComponent, ComponentsContainer, CharacterCounterComponent, HeaderMobile, HeaderCell, Header, SurveyLocStringViewer, SurveyLocStringEditor, LoadingIndicatorComponent, SvgBundleComponent */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _react_reactSurvey__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../react/reactSurvey */ "./src/react/reactSurvey.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Survey", function() {
                return _react_reactSurvey__WEBPACK_IMPORTED_MODULE_0__["Survey"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "attachKey2click", function() {
                return _react_reactSurvey__WEBPACK_IMPORTED_MODULE_0__["attachKey2click"];
            });
            /* harmony import */ var _react_reactsurveymodel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../react/reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReactSurveyElementsWrapper", function() {
                return _react_reactsurveymodel__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElementsWrapper"];
            });
            /* harmony import */ var _react_reactSurveyNavigationBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../react/reactSurveyNavigationBase */ "./src/react/reactSurveyNavigationBase.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyNavigationBase", function() {
                return _react_reactSurveyNavigationBase__WEBPACK_IMPORTED_MODULE_2__["SurveyNavigationBase"];
            });
            /* harmony import */ var _react_reacttimerpanel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../react/reacttimerpanel */ "./src/react/reacttimerpanel.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTimerPanel", function() {
                return _react_reacttimerpanel__WEBPACK_IMPORTED_MODULE_3__["SurveyTimerPanel"];
            });
            /* harmony import */ var _react_page__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../react/page */ "./src/react/page.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyPage", function() {
                return _react_page__WEBPACK_IMPORTED_MODULE_4__["SurveyPage"];
            });
            /* harmony import */ var _react_row__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../react/row */ "./src/react/row.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyRow", function() {
                return _react_row__WEBPACK_IMPORTED_MODULE_5__["SurveyRow"];
            });
            /* harmony import */ var _react_panel__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../react/panel */ "./src/react/panel.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyPanel", function() {
                return _react_panel__WEBPACK_IMPORTED_MODULE_6__["SurveyPanel"];
            });
            /* harmony import */ var _react_flow_panel__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../react/flow-panel */ "./src/react/flow-panel.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyFlowPanel", function() {
                return _react_flow_panel__WEBPACK_IMPORTED_MODULE_7__["SurveyFlowPanel"];
            });
            /* harmony import */ var _react_reactquestion__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../react/reactquestion */ "./src/react/reactquestion.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestion", function() {
                return _react_reactquestion__WEBPACK_IMPORTED_MODULE_8__["SurveyQuestion"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElementErrors", function() {
                return _react_reactquestion__WEBPACK_IMPORTED_MODULE_8__["SurveyElementErrors"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionAndErrorsCell", function() {
                return _react_reactquestion__WEBPACK_IMPORTED_MODULE_8__["SurveyQuestionAndErrorsCell"];
            });
            /* harmony import */ var _react_reactquestion_element__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../react/reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReactSurveyElement", function() {
                return _react_reactquestion_element__WEBPACK_IMPORTED_MODULE_9__["ReactSurveyElement"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElementBase", function() {
                return _react_reactquestion_element__WEBPACK_IMPORTED_MODULE_9__["SurveyElementBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionElementBase", function() {
                return _react_reactquestion_element__WEBPACK_IMPORTED_MODULE_9__["SurveyQuestionElementBase"];
            });
            /* harmony import */ var _react_reactquestion_comment__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../react/reactquestion_comment */ "./src/react/reactquestion_comment.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCommentItem", function() {
                return _react_reactquestion_comment__WEBPACK_IMPORTED_MODULE_10__["SurveyQuestionCommentItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionComment", function() {
                return _react_reactquestion_comment__WEBPACK_IMPORTED_MODULE_10__["SurveyQuestionComment"];
            });
            /* harmony import */ var _react_reactquestion_checkbox__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../react/reactquestion_checkbox */ "./src/react/reactquestion_checkbox.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCheckbox", function() {
                return _react_reactquestion_checkbox__WEBPACK_IMPORTED_MODULE_11__["SurveyQuestionCheckbox"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCheckboxItem", function() {
                return _react_reactquestion_checkbox__WEBPACK_IMPORTED_MODULE_11__["SurveyQuestionCheckboxItem"];
            });
            /* harmony import */ var _react_reactquestion_ranking__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../react/reactquestion_ranking */ "./src/react/reactquestion_ranking.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRanking", function() {
                return _react_reactquestion_ranking__WEBPACK_IMPORTED_MODULE_12__["SurveyQuestionRanking"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRankingItem", function() {
                return _react_reactquestion_ranking__WEBPACK_IMPORTED_MODULE_12__["SurveyQuestionRankingItem"];
            });
            /* harmony import */ var _react_components_rating_rating_item__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../react/components/rating/rating-item */ "./src/react/components/rating/rating-item.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingItem", function() {
                return _react_components_rating_rating_item__WEBPACK_IMPORTED_MODULE_13__["RatingItem"];
            });
            /* harmony import */ var _react_components_rating_rating_item_star__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../react/components/rating/rating-item-star */ "./src/react/components/rating/rating-item-star.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingItemStar", function() {
                return _react_components_rating_rating_item_star__WEBPACK_IMPORTED_MODULE_14__["RatingItemStar"];
            });
            /* harmony import */ var _react_components_rating_rating_item_smiley__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../react/components/rating/rating-item-smiley */ "./src/react/components/rating/rating-item-smiley.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingItemSmiley", function() {
                return _react_components_rating_rating_item_smiley__WEBPACK_IMPORTED_MODULE_15__["RatingItemSmiley"];
            });
            /* harmony import */ var _react_components_rating_rating_dropdown_item__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../react/components/rating/rating-dropdown-item */ "./src/react/components/rating/rating-dropdown-item.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingDropdownItem", function() {
                return _react_components_rating_rating_dropdown_item__WEBPACK_IMPORTED_MODULE_16__["RatingDropdownItem"];
            });
            /* harmony import */ var _react_tagbox_filter__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../react/tagbox-filter */ "./src/react/tagbox-filter.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagboxFilterString", function() {
                return _react_tagbox_filter__WEBPACK_IMPORTED_MODULE_17__["TagboxFilterString"];
            });
            /* harmony import */ var _react_dropdown_item__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../react/dropdown-item */ "./src/react/dropdown-item.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionOptionItem", function() {
                return _react_dropdown_item__WEBPACK_IMPORTED_MODULE_18__["SurveyQuestionOptionItem"];
            });
            /* harmony import */ var _react_dropdown_base__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../react/dropdown-base */ "./src/react/dropdown-base.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdownBase", function() {
                return _react_dropdown_base__WEBPACK_IMPORTED_MODULE_19__["SurveyQuestionDropdownBase"];
            });
            /* harmony import */ var _react_reactquestion_dropdown__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../react/reactquestion_dropdown */ "./src/react/reactquestion_dropdown.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdown", function() {
                return _react_reactquestion_dropdown__WEBPACK_IMPORTED_MODULE_20__["SurveyQuestionDropdown"];
            });
            /* harmony import */ var _react_tagbox_item__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../react/tagbox-item */ "./src/react/tagbox-item.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionTagboxItem", function() {
                return _react_tagbox_item__WEBPACK_IMPORTED_MODULE_21__["SurveyQuestionTagboxItem"];
            });
            /* harmony import */ var _react_reactquestion_tagbox__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../react/reactquestion_tagbox */ "./src/react/reactquestion_tagbox.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionTagbox", function() {
                return _react_reactquestion_tagbox__WEBPACK_IMPORTED_MODULE_22__["SurveyQuestionTagbox"];
            });
            /* harmony import */ var _react_dropdown_select__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../react/dropdown-select */ "./src/react/dropdown-select.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdownSelect", function() {
                return _react_dropdown_select__WEBPACK_IMPORTED_MODULE_23__["SurveyQuestionDropdownSelect"];
            });
            /* harmony import */ var _react_reactquestion_matrix__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../react/reactquestion_matrix */ "./src/react/reactquestion_matrix.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrix", function() {
                return _react_reactquestion_matrix__WEBPACK_IMPORTED_MODULE_24__["SurveyQuestionMatrix"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixRow", function() {
                return _react_reactquestion_matrix__WEBPACK_IMPORTED_MODULE_24__["SurveyQuestionMatrixRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixCell", function() {
                return _react_reactquestion_matrix__WEBPACK_IMPORTED_MODULE_24__["SurveyQuestionMatrixCell"];
            });
            /* harmony import */ var _react_reactquestion_html__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../react/reactquestion_html */ "./src/react/reactquestion_html.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionHtml", function() {
                return _react_reactquestion_html__WEBPACK_IMPORTED_MODULE_25__["SurveyQuestionHtml"];
            });
            /* harmony import */ var _react_reactquestion_file__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../react/reactquestion_file */ "./src/react/reactquestion_file.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionFile", function() {
                return _react_reactquestion_file__WEBPACK_IMPORTED_MODULE_26__["SurveyQuestionFile"];
            });
            /* harmony import */ var _react_components_file_file_choose_button__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../react/components/file/file-choose-button */ "./src/react/components/file/file-choose-button.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyFileChooseButton", function() {
                return _react_components_file_file_choose_button__WEBPACK_IMPORTED_MODULE_27__["SurveyFileChooseButton"];
            });
            /* harmony import */ var _react_components_file_file_preview__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../react/components/file/file-preview */ "./src/react/components/file/file-preview.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyFilePreview", function() {
                return _react_components_file_file_preview__WEBPACK_IMPORTED_MODULE_28__["SurveyFilePreview"];
            });
            /* harmony import */ var _react_reactquestion_multipletext__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../react/reactquestion_multipletext */ "./src/react/reactquestion_multipletext.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMultipleText", function() {
                return _react_reactquestion_multipletext__WEBPACK_IMPORTED_MODULE_29__["SurveyQuestionMultipleText"];
            });
            /* harmony import */ var _react_reactquestion_radiogroup__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../react/reactquestion_radiogroup */ "./src/react/reactquestion_radiogroup.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRadiogroup", function() {
                return _react_reactquestion_radiogroup__WEBPACK_IMPORTED_MODULE_30__["SurveyQuestionRadiogroup"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRadioItem", function() {
                return _react_reactquestion_radiogroup__WEBPACK_IMPORTED_MODULE_30__["SurveyQuestionRadioItem"];
            });
            /* harmony import */ var _react_reactquestion_text__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../react/reactquestion_text */ "./src/react/reactquestion_text.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionText", function() {
                return _react_reactquestion_text__WEBPACK_IMPORTED_MODULE_31__["SurveyQuestionText"];
            });
            /* harmony import */ var _react_boolean__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../react/boolean */ "./src/react/boolean.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBoolean", function() {
                return _react_boolean__WEBPACK_IMPORTED_MODULE_32__["SurveyQuestionBoolean"];
            });
            /* harmony import */ var _react_boolean_checkbox__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../react/boolean-checkbox */ "./src/react/boolean-checkbox.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBooleanCheckbox", function() {
                return _react_boolean_checkbox__WEBPACK_IMPORTED_MODULE_33__["SurveyQuestionBooleanCheckbox"];
            });
            /* harmony import */ var _react_boolean_radio__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../react/boolean-radio */ "./src/react/boolean-radio.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBooleanRadio", function() {
                return _react_boolean_radio__WEBPACK_IMPORTED_MODULE_34__["SurveyQuestionBooleanRadio"];
            });
            /* harmony import */ var _react_reactquestion_empty__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../react/reactquestion_empty */ "./src/react/reactquestion_empty.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEmpty", function() {
                return _react_reactquestion_empty__WEBPACK_IMPORTED_MODULE_35__["SurveyQuestionEmpty"];
            });
            /* harmony import */ var _react_reactquestion_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../react/reactquestion_matrixdropdownbase */ "./src/react/reactquestion_matrixdropdownbase.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdownCell", function() {
                return _react_reactquestion_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_36__["SurveyQuestionMatrixDropdownCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdownBase", function() {
                return _react_reactquestion_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_36__["SurveyQuestionMatrixDropdownBase"];
            });
            /* harmony import */ var _react_reactquestion_matrixdropdown__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../react/reactquestion_matrixdropdown */ "./src/react/reactquestion_matrixdropdown.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdown", function() {
                return _react_reactquestion_matrixdropdown__WEBPACK_IMPORTED_MODULE_37__["SurveyQuestionMatrixDropdown"];
            });
            /* harmony import */ var _react_reactquestion_matrixdynamic__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../react/reactquestion_matrixdynamic */ "./src/react/reactquestion_matrixdynamic.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamic", function() {
                return _react_reactquestion_matrixdynamic__WEBPACK_IMPORTED_MODULE_38__["SurveyQuestionMatrixDynamic"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicAddButton", function() {
                return _react_reactquestion_matrixdynamic__WEBPACK_IMPORTED_MODULE_38__["SurveyQuestionMatrixDynamicAddButton"];
            });
            /* harmony import */ var _react_reactquestion_paneldynamic__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../react/reactquestion_paneldynamic */ "./src/react/reactquestion_paneldynamic.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamic", function() {
                return _react_reactquestion_paneldynamic__WEBPACK_IMPORTED_MODULE_39__["SurveyQuestionPanelDynamic"];
            });
            /* harmony import */ var _react_progress__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../react/progress */ "./src/react/progress.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgress", function() {
                return _react_progress__WEBPACK_IMPORTED_MODULE_40__["SurveyProgress"];
            });
            /* harmony import */ var _react_progressButtons__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../react/progressButtons */ "./src/react/progressButtons.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressButtons", function() {
                return _react_progressButtons__WEBPACK_IMPORTED_MODULE_41__["SurveyProgressButtons"];
            });
            /* harmony import */ var _react_progressToc__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../react/progressToc */ "./src/react/progressToc.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressToc", function() {
                return _react_progressToc__WEBPACK_IMPORTED_MODULE_42__["SurveyProgressToc"];
            });
            /* harmony import */ var _react_reactquestion_rating__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../react/reactquestion_rating */ "./src/react/reactquestion_rating.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRating", function() {
                return _react_reactquestion_rating__WEBPACK_IMPORTED_MODULE_43__["SurveyQuestionRating"];
            });
            /* harmony import */ var _react_rating_dropdown__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../react/rating-dropdown */ "./src/react/rating-dropdown.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRatingDropdown", function() {
                return _react_rating_dropdown__WEBPACK_IMPORTED_MODULE_44__["SurveyQuestionRatingDropdown"];
            });
            /* harmony import */ var _react_reactquestion_expression__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../react/reactquestion_expression */ "./src/react/reactquestion_expression.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionExpression", function() {
                return _react_reactquestion_expression__WEBPACK_IMPORTED_MODULE_45__["SurveyQuestionExpression"];
            });
            /* harmony import */ var _react_react_popup_survey__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../react/react-popup-survey */ "./src/react/react-popup-survey.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupSurvey", function() {
                return _react_react_popup_survey__WEBPACK_IMPORTED_MODULE_46__["PopupSurvey"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyWindow", function() {
                return _react_react_popup_survey__WEBPACK_IMPORTED_MODULE_46__["SurveyWindow"];
            });
            /* harmony import */ var _react_reactquestion_factory__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../react/reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReactQuestionFactory", function() {
                return _react_reactquestion_factory__WEBPACK_IMPORTED_MODULE_47__["ReactQuestionFactory"];
            });
            /* harmony import */ var _react_element_factory__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../react/element-factory */ "./src/react/element-factory.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReactElementFactory", function() {
                return _react_element_factory__WEBPACK_IMPORTED_MODULE_48__["ReactElementFactory"];
            });
            /* harmony import */ var _react_imagepicker__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../react/imagepicker */ "./src/react/imagepicker.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionImagePicker", function() {
                return _react_imagepicker__WEBPACK_IMPORTED_MODULE_49__["SurveyQuestionImagePicker"];
            });
            /* harmony import */ var _react_image__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../react/image */ "./src/react/image.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionImage", function() {
                return _react_image__WEBPACK_IMPORTED_MODULE_50__["SurveyQuestionImage"];
            });
            /* harmony import */ var _react_signaturepad__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../react/signaturepad */ "./src/react/signaturepad.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionSignaturePad", function() {
                return _react_signaturepad__WEBPACK_IMPORTED_MODULE_51__["SurveyQuestionSignaturePad"];
            });
            /* harmony import */ var _react_reactquestion_buttongroup__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../react/reactquestion_buttongroup */ "./src/react/reactquestion_buttongroup.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionButtonGroup", function() {
                return _react_reactquestion_buttongroup__WEBPACK_IMPORTED_MODULE_52__["SurveyQuestionButtonGroup"];
            });
            /* harmony import */ var _react_reactquestion_custom__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../react/reactquestion_custom */ "./src/react/reactquestion_custom.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCustom", function() {
                return _react_reactquestion_custom__WEBPACK_IMPORTED_MODULE_53__["SurveyQuestionCustom"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionComposite", function() {
                return _react_reactquestion_custom__WEBPACK_IMPORTED_MODULE_53__["SurveyQuestionComposite"];
            });
            /* harmony import */ var _react_components_popup_popup__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../react/components/popup/popup */ "./src/react/components/popup/popup.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() {
                return _react_components_popup_popup__WEBPACK_IMPORTED_MODULE_54__["Popup"];
            });
            /* harmony import */ var _react_components_list_list__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../react/components/list/list */ "./src/react/components/list/list.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() {
                return _react_components_list_list__WEBPACK_IMPORTED_MODULE_55__["List"];
            });
            /* harmony import */ var _react_components_title_title_actions__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../react/components/title/title-actions */ "./src/react/components/title/title-actions.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TitleActions", function() {
                return _react_components_title_title_actions__WEBPACK_IMPORTED_MODULE_56__["TitleActions"];
            });
            /* harmony import */ var _react_components_title_title_element__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../react/components/title/title-element */ "./src/react/components/title/title-element.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TitleElement", function() {
                return _react_components_title_title_element__WEBPACK_IMPORTED_MODULE_57__["TitleElement"];
            });
            /* harmony import */ var _react_components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../react/components/action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyActionBar", function() {
                return _react_components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_58__["SurveyActionBar"];
            });
            /* harmony import */ var _react_components_survey_header_logo_image__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../react/components/survey-header/logo-image */ "./src/react/components/survey-header/logo-image.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LogoImage", function() {
                return _react_components_survey_header_logo_image__WEBPACK_IMPORTED_MODULE_59__["LogoImage"];
            });
            /* harmony import */ var _react_components_survey_header_survey_header__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../react/components/survey-header/survey-header */ "./src/react/components/survey-header/survey-header.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyHeader", function() {
                return _react_components_survey_header_survey_header__WEBPACK_IMPORTED_MODULE_60__["SurveyHeader"];
            });
            /* harmony import */ var _react_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../react/components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgIcon", function() {
                return _react_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_61__["SvgIcon"];
            });
            /* harmony import */ var _react_components_matrix_actions_remove_button_remove_button__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../react/components/matrix-actions/remove-button/remove-button */ "./src/react/components/matrix-actions/remove-button/remove-button.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicRemoveButton", function() {
                return _react_components_matrix_actions_remove_button_remove_button__WEBPACK_IMPORTED_MODULE_62__["SurveyQuestionMatrixDynamicRemoveButton"];
            });
            /* harmony import */ var _react_components_matrix_actions_detail_button_detail_button__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../react/components/matrix-actions/detail-button/detail-button */ "./src/react/components/matrix-actions/detail-button/detail-button.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDetailButton", function() {
                return _react_components_matrix_actions_detail_button_detail_button__WEBPACK_IMPORTED_MODULE_63__["SurveyQuestionMatrixDetailButton"];
            });
            /* harmony import */ var _react_components_matrix_actions_drag_drop_icon_drag_drop_icon__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../react/components/matrix-actions/drag-drop-icon/drag-drop-icon */ "./src/react/components/matrix-actions/drag-drop-icon/drag-drop-icon.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicDragDropIcon", function() {
                return _react_components_matrix_actions_drag_drop_icon_drag_drop_icon__WEBPACK_IMPORTED_MODULE_64__["SurveyQuestionMatrixDynamicDragDropIcon"];
            });
            /* harmony import */ var _react_components_paneldynamic_actions_paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../react/components/paneldynamic-actions/paneldynamic-add-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-add-btn.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicAddButton", function() {
                return _react_components_paneldynamic_actions_paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_65__["SurveyQuestionPanelDynamicAddButton"];
            });
            /* harmony import */ var _react_components_paneldynamic_actions_paneldynamic_remove_btn__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../react/components/paneldynamic-actions/paneldynamic-remove-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-remove-btn.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicRemoveButton", function() {
                return _react_components_paneldynamic_actions_paneldynamic_remove_btn__WEBPACK_IMPORTED_MODULE_66__["SurveyQuestionPanelDynamicRemoveButton"];
            });
            /* harmony import */ var _react_components_paneldynamic_actions_paneldynamic_prev_btn__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../react/components/paneldynamic-actions/paneldynamic-prev-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-prev-btn.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicPrevButton", function() {
                return _react_components_paneldynamic_actions_paneldynamic_prev_btn__WEBPACK_IMPORTED_MODULE_67__["SurveyQuestionPanelDynamicPrevButton"];
            });
            /* harmony import */ var _react_components_paneldynamic_actions_paneldynamic_next_btn__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../react/components/paneldynamic-actions/paneldynamic-next-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-next-btn.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicNextButton", function() {
                return _react_components_paneldynamic_actions_paneldynamic_next_btn__WEBPACK_IMPORTED_MODULE_68__["SurveyQuestionPanelDynamicNextButton"];
            });
            /* harmony import */ var _react_components_paneldynamic_actions_paneldynamic_progress_text__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../react/components/paneldynamic-actions/paneldynamic-progress-text */ "./src/react/components/paneldynamic-actions/paneldynamic-progress-text.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicProgressText", function() {
                return _react_components_paneldynamic_actions_paneldynamic_progress_text__WEBPACK_IMPORTED_MODULE_69__["SurveyQuestionPanelDynamicProgressText"];
            });
            /* harmony import */ var _react_components_survey_actions_survey_nav_button__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../react/components/survey-actions/survey-nav-button */ "./src/react/components/survey-actions/survey-nav-button.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyNavigationButton", function() {
                return _react_components_survey_actions_survey_nav_button__WEBPACK_IMPORTED_MODULE_70__["SurveyNavigationButton"];
            });
            /* harmony import */ var _react_components_matrix_row__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../react/components/matrix/row */ "./src/react/components/matrix/row.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixRow", function() {
                return _react_components_matrix_row__WEBPACK_IMPORTED_MODULE_71__["MatrixRow"];
            });
            /* harmony import */ var _react_components_skeleton__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../react/components/skeleton */ "./src/react/components/skeleton.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Skeleton", function() {
                return _react_components_skeleton__WEBPACK_IMPORTED_MODULE_72__["Skeleton"];
            });
            /* harmony import */ var _react_components_notifier__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../react/components/notifier */ "./src/react/components/notifier.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NotifierComponent", function() {
                return _react_components_notifier__WEBPACK_IMPORTED_MODULE_73__["NotifierComponent"];
            });
            /* harmony import */ var _react_components_components_container__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../react/components/components-container */ "./src/react/components/components-container.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentsContainer", function() {
                return _react_components_components_container__WEBPACK_IMPORTED_MODULE_74__["ComponentsContainer"];
            });
            /* harmony import */ var _react_components_character_counter__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../react/components/character-counter */ "./src/react/components/character-counter.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CharacterCounterComponent", function() {
                return _react_components_character_counter__WEBPACK_IMPORTED_MODULE_75__["CharacterCounterComponent"];
            });
            /* harmony import */ var _react_components_header__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../react/components/header */ "./src/react/components/header.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderMobile", function() {
                return _react_components_header__WEBPACK_IMPORTED_MODULE_76__["HeaderMobile"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderCell", function() {
                return _react_components_header__WEBPACK_IMPORTED_MODULE_76__["HeaderCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Header", function() {
                return _react_components_header__WEBPACK_IMPORTED_MODULE_76__["Header"];
            });
            /* harmony import */ var _react_string_viewer__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../react/string-viewer */ "./src/react/string-viewer.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyLocStringViewer", function() {
                return _react_string_viewer__WEBPACK_IMPORTED_MODULE_77__["SurveyLocStringViewer"];
            });
            /* harmony import */ var _react_string_editor__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../react/string-editor */ "./src/react/string-editor.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyLocStringEditor", function() {
                return _react_string_editor__WEBPACK_IMPORTED_MODULE_78__["SurveyLocStringEditor"];
            });
            /* harmony import */ var _react_components_loading_indicator__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../react/components/loading-indicator */ "./src/react/components/loading-indicator.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoadingIndicatorComponent", function() {
                return _react_components_loading_indicator__WEBPACK_IMPORTED_MODULE_79__["LoadingIndicatorComponent"];
            });
            /* harmony import */ var _react_svgbundle__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../react/svgbundle */ "./src/react/svgbundle.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgBundleComponent", function() {
                return _react_svgbundle__WEBPACK_IMPORTED_MODULE_80__["SvgBundleComponent"];
            });
        // react
        //Uncomment to include the "date" question type.
        //export {default as SurveyQuestionDate} from "../plugins/react/reactquestiondate";
        /***/ },
        /***/ "./src/entries/react-ui.ts": /*!*********************************!*\
  !*** ./src/entries/react-ui.ts ***!
  \*********************************/ /*! exports provided: Survey, attachKey2click, ReactSurveyElementsWrapper, SurveyNavigationBase, SurveyTimerPanel, SurveyPage, SurveyRow, SurveyPanel, SurveyFlowPanel, SurveyQuestion, SurveyElementErrors, SurveyQuestionAndErrorsCell, ReactSurveyElement, SurveyElementBase, SurveyQuestionElementBase, SurveyQuestionCommentItem, SurveyQuestionComment, SurveyQuestionCheckbox, SurveyQuestionCheckboxItem, SurveyQuestionRanking, SurveyQuestionRankingItem, RatingItem, RatingItemStar, RatingItemSmiley, RatingDropdownItem, TagboxFilterString, SurveyQuestionOptionItem, SurveyQuestionDropdownBase, SurveyQuestionDropdown, SurveyQuestionTagboxItem, SurveyQuestionTagbox, SurveyQuestionDropdownSelect, SurveyQuestionMatrix, SurveyQuestionMatrixRow, SurveyQuestionMatrixCell, SurveyQuestionHtml, SurveyQuestionFile, SurveyFileChooseButton, SurveyFilePreview, SurveyQuestionMultipleText, SurveyQuestionRadiogroup, SurveyQuestionRadioItem, SurveyQuestionText, SurveyQuestionBoolean, SurveyQuestionBooleanCheckbox, SurveyQuestionBooleanRadio, SurveyQuestionEmpty, SurveyQuestionMatrixDropdownCell, SurveyQuestionMatrixDropdownBase, SurveyQuestionMatrixDropdown, SurveyQuestionMatrixDynamic, SurveyQuestionMatrixDynamicAddButton, SurveyQuestionPanelDynamic, SurveyProgress, SurveyProgressButtons, SurveyProgressToc, SurveyQuestionRating, SurveyQuestionRatingDropdown, SurveyQuestionExpression, PopupSurvey, SurveyWindow, ReactQuestionFactory, ReactElementFactory, SurveyQuestionImagePicker, SurveyQuestionImage, SurveyQuestionSignaturePad, SurveyQuestionButtonGroup, SurveyQuestionCustom, SurveyQuestionComposite, Popup, List, TitleActions, TitleElement, SurveyActionBar, LogoImage, SurveyHeader, SvgIcon, SurveyQuestionMatrixDynamicRemoveButton, SurveyQuestionMatrixDetailButton, SurveyQuestionMatrixDynamicDragDropIcon, SurveyQuestionPanelDynamicAddButton, SurveyQuestionPanelDynamicRemoveButton, SurveyQuestionPanelDynamicPrevButton, SurveyQuestionPanelDynamicNextButton, SurveyQuestionPanelDynamicProgressText, SurveyNavigationButton, MatrixRow, Skeleton, NotifierComponent, ComponentsContainer, CharacterCounterComponent, HeaderMobile, HeaderCell, Header, SurveyLocStringViewer, SurveyLocStringEditor, LoadingIndicatorComponent, SvgBundleComponent, SurveyModel, SurveyWindowModel, settings, surveyLocalization, surveyStrings, Model, ResponsivityManager, VerticalResponsivityManager, unwrap */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony import */ var _react_ui_model__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./react-ui-model */ "./src/entries/react-ui-model.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Survey", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["Survey"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "attachKey2click", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["attachKey2click"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReactSurveyElementsWrapper", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["ReactSurveyElementsWrapper"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyNavigationBase", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyNavigationBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyTimerPanel", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyTimerPanel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyPage", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyPage"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyRow", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyPanel", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyPanel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyFlowPanel", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyFlowPanel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestion", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestion"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElementErrors", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyElementErrors"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionAndErrorsCell", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionAndErrorsCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReactSurveyElement", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["ReactSurveyElement"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyElementBase", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyElementBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionElementBase", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionElementBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCommentItem", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionCommentItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionComment", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionComment"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCheckbox", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionCheckbox"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCheckboxItem", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionCheckboxItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRanking", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionRanking"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRankingItem", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionRankingItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingItem", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["RatingItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingItemStar", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["RatingItemStar"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingItemSmiley", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["RatingItemSmiley"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingDropdownItem", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["RatingDropdownItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TagboxFilterString", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["TagboxFilterString"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionOptionItem", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionOptionItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdownBase", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionDropdownBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdown", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionDropdown"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionTagboxItem", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionTagboxItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionTagbox", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionTagbox"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdownSelect", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionDropdownSelect"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrix", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrix"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixRow", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixCell", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionHtml", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionHtml"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionFile", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionFile"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyFileChooseButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyFileChooseButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyFilePreview", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyFilePreview"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMultipleText", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMultipleText"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRadiogroup", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionRadiogroup"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRadioItem", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionRadioItem"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionText", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionText"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBoolean", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionBoolean"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBooleanCheckbox", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionBooleanCheckbox"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBooleanRadio", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionBooleanRadio"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEmpty", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionEmpty"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdownCell", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixDropdownCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdownBase", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixDropdownBase"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdown", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixDropdown"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamic", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixDynamic"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicAddButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixDynamicAddButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamic", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionPanelDynamic"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgress", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyProgress"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressButtons", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyProgressButtons"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressToc", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyProgressToc"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRating", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionRating"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRatingDropdown", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionRatingDropdown"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionExpression", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionExpression"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "PopupSurvey", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["PopupSurvey"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyWindow", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyWindow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReactQuestionFactory", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["ReactQuestionFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ReactElementFactory", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["ReactElementFactory"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionImagePicker", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionImagePicker"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionImage", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionImage"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionSignaturePad", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionSignaturePad"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionButtonGroup", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionButtonGroup"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCustom", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionCustom"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionComposite", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionComposite"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Popup", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["Popup"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "List", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["List"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TitleActions", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["TitleActions"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "TitleElement", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["TitleElement"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyActionBar", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyActionBar"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LogoImage", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["LogoImage"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyHeader", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyHeader"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgIcon", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SvgIcon"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicRemoveButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixDynamicRemoveButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDetailButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixDetailButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicDragDropIcon", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionMatrixDynamicDragDropIcon"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicAddButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionPanelDynamicAddButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicRemoveButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionPanelDynamicRemoveButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicPrevButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionPanelDynamicPrevButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicNextButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionPanelDynamicNextButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicProgressText", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionPanelDynamicProgressText"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyNavigationButton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyNavigationButton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "MatrixRow", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["MatrixRow"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Skeleton", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["Skeleton"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "NotifierComponent", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["NotifierComponent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ComponentsContainer", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["ComponentsContainer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "CharacterCounterComponent", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["CharacterCounterComponent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderMobile", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["HeaderMobile"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "HeaderCell", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["HeaderCell"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Header", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["Header"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyLocStringViewer", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyLocStringViewer"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyLocStringEditor", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SurveyLocStringEditor"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "LoadingIndicatorComponent", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["LoadingIndicatorComponent"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SvgBundleComponent", function() {
                return _react_ui_model__WEBPACK_IMPORTED_MODULE_0__["SvgBundleComponent"];
            });
            /* harmony import */ var _core_export__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./core-export */ "./src/entries/core-export.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyModel", function() {
                return _core_export__WEBPACK_IMPORTED_MODULE_1__["SurveyModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyWindowModel", function() {
                return _core_export__WEBPACK_IMPORTED_MODULE_1__["SurveyWindowModel"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "settings", function() {
                return _core_export__WEBPACK_IMPORTED_MODULE_1__["settings"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyLocalization", function() {
                return _core_export__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "surveyStrings", function() {
                return _core_export__WEBPACK_IMPORTED_MODULE_1__["surveyStrings"];
            });
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_2__);
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "Model", function() {
                return survey_core__WEBPACK_IMPORTED_MODULE_2__["SurveyModel"];
            });
            /* harmony import */ var _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/responsivity-manager */ "./src/utils/responsivity-manager.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "ResponsivityManager", function() {
                return _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_3__["ResponsivityManager"];
            });
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "VerticalResponsivityManager", function() {
                return _utils_responsivity_manager__WEBPACK_IMPORTED_MODULE_3__["VerticalResponsivityManager"];
            });
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "unwrap", function() {
                return _utils_utils__WEBPACK_IMPORTED_MODULE_4__["unwrap"];
            });
            Object(survey_core__WEBPACK_IMPORTED_MODULE_2__["checkLibraryVersion"])("1.9.137", "survey-react-ui");
        /***/ },
        /***/ "./src/expressions/expressionParser.ts": /*!*********************************************!*\
  !*** ./src/expressions/expressionParser.ts ***!
  \*********************************************/ /*! exports provided: SyntaxError, parse */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SyntaxError", function() {
                return SyntaxError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parse", function() {
                return parse;
            });
            /* harmony import */ var _expressions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./expressions */ "./src/expressions/expressions.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            /* eslint-disable */ // Generated by PEG.js v. 0.10.0 (ts-pegjs plugin v. 0.3.1 )
            //
            // https://pegjs.org/   https://github.com/metadevpro/ts-pegjs
            "use strict";
            var SyntaxError = /** @class */ function(_super) {
                __extends(SyntaxError, _super);
                function SyntaxError(message, expected, found, location) {
                    var _this = _super.call(this) || this;
                    _this.message = message;
                    _this.expected = expected;
                    _this.found = found;
                    _this.location = location;
                    _this.name = "SyntaxError";
                    if (typeof Error.captureStackTrace === "function") Error.captureStackTrace(_this, SyntaxError);
                    return _this;
                }
                SyntaxError.buildMessage = function(expected, found) {
                    function hex(ch) {
                        return ch.charCodeAt(0).toString(16).toUpperCase();
                    }
                    function literalEscape(s) {
                        return s.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                            return "\\x0" + hex(ch);
                        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                            return "\\x" + hex(ch);
                        });
                    }
                    function classEscape(s) {
                        return s.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, function(ch) {
                            return "\\x0" + hex(ch);
                        }).replace(/[\x10-\x1F\x7F-\x9F]/g, function(ch) {
                            return "\\x" + hex(ch);
                        });
                    }
                    function describeExpectation(expectation) {
                        switch(expectation.type){
                            case "literal":
                                return '"' + literalEscape(expectation.text) + '"';
                            case "class":
                                var escapedParts = expectation.parts.map(function(part) {
                                    return Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part);
                                });
                                return "[" + (expectation.inverted ? "^" : "") + escapedParts + "]";
                            case "any":
                                return "any character";
                            case "end":
                                return "end of input";
                            case "other":
                                return expectation.description;
                        }
                    }
                    function describeExpected(expected1) {
                        var descriptions = expected1.map(describeExpectation);
                        var i;
                        var j;
                        descriptions.sort();
                        if (descriptions.length > 0) {
                            for(i = 1, j = 1; i < descriptions.length; i++)if (descriptions[i - 1] !== descriptions[i]) {
                                descriptions[j] = descriptions[i];
                                j++;
                            }
                            descriptions.length = j;
                        }
                        switch(descriptions.length){
                            case 1:
                                return descriptions[0];
                            case 2:
                                return descriptions[0] + " or " + descriptions[1];
                            default:
                                return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
                        }
                    }
                    function describeFound(found1) {
                        return found1 ? '"' + literalEscape(found1) + '"' : "end of input";
                    }
                    return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
                };
                return SyntaxError;
            }(Error);
            function peg$parse(input, options) {
                options = options !== undefined ? options : {};
                var peg$FAILED = {};
                var peg$startRuleFunctions = {
                    Expression: peg$parseExpression
                };
                var peg$startRuleFunction = peg$parseExpression;
                var peg$c0 = function(head, tail) {
                    return buildBinaryOperand(head, tail, true);
                };
                var peg$c1 = "||";
                var peg$c2 = peg$literalExpectation("||", false);
                var peg$c3 = "or";
                var peg$c4 = peg$literalExpectation("or", true);
                var peg$c5 = function() {
                    return "or";
                };
                var peg$c6 = "&&";
                var peg$c7 = peg$literalExpectation("&&", false);
                var peg$c8 = "and";
                var peg$c9 = peg$literalExpectation("and", true);
                var peg$c10 = function() {
                    return "and";
                };
                var peg$c11 = function(head, tail) {
                    return buildBinaryOperand(head, tail);
                };
                var peg$c12 = "<=";
                var peg$c13 = peg$literalExpectation("<=", false);
                var peg$c14 = "lessorequal";
                var peg$c15 = peg$literalExpectation("lessorequal", true);
                var peg$c16 = function() {
                    return "lessorequal";
                };
                var peg$c17 = ">=";
                var peg$c18 = peg$literalExpectation(">=", false);
                var peg$c19 = "greaterorequal";
                var peg$c20 = peg$literalExpectation("greaterorequal", true);
                var peg$c21 = function() {
                    return "greaterorequal";
                };
                var peg$c22 = "==";
                var peg$c23 = peg$literalExpectation("==", false);
                var peg$c24 = "equal";
                var peg$c25 = peg$literalExpectation("equal", true);
                var peg$c26 = function() {
                    return "equal";
                };
                var peg$c27 = "=";
                var peg$c28 = peg$literalExpectation("=", false);
                var peg$c29 = "!=";
                var peg$c30 = peg$literalExpectation("!=", false);
                var peg$c31 = "notequal";
                var peg$c32 = peg$literalExpectation("notequal", true);
                var peg$c33 = function() {
                    return "notequal";
                };
                var peg$c34 = "<";
                var peg$c35 = peg$literalExpectation("<", false);
                var peg$c36 = "less";
                var peg$c37 = peg$literalExpectation("less", true);
                var peg$c38 = function() {
                    return "less";
                };
                var peg$c39 = ">";
                var peg$c40 = peg$literalExpectation(">", false);
                var peg$c41 = "greater";
                var peg$c42 = peg$literalExpectation("greater", true);
                var peg$c43 = function() {
                    return "greater";
                };
                var peg$c44 = "+";
                var peg$c45 = peg$literalExpectation("+", false);
                var peg$c46 = function() {
                    return "plus";
                };
                var peg$c47 = "-";
                var peg$c48 = peg$literalExpectation("-", false);
                var peg$c49 = function() {
                    return "minus";
                };
                var peg$c50 = "*";
                var peg$c51 = peg$literalExpectation("*", false);
                var peg$c52 = function() {
                    return "mul";
                };
                var peg$c53 = "/";
                var peg$c54 = peg$literalExpectation("/", false);
                var peg$c55 = function() {
                    return "div";
                };
                var peg$c56 = "%";
                var peg$c57 = peg$literalExpectation("%", false);
                var peg$c58 = function() {
                    return "mod";
                };
                var peg$c59 = "^";
                var peg$c60 = peg$literalExpectation("^", false);
                var peg$c61 = "power";
                var peg$c62 = peg$literalExpectation("power", true);
                var peg$c63 = function() {
                    return "power";
                };
                var peg$c64 = "*=";
                var peg$c65 = peg$literalExpectation("*=", false);
                var peg$c66 = "contains";
                var peg$c67 = peg$literalExpectation("contains", true);
                var peg$c68 = "contain";
                var peg$c69 = peg$literalExpectation("contain", true);
                var peg$c70 = function() {
                    return "contains";
                };
                var peg$c71 = "notcontains";
                var peg$c72 = peg$literalExpectation("notcontains", true);
                var peg$c73 = "notcontain";
                var peg$c74 = peg$literalExpectation("notcontain", true);
                var peg$c75 = function() {
                    return "notcontains";
                };
                var peg$c76 = "anyof";
                var peg$c77 = peg$literalExpectation("anyof", true);
                var peg$c78 = function() {
                    return "anyof";
                };
                var peg$c79 = "allof";
                var peg$c80 = peg$literalExpectation("allof", true);
                var peg$c81 = function() {
                    return "allof";
                };
                var peg$c82 = "(";
                var peg$c83 = peg$literalExpectation("(", false);
                var peg$c84 = ")";
                var peg$c85 = peg$literalExpectation(")", false);
                var peg$c86 = function(expr) {
                    return expr;
                };
                var peg$c87 = function(name, params) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["FunctionOperand"](name, params);
                };
                var peg$c88 = "!";
                var peg$c89 = peg$literalExpectation("!", false);
                var peg$c90 = "negate";
                var peg$c91 = peg$literalExpectation("negate", true);
                var peg$c92 = function(expr) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["UnaryOperand"](expr, "negate");
                };
                var peg$c93 = function(expr, op) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["UnaryOperand"](expr, op);
                };
                var peg$c94 = "empty";
                var peg$c95 = peg$literalExpectation("empty", true);
                var peg$c96 = function() {
                    return "empty";
                };
                var peg$c97 = "notempty";
                var peg$c98 = peg$literalExpectation("notempty", true);
                var peg$c99 = function() {
                    return "notempty";
                };
                var peg$c100 = "undefined";
                var peg$c101 = peg$literalExpectation("undefined", false);
                var peg$c102 = "null";
                var peg$c103 = peg$literalExpectation("null", false);
                var peg$c104 = function() {
                    return null;
                };
                var peg$c105 = function(value) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["Const"](value);
                };
                var peg$c106 = "{";
                var peg$c107 = peg$literalExpectation("{", false);
                var peg$c108 = "}";
                var peg$c109 = peg$literalExpectation("}", false);
                var peg$c110 = function(value) {
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["Variable"](value);
                };
                var peg$c111 = function(value) {
                    return value;
                };
                var peg$c112 = "''";
                var peg$c113 = peg$literalExpectation("''", false);
                var peg$c114 = function() {
                    return "";
                };
                var peg$c115 = '""';
                var peg$c116 = peg$literalExpectation('""', false);
                var peg$c117 = "'";
                var peg$c118 = peg$literalExpectation("'", false);
                var peg$c119 = function(value) {
                    return "'" + value + "'";
                };
                var peg$c120 = '"';
                var peg$c121 = peg$literalExpectation('"', false);
                var peg$c122 = "[";
                var peg$c123 = peg$literalExpectation("[", false);
                var peg$c124 = "]";
                var peg$c125 = peg$literalExpectation("]", false);
                var peg$c126 = function(sequence) {
                    return sequence;
                };
                var peg$c127 = ",";
                var peg$c128 = peg$literalExpectation(",", false);
                var peg$c129 = function(expr, tail) {
                    if (expr == null) return new _expressions__WEBPACK_IMPORTED_MODULE_0__["ArrayOperand"]([]);
                    var array = [
                        expr
                    ];
                    if (Array.isArray(tail)) {
                        var flatten = flattenArray(tail);
                        for(var i = 3; i < flatten.length; i += 4)array.push(flatten[i]);
                    }
                    return new _expressions__WEBPACK_IMPORTED_MODULE_0__["ArrayOperand"](array);
                };
                var peg$c130 = "true";
                var peg$c131 = peg$literalExpectation("true", true);
                var peg$c132 = function() {
                    return true;
                };
                var peg$c133 = "false";
                var peg$c134 = peg$literalExpectation("false", true);
                var peg$c135 = function() {
                    return false;
                };
                var peg$c136 = "0x";
                var peg$c137 = peg$literalExpectation("0x", false);
                var peg$c138 = function() {
                    return parseInt(text(), 16);
                };
                var peg$c139 = /^[\-]/;
                var peg$c140 = peg$classExpectation([
                    "-"
                ], false, false);
                var peg$c141 = function(sign, num) {
                    return sign == null ? num : -num;
                };
                var peg$c142 = ".";
                var peg$c143 = peg$literalExpectation(".", false);
                var peg$c144 = function() {
                    return parseFloat(text());
                };
                var peg$c145 = function() {
                    return parseInt(text(), 10);
                };
                var peg$c146 = "0";
                var peg$c147 = peg$literalExpectation("0", false);
                var peg$c148 = function() {
                    return 0;
                };
                var peg$c149 = function(chars) {
                    return chars.join("");
                };
                var peg$c150 = "\\'";
                var peg$c151 = peg$literalExpectation("\\'", false);
                var peg$c152 = function() {
                    return "'";
                };
                var peg$c153 = '\\"';
                var peg$c154 = peg$literalExpectation('\\"', false);
                var peg$c155 = function() {
                    return '"';
                };
                var peg$c156 = /^[^"']/;
                var peg$c157 = peg$classExpectation([
                    '"',
                    "'"
                ], true, false);
                var peg$c158 = function() {
                    return text();
                };
                var peg$c159 = /^[^{}]/;
                var peg$c160 = peg$classExpectation([
                    "{",
                    "}"
                ], true, false);
                var peg$c161 = /^[0-9]/;
                var peg$c162 = peg$classExpectation([
                    [
                        "0",
                        "9"
                    ]
                ], false, false);
                var peg$c163 = /^[1-9]/;
                var peg$c164 = peg$classExpectation([
                    [
                        "1",
                        "9"
                    ]
                ], false, false);
                var peg$c165 = /^[a-zA-Z_]/;
                var peg$c166 = peg$classExpectation([
                    [
                        "a",
                        "z"
                    ],
                    [
                        "A",
                        "Z"
                    ],
                    "_"
                ], false, false);
                var peg$c167 = peg$otherExpectation("whitespace");
                var peg$c168 = /^[ \t\n\r]/;
                var peg$c169 = peg$classExpectation([
                    " ",
                    "	",
                    "\n",
                    "\r"
                ], false, false);
                var peg$currPos = 0;
                var peg$savedPos = 0;
                var peg$posDetailsCache = [
                    {
                        line: 1,
                        column: 1
                    }
                ];
                var peg$maxFailPos = 0;
                var peg$maxFailExpected = [];
                var peg$silentFails = 0;
                var peg$resultsCache = {};
                var peg$result;
                if (options.startRule !== undefined) {
                    if (!(options.startRule in peg$startRuleFunctions)) throw new Error("Can't start parsing from rule \"" + options.startRule + '".');
                    peg$startRuleFunction = peg$startRuleFunctions[options.startRule];
                }
                function text() {
                    return input.substring(peg$savedPos, peg$currPos);
                }
                function location() {
                    return peg$computeLocation(peg$savedPos, peg$currPos);
                }
                function expected(description, location1) {
                    location1 = location1 !== undefined ? location1 : peg$computeLocation(peg$savedPos, peg$currPos);
                    throw peg$buildStructuredError([
                        peg$otherExpectation(description)
                    ], input.substring(peg$savedPos, peg$currPos), location1);
                }
                function error(message, location1) {
                    location1 = location1 !== undefined ? location1 : peg$computeLocation(peg$savedPos, peg$currPos);
                    throw peg$buildSimpleError(message, location1);
                }
                function peg$literalExpectation(text1, ignoreCase) {
                    return {
                        type: "literal",
                        text: text1,
                        ignoreCase: ignoreCase
                    };
                }
                function peg$classExpectation(parts, inverted, ignoreCase) {
                    return {
                        type: "class",
                        parts: parts,
                        inverted: inverted,
                        ignoreCase: ignoreCase
                    };
                }
                function peg$anyExpectation() {
                    return {
                        type: "any"
                    };
                }
                function peg$endExpectation() {
                    return {
                        type: "end"
                    };
                }
                function peg$otherExpectation(description) {
                    return {
                        type: "other",
                        description: description
                    };
                }
                function peg$computePosDetails(pos) {
                    var details = peg$posDetailsCache[pos];
                    var p;
                    if (details) return details;
                    else {
                        p = pos - 1;
                        while(!peg$posDetailsCache[p])p--;
                        details = peg$posDetailsCache[p];
                        details = {
                            line: details.line,
                            column: details.column
                        };
                        while(p < pos){
                            if (input.charCodeAt(p) === 10) {
                                details.line++;
                                details.column = 1;
                            } else details.column++;
                            p++;
                        }
                        peg$posDetailsCache[pos] = details;
                        return details;
                    }
                }
                function peg$computeLocation(startPos, endPos) {
                    var startPosDetails = peg$computePosDetails(startPos);
                    var endPosDetails = peg$computePosDetails(endPos);
                    return {
                        start: {
                            offset: startPos,
                            line: startPosDetails.line,
                            column: startPosDetails.column
                        },
                        end: {
                            offset: endPos,
                            line: endPosDetails.line,
                            column: endPosDetails.column
                        }
                    };
                }
                function peg$fail(expected1) {
                    if (peg$currPos < peg$maxFailPos) return;
                    if (peg$currPos > peg$maxFailPos) {
                        peg$maxFailPos = peg$currPos;
                        peg$maxFailExpected = [];
                    }
                    peg$maxFailExpected.push(expected1);
                }
                function peg$buildSimpleError(message, location1) {
                    return new SyntaxError(message, [], "", location1);
                }
                function peg$buildStructuredError(expected1, found, location1) {
                    return new SyntaxError(SyntaxError.buildMessage(expected1, found), expected1, found, location1);
                }
                function peg$parseExpression() {
                    var s0, s1, s2, s3, s4, s5, s6, s7, s8;
                    var key = peg$currPos * 34 + 0;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parse_();
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseLogicOr();
                        if (s2 !== peg$FAILED) {
                            s3 = [];
                            s4 = peg$currPos;
                            s5 = peg$parse_();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parseOrSign();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parse_();
                                    if (s7 !== peg$FAILED) {
                                        s8 = peg$parseLogicOr();
                                        if (s8 !== peg$FAILED) {
                                            s5 = [
                                                s5,
                                                s6,
                                                s7,
                                                s8
                                            ];
                                            s4 = s5;
                                        } else {
                                            peg$currPos = s4;
                                            s4 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s4;
                                        s4 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s4;
                                s4 = peg$FAILED;
                            }
                            while(s4 !== peg$FAILED){
                                s3.push(s4);
                                s4 = peg$currPos;
                                s5 = peg$parse_();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parseOrSign();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parse_();
                                        if (s7 !== peg$FAILED) {
                                            s8 = peg$parseLogicOr();
                                            if (s8 !== peg$FAILED) {
                                                s5 = [
                                                    s5,
                                                    s6,
                                                    s7,
                                                    s8
                                                ];
                                                s4 = s5;
                                            } else {
                                                peg$currPos = s4;
                                                s4 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s4;
                                            s4 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s4;
                                        s4 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s4;
                                    s4 = peg$FAILED;
                                }
                            }
                            if (s3 !== peg$FAILED) {
                                s4 = peg$parse_();
                                if (s4 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c0(s2, s3);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseOrSign() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 1;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c1) {
                        s1 = peg$c1;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c2);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 2).toLowerCase() === peg$c3) {
                            s1 = input.substr(peg$currPos, 2);
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c4);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c5();
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLogicOr() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 2;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseLogicAnd();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseAndSign();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseLogicAnd();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseAndSign();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseLogicAnd();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseAndSign() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 3;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c6) {
                        s1 = peg$c6;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c7);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 3).toLowerCase() === peg$c8) {
                            s1 = input.substr(peg$currPos, 3);
                            peg$currPos += 3;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c9);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c10();
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLogicAnd() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 4;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseCompOps();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseComparableOperators();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseCompOps();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseComparableOperators();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseCompOps();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c11(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseComparableOperators() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 5;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c12) {
                        s1 = peg$c12;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c13);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 11).toLowerCase() === peg$c14) {
                            s1 = input.substr(peg$currPos, 11);
                            peg$currPos += 11;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c15);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c16();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c17) {
                            s1 = peg$c17;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c18);
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 14).toLowerCase() === peg$c19) {
                                s1 = input.substr(peg$currPos, 14);
                                peg$currPos += 14;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c20);
                            }
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c21();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 2) === peg$c22) {
                                s1 = peg$c22;
                                peg$currPos += 2;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c23);
                            }
                            if (s1 === peg$FAILED) {
                                if (input.substr(peg$currPos, 5).toLowerCase() === peg$c24) {
                                    s1 = input.substr(peg$currPos, 5);
                                    peg$currPos += 5;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c25);
                                }
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c26();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.charCodeAt(peg$currPos) === 61) {
                                    s1 = peg$c27;
                                    peg$currPos++;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c28);
                                }
                                if (s1 === peg$FAILED) {
                                    if (input.substr(peg$currPos, 5).toLowerCase() === peg$c24) {
                                        s1 = input.substr(peg$currPos, 5);
                                        peg$currPos += 5;
                                    } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c25);
                                    }
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c26();
                                }
                                s0 = s1;
                                if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    if (input.substr(peg$currPos, 2) === peg$c29) {
                                        s1 = peg$c29;
                                        peg$currPos += 2;
                                    } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c30);
                                    }
                                    if (s1 === peg$FAILED) {
                                        if (input.substr(peg$currPos, 8).toLowerCase() === peg$c31) {
                                            s1 = input.substr(peg$currPos, 8);
                                            peg$currPos += 8;
                                        } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c32);
                                        }
                                    }
                                    if (s1 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c33();
                                    }
                                    s0 = s1;
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 60) {
                                            s1 = peg$c34;
                                            peg$currPos++;
                                        } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c35);
                                        }
                                        if (s1 === peg$FAILED) {
                                            if (input.substr(peg$currPos, 4).toLowerCase() === peg$c36) {
                                                s1 = input.substr(peg$currPos, 4);
                                                peg$currPos += 4;
                                            } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) peg$fail(peg$c37);
                                            }
                                        }
                                        if (s1 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c38();
                                        }
                                        s0 = s1;
                                        if (s0 === peg$FAILED) {
                                            s0 = peg$currPos;
                                            if (input.charCodeAt(peg$currPos) === 62) {
                                                s1 = peg$c39;
                                                peg$currPos++;
                                            } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) peg$fail(peg$c40);
                                            }
                                            if (s1 === peg$FAILED) {
                                                if (input.substr(peg$currPos, 7).toLowerCase() === peg$c41) {
                                                    s1 = input.substr(peg$currPos, 7);
                                                    peg$currPos += 7;
                                                } else {
                                                    s1 = peg$FAILED;
                                                    if (peg$silentFails === 0) peg$fail(peg$c42);
                                                }
                                            }
                                            if (s1 !== peg$FAILED) {
                                                peg$savedPos = s0;
                                                s1 = peg$c43();
                                            }
                                            s0 = s1;
                                        }
                                    }
                                }
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseCompOps() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 6;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parsePlusMinusOps();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsePlusMinusSigns();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parsePlusMinusOps();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parsePlusMinusSigns();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parsePlusMinusOps();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parsePlusMinusSigns() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 7;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 43) {
                        s1 = peg$c44;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c45);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c46();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 45) {
                            s1 = peg$c47;
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c48);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c49();
                        }
                        s0 = s1;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parsePlusMinusOps() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 8;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseMulDivOps();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseMulDivSigns();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseMulDivOps();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseMulDivSigns();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseMulDivOps();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseMulDivSigns() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 9;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 42) {
                        s1 = peg$c50;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c51);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c52();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.charCodeAt(peg$currPos) === 47) {
                            s1 = peg$c53;
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c54);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c55();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 37) {
                                s1 = peg$c56;
                                peg$currPos++;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c57);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c58();
                            }
                            s0 = s1;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseMulDivOps() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 10;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseBinaryFuncOp();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parsePowerSigns();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseBinaryFuncOp();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parsePowerSigns();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseBinaryFuncOp();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c0(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parsePowerSigns() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 11;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 94) {
                        s1 = peg$c59;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c60);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 5).toLowerCase() === peg$c61) {
                            s1 = input.substr(peg$currPos, 5);
                            peg$currPos += 5;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c62);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c63();
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseBinaryFuncOp() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 12;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseFactor();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            s5 = peg$parseBinFunctions();
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseFactor();
                                    if (s7 === peg$FAILED) s7 = null;
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                s5 = peg$parseBinFunctions();
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseFactor();
                                        if (s7 === peg$FAILED) s7 = null;
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c11(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseBinFunctions() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 13;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c64) {
                        s1 = peg$c64;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c65);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 8).toLowerCase() === peg$c66) {
                            s1 = input.substr(peg$currPos, 8);
                            peg$currPos += 8;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c67);
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 7).toLowerCase() === peg$c68) {
                                s1 = input.substr(peg$currPos, 7);
                                peg$currPos += 7;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c69);
                            }
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c70();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 11).toLowerCase() === peg$c71) {
                            s1 = input.substr(peg$currPos, 11);
                            peg$currPos += 11;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c72);
                        }
                        if (s1 === peg$FAILED) {
                            if (input.substr(peg$currPos, 10).toLowerCase() === peg$c73) {
                                s1 = input.substr(peg$currPos, 10);
                                peg$currPos += 10;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c74);
                            }
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c75();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.substr(peg$currPos, 5).toLowerCase() === peg$c76) {
                                s1 = input.substr(peg$currPos, 5);
                                peg$currPos += 5;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c77);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c78();
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 5).toLowerCase() === peg$c79) {
                                    s1 = input.substr(peg$currPos, 5);
                                    peg$currPos += 5;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c80);
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c81();
                                }
                                s0 = s1;
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseFactor() {
                    var s0, s1, s2, s3, s4, s5;
                    var key = peg$currPos * 34 + 14;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 40) {
                        s1 = peg$c82;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c83);
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parse_();
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseExpression();
                            if (s3 !== peg$FAILED) {
                                s4 = peg$parse_();
                                if (s4 !== peg$FAILED) {
                                    if (input.charCodeAt(peg$currPos) === 41) {
                                        s5 = peg$c84;
                                        peg$currPos++;
                                    } else {
                                        s5 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c85);
                                    }
                                    if (s5 === peg$FAILED) s5 = null;
                                    if (s5 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c86(s3);
                                        s0 = s1;
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$parseFunctionOp();
                        if (s0 === peg$FAILED) {
                            s0 = peg$parseUnaryFunctionOp();
                            if (s0 === peg$FAILED) {
                                s0 = peg$parseAtom();
                                if (s0 === peg$FAILED) s0 = peg$parseArrayOp();
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseFunctionOp() {
                    var s0, s1, s2, s3, s4;
                    var key = peg$currPos * 34 + 15;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseLettersAndDigits();
                    if (s1 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 40) {
                            s2 = peg$c82;
                            peg$currPos++;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c83);
                        }
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseSequence();
                            if (s3 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 41) {
                                    s4 = peg$c84;
                                    peg$currPos++;
                                } else {
                                    s4 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c85);
                                }
                                if (s4 === peg$FAILED) s4 = null;
                                if (s4 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c87(s1, s3);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseUnaryFunctionOp() {
                    var s0, s1, s2, s3;
                    var key = peg$currPos * 34 + 16;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 33) {
                        s1 = peg$c88;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c89);
                    }
                    if (s1 === peg$FAILED) {
                        if (input.substr(peg$currPos, 6).toLowerCase() === peg$c90) {
                            s1 = input.substr(peg$currPos, 6);
                            peg$currPos += 6;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c91);
                        }
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parse_();
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseExpression();
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c92(s3);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseAtom();
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parse_();
                            if (s2 !== peg$FAILED) {
                                s3 = peg$parseUnFunctions();
                                if (s3 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c93(s1, s3);
                                    s0 = s1;
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseUnFunctions() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 17;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 5).toLowerCase() === peg$c94) {
                        s1 = input.substr(peg$currPos, 5);
                        peg$currPos += 5;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c95);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c96();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 8).toLowerCase() === peg$c97) {
                            s1 = input.substr(peg$currPos, 8);
                            peg$currPos += 8;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c98);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c99();
                        }
                        s0 = s1;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseAtom() {
                    var s0, s1, s2, s3, s4;
                    var key = peg$currPos * 34 + 18;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parse_();
                    if (s1 !== peg$FAILED) {
                        if (input.substr(peg$currPos, 9) === peg$c100) {
                            s2 = peg$c100;
                            peg$currPos += 9;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c101);
                        }
                        if (s2 === peg$FAILED) {
                            if (input.substr(peg$currPos, 4) === peg$c102) {
                                s2 = peg$c102;
                                peg$currPos += 4;
                            } else {
                                s2 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c103);
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c104();
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parse_();
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parseConstValue();
                            if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c105(s2);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parse_();
                            if (s1 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 123) {
                                    s2 = peg$c106;
                                    peg$currPos++;
                                } else {
                                    s2 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c107);
                                }
                                if (s2 !== peg$FAILED) {
                                    s3 = peg$parseValueInput();
                                    if (s3 !== peg$FAILED) {
                                        if (input.charCodeAt(peg$currPos) === 125) {
                                            s4 = peg$c108;
                                            peg$currPos++;
                                        } else {
                                            s4 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c109);
                                        }
                                        if (s4 !== peg$FAILED) {
                                            peg$savedPos = s0;
                                            s1 = peg$c110(s3);
                                            s0 = s1;
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s0;
                                        s0 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s0;
                                    s0 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseConstValue() {
                    var s0, s1, s2, s3;
                    var key = peg$currPos * 34 + 19;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseLogicValue();
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c111(s1);
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseArithmeticValue();
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c111(s1);
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            s1 = peg$parseLettersAndDigits();
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c111(s1);
                            }
                            s0 = s1;
                            if (s0 === peg$FAILED) {
                                s0 = peg$currPos;
                                if (input.substr(peg$currPos, 2) === peg$c112) {
                                    s1 = peg$c112;
                                    peg$currPos += 2;
                                } else {
                                    s1 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c113);
                                }
                                if (s1 !== peg$FAILED) {
                                    peg$savedPos = s0;
                                    s1 = peg$c114();
                                }
                                s0 = s1;
                                if (s0 === peg$FAILED) {
                                    s0 = peg$currPos;
                                    if (input.substr(peg$currPos, 2) === peg$c115) {
                                        s1 = peg$c115;
                                        peg$currPos += 2;
                                    } else {
                                        s1 = peg$FAILED;
                                        if (peg$silentFails === 0) peg$fail(peg$c116);
                                    }
                                    if (s1 !== peg$FAILED) {
                                        peg$savedPos = s0;
                                        s1 = peg$c114();
                                    }
                                    s0 = s1;
                                    if (s0 === peg$FAILED) {
                                        s0 = peg$currPos;
                                        if (input.charCodeAt(peg$currPos) === 39) {
                                            s1 = peg$c117;
                                            peg$currPos++;
                                        } else {
                                            s1 = peg$FAILED;
                                            if (peg$silentFails === 0) peg$fail(peg$c118);
                                        }
                                        if (s1 !== peg$FAILED) {
                                            s2 = peg$parseAnyInput();
                                            if (s2 !== peg$FAILED) {
                                                if (input.charCodeAt(peg$currPos) === 39) {
                                                    s3 = peg$c117;
                                                    peg$currPos++;
                                                } else {
                                                    s3 = peg$FAILED;
                                                    if (peg$silentFails === 0) peg$fail(peg$c118);
                                                }
                                                if (s3 !== peg$FAILED) {
                                                    peg$savedPos = s0;
                                                    s1 = peg$c119(s2);
                                                    s0 = s1;
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        } else {
                                            peg$currPos = s0;
                                            s0 = peg$FAILED;
                                        }
                                        if (s0 === peg$FAILED) {
                                            s0 = peg$currPos;
                                            if (input.charCodeAt(peg$currPos) === 34) {
                                                s1 = peg$c120;
                                                peg$currPos++;
                                            } else {
                                                s1 = peg$FAILED;
                                                if (peg$silentFails === 0) peg$fail(peg$c121);
                                            }
                                            if (s1 !== peg$FAILED) {
                                                s2 = peg$parseAnyInput();
                                                if (s2 !== peg$FAILED) {
                                                    if (input.charCodeAt(peg$currPos) === 34) {
                                                        s3 = peg$c120;
                                                        peg$currPos++;
                                                    } else {
                                                        s3 = peg$FAILED;
                                                        if (peg$silentFails === 0) peg$fail(peg$c121);
                                                    }
                                                    if (s3 !== peg$FAILED) {
                                                        peg$savedPos = s0;
                                                        s1 = peg$c119(s2);
                                                        s0 = s1;
                                                    } else {
                                                        peg$currPos = s0;
                                                        s0 = peg$FAILED;
                                                    }
                                                } else {
                                                    peg$currPos = s0;
                                                    s0 = peg$FAILED;
                                                }
                                            } else {
                                                peg$currPos = s0;
                                                s0 = peg$FAILED;
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseArrayOp() {
                    var s0, s1, s2, s3;
                    var key = peg$currPos * 34 + 20;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.charCodeAt(peg$currPos) === 91) {
                        s1 = peg$c122;
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c123);
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseSequence();
                        if (s2 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 93) {
                                s3 = peg$c124;
                                peg$currPos++;
                            } else {
                                s3 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c125);
                            }
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c126(s2);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseSequence() {
                    var s0, s1, s2, s3, s4, s5, s6, s7;
                    var key = peg$currPos * 34 + 21;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseExpression();
                    if (s1 === peg$FAILED) s1 = null;
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parse_();
                        if (s4 !== peg$FAILED) {
                            if (input.charCodeAt(peg$currPos) === 44) {
                                s5 = peg$c127;
                                peg$currPos++;
                            } else {
                                s5 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c128);
                            }
                            if (s5 !== peg$FAILED) {
                                s6 = peg$parse_();
                                if (s6 !== peg$FAILED) {
                                    s7 = peg$parseExpression();
                                    if (s7 !== peg$FAILED) {
                                        s4 = [
                                            s4,
                                            s5,
                                            s6,
                                            s7
                                        ];
                                        s3 = s4;
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parse_();
                            if (s4 !== peg$FAILED) {
                                if (input.charCodeAt(peg$currPos) === 44) {
                                    s5 = peg$c127;
                                    peg$currPos++;
                                } else {
                                    s5 = peg$FAILED;
                                    if (peg$silentFails === 0) peg$fail(peg$c128);
                                }
                                if (s5 !== peg$FAILED) {
                                    s6 = peg$parse_();
                                    if (s6 !== peg$FAILED) {
                                        s7 = peg$parseExpression();
                                        if (s7 !== peg$FAILED) {
                                            s4 = [
                                                s4,
                                                s5,
                                                s6,
                                                s7
                                            ];
                                            s3 = s4;
                                        } else {
                                            peg$currPos = s3;
                                            s3 = peg$FAILED;
                                        }
                                    } else {
                                        peg$currPos = s3;
                                        s3 = peg$FAILED;
                                    }
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c129(s1, s2);
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLogicValue() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 22;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 4).toLowerCase() === peg$c130) {
                        s1 = input.substr(peg$currPos, 4);
                        peg$currPos += 4;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c131);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c132();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 5).toLowerCase() === peg$c133) {
                            s1 = input.substr(peg$currPos, 5);
                            peg$currPos += 5;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c134);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c135();
                        }
                        s0 = s1;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseArithmeticValue() {
                    var s0, s1, s2;
                    var key = peg$currPos * 34 + 23;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c136) {
                        s1 = peg$c136;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c137);
                    }
                    if (s1 !== peg$FAILED) {
                        s2 = peg$parseDigits();
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c138();
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (peg$c139.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c140);
                        }
                        if (s1 === peg$FAILED) s1 = null;
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parseNumber();
                            if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c141(s1, s2);
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseNumber() {
                    var s0, s1, s2, s3;
                    var key = peg$currPos * 34 + 24;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseDigits();
                    if (s1 !== peg$FAILED) {
                        if (input.charCodeAt(peg$currPos) === 46) {
                            s2 = peg$c142;
                            peg$currPos++;
                        } else {
                            s2 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c143);
                        }
                        if (s2 !== peg$FAILED) {
                            s3 = peg$parseDigits();
                            if (s3 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c144();
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        s1 = peg$parseNonZeroDigits();
                        if (s1 !== peg$FAILED) {
                            s2 = peg$parseDigits();
                            if (s2 === peg$FAILED) s2 = null;
                            if (s2 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c145();
                                s0 = s1;
                            } else {
                                peg$currPos = s0;
                                s0 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (input.charCodeAt(peg$currPos) === 48) {
                                s1 = peg$c146;
                                peg$currPos++;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c147);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c148();
                            }
                            s0 = s1;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseValueInput() {
                    var s0, s1, s2;
                    var key = peg$currPos * 34 + 25;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = [];
                    s2 = peg$parseValueCharacters();
                    if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                        s1.push(s2);
                        s2 = peg$parseValueCharacters();
                    }
                    else s1 = peg$FAILED;
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c149(s1);
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseAnyInput() {
                    var s0, s1, s2;
                    var key = peg$currPos * 34 + 26;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = [];
                    s2 = peg$parseAnyCharacters();
                    if (s2 !== peg$FAILED) while(s2 !== peg$FAILED){
                        s1.push(s2);
                        s2 = peg$parseAnyCharacters();
                    }
                    else s1 = peg$FAILED;
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c149(s1);
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseAnyCharacters() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 27;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (input.substr(peg$currPos, 2) === peg$c150) {
                        s1 = peg$c150;
                        peg$currPos += 2;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c151);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c152();
                    }
                    s0 = s1;
                    if (s0 === peg$FAILED) {
                        s0 = peg$currPos;
                        if (input.substr(peg$currPos, 2) === peg$c153) {
                            s1 = peg$c153;
                            peg$currPos += 2;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c154);
                        }
                        if (s1 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c155();
                        }
                        s0 = s1;
                        if (s0 === peg$FAILED) {
                            s0 = peg$currPos;
                            if (peg$c156.test(input.charAt(peg$currPos))) {
                                s1 = input.charAt(peg$currPos);
                                peg$currPos++;
                            } else {
                                s1 = peg$FAILED;
                                if (peg$silentFails === 0) peg$fail(peg$c157);
                            }
                            if (s1 !== peg$FAILED) {
                                peg$savedPos = s0;
                                s1 = peg$c158();
                            }
                            s0 = s1;
                        }
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseValueCharacters() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 28;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    if (peg$c159.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c160);
                    }
                    if (s1 !== peg$FAILED) {
                        peg$savedPos = s0;
                        s1 = peg$c158();
                    }
                    s0 = s1;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLettersAndDigits() {
                    var s0, s1, s2, s3, s4, s5, s6;
                    var key = peg$currPos * 34 + 29;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = peg$currPos;
                    s1 = peg$parseLetters();
                    if (s1 !== peg$FAILED) {
                        s2 = [];
                        s3 = peg$currPos;
                        s4 = peg$parseDigits();
                        if (s4 !== peg$FAILED) {
                            s5 = [];
                            s6 = peg$parseLetters();
                            while(s6 !== peg$FAILED){
                                s5.push(s6);
                                s6 = peg$parseLetters();
                            }
                            if (s5 !== peg$FAILED) {
                                s4 = [
                                    s4,
                                    s5
                                ];
                                s3 = s4;
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        } else {
                            peg$currPos = s3;
                            s3 = peg$FAILED;
                        }
                        while(s3 !== peg$FAILED){
                            s2.push(s3);
                            s3 = peg$currPos;
                            s4 = peg$parseDigits();
                            if (s4 !== peg$FAILED) {
                                s5 = [];
                                s6 = peg$parseLetters();
                                while(s6 !== peg$FAILED){
                                    s5.push(s6);
                                    s6 = peg$parseLetters();
                                }
                                if (s5 !== peg$FAILED) {
                                    s4 = [
                                        s4,
                                        s5
                                    ];
                                    s3 = s4;
                                } else {
                                    peg$currPos = s3;
                                    s3 = peg$FAILED;
                                }
                            } else {
                                peg$currPos = s3;
                                s3 = peg$FAILED;
                            }
                        }
                        if (s2 !== peg$FAILED) {
                            peg$savedPos = s0;
                            s1 = peg$c158();
                            s0 = s1;
                        } else {
                            peg$currPos = s0;
                            s0 = peg$FAILED;
                        }
                    } else {
                        peg$currPos = s0;
                        s0 = peg$FAILED;
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseDigits() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 30;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = [];
                    if (peg$c161.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c162);
                    }
                    if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                        s0.push(s1);
                        if (peg$c161.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c162);
                        }
                    }
                    else s0 = peg$FAILED;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseNonZeroDigits() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 31;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = [];
                    if (peg$c163.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c164);
                    }
                    if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                        s0.push(s1);
                        if (peg$c163.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c164);
                        }
                    }
                    else s0 = peg$FAILED;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parseLetters() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 32;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    s0 = [];
                    if (peg$c165.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c166);
                    }
                    if (s1 !== peg$FAILED) while(s1 !== peg$FAILED){
                        s0.push(s1);
                        if (peg$c165.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c166);
                        }
                    }
                    else s0 = peg$FAILED;
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function peg$parse_() {
                    var s0, s1;
                    var key = peg$currPos * 34 + 33;
                    var cached = peg$resultsCache[key];
                    if (cached) {
                        peg$currPos = cached.nextPos;
                        return cached.result;
                    }
                    peg$silentFails++;
                    s0 = [];
                    if (peg$c168.test(input.charAt(peg$currPos))) {
                        s1 = input.charAt(peg$currPos);
                        peg$currPos++;
                    } else {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c169);
                    }
                    while(s1 !== peg$FAILED){
                        s0.push(s1);
                        if (peg$c168.test(input.charAt(peg$currPos))) {
                            s1 = input.charAt(peg$currPos);
                            peg$currPos++;
                        } else {
                            s1 = peg$FAILED;
                            if (peg$silentFails === 0) peg$fail(peg$c169);
                        }
                    }
                    peg$silentFails--;
                    if (s0 === peg$FAILED) {
                        s1 = peg$FAILED;
                        if (peg$silentFails === 0) peg$fail(peg$c167);
                    }
                    peg$resultsCache[key] = {
                        nextPos: peg$currPos,
                        result: s0
                    };
                    return s0;
                }
                function buildBinaryOperand(head, tail, isArithmeticOp) {
                    if (isArithmeticOp === void 0) isArithmeticOp = false;
                    return tail.reduce(function(result, elements) {
                        return new _expressions__WEBPACK_IMPORTED_MODULE_0__["BinaryOperand"](elements[1], result, elements[3], isArithmeticOp);
                    }, head);
                }
                function flattenArray(array) {
                    return [].concat.apply([], array);
                }
                peg$result = peg$startRuleFunction();
                if (peg$result !== peg$FAILED && peg$currPos === input.length) return peg$result;
                else {
                    if (peg$result !== peg$FAILED && peg$currPos < input.length) peg$fail(peg$endExpectation());
                    throw peg$buildStructuredError(peg$maxFailExpected, peg$maxFailPos < input.length ? input.charAt(peg$maxFailPos) : null, peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos));
                }
            }
            var parse = peg$parse;
        /***/ },
        /***/ "./src/expressions/expressions.ts": /*!****************************************!*\
  !*** ./src/expressions/expressions.ts ***!
  \****************************************/ /*! exports provided: Operand, BinaryOperand, UnaryOperand, ArrayOperand, Const, Variable, FunctionOperand, OperandMaker */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Operand", function() {
                return Operand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BinaryOperand", function() {
                return BinaryOperand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "UnaryOperand", function() {
                return UnaryOperand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ArrayOperand", function() {
                return ArrayOperand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Const", function() {
                return Const;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Variable", function() {
                return Variable;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionOperand", function() {
                return FunctionOperand;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "OperandMaker", function() {
                return OperandMaker;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../helpers */ "./src/helpers.ts");
            /* harmony import */ var _functionsfactory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../functionsfactory */ "./src/functionsfactory.ts");
            /* harmony import */ var _conditionProcessValue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../conditionProcessValue */ "./src/conditionProcessValue.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var Operand = /** @class */ function() {
                function Operand() {}
                Operand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    return "";
                };
                Operand.prototype.hasFunction = function() {
                    return false;
                };
                Operand.prototype.hasAsyncFunction = function() {
                    return false;
                };
                Operand.prototype.addToAsyncList = function(list) {};
                Operand.prototype.isEqual = function(op) {
                    return !!op && op.getType() === this.getType() && this.isContentEqual(op);
                };
                Operand.prototype.areOperatorsEquals = function(op1, op2) {
                    return !op1 && !op2 || !!op1 && op1.isEqual(op2);
                };
                return Operand;
            }();
            var BinaryOperand = /** @class */ function(_super) {
                __extends(BinaryOperand, _super);
                function BinaryOperand(operatorName, left, right, isArithmeticOp) {
                    if (left === void 0) left = null;
                    if (right === void 0) right = null;
                    if (isArithmeticOp === void 0) isArithmeticOp = false;
                    var _this = _super.call(this) || this;
                    _this.operatorName = operatorName;
                    _this.left = left;
                    _this.right = right;
                    _this.isArithmeticValue = isArithmeticOp;
                    if (isArithmeticOp) _this.consumer = OperandMaker.binaryFunctions["arithmeticOp"](operatorName);
                    else _this.consumer = OperandMaker.binaryFunctions[operatorName];
                    if (_this.consumer == null) OperandMaker.throwInvalidOperatorError(operatorName);
                    return _this;
                }
                Object.defineProperty(BinaryOperand.prototype, "requireStrictCompare", {
                    get: function() {
                        return this.getIsOperandRequireStrict(this.left) || this.getIsOperandRequireStrict(this.right);
                    },
                    enumerable: false,
                    configurable: true
                });
                BinaryOperand.prototype.getIsOperandRequireStrict = function(op) {
                    return !!op && op.requireStrictCompare;
                };
                BinaryOperand.prototype.getType = function() {
                    return "binary";
                };
                Object.defineProperty(BinaryOperand.prototype, "isArithmetic", {
                    get: function() {
                        return this.isArithmeticValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "isConjunction", {
                    get: function() {
                        return this.operatorName == "or" || this.operatorName == "and";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "conjunction", {
                    get: function() {
                        return this.isConjunction ? this.operatorName : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "operator", {
                    get: function() {
                        return this.operatorName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "leftOperand", {
                    get: function() {
                        return this.left;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(BinaryOperand.prototype, "rightOperand", {
                    get: function() {
                        return this.right;
                    },
                    enumerable: false,
                    configurable: true
                });
                BinaryOperand.prototype.isContentEqual = function(op) {
                    var bOp = op;
                    return bOp.operator === this.operator && this.areOperatorsEquals(this.left, bOp.left) && this.areOperatorsEquals(this.right, bOp.right);
                };
                BinaryOperand.prototype.evaluateParam = function(x, processValue) {
                    return x == null ? null : x.evaluate(processValue);
                };
                BinaryOperand.prototype.evaluate = function(processValue) {
                    return this.consumer.call(this, this.evaluateParam(this.left, processValue), this.evaluateParam(this.right, processValue), this.requireStrictCompare);
                };
                BinaryOperand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return "(" + OperandMaker.safeToString(this.left, func) + " " + OperandMaker.operatorToString(this.operatorName) + " " + OperandMaker.safeToString(this.right, func) + ")";
                };
                BinaryOperand.prototype.setVariables = function(variables) {
                    if (this.left != null) this.left.setVariables(variables);
                    if (this.right != null) this.right.setVariables(variables);
                };
                BinaryOperand.prototype.hasFunction = function() {
                    return !!this.left && this.left.hasFunction() || !!this.right && this.right.hasFunction();
                };
                BinaryOperand.prototype.hasAsyncFunction = function() {
                    return !!this.left && this.left.hasAsyncFunction() || !!this.right && this.right.hasAsyncFunction();
                };
                BinaryOperand.prototype.addToAsyncList = function(list) {
                    if (!!this.left) this.left.addToAsyncList(list);
                    if (!!this.right) this.right.addToAsyncList(list);
                };
                return BinaryOperand;
            }(Operand);
            var UnaryOperand = /** @class */ function(_super) {
                __extends(UnaryOperand, _super);
                function UnaryOperand(expressionValue, operatorName) {
                    var _this = _super.call(this) || this;
                    _this.expressionValue = expressionValue;
                    _this.operatorName = operatorName;
                    _this.consumer = OperandMaker.unaryFunctions[operatorName];
                    if (_this.consumer == null) OperandMaker.throwInvalidOperatorError(operatorName);
                    return _this;
                }
                Object.defineProperty(UnaryOperand.prototype, "operator", {
                    get: function() {
                        return this.operatorName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(UnaryOperand.prototype, "expression", {
                    get: function() {
                        return this.expressionValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                UnaryOperand.prototype.getType = function() {
                    return "unary";
                };
                UnaryOperand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return OperandMaker.operatorToString(this.operatorName) + " " + this.expression.toString(func);
                };
                UnaryOperand.prototype.isContentEqual = function(op) {
                    var uOp = op;
                    return uOp.operator == this.operator && this.areOperatorsEquals(this.expression, uOp.expression);
                };
                UnaryOperand.prototype.hasFunction = function() {
                    return this.expression.hasFunction();
                };
                UnaryOperand.prototype.hasAsyncFunction = function() {
                    return this.expression.hasAsyncFunction();
                };
                UnaryOperand.prototype.addToAsyncList = function(list) {
                    this.expression.addToAsyncList(list);
                };
                UnaryOperand.prototype.evaluate = function(processValue) {
                    var value = this.expression.evaluate(processValue);
                    return this.consumer.call(this, value);
                };
                UnaryOperand.prototype.setVariables = function(variables) {
                    this.expression.setVariables(variables);
                };
                return UnaryOperand;
            }(Operand);
            var ArrayOperand = /** @class */ function(_super) {
                __extends(ArrayOperand, _super);
                function ArrayOperand(values) {
                    var _this = _super.call(this) || this;
                    _this.values = values;
                    return _this;
                }
                ArrayOperand.prototype.getType = function() {
                    return "array";
                };
                ArrayOperand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return "[" + this.values.map(function(el) {
                        return el.toString(func);
                    }).join(", ") + "]";
                };
                ArrayOperand.prototype.evaluate = function(processValue) {
                    return this.values.map(function(el) {
                        return el.evaluate(processValue);
                    });
                };
                ArrayOperand.prototype.setVariables = function(variables) {
                    this.values.forEach(function(el) {
                        el.setVariables(variables);
                    });
                };
                ArrayOperand.prototype.hasFunction = function() {
                    return this.values.some(function(operand) {
                        return operand.hasFunction();
                    });
                };
                ArrayOperand.prototype.hasAsyncFunction = function() {
                    return this.values.some(function(operand) {
                        return operand.hasAsyncFunction();
                    });
                };
                ArrayOperand.prototype.addToAsyncList = function(list) {
                    this.values.forEach(function(operand) {
                        return operand.addToAsyncList(list);
                    });
                };
                ArrayOperand.prototype.isContentEqual = function(op) {
                    var aOp = op;
                    if (aOp.values.length !== this.values.length) return false;
                    for(var i = 0; i < this.values.length; i++){
                        if (!aOp.values[i].isEqual(this.values[i])) return false;
                    }
                    return true;
                };
                return ArrayOperand;
            }(Operand);
            var Const = /** @class */ function(_super) {
                __extends(Const, _super);
                function Const(value) {
                    var _this = _super.call(this) || this;
                    _this.value = value;
                    return _this;
                }
                Const.prototype.getType = function() {
                    return "const";
                };
                Const.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return this.value.toString();
                };
                Object.defineProperty(Const.prototype, "correctValue", {
                    get: function() {
                        return this.getCorrectValue(this.value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Const.prototype, "requireStrictCompare", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Const.prototype.evaluate = function() {
                    return this.getCorrectValue(this.value);
                };
                Const.prototype.setVariables = function(variables) {};
                Const.prototype.getCorrectValue = function(value) {
                    if (!value || typeof value != "string") return value;
                    if (this.isBooleanValue(value)) return value.toLowerCase() === "true";
                    if (value.length > 1 && this.isQuote(value[0]) && this.isQuote(value[value.length - 1])) return value.substring(1, value.length - 1);
                    if (OperandMaker.isNumeric(value)) {
                        if (value.indexOf("0x") == 0) return parseInt(value);
                        if (value.length > 1 && value[0] == "0" && (value.length < 2 || value[1] !== "." && value[1] !== ",")) return value;
                        return parseFloat(value);
                    }
                    return value;
                };
                Const.prototype.isContentEqual = function(op) {
                    var cOp = op;
                    return cOp.value == this.value;
                };
                Const.prototype.isQuote = function(ch) {
                    return ch == "'" || ch == '"';
                };
                Const.prototype.isBooleanValue = function(value) {
                    return value && (value.toLowerCase() === "true" || value.toLowerCase() === "false");
                };
                return Const;
            }(Operand);
            var Variable = /** @class */ function(_super) {
                __extends(Variable, _super);
                function Variable(variableName) {
                    var _this = _super.call(this, variableName) || this;
                    _this.variableName = variableName;
                    _this.valueInfo = {};
                    _this.useValueAsItIs = false;
                    if (!!_this.variableName && _this.variableName.length > 1 && _this.variableName[0] === Variable.DisableConversionChar) {
                        _this.variableName = _this.variableName.substring(1);
                        _this.useValueAsItIs = true;
                    }
                    return _this;
                }
                Object.defineProperty(Variable, "DisableConversionChar", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].expressionDisableConversionChar;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_3__["settings"].expressionDisableConversionChar = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(Variable.prototype, "requireStrictCompare", {
                    get: function() {
                        return this.valueInfo.sctrictCompare === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Variable.prototype.getType = function() {
                    return "variable";
                };
                Variable.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    var prefix = this.useValueAsItIs ? Variable.DisableConversionChar : "";
                    return "{" + prefix + this.variableName + "}";
                };
                Object.defineProperty(Variable.prototype, "variable", {
                    get: function() {
                        return this.variableName;
                    },
                    enumerable: false,
                    configurable: true
                });
                Variable.prototype.evaluate = function(processValue) {
                    this.valueInfo.name = this.variableName;
                    processValue.getValueInfo(this.valueInfo);
                    return this.valueInfo.hasValue ? this.getCorrectValue(this.valueInfo.value) : null;
                };
                Variable.prototype.setVariables = function(variables) {
                    variables.push(this.variableName);
                };
                Variable.prototype.getCorrectValue = function(value) {
                    if (this.useValueAsItIs) return value;
                    return _super.prototype.getCorrectValue.call(this, value);
                };
                Variable.prototype.isContentEqual = function(op) {
                    var vOp = op;
                    return vOp.variable == this.variable;
                };
                return Variable;
            }(Const);
            var FunctionOperand = /** @class */ function(_super) {
                __extends(FunctionOperand, _super);
                function FunctionOperand(originalValue, parameters) {
                    var _this = _super.call(this) || this;
                    _this.originalValue = originalValue;
                    _this.parameters = parameters;
                    _this.isReadyValue = false;
                    if (Array.isArray(parameters) && parameters.length === 0) _this.parameters = new ArrayOperand([]);
                    return _this;
                }
                FunctionOperand.prototype.getType = function() {
                    return "function";
                };
                FunctionOperand.prototype.evaluateAsync = function(processValue) {
                    var _this = this;
                    this.isReadyValue = false;
                    var asyncProcessValue = new _conditionProcessValue__WEBPACK_IMPORTED_MODULE_2__["ProcessValue"]();
                    asyncProcessValue.values = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(processValue.values);
                    asyncProcessValue.properties = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(processValue.properties);
                    asyncProcessValue.properties.returnResult = function(result) {
                        _this.asynResult = result;
                        _this.isReadyValue = true;
                        _this.onAsyncReady();
                    };
                    this.evaluateCore(asyncProcessValue);
                };
                FunctionOperand.prototype.evaluate = function(processValue) {
                    if (this.isReady) return this.asynResult;
                    return this.evaluateCore(processValue);
                };
                FunctionOperand.prototype.evaluateCore = function(processValue) {
                    return _functionsfactory__WEBPACK_IMPORTED_MODULE_1__["FunctionFactory"].Instance.run(this.originalValue, this.parameters.evaluate(processValue), processValue.properties);
                };
                FunctionOperand.prototype.toString = function(func) {
                    if (func === void 0) func = undefined;
                    if (!!func) {
                        var res = func(this);
                        if (!!res) return res;
                    }
                    return this.originalValue + "(" + this.parameters.toString(func) + ")";
                };
                FunctionOperand.prototype.setVariables = function(variables) {
                    this.parameters.setVariables(variables);
                };
                Object.defineProperty(FunctionOperand.prototype, "isReady", {
                    get: function() {
                        return this.isReadyValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                FunctionOperand.prototype.hasFunction = function() {
                    return true;
                };
                FunctionOperand.prototype.hasAsyncFunction = function() {
                    return _functionsfactory__WEBPACK_IMPORTED_MODULE_1__["FunctionFactory"].Instance.isAsyncFunction(this.originalValue);
                };
                FunctionOperand.prototype.addToAsyncList = function(list) {
                    if (this.hasAsyncFunction()) list.push(this);
                };
                FunctionOperand.prototype.isContentEqual = function(op) {
                    var fOp = op;
                    return fOp.originalValue == this.originalValue && this.areOperatorsEquals(fOp.parameters, this.parameters);
                };
                return FunctionOperand;
            }(Operand);
            var OperandMaker = /** @class */ function() {
                function OperandMaker() {}
                OperandMaker.throwInvalidOperatorError = function(op) {
                    throw new Error("Invalid operator: '" + op + "'");
                };
                OperandMaker.safeToString = function(operand, func) {
                    return operand == null ? "" : operand.toString(func);
                };
                OperandMaker.toOperandString = function(value) {
                    if (!!value && !OperandMaker.isNumeric(value) && !OperandMaker.isBooleanValue(value)) value = "'" + value + "'";
                    return value;
                };
                OperandMaker.isSpaceString = function(str) {
                    return !!str && !str.replace(" ", "");
                };
                OperandMaker.isNumeric = function(value) {
                    if (!!value && (value.indexOf("-") > -1 || value.indexOf("+") > 1 || value.indexOf("*") > -1 || value.indexOf("^") > -1 || value.indexOf("/") > -1 || value.indexOf("%") > -1)) return false;
                    if (OperandMaker.isSpaceString(value)) return false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(value);
                };
                OperandMaker.isBooleanValue = function(value) {
                    return !!value && (value.toLowerCase() === "true" || value.toLowerCase() === "false");
                };
                OperandMaker.countDecimals = function(value) {
                    if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(value) && Math.floor(value) !== value) {
                        var strs = value.toString().split(".");
                        return strs.length > 1 && strs[1].length || 0;
                    }
                    return 0;
                };
                OperandMaker.plusMinus = function(a, b, res) {
                    var digitsA = OperandMaker.countDecimals(a);
                    var digitsB = OperandMaker.countDecimals(b);
                    if (digitsA > 0 || digitsB > 0) {
                        var digits = Math.max(digitsA, digitsB);
                        res = parseFloat(res.toFixed(digits));
                    }
                    return res;
                };
                OperandMaker.isTwoValueEquals = function(x, y, ignoreOrder) {
                    if (ignoreOrder === void 0) ignoreOrder = true;
                    if (x === "undefined") x = undefined;
                    if (y === "undefined") y = undefined;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(x, y, ignoreOrder);
                };
                OperandMaker.operatorToString = function(operatorName) {
                    var opStr = OperandMaker.signs[operatorName];
                    return opStr == null ? operatorName : opStr;
                };
                OperandMaker.convertValForDateCompare = function(val1, second) {
                    if (second instanceof Date && typeof val1 === "string") {
                        var res = new Date(val1);
                        res.setHours(0, 0, 0);
                        return res;
                    }
                    return val1;
                };
                OperandMaker.unaryFunctions = {
                    empty: function(value) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(value);
                    },
                    notempty: function(value) {
                        return !OperandMaker.unaryFunctions.empty(value);
                    },
                    negate: function(value) {
                        return !value;
                    }
                };
                OperandMaker.binaryFunctions = {
                    arithmeticOp: function(operatorName) {
                        var convertForArithmeticOp = function(val1, second) {
                            if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(val1)) return val1;
                            if (typeof second === "number") return 0;
                            if (typeof val1 === "string") return val1;
                            if (typeof second === "string") return "";
                            if (Array.isArray(second)) return [];
                            return 0;
                        };
                        return function(a, b) {
                            a = convertForArithmeticOp(a, b);
                            b = convertForArithmeticOp(b, a);
                            var consumer = OperandMaker.binaryFunctions[operatorName];
                            return consumer == null ? null : consumer.call(this, a, b);
                        };
                    },
                    and: function(a, b) {
                        return a && b;
                    },
                    or: function(a, b) {
                        return a || b;
                    },
                    plus: function(a, b) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].sumAnyValues(a, b);
                    },
                    minus: function(a, b) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].correctAfterPlusMinis(a, b, a - b);
                    },
                    mul: function(a, b) {
                        return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].correctAfterMultiple(a, b, a * b);
                    },
                    div: function(a, b) {
                        if (!b) return null;
                        return a / b;
                    },
                    mod: function(a, b) {
                        if (!b) return null;
                        return a % b;
                    },
                    power: function(a, b) {
                        return Math.pow(a, b);
                    },
                    greater: function(left, right) {
                        if (left == null || right == null) return false;
                        left = OperandMaker.convertValForDateCompare(left, right);
                        right = OperandMaker.convertValForDateCompare(right, left);
                        return left > right;
                    },
                    less: function(left, right) {
                        if (left == null || right == null) return false;
                        left = OperandMaker.convertValForDateCompare(left, right);
                        right = OperandMaker.convertValForDateCompare(right, left);
                        return left < right;
                    },
                    greaterorequal: function(left, right) {
                        if (OperandMaker.binaryFunctions.equal(left, right)) return true;
                        return OperandMaker.binaryFunctions.greater(left, right);
                    },
                    lessorequal: function(left, right) {
                        if (OperandMaker.binaryFunctions.equal(left, right)) return true;
                        return OperandMaker.binaryFunctions.less(left, right);
                    },
                    equal: function(left, right, strictCompare) {
                        left = OperandMaker.convertValForDateCompare(left, right);
                        right = OperandMaker.convertValForDateCompare(right, left);
                        return OperandMaker.isTwoValueEquals(left, right, strictCompare !== true);
                    },
                    notequal: function(left, right, strictCompare) {
                        return !OperandMaker.binaryFunctions.equal(left, right, strictCompare);
                    },
                    contains: function(left, right) {
                        return OperandMaker.binaryFunctions.containsCore(left, right, true);
                    },
                    notcontains: function(left, right) {
                        if (!left && !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(right)) return true;
                        return OperandMaker.binaryFunctions.containsCore(left, right, false);
                    },
                    anyof: function(left, right) {
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(left) && _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(right)) return true;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(left) || !Array.isArray(left) && left.length === 0) return false;
                        if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(right)) return true;
                        if (!Array.isArray(left)) return OperandMaker.binaryFunctions.contains(right, left);
                        if (!Array.isArray(right)) return OperandMaker.binaryFunctions.contains(left, right);
                        for(var i = 0; i < right.length; i++){
                            if (OperandMaker.binaryFunctions.contains(left, right[i])) return true;
                        }
                        return false;
                    },
                    allof: function(left, right) {
                        if (!left && !_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(right)) return false;
                        if (!Array.isArray(right)) return OperandMaker.binaryFunctions.contains(left, right);
                        for(var i = 0; i < right.length; i++){
                            if (!OperandMaker.binaryFunctions.contains(left, right[i])) return false;
                        }
                        return true;
                    },
                    containsCore: function(left, right, isContains) {
                        if (!left && left !== 0 && left !== false) return false;
                        if (!left.length) {
                            left = left.toString();
                            if (typeof right === "string" || right instanceof String) {
                                left = left.toUpperCase();
                                right = right.toUpperCase();
                            }
                        }
                        if (typeof left === "string" || left instanceof String) {
                            if (!right) return false;
                            right = right.toString();
                            var found = left.indexOf(right) > -1;
                            return isContains ? found : !found;
                        }
                        var rightArray = Array.isArray(right) ? right : [
                            right
                        ];
                        for(var rIndex = 0; rIndex < rightArray.length; rIndex++){
                            var i = 0;
                            right = rightArray[rIndex];
                            for(; i < left.length; i++){
                                if (OperandMaker.isTwoValueEquals(left[i], right)) break;
                            }
                            if (i == left.length) return !isContains;
                        }
                        return isContains;
                    }
                };
                OperandMaker.signs = {
                    less: "<",
                    lessorequal: "<=",
                    greater: ">",
                    greaterorequal: ">=",
                    equal: "==",
                    notequal: "!=",
                    plus: "+",
                    minus: "-",
                    mul: "*",
                    div: "/",
                    and: "and",
                    or: "or",
                    power: "^",
                    mod: "%",
                    negate: "!"
                };
                return OperandMaker;
            }();
        /***/ },
        /***/ "./src/functionsfactory.ts": /*!*********************************!*\
  !*** ./src/functionsfactory.ts ***!
  \*********************************/ /*! exports provided: FunctionFactory, registerFunction */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "FunctionFactory", function() {
                return FunctionFactory;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "registerFunction", function() {
                return registerFunction;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            var FunctionFactory = /** @class */ function() {
                function FunctionFactory() {
                    this.functionHash = {};
                    this.isAsyncHash = {};
                }
                FunctionFactory.prototype.register = function(name, func, isAsync) {
                    if (isAsync === void 0) isAsync = false;
                    this.functionHash[name] = func;
                    if (isAsync) this.isAsyncHash[name] = true;
                };
                FunctionFactory.prototype.unregister = function(name) {
                    delete this.functionHash[name];
                    delete this.isAsyncHash[name];
                };
                FunctionFactory.prototype.hasFunction = function(name) {
                    return !!this.functionHash[name];
                };
                FunctionFactory.prototype.isAsyncFunction = function(name) {
                    return !!this.isAsyncHash[name];
                };
                FunctionFactory.prototype.clear = function() {
                    this.functionHash = {};
                };
                FunctionFactory.prototype.getAll = function() {
                    var result = [];
                    for(var key in this.functionHash)result.push(key);
                    return result.sort();
                };
                FunctionFactory.prototype.run = function(name, params, properties) {
                    if (properties === void 0) properties = null;
                    var func = this.functionHash[name];
                    if (!func) {
                        _console_warnings__WEBPACK_IMPORTED_MODULE_2__["ConsoleWarnings"].warn("Unknown function name: " + name);
                        return null;
                    }
                    var classRunner = {
                        func: func
                    };
                    if (properties) for(var key in properties)classRunner[key] = properties[key];
                    return classRunner.func(params);
                };
                FunctionFactory.Instance = new FunctionFactory();
                return FunctionFactory;
            }();
            var registerFunction = FunctionFactory.Instance.register;
            function getParamsAsArray(value, arr) {
                if (value === undefined || value === null) return;
                if (Array.isArray(value)) for(var i = 0; i < value.length; i++)getParamsAsArray(value[i], arr);
                else {
                    if (_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(value)) value = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].getNumber(value);
                    arr.push(value);
                }
            }
            function sum(params) {
                var arr = [];
                getParamsAsArray(params, arr);
                var res = 0;
                for(var i = 0; i < arr.length; i++)res = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].correctAfterPlusMinis(res, arr[i], res + arr[i]);
                return res;
            }
            FunctionFactory.Instance.register("sum", sum);
            function min_max(params, isMin) {
                var arr = [];
                getParamsAsArray(params, arr);
                var res = undefined;
                for(var i = 0; i < arr.length; i++){
                    if (res === undefined) res = arr[i];
                    if (isMin) {
                        if (res > arr[i]) res = arr[i];
                    } else if (res < arr[i]) res = arr[i];
                }
                return res;
            }
            function min(params) {
                return min_max(params, true);
            }
            FunctionFactory.Instance.register("min", min);
            function max(params) {
                return min_max(params, false);
            }
            FunctionFactory.Instance.register("max", max);
            function count(params) {
                var arr = [];
                getParamsAsArray(params, arr);
                return arr.length;
            }
            FunctionFactory.Instance.register("count", count);
            function avg(params) {
                var arr = [];
                getParamsAsArray(params, arr);
                var res = sum(params);
                return arr.length > 0 ? res / arr.length : 0;
            }
            FunctionFactory.Instance.register("avg", avg);
            function getInArrayParams(params) {
                if (params.length != 2) return null;
                var arr = params[0];
                if (!arr) return null;
                if (!Array.isArray(arr) && !Array.isArray(Object.keys(arr))) return null;
                var name = params[1];
                if (typeof name !== "string" && !(name instanceof String)) return null;
                return {
                    data: arr,
                    name: name
                };
            }
            function convertToNumber(val1) {
                if (typeof val1 === "string") return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(val1) ? _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].getNumber(val1) : undefined;
                return val1;
            }
            function processItemInArray(item, name, res, func, needToConvert) {
                if (!item || _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isValueEmpty(item[name])) return res;
                var val1 = needToConvert ? convertToNumber(item[name]) : 1;
                return func(res, val1);
            }
            function calcInArray(params, func, needToConvert) {
                if (needToConvert === void 0) needToConvert = true;
                var v = getInArrayParams(params);
                if (!v) return undefined;
                var res = undefined;
                if (Array.isArray(v.data)) for(var i = 0; i < v.data.length; i++)res = processItemInArray(v.data[i], v.name, res, func, needToConvert);
                else for(var key in v.data)res = processItemInArray(v.data[key], v.name, res, func, needToConvert);
                return res;
            }
            function sumInArray(params) {
                var res = calcInArray(params, function(res, val1) {
                    if (res == undefined) res = 0;
                    if (val1 == undefined || val1 == null) return res;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].correctAfterPlusMinis(res, val1, res + val1);
                });
                return res !== undefined ? res : 0;
            }
            FunctionFactory.Instance.register("sumInArray", sumInArray);
            function minInArray(params) {
                return calcInArray(params, function(res, val1) {
                    if (res == undefined) return val1;
                    if (val1 == undefined || val1 == null) return res;
                    return res < val1 ? res : val1;
                });
            }
            FunctionFactory.Instance.register("minInArray", minInArray);
            function maxInArray(params) {
                return calcInArray(params, function(res, val1) {
                    if (res == undefined) return val1;
                    if (val1 == undefined || val1 == null) return res;
                    return res > val1 ? res : val1;
                });
            }
            FunctionFactory.Instance.register("maxInArray", maxInArray);
            function countInArray(params) {
                var res = calcInArray(params, function(res, val1) {
                    if (res == undefined) res = 0;
                    if (val1 == undefined || val1 == null) return res;
                    return res + 1;
                }, false);
                return res !== undefined ? res : 0;
            }
            FunctionFactory.Instance.register("countInArray", countInArray);
            function avgInArray(params) {
                var count = countInArray(params);
                if (count == 0) return 0;
                return sumInArray(params) / count;
            }
            FunctionFactory.Instance.register("avgInArray", avgInArray);
            function iif(params) {
                if (!params && params.length !== 3) return "";
                return params[0] ? params[1] : params[2];
            }
            FunctionFactory.Instance.register("iif", iif);
            function getDate(params) {
                if (!params && params.length < 1) return null;
                if (!params[0]) return null;
                return new Date(params[0]);
            }
            FunctionFactory.Instance.register("getDate", getDate);
            function age(params) {
                if (!params && params.length < 1) return null;
                if (!params[0]) return null;
                var birthDate = new Date(params[0]);
                var today = new Date();
                var age = today.getFullYear() - birthDate.getFullYear();
                if (age > 0) {
                    var m = today.getMonth() - birthDate.getMonth();
                    if (m < 0 || m === 0 && today.getDate() < birthDate.getDate()) age -= 1;
                }
                return age;
            }
            FunctionFactory.Instance.register("age", age);
            function isContainerReadyCore(container) {
                if (!container) return false;
                var questions = container.questions;
                for(var i = 0; i < questions.length; i++){
                    if (!questions[i].validate(false)) return false;
                }
                return true;
            }
            function isContainerReady(params) {
                if (!params && params.length < 1) return false;
                if (!params[0] || !this.survey) return false;
                var name = params[0];
                var container = this.survey.getPageByName(name);
                if (!container) container = this.survey.getPanelByName(name);
                if (!container) {
                    var question = this.survey.getQuestionByName(name);
                    if (!question || !Array.isArray(question.panels)) return false;
                    if (params.length > 1) {
                        if (params[1] < question.panels.length) container = question.panels[params[1]];
                    } else {
                        for(var i = 0; i < question.panels.length; i++){
                            if (!isContainerReadyCore(question.panels[i])) return false;
                        }
                        return true;
                    }
                }
                return isContainerReadyCore(container);
            }
            FunctionFactory.Instance.register("isContainerReady", isContainerReady);
            function isDisplayMode() {
                return this.survey && this.survey.isDisplayMode;
            }
            FunctionFactory.Instance.register("isDisplayMode", isDisplayMode);
            function currentDate() {
                return new Date();
            }
            FunctionFactory.Instance.register("currentDate", currentDate);
            function today(params) {
                var res = new Date();
                if (_settings__WEBPACK_IMPORTED_MODULE_1__["settings"].localization.useLocalTimeZone) res.setHours(0, 0, 0, 0);
                else res.setUTCHours(0, 0, 0, 0);
                if (Array.isArray(params) && params.length == 1) res.setDate(res.getDate() + params[0]);
                return res;
            }
            FunctionFactory.Instance.register("today", today);
            function getYear(params) {
                if (params.length !== 1 || !params[0]) return undefined;
                return new Date(params[0]).getFullYear();
            }
            FunctionFactory.Instance.register("getYear", getYear);
            function currentYear() {
                return new Date().getFullYear();
            }
            FunctionFactory.Instance.register("currentYear", currentYear);
            function diffDays(params) {
                if (!Array.isArray(params) || params.length !== 2) return 0;
                if (!params[0] || !params[1]) return 0;
                var date1 = new Date(params[0]);
                var date2 = new Date(params[1]);
                var diffTime = Math.abs(date2 - date1);
                return Math.ceil(diffTime / 86400000);
            }
            FunctionFactory.Instance.register("diffDays", diffDays);
            function dateFromFirstParameterOrToday(params) {
                var date = today(undefined);
                if (params && params[0]) date = new Date(params[0]);
                return date;
            }
            function year(params) {
                var date = dateFromFirstParameterOrToday(params);
                return date.getFullYear();
            }
            FunctionFactory.Instance.register("year", year);
            function month(params) {
                var date = dateFromFirstParameterOrToday(params);
                return date.getMonth() + 1;
            }
            FunctionFactory.Instance.register("month", month);
            function day(params) {
                var date = dateFromFirstParameterOrToday(params);
                return date.getDate();
            }
            FunctionFactory.Instance.register("day", day);
            function weekday(params) {
                var date = dateFromFirstParameterOrToday(params);
                return date.getDay();
            }
            FunctionFactory.Instance.register("weekday", weekday);
            function getQuestionValueByContext(context, name) {
                if (!context || !name) return undefined;
                var keys = [
                    "row",
                    "panel",
                    "survey"
                ];
                for(var i = 0; i < keys.length; i++){
                    var ctx = context[keys[i]];
                    if (ctx && ctx.getQuestionByName) {
                        var res = ctx.getQuestionByName(name);
                        if (res) return res;
                    }
                }
                return null;
            }
            function displayValue(params) {
                var q = getQuestionValueByContext(this, params[0]);
                return q ? q.displayValue : "";
            }
            FunctionFactory.Instance.register("displayValue", displayValue);
            function propertyValue(params) {
                if (params.length !== 2 || !params[0] || !params[1]) return undefined;
                var q = getQuestionValueByContext(this, params[0]);
                return q ? q[params[1]] : undefined;
            }
            FunctionFactory.Instance.register("propertyValue", propertyValue);
            function substring_(params) {
                if (params.length < 2) return "";
                var s = params[0];
                if (!s || typeof s !== "string") return "";
                var start = params[1];
                if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(start)) return "";
                var end = params.length > 2 ? params[2] : undefined;
                if (!_helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isNumber(end)) return s.substring(start);
                return s.substring(start, end);
            }
            FunctionFactory.Instance.register("substring", substring_);
        /***/ },
        /***/ "./src/global_variables_utils.ts": /*!***************************************!*\
  !*** ./src/global_variables_utils.ts ***!
  \***************************************/ /*! exports provided: DomWindowHelper, DomDocumentHelper */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomWindowHelper", function() {
                return DomWindowHelper;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DomDocumentHelper", function() {
                return DomDocumentHelper;
            });
            /* eslint-disable no-restricted-globals */ var DomWindowHelper = /** @class */ function() {
                function DomWindowHelper() {}
                DomWindowHelper.isAvailable = function() {
                    return "undefined" !== typeof window;
                };
                DomWindowHelper.isFileReaderAvailable = function() {
                    if (!DomWindowHelper.isAvailable()) return false;
                    return !!window["FileReader"];
                };
                DomWindowHelper.getLocation = function() {
                    if (!DomWindowHelper.isAvailable()) return;
                    return window.location;
                };
                DomWindowHelper.getVisualViewport = function() {
                    if (!DomWindowHelper.isAvailable()) return null;
                    return window.visualViewport;
                };
                DomWindowHelper.getInnerWidth = function() {
                    if (!DomWindowHelper.isAvailable()) return;
                    return window.innerWidth;
                };
                DomWindowHelper.getInnerHeight = function() {
                    if (!DomWindowHelper.isAvailable()) return null;
                    return window.innerHeight;
                };
                DomWindowHelper.getWindow = function() {
                    if (!DomWindowHelper.isAvailable()) return;
                    return window;
                };
                DomWindowHelper.hasOwn = function(propertyName) {
                    if (!DomWindowHelper.isAvailable()) return;
                    return propertyName in window;
                };
                DomWindowHelper.getSelection = function() {
                    if (DomWindowHelper.isAvailable() && window.getSelection) return window.getSelection();
                };
                DomWindowHelper.requestAnimationFrame = function(callback) {
                    if (DomWindowHelper.isAvailable()) return window.requestAnimationFrame(callback);
                };
                DomWindowHelper.addEventListener = function(type, listener) {
                    if (!DomWindowHelper.isAvailable()) return;
                    window.addEventListener(type, listener);
                };
                DomWindowHelper.removeEventListener = function(type, listener) {
                    if (!DomWindowHelper.isAvailable()) return;
                    window.removeEventListener(type, listener);
                };
                return DomWindowHelper;
            }();
            var DomDocumentHelper = /** @class */ function() {
                function DomDocumentHelper() {}
                DomDocumentHelper.isAvailable = function() {
                    return "undefined" !== typeof document;
                };
                DomDocumentHelper.getBody = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document.body;
                };
                DomDocumentHelper.getDocumentElement = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document.documentElement;
                };
                DomDocumentHelper.getDocument = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document;
                };
                DomDocumentHelper.getCookie = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document.cookie;
                };
                DomDocumentHelper.setCookie = function(newCookie) {
                    if (!DomDocumentHelper.isAvailable()) return;
                    document.cookie = newCookie;
                };
                DomDocumentHelper.activeElementBlur = function() {
                    if (!DomDocumentHelper.isAvailable()) return;
                    var activeElement = document.activeElement;
                    if (!!activeElement && !!activeElement.blur) activeElement.blur();
                };
                DomDocumentHelper.createElement = function(tagName) {
                    if (!DomDocumentHelper.isAvailable()) return;
                    return document.createElement(tagName);
                };
                DomDocumentHelper.getComputedStyle = function(elt) {
                    if (!DomDocumentHelper.isAvailable()) return new CSSStyleDeclaration();
                    return document.defaultView.getComputedStyle(elt);
                };
                DomDocumentHelper.addEventListener = function(type, listener) {
                    if (!DomDocumentHelper.isAvailable()) return;
                    document.addEventListener(type, listener);
                };
                DomDocumentHelper.removeEventListener = function(type, listener) {
                    if (!DomDocumentHelper.isAvailable()) return;
                    document.removeEventListener(type, listener);
                };
                return DomDocumentHelper;
            }();
        /***/ },
        /***/ "./src/helpers.ts": /*!************************!*\
  !*** ./src/helpers.ts ***!
  \************************/ /*! exports provided: Helpers */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Helpers", function() {
                return Helpers;
            });
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var Helpers = /** @class */ function() {
                function Helpers() {}
                /**
     * A static methods that returns true if a value undefined, null, empty string or empty array.
     * @param value
     */ Helpers.isValueEmpty = function(value) {
                    if (Array.isArray(value) && value.length === 0) return true;
                    if (!!value && Helpers.isValueObject(value) && value.constructor === Object) {
                        for(var key in value){
                            if (!Helpers.isValueEmpty(value[key])) return false;
                        }
                        return true;
                    }
                    return !value && value !== 0 && value !== false;
                };
                Helpers.isArrayContainsEqual = function(x, y) {
                    if (!Array.isArray(x) || !Array.isArray(y)) return false;
                    if (x.length !== y.length) return false;
                    for(var i = 0; i < x.length; i++){
                        var j = 0;
                        for(; j < y.length; j++){
                            if (Helpers.isTwoValueEquals(x[i], y[j])) break;
                        }
                        if (j === y.length) return false;
                    }
                    return true;
                };
                Helpers.isArraysEqual = function(x, y, ignoreOrder, caseSensitive, trimStrings) {
                    if (ignoreOrder === void 0) ignoreOrder = false;
                    if (!Array.isArray(x) || !Array.isArray(y)) return false;
                    if (x.length !== y.length) return false;
                    if (ignoreOrder) {
                        var xSorted = [];
                        var ySorted = [];
                        for(var i = 0; i < x.length; i++){
                            xSorted.push(x[i]);
                            ySorted.push(y[i]);
                        }
                        xSorted.sort();
                        ySorted.sort();
                        x = xSorted;
                        y = ySorted;
                    }
                    for(var i = 0; i < x.length; i++){
                        if (!Helpers.isTwoValueEquals(x[i], y[i], ignoreOrder, caseSensitive, trimStrings)) return false;
                    }
                    return true;
                };
                Helpers.compareStrings = function(x, y) {
                    var normalize = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].comparator.normalizeTextCallback;
                    if (!!x) x = normalize(x, "compare").trim();
                    if (!!y) y = normalize(y, "compare").trim();
                    if (!x && !y) return 0;
                    if (!x) return -1;
                    if (!y) return 1;
                    if (x === y) return 0;
                    var digitIndex = -1;
                    for(var i = 0; i < x.length && i < y.length; i++){
                        if (this.isCharDigit(x[i]) && this.isCharDigit(y[i])) {
                            digitIndex = i;
                            break;
                        }
                        if (x[i] !== y[i]) break;
                    }
                    if (digitIndex > -1) {
                        var nX = this.getNumberFromStr(x, digitIndex);
                        var nY = this.getNumberFromStr(y, digitIndex);
                        if (!Number.isNaN(nX) && !Number.isNaN(nY) && nX !== nY) return nX > nY ? 1 : -1;
                    }
                    return x > y ? 1 : -1;
                };
                Helpers.isTwoValueEquals = function(x, y, ignoreOrder, caseSensitive, trimStrings) {
                    if (ignoreOrder === void 0) ignoreOrder = false;
                    if (x === y) return true;
                    if (Array.isArray(x) && x.length === 0 && typeof y === "undefined") return true;
                    if (Array.isArray(y) && y.length === 0 && typeof x === "undefined") return true;
                    if ((x === undefined || x === null) && y === "") return true;
                    if ((y === undefined || y === null) && x === "") return true;
                    if (trimStrings === undefined) trimStrings = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].comparator.trimStrings;
                    if (caseSensitive === undefined) caseSensitive = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].comparator.caseSensitive;
                    if (typeof x === "string" && typeof y === "string") {
                        var normalize = _settings__WEBPACK_IMPORTED_MODULE_0__["settings"].comparator.normalizeTextCallback;
                        x = normalize(x, "compare");
                        y = normalize(y, "compare");
                        if (trimStrings) {
                            x = x.trim();
                            y = y.trim();
                        }
                        if (!caseSensitive) {
                            x = x.toLowerCase();
                            y = y.toLowerCase();
                        }
                        return x === y;
                    }
                    if (x instanceof Date && y instanceof Date) return x.getTime() == y.getTime();
                    if (Helpers.isConvertibleToNumber(x) && Helpers.isConvertibleToNumber(y)) {
                        if (parseInt(x) === parseInt(y) && parseFloat(x) === parseFloat(y)) return true;
                    }
                    if (!Helpers.isValueEmpty(x) && Helpers.isValueEmpty(y) || Helpers.isValueEmpty(x) && !Helpers.isValueEmpty(y)) return false;
                    if ((x === true || x === false) && typeof y == "string") return x.toString() === y.toLocaleLowerCase();
                    if ((y === true || y === false) && typeof x == "string") return y.toString() === x.toLocaleLowerCase();
                    if (!Helpers.isValueObject(x) && !Helpers.isValueObject(y)) return x == y;
                    if (!Helpers.isValueObject(x) || !Helpers.isValueObject(y)) return false;
                    if (x["equals"] && y["equals"]) return x.equals(y);
                    if (Array.isArray(x) && Array.isArray(y)) return Helpers.isArraysEqual(x, y, ignoreOrder, caseSensitive, trimStrings);
                    for(var p in x){
                        if (!x.hasOwnProperty(p)) continue;
                        if (!y.hasOwnProperty(p)) return false;
                        if (!this.isTwoValueEquals(x[p], y[p], ignoreOrder, caseSensitive, trimStrings)) return false;
                    }
                    for(p in y){
                        if (y.hasOwnProperty(p) && !x.hasOwnProperty(p)) return false;
                    }
                    return true;
                };
                Helpers.randomizeArray = function(array) {
                    for(var i = array.length - 1; i > 0; i--){
                        var j = Math.floor(Math.random() * (i + 1));
                        var temp = array[i];
                        array[i] = array[j];
                        array[j] = temp;
                    }
                    return array;
                };
                Helpers.getUnbindValue = function(value) {
                    if (Array.isArray(value)) {
                        var res = [];
                        for(var i = 0; i < value.length; i++)res.push(Helpers.getUnbindValue(value[i]));
                        return res;
                    }
                    if (!!value && Helpers.isValueObject(value) && !(value instanceof Date)) return JSON.parse(JSON.stringify(value));
                    return value;
                };
                Helpers.createCopy = function(obj) {
                    var res = {};
                    if (!obj) return res;
                    for(var key in obj)res[key] = obj[key];
                    return res;
                };
                Helpers.isConvertibleToNumber = function(value) {
                    return value !== undefined && value !== null && !Array.isArray(value) && !isNaN(value);
                };
                Helpers.isValueObject = function(val1, excludeArray) {
                    return val1 instanceof Object && (!excludeArray || !Array.isArray(val1));
                };
                Helpers.isNumber = function(value) {
                    return !isNaN(this.getNumber(value));
                };
                Helpers.getNumber = function(value) {
                    if (typeof value == "string" && !!value && value.indexOf("0x") == 0 && value.length > 32) return NaN;
                    value = this.prepareStringToNumber(value);
                    var res = parseFloat(value);
                    if (isNaN(res) || !isFinite(value)) return NaN;
                    return res;
                };
                Helpers.prepareStringToNumber = function(val1) {
                    if (typeof val1 !== "string" || !val1) return val1;
                    var i = val1.indexOf(",");
                    if (i > -1 && val1.indexOf(",", i + 1) < 0) return val1.replace(",", ".");
                    return val1;
                };
                Helpers.getMaxLength = function(maxLength, surveyLength) {
                    if (maxLength < 0) maxLength = surveyLength;
                    return maxLength > 0 ? maxLength : null;
                };
                Helpers.getRemainingCharacterCounterText = function(newValue, maxLength) {
                    if (!maxLength || maxLength <= 0 || !_settings__WEBPACK_IMPORTED_MODULE_0__["settings"].showMaxLengthIndicator) return "";
                    var value = newValue ? newValue.length : "0";
                    return [
                        value,
                        maxLength
                    ].join("/");
                };
                Helpers.getNumberByIndex = function(index, startIndexStr) {
                    if (index < 0) return "";
                    var startIndex = 1;
                    var prefix = "";
                    var postfix = ".";
                    var isNumeric = true;
                    var strIndex = "A";
                    var str = "";
                    if (!!startIndexStr) {
                        str = startIndexStr;
                        var ind = str.length - 1;
                        var hasDigit = false;
                        for(var i = 0; i < str.length; i++)if (Helpers.isCharDigit(str[i])) {
                            hasDigit = true;
                            break;
                        }
                        var checkLetter = function() {
                            return hasDigit && !Helpers.isCharDigit(str[ind]) || Helpers.isCharNotLetterAndDigit(str[ind]);
                        };
                        while(ind >= 0 && checkLetter())ind--;
                        var newPostfix = "";
                        if (ind < str.length - 1) {
                            newPostfix = str.substring(ind + 1);
                            str = str.substring(0, ind + 1);
                        }
                        ind = str.length - 1;
                        while(ind >= 0){
                            if (checkLetter()) break;
                            ind--;
                            if (!hasDigit) break;
                        }
                        strIndex = str.substring(ind + 1);
                        prefix = str.substring(0, ind + 1);
                        if (parseInt(strIndex)) startIndex = parseInt(strIndex);
                        else if (strIndex.length == 1) isNumeric = false;
                        if (!!newPostfix || !!prefix) postfix = newPostfix;
                    }
                    if (isNumeric) {
                        var val1 = (index + startIndex).toString();
                        while(val1.length < strIndex.length)val1 = "0" + val1;
                        return prefix + val1 + postfix;
                    }
                    return prefix + String.fromCharCode(strIndex.charCodeAt(0) + index) + postfix;
                };
                Helpers.isCharNotLetterAndDigit = function(ch) {
                    return ch.toUpperCase() == ch.toLowerCase() && !Helpers.isCharDigit(ch);
                };
                Helpers.isCharDigit = function(ch) {
                    return ch >= "0" && ch <= "9";
                };
                Helpers.getNumberFromStr = function(str, index) {
                    if (!this.isCharDigit(str[index])) return NaN;
                    var nStr = "";
                    while(index < str.length && this.isCharDigit(str[index])){
                        nStr += str[index];
                        index++;
                    }
                    if (!nStr) return NaN;
                    return this.getNumber(nStr);
                };
                Helpers.countDecimals = function(value) {
                    if (Helpers.isNumber(value) && Math.floor(value) !== value) {
                        var strs = value.toString().split(".");
                        return strs.length > 1 && strs[1].length || 0;
                    }
                    return 0;
                };
                Helpers.correctAfterPlusMinis = function(a, b, res) {
                    var digitsA = Helpers.countDecimals(a);
                    var digitsB = Helpers.countDecimals(b);
                    if (digitsA > 0 || digitsB > 0) {
                        var digits = Math.max(digitsA, digitsB);
                        res = parseFloat(res.toFixed(digits));
                    }
                    return res;
                };
                Helpers.sumAnyValues = function(a, b) {
                    if (!Helpers.isNumber(a) || !Helpers.isNumber(b)) {
                        if (Array.isArray(a) && Array.isArray(b)) return [].concat(a).concat(b);
                        if (Array.isArray(a) || Array.isArray(b)) {
                            var arr = Array.isArray(a) ? a : b;
                            var val1 = arr === a ? b : a;
                            if (typeof val1 === "string") {
                                var str = arr.join(", ");
                                return arr === a ? str + val1 : val1 + str;
                            }
                            if (typeof val1 === "number") {
                                var res = 0;
                                for(var i = 0; i < arr.length; i++)if (typeof arr[i] === "number") res = Helpers.correctAfterPlusMinis(res, arr[i], res + arr[i]);
                                return Helpers.correctAfterPlusMinis(res, val1, res + val1);
                            }
                        }
                        return a + b;
                    }
                    if (typeof a === "string" || typeof b === "string") return a + b;
                    return Helpers.correctAfterPlusMinis(a, b, a + b);
                };
                Helpers.correctAfterMultiple = function(a, b, res) {
                    var digits = Helpers.countDecimals(a) + Helpers.countDecimals(b);
                    if (digits > 0) res = parseFloat(res.toFixed(digits));
                    return res;
                };
                Helpers.convertArrayValueToObject = function(src, propName, dest) {
                    if (dest === void 0) dest = undefined;
                    var res = new Array();
                    if (!src || !Array.isArray(src)) return res;
                    for(var i = 0; i < src.length; i++){
                        var item = void 0;
                        if (Array.isArray(dest)) item = Helpers.findObjByPropValue(dest, propName, src[i]);
                        if (!item) {
                            item = {};
                            item[propName] = src[i];
                        }
                        res.push(item);
                    }
                    return res;
                };
                Helpers.findObjByPropValue = function(arr, propName, val1) {
                    for(var i = 0; i < arr.length; i++){
                        if (Helpers.isTwoValueEquals(arr[i][propName], val1)) return arr[i];
                    }
                    return undefined;
                };
                Helpers.convertArrayObjectToValue = function(src, propName) {
                    var res = new Array();
                    if (!src || !Array.isArray(src)) return res;
                    for(var i = 0; i < src.length; i++){
                        var itemVal = !!src[i] ? src[i][propName] : undefined;
                        if (!Helpers.isValueEmpty(itemVal)) res.push(itemVal);
                    }
                    return res;
                };
                Helpers.convertDateToString = function(date) {
                    var toStr = function(val1) {
                        if (val1 < 10) return "0" + val1.toString();
                        return val1.toString();
                    };
                    return date.getFullYear() + "-" + toStr(date.getMonth() + 1) + "-" + toStr(date.getDate());
                };
                Helpers.convertDateTimeToString = function(date) {
                    var toStr = function(val1) {
                        if (val1 < 10) return "0" + val1.toString();
                        return val1.toString();
                    };
                    return this.convertDateToString(date) + " " + toStr(date.getHours()) + ":" + toStr(date.getMinutes());
                };
                Helpers.convertValToQuestionVal = function(val1, inputType) {
                    if (val1 instanceof Date) {
                        if (inputType === "datetime-local") return Helpers.convertDateTimeToString(val1);
                        return Helpers.convertDateToString(val1);
                    }
                    return val1;
                };
                Helpers.compareVerions = function(ver1, ver2) {
                    if (!ver1 && !ver2) return 0;
                    var ver1Ar = ver1.split(".");
                    var ver2Ar = ver2.split(".");
                    var len1 = ver1Ar.length;
                    var len2 = ver2Ar.length;
                    for(var i = 0; i < len1 && i < len2; i++){
                        var str1 = ver1Ar[i];
                        var str2 = ver2Ar[i];
                        if (str1.length === str2.length) {
                            if (str1 !== str2) return str1 < str2 ? -1 : 1;
                        } else return str1.length < str2.length ? -1 : 1;
                    }
                    return len1 === len2 ? 0 : len1 < len2 ? -1 : 1;
                };
                return Helpers;
            }();
            if (!String.prototype["format"]) String.prototype["format"] = function() {
                var args = arguments;
                return this.replace(/{(\d+)}/g, function(match, number) {
                    return typeof args[number] != "undefined" ? args[number] : match;
                });
            };
        /***/ },
        /***/ "./src/jsonobject.ts": /*!***************************!*\
  !*** ./src/jsonobject.ts ***!
  \***************************/ /*! exports provided: property, propertyArray, JsonObjectProperty, CustomPropertiesCollection, JsonMetadataClass, JsonMetadata, JsonError, JsonUnknownPropertyError, JsonMissingTypeErrorBase, JsonMissingTypeError, JsonIncorrectTypeError, JsonRequiredPropertyError, JsonRequiredArrayPropertyError, JsonIncorrectPropertyValueError, JsonObject, Serializer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "property", function() {
                return property;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "propertyArray", function() {
                return propertyArray;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonObjectProperty", function() {
                return JsonObjectProperty;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CustomPropertiesCollection", function() {
                return CustomPropertiesCollection;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonMetadataClass", function() {
                return JsonMetadataClass;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonMetadata", function() {
                return JsonMetadata;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonError", function() {
                return JsonError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonUnknownPropertyError", function() {
                return JsonUnknownPropertyError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeErrorBase", function() {
                return JsonMissingTypeErrorBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonMissingTypeError", function() {
                return JsonMissingTypeError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonIncorrectTypeError", function() {
                return JsonIncorrectTypeError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonRequiredPropertyError", function() {
                return JsonRequiredPropertyError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonRequiredArrayPropertyError", function() {
                return JsonRequiredArrayPropertyError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonIncorrectPropertyValueError", function() {
                return JsonIncorrectPropertyValueError;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "JsonObject", function() {
                return JsonObject;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Serializer", function() {
                return Serializer;
            });
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __spreadArray = function(to, from) {
                for(var i = 0, il = from.length, j = to.length; i < il; i++, j++)to[j] = from[i];
                return to;
            };
            function ensureLocString(target, options, key) {
                var locString = target.getLocalizableString(key);
                if (!locString) {
                    var defaultStr = void 0;
                    if (typeof options.localizable === "object" && options.localizable.defaultStr) defaultStr = options.localizable.defaultStr;
                    locString = target.createLocalizableString(key, target, true, defaultStr);
                    if (typeof options.localizable === "object" && typeof options.localizable.onGetTextCallback === "function") locString.onGetTextCallback = options.localizable.onGetTextCallback;
                }
            }
            function getLocStringValue(target, options, key) {
                ensureLocString(target, options, key);
                var res = target.getLocalizableStringText(key);
                if (!!res) return res;
                if (typeof options.localizable === "object" && options.localizable.defaultStr) {
                    var loc = !!target.getLocale ? target.getLocale() : "";
                    return _surveyStrings__WEBPACK_IMPORTED_MODULE_0__["surveyLocalization"].getString(options.localizable.defaultStr, loc);
                }
                return "";
            }
            function property(options) {
                if (options === void 0) options = {};
                // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                return function(target, key) {
                    var processComputedUpdater = function(obj, val1) {
                        if (!!val1 && typeof val1 === "object" && val1.type === _base__WEBPACK_IMPORTED_MODULE_1__["ComputedUpdater"].ComputedUpdaterType) {
                            _base__WEBPACK_IMPORTED_MODULE_1__["Base"].startCollectDependencies(function() {
                                return obj[key] = val1.updater();
                            }, obj, key);
                            var result = val1.updater();
                            var dependencies = _base__WEBPACK_IMPORTED_MODULE_1__["Base"].finishCollectDependencies();
                            val1.setDependencies(dependencies);
                            if (obj.dependencies[key]) obj.dependencies[key].dispose();
                            obj.dependencies[key] = val1;
                            return result;
                        }
                        return val1;
                    };
                    if (!options || !options.localizable) Object.defineProperty(target, key, {
                        get: function() {
                            // const serializationProperty = Serializer.getProperty(target.getType(), key);
                            // if(!!serializationProperty && options.defaultValue !== undefined) {
                            //   ConsoleWarnings.error("remove defaultValue from @property for class " + target.getType() + " property name is " + key);
                            // }
                            var defaultVal = null;
                            if (!!options) {
                                if (typeof options.getDefaultValue === "function") defaultVal = options.getDefaultValue(this);
                                if (options.defaultValue !== undefined) defaultVal = options.defaultValue;
                            }
                            return this.getPropertyValue(key, defaultVal);
                        },
                        set: function(val1) {
                            var newValue = processComputedUpdater(this, val1);
                            this.setPropertyValue(key, newValue);
                            if (!!options && options.onSet) options.onSet(newValue, this);
                        }
                    });
                    else {
                        Object.defineProperty(target, key, {
                            get: function() {
                                return getLocStringValue(this, options, key);
                            },
                            set: function(val1) {
                                ensureLocString(this, options, key);
                                var newValue = processComputedUpdater(this, val1);
                                this.setLocalizableStringText(key, newValue);
                                if (!!options && options.onSet) options.onSet(newValue, this);
                            }
                        });
                        Object.defineProperty(target, typeof options.localizable === "object" && !!options.localizable.name ? options.localizable.name : "loc" + key.charAt(0).toUpperCase() + key.slice(1), {
                            get: function() {
                                ensureLocString(this, options, key);
                                return this.getLocalizableString(key);
                            }
                        });
                    }
                };
            }
            function ensureArray(target, options, key) {
                target.ensureArray(key, function(item, index) {
                    var handler = !!options ? options.onPush : null;
                    handler && handler(item, index, target);
                }, function(item, index) {
                    var handler = !!options ? options.onRemove : null;
                    handler && handler(item, index, target);
                });
            }
            function propertyArray(options) {
                return function(target, key) {
                    Object.defineProperty(target, key, {
                        get: function() {
                            ensureArray(this, options, key);
                            return this.getPropertyValue(key);
                        },
                        set: function(val1) {
                            ensureArray(this, options, key);
                            var arr = this.getPropertyValue(key);
                            if (val1 === arr) return;
                            if (arr) arr.splice.apply(arr, __spreadArray([
                                0,
                                arr.length
                            ], val1 || []));
                            else this.setPropertyValue(key, val1);
                            if (!!options && options.onSet) options.onSet(val1, this);
                        }
                    });
                };
            }
            /**
 * Contains information about a property of a survey element (page, panel, questions, and etc).
 * @see addProperty
 * @see removeProperty
 * @see [Add Properties](https://surveyjs.io/Documentation/Survey-Creator#addproperties)
 * @see [Remove Properties](https://surveyjs.io/Documentation/Survey-Creator#removeproperties)
 */ var JsonObjectProperty = /** @class */ function() {
                function JsonObjectProperty(classInfo, name, isRequired) {
                    if (isRequired === void 0) isRequired = false;
                    this.name = name;
                    this.isRequiredValue = false;
                    this.isUniqueValue = false;
                    this.isSerializable = true;
                    this.isLightSerializable = true;
                    this.isCustom = false;
                    this.isDynamicChoices = false; //TODO obsolete, use dependsOn attribute
                    this.isBindable = false;
                    this.category = "";
                    this.categoryIndex = -1;
                    this.visibleIndex = -1;
                    this.maxLength = -1;
                    this.isArray = false;
                    this.classInfoValue = classInfo;
                    this.isRequiredValue = isRequired;
                    this.idValue = JsonObjectProperty.Index++;
                }
                Object.defineProperty(JsonObjectProperty.prototype, "id", {
                    get: function() {
                        return this.idValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "classInfo", {
                    get: function() {
                        return this.classInfoValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "type", {
                    get: function() {
                        return this.typeValue ? this.typeValue : "string";
                    },
                    set: function(value) {
                        if (value === "itemvalues") value = "itemvalue[]";
                        if (value === "textitems") value = "textitem[]";
                        this.typeValue = value;
                        if (this.typeValue.indexOf("[]") === this.typeValue.length - 2) {
                            this.isArray = true;
                            this.className = this.typeValue.substring(0, this.typeValue.length - 2);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "isRequired", {
                    get: function() {
                        return this.isRequiredValue;
                    },
                    set: function(val1) {
                        if (val1 !== this.isRequired) {
                            this.isRequiredValue = val1;
                            if (!!this.classInfo) this.classInfo.resetAllProperties();
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "isUnique", {
                    get: function() {
                        return this.isUniqueValue;
                    },
                    set: function(val1) {
                        this.isUniqueValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "uniquePropertyName", {
                    get: function() {
                        return this.uniquePropertyValue;
                    },
                    set: function(val1) {
                        this.uniquePropertyValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "hasToUseGetValue", {
                    get: function() {
                        return this.onGetValue || this.serializationProperty;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.getDefaultValue = function(obj) {
                    var result = !!this.defaultValueFunc ? this.defaultValueFunc(obj) : this.defaultValueValue;
                    if (!!JsonObjectProperty.getItemValuesDefaultValue && Serializer.isDescendantOf(this.className, "itemvalue")) result = JsonObjectProperty.getItemValuesDefaultValue(this.defaultValueValue || [], this.className);
                    return result;
                };
                Object.defineProperty(JsonObjectProperty.prototype, "defaultValue", {
                    get: function() {
                        return this.getDefaultValue(undefined);
                    },
                    set: function(newValue) {
                        this.defaultValueValue = newValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.isDefaultValue = function(value) {
                    return this.isDefaultValueByObj(undefined, value);
                };
                JsonObjectProperty.prototype.isDefaultValueByObj = function(obj, value) {
                    var dValue = this.getDefaultValue(obj);
                    if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(dValue)) return _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(value, dValue, false, true, false);
                    if (this.isLocalizable) return value === null || value === undefined;
                    return value === false && (this.type == "boolean" || this.type == "switch") || value === "" || _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(value);
                };
                JsonObjectProperty.prototype.getSerializableValue = function(obj) {
                    if (!!this.onSerializeValue) return this.onSerializeValue(obj);
                    return this.getValue(obj);
                };
                JsonObjectProperty.prototype.getValue = function(obj) {
                    if (this.onGetValue) return this.onGetValue(obj);
                    if (this.serializationProperty && !!obj[this.serializationProperty]) return obj[this.serializationProperty].getJson();
                    return obj[this.name];
                };
                JsonObjectProperty.prototype.getPropertyValue = function(obj) {
                    if (this.isLocalizable) return !!obj[this.serializationProperty] ? obj[this.serializationProperty].text : null;
                    return this.getValue(obj);
                };
                Object.defineProperty(JsonObjectProperty.prototype, "hasToUseSetValue", {
                    get: function() {
                        return this.onSetValue || this.serializationProperty;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.settingValue = function(obj, value) {
                    if (!this.onSettingValue || obj.isLoadingFromJson) return value;
                    return this.onSettingValue(obj, value);
                };
                JsonObjectProperty.prototype.setValue = function(obj, value, jsonConv) {
                    if (this.onSetValue) this.onSetValue(obj, value, jsonConv);
                    else if (this.serializationProperty && !!obj[this.serializationProperty]) obj[this.serializationProperty].setJson(value);
                    else {
                        if (value && typeof value === "string") {
                            if (this.type == "number") value = parseInt(value);
                            if (this.type == "boolean" || this.type == "switch") value = value.toLowerCase() === "true";
                        }
                        obj[this.name] = value;
                    }
                };
                JsonObjectProperty.prototype.validateValue = function(value) {
                    var choices = this.choices;
                    if (!Array.isArray(choices) || choices.length === 0) return true;
                    return choices.indexOf(value) > -1;
                };
                JsonObjectProperty.prototype.getObjType = function(objType) {
                    if (!this.classNamePart) return objType;
                    return objType.replace(this.classNamePart, "");
                };
                Object.defineProperty(JsonObjectProperty.prototype, "choices", {
                    /**
         * Depricated, please use getChoices
         */ get: function() {
                        return this.getChoices(null);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "hasChoices", {
                    get: function() {
                        return !!this.choicesValue || !!this.choicesfunc;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.getChoices = function(obj, choicesCallback) {
                    if (choicesCallback === void 0) choicesCallback = null;
                    if (this.choicesValue != null) return this.choicesValue;
                    if (this.choicesfunc != null) return this.choicesfunc(obj, choicesCallback);
                    return null;
                };
                JsonObjectProperty.prototype.setChoices = function(value, valueFunc) {
                    if (valueFunc === void 0) valueFunc = null;
                    this.choicesValue = value;
                    this.choicesfunc = valueFunc;
                };
                JsonObjectProperty.prototype.getBaseValue = function() {
                    if (!this.baseValue) return "";
                    if (typeof this.baseValue == "function") return this.baseValue();
                    return this.baseValue;
                };
                JsonObjectProperty.prototype.setBaseValue = function(val1) {
                    this.baseValue = val1;
                };
                Object.defineProperty(JsonObjectProperty.prototype, "readOnly", {
                    get: function() {
                        return this.readOnlyValue != null ? this.readOnlyValue : false;
                    },
                    set: function(val1) {
                        this.readOnlyValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.isEnable = function(obj) {
                    if (this.readOnly) return false;
                    if (!obj || !this.enableIf) return true;
                    return this.enableIf(this.getOriginalObj(obj));
                };
                JsonObjectProperty.prototype.isVisible = function(layout, obj) {
                    if (obj === void 0) obj = null;
                    var isLayout = !this.layout || this.layout == layout;
                    if (!this.visible || !isLayout) return false;
                    if (!!this.visibleIf && !!obj) return this.visibleIf(this.getOriginalObj(obj));
                    return true;
                };
                JsonObjectProperty.prototype.getOriginalObj = function(obj) {
                    if (obj && obj.getOriginalObj) {
                        var orjObj = obj.getOriginalObj();
                        if (orjObj && Serializer.findProperty(orjObj.getType(), this.name)) return orjObj;
                    }
                    return obj;
                };
                Object.defineProperty(JsonObjectProperty.prototype, "visible", {
                    get: function() {
                        return this.visibleValue != null ? this.visibleValue : true;
                    },
                    set: function(val1) {
                        this.visibleValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.isAvailableInVersion = function(ver) {
                    if (!!this.alternativeName || this.oldName) return true;
                    return this.isAvailableInVersionCore(ver);
                };
                JsonObjectProperty.prototype.getSerializedName = function(ver) {
                    if (!this.alternativeName) return this.name;
                    return this.isAvailableInVersionCore(ver) ? this.name : this.alternativeName || this.oldName;
                };
                JsonObjectProperty.prototype.getSerializedProperty = function(obj, ver) {
                    if (!this.oldName || this.isAvailableInVersionCore(ver)) return this;
                    if (!obj || !obj.getType) return null;
                    return Serializer.findProperty(obj.getType(), this.oldName);
                };
                JsonObjectProperty.prototype.isAvailableInVersionCore = function(ver) {
                    if (!ver || !this.version) return true;
                    return _helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].compareVerions(this.version, ver) <= 0;
                };
                Object.defineProperty(JsonObjectProperty.prototype, "isLocalizable", {
                    get: function() {
                        return this.isLocalizableValue != null ? this.isLocalizableValue : false;
                    },
                    set: function(val1) {
                        this.isLocalizableValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(JsonObjectProperty.prototype, "dataList", {
                    get: function() {
                        return Array.isArray(this.dataListValue) ? this.dataListValue : [];
                    },
                    set: function(val1) {
                        this.dataListValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObjectProperty.prototype.mergeWith = function(prop) {
                    var valuesNames = JsonObjectProperty.mergableValues;
                    for(var i = 0; i < valuesNames.length; i++)this.mergeValue(prop, valuesNames[i]);
                };
                JsonObjectProperty.prototype.addDependedProperty = function(name) {
                    if (!this.dependedProperties) this.dependedProperties = [];
                    if (this.dependedProperties.indexOf(name) < 0) this.dependedProperties.push(name);
                };
                JsonObjectProperty.prototype.getDependedProperties = function() {
                    return !!this.dependedProperties ? this.dependedProperties : [];
                };
                JsonObjectProperty.prototype.schemaType = function() {
                    if (this.className === "choicesByUrl") return undefined;
                    if (this.className === "string") return this.className;
                    if (!!this.className) return "array";
                    if (!!this.baseClassName) return "array";
                    if (this.type == "switch") return "boolean";
                    if (this.type == "boolean" || this.type == "number") return this.type;
                    return "string";
                };
                JsonObjectProperty.prototype.schemaRef = function() {
                    if (!!this.className) return this.className;
                    return undefined;
                };
                JsonObjectProperty.prototype.mergeValue = function(prop, valueName) {
                    if (this[valueName] == null && prop[valueName] != null) this[valueName] = prop[valueName];
                };
                JsonObjectProperty.Index = 1;
                JsonObjectProperty.mergableValues = [
                    "typeValue",
                    "choicesValue",
                    "baseValue",
                    "readOnlyValue",
                    "visibleValue",
                    "isSerializable",
                    "isLightSerializable",
                    "isCustom",
                    "isBindable",
                    "isUnique",
                    "uniquePropertyName",
                    "isDynamicChoices",
                    "isLocalizableValue",
                    "className",
                    "alternativeName",
                    "oldName",
                    "layout",
                    "version",
                    "classNamePart",
                    "baseClassName",
                    "defaultValue",
                    "defaultValueFunc",
                    "serializationProperty",
                    "onGetValue",
                    "onSetValue",
                    "onSettingValue",
                    "displayName",
                    "category",
                    "categoryIndex",
                    "visibleIndex",
                    "nextToProperty",
                    "overridingProperty",
                    "showMode",
                    "dependedProperties",
                    "visibleIf",
                    "enableIf",
                    "onExecuteExpression",
                    "onPropertyEditorUpdate",
                    "maxLength",
                    "maxValue",
                    "minValue",
                    "dataListValue"
                ];
                return JsonObjectProperty;
            }();
            var CustomPropertiesCollection = /** @class */ function() {
                function CustomPropertiesCollection() {}
                CustomPropertiesCollection.addProperty = function(className, property) {
                    className = className.toLowerCase();
                    var props = CustomPropertiesCollection.properties;
                    if (!props[className]) props[className] = [];
                    props[className].push(property);
                };
                CustomPropertiesCollection.removeProperty = function(className, propertyName) {
                    className = className.toLowerCase();
                    var props = CustomPropertiesCollection.properties;
                    if (!props[className]) return;
                    var properties = props[className];
                    for(var i = 0; i < properties.length; i++)if (properties[i].name == propertyName) {
                        props[className].splice(i, 1);
                        break;
                    }
                };
                CustomPropertiesCollection.removeAllProperties = function(className) {
                    className = className.toLowerCase();
                    delete CustomPropertiesCollection.properties[className];
                };
                CustomPropertiesCollection.addClass = function(className, parentClassName) {
                    className = className.toLowerCase();
                    if (parentClassName) parentClassName = parentClassName.toLowerCase();
                    CustomPropertiesCollection.parentClasses[className] = parentClassName;
                };
                CustomPropertiesCollection.getProperties = function(className) {
                    className = className.toLowerCase();
                    var res = [];
                    var props = CustomPropertiesCollection.properties;
                    while(className){
                        var properties = props[className];
                        if (properties) for(var i = 0; i < properties.length; i++)res.push(properties[i]);
                        className = CustomPropertiesCollection.parentClasses[className];
                    }
                    return res;
                };
                CustomPropertiesCollection.createProperties = function(obj) {
                    if (!obj || !obj.getType) return;
                    CustomPropertiesCollection.createPropertiesCore(obj, obj.getType());
                };
                CustomPropertiesCollection.createPropertiesCore = function(obj, className) {
                    var props = CustomPropertiesCollection.properties;
                    if (props[className]) CustomPropertiesCollection.createPropertiesInObj(obj, props[className]);
                    var parentClass = CustomPropertiesCollection.parentClasses[className];
                    if (parentClass) CustomPropertiesCollection.createPropertiesCore(obj, parentClass);
                };
                CustomPropertiesCollection.createPropertiesInObj = function(obj, properties) {
                    for(var i = 0; i < properties.length; i++)CustomPropertiesCollection.createPropertyInObj(obj, properties[i]);
                };
                CustomPropertiesCollection.createPropertyInObj = function(obj, prop) {
                    if (CustomPropertiesCollection.checkIsPropertyExists(obj, prop.name)) return;
                    if (!!prop.serializationProperty && CustomPropertiesCollection.checkIsPropertyExists(obj, prop.serializationProperty)) return;
                    if (prop.isLocalizable && prop.serializationProperty && obj.createCustomLocalizableObj) {
                        var locStr = obj.createCustomLocalizableObj(prop.name);
                        locStr.defaultValue = prop.defaultValue;
                        var locDesc = {
                            get: function() {
                                return obj.getLocalizableString(prop.name);
                            }
                        };
                        Object.defineProperty(obj, prop.serializationProperty, locDesc);
                        var desc = {
                            get: function() {
                                return obj.getLocalizableStringText(prop.name);
                            },
                            set: function(v) {
                                obj.setLocalizableStringText(prop.name, v);
                            }
                        };
                        Object.defineProperty(obj, prop.name, desc);
                    } else {
                        var defaultValue = prop.defaultValue;
                        var isArrayProp = prop.isArray || prop.type === "multiplevalues";
                        if (typeof obj.createNewArray === "function") {
                            if (Serializer.isDescendantOf(prop.className, "itemvalue")) {
                                obj.createNewArray(prop.name, function(item) {
                                    item.locOwner = obj;
                                    item.ownerPropertyName = prop.name;
                                });
                                isArrayProp = true;
                            } else //It is a simple array property
                            if (isArrayProp) obj.createNewArray(prop.name);
                            if (isArrayProp) {
                                if (Array.isArray(defaultValue)) obj.setPropertyValue(prop.name, defaultValue);
                                defaultValue = null;
                            }
                        }
                        if (!!obj.getPropertyValue && !!obj.setPropertyValue) {
                            var desc = {
                                get: function() {
                                    if (!!prop.onGetValue) return prop.onGetValue(obj);
                                    return obj.getPropertyValue(prop.name, defaultValue);
                                },
                                set: function(v) {
                                    if (!!prop.onSetValue) prop.onSetValue(obj, v, null);
                                    else obj.setPropertyValue(prop.name, v);
                                }
                            };
                            Object.defineProperty(obj, prop.name, desc);
                        }
                    }
                    if (prop.type === "condition" || prop.type === "expression") {
                        if (!!prop.onExecuteExpression) obj.addExpressionProperty(prop.name, prop.onExecuteExpression);
                    }
                };
                CustomPropertiesCollection.checkIsPropertyExists = function(obj, name) {
                    return obj.hasOwnProperty(name) || obj[name];
                };
                CustomPropertiesCollection.properties = {};
                CustomPropertiesCollection.parentClasses = {};
                return CustomPropertiesCollection;
            }();
            var JsonMetadataClass = /** @class */ function() {
                function JsonMetadataClass(name, properties, creator, parentName) {
                    if (creator === void 0) creator = null;
                    if (parentName === void 0) parentName = null;
                    this.name = name;
                    this.creator = creator;
                    this.parentName = parentName;
                    name = name.toLowerCase();
                    this.isCustomValue = !creator && name !== "survey";
                    if (this.parentName) {
                        this.parentName = this.parentName.toLowerCase();
                        CustomPropertiesCollection.addClass(name, this.parentName);
                        if (!!creator) this.makeParentRegularClass();
                    }
                    this.properties = new Array();
                    for(var i = 0; i < properties.length; i++)this.createProperty(properties[i], this.isCustom);
                }
                //Obsolete
                JsonMetadataClass.prototype.find = function(name) {
                    for(var i = 0; i < this.properties.length; i++){
                        if (this.properties[i].name == name) return this.properties[i];
                    }
                    return null;
                };
                JsonMetadataClass.prototype.findProperty = function(name) {
                    this.fillAllProperties();
                    return this.hashProperties[name];
                };
                JsonMetadataClass.prototype.getAllProperties = function() {
                    this.fillAllProperties();
                    return this.allProperties;
                };
                JsonMetadataClass.prototype.getRequiredProperties = function() {
                    if (!!this.requiredProperties) return this.requiredProperties;
                    this.requiredProperties = [];
                    var props = this.getAllProperties();
                    for(var i = 0; i < props.length; i++)if (props[i].isRequired) this.requiredProperties.push(props[i]);
                    return this.requiredProperties;
                };
                JsonMetadataClass.prototype.resetAllProperties = function() {
                    this.allProperties = undefined;
                    this.requiredProperties = undefined;
                    this.hashProperties = undefined;
                    var childClasses = Serializer.getChildrenClasses(this.name);
                    for(var i = 0; i < childClasses.length; i++)childClasses[i].resetAllProperties();
                };
                Object.defineProperty(JsonMetadataClass.prototype, "isCustom", {
                    get: function() {
                        return this.isCustomValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonMetadataClass.prototype.fillAllProperties = function() {
                    var _this = this;
                    if (!!this.allProperties) return;
                    this.allProperties = [];
                    this.hashProperties = {};
                    var localProperties = {};
                    this.properties.forEach(function(prop) {
                        return localProperties[prop.name] = prop;
                    });
                    var parentClass = !!this.parentName ? Serializer.findClass(this.parentName) : null;
                    if (!!parentClass) {
                        var parentProperties = parentClass.getAllProperties();
                        parentProperties.forEach(function(prop) {
                            var overridedProp = localProperties[prop.name];
                            if (!!overridedProp) {
                                overridedProp.mergeWith(prop);
                                _this.addPropCore(overridedProp);
                            } else _this.addPropCore(prop);
                        });
                    }
                    this.properties.forEach(function(prop) {
                        if (!_this.hashProperties[prop.name]) _this.addPropCore(prop);
                    });
                };
                JsonMetadataClass.prototype.addPropCore = function(prop) {
                    this.allProperties.push(prop);
                    this.hashProperties[prop.name] = prop;
                    if (!!prop.alternativeName) this.hashProperties[prop.alternativeName] = prop;
                };
                JsonMetadataClass.prototype.isOverridedProp = function(propName) {
                    return !!this.parentName && !!Serializer.findProperty(this.parentName, propName);
                };
                JsonMetadataClass.prototype.hasRegularChildClass = function() {
                    if (!this.isCustom) return;
                    this.isCustomValue = false;
                    for(var i = 0; i < this.properties.length; i++)this.properties[i].isCustom = false;
                    CustomPropertiesCollection.removeAllProperties(this.name);
                    this.makeParentRegularClass();
                };
                JsonMetadataClass.prototype.makeParentRegularClass = function() {
                    if (!this.parentName) return;
                    var parent = Serializer.findClass(this.parentName);
                    if (!!parent) parent.hasRegularChildClass();
                };
                JsonMetadataClass.prototype.createProperty = function(propInfo, isCustom) {
                    if (isCustom === void 0) isCustom = false;
                    var propertyName = typeof propInfo === "string" ? propInfo : propInfo.name;
                    if (!propertyName) return;
                    var propertyType = null;
                    var typeIndex = propertyName.indexOf(JsonMetadataClass.typeSymbol);
                    if (typeIndex > -1) {
                        propertyType = propertyName.substring(typeIndex + 1);
                        propertyName = propertyName.substring(0, typeIndex);
                    }
                    var isRequired = this.getIsPropertyNameRequired(propertyName) || !!propInfo.isRequired;
                    propertyName = this.getPropertyName(propertyName);
                    var prop = new JsonObjectProperty(this, propertyName, isRequired);
                    if (propertyType) prop.type = propertyType;
                    if (typeof propInfo === "object") {
                        if (propInfo.type) prop.type = propInfo.type;
                        if (propInfo.default !== undefined) prop.defaultValue = propInfo.default;
                        if (propInfo.defaultFunc !== undefined) prop.defaultValueFunc = propInfo.defaultFunc;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isSerializable)) prop.isSerializable = propInfo.isSerializable;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isLightSerializable)) prop.isLightSerializable = propInfo.isLightSerializable;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.maxLength)) prop.maxLength = propInfo.maxLength;
                        if (propInfo.displayName !== undefined) prop.displayName = propInfo.displayName;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.category)) prop.category = propInfo.category;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.categoryIndex)) prop.categoryIndex = propInfo.categoryIndex;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.nextToProperty)) prop.nextToProperty = propInfo.nextToProperty;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.overridingProperty)) prop.overridingProperty = propInfo.overridingProperty;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.visibleIndex)) prop.visibleIndex = propInfo.visibleIndex;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.showMode)) prop.showMode = propInfo.showMode;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.maxValue)) prop.maxValue = propInfo.maxValue;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.minValue)) prop.minValue = propInfo.minValue;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.dataList)) prop.dataList = propInfo.dataList;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isDynamicChoices)) prop.isDynamicChoices = propInfo.isDynamicChoices;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isBindable)) prop.isBindable = propInfo.isBindable;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isUnique)) prop.isUnique = propInfo.isUnique;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.uniqueProperty)) prop.uniquePropertyName = propInfo.uniqueProperty;
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(propInfo.isArray)) prop.isArray = propInfo.isArray;
                        if (propInfo.visible === true || propInfo.visible === false) prop.visible = propInfo.visible;
                        if (!!propInfo.visibleIf) prop.visibleIf = propInfo.visibleIf;
                        if (!!propInfo.enableIf) prop.enableIf = propInfo.enableIf;
                        if (!!propInfo.onExecuteExpression) prop.onExecuteExpression = propInfo.onExecuteExpression;
                        if (!!propInfo.onPropertyEditorUpdate) prop.onPropertyEditorUpdate = propInfo.onPropertyEditorUpdate;
                        if (propInfo.readOnly === true) prop.readOnly = true;
                        if (propInfo.choices) {
                            var choicesFunc = typeof propInfo.choices === "function" ? propInfo.choices : null;
                            var choicesValue = typeof propInfo.choices !== "function" ? propInfo.choices : null;
                            prop.setChoices(choicesValue, choicesFunc);
                        }
                        if (!!propInfo.baseValue) prop.setBaseValue(propInfo.baseValue);
                        if (propInfo.onSerializeValue) prop.onSerializeValue = propInfo.onSerializeValue;
                        if (propInfo.onGetValue) prop.onGetValue = propInfo.onGetValue;
                        if (propInfo.onSetValue) prop.onSetValue = propInfo.onSetValue;
                        if (propInfo.onSettingValue) prop.onSettingValue = propInfo.onSettingValue;
                        if (propInfo.isLocalizable) propInfo.serializationProperty = "loc" + prop.name;
                        if (propInfo.serializationProperty) {
                            prop.serializationProperty = propInfo.serializationProperty;
                            var s;
                            if (prop.serializationProperty && prop.serializationProperty.indexOf("loc") == 0) prop.isLocalizable = true;
                        }
                        if (propInfo.isLocalizable) prop.isLocalizable = propInfo.isLocalizable;
                        if (propInfo.className) prop.className = propInfo.className;
                        if (propInfo.baseClassName) {
                            prop.baseClassName = propInfo.baseClassName;
                            prop.isArray = true;
                        }
                        if (prop.isArray === true) prop.isArray = true;
                        if (propInfo.classNamePart) prop.classNamePart = propInfo.classNamePart;
                        if (propInfo.alternativeName) prop.alternativeName = propInfo.alternativeName;
                        if (propInfo.oldName) prop.oldName = propInfo.oldName;
                        if (propInfo.layout) prop.layout = propInfo.layout;
                        if (propInfo.version) prop.version = propInfo.version;
                        if (propInfo.dependsOn) this.addDependsOnProperties(prop, propInfo.dependsOn);
                    }
                    this.properties.push(prop);
                    if (isCustom && !this.isOverridedProp(prop.name)) {
                        prop.isCustom = true;
                        CustomPropertiesCollection.addProperty(this.name, prop);
                    }
                    return prop;
                };
                JsonMetadataClass.prototype.addDependsOnProperties = function(prop, dependsOn) {
                    if (Array.isArray(dependsOn)) for(var i = 0; i < dependsOn.length; i++)this.addDependsOnProperty(prop, dependsOn[i]);
                    else this.addDependsOnProperty(prop, dependsOn);
                };
                JsonMetadataClass.prototype.addDependsOnProperty = function(prop, dependsOn) {
                    var property = this.find(dependsOn);
                    if (!property) property = Serializer.findProperty(this.parentName, dependsOn);
                    if (!property) return;
                    property.addDependedProperty(prop.name);
                };
                JsonMetadataClass.prototype.getIsPropertyNameRequired = function(propertyName) {
                    return propertyName.length > 0 && propertyName[0] == JsonMetadataClass.requiredSymbol;
                };
                JsonMetadataClass.prototype.getPropertyName = function(propertyName) {
                    if (!this.getIsPropertyNameRequired(propertyName)) return propertyName;
                    propertyName = propertyName.slice(1);
                    return propertyName;
                };
                JsonMetadataClass.requiredSymbol = "!";
                JsonMetadataClass.typeSymbol = ":";
                return JsonMetadataClass;
            }();
            /**
 * The metadata object. It contains object properties' runtime information and allows you to modify it.
 */ var JsonMetadata = /** @class */ function() {
                function JsonMetadata() {
                    this.classes = {};
                    this.alternativeNames = {};
                    this.childrenClasses = {};
                    this.dynamicPropsCache = {};
                }
                JsonMetadata.prototype.getObjPropertyValue = function(obj, name) {
                    if (this.isObjWrapper(obj) && this.isNeedUseObjWrapper(obj, name)) {
                        var orignalObj = obj.getOriginalObj();
                        var prop_1 = Serializer.findProperty(orignalObj.getType(), name);
                        if (!!prop_1) return this.getObjPropertyValueCore(orignalObj, prop_1);
                    }
                    var prop = Serializer.findProperty(obj.getType(), name);
                    if (!prop) return obj[name];
                    return this.getObjPropertyValueCore(obj, prop);
                };
                JsonMetadata.prototype.setObjPropertyValue = function(obj, name, val1) {
                    if (obj[name] === val1) return;
                    if (!!obj[name] && !!obj[name].setJson) obj[name].setJson(val1);
                    else {
                        if (Array.isArray(val1)) {
                            var newVal = [];
                            for(var i = 0; i < val1.length; i++)newVal.push(val1[i]);
                            val1 = newVal;
                        }
                        obj[name] = val1;
                    }
                };
                JsonMetadata.prototype.getObjPropertyValueCore = function(obj, prop) {
                    if (!prop.isSerializable) return obj[prop.name];
                    if (prop.isLocalizable) {
                        if (prop.isArray) return obj[prop.name];
                        if (!!prop.serializationProperty) return obj[prop.serializationProperty].text;
                    }
                    return obj.getPropertyValue(prop.name);
                };
                JsonMetadata.prototype.isObjWrapper = function(obj) {
                    return !!obj.getOriginalObj && !!obj.getOriginalObj();
                };
                JsonMetadata.prototype.isNeedUseObjWrapper = function(obj, name) {
                    if (!obj.getDynamicProperties) return true;
                    var props = obj.getDynamicProperties();
                    if (!Array.isArray(props)) return false;
                    for(var i = 0; i < props.length; i++){
                        if (props[i].name === name) return true;
                    }
                    return false;
                };
                JsonMetadata.prototype.addClass = function(name, properties, creator, parentName) {
                    if (creator === void 0) creator = null;
                    if (parentName === void 0) parentName = null;
                    name = name.toLowerCase();
                    var metaDataClass = new JsonMetadataClass(name, properties, creator, parentName);
                    this.classes[name] = metaDataClass;
                    if (parentName) {
                        parentName = parentName.toLowerCase();
                        var children = this.childrenClasses[parentName];
                        if (!children) this.childrenClasses[parentName] = [];
                        this.childrenClasses[parentName].push(metaDataClass);
                    }
                    return metaDataClass;
                };
                JsonMetadata.prototype.removeClass = function(name) {
                    var metaClass = this.findClass(name);
                    if (!metaClass) return;
                    delete this.classes[metaClass.name];
                    if (!!metaClass.parentName) {
                        var index = this.childrenClasses[metaClass.parentName].indexOf(metaClass);
                        if (index > -1) this.childrenClasses[metaClass.parentName].splice(index, 1);
                    }
                };
                JsonMetadata.prototype.overrideClassCreatore = function(name, creator) {
                    this.overrideClassCreator(name, creator);
                };
                JsonMetadata.prototype.overrideClassCreator = function(name, creator) {
                    name = name.toLowerCase();
                    var metaDataClass = this.findClass(name);
                    if (metaDataClass) metaDataClass.creator = creator;
                };
                JsonMetadata.prototype.getProperties = function(className) {
                    var metaClass = this.findClass(className);
                    if (!metaClass) return [];
                    return metaClass.getAllProperties();
                };
                JsonMetadata.prototype.getPropertiesByObj = function(obj) {
                    if (!obj || !obj.getType) return [];
                    var props = this.getProperties(obj.getType());
                    var dynamicProps = this.getDynamicPropertiesByObj(obj);
                    return [].concat(props).concat(dynamicProps);
                };
                JsonMetadata.prototype.addDynamicPropertiesIntoObj = function(dest, src, props) {
                    var _this = this;
                    props.forEach(function(prop) {
                        _this.addDynamicPropertyIntoObj(dest, src, prop.name, false);
                        if (prop.serializationProperty) _this.addDynamicPropertyIntoObj(dest, src, prop.serializationProperty, true);
                        if (prop.alternativeName) _this.addDynamicPropertyIntoObj(dest, src, prop.alternativeName, false);
                    });
                };
                JsonMetadata.prototype.addDynamicPropertyIntoObj = function(dest, src, propName, isReadOnly) {
                    var desc = {
                        configurable: true,
                        get: function() {
                            return src[propName];
                        }
                    };
                    if (!isReadOnly) desc["set"] = function(v) {
                        src[propName] = v;
                    };
                    Object.defineProperty(dest, propName, desc);
                };
                JsonMetadata.prototype.getDynamicPropertiesByObj = function(obj, dynamicType) {
                    if (dynamicType === void 0) dynamicType = null;
                    if (!obj || !obj.getType) return [];
                    if (!!obj.getDynamicProperties) return obj.getDynamicProperties();
                    if (!obj.getDynamicType && !dynamicType) return [];
                    var dType = !!dynamicType ? dynamicType : obj.getDynamicType();
                    return this.getDynamicPropertiesByTypes(obj.getType(), dType);
                };
                JsonMetadata.prototype.getDynamicPropertiesByTypes = function(objType, dynamicType, invalidNames) {
                    if (!dynamicType) return [];
                    var cacheType = dynamicType + "-" + objType;
                    if (this.dynamicPropsCache[cacheType]) return this.dynamicPropsCache[cacheType];
                    var dynamicProps = this.getProperties(dynamicType);
                    if (!dynamicProps || dynamicProps.length == 0) return [];
                    var hash = {};
                    var props = this.getProperties(objType);
                    for(var i = 0; i < props.length; i++)hash[props[i].name] = props[i];
                    var res = [];
                    if (!invalidNames) invalidNames = [];
                    for(var i_1 = 0; i_1 < dynamicProps.length; i_1++){
                        var dProp = dynamicProps[i_1];
                        if (!hash[dProp.name] && invalidNames.indexOf(dProp.name) < 0) res.push(dProp);
                    }
                    this.dynamicPropsCache[cacheType] = res;
                    return res;
                };
                JsonMetadata.prototype.hasOriginalProperty = function(obj, propName) {
                    return !!this.getOriginalProperty(obj, propName);
                };
                JsonMetadata.prototype.getOriginalProperty = function(obj, propName) {
                    var res = this.findProperty(obj.getType(), propName);
                    if (!!res) return res;
                    if (this.isObjWrapper(obj)) return this.findProperty(obj.getOriginalObj().getType(), propName);
                    return null;
                };
                JsonMetadata.prototype.getProperty = function(className, propertyName) {
                    var prop = this.findProperty(className, propertyName);
                    if (!prop) return prop;
                    var classInfo = this.findClass(className);
                    if (prop.classInfo === classInfo) return prop;
                    var newProp = new JsonObjectProperty(classInfo, prop.name, prop.isRequired);
                    newProp.mergeWith(prop);
                    newProp.isArray = prop.isArray;
                    classInfo.properties.push(newProp);
                    classInfo.resetAllProperties();
                    return newProp;
                };
                JsonMetadata.prototype.findProperty = function(className, propertyName) {
                    var cl = this.findClass(className);
                    return !!cl ? cl.findProperty(propertyName) : null;
                };
                JsonMetadata.prototype.findProperties = function(className, propertyNames) {
                    var result = new Array();
                    var cl = this.findClass(className);
                    if (!cl) return result;
                    for(var i = 0; i < propertyNames.length; i++){
                        var prop = cl.findProperty(propertyNames[i]);
                        if (prop) result.push(prop);
                    }
                    return result;
                };
                JsonMetadata.prototype.getAllPropertiesByName = function(propertyName) {
                    var res = new Array();
                    var classes = this.getAllClasses();
                    for(var i = 0; i < classes.length; i++){
                        var classInfo = this.findClass(classes[i]);
                        for(var j = 0; j < classInfo.properties.length; j++)if (classInfo.properties[j].name == propertyName) {
                            res.push(classInfo.properties[j]);
                            break;
                        }
                    }
                    return res;
                };
                JsonMetadata.prototype.getAllClasses = function() {
                    var res = new Array();
                    for(var name in this.classes)res.push(name);
                    return res;
                };
                JsonMetadata.prototype.createClass = function(name, json) {
                    if (json === void 0) json = undefined;
                    name = name.toLowerCase();
                    var metaDataClass = this.findClass(name);
                    if (!metaDataClass) return null;
                    if (metaDataClass.creator) return metaDataClass.creator(json);
                    var parentName = metaDataClass.parentName;
                    while(parentName){
                        metaDataClass = this.findClass(parentName);
                        if (!metaDataClass) return null;
                        parentName = metaDataClass.parentName;
                        if (metaDataClass.creator) return this.createCustomType(name, metaDataClass.creator, json);
                    }
                    return null;
                };
                JsonMetadata.prototype.createCustomType = function(name, creator, json) {
                    if (json === void 0) json = undefined;
                    name = name.toLowerCase();
                    var res = creator(json);
                    var customTypeName = name;
                    var customTemplateName = res.getTemplate ? res.getTemplate() : res.getType();
                    res.getType = function() {
                        return customTypeName;
                    };
                    res.getTemplate = function() {
                        return customTemplateName;
                    };
                    CustomPropertiesCollection.createProperties(res);
                    return res;
                };
                JsonMetadata.prototype.getChildrenClasses = function(name, canBeCreated) {
                    if (canBeCreated === void 0) canBeCreated = false;
                    name = name.toLowerCase();
                    var result = [];
                    this.fillChildrenClasses(name, canBeCreated, result);
                    return result;
                };
                JsonMetadata.prototype.getRequiredProperties = function(name) {
                    var metaClass = this.findClass(name);
                    if (!metaClass) return [];
                    var props = metaClass.getRequiredProperties();
                    var res = [];
                    for(var i = 0; i < props.length; i++)res.push(props[i].name);
                    return res;
                };
                JsonMetadata.prototype.addProperties = function(className, propertiesInfos) {
                    className = className.toLowerCase();
                    var metaDataClass = this.findClass(className);
                    for(var i = 0; i < propertiesInfos.length; i++)this.addCustomPropertyCore(metaDataClass, propertiesInfos[i]);
                };
                JsonMetadata.prototype.addProperty = function(className, propertyInfo) {
                    return this.addCustomPropertyCore(this.findClass(className), propertyInfo);
                };
                JsonMetadata.prototype.addCustomPropertyCore = function(metaDataClass, propertyInfo) {
                    if (!metaDataClass) return null;
                    var property = metaDataClass.createProperty(propertyInfo, true);
                    if (property) {
                        this.clearDynamicPropsCache(metaDataClass);
                        metaDataClass.resetAllProperties();
                    }
                    return property;
                };
                JsonMetadata.prototype.removeProperty = function(className, propertyName) {
                    var metaDataClass = this.findClass(className);
                    if (!metaDataClass) return false;
                    var property = metaDataClass.find(propertyName);
                    if (property) {
                        this.clearDynamicPropsCache(metaDataClass);
                        this.removePropertyFromClass(metaDataClass, property);
                        metaDataClass.resetAllProperties();
                        CustomPropertiesCollection.removeProperty(metaDataClass.name, propertyName);
                    }
                };
                JsonMetadata.prototype.clearDynamicPropsCache = function(metaDataClass) {
                    this.dynamicPropsCache = {};
                };
                JsonMetadata.prototype.removePropertyFromClass = function(metaDataClass, property) {
                    var index = metaDataClass.properties.indexOf(property);
                    if (index < 0) return;
                    metaDataClass.properties.splice(index, 1);
                };
                JsonMetadata.prototype.fillChildrenClasses = function(name, canBeCreated, result) {
                    var children = this.childrenClasses[name];
                    if (!children) return;
                    for(var i = 0; i < children.length; i++){
                        if (!canBeCreated || children[i].creator) result.push(children[i]);
                        this.fillChildrenClasses(children[i].name, canBeCreated, result);
                    }
                };
                JsonMetadata.prototype.findClass = function(name) {
                    name = name.toLowerCase();
                    var res = this.classes[name];
                    if (!res) {
                        var newName = this.alternativeNames[name];
                        if (!!newName && newName != name) return this.findClass(newName);
                    }
                    return res;
                };
                JsonMetadata.prototype.isDescendantOf = function(className, ancestorClassName) {
                    if (!className || !ancestorClassName) return false;
                    className = className.toLowerCase();
                    ancestorClassName = ancestorClassName.toLowerCase();
                    var class_ = this.findClass(className);
                    if (!class_) return false;
                    var parentClass = class_;
                    do {
                        if (parentClass.name === ancestorClassName) return true;
                        parentClass = this.classes[parentClass.parentName];
                    }while (!!parentClass);
                    return false;
                };
                JsonMetadata.prototype.addAlterNativeClassName = function(name, alternativeName) {
                    this.alternativeNames[alternativeName.toLowerCase()] = name.toLowerCase();
                };
                JsonMetadata.prototype.generateSchema = function(className) {
                    if (className === void 0) className = undefined;
                    if (!className) className = "survey";
                    var classInfo = this.findClass(className);
                    if (!classInfo) return null;
                    var res = {
                        $schema: "http://json-schema.org/draft-07/schema#",
                        title: "SurveyJS Library json schema",
                        type: "object",
                        properties: {},
                        definitions: {
                            locstring: this.generateLocStrClass()
                        }
                    };
                    this.generateSchemaProperties(classInfo, res, res.definitions, true);
                    return res;
                };
                JsonMetadata.prototype.generateLocStrClass = function() {
                    var props = {};
                    var locProp = Serializer.findProperty("survey", "locale");
                    if (!!locProp) {
                        var choices = locProp.getChoices(null);
                        if (Array.isArray(choices)) {
                            if (choices.indexOf("en") < 0) choices.splice(0, 0, "en");
                            choices.splice(0, 0, "default");
                            choices.forEach(function(l) {
                                if (!!l) props[l] = {
                                    type: "string"
                                };
                            });
                        }
                    }
                    return {
                        $id: "locstring",
                        type: "object",
                        properties: props
                    };
                };
                JsonMetadata.prototype.generateSchemaProperties = function(classInfo, classSchema, schemaDef, isRoot) {
                    if (!classInfo) return;
                    var schemaProperties = classSchema.properties;
                    var requiredProps = [];
                    if (classInfo.name === "question" || classInfo.name === "panel") {
                        schemaProperties.type = {
                            type: "string"
                        };
                        requiredProps.push("type");
                    }
                    for(var i = 0; i < classInfo.properties.length; i++){
                        var prop = classInfo.properties[i];
                        if (!!classInfo.parentName && !!Serializer.findProperty(classInfo.parentName, prop.name)) continue;
                        schemaProperties[prop.name] = this.generateSchemaProperty(prop, schemaDef, isRoot);
                        if (prop.isRequired) requiredProps.push(prop.name);
                    }
                    if (requiredProps.length > 0) classSchema.required = requiredProps;
                };
                JsonMetadata.prototype.generateSchemaProperty = function(prop, schemaDef, isRoot) {
                    if (prop.isLocalizable) return {
                        oneOf: [
                            {
                                "type": "string"
                            },
                            {
                                "$ref": this.getChemeRefName("locstring", isRoot)
                            }
                        ]
                    };
                    var propType = prop.schemaType();
                    var refType = prop.schemaRef();
                    var res = {};
                    if (!!propType) res.type = propType;
                    if (prop.hasChoices) {
                        var enumRes = prop.getChoices(null);
                        if (Array.isArray(enumRes) && enumRes.length > 0) res.enum = this.getChoicesValues(enumRes);
                    }
                    if (!!refType) {
                        if (propType === "array") {
                            if (prop.className === "string") res.items = {
                                type: prop.className
                            };
                            else res.items = {
                                $ref: this.getChemeRefName(prop.className, isRoot)
                            };
                        } else res["$ref"] = this.getChemeRefName(refType, isRoot);
                        this.generateChemaClass(prop.className, schemaDef, false);
                    }
                    if (!!prop.baseClassName) {
                        var usedClasses = this.getChildrenClasses(prop.baseClassName, true);
                        if (prop.baseClassName == "question") usedClasses.push(this.findClass("panel"));
                        res.items = {
                            anyOf: []
                        };
                        for(var i = 0; i < usedClasses.length; i++){
                            var className = usedClasses[i].name;
                            res.items.anyOf.push({
                                $ref: this.getChemeRefName(className, isRoot)
                            });
                            this.generateChemaClass(className, schemaDef, false);
                        }
                    }
                    return res;
                };
                JsonMetadata.prototype.getChemeRefName = function(className, isRoot) {
                    //Fix for #6486, according to https://niem.github.io/json/reference/json-schema/references/#:~:text=In%20a%20JSON%20schema%2C%20a,%2C%20an%20in%2Dschema%20reference
                    //Checked by https://www.jsonschemavalidator.net/
                    return isRoot ? "#/definitions/" + className : className;
                };
                JsonMetadata.prototype.generateChemaClass = function(className, schemaDef, isRoot) {
                    if (!!schemaDef[className]) return;
                    var classInfo = this.findClass(className);
                    if (!classInfo) return;
                    var hasParent = !!classInfo.parentName && classInfo.parentName != "base";
                    if (hasParent) this.generateChemaClass(classInfo.parentName, schemaDef, isRoot);
                    var res = {
                        type: "object",
                        $id: className
                    };
                    schemaDef[className] = res;
                    var chemaProps = {
                        properties: {}
                    };
                    this.generateSchemaProperties(classInfo, chemaProps, schemaDef, isRoot);
                    if (hasParent) res.allOf = [
                        {
                            $ref: this.getChemeRefName(classInfo.parentName, isRoot)
                        },
                        {
                            properties: chemaProps.properties
                        }
                    ];
                    else res.properties = chemaProps.properties;
                    if (Array.isArray(chemaProps.required)) res.required = chemaProps.required;
                };
                JsonMetadata.prototype.getChoicesValues = function(enumRes) {
                    var res = new Array();
                    enumRes.forEach(function(item) {
                        if (typeof item === "object" && item.value !== undefined) res.push(item.value);
                        else res.push(item);
                    });
                    return res;
                };
                return JsonMetadata;
            }();
            var JsonError = /** @class */ function() {
                function JsonError(type, message) {
                    this.type = type;
                    this.message = message;
                    this.description = "";
                    this.at = -1;
                    this.end = -1;
                }
                JsonError.prototype.getFullDescription = function() {
                    return this.message + (this.description ? "\n" + this.description : "");
                };
                return JsonError;
            }();
            var JsonUnknownPropertyError = /** @class */ function(_super) {
                __extends(JsonUnknownPropertyError, _super);
                function JsonUnknownPropertyError(propertyName, className) {
                    var _this = _super.call(this, "unknownproperty", "Unknown property in class '" + className + "': '" + propertyName + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.className = className;
                    return _this;
                }
                return JsonUnknownPropertyError;
            }(JsonError);
            var JsonMissingTypeErrorBase = /** @class */ function(_super) {
                __extends(JsonMissingTypeErrorBase, _super);
                function JsonMissingTypeErrorBase(baseClassName, type, message) {
                    var _this = _super.call(this, type, message) || this;
                    _this.baseClassName = baseClassName;
                    _this.type = type;
                    _this.message = message;
                    return _this;
                }
                return JsonMissingTypeErrorBase;
            }(JsonError);
            var JsonMissingTypeError = /** @class */ function(_super) {
                __extends(JsonMissingTypeError, _super);
                function JsonMissingTypeError(propertyName, baseClassName) {
                    var _this = _super.call(this, baseClassName, "missingtypeproperty", "The property type is missing in the object. Please take a look at property: '" + propertyName + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.baseClassName = baseClassName;
                    return _this;
                }
                return JsonMissingTypeError;
            }(JsonMissingTypeErrorBase);
            var JsonIncorrectTypeError = /** @class */ function(_super) {
                __extends(JsonIncorrectTypeError, _super);
                function JsonIncorrectTypeError(propertyName, baseClassName) {
                    var _this = _super.call(this, baseClassName, "incorrecttypeproperty", "The property type is incorrect in the object. Please take a look at property: '" + propertyName + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.baseClassName = baseClassName;
                    return _this;
                }
                return JsonIncorrectTypeError;
            }(JsonMissingTypeErrorBase);
            var JsonRequiredPropertyError = /** @class */ function(_super) {
                __extends(JsonRequiredPropertyError, _super);
                function JsonRequiredPropertyError(propertyName, className) {
                    var _this = _super.call(this, "requiredproperty", "The property '" + propertyName + "' is required in class '" + className + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.className = className;
                    return _this;
                }
                return JsonRequiredPropertyError;
            }(JsonError);
            var JsonRequiredArrayPropertyError = /** @class */ function(_super) {
                __extends(JsonRequiredArrayPropertyError, _super);
                function JsonRequiredArrayPropertyError(propertyName, className) {
                    var _this = _super.call(this, "arrayproperty", "The property '" + propertyName + "' should be an array in '" + className + "'.") || this;
                    _this.propertyName = propertyName;
                    _this.className = className;
                    return _this;
                }
                return JsonRequiredArrayPropertyError;
            }(JsonError);
            var JsonIncorrectPropertyValueError = /** @class */ function(_super) {
                __extends(JsonIncorrectPropertyValueError, _super);
                function JsonIncorrectPropertyValueError(property, value) {
                    var _this = _super.call(this, "incorrectvalue", "The property value: '" + value + "' is incorrect for property '" + property.name + "'.") || this;
                    _this.property = property;
                    _this.value = value;
                    return _this;
                }
                return JsonIncorrectPropertyValueError;
            }(JsonError);
            var JsonObject = /** @class */ function() {
                function JsonObject() {
                    this.errors = new Array();
                    this.lightSerializing = false;
                }
                Object.defineProperty(JsonObject, "metaData", {
                    get: function() {
                        return JsonObject.metaDataValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                JsonObject.prototype.toJsonObject = function(obj, options) {
                    return this.toJsonObjectCore(obj, null, options);
                };
                JsonObject.prototype.toObject = function(jsonObj, obj, options) {
                    this.toObjectCore(jsonObj, obj, options);
                    var error = this.getRequiredError(obj, jsonObj);
                    if (!!error) this.addNewError(error, jsonObj, obj);
                };
                JsonObject.prototype.toObjectCore = function(jsonObj, obj, options) {
                    if (!jsonObj) return;
                    var properties = null;
                    var objType = undefined;
                    var needAddErrors = true;
                    if (obj.getType) {
                        objType = obj.getType();
                        properties = Serializer.getProperties(objType);
                        needAddErrors = !!objType && !Serializer.isDescendantOf(objType, "itemvalue");
                    }
                    if (!properties) return;
                    if (obj.startLoadingFromJson) obj.startLoadingFromJson(jsonObj);
                    properties = this.addDynamicProperties(obj, jsonObj, properties);
                    this.options = options;
                    for(var key in jsonObj){
                        if (key === JsonObject.typePropertyName) continue;
                        if (key === JsonObject.positionPropertyName) {
                            obj[key] = jsonObj[key];
                            continue;
                        }
                        var property = this.findProperty(properties, key);
                        if (!property) {
                            if (needAddErrors) this.addNewError(new JsonUnknownPropertyError(key.toString(), objType), jsonObj, obj);
                            continue;
                        }
                        this.valueToObj(jsonObj[key], obj, property, jsonObj, options);
                    }
                    this.options = undefined;
                    if (obj.endLoadingFromJson) obj.endLoadingFromJson();
                };
                JsonObject.prototype.toJsonObjectCore = function(obj, property, options) {
                    if (!obj || !obj.getType) return obj;
                    if (typeof obj.getData === "function") return obj.getData();
                    var result = {};
                    if (property != null && !property.className) result[JsonObject.typePropertyName] = property.getObjType(obj.getType());
                    var storeDefaults = options === true;
                    if (!options || options === true) options = {};
                    if (storeDefaults) options.storeDefaults = storeDefaults;
                    this.propertiesToJson(obj, Serializer.getProperties(obj.getType()), result, options);
                    this.propertiesToJson(obj, this.getDynamicProperties(obj), result, options);
                    return result;
                };
                JsonObject.prototype.getDynamicProperties = function(obj) {
                    return Serializer.getDynamicPropertiesByObj(obj);
                };
                JsonObject.prototype.addDynamicProperties = function(obj, jsonObj, props) {
                    if (!obj.getDynamicPropertyName && !obj.getDynamicProperties) return props;
                    if (obj.getDynamicPropertyName) {
                        var dynamicPropName = obj.getDynamicPropertyName();
                        if (!dynamicPropName) return props;
                        if (dynamicPropName && jsonObj[dynamicPropName]) obj[dynamicPropName] = jsonObj[dynamicPropName];
                    }
                    var dynamicProps = this.getDynamicProperties(obj);
                    return dynamicProps.length === 0 ? props : [].concat(props).concat(dynamicProps);
                };
                JsonObject.prototype.propertiesToJson = function(obj, properties, json, options) {
                    for(var i = 0; i < properties.length; i++)this.valueToJson(obj, json, properties[i], options);
                };
                JsonObject.prototype.valueToJson = function(obj, result, prop, options) {
                    if (!options) options = {};
                    if (prop.isSerializable === false || prop.isLightSerializable === false && this.lightSerializing) return;
                    if (options.version && !prop.isAvailableInVersion(options.version)) return;
                    this.valueToJsonCore(obj, result, prop, options);
                };
                JsonObject.prototype.valueToJsonCore = function(obj, result, prop, options) {
                    var serProp = prop.getSerializedProperty(obj, options.version);
                    if (serProp && serProp !== prop) {
                        this.valueToJsonCore(obj, result, serProp, options);
                        return;
                    }
                    var value = prop.getSerializableValue(obj);
                    if (!options.storeDefaults && prop.isDefaultValueByObj(obj, value)) return;
                    if (this.isValueArray(value)) {
                        var arrValue = [];
                        for(var i = 0; i < value.length; i++)arrValue.push(this.toJsonObjectCore(value[i], prop, options));
                        value = arrValue.length > 0 ? arrValue : null;
                    } else value = this.toJsonObjectCore(value, prop, options);
                    if (value === undefined || value === null) return;
                    var name = prop.getSerializedName(options.version);
                    var hasValue = typeof obj["getPropertyValue"] === "function" && obj["getPropertyValue"](name, null) !== null;
                    if (options.storeDefaults && hasValue || !prop.isDefaultValueByObj(obj, value)) {
                        if (!Serializer.onSerializingProperty || !Serializer.onSerializingProperty(obj, prop, value, result)) result[name] = this.removePosOnValueToJson(prop, value);
                    }
                };
                JsonObject.prototype.valueToObj = function(value, obj, property, jsonObj, options) {
                    if (value === null || value === undefined) return;
                    this.removePos(property, value);
                    if (property != null && property.hasToUseSetValue) {
                        property.setValue(obj, value, this);
                        return;
                    }
                    if (property.isArray && !Array.isArray(value) && !!value) {
                        value = [
                            value
                        ];
                        var propName = !!jsonObj && property.alternativeName && !!jsonObj[property.alternativeName] ? property.alternativeName : property.name;
                        this.addNewError(new JsonRequiredArrayPropertyError(propName, obj.getType()), !!jsonObj ? jsonObj : value, obj);
                    }
                    if (this.isValueArray(value)) {
                        this.valueToArray(value, obj, property.name, property, options);
                        return;
                    }
                    var newObj = this.createNewObj(value, property);
                    if (newObj.newObj) {
                        this.toObjectCore(value, newObj.newObj, options);
                        value = newObj.newObj;
                    }
                    if (!newObj.error) {
                        if (property != null) {
                            property.setValue(obj, value, this);
                            if (!!options && options.validatePropertyValues) {
                                if (!property.validateValue(value)) this.addNewError(new JsonIncorrectPropertyValueError(property, value), jsonObj, obj);
                            }
                        } else obj[property.name] = value;
                    }
                };
                JsonObject.prototype.removePosOnValueToJson = function(property, value) {
                    if (!property.isCustom || !value) return value;
                    this.removePosFromObj(value);
                    return value;
                };
                JsonObject.prototype.removePos = function(property, value) {
                    if (!property || !property.type || property.type.indexOf("value") < 0) return;
                    this.removePosFromObj(value);
                };
                JsonObject.prototype.removePosFromObj = function(obj) {
                    if (!obj) return;
                    if (Array.isArray(obj)) for(var i = 0; i < obj.length; i++)this.removePosFromObj(obj[i]);
                    if (typeof obj !== "object") return;
                    if (!!obj[JsonObject.positionPropertyName]) delete obj[JsonObject.positionPropertyName];
                    for(var key in obj)this.removePosFromObj(obj[key]);
                };
                JsonObject.prototype.isValueArray = function(value) {
                    return value && Array.isArray(value);
                };
                JsonObject.prototype.createNewObj = function(value, property) {
                    var result = {
                        newObj: null,
                        error: null
                    };
                    var className = this.getClassNameForNewObj(value, property);
                    result.newObj = className ? Serializer.createClass(className, value) : null;
                    result.error = this.checkNewObjectOnErrors(result.newObj, value, property, className);
                    return result;
                };
                JsonObject.prototype.getClassNameForNewObj = function(value, property) {
                    var res = property != null && property.className ? property.className : undefined;
                    if (!res) res = value[JsonObject.typePropertyName];
                    if (!res) return res;
                    res = res.toLowerCase();
                    var classNamePart = property.classNamePart;
                    if (classNamePart && res.indexOf(classNamePart) < 0) res += classNamePart;
                    return res;
                };
                JsonObject.prototype.checkNewObjectOnErrors = function(newObj, value, property, className) {
                    var error = null;
                    if (newObj) error = this.getRequiredError(newObj, value);
                    else if (property.baseClassName) {
                        if (!className) error = new JsonMissingTypeError(property.name, property.baseClassName);
                        else error = new JsonIncorrectTypeError(property.name, property.baseClassName);
                    }
                    if (error) this.addNewError(error, value, newObj);
                    return error;
                };
                JsonObject.prototype.getRequiredError = function(obj, jsonValue) {
                    if (!obj.getType || typeof obj.getData === "function") return null;
                    var metaClass = Serializer.findClass(obj.getType());
                    if (!metaClass) return null;
                    var props = metaClass.getRequiredProperties();
                    if (!Array.isArray(props)) return null;
                    for(var i = 0; i < props.length; i++){
                        var prop = props[i];
                        if (!_helpers__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isValueEmpty(prop.defaultValue)) continue;
                        if (!jsonValue[prop.name]) return new JsonRequiredPropertyError(prop.name, obj.getType());
                    }
                    return null;
                };
                JsonObject.prototype.addNewError = function(error, jsonObj, element) {
                    error.jsonObj = jsonObj;
                    error.element = element;
                    this.errors.push(error);
                    if (!jsonObj) return;
                    var posObj = jsonObj[JsonObject.positionPropertyName];
                    if (!posObj) return;
                    error.at = posObj.start;
                    error.end = posObj.end;
                };
                JsonObject.prototype.valueToArray = function(value, obj, key, property, options) {
                    if (obj[key] && !this.isValueArray(obj[key])) return;
                    if (obj[key] && value.length > 0) obj[key].splice(0, obj[key].length);
                    var valueRes = obj[key] ? obj[key] : [];
                    this.addValuesIntoArray(value, valueRes, property, options);
                    if (!obj[key]) obj[key] = valueRes;
                };
                JsonObject.prototype.addValuesIntoArray = function(value, result, property, options) {
                    for(var i = 0; i < value.length; i++){
                        var newValue = this.createNewObj(value[i], property);
                        if (newValue.newObj) {
                            if (!!value[i].name) newValue.newObj.name = value[i].name;
                            if (!!value[i].valueName) newValue.newObj.valueName = value[i].valueName.toString();
                            result.push(newValue.newObj);
                            this.toObjectCore(value[i], newValue.newObj, options);
                        } else if (!newValue.error) result.push(value[i]);
                    }
                };
                JsonObject.prototype.findProperty = function(properties, key) {
                    if (!properties) return null;
                    for(var i = 0; i < properties.length; i++){
                        var prop = properties[i];
                        if (prop.name == key || prop.alternativeName == key) return prop;
                    }
                    return null;
                };
                JsonObject.typePropertyName = "type";
                JsonObject.positionPropertyName = "pos";
                JsonObject.metaDataValue = new JsonMetadata();
                return JsonObject;
            }();
            /**
 * An alias for the metadata object. It contains object properties' runtime information and allows you to modify it.
 * @see JsonMetadata
 */ var Serializer = JsonObject.metaData;
        /***/ },
        /***/ "./src/list.ts": /*!*********************!*\
  !*** ./src/list.ts ***!
  \*********************/ /*! exports provided: defaultListCss, ListModel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "defaultListCss", function() {
                return defaultListCss;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListModel", function() {
                return ListModel;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            /* harmony import */ var _actions_action__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./actions/action */ "./src/actions/action.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _element_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./element-helper */ "./src/element-helper.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var defaultListCss = {
                root: "sv-list__container",
                item: "sv-list__item",
                searchClearButtonIcon: "sv-list__filter-clear-button",
                loadingIndicator: "sv-list__loading-indicator",
                itemSelected: "sv-list__item--selected",
                itemWithIcon: "sv-list__item--with-icon",
                itemDisabled: "sv-list__item--disabled",
                itemFocused: "sv-list__item--focused",
                itemTextWrap: "sv-list__item-text--wrap",
                itemIcon: "sv-list__item-icon",
                itemSeparator: "sv-list__item-separator",
                itemBody: "sv-list__item-body",
                itemsContainer: "sv-list",
                itemsContainerFiltering: "sv-list--filtering",
                filter: "sv-list__filter",
                filterIcon: "sv-list__filter-icon",
                filterInput: "sv-list__input",
                emptyContainer: "sv-list__empty-container",
                emptyText: "sv-list__empty-text"
            };
            var ListModel = /** @class */ function(_super) {
                __extends(ListModel, _super);
                function ListModel(items, onSelectionChanged, allowSelection, selectedItem, onFilterStringChangedCallback, elementId) {
                    var _this = _super.call(this) || this;
                    _this.onSelectionChanged = onSelectionChanged;
                    _this.allowSelection = allowSelection;
                    _this.onFilterStringChangedCallback = onFilterStringChangedCallback;
                    _this.elementId = elementId;
                    _this.onItemClick = function(itemValue) {
                        if (_this.isItemDisabled(itemValue)) return;
                        _this.isExpanded = false;
                        if (_this.allowSelection) _this.selectedItem = itemValue;
                        if (!!_this.onSelectionChanged) _this.onSelectionChanged(itemValue);
                    };
                    _this.isItemDisabled = function(itemValue) {
                        return itemValue.enabled !== undefined && !itemValue.enabled;
                    };
                    _this.isItemSelected = function(itemValue) {
                        return _this.areSameItems(_this.selectedItem, itemValue);
                    };
                    _this.isItemFocused = function(itemValue) {
                        return _this.areSameItems(_this.focusedItem, itemValue);
                    };
                    _this.getListClass = function() {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(_this.cssClasses.itemsContainer).append(_this.cssClasses.itemsContainerFiltering, !!_this.filterString && _this.visibleActions.length !== _this.visibleItems.length).toString();
                    };
                    _this.getItemClass = function(itemValue) {
                        return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_3__["CssClassBuilder"]().append(_this.cssClasses.item).append(_this.cssClasses.itemWithIcon, !!itemValue.iconName).append(_this.cssClasses.itemDisabled, _this.isItemDisabled(itemValue)).append(_this.cssClasses.itemFocused, _this.isItemFocused(itemValue)).append(_this.cssClasses.itemSelected, _this.isItemSelected(itemValue)).append(_this.cssClasses.itemTextWrap, _this.textWrapEnabled).append(itemValue.css).toString();
                    };
                    _this.getItemIndent = function(itemValue) {
                        var level = itemValue.level || 0;
                        return (level + 1) * ListModel.INDENT + "px";
                    };
                    _this.setItems(items);
                    _this.selectedItem = selectedItem;
                    return _this;
                }
                ListModel.prototype.hasText = function(item, filterStringInLow) {
                    if (!filterStringInLow) return true;
                    var text = item.title || "";
                    if (this.onTextSearchCallback) return this.onTextSearchCallback(item, filterStringInLow);
                    var textInLow = text.toLocaleLowerCase();
                    textInLow = _settings__WEBPACK_IMPORTED_MODULE_6__["settings"].comparator.normalizeTextCallback(textInLow, "filter");
                    return textInLow.indexOf(filterStringInLow.toLocaleLowerCase()) > -1;
                };
                ListModel.prototype.isItemVisible = function(item) {
                    return item.visible && (!this.shouldProcessFilter || this.hasText(item, this.filterString));
                };
                Object.defineProperty(ListModel.prototype, "visibleItems", {
                    get: function() {
                        var _this = this;
                        return this.visibleActions.filter(function(item) {
                            return _this.isItemVisible(item);
                        });
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "shouldProcessFilter", {
                    get: function() {
                        return !this.onFilterStringChangedCallback;
                    },
                    enumerable: false,
                    configurable: true
                });
                ListModel.prototype.onFilterStringChanged = function(text) {
                    var _this = this;
                    if (!!this.onFilterStringChangedCallback) this.onFilterStringChangedCallback(text);
                    this.isEmpty = this.renderedActions.filter(function(action) {
                        return _this.isItemVisible(action);
                    }).length === 0;
                };
                ListModel.prototype.scrollToItem = function(selector, ms) {
                    var _this = this;
                    if (ms === void 0) ms = 0;
                    setTimeout(function() {
                        if (!_this.listContainerHtmlElement) return;
                        var item = _this.listContainerHtmlElement.querySelector("." + selector);
                        if (item) setTimeout(function() {
                            item.scrollIntoView({
                                behavior: "smooth",
                                block: "nearest",
                                inline: "start"
                            });
                        }, ms);
                    }, ms);
                };
                ListModel.prototype.setOnFilterStringChangedCallback = function(callback) {
                    this.onFilterStringChangedCallback = callback;
                };
                ListModel.prototype.setOnTextSearchCallback = function(callback) {
                    this.onTextSearchCallback = callback;
                };
                ListModel.prototype.setItems = function(items, sortByVisibleIndex) {
                    var _this = this;
                    if (sortByVisibleIndex === void 0) sortByVisibleIndex = true;
                    _super.prototype.setItems.call(this, items, sortByVisibleIndex);
                    if (this.elementId) this.renderedActions.forEach(function(action) {
                        action.elementId = _this.elementId + action.id;
                    });
                    if (!this.isAllDataLoaded && !!this.actions.length) this.actions.push(this.loadingIndicator);
                };
                ListModel.prototype.onSet = function() {
                    this.showFilter = this.searchEnabled && (this.forceShowFilter || (this.actions || []).length > ListModel.MINELEMENTCOUNT);
                    _super.prototype.onSet.call(this);
                };
                ListModel.prototype.getDefaultCssClasses = function() {
                    return defaultListCss;
                };
                ListModel.prototype.areSameItems = function(item1, item2) {
                    if (!!this.areSameItemsCallback) return this.areSameItemsCallback(item1, item2);
                    return !!item1 && !!item2 && item1.id == item2.id;
                };
                Object.defineProperty(ListModel.prototype, "filterStringPlaceholder", {
                    get: function() {
                        return this.getLocalizationString("filterStringPlaceholder");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "emptyMessage", {
                    get: function() {
                        return this.isAllDataLoaded ? this.getLocalizationString("emptyMessage") : this.loadingText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "scrollableContainer", {
                    get: function() {
                        return this.listContainerHtmlElement.querySelector("." + this.getDefaultCssClasses().itemsContainer);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "loadingText", {
                    get: function() {
                        return this.getLocalizationString("loadingFile");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListModel.prototype, "loadingIndicator", {
                    get: function() {
                        if (!this.loadingIndicatorValue) this.loadingIndicatorValue = new _actions_action__WEBPACK_IMPORTED_MODULE_2__["Action"]({
                            id: "loadingIndicator",
                            title: this.loadingText,
                            action: function() {},
                            css: this.cssClasses.loadingIndicator
                        });
                        return this.loadingIndicatorValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                ListModel.prototype.goToItems = function(event) {
                    if (event.key === "ArrowDown" || event.keyCode === 40) {
                        var currentElement = event.target.parentElement;
                        var listElement = currentElement.parentElement.querySelector("ul");
                        var firstChild = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_5__["getFirstVisibleChild"])(listElement);
                        if (!!listElement && !!firstChild) {
                            _element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].focusElement(firstChild);
                            event.preventDefault();
                        }
                    }
                };
                ListModel.prototype.onMouseMove = function(event) {
                    this.resetFocusedItem();
                };
                ListModel.prototype.onKeyDown = function(event) {
                    var currentElement = event.target;
                    if (event.key === "ArrowDown" || event.keyCode === 40) {
                        _element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].focusElement(_element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].getNextElementPreorder(currentElement));
                        event.preventDefault();
                    } else if (event.key === "ArrowUp" || event.keyCode === 38) {
                        _element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].focusElement(_element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].getNextElementPostorder(currentElement));
                        event.preventDefault();
                    }
                };
                ListModel.prototype.onPointerDown = function(event, item) {};
                ListModel.prototype.refresh = function() {
                    this.filterString = "";
                    this.resetFocusedItem();
                };
                ListModel.prototype.onClickSearchClearButton = function(event) {
                    event.currentTarget.parentElement.querySelector("input").focus();
                    this.refresh();
                };
                ListModel.prototype.resetFocusedItem = function() {
                    this.focusedItem = undefined;
                };
                ListModel.prototype.focusFirstVisibleItem = function() {
                    this.focusedItem = this.visibleItems[0];
                };
                ListModel.prototype.focusLastVisibleItem = function() {
                    this.focusedItem = this.visibleItems[this.visibleItems.length - 1];
                };
                ListModel.prototype.initFocusedItem = function() {
                    var _this = this;
                    this.focusedItem = this.visibleItems.filter(function(item) {
                        return item.visible && _this.isItemSelected(item);
                    })[0];
                    if (!this.focusedItem) this.focusFirstVisibleItem();
                };
                ListModel.prototype.focusNextVisibleItem = function() {
                    if (!this.focusedItem) this.initFocusedItem();
                    else {
                        var items = this.visibleItems;
                        var currentFocusedItemIndex = items.indexOf(this.focusedItem);
                        var nextItem = items[currentFocusedItemIndex + 1];
                        if (nextItem) this.focusedItem = nextItem;
                        else this.focusFirstVisibleItem();
                    }
                };
                ListModel.prototype.focusPrevVisibleItem = function() {
                    if (!this.focusedItem) this.initFocusedItem();
                    else {
                        var items = this.visibleItems;
                        var currentFocusedItemIndex = items.indexOf(this.focusedItem);
                        var prevItem = items[currentFocusedItemIndex - 1];
                        if (prevItem) this.focusedItem = prevItem;
                        else this.focusLastVisibleItem();
                    }
                };
                ListModel.prototype.selectFocusedItem = function() {
                    !!this.focusedItem && this.onItemClick(this.focusedItem);
                };
                ListModel.prototype.initListContainerHtmlElement = function(htmlElement) {
                    this.listContainerHtmlElement = htmlElement;
                };
                ListModel.prototype.onLastItemRended = function(item) {
                    if (this.isAllDataLoaded) return;
                    if (item === this.actions[this.actions.length - 1] && !!this.listContainerHtmlElement) this.hasVerticalScroller = _element_helper__WEBPACK_IMPORTED_MODULE_4__["ElementHelper"].hasVerticalScroller(this.scrollableContainer);
                };
                ListModel.prototype.scrollToFocusedItem = function() {
                    this.scrollToItem(this.getDefaultCssClasses().itemFocused);
                };
                ListModel.prototype.scrollToSelectedItem = function() {
                    this.scrollToItem(this.getDefaultCssClasses().itemSelected, 110);
                };
                ListModel.prototype.addScrollEventListener = function(handler) {
                    if (!!handler) this.scrollHandler = handler;
                    if (!!this.scrollHandler) this.scrollableContainer.addEventListener("scroll", this.scrollHandler);
                };
                ListModel.prototype.removeScrollEventListener = function() {
                    if (!!this.scrollHandler) this.scrollableContainer.removeEventListener("scroll", this.scrollHandler);
                };
                ListModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (!!this.loadingIndicatorValue) this.loadingIndicatorValue.dispose();
                    this.listContainerHtmlElement = undefined;
                };
                ListModel.INDENT = 16;
                ListModel.MINELEMENTCOUNT = 10;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true,
                        onSet: function(newValue, target) {
                            target.onSet();
                        }
                    })
                ], ListModel.prototype, "searchEnabled", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "showFilter", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "forceShowFilter", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "isExpanded", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({})
                ], ListModel.prototype, "selectedItem", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], ListModel.prototype, "focusedItem", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        onSet: function(_, target) {
                            target.onFilterStringChanged(target.filterString);
                        }
                    })
                ], ListModel.prototype, "filterString", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "hasVerticalScroller", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], ListModel.prototype, "isAllDataLoaded", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "showSearchClearButton", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], ListModel.prototype, "renderElements", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], ListModel.prototype, "textWrapEnabled", void 0);
                return ListModel;
            }(_actions_container__WEBPACK_IMPORTED_MODULE_1__["ActionContainer"]);
        /***/ },
        /***/ "./src/localizablestring.ts": /*!**********************************!*\
  !*** ./src/localizablestring.ts ***!
  \**********************************/ /*! exports provided: LocalizableString, LocalizableStrings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalizableString", function() {
                return LocalizableString;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LocalizableStrings", function() {
                return LocalizableStrings;
            });
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _survey_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./survey-element */ "./src/survey-element.ts");
            /**
 * The class represents the string that supports multi-languages and markdown.
 * It uses in all objects where support for multi-languages and markdown is required.
 */ var LocalizableString = /** @class */ function() {
                function LocalizableString(owner, useMarkdown, name) {
                    if (useMarkdown === void 0) useMarkdown = false;
                    var _a;
                    this.owner = owner;
                    this.useMarkdown = useMarkdown;
                    this.name = name;
                    this.values = {};
                    this.htmlValues = {};
                    this._allowLineBreaks = false;
                    this.onStringChanged = new _base__WEBPACK_IMPORTED_MODULE_3__["EventBase"]();
                    if (owner instanceof _survey_element__WEBPACK_IMPORTED_MODULE_5__["SurveyElementCore"]) this._allowLineBreaks = ((_a = _jsonobject__WEBPACK_IMPORTED_MODULE_4__["Serializer"].findProperty(owner.getType(), name)) === null || _a === void 0 ? void 0 : _a.type) == "text";
                    this.onCreating();
                }
                Object.defineProperty(LocalizableString, "defaultLocale", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                    },
                    set: function(val1) {
                        _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "localizationName", {
                    get: function() {
                        return this._localizationName;
                    },
                    set: function(val1) {
                        if (this._localizationName != val1) {
                            this._localizationName = val1;
                            this.strChanged();
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "allowLineBreaks", {
                    get: function() {
                        return this._allowLineBreaks;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.getIsMultiple = function() {
                    return false;
                };
                Object.defineProperty(LocalizableString.prototype, "locale", {
                    get: function() {
                        if (this.owner && this.owner.getLocale) {
                            var res = this.owner.getLocale();
                            if (!!res || !this.sharedData) return res;
                        }
                        if (!!this.sharedData) return this.sharedData.locale;
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.strChanged = function() {
                    this.searchableText = undefined;
                    if (this.renderedText === undefined) return;
                    this.calculatedTextValue = this.calcText();
                    if (this.renderedText !== this.calculatedTextValue) {
                        this.renderedText = undefined;
                        this.calculatedTextValue = undefined;
                    }
                    this.htmlValues = {};
                    this.onChanged();
                    this.onStringChanged.fire(this, {});
                };
                Object.defineProperty(LocalizableString.prototype, "text", {
                    get: function() {
                        return this.pureText;
                    },
                    set: function(value) {
                        this.setLocaleText(this.locale, value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "calculatedText", {
                    get: function() {
                        this.renderedText = this.calculatedTextValue !== undefined ? this.calculatedTextValue : this.calcText();
                        this.calculatedTextValue = undefined;
                        return this.renderedText;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.calcText = function() {
                    var res = this.pureText;
                    if (res && this.owner && this.owner.getProcessedText && res.indexOf("{") > -1) res = this.owner.getProcessedText(res);
                    if (this.onGetTextCallback) res = this.onGetTextCallback(res);
                    return res;
                };
                Object.defineProperty(LocalizableString.prototype, "pureText", {
                    get: function() {
                        var loc = this.locale;
                        if (!loc) loc = this.defaultLoc;
                        var res = this.getValue(loc);
                        if (this.isValueEmpty(res) && loc === this.defaultLoc) res = this.getValue(_surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].defaultLocale);
                        if (this.isValueEmpty(res)) {
                            var dialect = this.getRootDialect(loc);
                            if (!!dialect) res = this.getValue(dialect);
                        }
                        if (this.isValueEmpty(res) && loc !== this.defaultLoc) res = this.getValue(this.defaultLoc);
                        if (this.isValueEmpty(res) && !!this.getLocalizationName()) {
                            res = this.getLocalizationStr();
                            if (!!this.onGetLocalizationTextCallback) res = this.onGetLocalizationTextCallback(res);
                        }
                        if (!res) res = this.defaultValue || "";
                        return res;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.getRootDialect = function(loc) {
                    if (!loc) return loc;
                    var index = loc.indexOf("-");
                    return index > -1 ? loc.substring(0, index) : "";
                };
                LocalizableString.prototype.getLocalizationName = function() {
                    return !!this.sharedData ? this.sharedData.localizationName : this.localizationName;
                };
                LocalizableString.prototype.getLocalizationStr = function() {
                    var name = this.getLocalizationName();
                    return !!name ? _surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].getString(name, this.locale) : "";
                };
                Object.defineProperty(LocalizableString.prototype, "hasHtml", {
                    get: function() {
                        return this.hasHtmlValue();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "html", {
                    get: function() {
                        if (!this.hasHtml) return "";
                        return this.getHtmlValue();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "isEmpty", {
                    get: function() {
                        return this.getValuesKeys().length == 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "textOrHtml", {
                    get: function() {
                        return this.hasHtml ? this.getHtmlValue() : this.calculatedText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "renderedHtml", {
                    get: function() {
                        return this.textOrHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.getLocaleText = function(loc) {
                    var res = this.getLocaleTextCore(loc);
                    return res ? res : "";
                };
                LocalizableString.prototype.getLocaleTextCore = function(loc) {
                    if (!loc) loc = this.defaultLoc;
                    return this.getValue(loc);
                };
                LocalizableString.prototype.isLocaleTextEqualsWithDefault = function(loc, val1) {
                    var res = this.getLocaleTextCore(loc);
                    if (res === val1) return true;
                    return this.isValueEmpty(res) && this.isValueEmpty(val1);
                };
                LocalizableString.prototype.clear = function() {
                    this.setJson(undefined);
                };
                LocalizableString.prototype.clearLocale = function(loc) {
                    this.setLocaleText(loc, undefined);
                };
                LocalizableString.prototype.setLocaleText = function(loc, value) {
                    loc = this.getValueLoc(loc);
                    if (!this.storeDefaultText && this.isLocaleTextEqualsWithDefault(loc, value)) {
                        if (!this.isValueEmpty(value) || !!loc && loc !== this.defaultLoc) return;
                        var dl = _surveyStrings__WEBPACK_IMPORTED_MODULE_1__["surveyLocalization"].defaultLocale;
                        var oldValue_1 = this.getValue(dl);
                        if (!!dl && !this.isValueEmpty(oldValue_1)) {
                            this.setValue(dl, value);
                            this.fireStrChanged(dl, oldValue_1);
                        }
                        return;
                    }
                    if (!_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.storeDuplicatedTranslations && !this.isValueEmpty(value) && loc && loc != this.defaultLoc && !this.getValue(loc) && value == this.getLocaleText(this.defaultLoc)) return;
                    var curLoc = this.curLocale;
                    if (!loc) loc = this.defaultLoc;
                    var oldValue = this.onStrChanged && loc === curLoc ? this.pureText : undefined;
                    delete this.htmlValues[loc];
                    if (this.isValueEmpty(value)) this.deleteValue(loc);
                    else if (typeof value === "string") {
                        if (this.canRemoveLocValue(loc, value)) this.setLocaleText(loc, null);
                        else {
                            this.setValue(loc, value);
                            if (loc == this.defaultLoc) this.deleteValuesEqualsToDefault(value);
                        }
                    }
                    this.fireStrChanged(loc, oldValue);
                };
                LocalizableString.prototype.isValueEmpty = function(val1) {
                    if (val1 === undefined || val1 === null) return true;
                    if (this.localizationName) return false;
                    return val1 === "";
                };
                Object.defineProperty(LocalizableString.prototype, "curLocale", {
                    get: function() {
                        return !!this.locale ? this.locale : this.defaultLoc;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.canRemoveLocValue = function(loc, val1) {
                    if (_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.storeDuplicatedTranslations) return false;
                    if (loc === this.defaultLoc) return false;
                    var dialect = this.getRootDialect(loc);
                    if (!!dialect) {
                        var dialectVal = this.getLocaleText(dialect);
                        if (!!dialectVal) return dialectVal == val1;
                        return this.canRemoveLocValue(dialect, val1);
                    } else return val1 == this.getLocaleText(this.defaultLoc);
                };
                LocalizableString.prototype.fireStrChanged = function(loc, oldValue) {
                    this.strChanged();
                    if (!this.onStrChanged) return;
                    var value = this.pureText;
                    if (loc !== this.curLocale || oldValue !== value) this.onStrChanged(oldValue, value);
                };
                LocalizableString.prototype.hasNonDefaultText = function() {
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return false;
                    return keys.length > 1 || keys[0] != this.defaultLoc;
                };
                LocalizableString.prototype.getLocales = function() {
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return [];
                    return keys;
                };
                LocalizableString.prototype.getJson = function() {
                    if (!!this.sharedData) return this.sharedData.getJson();
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return null;
                    if (keys.length == 1 && keys[0] == _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName && !_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].serialization.localizableStringSerializeAsObject) return this.values[keys[0]];
                    var res = {};
                    for(var key in this.values)res[key] = this.values[key];
                    return res;
                };
                LocalizableString.prototype.setJson = function(value) {
                    if (!!this.sharedData) {
                        this.sharedData.setJson(value);
                        return;
                    }
                    this.values = {};
                    this.htmlValues = {};
                    if (value === null || value === undefined) return;
                    if (typeof value === "string") this.setLocaleText(null, value);
                    else for(var key in value)this.setLocaleText(key, value[key]);
                    this.strChanged();
                };
                Object.defineProperty(LocalizableString.prototype, "renderAs", {
                    get: function() {
                        if (!this.owner || typeof this.owner.getRenderer !== "function") return LocalizableString.defaultRenderer;
                        return this.owner.getRenderer(this.name) || LocalizableString.defaultRenderer;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableString.prototype, "renderAsData", {
                    get: function() {
                        if (!this.owner || typeof this.owner.getRendererContext !== "function") return this;
                        return this.owner.getRendererContext(this) || this;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.prototype.equals = function(obj) {
                    if (!!this.sharedData) return this.sharedData.equals(obj);
                    if (!obj || !obj.values) return false;
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].isTwoValueEquals(this.values, obj.values, false, true, false);
                };
                LocalizableString.prototype.setFindText = function(text) {
                    if (this.searchText == text) return;
                    this.searchText = text;
                    if (!this.searchableText) {
                        var textOrHtml = this.textOrHtml;
                        this.searchableText = !!textOrHtml ? textOrHtml.toLowerCase() : "";
                    }
                    var str = this.searchableText;
                    var index = !!str && !!text ? str.indexOf(text) : undefined;
                    if (index < 0) index = undefined;
                    if (index != undefined || this.searchIndex != index) {
                        this.searchIndex = index;
                        if (!!this.onSearchChanged) this.onSearchChanged();
                    }
                    return this.searchIndex != undefined;
                };
                LocalizableString.prototype.onChanged = function() {};
                LocalizableString.prototype.onCreating = function() {};
                LocalizableString.prototype.hasHtmlValue = function() {
                    if (!this.owner || !this.useMarkdown) return false;
                    var loc = this.locale;
                    if (!loc) loc = this.defaultLoc;
                    if (this.htmlValues[loc] !== undefined) return !!this.htmlValues[loc];
                    var renderedText = this.calculatedText;
                    if (!renderedText) {
                        this.setHtmlValue(loc, "");
                        return false;
                    }
                    if (!!this.getLocalizationName() && renderedText === this.getLocalizationStr()) {
                        this.setHtmlValue(loc, "");
                        return false;
                    }
                    var res = this.owner.getMarkdownHtml(renderedText, this.name);
                    this.setHtmlValue(loc, res);
                    return !!res;
                };
                LocalizableString.prototype.setHtmlValue = function(loc, val1) {
                    this.htmlValues[loc] = val1;
                };
                LocalizableString.prototype.getHtmlValue = function() {
                    var loc = this.locale;
                    if (!loc) loc = this.defaultLoc;
                    return this.htmlValues[loc];
                };
                LocalizableString.prototype.deleteValuesEqualsToDefault = function(defaultValue) {
                    if (_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.storeDuplicatedTranslations) return;
                    var keys = this.getValuesKeys();
                    for(var i = 0; i < keys.length; i++){
                        if (keys[i] == this.defaultLoc) continue;
                        if (this.getValue(keys[i]) == defaultValue) this.deleteValue(keys[i]);
                    }
                };
                LocalizableString.prototype.getValue = function(loc) {
                    if (!!this.sharedData) return this.sharedData.getValue(loc);
                    return this.values[this.getValueLoc(loc)];
                };
                LocalizableString.prototype.setValue = function(loc, value) {
                    if (!!this.sharedData) this.sharedData.setValue(loc, value);
                    else this.values[this.getValueLoc(loc)] = value;
                };
                LocalizableString.prototype.deleteValue = function(loc) {
                    if (!!this.sharedData) this.sharedData.deleteValue(loc);
                    else delete this.values[this.getValueLoc(loc)];
                };
                LocalizableString.prototype.getValueLoc = function(loc) {
                    if (this.disableLocalization) return _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                    return loc;
                };
                LocalizableString.prototype.getValuesKeys = function() {
                    if (!!this.sharedData) return this.sharedData.getValuesKeys();
                    return Object.keys(this.values);
                };
                Object.defineProperty(LocalizableString.prototype, "defaultLoc", {
                    get: function() {
                        return _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableString.SerializeAsObject = false;
                LocalizableString.defaultRenderer = "sv-string-viewer";
                LocalizableString.editableRenderer = "sv-string-editor";
                return LocalizableString;
            }();
            /**
 * The class represents the list of strings that supports multi-languages.
 */ var LocalizableStrings = /** @class */ function() {
                function LocalizableStrings(owner) {
                    this.owner = owner;
                    this.values = {};
                }
                LocalizableStrings.prototype.getIsMultiple = function() {
                    return true;
                };
                Object.defineProperty(LocalizableStrings.prototype, "locale", {
                    get: function() {
                        return this.owner && this.owner.getLocale ? this.owner.getLocale() : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableStrings.prototype, "value", {
                    get: function() {
                        return this.getValue("");
                    },
                    set: function(val1) {
                        this.setValue("", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(LocalizableStrings.prototype, "text", {
                    get: function() {
                        return Array.isArray(this.value) ? this.value.join("\n") : "";
                    },
                    set: function(val1) {
                        this.value = !!val1 ? val1.split("\n") : [];
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableStrings.prototype.getLocaleText = function(loc) {
                    var res = this.getValueCore(loc, !loc || loc === this.locale);
                    if (!res || !Array.isArray(res) || res.length == 0) return "";
                    return res.join("\n");
                };
                LocalizableStrings.prototype.setLocaleText = function(loc, newValue) {
                    var val1 = !!newValue ? newValue.split("\n") : null;
                    this.setValue(loc, val1);
                };
                LocalizableStrings.prototype.getValue = function(loc) {
                    return this.getValueCore(loc);
                };
                LocalizableStrings.prototype.getValueCore = function(loc, useDefault) {
                    if (useDefault === void 0) useDefault = true;
                    loc = this.getLocale(loc);
                    if (this.values[loc]) return this.values[loc];
                    if (useDefault) {
                        var defLoc = _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                        if (loc !== defLoc && this.values[defLoc]) return this.values[defLoc];
                    }
                    return [];
                };
                LocalizableStrings.prototype.setValue = function(loc, val1) {
                    loc = this.getLocale(loc);
                    var oldValue = _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(this.values);
                    if (!val1 || val1.length == 0) delete this.values[loc];
                    else this.values[loc] = val1;
                    if (!!this.onValueChanged) this.onValueChanged(oldValue, this.values);
                };
                LocalizableStrings.prototype.hasValue = function(loc) {
                    if (loc === void 0) loc = "";
                    return !this.isEmpty && this.getValue(loc).length > 0;
                };
                Object.defineProperty(LocalizableStrings.prototype, "isEmpty", {
                    get: function() {
                        return this.getValuesKeys().length == 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                LocalizableStrings.prototype.getLocale = function(loc) {
                    if (!!loc) return loc;
                    loc = this.locale;
                    return !!loc ? loc : _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName;
                };
                LocalizableStrings.prototype.getLocales = function() {
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return [];
                    return keys;
                };
                LocalizableStrings.prototype.getJson = function() {
                    var keys = this.getValuesKeys();
                    if (keys.length == 0) return null;
                    if (keys.length == 1 && keys[0] == _settings__WEBPACK_IMPORTED_MODULE_2__["settings"].localization.defaultLocaleName && !_settings__WEBPACK_IMPORTED_MODULE_2__["settings"].serialization.localizableStringSerializeAsObject) return this.values[keys[0]];
                    return _helpers__WEBPACK_IMPORTED_MODULE_0__["Helpers"].createCopy(this.values);
                };
                LocalizableStrings.prototype.setJson = function(value) {
                    this.values = {};
                    if (!value) return;
                    if (Array.isArray(value)) this.setValue(null, value);
                    else for(var key in value)this.setValue(key, value[key]);
                };
                LocalizableStrings.prototype.getValuesKeys = function() {
                    return Object.keys(this.values);
                };
                return LocalizableStrings;
            }();
        /***/ },
        /***/ "./src/localization/english.ts": /*!*************************************!*\
  !*** ./src/localization/english.ts ***!
  \*************************************/ /*! exports provided: englishStrings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "englishStrings", function() {
                return englishStrings;
            });
            // Uncomment the line below if you create a custom dictionary
            // import { surveyLocalization } from "survey-core";
            var englishStrings = {
                pagePrevText: "Previous",
                pageNextText: "Next",
                completeText: "Complete",
                previewText: "Preview",
                editText: "Edit",
                startSurveyText: "Start",
                otherItemText: "Other (describe)",
                noneItemText: "None",
                refuseItemText: "Refuse to answer",
                dontKnowItemText: "Don't know",
                selectAllItemText: "Select All",
                progressText: "Page {0} of {1}",
                indexText: "{0} of {1}",
                panelDynamicProgressText: "{0} of {1}",
                panelDynamicTabTextFormat: "Panel {panelIndex}",
                questionsProgressText: "Answered {0}/{1} questions",
                emptySurvey: "The survey doesn't contain any visible elements.",
                completingSurvey: "Thank you for completing the survey",
                completingSurveyBefore: "Our records show that you have already completed this survey.",
                loadingSurvey: "Loading Survey...",
                placeholder: "Select...",
                ratingOptionsCaption: "Select...",
                value: "value",
                requiredError: "Response required.",
                requiredErrorInPanel: "Response required: answer at least one question.",
                requiredInAllRowsError: "Response required: answer questions in all rows.",
                eachRowUniqueError: "Each row must have a unique value.",
                numericError: "The value should be numeric.",
                minError: "The value should not be less than {0}",
                maxError: "The value should not be greater than {0}",
                textMinLength: "Please enter at least {0} character(s).",
                textMaxLength: "Please enter no more than {0} character(s).",
                textMinMaxLength: "Please enter at least {0} and no more than {1} characters.",
                minRowCountError: "Please fill in at least {0} row(s).",
                minSelectError: "Please select at least {0} option(s).",
                maxSelectError: "Please select no more than {0} option(s).",
                numericMinMax: "The '{0}' should be at least {1} and at most {2}",
                numericMin: "The '{0}' should be at least {1}",
                numericMax: "The '{0}' should be at most {1}",
                invalidEmail: "Please enter a valid e-mail address.",
                invalidExpression: "The expression: {0} should return 'true'.",
                urlRequestError: "The request returned error '{0}'. {1}",
                urlGetChoicesError: "The request returned empty data or the 'path' property is incorrect",
                exceedMaxSize: "The file size should not exceed {0}.",
                noUploadFilesHandler: "Files cannot be uploaded. Please add a handler for the 'onUploadFiles' event.",
                otherRequiredError: "Response required: enter another value.",
                uploadingFile: "Your file is uploading. Please wait several seconds and try again.",
                loadingFile: "Loading...",
                chooseFile: "Choose file(s)...",
                noFileChosen: "No file chosen",
                filePlaceholder: "Drag and drop a file here or click the button below to select a file to upload.",
                confirmDelete: "Are you sure you want to delete this record?",
                keyDuplicationError: "This value should be unique.",
                addColumn: "Add Column",
                addRow: "Add Row",
                removeRow: "Remove",
                emptyRowsText: "There are no rows.",
                addPanel: "Add new",
                removePanel: "Remove",
                showDetails: "Show Details",
                hideDetails: "Hide Details",
                choices_Item: "item",
                matrix_column: "Column",
                matrix_row: "Row",
                multipletext_itemname: "text",
                savingData: "The results are being saved on the server...",
                savingDataError: "An error occurred and we could not save the results.",
                savingDataSuccess: "The results were saved successfully!",
                saveAgainButton: "Try again",
                timerMin: "min",
                timerSec: "sec",
                timerSpentAll: "You have spent {0} on this page and {1} in total.",
                timerSpentPage: "You have spent {0} on this page.",
                timerSpentSurvey: "You have spent {0} in total.",
                timerLimitAll: "You have spent {0} of {1} on this page and {2} of {3} in total.",
                timerLimitPage: "You have spent {0} of {1} on this page.",
                timerLimitSurvey: "You have spent {0} of {1} in total.",
                clearCaption: "Clear",
                signaturePlaceHolder: "Sign here",
                chooseFileCaption: "Select File",
                takePhotoCaption: "Take Photo",
                photoPlaceholder: "Click the button below to take a photo using the camera.",
                fileOrPhotoPlaceholder: "Drag and drop or select a file to upload or take a photo using the camera.",
                replaceFileCaption: "Replace file",
                removeFileCaption: "Remove this file",
                booleanCheckedLabel: "Yes",
                booleanUncheckedLabel: "No",
                confirmRemoveFile: "Are you sure that you want to remove this file: {0}?",
                confirmRemoveAllFiles: "Are you sure that you want to remove all files?",
                questionTitlePatternText: "Question Title",
                modalCancelButtonText: "Cancel",
                modalApplyButtonText: "Apply",
                filterStringPlaceholder: "Type to search...",
                emptyMessage: "No data to display",
                noEntriesText: "No entries yet.\nClick the button below to add a new entry.",
                noEntriesReadonlyText: "No entries.",
                more: "More",
                tagboxDoneButtonCaption: "OK",
                selectToRankEmptyRankedAreaText: "All choices are selected for ranking",
                selectToRankEmptyUnrankedAreaText: "Drag choices here to rank them",
                ok: "OK",
                cancel: "Cancel"
            };
        // Uncomment the lines below if you create a custom dictionary.
        // Replace "en" with a custom locale code (for example, "fr" or "de"),
        // Replace `englishStrings` with the name of the variable that contains the custom dictionary.
        // surveyLocalization.locales["en"] = englishStrings;
        // surveyLocalization.localeNames["en"] = "English";
        /***/ },
        /***/ "./src/popup.ts": /*!**********************!*\
  !*** ./src/popup.ts ***!
  \**********************/ /*! exports provided: PopupModel, createDialogOptions */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupModel", function() {
                return PopupModel;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createDialogOptions", function() {
                return createDialogOptions;
            });
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _console_warnings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./console-warnings */ "./src/console-warnings.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            var PopupModel = /** @class */ function(_super) {
                __extends(PopupModel, _super);
                function PopupModel(contentComponentName, contentComponentData, verticalPosition, horizontalPosition, showPointer, isModal, onCancel, onApply, onHide, onShow, cssClass, title, onDispose) {
                    if (verticalPosition === void 0) verticalPosition = "bottom";
                    if (horizontalPosition === void 0) horizontalPosition = "left";
                    if (showPointer === void 0) showPointer = true;
                    if (isModal === void 0) isModal = false;
                    if (onCancel === void 0) onCancel = function() {};
                    if (onApply === void 0) onApply = function() {
                        return true;
                    };
                    if (onHide === void 0) onHide = function() {};
                    if (onShow === void 0) onShow = function() {};
                    if (cssClass === void 0) cssClass = "";
                    if (title === void 0) title = "";
                    if (onDispose === void 0) onDispose = function() {};
                    var _this = _super.call(this) || this;
                    _this.onDispose = onDispose;
                    _this.focusFirstInputSelector = "";
                    _this.onVisibilityChanged = _this.addEvent();
                    _this.onFooterActionsCreated = _this.addEvent();
                    _this.onRecalculatePosition = _this.addEvent();
                    _this.contentComponentName = contentComponentName;
                    _this.contentComponentData = contentComponentData;
                    _this.verticalPosition = verticalPosition;
                    _this.horizontalPosition = horizontalPosition;
                    _this.showPointer = showPointer;
                    _this.isModal = isModal;
                    _this.onCancel = onCancel;
                    _this.onApply = onApply;
                    _this.onHide = onHide;
                    _this.onShow = onShow;
                    _this.cssClass = cssClass;
                    _this.title = title;
                    return _this;
                }
                PopupModel.prototype.refreshInnerModel = function() {
                    var innerModel = this.contentComponentData["model"];
                    innerModel && innerModel.refresh && innerModel.refresh();
                };
                Object.defineProperty(PopupModel.prototype, "isVisible", {
                    get: function() {
                        return this.getPropertyValue("isVisible", false);
                    },
                    set: function(value) {
                        if (this.isVisible === value) return;
                        this.setPropertyValue("isVisible", value);
                        this.onVisibilityChanged.fire(this, {
                            model: this,
                            isVisible: value
                        });
                        if (this.isVisible) this.onShow();
                        else {
                            this.refreshInnerModel();
                            this.onHide();
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupModel.prototype.toggleVisibility = function() {
                    this.isVisible = !this.isVisible;
                };
                PopupModel.prototype.recalculatePosition = function(isResetHeight) {
                    this.onRecalculatePosition.fire(this, {
                        isResetHeight: isResetHeight
                    });
                };
                PopupModel.prototype.updateFooterActions = function(footerActions) {
                    var options = {
                        actions: footerActions
                    };
                    this.onFooterActionsCreated.fire(this, options);
                    return options.actions;
                };
                PopupModel.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    this.onDispose();
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], PopupModel.prototype, "contentComponentName", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])()
                ], PopupModel.prototype, "contentComponentData", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "bottom"
                    })
                ], PopupModel.prototype, "verticalPosition", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "left"
                    })
                ], PopupModel.prototype, "horizontalPosition", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], PopupModel.prototype, "showPointer", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: false
                    })
                ], PopupModel.prototype, "isModal", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: true
                    })
                ], PopupModel.prototype, "isFocusedContent", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: true
                    })
                ], PopupModel.prototype, "isFocusedContainer", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: function() {}
                    })
                ], PopupModel.prototype, "onCancel", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: function() {
                            return true;
                        }
                    })
                ], PopupModel.prototype, "onApply", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: function() {}
                    })
                ], PopupModel.prototype, "onHide", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: function() {}
                    })
                ], PopupModel.prototype, "onShow", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: ""
                    })
                ], PopupModel.prototype, "cssClass", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: ""
                    })
                ], PopupModel.prototype, "title", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "auto"
                    })
                ], PopupModel.prototype, "overlayDisplayMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "popup"
                    })
                ], PopupModel.prototype, "displayMode", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_1__["property"])({
                        defaultValue: "flex"
                    })
                ], PopupModel.prototype, "positionMode", void 0);
                return PopupModel;
            }(_base__WEBPACK_IMPORTED_MODULE_0__["Base"]);
            function createDialogOptions(componentName, data, onApply, onCancel, onHide, onShow, cssClass, title, displayMode) {
                if (onHide === void 0) onHide = function() {};
                if (onShow === void 0) onShow = function() {};
                if (displayMode === void 0) displayMode = "popup";
                _console_warnings__WEBPACK_IMPORTED_MODULE_2__["ConsoleWarnings"].warn("The `showModal()` and `createDialogOptions()` methods are obsolete. Use the `showDialog()` method instead.");
                return {
                    componentName: componentName,
                    data: data,
                    onApply: onApply,
                    onCancel: onCancel,
                    onHide: onHide,
                    onShow: onShow,
                    cssClass: cssClass,
                    title: title,
                    displayMode: displayMode
                };
            }
        /***/ },
        /***/ "./src/react/boolean-checkbox.tsx": /*!****************************************!*\
  !*** ./src/react/boolean-checkbox.tsx ***!
  \****************************************/ /*! exports provided: SurveyQuestionBooleanCheckbox */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBooleanCheckbox", function() {
                return SurveyQuestionBooleanCheckbox;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _boolean__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./boolean */ "./src/react/boolean.tsx");
            /* harmony import */ var _components_title_title_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/title/title-actions */ "./src/react/components/title/title-actions.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionBooleanCheckbox = /** @class */ function(_super) {
                __extends(SurveyQuestionBooleanCheckbox, _super);
                function SurveyQuestionBooleanCheckbox(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionBooleanCheckbox.prototype.renderElement = function() {
                    var cssClasses = this.question.cssClasses;
                    var itemClass = this.question.getCheckboxItemCss();
                    var description = this.question.canRenderLabelDescription ? _reactquestion_element__WEBPACK_IMPORTED_MODULE_5__["SurveyElementBase"].renderQuestionDescription(this.question) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.rootCheckbox
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: itemClass
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("label", {
                        className: cssClasses.checkboxLabel
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        ref: this.checkRef,
                        type: "checkbox",
                        name: this.question.name,
                        value: this.question.booleanValue === null ? "" : this.question.booleanValue,
                        id: this.question.inputId,
                        className: cssClasses.controlCheckbox,
                        disabled: this.isDisplayMode,
                        checked: this.question.booleanValue || false,
                        onChange: this.handleOnChange,
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.checkboxMaterialDecorator
                    }, this.question.svgIcon ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", {
                        className: cssClasses.checkboxItemDecorator
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", {
                        xlinkHref: this.question.svgIcon
                    })) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: "check"
                    })), this.question.isLabelRendered && react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.checkboxControlLabel,
                        id: this.question.labelRenderedAriaID
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_title_title_actions__WEBPACK_IMPORTED_MODULE_4__["TitleActions"], {
                        element: this.question,
                        cssClasses: this.question.cssClasses
                    }))), description));
                };
                return SurveyQuestionBooleanCheckbox;
            }(_boolean__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestionBoolean"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("sv-boolean-checkbox", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionBooleanCheckbox, props);
            });
            survey_core__WEBPACK_IMPORTED_MODULE_1__["RendererFactory"].Instance.registerRenderer("boolean", "checkbox", "sv-boolean-checkbox");
        /***/ },
        /***/ "./src/react/boolean-radio.tsx": /*!*************************************!*\
  !*** ./src/react/boolean-radio.tsx ***!
  \*************************************/ /*! exports provided: SurveyQuestionBooleanRadio */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBooleanRadio", function() {
                return SurveyQuestionBooleanRadio;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _boolean__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./boolean */ "./src/react/boolean.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionBooleanRadio = /** @class */ function(_super) {
                __extends(SurveyQuestionBooleanRadio, _super);
                function SurveyQuestionBooleanRadio(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnChange = function(event) {
                        _this.question.booleanValue = event.nativeEvent.target.value == "true";
                    };
                    return _this;
                }
                SurveyQuestionBooleanRadio.prototype.renderRadioItem = function(value, locText) {
                    var cssClasses = this.question.cssClasses;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        role: "presentation",
                        className: this.question.getRadioItemClass(cssClasses, value)
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("label", {
                        className: cssClasses.radioLabel
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        type: "radio",
                        name: this.question.name,
                        value: value,
                        "aria-errormessage": this.question.ariaErrormessage,
                        checked: value === this.question.booleanValueRendered,
                        disabled: this.question.isInputReadOnly,
                        className: cssClasses.itemRadioControl,
                        onChange: this.handleOnChange
                    }), this.question.cssClasses.materialRadioDecorator ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.materialRadioDecorator
                    }, this.question.itemSvgIcon ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", {
                        className: cssClasses.itemRadioDecorator
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", {
                        xlinkHref: this.question.itemSvgIcon
                    })) : null) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.radioControlLabel
                    }, this.renderLocString(locText))));
                };
                SurveyQuestionBooleanRadio.prototype.renderElement = function() {
                    var cssClasses = this.question.cssClasses;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.rootRadio
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("fieldset", {
                        role: "presentation",
                        className: cssClasses.radioFieldset
                    }, this.renderRadioItem(false, this.question.locLabelFalse), this.renderRadioItem(true, this.question.locLabelTrue)));
                };
                return SurveyQuestionBooleanRadio;
            }(_boolean__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestionBoolean"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("sv-boolean-radio", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionBooleanRadio, props);
            });
            survey_core__WEBPACK_IMPORTED_MODULE_1__["RendererFactory"].Instance.registerRenderer("boolean", "radio", "sv-boolean-radio");
        /***/ },
        /***/ "./src/react/boolean.tsx": /*!*******************************!*\
  !*** ./src/react/boolean.tsx ***!
  \*******************************/ /*! exports provided: SurveyQuestionBoolean */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionBoolean", function() {
                return SurveyQuestionBoolean;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionBoolean = /** @class */ function(_super) {
                __extends(SurveyQuestionBoolean, _super);
                function SurveyQuestionBoolean(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnChange = _this.handleOnChange.bind(_this);
                    _this.handleOnClick = _this.handleOnClick.bind(_this);
                    _this.handleOnLabelClick = _this.handleOnLabelClick.bind(_this);
                    _this.handleOnSwitchClick = _this.handleOnSwitchClick.bind(_this);
                    _this.handleOnKeyDown = _this.handleOnKeyDown.bind(_this);
                    _this.checkRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    return _this;
                }
                SurveyQuestionBoolean.prototype.getStateElement = function() {
                    return this.question;
                };
                Object.defineProperty(SurveyQuestionBoolean.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                /*
    private get allowClick(): boolean {
      return this.question.isIndeterminate && !this.isDisplayMode;
    }
    */ SurveyQuestionBoolean.prototype.doCheck = function(value) {
                    this.question.booleanValue = value;
                };
                SurveyQuestionBoolean.prototype.handleOnChange = function(event) {
                    this.doCheck(event.target.checked);
                };
                SurveyQuestionBoolean.prototype.handleOnClick = function(event) {
                    this.question.onLabelClick(event, true);
                };
                SurveyQuestionBoolean.prototype.handleOnSwitchClick = function(event) {
                    this.question.onSwitchClickModel(event.nativeEvent);
                };
                SurveyQuestionBoolean.prototype.handleOnLabelClick = function(event, value) {
                    this.question.onLabelClick(event, value);
                };
                SurveyQuestionBoolean.prototype.handleOnKeyDown = function(event) {
                    this.question.onKeyDownCore(event);
                };
                SurveyQuestionBoolean.prototype.updateDomElement = function() {
                    if (!this.question) return;
                    var el = this.checkRef.current;
                    if (el) el.indeterminate = this.question.isIndeterminate;
                    this.setControl(el);
                    _super.prototype.updateDomElement.call(this);
                };
                SurveyQuestionBoolean.prototype.renderElement = function() {
                    var _this = this;
                    var cssClasses = this.question.cssClasses;
                    var itemClass = this.question.getItemCss();
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.root,
                        onKeyDown: this.handleOnKeyDown
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("label", {
                        className: itemClass,
                        onClick: this.handleOnClick
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        ref: this.checkRef,
                        type: "checkbox",
                        name: this.question.name,
                        value: this.question.booleanValue === null ? "" : this.question.booleanValue,
                        id: this.question.inputId,
                        className: cssClasses.control,
                        disabled: this.isDisplayMode,
                        checked: this.question.booleanValue || false,
                        onChange: this.handleOnChange,
                        role: this.question.a11y_input_ariaRole,
                        "aria-required": this.question.a11y_input_ariaRequired,
                        "aria-label": this.question.a11y_input_ariaLabel,
                        "aria-labelledby": this.question.a11y_input_ariaLabelledBy,
                        "aria-describedby": this.question.a11y_input_ariaDescribedBy,
                        "aria-invalid": this.question.a11y_input_ariaInvalid,
                        "aria-errormessage": this.question.a11y_input_ariaErrormessage
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.sliderGhost,
                        onClick: function(event) {
                            return _this.handleOnLabelClick(event, _this.question.swapOrder);
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.question.getLabelCss(this.question.swapOrder)
                    }, this.renderLocString(this.question.locLabelLeft))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.switch,
                        onClick: this.handleOnSwitchClick
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.slider
                    }, this.question.isDeterminated && cssClasses.sliderText ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.sliderText
                    }, this.renderLocString(this.question.getCheckedLabel())) : null)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.sliderGhost,
                        onClick: function(event) {
                            return _this.handleOnLabelClick(event, !_this.question.swapOrder);
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.question.getLabelCss(!this.question.swapOrder)
                    }, this.renderLocString(this.question.locLabelRight)))));
                };
                return SurveyQuestionBoolean;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("boolean", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionBoolean, props);
            });
        /***/ },
        /***/ "./src/react/components/action-bar/action-bar-item-dropdown.tsx": /*!**********************************************************************!*\
  !*** ./src/react/components/action-bar/action-bar-item-dropdown.tsx ***!
  \**********************************************************************/ /*! exports provided: SurveyActionBarItemDropdown */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyActionBarItemDropdown", function() {
                return SurveyActionBarItemDropdown;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _popup_popup__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../popup/popup */ "./src/react/components/popup/popup.tsx");
            /* harmony import */ var _action_bar_item__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./action-bar-item */ "./src/react/components/action-bar/action-bar-item.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyActionBarItemDropdown = /** @class */ function(_super) {
                __extends(SurveyActionBarItemDropdown, _super);
                function SurveyActionBarItemDropdown(props) {
                    var _this = _super.call(this, props) || this;
                    _this.viewModel = new survey_core__WEBPACK_IMPORTED_MODULE_1__["ActionDropdownViewModel"](_this.item);
                    return _this;
                }
                SurveyActionBarItemDropdown.prototype.renderInnerButton = function() {
                    var button = _super.prototype.renderInnerButton.call(this);
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, button, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_popup_popup__WEBPACK_IMPORTED_MODULE_3__["Popup"], {
                        model: this.item.popupModel,
                        getTarget: survey_core__WEBPACK_IMPORTED_MODULE_1__["getActionDropdownButtonTarget"]
                    }));
                };
                SurveyActionBarItemDropdown.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.viewModel.dispose();
                };
                return SurveyActionBarItemDropdown;
            }(_action_bar_item__WEBPACK_IMPORTED_MODULE_4__["SurveyActionBarItem"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("sv-action-bar-item-dropdown", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyActionBarItemDropdown, props);
            });
        /***/ },
        /***/ "./src/react/components/action-bar/action-bar-item.tsx": /*!*************************************************************!*\
  !*** ./src/react/components/action-bar/action-bar-item.tsx ***!
  \*************************************************************/ /*! exports provided: SurveyAction, SurveyActionBarItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyAction", function() {
                return SurveyAction;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyActionBarItem", function() {
                return SurveyActionBarItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactSurvey__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../reactSurvey */ "./src/react/reactSurvey.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _action_bar_separator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./action-bar-separator */ "./src/react/components/action-bar/action-bar-separator.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyAction = /** @class */ function(_super) {
                __extends(SurveyAction, _super);
                function SurveyAction() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyAction.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyAction.prototype.getStateElement = function() {
                    return this.item;
                };
                SurveyAction.prototype.renderElement = function() {
                    //refactor
                    var itemClass = this.item.getActionRootCss();
                    var separator = this.item.needSeparator ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_action_bar_separator__WEBPACK_IMPORTED_MODULE_5__["SurveyActionBarSeparator"], null) : null;
                    var itemComponent = _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(this.item.component || "sv-action-bar-item", {
                        item: this.item
                    });
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: itemClass,
                        id: this.item.id
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-action__content"
                    }, separator, itemComponent));
                };
                return SurveyAction;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"]);
            var SurveyActionBarItem = /** @class */ function(_super) {
                __extends(SurveyActionBarItem, _super);
                function SurveyActionBarItem() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyActionBarItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyActionBarItem.prototype.getStateElement = function() {
                    return this.item;
                };
                SurveyActionBarItem.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, this.renderInnerButton());
                };
                SurveyActionBarItem.prototype.renderText = function() {
                    if (!this.item.hasTitle) return null;
                    var titleClass = this.item.getActionBarItemTitleCss();
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: titleClass
                    }, this.item.title);
                };
                SurveyActionBarItem.prototype.renderButtonContent = function() {
                    var text = this.renderText();
                    var svgIcon = !!this.item.iconName ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__["SvgIcon"], {
                        className: this.item.cssClasses.itemIcon,
                        size: this.item.iconSize,
                        iconName: this.item.iconName,
                        title: this.item.tooltip || this.item.title
                    }) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, svgIcon, text);
                };
                SurveyActionBarItem.prototype.renderInnerButton = function() {
                    var _this = this;
                    var className = this.item.getActionBarItemCss();
                    var title = this.item.tooltip || this.item.title;
                    var buttonContent = this.renderButtonContent();
                    var tabIndex = this.item.disableTabStop ? -1 : undefined;
                    var button = Object(_reactSurvey__WEBPACK_IMPORTED_MODULE_3__["attachKey2click"])(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", {
                        className: className,
                        type: "button",
                        disabled: this.item.disabled,
                        onClick: function(args) {
                            return _this.item.action(_this.item, _this.item.getIsTrusted(args));
                        },
                        title: title,
                        tabIndex: tabIndex,
                        "aria-checked": this.item.ariaChecked,
                        "aria-expanded": this.item.ariaExpanded,
                        role: this.item.ariaRole
                    }, buttonContent), this.item, {
                        processEsc: false
                    });
                    return button;
                };
                return SurveyActionBarItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-action-bar-item", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyActionBarItem, props);
            });
        /***/ },
        /***/ "./src/react/components/action-bar/action-bar-separator.tsx": /*!******************************************************************!*\
  !*** ./src/react/components/action-bar/action-bar-separator.tsx ***!
  \******************************************************************/ /*! exports provided: SurveyActionBarSeparator */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyActionBarSeparator", function() {
                return SurveyActionBarSeparator;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyActionBarSeparator = /** @class */ function(_super) {
                __extends(SurveyActionBarSeparator, _super);
                function SurveyActionBarSeparator(props) {
                    return _super.call(this, props) || this;
                }
                SurveyActionBarSeparator.prototype.render = function() {
                    var className = "sv-action-bar-separator " + this.props.cssClasses;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: className
                    });
                };
                return SurveyActionBarSeparator;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-action-bar-separator", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyActionBarSeparator, props);
            });
        /***/ },
        /***/ "./src/react/components/action-bar/action-bar.tsx": /*!********************************************************!*\
  !*** ./src/react/components/action-bar/action-bar.tsx ***!
  \********************************************************/ /*! exports provided: SurveyActionBarItemDropdown, SurveyActionBarSeparator, SurveyActionBar */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyActionBar", function() {
                return SurveyActionBar;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _action_bar_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./action-bar-item */ "./src/react/components/action-bar/action-bar-item.tsx");
            /* harmony import */ var _action_bar_item_dropdown__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./action-bar-item-dropdown */ "./src/react/components/action-bar/action-bar-item-dropdown.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyActionBarItemDropdown", function() {
                return _action_bar_item_dropdown__WEBPACK_IMPORTED_MODULE_4__["SurveyActionBarItemDropdown"];
            });
            /* harmony import */ var _action_bar_separator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./action-bar-separator */ "./src/react/components/action-bar/action-bar-separator.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "SurveyActionBarSeparator", function() {
                return _action_bar_separator__WEBPACK_IMPORTED_MODULE_5__["SurveyActionBarSeparator"];
            });
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyActionBar = /** @class */ function(_super) {
                __extends(SurveyActionBar, _super);
                function SurveyActionBar(props) {
                    var _this = _super.call(this, props) || this;
                    _this.rootRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();
                    return _this;
                }
                Object.defineProperty(SurveyActionBar.prototype, "handleClick", {
                    get: function() {
                        return this.props.handleClick !== undefined ? this.props.handleClick : true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyActionBar.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyActionBar.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    if (!this.model.hasActions) return;
                    var container = this.rootRef.current;
                    if (!!container) this.model.initResponsivityManager(container, function(callback) {
                        setTimeout(callback);
                    });
                };
                SurveyActionBar.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (!!this.model.hasActions) this.model.resetResponsivityManager();
                };
                SurveyActionBar.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    if (prevProps.model == this.props.model) return;
                    if (!!this.model.hasActions) {
                        this.model.resetResponsivityManager();
                        var container = this.rootRef.current;
                        if (!!container) this.model.initResponsivityManager(container, function(callback) {
                            setTimeout(callback);
                        });
                    }
                };
                SurveyActionBar.prototype.getStateElement = function() {
                    return this.model;
                };
                SurveyActionBar.prototype.renderElement = function() {
                    if (!this.model.hasActions) return null;
                    var items = this.renderItems();
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        ref: this.rootRef,
                        className: this.model.getRootCss(),
                        onClick: this.handleClick ? function(event) {
                            event.stopPropagation();
                        } : undefined
                    }, items);
                };
                SurveyActionBar.prototype.renderItems = function() {
                    return this.model.renderedActions.map(function(item, itemIndex) {
                        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_action_bar_item__WEBPACK_IMPORTED_MODULE_3__["SurveyAction"], {
                            item: item,
                            key: "item" + itemIndex
                        });
                    });
                };
                return SurveyActionBar;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-action-bar", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyActionBar, props);
            });
        /***/ },
        /***/ "./src/react/components/brand-info.tsx": /*!*********************************************!*\
  !*** ./src/react/components/brand-info.tsx ***!
  \*********************************************/ /*! exports provided: BrandInfo */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "BrandInfo", function() {
                return BrandInfo;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var BrandInfo = /** @class */ function(_super) {
                __extends(BrandInfo, _super);
                function BrandInfo() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                BrandInfo.prototype.render = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-brand-info"
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("a", {
                        className: "sv-brand-info__logo",
                        href: "https://surveyjs.io/?utm_source=built-in_links&utm_medium=online_survey_tool&utm_campaign=landing_page"
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("img", {
                        src: "https://surveyjs.io/Content/Images/poweredby.svg"
                    })), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-brand-info__text"
                    }, "Try and see how easy it is to ", react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("a", {
                        href: "https://surveyjs.io/create-survey?utm_source=built-in_links&utm_medium=online_survey_tool&utm_campaign=create_survey"
                    }, "create a survey")), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-brand-info__terms"
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("a", {
                        href: "https://surveyjs.io/TermsOfUse"
                    }, "Terms of Use & Privacy Statement")));
                };
                return BrandInfo;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
        /***/ },
        /***/ "./src/react/components/character-counter.tsx": /*!****************************************************!*\
  !*** ./src/react/components/character-counter.tsx ***!
  \****************************************************/ /*! exports provided: CharacterCounterComponent */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CharacterCounterComponent", function() {
                return CharacterCounterComponent;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var CharacterCounterComponent = /** @class */ function(_super) {
                __extends(CharacterCounterComponent, _super);
                function CharacterCounterComponent() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                CharacterCounterComponent.prototype.getStateElement = function() {
                    return this.props.counter;
                };
                CharacterCounterComponent.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.props.remainingCharacterCounter
                    }, this.props.counter.remainingCharacterCounter);
                };
                return CharacterCounterComponent;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-character-counter", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(CharacterCounterComponent, props);
            });
        /***/ },
        /***/ "./src/react/components/components-container.tsx": /*!*******************************************************!*\
  !*** ./src/react/components/components-container.tsx ***!
  \*******************************************************/ /*! exports provided: ComponentsContainer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ComponentsContainer", function() {
                return ComponentsContainer;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ComponentsContainer = /** @class */ function(_super) {
                __extends(ComponentsContainer, _super);
                function ComponentsContainer() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                ComponentsContainer.prototype.render = function() {
                    var _this = this;
                    var components = this.props.survey.getContainerContent(this.props.container);
                    var needRenderWrapper = this.props.needRenderWrapper === false ? false : true;
                    if (components.length == 0) return null;
                    if (!needRenderWrapper) return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, components.map(function(component) {
                        return _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(component.component, {
                            survey: _this.props.survey,
                            model: component.data,
                            container: _this.props.container,
                            key: component.id
                        });
                    }));
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-components-column"
                    }, components.map(function(component) {
                        return _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(component.component, {
                            survey: _this.props.survey,
                            model: component.data,
                            container: _this.props.container,
                            key: component.id
                        });
                    }));
                };
                return ComponentsContainer;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-components-container", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ComponentsContainer, props);
            });
        /***/ },
        /***/ "./src/react/components/file/file-choose-button.tsx": /*!**********************************************************!*\
  !*** ./src/react/components/file/file-choose-button.tsx ***!
  \**********************************************************/ /*! exports provided: SurveyFileChooseButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyFileChooseButton", function() {
                return SurveyFileChooseButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactSurvey__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../reactSurvey */ "./src/react/reactSurvey.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyFileChooseButton = /** @class */ function(_super) {
                __extends(SurveyFileChooseButton, _super);
                function SurveyFileChooseButton(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyFileChooseButton.prototype, "question", {
                    get: function() {
                        return this.props.item && this.props.item.data.question || this.props.data.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyFileChooseButton.prototype.render = function() {
                    var _this = this;
                    return Object(_reactSurvey__WEBPACK_IMPORTED_MODULE_1__["attachKey2click"])(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", {
                        tabIndex: 0,
                        className: this.question.getChooseFileCss(),
                        htmlFor: this.question.inputId,
                        "aria-label": this.question.chooseButtonText,
                        onClick: function(e) {
                            return _this.question.chooseFile(e.nativeEvent);
                        }
                    }, !!this.question.cssClasses.chooseFileIconId ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        title: this.question.chooseButtonText,
                        iconName: this.question.cssClasses.chooseFileIconId,
                        size: "auto"
                    }) : null, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null, this.question.chooseButtonText)));
                };
                return SurveyFileChooseButton;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_4__["ReactElementFactory"].Instance.registerElement("sv-file-choose-btn", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyFileChooseButton, props);
            });
        /***/ },
        /***/ "./src/react/components/file/file-preview.tsx": /*!****************************************************!*\
  !*** ./src/react/components/file/file-preview.tsx ***!
  \****************************************************/ /*! exports provided: SurveyFilePreview */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyFilePreview", function() {
                return SurveyFilePreview;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyFilePreview = /** @class */ function(_super) {
                __extends(SurveyFilePreview, _super);
                function SurveyFilePreview() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyFilePreview.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyFilePreview.prototype.renderFileSign = function(className, val1) {
                    var _this = this;
                    if (!className || !val1.name) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: className
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("a", {
                        href: val1.content,
                        onClick: function(event) {
                            _this.question.doDownloadFile(event, val1);
                        },
                        title: val1.name,
                        download: val1.name,
                        style: {
                            width: this.question.imageWidth
                        }
                    }, val1.name));
                };
                SurveyFilePreview.prototype.renderElement = function() {
                    var _this = this;
                    var previews = this.question.previewValue.map(function(val1, index) {
                        if (!val1) return null;
                        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                            key: _this.question.inputId + "_" + index,
                            className: _this.question.cssClasses.preview,
                            style: {
                                display: _this.question.isPreviewVisible(index) ? undefined : "none"
                            }
                        }, _this.renderFileSign(_this.question.cssClasses.fileSign, val1), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                            className: _this.question.getImageWrapperCss(val1)
                        }, _this.question.canPreviewImage(val1) ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("img", {
                            src: val1.content,
                            style: {
                                height: _this.question.imageHeight,
                                width: _this.question.imageWidth
                            },
                            alt: "File preview"
                        }) : _this.question.cssClasses.defaultImage ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                            iconName: _this.question.cssClasses.defaultImageIconId,
                            size: "auto",
                            className: _this.question.cssClasses.defaultImage
                        }) : null, val1.name && !_this.question.isReadOnly ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                            className: _this.question.getRemoveButtonCss(),
                            onClick: function() {
                                return _this.question.doRemoveFile(val1);
                            }
                        }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                            className: _this.question.cssClasses.removeFile
                        }, _this.question.removeFileCaption), _this.question.cssClasses.removeFileSvgIconId ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                            title: _this.question.removeFileCaption,
                            iconName: _this.question.cssClasses.removeFileSvgIconId,
                            size: "auto",
                            className: _this.question.cssClasses.removeFileSvg
                        }) : null) : null), _this.renderFileSign(_this.question.cssClasses.fileSignBottom, val1));
                    });
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.question.cssClasses.fileList || undefined
                    }, previews);
                };
                SurveyFilePreview.prototype.canRender = function() {
                    return this.question.showPreviewContainer;
                };
                return SurveyFilePreview;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("sv-file-preview", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyFilePreview, props);
            });
        /***/ },
        /***/ "./src/react/components/header.tsx": /*!*****************************************!*\
  !*** ./src/react/components/header.tsx ***!
  \*****************************************/ /*! exports provided: HeaderMobile, HeaderCell, Header */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderMobile", function() {
                return HeaderMobile;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "HeaderCell", function() {
                return HeaderCell;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Header", function() {
                return Header;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _title_title_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./title/title-element */ "./src/react/components/title/title-element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var HeaderMobile = /** @class */ function(_super) {
                __extends(HeaderMobile, _super);
                function HeaderMobile() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(HeaderMobile.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                HeaderMobile.prototype.renderLogoImage = function() {
                    var componentName = this.model.survey.getElementWrapperComponentName(this.model.survey, "logo-image");
                    var componentData = this.model.survey.getElementWrapperComponentData(this.model.survey, "logo-image");
                    return _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.createElement(componentName, {
                        data: componentData
                    });
                };
                HeaderMobile.prototype.render = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-header--mobile"
                    }, this.model.survey.hasLogo ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-header__logo"
                    }, this.renderLogoImage()) : null, this.model.survey.hasTitle ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-header__title",
                        style: {
                            maxWidth: this.model.textAreaWidth
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_title_title_element__WEBPACK_IMPORTED_MODULE_3__["TitleElement"], {
                        element: this.model.survey
                    })) : null, this.model.survey.renderedHasDescription ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-header__description",
                        style: {
                            maxWidth: this.model.textAreaWidth
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.survey.css.description
                    }, _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"].renderLocString(this.model.survey.locDescription))) : null);
                };
                return HeaderMobile;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            var HeaderCell = /** @class */ function(_super) {
                __extends(HeaderCell, _super);
                function HeaderCell() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(HeaderCell.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                HeaderCell.prototype.renderLogoImage = function() {
                    var componentName = this.model.survey.getElementWrapperComponentName(this.model.survey, "logo-image");
                    var componentData = this.model.survey.getElementWrapperComponentData(this.model.survey, "logo-image");
                    return _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.createElement(componentName, {
                        data: componentData
                    });
                };
                HeaderCell.prototype.render = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.css,
                        style: this.model.style
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-header__cell-content",
                        style: this.model.contentStyle
                    }, this.model.showLogo ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-header__logo"
                    }, this.renderLogoImage()) : null, this.model.showTitle ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-header__title",
                        style: {
                            maxWidth: this.model.textAreaWidth
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_title_title_element__WEBPACK_IMPORTED_MODULE_3__["TitleElement"], {
                        element: this.model.survey
                    })) : null, this.model.showDescription ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-header__description",
                        style: {
                            maxWidth: this.model.textAreaWidth
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.survey.css.description
                    }, _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"].renderLocString(this.model.survey.locDescription))) : null));
                };
                return HeaderCell;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            var Header = /** @class */ function(_super) {
                __extends(Header, _super);
                function Header() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(Header.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Header.prototype.getStateElement = function() {
                    return this.model;
                };
                Header.prototype.renderElement = function() {
                    this.model.survey = this.props.survey;
                    if (!(this.props.survey.headerView === "advanced")) return null;
                    var headerContent = null;
                    if (this.props.survey.isMobile) headerContent = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(HeaderMobile, {
                        model: this.model
                    });
                    else headerContent = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.contentClasses,
                        style: {
                            maxWidth: this.model.maxWidth
                        }
                    }, this.model.cells.map(function(cell, index) {
                        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(HeaderCell, {
                            key: index,
                            model: cell
                        });
                    }));
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.headerClasses,
                        style: {
                            height: this.model.renderedHeight
                        }
                    }, this.model.backgroundImage ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        style: this.model.backgroundImageStyle,
                        className: this.model.backgroundImageClasses
                    }) : null, headerContent);
                };
                return Header;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("sv-header", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Header, props);
            });
        /***/ },
        /***/ "./src/react/components/list/list-item.tsx": /*!*************************************************!*\
  !*** ./src/react/components/list/list-item.tsx ***!
  \*************************************************/ /*! exports provided: ListItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ListItem", function() {
                return ListItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactSurvey__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../reactSurvey */ "./src/react/reactSurvey.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ListItem = /** @class */ function(_super) {
                __extends(ListItem, _super);
                function ListItem() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.handleKeydown = function(event) {
                        _this.model.onKeyDown(event);
                    };
                    return _this;
                }
                Object.defineProperty(ListItem.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(ListItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                ListItem.prototype.getStateElement = function() {
                    return this.item;
                };
                ListItem.prototype.render = function() {
                    var _this = this;
                    if (!this.item) return null;
                    var contentWrapStyle = {
                        paddingInlineStart: this.model.getItemIndent(this.item)
                    };
                    var className = this.model.getItemClass(this.item);
                    var content = [];
                    if (!this.item.component) {
                        var text = this.renderLocString(this.item.locTitle, undefined, "locString");
                        if (this.item.iconName) {
                            var icon = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__["SvgIcon"], {
                                key: 1,
                                className: this.model.cssClasses.itemIcon,
                                iconName: this.item.iconName,
                                size: this.item.iconSize,
                                "aria-label": this.item.title
                            });
                            content.push(icon);
                            content.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                                key: 2
                            }, text));
                        } else content.push(text);
                    } else {
                        var newElement = _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(this.item.component, {
                            item: this.item,
                            key: this.item.id
                        });
                        if (!!newElement) content.push(newElement);
                    }
                    var contentWrap = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        style: contentWrapStyle,
                        className: this.model.cssClasses.itemBody,
                        title: this.item.locTitle.calculatedText
                    }, content);
                    var separator = this.item.needSeparator ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.cssClasses.itemSeparator
                    }) : null;
                    var isVisible = this.model.isItemVisible(this.item);
                    var style = {
                        display: isVisible ? null : "none"
                    };
                    return Object(_reactSurvey__WEBPACK_IMPORTED_MODULE_3__["attachKey2click"])(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("li", {
                        className: className,
                        role: "option",
                        style: style,
                        id: this.item.elementId,
                        "aria-selected": this.model.isItemSelected(this.item),
                        onClick: function(event) {
                            _this.model.onItemClick(_this.item);
                            event.stopPropagation();
                        },
                        onPointerDown: function(event) {
                            return _this.model.onPointerDown(event, _this.item);
                        }
                    }, separator, contentWrap));
                };
                ListItem.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.model.onLastItemRended(this.item);
                };
                return ListItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-list-item", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(ListItem, props);
            });
        /***/ },
        /***/ "./src/react/components/list/list.tsx": /*!********************************************!*\
  !*** ./src/react/components/list/list.tsx ***!
  \********************************************/ /*! exports provided: List */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "List", function() {
                return List;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _list_item__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./list-item */ "./src/react/components/list/list-item.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var List = /** @class */ function(_super) {
                __extends(List, _super);
                function List(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleKeydown = function(event) {
                        _this.model.onKeyDown(event);
                    };
                    _this.handleMouseMove = function(event) {
                        _this.model.onMouseMove(event);
                    };
                    _this.state = {
                        filterString: _this.model.filterString || ""
                    };
                    _this.listContainerRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();
                    return _this;
                }
                Object.defineProperty(List.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                List.prototype.getStateElement = function() {
                    return this.model;
                };
                List.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    if (!!this.listContainerRef && !!this.listContainerRef.current) this.model.initListContainerHtmlElement(this.listContainerRef.current);
                };
                List.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (!!this.model) this.model.initListContainerHtmlElement(undefined);
                };
                List.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.cssClasses.root,
                        ref: this.listContainerRef
                    }, this.searchElementContent(), this.emptyContent(), this.renderList());
                };
                List.prototype.renderList = function() {
                    if (!this.model.renderElements) return null;
                    var items = this.renderItems();
                    var ulStyle = {
                        display: this.model.isEmpty ? "none" : null
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("ul", {
                        className: this.model.getListClass(),
                        style: ulStyle,
                        role: "listbox",
                        id: this.model.elementId,
                        onMouseDown: function(e) {
                            e.preventDefault();
                        },
                        onKeyDown: this.handleKeydown,
                        onMouseMove: this.handleMouseMove
                    }, items);
                };
                List.prototype.renderItems = function() {
                    var _this = this;
                    if (!this.model) return null;
                    var items = this.model.renderedActions;
                    if (!items) return null;
                    return items.map(function(item, itemIndex) {
                        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_list_item__WEBPACK_IMPORTED_MODULE_5__["ListItem"], {
                            model: _this.model,
                            item: item,
                            key: "item" + itemIndex
                        });
                    });
                };
                List.prototype.searchElementContent = function() {
                    var _this = this;
                    if (!this.model.showFilter) return null;
                    else {
                        var onChange = function(e) {
                            var root = survey_core__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                            if (e.target === root.activeElement) _this.model.filterString = e.target.value;
                        };
                        var onKeyUp = function(e) {
                            _this.model.goToItems(e);
                        };
                        var clearButton = this.model.showSearchClearButton && !!this.model.filterString ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", {
                            className: this.model.cssClasses.searchClearButtonIcon,
                            onClick: function(event) {
                                _this.model.onClickSearchClearButton(event);
                            }
                        }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__["SvgIcon"], {
                            iconName: "icon-searchclear",
                            size: "auto"
                        })) : null;
                        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                            className: this.model.cssClasses.filter
                        }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                            className: this.model.cssClasses.filterIcon
                        }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__["SvgIcon"], {
                            iconName: "icon-search",
                            size: "auto"
                        })), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", {
                            type: "text",
                            className: this.model.cssClasses.filterInput,
                            "aria-label": this.model.filterStringPlaceholder,
                            placeholder: this.model.filterStringPlaceholder,
                            value: this.state.filterString,
                            onKeyUp: onKeyUp,
                            onChange: onChange
                        }), clearButton);
                    }
                };
                List.prototype.emptyContent = function() {
                    var style = {
                        display: this.model.isEmpty ? null : "none"
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.cssClasses.emptyContainer,
                        style: style
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.model.cssClasses.emptyText,
                        "aria-label": this.model.emptyMessage
                    }, this.model.emptyMessage));
                };
                return List;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("sv-list", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(List, props);
            });
        /***/ },
        /***/ "./src/react/components/loading-indicator.tsx": /*!****************************************************!*\
  !*** ./src/react/components/loading-indicator.tsx ***!
  \****************************************************/ /*! exports provided: LoadingIndicatorComponent */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LoadingIndicatorComponent", function() {
                return LoadingIndicatorComponent;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var LoadingIndicatorComponent = /** @class */ function(_super) {
                __extends(LoadingIndicatorComponent, _super);
                function LoadingIndicatorComponent() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                LoadingIndicatorComponent.prototype.render = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: "sd-loading-indicator"
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_1__["SvgIcon"], {
                        iconName: "icon-loading",
                        size: "auto"
                    }));
                };
                return LoadingIndicatorComponent;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /***/ },
        /***/ "./src/react/components/matrix-actions/detail-button/detail-button.tsx": /*!*****************************************************************************!*\
  !*** ./src/react/components/matrix-actions/detail-button/detail-button.tsx ***!
  \*****************************************************************************/ /*! exports provided: SurveyQuestionMatrixDetailButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDetailButton", function() {
                return SurveyQuestionMatrixDetailButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionMatrixDetailButton = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixDetailButton, _super);
                function SurveyQuestionMatrixDetailButton(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnShowHideClick = _this.handleOnShowHideClick.bind(_this);
                    return _this;
                }
                SurveyQuestionMatrixDetailButton.prototype.getStateElement = function() {
                    return this.props.item;
                };
                Object.defineProperty(SurveyQuestionMatrixDetailButton.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixDetailButton.prototype, "question", {
                    get: function() {
                        return this.props.item.data.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixDetailButton.prototype, "row", {
                    get: function() {
                        return this.props.item.data.row;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixDetailButton.prototype.handleOnShowHideClick = function(event) {
                    this.row.showHideDetailPanelClick();
                };
                SurveyQuestionMatrixDetailButton.prototype.renderElement = function() {
                    var isExpanded = this.row.isDetailPanelShowing;
                    var ariaExpanded = isExpanded;
                    var ariaControls = isExpanded ? this.row.detailPanelId : undefined;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", {
                        type: "button",
                        onClick: this.handleOnShowHideClick,
                        className: this.question.getDetailPanelButtonCss(this.row),
                        "aria-expanded": ariaExpanded,
                        "aria-controls": ariaControls
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        className: this.question.getDetailPanelIconCss(this.row),
                        iconName: this.question.getDetailPanelIconId(this.row),
                        size: "auto"
                    }));
                };
                return SurveyQuestionMatrixDetailButton;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-matrix-detail-button", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyQuestionMatrixDetailButton, props);
            });
        /***/ },
        /***/ "./src/react/components/matrix-actions/drag-drop-icon/drag-drop-icon.tsx": /*!*******************************************************************************!*\
  !*** ./src/react/components/matrix-actions/drag-drop-icon/drag-drop-icon.tsx ***!
  \*******************************************************************************/ /*! exports provided: SurveyQuestionMatrixDynamicDragDropIcon */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicDragDropIcon", function() {
                return SurveyQuestionMatrixDynamicDragDropIcon;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionMatrixDynamicDragDropIcon = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixDynamicDragDropIcon, _super);
                function SurveyQuestionMatrixDynamicDragDropIcon() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyQuestionMatrixDynamicDragDropIcon.prototype, "question", {
                    get: function() {
                        return this.props.item.data.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixDynamicDragDropIcon.prototype.renderElement = function() {
                    if (this.question.iconDragElement) return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", {
                        className: this.question.cssClasses.dragElementDecorator
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("use", {
                        xlinkHref: this.question.iconDragElement
                    }));
                    else return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: this.question.cssClasses.iconDrag
                    });
                };
                return SurveyQuestionMatrixDynamicDragDropIcon;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-matrix-drag-drop-icon", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyQuestionMatrixDynamicDragDropIcon, props);
            });
        /***/ },
        /***/ "./src/react/components/matrix-actions/remove-button/remove-button.tsx": /*!*****************************************************************************!*\
  !*** ./src/react/components/matrix-actions/remove-button/remove-button.tsx ***!
  \*****************************************************************************/ /*! exports provided: SurveyQuestionMatrixDynamicRemoveButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicRemoveButton", function() {
                return SurveyQuestionMatrixDynamicRemoveButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionMatrixDynamicRemoveButton = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixDynamicRemoveButton, _super);
                function SurveyQuestionMatrixDynamicRemoveButton(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnRowRemoveClick = _this.handleOnRowRemoveClick.bind(_this);
                    return _this;
                }
                Object.defineProperty(SurveyQuestionMatrixDynamicRemoveButton.prototype, "question", {
                    get: function() {
                        return this.props.item.data.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixDynamicRemoveButton.prototype, "row", {
                    get: function() {
                        return this.props.item.data.row;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixDynamicRemoveButton.prototype.handleOnRowRemoveClick = function(event) {
                    this.question.removeRowUI(this.row);
                };
                SurveyQuestionMatrixDynamicRemoveButton.prototype.renderElement = function() {
                    var removeRowText = this.renderLocString(this.question.locRemoveRowText);
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", {
                        className: this.question.getRemoveRowButtonCss(),
                        type: "button",
                        onClick: this.handleOnRowRemoveClick,
                        disabled: this.question.isInputReadOnly
                    }, removeRowText, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: this.question.cssClasses.iconRemove
                    }));
                };
                return SurveyQuestionMatrixDynamicRemoveButton;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-matrix-remove-button", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyQuestionMatrixDynamicRemoveButton, props);
            });
        /***/ },
        /***/ "./src/react/components/matrix/row.tsx": /*!*********************************************!*\
  !*** ./src/react/components/matrix/row.tsx ***!
  \*********************************************/ /*! exports provided: MatrixRow */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "MatrixRow", function() {
                return MatrixRow;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var MatrixRow = /** @class */ function(_super) {
                __extends(MatrixRow, _super);
                function MatrixRow(props) {
                    var _this = _super.call(this, props) || this;
                    _this.onPointerDownHandler = function(event) {
                        _this.parentMatrix.onPointerDown(event.nativeEvent, _this.model.row);
                    };
                    return _this;
                }
                Object.defineProperty(MatrixRow.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(MatrixRow.prototype, "parentMatrix", {
                    get: function() {
                        return this.props.parentMatrix;
                    },
                    enumerable: false,
                    configurable: true
                });
                MatrixRow.prototype.getStateElement = function() {
                    return this.model;
                };
                MatrixRow.prototype.render = function() {
                    var _this = this;
                    var model = this.model;
                    if (!model.visible) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("tr", {
                        className: model.className,
                        "data-sv-drop-target-matrix-row": model.row && model.row.id,
                        onPointerDown: function(event) {
                            return _this.onPointerDownHandler(event);
                        }
                    }, this.props.children);
                };
                return MatrixRow;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-matrix-row", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(MatrixRow, props);
            });
        /***/ },
        /***/ "./src/react/components/notifier.tsx": /*!*******************************************!*\
  !*** ./src/react/components/notifier.tsx ***!
  \*******************************************/ /*! exports provided: NotifierComponent */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "NotifierComponent", function() {
                return NotifierComponent;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _action_bar_action_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var NotifierComponent = /** @class */ function(_super) {
                __extends(NotifierComponent, _super);
                function NotifierComponent() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(NotifierComponent.prototype, "notifier", {
                    get: function() {
                        return this.props.notifier;
                    },
                    enumerable: false,
                    configurable: true
                });
                NotifierComponent.prototype.getStateElement = function() {
                    return this.notifier;
                };
                NotifierComponent.prototype.renderElement = function() {
                    if (!this.notifier.isDisplayed) return null;
                    var style = {
                        visibility: this.notifier.active ? "visible" : "hidden"
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.notifier.css,
                        style: style,
                        role: "alert",
                        "aria-live": "polite"
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null, this.notifier.message), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_3__["SurveyActionBar"], {
                        model: this.notifier.actionBar
                    }));
                };
                return NotifierComponent;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("sv-notifier", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(NotifierComponent, props);
            });
        /***/ },
        /***/ "./src/react/components/paneldynamic-actions/paneldynamic-add-btn.tsx": /*!****************************************************************************!*\
  !*** ./src/react/components/paneldynamic-actions/paneldynamic-add-btn.tsx ***!
  \****************************************************************************/ /*! exports provided: SurveyQuestionPanelDynamicAction, SurveyQuestionPanelDynamicAddButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicAction", function() {
                return SurveyQuestionPanelDynamicAction;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicAddButton", function() {
                return SurveyQuestionPanelDynamicAddButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionPanelDynamicAction = /** @class */ function(_super) {
                __extends(SurveyQuestionPanelDynamicAction, _super);
                function SurveyQuestionPanelDynamicAction(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionPanelDynamicAction.prototype, "data", {
                    get: function() {
                        return this.props.item && this.props.item.data || this.props.data;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionPanelDynamicAction.prototype, "question", {
                    get: function() {
                        return this.props.item && this.props.item.data.question || this.props.data.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                return SurveyQuestionPanelDynamicAction;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["ReactSurveyElement"]);
            var SurveyQuestionPanelDynamicAddButton = /** @class */ function(_super) {
                __extends(SurveyQuestionPanelDynamicAddButton, _super);
                function SurveyQuestionPanelDynamicAddButton() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.handleClick = function(event) {
                        _this.question.addPanelUI();
                    };
                    return _this;
                }
                SurveyQuestionPanelDynamicAddButton.prototype.renderElement = function() {
                    if (!this.question.canAddPanel) return null;
                    var btnText = this.renderLocString(this.question.locPanelAddText);
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", {
                        type: "button",
                        className: this.question.getAddButtonCss(),
                        onClick: this.handleClick
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: this.question.cssClasses.buttonAddText
                    }, btnText));
                };
                return SurveyQuestionPanelDynamicAddButton;
            }(SurveyQuestionPanelDynamicAction);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-paneldynamic-add-btn", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyQuestionPanelDynamicAddButton, props);
            });
        /***/ },
        /***/ "./src/react/components/paneldynamic-actions/paneldynamic-next-btn.tsx": /*!*****************************************************************************!*\
  !*** ./src/react/components/paneldynamic-actions/paneldynamic-next-btn.tsx ***!
  \*****************************************************************************/ /*! exports provided: SurveyQuestionPanelDynamicNextButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicNextButton", function() {
                return SurveyQuestionPanelDynamicNextButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./paneldynamic-add-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-add-btn.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionPanelDynamicNextButton = /** @class */ function(_super) {
                __extends(SurveyQuestionPanelDynamicNextButton, _super);
                function SurveyQuestionPanelDynamicNextButton() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.handleClick = function(event) {
                        _this.question.goToNextPanel();
                    };
                    return _this;
                }
                SurveyQuestionPanelDynamicNextButton.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        title: this.question.panelNextText,
                        onClick: this.handleClick,
                        className: this.question.getNextButtonCss()
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                        iconName: this.question.cssClasses.progressBtnIcon,
                        size: "auto"
                    }));
                };
                return SurveyQuestionPanelDynamicNextButton;
            }(_paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestionPanelDynamicAction"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-paneldynamic-next-btn", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyQuestionPanelDynamicNextButton, props);
            });
        /***/ },
        /***/ "./src/react/components/paneldynamic-actions/paneldynamic-prev-btn.tsx": /*!*****************************************************************************!*\
  !*** ./src/react/components/paneldynamic-actions/paneldynamic-prev-btn.tsx ***!
  \*****************************************************************************/ /*! exports provided: SurveyQuestionPanelDynamicPrevButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicPrevButton", function() {
                return SurveyQuestionPanelDynamicPrevButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./paneldynamic-add-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-add-btn.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionPanelDynamicPrevButton = /** @class */ function(_super) {
                __extends(SurveyQuestionPanelDynamicPrevButton, _super);
                function SurveyQuestionPanelDynamicPrevButton() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.handleClick = function(event) {
                        _this.question.goToPrevPanel();
                    };
                    return _this;
                }
                SurveyQuestionPanelDynamicPrevButton.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        title: this.question.panelPrevText,
                        onClick: this.handleClick,
                        className: this.question.getPrevButtonCss()
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                        iconName: this.question.cssClasses.progressBtnIcon,
                        size: "auto"
                    }));
                };
                return SurveyQuestionPanelDynamicPrevButton;
            }(_paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestionPanelDynamicAction"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-paneldynamic-prev-btn", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyQuestionPanelDynamicPrevButton, props);
            });
        /***/ },
        /***/ "./src/react/components/paneldynamic-actions/paneldynamic-progress-text.tsx": /*!**********************************************************************************!*\
  !*** ./src/react/components/paneldynamic-actions/paneldynamic-progress-text.tsx ***!
  \**********************************************************************************/ /*! exports provided: SurveyQuestionPanelDynamicProgressText */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicProgressText", function() {
                return SurveyQuestionPanelDynamicProgressText;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./paneldynamic-add-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-add-btn.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionPanelDynamicProgressText = /** @class */ function(_super) {
                __extends(SurveyQuestionPanelDynamicProgressText, _super);
                function SurveyQuestionPanelDynamicProgressText() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                SurveyQuestionPanelDynamicProgressText.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.question.cssClasses.progressText
                    }, this.question.progressText);
                };
                return SurveyQuestionPanelDynamicProgressText;
            }(_paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionPanelDynamicAction"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-paneldynamic-progress-text", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyQuestionPanelDynamicProgressText, props);
            });
        /***/ },
        /***/ "./src/react/components/paneldynamic-actions/paneldynamic-remove-btn.tsx": /*!*******************************************************************************!*\
  !*** ./src/react/components/paneldynamic-actions/paneldynamic-remove-btn.tsx ***!
  \*******************************************************************************/ /*! exports provided: SurveyQuestionPanelDynamicRemoveButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicRemoveButton", function() {
                return SurveyQuestionPanelDynamicRemoveButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./paneldynamic-add-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-add-btn.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionPanelDynamicRemoveButton = /** @class */ function(_super) {
                __extends(SurveyQuestionPanelDynamicRemoveButton, _super);
                function SurveyQuestionPanelDynamicRemoveButton() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.handleClick = function(event) {
                        _this.question.removePanelUI(_this.data.panel);
                    };
                    return _this;
                }
                SurveyQuestionPanelDynamicRemoveButton.prototype.renderElement = function() {
                    var btnText = this.renderLocString(this.question.locPanelRemoveText);
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("button", {
                        className: this.question.getPanelRemoveButtonCss(),
                        onClick: this.handleClick,
                        type: "button"
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: this.question.cssClasses.buttonRemoveText
                    }, btnText), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: this.question.cssClasses.iconRemove
                    }));
                };
                return SurveyQuestionPanelDynamicRemoveButton;
            }(_paneldynamic_add_btn__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionPanelDynamicAction"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-paneldynamic-remove-btn", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyQuestionPanelDynamicRemoveButton, props);
            });
        /***/ },
        /***/ "./src/react/components/popup/popup.tsx": /*!**********************************************!*\
  !*** ./src/react/components/popup/popup.tsx ***!
  \**********************************************/ /*! exports provided: Popup, PopupContainer, PopupDropdownContainer, showModal, showDialog */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Popup", function() {
                return Popup;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupContainer", function() {
                return PopupContainer;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupDropdownContainer", function() {
                return PopupDropdownContainer;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showModal", function() {
                return showModal;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showDialog", function() {
                return showDialog;
            });
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react-dom */ "react-dom");
            /* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_2__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _action_bar_action_bar__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var Popup = /** @class */ function(_super) {
                __extends(Popup, _super);
                function Popup(props) {
                    var _this = _super.call(this, props) || this;
                    _this.containerRef = react__WEBPACK_IMPORTED_MODULE_1___default.a.createRef();
                    _this.createModel();
                    return _this;
                }
                Object.defineProperty(Popup.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Popup.prototype.getStateElement = function() {
                    return this.model;
                };
                Popup.prototype.createModel = function() {
                    this.popup = Object(survey_core__WEBPACK_IMPORTED_MODULE_2__["createPopupViewModel"])(this.props.model, undefined);
                };
                Popup.prototype.setTargetElement = function() {
                    var container = this.containerRef.current;
                    this.popup.setComponentElement(container, this.props.getTarget ? this.props.getTarget(container) : undefined);
                };
                Popup.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.setTargetElement();
                };
                Popup.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.setTargetElement();
                };
                Popup.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.popup.resetComponentElement();
                };
                Popup.prototype.shouldComponentUpdate = function(nextProps, nextState) {
                    var _a;
                    if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState)) return false;
                    var isNeedUpdate = nextProps.model !== this.popup.model;
                    if (isNeedUpdate) {
                        (_a = this.popup) === null || _a === void 0 || _a.dispose();
                        this.createModel();
                    }
                    return isNeedUpdate;
                };
                Popup.prototype.render = function() {
                    this.popup.model = this.model;
                    var popupContainer;
                    if (this.model.isModal) popupContainer = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(PopupContainer, {
                        model: this.popup
                    });
                    else popupContainer = react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(PopupDropdownContainer, {
                        model: this.popup
                    });
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        ref: this.containerRef
                    }, popupContainer);
                };
                return Popup;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_4__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("sv-popup", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(Popup, props);
            });
            var PopupContainer = /** @class */ function(_super) {
                __extends(PopupContainer, _super);
                function PopupContainer(props) {
                    var _this = _super.call(this, props) || this;
                    _this.prevIsVisible = false;
                    _this.handleKeydown = function(event) {
                        _this.model.onKeyDown(event);
                    };
                    _this.clickInside = function(ev) {
                        ev.stopPropagation();
                    };
                    return _this;
                }
                Object.defineProperty(PopupContainer.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                PopupContainer.prototype.getStateElement = function() {
                    return this.model;
                };
                PopupContainer.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    if (!this.prevIsVisible && this.model.isVisible) this.model.updateOnShowing();
                    this.prevIsVisible = this.model.isVisible;
                };
                PopupContainer.prototype.renderContainer = function(popupBaseViewModel) {
                    var _this = this;
                    var headerPopup = popupBaseViewModel.showHeader ? this.renderHeaderPopup(popupBaseViewModel) : null;
                    var headerContent = !!popupBaseViewModel.title ? this.renderHeaderContent() : null;
                    var content = this.renderContent();
                    var footerContent = popupBaseViewModel.showFooter ? this.renderFooter(this.model) : null;
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: "sv-popup__container",
                        style: {
                            left: popupBaseViewModel.left,
                            top: popupBaseViewModel.top,
                            height: popupBaseViewModel.height,
                            width: popupBaseViewModel.width,
                            minWidth: popupBaseViewModel.minWidth
                        },
                        onClick: function(ev) {
                            _this.clickInside(ev);
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: "sv-popup__shadow"
                    }, headerPopup, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: "sv-popup__body-content"
                    }, headerContent, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: "sv-popup__scrolling-content"
                    }, content), footerContent)));
                };
                PopupContainer.prototype.renderHeaderContent = function() {
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: "sv-popup__body-header"
                    }, this.model.title);
                };
                PopupContainer.prototype.renderContent = function() {
                    var contentComponent = _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.createElement(this.model.contentComponentName, this.model.contentComponentData);
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: "sv-popup__content"
                    }, contentComponent);
                };
                PopupContainer.prototype.renderHeaderPopup = function(popupModel) {
                    return null;
                };
                PopupContainer.prototype.renderFooter = function(popuModel) {
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: "sv-popup__body-footer"
                    }, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_5__["SurveyActionBar"], {
                        model: popuModel.footerToolbar
                    }));
                };
                PopupContainer.prototype.render = function() {
                    var _this = this;
                    var container = this.renderContainer(this.model);
                    var className = new survey_core__WEBPACK_IMPORTED_MODULE_2__["CssClassBuilder"]().append("sv-popup").append(this.model.styleClass).toString();
                    var style = {
                        display: this.model.isVisible ? "" : "none"
                    };
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        tabIndex: -1,
                        className: className,
                        style: style,
                        onClick: function(e) {
                            _this.model.clickOutside(e);
                        },
                        onKeyDown: this.handleKeydown
                    }, container);
                };
                return PopupContainer;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_4__["SurveyElementBase"]);
            var PopupDropdownContainer = /** @class */ function(_super) {
                __extends(PopupDropdownContainer, _super);
                function PopupDropdownContainer() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                PopupDropdownContainer.prototype.renderHeaderPopup = function(popupModel) {
                    var popupDropdownModel = popupModel;
                    if (!popupDropdownModel) return null;
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", {
                        style: {
                            left: popupDropdownModel.pointerTarget.left,
                            top: popupDropdownModel.pointerTarget.top
                        },
                        className: "sv-popup__pointer"
                    });
                };
                return PopupDropdownContainer;
            }(PopupContainer);
            // replace to showDialog then delete
            function showModal(componentName, data, onApply, onCancel, cssClass, title, displayMode) {
                if (displayMode === void 0) displayMode = "popup";
                var options = Object(survey_core__WEBPACK_IMPORTED_MODULE_2__["createDialogOptions"])(componentName, data, onApply, onCancel, undefined, undefined, cssClass, title, displayMode);
                return showDialog(options);
            }
            function showDialog(dialogOptions, rootElement1) {
                var popupViewModel = Object(survey_core__WEBPACK_IMPORTED_MODULE_2__["createPopupModalViewModel"])(dialogOptions, rootElement1);
                var onVisibilityChangedCallback = function(_, options) {
                    if (!options.isVisible) {
                        react_dom__WEBPACK_IMPORTED_MODULE_0___default.a.unmountComponentAtNode(popupViewModel.container);
                        popupViewModel.dispose();
                    }
                };
                popupViewModel.onVisibilityChanged.add(onVisibilityChangedCallback);
                react_dom__WEBPACK_IMPORTED_MODULE_0___default.a.render(react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(PopupContainer, {
                    model: popupViewModel
                }), popupViewModel.container);
                popupViewModel.model.isVisible = true;
                return popupViewModel;
            }
            survey_core__WEBPACK_IMPORTED_MODULE_2__["settings"].showModal = showModal;
            survey_core__WEBPACK_IMPORTED_MODULE_2__["settings"].showDialog = showDialog;
        /***/ },
        /***/ "./src/react/components/rating/rating-dropdown-item.tsx": /*!**************************************************************!*\
  !*** ./src/react/components/rating/rating-dropdown-item.tsx ***!
  \**************************************************************/ /*! exports provided: RatingDropdownItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RatingDropdownItem", function() {
                return RatingDropdownItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var RatingDropdownItem = /** @class */ function(_super) {
                __extends(RatingDropdownItem, _super);
                function RatingDropdownItem() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(RatingDropdownItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                RatingDropdownItem.prototype.getStateElement = function() {
                    return this.item;
                };
                RatingDropdownItem.prototype.render = function() {
                    if (!this.item) return null;
                    var item = this.props.item;
                    var description = this.renderDescription(item);
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sd-rating-dropdown-item"
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: "sd-rating-dropdown-item_text"
                    }, item.title), description);
                };
                RatingDropdownItem.prototype.renderDescription = function(item) {
                    if (!item.description) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sd-rating-dropdown-item_description"
                    }, this.renderLocString(item.description, undefined, "locString"));
                };
                return RatingDropdownItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-rating-dropdown-item", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(RatingDropdownItem, props);
            });
        /***/ },
        /***/ "./src/react/components/rating/rating-item-smiley.tsx": /*!************************************************************!*\
  !*** ./src/react/components/rating/rating-item-smiley.tsx ***!
  \************************************************************/ /*! exports provided: RatingItemSmiley */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RatingItemSmiley", function() {
                return RatingItemSmiley;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _rating_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./rating-item */ "./src/react/components/rating/rating-item.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var RatingItemSmiley = /** @class */ function(_super) {
                __extends(RatingItemSmiley, _super);
                function RatingItemSmiley() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RatingItemSmiley.prototype.render = function() {
                    var _this = this;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", {
                        onMouseDown: this.handleOnMouseDown,
                        style: this.question.getItemStyle(this.item.itemValue, this.item.highlight),
                        className: this.question.getItemClass(this.item.itemValue),
                        onMouseOver: function(e) {
                            return _this.question.onItemMouseIn(_this.item);
                        },
                        onMouseOut: function(e) {
                            return _this.question.onItemMouseOut(_this.item);
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", {
                        type: "radio",
                        className: "sv-visuallyhidden",
                        name: this.question.name,
                        id: this.question.getInputId(this.index),
                        value: this.item.value,
                        disabled: this.isDisplayMode,
                        checked: this.question.value == this.item.value,
                        onClick: this.props.handleOnClick,
                        onChange: function() {},
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage
                    }), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                        size: "auto",
                        iconName: this.question.getItemSmileyIconName(this.item.itemValue),
                        title: this.item.text
                    }));
                };
                return RatingItemSmiley;
            }(_rating_item__WEBPACK_IMPORTED_MODULE_3__["RatingItemBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-rating-item-smiley", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(RatingItemSmiley, props);
            });
        /***/ },
        /***/ "./src/react/components/rating/rating-item-star.tsx": /*!**********************************************************!*\
  !*** ./src/react/components/rating/rating-item-star.tsx ***!
  \**********************************************************/ /*! exports provided: RatingItemStar */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RatingItemStar", function() {
                return RatingItemStar;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _rating_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./rating-item */ "./src/react/components/rating/rating-item.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var RatingItemStar = /** @class */ function(_super) {
                __extends(RatingItemStar, _super);
                function RatingItemStar() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RatingItemStar.prototype.render = function() {
                    var _this = this;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", {
                        onMouseDown: this.handleOnMouseDown,
                        className: this.question.getItemClass(this.item.itemValue),
                        onMouseOver: function(e) {
                            return _this.question.onItemMouseIn(_this.item);
                        },
                        onMouseOut: function(e) {
                            return _this.question.onItemMouseOut(_this.item);
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", {
                        type: "radio",
                        className: "sv-visuallyhidden",
                        name: this.question.name,
                        id: this.question.getInputId(this.index),
                        value: this.item.value,
                        disabled: this.isDisplayMode,
                        checked: this.question.value == this.item.value,
                        onClick: this.props.handleOnClick,
                        onChange: function() {},
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage
                    }), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                        className: "sv-star",
                        size: "auto",
                        iconName: this.question.itemStarIcon,
                        title: this.item.text
                    }), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                        className: "sv-star-2",
                        size: "auto",
                        iconName: this.question.itemStarIconAlt,
                        title: this.item.text
                    }));
                };
                return RatingItemStar;
            }(_rating_item__WEBPACK_IMPORTED_MODULE_3__["RatingItemBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-rating-item-star", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(RatingItemStar, props);
            });
        /***/ },
        /***/ "./src/react/components/rating/rating-item.tsx": /*!*****************************************************!*\
  !*** ./src/react/components/rating/rating-item.tsx ***!
  \*****************************************************/ /*! exports provided: RatingItemBase, RatingItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RatingItemBase", function() {
                return RatingItemBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "RatingItem", function() {
                return RatingItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var RatingItemBase = /** @class */ function(_super) {
                __extends(RatingItemBase, _super);
                function RatingItemBase(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnMouseDown = _this.handleOnMouseDown.bind(_this);
                    return _this;
                }
                Object.defineProperty(RatingItemBase.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RatingItemBase.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(RatingItemBase.prototype, "index", {
                    get: function() {
                        return this.props.index;
                    },
                    enumerable: false,
                    configurable: true
                });
                RatingItemBase.prototype.getStateElement = function() {
                    return this.item;
                };
                RatingItemBase.prototype.handleOnMouseDown = function(event) {
                    this.question.onMouseDown();
                };
                return RatingItemBase;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"]);
            var RatingItem = /** @class */ function(_super) {
                __extends(RatingItem, _super);
                function RatingItem() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                RatingItem.prototype.render = function() {
                    var itemText = this.renderLocString(this.item.locText);
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("label", {
                        onMouseDown: this.handleOnMouseDown,
                        className: this.question.getItemClassByText(this.item.itemValue, this.item.text)
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", {
                        type: "radio",
                        className: "sv-visuallyhidden",
                        name: this.question.name,
                        id: this.question.getInputId(this.index),
                        value: this.item.value,
                        disabled: this.isDisplayMode,
                        checked: this.question.value == this.item.value,
                        onClick: this.props.handleOnClick,
                        onChange: function() {},
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage
                    }), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: this.question.cssClasses.itemText
                    }, itemText));
                };
                RatingItem.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                };
                return RatingItem;
            }(RatingItemBase);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-rating-item", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(RatingItem, props);
            });
        /***/ },
        /***/ "./src/react/components/skeleton.tsx": /*!*******************************************!*\
  !*** ./src/react/components/skeleton.tsx ***!
  \*******************************************/ /*! exports provided: Skeleton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Skeleton", function() {
                return Skeleton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var Skeleton = /** @class */ function(_super) {
                __extends(Skeleton, _super);
                function Skeleton() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Skeleton.prototype.render = function() {
                    var _a;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-skeleton-element",
                        id: (_a = this.props.element) === null || _a === void 0 ? void 0 : _a.id
                    });
                };
                return Skeleton;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-skeleton", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(Skeleton, props);
            });
        /***/ },
        /***/ "./src/react/components/survey-actions/survey-nav-button.tsx": /*!*******************************************************************!*\
  !*** ./src/react/components/survey-actions/survey-nav-button.tsx ***!
  \*******************************************************************/ /*! exports provided: SurveyNavigationButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyNavigationButton", function() {
                return SurveyNavigationButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyNavigationButton = /** @class */ function(_super) {
                __extends(SurveyNavigationButton, _super);
                function SurveyNavigationButton() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyNavigationButton.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyNavigationButton.prototype.canRender = function() {
                    return this.item.isVisible;
                };
                SurveyNavigationButton.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("input", {
                        className: this.item.innerCss,
                        type: "button",
                        disabled: this.item.disabled,
                        onMouseDown: this.item.data && this.item.data.mouseDown,
                        onClick: this.item.action,
                        title: this.item.getTooltip(),
                        value: this.item.title
                    });
                };
                return SurveyNavigationButton;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-nav-btn", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyNavigationButton, props);
            });
        /***/ },
        /***/ "./src/react/components/survey-header/logo-image.tsx": /*!***********************************************************!*\
  !*** ./src/react/components/survey-header/logo-image.tsx ***!
  \***********************************************************/ /*! exports provided: LogoImage */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "LogoImage", function() {
                return LogoImage;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var LogoImage = /** @class */ function(_super) {
                __extends(LogoImage, _super);
                function LogoImage(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(LogoImage.prototype, "survey", {
                    get: function() {
                        return this.props.data;
                    },
                    enumerable: false,
                    configurable: true
                });
                LogoImage.prototype.render = function() {
                    var content = [];
                    content.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        key: "logo-image",
                        className: this.survey.logoClassNames
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("img", {
                        className: this.survey.css.logoImage,
                        src: this.survey.locLogo.renderedHtml,
                        alt: this.survey.locTitle.renderedHtml,
                        width: this.survey.renderedLogoWidth,
                        height: this.survey.renderedLogoHeight,
                        style: {
                            objectFit: this.survey.logoFit,
                            width: this.survey.renderedStyleLogoWidth,
                            height: this.survey.renderedStyleLogoHeight
                        }
                    })));
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, content);
                };
                return LogoImage;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-logo-image", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(LogoImage, props);
            });
        /***/ },
        /***/ "./src/react/components/survey-header/survey-header.tsx": /*!**************************************************************!*\
  !*** ./src/react/components/survey-header/survey-header.tsx ***!
  \**************************************************************/ /*! exports provided: SurveyHeader */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyHeader", function() {
                return SurveyHeader;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _title_title_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../title/title-element */ "./src/react/components/title/title-element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyHeader = /** @class */ function(_super) {
                __extends(SurveyHeader, _super);
                function SurveyHeader(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = {
                        changed: 0
                    };
                    _this.rootRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();
                    return _this;
                }
                Object.defineProperty(SurveyHeader.prototype, "survey", {
                    get: function() {
                        return this.props.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyHeader.prototype, "css", {
                    get: function() {
                        return this.survey.css;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyHeader.prototype.componentDidMount = function() {
                    var self = this;
                    this.survey.afterRenderHeader(this.rootRef.current);
                    this.survey.locLogo.onChanged = function() {
                        self.setState({
                            changed: self.state.changed + 1
                        });
                    };
                };
                SurveyHeader.prototype.componentWillUnmount = function() {
                    this.survey.locLogo.onChanged = function() {};
                };
                SurveyHeader.prototype.renderTitle = function() {
                    if (!this.survey.renderedHasTitle) return null;
                    var description = _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"].renderLocString(this.survey.locDescription);
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.css.headerText,
                        style: {
                            maxWidth: this.survey.titleMaxWidth
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_title_title_element__WEBPACK_IMPORTED_MODULE_3__["TitleElement"], {
                        element: this.survey
                    }), this.survey.renderedHasDescription ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.css.description
                    }, description) : null);
                };
                SurveyHeader.prototype.renderLogoImage = function(isRender) {
                    if (!isRender) return null;
                    var componentName = this.survey.getElementWrapperComponentName(this.survey, "logo-image");
                    var componentData = this.survey.getElementWrapperComponentData(this.survey, "logo-image");
                    return _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.createElement(componentName, {
                        data: componentData
                    });
                };
                SurveyHeader.prototype.render = function() {
                    if (!this.survey.renderedHasHeader) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.css.header,
                        ref: this.rootRef
                    }, this.renderLogoImage(this.survey.isLogoBefore), this.renderTitle(), this.renderLogoImage(this.survey.isLogoAfter), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: this.css.headerClose
                    }));
                };
                return SurveyHeader;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("survey-header", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyHeader, props);
            });
        /***/ },
        /***/ "./src/react/components/svg-icon/svg-icon.tsx": /*!****************************************************!*\
  !*** ./src/react/components/svg-icon/svg-icon.tsx ***!
  \****************************************************/ /*! exports provided: SvgIcon */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgIcon", function() {
                return SvgIcon;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_2__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SvgIcon = /** @class */ function(_super) {
                __extends(SvgIcon, _super);
                function SvgIcon(props) {
                    var _this = _super.call(this, props) || this;
                    _this.svgIconRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();
                    return _this;
                }
                SvgIcon.prototype.updateSvg = function() {
                    if (this.props.iconName) Object(survey_core__WEBPACK_IMPORTED_MODULE_2__["createSvg"])(this.props.size, this.props.width, this.props.height, this.props.iconName, this.svgIconRef.current, this.props.title);
                };
                SvgIcon.prototype.componentDidUpdate = function() {
                    this.updateSvg();
                };
                SvgIcon.prototype.render = function() {
                    var className = "sv-svg-icon";
                    if (this.props.className) className += " " + this.props.className;
                    return this.props.iconName ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", {
                        className: className,
                        style: this.props.style,
                        onClick: this.props.onClick,
                        ref: this.svgIconRef,
                        role: "img"
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("use", null)) : null;
                };
                SvgIcon.prototype.componentDidMount = function() {
                    this.updateSvg();
                };
                return SvgIcon;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("sv-svg-icon", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SvgIcon, props);
            });
        /***/ },
        /***/ "./src/react/components/title/title-actions.tsx": /*!******************************************************!*\
  !*** ./src/react/components/title/title-actions.tsx ***!
  \******************************************************/ /*! exports provided: TitleActions */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TitleActions", function() {
                return TitleActions;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _action_bar_action_bar__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            /* harmony import */ var _title_content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./title-content */ "./src/react/components/title/title-content.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var TitleActions = /** @class */ function(_super) {
                __extends(TitleActions, _super);
                function TitleActions() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(TitleActions.prototype, "cssClasses", {
                    get: function() {
                        return this.props.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TitleActions.prototype, "element", {
                    get: function() {
                        return this.props.element;
                    },
                    enumerable: false,
                    configurable: true
                });
                TitleActions.prototype.render = function() {
                    var titleContent = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_title_content__WEBPACK_IMPORTED_MODULE_4__["TitleContent"], {
                        element: this.element,
                        cssClasses: this.cssClasses
                    });
                    if (!this.element.hasTitleActions) return titleContent;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: "sv-title-actions"
                    }, react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: "sv-title-actions__title"
                    }, titleContent), react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_3__["SurveyActionBar"], {
                        model: this.element.getTitleToolbar()
                    }));
                };
                return TitleActions;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            survey_core__WEBPACK_IMPORTED_MODULE_1__["RendererFactory"].Instance.registerRenderer("element", "title-actions", "sv-title-actions");
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("sv-title-actions", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(TitleActions, props);
            });
        /***/ },
        /***/ "./src/react/components/title/title-content.tsx": /*!******************************************************!*\
  !*** ./src/react/components/title/title-content.tsx ***!
  \******************************************************/ /*! exports provided: TitleContent */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TitleContent", function() {
                return TitleContent;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var TitleContent = /** @class */ function(_super) {
                __extends(TitleContent, _super);
                function TitleContent(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(TitleContent.prototype, "cssClasses", {
                    get: function() {
                        return this.props.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TitleContent.prototype, "element", {
                    get: function() {
                        return this.props.element;
                    },
                    enumerable: false,
                    configurable: true
                });
                TitleContent.prototype.render = function() {
                    if (this.element.isTitleRenderedAsString) return _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"].renderLocString(this.element.locTitle);
                    var spans = this.renderTitleSpans(this.element.getTitleOwner(), this.cssClasses);
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(react__WEBPACK_IMPORTED_MODULE_0___default.a.Fragment, null, spans);
                };
                TitleContent.prototype.renderTitleSpans = function(element, cssClasses) {
                    var getSpaceSpan = function(key) {
                        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                            "data-key": key,
                            key: key
                        }, "\xa0");
                    };
                    var spans = [];
                    if (element.isRequireTextOnStart) {
                        spans.push(this.renderRequireText(element, cssClasses));
                        spans.push(getSpaceSpan("req-sp"));
                    }
                    var questionNumber = element.no;
                    if (questionNumber) {
                        var panelNumber = !!cssClasses.panel ? cssClasses.panel.number : undefined;
                        spans.push(react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                            "data-key": "q_num",
                            key: "q_num",
                            className: cssClasses.number || panelNumber,
                            style: {
                                position: "static"
                            },
                            "aria-hidden": true
                        }, questionNumber));
                        spans.push(getSpaceSpan("num-sp"));
                    }
                    if (element.isRequireTextBeforeTitle) {
                        spans.push(this.renderRequireText(element, cssClasses));
                        spans.push(getSpaceSpan("req-sp"));
                    }
                    spans.push(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"].renderLocString(element.locTitle, null, "q_title"));
                    if (element.isRequireTextAfterTitle) {
                        spans.push(getSpaceSpan("req-sp"));
                        spans.push(this.renderRequireText(element, cssClasses));
                    }
                    return spans;
                };
                TitleContent.prototype.renderRequireText = function(element, cssClasses) {
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        "data-key": "req-text",
                        key: "req-text",
                        className: cssClasses.requiredText || cssClasses.panel.requiredText,
                        "aria-hidden": true
                    }, element.requiredText);
                };
                return TitleContent;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
        /***/ },
        /***/ "./src/react/components/title/title-element.tsx": /*!******************************************************!*\
  !*** ./src/react/components/title/title-element.tsx ***!
  \******************************************************/ /*! exports provided: TitleElement */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TitleElement", function() {
                return TitleElement;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _title_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./title-actions */ "./src/react/components/title/title-actions.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var TitleElement = /** @class */ function(_super) {
                __extends(TitleElement, _super);
                function TitleElement(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(TitleElement.prototype, "element", {
                    get: function() {
                        return this.props.element;
                    },
                    enumerable: false,
                    configurable: true
                });
                TitleElement.prototype.render = function() {
                    var element = this.element;
                    if (!element || !element.hasTitle) return null;
                    var ariaLabel = element.titleAriaLabel || undefined;
                    var titleContent = react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_title_actions__WEBPACK_IMPORTED_MODULE_2__["TitleActions"], {
                        element: element,
                        cssClasses: element.cssClasses
                    });
                    var onClick = undefined;
                    var onKeyUp = undefined;
                    if (element.hasTitleEvents) onKeyUp = function(evt) {
                        Object(survey_core__WEBPACK_IMPORTED_MODULE_1__["doKey2ClickUp"])(evt.nativeEvent);
                    };
                    var CustomTag = element.titleTagName;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(CustomTag, {
                        className: element.cssTitle,
                        id: element.ariaTitleId,
                        "aria-label": ariaLabel,
                        tabIndex: element.titleTabIndex,
                        "aria-expanded": element.titleAriaExpanded,
                        role: element.titleAriaRole,
                        onClick: onClick,
                        onKeyUp: onKeyUp
                    }, titleContent);
                };
                return TitleElement;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
        /***/ },
        /***/ "./src/react/custom-widget.tsx": /*!*************************************!*\
  !*** ./src/react/custom-widget.tsx ***!
  \*************************************/ /*! exports provided: SurveyCustomWidget */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyCustomWidget", function() {
                return SurveyCustomWidget;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyCustomWidget = /** @class */ function(_super) {
                __extends(SurveyCustomWidget, _super);
                function SurveyCustomWidget(props) {
                    var _this = _super.call(this, props) || this;
                    _this.widgetRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    return _this;
                }
                SurveyCustomWidget.prototype._afterRender = function() {
                    if (this.questionBase.customWidget) {
                        var el = this.widgetRef.current;
                        if (!!el) {
                            this.questionBase.customWidget.afterRender(this.questionBase, el);
                            this.questionBase.customWidgetData.isNeedRender = false;
                        }
                    }
                };
                SurveyCustomWidget.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    if (this.questionBase) this._afterRender();
                };
                SurveyCustomWidget.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    var isDefaultRender = !!this.questionBase.customWidget && this.questionBase.customWidget.isDefaultRender;
                    if (this.questionBase && !isDefaultRender) this._afterRender();
                };
                SurveyCustomWidget.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (this.questionBase.customWidget) {
                        var el = this.widgetRef.current;
                        if (!!el) this.questionBase.customWidget.willUnmount(this.questionBase, el);
                    }
                };
                SurveyCustomWidget.prototype.canRender = function() {
                    return _super.prototype.canRender.call(this) && this.questionBase.visible;
                };
                SurveyCustomWidget.prototype.renderElement = function() {
                    var customWidget = this.questionBase.customWidget;
                    if (customWidget.isDefaultRender) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        ref: this.widgetRef
                    }, this.creator.createQuestionElement(this.questionBase));
                    var widget = null;
                    if (customWidget.widgetJson.render) widget = customWidget.widgetJson.render(this.questionBase);
                    else if (customWidget.htmlTemplate) {
                        var htmlValue = {
                            __html: customWidget.htmlTemplate
                        };
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            ref: this.widgetRef,
                            dangerouslySetInnerHTML: htmlValue
                        });
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        ref: this.widgetRef
                    }, widget);
                };
                return SurveyCustomWidget;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
        /***/ },
        /***/ "./src/react/dropdown-base.tsx": /*!*************************************!*\
  !*** ./src/react/dropdown-base.tsx ***!
  \*************************************/ /*! exports provided: SurveyQuestionDropdownBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdownBase", function() {
                return SurveyQuestionDropdownBase;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _components_popup_popup__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/popup/popup */ "./src/react/components/popup/popup.tsx");
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_comment__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./reactquestion_comment */ "./src/react/reactquestion_comment.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionDropdownBase = /** @class */ function(_super) {
                __extends(SurveyQuestionDropdownBase, _super);
                function SurveyQuestionDropdownBase() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.click = function(event) {
                        var _a;
                        (_a = _this.question.dropdownListModel) === null || _a === void 0 || _a.onClick(event);
                    };
                    _this.chevronPointerDown = function(event) {
                        var _a;
                        (_a = _this.question.dropdownListModel) === null || _a === void 0 || _a.chevronPointerDown(event);
                    };
                    _this.clear = function(event) {
                        var _a;
                        (_a = _this.question.dropdownListModel) === null || _a === void 0 || _a.onClear(event);
                    };
                    _this.keyhandler = function(event) {
                        var _a;
                        (_a = _this.question.dropdownListModel) === null || _a === void 0 || _a.keyHandler(event);
                    };
                    _this.blur = function(event) {
                        var _a;
                        (_a = _this.question.dropdownListModel) === null || _a === void 0 || _a.onBlur(event);
                        _this.updateInputDomElement();
                    };
                    _this.focus = function(event) {
                        var _a;
                        (_a = _this.question.dropdownListModel) === null || _a === void 0 || _a.onFocus(event);
                    };
                    return _this;
                }
                SurveyQuestionDropdownBase.prototype.getStateElement = function() {
                    return this.question["dropdownListModel"];
                };
                SurveyQuestionDropdownBase.prototype.setValueCore = function(newValue) {
                    this.questionBase.renderedValue = newValue;
                };
                SurveyQuestionDropdownBase.prototype.getValueCore = function() {
                    return this.questionBase.renderedValue;
                };
                SurveyQuestionDropdownBase.prototype.renderReadOnlyElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, this.question.readOnlyText);
                };
                SurveyQuestionDropdownBase.prototype.renderSelect = function(cssClasses) {
                    var _a, _b;
                    var selectElement = null;
                    if (this.question.isReadOnly) {
                        var text = this.question.selectedItemLocText ? this.renderLocString(this.question.selectedItemLocText) : "";
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        selectElement = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            id: this.question.inputId,
                            className: this.question.getControlClass(),
                            disabled: true
                        }, text, this.renderReadOnlyElement());
                    } else {
                        if (!this.question["dropdownListModel"]) this.question["dropdownListModel"] = new survey_core__WEBPACK_IMPORTED_MODULE_1__["DropdownListModel"](this.question);
                        selectElement = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, this.renderInput(this.question["dropdownListModel"]), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_popup_popup__WEBPACK_IMPORTED_MODULE_2__["Popup"], {
                            model: (_b = (_a = this.question) === null || _a === void 0 ? void 0 : _a.dropdownListModel) === null || _b === void 0 ? void 0 : _b.popupModel
                        }));
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.selectWrapper,
                        onClick: this.click
                    }, selectElement, this.createChevronButton());
                };
                SurveyQuestionDropdownBase.prototype.renderValueElement = function(dropdownListModel) {
                    if (this.question.showInputFieldComponent) return _element_factory__WEBPACK_IMPORTED_MODULE_4__["ReactElementFactory"].Instance.createElement(this.question.inputFieldComponentName, {
                        item: dropdownListModel.getSelectedAction(),
                        question: this.question
                    });
                    else if (this.question.showSelectedItemLocText) return this.renderLocString(this.question.selectedItemLocText);
                    return null;
                };
                SurveyQuestionDropdownBase.prototype.renderInput = function(dropdownListModel) {
                    var _this = this;
                    var valueElement = this.renderValueElement(dropdownListModel);
                    var root = survey_core__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                    var onInputChange = function(e) {
                        if (e.target === root.activeElement) dropdownListModel.inputStringRendered = e.target.value;
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        id: this.question.inputId,
                        className: this.question.getControlClass(),
                        tabIndex: dropdownListModel.noTabIndex ? undefined : 0,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        disabled: this.question.isInputReadOnly,
                        required: this.question.isRequired,
                        onKeyDown: this.keyhandler,
                        onBlur: this.blur,
                        role: this.question.ariaRole,
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage,
                        "aria-expanded": this.question.ariaExpanded === null ? undefined : this.question.ariaExpanded === "true",
                        "aria-controls": dropdownListModel.listElementId,
                        "aria-activedescendant": dropdownListModel.ariaActivedescendant
                    }, dropdownListModel.showHintPrefix ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.hintPrefix
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, dropdownListModel.hintStringPrefix)) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.controlValue
                    }, dropdownListModel.showHintString ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.hintSuffix
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        style: {
                            visibility: "hidden"
                        },
                        "data-bind": "text: model.filterString"
                    }, dropdownListModel.inputStringRendered), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, dropdownListModel.hintStringSuffix)) : null, valueElement, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        type: "text",
                        autoComplete: "off",
                        id: this.question.getInputId(),
                        ref: function(element) {
                            return _this.inputElement = element;
                        },
                        className: this.question.cssClasses.filterStringInput,
                        role: dropdownListModel.filterStringEnabled ? this.question.ariaRole : undefined,
                        "aria-expanded": this.question.ariaExpanded === null ? undefined : this.question.ariaExpanded === "true",
                        "aria-label": this.question.a11y_input_ariaLabel,
                        "aria-labelledby": this.question.a11y_input_ariaLabelledBy,
                        "aria-describedby": this.question.a11y_input_ariaDescribedBy,
                        "aria-controls": dropdownListModel.listElementId,
                        "aria-activedescendant": dropdownListModel.ariaActivedescendant,
                        placeholder: dropdownListModel.placeholderRendered,
                        readOnly: dropdownListModel.filterReadOnly ? true : undefined,
                        tabIndex: dropdownListModel.noTabIndex ? undefined : -1,
                        disabled: this.question.isInputReadOnly,
                        inputMode: dropdownListModel.inputMode,
                        onChange: function(e) {
                            onInputChange(e);
                        },
                        onBlur: this.blur,
                        onFocus: this.focus
                    })), this.createClearButton());
                };
                SurveyQuestionDropdownBase.prototype.createClearButton = function() {
                    if (!this.question.allowClear || !this.question.cssClasses.cleanButtonIconId) return null;
                    var style = {
                        display: !this.question.showClearButton ? "none" : ""
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.cleanButton,
                        style: style,
                        onClick: this.clear,
                        "aria-hidden": "true"
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        className: this.question.cssClasses.cleanButtonSvg,
                        iconName: this.question.cssClasses.cleanButtonIconId,
                        title: this.question.clearCaption,
                        size: "auto"
                    }));
                };
                SurveyQuestionDropdownBase.prototype.createChevronButton = function() {
                    if (!this.question.cssClasses.chevronButtonIconId) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.chevronButton,
                        "aria-hidden": "true",
                        onPointerDown: this.chevronPointerDown
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        className: this.question.cssClasses.chevronButtonSvg,
                        iconName: this.question.cssClasses.chevronButtonIconId,
                        size: "auto"
                    }));
                };
                SurveyQuestionDropdownBase.prototype.renderOther = function(cssClasses) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.getCommentAreaCss(true)
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion_comment__WEBPACK_IMPORTED_MODULE_5__["SurveyQuestionOtherValueItem"], {
                        question: this.question,
                        otherCss: cssClasses.other,
                        cssClasses: cssClasses,
                        isDisplayMode: this.isDisplayMode,
                        isOther: true
                    }));
                };
                SurveyQuestionDropdownBase.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.updateInputDomElement();
                };
                SurveyQuestionDropdownBase.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.updateInputDomElement();
                };
                SurveyQuestionDropdownBase.prototype.updateInputDomElement = function() {
                    if (!!this.inputElement) {
                        var control = this.inputElement;
                        var newValue = this.question.dropdownListModel.inputStringRendered;
                        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(newValue, control.value, false, true, false)) control.value = this.question.dropdownListModel.inputStringRendered;
                    }
                };
                return SurveyQuestionDropdownBase;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_6__["SurveyQuestionUncontrolledElement"]);
        /***/ },
        /***/ "./src/react/dropdown-item.tsx": /*!*************************************!*\
  !*** ./src/react/dropdown-item.tsx ***!
  \*************************************/ /*! exports provided: SurveyQuestionOptionItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionOptionItem", function() {
                return SurveyQuestionOptionItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionOptionItem = /** @class */ function(_super) {
                __extends(SurveyQuestionOptionItem, _super);
                function SurveyQuestionOptionItem(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = {
                        changed: 0
                    };
                    _this.setupModel();
                    return _this;
                }
                SurveyQuestionOptionItem.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.setupModel();
                };
                SurveyQuestionOptionItem.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (!!this.item) this.item.locText.onChanged = function() {};
                };
                SurveyQuestionOptionItem.prototype.setupModel = function() {
                    if (!this.item.locText) return;
                    var self = this;
                    this.item.locText.onChanged = function() {
                        self.setState({
                            changed: self.state.changed + 1
                        });
                    };
                };
                SurveyQuestionOptionItem.prototype.getStateElement = function() {
                    return this.item;
                };
                Object.defineProperty(SurveyQuestionOptionItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionOptionItem.prototype.canRender = function() {
                    return !!this.item;
                };
                SurveyQuestionOptionItem.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("option", {
                        value: this.item.value,
                        disabled: !this.item.isEnabled
                    }, this.item.text);
                };
                return SurveyQuestionOptionItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
        /***/ },
        /***/ "./src/react/dropdown-select.tsx": /*!***************************************!*\
  !*** ./src/react/dropdown-select.tsx ***!
  \***************************************/ /*! exports provided: SurveyQuestionDropdownSelect */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdownSelect", function() {
                return SurveyQuestionDropdownSelect;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _reactquestion_dropdown__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_dropdown */ "./src/react/reactquestion_dropdown.tsx");
            /* harmony import */ var _dropdown_item__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./dropdown-item */ "./src/react/dropdown-item.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionDropdownSelect = /** @class */ function(_super) {
                __extends(SurveyQuestionDropdownSelect, _super);
                function SurveyQuestionDropdownSelect(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionDropdownSelect.prototype.renderSelect = function(cssClasses) {
                    var _this = this;
                    var click = function(event) {
                        _this.question.onClick(event);
                    };
                    var keyup = function(event) {
                        _this.question.onKeyUp(event);
                    };
                    var selectElement = this.isDisplayMode ? // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        id: this.question.inputId,
                        className: this.question.getControlClass(),
                        disabled: true
                    }, this.question.readOnlyText) : react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("select", {
                        id: this.question.inputId,
                        className: this.question.getControlClass(),
                        ref: function(select) {
                            return _this.setControl(select);
                        },
                        autoComplete: this.question.autocomplete,
                        onChange: this.updateValueOnEvent,
                        onInput: this.updateValueOnEvent,
                        onClick: click,
                        onKeyUp: keyup,
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage,
                        required: this.question.isRequired
                    }, this.question.allowClear ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("option", {
                        value: ""
                    }, this.question.placeholder) : null, this.question.visibleChoices.map(function(item, i) {
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_dropdown_item__WEBPACK_IMPORTED_MODULE_4__["SurveyQuestionOptionItem"], {
                            key: "item" + i,
                            item: item
                        });
                    }));
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.selectWrapper
                    }, selectElement, this.createChevronButton());
                };
                return SurveyQuestionDropdownSelect;
            }(_reactquestion_dropdown__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestionDropdown"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("sv-dropdown-select", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionDropdownSelect, props);
            });
            survey_core__WEBPACK_IMPORTED_MODULE_1__["RendererFactory"].Instance.registerRenderer("dropdown", "select", "sv-dropdown-select");
        /***/ },
        /***/ "./src/react/element-factory.tsx": /*!***************************************!*\
  !*** ./src/react/element-factory.tsx ***!
  \***************************************/ /*! exports provided: ReactElementFactory */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactElementFactory", function() {
                return ReactElementFactory;
            });
            var ReactElementFactory = /** @class */ function() {
                function ReactElementFactory() {
                    this.creatorHash = {};
                }
                ReactElementFactory.prototype.registerElement = function(elementType, elementCreator) {
                    this.creatorHash[elementType] = elementCreator;
                };
                ReactElementFactory.prototype.getAllTypes = function() {
                    var result = new Array();
                    for(var key in this.creatorHash)result.push(key);
                    return result.sort();
                };
                ReactElementFactory.prototype.isElementRegistered = function(elementType) {
                    return !!this.creatorHash[elementType];
                };
                ReactElementFactory.prototype.createElement = function(elementType, params) {
                    var creator = this.creatorHash[elementType];
                    if (creator == null) return null;
                    return creator(params);
                };
                ReactElementFactory.Instance = new ReactElementFactory();
                return ReactElementFactory;
            }();
        /***/ },
        /***/ "./src/react/element-header.tsx": /*!**************************************!*\
  !*** ./src/react/element-header.tsx ***!
  \**************************************/ /*! exports provided: SurveyElementHeader */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyElementHeader", function() {
                return SurveyElementHeader;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            /* harmony import */ var _components_title_title_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/title/title-element */ "./src/react/components/title/title-element.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyElementHeader = /** @class */ function(_super) {
                __extends(SurveyElementHeader, _super);
                function SurveyElementHeader() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyElementHeader.prototype, "element", {
                    get: function() {
                        return this.props.element;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementHeader.prototype.render = function() {
                    var element = this.element;
                    var title = element.hasTitle ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_title_title_element__WEBPACK_IMPORTED_MODULE_2__["TitleElement"], {
                        element: element
                    }) : null;
                    var description = element.hasDescriptionUnderTitle ? _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElementBase"].renderQuestionDescription(this.element) : null;
                    var additionalTitleToolbarElement = !!element.additionalTitleToolbar ? react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(_components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_1__["SurveyActionBar"], {
                        model: element.additionalTitleToolbar
                    }) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("div", {
                        className: element.cssHeader,
                        onClick: function(e) {
                            return element.clickTitleFunction && element.clickTitleFunction(e.nativeEvent);
                        }
                    }, title, description, additionalTitleToolbarElement);
                };
                return SurveyElementHeader;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
        /***/ },
        /***/ "./src/react/element.tsx": /*!*******************************!*\
  !*** ./src/react/element.tsx ***!
  \*******************************/ /*! exports provided: SurveyRowElement */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyRowElement", function() {
                return SurveyRowElement;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyRowElement = /** @class */ function(_super) {
                __extends(SurveyRowElement, _super);
                function SurveyRowElement(props) {
                    var _this = _super.call(this, props) || this;
                    _this.element.cssClasses;
                    _this.rootRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    return _this;
                }
                SurveyRowElement.prototype.getStateElement = function() {
                    return this.element;
                };
                Object.defineProperty(SurveyRowElement.prototype, "element", {
                    get: function() {
                        return this.props.element;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyRowElement.prototype, "index", {
                    get: function() {
                        return this.props.index;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyRowElement.prototype, "row", {
                    get: function() {
                        return this.props.row;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyRowElement.prototype, "survey", {
                    get: function() {
                        return this.props.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyRowElement.prototype, "creator", {
                    get: function() {
                        return this.props.creator;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyRowElement.prototype, "css", {
                    get: function() {
                        return this.props.css;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyRowElement.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    if (this.rootRef.current) this.element.setWrapperElement(this.rootRef.current);
                };
                SurveyRowElement.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.element.setWrapperElement(undefined);
                };
                SurveyRowElement.prototype.shouldComponentUpdate = function(nextProps, nextState) {
                    if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState)) return false;
                    if (nextProps.element !== this.element) {
                        if (nextProps.element) nextProps.element.setWrapperElement(this.rootRef.current);
                        if (this.element) this.element.setWrapperElement(undefined);
                    }
                    this.element.cssClasses;
                    return true;
                };
                SurveyRowElement.prototype.renderElement = function() {
                    var element = this.element;
                    var innerElement = this.createElement(element, this.index);
                    var css = element.cssClassesValue;
                    var focusIn = function() {
                        var el = element;
                        if (el && el.isQuestion) el.focusIn();
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: css.questionWrapper,
                        style: element.rootStyle,
                        "data-key": innerElement.key,
                        key: innerElement.key,
                        onFocus: focusIn,
                        ref: this.rootRef
                    }, this.row.isNeedRender ? innerElement : _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.createElement(element.skeletonComponentName, {
                        element: element,
                        css: this.css
                    }));
                };
                SurveyRowElement.prototype.createElement = function(element, elementIndex) {
                    var index = elementIndex ? "-" + elementIndex : 0;
                    var elementType = element.getType();
                    if (!_element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.isElementRegistered(elementType)) elementType = "question";
                    return _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.createElement(elementType, {
                        key: element.name + index,
                        element: element,
                        creator: this.creator,
                        survey: this.survey,
                        css: this.css
                    });
                };
                return SurveyRowElement;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"]);
        /***/ },
        /***/ "./src/react/flow-panel.tsx": /*!**********************************!*\
  !*** ./src/react/flow-panel.tsx ***!
  \**********************************/ /*! exports provided: SurveyFlowPanel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyFlowPanel", function() {
                return SurveyFlowPanel;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _panel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./panel */ "./src/react/panel.tsx");
            /* harmony import */ var _reactquestion__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion */ "./src/react/reactquestion.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyFlowPanel = /** @class */ function(_super) {
                __extends(SurveyFlowPanel, _super);
                function SurveyFlowPanel(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyFlowPanel.prototype, "flowPanel", {
                    get: function() {
                        return this.panel;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyFlowPanel.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    if (!!this.flowPanel) {
                        this.flowPanel.onCustomHtmlProducing = function() {
                            return "";
                        };
                        this.flowPanel.onGetHtmlForQuestion = this.renderQuestion;
                    }
                };
                SurveyFlowPanel.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (!!this.flowPanel) {
                        this.flowPanel.onCustomHtmlProducing = null;
                        this.flowPanel.onGetHtmlForQuestion = null;
                    }
                };
                SurveyFlowPanel.prototype.getQuestion = function(name) {
                    return this.flowPanel.getQuestionByName(name);
                };
                SurveyFlowPanel.prototype.renderQuestion = function(question) {
                    return "<question>" + question.name + "</question>";
                };
                SurveyFlowPanel.prototype.renderRows = function() {
                    var result = this.renderHtml();
                    if (!!result) return [
                        result
                    ];
                    else return [];
                };
                SurveyFlowPanel.prototype.getNodeIndex = function() {
                    return this.renderedIndex++;
                };
                SurveyFlowPanel.prototype.renderHtml = function() {
                    if (!this.flowPanel) return null;
                    var html = "<span>" + this.flowPanel.produceHtml() + "</span>";
                    if (!DOMParser) {
                        var htmlValue = {
                            __html: html
                        };
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            dangerouslySetInnerHTML: htmlValue
                        });
                    }
                    var doc = new DOMParser().parseFromString(html, "text/xml");
                    this.renderedIndex = 0;
                    return this.renderParentNode(doc);
                };
                SurveyFlowPanel.prototype.renderNodes = function(domNodes) {
                    var nodes = [];
                    for(var i = 0; i < domNodes.length; i++){
                        var node = this.renderNode(domNodes[i]);
                        if (!!node) nodes.push(node);
                    }
                    return nodes;
                };
                SurveyFlowPanel.prototype.getStyle = function(nodeType) {
                    var style = {};
                    if (nodeType.toLowerCase() === "b") style.fontWeight = "bold";
                    if (nodeType.toLowerCase() === "i") style.fontStyle = "italic";
                    if (nodeType.toLowerCase() === "u") style.textDecoration = "underline";
                    return style;
                };
                SurveyFlowPanel.prototype.renderParentNode = function(node) {
                    var nodeType = node.nodeName.toLowerCase();
                    var children = this.renderNodes(this.getChildDomNodes(node));
                    if (nodeType === "div") return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        key: this.getNodeIndex()
                    }, children);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        key: this.getNodeIndex(),
                        style: this.getStyle(nodeType)
                    }, children);
                };
                SurveyFlowPanel.prototype.renderNode = function(node) {
                    if (!this.hasTextChildNodesOnly(node)) return this.renderParentNode(node);
                    var nodeType = node.nodeName.toLowerCase();
                    if (nodeType === "question") {
                        var question = this.flowPanel.getQuestionByName(node.textContent);
                        if (!question) return null;
                        var questionBody = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestion"], {
                            key: question.name,
                            element: question,
                            creator: this.creator,
                            css: this.css
                        });
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                            key: this.getNodeIndex()
                        }, questionBody);
                    }
                    if (nodeType === "div") return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        key: this.getNodeIndex()
                    }, node.textContent);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        key: this.getNodeIndex(),
                        style: this.getStyle(nodeType)
                    }, node.textContent);
                };
                SurveyFlowPanel.prototype.getChildDomNodes = function(node) {
                    var domNodes = [];
                    for(var i = 0; i < node.childNodes.length; i++)domNodes.push(node.childNodes[i]);
                    return domNodes;
                };
                SurveyFlowPanel.prototype.hasTextChildNodesOnly = function(node) {
                    var nodes = node.childNodes;
                    for(var i = 0; i < nodes.length; i++){
                        if (nodes[i].nodeName.toLowerCase() !== "#text") return false;
                    }
                    return true;
                };
                SurveyFlowPanel.prototype.renderContent = function(style, rows) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("f-panel", {
                        style: style
                    }, rows);
                };
                return SurveyFlowPanel;
            }(_panel__WEBPACK_IMPORTED_MODULE_2__["SurveyPanel"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.registerElement("flowpanel", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyFlowPanel, props);
            });
        /***/ },
        /***/ "./src/react/image.tsx": /*!*****************************!*\
  !*** ./src/react/image.tsx ***!
  \*****************************/ /*! exports provided: SurveyQuestionImage */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionImage", function() {
                return SurveyQuestionImage;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionImage = /** @class */ function(_super) {
                __extends(SurveyQuestionImage, _super);
                function SurveyQuestionImage(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionImage.prototype.componentDidMount = function() {
                    var _this = this;
                    _super.prototype.componentDidMount.call(this);
                    this.question.locImageLink.onChanged = function() {
                        _this.forceUpdate();
                    };
                };
                SurveyQuestionImage.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.question.locImageLink.onChanged = function() {};
                };
                Object.defineProperty(SurveyQuestionImage.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionImage.prototype.renderElement = function() {
                    var _this = this;
                    var cssClasses = this.question.getImageCss();
                    var style = {
                        objectFit: this.question.imageFit,
                        width: this.question.renderedStyleWidth,
                        height: this.question.renderedStyleHeight
                    };
                    if (!this.question.imageLink || this.question.contentNotLoaded) style["display"] = "none";
                    var control = null;
                    if (this.question.renderedMode === "image") control = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("img", {
                        className: cssClasses,
                        src: this.question.locImageLink.renderedHtml,
                        alt: this.question.altText || this.question.title,
                        width: this.question.renderedWidth,
                        height: this.question.renderedHeight,
                        //alt={item.text || item.value}
                        style: style,
                        onLoad: function(event) {
                            _this.question.onLoadHandler();
                        },
                        onError: function(event) {
                            _this.question.onErrorHandler();
                        }
                    });
                    if (this.question.renderedMode === "video") control = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("video", {
                        controls: true,
                        className: cssClasses,
                        src: this.question.locImageLink.renderedHtml,
                        width: this.question.renderedWidth,
                        height: this.question.renderedHeight,
                        style: style,
                        onLoadedMetadata: function(event) {
                            _this.question.onLoadHandler();
                        },
                        onError: function(event) {
                            _this.question.onErrorHandler();
                        }
                    });
                    if (this.question.renderedMode === "youtube") control = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("iframe", {
                        className: cssClasses,
                        src: this.question.locImageLink.renderedHtml,
                        width: this.question.renderedWidth,
                        height: this.question.renderedHeight,
                        style: style
                    });
                    var noImage = null;
                    if (!this.question.imageLink || this.question.contentNotLoaded) noImage = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.noImage
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        iconName: this.question.cssClasses.noImageSvgIconId,
                        size: 48
                    }));
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.root
                    }, control, noImage);
                };
                return SurveyQuestionImage;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("image", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionImage, props);
            });
        /***/ },
        /***/ "./src/react/imagepicker.tsx": /*!***********************************!*\
  !*** ./src/react/imagepicker.tsx ***!
  \***********************************/ /*! exports provided: SurveyQuestionImagePicker, SurveyQuestionImagePickerItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionImagePicker", function() {
                return SurveyQuestionImagePicker;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionImagePickerItem", function() {
                return SurveyQuestionImagePickerItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionImagePicker = /** @class */ function(_super) {
                __extends(SurveyQuestionImagePicker, _super);
                function SurveyQuestionImagePicker(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionImagePicker.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionImagePicker.prototype.renderElement = function() {
                    var cssClasses = this.question.cssClasses;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("fieldset", {
                        className: this.question.getSelectBaseRootCss()
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("legend", {
                        className: "sv-hidden"
                    }, this.question.locTitle.renderedHtml), this.question.hasColumns ? this.getColumns(cssClasses) : this.getItems(cssClasses));
                };
                SurveyQuestionImagePicker.prototype.getColumns = function(cssClasses) {
                    var _this = this;
                    return this.question.columns.map(function(column, ci) {
                        var items = column.map(function(item, ii) {
                            return _this.renderItem("item" + ii, item, cssClasses);
                        });
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            key: "column" + ci,
                            className: _this.question.getColumnClass(),
                            role: "presentation"
                        }, items);
                    });
                };
                SurveyQuestionImagePicker.prototype.getItems = function(cssClasses) {
                    var items = [];
                    for(var i = 0; i < this.question.visibleChoices.length; i++){
                        var item = this.question.visibleChoices[i];
                        var key = "item" + i;
                        items.push(this.renderItem(key, item, cssClasses));
                    }
                    return items;
                };
                Object.defineProperty(SurveyQuestionImagePicker.prototype, "textStyle", {
                    get: function() {
                        return {
                            marginLeft: "3px",
                            display: "inline",
                            position: "static"
                        };
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionImagePicker.prototype.renderItem = function(key, item, cssClasses) {
                    var renderedItem = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionImagePickerItem, {
                        key: key,
                        question: this.question,
                        item: item,
                        cssClasses: cssClasses
                    });
                    var survey = this.question.survey;
                    var wrappedItem = null;
                    if (!!survey) wrappedItem = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_3__["ReactSurveyElementsWrapper"].wrapItemValue(survey, renderedItem, this.question, item);
                    return wrappedItem !== null && wrappedItem !== void 0 ? wrappedItem : renderedItem;
                };
                return SurveyQuestionImagePicker;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            var SurveyQuestionImagePickerItem = /** @class */ function(_super) {
                __extends(SurveyQuestionImagePickerItem, _super);
                function SurveyQuestionImagePickerItem(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnChange = _this.handleOnChange.bind(_this);
                    return _this;
                }
                SurveyQuestionImagePickerItem.prototype.getStateElement = function() {
                    return this.item;
                };
                SurveyQuestionImagePickerItem.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.reactOnStrChanged();
                };
                SurveyQuestionImagePickerItem.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.item.locImageLink.onChanged = function() {};
                };
                SurveyQuestionImagePickerItem.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.reactOnStrChanged();
                };
                SurveyQuestionImagePickerItem.prototype.reactOnStrChanged = function() {
                    var _this = this;
                    this.item.locImageLink.onChanged = function() {
                        _this.setState({
                            locImageLinkchanged: !!_this.state && _this.state.locImageLink ? _this.state.locImageLink + 1 : 1
                        });
                    };
                };
                Object.defineProperty(SurveyQuestionImagePickerItem.prototype, "cssClasses", {
                    get: function() {
                        return this.props.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionImagePickerItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionImagePickerItem.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionImagePickerItem.prototype.handleOnChange = function(event) {
                    if (this.question.multiSelect) {
                        if (event.target.checked) this.question.value = this.question.value.concat(event.target.value);
                        else {
                            var currValue = this.question.value;
                            currValue.splice(this.question.value.indexOf(event.target.value), 1);
                            this.question.value = currValue;
                        }
                    } else this.question.value = event.target.value;
                    this.setState({
                        value: this.question.value
                    });
                };
                SurveyQuestionImagePickerItem.prototype.renderElement = function() {
                    var _this = this;
                    var item = this.item;
                    var question = this.question;
                    var cssClasses = this.cssClasses;
                    var isChecked = question.isItemSelected(item);
                    var itemClass = question.getItemClass(item);
                    var text = null;
                    if (question.showLabel) text = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: question.cssClasses.itemText
                    }, item.text ? _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"].renderLocString(item.locText) : item.value);
                    var style = {
                        objectFit: this.question.imageFit
                    };
                    var control = null;
                    if (item.locImageLink.renderedHtml && this.question.contentMode === "image") control = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("img", {
                        className: cssClasses.image,
                        src: item.locImageLink.renderedHtml,
                        width: this.question.renderedImageWidth,
                        height: this.question.renderedImageHeight,
                        alt: item.locText.renderedHtml,
                        style: style,
                        onLoad: function(event) {
                            _this.question["onContentLoaded"](item, event.nativeEvent);
                        },
                        onError: function(event) {
                            item.onErrorHandler(item, event.nativeEvent);
                        }
                    });
                    if (item.locImageLink.renderedHtml && this.question.contentMode === "video") control = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("video", {
                        controls: true,
                        className: cssClasses.image,
                        src: item.locImageLink.renderedHtml,
                        width: this.question.renderedImageWidth,
                        height: this.question.renderedImageHeight,
                        style: style,
                        onLoadedMetadata: function(event) {
                            _this.question["onContentLoaded"](item, event.nativeEvent);
                        },
                        onError: function(event) {
                            item.onErrorHandler(item, event.nativeEvent);
                        }
                    });
                    if (!item.locImageLink.renderedHtml || item.contentNotLoaded) {
                        var style_1 = {
                            width: this.question.renderedImageWidth,
                            height: this.question.renderedImageHeight,
                            objectFit: this.question.imageFit
                        };
                        control = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: cssClasses.itemNoImage,
                            style: style_1
                        }, cssClasses.itemNoImageSvgIcon ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__["SvgIcon"], {
                            className: cssClasses.itemNoImageSvgIcon,
                            iconName: this.question.cssClasses.itemNoImageSvgIconId,
                            size: 48
                        }) : null);
                    }
                    var renderedItem = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: itemClass
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("label", {
                        className: cssClasses.label
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        className: cssClasses.itemControl,
                        id: this.question.getItemId(item),
                        type: this.question.inputType,
                        name: this.question.questionName,
                        checked: isChecked,
                        value: item.value,
                        disabled: !this.question.getItemEnabled(item),
                        onChange: this.handleOnChange,
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.itemDecorator
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.imageContainer
                    }, !!this.question.cssClasses.checkedItemDecorator ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.question.cssClasses.checkedItemDecorator
                    }, !!this.question.cssClasses.checkedItemSvgIconId ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_4__["SvgIcon"], {
                        size: "auto",
                        className: this.question.cssClasses.checkedItemSvgIcon,
                        iconName: this.question.cssClasses.checkedItemSvgIconId
                    }) : null) : null, control), text)));
                    return renderedItem;
                };
                return SurveyQuestionImagePickerItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("imagepicker", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionImagePicker, props);
            });
        /***/ },
        /***/ "./src/react/page.tsx": /*!****************************!*\
  !*** ./src/react/page.tsx ***!
  \****************************/ /*! exports provided: SurveyPage */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPage", function() {
                return SurveyPage;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _panel_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./panel-base */ "./src/react/panel-base.tsx");
            /* harmony import */ var _components_title_title_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/title/title-element */ "./src/react/components/title/title-element.tsx");
            /* harmony import */ var _reactquestion__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./reactquestion */ "./src/react/reactquestion.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyPage = /** @class */ function(_super) {
                __extends(SurveyPage, _super);
                function SurveyPage(props) {
                    return _super.call(this, props) || this;
                }
                SurveyPage.prototype.getPanelBase = function() {
                    return this.props.page;
                };
                Object.defineProperty(SurveyPage.prototype, "page", {
                    get: function() {
                        return this.panelBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                // shouldComponentUpdate(nextProps: any, nextState: any): boolean {
                //   if(!super.shouldComponentUpdate(nextProps, nextState)) return false;
                //   return true;
                // }
                SurveyPage.prototype.renderElement = function() {
                    var title = this.renderTitle();
                    var description = this.renderDescription();
                    var rows = this.renderRows(this.panelBase.cssClasses);
                    var errors = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion__WEBPACK_IMPORTED_MODULE_4__["SurveyElementErrors"], {
                        element: this.panelBase,
                        cssClasses: this.panelBase.cssClasses,
                        creator: this.creator
                    });
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        ref: this.rootRef,
                        className: this.page.cssRoot
                    }, title, description, errors, rows);
                };
                SurveyPage.prototype.renderTitle = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_title_title_element__WEBPACK_IMPORTED_MODULE_3__["TitleElement"], {
                        element: this.page
                    });
                };
                SurveyPage.prototype.renderDescription = function() {
                    if (!this.page._showDescription) return null;
                    var text = _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"].renderLocString(this.page.locDescription);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.panelBase.cssClasses.page.description
                    }, text);
                };
                return SurveyPage;
            }(_panel_base__WEBPACK_IMPORTED_MODULE_2__["SurveyPanelBase"]);
        /***/ },
        /***/ "./src/react/panel-base.tsx": /*!**********************************!*\
  !*** ./src/react/panel-base.tsx ***!
  \**********************************/ /*! exports provided: SurveyPanelBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPanelBase", function() {
                return SurveyPanelBase;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _row__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./row */ "./src/react/row.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyPanelBase = /** @class */ function(_super) {
                __extends(SurveyPanelBase, _super);
                function SurveyPanelBase(props) {
                    var _this = _super.call(this, props) || this;
                    _this.rootRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    return _this;
                }
                SurveyPanelBase.prototype.getStateElement = function() {
                    return this.panelBase;
                };
                SurveyPanelBase.prototype.canUsePropInState = function(key) {
                    return key !== "elements" && _super.prototype.canUsePropInState.call(this, key);
                };
                Object.defineProperty(SurveyPanelBase.prototype, "survey", {
                    get: function() {
                        return this.getSurvey();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyPanelBase.prototype, "creator", {
                    get: function() {
                        return this.props.creator;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyPanelBase.prototype, "css", {
                    get: function() {
                        return this.getCss();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyPanelBase.prototype, "panelBase", {
                    get: function() {
                        return this.getPanelBase();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyPanelBase.prototype.getPanelBase = function() {
                    return this.props.element || this.props.question;
                };
                SurveyPanelBase.prototype.getSurvey = function() {
                    return this.props.survey || (!!this.panelBase ? this.panelBase.survey : null);
                };
                SurveyPanelBase.prototype.getCss = function() {
                    return this.props.css;
                };
                SurveyPanelBase.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.doAfterRender();
                };
                SurveyPanelBase.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    var el = this.rootRef.current;
                    if (!!el) el.removeAttribute("data-rendered");
                };
                SurveyPanelBase.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    if (!!prevProps.page && !!this.survey && !!this.survey.activePage && prevProps.page.id === this.survey.activePage.id) return;
                    this.doAfterRender();
                };
                SurveyPanelBase.prototype.doAfterRender = function() {
                    var el = this.rootRef.current;
                    if (el && this.survey) {
                        if (this.panelBase.isPanel) this.survey.afterRenderPanel(this.panelBase, el);
                        else this.survey.afterRenderPage(el);
                    }
                };
                SurveyPanelBase.prototype.getIsVisible = function() {
                    return this.panelBase.isVisible;
                };
                SurveyPanelBase.prototype.canRender = function() {
                    return _super.prototype.canRender.call(this) && !!this.survey && !!this.panelBase && !!this.panelBase.survey && this.getIsVisible();
                };
                SurveyPanelBase.prototype.renderRows = function(css) {
                    var _this = this;
                    return this.panelBase.visibleRows.map(function(row) {
                        return _this.createRow(row, css);
                    });
                };
                SurveyPanelBase.prototype.createRow = function(row, css) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_row__WEBPACK_IMPORTED_MODULE_2__["SurveyRow"], {
                        key: row.id,
                        row: row,
                        survey: this.survey,
                        creator: this.creator,
                        css: css
                    });
                };
                return SurveyPanelBase;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"]);
        /***/ },
        /***/ "./src/react/panel.tsx": /*!*****************************!*\
  !*** ./src/react/panel.tsx ***!
  \*****************************/ /*! exports provided: SurveyPanel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyPanel", function() {
                return SurveyPanel;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion */ "./src/react/reactquestion.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _panel_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./panel-base */ "./src/react/panel-base.tsx");
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            /* harmony import */ var _components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            /* harmony import */ var _components_title_title_element__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/title/title-element */ "./src/react/components/title/title-element.tsx");
            /* harmony import */ var _element_header__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./element-header */ "./src/react/element-header.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyPanel = /** @class */ function(_super) {
                __extends(SurveyPanel, _super);
                function SurveyPanel(props) {
                    var _this = _super.call(this, props) || this;
                    _this.hasBeenExpanded = false;
                    return _this;
                }
                Object.defineProperty(SurveyPanel.prototype, "panel", {
                    get: function() {
                        return this.panelBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyPanel.prototype.renderElement = function() {
                    var _this = this;
                    var header = this.renderHeader();
                    var errors = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion__WEBPACK_IMPORTED_MODULE_1__["SurveyElementErrors"], {
                        element: this.panelBase,
                        cssClasses: this.panelBase.cssClasses,
                        creator: this.creator
                    });
                    var style = {
                        paddingLeft: this.panel.innerPaddingLeft,
                        display: this.panel.renderedIsExpanded ? undefined : "none"
                    };
                    var content = null;
                    if (this.panel.renderedIsExpanded) {
                        // this.hasBeenExpanded = true;
                        var rows = this.renderRows(this.panelBase.cssClasses);
                        var className = this.panelBase.cssClasses.panel.content;
                        content = this.renderContent(style, rows, className);
                    }
                    var focusIn = function() {
                        if (_this.panelBase) _this.panelBase.focusIn();
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        ref: this.rootRef,
                        className: this.panelBase.getContainerCss(),
                        onFocus: focusIn,
                        id: this.panelBase.id
                    }, this.panel.showErrorsAbovePanel ? errors : null, header, this.panel.showErrorsAbovePanel ? null : errors, content);
                };
                SurveyPanel.prototype.renderHeader = function() {
                    if (!this.panel.hasTitle && !this.panel.hasDescription) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_element_header__WEBPACK_IMPORTED_MODULE_8__["SurveyElementHeader"], {
                        element: this.panel
                    });
                };
                SurveyPanel.prototype.wrapElement = function(element) {
                    var survey = this.panel.survey;
                    var wrapper = null;
                    if (survey) wrapper = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_5__["ReactSurveyElementsWrapper"].wrapElement(survey, element, this.panel);
                    return wrapper !== null && wrapper !== void 0 ? wrapper : element;
                };
                SurveyPanel.prototype.renderContent = function(style, rows, className) {
                    var bottom = this.renderBottom();
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        style: style,
                        className: className,
                        id: this.panel.contentId
                    }, rows, bottom);
                };
                SurveyPanel.prototype.renderTitle = function() {
                    if (!this.panelBase.title) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_title_title_element__WEBPACK_IMPORTED_MODULE_7__["TitleElement"], {
                        element: this.panelBase
                    });
                };
                SurveyPanel.prototype.renderDescription = function() {
                    if (!this.panelBase.description) return null;
                    var text = _reactquestion_element__WEBPACK_IMPORTED_MODULE_2__["SurveyElementBase"].renderLocString(this.panelBase.locDescription);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.panel.cssClasses.panel.description
                    }, text);
                };
                SurveyPanel.prototype.renderBottom = function() {
                    var footerToolbar = this.panel.getFooterToolbar();
                    if (!footerToolbar.hasActions) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_6__["SurveyActionBar"], {
                        model: footerToolbar
                    });
                };
                SurveyPanel.prototype.getIsVisible = function() {
                    return this.panelBase.getIsContentVisible();
                };
                return SurveyPanel;
            }(_panel_base__WEBPACK_IMPORTED_MODULE_4__["SurveyPanelBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("panel", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyPanel, props);
            });
        /***/ },
        /***/ "./src/react/progress.tsx": /*!********************************!*\
  !*** ./src/react/progress.tsx ***!
  \********************************/ /*! exports provided: SurveyProgress */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyProgress", function() {
                return SurveyProgress;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _reactSurveyNavigationBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactSurveyNavigationBase */ "./src/react/reactSurveyNavigationBase.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyProgress = /** @class */ function(_super) {
                __extends(SurveyProgress, _super);
                function SurveyProgress(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyProgress.prototype, "isTop", {
                    get: function() {
                        return this.props.isTop;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyProgress.prototype, "progress", {
                    get: function() {
                        return this.survey.progressValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyProgress.prototype, "progressText", {
                    get: function() {
                        return this.survey.progressText;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyProgress.prototype.render = function() {
                    var progressStyle = {
                        width: this.progress + "%"
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.survey.getProgressCssClasses(this.props.container)
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        style: progressStyle,
                        className: this.css.progressBar,
                        role: "progressbar",
                        "aria-valuemin": 0,
                        "aria-valuemax": 100,
                        "aria-label": "progress"
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: survey_core__WEBPACK_IMPORTED_MODULE_1__["SurveyProgressModel"].getProgressTextInBarCss(this.css)
                    }, this.progressText)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: survey_core__WEBPACK_IMPORTED_MODULE_1__["SurveyProgressModel"].getProgressTextUnderBarCss(this.css)
                    }, this.progressText));
                };
                return SurveyProgress;
            }(_reactSurveyNavigationBase__WEBPACK_IMPORTED_MODULE_2__["SurveyNavigationBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("sv-progress-pages", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyProgress, props);
            });
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("sv-progress-questions", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyProgress, props);
            });
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("sv-progress-correctquestions", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyProgress, props);
            });
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("sv-progress-requiredquestions", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyProgress, props);
            });
        /***/ },
        /***/ "./src/react/progressButtons.tsx": /*!***************************************!*\
  !*** ./src/react/progressButtons.tsx ***!
  \***************************************/ /*! exports provided: SurveyProgressButtons */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressButtons", function() {
                return SurveyProgressButtons;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _reactSurveyNavigationBase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactSurveyNavigationBase */ "./src/react/reactSurveyNavigationBase.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyProgressButtons = /** @class */ function(_super) {
                __extends(SurveyProgressButtons, _super);
                function SurveyProgressButtons(props) {
                    var _this = _super.call(this, props) || this;
                    _this.listContainerRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    return _this;
                }
                Object.defineProperty(SurveyProgressButtons.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyProgressButtons.prototype, "container", {
                    get: function() {
                        return this.props.container;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyProgressButtons.prototype.onResize = function(canShowItemTitles) {
                    this.setState({
                        canShowItemTitles: canShowItemTitles
                    });
                    this.setState({
                        canShowHeader: !canShowItemTitles
                    });
                };
                SurveyProgressButtons.prototype.onUpdateScroller = function(hasScroller) {
                    this.setState({
                        hasScroller: hasScroller
                    });
                };
                SurveyProgressButtons.prototype.onUpdateSettings = function() {
                    this.setState({
                        canShowItemTitles: this.model.showItemTitles
                    });
                    this.setState({
                        canShowFooter: !this.model.showItemTitles
                    });
                };
                SurveyProgressButtons.prototype.render = function() {
                    var _this = this;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.model.getRootCss(this.props.container),
                        style: {
                            "maxWidth": this.model.progressWidth
                        },
                        role: "progressbar",
                        "aria-valuemin": 0,
                        "aria-valuemax": 100,
                        "aria-label": "progress"
                    }, this.state.canShowHeader ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsHeader
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsPageTitle,
                        title: this.model.headerText
                    }, this.model.headerText)) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsContainer
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.model.getScrollButtonCss(this.state.hasScroller, true),
                        role: "button",
                        onClick: function() {
                            return _this.clickScrollButton(_this.listContainerRef.current, true);
                        }
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsListContainer,
                        ref: this.listContainerRef
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("ul", {
                        className: this.css.progressButtonsList
                    }, this.getListElements())), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.model.getScrollButtonCss(this.state.hasScroller, false),
                        role: "button",
                        onClick: function() {
                            return _this.clickScrollButton(_this.listContainerRef.current, false);
                        }
                    })), this.state.canShowFooter ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsFooter
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsPageTitle,
                        title: this.model.footerText
                    }, this.model.footerText)) : null);
                };
                SurveyProgressButtons.prototype.getListElements = function() {
                    var _this = this;
                    var buttons = [];
                    this.survey.visiblePages.forEach(function(page, index) {
                        buttons.push(_this.renderListElement(page, index));
                    });
                    return buttons;
                };
                SurveyProgressButtons.prototype.renderListElement = function(page, index) {
                    var _this = this;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("li", {
                        key: "listelement" + index,
                        className: this.model.getListElementCss(index),
                        onClick: this.model.isListElementClickable(index) ? function() {
                            return _this.model.clickListElement(page);
                        } : undefined,
                        "data-page-number": this.model.getItemNumber(page)
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsConnector
                    }), this.state.canShowItemTitles ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsPageTitle,
                        title: page.renderedNavigationTitle
                    }, page.renderedNavigationTitle), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsPageDescription,
                        title: page.navigationDescription
                    }, page.navigationDescription)) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsButton
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsButtonBackground
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.progressButtonsButtonContent
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, this.model.getItemNumber(page))));
                };
                SurveyProgressButtons.prototype.clickScrollButton = function(listContainerElement, isLeftScroll) {
                    if (!!listContainerElement) listContainerElement.scrollLeft += (isLeftScroll ? -1 : 1) * 70;
                };
                SurveyProgressButtons.prototype.componentDidMount = function() {
                    var _this = this;
                    _super.prototype.componentDidMount.call(this);
                    setTimeout(function() {
                        _this.respManager = new survey_core__WEBPACK_IMPORTED_MODULE_1__["ProgressButtonsResponsivityManager"](_this.model, _this.listContainerRef.current, _this);
                    }, 10);
                };
                SurveyProgressButtons.prototype.componentWillUnmount = function() {
                    if (!!this.respManager) this.respManager.dispose();
                    _super.prototype.componentWillUnmount.call(this);
                };
                return SurveyProgressButtons;
            }(_reactSurveyNavigationBase__WEBPACK_IMPORTED_MODULE_2__["SurveyNavigationBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("sv-progress-buttons", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyProgressButtons, props);
            });
        /***/ },
        /***/ "./src/react/progressToc.tsx": /*!***********************************!*\
  !*** ./src/react/progressToc.tsx ***!
  \***********************************/ /*! exports provided: SurveyProgressToc */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyProgressToc", function() {
                return SurveyProgressToc;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactSurveyNavigationBase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactSurveyNavigationBase */ "./src/react/reactSurveyNavigationBase.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _components_list_list__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/list/list */ "./src/react/components/list/list.tsx");
            /* harmony import */ var _components_popup_popup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/popup/popup */ "./src/react/components/popup/popup.tsx");
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyProgressToc = /** @class */ function(_super) {
                __extends(SurveyProgressToc, _super);
                function SurveyProgressToc() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                SurveyProgressToc.prototype.render = function() {
                    var tocModel = this.props.model;
                    var content;
                    if (tocModel.isMobile) content = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        onClick: tocModel.togglePopup
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_5__["SvgIcon"], {
                        iconName: tocModel.icon,
                        size: 24
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_popup_popup__WEBPACK_IMPORTED_MODULE_4__["Popup"], {
                        model: tocModel.popupModel
                    }));
                    else content = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_list_list__WEBPACK_IMPORTED_MODULE_3__["List"], {
                        model: tocModel.listModel
                    });
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: tocModel.containerCss
                    }, content);
                };
                return SurveyProgressToc;
            }(_reactSurveyNavigationBase__WEBPACK_IMPORTED_MODULE_1__["SurveyNavigationBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("sv-navigation-toc", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyProgressToc, props);
            });
        /***/ },
        /***/ "./src/react/rating-dropdown.tsx": /*!***************************************!*\
  !*** ./src/react/rating-dropdown.tsx ***!
  \***************************************/ /*! exports provided: RatingDropdownItem, SurveyQuestionRatingDropdown */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRatingDropdown", function() {
                return SurveyQuestionRatingDropdown;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _dropdown_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./dropdown-base */ "./src/react/dropdown-base.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _components_rating_rating_dropdown_item__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/rating/rating-dropdown-item */ "./src/react/components/rating/rating-dropdown-item.tsx");
            /* harmony reexport (safe) */ __webpack_require__.d(__webpack_exports__, "RatingDropdownItem", function() {
                return _components_rating_rating_dropdown_item__WEBPACK_IMPORTED_MODULE_4__["RatingDropdownItem"];
            });
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionRatingDropdown = /** @class */ function(_super) {
                __extends(SurveyQuestionRatingDropdown, _super);
                function SurveyQuestionRatingDropdown(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionRatingDropdown.prototype.renderElement = function() {
                    var cssClasses = this.question.cssClasses;
                    var select = this.renderSelect(cssClasses);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.rootDropdown
                    }, select);
                };
                return SurveyQuestionRatingDropdown;
            }(_dropdown_base__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionDropdownBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__["ReactQuestionFactory"].Instance.registerQuestion("sv-rating-dropdown", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionRatingDropdown, props);
            });
            survey_core__WEBPACK_IMPORTED_MODULE_1__["RendererFactory"].Instance.registerRenderer("rating", "dropdown", "sv-rating-dropdown");
        /***/ },
        /***/ "./src/react/react-popup-survey.tsx": /*!******************************************!*\
  !*** ./src/react/react-popup-survey.tsx ***!
  \******************************************/ /*! exports provided: PopupSurvey, SurveyWindow */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "PopupSurvey", function() {
                return PopupSurvey;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyWindow", function() {
                return SurveyWindow;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _reactSurvey__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactSurvey */ "./src/react/reactSurvey.tsx");
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var PopupSurvey = /** @class */ function(_super) {
                __extends(PopupSurvey, _super);
                function PopupSurvey(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnExpanded = _this.handleOnExpanded.bind(_this);
                    return _this;
                }
                PopupSurvey.prototype.getStateElements = function() {
                    return [
                        this.popup,
                        this.popup.survey
                    ];
                };
                PopupSurvey.prototype.handleOnExpanded = function(event) {
                    this.popup.changeExpandCollapse();
                };
                PopupSurvey.prototype.canRender = function() {
                    return _super.prototype.canRender.call(this) && this.popup.isShowing;
                };
                PopupSurvey.prototype.renderElement = function() {
                    var _this = this;
                    var header = this.renderWindowHeader();
                    var body = this.renderBody();
                    var style = {};
                    if (!!this.popup.renderedWidth) {
                        style.width = this.popup.renderedWidth;
                        style.maxWidth = this.popup.renderedWidth;
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.popup.cssRoot,
                        style: style,
                        onScroll: function() {
                            return _this.popup.onScroll();
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.popup.cssRootContent
                    }, header, body));
                };
                PopupSurvey.prototype.renderWindowHeader = function() {
                    var popup = this.popup;
                    var headerCss = popup.cssHeaderRoot;
                    var titleCollapsed = null;
                    var expandCollapseIcon;
                    var closeButton = null;
                    var allowFullScreenButon = null;
                    if (popup.isCollapsed) {
                        headerCss += " " + popup.cssRootCollapsedMod;
                        titleCollapsed = this.renderTitleCollapsed(popup);
                        expandCollapseIcon = this.renderExpandIcon();
                    } else expandCollapseIcon = this.renderCollapseIcon();
                    if (popup.allowClose) closeButton = this.renderCloseButton(this.popup);
                    if (popup.allowFullScreen) allowFullScreenButon = this.renderAllowFullScreenButon(this.popup);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: popup.cssHeaderRoot
                    }, titleCollapsed, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: popup.cssHeaderButtonsContainer
                    }, allowFullScreenButon, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: popup.cssHeaderCollapseButton,
                        onClick: this.handleOnExpanded
                    }, expandCollapseIcon), closeButton));
                };
                PopupSurvey.prototype.renderTitleCollapsed = function(popup) {
                    if (!popup.locTitle) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: popup.cssHeaderTitleCollapsed
                    }, popup.locTitle.renderedHtml);
                };
                PopupSurvey.prototype.renderExpandIcon = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        iconName: "icon-restore_16x16",
                        size: 16
                    });
                };
                PopupSurvey.prototype.renderCollapseIcon = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        iconName: "icon-minimize_16x16",
                        size: 16
                    });
                };
                PopupSurvey.prototype.renderCloseButton = function(popup) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: popup.cssHeaderCloseButton,
                        onClick: function() {
                            popup.hide();
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        iconName: "icon-close_16x16",
                        size: 16
                    }));
                };
                PopupSurvey.prototype.renderAllowFullScreenButon = function(popup) {
                    var Icon;
                    if (popup.isFullScreen) Icon = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        iconName: "icon-back-to-panel_16x16",
                        size: 16
                    });
                    else Icon = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        iconName: "icon-full-screen_16x16",
                        size: 16
                    });
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: popup.cssHeaderFullScreenButton,
                        onClick: function() {
                            popup.toggleFullScreen();
                        }
                    }, Icon);
                };
                PopupSurvey.prototype.renderBody = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.popup.cssBody
                    }, this.doRender());
                };
                PopupSurvey.prototype.createSurvey = function(newProps) {
                    if (!newProps) newProps = {};
                    _super.prototype.createSurvey.call(this, newProps);
                    this.popup = new survey_core__WEBPACK_IMPORTED_MODULE_1__["PopupSurveyModel"](null, this.survey);
                    if (newProps.closeOnCompleteTimeout) this.popup.closeOnCompleteTimeout = newProps.closeOnCompleteTimeout;
                    this.popup.allowClose = newProps.allowClose;
                    this.popup.allowFullScreen = newProps.allowFullScreen;
                    this.popup.isShowing = true;
                    if (!this.popup.isExpanded && (newProps.expanded || newProps.isExpanded)) this.popup.expand();
                };
                return PopupSurvey;
            }(_reactSurvey__WEBPACK_IMPORTED_MODULE_2__["Survey"]);
            /**
 * Obsolete. Please use PopupSurvey
 */ var SurveyWindow = /** @class */ function(_super) {
                __extends(SurveyWindow, _super);
                function SurveyWindow() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                return SurveyWindow;
            }(PopupSurvey);
        /***/ },
        /***/ "./src/react/reactSurvey.tsx": /*!***********************************!*\
  !*** ./src/react/reactSurvey.tsx ***!
  \***********************************/ /*! exports provided: Survey, attachKey2click */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Survey", function() {
                return Survey;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "attachKey2click", function() {
                return attachKey2click;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _page__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./page */ "./src/react/page.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _string_viewer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./string-viewer */ "./src/react/string-viewer.tsx");
            /* harmony import */ var _components_survey_header_survey_header__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/survey-header/survey-header */ "./src/react/components/survey-header/survey-header.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _components_brand_info__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/brand-info */ "./src/react/components/brand-info.tsx");
            /* harmony import */ var _components_notifier__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./components/notifier */ "./src/react/components/notifier.tsx");
            /* harmony import */ var _components_components_container__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./components/components-container */ "./src/react/components/components-container.tsx");
            /* harmony import */ var _svgbundle__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./svgbundle */ "./src/react/svgbundle.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __assign = function() {
                __assign = Object.assign || function(t) {
                    for(var s, i = 1, n = arguments.length; i < n; i++){
                        s = arguments[i];
                        for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
                    }
                    return t;
                };
                return __assign.apply(this, arguments);
            };
            var Survey = /** @class */ function(_super) {
                __extends(Survey, _super);
                function Survey(props) {
                    var _this = _super.call(this, props) || this;
                    _this.previousJSON = {};
                    _this.isSurveyUpdated = false;
                    _this.createSurvey(props);
                    _this.updateSurvey(props, {});
                    _this.rootRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    _this.rootNodeId = props.id || null;
                    _this.rootNodeClassName = props.className || "";
                    return _this;
                }
                Object.defineProperty(Survey, "cssType", {
                    get: function() {
                        return survey_core__WEBPACK_IMPORTED_MODULE_1__["surveyCss"].currentType;
                    },
                    set: function(value) {
                        survey_core__WEBPACK_IMPORTED_MODULE_1__["StylesManager"].applyTheme(value);
                    },
                    enumerable: false,
                    configurable: true
                });
                Survey.prototype.getStateElement = function() {
                    return this.survey;
                };
                Survey.prototype.onSurveyUpdated = function() {
                    if (!!this.survey) {
                        var el = this.rootRef.current;
                        if (!!el) this.survey.afterRenderSurvey(el);
                        this.survey.startTimerFromUI();
                    }
                };
                Survey.prototype.shouldComponentUpdate = function(nextProps, nextState) {
                    if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState)) return false;
                    if (this.isModelJSONChanged(nextProps)) {
                        this.destroySurvey();
                        this.createSurvey(nextProps);
                        this.updateSurvey(nextProps, {});
                        this.isSurveyUpdated = true;
                    }
                    return true;
                };
                Survey.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.updateSurvey(this.props, prevProps);
                    if (this.isSurveyUpdated) {
                        this.onSurveyUpdated();
                        this.isSurveyUpdated = false;
                    }
                };
                Survey.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.onSurveyUpdated();
                };
                Survey.prototype.destroySurvey = function() {
                    if (this.survey) {
                        this.survey.renderCallback = undefined;
                        this.survey.onPartialSend.clear();
                        this.survey.stopTimer();
                        this.survey.destroyResizeObserver();
                    }
                };
                Survey.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.destroySurvey();
                };
                Survey.prototype.doRender = function() {
                    var renderResult;
                    if (this.survey.state == "completed") renderResult = this.renderCompleted();
                    else if (this.survey.state == "completedbefore") renderResult = this.renderCompletedBefore();
                    else if (this.survey.state == "loading") renderResult = this.renderLoading();
                    else if (this.survey.state == "empty") renderResult = this.renderEmptySurvey();
                    else renderResult = this.renderSurvey();
                    var backgroundImage = !!this.survey.backgroundImage ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.rootBackgroundImage,
                        style: this.survey.backgroundImageStyle
                    }) : null;
                    var header = this.survey.headerView === "basic" ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_survey_header_survey_header__WEBPACK_IMPORTED_MODULE_5__["SurveyHeader"], {
                        survey: this.survey
                    }) : null;
                    var onSubmit = function(event) {
                        event.preventDefault();
                    };
                    var customHeader = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: "sv_custom_header"
                    });
                    if (this.survey.hasLogo) customHeader = null;
                    var rootCss = this.survey.getRootCss();
                    var cssClasses = this.rootNodeClassName ? this.rootNodeClassName + " " + rootCss : rootCss;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        id: this.rootNodeId,
                        ref: this.rootRef,
                        className: cssClasses,
                        style: this.survey.themeVariables
                    }, this.survey.needRenderIcons ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_svgbundle__WEBPACK_IMPORTED_MODULE_11__["SvgBundleComponent"], null) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.survey.wrapperFormCss
                    }, backgroundImage, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("form", {
                        onSubmit: onSubmit
                    }, customHeader, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.container
                    }, header, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_components_container__WEBPACK_IMPORTED_MODULE_10__["ComponentsContainer"], {
                        survey: this.survey,
                        container: "header",
                        needRenderWrapper: false
                    }), renderResult, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_components_container__WEBPACK_IMPORTED_MODULE_10__["ComponentsContainer"], {
                        survey: this.survey,
                        container: "footer",
                        needRenderWrapper: false
                    }))), this.survey.showBrandInfo ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_brand_info__WEBPACK_IMPORTED_MODULE_8__["BrandInfo"], null) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_notifier__WEBPACK_IMPORTED_MODULE_9__["NotifierComponent"], {
                        notifier: this.survey.notifier
                    })));
                };
                Survey.prototype.renderElement = function() {
                    return this.doRender();
                };
                Object.defineProperty(Survey.prototype, "css", {
                    get: function() {
                        return this.survey.css;
                    },
                    set: function(value) {
                        this.survey.css = value;
                    },
                    enumerable: false,
                    configurable: true
                });
                Survey.prototype.renderCompleted = function() {
                    if (!this.survey.showCompletedPage) return null;
                    var htmlValue = {
                        __html: this.survey.processedCompletedHtml
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        dangerouslySetInnerHTML: htmlValue,
                        className: this.survey.completedCss
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_components_container__WEBPACK_IMPORTED_MODULE_10__["ComponentsContainer"], {
                        survey: this.survey,
                        container: "completePage",
                        needRenderWrapper: false
                    }));
                };
                Survey.prototype.renderCompletedBefore = function() {
                    var htmlValue = {
                        __html: this.survey.processedCompletedBeforeHtml
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        dangerouslySetInnerHTML: htmlValue,
                        className: this.survey.completedBeforeCss
                    });
                };
                Survey.prototype.renderLoading = function() {
                    var htmlValue = {
                        __html: this.survey.processedLoadingHtml
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        dangerouslySetInnerHTML: htmlValue,
                        className: this.survey.loadingBodyCss
                    });
                };
                Survey.prototype.renderSurvey = function() {
                    var activePage = this.survey.activePage ? this.renderPage(this.survey.activePage) : null;
                    var isStaring = this.survey.isShowStartingPage;
                    var pageId = this.survey.activePage ? this.survey.activePage.id : "";
                    var className = this.survey.bodyCss;
                    var style = {};
                    if (!!this.survey.renderedWidth) style.maxWidth = this.survey.renderedWidth;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.survey.bodyContainerCss
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_components_container__WEBPACK_IMPORTED_MODULE_10__["ComponentsContainer"], {
                        survey: this.survey,
                        container: "left"
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: "sv-components-column sv-components-column--expandable"
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_components_container__WEBPACK_IMPORTED_MODULE_10__["ComponentsContainer"], {
                        survey: this.survey,
                        container: "center"
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        id: pageId,
                        className: className,
                        style: style
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_components_container__WEBPACK_IMPORTED_MODULE_10__["ComponentsContainer"], {
                        survey: this.survey,
                        container: "contentTop"
                    }), activePage, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_components_container__WEBPACK_IMPORTED_MODULE_10__["ComponentsContainer"], {
                        survey: this.survey,
                        container: "contentBottom"
                    }))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_components_container__WEBPACK_IMPORTED_MODULE_10__["ComponentsContainer"], {
                        survey: this.survey,
                        container: "right"
                    }));
                };
                Survey.prototype.renderPage = function(page) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_page__WEBPACK_IMPORTED_MODULE_2__["SurveyPage"], {
                        survey: this.survey,
                        page: page,
                        css: this.css,
                        creator: this
                    });
                };
                Survey.prototype.renderEmptySurvey = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.css.bodyEmpty
                    }, this.survey.emptySurveyText);
                };
                Survey.prototype.createSurvey = function(newProps) {
                    if (!newProps) newProps = {};
                    this.previousJSON = {};
                    if (newProps) {
                        if (newProps.model) this.survey = newProps.model;
                        else if (newProps.json) {
                            this.previousJSON = newProps.json;
                            this.survey = new survey_core__WEBPACK_IMPORTED_MODULE_1__["SurveyModel"](newProps.json);
                        }
                    } else this.survey = new survey_core__WEBPACK_IMPORTED_MODULE_1__["SurveyModel"]();
                    if (!!newProps.css) this.survey.css = this.css;
                    this.setSurveyEvents();
                };
                Survey.prototype.isModelJSONChanged = function(newProps) {
                    if (!!newProps["model"]) return this.survey !== newProps["model"];
                    if (!!newProps["json"]) return !survey_core__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(newProps["json"], this.previousJSON);
                    return false;
                };
                Survey.prototype.updateSurvey = function(newProps, oldProps) {
                    if (!newProps) return;
                    oldProps = oldProps || {};
                    for(var key in newProps){
                        if (key == "model" || key == "children" || key == "json") continue;
                        if (key == "css") {
                            this.survey.mergeValues(newProps.css, this.survey.getCss());
                            this.survey["updateNavigationCss"]();
                            this.survey["updateElementCss"]();
                            continue;
                        }
                        if (newProps[key] === oldProps[key]) continue;
                        if (key.indexOf("on") == 0 && this.survey[key] && this.survey[key].add) {
                            if (!!oldProps[key]) this.survey[key].remove(oldProps[key]);
                            this.survey[key].add(newProps[key]);
                        } else this.survey[key] = newProps[key];
                    }
                };
                Survey.prototype.setSurveyEvents = function() {
                    var self = this;
                    this.survey.renderCallback = function() {
                        var counter = !!self.state && !!self.state.modelChanged ? self.state.modelChanged : 0;
                        self.setState({
                            modelChanged: counter + 1
                        });
                    };
                    this.survey.onPartialSend.add(function(sender) {
                        if (!!self.state) self.setState(self.state);
                    });
                };
                //ISurveyCreator
                Survey.prototype.createQuestionElement = function(question) {
                    return _reactquestion_factory__WEBPACK_IMPORTED_MODULE_6__["ReactQuestionFactory"].Instance.createQuestion(question.isDefaultRendering() ? question.getTemplate() : question.getComponentName(), {
                        question: question,
                        isDisplayMode: question.isInputReadOnly,
                        creator: this
                    });
                };
                Survey.prototype.renderError = function(key, error, cssClasses) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        key: key
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.error.icon || undefined,
                        "aria-hidden": "true"
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.error.item || undefined
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_string_viewer__WEBPACK_IMPORTED_MODULE_4__["SurveyLocStringViewer"], {
                        locStr: error.locText
                    })));
                };
                Survey.prototype.questionTitleLocation = function() {
                    return this.survey.questionTitleLocation;
                };
                Survey.prototype.questionErrorLocation = function() {
                    return this.survey.questionErrorLocation;
                };
                return Survey;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_7__["ReactElementFactory"].Instance.registerElement("survey", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](Survey, props);
            });
            function attachKey2click(element, viewModel, options) {
                if (options === void 0) options = {
                    processEsc: true,
                    disableTabStop: false
                };
                if (!!viewModel && viewModel.disableTabStop || !!options && options.disableTabStop) return react__WEBPACK_IMPORTED_MODULE_0__["cloneElement"](element, {
                    tabIndex: -1
                });
                options = __assign({}, options);
                return react__WEBPACK_IMPORTED_MODULE_0__["cloneElement"](element, {
                    tabIndex: 0,
                    onKeyUp: function(evt) {
                        evt.preventDefault();
                        evt.stopPropagation();
                        Object(survey_core__WEBPACK_IMPORTED_MODULE_1__["doKey2ClickUp"])(evt, options);
                        return false;
                    },
                    onKeyDown: function(evt) {
                        return Object(survey_core__WEBPACK_IMPORTED_MODULE_1__["doKey2ClickDown"])(evt, options);
                    },
                    onBlur: function(evt) {
                        return Object(survey_core__WEBPACK_IMPORTED_MODULE_1__["doKey2ClickBlur"])(evt);
                    }
                });
            }
        /***/ },
        /***/ "./src/react/reactSurveyNavigationBase.tsx": /*!*************************************************!*\
  !*** ./src/react/reactSurveyNavigationBase.tsx ***!
  \*************************************************/ /*! exports provided: SurveyNavigationBase */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyNavigationBase", function() {
                return SurveyNavigationBase;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyNavigationBase = /** @class */ function(_super) {
                __extends(SurveyNavigationBase, _super);
                function SurveyNavigationBase(props) {
                    var _this = _super.call(this, props) || this;
                    _this.updateStateFunction = null;
                    _this.state = {
                        update: 0
                    };
                    return _this;
                }
                Object.defineProperty(SurveyNavigationBase.prototype, "survey", {
                    get: function() {
                        return this.props.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyNavigationBase.prototype, "css", {
                    get: function() {
                        return this.props.css || this.survey.css;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyNavigationBase.prototype.componentDidMount = function() {
                    if (this.survey) {
                        var self = this;
                        this.updateStateFunction = function() {
                            self.setState({
                                update: self.state.update + 1
                            });
                        };
                        this.survey.onPageVisibleChanged.add(this.updateStateFunction);
                    }
                };
                SurveyNavigationBase.prototype.componentWillUnmount = function() {
                    if (this.survey && this.updateStateFunction) {
                        this.survey.onPageVisibleChanged.remove(this.updateStateFunction);
                        this.updateStateFunction = null;
                    }
                };
                return SurveyNavigationBase;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /***/ },
        /***/ "./src/react/reactquestion.tsx": /*!*************************************!*\
  !*** ./src/react/reactquestion.tsx ***!
  \*************************************/ /*! exports provided: SurveyQuestion, SurveyElementErrors, SurveyQuestionAndErrorsWrapped, SurveyQuestionAndErrorsCell, SurveyQuestionErrorCell */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestion", function() {
                return SurveyQuestion;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyElementErrors", function() {
                return SurveyElementErrors;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionAndErrorsWrapped", function() {
                return SurveyQuestionAndErrorsWrapped;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionAndErrorsCell", function() {
                return SurveyQuestionAndErrorsCell;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionErrorCell", function() {
                return SurveyQuestionErrorCell;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_comment__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./reactquestion_comment */ "./src/react/reactquestion_comment.tsx");
            /* harmony import */ var _custom_widget__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./custom-widget */ "./src/react/custom-widget.tsx");
            /* harmony import */ var _element_header__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./element-header */ "./src/react/element-header.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestion = /** @class */ function(_super) {
                __extends(SurveyQuestion, _super);
                function SurveyQuestion(props) {
                    var _this = _super.call(this, props) || this;
                    _this.isNeedFocus = false;
                    _this.rootRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    return _this;
                }
                SurveyQuestion.renderQuestionBody = function(creator, question) {
                    // if (!question.isVisible) return null;
                    var customWidget = question.customWidget;
                    if (!customWidget) return creator.createQuestionElement(question);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_custom_widget__WEBPACK_IMPORTED_MODULE_5__["SurveyCustomWidget"], {
                        creator: creator,
                        question: question
                    });
                };
                SurveyQuestion.prototype.getStateElement = function() {
                    return this.question;
                };
                Object.defineProperty(SurveyQuestion.prototype, "question", {
                    get: function() {
                        return this.props.element;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestion.prototype, "creator", {
                    get: function() {
                        return this.props.creator;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestion.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    if (!!this.question) this.question["react"] = this;
                    this.doAfterRender();
                };
                SurveyQuestion.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (!!this.question) this.question["react"] = null;
                    var el = this.rootRef.current;
                    if (!!el) el.removeAttribute("data-rendered");
                };
                SurveyQuestion.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.doAfterRender();
                };
                SurveyQuestion.prototype.doAfterRender = function() {
                    if (this.isNeedFocus) {
                        if (!this.question.isCollapsed) this.question.clickTitleFunction();
                        this.isNeedFocus = false;
                    }
                    if (this.question) {
                        var el = this.rootRef.current;
                        if (el && el.getAttribute("data-rendered") !== "r") {
                            el.setAttribute("data-rendered", "r");
                            el.setAttribute("data-name", this.question.name);
                            if (this.question.afterRender) this.question.afterRender(el);
                        }
                    }
                };
                SurveyQuestion.prototype.canRender = function() {
                    return _super.prototype.canRender.call(this) && !!this.question && !!this.creator;
                };
                SurveyQuestion.prototype.renderQuestionContent = function() {
                    var question = this.question;
                    var contentStyle = {
                        display: this.question.renderedIsExpanded ? "" : "none"
                    };
                    var cssClasses = question.cssClasses;
                    var questionRender = this.renderQuestion();
                    var errorsTop = this.question.showErrorOnTop ? this.renderErrors(cssClasses, "top") : null;
                    var errorsBottom = this.question.showErrorOnBottom ? this.renderErrors(cssClasses, "bottom") : null;
                    var comment = question && question.hasComment ? this.renderComment(cssClasses) : null;
                    var descriptionUnderInput = question.hasDescriptionUnderInput ? this.renderDescription() : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: question.cssContent || undefined,
                        style: contentStyle,
                        role: "presentation"
                    }, errorsTop, questionRender, comment, errorsBottom, descriptionUnderInput);
                };
                SurveyQuestion.prototype.renderElement = function() {
                    var question = this.question;
                    var cssClasses = question.cssClasses;
                    var header = this.renderHeader(question);
                    var headerTop = question.hasTitleOnLeftTop ? header : null;
                    var headerBottom = question.hasTitleOnBottom ? header : null;
                    var errorsAboveQuestion = this.question.showErrorsAboveQuestion ? this.renderErrors(cssClasses, "") : null;
                    var errorsBelowQuestion = this.question.showErrorsBelowQuestion ? this.renderErrors(cssClasses, "") : null;
                    var rootStyle = question.getRootStyle();
                    var questionContent = this.wrapQuestionContent(this.renderQuestionContent());
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        ref: this.rootRef,
                        id: question.id,
                        className: question.getRootCss(),
                        style: rootStyle,
                        role: question.ariaRole,
                        "aria-required": this.question.ariaRequired,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-labelledby": question.ariaLabelledBy,
                        "aria-describedby": question.ariaDescribedBy,
                        "aria-expanded": question.ariaExpanded === null ? undefined : question.ariaExpanded === "true"
                    }, errorsAboveQuestion, headerTop, questionContent, headerBottom, errorsBelowQuestion));
                };
                SurveyQuestion.prototype.wrapElement = function(element) {
                    var survey = this.question.survey;
                    var wrapper = null;
                    if (survey) wrapper = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElementsWrapper"].wrapElement(survey, element, this.question);
                    return wrapper !== null && wrapper !== void 0 ? wrapper : element;
                };
                SurveyQuestion.prototype.wrapQuestionContent = function(element) {
                    var survey = this.question.survey;
                    var wrapper = null;
                    if (survey) wrapper = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElementsWrapper"].wrapQuestionContent(survey, element, this.question);
                    return wrapper !== null && wrapper !== void 0 ? wrapper : element;
                };
                SurveyQuestion.prototype.renderQuestion = function() {
                    return SurveyQuestion.renderQuestionBody(this.creator, this.question);
                };
                SurveyQuestion.prototype.renderDescription = function() {
                    return _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElementBase"].renderQuestionDescription(this.question);
                };
                SurveyQuestion.prototype.renderComment = function(cssClasses) {
                    var commentText = _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElementBase"].renderLocString(this.question.locCommentText);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.getCommentAreaCss()
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, commentText), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion_comment__WEBPACK_IMPORTED_MODULE_4__["SurveyQuestionCommentItem"], {
                        question: this.question,
                        cssClasses: cssClasses,
                        otherCss: cssClasses.other,
                        isDisplayMode: this.question.isInputReadOnly
                    }));
                };
                SurveyQuestion.prototype.renderHeader = function(question) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_element_header__WEBPACK_IMPORTED_MODULE_6__["SurveyElementHeader"], {
                        element: question
                    });
                };
                SurveyQuestion.prototype.renderErrors = function(cssClasses, location) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyElementErrors, {
                        element: this.question,
                        cssClasses: cssClasses,
                        creator: this.creator,
                        location: location,
                        id: this.question.id + "_errors"
                    });
                };
                return SurveyQuestion;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElementBase"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("question", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestion, props);
            });
            var SurveyElementErrors = /** @class */ function(_super) {
                __extends(SurveyElementErrors, _super);
                function SurveyElementErrors(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = _this.getState();
                    return _this;
                }
                Object.defineProperty(SurveyElementErrors.prototype, "id", {
                    get: function() {
                        return this.props.element.id + "_errors";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementErrors.prototype, "element", {
                    get: function() {
                        return this.props.element;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementErrors.prototype, "creator", {
                    get: function() {
                        return this.props.creator;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementErrors.prototype, "location", {
                    get: function() {
                        return this.props.location;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementErrors.prototype.getState = function(prevState) {
                    if (prevState === void 0) prevState = null;
                    return !prevState ? {
                        error: 0
                    } : {
                        error: prevState.error + 1
                    };
                };
                SurveyElementErrors.prototype.canRender = function() {
                    return !!this.element && this.element.hasVisibleErrors;
                };
                SurveyElementErrors.prototype.componentWillUnmount = function() {};
                SurveyElementErrors.prototype.renderElement = function() {
                    var errors = [];
                    for(var i = 0; i < this.element.errors.length; i++){
                        var key = "error" + i;
                        errors.push(this.creator.renderError(key, this.element.errors[i], this.cssClasses));
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        role: "alert",
                        "aria-live": "polite",
                        className: this.element.cssError,
                        id: this.id
                    }, errors);
                };
                return SurveyElementErrors;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["ReactSurveyElement"]);
            var SurveyQuestionAndErrorsWrapped = /** @class */ function(_super) {
                __extends(SurveyQuestionAndErrorsWrapped, _super);
                function SurveyQuestionAndErrorsWrapped(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionAndErrorsWrapped.prototype.getStateElement = function() {
                    return this.question;
                };
                Object.defineProperty(SurveyQuestionAndErrorsWrapped.prototype, "question", {
                    get: function() {
                        return this.getQuestion();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionAndErrorsWrapped.prototype, "creator", {
                    get: function() {
                        return this.props.creator;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionAndErrorsWrapped.prototype.getQuestion = function() {
                    return this.props.question;
                };
                Object.defineProperty(SurveyQuestionAndErrorsWrapped.prototype, "itemCss", {
                    get: function() {
                        return this.props.itemCss;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionAndErrorsWrapped.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.doAfterRender();
                };
                SurveyQuestionAndErrorsWrapped.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.doAfterRender();
                };
                SurveyQuestionAndErrorsWrapped.prototype.doAfterRender = function() {};
                SurveyQuestionAndErrorsWrapped.prototype.canRender = function() {
                    return !!this.question;
                };
                SurveyQuestionAndErrorsWrapped.prototype.renderContent = function() {
                    var renderedQuestion = this.renderQuestion();
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, renderedQuestion);
                };
                SurveyQuestionAndErrorsWrapped.prototype.getShowErrors = function() {
                    return this.question.isVisible;
                };
                SurveyQuestionAndErrorsWrapped.prototype.renderQuestion = function() {
                    return SurveyQuestion.renderQuestionBody(this.creator, this.question);
                };
                return SurveyQuestionAndErrorsWrapped;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["ReactSurveyElement"]);
            var SurveyQuestionAndErrorsCell = /** @class */ function(_super) {
                __extends(SurveyQuestionAndErrorsCell, _super);
                function SurveyQuestionAndErrorsCell(props) {
                    var _this = _super.call(this, props) || this;
                    _this.cellRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    return _this;
                }
                SurveyQuestionAndErrorsCell.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (this.question) {
                        var el = this.cellRef.current;
                        if (!!el) el.removeAttribute("data-rendered");
                    }
                };
                SurveyQuestionAndErrorsCell.prototype.renderElement = function() {
                    var style = this.getCellStyle();
                    var cell = this.props.cell;
                    var focusIn = function() {
                        cell.focusIn();
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("td", {
                        ref: this.cellRef,
                        className: this.itemCss,
                        colSpan: cell.colSpans,
                        "data-responsive-title": this.getHeaderText(),
                        title: cell.getTitle(),
                        style: style,
                        onFocus: focusIn
                    }, this.wrapCell(this.props.cell, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.props.cell.cellQuestionWrapperClassName
                    }, this.renderQuestion())));
                };
                SurveyQuestionAndErrorsCell.prototype.getCellStyle = function() {
                    return null;
                };
                SurveyQuestionAndErrorsCell.prototype.getHeaderText = function() {
                    return "";
                };
                SurveyQuestionAndErrorsCell.prototype.wrapCell = function(cell, element) {
                    if (!cell) return element;
                    var survey = this.question.survey;
                    var wrapper = null;
                    if (survey) wrapper = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElementsWrapper"].wrapMatrixCell(survey, element, cell, this.props.reason);
                    return wrapper !== null && wrapper !== void 0 ? wrapper : element;
                };
                return SurveyQuestionAndErrorsCell;
            }(SurveyQuestionAndErrorsWrapped);
            var SurveyQuestionErrorCell = /** @class */ function(_super) {
                __extends(SurveyQuestionErrorCell, _super);
                function SurveyQuestionErrorCell(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = {
                        changed: 0
                    };
                    if (_this.question) _this.registerCallback(_this.question);
                    return _this;
                }
                Object.defineProperty(SurveyQuestionErrorCell.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionErrorCell.prototype.update = function() {
                    this.setState({
                        changed: this.state.changed + 1
                    });
                };
                SurveyQuestionErrorCell.prototype.registerCallback = function(question) {
                    var _this = this;
                    question.registerFunctionOnPropertyValueChanged("errors", function() {
                        _this.update();
                    }, "__reactSubscription");
                };
                SurveyQuestionErrorCell.prototype.unRegisterCallback = function(question) {
                    question.unRegisterFunctionOnPropertyValueChanged("errors", "__reactSubscription");
                };
                SurveyQuestionErrorCell.prototype.componentDidUpdate = function(prevProps) {
                    if (prevProps.question && prevProps.question !== this.question) this.unRegisterCallback(prevProps.cell);
                    if (this.question) this.registerCallback(this.question);
                };
                SurveyQuestionErrorCell.prototype.componentWillUnmount = function() {
                    if (this.question) this.unRegisterCallback(this.question);
                };
                SurveyQuestionErrorCell.prototype.render = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyElementErrors, {
                        element: this.question,
                        creator: this.props.creator,
                        cssClasses: this.question.cssClasses
                    });
                };
                return SurveyQuestionErrorCell;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
        /***/ },
        /***/ "./src/react/reactquestion_buttongroup.tsx": /*!*************************************************!*\
  !*** ./src/react/reactquestion_buttongroup.tsx ***!
  \*************************************************/ /*! exports provided: SurveyQuestionButtonGroup, SurveyButtonGroupItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionButtonGroup", function() {
                return SurveyQuestionButtonGroup;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyButtonGroupItem", function() {
                return SurveyButtonGroupItem;
            });
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_3__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionButtonGroup = /** @class */ function(_super) {
                __extends(SurveyQuestionButtonGroup, _super);
                function SurveyQuestionButtonGroup(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionButtonGroup.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionButtonGroup.prototype.getStateElement = function() {
                    return this.question;
                };
                SurveyQuestionButtonGroup.prototype.renderElement = function() {
                    var items = this.renderItems();
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: this.question.cssClasses.root
                    }, items);
                };
                SurveyQuestionButtonGroup.prototype.renderItems = function() {
                    var _this = this;
                    return this.question.visibleChoices.map(function(item, index) {
                        return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(SurveyButtonGroupItem, {
                            key: _this.question.inputId + "_" + index,
                            item: item,
                            question: _this.question,
                            index: index
                        });
                    });
                };
                return SurveyQuestionButtonGroup;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_0__["SurveyQuestionElementBase"]);
            var SurveyButtonGroupItem = /** @class */ function(_super) {
                __extends(SurveyButtonGroupItem, _super);
                function SurveyButtonGroupItem(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyButtonGroupItem.prototype, "index", {
                    get: function() {
                        return this.props.index;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyButtonGroupItem.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyButtonGroupItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyButtonGroupItem.prototype.getStateElement = function() {
                    return this.item;
                };
                SurveyButtonGroupItem.prototype.renderElement = function() {
                    this.model = new survey_core__WEBPACK_IMPORTED_MODULE_3__["ButtonGroupItemModel"](this.question, this.item, this.index);
                    var icon = this.renderIcon();
                    var input = this.renderInput();
                    var caption = this.renderCaption();
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("label", {
                        role: "radio",
                        className: this.model.css.label,
                        title: this.model.caption.renderedHtml
                    }, input, react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("div", {
                        className: this.model.css.decorator
                    }, icon, caption));
                };
                SurveyButtonGroupItem.prototype.renderIcon = function() {
                    if (!!this.model.iconName) return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement(_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                        className: this.model.css.icon,
                        iconName: this.model.iconName,
                        size: this.model.iconSize || 24
                    });
                    return null;
                };
                SurveyButtonGroupItem.prototype.renderInput = function() {
                    var _this = this;
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("input", {
                        className: this.model.css.control,
                        id: this.model.id,
                        type: "radio",
                        name: this.model.name,
                        checked: this.model.selected,
                        value: this.model.value,
                        disabled: this.model.readOnly,
                        onChange: function() {
                            _this.model.onChange();
                        },
                        "aria-required": this.model.isRequired,
                        "aria-label": this.model.caption.renderedHtml,
                        "aria-invalid": this.model.hasErrors,
                        "aria-errormessage": this.model.describedBy,
                        role: "radio"
                    });
                };
                SurveyButtonGroupItem.prototype.renderCaption = function() {
                    if (!this.model.showCaption) return null;
                    var caption = this.renderLocString(this.model.caption);
                    return react__WEBPACK_IMPORTED_MODULE_1___default.a.createElement("span", {
                        className: this.model.css.caption,
                        title: this.model.caption.renderedHtml
                    }, caption);
                };
                return SurveyButtonGroupItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_0__["SurveyElementBase"]);
        // ReactQuestionFactory.Instance.registerQuestion("buttongroup", props => {
        //   return React.createElement(SurveyQuestionButtonGroup, props);
        // });
        /***/ },
        /***/ "./src/react/reactquestion_checkbox.tsx": /*!**********************************************!*\
  !*** ./src/react/reactquestion_checkbox.tsx ***!
  \**********************************************/ /*! exports provided: SurveyQuestionCheckbox, SurveyQuestionCheckboxItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCheckbox", function() {
                return SurveyQuestionCheckbox;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCheckboxItem", function() {
                return SurveyQuestionCheckboxItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_comment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_comment */ "./src/react/reactquestion_comment.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionCheckbox = /** @class */ function(_super) {
                __extends(SurveyQuestionCheckbox, _super);
                function SurveyQuestionCheckbox(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionCheckbox.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionCheckbox.prototype.renderElement = function() {
                    var _this = this;
                    var cssClasses = this.question.cssClasses;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("fieldset", {
                        className: this.question.getSelectBaseRootCss(),
                        ref: function(fieldset) {
                            return _this.setControl(fieldset);
                        },
                        role: this.question.a11y_input_ariaRole,
                        "aria-required": this.question.a11y_input_ariaRequired,
                        "aria-label": this.question.a11y_input_ariaLabel,
                        "aria-labelledby": this.question.a11y_input_ariaLabelledBy,
                        "aria-describedby": this.question.a11y_input_ariaDescribedBy,
                        "aria-invalid": this.question.a11y_input_ariaInvalid,
                        "aria-errormessage": this.question.a11y_input_ariaErrormessage
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("legend", {
                        className: "sv-hidden"
                    }, this.question.locTitle.renderedHtml), this.getHeader(), this.question.hasColumns ? this.getColumnedBody(cssClasses) : this.getBody(cssClasses), this.getFooter(), this.question.isOtherSelected ? this.renderOther() : null);
                };
                SurveyQuestionCheckbox.prototype.getHeader = function() {
                    var _this = this;
                    if (this.question.hasHeadItems) return this.question.headItems.map(function(item, ii) {
                        return _this.renderItem("item_h" + ii, item, false, _this.question.cssClasses);
                    });
                };
                SurveyQuestionCheckbox.prototype.getFooter = function() {
                    var _this = this;
                    if (this.question.hasFootItems) return this.question.footItems.map(function(item, ii) {
                        return _this.renderItem("item_f" + ii, item, false, _this.question.cssClasses);
                    });
                };
                SurveyQuestionCheckbox.prototype.getColumnedBody = function(cssClasses) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.rootMultiColumn
                    }, this.getColumns(cssClasses));
                };
                SurveyQuestionCheckbox.prototype.getColumns = function(cssClasses) {
                    var _this = this;
                    return this.question.columns.map(function(column, ci) {
                        var items = column.map(function(item, ii) {
                            return _this.renderItem("item" + ii, item, ci === 0 && ii === 0, cssClasses, "" + ci + ii);
                        });
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            key: "column" + ci,
                            className: _this.question.getColumnClass(),
                            role: "presentation"
                        }, items);
                    });
                };
                SurveyQuestionCheckbox.prototype.getBody = function(cssClasses) {
                    if (this.question.blockedRow) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.rootRow
                    }, this.getItems(cssClasses, this.question.dataChoices));
                    else return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, this.getItems(cssClasses, this.question.bodyItems));
                };
                SurveyQuestionCheckbox.prototype.getItems = function(cssClasses, choices) {
                    var renderedItems = [];
                    for(var i = 0; i < choices.length; i++){
                        var item = choices[i];
                        var key = "item" + i;
                        var renderedItem = this.renderItem(key, item, i == 0, cssClasses, "" + i);
                        if (!!renderedItem) renderedItems.push(renderedItem);
                    }
                    return renderedItems;
                };
                Object.defineProperty(SurveyQuestionCheckbox.prototype, "textStyle", {
                    get: function() {
                        return null;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionCheckbox.prototype.renderOther = function() {
                    var cssClasses = this.question.cssClasses;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.getCommentAreaCss(true)
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion_comment__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionOtherValueItem"], {
                        question: this.question,
                        otherCss: cssClasses.other,
                        cssClasses: cssClasses,
                        isDisplayMode: this.isDisplayMode
                    }));
                };
                SurveyQuestionCheckbox.prototype.renderItem = function(key, item, isFirst, cssClasses, index) {
                    var renderedItem = _element_factory__WEBPACK_IMPORTED_MODULE_5__["ReactElementFactory"].Instance.createElement(this.question.itemComponent, {
                        key: key,
                        question: this.question,
                        cssClasses: cssClasses,
                        isDisplayMode: this.isDisplayMode,
                        item: item,
                        textStyle: this.textStyle,
                        index: index,
                        isFirst: isFirst
                    });
                    var survey = this.question.survey;
                    var wrappedItem = null;
                    if (!!survey && !!renderedItem) wrappedItem = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_4__["ReactSurveyElementsWrapper"].wrapItemValue(survey, renderedItem, this.question, item);
                    return wrappedItem !== null && wrappedItem !== void 0 ? wrappedItem : renderedItem;
                };
                return SurveyQuestionCheckbox;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            var SurveyQuestionCheckboxItem = /** @class */ function(_super) {
                __extends(SurveyQuestionCheckboxItem, _super);
                function SurveyQuestionCheckboxItem(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnChange = function(event) {
                        _this.question.clickItemHandler(_this.item, event.target.checked);
                    };
                    return _this;
                }
                SurveyQuestionCheckboxItem.prototype.getStateElement = function() {
                    return this.item;
                };
                Object.defineProperty(SurveyQuestionCheckboxItem.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionCheckboxItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionCheckboxItem.prototype, "textStyle", {
                    get: function() {
                        return this.props.textStyle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionCheckboxItem.prototype, "isFirst", {
                    get: function() {
                        return this.props.isFirst;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionCheckboxItem.prototype, "index", {
                    get: function() {
                        return this.props.index;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionCheckboxItem.prototype, "hideCaption", {
                    get: function() {
                        return this.props.hideCaption === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionCheckboxItem.prototype.shouldComponentUpdate = function(nextProps, nextState) {
                    if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState)) return false;
                    if (!this.question) return false;
                    return !this.question.customWidget || !!this.question.customWidgetData.isNeedRender || !!this.question.customWidget.widgetJson.isDefaultRender || !!this.question.customWidget.widgetJson.render;
                };
                SurveyQuestionCheckboxItem.prototype.canRender = function() {
                    return !!this.item && !!this.question;
                };
                SurveyQuestionCheckboxItem.prototype.renderElement = function() {
                    var isChecked = this.question.isItemSelected(this.item);
                    return this.renderCheckbox(isChecked, null);
                };
                Object.defineProperty(SurveyQuestionCheckboxItem.prototype, "inputStyle", {
                    get: function() {
                        return null; //{ marginRight: "3px" };
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionCheckboxItem.prototype.renderCheckbox = function(isChecked, otherItem) {
                    var id = this.question.getItemId(this.item);
                    var itemClass = this.question.getItemClass(this.item);
                    var labelClass = this.question.getLabelClass(this.item);
                    var itemLabel = !this.hideCaption ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.cssClasses.controlLabel
                    }, this.renderLocString(this.item.locText, this.textStyle)) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: itemClass,
                        role: "presentation"
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("label", {
                        className: labelClass
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        className: this.cssClasses.itemControl,
                        type: "checkbox",
                        role: "option",
                        name: this.question.name + this.item.id,
                        value: this.item.value,
                        id: id,
                        style: this.inputStyle,
                        disabled: !this.question.getItemEnabled(this.item),
                        checked: isChecked,
                        onChange: this.handleOnChange
                    }), this.cssClasses.materialDecorator ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.cssClasses.materialDecorator
                    }, this.question.itemSvgIcon ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", {
                        className: this.cssClasses.itemDecorator
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", {
                        xlinkHref: this.question.itemSvgIcon
                    })) : null) : null, itemLabel), otherItem);
                };
                return SurveyQuestionCheckboxItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_5__["ReactElementFactory"].Instance.registerElement("survey-checkbox-item", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionCheckboxItem, props);
            });
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__["ReactQuestionFactory"].Instance.registerQuestion("checkbox", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionCheckbox, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_comment.tsx": /*!*********************************************!*\
  !*** ./src/react/reactquestion_comment.tsx ***!
  \*********************************************/ /*! exports provided: SurveyQuestionComment, SurveyQuestionCommentItem, SurveyQuestionOtherValueItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionComment", function() {
                return SurveyQuestionComment;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCommentItem", function() {
                return SurveyQuestionCommentItem;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionOtherValueItem", function() {
                return SurveyQuestionOtherValueItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_2__);
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _components_character_counter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/character-counter */ "./src/react/components/character-counter.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionComment = /** @class */ function(_super) {
                __extends(SurveyQuestionComment, _super);
                function SurveyQuestionComment(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionComment.prototype.renderElement = function() {
                    var _this = this;
                    var onBlur = !this.question.isInputTextUpdate ? this.updateValueOnEvent : undefined;
                    var onInput = function(event) {
                        if (_this.question.isInputTextUpdate) _this.updateValueOnEvent(event);
                        else _this.question.updateElement();
                        var newValue = event.target.value;
                        _this.question.updateRemainingCharacterCounter(newValue);
                    };
                    var placeholder = this.question.renderedPlaceholder;
                    if (this.question.isReadOnlyRenderDiv()) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, this.question.value);
                    var counter = !!this.question.getMaxLength() ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_character_counter__WEBPACK_IMPORTED_MODULE_4__["CharacterCounterComponent"], {
                        counter: this.question.characterCounter,
                        remainingCharacterCounter: this.question.cssClasses.remainingCharacterCounter
                    }) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("textarea", {
                        id: this.question.inputId,
                        className: this.question.className,
                        disabled: this.question.isInputReadOnly,
                        readOnly: this.question.isInputReadOnly,
                        ref: function(textarea) {
                            return _this.setControl(textarea);
                        },
                        maxLength: this.question.getMaxLength(),
                        placeholder: placeholder,
                        onBlur: onBlur,
                        onInput: onInput,
                        onKeyDown: function(event) {
                            _this.question.onKeyDown(event);
                        },
                        cols: this.question.cols,
                        rows: this.question.rows,
                        "aria-required": this.question.a11y_input_ariaRequired,
                        "aria-label": this.question.a11y_input_ariaLabel,
                        "aria-labelledby": this.question.a11y_input_ariaLabelledBy,
                        "aria-describedby": this.question.a11y_input_ariaDescribedBy,
                        "aria-invalid": this.question.a11y_input_ariaInvalid,
                        "aria-errormessage": this.question.a11y_input_ariaErrormessage,
                        style: {
                            resize: this.question.resizeStyle
                        }
                    }), counter);
                };
                return SurveyQuestionComment;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionUncontrolledElement"]);
            var SurveyQuestionCommentItem = /** @class */ function(_super) {
                __extends(SurveyQuestionCommentItem, _super);
                function SurveyQuestionCommentItem(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = {
                        comment: _this.getComment() || ""
                    };
                    return _this;
                }
                SurveyQuestionCommentItem.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.updateDomElement();
                };
                SurveyQuestionCommentItem.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.updateDomElement();
                };
                SurveyQuestionCommentItem.prototype.updateDomElement = function() {
                    if (!!this.control) {
                        var control = this.control;
                        var newValue = this.getComment() || "";
                        if (!survey_core__WEBPACK_IMPORTED_MODULE_2__["Helpers"].isTwoValueEquals(newValue, control.value, false, true, false)) control.value = newValue;
                    }
                };
                SurveyQuestionCommentItem.prototype.setControl = function(element) {
                    if (!!element) this.control = element;
                };
                SurveyQuestionCommentItem.prototype.canRender = function() {
                    return !!this.props.question;
                };
                SurveyQuestionCommentItem.prototype.onCommentChange = function(event) {
                    this.props.question.onCommentChange(event);
                };
                SurveyQuestionCommentItem.prototype.onCommentInput = function(event) {
                    this.props.question.onCommentInput(event);
                };
                SurveyQuestionCommentItem.prototype.getComment = function() {
                    return this.props.question.comment;
                };
                SurveyQuestionCommentItem.prototype.setComment = function(value) {
                    this.props.question.comment = value;
                };
                SurveyQuestionCommentItem.prototype.getId = function() {
                    return this.props.question.commentId;
                };
                SurveyQuestionCommentItem.prototype.getPlaceholder = function() {
                    return this.props.question.renderedCommentPlaceholder;
                };
                SurveyQuestionCommentItem.prototype.renderElement = function() {
                    var _this = this;
                    var question = this.props.question;
                    var className = this.props.otherCss || this.cssClasses.comment;
                    if (question.isReadOnlyRenderDiv()) {
                        var comment = this.getComment() || "";
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, comment);
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("textarea", {
                        id: this.getId(),
                        className: className,
                        ref: function(textarea) {
                            return _this.setControl(textarea);
                        },
                        disabled: this.isDisplayMode,
                        maxLength: question.getOthersMaxLength(),
                        placeholder: this.getPlaceholder(),
                        onBlur: function(e) {
                            _this.onCommentChange(e);
                        },
                        onInput: function(e) {
                            return _this.onCommentInput(e);
                        },
                        "aria-required": question.isRequired || question.a11y_input_ariaRequired,
                        "aria-label": question.ariaLabel || question.a11y_input_ariaLabel,
                        style: {
                            resize: question.resizeStyle
                        }
                    });
                };
                return SurveyQuestionCommentItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            var SurveyQuestionOtherValueItem = /** @class */ function(_super) {
                __extends(SurveyQuestionOtherValueItem, _super);
                function SurveyQuestionOtherValueItem() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                SurveyQuestionOtherValueItem.prototype.onCommentChange = function(event) {
                    this.props.question.onOtherValueChange(event);
                };
                SurveyQuestionOtherValueItem.prototype.onCommentInput = function(event) {
                    this.props.question.onOtherValueInput(event);
                };
                SurveyQuestionOtherValueItem.prototype.getComment = function() {
                    return this.props.question.otherValue;
                };
                SurveyQuestionOtherValueItem.prototype.setComment = function(value) {
                    this.props.question.otherValue = value;
                };
                SurveyQuestionOtherValueItem.prototype.getId = function() {
                    return this.props.question.otherId;
                };
                SurveyQuestionOtherValueItem.prototype.getPlaceholder = function() {
                    return this.props.question.otherPlaceholder;
                };
                return SurveyQuestionOtherValueItem;
            }(SurveyQuestionCommentItem);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__["ReactQuestionFactory"].Instance.registerQuestion("comment", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionComment, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_custom.tsx": /*!********************************************!*\
  !*** ./src/react/reactquestion_custom.tsx ***!
  \********************************************/ /*! exports provided: SurveyQuestionCustom, SurveyQuestionComposite */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionCustom", function() {
                return SurveyQuestionCustom;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionComposite", function() {
                return SurveyQuestionComposite;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion */ "./src/react/reactquestion.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _panel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./panel */ "./src/react/panel.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionCustom = /** @class */ function(_super) {
                __extends(SurveyQuestionCustom, _super);
                function SurveyQuestionCustom(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionCustom.prototype.getStateElements = function() {
                    var res = _super.prototype.getStateElements.call(this);
                    if (!!this.question.contentQuestion) res.push(this.question.contentQuestion);
                    return res;
                };
                SurveyQuestionCustom.prototype.renderElement = function() {
                    return _reactquestion__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestion"].renderQuestionBody(this.creator, this.question.contentQuestion);
                };
                return SurveyQuestionCustom;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionUncontrolledElement"]);
            var SurveyQuestionComposite = /** @class */ function(_super) {
                __extends(SurveyQuestionComposite, _super);
                function SurveyQuestionComposite(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionComposite.prototype.canRender = function() {
                    return !!this.question.contentPanel;
                };
                SurveyQuestionComposite.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_panel__WEBPACK_IMPORTED_MODULE_4__["SurveyPanel"], {
                        element: this.question.contentPanel,
                        creator: this.creator,
                        survey: this.question.survey
                    });
                };
                return SurveyQuestionComposite;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionUncontrolledElement"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__["ReactQuestionFactory"].Instance.registerQuestion("custom", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionCustom, props);
            });
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__["ReactQuestionFactory"].Instance.registerQuestion("composite", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionComposite, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_dropdown.tsx": /*!**********************************************!*\
  !*** ./src/react/reactquestion_dropdown.tsx ***!
  \**********************************************/ /*! exports provided: SurveyQuestionDropdown */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionDropdown", function() {
                return SurveyQuestionDropdown;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _dropdown_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./dropdown-base */ "./src/react/dropdown-base.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionDropdown = /** @class */ function(_super) {
                __extends(SurveyQuestionDropdown, _super);
                function SurveyQuestionDropdown(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionDropdown.prototype.renderElement = function() {
                    var cssClasses = this.question.cssClasses;
                    var comment = this.question.isOtherSelected ? this.renderOther(cssClasses) : null;
                    var select = this.renderSelect(cssClasses);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.renderCssRoot
                    }, select, comment);
                };
                return SurveyQuestionDropdown;
            }(_dropdown_base__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionDropdownBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_1__["ReactQuestionFactory"].Instance.registerQuestion("dropdown", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionDropdown, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_element.tsx": /*!*********************************************!*\
  !*** ./src/react/reactquestion_element.tsx ***!
  \*********************************************/ /*! exports provided: SurveyElementBase, ReactSurveyElement, SurveyQuestionElementBase, SurveyQuestionUncontrolledElement */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyElementBase", function() {
                return SurveyElementBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactSurveyElement", function() {
                return ReactSurveyElement;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionElementBase", function() {
                return SurveyQuestionElementBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionUncontrolledElement", function() {
                return SurveyQuestionUncontrolledElement;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyElementBase = /** @class */ function(_super) {
                __extends(SurveyElementBase, _super);
                function SurveyElementBase(props) {
                    var _this = _super.call(this, props) || this;
                    _this._allowComponentUpdate = true;
                    return _this;
                }
                SurveyElementBase.renderLocString = function(locStr, style, key) {
                    if (style === void 0) style = null;
                    return _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.createElement(locStr.renderAs, {
                        locStr: locStr.renderAsData,
                        style: style,
                        key: key
                    });
                };
                SurveyElementBase.renderQuestionDescription = function(question) {
                    var descriptionText = SurveyElementBase.renderLocString(question.locDescription);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        style: question.hasDescription ? undefined : {
                            display: "none"
                        },
                        id: question.ariaDescriptionId,
                        className: question.cssDescription
                    }, descriptionText);
                };
                SurveyElementBase.prototype.componentDidMount = function() {
                    this.makeBaseElementsReact();
                };
                SurveyElementBase.prototype.componentWillUnmount = function() {
                    this.unMakeBaseElementsReact();
                };
                SurveyElementBase.prototype.componentDidUpdate = function(prevProps, prevState) {
                    this.makeBaseElementsReact();
                };
                SurveyElementBase.prototype.allowComponentUpdate = function() {
                    this._allowComponentUpdate = true;
                    this.forceUpdate();
                };
                SurveyElementBase.prototype.denyComponentUpdate = function() {
                    this._allowComponentUpdate = false;
                };
                SurveyElementBase.prototype.shouldComponentUpdate = function(nextProps, nextState) {
                    if (this._allowComponentUpdate) this.unMakeBaseElementsReact();
                    return this._allowComponentUpdate;
                };
                SurveyElementBase.prototype.render = function() {
                    if (!this.canRender()) return null;
                    this.startEndRendering(1);
                    var res = this.renderElement();
                    this.startEndRendering(-1);
                    if (!!res) res = this.wrapElement(res);
                    this.changedStatePropNameValue = undefined;
                    return res;
                };
                SurveyElementBase.prototype.wrapElement = function(element) {
                    return element;
                };
                Object.defineProperty(SurveyElementBase.prototype, "isRendering", {
                    get: function() {
                        var stateEls = this.getRenderedElements();
                        for(var _i = 0, stateEls_1 = stateEls; _i < stateEls_1.length; _i++){
                            var stateEl = stateEls_1[_i];
                            if (stateEl.reactRendering > 0) return true;
                        }
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementBase.prototype.getRenderedElements = function() {
                    return this.getStateElements();
                };
                SurveyElementBase.prototype.startEndRendering = function(val1) {
                    var stateEls = this.getRenderedElements();
                    for(var _i = 0, stateEls_2 = stateEls; _i < stateEls_2.length; _i++){
                        var stateEl = stateEls_2[_i];
                        if (!stateEl.reactRendering) stateEl.reactRendering = 0;
                        stateEl.reactRendering += val1;
                    }
                };
                SurveyElementBase.prototype.canRender = function() {
                    return true;
                };
                SurveyElementBase.prototype.renderElement = function() {
                    return null;
                };
                Object.defineProperty(SurveyElementBase.prototype, "changedStatePropName", {
                    get: function() {
                        return this.changedStatePropNameValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementBase.prototype.makeBaseElementsReact = function() {
                    var els = this.getStateElements();
                    for(var i = 0; i < els.length; i++)this.makeBaseElementReact(els[i]);
                };
                SurveyElementBase.prototype.unMakeBaseElementsReact = function() {
                    var els = this.getStateElements();
                    for(var i = 0; i < els.length; i++)this.unMakeBaseElementReact(els[i]);
                };
                SurveyElementBase.prototype.getStateElements = function() {
                    var el = this.getStateElement();
                    return !!el ? [
                        el
                    ] : [];
                };
                SurveyElementBase.prototype.getStateElement = function() {
                    return null;
                };
                Object.defineProperty(SurveyElementBase.prototype, "isDisplayMode", {
                    get: function() {
                        var props = this.props;
                        return props.isDisplayMode || false;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementBase.prototype.renderLocString = function(locStr, style, key) {
                    if (style === void 0) style = null;
                    return SurveyElementBase.renderLocString(locStr, style, key);
                };
                SurveyElementBase.prototype.canMakeReact = function(stateElement) {
                    return !!stateElement && !!stateElement.iteratePropertiesHash;
                };
                SurveyElementBase.prototype.makeBaseElementReact = function(stateElement) {
                    var _this = this;
                    if (!this.canMakeReact(stateElement)) return;
                    stateElement.iteratePropertiesHash(function(hash, key) {
                        if (!_this.canUsePropInState(key)) return;
                        var val1 = hash[key];
                        if (Array.isArray(val1)) {
                            var val1 = val1;
                            val1["onArrayChanged"] = function(arrayChanges) {
                                if (_this.isRendering) return;
                                _this.changedStatePropNameValue = key;
                                _this.setState(function(state) {
                                    var newState = {};
                                    newState[key] = val1;
                                    return newState;
                                });
                            };
                        }
                    });
                    stateElement.setPropertyValueCoreHandler = function(hash, key, val1) {
                        if (hash[key] !== val1) {
                            hash[key] = val1;
                            if (!_this.canUsePropInState(key)) return;
                            if (_this.isRendering) return;
                            _this.changedStatePropNameValue = key;
                            _this.setState(function(state) {
                                var newState = {};
                                newState[key] = val1;
                                return newState;
                            });
                        }
                    };
                };
                SurveyElementBase.prototype.canUsePropInState = function(key) {
                    return true;
                };
                SurveyElementBase.prototype.unMakeBaseElementReact = function(stateElement) {
                    if (!this.canMakeReact(stateElement)) return;
                    stateElement.setPropertyValueCoreHandler = undefined;
                    stateElement.iteratePropertiesHash(function(hash, key) {
                        var val1 = hash[key];
                        if (Array.isArray(val1)) {
                            var val1 = val1;
                            val1["onArrayChanged"] = function() {};
                        }
                    });
                };
                return SurveyElementBase;
            }(react__WEBPACK_IMPORTED_MODULE_0__["Component"]);
            var ReactSurveyElement = /** @class */ function(_super) {
                __extends(ReactSurveyElement, _super);
                function ReactSurveyElement(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(ReactSurveyElement.prototype, "cssClasses", {
                    get: function() {
                        return this.props.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                return ReactSurveyElement;
            }(SurveyElementBase);
            var SurveyQuestionElementBase = /** @class */ function(_super) {
                __extends(SurveyQuestionElementBase, _super);
                function SurveyQuestionElementBase(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionElementBase.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.updateDomElement();
                };
                SurveyQuestionElementBase.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.updateDomElement();
                };
                SurveyQuestionElementBase.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (!!this.questionBase) {
                        var el = this.control;
                        this.questionBase.beforeDestroyQuestionElement(el);
                        if (!!el) el.removeAttribute("data-rendered");
                    }
                };
                SurveyQuestionElementBase.prototype.updateDomElement = function() {
                    var el = this.control;
                    if (!!el) {
                        if (el.getAttribute("data-rendered") !== "r") {
                            el.setAttribute("data-rendered", "r");
                            this.questionBase.afterRenderQuestionElement(el);
                        }
                    }
                };
                Object.defineProperty(SurveyQuestionElementBase.prototype, "questionBase", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionElementBase.prototype.getRenderedElements = function() {
                    return [
                        this.questionBase
                    ];
                };
                Object.defineProperty(SurveyQuestionElementBase.prototype, "creator", {
                    get: function() {
                        return this.props.creator;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionElementBase.prototype.canRender = function() {
                    return !!this.questionBase && !!this.creator;
                };
                SurveyQuestionElementBase.prototype.shouldComponentUpdate = function(nextProps, nextState) {
                    if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState)) return false;
                    return !this.questionBase.customWidget || !!this.questionBase.customWidgetData.isNeedRender || !!this.questionBase.customWidget.widgetJson.isDefaultRender || !!this.questionBase.customWidget.widgetJson.render;
                };
                Object.defineProperty(SurveyQuestionElementBase.prototype, "isDisplayMode", {
                    get: function() {
                        var props = this.props;
                        return props.isDisplayMode || !!this.questionBase && this.questionBase.isInputReadOnly || false;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionElementBase.prototype.wrapCell = function(cell, element, reason) {
                    if (!reason) return element;
                    var survey = this.questionBase.survey;
                    var wrapper = null;
                    if (survey) wrapper = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_3__["ReactSurveyElementsWrapper"].wrapMatrixCell(survey, element, cell, reason);
                    return wrapper !== null && wrapper !== void 0 ? wrapper : element;
                };
                SurveyQuestionElementBase.prototype.setControl = function(element) {
                    if (!!element) this.control = element;
                };
                return SurveyQuestionElementBase;
            }(SurveyElementBase);
            var SurveyQuestionUncontrolledElement = /** @class */ function(_super) {
                __extends(SurveyQuestionUncontrolledElement, _super);
                function SurveyQuestionUncontrolledElement(props) {
                    var _this = _super.call(this, props) || this;
                    _this.updateValueOnEvent = function(event) {
                        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(_this.questionBase.value, event.target.value, false, true, false)) _this.setValueCore(event.target.value);
                    };
                    _this.updateValueOnEvent = _this.updateValueOnEvent.bind(_this);
                    return _this;
                }
                Object.defineProperty(SurveyQuestionUncontrolledElement.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionUncontrolledElement.prototype.setValueCore = function(newValue) {
                    this.questionBase.value = newValue;
                };
                SurveyQuestionUncontrolledElement.prototype.getValueCore = function() {
                    return this.questionBase.value;
                };
                SurveyQuestionUncontrolledElement.prototype.updateDomElement = function() {
                    if (!!this.control) {
                        var control = this.control;
                        var newValue = this.getValueCore();
                        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(newValue, control.value, false, true, false)) control.value = this.getValue(newValue);
                    }
                    _super.prototype.updateDomElement.call(this);
                };
                SurveyQuestionUncontrolledElement.prototype.getValue = function(val1) {
                    if (survey_core__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isValueEmpty(val1)) return "";
                    return val1;
                };
                return SurveyQuestionUncontrolledElement;
            }(SurveyQuestionElementBase);
        /***/ },
        /***/ "./src/react/reactquestion_empty.tsx": /*!*******************************************!*\
  !*** ./src/react/reactquestion_empty.tsx ***!
  \*******************************************/ /*! exports provided: SurveyQuestionEmpty */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionEmpty", function() {
                return SurveyQuestionEmpty;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionEmpty = /** @class */ function(_super) {
                __extends(SurveyQuestionEmpty, _super);
                function SurveyQuestionEmpty(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = {
                        value: _this.question.value
                    };
                    return _this;
                }
                Object.defineProperty(SurveyQuestionEmpty.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionEmpty.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null);
                };
                return SurveyQuestionEmpty;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("empty", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionEmpty, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_expression.tsx": /*!************************************************!*\
  !*** ./src/react/reactquestion_expression.tsx ***!
  \************************************************/ /*! exports provided: SurveyQuestionExpression */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionExpression", function() {
                return SurveyQuestionExpression;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionExpression = /** @class */ function(_super) {
                __extends(SurveyQuestionExpression, _super);
                function SurveyQuestionExpression(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionExpression.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionExpression.prototype.renderElement = function() {
                    var _this = this;
                    var cssClasses = this.question.cssClasses;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        id: this.question.inputId,
                        className: cssClasses.root,
                        ref: function(div) {
                            return _this.setControl(div);
                        }
                    }, this.question.formatedValue);
                };
                return SurveyQuestionExpression;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("expression", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionExpression, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_factory.tsx": /*!*********************************************!*\
  !*** ./src/react/reactquestion_factory.tsx ***!
  \*********************************************/ /*! exports provided: ReactQuestionFactory */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactQuestionFactory", function() {
                return ReactQuestionFactory;
            });
            var ReactQuestionFactory = /** @class */ function() {
                function ReactQuestionFactory() {
                    this.creatorHash = {};
                }
                ReactQuestionFactory.prototype.registerQuestion = function(questionType, questionCreator) {
                    this.creatorHash[questionType] = questionCreator;
                };
                ReactQuestionFactory.prototype.getAllTypes = function() {
                    var result = new Array();
                    for(var key in this.creatorHash)result.push(key);
                    return result.sort();
                };
                ReactQuestionFactory.prototype.createQuestion = function(questionType, params) {
                    var creator = this.creatorHash[questionType];
                    if (creator == null) return null;
                    return creator(params);
                };
                ReactQuestionFactory.Instance = new ReactQuestionFactory();
                return ReactQuestionFactory;
            }();
        /***/ },
        /***/ "./src/react/reactquestion_file.tsx": /*!******************************************!*\
  !*** ./src/react/reactquestion_file.tsx ***!
  \******************************************/ /*! exports provided: SurveyQuestionFile */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionFile", function() {
                return SurveyQuestionFile;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _components_loading_indicator__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/loading-indicator */ "./src/react/components/loading-indicator.tsx");
            /* harmony import */ var _components_action_bar_action_bar_item__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/action-bar/action-bar-item */ "./src/react/components/action-bar/action-bar-item.tsx");
            /* harmony import */ var _entries_react_ui_model__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../entries/react-ui-model */ "./src/entries/react-ui-model.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionFile = /** @class */ function(_super) {
                __extends(SurveyQuestionFile, _super);
                function SurveyQuestionFile(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionFile.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionFile.prototype.renderElement = function() {
                    var _this = this;
                    var preview = this.question.allowShowPreview ? this.renderPreview() : null;
                    var loadingIndicator = this.question.showLoadingIndicator ? this.renderLoadingIndicator() : null;
                    var video = this.question.isPlayingVideo ? this.renderVideo() : null;
                    var fileDecorator = this.question.showFileDecorator ? this.renderFileDecorator() : null;
                    var clearButton = this.question.showRemoveButton ? this.renderClearButton(this.question.cssClasses.removeButton) : null;
                    var clearButtonBottom = this.question.showRemoveButtonBottom ? this.renderClearButton(this.question.cssClasses.removeButtonBottom) : null;
                    var fileNavigator = this.question.fileNavigatorVisible ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_1__["SurveyActionBar"], {
                        model: this.question.fileNavigator
                    }) : null;
                    var fileInput = this.isDisplayMode ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        type: "file",
                        disabled: this.isDisplayMode,
                        className: !this.isDisplayMode ? this.question.cssClasses.fileInput : this.question.getReadOnlyFileCss(),
                        id: this.question.inputId,
                        ref: function(input) {
                            return _this.setControl(input);
                        },
                        style: !this.isDisplayMode ? {} : {
                            color: "transparent"
                        },
                        multiple: this.question.allowMultiple,
                        placeholder: this.question.title,
                        accept: this.question.acceptedTypes
                    }) : this.question.hasFileUI ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        type: "file",
                        disabled: this.isDisplayMode,
                        tabIndex: -1,
                        className: !this.isDisplayMode ? this.question.cssClasses.fileInput : this.question.getReadOnlyFileCss(),
                        id: this.question.inputId,
                        ref: function(input) {
                            return _this.setControl(input);
                        },
                        style: !this.isDisplayMode ? {} : {
                            color: "transparent"
                        },
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage,
                        multiple: this.question.allowMultiple,
                        title: this.question.inputTitle,
                        accept: this.question.acceptedTypes,
                        capture: this.question.renderCapture
                    }) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.fileRootCss
                    }, fileInput, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.dragArea,
                        onDrop: this.question.onDrop,
                        onDragOver: this.question.onDragOver,
                        onDragLeave: this.question.onDragLeave,
                        onDragEnter: this.question.onDragEnter
                    }, fileDecorator, loadingIndicator, video, clearButton, preview, clearButtonBottom, fileNavigator));
                };
                SurveyQuestionFile.prototype.renderFileDecorator = function() {
                    var chooseButton = this.question.showChooseButton ? this.renderChooseButton() : null;
                    var actionsContainer = this.question.actionsContainerVisible ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_1__["SurveyActionBar"], {
                        model: this.question.actionsContainer
                    }) : null;
                    var noFileChosen = this.question.isEmpty() ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.question.cssClasses.noFileChosen
                    }, this.question.noFileChosenCaption) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.getFileDecoratorCss()
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.question.cssClasses.dragAreaPlaceholder
                    }, this.renderLocString(this.question.locRenderedPlaceholder)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.wrapper
                    }, chooseButton, actionsContainer, noFileChosen));
                };
                SurveyQuestionFile.prototype.renderChooseButton = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_entries_react_ui_model__WEBPACK_IMPORTED_MODULE_7__["SurveyFileChooseButton"], {
                        data: {
                            question: this.question
                        }
                    });
                };
                SurveyQuestionFile.prototype.renderClearButton = function(className) {
                    return !this.question.isUploading ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("button", {
                        type: "button",
                        onClick: this.question.doClean,
                        className: className
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, this.question.clearButtonCaption), !!this.question.cssClasses.removeButtonIconId ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                        iconName: this.question.cssClasses.removeButtonIconId,
                        size: "auto",
                        title: this.question.clearButtonCaption
                    }) : null) : null;
                };
                SurveyQuestionFile.prototype.renderPreview = function() {
                    return _entries_react_ui_model__WEBPACK_IMPORTED_MODULE_7__["ReactElementFactory"].Instance.createElement("sv-file-preview", {
                        question: this.question
                    });
                };
                SurveyQuestionFile.prototype.renderLoadingIndicator = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.loadingIndicator
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_loading_indicator__WEBPACK_IMPORTED_MODULE_5__["LoadingIndicatorComponent"], null));
                };
                SurveyQuestionFile.prototype.renderVideo = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.videoContainer
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_action_bar_action_bar_item__WEBPACK_IMPORTED_MODULE_6__["SurveyAction"], {
                        item: this.question.changeCameraAction
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_action_bar_action_bar_item__WEBPACK_IMPORTED_MODULE_6__["SurveyAction"], {
                        item: this.question.closeCameraAction
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("video", {
                        autoPlay: true,
                        playsInline: true,
                        id: this.question.videoId,
                        className: this.question.cssClasses.video
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_action_bar_action_bar_item__WEBPACK_IMPORTED_MODULE_6__["SurveyAction"], {
                        item: this.question.takePictureAction
                    }));
                };
                return SurveyQuestionFile;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestionElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_4__["ReactQuestionFactory"].Instance.registerQuestion("file", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionFile, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_html.tsx": /*!******************************************!*\
  !*** ./src/react/reactquestion_html.tsx ***!
  \******************************************/ /*! exports provided: SurveyQuestionHtml */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionHtml", function() {
                return SurveyQuestionHtml;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionHtml = /** @class */ function(_super) {
                __extends(SurveyQuestionHtml, _super);
                function SurveyQuestionHtml(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionHtml.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionHtml.prototype.componentDidMount = function() {
                    this.reactOnStrChanged();
                };
                SurveyQuestionHtml.prototype.componentWillUnmount = function() {
                    this.question.locHtml.onChanged = function() {};
                };
                SurveyQuestionHtml.prototype.componentDidUpdate = function(prevProps, prevState) {
                    this.reactOnStrChanged();
                };
                SurveyQuestionHtml.prototype.reactOnStrChanged = function() {
                    var _this = this;
                    this.question.locHtml.onChanged = function() {
                        _this.setState({
                            changed: !!_this.state && _this.state.changed ? _this.state.changed + 1 : 1
                        });
                    };
                };
                SurveyQuestionHtml.prototype.canRender = function() {
                    return _super.prototype.canRender.call(this) && !!this.question.html;
                };
                SurveyQuestionHtml.prototype.renderElement = function() {
                    var htmlValue = {
                        __html: this.question.locHtml.renderedHtml
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.renderCssRoot,
                        dangerouslySetInnerHTML: htmlValue
                    });
                };
                return SurveyQuestionHtml;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("html", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionHtml, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_matrix.tsx": /*!********************************************!*\
  !*** ./src/react/reactquestion_matrix.tsx ***!
  \********************************************/ /*! exports provided: SurveyQuestionMatrix, SurveyQuestionMatrixRow, SurveyQuestionMatrixCell */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrix", function() {
                return SurveyQuestionMatrix;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixRow", function() {
                return SurveyQuestionMatrixRow;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixCell", function() {
                return SurveyQuestionMatrixCell;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionMatrix = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrix, _super);
                function SurveyQuestionMatrix(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = {
                        rowsChanged: 0
                    };
                    return _this;
                }
                Object.defineProperty(SurveyQuestionMatrix.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrix.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    if (this.question) {
                        var self = this;
                        this.question.visibleRowsChangedCallback = function() {
                            self.setState({
                                rowsChanged: self.state.rowsChanged + 1
                            });
                        };
                    }
                };
                SurveyQuestionMatrix.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    if (this.question) this.question.visibleRowsChangedCallback = null;
                };
                SurveyQuestionMatrix.prototype.renderElement = function() {
                    var _this = this;
                    var cssClasses = this.question.cssClasses;
                    var rowsTH = this.question.hasRows ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("td", null) : null;
                    var headers = [];
                    for(var i = 0; i < this.question.visibleColumns.length; i++){
                        var column = this.question.visibleColumns[i];
                        var key = "column" + i;
                        var columText = this.renderLocString(column.locText);
                        var style = {};
                        if (!!this.question.columnMinWidth) {
                            style.minWidth = this.question.columnMinWidth;
                            style.width = this.question.columnMinWidth;
                        }
                        headers.push(react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("th", {
                            className: this.question.cssClasses.headerCell,
                            style: style,
                            key: key
                        }, this.wrapCell({
                            column: column
                        }, columText, "column-header")));
                    }
                    var rows = [];
                    var visibleRows = this.question.visibleRows;
                    for(var i = 0; i < visibleRows.length; i++){
                        var row = visibleRows[i];
                        var key = "row-" + row.name + "-" + i;
                        rows.push(react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrixRow, {
                            key: key,
                            question: this.question,
                            cssClasses: cssClasses,
                            row: row,
                            isFirst: i == 0
                        }));
                    }
                    var header = !this.question.showHeader ? null : react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("thead", null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tr", null, rowsTH, headers));
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.tableWrapper,
                        ref: function(root) {
                            return _this.setControl(root);
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("fieldset", null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("legend", {
                        className: "sv-hidden"
                    }, this.question.locTitle.renderedHtml), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("table", {
                        className: this.question.getTableCss()
                    }, header, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tbody", null, rows))));
                };
                return SurveyQuestionMatrix;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            var SurveyQuestionMatrixRow = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixRow, _super);
                function SurveyQuestionMatrixRow(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionMatrixRow.prototype.getStateElement = function() {
                    if (!!this.row) return this.row.item;
                    return _super.prototype.getStateElement.call(this);
                };
                Object.defineProperty(SurveyQuestionMatrixRow.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixRow.prototype, "row", {
                    get: function() {
                        return this.props.row;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixRow.prototype.wrapCell = function(cell, element, reason) {
                    if (!reason) return element;
                    var survey = this.question.survey;
                    var wrapper = null;
                    if (survey) wrapper = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_3__["ReactSurveyElementsWrapper"].wrapMatrixCell(survey, element, cell, reason);
                    return wrapper !== null && wrapper !== void 0 ? wrapper : element;
                };
                SurveyQuestionMatrixRow.prototype.canRender = function() {
                    return !!this.row;
                };
                SurveyQuestionMatrixRow.prototype.renderElement = function() {
                    var rowsTD = null;
                    if (this.question.hasRows) {
                        var rowText = this.renderLocString(this.row.locText);
                        var style = {};
                        if (!!this.question.rowTitleWidth) {
                            style.minWidth = this.question.rowTitleWidth;
                            style.width = this.question.rowTitleWidth;
                        }
                        rowsTD = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("td", {
                            style: style,
                            className: this.row.rowTextClasses
                        }, this.wrapCell({
                            row: this.row
                        }, rowText, "row-header"));
                    }
                    var tds = this.generateTds();
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tr", {
                        className: this.row.rowClasses || undefined
                    }, rowsTD, tds);
                };
                SurveyQuestionMatrixRow.prototype.generateTds = function() {
                    var _this = this;
                    var tds = [];
                    var row = this.row;
                    var cellComponent = this.question.cellComponent;
                    var _loop_1 = function() {
                        var td = null;
                        var column = this_1.question.visibleColumns[i];
                        var key = "value" + i;
                        var itemClass = this_1.question.getItemClass(row, column);
                        if (this_1.question.hasCellText) {
                            var getHandler = function(column) {
                                return function() {
                                    return _this.cellClick(row, column);
                                };
                            };
                            td = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("td", {
                                key: key,
                                className: itemClass,
                                onClick: getHandler ? getHandler(column) : function() {}
                            }, this_1.renderLocString(this_1.question.getCellDisplayLocText(row.name, column)));
                        } else {
                            var renderedCell = _element_factory__WEBPACK_IMPORTED_MODULE_4__["ReactElementFactory"].Instance.createElement(cellComponent, {
                                question: this_1.question,
                                row: this_1.row,
                                column: column,
                                columnIndex: i,
                                cssClasses: this_1.cssClasses,
                                cellChanged: function() {
                                    _this.cellClick(_this.row, column);
                                }
                            });
                            td = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("td", {
                                key: key,
                                "data-responsive-title": column.locText.renderedHtml,
                                className: this_1.question.cssClasses.cell
                            }, renderedCell);
                        }
                        tds.push(td);
                    };
                    var this_1 = this;
                    for(var i = 0; i < this.question.visibleColumns.length; i++)_loop_1();
                    return tds;
                };
                SurveyQuestionMatrixRow.prototype.cellClick = function(row, column) {
                    row.value = column.value;
                    this.setState({
                        value: this.row.value
                    });
                };
                return SurveyQuestionMatrixRow;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            var SurveyQuestionMatrixCell = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixCell, _super);
                function SurveyQuestionMatrixCell(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnMouseDown = _this.handleOnMouseDown.bind(_this);
                    _this.handleOnChange = _this.handleOnChange.bind(_this);
                    return _this;
                }
                SurveyQuestionMatrixCell.prototype.handleOnChange = function(event) {
                    if (!!this.props.cellChanged) this.props.cellChanged();
                };
                SurveyQuestionMatrixCell.prototype.handleOnMouseDown = function(event) {
                    this.question.onMouseDown();
                };
                Object.defineProperty(SurveyQuestionMatrixCell.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixCell.prototype, "row", {
                    get: function() {
                        return this.props.row;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixCell.prototype, "column", {
                    get: function() {
                        return this.props.column;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixCell.prototype, "columnIndex", {
                    get: function() {
                        return this.props.columnIndex;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixCell.prototype.canRender = function() {
                    return !!this.question && !!this.row;
                };
                SurveyQuestionMatrixCell.prototype.renderElement = function() {
                    var isChecked = this.row.value == this.column.value;
                    var inputId = this.question.inputId + "_" + this.row.name + "_" + this.columnIndex;
                    var itemClass = this.question.getItemClass(this.row, this.column);
                    var mobileSpan = this.question.isMobile ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.question.cssClasses.cellResponsiveTitle
                    }, this.renderLocString(this.column.locText)) : undefined;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("label", {
                        onMouseDown: this.handleOnMouseDown,
                        className: itemClass
                    }, this.renderInput(inputId, isChecked), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.question.cssClasses.materialDecorator
                    }, this.question.itemSvgIcon ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", {
                        className: this.cssClasses.itemDecorator
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", {
                        xlinkHref: this.question.itemSvgIcon
                    })) : null), mobileSpan);
                };
                SurveyQuestionMatrixCell.prototype.renderInput = function(inputId, isChecked) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        id: inputId,
                        type: "radio",
                        className: this.cssClasses.itemValue,
                        name: this.row.fullName,
                        value: this.column.value,
                        disabled: this.row.isReadOnly,
                        checked: isChecked,
                        onChange: this.handleOnChange,
                        "aria-required": this.question.a11y_input_ariaRequired,
                        "aria-label": this.question.getCellAriaLabel(this.row.locText.renderedHtml, this.column.locText.renderedHtml),
                        "aria-invalid": this.question.a11y_input_ariaInvalid,
                        "aria-errormessage": this.question.a11y_input_ariaErrormessage
                    });
                };
                return SurveyQuestionMatrixCell;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_4__["ReactElementFactory"].Instance.registerElement("survey-matrix-cell", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrixCell, props);
            });
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("matrix", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrix, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_matrixdropdown.tsx": /*!****************************************************!*\
  !*** ./src/react/reactquestion_matrixdropdown.tsx ***!
  \****************************************************/ /*! exports provided: SurveyQuestionMatrixDropdown */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdown", function() {
                return SurveyQuestionMatrixDropdown;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_matrixdropdownbase */ "./src/react/reactquestion_matrixdropdownbase.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionMatrixDropdown = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixDropdown, _super);
                function SurveyQuestionMatrixDropdown(props) {
                    return _super.call(this, props) || this;
                }
                return SurveyQuestionMatrixDropdown;
            }(_reactquestion_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionMatrixDropdownBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("matrixdropdown", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrixDropdown, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_matrixdropdownbase.tsx": /*!********************************************************!*\
  !*** ./src/react/reactquestion_matrixdropdownbase.tsx ***!
  \********************************************************/ /*! exports provided: SurveyQuestionMatrixDropdownBase, SurveyQuestionMatrixDropdownCell */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdownBase", function() {
                return SurveyQuestionMatrixDropdownBase;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDropdownCell", function() {
                return SurveyQuestionMatrixDropdownCell;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion */ "./src/react/reactquestion.tsx");
            /* harmony import */ var _reactquestion_checkbox__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_checkbox */ "./src/react/reactquestion_checkbox.tsx");
            /* harmony import */ var _reactquestion_radiogroup__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./reactquestion_radiogroup */ "./src/react/reactquestion_radiogroup.tsx");
            /* harmony import */ var _panel__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./panel */ "./src/react/panel.tsx");
            /* harmony import */ var _components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            /* harmony import */ var _components_matrix_row__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/matrix/row */ "./src/react/components/matrix/row.tsx");
            /* harmony import */ var _components_matrix_actions_drag_drop_icon_drag_drop_icon__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./components/matrix-actions/drag-drop-icon/drag-drop-icon */ "./src/react/components/matrix-actions/drag-drop-icon/drag-drop-icon.tsx");
            /* harmony import */ var _reactquestion_comment__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./reactquestion_comment */ "./src/react/reactquestion_comment.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionMatrixDropdownBase = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixDropdownBase, _super);
                function SurveyQuestionMatrixDropdownBase(props) {
                    var _this = _super.call(this, props) || this;
                    //Create rendered table in contructor and not on rendering
                    var table = _this.question.renderedTable;
                    _this.state = _this.getState();
                    return _this;
                }
                Object.defineProperty(SurveyQuestionMatrixDropdownBase.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixDropdownBase.prototype.getState = function(prevState) {
                    if (prevState === void 0) prevState = null;
                    return {
                        rowCounter: !prevState ? 0 : prevState.rowCounter + 1
                    };
                };
                SurveyQuestionMatrixDropdownBase.prototype.updateStateOnCallback = function() {
                    if (this.isRendering) return;
                    this.setState(this.getState(this.state));
                };
                SurveyQuestionMatrixDropdownBase.prototype.componentDidMount = function() {
                    var _this = this;
                    _super.prototype.componentDidMount.call(this);
                    this.question.visibleRowsChangedCallback = function() {
                        _this.updateStateOnCallback();
                    };
                    this.question.onRenderedTableResetCallback = function() {
                        _this.question.renderedTable.renderedRowsChangedCallback = function() {
                            _this.updateStateOnCallback();
                        };
                        _this.updateStateOnCallback();
                    };
                    this.question.renderedTable.renderedRowsChangedCallback = function() {
                        _this.updateStateOnCallback();
                    };
                };
                SurveyQuestionMatrixDropdownBase.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.question.visibleRowsChangedCallback = function() {};
                    this.question.onRenderedTableResetCallback = function() {};
                    this.question.renderedTable.renderedRowsChangedCallback = function() {};
                };
                SurveyQuestionMatrixDropdownBase.prototype.renderElement = function() {
                    return this.renderTableDiv();
                };
                SurveyQuestionMatrixDropdownBase.prototype.renderTableDiv = function() {
                    var _this = this;
                    var header = this.renderHeader();
                    var footers = this.renderFooter();
                    var rows = this.renderRows();
                    var divStyle = this.question.showHorizontalScroll ? {
                        overflowX: "scroll"
                    } : {};
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        style: divStyle,
                        className: this.question.cssClasses.tableWrapper,
                        ref: function(root) {
                            return _this.setControl(root);
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("table", {
                        className: this.question.getTableCss()
                    }, header, rows, footers));
                };
                SurveyQuestionMatrixDropdownBase.prototype.renderHeader = function() {
                    var table = this.question.renderedTable;
                    if (!table.showHeader) return null;
                    var headers = [];
                    var cells = table.headerRow.cells;
                    for(var i = 0; i < cells.length; i++){
                        var cell = cells[i];
                        var key = "column" + i;
                        var columnStyle = {};
                        if (!!cell.width) columnStyle.width = cell.width;
                        if (!!cell.minWidth) columnStyle.minWidth = cell.minWidth;
                        var cellContent = this.renderCellContent(cell, "column-header", {});
                        var header = cell.hasTitle ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("th", {
                            className: cell.className,
                            key: key,
                            style: columnStyle
                        }, " ", cellContent, " ") : react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("td", {
                            className: cell.className,
                            key: key,
                            style: columnStyle
                        });
                        headers.push(header);
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("thead", null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tr", null, headers));
                };
                SurveyQuestionMatrixDropdownBase.prototype.renderFooter = function() {
                    var table = this.question.renderedTable;
                    if (!table.showFooter) return null;
                    var row = this.renderRow("footer", table.footerRow, this.question.cssClasses, "row-footer");
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tfoot", null, row);
                };
                SurveyQuestionMatrixDropdownBase.prototype.renderRows = function() {
                    var cssClasses = this.question.cssClasses;
                    var rows = [];
                    var renderedRows = this.question.renderedTable.rows;
                    for(var i = 0; i < renderedRows.length; i++)rows.push(this.renderRow(renderedRows[i].id, renderedRows[i], cssClasses));
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tbody", null, rows);
                };
                SurveyQuestionMatrixDropdownBase.prototype.renderRow = function(keyValue, row, cssClasses, reason) {
                    var matrixrow = [];
                    var cells = row.cells;
                    for(var i = 0; i < cells.length; i++)matrixrow.push(this.renderCell(cells[i], i, cssClasses, reason));
                    var key = "row" + keyValue;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], {
                        key: key
                    }, reason == "row-footer" ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tr", null, matrixrow) : react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_matrix_row__WEBPACK_IMPORTED_MODULE_7__["MatrixRow"], {
                        model: row,
                        parentMatrix: this.question
                    }, matrixrow));
                };
                SurveyQuestionMatrixDropdownBase.prototype.renderCell = function(cell, index, cssClasses, reason) {
                    var key = "cell" + index;
                    if (cell.hasQuestion) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrixDropdownCell, {
                        key: key,
                        cssClasses: cssClasses,
                        cell: cell,
                        creator: this.creator,
                        reason: reason
                    });
                    var calcReason = reason;
                    if (!calcReason) calcReason = cell.hasTitle ? "row-header" : "";
                    var cellContent = this.renderCellContent(cell, calcReason, cssClasses);
                    var cellStyle = null;
                    if (!!cell.width || !!cell.minWidth) {
                        cellStyle = {};
                        if (!!cell.width) cellStyle.width = cell.width;
                        if (!!cell.minWidth) cellStyle.minWidth = cell.minWidth;
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("td", {
                        className: cell.className,
                        key: key,
                        style: cellStyle,
                        colSpan: cell.colSpans,
                        "data-responsive-title": cell.headers,
                        title: cell.getTitle()
                    }, cellContent);
                };
                SurveyQuestionMatrixDropdownBase.prototype.renderCellContent = function(cell, reason, cssClasses) {
                    var cellContent = null;
                    var cellStyle = null;
                    if (!!cell.width || !!cell.minWidth) {
                        cellStyle = {};
                        if (!!cell.width) cellStyle.width = cell.width;
                        if (!!cell.minWidth) cellStyle.minWidth = cell.minWidth;
                    }
                    if (cell.hasTitle) {
                        reason = "row-header";
                        var str = this.renderLocString(cell.locTitle);
                        var require_1 = !!cell.column ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrixHeaderRequired, {
                            column: cell.column,
                            question: this.question
                        }) : null;
                        cellContent = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, str, require_1);
                    }
                    if (cell.isDragHandlerCell) cellContent = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_matrix_actions_drag_drop_icon_drag_drop_icon__WEBPACK_IMPORTED_MODULE_8__["SurveyQuestionMatrixDynamicDragDropIcon"], {
                        item: {
                            data: {
                                row: cell.row,
                                question: this.question
                            }
                        }
                    }));
                    if (cell.isActionsCell) cellContent = _element_factory__WEBPACK_IMPORTED_MODULE_10__["ReactElementFactory"].Instance.createElement("sv-matrixdynamic-actions-cell", {
                        question: this.question,
                        cssClasses: cssClasses,
                        cell: cell,
                        model: cell.item.getData()
                    });
                    if (cell.hasPanel) cellContent = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_panel__WEBPACK_IMPORTED_MODULE_5__["SurveyPanel"], {
                        key: cell.panel.id,
                        element: cell.panel,
                        survey: this.question.survey,
                        cssClasses: cssClasses,
                        isDisplayMode: this.isDisplayMode,
                        creator: this.creator
                    });
                    if (cell.isErrorsCell) {
                        if (cell.isErrorsCell) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionErrorCell"], {
                            question: cell.question,
                            creator: this.creator
                        });
                    }
                    if (!cellContent) return null;
                    var readyCell = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, cellContent);
                    return this.wrapCell(cell, readyCell, reason);
                };
                return SurveyQuestionMatrixDropdownBase;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            var SurveyQuestionMatrixActionsCell = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixActionsCell, _super);
                function SurveyQuestionMatrixActionsCell(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionMatrixActionsCell.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixActionsCell.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_6__["SurveyActionBar"], {
                        model: this.model,
                        handleClick: false
                    });
                };
                return SurveyQuestionMatrixActionsCell;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_10__["ReactElementFactory"].Instance.registerElement("sv-matrixdynamic-actions-cell", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrixActionsCell, props);
            });
            var SurveyQuestionMatrixHeaderRequired = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixHeaderRequired, _super);
                function SurveyQuestionMatrixHeaderRequired(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionMatrixHeaderRequired.prototype, "column", {
                    get: function() {
                        return this.props.column;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixHeaderRequired.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixHeaderRequired.prototype.getStateElement = function() {
                    return this.column;
                };
                SurveyQuestionMatrixHeaderRequired.prototype.renderElement = function() {
                    if (!this.column.isRenderedRequired) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, "\xa0"), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.question.cssClasses.cellRequiredText
                    }, this.column.requiredText));
                };
                return SurveyQuestionMatrixHeaderRequired;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            var SurveyQuestionMatrixDropdownCell = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixDropdownCell, _super);
                function SurveyQuestionMatrixDropdownCell(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionMatrixDropdownCell.prototype, "cell", {
                    get: function() {
                        return this.props.cell;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionMatrixDropdownCell.prototype, "itemCss", {
                    get: function() {
                        return !!this.cell ? this.cell.className : "";
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixDropdownCell.prototype.getQuestion = function() {
                    var q = _super.prototype.getQuestion.call(this);
                    if (!!q) return q;
                    return !!this.cell ? this.cell.question : null;
                };
                SurveyQuestionMatrixDropdownCell.prototype.doAfterRender = function() {
                    var el = this.cellRef.current;
                    if (el && this.cell && this.question && this.question.survey && el.getAttribute("data-rendered") !== "r") {
                        el.setAttribute("data-rendered", "r");
                        var options = {
                            cell: this.cell,
                            cellQuestion: this.question,
                            htmlElement: el,
                            row: this.cell.row,
                            column: this.cell.cell.column
                        };
                        this.question.survey.matrixAfterCellRender(this.question, options);
                        this.question.afterRenderCore(el);
                    }
                };
                SurveyQuestionMatrixDropdownCell.prototype.getShowErrors = function() {
                    return this.question.isVisible && (!this.cell.isChoice || this.cell.isFirstChoice);
                };
                SurveyQuestionMatrixDropdownCell.prototype.getCellStyle = function() {
                    var res = _super.prototype.getCellStyle.call(this);
                    if (!!this.cell.width || !!this.cell.minWidth) {
                        if (!res) res = {};
                        if (!!this.cell.width) res.width = this.cell.width;
                        if (!!this.cell.minWidth) res.minWidth = this.cell.minWidth;
                    }
                    return res;
                };
                SurveyQuestionMatrixDropdownCell.prototype.getHeaderText = function() {
                    return this.cell.headers;
                };
                SurveyQuestionMatrixDropdownCell.prototype.renderQuestion = function() {
                    if (!this.cell.isChoice) return _reactquestion__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestion"].renderQuestionBody(this.creator, this.question);
                    if (this.cell.isOtherChoice) return this.renderOtherComment();
                    if (this.cell.isCheckbox) return this.renderCellCheckboxButton();
                    return this.renderCellRadiogroupButton();
                };
                SurveyQuestionMatrixDropdownCell.prototype.renderOtherComment = function() {
                    var question = this.cell.question;
                    var cssClasses = question.cssClasses || {};
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion_comment__WEBPACK_IMPORTED_MODULE_9__["SurveyQuestionOtherValueItem"], {
                        question: question,
                        cssClasses: cssClasses,
                        otherCss: cssClasses.other,
                        isDisplayMode: question.isInputReadOnly
                    });
                };
                SurveyQuestionMatrixDropdownCell.prototype.renderCellCheckboxButton = function() {
                    var key = this.cell.question.id + "item" + this.cell.choiceIndex;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion_checkbox__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestionCheckboxItem"], {
                        key: key,
                        question: this.cell.question,
                        cssClasses: this.cell.question.cssClasses,
                        isDisplayMode: this.cell.question.isInputReadOnly,
                        item: this.cell.item,
                        isFirst: this.cell.isFirstChoice,
                        index: this.cell.choiceIndex.toString(),
                        hideCaption: true
                    });
                };
                SurveyQuestionMatrixDropdownCell.prototype.renderCellRadiogroupButton = function() {
                    var key = this.cell.question.id + "item" + this.cell.choiceIndex;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion_radiogroup__WEBPACK_IMPORTED_MODULE_4__["SurveyQuestionRadioItem"], {
                        key: key,
                        question: this.cell.question,
                        cssClasses: this.cell.question.cssClasses,
                        isDisplayMode: this.cell.question.isInputReadOnly,
                        item: this.cell.item,
                        index: this.cell.choiceIndex.toString(),
                        isChecked: this.cell.question.value === this.cell.item.value,
                        isDisabled: this.cell.question.isReadOnly || !this.cell.item.isEnabled,
                        hideCaption: true
                    });
                };
                return SurveyQuestionMatrixDropdownCell;
            }(_reactquestion__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionAndErrorsCell"]);
        /***/ },
        /***/ "./src/react/reactquestion_matrixdynamic.tsx": /*!***************************************************!*\
  !*** ./src/react/reactquestion_matrixdynamic.tsx ***!
  \***************************************************/ /*! exports provided: SurveyQuestionMatrixDynamic, SurveyQuestionMatrixDynamicAddButton */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamic", function() {
                return SurveyQuestionMatrixDynamic;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMatrixDynamicAddButton", function() {
                return SurveyQuestionMatrixDynamicAddButton;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _reactquestion_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_matrixdropdownbase */ "./src/react/reactquestion_matrixdropdownbase.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionMatrixDynamic = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixDynamic, _super);
                function SurveyQuestionMatrixDynamic(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnRowAddClick = _this.handleOnRowAddClick.bind(_this);
                    return _this;
                }
                Object.defineProperty(SurveyQuestionMatrixDynamic.prototype, "matrix", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixDynamic.prototype.handleOnRowAddClick = function(event) {
                    this.matrix.addRowUI();
                };
                SurveyQuestionMatrixDynamic.prototype.renderElement = function() {
                    var cssClasses = this.question.cssClasses;
                    var showTable = this.question.renderedTable.showTable;
                    var mainDiv = showTable ? this.renderTableDiv() : this.renderNoRowsContent(cssClasses);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, this.renderAddRowButtonOnTop(cssClasses), mainDiv, this.renderAddRowButtonOnBottom(cssClasses));
                };
                SurveyQuestionMatrixDynamic.prototype.renderAddRowButtonOnTop = function(cssClasses) {
                    if (!this.matrix.renderedTable.showAddRowOnTop) return null;
                    return this.renderAddRowButton(cssClasses);
                };
                SurveyQuestionMatrixDynamic.prototype.renderAddRowButtonOnBottom = function(cssClasses) {
                    if (!this.matrix.renderedTable.showAddRowOnBottom) return null;
                    return this.renderAddRowButton(cssClasses);
                };
                SurveyQuestionMatrixDynamic.prototype.renderNoRowsContent = function(cssClasses) {
                    var text = this.renderLocString(this.matrix.locEmptyRowsText);
                    var textDiv = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.emptyRowsText
                    }, text);
                    var btn = this.matrix.renderedTable.showAddRow ? this.renderAddRowButton(cssClasses, true) : undefined;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.emptyRowsSection
                    }, textDiv, btn);
                };
                SurveyQuestionMatrixDynamic.prototype.renderAddRowButton = function(cssClasses, isEmptySection) {
                    if (isEmptySection === void 0) isEmptySection = false;
                    return _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.createElement("sv-matrixdynamic-add-btn", {
                        question: this.question,
                        cssClasses: cssClasses,
                        isEmptySection: isEmptySection
                    });
                };
                return SurveyQuestionMatrixDynamic;
            }(_reactquestion_matrixdropdownbase__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionMatrixDropdownBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_1__["ReactQuestionFactory"].Instance.registerQuestion("matrixdynamic", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrixDynamic, props);
            });
            var SurveyQuestionMatrixDynamicAddButton = /** @class */ function(_super) {
                __extends(SurveyQuestionMatrixDynamicAddButton, _super);
                function SurveyQuestionMatrixDynamicAddButton(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnRowAddClick = _this.handleOnRowAddClick.bind(_this);
                    return _this;
                }
                Object.defineProperty(SurveyQuestionMatrixDynamicAddButton.prototype, "matrix", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMatrixDynamicAddButton.prototype.handleOnRowAddClick = function(event) {
                    this.matrix.addRowUI();
                };
                SurveyQuestionMatrixDynamicAddButton.prototype.renderElement = function() {
                    var addRowText = this.renderLocString(this.matrix.locAddRowText);
                    var addButton = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("button", {
                        className: this.matrix.getAddRowButtonCss(this.props.isEmptySection),
                        type: "button",
                        disabled: this.matrix.isInputReadOnly,
                        onClick: this.matrix.isDesignMode ? undefined : this.handleOnRowAddClick
                    }, addRowText, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.props.cssClasses.iconAdd
                    }));
                    return this.props.isEmptySection ? addButton : react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.props.cssClasses.footer
                    }, addButton);
                };
                return SurveyQuestionMatrixDynamicAddButton;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_4__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.registerElement("sv-matrixdynamic-add-btn", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMatrixDynamicAddButton, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_multipletext.tsx": /*!**************************************************!*\
  !*** ./src/react/reactquestion_multipletext.tsx ***!
  \**************************************************/ /*! exports provided: SurveyQuestionMultipleText, SurveyMultipleTextItem, SurveyMultipleTextItemEditor */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionMultipleText", function() {
                return SurveyQuestionMultipleText;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyMultipleTextItem", function() {
                return SurveyMultipleTextItem;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyMultipleTextItemEditor", function() {
                return SurveyMultipleTextItemEditor;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion */ "./src/react/reactquestion.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _components_title_title_content__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/title/title-content */ "./src/react/components/title/title-content.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionMultipleText = /** @class */ function(_super) {
                __extends(SurveyQuestionMultipleText, _super);
                function SurveyQuestionMultipleText(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionMultipleText.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionMultipleText.prototype.renderElement = function() {
                    var cssClasses = this.question.cssClasses;
                    var tableRows = this.question.getRows();
                    var rows = [];
                    for(var i = 0; i < tableRows.length; i++)if (tableRows[i].isVisible) rows.push(this.renderRow(i, tableRows[i].cells, cssClasses));
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("table", {
                        className: this.question.getQuestionRootCss()
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tbody", null, rows));
                };
                SurveyQuestionMultipleText.prototype.renderCell = function(cell, cssClasses, index) {
                    var cellContent;
                    var focusIn = function() {
                        cell.item.focusIn();
                    };
                    if (cell.isErrorsCell) cellContent = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionErrorCell"], {
                        question: cell.item.editor,
                        creator: this.creator
                    });
                    else cellContent = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyMultipleTextItem, {
                        question: this.question,
                        item: cell.item,
                        creator: this.creator,
                        cssClasses: cssClasses
                    });
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("td", {
                        key: "item" + index,
                        className: cell.className,
                        onFocus: focusIn
                    }, cellContent);
                };
                SurveyQuestionMultipleText.prototype.renderRow = function(rowIndex, cells, cssClasses) {
                    var key = "item" + rowIndex;
                    var tds = [];
                    for(var i = 0; i < cells.length; i++){
                        var cell = cells[i];
                        tds.push(this.renderCell(cell, cssClasses, i));
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("tr", {
                        key: key,
                        className: cssClasses.row
                    }, tds);
                };
                return SurveyQuestionMultipleText;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            var SurveyMultipleTextItem = /** @class */ function(_super) {
                __extends(SurveyMultipleTextItem, _super);
                function SurveyMultipleTextItem() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyMultipleTextItem.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyMultipleTextItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyMultipleTextItem.prototype.getStateElements = function() {
                    return [
                        this.item,
                        this.item.editor
                    ];
                };
                Object.defineProperty(SurveyMultipleTextItem.prototype, "creator", {
                    get: function() {
                        return this.props.creator;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyMultipleTextItem.prototype.renderElement = function() {
                    var item = this.item;
                    var cssClasses = this.cssClasses;
                    var titleStyle = {};
                    if (!!this.question.itemTitleWidth) {
                        titleStyle.minWidth = this.question.itemTitleWidth;
                        titleStyle.width = this.question.itemTitleWidth;
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("label", {
                        className: this.question.getItemLabelCss(item)
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.itemTitle,
                        style: titleStyle
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_title_title_content__WEBPACK_IMPORTED_MODULE_4__["TitleContent"], {
                        element: item.editor,
                        cssClasses: item.editor.cssClasses
                    })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyMultipleTextItemEditor, {
                        cssClasses: cssClasses,
                        itemCss: this.question.getItemCss(),
                        question: item.editor,
                        creator: this.creator
                    }));
                };
                return SurveyMultipleTextItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            var SurveyMultipleTextItemEditor = /** @class */ function(_super) {
                __extends(SurveyMultipleTextItemEditor, _super);
                function SurveyMultipleTextItemEditor() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                SurveyMultipleTextItemEditor.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.itemCss
                    }, this.renderContent());
                };
                return SurveyMultipleTextItemEditor;
            }(_reactquestion__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionAndErrorsWrapped"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__["ReactQuestionFactory"].Instance.registerQuestion("multipletext", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionMultipleText, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_paneldynamic.tsx": /*!**************************************************!*\
  !*** ./src/react/reactquestion_paneldynamic.tsx ***!
  \**************************************************/ /*! exports provided: SurveyQuestionPanelDynamic, SurveyQuestionPanelDynamicItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamic", function() {
                return SurveyQuestionPanelDynamic;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionPanelDynamicItem", function() {
                return SurveyQuestionPanelDynamicItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _panel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./panel */ "./src/react/panel.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/action-bar/action-bar */ "./src/react/components/action-bar/action-bar.tsx");
            /* harmony import */ var _components_paneldynamic_actions_paneldynamic_next_btn__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./components/paneldynamic-actions/paneldynamic-next-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-next-btn.tsx");
            /* harmony import */ var _components_paneldynamic_actions_paneldynamic_prev_btn__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./components/paneldynamic-actions/paneldynamic-prev-btn */ "./src/react/components/paneldynamic-actions/paneldynamic-prev-btn.tsx");
            /* harmony import */ var _components_paneldynamic_actions_paneldynamic_progress_text__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./components/paneldynamic-actions/paneldynamic-progress-text */ "./src/react/components/paneldynamic-actions/paneldynamic-progress-text.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionPanelDynamic = /** @class */ function(_super) {
                __extends(SurveyQuestionPanelDynamic, _super);
                function SurveyQuestionPanelDynamic(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionPanelDynamic.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionPanelDynamic.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.setState({
                        panelCounter: 0
                    });
                    var self = this;
                    this.question.panelCountChangedCallback = function() {
                        self.updateQuestionRendering();
                    };
                    this.question.currentIndexChangedCallback = function() {
                        self.updateQuestionRendering();
                    };
                    this.question.renderModeChangedCallback = function() {
                        self.updateQuestionRendering();
                    };
                };
                SurveyQuestionPanelDynamic.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.question.panelCountChangedCallback = function() {};
                    this.question.currentIndexChangedCallback = function() {};
                    this.question.renderModeChangedCallback = function() {};
                };
                SurveyQuestionPanelDynamic.prototype.updateQuestionRendering = function() {
                    this.setState({
                        panelCounter: this.state ? this.state.panelCounter + 1 : 1
                    });
                };
                SurveyQuestionPanelDynamic.prototype.renderElement = function() {
                    var panels = [];
                    if (this.question.isRenderModeList) for(var i = 0; i < this.question.panels.length; i++){
                        var panel = this.question.panels[i];
                        panels.push(react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionPanelDynamicItem, {
                            key: panel.id,
                            element: panel,
                            question: this.question,
                            index: i,
                            cssClasses: this.question.cssClasses,
                            isDisplayMode: this.isDisplayMode,
                            creator: this.creator
                        }));
                    }
                    else if (this.question.currentPanel != null) {
                        var panel = this.question.currentPanel;
                        panels.push(react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionPanelDynamicItem, {
                            key: this.question.currentIndex,
                            element: panel,
                            question: this.question,
                            index: this.question.currentIndex,
                            cssClasses: this.question.cssClasses,
                            isDisplayMode: this.isDisplayMode,
                            creator: this.creator
                        }));
                    }
                    var btnAdd = this.question.isRenderModeList && this.question["showLegacyNavigation"] ? this.renderAddRowButton() : null;
                    var navTop = this.question.isProgressTopShowing ? this.renderNavigator() : null;
                    var navBottom = this.question.isProgressBottomShowing ? this.renderNavigator() : null;
                    var style = {};
                    var navV2 = this.renderNavigatorV2();
                    var noEntriesPlaceholder = this.renderPlaceholder();
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.root
                    }, noEntriesPlaceholder, navTop, panels, navBottom, btnAdd, navV2);
                };
                SurveyQuestionPanelDynamic.prototype.renderNavigator = function() {
                    if (!this.question["showLegacyNavigation"]) {
                        if (this.question.isRangeShowing && this.question.isProgressTopShowing) return this.renderRange();
                        else return null;
                    }
                    var range = this.question.isRangeShowing ? this.renderRange() : null;
                    var btnPrev = this.rendrerPrevButton();
                    var btnNext = this.rendrerNextButton();
                    var btnAdd = this.renderAddRowButton();
                    var progressClass = this.question.isProgressTopShowing ? this.question.cssClasses.progressTop : this.question.cssClasses.progressBottom;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: progressClass
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        style: {
                            clear: "both"
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.progressContainer
                    }, btnPrev, range, btnNext), btnAdd, this.renderProgressText()));
                };
                SurveyQuestionPanelDynamic.prototype.renderProgressText = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_paneldynamic_actions_paneldynamic_progress_text__WEBPACK_IMPORTED_MODULE_7__["SurveyQuestionPanelDynamicProgressText"], {
                        data: {
                            question: this.question
                        }
                    });
                };
                SurveyQuestionPanelDynamic.prototype.rendrerPrevButton = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_paneldynamic_actions_paneldynamic_prev_btn__WEBPACK_IMPORTED_MODULE_6__["SurveyQuestionPanelDynamicPrevButton"], {
                        data: {
                            question: this.question
                        }
                    });
                };
                SurveyQuestionPanelDynamic.prototype.rendrerNextButton = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_paneldynamic_actions_paneldynamic_next_btn__WEBPACK_IMPORTED_MODULE_5__["SurveyQuestionPanelDynamicNextButton"], {
                        data: {
                            question: this.question
                        }
                    });
                };
                SurveyQuestionPanelDynamic.prototype.renderRange = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.progress
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.progressBar,
                        style: {
                            width: this.question.progress
                        },
                        role: "progressbar"
                    }));
                };
                SurveyQuestionPanelDynamic.prototype.renderAddRowButton = function() {
                    return _element_factory__WEBPACK_IMPORTED_MODULE_8__["ReactElementFactory"].Instance.createElement("sv-paneldynamic-add-btn", {
                        data: {
                            question: this.question
                        }
                    });
                };
                SurveyQuestionPanelDynamic.prototype.renderNavigatorV2 = function() {
                    if (!this.question.showNavigation) return null;
                    var range = this.question.isRangeShowing && this.question.isProgressBottomShowing ? this.renderRange() : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.footer
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("hr", {
                        className: this.question.cssClasses.separator
                    }), range, this.question.footerToolbar.visibleActions.length ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.footerButtonsContainer
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_action_bar_action_bar__WEBPACK_IMPORTED_MODULE_4__["SurveyActionBar"], {
                        model: this.question.footerToolbar
                    })) : null);
                };
                SurveyQuestionPanelDynamic.prototype.renderPlaceholder = function() {
                    if (this.question.getShowNoEntriesPlaceholder()) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.noEntriesPlaceholder
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, this.renderLocString(this.question.locNoEntriesText)), this.renderAddRowButton());
                    return null;
                };
                return SurveyQuestionPanelDynamic;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            var SurveyQuestionPanelDynamicItem = /** @class */ function(_super) {
                __extends(SurveyQuestionPanelDynamicItem, _super);
                function SurveyQuestionPanelDynamicItem() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyQuestionPanelDynamicItem.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionPanelDynamicItem.prototype, "index", {
                    get: function() {
                        return this.props.index;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionPanelDynamicItem.prototype.getSurvey = function() {
                    return !!this.question ? this.question.survey : null;
                };
                SurveyQuestionPanelDynamicItem.prototype.getCss = function() {
                    var survey = this.getSurvey();
                    return !!survey ? survey.getCss() : {};
                };
                SurveyQuestionPanelDynamicItem.prototype.render = function() {
                    var panel = _super.prototype.render.call(this);
                    var removeButton = this.renderButton();
                    var separator = this.question.showSeparator(this.index) ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("hr", {
                        className: this.question.cssClasses.separator
                    }) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.getPanelWrapperCss(this.panel)
                    }, panel, removeButton), separator);
                };
                SurveyQuestionPanelDynamicItem.prototype.renderButton = function() {
                    if (this.question.panelRemoveButtonLocation !== "right" || !this.question.canRemovePanel || this.question.isRenderModeList && this.panel.isCollapsed) return null;
                    return _element_factory__WEBPACK_IMPORTED_MODULE_8__["ReactElementFactory"].Instance.createElement("sv-paneldynamic-remove-btn", {
                        data: {
                            question: this.question,
                            panel: this.panel
                        }
                    });
                };
                return SurveyQuestionPanelDynamicItem;
            }(_panel__WEBPACK_IMPORTED_MODULE_2__["SurveyPanel"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__["ReactQuestionFactory"].Instance.registerQuestion("paneldynamic", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionPanelDynamic, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_radiogroup.tsx": /*!************************************************!*\
  !*** ./src/react/reactquestion_radiogroup.tsx ***!
  \************************************************/ /*! exports provided: SurveyQuestionRadiogroup, SurveyQuestionRadioItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRadiogroup", function() {
                return SurveyQuestionRadiogroup;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRadioItem", function() {
                return SurveyQuestionRadioItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_comment__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_comment */ "./src/react/reactquestion_comment.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionRadiogroup = /** @class */ function(_super) {
                __extends(SurveyQuestionRadiogroup, _super);
                function SurveyQuestionRadiogroup(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionRadiogroup.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionRadiogroup.prototype.renderElement = function() {
                    var _this = this;
                    var cssClasses = this.question.cssClasses;
                    var clearButton = null;
                    if (this.question.showClearButtonInContent) clearButton = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        type: "button",
                        className: this.question.cssClasses.clearButton,
                        onClick: function() {
                            return _this.question.clearValue();
                        },
                        value: this.question.clearButtonCaption
                    }));
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("fieldset", {
                        className: this.question.getSelectBaseRootCss(),
                        ref: function(fieldset) {
                            return _this.setControl(fieldset);
                        },
                        role: this.question.a11y_input_ariaRole,
                        "aria-required": this.question.a11y_input_ariaRequired,
                        "aria-label": this.question.a11y_input_ariaLabel,
                        "aria-labelledby": this.question.a11y_input_ariaLabelledBy,
                        "aria-describedby": this.question.a11y_input_ariaDescribedBy,
                        "aria-invalid": this.question.a11y_input_ariaInvalid,
                        "aria-errormessage": this.question.a11y_input_ariaErrormessage
                    }, this.question.hasColumns ? this.getColumnedBody(cssClasses) : this.getBody(cssClasses), this.getFooter(), this.question.isOtherSelected ? this.renderOther(cssClasses) : null, clearButton);
                };
                SurveyQuestionRadiogroup.prototype.getFooter = function() {
                    var _this = this;
                    if (this.question.hasFootItems) return this.question.footItems.map(function(item, ii) {
                        return _this.renderItem("item_f" + ii, item, false, _this.question.cssClasses);
                    });
                };
                SurveyQuestionRadiogroup.prototype.getColumnedBody = function(cssClasses) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.rootMultiColumn
                    }, this.getColumns(cssClasses));
                };
                SurveyQuestionRadiogroup.prototype.getColumns = function(cssClasses) {
                    var _this = this;
                    var value = this.getStateValue();
                    return this.question.columns.map(function(column, ci) {
                        var items = column.map(function(item, ii) {
                            return _this.renderItem("item" + ci + ii, item, value, cssClasses, "" + ci + ii);
                        });
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            key: "column" + ci,
                            className: _this.question.getColumnClass(),
                            role: "presentation"
                        }, items);
                    });
                };
                SurveyQuestionRadiogroup.prototype.getBody = function(cssClasses) {
                    if (this.question.blockedRow) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.rootRow
                    }, this.getItems(cssClasses, this.question.dataChoices));
                    else return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, this.getItems(cssClasses, this.question.bodyItems));
                };
                SurveyQuestionRadiogroup.prototype.getItems = function(cssClasses, choices) {
                    var items = [];
                    var value = this.getStateValue();
                    for(var i = 0; i < choices.length; i++){
                        var item = choices[i];
                        var renderedItem = this.renderItem("item" + i, item, value, cssClasses, "" + i);
                        items.push(renderedItem);
                    }
                    return items;
                };
                Object.defineProperty(SurveyQuestionRadiogroup.prototype, "textStyle", {
                    get: function() {
                        return null; //{ display: "inline", position: "static" };
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionRadiogroup.prototype.renderOther = function(cssClasses) {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.getCommentAreaCss(true)
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_reactquestion_comment__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionOtherValueItem"], {
                        question: this.question,
                        otherCss: cssClasses.other,
                        cssClasses: cssClasses,
                        isDisplayMode: this.isDisplayMode
                    }));
                };
                SurveyQuestionRadiogroup.prototype.renderItem = function(key, item, value, cssClasses, index) {
                    var renderedItem = _element_factory__WEBPACK_IMPORTED_MODULE_5__["ReactElementFactory"].Instance.createElement(this.question.itemComponent, {
                        key: key,
                        question: this.question,
                        cssClasses: cssClasses,
                        isDisplayMode: this.isDisplayMode,
                        item: item,
                        textStyle: this.textStyle,
                        index: index,
                        isChecked: value === item.value
                    });
                    var survey = this.question.survey;
                    var wrappedItem = null;
                    if (!!survey) wrappedItem = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_4__["ReactSurveyElementsWrapper"].wrapItemValue(survey, renderedItem, this.question, item);
                    return wrappedItem !== null && wrappedItem !== void 0 ? wrappedItem : renderedItem;
                };
                SurveyQuestionRadiogroup.prototype.getStateValue = function() {
                    return !this.question.isEmpty() ? this.question.renderedValue : "";
                };
                return SurveyQuestionRadiogroup;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            var SurveyQuestionRadioItem = /** @class */ function(_super) {
                __extends(SurveyQuestionRadioItem, _super);
                function SurveyQuestionRadioItem(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnChange = _this.handleOnChange.bind(_this);
                    _this.handleOnMouseDown = _this.handleOnMouseDown.bind(_this);
                    return _this;
                }
                SurveyQuestionRadioItem.prototype.getStateElement = function() {
                    return this.item;
                };
                Object.defineProperty(SurveyQuestionRadioItem.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRadioItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRadioItem.prototype, "textStyle", {
                    get: function() {
                        return this.props.textStyle;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRadioItem.prototype, "index", {
                    get: function() {
                        return this.props.index;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRadioItem.prototype, "isChecked", {
                    get: function() {
                        return this.props.isChecked;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRadioItem.prototype, "hideCaption", {
                    get: function() {
                        return this.props.hideCaption === true;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionRadioItem.prototype.shouldComponentUpdate = function(nextProps, nextState) {
                    if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState)) return false;
                    if (!this.question) return false;
                    return !this.question.customWidget || !!this.question.customWidgetData.isNeedRender || !!this.question.customWidget.widgetJson.isDefaultRender || !!this.question.customWidget.widgetJson.render;
                };
                SurveyQuestionRadioItem.prototype.handleOnChange = function(event) {
                    this.question.clickItemHandler(this.item);
                };
                SurveyQuestionRadioItem.prototype.handleOnMouseDown = function(event) {
                    this.question.onMouseDown();
                };
                SurveyQuestionRadioItem.prototype.canRender = function() {
                    return !!this.question && !!this.item;
                };
                SurveyQuestionRadioItem.prototype.renderElement = function() {
                    var itemClass = this.question.getItemClass(this.item);
                    var labelClass = this.question.getLabelClass(this.item);
                    var controlLabelClass = this.question.getControlLabelClass(this.item);
                    var itemLabel = !this.hideCaption ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: controlLabelClass
                    }, this.renderLocString(this.item.locText, this.textStyle)) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: itemClass,
                        role: "presentation"
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("label", {
                        onMouseDown: this.handleOnMouseDown,
                        className: labelClass
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        "aria-errormessage": this.question.ariaErrormessage,
                        className: this.cssClasses.itemControl,
                        id: this.question.getItemId(this.item),
                        type: "radio",
                        name: this.question.questionName,
                        checked: this.isChecked,
                        value: this.item.value,
                        disabled: !this.question.getItemEnabled(this.item),
                        onChange: this.handleOnChange
                    }), this.cssClasses.materialDecorator ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: this.cssClasses.materialDecorator
                    }, this.question.itemSvgIcon ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", {
                        className: this.cssClasses.itemDecorator
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", {
                        xlinkHref: this.question.itemSvgIcon
                    })) : null) : null, itemLabel));
                };
                return SurveyQuestionRadioItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_5__["ReactElementFactory"].Instance.registerElement("survey-radiogroup-item", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionRadioItem, props);
            });
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_3__["ReactQuestionFactory"].Instance.registerQuestion("radiogroup", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionRadiogroup, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_ranking.tsx": /*!*********************************************!*\
  !*** ./src/react/reactquestion_ranking.tsx ***!
  \*********************************************/ /*! exports provided: SurveyQuestionRanking, SurveyQuestionRankingItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRanking", function() {
                return SurveyQuestionRanking;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRankingItem", function() {
                return SurveyQuestionRankingItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionRanking = /** @class */ function(_super) {
                __extends(SurveyQuestionRanking, _super);
                function SurveyQuestionRanking() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyQuestionRanking.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionRanking.prototype.renderElement = function() {
                    var _this = this;
                    if (!this.question.selectToRankEnabled) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.rootClass,
                        ref: function(root) {
                            return _this.setControl(root);
                        }
                    }, this.getItems());
                    else {
                        var unrankedItem = true;
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: this.question.rootClass,
                            ref: function(root) {
                                return _this.setControl(root);
                            }
                        }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: this.question.getContainerClasses("from"),
                            "data-ranking": "from-container"
                        }, this.getItems(this.question.unRankingChoices, unrankedItem), this.question.unRankingChoices.length === 0 ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: this.question.cssClasses.containerPlaceholder
                        }, " ", this.renderLocString(this.question.locSelectToRankEmptyRankedAreaText), " ") : null), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: this.question.cssClasses.containersDivider
                        }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: this.question.getContainerClasses("to"),
                            "data-ranking": "to-container"
                        }, this.getItems(), this.question.rankingChoices.length === 0 ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: this.question.cssClasses.containerPlaceholder
                        }, " ", this.renderLocString(this.question.locSelectToRankEmptyUnrankedAreaText), " ") : null));
                    }
                };
                SurveyQuestionRanking.prototype.getItems = function(choices, unrankedItem) {
                    var _this = this;
                    if (choices === void 0) choices = this.question.rankingChoices;
                    var items = [];
                    var _loop_1 = function(i) {
                        var item = choices[i];
                        items.push(this_1.renderItem(item, i, function(event) {
                            _this.question.handleKeydown.call(_this.question, event, item);
                        }, function(event) {
                            event.persist();
                            //event.preventDefault();
                            _this.question.handlePointerDown.call(_this.question, event, item, event.currentTarget);
                        }, this_1.question.cssClasses, this_1.question.getItemClass(item), this_1.question, unrankedItem));
                    };
                    var this_1 = this;
                    for(var i = 0; i < choices.length; i++)_loop_1(i);
                    return items;
                };
                SurveyQuestionRanking.prototype.renderItem = function(item, i, handleKeydown, handlePointerDown, cssClasses, itemClass, question, unrankedItem) {
                    var key = item.value + "-" + i + "-item";
                    var text = this.renderLocString(item.locText);
                    var index = i;
                    var indexText = this.question.getNumberByIndex(i);
                    var tabIndex = this.question.getItemTabIndex(item);
                    var renderedItem = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionRankingItem, {
                        key: key,
                        text: text,
                        index: index,
                        indexText: indexText,
                        itemTabIndex: tabIndex,
                        handleKeydown: handleKeydown,
                        handlePointerDown: handlePointerDown,
                        cssClasses: cssClasses,
                        itemClass: itemClass,
                        question: question,
                        unrankedItem: unrankedItem,
                        item: item
                    });
                    var survey = this.question.survey;
                    var wrappedItem = null;
                    if (!!survey) wrappedItem = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_3__["ReactSurveyElementsWrapper"].wrapItemValue(survey, renderedItem, this.question, item);
                    return wrappedItem !== null && wrappedItem !== void 0 ? wrappedItem : renderedItem;
                };
                return SurveyQuestionRanking;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            var SurveyQuestionRankingItem = /** @class */ function(_super) {
                __extends(SurveyQuestionRankingItem, _super);
                function SurveyQuestionRankingItem() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "text", {
                    get: function() {
                        return this.props.text;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "index", {
                    get: function() {
                        return this.props.index;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "indexText", {
                    get: function() {
                        return this.props.indexText;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "handleKeydown", {
                    get: function() {
                        return this.props.handleKeydown;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "handlePointerDown", {
                    get: function() {
                        return this.props.handlePointerDown;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "cssClasses", {
                    get: function() {
                        return this.props.cssClasses;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "itemClass", {
                    get: function() {
                        return this.props.itemClass;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "itemTabIndex", {
                    get: function() {
                        return this.props.itemTabIndex;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "unrankedItem", {
                    get: function() {
                        return this.props.unrankedItem;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionRankingItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionRankingItem.prototype.renderEmptyIcon = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", {
                        xlinkHref: this.question.dashSvgIcon
                    }));
                };
                SurveyQuestionRankingItem.prototype.renderElement = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        tabIndex: this.itemTabIndex,
                        className: this.itemClass,
                        onKeyDown: this.handleKeydown,
                        onPointerDown: this.handlePointerDown,
                        "data-sv-drop-target-ranking-item": this.index
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        tabIndex: -1,
                        style: {
                            outline: "none"
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.cssClasses.itemGhostNode
                    }), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.cssClasses.itemContent
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.cssClasses.itemIconContainer
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", {
                        className: this.question.getIconHoverCss()
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", {
                        xlinkHref: this.question.dragDropSvgIcon
                    })), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("svg", {
                        className: this.question.getIconFocusCss()
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("use", {
                        xlinkHref: this.question.arrowsSvgIcon
                    }))), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.getItemIndexClasses(this.item)
                    }, !this.unrankedItem && this.indexText ? this.indexText : this.renderEmptyIcon()), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.cssClasses.controlLabel
                    }, this.text))));
                };
                return SurveyQuestionRankingItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("ranking", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionRanking, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_rating.tsx": /*!********************************************!*\
  !*** ./src/react/reactquestion_rating.tsx ***!
  \********************************************/ /*! exports provided: SurveyQuestionRating */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionRating", function() {
                return SurveyQuestionRating;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionRating = /** @class */ function(_super) {
                __extends(SurveyQuestionRating, _super);
                function SurveyQuestionRating(props) {
                    var _this = _super.call(this, props) || this;
                    _this.handleOnClick = _this.handleOnClick.bind(_this);
                    return _this;
                }
                Object.defineProperty(SurveyQuestionRating.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionRating.prototype.handleOnClick = function(event) {
                    this.question.setValueFromClick(event.target.value);
                    this.setState({
                        value: this.question.value
                    });
                };
                SurveyQuestionRating.prototype.renderItem = function(item, index) {
                    var renderedItem = _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.createElement(this.question.itemComponent, {
                        question: this.question,
                        item: item,
                        index: index,
                        key: "value" + index,
                        handleOnClick: this.handleOnClick,
                        isDisplayMode: this.isDisplayMode
                    });
                    return renderedItem;
                };
                SurveyQuestionRating.prototype.renderElement = function() {
                    var _this = this;
                    var cssClasses = this.question.cssClasses;
                    var minText = this.question.minRateDescription ? this.renderLocString(this.question.locMinRateDescription) : null;
                    var maxText = this.question.maxRateDescription ? this.renderLocString(this.question.locMaxRateDescription) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.ratingRootCss,
                        ref: function(div) {
                            return _this.setControl(div);
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("fieldset", {
                        role: "radiogroup"
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("legend", {
                        role: "presentation",
                        className: "sv-hidden"
                    }), !!this.question.hasMinLabel ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.minText
                    }, minText) : null, this.question.renderedRateItems.map(function(item, index) {
                        return _this.renderItem(item, index);
                    }), !!this.question.hasMaxLabel ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        className: cssClasses.maxText
                    }, maxText) : null));
                };
                return SurveyQuestionRating;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("rating", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionRating, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_tagbox.tsx": /*!********************************************!*\
  !*** ./src/react/reactquestion_tagbox.tsx ***!
  \********************************************/ /*! exports provided: SurveyQuestionTagbox */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionTagbox", function() {
                return SurveyQuestionTagbox;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _dropdown_base__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./dropdown-base */ "./src/react/dropdown-base.tsx");
            /* harmony import */ var _tagbox_item__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./tagbox-item */ "./src/react/tagbox-item.tsx");
            /* harmony import */ var _tagbox_filter__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./tagbox-filter */ "./src/react/tagbox-filter.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionTagbox = /** @class */ function(_super) {
                __extends(SurveyQuestionTagbox, _super);
                function SurveyQuestionTagbox(props) {
                    return _super.call(this, props) || this;
                }
                SurveyQuestionTagbox.prototype.renderItem = function(key, item) {
                    var renderedItem = react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_tagbox_item__WEBPACK_IMPORTED_MODULE_3__["SurveyQuestionTagboxItem"], {
                        key: key,
                        question: this.question,
                        item: item
                    });
                    return renderedItem;
                };
                SurveyQuestionTagbox.prototype.renderInput = function(dropdownListModel) {
                    var _this = this;
                    var dropdownMultiSelectListModel = dropdownListModel;
                    var items = this.question.selectedChoices.map(function(choice, index) {
                        return _this.renderItem("item" + index, choice);
                    });
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        id: this.question.inputId,
                        className: this.question.getControlClass(),
                        tabIndex: dropdownListModel.noTabIndex ? undefined : 0,
                        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                        // @ts-ignore
                        disabled: this.question.isInputReadOnly,
                        required: this.question.isRequired,
                        onKeyDown: this.keyhandler,
                        onBlur: this.blur,
                        role: this.question.ariaRole,
                        "aria-required": this.question.ariaRequired,
                        "aria-label": this.question.ariaLabel,
                        "aria-invalid": this.question.ariaInvalid,
                        "aria-errormessage": this.question.ariaErrormessage,
                        "aria-expanded": this.question.ariaExpanded === null ? undefined : this.question.ariaExpanded === "true",
                        "aria-controls": dropdownListModel.listElementId,
                        "aria-activedescendant": dropdownListModel.ariaActivedescendant
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.controlValue
                    }, items, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_tagbox_filter__WEBPACK_IMPORTED_MODULE_4__["TagboxFilterString"], {
                        model: dropdownMultiSelectListModel,
                        question: this.question
                    })), this.createClearButton());
                };
                SurveyQuestionTagbox.prototype.renderElement = function() {
                    var cssClasses = this.question.cssClasses;
                    var comment = this.question.isOtherSelected ? this.renderOther(cssClasses) : null;
                    var select = this.renderSelect(cssClasses);
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.renderCssRoot
                    }, select, comment);
                };
                SurveyQuestionTagbox.prototype.renderReadOnlyElement = function() {
                    if (this.question.locReadOnlyText) return this.renderLocString(this.question.locReadOnlyText);
                    else return null;
                };
                return SurveyQuestionTagbox;
            }(_dropdown_base__WEBPACK_IMPORTED_MODULE_2__["SurveyQuestionDropdownBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_1__["ReactQuestionFactory"].Instance.registerQuestion("tagbox", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionTagbox, props);
            });
        /***/ },
        /***/ "./src/react/reactquestion_text.tsx": /*!******************************************!*\
  !*** ./src/react/reactquestion_text.tsx ***!
  \******************************************/ /*! exports provided: SurveyQuestionText */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionText", function() {
                return SurveyQuestionText;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _components_character_counter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/character-counter */ "./src/react/components/character-counter.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionText = /** @class */ function(_super) {
                __extends(SurveyQuestionText, _super);
                //controlRef: React.RefObject<HTMLInputElement>;
                function SurveyQuestionText(props) {
                    return _super.call(this, props) || this;
                //this.controlRef = React.createRef();
                }
                SurveyQuestionText.prototype.renderInput = function() {
                    var _this = this;
                    var inputClass = this.question.getControlClass();
                    var placeholder = this.question.renderedPlaceholder;
                    if (this.question.isReadOnlyRenderDiv()) return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, this.question.inputValue);
                    var counter = !!this.question.getMaxLength() ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_character_counter__WEBPACK_IMPORTED_MODULE_3__["CharacterCounterComponent"], {
                        counter: this.question.characterCounter,
                        remainingCharacterCounter: this.question.cssClasses.remainingCharacterCounter
                    }) : null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](react__WEBPACK_IMPORTED_MODULE_0__["Fragment"], null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        id: this.question.inputId,
                        disabled: this.isDisplayMode,
                        className: inputClass,
                        type: this.question.inputType,
                        //ref={this.controlRef}
                        ref: function(input) {
                            return _this.setControl(input);
                        },
                        style: this.question.inputStyle,
                        maxLength: this.question.getMaxLength(),
                        min: this.question.renderedMin,
                        max: this.question.renderedMax,
                        step: this.question.renderedStep,
                        size: this.question.inputSize,
                        placeholder: placeholder,
                        list: this.question.dataListId,
                        autoComplete: this.question.autocomplete,
                        onBlur: this.question.onBlur,
                        onFocus: this.question.onFocus,
                        onChange: this.question.onChange,
                        onKeyUp: this.question.onKeyUp,
                        onKeyDown: this.question.onKeyDown,
                        onCompositionUpdate: function(event) {
                            return _this.question.onCompositionUpdate(event.nativeEvent);
                        },
                        "aria-required": this.question.a11y_input_ariaRequired,
                        "aria-label": this.question.a11y_input_ariaLabel,
                        "aria-labelledby": this.question.a11y_input_ariaLabelledBy,
                        "aria-describedby": this.question.a11y_input_ariaDescribedBy,
                        "aria-invalid": this.question.a11y_input_ariaInvalid,
                        "aria-errormessage": this.question.a11y_input_ariaErrormessage
                    }), counter);
                };
                SurveyQuestionText.prototype.renderElement = function() {
                    return this.question.dataListId ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, this.renderInput(), this.renderDataList()) : this.renderInput();
                };
                SurveyQuestionText.prototype.setValueCore = function(newValue) {
                    this.question.inputValue = newValue;
                };
                SurveyQuestionText.prototype.getValueCore = function() {
                    return this.question.inputValue;
                };
                SurveyQuestionText.prototype.renderDataList = function() {
                    if (!this.question.dataListId) return null;
                    var items = this.question.dataList;
                    if (items.length == 0) return null;
                    var options = [];
                    for(var i = 0; i < items.length; i++)options.push(react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("option", {
                        key: "item" + i,
                        value: items[i]
                    }));
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("datalist", {
                        id: this.question.dataListId
                    }, options);
                };
                return SurveyQuestionText;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionUncontrolledElement"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("text", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionText, props);
            });
        /***/ },
        /***/ "./src/react/reactsurveymodel.tsx": /*!****************************************!*\
  !*** ./src/react/reactsurveymodel.tsx ***!
  \****************************************/ /*! exports provided: ReactSurveyElementsWrapper */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ReactSurveyElementsWrapper", function() {
                return ReactSurveyElementsWrapper;
            });
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var ReactSurveyElementsWrapper = /** @class */ function() {
                function ReactSurveyElementsWrapper() {}
                ReactSurveyElementsWrapper.wrapRow = function(survey, element, row) {
                    var componentName = survey.getRowWrapperComponentName(row);
                    var componentData = survey.getRowWrapperComponentData(row);
                    return _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(componentName, {
                        element: element,
                        row: row,
                        componentData: componentData
                    });
                };
                ReactSurveyElementsWrapper.wrapElement = function(survey, element, question) {
                    var componentName = survey.getElementWrapperComponentName(question);
                    var componentData = survey.getElementWrapperComponentData(question);
                    return _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(componentName, {
                        element: element,
                        question: question,
                        componentData: componentData
                    });
                };
                ReactSurveyElementsWrapper.wrapQuestionContent = function(survey, element, question) {
                    var componentName = survey.getQuestionContentWrapperComponentName(question);
                    var componentData = survey.getElementWrapperComponentData(question);
                    return _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(componentName, {
                        element: element,
                        question: question,
                        componentData: componentData
                    });
                };
                ReactSurveyElementsWrapper.wrapItemValue = function(survey, element, question, item) {
                    var componentName = survey.getItemValueWrapperComponentName(item, question);
                    var componentData = survey.getItemValueWrapperComponentData(item, question);
                    return _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(componentName, {
                        key: element === null || element === void 0 ? void 0 : element.key,
                        element: element,
                        question: question,
                        item: item,
                        componentData: componentData
                    });
                };
                ReactSurveyElementsWrapper.wrapMatrixCell = function(survey, element, cell, reason) {
                    if (reason === void 0) reason = "cell";
                    var componentName = survey.getElementWrapperComponentName(cell, reason);
                    var componentData = survey.getElementWrapperComponentData(cell, reason);
                    return _element_factory__WEBPACK_IMPORTED_MODULE_1__["ReactElementFactory"].Instance.createElement(componentName, {
                        element: element,
                        cell: cell,
                        componentData: componentData
                    });
                };
                return ReactSurveyElementsWrapper;
            }();
            survey_core__WEBPACK_IMPORTED_MODULE_0__["SurveyModel"].platform = "react";
        /***/ },
        /***/ "./src/react/reacttimerpanel.tsx": /*!***************************************!*\
  !*** ./src/react/reacttimerpanel.tsx ***!
  \***************************************/ /*! exports provided: SurveyTimerPanel */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyTimerPanel", function() {
                return SurveyTimerPanel;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyTimerPanel = /** @class */ function(_super) {
                __extends(SurveyTimerPanel, _super);
                function SurveyTimerPanel(props) {
                    var _this = _super.call(this, props) || this;
                    _this.circleLength = 440;
                    return _this;
                }
                SurveyTimerPanel.prototype.getStateElement = function() {
                    return this.timerModel;
                };
                Object.defineProperty(SurveyTimerPanel.prototype, "timerModel", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyTimerPanel.prototype, "progress", {
                    get: function() {
                        return -this.timerModel.progress * this.circleLength;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyTimerPanel.prototype.render = function() {
                    if (!this.timerModel.isRunning) return null;
                    var result = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.timerModel.survey.getCss().timerRoot
                    }, this.timerModel.text);
                    if (this.timerModel.showTimerAsClock) {
                        var style = {
                            strokeDasharray: this.circleLength,
                            strokeDashoffset: this.progress
                        };
                        var progress = this.timerModel.showProgress ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_1__["SvgIcon"], {
                            className: this.timerModel.getProgressCss(),
                            style: style,
                            iconName: "icon-timercircle",
                            size: "auto"
                        }) : null;
                        result = react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: this.timerModel.rootCss
                        }, progress, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                            className: this.timerModel.textContainerCss
                        }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                            className: this.timerModel.majorTextCss
                        }, this.timerModel.clockMajorText), this.timerModel.clockMinorText ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                            className: this.timerModel.minorTextCss
                        }, this.timerModel.clockMinorText) : null));
                    }
                    return result;
                };
                return SurveyTimerPanel;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["ReactSurveyElement"]);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement("sv-timerpanel", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyTimerPanel, props);
            });
        /***/ },
        /***/ "./src/react/row.tsx": /*!***************************!*\
  !*** ./src/react/row.tsx ***!
  \***************************/ /*! exports provided: SurveyRow */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyRow", function() {
                return SurveyRow;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _element__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./element */ "./src/react/element.tsx");
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            /* harmony import */ var _reactsurveymodel__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./reactsurveymodel */ "./src/react/reactsurveymodel.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyRow = /** @class */ function(_super) {
                __extends(SurveyRow, _super);
                function SurveyRow(props) {
                    var _this = _super.call(this, props) || this;
                    _this.rootRef = react__WEBPACK_IMPORTED_MODULE_0__["createRef"]();
                    _this.recalculateCss();
                    return _this;
                }
                SurveyRow.prototype.recalculateCss = function() {
                    this.row.visibleElements.map(function(element) {
                        return element.cssClasses;
                    });
                };
                SurveyRow.prototype.getStateElement = function() {
                    return this.row;
                };
                Object.defineProperty(SurveyRow.prototype, "row", {
                    get: function() {
                        return this.props.row;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyRow.prototype, "survey", {
                    get: function() {
                        return this.props.survey;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyRow.prototype, "creator", {
                    get: function() {
                        return this.props.creator;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyRow.prototype, "css", {
                    get: function() {
                        return this.props.css;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyRow.prototype.canRender = function() {
                    return !!this.row && !!this.survey && !!this.creator;
                };
                SurveyRow.prototype.renderElementContent = function() {
                    var _this = this;
                    var elements = this.row.visibleElements.map(function(element, elementIndex) {
                        var index = elementIndex ? "-" + elementIndex : 0;
                        var key = element.name + index;
                        return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_element__WEBPACK_IMPORTED_MODULE_2__["SurveyRowElement"], {
                            element: element,
                            index: elementIndex,
                            row: _this.row,
                            survey: _this.survey,
                            creator: _this.creator,
                            css: _this.css,
                            key: key
                        });
                    });
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        ref: this.rootRef,
                        className: this.row.getRowCss()
                    }, elements);
                };
                SurveyRow.prototype.renderElement = function() {
                    var survey = this.survey;
                    var content = this.renderElementContent();
                    var wrapper = _reactsurveymodel__WEBPACK_IMPORTED_MODULE_4__["ReactSurveyElementsWrapper"].wrapRow(survey, content, this.row);
                    return wrapper || content;
                };
                SurveyRow.prototype.componentDidMount = function() {
                    var _this = this;
                    _super.prototype.componentDidMount.call(this);
                    var el = this.rootRef.current;
                    if (this.rootRef.current) this.row.setRootElement(this.rootRef.current);
                    if (!!el && !this.row.isNeedRender) {
                        var rowContainerDiv = el;
                        setTimeout(function() {
                            _this.row.startLazyRendering(rowContainerDiv);
                        }, 10);
                    }
                };
                SurveyRow.prototype.shouldComponentUpdate = function(nextProps, nextState) {
                    if (!_super.prototype.shouldComponentUpdate.call(this, nextProps, nextState)) return false;
                    if (nextProps.row !== this.row) {
                        nextProps.row.isNeedRender = this.row.isNeedRender;
                        nextProps.row.setRootElement(this.rootRef.current);
                        this.row.setRootElement(undefined);
                        this.stopLazyRendering();
                    }
                    this.recalculateCss();
                    return true;
                };
                SurveyRow.prototype.stopLazyRendering = function() {
                    this.row.stopLazyRendering();
                    this.row.isNeedRender = !this.row.isLazyRendering();
                };
                SurveyRow.prototype.componentWillUnmount = function() {
                    _super.prototype.componentWillUnmount.call(this);
                    this.row.setRootElement(undefined);
                    this.stopLazyRendering();
                };
                SurveyRow.prototype.createElement = function(element, elementIndex) {
                    var index = elementIndex ? "-" + elementIndex : 0;
                    var elementType = element.getType();
                    if (!_element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.isElementRegistered(elementType)) elementType = "question";
                    return _element_factory__WEBPACK_IMPORTED_MODULE_3__["ReactElementFactory"].Instance.createElement(elementType, {
                        key: element.name + index,
                        element: element,
                        creator: this.creator,
                        survey: this.survey,
                        css: this.css
                    });
                };
                return SurveyRow;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyElementBase"]);
        /***/ },
        /***/ "./src/react/signaturepad.tsx": /*!************************************!*\
  !*** ./src/react/signaturepad.tsx ***!
  \************************************/ /*! exports provided: SurveyQuestionSignaturePad */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionSignaturePad", function() {
                return SurveyQuestionSignaturePad;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            /* harmony import */ var _components_loading_indicator__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/loading-indicator */ "./src/react/components/loading-indicator.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionSignaturePad = /** @class */ function(_super) {
                __extends(SurveyQuestionSignaturePad, _super);
                function SurveyQuestionSignaturePad(props) {
                    var _this = _super.call(this, props) || this;
                    _this.state = {
                        value: _this.question.value
                    };
                    return _this;
                }
                Object.defineProperty(SurveyQuestionSignaturePad.prototype, "question", {
                    get: function() {
                        return this.questionBase;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionSignaturePad.prototype.renderElement = function() {
                    var _this = this;
                    var cssClasses = this.question.cssClasses;
                    var loadingIndicator = this.question.showLoadingIndicator ? this.renderLoadingIndicator() : null;
                    var clearButton = this.renderCleanButton();
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.root,
                        ref: function(root) {
                            return _this.setControl(root);
                        },
                        style: {
                            width: this.question.renderedCanvasWidth
                        }
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.placeholder,
                        style: {
                            display: this.question.needShowPlaceholder() ? "" : "none"
                        }
                    }, this.renderLocString(this.question.locPlaceholder)), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", null, this.renderBackgroundImage(), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("canvas", {
                        tabIndex: -1,
                        className: this.question.cssClasses.canvas,
                        onBlur: this.question.onBlur
                    })), clearButton, loadingIndicator);
                };
                SurveyQuestionSignaturePad.prototype.renderBackgroundImage = function() {
                    if (!this.question.backgroundImage) return null;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("img", {
                        className: this.question.cssClasses.backgroundImage,
                        src: this.question.backgroundImage,
                        style: {
                            width: this.question.renderedCanvasWidth
                        }
                    });
                };
                SurveyQuestionSignaturePad.prototype.renderLoadingIndicator = function() {
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.loadingIndicator
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_loading_indicator__WEBPACK_IMPORTED_MODULE_4__["LoadingIndicatorComponent"], null));
                };
                SurveyQuestionSignaturePad.prototype.renderCleanButton = function() {
                    var _this = this;
                    if (!this.question.canShowClearButton) return null;
                    var cssClasses = this.question.cssClasses;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: cssClasses.controls
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("button", {
                        type: "button",
                        className: cssClasses.clearButton,
                        title: this.question.clearButtonCaption,
                        onClick: function() {
                            return _this.question.clearValue();
                        }
                    }, this.question.cssClasses.clearButtonIconId ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_3__["SvgIcon"], {
                        iconName: this.question.cssClasses.clearButtonIconId,
                        size: "auto"
                    }) : react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, "\u2716")));
                };
                return SurveyQuestionSignaturePad;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["SurveyQuestionElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("signaturepad", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](SurveyQuestionSignaturePad, props);
            });
        /***/ },
        /***/ "./src/react/string-editor.tsx": /*!*************************************!*\
  !*** ./src/react/string-editor.tsx ***!
  \*************************************/ /*! exports provided: SurveyLocStringEditor */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyLocStringEditor", function() {
                return SurveyLocStringEditor;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyLocStringEditor = /** @class */ function(_super) {
                __extends(SurveyLocStringEditor, _super);
                function SurveyLocStringEditor(props) {
                    var _this = _super.call(this, props) || this;
                    _this.onInput = function(event) {
                        _this.locStr.text = event.target.innerText;
                    };
                    _this.onClick = function(event) {
                        event.preventDefault();
                        event.stopPropagation();
                    };
                    _this.state = {
                        changed: 0
                    };
                    return _this;
                }
                Object.defineProperty(SurveyLocStringEditor.prototype, "locStr", {
                    get: function() {
                        return this.props.locStr;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyLocStringEditor.prototype, "style", {
                    get: function() {
                        return this.props.style;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyLocStringEditor.prototype.componentDidMount = function() {
                    if (!this.locStr) return;
                    var self = this;
                    this.locStr.onChanged = function() {
                        self.setState({
                            changed: self.state.changed + 1
                        });
                    };
                };
                SurveyLocStringEditor.prototype.componentWillUnmount = function() {
                    if (!this.locStr) return;
                    this.locStr.onChanged = function() {};
                };
                SurveyLocStringEditor.prototype.render = function() {
                    if (!this.locStr) return null;
                    if (this.locStr.hasHtml) {
                        var htmlValue = {
                            __html: this.locStr.renderedHtml
                        };
                        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                            className: "sv-string-editor",
                            contentEditable: "true",
                            suppressContentEditableWarning: true,
                            style: this.style,
                            dangerouslySetInnerHTML: htmlValue,
                            onBlur: this.onInput,
                            onClick: this.onClick
                        });
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        className: "sv-string-editor",
                        contentEditable: "true",
                        suppressContentEditableWarning: true,
                        style: this.style,
                        onBlur: this.onInput,
                        onClick: this.onClick
                    }, this.locStr.renderedHtml);
                };
                return SurveyLocStringEditor;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement(survey_core__WEBPACK_IMPORTED_MODULE_1__["LocalizableString"].editableRenderer, function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyLocStringEditor, props);
            });
        /***/ },
        /***/ "./src/react/string-viewer.tsx": /*!*************************************!*\
  !*** ./src/react/string-viewer.tsx ***!
  \*************************************/ /*! exports provided: SurveyLocStringViewer */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyLocStringViewer", function() {
                return SurveyLocStringViewer;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _element_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./element-factory */ "./src/react/element-factory.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyLocStringViewer = /** @class */ function(_super) {
                __extends(SurveyLocStringViewer, _super);
                function SurveyLocStringViewer(props) {
                    var _this = _super.call(this, props) || this;
                    _this.onChangedHandler = function(sender, options) {
                        if (_this.isRendering) return;
                        _this.setState({
                            changed: !!_this.state && _this.state.changed ? _this.state.changed + 1 : 1
                        });
                    };
                    _this.rootRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();
                    return _this;
                }
                Object.defineProperty(SurveyLocStringViewer.prototype, "locStr", {
                    get: function() {
                        return this.props.locStr;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyLocStringViewer.prototype, "style", {
                    get: function() {
                        return this.props.style;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyLocStringViewer.prototype.componentDidMount = function() {
                    this.reactOnStrChanged();
                };
                SurveyLocStringViewer.prototype.componentWillUnmount = function() {
                    if (!this.locStr) return;
                    this.locStr.onStringChanged.remove(this.onChangedHandler);
                };
                SurveyLocStringViewer.prototype.componentDidUpdate = function(prevProps, prevState) {
                    if (!!prevProps.locStr) prevProps.locStr.onStringChanged.remove(this.onChangedHandler);
                    this.reactOnStrChanged();
                };
                SurveyLocStringViewer.prototype.reactOnStrChanged = function() {
                    if (!this.locStr) return;
                    this.locStr.onStringChanged.add(this.onChangedHandler);
                };
                SurveyLocStringViewer.prototype.render = function() {
                    if (!this.locStr) return null;
                    this.isRendering = true;
                    var strEl = this.renderString();
                    this.isRendering = false;
                    return strEl;
                };
                SurveyLocStringViewer.prototype.renderString = function() {
                    var className = this.locStr.allowLineBreaks ? "sv-string-viewer sv-string-viewer--multiline" : "sv-string-viewer";
                    if (this.locStr.hasHtml) {
                        var htmlValue = {
                            __html: this.locStr.renderedHtml
                        };
                        return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                            ref: this.rootRef,
                            className: className,
                            style: this.style,
                            dangerouslySetInnerHTML: htmlValue
                        });
                    }
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", {
                        ref: this.rootRef,
                        className: className,
                        style: this.style
                    }, this.locStr.renderedHtml);
                };
                return SurveyLocStringViewer;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
            _element_factory__WEBPACK_IMPORTED_MODULE_2__["ReactElementFactory"].Instance.registerElement(survey_core__WEBPACK_IMPORTED_MODULE_1__["LocalizableString"].defaultRenderer, function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement(SurveyLocStringViewer, props);
            });
        /***/ },
        /***/ "./src/react/svgbundle.tsx": /*!*********************************!*\
  !*** ./src/react/svgbundle.tsx ***!
  \*********************************/ /*! exports provided: SvgBundleComponent */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SvgBundleComponent", function() {
                return SvgBundleComponent;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SvgBundleComponent = /** @class */ function(_super) {
                __extends(SvgBundleComponent, _super);
                function SvgBundleComponent(props) {
                    var _this = _super.call(this, props) || this;
                    _this.containerRef = react__WEBPACK_IMPORTED_MODULE_0___default.a.createRef();
                    return _this;
                }
                SvgBundleComponent.prototype.componentDidMount = function() {
                    if (!!this.containerRef.current) this.containerRef.current.innerHTML = survey_core__WEBPACK_IMPORTED_MODULE_1__["SvgRegistry"].iconsRenderedHtml();
                };
                SvgBundleComponent.prototype.render = function() {
                    var svgStyle = {
                        display: "none"
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("svg", {
                        style: svgStyle,
                        id: "sv-icon-holder-global-container",
                        ref: this.containerRef
                    });
                };
                return SvgBundleComponent;
            }(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);
        /***/ },
        /***/ "./src/react/tagbox-filter.tsx": /*!*************************************!*\
  !*** ./src/react/tagbox-filter.tsx ***!
  \*************************************/ /*! exports provided: TagboxFilterString */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TagboxFilterString", function() {
                return TagboxFilterString;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
            /* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/ __webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
            /* harmony import */ var _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./reactquestion_factory */ "./src/react/reactquestion_factory.tsx");
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var TagboxFilterString = /** @class */ function(_super) {
                __extends(TagboxFilterString, _super);
                function TagboxFilterString(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(TagboxFilterString.prototype, "model", {
                    get: function() {
                        return this.props.model;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(TagboxFilterString.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                TagboxFilterString.prototype.componentDidUpdate = function(prevProps, prevState) {
                    _super.prototype.componentDidUpdate.call(this, prevProps, prevState);
                    this.updateDomElement();
                };
                TagboxFilterString.prototype.componentDidMount = function() {
                    _super.prototype.componentDidMount.call(this);
                    this.updateDomElement();
                };
                TagboxFilterString.prototype.updateDomElement = function() {
                    if (!!this.inputElement) {
                        var control = this.inputElement;
                        var newValue = this.model.inputStringRendered;
                        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__["Helpers"].isTwoValueEquals(newValue, control.value, false, true, false)) control.value = this.model.inputStringRendered;
                    }
                };
                TagboxFilterString.prototype.onChange = function(e) {
                    var root = survey_core__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                    if (e.target === root.activeElement) this.model.inputStringRendered = e.target.value;
                };
                TagboxFilterString.prototype.keyhandler = function(e) {
                    this.model.inputKeyHandler(e);
                };
                TagboxFilterString.prototype.onBlur = function(e) {
                    this.model.onBlur(e);
                };
                TagboxFilterString.prototype.onFocus = function(e) {
                    this.model.onFocus(e);
                };
                TagboxFilterString.prototype.getStateElement = function() {
                    return this.model;
                };
                TagboxFilterString.prototype.render = function() {
                    var _this = this;
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.hint
                    }, this.model.showHintPrefix ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.hintPrefix
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, this.model.hintStringPrefix)) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.hintSuffixWrapper
                    }, this.model.showHintString ? react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.hintSuffix
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", {
                        style: {
                            visibility: "hidden"
                        },
                        "data-bind": "text: model.filterString"
                    }, this.model.inputStringRendered), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("span", null, this.model.hintStringSuffix)) : null, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("input", {
                        type: "text",
                        autoComplete: "off",
                        id: this.question.getInputId(),
                        inputMode: this.model.inputMode,
                        ref: function(element) {
                            return _this.inputElement = element;
                        },
                        className: this.question.cssClasses.filterStringInput,
                        disabled: this.question.isInputReadOnly,
                        readOnly: this.model.filterReadOnly ? true : undefined,
                        size: !this.model.inputStringRendered ? 1 : undefined,
                        role: this.model.filterStringEnabled ? this.question.ariaRole : undefined,
                        "aria-expanded": this.question.ariaExpanded === null ? undefined : this.question.ariaExpanded === "true",
                        "aria-label": this.question.a11y_input_ariaLabel,
                        "aria-labelledby": this.question.a11y_input_ariaLabelledBy,
                        "aria-describedby": this.question.a11y_input_ariaDescribedBy,
                        "aria-controls": this.model.listElementId,
                        "aria-activedescendant": this.model.ariaActivedescendant,
                        placeholder: this.model.filterStringPlaceholder,
                        onKeyDown: function(e) {
                            _this.keyhandler(e);
                        },
                        onChange: function(e) {
                            _this.onChange(e);
                        },
                        onBlur: function(e) {
                            _this.onBlur(e);
                        },
                        onFocus: function(e) {
                            _this.onFocus(e);
                        }
                    })));
                };
                return TagboxFilterString;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_3__["SurveyElementBase"]);
            _reactquestion_factory__WEBPACK_IMPORTED_MODULE_2__["ReactQuestionFactory"].Instance.registerQuestion("sv-tagbox-filter", function(props) {
                return react__WEBPACK_IMPORTED_MODULE_0__["createElement"](TagboxFilterString, props);
            });
        /***/ },
        /***/ "./src/react/tagbox-item.tsx": /*!***********************************!*\
  !*** ./src/react/tagbox-item.tsx ***!
  \***********************************/ /*! exports provided: SurveyQuestionTagboxItem */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyQuestionTagboxItem", function() {
                return SurveyQuestionTagboxItem;
            });
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! react */ "react");
            /* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/ __webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
            /* harmony import */ var _reactquestion_element__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./reactquestion_element */ "./src/react/reactquestion_element.tsx");
            /* harmony import */ var _components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./components/svg-icon/svg-icon */ "./src/react/components/svg-icon/svg-icon.tsx");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var SurveyQuestionTagboxItem = /** @class */ function(_super) {
                __extends(SurveyQuestionTagboxItem, _super);
                function SurveyQuestionTagboxItem(props) {
                    return _super.call(this, props) || this;
                }
                Object.defineProperty(SurveyQuestionTagboxItem.prototype, "question", {
                    get: function() {
                        return this.props.question;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyQuestionTagboxItem.prototype, "item", {
                    get: function() {
                        return this.props.item;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyQuestionTagboxItem.prototype.canRender = function() {
                    return !!this.item && !!this.question;
                };
                SurveyQuestionTagboxItem.prototype.renderElement = function() {
                    var _this = this;
                    var text = this.renderLocString(this.item.locText);
                    var removeItem = function(event) {
                        _this.question.dropdownListModel.deselectItem(_this.item.value);
                        event.stopPropagation();
                    };
                    return react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: "sv-tagbox__item"
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: "sv-tagbox__item-text"
                    }, text), react__WEBPACK_IMPORTED_MODULE_0__["createElement"]("div", {
                        className: this.question.cssClasses.cleanItemButton,
                        onClick: removeItem
                    }, react__WEBPACK_IMPORTED_MODULE_0__["createElement"](_components_svg_icon_svg_icon__WEBPACK_IMPORTED_MODULE_2__["SvgIcon"], {
                        className: this.question.cssClasses.cleanItemButtonSvg,
                        iconName: this.question.cssClasses.cleanItemButtonIconId,
                        size: "auto"
                    })));
                };
                return SurveyQuestionTagboxItem;
            }(_reactquestion_element__WEBPACK_IMPORTED_MODULE_1__["ReactSurveyElement"]);
        /***/ },
        /***/ "./src/settings.ts": /*!*************************!*\
  !*** ./src/settings.ts ***!
  \*************************/ /*! exports provided: settings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "settings", function() {
                return settings;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            var document1 = typeof globalThis !== "undefined" ? globalThis.document : undefined.document;
            var defaultEnvironment = !!document1 ? {
                root: document1,
                _rootElement: _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody(),
                get rootElement () {
                    var _a;
                    return (_a = this._rootElement) !== null && _a !== void 0 ? _a : _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody();
                },
                set rootElement (rootElement){
                    this._rootElement = rootElement;
                },
                _popupMountContainer: _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody(),
                get popupMountContainer () {
                    var _a1;
                    return (_a1 = this._popupMountContainer) !== null && _a1 !== void 0 ? _a1 : _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getBody();
                },
                set popupMountContainer (popupMountContainer){
                    this._popupMountContainer = popupMountContainer;
                },
                svgMountContainer: document1.head,
                stylesSheetsMountContainer: document1.head
            } : undefined;
            var columnWidthsByType = {
                "file": {
                    minWidth: "240px"
                },
                "comment": {
                    minWidth: "200px"
                }
            };
            /**
 * Global settings that apply to all surveys on the page. To specify one of the settings, use the code below:
 *
 * ```js
 * import { settings } from "survey-core";
 *
 * settings.settingName = "value";
 * ```
 */ var settings = {
                /**
     * An object that configures survey appearance when the survey is being designed in Survey Creator.
     *
     * Nested properties:
     *
     * - `showEmptyDescriptions`: `boolean`\
     * Specifies whether to display an empty description for pages and panels. Default value: `true`.
     *
     * - `showEmptyTitles`: `boolean`\
     * Specifies whether to display an empty title for pages and panels. Default value: `true`.
     */ designMode: {
                    showEmptyDescriptions: true,
                    showEmptyTitles: true
                },
                //#region designMode section, Obsolete properties
                get allowShowEmptyDescriptionInDesignMode () {
                    return this.designMode.showEmptyDescriptions;
                },
                set allowShowEmptyDescriptionInDesignMode (val){
                    this.designMode.showEmptyDescriptions = val;
                },
                get allowShowEmptyTitleInDesignMode () {
                    return this.designMode.showEmptyTitles;
                },
                set allowShowEmptyTitleInDesignMode (val){
                    this.designMode.showEmptyTitles = val;
                },
                //#endregion
                /**
     * An object that contains properties related to localization.
     *
     * Nested properties:
     *
     * - `useLocalTimeZone`: `boolean`\
     * Disable this property if you want internal SurveyJS functions to use methods that work with UTC date and time (`setUTCDate()` `setUTCHours()`, etc.) instead of methods that work with local date and time (`setYear()`, `setHours()`, etc.). Default value: `true`.
     *
     * - `defaultLocaleName`: `string`\
     * A property key that stores a translation for the default locale. Default value: `"default"`.
     *
     * - `storeDuplicatedTranslations`: `boolean`\
     * Specifies whether surveys should store translation strings that equal the translation strings in the default locale. Default value: `false`.
     */ localization: {
                    useLocalTimeZone: true,
                    storeDuplicatedTranslations: false,
                    defaultLocaleName: "default"
                },
                //#region localization section, obsolete properties
                get useLocalTimeZone () {
                    return this.localization.useLocalTimeZone;
                },
                set useLocalTimeZone (val){
                    this.localization.useLocalTimeZone = val;
                },
                get storeDuplicatedTranslations () {
                    return this.localization.storeDuplicatedTranslations;
                },
                set storeDuplicatedTranslations (val){
                    this.localization.storeDuplicatedTranslations = val;
                },
                get defaultLocaleName () {
                    return this.localization.defaultLocaleName;
                },
                set defaultLocaleName (val){
                    this.localization.defaultLocaleName = val;
                },
                //#endregion
                /**
     * An object with properties that configure surveys when they work with a web service.
     *
     * Nested properties:
     *
     * - `encodeUrlParams`: `boolean`\
     * Specifies whether to encode URL parameters when you access a web service. Default value: `true`.
     *
     * - `cacheLoadedChoices`: `boolean`\
     * Specifies whether to cache [choices loaded from a web service](https://surveyjs.io/form-library/documentation/api-reference/questionselectbase#choicesByUrl). Default value: `true`.
     *
     * - `disableQuestionWhileLoadingChoices`: `boolean`\
     * Disables a question while its choices are being loaded from a web service. Default value: `false`.
     *
     * - `surveyServiceUrl`: `string`\
     * The URL of the SurveyJS Service API endpoint.
     *
     * - `onBeforeRequestChoices`: `(sender: ChoicesRestful, options: { request: XMLHttpRequest })`\
     * An event that is raised before a request for choices is send. Applies to questions with a specified [`choiceByUrl`](https://surveyjs.io/form-library/documentation/api-reference/questionselectbase#choicesByUrl) property. Use the `options.request` parameter to access and modify the `XMLHttpRequest` object. For instance, you can add authentication headers to it:
     *
     *     ```js
     *     import { settings } from "survey-core";
     *
     *     settings.web.onBeforeSendRequest = (sender, options) => {
     *       options.request.setRequestHeader('RequestVerificationToken', requestVerificationToken);
     *     };
     *     ```
     */ web: {
                    onBeforeRequestChoices: function(sender, options) {},
                    encodeUrlParams: true,
                    cacheLoadedChoices: true,
                    disableQuestionWhileLoadingChoices: false,
                    surveyServiceUrl: "https://api.surveyjs.io/public/v1/Survey"
                },
                //#region web section, obsolete properties
                get webserviceEncodeParameters () {
                    return this.web.encodeUrlParams;
                },
                set webserviceEncodeParameters (val){
                    this.web.encodeUrlParams = val;
                },
                get useCachingForChoicesRestful () {
                    return this.web.cacheLoadedChoices;
                },
                set useCachingForChoicesRestful (val){
                    this.web.cacheLoadedChoices = val;
                },
                get useCachingForChoicesRestfull () {
                    return this.web.cacheLoadedChoices;
                },
                set useCachingForChoicesRestfull (val){
                    this.web.cacheLoadedChoices = val;
                },
                get disableOnGettingChoicesFromWeb () {
                    return this.web.disableQuestionWhileLoadingChoices;
                },
                set disableOnGettingChoicesFromWeb (val){
                    this.web.disableQuestionWhileLoadingChoices = val;
                },
                get surveyServiceUrl () {
                    return this.web.surveyServiceUrl;
                },
                set surveyServiceUrl (val){
                    this.web.surveyServiceUrl = val;
                },
                //#endregion
                /**
     * An object that contains properties related to [triggers](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#conditional-survey-logic-triggers).
     *
     * Nested properties:
     *
     * - `changeNavigationButtonsOnComplete`: `boolean`\
     * Specifies whether to re-evaluate an expression associated with the [Complete trigger](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#complete) immediately when a question value changes. If the expression evaluates to `true`, the trigger is executed. Default value: `false`.\
     * Keep this property set to `false` if you want to re-evaluate the Complete trigger's expression only when the respondents navigate to another page.
     *
     * - `executeCompleteOnValueChanged`: `boolean`\
     * Specifies whether to replace the Next button with the Complete button when the [Complete trigger](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#complete) is going to be executed. Default value: `true`.
     *
     * - `executeSkipOnValueChanged`: `boolean`\
     * Specifies whether to re-evaluate an expression associated with the [Skip trigger](https://surveyjs.io/form-library/documentation/design-survey/conditional-logic#skip) immediately when a question value changes. If the expression evaluates to `true`, the trigger is executed. Default value: `true`.\
     * Disable this property if you want to re-evaluate the Skip trigger's expression only when respondents navigate to another page.
     */ triggers: {
                    changeNavigationButtonsOnComplete: true,
                    executeCompleteOnValueChanged: false,
                    executeSkipOnValueChanged: true
                },
                //#region triggers section, Obsolete properties
                get executeCompleteTriggerOnValueChanged () {
                    return this.triggers.executeCompleteOnValueChanged;
                },
                set executeCompleteTriggerOnValueChanged (val){
                    this.triggers.executeCompleteOnValueChanged = val;
                },
                get changeNavigationButtonsOnCompleteTrigger () {
                    return this.triggers.changeNavigationButtonsOnComplete;
                },
                set changeNavigationButtonsOnCompleteTrigger (val){
                    this.triggers.changeNavigationButtonsOnComplete = val;
                },
                get executeSkipTriggerOnValueChanged () {
                    return this.triggers.executeSkipOnValueChanged;
                },
                set executeSkipTriggerOnValueChanged (val){
                    this.triggers.executeSkipOnValueChanged = val;
                },
                //#endregion
                /**
     * An object that contains properties related to JSON serialization.
     *
     * Nested properties:
     *
     * - `itemValueSerializeAsObject`: `boolean`\
     * Enable this property if you want to serialize [`ItemValue`](https://surveyjs.io/form-library/documentation/api-reference/itemvalue) instances as objects even when they include only the `value` property. Default value: `false`. View an example below.
     *
     * - `itemValueSerializeDisplayText`: `boolean`\
     * Enable this property if you want to serialize the `text` property of [`ItemValue`](https://surveyjs.io/form-library/documentation/api-reference/itemvalue) objects even when it is empty or equal to the `value` property. Default value: `false`. View an example below.
     *
     * - `localizableStringSerializeAsObject`: `boolean`\
     * Enable this property if you want to serialize [`LocalizableString`](https://surveyjs.io/form-library/documentation/api-reference/localizablestring) instances as objects even when they include only a translation string for the default locale. For example, `"Custom String"` will be serialized as `{ default: "Custom String" }`. Default value: `false`.
     *
     * ```js
     * import { ItemValue, settings } from "survey-core";
     *
     * // `itemValueSerializeAsObject` example
     * settings.serialization.itemValueSerializeAsObject = true;
     * const item = new ItemValue(5);
     * const itemString = item.toJSON(); // Produces { value: 5 } instead of 5
     *
     * // `itemValueSerializeDisplayText` example
     * settings.serialization.itemValueSerializeDisplayText = true;
     * const item = new ItemValue("item1");
     * const itemString = item.toJSON(); // Produces { value: "item1", text: "item1" } instead of "item1"
     * ```
     */ serialization: {
                    itemValueSerializeAsObject: false,
                    itemValueSerializeDisplayText: false,
                    localizableStringSerializeAsObject: false
                },
                //#region serialization section, Obsolete properties
                get itemValueAlwaysSerializeAsObject () {
                    return this.serialization.itemValueSerializeAsObject;
                },
                set itemValueAlwaysSerializeAsObject (val){
                    this.serialization.itemValueSerializeAsObject = val;
                },
                get itemValueAlwaysSerializeText () {
                    return this.serialization.itemValueSerializeDisplayText;
                },
                set itemValueAlwaysSerializeText (val){
                    this.serialization.itemValueSerializeDisplayText = val;
                },
                get serializeLocalizableStringAsObject () {
                    return this.serialization.localizableStringSerializeAsObject;
                },
                set serializeLocalizableStringAsObject (val){
                    this.serialization.localizableStringSerializeAsObject = val;
                },
                //#endregion
                /**
     * An object that configures lazy rendering.
     *
     * Nested properties:
     *
     * - `enabled`: `boolean`\
     * Specifies whether to add questions to the DOM only when they get into the viewport. Default value: `false`.
     *
     * [View Demo](https://surveyjs.io/form-library/examples/survey-lazy/ (linkStyle))
     * @see [SurveyModel.lazyRendering](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#lazyRendering)
     */ lazyRender: {
                    enabled: false,
                    firstBatchSize: 3
                },
                //#region lazyRender section, Obsolete properties
                get lazyRowsRendering () {
                    return this.lazyRender.enabled;
                },
                set lazyRowsRendering (val){
                    this.lazyRender.enabled = val;
                },
                get lazyRowsRenderingStartRow () {
                    return this.lazyRender.firstBatchSize;
                },
                set lazyRowsRenderingStartRow (val){
                    this.lazyRender.firstBatchSize = val;
                },
                //#endregion
                /**
     * An object with properties that apply to [Single-Choice](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-question-model), [Multiple-Choice](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list), and [Dynamic Matrix](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model) questions.
     *
     * Nested properties:
     *
     * - `defaultRowName`: `string`\
     * A property key that stores an object with default cell values. Default value: "default".
     *
     * - `defaultCellType`: `string`\
     * The default type of matrix cells. Default value: `"dropdown"`.\
     * You can specify this setting for individual questions or matrix columns: [`cellType`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model#cellType). Refer to the `cellType` property description for information on possible values.
     *
     * - `totalsSuffix`: `string`\
     * A suffix added to the name of the property that stores total values. The resulting property name consists of the matrix name and the suffix. Default value: `"-total"`.
     *
     * - `maxRowCount`: `number`\
     * A maximum number of rows in a Dynamic Matrix. Default value: 1000.\
     * You can specify this setting for an individual Dynamic Matrix: [`maxRowCount`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model#maxRowCount).
     *
     * - `maxRowCountInCondition`: `number`\
     * A maximum number of matrix rows included in the Condition drop-down menu in Survey Creator. This menu is used to configure conditional survey logic. Default value: 1.\
     * If you set this property to 0, the Condition menu does not include any matrix rows. Users still can specify conditions that use matrix rows but only with Manual Entry.
     *
     * - `renderRemoveAsIcon`: `boolean`\
     * Disable this property if you want to render the Remove action in Dynamic Matrix as a button. Otherwise, the action is rendered as an icon. Default value: `true`.
     *
     * - `columnWidthsByType`: `object`\
     * An object that specifies fixed and minimum column width based on the column type.\
     * Example: `settings.matrix.columnWidthsByType = { "tagbox": { minWidth: "240px", width: "300px" } }`
     *
     * - `rateSize`: `"small"` (default) | `"normal"`\
     * Specifies the size of rate values. Applies to [Rating Scale](https://surveyjs.io/form-library/examples/rating-scale/) questions within matrixes.
     */ matrix: {
                    defaultCellType: "dropdown",
                    defaultRowName: "default",
                    totalsSuffix: "-total",
                    maxRowCount: 1000,
                    maxRowCountInCondition: 1,
                    renderRemoveAsIcon: true,
                    columnWidthsByType: columnWidthsByType,
                    rateSize: "small"
                },
                //#region matrix section, Obsolete properties
                get matrixDefaultRowName () {
                    return this.matrix.defaultRowName;
                },
                set matrixDefaultRowName (val){
                    this.matrix.defaultRowName = val;
                },
                get matrixDefaultCellType () {
                    return this.matrix.defaultCellType;
                },
                set matrixDefaultCellType (val){
                    this.matrix.defaultCellType = val;
                },
                get matrixTotalValuePostFix () {
                    return this.matrix.totalsSuffix;
                },
                set matrixTotalValuePostFix (val){
                    this.matrix.totalsSuffix = val;
                },
                get matrixMaximumRowCount () {
                    return this.matrix.maxRowCount;
                },
                set matrixMaximumRowCount (val){
                    this.matrix.maxRowCount = val;
                },
                get matrixMaxRowCountInCondition () {
                    return this.matrix.maxRowCountInCondition;
                },
                set matrixMaxRowCountInCondition (val){
                    this.matrix.maxRowCountInCondition = val;
                },
                get matrixRenderRemoveAsIcon () {
                    return this.matrix.renderRemoveAsIcon;
                },
                set matrixRenderRemoveAsIcon (val){
                    this.matrix.renderRemoveAsIcon = val;
                },
                //#endregion
                /**
     * An object with properties that apply to [Dynamic Panel](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model) questions.
     *
     * Nested properties:
     *
     * - `maxPanelCount`: `number`\
     * A maximum number of panels in Dynamic Panel. Default value: 100.\
     * You can specify this setting for an individual Dynamic Panel: [`maxPanelCount`](https://surveyjs.io/form-library/documentation/api-reference/dynamic-panel-model#maxPanelCount).
     *
     * - `maxPanelCountInCondition`: `number`\
     * A maximum number of Dynamic Panel panels included in the Condition drop-down menu in Survey Creator. This menu is used to configure conditional survey logic. Default value: 1.\
     * If you set this property to 0, the Condition menu does not include any panel questions. Users still can specify conditions that use panel questions but only with Manual Entry.
     */ panel: {
                    maxPanelCount: 100,
                    maxPanelCountInCondition: 1
                },
                //#region panel section, Obsolete properties
                get panelDynamicMaxPanelCountInCondition () {
                    return this.panel.maxPanelCountInCondition;
                },
                set panelDynamicMaxPanelCountInCondition (val){
                    this.panel.maxPanelCountInCondition = val;
                },
                get panelMaximumPanelCount () {
                    return this.panel.maxPanelCount;
                },
                set panelMaximumPanelCount (val){
                    this.panel.maxPanelCount = val;
                },
                //#endregion
                /**
     * An object with properties that configure questions in read-only mode.
     *
     * Nested properties:
     *
     * - `commentRenderMode`: `"textarea"` (default) | `"div"`\
     * Specifies how to render the input field of [Comment](https://surveyjs.io/form-library/documentation/api-reference/comment-field-model) questions in [read-only](https://surveyjs.io/form-library/documentation/api-reference/comment-field-model#readOnly) mode: as a disabled `<textarea>` element or as a `<div>` element with a non-editable question value within it.
     *
     * - `textRenderMode`: `"input"` (default) | `"div"`\
     * Specifies how to render the input field of [Text](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model) questions in [read-only](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#readOnly) mode: as a disabled `<input>` element or as a `<div>` element with a non-editable question value within it.
     */ readOnly: {
                    enableValidation: false,
                    commentRenderMode: "textarea",
                    textRenderMode: "input"
                },
                //#region readOnly section, Obsolete properties
                get readOnlyCommentRenderMode () {
                    return this.readOnly.commentRenderMode;
                },
                set readOnlyCommentRenderMode (val){
                    this.readOnly.commentRenderMode = val;
                },
                get readOnlyTextRenderMode () {
                    return this.readOnly.textRenderMode;
                },
                set readOnlyTextRenderMode (val){
                    this.readOnly.textRenderMode = val;
                },
                //#endregion
                /**
     * An object with properties that configure question numbering.
     *
     * Nested properties:
     *
     * - `includeQuestionsWithHiddenNumber`: `boolean`\
     * Specifies whether to number questions whose [`hideNumber`](https://surveyjs.io/form-library/documentation/api-reference/question#hideNumber) property is enabled. Default value: `false`.
     *
     * - `includeQuestionsWithHiddenTitle`: `boolean`\
     * Specifies whether to number questions whose [`titleLocation`](https://surveyjs.io/form-library/documentation/api-reference/question#titleLocation) property is set to `"hidden"`. Default value: `false`.
     */ numbering: {
                    includeQuestionsWithHiddenNumber: false,
                    includeQuestionsWithHiddenTitle: false
                },
                //#region numbering section, Obsolete properties
                get setQuestionVisibleIndexForHiddenTitle () {
                    return this.numbering.includeQuestionsWithHiddenTitle;
                },
                set setQuestionVisibleIndexForHiddenTitle (val){
                    this.numbering.includeQuestionsWithHiddenTitle = val;
                },
                get setQuestionVisibleIndexForHiddenNumber () {
                    return this.numbering.includeQuestionsWithHiddenNumber;
                },
                set setQuestionVisibleIndexForHiddenNumber (val){
                    this.numbering.includeQuestionsWithHiddenNumber = val;
                },
                //#endregion
                /**
     * Specifies an action to perform when users press the Enter key within a survey.
     *
     * Possible values:
     *
     * - `"moveToNextEditor"` - Moves focus to the next editor.
     * - `"loseFocus"` - Removes focus from the current editor.
     * - `"default"` - Behaves as a standard `<input>` element.
     */ enterKeyAction: "default",
                /**
     * An object that configures string comparison.
     *
     * Nested properties:
     *
     * - `trimStrings`: `boolean`\
     * Specifies whether to remove whitespace from both ends of a string before the comparison. Default value: `true`.
     *
     * - `caseSensitive`: `boolean`\
     * Specifies whether to differentiate between capital and lower-case letters. Default value: `false`.
     */ comparator: {
                    trimStrings: true,
                    caseSensitive: false,
                    normalizeTextCallback: function(str, reason) {
                        return str;
                    }
                },
                expressionDisableConversionChar: "#",
                get commentPrefix () {
                    return settings.commentSuffix;
                },
                set commentPrefix (val){
                    settings.commentSuffix = val;
                },
                /**
     * A suffix added to the name of the property that stores comments.
     *
     * Default value: "-Comment"
     *
     * You can specify this setting for an individual survey: [`commentSuffix`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#commentSuffix).
     */ commentSuffix: "-Comment",
                /**
     * A separator used in a shorthand notation that specifies a value and display text for an [`ItemValue`](https://surveyjs.io/form-library/documentation/api-reference/itemvalue) object: `"value|text"`.
     *
     * Default value: `"|"`
     */ itemValueSeparator: "|",
                /**
     * A maximum number of rate values in a [Rating](https://surveyjs.io/form-library/documentation/api-reference/rating-scale-question-model) question.
     *
     * Default value: 20
     */ ratingMaximumRateValueCount: 20,
                /**
     * Specifies whether to close the drop-down menu of a [TagBox](https://surveyjs.io/form-library/examples/how-to-create-multiselect-tag-box/) question after a user selects a value.
     *
     * This setting applies to all TagBox questions on a page. You can use the [closeOnSelect](https://surveyjs.io/form-library/documentation/api-reference/dropdown-tag-box-model#closeOnSelect) property to specify the same setting for an individual TagBox question.
     */ tagboxCloseOnSelect: false,
                /**
     * A function that activates a browser confirm dialog.
     *
     * Use the following code to execute this function:
     *
     * ```js
     * import { settings } from "survey-core";
     *
     * // `result` contains `true` if the action was confirmed or `false` otherwise
     * const result = settings.confirmActionFunc("Are you sure?");
     * ```
     *
     * You can redefine the `confirmActionFunc` function if you want to display a custom dialog window. Your function should return `true` if a user confirms an action or `false` otherwise.
     * @param message A message to be displayed in the confirm dialog window.
     */ confirmActionFunc: function(message) {
                    return confirm(message);
                },
                /**
     * A function that activates a proprietary SurveyJS confirm dialog.
     *
     * Use the following code to execute this function:
     *
     * ```js
     * import { settings } from "survey-core";
     *
     * settings.confirmActionAsync("Are you sure?", (confirmed) => {
     *   if (confirmed) {
     *     // ...
     *     // Proceed with the action
     *     // ...
     *   } else {
     *     // ...
     *     // Cancel the action
     *     // ...
     *   }
     * });
     * ```
     *
     * You can redefine the `confirmActionAsync` function if you want to display a custom dialog window. Your function should return `true` to be enabled; otherwise, a survey executes the [`confirmActionFunc`](#confirmActionFunc) function. Pass the dialog result as the `callback` parameter: `true` if a user confirms an action, `false` otherwise.
     * @param message A message to be displayed in the confirm dialog window.
     * @param callback A callback function that should be called with `true` if a user confirms an action or `false` otherwise.
     */ confirmActionAsync: function(message, callback, applyTitle, locale, rootElement1) {
                    return Object(_utils_utils__WEBPACK_IMPORTED_MODULE_1__["showConfirmDialog"])(message, callback, applyTitle, locale, rootElement1);
                },
                /**
     * A minimum width value for all survey elements.
     *
     * Default value: `"300px"`
     *
     * You can override this setting for individual elements: [`minWidth`](https://surveyjs.io/form-library/documentation/api-reference/surveyelement#minWidth).
     */ minWidth: "300px",
                /**
     * A maximum width value for all survey elements.
     *
     * Default value: `"100%"`
     *
     * You can override this setting for individual elements: [`maxWidth`](https://surveyjs.io/form-library/documentation/api-reference/surveyelement#maxWidth).
     */ maxWidth: "100%",
                /**
     * Specifies how many times surveys can re-evaluate expressions when a question value changes. This limit helps avoid recursions in expressions.
     *
     * Default value: 10
     */ maxConditionRunCountOnValueChanged: 10,
                /**
     * An object that configures notifications.
     *
     * Nested properties:
     *
     * - `lifetime`: `number`\
     * Specifies a time period during which a notification is displayed; measured in milliseconds.
     */ notifications: {
                    lifetime: 2000
                },
                /**
     * Specifies how many milliseconds a survey should wait before it automatically switches to the next page. Applies only when [auto-advance](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#goNextPageAutomatic) is enabled.
     *
     * Default value: 300
     */ autoAdvanceDelay: 300,
                /**
     * Specifies the direction in which to lay out Checkbox and Radiogroup items. This setting affects the resulting UI when items are arranged in [more than one column](https://surveyjs.io/form-library/documentation/api-reference/checkbox-question-model#colCount).
     *
     * Possible values:
     *
     * - `"row"` (default) - Items fill the current row, then move on to the next row.
     * - `"column"` - Items fill the current column, then move on to the next column.
     */ showItemsInOrder: "default",
                /**
     * A value to save in survey results when respondents select the "None" choice item.
     *
     * Default value: `"none"`
     */ noneItemValue: "none",
                /**
     * A value to save in survey results when respondents select the "Refuse to answer" choice item.
     *
     * Default value: `"refused"`
     */ refuseItemValue: "refused",
                /**
     * A value to save in survey results when respondents select the "Don't know" choice item.
     *
     * Default value: `"dontknow"`
     */ dontKnowItemValue: "dontknow",
                /**
     * An object whose properties specify the order of the special choice items ("None", "Other", "Select All", "Refuse to answer", "Don't know") in select-based questions.
     *
     * Default value: `{ selectAllItem: [-1], noneItem: [1], otherItem: [2], dontKnowItem: [3], otherItem: [4] }`
     *
     * Use this object to reorder special choices. Each property accepts an array of integer numbers. Negative numbers place a special choice item above regular choice items, positive numbers place it below them. For instance, the code below specifies the following order of choices: None, Select All, regular choices, Other.
     *
     * ```js
     * import { settings } from "survey-core";
     *
     * settings.specialChoicesOrder.noneItem = [-2];
     * settings.specialChoicesOrder.selectAllItem = [-1];
     * settings.specialChoicesOrder.otherItem = [1];
     * ```
     *
     * If you want to duplicate a special choice item above and below other choices, add two numbers to the corresponding array:
     *
     * ```js
     * settings.specialChoicesOrder.selectAllItem = [-1, 3] // Displays Select All above and below other choices
     * ```
     */ specialChoicesOrder: {
                    selectAllItem: [
                        -1
                    ],
                    noneItem: [
                        1
                    ],
                    refuseItem: [
                        2
                    ],
                    dontKnowItem: [
                        3
                    ],
                    otherItem: [
                        4
                    ]
                },
                /**
     * A list of supported validators by question type.
     */ supportedValidators: {
                    question: [
                        "expression"
                    ],
                    comment: [
                        "text",
                        "regex"
                    ],
                    text: [
                        "numeric",
                        "text",
                        "regex",
                        "email"
                    ],
                    checkbox: [
                        "answercount"
                    ],
                    imagepicker: [
                        "answercount"
                    ]
                },
                /**
     * Specifies a minimum date that users can enter into a [Text](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model) question with [`inputType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#inputType) set to `"date"` or `"datetime-local"`. Set this property to a string with the folllowing format: `"yyyy-mm-dd"`.
     */ minDate: "",
                /**
     * Specifies a maximum date that users can enter into a [Text](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model) question with [`inputType`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#inputType) set to `"date"` or `"datetime-local"`. Set this property to a string with the folllowing format: `"yyyy-mm-dd"`.
     */ maxDate: "",
                showModal: undefined,
                showDialog: undefined,
                supportCreatorV2: false,
                showDefaultItemsInCreatorV2: true,
                /**
     * An object that specifies icon replacements. Object keys are built-in icon names. To use a custom icon, assign its name to the key of the icon you want to replace:
     *
     * ```js
     * import { settings } from "survey-core";
     *
     * settings.customIcons["icon-redo"] = "custom-redo-icon";
     * ```
     *
     * For more information about icons in SurveyJS, refer to the following help topic: [UI Icons](https://surveyjs.io/form-library/documentation/icons).
     */ customIcons: {},
                /**
     * Specifies which part of a choice item responds to a drag gesture in Ranking questions.
     *
     * Possible values:
     *
     * - `"entireItem"` (default) - Users can use the entire choice item as a drag handle.
     * - `"icon"` - Users can only use the choice item icon as a drag handle.
     */ rankingDragHandleArea: "entireItem",
                environment: defaultEnvironment,
                /**
     * Allows you to hide the maximum length indicator in text input questions.
     *
     * If you specify a question's [`maxLength`](https://surveyjs.io/form-library/documentation/api-reference/text-entry-question-model#maxLength) property or a survey's [`maxTextLength`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#maxTextLength) property, text input questions indicate the number of entered characters and the character limit. Assign `false` to the `settings.showMaxLengthIndicator` property if you want to hide this indicator.
     *
     * Default value: `true`
     */ showMaxLengthIndicator: true,
                /**
     * Specifies whether to animate survey elements.
     *
     * Default value: `true`
    */ animationEnabled: true,
                /**
     * An object that specifies heading levels (`<h1>`, `<h2>`, etc.) to use when rendering survey, page, panel, and question titles.
     *
     * Default value: `{ survey: "h3", page: "h4", panel: "h4", question: "h5" }`
     *
     * If you want to modify heading levels for individual titles, handle `SurveyModel`'s [`onGetTitleTagName`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onGetTitleTagName) event.
     */ titleTags: {
                    survey: "h3",
                    page: "h4",
                    panel: "h4",
                    question: "h5"
                },
                questions: {
                    inputTypes: [
                        "color",
                        "date",
                        "datetime-local",
                        "email",
                        "month",
                        "number",
                        "password",
                        "range",
                        "tel",
                        "text",
                        "time",
                        "url",
                        "week"
                    ],
                    dataList: [
                        "",
                        "name",
                        "honorific-prefix",
                        "given-name",
                        "additional-name",
                        "family-name",
                        "honorific-suffix",
                        "nickname",
                        "organization-title",
                        "username",
                        "new-password",
                        "current-password",
                        "organization",
                        "street-address",
                        "address-line1",
                        "address-line2",
                        "address-line3",
                        "address-level4",
                        "address-level3",
                        "address-level2",
                        "address-level1",
                        "country",
                        "country-name",
                        "postal-code",
                        "cc-name",
                        "cc-given-name",
                        "cc-additional-name",
                        "cc-family-name",
                        "cc-number",
                        "cc-exp",
                        "cc-exp-month",
                        "cc-exp-year",
                        "cc-csc",
                        "cc-type",
                        "transaction-currency",
                        "transaction-amount",
                        "language",
                        "bday",
                        "bday-day",
                        "bday-month",
                        "bday-year",
                        "sex",
                        "url",
                        "photo",
                        "tel",
                        "tel-country-code",
                        "tel-national",
                        "tel-area-code",
                        "tel-local",
                        "tel-local-prefix",
                        "tel-local-suffix",
                        "tel-extension",
                        "email",
                        "impp"
                    ]
                },
                legacyProgressBarView: false,
                /**
     * An object with properties that configure input masks.
     *
     * Nested properties:
     *
     * - `patternPlaceholderChar`: `string`\
     * A symbol used as a placeholder for characters to be entered in [pattern masks](https://surveyjs.io/form-library/documentation/api-reference/inputmaskpattern). Default value: `"_"`.
     *
     * - `patternEscapeChar`: `string`\
     * A symbol used to insert literal representations of special characters in [pattern masks](https://surveyjs.io/form-library/documentation/api-reference/inputmaskpattern). Default value: `"\\"`.
     *
     * - `patternDefinitions`: `<{ [key: string]: RegExp }>`\
     * An object that maps placeholder symbols to regular expressions in [pattern masks](https://surveyjs.io/form-library/documentation/api-reference/inputmaskpattern). Default value: `{ "9": /[0-9]/, "a": /[a-zA-Z]/, "#": /[a-zA-Z0-9]/ }`.
     */ maskSettings: {
                    patternPlaceholderChar: "_",
                    patternEscapeChar: "\\",
                    patternDefinitions: {
                        "9": /[0-9]/,
                        "a": /[a-zA-Z]/,
                        "#": /[a-zA-Z0-9]/
                    }
                }
            };
        /***/ },
        /***/ "./src/survey-element.ts": /*!*******************************!*\
  !*** ./src/survey-element.ts ***!
  \*******************************/ /*! exports provided: SurveyElementCore, DragTypeOverMeEnum, SurveyElement */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyElementCore", function() {
                return SurveyElementCore;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DragTypeOverMeEnum", function() {
                return DragTypeOverMeEnum;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "SurveyElement", function() {
                return SurveyElement;
            });
            /* harmony import */ var _jsonobject__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./jsonobject */ "./src/jsonobject.ts");
            /* harmony import */ var _base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./base */ "./src/base.ts");
            /* harmony import */ var _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./actions/adaptive-container */ "./src/actions/adaptive-container.ts");
            /* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./helpers */ "./src/helpers.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./settings */ "./src/settings.ts");
            /* harmony import */ var _actions_container__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./actions/container */ "./src/actions/container.ts");
            /* harmony import */ var _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./utils/cssClassBuilder */ "./src/utils/cssClassBuilder.ts");
            /* harmony import */ var _utils_animation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./utils/animation */ "./src/utils/animation.ts");
            /* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./global_variables_utils */ "./src/global_variables_utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var __decorate = function(decorators, target, key, desc) {
                var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
                if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
                else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
                return c > 3 && r && Object.defineProperty(target, key, r), r;
            };
            /**
 * A base class for the [`SurveyElement`](https://surveyjs.io/form-library/documentation/surveyelement) and [`SurveyModel`](https://surveyjs.io/form-library/documentation/surveymodel) classes.
 */ var SurveyElementCore = /** @class */ function(_super) {
                __extends(SurveyElementCore, _super);
                function SurveyElementCore() {
                    var _this = _super.call(this) || this;
                    _this.createLocTitleProperty();
                    return _this;
                }
                SurveyElementCore.prototype.createLocTitleProperty = function() {
                    return this.createLocalizableString("title", this, true);
                };
                Object.defineProperty(SurveyElementCore.prototype, "title", {
                    /**
         * A title for the survey element. If `title` is undefined, the `name` property value is displayed instead.
         *
         * Empty pages and panels do not display their titles or names.
         *
         * @see [Configure Question Titles](https://surveyjs.io/form-library/documentation/design-survey-question-titles)
        */ get: function() {
                        return this.getLocalizableStringText("title", this.getDefaultTitleValue());
                    },
                    set: function(val1) {
                        this.setLocalizableStringText("title", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "locTitle", {
                    get: function() {
                        return this.getLocalizableString("title");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.getDefaultTitleValue = function() {
                    return undefined;
                };
                SurveyElementCore.prototype.updateDescriptionVisibility = function(newDescription) {
                    var showPlaceholder = false;
                    if (this.isDesignMode) {
                        var property_1 = _jsonobject__WEBPACK_IMPORTED_MODULE_0__["Serializer"].findProperty(this.getType(), "description");
                        showPlaceholder = !!(property_1 === null || property_1 === void 0 ? void 0 : property_1.placeholder);
                    }
                    this.hasDescription = !!newDescription || showPlaceholder && this.isDesignMode;
                };
                Object.defineProperty(SurveyElementCore.prototype, "locDescription", {
                    get: function() {
                        return this.getLocalizableString("description");
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleTagName", {
                    get: function() {
                        var titleTagName = this.getDefaultTitleTagName();
                        var survey = this.getSurvey();
                        return !!survey ? survey.getElementTitleTagName(this, titleTagName) : titleTagName;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.getDefaultTitleTagName = function() {
                    return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].titleTags[this.getType()];
                };
                Object.defineProperty(SurveyElementCore.prototype, "hasTitle", {
                    get: function() {
                        return this.title.length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "hasTitleActions", {
                    get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "hasTitleEvents", {
                    get: function() {
                        return this.hasTitleActions;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.getTitleToolbar = function() {
                    return null;
                };
                SurveyElementCore.prototype.getTitleOwner = function() {
                    return undefined;
                };
                Object.defineProperty(SurveyElementCore.prototype, "isTitleOwner", {
                    get: function() {
                        return !!this.getTitleOwner();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "isTitleRenderedAsString", {
                    get: function() {
                        return this.getIsTitleRenderedAsString();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.toggleState = function() {
                    return undefined;
                };
                Object.defineProperty(SurveyElementCore.prototype, "cssClasses", {
                    get: function() {
                        return {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "cssTitle", {
                    get: function() {
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "ariaTitleId", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "ariaDescriptionId", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleTabIndex", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleAriaExpanded", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleAriaRole", {
                    get: function() {
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "ariaLabel", {
                    get: function() {
                        return this.locTitle.renderedHtml;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElementCore.prototype, "titleAriaLabel", {
                    get: function() {
                        return this.ariaLabel;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElementCore.prototype.getIsTitleRenderedAsString = function() {
                    return !this.isTitleOwner;
                };
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], SurveyElementCore.prototype, "hasDescription", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        localizable: true,
                        onSet: function(newDescription, self) {
                            self.updateDescriptionVisibility(newDescription);
                        }
                    })
                ], SurveyElementCore.prototype, "description", void 0);
                return SurveyElementCore;
            }(_base__WEBPACK_IMPORTED_MODULE_1__["Base"]);
            // TODO: rename
            var DragTypeOverMeEnum;
            (function(DragTypeOverMeEnum) {
                DragTypeOverMeEnum[DragTypeOverMeEnum["InsideEmptyPanel"] = 1] = "InsideEmptyPanel";
                DragTypeOverMeEnum[DragTypeOverMeEnum["MultilineRight"] = 2] = "MultilineRight";
                DragTypeOverMeEnum[DragTypeOverMeEnum["MultilineLeft"] = 3] = "MultilineLeft";
                DragTypeOverMeEnum[DragTypeOverMeEnum["Top"] = 4] = "Top";
                DragTypeOverMeEnum[DragTypeOverMeEnum["Right"] = 5] = "Right";
                DragTypeOverMeEnum[DragTypeOverMeEnum["Bottom"] = 6] = "Bottom";
                DragTypeOverMeEnum[DragTypeOverMeEnum["Left"] = 7] = "Left";
            })(DragTypeOverMeEnum || (DragTypeOverMeEnum = {}));
            /**
 * A base class for all survey elements.
 */ var SurveyElement = /** @class */ function(_super) {
                __extends(SurveyElement, _super);
                function SurveyElement(name) {
                    var _this = _super.call(this) || this;
                    _this.selectedElementInDesignValue = _this;
                    _this.disableDesignActions = SurveyElement.CreateDisabledDesignElements;
                    _this.parentQuestionValue = null;
                    _this.isContentElement = false;
                    _this.isEditableTemplateElement = false;
                    _this.isInteractiveDesignElement = true;
                    _this.isSingleInRow = true;
                    _this._renderedIsExpanded = true;
                    _this._isAnimatingCollapseExpand = false;
                    _this.animationCollapsed = new _utils_animation__WEBPACK_IMPORTED_MODULE_7__["AnimationBoolean"](_this.getExpandCollapseAnimationOptions(), function(val1) {
                        _this._renderedIsExpanded = val1;
                        if (_this.animationAllowed) {
                            if (val1) _this.isAnimatingCollapseExpand = true;
                            else _this.updateElementCss(false);
                        }
                    }, function() {
                        return _this.renderedIsExpanded;
                    });
                    _this.animationAllowedValue = true;
                    _this.name = name;
                    _this.createNewArray("errors");
                    _this.createNewArray("titleActions");
                    _this.registerPropertyChangedHandlers([
                        "isReadOnly"
                    ], function() {
                        _this.onReadOnlyChanged();
                    });
                    _this.registerPropertyChangedHandlers([
                        "errors"
                    ], function() {
                        _this.updateVisibleErrors();
                    });
                    _this.registerPropertyChangedHandlers([
                        "isSingleInRow"
                    ], function() {
                        _this.updateElementCss(false);
                    });
                    return _this;
                }
                SurveyElement.getProgressInfoByElements = function(children, isRequired) {
                    var info = _base__WEBPACK_IMPORTED_MODULE_1__["Base"].createProgressInfo();
                    for(var i = 0; i < children.length; i++){
                        if (!children[i].isVisible) continue;
                        var childInfo = children[i].getProgressInfo();
                        info.questionCount += childInfo.questionCount;
                        info.answeredQuestionCount += childInfo.answeredQuestionCount;
                        info.requiredQuestionCount += childInfo.requiredQuestionCount;
                        info.requiredAnsweredQuestionCount += childInfo.requiredAnsweredQuestionCount;
                    }
                    if (isRequired && info.questionCount > 0) {
                        if (info.requiredQuestionCount == 0) info.requiredQuestionCount = 1;
                        if (info.answeredQuestionCount > 0) info.requiredAnsweredQuestionCount = 1;
                    }
                    return info;
                };
                SurveyElement.ScrollElementToTop = function(elementId, scrollIfVisible) {
                    var root = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root;
                    if (!elementId || typeof root === "undefined") return false;
                    var el = root.getElementById(elementId);
                    return SurveyElement.ScrollElementToViewCore(el, false, scrollIfVisible);
                };
                SurveyElement.ScrollElementToViewCore = function(el, checkLeft, scrollIfVisible) {
                    if (!el || !el.scrollIntoView) return false;
                    var elTop = scrollIfVisible ? -1 : el.getBoundingClientRect().top;
                    var needScroll = elTop < 0;
                    var elLeft = -1;
                    if (!needScroll && checkLeft) {
                        elLeft = el.getBoundingClientRect().left;
                        needScroll = elLeft < 0;
                    }
                    if (!needScroll && _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomWindowHelper"].isAvailable()) {
                        var height = _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomWindowHelper"].getInnerHeight();
                        needScroll = height > 0 && height < elTop;
                        if (!needScroll && checkLeft) {
                            var width = _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomWindowHelper"].getInnerWidth();
                            needScroll = width > 0 && width < elLeft;
                        }
                    }
                    if (needScroll) el.scrollIntoView();
                    return needScroll;
                };
                SurveyElement.GetFirstNonTextElement = function(elements, removeSpaces) {
                    if (removeSpaces === void 0) removeSpaces = false;
                    if (!elements || !elements.length || elements.length == 0) return null;
                    if (removeSpaces) {
                        var tEl = elements[0];
                        if (tEl.nodeName === "#text") tEl.data = "";
                        tEl = elements[elements.length - 1];
                        if (tEl.nodeName === "#text") tEl.data = "";
                    }
                    for(var i = 0; i < elements.length; i++){
                        if (elements[i].nodeName != "#text" && elements[i].nodeName != "#comment") return elements[i];
                    }
                    return null;
                };
                SurveyElement.FocusElement = function(elementId) {
                    if (!elementId || !_global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomDocumentHelper"].isAvailable()) return false;
                    var res = SurveyElement.focusElementCore(elementId);
                    if (!res) setTimeout(function() {
                        SurveyElement.focusElementCore(elementId);
                    }, 10);
                    return res;
                };
                SurveyElement.focusElementCore = function(elementId) {
                    var root = _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].environment.root;
                    if (!root) return false;
                    var el = root.getElementById(elementId);
                    // https://stackoverflow.com/questions/19669786/check-if-element-is-visible-in-dom
                    if (el && !el["disabled"] && el.style.display !== "none" && el.offsetParent !== null) {
                        SurveyElement.ScrollElementToViewCore(el, true, false);
                        el.focus();
                        return true;
                    }
                    return false;
                };
                SurveyElement.prototype.onPropertyValueChanged = function(name, oldValue, newValue) {
                    _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
                    if (name === "state") {
                        this.updateElementCss(false);
                        this.notifyStateChanged(oldValue);
                        if (this.stateChangedCallback) this.stateChangedCallback();
                    }
                };
                SurveyElement.prototype.getSkeletonComponentNameCore = function() {
                    if (this.survey) return this.survey.getSkeletonComponentName(this);
                    return "";
                };
                Object.defineProperty(SurveyElement.prototype, "parentQuestion", {
                    /**
         * A Dynamic Panel, Dynamic Matrix, or Dropdown Matrix that includes the current question.
         *
         * This property is `null` for standalone questions.
         */ get: function() {
                        return this.parentQuestionValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.setParentQuestion = function(val1) {
                    this.parentQuestionValue = val1;
                    this.onParentQuestionChanged();
                };
                SurveyElement.prototype.onParentQuestionChanged = function() {};
                Object.defineProperty(SurveyElement.prototype, "skeletonComponentName", {
                    get: function() {
                        return this.getSkeletonComponentNameCore();
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "state", {
                    /**
         * Gets and sets the survey element's expand state.
         *
         * Possible values:
         *
         * - `"default"` (default) - The survey element is displayed in full and cannot be collapsed in the UI.
         * - `"expanded"` - The survey element is displayed in full and can be collapsed in the UI.
         * - `"collapsed"` - The survey element displays only `title` and `description` and can be expanded in the UI.
         *
         * @see toggleState
         * @see collapse
         * @see expand
         * @see isCollapsed
         * @see isExpanded
         */ get: function() {
                        return this.getPropertyValue("state");
                    },
                    set: function(val1) {
                        this.setPropertyValue("state", val1);
                        this.renderedIsExpanded = !(this.state === "collapsed" && !this.isDesignMode);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.notifyStateChanged = function(prevState) {
                    if (this.survey) this.survey.elementContentVisibilityChanged(this);
                };
                Object.defineProperty(SurveyElement.prototype, "isCollapsed", {
                    /**
         * Returns `true` if the survey element is collapsed.
         * @see state
         * @see toggleState
         * @see collapse
         * @see expand
         * @see isExpanded
         */ get: function() {
                        return this.state === "collapsed" && !this.isDesignMode;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isExpanded", {
                    /**
         * Returns `true` if the survey element is expanded.
         * @see state
         * @see toggleState
         * @see collapse
         * @see expand
         * @see isCollapsed
         */ get: function() {
                        return this.state === "expanded";
                    },
                    enumerable: false,
                    configurable: true
                });
                /**
     * Collapses the survey element.
     *
     * In collapsed state, the element displays only `title` and `description`.
     * @see title
     * @see description
     * @see state
     * @see toggleState
     * @see expand
     * @see isCollapsed
     * @see isExpanded
     */ SurveyElement.prototype.collapse = function() {
                    if (this.isDesignMode) return;
                    this.state = "collapsed";
                };
                /**
     * Expands the survey element.
     * @see state
     * @see toggleState
     * @see collapse
     * @see isCollapsed
     * @see isExpanded
     */ SurveyElement.prototype.expand = function() {
                    this.state = "expanded";
                };
                /**
     * Toggles the survey element's `state` between collapsed and expanded.
     * @see state
     * @see collapse
     * @see expand
     * @see isCollapsed
     * @see isExpanded
     */ SurveyElement.prototype.toggleState = function() {
                    if (this.isCollapsed) {
                        this.expand();
                        return true;
                    }
                    if (this.isExpanded) {
                        this.collapse();
                        return false;
                    }
                    return true;
                };
                Object.defineProperty(SurveyElement.prototype, "hasStateButton", {
                    get: function() {
                        return this.isExpanded || this.isCollapsed;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "shortcutText", {
                    get: function() {
                        return this.title || this.name;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getTitleToolbar = function() {
                    if (!this.titleToolbarValue) {
                        this.titleToolbarValue = this.createActionContainer(true);
                        this.titleToolbarValue.containerCss = (this.isPanel ? this.cssClasses.panel.titleBar : this.cssClasses.titleBar) || "sv-action-title-bar";
                        this.titleToolbarValue.setItems(this.getTitleActions());
                    }
                    return this.titleToolbarValue;
                };
                SurveyElement.prototype.createActionContainer = function(allowAdaptiveActions) {
                    var actionContainer = allowAdaptiveActions ? new _actions_adaptive_container__WEBPACK_IMPORTED_MODULE_2__["AdaptiveActionContainer"]() : new _actions_container__WEBPACK_IMPORTED_MODULE_5__["ActionContainer"]();
                    if (this.survey && !!this.survey.getCss().actionBar) actionContainer.cssClasses = this.survey.getCss().actionBar;
                    return actionContainer;
                };
                Object.defineProperty(SurveyElement.prototype, "titleActions", {
                    get: function() {
                        return this.getPropertyValue("titleActions");
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getTitleActions = function() {
                    if (!this.isTitleActionRequested) {
                        this.updateTitleActions();
                        this.isTitleActionRequested = true;
                    }
                    return this.titleActions;
                };
                SurveyElement.prototype.getDefaultTitleActions = function() {
                    return [];
                };
                SurveyElement.prototype.updateTitleActions = function() {
                    var actions = this.getDefaultTitleActions();
                    if (!!this.survey) actions = this.survey.getUpdatedElementTitleActions(this, actions);
                    this.setPropertyValue("titleActions", actions);
                };
                Object.defineProperty(SurveyElement.prototype, "hasTitleActions", {
                    get: function() {
                        return this.getTitleActions().length > 0;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "hasTitleEvents", {
                    get: function() {
                        return this.state !== undefined && this.state !== "default";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "titleTabIndex", {
                    get: function() {
                        return !this.isPage && this.state !== "default" ? 0 : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "titleAriaExpanded", {
                    get: function() {
                        if (this.isPage || this.state === "default") return undefined;
                        return this.state === "expanded" ? "true" : "false";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "titleAriaRole", {
                    get: function() {
                        if (this.isPage || this.state === "default") return undefined;
                        return "button";
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.setSurveyImpl = function(value, isLight) {
                    this.surveyImplValue = value;
                    if (!this.surveyImplValue) {
                        this.setSurveyCore(null);
                        this.surveyDataValue = null;
                    } else {
                        this.surveyDataValue = this.surveyImplValue.getSurveyData();
                        this.setSurveyCore(this.surveyImplValue.getSurvey());
                        this.textProcessorValue = this.surveyImplValue.getTextProcessor();
                        this.onSetData();
                    }
                    if (!!this.survey) {
                        this.updateDescriptionVisibility(this.description);
                        this.clearCssClasses();
                    }
                };
                SurveyElement.prototype.canRunConditions = function() {
                    return _super.prototype.canRunConditions.call(this) && !!this.data;
                };
                SurveyElement.prototype.getDataFilteredValues = function() {
                    return !!this.data ? this.data.getFilteredValues() : {};
                };
                SurveyElement.prototype.getDataFilteredProperties = function() {
                    var props = !!this.data ? this.data.getFilteredProperties() : {};
                    props.question = this;
                    return props;
                };
                Object.defineProperty(SurveyElement.prototype, "surveyImpl", {
                    get: function() {
                        return this.surveyImplValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                /* You shouldn't use this method ever */ SurveyElement.prototype.__setData = function(data) {
                    if (_settings__WEBPACK_IMPORTED_MODULE_4__["settings"].supportCreatorV2) this.surveyDataValue = data;
                };
                Object.defineProperty(SurveyElement.prototype, "data", {
                    get: function() {
                        return this.surveyDataValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "survey", {
                    /**
         * Returns the survey object.
         */ get: function() {
                        return this.getSurvey();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getSurvey = function(live) {
                    if (live === void 0) live = false;
                    if (!!this.surveyValue) return this.surveyValue;
                    if (!!this.surveyImplValue) this.setSurveyCore(this.surveyImplValue.getSurvey());
                    return this.surveyValue;
                };
                SurveyElement.prototype.setSurveyCore = function(value) {
                    this.surveyValue = value;
                    if (!!this.surveyChangedCallback) this.surveyChangedCallback();
                };
                Object.defineProperty(SurveyElement.prototype, "isInternal", {
                    get: function() {
                        return this.isContentElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "areInvisibleElementsShowing", {
                    get: function() {
                        return !!this.survey && this.survey.areInvisibleElementsShowing && !this.isContentElement;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isVisible", {
                    get: function() {
                        return true;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isReadOnly", {
                    /**
         * Returns `true` if the survey element or its parent element is read-only.
         *
         * If you want to switch a survey element to the read-only state based on a condition, specify the [`enableIf`](https://surveyjs.io/form-library/documentation/question#enableIf) property. Refer to the following help topic for information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see readOnly
         */ get: function() {
                        return this.readOnly;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "readOnly", {
                    /**
         * Makes the survey element read-only.
         *
         * If you want to switch a survey element to the read-only state based on a condition, specify the [`enableIf`](https://surveyjs.io/form-library/documentation/question#enableIf) property. Refer to the following help topic for information: [Conditional Visibility](https://surveyjs.io/form-library/documentation/design-survey-conditional-logic#conditional-visibility).
         * @see isReadOnly
         */ get: function() {
                        return this.getPropertyValue("readOnly");
                    },
                    set: function(val1) {
                        if (this.readOnly == val1) return;
                        this.setPropertyValue("readOnly", val1);
                        if (!this.isLoadingFromJson) this.setPropertyValue("isReadOnly", this.isReadOnly);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.onReadOnlyChanged = function() {
                    if (!!this.readOnlyChangedCallback) this.readOnlyChangedCallback();
                };
                Object.defineProperty(SurveyElement.prototype, "css", {
                    get: function() {
                        return !!this.survey ? this.survey.getCss() : {};
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "cssClassesValue", {
                    get: function() {
                        return this.getPropertyValueWithoutDefault("cssClassesValue");
                    },
                    set: function(val1) {
                        this.setPropertyValue("cssClassesValue", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.ensureCssClassesValue = function() {
                    if (!this.cssClassesValue) {
                        this.cssClassesValue = this.calcCssClasses(this.css);
                        this.updateElementCssCore(this.cssClassesValue);
                    }
                };
                Object.defineProperty(SurveyElement.prototype, "cssClasses", {
                    /**
         * Returns an object in which keys are UI elements and values are CSS classes applied to them.
         *
         * Use the following events of the [`SurveyModel`](https://surveyjs.io/form-library/documentation/surveymodel) object to override CSS classes:
         *
         * - [`onUpdateQuestionCssClasses`](https://surveyjs.io/form-library/documentation/surveymodel#onUpdateQuestionCssClasses)
         * - [`onUpdatePanelCssClasses`](https://surveyjs.io/form-library/documentation/surveymodel#onUpdatePanelCssClasses)
         * - [`onUpdatePageCssClasses`](https://surveyjs.io/form-library/documentation/surveymodel#onUpdatePageCssClasses)
         * - [`onUpdateChoiceItemCss`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#onUpdateChoiceItemCss)
         */ get: function() {
                        var _dummy = this.cssClassesValue;
                        if (!this.survey) return this.calcCssClasses(this.css);
                        this.ensureCssClassesValue();
                        return this.cssClassesValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "cssTitleNumber", {
                    get: function() {
                        var css = this.cssClasses;
                        if (css.number) return css.number;
                        return css.panel ? css.panel.number : undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.calcCssClasses = function(css) {
                    return undefined;
                };
                SurveyElement.prototype.updateElementCssCore = function(cssClasses) {};
                Object.defineProperty(SurveyElement.prototype, "cssError", {
                    get: function() {
                        return "";
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.updateElementCss = function(reNew) {
                    this.clearCssClasses();
                };
                SurveyElement.prototype.clearCssClasses = function() {
                    this.cssClassesValue = undefined;
                };
                SurveyElement.prototype.getIsLoadingFromJson = function() {
                    if (_super.prototype.getIsLoadingFromJson.call(this)) return true;
                    return this.surveyValue ? this.surveyValue.isLoadingFromJson : false;
                };
                Object.defineProperty(SurveyElement.prototype, "name", {
                    /**
         * A survey element identifier.
         *
         * > Question names must be unique.
         */ get: function() {
                        return this.getPropertyValue("name", "");
                    },
                    set: function(val1) {
                        var oldValue = this.name;
                        this.setPropertyValue("name", this.getValidName(val1));
                        if (!this.isLoadingFromJson && !!oldValue) this.onNameChanged(oldValue);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getValidName = function(name) {
                    return name;
                };
                SurveyElement.prototype.onNameChanged = function(oldValue) {};
                SurveyElement.prototype.updateBindingValue = function(valueName, value) {
                    if (!!this.data && !this.isTwoValueEquals(value, this.data.getValue(valueName))) this.data.setValue(valueName, value, false);
                };
                Object.defineProperty(SurveyElement.prototype, "errors", {
                    /**
         * Validation errors. Call the `validate()` method to validate survey element data.
         * @see validate
         */ get: function() {
                        return this.getPropertyValue("errors");
                    },
                    set: function(val1) {
                        this.setPropertyValue("errors", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.updateVisibleErrors = function() {
                    var counter = 0;
                    for(var i = 0; i < this.errors.length; i++)if (this.errors[i].visible) counter++;
                    this.hasVisibleErrors = counter > 0;
                };
                Object.defineProperty(SurveyElement.prototype, "containsErrors", {
                    /**
         * Returns `true` if the survey element or its child elements have validation errors.
         *
         * This property contains the result of the most recent validation. This result may be outdated. Call the `validate` method to get an up-to-date value.
         * @see errors
         */ get: function() {
                        return this.getPropertyValue("containsErrors", false);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.updateContainsErrors = function() {
                    this.setPropertyValue("containsErrors", this.getContainsErrors());
                };
                SurveyElement.prototype.getContainsErrors = function() {
                    return this.errors.length > 0;
                };
                Object.defineProperty(SurveyElement.prototype, "selectedElementInDesign", {
                    get: function() {
                        return this.selectedElementInDesignValue;
                    },
                    set: function(val1) {
                        this.selectedElementInDesignValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.updateCustomWidgets = function() {};
                SurveyElement.prototype.onSurveyLoad = function() {};
                Object.defineProperty(SurveyElement.prototype, "wasRendered", {
                    get: function() {
                        return !!this.wasRenderedValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.onFirstRendering = function() {
                    this.wasRenderedValue = true;
                    this.ensureCssClassesValue();
                };
                SurveyElement.prototype.endLoadingFromJson = function() {
                    _super.prototype.endLoadingFromJson.call(this);
                    if (!this.survey) this.onSurveyLoad();
                    this.updateDescriptionVisibility(this.description);
                };
                SurveyElement.prototype.setVisibleIndex = function(index) {
                    return 0;
                };
                Object.defineProperty(SurveyElement.prototype, "isPage", {
                    /**
         * Returns `true` if the survey element is a page.
         * @see Base.getType
         */ get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isPanel", {
                    /**
         * Returns `true` if the survey element is a panel.
         * @see Base.getType
         */ get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "isQuestion", {
                    /**
         * Returns `true` if the survey element is a question.
         * @see Base.getType
         */ get: function() {
                        return false;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.delete = function(doDispose) {};
                /**
     * Returns the survey's [locale](https://surveyjs.io/form-library/documentation/surveymodel#locale).
     *
     * If a default locale is used, this method returns an empty string. To get the applied locale in this case, use the following code:
     *
     * ```js
     * import { surveyLocalization } from 'survey-core';
     * const defaultLocale = surveyLocalization.defaultLocale;
     * ```
     *
     * @see [Localization & Globalization](https://surveyjs.io/form-library/documentation/localization)
     */ SurveyElement.prototype.getLocale = function() {
                    return this.survey ? this.survey.getLocale() : this.locOwner ? this.locOwner.getLocale() : "";
                };
                SurveyElement.prototype.getMarkdownHtml = function(text, name) {
                    return this.survey ? this.survey.getSurveyMarkdownHtml(this, text, name) : this.locOwner ? this.locOwner.getMarkdownHtml(text, name) : undefined;
                };
                SurveyElement.prototype.getRenderer = function(name) {
                    return this.survey && typeof this.survey.getRendererForString === "function" ? this.survey.getRendererForString(this, name) : this.locOwner && typeof this.locOwner.getRenderer === "function" ? this.locOwner.getRenderer(name) : null;
                };
                SurveyElement.prototype.getRendererContext = function(locStr) {
                    return this.survey && typeof this.survey.getRendererContextForString === "function" ? this.survey.getRendererContextForString(this, locStr) : this.locOwner && typeof this.locOwner.getRendererContext === "function" ? this.locOwner.getRendererContext(locStr) : locStr;
                };
                SurveyElement.prototype.getProcessedText = function(text) {
                    if (this.isLoadingFromJson) return text;
                    if (this.textProcessor) return this.textProcessor.processText(text, this.getUseDisplayValuesInDynamicTexts());
                    if (this.locOwner) return this.locOwner.getProcessedText(text);
                    return text;
                };
                SurveyElement.prototype.getUseDisplayValuesInDynamicTexts = function() {
                    return true;
                };
                SurveyElement.prototype.removeSelfFromList = function(list) {
                    if (!list || !Array.isArray(list)) return;
                    var index = list.indexOf(this);
                    if (index > -1) list.splice(index, 1);
                };
                Object.defineProperty(SurveyElement.prototype, "textProcessor", {
                    get: function() {
                        return this.textProcessorValue;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getProcessedHtml = function(html) {
                    if (!html || !this.textProcessor) return html;
                    return this.textProcessor.processText(html, true);
                };
                SurveyElement.prototype.onSetData = function() {};
                Object.defineProperty(SurveyElement.prototype, "parent", {
                    get: function() {
                        return this.getPropertyValue("parent", null);
                    },
                    set: function(val1) {
                        this.setPropertyValue("parent", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getPage = function(parent) {
                    while(parent && parent.parent)parent = parent.parent;
                    if (parent && parent.getType() == "page") return parent;
                    return null;
                };
                SurveyElement.prototype.moveToBase = function(parent, container, insertBefore) {
                    if (insertBefore === void 0) insertBefore = null;
                    if (!container) return false;
                    parent.removeElement(this);
                    var index = -1;
                    if (_helpers__WEBPACK_IMPORTED_MODULE_3__["Helpers"].isNumber(insertBefore)) index = parseInt(insertBefore);
                    if (index == -1 && !!insertBefore && !!insertBefore.getType) index = container.indexOf(insertBefore);
                    container.addElement(this, index);
                    return true;
                };
                SurveyElement.prototype.setPage = function(parent, newPage) {
                    var oldPage = this.getPage(parent);
                    //fix for the creator v1: https://github.com/surveyjs/survey-creator/issues/1744
                    if (typeof newPage === "string") {
                        var survey = this.getSurvey();
                        survey.pages.forEach(function(page) {
                            if (newPage === page.name) newPage = page;
                        });
                    }
                    if (oldPage === newPage) return;
                    if (parent) parent.removeElement(this);
                    if (newPage) newPage.addElement(this, -1);
                };
                SurveyElement.prototype.getSearchableLocKeys = function(keys) {
                    keys.push("title");
                    keys.push("description");
                };
                Object.defineProperty(SurveyElement.prototype, "isDefaultV2Theme", {
                    get: function() {
                        return this.survey && this.survey.getCss().root == "sd-root-modern";
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "hasParent", {
                    get: function() {
                        return this.parent && !this.parent.isPage && !this.parent.originalPage || this.parent === undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.shouldAddRunnerStyles = function() {
                    return !this.isDesignMode && this.isDefaultV2Theme;
                };
                Object.defineProperty(SurveyElement.prototype, "isCompact", {
                    get: function() {
                        return this.survey && this.survey["isCompact"];
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getHasFrameV2 = function() {
                    return this.shouldAddRunnerStyles() && !this.hasParent;
                };
                SurveyElement.prototype.getIsNested = function() {
                    return this.shouldAddRunnerStyles() && this.hasParent;
                };
                SurveyElement.prototype.getCssRoot = function(cssClasses) {
                    var isExpanadable = !!this.isCollapsed || !!this.isExpanded;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(cssClasses.withFrame, this.getHasFrameV2() && !this.isCompact).append(cssClasses.compact, this.isCompact && this.getHasFrameV2()).append(cssClasses.collapsed, !!this.isCollapsed).append(cssClasses.expandableAnimating, isExpanadable && this.isAnimatingCollapseExpand).append(cssClasses.expanded, !!this.isExpanded && this.renderedIsExpanded).append(cssClasses.expandable, isExpanadable).append(cssClasses.nested, this.getIsNested()).toString();
                };
                Object.defineProperty(SurveyElement.prototype, "width", {
                    /**
         * Sets survey element width in CSS values.
         *
         * Default value: ""
         * @see minWidth
         * @see maxWidth
        */ get: function() {
                        return this.getPropertyValue("width", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("width", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "minWidth", {
                    /**
         * Gets or sets minimum survey element width in CSS values.
         *
         * Default value: "300px" (taken from [`settings.minWidth`](https://surveyjs.io/form-library/documentation/settings#minWidth))
         * @see maxWidth
         * @see renderWidth
         * @see width
         */ get: function() {
                        return this.getPropertyValue("minWidth");
                    },
                    set: function(val1) {
                        this.setPropertyValue("minWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "maxWidth", {
                    /**
         * Gets or sets maximum survey element width in CSS values.
         *
         * Default value: "100%" (taken from [`settings.maxWidth`](https://surveyjs.io/form-library/documentation/settings#maxWidth))
         * @see minWidth
         * @see renderWidth
         * @see width
         */ get: function() {
                        return this.getPropertyValue("maxWidth");
                    },
                    set: function(val1) {
                        this.setPropertyValue("maxWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "renderWidth", {
                    /**
         * Returns a calculated width of the rendered survey element in CSS values.
         * @see width
         * @see minWidth
         * @see maxWidth
         */ get: function() {
                        return this.getPropertyValue("renderWidth", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("renderWidth", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "indent", {
                    /**
         * Increases or decreases an indent of survey element content from the left edge. Accepts positive integer values and 0. Does not apply in the Default V2 theme.
         * @see rightIndent
         */ get: function() {
                        return this.getPropertyValue("indent");
                    },
                    set: function(val1) {
                        this.setPropertyValue("indent", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "rightIndent", {
                    /**
         * Increases or decreases an indent of survey element content from the right edge. Accepts positive integer values and 0. Does not apply in the Default V2 theme.
         * @see indent
         */ get: function() {
                        return this.getPropertyValue("rightIndent", 0);
                    },
                    set: function(val1) {
                        this.setPropertyValue("rightIndent", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getRootStyle = function() {
                    var style = {};
                    if (!!this.paddingLeft) style["--sv-element-add-padding-left"] = this.paddingLeft;
                    if (!!this.paddingRight) style["--sv-element-add-padding-right"] = this.paddingRight;
                    return style;
                };
                Object.defineProperty(SurveyElement.prototype, "paddingLeft", {
                    get: function() {
                        return this.getPropertyValue("paddingLeft", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("paddingLeft", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "paddingRight", {
                    get: function() {
                        return this.getPropertyValue("paddingRight", "");
                    },
                    set: function(val1) {
                        this.setPropertyValue("paddingRight", val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "rootStyle", {
                    get: function() {
                        var style = {};
                        var minWidth = this.minWidth;
                        if (minWidth != "auto") minWidth = "min(100%, " + this.minWidth + ")";
                        if (this.allowRootStyle && this.renderWidth) {
                            // style["width"] = this.renderWidth;
                            style["flexGrow"] = 1;
                            style["flexShrink"] = 1;
                            style["flexBasis"] = this.renderWidth;
                            style["minWidth"] = minWidth;
                            style["maxWidth"] = this.maxWidth;
                        }
                        return style;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.isContainsSelection = function(el) {
                    var elementWithSelection = undefined;
                    var _document = _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomDocumentHelper"].getDocument();
                    if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomDocumentHelper"].isAvailable() && !!_document && _document["selection"]) elementWithSelection = _document["selection"].createRange().parentElement();
                    else {
                        var selection = _global_variables_utils__WEBPACK_IMPORTED_MODULE_9__["DomWindowHelper"].getSelection();
                        if (!!selection && selection.rangeCount > 0) {
                            var range = selection.getRangeAt(0);
                            if (range.startOffset !== range.endOffset) elementWithSelection = range.startContainer.parentNode;
                        }
                    }
                    return elementWithSelection == el;
                };
                Object.defineProperty(SurveyElement.prototype, "clickTitleFunction", {
                    get: function() {
                        var _this = this;
                        if (this.needClickTitleFunction()) return function(event) {
                            if (!!event && _this.isContainsSelection(event.target)) return;
                            return _this.processTitleClick();
                        };
                        return undefined;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.needClickTitleFunction = function() {
                    return this.state !== "default";
                };
                SurveyElement.prototype.processTitleClick = function() {
                    if (this.state !== "default") this.toggleState();
                };
                Object.defineProperty(SurveyElement.prototype, "additionalTitleToolbar", {
                    get: function() {
                        return this.getAdditionalTitleToolbar();
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getAdditionalTitleToolbar = function() {
                    return null;
                };
                SurveyElement.prototype.getCssTitle = function(cssClasses) {
                    var isExpandable = this.state !== "default";
                    var numInlineLimit = 4;
                    return new _utils_cssClassBuilder__WEBPACK_IMPORTED_MODULE_6__["CssClassBuilder"]().append(cssClasses.title).append(cssClasses.titleNumInline, (this.no || "").length > numInlineLimit || isExpandable).append(cssClasses.titleExpandable, isExpandable).append(cssClasses.titleExpanded, this.isExpanded).append(cssClasses.titleCollapsed, this.isCollapsed).append(cssClasses.titleDisabled, this.isReadOnly).append(cssClasses.titleOnError, this.containsErrors).toString();
                };
                SurveyElement.prototype.localeChanged = function() {
                    _super.prototype.localeChanged.call(this);
                    this.updateDescriptionVisibility(this.description);
                    if (this.errors.length > 0) this.errors.forEach(function(err) {
                        err.updateText();
                    });
                };
                SurveyElement.prototype.setWrapperElement = function(element) {
                    this.wrapperElement = element;
                };
                SurveyElement.prototype.getWrapperElement = function() {
                    return this.wrapperElement;
                };
                Object.defineProperty(SurveyElement.prototype, "isAnimatingCollapseExpand", {
                    get: function() {
                        return this._isAnimatingCollapseExpand || this._renderedIsExpanded != this.isExpanded;
                    },
                    set: function(val1) {
                        if (val1 !== this._isAnimatingCollapseExpand) {
                            this._isAnimatingCollapseExpand = val1;
                            this.updateElementCss(false);
                        }
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.getExpandCollapseAnimationOptions = function() {
                    var _this = this;
                    var beforeRunAnimation = function(el) {
                        _this.isAnimatingCollapseExpand = true;
                        el.style.setProperty("--animation-height", el.offsetHeight + "px");
                    };
                    var afterRunAnimation = function(el) {
                        _this.isAnimatingCollapseExpand = false;
                    };
                    return {
                        getEnterOptions: function() {
                            var cssClasses = _this.isPanel ? _this.cssClasses.panel : _this.cssClasses;
                            return {
                                cssClass: cssClasses.contentFadeIn,
                                onBeforeRunAnimation: beforeRunAnimation,
                                onAfterRunAnimation: afterRunAnimation
                            };
                        },
                        getLeaveOptions: function() {
                            var cssClasses = _this.isPanel ? _this.cssClasses.panel : _this.cssClasses;
                            return {
                                cssClass: cssClasses.contentFadeOut,
                                onBeforeRunAnimation: beforeRunAnimation,
                                onAfterRunAnimation: afterRunAnimation
                            };
                        },
                        getAnimatedElement: function() {
                            var _a;
                            var cssClasses = _this.isPanel ? _this.cssClasses.panel : _this.cssClasses;
                            if (cssClasses.content) {
                                var selector = Object(_utils_utils__WEBPACK_IMPORTED_MODULE_8__["classesToSelector"])(cssClasses.content);
                                if (selector) return (_a = _this.getWrapperElement()) === null || _a === void 0 ? void 0 : _a.querySelector(selector);
                            }
                            return undefined;
                        },
                        isAnimationEnabled: function() {
                            return _settings__WEBPACK_IMPORTED_MODULE_4__["settings"].animationEnabled && _this.animationAllowed && !_this.isDesignMode;
                        }
                    };
                };
                Object.defineProperty(SurveyElement.prototype, "renderedIsExpanded", {
                    get: function() {
                        return !!this._renderedIsExpanded;
                    },
                    set: function(val1) {
                        this.animationCollapsed.sync(val1);
                    },
                    enumerable: false,
                    configurable: true
                });
                Object.defineProperty(SurveyElement.prototype, "animationAllowed", {
                    get: function() {
                        return !this.isLoadingFromJson && !this.isDisposed && !!this.survey && this.animationAllowedValue;
                    },
                    set: function(val1) {
                        this.animationAllowedValue = val1;
                    },
                    enumerable: false,
                    configurable: true
                });
                SurveyElement.prototype.dispose = function() {
                    _super.prototype.dispose.call(this);
                    if (this.titleToolbarValue) this.titleToolbarValue.dispose();
                };
                SurveyElement.CreateDisabledDesignElements = false;
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: null
                    })
                ], SurveyElement.prototype, "dragTypeOverMe", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], SurveyElement.prototype, "isDragMe", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: false
                    })
                ], SurveyElement.prototype, "hasVisibleErrors", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], SurveyElement.prototype, "isSingleInRow", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])({
                        defaultValue: true
                    })
                ], SurveyElement.prototype, "allowRootStyle", void 0);
                __decorate([
                    Object(_jsonobject__WEBPACK_IMPORTED_MODULE_0__["property"])()
                ], SurveyElement.prototype, "_renderedIsExpanded", void 0);
                return SurveyElement;
            }(SurveyElementCore);
        /***/ },
        /***/ "./src/surveyStrings.ts": /*!******************************!*\
  !*** ./src/surveyStrings.ts ***!
  \******************************/ /*! exports provided: surveyLocalization, surveyStrings */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "surveyLocalization", function() {
                return surveyLocalization;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "surveyStrings", function() {
                return surveyStrings;
            });
            /* harmony import */ var _localization_english__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./localization/english */ "./src/localization/english.ts");
            var surveyLocalization = {
                currentLocaleValue: "",
                defaultLocaleValue: "en",
                locales: {},
                localeNames: {},
                supportedLocales: [],
                get currentLocale () {
                    return this.currentLocaleValue === this.defaultLocaleValue ? "" : this.currentLocaleValue;
                },
                set currentLocale (val){
                    if (val === "cz") val = "cs";
                    this.currentLocaleValue = val;
                },
                get defaultLocale () {
                    return this.defaultLocaleValue;
                },
                set defaultLocale (val){
                    if (val === "cz") val = "cs";
                    this.defaultLocaleValue = val;
                },
                getLocaleStrings: function(loc) {
                    return this.locales[loc];
                },
                getString: function(strName, locale) {
                    var _this = this;
                    if (locale === void 0) locale = null;
                    var locs = new Array();
                    var addLocaleCore = function(locName) {
                        var strs = _this.locales[locName];
                        if (!!strs) locs.push(strs);
                    };
                    var addLocale = function(locName) {
                        if (!locName) return;
                        addLocaleCore(locName);
                        var index = locName.indexOf("-");
                        if (index < 1) return;
                        locName = locName.substring(0, index);
                        addLocaleCore(locName);
                    };
                    addLocale(locale);
                    addLocale(this.currentLocale);
                    addLocale(this.defaultLocale);
                    if (this.defaultLocale !== "en") addLocaleCore("en");
                    for(var i = 0; i < locs.length; i++){
                        var res = locs[i][strName];
                        if (res !== undefined) return res;
                    }
                    return this.onGetExternalString(strName, locale);
                },
                getLocales: function(removeDefaultLoc) {
                    if (removeDefaultLoc === void 0) removeDefaultLoc = false;
                    var res = [];
                    res.push("");
                    var locs = this.locales;
                    if (this.supportedLocales && this.supportedLocales.length > 0) {
                        locs = {};
                        for(var i = 0; i < this.supportedLocales.length; i++)locs[this.supportedLocales[i]] = true;
                    }
                    for(var key in locs){
                        if (removeDefaultLoc && key == this.defaultLocale) continue;
                        res.push(key);
                    }
                    var locName = function(loc) {
                        if (!loc) return "";
                        var res = surveyLocalization.localeNames[loc];
                        if (!res) res = loc;
                        return res.toLowerCase();
                    };
                    res.sort(function(a, b) {
                        var str1 = locName(a);
                        var str2 = locName(b);
                        if (str1 === str2) return 0;
                        return str1 < str2 ? -1 : 1;
                    });
                    return res;
                },
                onGetExternalString: function(name, locale) {
                    return undefined;
                }
            };
            var surveyStrings = _localization_english__WEBPACK_IMPORTED_MODULE_0__["englishStrings"];
            surveyLocalization.locales["en"] = _localization_english__WEBPACK_IMPORTED_MODULE_0__["englishStrings"];
            surveyLocalization.localeNames["en"] = "english";
        /***/ },
        /***/ "./src/utils/animation.ts": /*!********************************!*\
  !*** ./src/utils/animation.ts ***!
  \********************************/ /*! exports provided: AnimationUtils, AnimationPropertyUtils, AnimationGroupUtils, AnimationBoolean, AnimationGroup */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationUtils", function() {
                return AnimationUtils;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationPropertyUtils", function() {
                return AnimationPropertyUtils;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationGroupUtils", function() {
                return AnimationGroupUtils;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationBoolean", function() {
                return AnimationBoolean;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "AnimationGroup", function() {
                return AnimationGroup;
            });
            /* harmony import */ var _taskmanager__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./taskmanager */ "./src/utils/taskmanager.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var AnimationUtils = /** @class */ function() {
                function AnimationUtils() {
                    this.cancelQueue = [];
                }
                AnimationUtils.prototype.getMsFromRule = function(value) {
                    if (value === "auto") return 0;
                    return Number(value.slice(0, -1).replace(",", ".")) * 1000;
                };
                AnimationUtils.prototype.getAnimationsCount = function(element) {
                    var animationName = "";
                    if (getComputedStyle) animationName = getComputedStyle(element).animationName;
                    return animationName && animationName != "none" ? animationName.split(", ").length : 0;
                };
                AnimationUtils.prototype.getAnimationDuration = function(element) {
                    var style = getComputedStyle(element);
                    var delays = style["animationDelay"].split(", ");
                    var durations = style["animationDuration"].split(", ");
                    var duration = 0;
                    for(var i = 0; i < Math.max(durations.length, delays.length); i++)duration = Math.max(duration, this.getMsFromRule(durations[i % durations.length]) + this.getMsFromRule(delays[i % delays.length]));
                    return duration;
                };
                AnimationUtils.prototype.onAnimationEnd = function(element, callback, options) {
                    var _this = this;
                    var cancelTimeout;
                    var animationsCount = this.getAnimationsCount(element);
                    var onEndCallback = function(isCancel) {
                        if (isCancel === void 0) isCancel = true;
                        options.onAfterRunAnimation && options.onAfterRunAnimation(element);
                        callback(isCancel);
                        clearTimeout(cancelTimeout);
                        _this.cancelQueue.splice(_this.cancelQueue.indexOf(onEndCallback), 1);
                        element.removeEventListener("animationend", onAnimationEndCallback);
                    };
                    var onAnimationEndCallback = function(event) {
                        if (event.target == event.currentTarget && --animationsCount <= 0) onEndCallback(false);
                    };
                    if (animationsCount > 0) {
                        element.addEventListener("animationend", onAnimationEndCallback);
                        this.cancelQueue.push(onEndCallback);
                        cancelTimeout = setTimeout(function() {
                            onEndCallback(false);
                        }, this.getAnimationDuration(element) + 10);
                    } else callback(true);
                };
                AnimationUtils.prototype.beforeAnimationRun = function(element, options) {
                    if (element) options.onBeforeRunAnimation && options.onBeforeRunAnimation(element);
                };
                AnimationUtils.prototype.runLeaveAnimation = function(element, options, callback) {
                    if (element && options.cssClass) {
                        element.classList.add(options.cssClass);
                        var onAnimationEndCallback = function(isCancel) {
                            callback();
                            if (isCancel) element.classList.remove(options.cssClass);
                            else requestAnimationFrame(function() {
                                requestAnimationFrame(function() {
                                    element.classList.remove(options.cssClass);
                                });
                            });
                        };
                        this.onAnimationEnd(element, onAnimationEndCallback, options);
                    } else callback();
                };
                AnimationUtils.prototype.runEnterAnimation = function(element, options) {
                    if (element && options.cssClass) {
                        element.classList.add(options.cssClass);
                        this.onAnimationEnd(element, function() {
                            element.classList.remove(options.cssClass);
                        }, options);
                    }
                };
                AnimationUtils.prototype.cancel = function() {
                    this.cancelQueue.forEach(function(func) {
                        return func();
                    });
                    this.cancelQueue = [];
                };
                return AnimationUtils;
            }();
            var AnimationPropertyUtils = /** @class */ function(_super) {
                __extends(AnimationPropertyUtils, _super);
                function AnimationPropertyUtils() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                AnimationPropertyUtils.prototype.onEnter = function(getElement, options) {
                    var _this = this;
                    var callback = function() {
                        var element = getElement();
                        _this.beforeAnimationRun(element, options);
                        _this.runEnterAnimation(element, options);
                    };
                    requestAnimationFrame(function() {
                        if (getElement()) callback();
                        else requestAnimationFrame(callback);
                    });
                };
                AnimationPropertyUtils.prototype.onLeave = function(getElement, callback, options) {
                    var element = getElement();
                    this.beforeAnimationRun(element, options);
                    this.runLeaveAnimation(element, options, callback);
                };
                return AnimationPropertyUtils;
            }(AnimationUtils);
            var AnimationGroupUtils = /** @class */ function(_super) {
                __extends(AnimationGroupUtils, _super);
                function AnimationGroupUtils() {
                    return _super !== null && _super.apply(this, arguments) || this;
                }
                AnimationGroupUtils.prototype.onEnter = function(getElement, getOptions, elements) {
                    var _this = this;
                    if (elements.length == 0) return;
                    requestAnimationFrame(function() {
                        var callback = function() {
                            elements.forEach(function(el) {
                                _this.beforeAnimationRun(getElement(el), getOptions(el));
                            });
                            elements.forEach(function(el) {
                                _this.runEnterAnimation(getElement(el), getOptions(el));
                            });
                        };
                        if (!getElement(elements[0])) requestAnimationFrame(callback);
                        else callback();
                    });
                };
                AnimationGroupUtils.prototype.onLeave = function(getElement, callback, getOptions, elements) {
                    var _this = this;
                    elements.forEach(function(el) {
                        _this.beforeAnimationRun(getElement(el), getOptions(el));
                    });
                    var counter = elements.length;
                    var onEndCallback = function() {
                        if (--counter <= 0) callback();
                    };
                    elements.forEach(function(el) {
                        _this.runLeaveAnimation(getElement(el), getOptions(el), onEndCallback);
                    });
                };
                return AnimationGroupUtils;
            }(AnimationUtils);
            var AnimationProperty = /** @class */ function() {
                function AnimationProperty(animationOptions, update, getCurrentValue) {
                    var _this = this;
                    this.animationOptions = animationOptions;
                    this.update = update;
                    this.getCurrentValue = getCurrentValue;
                    this._debouncedSync = Object(_taskmanager__WEBPACK_IMPORTED_MODULE_0__["debounce"])(function(newValue) {
                        _this.animation.cancel();
                        _this._sync(newValue);
                    });
                }
                AnimationProperty.prototype.sync = function(newValue) {
                    if (this.animationOptions.isAnimationEnabled()) this._debouncedSync.run(newValue);
                    else this.update(newValue);
                };
                AnimationProperty.prototype.cancel = function() {
                    this.animation.cancel();
                    this._debouncedSync.cancel();
                };
                return AnimationProperty;
            }();
            var AnimationBoolean = /** @class */ function(_super) {
                __extends(AnimationBoolean, _super);
                function AnimationBoolean() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.animation = new AnimationPropertyUtils();
                    return _this;
                }
                AnimationBoolean.prototype._sync = function(newValue) {
                    var _this = this;
                    if (newValue !== this.getCurrentValue()) {
                        if (newValue) {
                            this.update(newValue);
                            this.animation.onEnter(function() {
                                return _this.animationOptions.getAnimatedElement();
                            }, this.animationOptions.getEnterOptions());
                        } else this.animation.onLeave(function() {
                            return _this.animationOptions.getAnimatedElement();
                        }, function() {
                            _this.update(newValue);
                        }, this.animationOptions.getLeaveOptions());
                    } else this.update(newValue);
                };
                return AnimationBoolean;
            }(AnimationProperty);
            var AnimationGroup = /** @class */ function(_super) {
                __extends(AnimationGroup, _super);
                function AnimationGroup() {
                    var _this = _super !== null && _super.apply(this, arguments) || this;
                    _this.animation = new AnimationGroupUtils();
                    return _this;
                }
                AnimationGroup.prototype._sync = function(newValue) {
                    var _this = this;
                    var oldValue = this.getCurrentValue();
                    var itemsToAdd = newValue.filter(function(el) {
                        return oldValue.indexOf(el) < 0;
                    });
                    var deletedItems = oldValue.filter(function(el) {
                        return newValue.indexOf(el) < 0;
                    });
                    this.animation.onEnter(function(el) {
                        return _this.animationOptions.getAnimatedElement(el);
                    }, function(el) {
                        return _this.animationOptions.getEnterOptions(el);
                    }, itemsToAdd);
                    if (itemsToAdd.length == 0 && (deletedItems === null || deletedItems === void 0 ? void 0 : deletedItems.length) > 0) this.animation.onLeave(function(el) {
                        return _this.animationOptions.getAnimatedElement(el);
                    }, function() {
                        _this.update(newValue);
                    }, function(el) {
                        return _this.animationOptions.getLeaveOptions(el);
                    }, deletedItems);
                    else this.update(newValue);
                };
                return AnimationGroup;
            }(AnimationProperty);
        /***/ },
        /***/ "./src/utils/cssClassBuilder.ts": /*!**************************************!*\
  !*** ./src/utils/cssClassBuilder.ts ***!
  \**************************************/ /*! exports provided: CssClassBuilder */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "CssClassBuilder", function() {
                return CssClassBuilder;
            });
            var CssClassBuilder = /** @class */ function() {
                function CssClassBuilder() {
                    this.classes = [];
                }
                CssClassBuilder.prototype.isEmpty = function() {
                    return this.toString() === "";
                };
                CssClassBuilder.prototype.append = function(value, condition) {
                    if (condition === void 0) condition = true;
                    if (!!value && condition) {
                        if (typeof value === "string") value = value.trim();
                        this.classes.push(value);
                    }
                    return this;
                };
                CssClassBuilder.prototype.toString = function() {
                    return this.classes.join(" ");
                };
                return CssClassBuilder;
            }();
        /***/ },
        /***/ "./src/utils/responsivity-manager.ts": /*!*******************************************!*\
  !*** ./src/utils/responsivity-manager.ts ***!
  \*******************************************/ /*! exports provided: ResponsivityManager, VerticalResponsivityManager */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ResponsivityManager", function() {
                return ResponsivityManager;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "VerticalResponsivityManager", function() {
                return VerticalResponsivityManager;
            });
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            /* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils */ "./src/utils/utils.ts");
            var __extends = function() {
                var extendStatics = function(d, b) {
                    extendStatics = Object.setPrototypeOf || ({
                        __proto__: []
                    }) instanceof Array && function(d, b) {
                        d.__proto__ = b;
                    } || function(d, b) {
                        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
                    };
                    return extendStatics(d, b);
                };
                return function(d, b) {
                    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
                    extendStatics(d, b);
                    function __() {
                        this.constructor = d;
                    }
                    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
                };
            }();
            var ResponsivityManager = /** @class */ function() {
                function ResponsivityManager(container, model, itemsSelector, dotsItemSize, delayedUpdateFunction) {
                    var _this = this;
                    if (dotsItemSize === void 0) dotsItemSize = null;
                    this.container = container;
                    this.model = model;
                    this.itemsSelector = itemsSelector;
                    this.dotsItemSize = dotsItemSize;
                    this.delayedUpdateFunction = delayedUpdateFunction;
                    this.resizeObserver = undefined;
                    this.isInitialized = false;
                    this.minDimensionConst = 56;
                    this.separatorSize = 17;
                    this.separatorAddConst = 1;
                    this.paddingSizeConst = 8;
                    this.dotsSizeConst = 48;
                    this.recalcMinDimensionConst = true;
                    this.getComputedStyle = function(elt) {
                        return _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomDocumentHelper"].getComputedStyle(elt);
                    };
                    this.model.updateCallback = function(isResetInitialized) {
                        if (isResetInitialized) _this.isInitialized = false;
                        setTimeout(function() {
                            _this.process();
                        }, 1);
                    };
                    if (typeof ResizeObserver !== "undefined") {
                        this.resizeObserver = new ResizeObserver(function(entries) {
                            _global_variables_utils__WEBPACK_IMPORTED_MODULE_0__["DomWindowHelper"].requestAnimationFrame(function() {
                                _this.process();
                            });
                        });
                        this.resizeObserver.observe(this.container.parentElement);
                    }
                }
                ResponsivityManager.prototype.getDimensions = function(element) {
                    return {
                        scroll: element.scrollWidth,
                        offset: element.offsetWidth
                    };
                };
                ResponsivityManager.prototype.getAvailableSpace = function() {
                    var style = this.getComputedStyle(this.container);
                    var space = this.container.offsetWidth;
                    if (style.boxSizing === "border-box") space -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight);
                    return space;
                };
                ResponsivityManager.prototype.calcItemSize = function(item) {
                    return item.offsetWidth;
                };
                ResponsivityManager.prototype.calcMinDimension = function(currentAction) {
                    var minDimensionConst = this.minDimensionConst;
                    if (currentAction.iconSize && this.recalcMinDimensionConst) minDimensionConst = 2 * currentAction.iconSize + this.paddingSizeConst;
                    return currentAction.canShrink ? minDimensionConst + (currentAction.needSeparator ? this.separatorSize : 0) : currentAction.maxDimension;
                };
                ResponsivityManager.prototype.getRenderedVisibleActionsCount = function() {
                    var _this = this;
                    var count = 0;
                    this.container.querySelectorAll(this.itemsSelector).forEach(function(item) {
                        if (_this.calcItemSize(item) > 0) count++;
                    });
                    return count;
                };
                ResponsivityManager.prototype.calcItemsSizes = function() {
                    var _this = this;
                    var actions = this.model.actions;
                    var _items = this.container.querySelectorAll(this.itemsSelector);
                    (_items || []).forEach(function(item, index) {
                        var currentAction = actions[index];
                        _this.calcActionDimensions(currentAction, item);
                    });
                };
                ResponsivityManager.prototype.calcActionDimensions = function(currentAction, item) {
                    currentAction.maxDimension = this.calcItemSize(item);
                    currentAction.minDimension = this.calcMinDimension(currentAction);
                };
                Object.defineProperty(ResponsivityManager.prototype, "isContainerVisible", {
                    get: function() {
                        return Object(_utils__WEBPACK_IMPORTED_MODULE_1__["isContainerVisible"])(this.container);
                    },
                    enumerable: false,
                    configurable: true
                });
                ResponsivityManager.prototype.process = function() {
                    var _this = this;
                    if (this.isContainerVisible && !this.model.isResponsivenessDisabled) {
                        if (!this.isInitialized) this.model.setActionsMode("large");
                        var processResponsiveness_1 = function() {
                            var _a;
                            var dotsItemSize = _this.dotsItemSize;
                            if (!_this.dotsItemSize) {
                                var dotsItemElement = (_a = _this.container) === null || _a === void 0 ? void 0 : _a.querySelector(".sv-dots");
                                dotsItemSize = dotsItemElement && _this.calcItemSize(dotsItemElement) || _this.dotsSizeConst;
                            }
                            _this.model.fit(_this.getAvailableSpace(), dotsItemSize);
                        };
                        if (!this.isInitialized) {
                            var callback = function() {
                                _this.calcItemsSizes();
                                _this.isInitialized = true;
                                processResponsiveness_1();
                            };
                            if (this.getRenderedVisibleActionsCount() < this.model.visibleActions.length) {
                                if (this.delayedUpdateFunction) this.delayedUpdateFunction(callback);
                                else if (queueMicrotask) queueMicrotask(callback);
                                else callback();
                            } else callback();
                        } else processResponsiveness_1();
                    }
                };
                ResponsivityManager.prototype.dispose = function() {
                    this.model.updateCallback = undefined;
                    if (!!this.resizeObserver) this.resizeObserver.disconnect();
                };
                return ResponsivityManager;
            }();
            var VerticalResponsivityManager = /** @class */ function(_super) {
                __extends(VerticalResponsivityManager, _super);
                function VerticalResponsivityManager(container, model, itemsSelector, dotsItemSize, minDimension, delayedUpdateFunction) {
                    if (minDimension === void 0) minDimension = 40;
                    var _this = _super.call(this, container, model, itemsSelector, dotsItemSize, delayedUpdateFunction) || this;
                    _this.minDimensionConst = minDimension;
                    _this.recalcMinDimensionConst = false;
                    return _this;
                }
                VerticalResponsivityManager.prototype.getDimensions = function() {
                    return {
                        scroll: this.container.scrollHeight,
                        offset: this.container.offsetHeight
                    };
                };
                VerticalResponsivityManager.prototype.getAvailableSpace = function() {
                    var style = this.getComputedStyle(this.container);
                    var space = this.container.offsetHeight;
                    if (style.boxSizing === "border-box") space -= parseFloat(style.paddingTop) + parseFloat(style.paddingBottom);
                    return space;
                };
                VerticalResponsivityManager.prototype.calcItemSize = function(item) {
                    return item.offsetHeight;
                };
                VerticalResponsivityManager.prototype.calcActionDimensions = function(currentAction, item) {
                    currentAction.maxDimension = this.calcItemSize(item);
                    currentAction.minDimension = this.calcItemSize(item);
                };
                return VerticalResponsivityManager;
            }(ResponsivityManager);
        /***/ },
        /***/ "./src/utils/taskmanager.ts": /*!**********************************!*\
  !*** ./src/utils/taskmanager.ts ***!
  \**********************************/ /*! exports provided: Task, TaskManger, debounce */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Task", function() {
                return Task;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "TaskManger", function() {
                return TaskManger;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "debounce", function() {
                return debounce;
            });
            var Task = /** @class */ function() {
                function Task(func, isMultiple) {
                    var _this = this;
                    if (isMultiple === void 0) isMultiple = false;
                    this.func = func;
                    this.isMultiple = isMultiple;
                    this._isCompleted = false;
                    this.execute = function() {
                        if (!_this._isCompleted) {
                            _this.func();
                            _this._isCompleted = !_this.isMultiple;
                        }
                    };
                }
                Task.prototype.discard = function() {
                    this._isCompleted = true;
                };
                Object.defineProperty(Task.prototype, "isCompleted", {
                    get: function() {
                        return this._isCompleted;
                    },
                    enumerable: false,
                    configurable: true
                });
                return Task;
            }();
            var TaskManger = /** @class */ function() {
                function TaskManger(interval) {
                    if (interval === void 0) interval = 100;
                    this.interval = interval;
                    setTimeout(TaskManger.Instance().tick, interval);
                }
                // dispose
                TaskManger.Instance = function() {
                    if (!TaskManger.instance) TaskManger.instance = new TaskManger();
                    return TaskManger.instance;
                };
                TaskManger.prototype.tick = function() {
                    try {
                        var newTasks = [];
                        for(var i = 0; i < TaskManger.tasks.length; i++){
                            var task = TaskManger.tasks[i];
                            task.execute();
                            if (!task.isCompleted) newTasks.push(task);
                            else if (typeof task.dispose === "function") task.dispose();
                        }
                        TaskManger.tasks = newTasks;
                    } finally{
                        setTimeout(TaskManger.Instance().tick, this.interval);
                    }
                };
                TaskManger.schedule = function(task) {
                    TaskManger.tasks.push(task);
                };
                TaskManger.instance = undefined;
                TaskManger.tasks = [];
                return TaskManger;
            }();
            function debounce(func) {
                var _this = this;
                var isSheduled = false;
                var isCanceled = false;
                var funcArgs;
                return {
                    run: function() {
                        var args = [];
                        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
                        isCanceled = false;
                        funcArgs = args;
                        if (!isSheduled) {
                            isSheduled = true;
                            queueMicrotask(function() {
                                if (!isCanceled) func.apply(_this, funcArgs);
                                isCanceled = false;
                                isSheduled = false;
                            });
                        }
                    },
                    cancel: function() {
                        isCanceled = true;
                    }
                };
            }
        /***/ },
        /***/ "./src/utils/utils.ts": /*!****************************!*\
  !*** ./src/utils/utils.ts ***!
  \****************************/ /*! exports provided: unwrap, getRenderedSize, getRenderedStyleSize, doKey2ClickBlur, doKey2ClickUp, doKey2ClickDown, sanitizeEditableContent, Logger, showConfirmDialog, configConfirmDialog, mergeValues, getElementWidth, isContainerVisible, classesToSelector, compareVersions, confirmAction, confirmActionAsync, detectIEOrEdge, detectIEBrowser, loadFileFromBase64, isMobile, isShadowDOM, getElement, isElementVisible, findScrollableParent, scrollElementByChildId, navigateToUrl, wrapUrlForBackgroundImage, createSvg, getIconNameFromProxy, increaseHeightByContent, getOriginalEvent, preventDefaults, findParentByClassNames, getFirstVisibleChild, chooseFiles */ /***/ function(module1, __webpack_exports__, __webpack_require__) {
            "use strict";
            __webpack_require__.r(__webpack_exports__);
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unwrap", function() {
                return unwrap;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRenderedSize", function() {
                return getRenderedSize;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRenderedStyleSize", function() {
                return getRenderedStyleSize;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickBlur", function() {
                return doKey2ClickBlur;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickUp", function() {
                return doKey2ClickUp;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "doKey2ClickDown", function() {
                return doKey2ClickDown;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "sanitizeEditableContent", function() {
                return sanitizeEditableContent;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Logger", function() {
                return Logger;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "showConfirmDialog", function() {
                return showConfirmDialog;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "configConfirmDialog", function() {
                return configConfirmDialog;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergeValues", function() {
                return mergeValues;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementWidth", function() {
                return getElementWidth;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isContainerVisible", function() {
                return isContainerVisible;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "classesToSelector", function() {
                return classesToSelector;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareVersions", function() {
                return compareVersions;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmAction", function() {
                return confirmAction;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "confirmActionAsync", function() {
                return confirmActionAsync;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detectIEOrEdge", function() {
                return detectIEOrEdge;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "detectIEBrowser", function() {
                return detectIEBrowser;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadFileFromBase64", function() {
                return loadFileFromBase64;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isMobile", function() {
                return isMobile;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isShadowDOM", function() {
                return isShadowDOM;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElement", function() {
                return getElement;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isElementVisible", function() {
                return isElementVisible;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findScrollableParent", function() {
                return findScrollableParent;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollElementByChildId", function() {
                return scrollElementByChildId;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "navigateToUrl", function() {
                return navigateToUrl;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wrapUrlForBackgroundImage", function() {
                return wrapUrlForBackgroundImage;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createSvg", function() {
                return createSvg;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIconNameFromProxy", function() {
                return getIconNameFromProxy;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "increaseHeightByContent", function() {
                return increaseHeightByContent;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getOriginalEvent", function() {
                return getOriginalEvent;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preventDefaults", function() {
                return preventDefaults;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "findParentByClassNames", function() {
                return findParentByClassNames;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFirstVisibleChild", function() {
                return getFirstVisibleChild;
            });
            /* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "chooseFiles", function() {
                return chooseFiles;
            });
            /* harmony import */ var _localizablestring__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../localizablestring */ "./src/localizablestring.ts");
            /* harmony import */ var _settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./../settings */ "./src/settings.ts");
            /* harmony import */ var _surveyStrings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../surveyStrings */ "./src/surveyStrings.ts");
            /* harmony import */ var _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../global_variables_utils */ "./src/global_variables_utils.ts");
            function compareVersions(a, b) {
                var regExStrip0 = /(\.0+)+$/;
                var segmentsA = a.replace(regExStrip0, "").split(".");
                var segmentsB = b.replace(regExStrip0, "").split(".");
                var len = Math.min(segmentsA.length, segmentsB.length);
                for(var i = 0; i < len; i++){
                    var diff = parseInt(segmentsA[i], 10) - parseInt(segmentsB[i], 10);
                    if (diff) return diff;
                }
                return segmentsA.length - segmentsB.length;
            }
            function confirmAction(message) {
                if (!!_settings__WEBPACK_IMPORTED_MODULE_1__["settings"] && !!_settings__WEBPACK_IMPORTED_MODULE_1__["settings"].confirmActionFunc) return _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].confirmActionFunc(message);
                return confirm(message);
            }
            function confirmActionAsync(message, funcOnYes, funcOnNo, locale, rootElement1) {
                var callbackFunc = function(res) {
                    if (res) funcOnYes();
                    else if (!!funcOnNo) funcOnNo();
                };
                if (!!_settings__WEBPACK_IMPORTED_MODULE_1__["settings"] && !!_settings__WEBPACK_IMPORTED_MODULE_1__["settings"].confirmActionAsync) {
                    if (_settings__WEBPACK_IMPORTED_MODULE_1__["settings"].confirmActionAsync(message, callbackFunc, undefined, locale, rootElement1)) return;
                }
                callbackFunc(confirmAction(message));
            }
            function detectIEBrowser() {
                var ua = navigator.userAgent;
                var oldIe = ua.indexOf("MSIE ");
                var elevenIe = ua.indexOf("Trident/");
                return oldIe > -1 || elevenIe > -1;
            }
            function detectIEOrEdge() {
                if (typeof detectIEOrEdge.isIEOrEdge === "undefined") {
                    var ua = navigator.userAgent;
                    var msie = ua.indexOf("MSIE ");
                    var trident = ua.indexOf("Trident/");
                    var edge = ua.indexOf("Edge/");
                    detectIEOrEdge.isIEOrEdge = edge > 0 || trident > 0 || msie > 0;
                }
                return detectIEOrEdge.isIEOrEdge;
            }
            function loadFileFromBase64(b64Data, fileName) {
                try {
                    var byteString = atob(b64Data.split(",")[1]);
                    // separate out the mime component
                    var mimeString = b64Data.split(",")[0].split(":")[1].split(";")[0];
                    // write the bytes of the string to an ArrayBuffer
                    var ab = new ArrayBuffer(byteString.length);
                    var ia = new Uint8Array(ab);
                    for(var i = 0; i < byteString.length; i++)ia[i] = byteString.charCodeAt(i);
                    // write the ArrayBuffer to a blob, and you're done
                    var bb = new Blob([
                        ab
                    ], {
                        type: mimeString
                    });
                    if (!!navigator && navigator["msSaveBlob"]) navigator["msSaveOrOpenBlob"](bb, fileName);
                } catch (err) {}
            }
            function isMobile() {
                return _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].isAvailable() && _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].hasOwn("orientation");
            }
            var isShadowDOM = function(rootElement1) {
                return !!rootElement1 && !!("host" in rootElement1 && rootElement1.host);
            };
            var getElement = function(element) {
                var root = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                return typeof element === "string" ? root.getElementById(element) : element;
            };
            function isElementVisible(element, threshold) {
                if (threshold === void 0) threshold = 0;
                if (typeof _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment === "undefined") return false;
                var root = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                var clientHeight = isShadowDOM(root) ? root.host.clientHeight : root.documentElement.clientHeight;
                var elementRect = element.getBoundingClientRect();
                var viewHeight = Math.max(clientHeight, _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].getInnerHeight());
                var topWin = -threshold;
                var bottomWin = viewHeight + threshold;
                var topEl = elementRect.top;
                var bottomEl = elementRect.bottom;
                var maxTop = Math.max(topWin, topEl);
                var minBottom = Math.min(bottomWin, bottomEl);
                return maxTop <= minBottom;
            }
            function findScrollableParent(element) {
                var root = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment.root;
                if (!element) return isShadowDOM(root) ? root.host : root.documentElement;
                if (element.scrollHeight > element.clientHeight && (getComputedStyle(element).overflowY === "scroll" || getComputedStyle(element).overflowY === "auto")) return element;
                if (element.scrollWidth > element.clientWidth && (getComputedStyle(element).overflowX === "scroll" || getComputedStyle(element).overflowX === "auto")) return element;
                return findScrollableParent(element.parentElement);
            }
            function scrollElementByChildId(id) {
                var environment = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].environment;
                if (!environment) return;
                var root = environment.root;
                var el = root.getElementById(id);
                if (!el) return;
                var scrollableEl = findScrollableParent(el);
                if (!!scrollableEl) setTimeout(function() {
                    return scrollableEl.dispatchEvent(new CustomEvent("scroll"));
                }, 10);
            }
            function navigateToUrl(url) {
                var location = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].getLocation();
                if (!url || !location) return;
                location.href = url;
            }
            function wrapUrlForBackgroundImage(url) {
                return !!url ? [
                    "url(",
                    url,
                    ")"
                ].join("") : "";
            }
            function getIconNameFromProxy(iconName) {
                if (!iconName) return iconName;
                var proxyName = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].customIcons[iconName];
                return !!proxyName ? proxyName : iconName;
            }
            function createSvg(size, width, height, iconName, svgElem, title) {
                if (!svgElem) return;
                if (size !== "auto") {
                    svgElem.style.width = (size || width || 16) + "px";
                    svgElem.style.height = (size || height || 16) + "px";
                }
                var node = svgElem.childNodes[0];
                var realIconName = getIconNameFromProxy(iconName);
                node.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#" + realIconName);
                var titleElement = svgElem.getElementsByTagName("title")[0];
                if (!title) {
                    if (!!titleElement) svgElem.removeChild(titleElement);
                    return;
                } else if (!titleElement) {
                    titleElement = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].getDocument().createElementNS("http://www.w3.org/2000/svg", "title");
                    svgElem.appendChild(titleElement);
                }
                titleElement.textContent = title;
            }
            function unwrap(value) {
                if (typeof value !== "function") return value;
                else return value();
            }
            // export function getSize(value: any): number {
            //   if (typeof value === "number") {
            //     return value;
            //   }
            //   if (typeof value === "string" && value.includes("px")) {
            //     return parseInt(value);
            //   }
            //   if (!!value && typeof value === "string" && value.length > 0) {
            //     const lastSymbol: string = value[value.length - 1];
            //     if ((lastSymbol >= "0" && lastSymbol <= "9") || lastSymbol == ".") {
            //       try {
            //         const num: number = parseInt(value);
            //         return num;
            //       } catch { }
            //     }
            //   }
            //   return value;
            // }
            function getRenderedSize(val1) {
                if (typeof val1 == "string") {
                    if (!isNaN(Number(val1))) return Number(val1);
                    else if (val1.includes("px")) return parseFloat(val1);
                }
                if (typeof val1 == "number") return val1;
                return undefined;
            }
            function getRenderedStyleSize(val1) {
                if (getRenderedSize(val1) !== undefined) return undefined;
                return val1;
            }
            var keyFocusedClassName = "sv-focused--by-key";
            function doKey2ClickBlur(evt) {
                var element = evt.target;
                if (!element || !element.classList) return;
                element.classList.remove(keyFocusedClassName);
            }
            function doKey2ClickUp(evt, options) {
                if (!!evt.target && evt.target["contentEditable"] === "true") return;
                var element = evt.target;
                if (!element) return;
                var char = evt.which || evt.keyCode;
                if (char === 9) {
                    if (!!element.classList && !element.classList.contains(keyFocusedClassName)) element.classList.add(keyFocusedClassName);
                    return;
                }
                if (options) {
                    if (!options.__keyDownReceived) return;
                    options.__keyDownReceived = false;
                }
                if (char === 13 || char === 32) {
                    if (element.click) element.click();
                } else if ((!options || options.processEsc) && char === 27) {
                    if (element.blur) element.blur();
                }
            }
            function doKey2ClickDown(evt, options) {
                if (options === void 0) options = {
                    processEsc: true
                };
                if (options) options.__keyDownReceived = true;
                if (!!evt.target && evt.target["contentEditable"] === "true") return;
                var char = evt.which || evt.keyCode;
                var supportedCodes = [
                    13,
                    32
                ];
                if (options.processEsc) supportedCodes.push(27);
                if (supportedCodes.indexOf(char) !== -1) evt.preventDefault();
            }
            function increaseHeightByContent(element, getComputedStyle1) {
                if (!element) return;
                if (!getComputedStyle1) getComputedStyle1 = function(elt) {
                    return _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].getComputedStyle(elt);
                };
                var style = getComputedStyle1(element);
                element.style.height = "auto";
                if (!!element.scrollHeight) element.style.height = element.scrollHeight + parseFloat(style.borderTopWidth) + parseFloat(style.borderBottomWidth) + "px";
            }
            function getOriginalEvent(event) {
                return event.originalEvent || event;
            }
            function preventDefaults(event) {
                event.preventDefault();
                event.stopPropagation();
            }
            function classesToSelector(str) {
                var re = /\s*?([\w-]+)\s*?/g;
                return str.replace(re, ".$1");
            }
            function getElementWidth(el) {
                return !!getComputedStyle ? Number.parseFloat(getComputedStyle(el).width) : el.offsetWidth;
            }
            function isContainerVisible(el) {
                return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
            }
            function getFirstVisibleChild(el) {
                var result;
                for(var index = 0; index < el.children.length; index++)if (!result && getComputedStyle(el.children[index]).display !== "none") result = el.children[index];
                return result;
            }
            function findParentByClassNames(element, classNames) {
                if (!!element) {
                    if (classNames.every(function(className) {
                        return !className || element.classList.contains(className);
                    })) return element;
                    else return findParentByClassNames(element.parentElement, classNames);
                }
            }
            function sanitizeEditableContent(element, cleanLineBreaks) {
                if (cleanLineBreaks === void 0) cleanLineBreaks = true;
                if (_global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].isAvailable() && _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].isAvailable() && element.childNodes.length > 0) {
                    var selection = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].getSelection();
                    if (selection.rangeCount == 0) return;
                    var range = selection.getRangeAt(0);
                    range.setStart(range.endContainer, range.endOffset);
                    range.setEndAfter(element.lastChild);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    var tail = selection.toString();
                    var innerText = element.innerText;
                    tail = tail.replace(/\r/g, "");
                    if (cleanLineBreaks) {
                        tail = tail.replace(/\n/g, "");
                        innerText = innerText.replace(/\n/g, "");
                    }
                    var tail_len = tail.length;
                    element.innerText = innerText;
                    range = _global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomDocumentHelper"].getDocument().createRange();
                    range.setStart(element.firstChild, 0);
                    range.setEnd(element.firstChild, 0);
                    selection.removeAllRanges();
                    selection.addRange(range);
                    while(selection.toString().length < innerText.length - tail_len){
                        var selLen = selection.toString().length;
                        selection.modify("extend", "forward", "character");
                        if (selection.toString().length == selLen) break;
                    }
                    range = selection.getRangeAt(0);
                    range.setStart(range.endContainer, range.endOffset);
                }
            }
            function mergeValues(src, dest) {
                if (!dest || !src) return;
                if (typeof dest !== "object") return;
                for(var key in src){
                    var value = src[key];
                    if (!Array.isArray(value) && value && typeof value === "object") {
                        if (!dest[key] || typeof dest[key] !== "object") dest[key] = {};
                        mergeValues(value, dest[key]);
                    } else dest[key] = value;
                }
            }
            var Logger = /** @class */ function() {
                function Logger() {
                    this._result = "";
                }
                Logger.prototype.log = function(action) {
                    this._result += "->" + action;
                };
                Object.defineProperty(Logger.prototype, "result", {
                    get: function() {
                        return this._result;
                    },
                    enumerable: false,
                    configurable: true
                });
                return Logger;
            }();
            function showConfirmDialog(message, callback, applyTitle, locale, rootElement1) {
                var locStr = new _localizablestring__WEBPACK_IMPORTED_MODULE_0__["LocalizableString"](undefined);
                var popupViewModel = _settings__WEBPACK_IMPORTED_MODULE_1__["settings"].showDialog({
                    componentName: "sv-string-viewer",
                    data: {
                        locStr: locStr,
                        locString: locStr,
                        model: locStr
                    },
                    onApply: function() {
                        callback(true);
                        return true;
                    },
                    onCancel: function() {
                        callback(false);
                        return false;
                    },
                    title: message,
                    displayMode: "popup",
                    isFocusedContent: false,
                    cssClass: "sv-popup--confirm-delete"
                }, rootElement1);
                var toolbar = popupViewModel.footerToolbar;
                var applyBtn = toolbar.getActionById("apply");
                var cancelBtn = toolbar.getActionById("cancel");
                cancelBtn.title = _surveyStrings__WEBPACK_IMPORTED_MODULE_2__["surveyLocalization"].getString("cancel", locale);
                cancelBtn.innerCss = "sv-popup__body-footer-item sv-popup__button sd-btn sd-btn--small";
                applyBtn.title = applyTitle || _surveyStrings__WEBPACK_IMPORTED_MODULE_2__["surveyLocalization"].getString("ok", locale);
                applyBtn.innerCss = "sv-popup__body-footer-item sv-popup__button sv-popup__button--danger sd-btn sd-btn--small sd-btn--danger";
                configConfirmDialog(popupViewModel);
                return true;
            }
            function configConfirmDialog(popupViewModel) {
                popupViewModel.width = "min-content";
            }
            function chooseFiles(input, callback) {
                if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].isFileReaderAvailable()) return;
                input.value = "";
                input.onchange = function(event) {
                    if (!_global_variables_utils__WEBPACK_IMPORTED_MODULE_3__["DomWindowHelper"].isFileReaderAvailable()) return;
                    if (!input || !input.files || input.files.length < 1) return;
                    var files = [];
                    for(var i = 0; i < input.files.length; i++)files.push(input.files[i]);
                    callback(files);
                };
                input.click();
            }
        /***/ },
        /***/ "react": /*!**************************************************************************************!*\
  !*** external {"root":"React","commonjs2":"react","commonjs":"react","amd":"react"} ***!
  \**************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react__;
        /***/ },
        /***/ "react-dom": /*!*****************************************************************************************************!*\
  !*** external {"root":"ReactDOM","commonjs2":"react-dom","commonjs":"react-dom","amd":"react-dom"} ***!
  \*****************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_react_dom__;
        /***/ },
        /***/ "survey-core": /*!*********************************************************************************************************!*\
  !*** external {"root":"Survey","commonjs2":"survey-core","commonjs":"survey-core","amd":"survey-core"} ***!
  \*********************************************************************************************************/ /*! no static exports found */ /***/ function(module1, exports) {
            module1.exports = __WEBPACK_EXTERNAL_MODULE_survey_core__;
        /***/ }
    });
});


var $45de9c4568754923$exports = {};
$45de9c4568754923$exports = JSON.parse("{\"firstPageIsStarted\":true,\"startSurveyText\":\"Begin\",\"pages\":[{\"elements\":[{\"type\":\"html\",\"html\":\"<p>Does your home need repaired, replaced, or demolished due to the March 2024 Tornados?</p>\"}]},{\"elements\":[{\"name\":\"homeType\",\"title\":\"What is the type of home you live in?\",\"type\":\"radiogroup\",\"choices\":[{\"value\":1,\"text\":\"My home is located in a licensed manufactured home park\"},{\"value\":2,\"text\":\"My home is located in a licensed RV Park\"},{\"value\":3,\"text\":\"Other\"}]}]},{\"visibleIf\":\"{homeType} = 3\",\"elements\":[{\"name\":\"location\",\"title\":\"Where is your home located?\",\"type\":\"radiogroup\",\"choices\":[{\"value\":1,\"text\":\"Stokes Township\"},{\"value\":2,\"text\":\"Washington Township\"},{\"value\":3,\"text\":\"Lakeview\"},{\"value\":4,\"text\":\"Russells Point\"},{\"value\":5,\"text\":\"Other/Don't Know\"}]}]}],\"completedHtmlOnCondition\":[{\"expression\":\"{homeType} = 1\",\"html\":\"<ul class='p-4 list-inside text-left list-image-[url(/check.svg)] list-disc'><li>Report Damages to the <a class='underline' href='https://www.co.logan.oh.us/201/Emergency-Management-Agency'>Logan County EMA</a>.</li><li>Contact the Ohio Department of Commerce Division of Industrial Compliance at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+16146442223'>(614) 644-2223</a></li><li>Email: <a class='underline' href='mailto:IC@com.state.oh.us'>IC@com.state.oh.us</a></li></ul></li></ul>\"},{\"expression\":\"{homeType} = 2\",\"html\":\"<ul class='p-4 list-inside text-left list-image-[url(/check.svg)] list-disc'><li>Report Damages to the <a class='underline' href='https://www.co.logan.oh.us/201/Emergency-Management-Agency'>Logan County EMA</a>.</li><li>Contact the Ohio Department of Health: <a class='underline' href='tel+16146447455'>(614) 644-7455</a></li></ul>\"},{\"expression\":\"{homeType} = 3 && {location} = 1\",\"html\":\"<ul class='p-4 list-inside text-left list-image-[url(/check.svg)] list-disc'><li>Report Damages to the <a class='underline' href='https://www.co.logan.oh.us/201/Emergency-Management-Agency'>Logan County EMA</a>.</li><li>Contact the Logan County Soil and Water Conservation District to Determine Floodplain info at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19374043147'>(937) 404-3147</a></li><li>Email: <a class='underline' href='mailto:allison.fowler@oh.nacdnet.net'>allison.fowler@oh.nacdnet.net</a></li></ul></li><li>Contact the Logan County Building Authority for any applicable building, gas, and electrical permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19375927473'>(937) 592-7473</a></li><li>Email: <a class='underline' href='mailto:buildinginfo@logancountyohio.gov'>buildinginfo@logancountyohio.gov</a></li></ul></li><li>Contact the Logan County Plumbing Inspector for all plumbing permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516195'>(937) 651-6195</a></li><li>Email: <a class='underline' href='mailto:cwren@loganhealthohio.gov'>cwren@loganhealthohio.go</a></li></ul></li><li>Contact the Logan County Sewer District for any applicable sewer permits at:<a class='underline' href='tel:+19378433328'>(937) 843-3328</a></li><li>Contact the Logan County Auditors Office before moving or placing any manufactured home to get all applicable permits at: <a class='underline' href='+19375997209'>(937) 599-7209</a></li><li>Contact the Logan County Health District if you have a well to get a building site review and any applicable well (New, Altered, Abandoned) permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516205'>(937) 651-6205</a></li><li>Email: <a class='underline' href='mailto:aharshfield@loganhealthohio.gov'>aharshfield@loganhealthohio.gov</a></li></ul></li></ul>\"},{\"expression\":\"{homeType} = 3 && {location} = 2\",\"html\":\"<ul class='p-4 list-inside text-left list-image-[url(/check.svg)] list-disc'><li>Report Damages to the <a class='underline' href='https://www.co.logan.oh.us/201/Emergency-Management-Agency'>Logan County EMA</a>.</li><li>Contact the Logan County Soil and Water Conservation District to Determine Floodplain info at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19374043147'>(937) 404-3147</a></li><li>Email:<a class='underline' href='mailto:allison.fowler@oh.nacdnet.net'>allison.fowler@oh.nacdnet.net</a></li></ul></li><li>Contact the Washington Townshop Zoning Inspector for any applicable permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19375391879'>(937) 539-1879</a></li><li>Email: <a class='underline' href='mailto:\u200Bwashtwpzoning@gmail.com'>\u200Bwashtwpzoning@gmail.com</a></li></ul></li><li>Contact the Logan County Building Authority for any applicable building, gas, and electrical permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19375927473'>(937) 592-7473</a></li><li>Email: <a class='underline' href='mailto:buildinginfo@logancountyohio.gov'>buildinginfo@logancountyohio.gov</a></li></ul></li><li>Contact the Logan County Plumbing Inspector for all plumbing permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516195'>(937) 651-6195</a> </li><li>Email: <a class='underline' href='mailto:cwren@loganhealthohio.gov'>cwren@loganhealthohio.go</a></li></ul></li><li>Contact the Logan County Sewer District for any applicable sewer permits at: <a class='underline' href='tel:+19378433328'>(937) 843-3328</a></li><li>Contact the Logan County Auditors Office before moving or placing any manufactured home to get all applicable permits at: <a class='underline' href='+19375997209'>(937) 599-7209</a></li><li>Contact the Logan County Health District if you have a well to get a building site review and any applicable well (New, Altered, Abandoned) permits at: <ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516205'>(937) 651-6205</a></li><li>Email: <a class='underline' href='mailto:aharshfield@loganhealthohio.gov'>aharshfield@loganhealthohio.gov</a></li></ul></li></ul>\"},{\"expression\":\"{homeType} = 3 && {location} = 3\",\"html\":\"<ul class='p-4 list-inside text-left list-image-[url(/check.svg)] list-disc'><li>Report Damages to the <a class='underline' href='https://www.co.logan.oh.us/201/Emergency-Management-Agency'>Logan County EMA</a>.</li><li>Contact Village for floodplain info, demolition permits, and any applicable zoning permits at: <a class='underline' href='tel:+19373608412'>(937) 360-8412</a></li><li>Contact the Logan County Building Authority for any applicable building, gas, and electrical permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19375927473'>(937) 592-7473</a></li><li>Email: <a class='underline' href='mailto:buildinginfo@logancountyohio.gov'>buildinginfo@logancountyohio.gov</a></li></ul></li><li>Contact the Logan County Plumbing Inspector for all plumbing permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516195'>(937) 651-6195</a></li><li>Email: <a class='underline' href='mailto:cwren@loganhealthohio.gov'>cwren@loganhealthohio.go</a></li></ul></li><li>Contact the Logan County Sewer District for any applicable sewer permits at: <a class='underline' href='tel:+19378433328'>(937) 843-3328</a></li><li>Contact the Logan County Auditors Office before moving or placing any manufactured home to get all applicable permits at: <a class='underline' href='+19375997209'>(937) 599-7209</a></li><li>Contact the Logan County Health District if you have a well to get a building site review and any applicable well (New, Altered, Abandoned) permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516205'>(937) 651-6205</a></li><li>Email: <a class='underline' href='mailto:aharshfield@loganhealthohio.gov'>aharshfield@loganhealthohio.gov</a></li></ul></li></ul>\"},{\"expression\":\"{homeType} = 3 && {location} = 4\",\"html\":\"<ul class='p-4 list-inside text-left list-image-[url(/check.svg)] list-disc'><li>Report Damages to the <a class='underline' href='https://www.co.logan.oh.us/201/Emergency-Management-Agency'>Logan County EMA</a>.</li><li>Contact Village for floodplain info, demolition permits, and any applicable zoning permits at: <a class='underline' href='tel:+19378432245'>(937) 843-2245 ext. 4</a></li><li>Contact the Logan County Building Authority for any applicable building, gas, and electrical permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19375927473'>(937) 592-7473</a></li><li>Email: <a class='underline' href='mailto:buildinginfo@logancountyohio.gov'>buildinginfo@logancountyohio.gov</a></li></ul></li><li>Contact the Logan County Plumbing Inspector for all plumbing permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516195'>(937) 651-6195</a></li><li>Email: <a class='underline' href='mailto:cwren@loganhealthohio.gov'>cwren@loganhealthohio.go</a></li></ul></li><li>Contact the Logan County Sewer District for any applicable sewer permits at: <a class='underline' href='tel:+19378433328'>(937) 843-3328</a></li><li>Contact the Logan County Auditors Office before moving or placing any manufactured home to get all applicable permits at: <a class='underline' href='+19375997209'>(937) 599-7209</a></li><li>Contact the Logan County Health District if you have a well to get a building site review and any applicable well (New, Altered, Abandoned) permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516205'>(937) 651-6205</a></li><li>Email: <a class='underline' href='mailto:aharshfield@loganhealthohio.gov'>aharshfield@loganhealthohio.gov</a></li></ul></li></ul>\"},{\"expression\":\"{homeType} = 3 && {location} = 5\",\"html\":\"<ul class='p-4 list-inside text-left list-image-[url(/check.svg)] list-disc'><li>Report Damages to the <a class='underline' href='https://www.co.logan.oh.us/201/Emergency-Management-Agency'>Logan County EMA</a>.</li><li>Contact the Logan County Building Authority for any applicable building, gas, and electrical permits at: <ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19375927473'>(937) 592-7473</a></li><li>Email: <a class='underline' href='mailto:buildinginfo@logancountyohio.gov'>buildinginfo@logancountyohio.gov</a></li></ul></li><li>Contact the Logan County Plumbing Inspector for all plumbing permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516195'>(937) 651-6195</a></li><li>Email: <a class='underline' href='mailto:cwren@loganhealthohio.gov'>cwren@loganhealthohio.go</a></li></ul></li><li>Contact the Logan County Sewer District for any applicable sewer permits at: <a class='underline' href='tel:+19378433328'>(937) 843-3328</a></li><li>Contact the Logan County Auditors Office before moving or placing any manufactured home to get all applicable permits at: <a class='underline' href='+19375997209'>(937) 599-7209</a></li><li>Contact the Logan County Health District if you have a well to get a building site review and any applicable well (New, Altered, Abandoned) permits at:<ul class='p-4 list-inside list-disc'><li>Phone: <a class='underline' href='tel:+19376516205'>(937) 651-6205</a></li><li>Email: <a class='underline' href='mailto:aharshfield@loganhealthohio.gov'>aharshfield@loganhealthohio.gov</a></li></ul></li></ul>\"}]}");



const $53f3a2b3a571fa65$var$_SurveyComp = ({ setIsCompleted: setIsCompleted })=>{
    const surveyConfig = new (0, $8dUxG.Model)((0, (/*@__PURE__*/$parcel$interopDefault($45de9c4568754923$exports))));
    surveyConfig.focusFirstQuestionAutomatic = false;
    const alertResults = (0, $acw62.useCallback)((sender)=>{
        setIsCompleted(true);
    }, []);
    surveyConfig.onComplete.add(alertResults);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $661535155caf22bb$exports.Survey), {
        model: surveyConfig
    });
};
const $53f3a2b3a571fa65$var$SurveyComp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).memo($53f3a2b3a571fa65$var$_SurveyComp);
function $53f3a2b3a571fa65$var$NeedHelp() {
    const [isCompleted, setIsCompleted] = (0, $acw62.useState)(false);
    function refreshPage() {
        window.location.reload(false);
    }
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e9bd92b954fbb741$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("main", {
                className: "p-6",
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)($53f3a2b3a571fa65$var$SurveyComp, {
                        setIsCompleted: setIsCompleted
                    }),
                    isCompleted && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: "bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded",
                        onClick: ()=>refreshPage(),
                        children: "Restart"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $5686e64eaa3841eb$export$2e2bcd8739ae039), {})
        ]
    });
}
var $53f3a2b3a571fa65$export$2e2bcd8739ae039 = $53f3a2b3a571fa65$var$NeedHelp;


function $37e03e25754217c1$var$App() {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $040dbb9c344a508d$export$9ba4e89fdfa1fc54), {
        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7939e29d663dd3ed$export$3565eb3d00ca5a74), {
            children: [
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/want-to-help",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $3079aca9503d0e47$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/need-help",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $53f3a2b3a571fa65$export$2e2bcd8739ae039), {})
                }),
                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7939e29d663dd3ed$export$e7b0ac011bb776c6), {
                    path: "/",
                    element: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $a878297d5108f03e$export$2e2bcd8739ae039), {})
                })
            ]
        })
    });
}
var $37e03e25754217c1$export$2e2bcd8739ae039 = $37e03e25754217c1$var$App;


const $35da740d59af89ba$var$root = (0, $7e96a608cb33bf79$export$882461b6382ed46c)(document.getElementById("app"));
$35da740d59af89ba$var$root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $37e03e25754217c1$export$2e2bcd8739ae039), {}));


//# sourceMappingURL=index.c3093cb8.js.map
